const C_ = (e, t) => e === t, Tr = /* @__PURE__ */ Symbol("solid-proxy"), D7 = typeof Proxy == "function", Zd = /* @__PURE__ */ Symbol("solid-track"), C0 = {
  equals: C_
};
let N7 = j7;
const oa = 1, T0 = 2, M7 = {
  owned: null,
  cleanups: null,
  context: null,
  owner: null
}, Ph = {};
var lt = null;
let Ih = null, T_ = null, Ct = null, Vr = null, Ji = null, I1 = 0;
function Ws(e, t) {
  const r = Ct, n = lt, i = e.length === 0, a = t === void 0 ? n : t, o = i ? M7 : {
    owned: null,
    cleanups: null,
    context: a ? a.context : null,
    owner: a
  }, s = i ? e : () => e(() => Le(() => Xd(o)));
  lt = o, Ct = null;
  try {
    return Pi(s, !0);
  } finally {
    Ct = r, lt = n;
  }
}
function z(e, t) {
  t = t ? Object.assign({}, C0, t) : C0;
  const r = {
    value: e,
    observers: null,
    observerSlots: null,
    comparator: t.equals || void 0
  }, n = (i) => (typeof i == "function" && (i = i(r.value)), F7(r, i));
  return [L7.bind(r), n];
}
function J5(e, t, r) {
  const n = D1(e, t, !0, oa);
  Cl(n);
}
function te(e, t, r) {
  const n = D1(e, t, !1, oa);
  Cl(n);
}
function le(e, t, r) {
  N7 = L_;
  const n = D1(e, t, !1, oa);
  n.user = !0, Ji ? Ji.push(n) : Cl(n);
}
function B(e, t, r) {
  r = r ? Object.assign({}, C0, r) : C0;
  const n = D1(e, t, !0, 0);
  return n.observers = null, n.observerSlots = null, n.comparator = r.equals || void 0, Cl(n), L7.bind(n);
}
function A_(e) {
  return e && typeof e == "object" && "then" in e;
}
function R7(e, t, r) {
  let n, i, a;
  typeof t == "function" ? (n = e, i = t, a = {}) : (n = !0, i = e, a = t || {});
  let o = null, s = Ph, l = !1, d = "initialValue" in a, c = typeof n == "function" && B(n);
  const u = /* @__PURE__ */ new Set(), [h, f] = (a.storage || z)(a.initialValue), [p, m] = z(void 0), [y, g] = z(void 0, {
    equals: !1
  }), [w, $] = z(d ? "ready" : "unresolved");
  function _(M, P, O, D) {
    return o === M && (o = null, D !== void 0 && (d = !0), (M === s || P === s) && a.onHydrated && queueMicrotask(() => a.onHydrated(D, {
      value: P
    })), s = Ph, x(P, O)), P;
  }
  function x(M, P) {
    Pi(() => {
      P === void 0 && f(() => M), $(P !== void 0 ? "errored" : d ? "ready" : "unresolved"), m(P);
      for (const O of u.keys()) O.decrement();
      u.clear();
    }, !1);
  }
  function S() {
    const M = N_, P = h(), O = p();
    if (O !== void 0 && !o) throw O;
    return Ct && Ct.user, P;
  }
  function T(M = !0) {
    if (M !== !1 && l) return;
    l = !1;
    const P = c ? c() : n;
    if (P == null || P === !1) {
      _(o, Le(h));
      return;
    }
    let O;
    const D = s !== Ph ? s : Le(() => {
      try {
        return i(P, {
          value: h(),
          refetching: M
        });
      } catch (R) {
        O = R;
      }
    });
    if (O !== void 0) {
      _(o, void 0, t0(O), P);
      return;
    } else if (!A_(D))
      return _(o, D, void 0, P), D;
    return o = D, "v" in D ? (D.s === 1 ? _(o, D.v, void 0, P) : _(o, void 0, t0(D.v), P), D) : (l = !0, queueMicrotask(() => l = !1), Pi(() => {
      $(d ? "refreshing" : "pending"), g();
    }, !1), D.then((R) => _(D, R, void 0, P), (R) => _(D, void 0, t0(R), P)));
  }
  Object.defineProperties(S, {
    state: {
      get: () => w()
    },
    error: {
      get: () => p()
    },
    loading: {
      get() {
        const M = w();
        return M === "pending" || M === "refreshing";
      }
    },
    latest: {
      get() {
        if (!d) return S();
        const M = p();
        if (M && !o) throw M;
        return h();
      }
    }
  });
  let I = lt;
  return c ? J5(() => (I = lt, T(!1))) : T(!1), [S, {
    refetch: (M) => O_(I, () => T(M)),
    mutate: f
  }];
}
function A0(e) {
  return Pi(e, !1);
}
function Le(e) {
  if (Ct === null) return e();
  const t = Ct;
  Ct = null;
  try {
    return e();
  } finally {
    Ct = t;
  }
}
function Ht(e) {
  le(() => Le(e));
}
function _r(e) {
  return lt === null || (lt.cleanups === null ? lt.cleanups = [e] : lt.cleanups.push(e)), e;
}
function sl() {
  return Ct;
}
function Pe() {
  return lt;
}
function O_(e, t) {
  const r = lt, n = Ct;
  lt = e, Ct = null;
  try {
    return Pi(t, !0);
  } catch (i) {
    X5(i);
  } finally {
    lt = r, Ct = n;
  }
}
function P_(e) {
  const t = Ct, r = lt;
  return Promise.resolve().then(() => {
    Ct = t, lt = r;
    let n;
    return Pi(e, !1), Ct = lt = null, n ? n.done : void 0;
  });
}
const [I_, Vue] = /* @__PURE__ */ z(!1);
function D_() {
  return [I_, P_];
}
function Rr(e, t) {
  const r = /* @__PURE__ */ Symbol("context");
  return {
    id: r,
    Provider: F_(r),
    defaultValue: e
  };
}
function gr(e) {
  let t;
  return lt && lt.context && (t = lt.context[e.id]) !== void 0 ? t : e.defaultValue;
}
function Z5(e) {
  const t = B(e), r = B(() => w2(t()));
  return r.toArray = () => {
    const n = r();
    return Array.isArray(n) ? n : n != null ? [n] : [];
  }, r;
}
let N_;
function L7() {
  if (this.sources && this.state)
    if (this.state === oa) Cl(this);
    else {
      const e = Vr;
      Vr = null, Pi(() => P0(this), !1), Vr = e;
    }
  if (Ct) {
    const e = this.observers ? this.observers.length : 0;
    Ct.sources ? (Ct.sources.push(this), Ct.sourceSlots.push(e)) : (Ct.sources = [this], Ct.sourceSlots = [e]), this.observers ? (this.observers.push(Ct), this.observerSlots.push(Ct.sources.length - 1)) : (this.observers = [Ct], this.observerSlots = [Ct.sources.length - 1]);
  }
  return this.value;
}
function F7(e, t, r) {
  let n = e.value;
  return (!e.comparator || !e.comparator(n, t)) && (e.value = t, e.observers && e.observers.length && Pi(() => {
    for (let i = 0; i < e.observers.length; i += 1) {
      const a = e.observers[i], o = Ih && Ih.running;
      o && Ih.disposed.has(a), (o ? !a.tState : !a.state) && (a.pure ? Vr.push(a) : Ji.push(a), a.observers && z7(a)), o || (a.state = oa);
    }
    if (Vr.length > 1e6)
      throw Vr = [], new Error();
  }, !1)), t;
}
function Cl(e) {
  if (!e.fn) return;
  Xd(e);
  const t = I1;
  M_(e, e.value, t);
}
function M_(e, t, r) {
  let n;
  const i = lt, a = Ct;
  Ct = lt = e;
  try {
    n = e.fn(t);
  } catch (o) {
    return e.pure && (e.state = oa, e.owned && e.owned.forEach(Xd), e.owned = null), e.updatedAt = r + 1, X5(o);
  } finally {
    Ct = a, lt = i;
  }
  (!e.updatedAt || e.updatedAt <= r) && (e.updatedAt != null && "observers" in e ? F7(e, n) : e.value = n, e.updatedAt = r);
}
function D1(e, t, r, n = oa, i) {
  const a = {
    fn: e,
    state: n,
    updatedAt: null,
    owned: null,
    sources: null,
    sourceSlots: null,
    cleanups: null,
    value: t,
    owner: lt,
    context: lt ? lt.context : null,
    pure: r
  };
  return lt === null || lt !== M7 && (lt.owned ? lt.owned.push(a) : lt.owned = [a]), a;
}
function O0(e) {
  if (e.state === 0) return;
  if (e.state === T0) return P0(e);
  if (e.suspense && Le(e.suspense.inFallback)) return e.suspense.effects.push(e);
  const t = [e];
  for (; (e = e.owner) && (!e.updatedAt || e.updatedAt < I1); )
    e.state && t.push(e);
  for (let r = t.length - 1; r >= 0; r--)
    if (e = t[r], e.state === oa)
      Cl(e);
    else if (e.state === T0) {
      const n = Vr;
      Vr = null, Pi(() => P0(e, t[0]), !1), Vr = n;
    }
}
function Pi(e, t) {
  if (Vr) return e();
  let r = !1;
  t || (Vr = []), Ji ? r = !0 : Ji = [], I1++;
  try {
    const n = e();
    return R_(r), n;
  } catch (n) {
    r || (Ji = null), Vr = null, X5(n);
  }
}
function R_(e) {
  if (Vr && (j7(Vr), Vr = null), e) return;
  const t = Ji;
  Ji = null, t.length && Pi(() => N7(t), !1);
}
function j7(e) {
  for (let t = 0; t < e.length; t++) O0(e[t]);
}
function L_(e) {
  let t, r = 0;
  for (t = 0; t < e.length; t++) {
    const n = e[t];
    n.user ? e[r++] = n : O0(n);
  }
  for (t = 0; t < r; t++) O0(e[t]);
}
function P0(e, t) {
  e.state = 0;
  for (let r = 0; r < e.sources.length; r += 1) {
    const n = e.sources[r];
    if (n.sources) {
      const i = n.state;
      i === oa ? n !== t && (!n.updatedAt || n.updatedAt < I1) && O0(n) : i === T0 && P0(n, t);
    }
  }
}
function z7(e) {
  for (let t = 0; t < e.observers.length; t += 1) {
    const r = e.observers[t];
    r.state || (r.state = T0, r.pure ? Vr.push(r) : Ji.push(r), r.observers && z7(r));
  }
}
function Xd(e) {
  let t;
  if (e.sources)
    for (; e.sources.length; ) {
      const r = e.sources.pop(), n = e.sourceSlots.pop(), i = r.observers;
      if (i && i.length) {
        const a = i.pop(), o = r.observerSlots.pop();
        n < i.length && (a.sourceSlots[o] = n, i[n] = a, r.observerSlots[n] = o);
      }
    }
  if (e.tOwned) {
    for (t = e.tOwned.length - 1; t >= 0; t--) Xd(e.tOwned[t]);
    delete e.tOwned;
  }
  if (e.owned) {
    for (t = e.owned.length - 1; t >= 0; t--) Xd(e.owned[t]);
    e.owned = null;
  }
  if (e.cleanups) {
    for (t = e.cleanups.length - 1; t >= 0; t--) e.cleanups[t]();
    e.cleanups = null;
  }
  e.state = 0;
}
function t0(e) {
  return e instanceof Error ? e : new Error(typeof e == "string" ? e : "Unknown error", {
    cause: e
  });
}
function X5(e, t = lt) {
  throw t0(e);
}
function w2(e) {
  if (typeof e == "function" && !e.length) return w2(e());
  if (Array.isArray(e)) {
    const t = [];
    for (let r = 0; r < e.length; r++) {
      const n = w2(e[r]);
      Array.isArray(n) ? t.push.apply(t, n) : t.push(n);
    }
    return t;
  }
  return e;
}
function F_(e, t) {
  return function(n) {
    let i;
    return te(() => i = Le(() => (lt.context = {
      ...lt.context,
      [e]: n.value
    }, Z5(() => n.children))), void 0), i;
  };
}
const j_ = /* @__PURE__ */ Symbol("fallback");
function cg(e) {
  for (let t = 0; t < e.length; t++) e[t]();
}
function z_(e, t, r = {}) {
  let n = [], i = [], a = [], o = 0, s = t.length > 1 ? [] : null;
  return _r(() => cg(a)), () => {
    let l = e() || [], d = l.length, c, u;
    return l[Zd], Le(() => {
      let f, p, m, y, g, w, $, _, x;
      if (d === 0)
        o !== 0 && (cg(a), a = [], n = [], i = [], o = 0, s && (s = [])), r.fallback && (n = [j_], i[0] = Ws((S) => (a[0] = S, r.fallback())), o = 1);
      else if (o === 0) {
        for (i = new Array(d), u = 0; u < d; u++)
          n[u] = l[u], i[u] = Ws(h);
        o = d;
      } else {
        for (m = new Array(d), y = new Array(d), s && (g = new Array(d)), w = 0, $ = Math.min(o, d); w < $ && n[w] === l[w]; w++) ;
        for ($ = o - 1, _ = d - 1; $ >= w && _ >= w && n[$] === l[_]; $--, _--)
          m[_] = i[$], y[_] = a[$], s && (g[_] = s[$]);
        for (f = /* @__PURE__ */ new Map(), p = new Array(_ + 1), u = _; u >= w; u--)
          x = l[u], c = f.get(x), p[u] = c === void 0 ? -1 : c, f.set(x, u);
        for (c = w; c <= $; c++)
          x = n[c], u = f.get(x), u !== void 0 && u !== -1 ? (m[u] = i[c], y[u] = a[c], s && (g[u] = s[c]), u = p[u], f.set(x, u)) : a[c]();
        for (u = w; u < d; u++)
          u in m ? (i[u] = m[u], a[u] = y[u], s && (s[u] = g[u], s[u](u))) : i[u] = Ws(h);
        i = i.slice(0, o = d), n = l.slice(0);
      }
      return i;
    });
    function h(f) {
      if (a[u] = f, s) {
        const [p, m] = z(u);
        return s[u] = m, t(l[u], p);
      }
      return t(l[u]);
    }
  };
}
function v(e, t) {
  return Le(() => e(t || {}));
}
function pu() {
  return !0;
}
const $2 = {
  get(e, t, r) {
    return t === Tr ? r : e.get(t);
  },
  has(e, t) {
    return t === Tr ? !0 : e.has(t);
  },
  set: pu,
  deleteProperty: pu,
  getOwnPropertyDescriptor(e, t) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return e.get(t);
      },
      set: pu,
      deleteProperty: pu
    };
  },
  ownKeys(e) {
    return e.keys();
  }
};
function Dh(e) {
  return (e = typeof e == "function" ? e() : e) ? e : {};
}
function V_() {
  for (let e = 0, t = this.length; e < t; ++e) {
    const r = this[e]();
    if (r !== void 0) return r;
  }
}
function Ke(...e) {
  let t = !1;
  for (let o = 0; o < e.length; o++) {
    const s = e[o];
    t = t || !!s && Tr in s, e[o] = typeof s == "function" ? (t = !0, B(s)) : s;
  }
  if (D7 && t)
    return new Proxy({
      get(o) {
        for (let s = e.length - 1; s >= 0; s--) {
          const l = Dh(e[s])[o];
          if (l !== void 0) return l;
        }
      },
      has(o) {
        for (let s = e.length - 1; s >= 0; s--)
          if (o in Dh(e[s])) return !0;
        return !1;
      },
      keys() {
        const o = [];
        for (let s = 0; s < e.length; s++) o.push(...Object.keys(Dh(e[s])));
        return [...new Set(o)];
      }
    }, $2);
  const r = {}, n = /* @__PURE__ */ Object.create(null);
  for (let o = e.length - 1; o >= 0; o--) {
    const s = e[o];
    if (!s) continue;
    const l = Object.getOwnPropertyNames(s);
    for (let d = l.length - 1; d >= 0; d--) {
      const c = l[d];
      if (c === "__proto__" || c === "constructor") continue;
      const u = Object.getOwnPropertyDescriptor(s, c);
      if (!n[c])
        n[c] = u.get ? {
          enumerable: !0,
          configurable: !0,
          get: V_.bind(r[c] = [u.get.bind(s)])
        } : u.value !== void 0 ? u : void 0;
      else {
        const h = r[c];
        h && (u.get ? h.push(u.get.bind(s)) : u.value !== void 0 && h.push(() => u.value));
      }
    }
  }
  const i = {}, a = Object.keys(n);
  for (let o = a.length - 1; o >= 0; o--) {
    const s = a[o], l = n[s];
    l && l.get ? Object.defineProperty(i, s, l) : i[s] = l ? l.value : void 0;
  }
  return i;
}
function qo(e, ...t) {
  const r = t.length;
  if (D7 && Tr in e) {
    const i = r > 1 ? t.flat() : t[0], a = t.map((o) => new Proxy({
      get(s) {
        return o.includes(s) ? e[s] : void 0;
      },
      has(s) {
        return o.includes(s) && s in e;
      },
      keys() {
        return o.filter((s) => s in e);
      }
    }, $2));
    return a.push(new Proxy({
      get(o) {
        return i.includes(o) ? void 0 : e[o];
      },
      has(o) {
        return i.includes(o) ? !1 : o in e;
      },
      keys() {
        return Object.keys(e).filter((o) => !i.includes(o));
      }
    }, $2)), a;
  }
  const n = [];
  for (let i = 0; i <= r; i++)
    n[i] = {};
  for (const i of Object.getOwnPropertyNames(e)) {
    let a = r;
    for (let l = 0; l < t.length; l++)
      if (t[l].includes(i)) {
        a = l;
        break;
      }
    const o = Object.getOwnPropertyDescriptor(e, i);
    !o.get && !o.set && o.enumerable && o.writable && o.configurable ? n[a][i] = o.value : Object.defineProperty(n[a], i, o);
  }
  return n;
}
let U_ = 0;
function Pa() {
  return `cl-${U_++}`;
}
const V7 = (e) => `Stale read from <${e}>.`;
function dt(e) {
  const t = "fallback" in e && {
    fallback: () => e.fallback
  };
  return B(z_(() => e.each, e.children, t || void 0));
}
function q(e) {
  const t = e.keyed, r = B(() => e.when, void 0, void 0), n = t ? r : B(r, void 0, {
    equals: (i, a) => !i == !a
  });
  return B(() => {
    const i = n();
    if (i) {
      const a = e.children;
      return typeof a == "function" && a.length > 0 ? Le(() => a(t ? i : () => {
        if (!Le(n)) throw V7("Show");
        return r();
      })) : a;
    }
    return e.fallback;
  }, void 0, void 0);
}
function N1(e) {
  const t = Z5(() => e.children), r = B(() => {
    const n = t(), i = Array.isArray(n) ? n : [n];
    let a = () => {
    };
    for (let o = 0; o < i.length; o++) {
      const s = o, l = i[o], d = a, c = B(() => d() ? void 0 : l.when, void 0, void 0), u = l.keyed ? c : B(c, void 0, {
        equals: (h, f) => !h == !f
      });
      a = () => d() || (u() ? [s, c, l] : void 0);
    }
    return a;
  });
  return B(() => {
    const n = r()();
    if (!n) return e.fallback;
    const [i, a, o] = n, s = o.children;
    return typeof s == "function" && s.length > 0 ? Le(() => s(o.keyed ? a() : () => {
      if (Le(r)()?.[0] !== i) throw V7("Match");
      return a();
    })) : s;
  }, void 0, void 0);
}
function Mn(e) {
  return e;
}
const q_ = [
  "allowfullscreen",
  "async",
  "alpha",
  "autofocus",
  "autoplay",
  "checked",
  "controls",
  "default",
  "disabled",
  "formnovalidate",
  "hidden",
  "indeterminate",
  "inert",
  "ismap",
  "loop",
  "multiple",
  "muted",
  "nomodule",
  "novalidate",
  "open",
  "playsinline",
  "readonly",
  "required",
  "reversed",
  "seamless",
  "selected",
  "adauctionheaders",
  "browsingtopics",
  "credentialless",
  "defaultchecked",
  "defaultmuted",
  "defaultselected",
  "defer",
  "disablepictureinpicture",
  "disableremoteplayback",
  "preservespitch",
  "shadowrootclonable",
  "shadowrootcustomelementregistry",
  "shadowrootdelegatesfocus",
  "shadowrootserializable",
  "sharedstoragewritable"
], B_ = /* @__PURE__ */ new Set([
  "className",
  "value",
  "readOnly",
  "noValidate",
  "formNoValidate",
  "isMap",
  "noModule",
  "playsInline",
  "adAuctionHeaders",
  "allowFullscreen",
  "browsingTopics",
  "defaultChecked",
  "defaultMuted",
  "defaultSelected",
  "disablePictureInPicture",
  "disableRemotePlayback",
  "preservesPitch",
  "shadowRootClonable",
  "shadowRootCustomElementRegistry",
  "shadowRootDelegatesFocus",
  "shadowRootSerializable",
  "sharedStorageWritable",
  ...q_
]), H_ = /* @__PURE__ */ new Set(["innerHTML", "textContent", "innerText", "children"]), W_ = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  className: "class",
  htmlFor: "for"
}), K_ = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  class: "className",
  novalidate: {
    $: "noValidate",
    FORM: 1
  },
  formnovalidate: {
    $: "formNoValidate",
    BUTTON: 1,
    INPUT: 1
  },
  ismap: {
    $: "isMap",
    IMG: 1
  },
  nomodule: {
    $: "noModule",
    SCRIPT: 1
  },
  playsinline: {
    $: "playsInline",
    VIDEO: 1
  },
  readonly: {
    $: "readOnly",
    INPUT: 1,
    TEXTAREA: 1
  },
  adauctionheaders: {
    $: "adAuctionHeaders",
    IFRAME: 1
  },
  allowfullscreen: {
    $: "allowFullscreen",
    IFRAME: 1
  },
  browsingtopics: {
    $: "browsingTopics",
    IMG: 1
  },
  defaultchecked: {
    $: "defaultChecked",
    INPUT: 1
  },
  defaultmuted: {
    $: "defaultMuted",
    AUDIO: 1,
    VIDEO: 1
  },
  defaultselected: {
    $: "defaultSelected",
    OPTION: 1
  },
  disablepictureinpicture: {
    $: "disablePictureInPicture",
    VIDEO: 1
  },
  disableremoteplayback: {
    $: "disableRemotePlayback",
    AUDIO: 1,
    VIDEO: 1
  },
  preservespitch: {
    $: "preservesPitch",
    AUDIO: 1,
    VIDEO: 1
  },
  shadowrootclonable: {
    $: "shadowRootClonable",
    TEMPLATE: 1
  },
  shadowrootdelegatesfocus: {
    $: "shadowRootDelegatesFocus",
    TEMPLATE: 1
  },
  shadowrootserializable: {
    $: "shadowRootSerializable",
    TEMPLATE: 1
  },
  sharedstoragewritable: {
    $: "sharedStorageWritable",
    IFRAME: 1,
    IMG: 1
  }
});
function Q_(e, t) {
  const r = K_[e];
  return typeof r == "object" ? r[t] ? r.$ : void 0 : r;
}
const G_ = /* @__PURE__ */ new Set(["beforeinput", "click", "dblclick", "contextmenu", "focusin", "focusout", "input", "keydown", "keyup", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "pointerdown", "pointermove", "pointerout", "pointerover", "pointerup", "touchend", "touchmove", "touchstart"]), Y_ = /* @__PURE__ */ new Set([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animate",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "circle",
  "clipPath",
  "color-profile",
  "cursor",
  "defs",
  "desc",
  "ellipse",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "filter",
  "font",
  "font-face",
  "font-face-format",
  "font-face-name",
  "font-face-src",
  "font-face-uri",
  "foreignObject",
  "g",
  "glyph",
  "glyphRef",
  "hkern",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "metadata",
  "missing-glyph",
  "mpath",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "set",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "textPath",
  "tref",
  "tspan",
  "use",
  "view",
  "vkern"
]), J_ = {
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace"
}, gt = (e) => B(() => e());
function Z_(e, t, r) {
  let n = r.length, i = t.length, a = n, o = 0, s = 0, l = t[i - 1].nextSibling, d = null;
  for (; o < i || s < a; ) {
    if (t[o] === r[s]) {
      o++, s++;
      continue;
    }
    for (; t[i - 1] === r[a - 1]; )
      i--, a--;
    if (i === o) {
      const c = a < n ? s ? r[s - 1].nextSibling : r[a - s] : l;
      for (; s < a; ) e.insertBefore(r[s++], c);
    } else if (a === s)
      for (; o < i; )
        (!d || !d.has(t[o])) && t[o].remove(), o++;
    else if (t[o] === r[a - 1] && r[s] === t[i - 1]) {
      const c = t[--i].nextSibling;
      e.insertBefore(r[s++], t[o++].nextSibling), e.insertBefore(r[--a], c), t[i] = r[a];
    } else {
      if (!d) {
        d = /* @__PURE__ */ new Map();
        let u = s;
        for (; u < a; ) d.set(r[u], u++);
      }
      const c = d.get(t[o]);
      if (c != null)
        if (s < c && c < a) {
          let u = o, h = 1, f;
          for (; ++u < i && u < a && !((f = d.get(t[u])) == null || f !== c + h); )
            h++;
          if (h > c - s) {
            const p = t[o];
            for (; s < c; ) e.insertBefore(r[s++], p);
          } else e.replaceChild(r[s++], t[o++]);
        } else o++;
      else t[o++].remove();
    }
  }
}
const ug = "_$DX_DELEGATE";
function re(e, t, r, n) {
  let i;
  const a = () => {
    const s = n ? document.createElementNS("http://www.w3.org/1998/Math/MathML", "template") : document.createElement("template");
    return s.innerHTML = e, r ? s.content.firstChild.firstChild : n ? s.firstChild : s.content.firstChild;
  }, o = t ? () => Le(() => document.importNode(i || (i = a()), !0)) : () => (i || (i = a())).cloneNode(!0);
  return o.cloneNode = o, o;
}
function ns(e, t = window.document) {
  const r = t[ug] || (t[ug] = /* @__PURE__ */ new Set());
  for (let n = 0, i = e.length; n < i; n++) {
    const a = e[n];
    r.has(a) || (r.add(a), t.addEventListener(a, ax));
  }
}
function I0(e, t, r) {
  r == null ? e.removeAttribute(t) : e.setAttribute(t, r);
}
function X_(e, t, r, n) {
  n == null ? e.removeAttributeNS(t, r) : e.setAttributeNS(t, r, n);
}
function ex(e, t, r) {
  r ? e.setAttribute(t, "") : e.removeAttribute(t);
}
function Zi(e, t) {
  t == null ? e.removeAttribute("class") : e.className = t;
}
function Oe(e, t, r, n) {
  if (n)
    Array.isArray(r) ? (e[`$$${t}`] = r[0], e[`$$${t}Data`] = r[1]) : e[`$$${t}`] = r;
  else if (Array.isArray(r)) {
    const i = r[0];
    e.addEventListener(t, r[0] = (a) => i.call(e, r[1], a));
  } else e.addEventListener(t, r, typeof r != "function" && r);
}
function tx(e, t, r = {}) {
  const n = Object.keys(t || {}), i = Object.keys(r);
  let a, o;
  for (a = 0, o = i.length; a < o; a++) {
    const s = i[a];
    !s || s === "undefined" || t[s] || (hg(e, s, !1), delete r[s]);
  }
  for (a = 0, o = n.length; a < o; a++) {
    const s = n[a], l = !!t[s];
    !s || s === "undefined" || r[s] === l || !l || (hg(e, s, !0), r[s] = l);
  }
  return r;
}
function U7(e, t, r) {
  if (!t) return r ? I0(e, "style") : t;
  const n = e.style;
  if (typeof t == "string") return n.cssText = t;
  typeof r == "string" && (n.cssText = r = void 0), r || (r = {}), t || (t = {});
  let i, a;
  for (a in r)
    t[a] == null && n.removeProperty(a), delete r[a];
  for (a in t)
    i = t[a], i !== r[a] && (n.setProperty(a, i), r[a] = i);
  return r;
}
function rx(e, t = {}, r, n) {
  const i = {};
  return te(() => i.children = ec(e, t.children, i.children)), te(() => typeof t.ref == "function" && Rt(t.ref, e)), te(() => nx(e, t, r, !0, i, !0)), i;
}
function Rt(e, t, r) {
  return Le(() => e(t, r));
}
function N(e, t, r, n) {
  if (r !== void 0 && !n && (n = []), typeof t != "function") return ec(e, t, n, r);
  te((i) => ec(e, t(), i, r), n);
}
function nx(e, t, r, n, i = {}, a = !1) {
  t || (t = {});
  for (const o in i)
    if (!(o in t)) {
      if (o === "children") continue;
      i[o] = fg(e, o, null, i[o], r, a, t);
    }
  for (const o in t) {
    if (o === "children")
      continue;
    const s = t[o];
    i[o] = fg(e, o, s, i[o], r, a, t);
  }
}
function ix(e) {
  return e.toLowerCase().replace(/-([a-z])/g, (t, r) => r.toUpperCase());
}
function hg(e, t, r) {
  const n = t.trim().split(/\s+/);
  for (let i = 0, a = n.length; i < a; i++) e.classList.toggle(n[i], r);
}
function fg(e, t, r, n, i, a, o) {
  let s, l, d, c, u;
  if (t === "style") return U7(e, r, n);
  if (t === "classList") return tx(e, r, n);
  if (r === n) return n;
  if (t === "ref")
    a || r(e);
  else if (t.slice(0, 3) === "on:") {
    const h = t.slice(3);
    n && e.removeEventListener(h, n, typeof n != "function" && n), r && e.addEventListener(h, r, typeof r != "function" && r);
  } else if (t.slice(0, 10) === "oncapture:") {
    const h = t.slice(10);
    n && e.removeEventListener(h, n, !0), r && e.addEventListener(h, r, !0);
  } else if (t.slice(0, 2) === "on") {
    const h = t.slice(2).toLowerCase(), f = G_.has(h);
    if (!f && n) {
      const p = Array.isArray(n) ? n[0] : n;
      e.removeEventListener(h, p);
    }
    (f || r) && (Oe(e, h, r, f), f && ns([h]));
  } else if (t.slice(0, 5) === "attr:")
    I0(e, t.slice(5), r);
  else if (t.slice(0, 5) === "bool:")
    ex(e, t.slice(5), r);
  else if ((u = t.slice(0, 5) === "prop:") || (d = H_.has(t)) || !i && ((c = Q_(t, e.tagName)) || (l = B_.has(t))) || (s = e.nodeName.includes("-") || "is" in o))
    u && (t = t.slice(5), l = !0), t === "class" || t === "className" ? Zi(e, r) : s && !l && !d ? e[ix(t)] = r : e[c || t] = r;
  else {
    const h = i && t.indexOf(":") > -1 && J_[t.split(":")[0]];
    h ? X_(e, h, t, r) : I0(e, W_[t] || t, r);
  }
  return r;
}
function ax(e) {
  let t = e.target;
  const r = `$$${e.type}`, n = e.target, i = e.currentTarget, a = (l) => Object.defineProperty(e, "target", {
    configurable: !0,
    value: l
  }), o = () => {
    const l = t[r];
    if (l && !t.disabled) {
      const d = t[`${r}Data`];
      if (d !== void 0 ? l.call(t, d, e) : l.call(t, e), e.cancelBubble) return;
    }
    return t.host && typeof t.host != "string" && !t.host._$host && t.contains(e.target) && a(t.host), !0;
  }, s = () => {
    for (; o() && (t = t._$host || t.parentNode || t.host); ) ;
  };
  if (Object.defineProperty(e, "currentTarget", {
    configurable: !0,
    get() {
      return t || document;
    }
  }), e.composedPath) {
    const l = e.composedPath();
    a(l[0]);
    for (let d = 0; d < l.length - 2 && (t = l[d], !!o()); d++) {
      if (t._$host) {
        t = t._$host, s();
        break;
      }
      if (t.parentNode === i)
        break;
    }
  } else s();
  a(n);
}
function ec(e, t, r, n, i) {
  for (; typeof r == "function"; ) r = r();
  if (t === r) return r;
  const a = typeof t, o = n !== void 0;
  if (e = o && r[0] && r[0].parentNode || e, a === "string" || a === "number") {
    if (a === "number" && (t = t.toString(), t === r))
      return r;
    if (o) {
      let s = r[0];
      s && s.nodeType === 3 ? s.data !== t && (s.data = t) : s = document.createTextNode(t), r = cs(e, r, n, s);
    } else
      r !== "" && typeof r == "string" ? r = e.firstChild.data = t : r = e.textContent = t;
  } else if (t == null || a === "boolean")
    r = cs(e, r, n);
  else {
    if (a === "function")
      return te(() => {
        let s = t();
        for (; typeof s == "function"; ) s = s();
        r = ec(e, s, r, n);
      }), () => r;
    if (Array.isArray(t)) {
      const s = [], l = r && Array.isArray(r);
      if (k2(s, t, r, i))
        return te(() => r = ec(e, s, r, n, !0)), () => r;
      if (s.length === 0) {
        if (r = cs(e, r, n), o) return r;
      } else l ? r.length === 0 ? pg(e, s, n) : Z_(e, r, s) : (r && cs(e), pg(e, s));
      r = s;
    } else if (t.nodeType) {
      if (Array.isArray(r)) {
        if (o) return r = cs(e, r, n, t);
        cs(e, r, null, t);
      } else r == null || r === "" || !e.firstChild ? e.appendChild(t) : e.replaceChild(t, e.firstChild);
      r = t;
    }
  }
  return r;
}
function k2(e, t, r, n) {
  let i = !1;
  for (let a = 0, o = t.length; a < o; a++) {
    let s = t[a], l = r && r[e.length], d;
    if (!(s == null || s === !0 || s === !1)) if ((d = typeof s) == "object" && s.nodeType)
      e.push(s);
    else if (Array.isArray(s))
      i = k2(e, s, l) || i;
    else if (d === "function")
      if (n) {
        for (; typeof s == "function"; ) s = s();
        i = k2(e, Array.isArray(s) ? s : [s], Array.isArray(l) ? l : [l]) || i;
      } else
        e.push(s), i = !0;
    else {
      const c = String(s);
      l && l.nodeType === 3 && l.data === c ? e.push(l) : e.push(document.createTextNode(c));
    }
  }
  return i;
}
function pg(e, t, r = null) {
  for (let n = 0, i = t.length; n < i; n++) e.insertBefore(t[n], r);
}
function cs(e, t, r, n) {
  if (r === void 0) return e.textContent = "";
  const i = n || document.createTextNode("");
  if (t.length) {
    let a = !1;
    for (let o = t.length - 1; o >= 0; o--) {
      const s = t[o];
      if (i !== s) {
        const l = s.parentNode === e;
        !a && !o ? l ? e.replaceChild(i, s) : e.insertBefore(i, r) : l && s.remove();
      } else a = !0;
    }
  } else e.insertBefore(i, r);
  return [i];
}
const ox = "http://www.w3.org/2000/svg";
function sx(e, t = !1, r = void 0) {
  return t ? document.createElementNS(ox, e) : document.createElement(e, {
    is: r
  });
}
function lx(e, t) {
  const r = B(e);
  return B(() => {
    const n = r();
    switch (typeof n) {
      case "function":
        return Le(() => n(t));
      case "string":
        const i = Y_.has(n), a = sx(n, i, Le(() => t.is));
        return rx(a, t, i), a;
    }
  });
}
function dx(e) {
  const [, t] = qo(e, ["component"]);
  return lx(() => e.component, t);
}
function cx(e) {
  return Object.keys(e).reduce((r, n) => {
    const i = e[n];
    return r[n] = Object.assign({}, i), B7(i.value) && !mx(i.value) && !Array.isArray(i.value) && (r[n].value = Object.assign({}, i.value)), Array.isArray(i.value) && (r[n].value = i.value.slice(0)), r;
  }, {});
}
function ux(e) {
  return e ? Object.keys(e).reduce((r, n) => {
    const i = e[n];
    return r[n] = B7(i) && "value" in i ? i : {
      value: i
    }, r[n].attribute || (r[n].attribute = px(n)), r[n].parse = "parse" in r[n] ? r[n].parse : typeof r[n].value != "string", r;
  }, {}) : {};
}
function hx(e) {
  return Object.keys(e).reduce((r, n) => (r[n] = e[n].value, r), {});
}
function fx(e, t) {
  const r = cx(t);
  return Object.keys(t).forEach((i) => {
    const a = r[i], o = e.getAttribute(a.attribute), s = e[i];
    o != null && (a.value = a.parse ? q7(o) : o), s != null && (a.value = Array.isArray(s) ? s.slice(0) : s), a.reflect && mg(e, a.attribute, a.value, !!a.parse), Object.defineProperty(e, i, {
      get() {
        return a.value;
      },
      set(l) {
        const d = a.value;
        a.value = l, a.reflect && mg(this, a.attribute, a.value, !!a.parse);
        for (let c = 0, u = this.__propertyChangedCallbacks.length; c < u; c++)
          this.__propertyChangedCallbacks[c](i, l, d);
      },
      enumerable: !0,
      configurable: !0
    });
  }), r;
}
function q7(e) {
  if (e)
    try {
      return JSON.parse(e);
    } catch {
      return e;
    }
}
function mg(e, t, r, n) {
  if (r == null || r === !1) return e.removeAttribute(t);
  let i = n ? JSON.stringify(r) : r;
  e.__updating[t] = !0, i === "true" && (i = ""), e.setAttribute(t, i), Promise.resolve().then(() => delete e.__updating[t]);
}
function px(e) {
  return e.replace(/\.?([A-Z]+)/g, (t, r) => "-" + r.toLowerCase()).replace("_", "-").replace(/^-/, "");
}
function B7(e) {
  return e != null && (typeof e == "object" || typeof e == "function");
}
function mx(e) {
  return Object.prototype.toString.call(e) === "[object Function]";
}
function gx(e) {
  return typeof e == "function" && e.toString().indexOf("class") === 0;
}
let Nh;
function vx(e, t) {
  const r = Object.keys(t);
  return class extends e {
    static get observedAttributes() {
      return r.map((i) => t[i].attribute);
    }
    constructor() {
      super(), this.__initialized = !1, this.__released = !1, this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = {};
    }
    connectedCallback() {
      if (this.__initialized) return;
      this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = fx(this, t);
      const i = hx(this.props), a = this.Component, o = Nh;
      try {
        Nh = this, this.__initialized = !0, gx(a) ? new a(i, {
          element: this
        }) : a(i, {
          element: this
        });
      } finally {
        Nh = o;
      }
    }
    async disconnectedCallback() {
      if (await Promise.resolve(), this.isConnected) return;
      this.__propertyChangedCallbacks.length = 0;
      let i = null;
      for (; i = this.__releaseCallbacks.pop(); ) i(this);
      delete this.__initialized, this.__released = !0;
    }
    attributeChangedCallback(i, a, o) {
      if (this.__initialized && !this.__updating[i] && (i = this.lookupProp(i), i in t)) {
        if (o == null && !this[i]) return;
        this[i] = t[i].parse ? q7(o) : o;
      }
    }
    lookupProp(i) {
      if (t)
        return r.find((a) => i === a || i === t[a].attribute);
    }
    get renderRoot() {
      return this.shadowRoot || this.attachShadow({
        mode: "open"
      });
    }
    addReleaseCallback(i) {
      this.__releaseCallbacks.push(i);
    }
    addPropertyChangedCallback(i) {
      this.__propertyChangedCallbacks.push(i);
    }
  };
}
function yx(e, t = {}, r = {}) {
  const {
    BaseElement: n = HTMLElement,
    extension: i,
    customElements: a = window.customElements
  } = r;
  return (o) => {
    if (!e) throw new Error("tag is required to register a Component");
    let s = a.get(e);
    return s ? (s.prototype.Component = o, s) : (s = vx(n, ux(t)), s.prototype.Component = o, s.prototype.registeredTag = e, a.define(e, s, i), s);
  };
}
function bx(e) {
  const t = Object.keys(e), r = {};
  for (let n = 0; n < t.length; n++) {
    const [i, a] = z(e[t[n]]);
    Object.defineProperty(r, t[n], {
      get: i,
      set(o) {
        a(() => o);
      }
    });
  }
  return r;
}
function wx(e) {
  if (e.assignedSlot && e.assignedSlot._$owner) return e.assignedSlot._$owner;
  let t = e.parentNode;
  for (; t && !t._$owner && !(t.assignedSlot && t.assignedSlot._$owner); )
    t = t.parentNode;
  return t && t.assignedSlot ? t.assignedSlot._$owner : e._$owner;
}
function $x(e) {
  return (t, r) => {
    const { element: n } = r;
    return Ws((i) => {
      const a = bx(t);
      n.addPropertyChangedCallback((s, l) => a[s] = l), n.addReleaseCallback(() => {
        n.renderRoot.textContent = "", i();
      });
      const o = e(a, r);
      return N(n.renderRoot, o);
    }, wx(n));
  };
}
function Xr(e, t, r) {
  return arguments.length === 2 && (r = t, t = {}), yx(e, t)($x(r));
}
var _2 = function(e, t) {
  return _2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, _2(e, t);
};
function Li(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  _2(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var F = function() {
  return F = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, F.apply(this, arguments);
};
function ii(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function qe(e, t, r, n) {
  function i(a) {
    return a instanceof r ? a : new r(function(o) {
      o(a);
    });
  }
  return new (r || (r = Promise))(function(a, o) {
    function s(c) {
      try {
        d(n.next(c));
      } catch (u) {
        o(u);
      }
    }
    function l(c) {
      try {
        d(n.throw(c));
      } catch (u) {
        o(u);
      }
    }
    function d(c) {
      c.done ? a(c.value) : i(c.value).then(s, l);
    }
    d((n = n.apply(e, t || [])).next());
  });
}
function ka(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = s(0), o.throw = s(1), o.return = s(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(d) {
    return function(c) {
      return l([d, c]);
    };
  }
  function l(d) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, d[0] && (r = 0)), r; ) try {
      if (n = 1, i && (a = d[0] & 2 ? i.return : d[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, d[1])).done) return a;
      switch (i = 0, a && (d = [d[0] & 2, a.value]), d[0]) {
        case 0:
        case 1:
          a = d;
          break;
        case 4:
          return r.label++, { value: d[1], done: !1 };
        case 5:
          r.label++, i = d[1], d = [0];
          continue;
        case 7:
          d = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (d[0] === 6 || d[0] === 2)) {
            r = 0;
            continue;
          }
          if (d[0] === 3 && (!a || d[1] > a[0] && d[1] < a[3])) {
            r.label = d[1];
            break;
          }
          if (d[0] === 6 && r.label < a[1]) {
            r.label = a[1], a = d;
            break;
          }
          if (a && r.label < a[2]) {
            r.label = a[2], r.ops.push(d);
            break;
          }
          a[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      d = t.call(e, r);
    } catch (c) {
      d = [6, c], i = 0;
    } finally {
      n = a = 0;
    }
    if (d[0] & 5) throw d[1];
    return { value: d[0] ? d[1] : void 0, done: !0 };
  }
}
function Nr(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, a; n < i; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function Wn(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var i = 0;
    for (n = Object.getOwnPropertySymbols(e); i < n.length; i++) t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  }
  return r;
}
const kx = { timeoutInSeconds: 60 }, H7 = { name: "auth0-spa-js", version: "2.17.0" }, W7 = () => Date.now();
let Gt = class x2 extends Error {
  constructor(t, r) {
    super(r), this.error = t, this.error_description = r, Object.setPrototypeOf(this, x2.prototype);
  }
  static fromPayload(t) {
    let { error: r, error_description: n } = t;
    return new x2(r, n);
  }
}, _x = class K7 extends Gt {
  constructor(t, r, n) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    super(t, r), this.state = n, this.appState = i, Object.setPrototypeOf(this, K7.prototype);
  }
}, xx = class Q7 extends Gt {
  constructor(t, r, n, i) {
    let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    super(t, r), this.connection = n, this.state = i, this.appState = a, Object.setPrototypeOf(this, Q7.prototype);
  }
}, M1 = class G7 extends Gt {
  constructor() {
    super("timeout", "Timeout"), Object.setPrototypeOf(this, G7.prototype);
  }
}, Ex = class Y7 extends M1 {
  constructor(t) {
    super(), this.popup = t, Object.setPrototypeOf(this, Y7.prototype);
  }
}, Sx = class J7 extends Gt {
  constructor(t) {
    super("cancelled", "Popup closed"), this.popup = t, Object.setPrototypeOf(this, J7.prototype);
  }
}, Cx = class Z7 extends Gt {
  constructor() {
    super("popup_open", "Unable to open a popup for loginWithPopup - window.open returned `null`"), Object.setPrototypeOf(this, Z7.prototype);
  }
}, D0 = class X7 extends Gt {
  constructor(t, r, n, i) {
    super(t, r), this.mfa_token = n, this.mfa_requirements = i, Object.setPrototypeOf(this, X7.prototype);
  }
}, e6 = class t6 extends Gt {
  constructor(t, r) {
    super("missing_refresh_token", "Missing Refresh Token (audience: '".concat(N0(t, ["default"]), "', scope: '").concat(N0(r), "')")), this.audience = t, this.scope = r, Object.setPrototypeOf(this, t6.prototype);
  }
}, Tx = class r6 extends Gt {
  constructor(t, r) {
    super("missing_scopes", "Missing requested scopes after refresh (audience: '".concat(N0(t, ["default"]), "', missing scope: '").concat(N0(r), "')")), this.audience = t, this.scope = r, Object.setPrototypeOf(this, r6.prototype);
  }
}, n6 = class i6 extends Gt {
  constructor(t) {
    super("use_dpop_nonce", "Server rejected DPoP proof: wrong nonce"), this.newDpopNonce = t, Object.setPrototypeOf(this, i6.prototype);
  }
};
function N0(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e && !t.includes(e) ? e : "";
}
const M0 = () => window.crypto, Zl = () => {
  const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
  let t = "";
  return Array.from(M0().getRandomValues(new Uint8Array(43))).forEach(((r) => t += e[r % e.length])), t;
}, Mh = (e) => btoa(e), Ax = [{ key: "name", type: ["string"] }, { key: "version", type: ["string", "number"] }, { key: "env", type: ["object"] }], a6 = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
  return Object.keys(e).reduce(((r, n) => {
    if (t && n === "env") return r;
    const i = Ax.find(((a) => a.key === n));
    return i && i.type.includes(typeof e[n]) && (r[n] = e[n]), r;
  }), {});
}, E2 = (e) => {
  var { clientId: t } = e, r = Wn(e, ["clientId"]);
  return new URLSearchParams(((n) => Object.keys(n).filter(((i) => n[i] !== void 0)).reduce(((i, a) => Object.assign(Object.assign({}, i), { [a]: n[a] })), {}))(Object.assign({ client_id: t }, r))).toString();
}, gg = async (e) => await M0().subtle.digest({ name: "SHA-256" }, new TextEncoder().encode(e)), vg = (e) => ((t) => decodeURIComponent(atob(t).split("").map(((r) => "%" + ("00" + r.charCodeAt(0).toString(16)).slice(-2))).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), yg = (e) => {
  const t = new Uint8Array(e);
  return ((r) => {
    const n = { "+": "-", "/": "_", "=": "" };
    return r.replace(/[+/=]/g, ((i) => n[i]));
  })(window.btoa(String.fromCharCode(...Array.from(t))));
};
var Bo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, o6 = {}, em = {};
Object.defineProperty(em, "__esModule", { value: !0 });
var Ox = (function() {
  function e() {
    var t = this;
    this.locked = /* @__PURE__ */ new Map(), this.addToLocked = function(r, n) {
      var i = t.locked.get(r);
      i === void 0 ? n === void 0 ? t.locked.set(r, []) : t.locked.set(r, [n]) : n !== void 0 && (i.unshift(n), t.locked.set(r, i));
    }, this.isLocked = function(r) {
      return t.locked.has(r);
    }, this.lock = function(r) {
      return new Promise((function(n, i) {
        t.isLocked(r) ? t.addToLocked(r, n) : (t.addToLocked(r), n());
      }));
    }, this.unlock = function(r) {
      var n = t.locked.get(r);
      if (n !== void 0 && n.length !== 0) {
        var i = n.pop();
        t.locked.set(r, n), i !== void 0 && setTimeout(i, 0);
      } else t.locked.delete(r);
    };
  }
  return e.getInstance = function() {
    return e.instance === void 0 && (e.instance = new e()), e.instance;
  }, e;
})();
em.default = function() {
  return Ox.getInstance();
};
var Kn = Bo && Bo.__awaiter || function(e, t, r, n) {
  return new (r || (r = Promise))((function(i, a) {
    function o(d) {
      try {
        l(n.next(d));
      } catch (c) {
        a(c);
      }
    }
    function s(d) {
      try {
        l(n.throw(d));
      } catch (c) {
        a(c);
      }
    }
    function l(d) {
      d.done ? i(d.value) : new r((function(c) {
        c(d.value);
      })).then(o, s);
    }
    l((n = n.apply(e, t || [])).next());
  }));
}, Qn = Bo && Bo.__generator || function(e, t) {
  var r, n, i, a, o = { label: 0, sent: function() {
    if (1 & i[0]) throw i[1];
    return i[1];
  }, trys: [], ops: [] };
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(l) {
    return function(d) {
      return (function(c) {
        if (r) throw new TypeError("Generator is already executing.");
        for (; o; ) try {
          if (r = 1, n && (i = 2 & c[0] ? n.return : c[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, c[1])).done) return i;
          switch (n = 0, i && (c = [2 & c[0], i.value]), c[0]) {
            case 0:
            case 1:
              i = c;
              break;
            case 4:
              return o.label++, { value: c[1], done: !1 };
            case 5:
              o.label++, n = c[1], c = [0];
              continue;
            case 7:
              c = o.ops.pop(), o.trys.pop();
              continue;
            default:
              if (i = o.trys, !((i = i.length > 0 && i[i.length - 1]) || c[0] !== 6 && c[0] !== 2)) {
                o = 0;
                continue;
              }
              if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
                o.label = c[1];
                break;
              }
              if (c[0] === 6 && o.label < i[1]) {
                o.label = i[1], i = c;
                break;
              }
              if (i && o.label < i[2]) {
                o.label = i[2], o.ops.push(c);
                break;
              }
              i[2] && o.ops.pop(), o.trys.pop();
              continue;
          }
          c = t.call(e, o);
        } catch (u) {
          c = [6, u], n = 0;
        } finally {
          r = i = 0;
        }
        if (5 & c[0]) throw c[1];
        return { value: c[0] ? c[1] : void 0, done: !0 };
      })([l, d]);
    };
  }
}, Xl = Bo;
Object.defineProperty(o6, "__esModule", { value: !0 });
var us = em, mu = { key: function(e) {
  return Kn(Xl, void 0, void 0, (function() {
    return Qn(this, (function(t) {
      throw new Error("Unsupported");
    }));
  }));
}, getItem: function(e) {
  return Kn(Xl, void 0, void 0, (function() {
    return Qn(this, (function(t) {
      throw new Error("Unsupported");
    }));
  }));
}, clear: function() {
  return Kn(Xl, void 0, void 0, (function() {
    return Qn(this, (function(e) {
      return [2, window.localStorage.clear()];
    }));
  }));
}, removeItem: function(e) {
  return Kn(Xl, void 0, void 0, (function() {
    return Qn(this, (function(t) {
      throw new Error("Unsupported");
    }));
  }));
}, setItem: function(e, t) {
  return Kn(Xl, void 0, void 0, (function() {
    return Qn(this, (function(r) {
      throw new Error("Unsupported");
    }));
  }));
}, keySync: function(e) {
  return window.localStorage.key(e);
}, getItemSync: function(e) {
  return window.localStorage.getItem(e);
}, clearSync: function() {
  return window.localStorage.clear();
}, removeItemSync: function(e) {
  return window.localStorage.removeItem(e);
}, setItemSync: function(e, t) {
  return window.localStorage.setItem(e, t);
} };
function Rh(e) {
  return new Promise((function(t) {
    return setTimeout(t, e);
  }));
}
function Lh(e) {
  for (var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", r = "", n = 0; n < e; n++)
    r += t[Math.floor(Math.random() * t.length)];
  return r;
}
var Px = (function() {
  function e(t) {
    this.acquiredIatSet = /* @__PURE__ */ new Set(), this.storageHandler = void 0, this.id = Date.now().toString() + Lh(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, e.waiters === void 0 && (e.waiters = []);
  }
  return e.prototype.acquireLock = function(t, r) {
    return r === void 0 && (r = 5e3), Kn(this, void 0, void 0, (function() {
      var n, i, a, o, s, l, d;
      return Qn(this, (function(c) {
        switch (c.label) {
          case 0:
            n = Date.now() + Lh(4), i = Date.now() + r, a = "browser-tabs-lock-key-" + t, o = this.storageHandler === void 0 ? mu : this.storageHandler, c.label = 1;
          case 1:
            return Date.now() < i ? [4, Rh(30)] : [3, 8];
          case 2:
            return c.sent(), o.getItemSync(a) !== null ? [3, 5] : (s = this.id + "-" + t + "-" + n, [4, Rh(Math.floor(25 * Math.random()))]);
          case 3:
            return c.sent(), o.setItemSync(a, JSON.stringify({ id: this.id, iat: n, timeoutKey: s, timeAcquired: Date.now(), timeRefreshed: Date.now() })), [4, Rh(30)];
          case 4:
            return c.sent(), (l = o.getItemSync(a)) !== null && (d = JSON.parse(l)).id === this.id && d.iat === n ? (this.acquiredIatSet.add(n), this.refreshLockWhileAcquired(a, n), [2, !0]) : [3, 7];
          case 5:
            return e.lockCorrector(this.storageHandler === void 0 ? mu : this.storageHandler), [4, this.waitForSomethingToChange(i)];
          case 6:
            c.sent(), c.label = 7;
          case 7:
            return n = Date.now() + Lh(4), [3, 1];
          case 8:
            return [2, !1];
        }
      }));
    }));
  }, e.prototype.refreshLockWhileAcquired = function(t, r) {
    return Kn(this, void 0, void 0, (function() {
      var n = this;
      return Qn(this, (function(i) {
        return setTimeout((function() {
          return Kn(n, void 0, void 0, (function() {
            var a, o, s;
            return Qn(this, (function(l) {
              switch (l.label) {
                case 0:
                  return [4, us.default().lock(r)];
                case 1:
                  return l.sent(), this.acquiredIatSet.has(r) ? (a = this.storageHandler === void 0 ? mu : this.storageHandler, (o = a.getItemSync(t)) === null ? (us.default().unlock(r), [2]) : ((s = JSON.parse(o)).timeRefreshed = Date.now(), a.setItemSync(t, JSON.stringify(s)), us.default().unlock(r), this.refreshLockWhileAcquired(t, r), [2])) : (us.default().unlock(r), [2]);
              }
            }));
          }));
        }), 1e3), [2];
      }));
    }));
  }, e.prototype.waitForSomethingToChange = function(t) {
    return Kn(this, void 0, void 0, (function() {
      return Qn(this, (function(r) {
        switch (r.label) {
          case 0:
            return [4, new Promise((function(n) {
              var i = !1, a = Date.now(), o = !1;
              function s() {
                if (o || (window.removeEventListener("storage", s), e.removeFromWaiting(s), clearTimeout(l), o = !0), !i) {
                  i = !0;
                  var d = 50 - (Date.now() - a);
                  d > 0 ? setTimeout(n, d) : n(null);
                }
              }
              window.addEventListener("storage", s), e.addToWaiting(s);
              var l = setTimeout(s, Math.max(0, t - Date.now()));
            }))];
          case 1:
            return r.sent(), [2];
        }
      }));
    }));
  }, e.addToWaiting = function(t) {
    this.removeFromWaiting(t), e.waiters !== void 0 && e.waiters.push(t);
  }, e.removeFromWaiting = function(t) {
    e.waiters !== void 0 && (e.waiters = e.waiters.filter((function(r) {
      return r !== t;
    })));
  }, e.notifyWaiters = function() {
    e.waiters !== void 0 && e.waiters.slice().forEach((function(t) {
      return t();
    }));
  }, e.prototype.releaseLock = function(t) {
    return Kn(this, void 0, void 0, (function() {
      return Qn(this, (function(r) {
        switch (r.label) {
          case 0:
            return [4, this.releaseLock__private__(t)];
          case 1:
            return [2, r.sent()];
        }
      }));
    }));
  }, e.prototype.releaseLock__private__ = function(t) {
    return Kn(this, void 0, void 0, (function() {
      var r, n, i, a;
      return Qn(this, (function(o) {
        switch (o.label) {
          case 0:
            return r = this.storageHandler === void 0 ? mu : this.storageHandler, n = "browser-tabs-lock-key-" + t, (i = r.getItemSync(n)) === null ? [2] : (a = JSON.parse(i)).id !== this.id ? [3, 2] : [4, us.default().lock(a.iat)];
          case 1:
            o.sent(), this.acquiredIatSet.delete(a.iat), r.removeItemSync(n), us.default().unlock(a.iat), e.notifyWaiters(), o.label = 2;
          case 2:
            return [2];
        }
      }));
    }));
  }, e.lockCorrector = function(t) {
    for (var r = Date.now() - 5e3, n = t, i = [], a = 0; ; ) {
      var o = n.keySync(a);
      if (o === null) break;
      i.push(o), a++;
    }
    for (var s = !1, l = 0; l < i.length; l++) {
      var d = i[l];
      if (d.includes("browser-tabs-lock-key")) {
        var c = n.getItemSync(d);
        if (c !== null) {
          var u = JSON.parse(c);
          (u.timeRefreshed === void 0 && u.timeAcquired < r || u.timeRefreshed !== void 0 && u.timeRefreshed < r) && (n.removeItemSync(d), s = !0);
        }
      }
    }
    s && e.notifyWaiters();
  }, e.waiters = void 0, e;
})(), Ix = o6.default = Px;
let Dx = class {
  async runWithLock(t, r, n) {
    const i = new AbortController(), a = setTimeout((() => i.abort()), r);
    try {
      return await navigator.locks.request(t, { mode: "exclusive", signal: i.signal }, (async (o) => {
        if (clearTimeout(a), !o) throw new Error("Lock not available");
        return await n();
      }));
    } catch (o) {
      throw clearTimeout(a), o?.name === "AbortError" ? new M1() : o;
    }
  }
};
class Nx {
  constructor() {
    this.activeLocks = /* @__PURE__ */ new Set(), this.lock = new Ix(), this.pagehideHandler = () => {
      this.activeLocks.forEach(((t) => this.lock.releaseLock(t))), this.activeLocks.clear();
    };
  }
  async runWithLock(t, r, n) {
    let i = !1;
    for (let a = 0; a < 10 && !i; a++) i = await this.lock.acquireLock(t, r);
    if (!i) throw new M1();
    this.activeLocks.add(t), this.activeLocks.size === 1 && typeof window < "u" && window.addEventListener("pagehide", this.pagehideHandler);
    try {
      return await n();
    } finally {
      this.activeLocks.delete(t), await this.lock.releaseLock(t), this.activeLocks.size === 0 && typeof window < "u" && window.removeEventListener("pagehide", this.pagehideHandler);
    }
  }
}
function Mx() {
  return typeof navigator < "u" && typeof ((e = navigator.locks) === null || e === void 0 ? void 0 : e.request) == "function" ? new Dx() : new Nx();
  var e;
}
let Fh = null;
const Rx = new TextEncoder(), Lx = new TextDecoder();
function Ld(e) {
  return typeof e == "string" ? Rx.encode(e) : Lx.decode(e);
}
function bg(e) {
  if (typeof e.modulusLength != "number" || e.modulusLength < 2048) throw new jx(`${e.name} modulusLength must be at least 2048 bits`);
}
async function Fx(e, t, r) {
  if (r.usages.includes("sign") === !1) throw new TypeError('private CryptoKey instances used for signing assertions must include "sign" in their "usages"');
  const n = `${Fd(Ld(JSON.stringify(e)))}.${Fd(Ld(JSON.stringify(t)))}`;
  return `${n}.${Fd(await crypto.subtle.sign((function(i) {
    switch (i.algorithm.name) {
      case "ECDSA":
        return { name: i.algorithm.name, hash: "SHA-256" };
      case "RSA-PSS":
        return bg(i.algorithm), { name: i.algorithm.name, saltLength: 32 };
      case "RSASSA-PKCS1-v1_5":
        return bg(i.algorithm), { name: i.algorithm.name };
      case "Ed25519":
        return { name: i.algorithm.name };
    }
    throw new No();
  })(r), r, Ld(n)))}`;
}
let S2;
Uint8Array.prototype.toBase64 ? S2 = (e) => (e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({ alphabet: "base64url", omitPadding: !0 })) : S2 = (t) => {
  t instanceof ArrayBuffer && (t = new Uint8Array(t));
  const r = [];
  for (let n = 0; n < t.byteLength; n += 32768) r.push(String.fromCharCode.apply(null, t.subarray(n, n + 32768)));
  return btoa(r.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
function Fd(e) {
  return S2(e);
}
let No = class extends Error {
  constructor(t) {
    var r;
    super(t ?? "operation not supported"), this.name = this.constructor.name, (r = Error.captureStackTrace) === null || r === void 0 || r.call(Error, this, this.constructor);
  }
}, jx = class extends Error {
  constructor(t) {
    var r;
    super(t), this.name = this.constructor.name, (r = Error.captureStackTrace) === null || r === void 0 || r.call(Error, this, this.constructor);
  }
};
function zx(e) {
  switch (e.algorithm.name) {
    case "RSA-PSS":
      return (function(t) {
        if (t.algorithm.hash.name === "SHA-256") return "PS256";
        throw new No("unsupported RsaHashedKeyAlgorithm hash name");
      })(e);
    case "RSASSA-PKCS1-v1_5":
      return (function(t) {
        if (t.algorithm.hash.name === "SHA-256") return "RS256";
        throw new No("unsupported RsaHashedKeyAlgorithm hash name");
      })(e);
    case "ECDSA":
      return (function(t) {
        if (t.algorithm.namedCurve === "P-256") return "ES256";
        throw new No("unsupported EcKeyAlgorithm namedCurve");
      })(e);
    case "Ed25519":
      return "Ed25519";
    default:
      throw new No("unsupported CryptoKey algorithm name");
  }
}
function s6(e) {
  return e instanceof CryptoKey;
}
function l6(e) {
  return s6(e) && e.type === "public";
}
async function Vx(e, t, r, n, i, a) {
  const o = e?.privateKey, s = e?.publicKey;
  if (!s6(l = o) || l.type !== "private") throw new TypeError('"keypair.privateKey" must be a private CryptoKey');
  var l;
  if (!l6(s)) throw new TypeError('"keypair.publicKey" must be a public CryptoKey');
  if (s.extractable !== !0) throw new TypeError('"keypair.publicKey.extractable" must be true');
  if (typeof t != "string") throw new TypeError('"htu" must be a string');
  if (typeof r != "string") throw new TypeError('"htm" must be a string');
  if (n !== void 0 && typeof n != "string") throw new TypeError('"nonce" must be a string or undefined');
  if (i !== void 0 && typeof i != "string") throw new TypeError('"accessToken" must be a string or undefined');
  return Fx({ alg: zx(o), typ: "dpop+jwt", jwk: await d6(s) }, Object.assign(Object.assign({}, a), { iat: Math.floor(Date.now() / 1e3), jti: crypto.randomUUID(), htm: r, nonce: n, htu: t, ath: i ? Fd(await crypto.subtle.digest("SHA-256", Ld(i))) : void 0 }), o);
}
async function d6(e) {
  const { kty: t, e: r, n, x: i, y: a, crv: o } = await crypto.subtle.exportKey("jwk", e);
  return { kty: t, crv: o, e: r, n, x: i, y: a };
}
const Ux = ["authorization_code", "refresh_token", "urn:ietf:params:oauth:grant-type:token-exchange", "http://auth0.com/oauth/grant-type/mfa-oob", "http://auth0.com/oauth/grant-type/mfa-otp", "http://auth0.com/oauth/grant-type/mfa-recovery-code"];
function qx() {
  return (async function(e, t) {
    var r;
    let n;
    if (e.length === 0) throw new TypeError('"alg" must be a non-empty string');
    switch (e) {
      case "PS256":
        n = { name: "RSA-PSS", hash: "SHA-256", modulusLength: 2048, publicExponent: new Uint8Array([1, 0, 1]) };
        break;
      case "RS256":
        n = { name: "RSASSA-PKCS1-v1_5", hash: "SHA-256", modulusLength: 2048, publicExponent: new Uint8Array([1, 0, 1]) };
        break;
      case "ES256":
        n = { name: "ECDSA", namedCurve: "P-256" };
        break;
      case "Ed25519":
        n = { name: "Ed25519" };
        break;
      default:
        throw new No();
    }
    return crypto.subtle.generateKey(n, (r = t?.extractable) !== null && r !== void 0 && r, ["sign", "verify"]);
  })("ES256", { extractable: !1 });
}
function Bx(e) {
  return (async function(t) {
    if (!l6(t)) throw new TypeError('"publicKey" must be a public CryptoKey');
    if (t.extractable !== !0) throw new TypeError('"publicKey.extractable" must be true');
    const r = await d6(t);
    let n;
    switch (r.kty) {
      case "EC":
        n = { crv: r.crv, kty: r.kty, x: r.x, y: r.y };
        break;
      case "OKP":
        n = { crv: r.crv, kty: r.kty, x: r.x };
        break;
      case "RSA":
        n = { e: r.e, kty: r.kty, n: r.n };
        break;
      default:
        throw new No("unsupported JWK kty");
    }
    return Fd(await crypto.subtle.digest({ name: "SHA-256" }, Ld(JSON.stringify(n))));
  })(e.publicKey);
}
function Hx(e) {
  let { keyPair: t, url: r, method: n, nonce: i, accessToken: a } = e;
  const o = (function(s) {
    const l = new URL(s);
    return l.search = "", l.hash = "", l.href;
  })(r);
  return Vx(t, o, n, i, a);
}
const Wx = async (e, t) => {
  const r = await fetch(e, t);
  return { ok: r.ok, json: await r.json(), headers: (n = r.headers, [...n].reduce(((i, a) => {
    let [o, s] = a;
    return i[o] = s, i;
  }), {})) };
  var n;
}, Kx = async (e, t, r) => {
  const n = new AbortController();
  let i;
  return t.signal = n.signal, Promise.race([Wx(e, t), new Promise(((a, o) => {
    i = setTimeout((() => {
      n.abort(), o(new Error("Timeout when executing 'fetch'"));
    }), r);
  }))]).finally((() => {
    clearTimeout(i);
  }));
}, Qx = async (e, t, r, n, i, a, o, s) => ((l, d) => new Promise((function(c, u) {
  const h = new MessageChannel();
  h.port1.onmessage = function(f) {
    f.data.error ? u(new Error(f.data.error)) : c(f.data), h.port1.close();
  }, d.postMessage(l, [h.port2]);
})))({ auth: { audience: t, scope: r }, timeout: i, fetchUrl: e, fetchOptions: n, useFormData: o, useMrrt: s }, a), Gx = async function(e, t, r, n, i, a) {
  let o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 1e4, s = arguments.length > 7 ? arguments[7] : void 0;
  return i ? Qx(e, t, r, n, o, i, a, s) : Kx(e, n, o);
};
async function c6(e, t, r, n, i, a, o, s, l, d) {
  if (l) {
    const $ = await l.generateProof({ url: e, method: i.method || "GET", nonce: await l.getNonce() });
    i.headers = Object.assign(Object.assign({}, i.headers), { dpop: $ });
  }
  let c, u = null;
  for (let $ = 0; $ < 3; $++) try {
    c = await Gx(e, r, n, i, a, o, t, s), u = null;
    break;
  } catch (_) {
    u = _;
  }
  if (u) throw u;
  const h = c.json, { error: f, error_description: p } = h, m = Wn(h, ["error", "error_description"]), { headers: y, ok: g } = c;
  let w;
  if (l && (w = y["dpop-nonce"], w && await l.setNonce(w)), !g) {
    const $ = p || "HTTP error. Unable to fetch ".concat(e);
    if (f === "mfa_required") throw new D0(f, $, m.mfa_token, m.mfa_requirements);
    if (f === "missing_refresh_token") throw new e6(r, n);
    if (f === "use_dpop_nonce") {
      if (!l || !w || d) throw new n6(w);
      return c6(e, t, r, n, i, a, o, s, l, !0);
    }
    throw new Gt(f || "request_error", $);
  }
  return m;
}
async function Yx(e, t) {
  var { baseUrl: r, timeout: n, audience: i, scope: a, auth0Client: o, useFormData: s, useMrrt: l, dpop: d } = e, c = Wn(e, ["baseUrl", "timeout", "audience", "scope", "auth0Client", "useFormData", "useMrrt", "dpop"]);
  const u = c.grant_type === "urn:ietf:params:oauth:grant-type:token-exchange", h = c.grant_type === "refresh_token" && l, f = Object.assign(Object.assign(Object.assign(Object.assign({}, c), u && i && { audience: i }), u && a && { scope: a }), h && { audience: i, scope: a }), p = s ? E2(f) : JSON.stringify(f), m = (y = c.grant_type, Ux.includes(y));
  var y;
  return await c6("".concat(r, "/oauth/token"), n, i || "default", a, { method: "POST", body: p, headers: { "Content-Type": s ? "application/x-www-form-urlencoded" : "application/json", "Auth0-Client": btoa(JSON.stringify(a6(o || H7))) } }, t, s, l, m ? d : void 0);
}
const Jx = (e) => Array.from(new Set(e)), r0 = function() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
  return Jx(t.filter(Boolean).join(" ").trim().split(/\s+/)).join(" ");
}, gu = (e, t, r) => {
  let n;
  return r && (n = e[r]), n || (n = e.default), r0(n, t);
};
let Qi = class C2 {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "@@auth0spajs@@", n = arguments.length > 2 ? arguments[2] : void 0;
    this.prefix = r, this.suffix = n, this.clientId = t.clientId, this.scope = t.scope, this.audience = t.audience;
  }
  toKey() {
    return [this.prefix, this.clientId, this.audience, this.scope, this.suffix].filter(Boolean).join("::");
  }
  static fromKey(t) {
    const [r, n, i, a] = t.split("::");
    return new C2({ clientId: n, scope: a, audience: i }, r);
  }
  static fromCacheEntry(t) {
    const { scope: r, audience: n, client_id: i } = t;
    return new C2({ scope: r, audience: n, clientId: i });
  }
}, Zx = class {
  set(t, r) {
    localStorage.setItem(t, JSON.stringify(r));
  }
  get(t) {
    const r = window.localStorage.getItem(t);
    if (r) try {
      return JSON.parse(r);
    } catch {
      return;
    }
  }
  remove(t) {
    localStorage.removeItem(t);
  }
  allKeys() {
    return Object.keys(window.localStorage).filter(((t) => t.startsWith("@@auth0spajs@@")));
  }
}, u6 = class {
  constructor() {
    this.enclosedCache = /* @__PURE__ */ (function() {
      let t = {};
      return { set(r, n) {
        t[r] = n;
      }, get(r) {
        const n = t[r];
        if (n) return n;
      }, remove(r) {
        delete t[r];
      }, allKeys: () => Object.keys(t) };
    })();
  }
};
class Xx {
  constructor(t, r, n) {
    this.cache = t, this.keyManifest = r, this.nowProvider = n || W7;
  }
  async setIdToken(t, r, n) {
    var i;
    const a = this.getIdTokenCacheKey(t);
    await this.cache.set(a, { id_token: r, decodedToken: n }), await ((i = this.keyManifest) === null || i === void 0 ? void 0 : i.add(a));
  }
  async getIdToken(t) {
    const r = await this.cache.get(this.getIdTokenCacheKey(t.clientId));
    if (!r && t.scope && t.audience) {
      const n = await this.get(t);
      return !n || !n.id_token || !n.decodedToken ? void 0 : { id_token: n.id_token, decodedToken: n.decodedToken };
    }
    if (r) return { id_token: r.id_token, decodedToken: r.decodedToken };
  }
  async get(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], i = arguments.length > 3 ? arguments[3] : void 0;
    var a;
    let o = await this.cache.get(t.toKey());
    if (!o) {
      const d = await this.getCacheKeys();
      if (!d) return;
      const c = this.matchExistingCacheKey(t, d);
      if (c && (o = await this.cache.get(c)), !o && n && i !== "cache-only") return this.getEntryWithRefreshToken(t, d);
    }
    if (!o) return;
    const s = await this.nowProvider(), l = Math.floor(s / 1e3);
    return o.expiresAt - r < l ? o.body.refresh_token ? this.modifiedCachedEntry(o, t) : (await this.cache.remove(t.toKey()), void await ((a = this.keyManifest) === null || a === void 0 ? void 0 : a.remove(t.toKey()))) : o.body;
  }
  async modifiedCachedEntry(t, r) {
    return t.body = { refresh_token: t.body.refresh_token, audience: t.body.audience, scope: t.body.scope }, await this.cache.set(r.toKey(), t), { refresh_token: t.body.refresh_token, audience: t.body.audience, scope: t.body.scope };
  }
  async set(t) {
    var r;
    const n = new Qi({ clientId: t.client_id, scope: t.scope, audience: t.audience }), i = await this.wrapCacheEntry(t);
    await this.cache.set(n.toKey(), i), await ((r = this.keyManifest) === null || r === void 0 ? void 0 : r.add(n.toKey()));
  }
  async remove(t, r, n) {
    const i = new Qi({ clientId: t, scope: n, audience: r });
    await this.cache.remove(i.toKey());
  }
  async clear(t) {
    var r;
    const n = await this.getCacheKeys();
    n && (await n.filter(((i) => !t || i.includes(t))).reduce((async (i, a) => {
      await i, await this.cache.remove(a);
    }), Promise.resolve()), await ((r = this.keyManifest) === null || r === void 0 ? void 0 : r.clear()));
  }
  async wrapCacheEntry(t) {
    const r = await this.nowProvider();
    return { body: t, expiresAt: Math.floor(r / 1e3) + t.expires_in };
  }
  async getCacheKeys() {
    var t;
    return this.keyManifest ? (t = await this.keyManifest.get()) === null || t === void 0 ? void 0 : t.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
  }
  getIdTokenCacheKey(t) {
    return new Qi({ clientId: t }, "@@auth0spajs@@", "@@user@@").toKey();
  }
  matchExistingCacheKey(t, r) {
    return r.filter(((n) => {
      var i;
      const a = Qi.fromKey(n), o = new Set(a.scope && a.scope.split(" ")), s = ((i = t.scope) === null || i === void 0 ? void 0 : i.split(" ")) || [], l = a.scope && s.reduce(((d, c) => d && o.has(c)), !0);
      return a.prefix === "@@auth0spajs@@" && a.clientId === t.clientId && a.audience === t.audience && l;
    }))[0];
  }
  async getEntryWithRefreshToken(t, r) {
    var n;
    for (const i of r) {
      const a = Qi.fromKey(i);
      if (a.prefix === "@@auth0spajs@@" && a.clientId === t.clientId) {
        const o = await this.cache.get(i);
        if (!((n = o?.body) === null || n === void 0) && n.refresh_token) return this.modifiedCachedEntry(o, t);
      }
    }
  }
  async updateEntry(t, r) {
    var n;
    const i = await this.getCacheKeys();
    if (i) for (const a of i) {
      const o = await this.cache.get(a);
      ((n = o?.body) === null || n === void 0 ? void 0 : n.refresh_token) === t && (o.body.refresh_token = r, await this.cache.set(a, o));
    }
  }
}
class eE {
  constructor(t, r, n) {
    this.storage = t, this.clientId = r, this.cookieDomain = n, this.storageKey = "".concat("a0.spajs.txs", ".").concat(this.clientId);
  }
  create(t) {
    this.storage.save(this.storageKey, t, { daysUntilExpire: 1, cookieDomain: this.cookieDomain });
  }
  get() {
    return this.storage.get(this.storageKey);
  }
  remove() {
    this.storage.remove(this.storageKey, { cookieDomain: this.cookieDomain });
  }
}
const ed = (e) => typeof e == "number", tE = ["iss", "aud", "exp", "nbf", "iat", "jti", "azp", "nonce", "auth_time", "at_hash", "c_hash", "acr", "amr", "sub_jwk", "cnf", "sip_from_tag", "sip_date", "sip_callid", "sip_cseq_num", "sip_via_branch", "orig", "dest", "mky", "events", "toe", "txn", "rph", "sid", "vot", "vtm"], rE = (e) => {
  if (!e.id_token) throw new Error("ID token is required but missing");
  const t = ((a) => {
    const o = a.split("."), [s, l, d] = o;
    if (o.length !== 3 || !s || !l || !d) throw new Error("ID token could not be decoded");
    const c = JSON.parse(vg(l)), u = { __raw: a }, h = {};
    return Object.keys(c).forEach(((f) => {
      u[f] = c[f], tE.includes(f) || (h[f] = c[f]);
    })), { encoded: { header: s, payload: l, signature: d }, header: JSON.parse(vg(s)), claims: u, user: h };
  })(e.id_token);
  if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
  if (t.claims.iss !== e.iss) throw new Error('Issuer (iss) claim mismatch in the ID token; expected "'.concat(e.iss, '", found "').concat(t.claims.iss, '"'));
  if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
  if (t.header.alg !== "RS256") throw new Error('Signature algorithm of "'.concat(t.header.alg, '" is not supported. Expected the ID token to be signed with "RS256".'));
  if (!t.claims.aud || typeof t.claims.aud != "string" && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
  if (Array.isArray(t.claims.aud)) {
    if (!t.claims.aud.includes(e.aud)) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but was not one of "').concat(t.claims.aud.join(", "), '"'));
    if (t.claims.aud.length > 1) {
      if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
      if (t.claims.azp !== e.aud) throw new Error('Authorized Party (azp) claim mismatch in the ID token; expected "'.concat(e.aud, '", found "').concat(t.claims.azp, '"'));
    }
  } else if (t.claims.aud !== e.aud) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but found "').concat(t.claims.aud, '"'));
  if (e.nonce) {
    if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
    if (t.claims.nonce !== e.nonce) throw new Error('Nonce (nonce) claim mismatch in the ID token; expected "'.concat(e.nonce, '", found "').concat(t.claims.nonce, '"'));
  }
  if (e.max_age && !ed(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
  if (t.claims.exp == null || !ed(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
  if (!ed(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
  const r = e.leeway || 60, n = new Date(e.now || Date.now()), i = /* @__PURE__ */ new Date(0);
  if (i.setUTCSeconds(t.claims.exp + r), n > i) throw new Error("Expiration Time (exp) claim error in the ID token; current time (".concat(n, ") is after expiration time (").concat(i, ")"));
  if (t.claims.nbf != null && ed(t.claims.nbf)) {
    const a = /* @__PURE__ */ new Date(0);
    if (a.setUTCSeconds(t.claims.nbf - r), n < a) throw new Error("Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (".concat(n, ") is before ").concat(a));
  }
  if (t.claims.auth_time != null && ed(t.claims.auth_time)) {
    const a = /* @__PURE__ */ new Date(0);
    if (a.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + r), n > a) throw new Error("Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (".concat(n, ") is after last auth at ").concat(a));
  }
  if (e.organization) {
    const a = e.organization.trim();
    if (a.startsWith("org_")) {
      const o = a;
      if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
      if (o !== t.claims.org_id) throw new Error('Organization ID (org_id) claim mismatch in the ID token; expected "'.concat(o, '", found "').concat(t.claims.org_id, '"'));
    } else {
      const o = a.toLowerCase();
      if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
      if (o !== t.claims.org_name) throw new Error('Organization Name (org_name) claim mismatch in the ID token; expected "'.concat(o, '", found "').concat(t.claims.org_name, '"'));
    }
  }
  return t;
};
var tc = Bo && Bo.__assign || function() {
  return tc = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var i in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    return e;
  }, tc.apply(this, arguments);
};
function td(e, t) {
  if (!t) return "";
  var r = "; " + e;
  return t === !0 ? r : r + "=" + t;
}
function nE(e, t, r) {
  return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + (function(n) {
    if (typeof n.expires == "number") {
      var i = /* @__PURE__ */ new Date();
      i.setMilliseconds(i.getMilliseconds() + 864e5 * n.expires), n.expires = i;
    }
    return td("Expires", n.expires ? n.expires.toUTCString() : "") + td("Domain", n.domain) + td("Path", n.path) + td("Secure", n.secure) + td("SameSite", n.sameSite);
  })(r);
}
function iE() {
  return (function(e) {
    for (var t = {}, r = e ? e.split("; ") : [], n = /(%[\dA-F]{2})+/gi, i = 0; i < r.length; i++) {
      var a = r[i].split("="), o = a.slice(1).join("=");
      o.charAt(0) === '"' && (o = o.slice(1, -1));
      try {
        t[a[0].replace(n, decodeURIComponent)] = o.replace(n, decodeURIComponent);
      } catch {
      }
    }
    return t;
  })(document.cookie);
}
var aE = function(e) {
  return iE()[e];
};
function h6(e, t, r) {
  document.cookie = nE(e, t, tc({ path: "/" }, r));
}
var f6 = h6, p6 = function(e, t) {
  h6(e, "", tc(tc({}, t), { expires: -1 }));
};
const ws = { get(e) {
  const t = aE(e);
  if (t !== void 0) return JSON.parse(t);
}, save(e, t, r) {
  let n = {};
  window.location.protocol === "https:" && (n = { secure: !0, sameSite: "none" }), r?.daysUntilExpire && (n.expires = r.daysUntilExpire), r?.cookieDomain && (n.domain = r.cookieDomain), f6(e, JSON.stringify(t), n);
}, remove(e, t) {
  let r = {};
  t?.cookieDomain && (r.domain = t.cookieDomain), p6(e, r);
} }, oE = { get(e) {
  return ws.get(e) || ws.get("".concat("_legacy_").concat(e));
}, save(e, t, r) {
  let n = {};
  window.location.protocol === "https:" && (n = { secure: !0 }), r?.daysUntilExpire && (n.expires = r.daysUntilExpire), r?.cookieDomain && (n.domain = r.cookieDomain), f6("".concat("_legacy_").concat(e), JSON.stringify(t), n), ws.save(e, t, r);
}, remove(e, t) {
  let r = {};
  t?.cookieDomain && (r.domain = t.cookieDomain), p6(e, r), ws.remove(e, t), ws.remove("".concat("_legacy_").concat(e), t);
} }, sE = { get(e) {
  if (typeof sessionStorage > "u") return;
  const t = sessionStorage.getItem(e);
  return t != null ? JSON.parse(t) : void 0;
}, save(e, t) {
  sessionStorage.setItem(e, JSON.stringify(t));
}, remove(e) {
  sessionStorage.removeItem(e);
} };
var Co;
(function(e) {
  e.Code = "code", e.ConnectCode = "connect_code";
})(Co || (Co = {}));
function lE(e, t, r) {
  var n = t === void 0 ? null : t, i = (function(l, d) {
    var c = atob(l);
    if (d) {
      for (var u = new Uint8Array(c.length), h = 0, f = c.length; h < f; ++h) u[h] = c.charCodeAt(h);
      return String.fromCharCode.apply(null, new Uint16Array(u.buffer));
    }
    return c;
  })(e, r !== void 0 && r), a = i.indexOf(`
`, 10) + 1, o = i.substring(a) + (n ? "//# sourceMappingURL=" + n : ""), s = new Blob([o], { type: "application/javascript" });
  return URL.createObjectURL(s);
}
var wg, $g, kg, jh, dE = (wg = "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", $g = null, kg = !1, function(e) {
  return jh = jh || lE(wg, $g, kg), new Worker(jh, e);
});
const zh = {};
let cE = class {
  constructor(t, r) {
    this.cache = t, this.clientId = r, this.manifestKey = this.createManifestKeyFrom(this.clientId);
  }
  async add(t) {
    var r;
    const n = new Set(((r = await this.cache.get(this.manifestKey)) === null || r === void 0 ? void 0 : r.keys) || []);
    n.add(t), await this.cache.set(this.manifestKey, { keys: [...n] });
  }
  async remove(t) {
    const r = await this.cache.get(this.manifestKey);
    if (r) {
      const n = new Set(r.keys);
      return n.delete(t), n.size > 0 ? await this.cache.set(this.manifestKey, { keys: [...n] }) : await this.cache.remove(this.manifestKey);
    }
  }
  get() {
    return this.cache.get(this.manifestKey);
  }
  clear() {
    return this.cache.remove(this.manifestKey);
  }
  createManifestKeyFrom(t) {
    return "".concat("@@auth0spajs@@", "::").concat(t);
  }
};
const uE = { memory: () => new u6().enclosedCache, localstorage: () => new Zx() }, _g = (e) => uE[e], xg = (e) => {
  const { openUrl: t, onRedirect: r } = e, n = Wn(e, ["openUrl", "onRedirect"]);
  return Object.assign(Object.assign({}, n), { openUrl: t === !1 || t ? t : r });
}, Eg = (e, t) => {
  const r = t?.split(" ") || [];
  return (e?.split(" ") || []).every(((n) => r.includes(n)));
}, so = { NONCE: "nonce", KEYPAIR: "keypair" };
class hE {
  constructor(t) {
    this.clientId = t;
  }
  getVersion() {
    return 1;
  }
  createDbHandle() {
    const t = window.indexedDB.open("auth0-spa-js", this.getVersion());
    return new Promise(((r, n) => {
      t.onupgradeneeded = () => Object.values(so).forEach(((i) => t.result.createObjectStore(i))), t.onerror = () => n(t.error), t.onsuccess = () => r(t.result);
    }));
  }
  async getDbHandle() {
    return this.dbHandle || (this.dbHandle = await this.createDbHandle()), this.dbHandle;
  }
  async executeDbRequest(t, r, n) {
    const i = n((await this.getDbHandle()).transaction(t, r).objectStore(t));
    return new Promise(((a, o) => {
      i.onsuccess = () => a(i.result), i.onerror = () => o(i.error);
    }));
  }
  buildKey(t) {
    const r = t ? "_".concat(t) : "auth0";
    return "".concat(this.clientId, "::").concat(r);
  }
  setNonce(t, r) {
    return this.save(so.NONCE, this.buildKey(r), t);
  }
  setKeyPair(t) {
    return this.save(so.KEYPAIR, this.buildKey(), t);
  }
  async save(t, r, n) {
    await this.executeDbRequest(t, "readwrite", ((i) => i.put(n, r)));
  }
  findNonce(t) {
    return this.find(so.NONCE, this.buildKey(t));
  }
  findKeyPair() {
    return this.find(so.KEYPAIR, this.buildKey());
  }
  find(t, r) {
    return this.executeDbRequest(t, "readonly", ((n) => n.get(r)));
  }
  async deleteBy(t, r) {
    const n = await this.executeDbRequest(t, "readonly", ((i) => i.getAllKeys()));
    n?.filter(r).map(((i) => this.executeDbRequest(t, "readwrite", ((a) => a.delete(i)))));
  }
  deleteByClientId(t, r) {
    return this.deleteBy(t, ((n) => typeof n == "string" && n.startsWith("".concat(r, "::"))));
  }
  clearNonces() {
    return this.deleteByClientId(so.NONCE, this.clientId);
  }
  clearKeyPairs() {
    return this.deleteByClientId(so.KEYPAIR, this.clientId);
  }
}
class fE {
  constructor(t) {
    this.storage = new hE(t);
  }
  getNonce(t) {
    return this.storage.findNonce(t);
  }
  setNonce(t, r) {
    return this.storage.setNonce(t, r);
  }
  async getOrGenerateKeyPair() {
    let t = await this.storage.findKeyPair();
    return t || (t = await qx(), await this.storage.setKeyPair(t)), t;
  }
  async generateProof(t) {
    const r = await this.getOrGenerateKeyPair();
    return Hx(Object.assign({ keyPair: r }, t));
  }
  async calculateThumbprint() {
    return Bx(await this.getOrGenerateKeyPair());
  }
  async clear() {
    await Promise.all([this.storage.clearNonces(), this.storage.clearKeyPairs()]);
  }
}
var Is;
(function(e) {
  e.Bearer = "Bearer", e.DPoP = "DPoP";
})(Is || (Is = {}));
class pE {
  constructor(t, r) {
    this.hooks = r, this.config = Object.assign(Object.assign({}, t), { fetch: t.fetch || (typeof window > "u" ? fetch : window.fetch.bind(window)) });
  }
  isAbsoluteUrl(t) {
    return /^(https?:)?\/\//i.test(t);
  }
  buildUrl(t, r) {
    if (r) {
      if (this.isAbsoluteUrl(r)) return r;
      if (t) return "".concat(t.replace(/\/?\/$/, ""), "/").concat(r.replace(/^\/+/, ""));
    }
    throw new TypeError("`url` must be absolute or `baseUrl` non-empty.");
  }
  getAccessToken(t) {
    return this.config.getAccessToken ? this.config.getAccessToken(t) : this.hooks.getAccessToken(t);
  }
  extractUrl(t) {
    return typeof t == "string" ? t : t instanceof URL ? t.href : t.url;
  }
  buildBaseRequest(t, r) {
    if (!this.config.baseUrl) return new Request(t, r);
    const n = this.buildUrl(this.config.baseUrl, this.extractUrl(t)), i = t instanceof Request ? new Request(n, t) : n;
    return new Request(i, r);
  }
  setAuthorizationHeader(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Is.Bearer;
    t.headers.set("authorization", "".concat(n, " ").concat(r));
  }
  async setDpopProofHeader(t, r) {
    if (!this.config.dpopNonceId) return;
    const n = await this.hooks.getDpopNonce(), i = await this.hooks.generateDpopProof({ accessToken: r, method: t.method, nonce: n, url: t.url });
    t.headers.set("dpop", i);
  }
  async prepareRequest(t, r) {
    const n = await this.getAccessToken(r);
    let i, a;
    typeof n == "string" ? (i = this.config.dpopNonceId ? Is.DPoP : Is.Bearer, a = n) : (i = n.token_type, a = n.access_token), this.setAuthorizationHeader(t, a, i), i === Is.DPoP && await this.setDpopProofHeader(t, a);
  }
  getHeader(t, r) {
    return Array.isArray(t) ? new Headers(t).get(r) || "" : typeof t.get == "function" ? t.get(r) || "" : t[r] || "";
  }
  hasUseDpopNonceError(t) {
    if (t.status !== 401) return !1;
    const r = this.getHeader(t.headers, "www-authenticate");
    return r.includes("invalid_dpop_nonce") || r.includes("use_dpop_nonce");
  }
  async handleResponse(t, r) {
    const n = this.getHeader(t.headers, "dpop-nonce");
    if (n && await this.hooks.setDpopNonce(n), !this.hasUseDpopNonceError(t)) return t;
    if (!n || !r.onUseDpopNonceError) throw new n6(n);
    return r.onUseDpopNonceError();
  }
  async internalFetchWithAuth(t, r, n, i) {
    const a = this.buildBaseRequest(t, r);
    await this.prepareRequest(a, i);
    const o = await this.config.fetch(a);
    return this.handleResponse(o, n);
  }
  fetchWithAuth(t, r, n) {
    const i = { onUseDpopNonceError: () => this.internalFetchWithAuth(t, r, Object.assign(Object.assign({}, i), { onUseDpopNonceError: void 0 }), n) };
    return this.internalFetchWithAuth(t, r, i, n);
  }
}
let mE = class {
  constructor(t, r) {
    this.myAccountFetcher = t, this.apiBase = r;
  }
  async connectAccount(t) {
    const r = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/connected-accounts/connect"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(t) });
    return this._handleResponse(r);
  }
  async completeAccount(t) {
    const r = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/connected-accounts/complete"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(t) });
    return this._handleResponse(r);
  }
  async _handleResponse(t) {
    let r;
    try {
      r = await t.text(), r = JSON.parse(r);
    } catch (n) {
      throw new Sg({ type: "invalid_json", status: t.status, title: "Invalid JSON response", detail: r || String(n) });
    }
    if (t.ok) return r;
    throw new Sg(r);
  }
}, Sg = class m6 extends Error {
  constructor(t) {
    let { type: r, status: n, title: i, detail: a, validation_errors: o } = t;
    super(a), this.name = "MyAccountApiError", this.type = r, this.status = n, this.title = i, this.detail = a, this.validation_errors = o, Object.setPrototypeOf(this, m6.prototype);
  }
};
const gE = { otp: { authenticatorTypes: ["otp"] }, sms: { authenticatorTypes: ["oob"], oobChannels: ["sms"] }, email: { authenticatorTypes: ["oob"], oobChannels: ["email"] }, push: { authenticatorTypes: ["oob"], oobChannels: ["auth0"] }, voice: { authenticatorTypes: ["oob"], oobChannels: ["voice"] } }, vE = "http://auth0.com/oauth/grant-type/mfa-otp", yE = "http://auth0.com/oauth/grant-type/mfa-oob", bE = "http://auth0.com/oauth/grant-type/mfa-recovery-code";
function g6(e, t) {
  this.v = e, this.k = t;
}
function hr(e, t, r) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : r;
  throw new TypeError("Private element is not present on this object");
}
function wE(e) {
  return new g6(e, 0);
}
function v6(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function he(e, t) {
  return e.get(hr(e, t));
}
function yr(e, t, r) {
  v6(e, t), t.set(e, r);
}
function Qt(e, t, r) {
  return e.set(hr(e, t), r), r;
}
function me(e, t, r) {
  return (t = (function(n) {
    var i = (function(a, o) {
      if (typeof a != "object" || !a) return a;
      var s = a[Symbol.toPrimitive];
      if (s !== void 0) {
        var l = s.call(a, o);
        if (typeof l != "object") return l;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (o === "string" ? String : Number)(a);
    })(n, "string");
    return typeof i == "symbol" ? i : i + "";
  })(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Cg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter((function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    }))), r.push.apply(r, n);
  }
  return r;
}
function Ne(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Cg(Object(r), !0).forEach((function(n) {
      me(e, n, r[n]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Cg(Object(r)).forEach((function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    }));
  }
  return e;
}
function Tg(e, t) {
  if (e == null) return {};
  var r, n, i = (function(o, s) {
    if (o == null) return {};
    var l = {};
    for (var d in o) if ({}.hasOwnProperty.call(o, d)) {
      if (s.indexOf(d) !== -1) continue;
      l[d] = o[d];
    }
    return l;
  })(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function $E(e) {
  return function() {
    return new Cd(e.apply(this, arguments));
  };
}
function Cd(e) {
  var t, r;
  function n(a, o) {
    try {
      var s = e[a](o), l = s.value, d = l instanceof g6;
      Promise.resolve(d ? l.v : l).then((function(c) {
        if (d) {
          var u = a === "return" ? "return" : "next";
          if (!l.k || c.done) return n(u, c);
          c = e[u](c).value;
        }
        i(s.done ? "return" : "normal", c);
      }), (function(c) {
        n("throw", c);
      }));
    } catch (c) {
      i("throw", c);
    }
  }
  function i(a, o) {
    switch (a) {
      case "return":
        t.resolve({ value: o, done: !0 });
        break;
      case "throw":
        t.reject(o);
        break;
      default:
        t.resolve({ value: o, done: !1 });
    }
    (t = t.next) ? n(t.key, t.arg) : r = null;
  }
  this._invoke = function(a, o) {
    return new Promise((function(s, l) {
      var d = { key: a, arg: o, resolve: s, reject: l, next: null };
      r ? r = r.next = d : (t = r = d, n(a, o));
    }));
  }, typeof e.return != "function" && (this.return = void 0);
}
var vu, Vh;
let T2;
Cd.prototype[typeof Symbol == "function" && Symbol.asyncIterator || "@@asyncIterator"] = function() {
  return this;
}, Cd.prototype.next = function(e) {
  return this._invoke("next", e);
}, Cd.prototype.throw = function(e) {
  return this._invoke("throw", e);
}, Cd.prototype.return = function(e) {
  return this._invoke("return", e);
}, (typeof navigator > "u" || (vu = navigator.userAgent) === null || vu === void 0 || (Vh = vu.startsWith) === null || Vh === void 0 || !Vh.call(vu, "Mozilla/5.0 ")) && (T2 = "".concat("oauth4webapi", "/").concat("v3.8.3"));
function Tl(e, t) {
  if (e == null) return !1;
  try {
    return e instanceof t || Object.getPrototypeOf(e)[Symbol.toStringTag] === t.prototype[Symbol.toStringTag];
  } catch {
    return !1;
  }
}
function _t(e, t, r) {
  const n = new TypeError(e, { cause: r });
  return Object.assign(n, { code: t }), n;
}
const Rn = /* @__PURE__ */ Symbol(), A2 = /* @__PURE__ */ Symbol(), O2 = /* @__PURE__ */ Symbol(), pi = /* @__PURE__ */ Symbol(), ea = /* @__PURE__ */ Symbol(), kE = new TextEncoder(), _E = new TextDecoder();
function Ks(e) {
  return typeof e == "string" ? kE.encode(e) : _E.decode(e);
}
let P2, y6;
Uint8Array.prototype.toBase64 ? P2 = (e) => (e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({ alphabet: "base64url", omitPadding: !0 })) : P2 = (t) => {
  t instanceof ArrayBuffer && (t = new Uint8Array(t));
  const r = [];
  for (let n = 0; n < t.byteLength; n += 32768) r.push(String.fromCharCode.apply(null, t.subarray(n, n + 32768)));
  return btoa(r.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
function jo(e) {
  return typeof e == "string" ? y6(e) : P2(e);
}
y6 = Uint8Array.fromBase64 ? (e) => {
  try {
    return Uint8Array.fromBase64(e, { alphabet: "base64url" });
  } catch (t) {
    throw _t("The input to be decoded is not correctly encoded.", "ERR_INVALID_ARG_VALUE", t);
  }
} : (e) => {
  try {
    const t = atob(e.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "")), r = new Uint8Array(t.length);
    for (let n = 0; n < t.length; n++) r[n] = t.charCodeAt(n);
    return r;
  } catch (t) {
    throw _t("The input to be decoded is not correctly encoded.", "ERR_INVALID_ARG_VALUE", t);
  }
};
let $n = class extends Error {
  constructor(t, r) {
    var n;
    super(t, r), me(this, "code", void 0), this.name = this.constructor.name, this.code = N2, (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
};
class tm extends Error {
  constructor(t, r) {
    var n;
    super(t, r), me(this, "code", void 0), this.name = this.constructor.name, r != null && r.code && (this.code = r?.code), (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
}
function Fe(e, t, r) {
  return new tm(e, { code: t, cause: r });
}
function xE(e, t) {
  if ((function(r, n) {
    if (!(r instanceof CryptoKey)) throw _t("".concat(n, " must be a CryptoKey"), "ERR_INVALID_ARG_TYPE");
  })(e, t), e.type !== "private") throw _t("".concat(t, " must be a private CryptoKey"), "ERR_INVALID_ARG_VALUE");
}
function R0(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function R1(e) {
  Tl(e, Headers) && (e = Object.fromEntries(e.entries()));
  const t = new Headers(e ?? {});
  if (T2 && !t.has("user-agent") && t.set("user-agent", T2), t.has("authorization")) throw _t('"options.headers" must not include the "authorization" header name', "ERR_INVALID_ARG_VALUE");
  return t;
}
function b6(e, t) {
  if (t !== void 0) {
    if (typeof t == "function" && (t = t(e.href)), !(t instanceof AbortSignal)) throw _t('"options.signal" must return or be an instance of AbortSignal', "ERR_INVALID_ARG_TYPE");
    return t;
  }
}
function Ag(e) {
  return e.includes("//") ? e.replace("//", "/") : e;
}
async function EE(e, t) {
  return (async function(r, n, i, a) {
    if (!(r instanceof URL)) throw _t('"'.concat(n, '" must be an instance of URL'), "ERR_INVALID_ARG_TYPE");
    rm(r, a?.[Rn] !== !0);
    const o = i(new URL(r.href)), s = R1(a?.headers);
    return s.set("accept", "application/json"), (a?.[pi] || fetch)(o.href, { body: void 0, headers: Object.fromEntries(s.entries()), method: "GET", redirect: "manual", signal: b6(o, a?.signal) });
  })(e, "issuerIdentifier", ((r) => {
    switch (t?.algorithm) {
      case void 0:
      case "oidc":
        (function(n, i) {
          n.pathname = Ag("".concat(n.pathname, "/").concat(i));
        })(r, ".well-known/openid-configuration");
        break;
      case "oauth2":
        (function(n, i) {
          let a = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
          n.pathname === "/" ? n.pathname = i : n.pathname = Ag("".concat(i, "/").concat(a ? n.pathname : n.pathname.replace(/(\/)$/, "")));
        })(r, ".well-known/oauth-authorization-server");
        break;
      default:
        throw _t('"options.algorithm" must be "oidc" (default), or "oauth2"', "ERR_INVALID_ARG_VALUE");
    }
    return r;
  }), t);
}
function Ma(e, t, r, n, i) {
  try {
    if (typeof e != "number" || !Number.isFinite(e)) throw _t("".concat(r, " must be a number"), "ERR_INVALID_ARG_TYPE", i);
    if (e > 0) return;
    if (t) {
      if (e !== 0) throw _t("".concat(r, " must be a non-negative number"), "ERR_INVALID_ARG_VALUE", i);
      return;
    }
    throw _t("".concat(r, " must be a positive number"), "ERR_INVALID_ARG_VALUE", i);
  } catch (a) {
    throw n ? Fe(a.message, n, i) : a;
  }
}
function mr(e, t, r, n) {
  try {
    if (typeof e != "string") throw _t("".concat(t, " must be a string"), "ERR_INVALID_ARG_TYPE", n);
    if (e.length === 0) throw _t("".concat(t, " must not be empty"), "ERR_INVALID_ARG_VALUE", n);
  } catch (i) {
    throw r ? Fe(i.message, r, n) : i;
  }
}
function w6(e) {
  (function(t, r) {
    if (x6(t) !== r) throw (function(n) {
      let i = '"response" content-type must be ';
      for (var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), s = 1; s < a; s++) o[s - 1] = arguments[s];
      if (o.length > 2) {
        const l = o.pop();
        i += "".concat(o.join(", "), ", or ").concat(l);
      } else o.length === 2 ? i += "".concat(o[0], " or ").concat(o[1]) : i += o[0];
      return Fe(i, S6, n);
    })(t, r);
  })(e, "application/json");
}
function $6() {
  return jo(crypto.getRandomValues(new Uint8Array(32)));
}
function SE(e) {
  switch (e.algorithm.name) {
    case "RSA-PSS":
      return (function(t) {
        switch (t.algorithm.hash.name) {
          case "SHA-256":
            return "PS256";
          case "SHA-384":
            return "PS384";
          case "SHA-512":
            return "PS512";
          default:
            throw new $n("unsupported RsaHashedKeyAlgorithm hash name", { cause: t });
        }
      })(e);
    case "RSASSA-PKCS1-v1_5":
      return (function(t) {
        switch (t.algorithm.hash.name) {
          case "SHA-256":
            return "RS256";
          case "SHA-384":
            return "RS384";
          case "SHA-512":
            return "RS512";
          default:
            throw new $n("unsupported RsaHashedKeyAlgorithm hash name", { cause: t });
        }
      })(e);
    case "ECDSA":
      return (function(t) {
        switch (t.algorithm.namedCurve) {
          case "P-256":
            return "ES256";
          case "P-384":
            return "ES384";
          case "P-521":
            return "ES512";
          default:
            throw new $n("unsupported EcKeyAlgorithm namedCurve", { cause: t });
        }
      })(e);
    case "Ed25519":
    case "ML-DSA-44":
    case "ML-DSA-65":
    case "ML-DSA-87":
      return e.algorithm.name;
    case "EdDSA":
      return "Ed25519";
    default:
      throw new $n("unsupported CryptoKey algorithm name", { cause: e });
  }
}
function L0(e) {
  const t = e?.[A2];
  return typeof t == "number" && Number.isFinite(t) ? t : 0;
}
function I2(e) {
  const t = e?.[O2];
  return typeof t == "number" && Number.isFinite(t) && Math.sign(t) !== -1 ? t : 30;
}
function F0() {
  return Math.floor(Date.now() / 1e3);
}
function oi(e) {
  if (typeof e != "object" || e === null) throw _t('"as" must be an object', "ERR_INVALID_ARG_TYPE");
  mr(e.issuer, '"as.issuer"');
}
function si(e) {
  if (typeof e != "object" || e === null) throw _t('"client" must be an object', "ERR_INVALID_ARG_TYPE");
  mr(e.client_id, '"client.client_id"');
}
function Og(e) {
  return mr(e, '"clientSecret"'), (t, r, n, i) => {
    n.set("client_id", r.client_id), n.set("client_secret", e);
  };
}
function CE(e, t) {
  const { key: r, kid: n } = (i = e) instanceof CryptoKey ? { key: i } : i?.key instanceof CryptoKey ? (i.kid !== void 0 && mr(i.kid, '"kid"'), { key: i.key, kid: i.kid }) : {};
  var i;
  return xE(r, '"clientPrivateKey.key"'), async (a, o, s, l) => {
    const d = { alg: SE(r), kid: n }, c = (function(u, h) {
      const f = F0() + L0(h);
      return { jti: $6(), aud: u.issuer, exp: f + 60, iat: f, nbf: f, iss: h.client_id, sub: h.client_id };
    })(a, o);
    s.set("client_id", o.client_id), s.set("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"), s.set("client_assertion", await (async function(u, h, f) {
      if (!f.usages.includes("sign")) throw _t('CryptoKey instances used for signing assertions must include "sign" in their "usages"', "ERR_INVALID_ARG_VALUE");
      const p = "".concat(jo(Ks(JSON.stringify(u))), ".").concat(jo(Ks(JSON.stringify(h)))), m = jo(await crypto.subtle.sign((function(y) {
        switch (y.algorithm.name) {
          case "ECDSA":
            return { name: y.algorithm.name, hash: HE(y) };
          case "RSA-PSS":
            switch (Dg(y), y.algorithm.hash.name) {
              case "SHA-256":
              case "SHA-384":
              case "SHA-512":
                return { name: y.algorithm.name, saltLength: parseInt(y.algorithm.hash.name.slice(-3), 10) >> 3 };
              default:
                throw new $n("unsupported RSA-PSS hash name", { cause: y });
            }
          case "RSASSA-PKCS1-v1_5":
            return Dg(y), y.algorithm.name;
          case "ML-DSA-44":
          case "ML-DSA-65":
          case "ML-DSA-87":
          case "Ed25519":
            return y.algorithm.name;
        }
        throw new $n("unsupported CryptoKey algorithm name", { cause: y });
      })(f), f, Ks(p)));
      return "".concat(p, ".").concat(m);
    })(d, c, r));
  };
}
const TE = URL.parse ? (e, t) => URL.parse(e, t) : (e, t) => {
  try {
    return new URL(e, t);
  } catch {
    return null;
  }
};
function rm(e, t) {
  if (t && e.protocol !== "https:") throw Fe("only requests to HTTPS are allowed", C6, e);
  if (e.protocol !== "https:" && e.protocol !== "http:") throw Fe("only HTTP and HTTPS requests are allowed", T6, e);
}
function Pg(e, t, r, n) {
  let i;
  if (typeof e != "string" || !(i = TE(e))) throw Fe("authorization server metadata does not contain a valid ".concat(r ? '"as.mtls_endpoint_aliases.'.concat(t, '"') : '"as.'.concat(t, '"')), e === void 0 ? qE : BE, { attribute: r ? "mtls_endpoint_aliases.".concat(t) : t });
  return rm(i, n), i;
}
function Rc(e, t, r, n) {
  return r && e.mtls_endpoint_aliases && t in e.mtls_endpoint_aliases ? Pg(e.mtls_endpoint_aliases[t], t, r, n) : Pg(e[t], t, r, n);
}
let L1 = class extends Error {
  constructor(t, r) {
    var n;
    super(t, r), me(this, "cause", void 0), me(this, "code", void 0), me(this, "error", void 0), me(this, "status", void 0), me(this, "error_description", void 0), me(this, "response", void 0), this.name = this.constructor.name, this.code = VE, this.cause = r.cause, this.error = r.cause.error, this.status = r.response.status, this.error_description = r.cause.error_description, Object.defineProperty(this, "response", { enumerable: !1, value: r.response }), (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
}, k6 = class extends Error {
  constructor(t, r) {
    var n, i;
    super(t, r), me(this, "cause", void 0), me(this, "code", void 0), me(this, "error", void 0), me(this, "error_description", void 0), this.name = this.constructor.name, this.code = UE, this.cause = r.cause, this.error = r.cause.get("error"), this.error_description = (n = r.cause.get("error_description")) !== null && n !== void 0 ? n : void 0, (i = Error.captureStackTrace) === null || i === void 0 || i.call(Error, this, this.constructor);
  }
}, nm = class extends Error {
  constructor(t, r) {
    var n;
    super(t, r), me(this, "cause", void 0), me(this, "code", void 0), me(this, "response", void 0), me(this, "status", void 0), this.name = this.constructor.name, this.code = zE, this.cause = r.cause, this.status = r.response.status, this.response = r.response, Object.defineProperty(this, "response", { enumerable: !1 }), (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
};
const AE = "[a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+", OE = new RegExp("^[,\\s]*(" + AE + ")"), PE = new RegExp('^[,\\s]*([a-zA-Z0-9!#$%&\\\'\\*\\+\\-\\.\\^_`\\|~]+)\\s*=\\s*"((?:[^"\\\\]|\\\\[\\s\\S])*)"[,\\s]*(.*)'), IE = new RegExp("^[,\\s]*([a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+)\\s*=\\s*([a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+)[,\\s]*(.*)"), DE = new RegExp("^([a-zA-Z0-9\\-\\._\\~\\+\\/]+={0,2})(?:$|[,\\s])(.*)");
async function im(e, t, r) {
  if (e.status !== t) {
    let i;
    var n;
    throw (function(a) {
      let o;
      if (o = (function(s) {
        if (!Tl(s, Response)) throw _t('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
        const l = s.headers.get("www-authenticate");
        if (l === null) return;
        const d = [];
        let c = l;
        for (; c; ) {
          var u;
          let h = c.match(OE);
          const f = (u = h) === null || u === void 0 ? void 0 : u[1].toLowerCase();
          if (!f) return;
          const p = c.substring(h[0].length);
          if (p && !p.match(/^[\s,]/)) return;
          const m = p.match(/^\s+(.*)$/), y = !!m;
          c = m ? m[1] : void 0;
          const g = {};
          let w;
          if (y) for (; c; ) {
            let _, x;
            if (h = c.match(PE)) {
              if ([, _, x, c] = h, x.includes("\\")) try {
                x = JSON.parse('"'.concat(x, '"'));
              } catch {
              }
              g[_.toLowerCase()] = x;
            } else {
              if (!(h = c.match(IE))) {
                if (h = c.match(DE)) {
                  if (Object.keys(g).length) break;
                  [, w, c] = h;
                  break;
                }
                return;
              }
              [, _, x, c] = h, g[_.toLowerCase()] = x;
            }
          }
          else c = p || void 0;
          const $ = { scheme: f, parameters: g };
          w && ($.token68 = w), d.push($);
        }
        return d.length ? d : void 0;
      })(a)) throw new nm("server responded with a challenge in the WWW-Authenticate HTTP Header", { cause: o, response: a });
    })(e), (i = await (async function(a) {
      if (a.status > 399 && a.status < 500) {
        Fc(a), w6(a);
        try {
          const o = await a.clone().json();
          if (R0(o) && typeof o.error == "string" && o.error.length) return o;
        } catch {
        }
      }
    })(e)) ? (await ((n = e.body) === null || n === void 0 ? void 0 : n.cancel()), new L1("server responded with an error in the response body", { cause: i, response: e })) : Fe('"response" is not a conform '.concat(r, " response (unexpected HTTP status code)"), sm, e);
  }
}
function _6(e) {
  if (!om.has(e)) throw _t('"options.DPoP" is not a valid DPoPHandle', "ERR_INVALID_ARG_VALUE");
}
function x6(e) {
  var t;
  return (t = e.headers.get("content-type")) === null || t === void 0 ? void 0 : t.split(";")[0];
}
async function am(e, t, r, n, i, a, o) {
  return await r(e, t, i, a), a.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), (o?.[pi] || fetch)(n.href, { body: i, headers: Object.fromEntries(a.entries()), method: "POST", redirect: "manual", signal: b6(n, o?.signal) });
}
async function Lc(e, t, r, n, i, a) {
  var o;
  const s = Rc(e, "token_endpoint", t.use_mtls_endpoint_aliases, a?.[Rn] !== !0);
  i.set("grant_type", n);
  const l = R1(a?.headers);
  l.set("accept", "application/json"), a?.DPoP !== void 0 && (_6(a.DPoP), await a.DPoP.addProof(s, l, "POST"));
  const d = await am(e, t, r, s, i, l, a);
  return a == null || (o = a.DPoP) === null || o === void 0 || o.cacheNonce(d, s), d;
}
const E6 = /* @__PURE__ */ new WeakMap(), NE = /* @__PURE__ */ new WeakMap();
function D2(e) {
  if (!e.id_token) return;
  const t = E6.get(e);
  if (!t) throw _t('"ref" was already garbage collected or did not resolve from the proper sources', "ERR_INVALID_ARG_VALUE");
  return t;
}
async function ll(e, t, r, n, i, a) {
  if (oi(e), si(t), !Tl(r, Response)) throw _t('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
  await im(r, 200, "Token Endpoint"), Fc(r);
  const o = await F1(r);
  if (mr(o.access_token, '"response" body "access_token" property', at, { body: o }), mr(o.token_type, '"response" body "token_type" property', at, { body: o }), o.token_type = o.token_type.toLowerCase(), o.expires_in !== void 0) {
    let s = typeof o.expires_in != "number" ? parseFloat(o.expires_in) : o.expires_in;
    Ma(s, !0, '"response" body "expires_in" property', at, { body: o }), o.expires_in = s;
  }
  if (o.refresh_token !== void 0 && mr(o.refresh_token, '"response" body "refresh_token" property', at, { body: o }), o.scope !== void 0 && typeof o.scope != "string") throw Fe('"response" body "scope" property must be a string', at, { body: o });
  if (o.id_token !== void 0) {
    mr(o.id_token, '"response" body "id_token" property', at, { body: o });
    const s = ["aud", "exp", "iat", "iss", "sub"];
    t.require_auth_time === !0 && s.push("auth_time"), t.default_max_age !== void 0 && (Ma(t.default_max_age, !0, '"client.default_max_age"'), s.push("auth_time")), n != null && n.length && s.push(...n);
    const { claims: l, jwt: d } = await (async function(c, u, h, f, p) {
      let m, y, { 0: g, 1: w, length: $ } = c.split(".");
      if ($ === 5) {
        if (p === void 0) throw new $n("JWE decryption is not configured", { cause: c });
        c = await p(c), { 0: g, 1: w, length: $ } = c.split(".");
      }
      if ($ !== 3) throw Fe("Invalid JWT", at, c);
      try {
        m = JSON.parse(Ks(jo(g)));
      } catch (x) {
        throw Fe("failed to parse JWT Header body as base64url encoded JSON", j0, x);
      }
      if (!R0(m)) throw Fe("JWT Header must be a top level object", at, c);
      if (u(m), m.crit !== void 0) throw new $n('no JWT "crit" header parameter extensions are supported', { cause: { header: m } });
      try {
        y = JSON.parse(Ks(jo(w)));
      } catch (x) {
        throw Fe("failed to parse JWT Payload body as base64url encoded JSON", j0, x);
      }
      if (!R0(y)) throw Fe("JWT Payload must be a top level object", at, c);
      const _ = F0() + h;
      if (y.exp !== void 0) {
        if (typeof y.exp != "number") throw Fe('unexpected JWT "exp" (expiration time) claim type', at, { claims: y });
        if (y.exp <= _ - f) throw Fe('unexpected JWT "exp" (expiration time) claim value, expiration is past current timestamp', rc, { claims: y, now: _, tolerance: f, claim: "exp" });
      }
      if (y.iat !== void 0 && typeof y.iat != "number") throw Fe('unexpected JWT "iat" (issued at) claim type', at, { claims: y });
      if (y.iss !== void 0 && typeof y.iss != "string") throw Fe('unexpected JWT "iss" (issuer) claim type', at, { claims: y });
      if (y.nbf !== void 0) {
        if (typeof y.nbf != "number") throw Fe('unexpected JWT "nbf" (not before) claim type', at, { claims: y });
        if (y.nbf > _ + f) throw Fe('unexpected JWT "nbf" (not before) claim value', rc, { claims: y, now: _, tolerance: f, claim: "nbf" });
      }
      if (y.aud !== void 0 && typeof y.aud != "string" && !Array.isArray(y.aud)) throw Fe('unexpected JWT "aud" (audience) claim type', at, { claims: y });
      return { header: m, claims: y, jwt: c };
    })(o.id_token, KE.bind(void 0, t.id_token_signed_response_alg, e.id_token_signing_alg_values_supported, "RS256"), L0(t), I2(t), i).then(FE.bind(void 0, s)).then(RE.bind(void 0, e)).then(ME.bind(void 0, t.client_id));
    if (Array.isArray(l.aud) && l.aud.length !== 1) {
      if (l.azp === void 0) throw Fe('ID Token "aud" (audience) claim includes additional untrusted audiences', Xi, { claims: l, claim: "aud" });
      if (l.azp !== t.client_id) throw Fe('unexpected ID Token "azp" (authorized party) claim value', Xi, { expected: t.client_id, claims: l, claim: "azp" });
    }
    l.auth_time !== void 0 && Ma(l.auth_time, !0, 'ID Token "auth_time" (authentication time)', at, { claims: l }), NE.set(r, d), E6.set(o, l);
  }
  if (a?.[o.token_type] !== void 0) a[o.token_type](r, o);
  else if (o.token_type !== "dpop" && o.token_type !== "bearer") throw new $n("unsupported `token_type` value", { cause: { body: o } });
  return o;
}
function ME(e, t) {
  if (Array.isArray(t.claims.aud)) {
    if (!t.claims.aud.includes(e)) throw Fe('unexpected JWT "aud" (audience) claim value', Xi, { expected: e, claims: t.claims, claim: "aud" });
  } else if (t.claims.aud !== e) throw Fe('unexpected JWT "aud" (audience) claim value', Xi, { expected: e, claims: t.claims, claim: "aud" });
  return t;
}
function RE(e, t) {
  var r, n;
  const i = (r = (n = e[A6]) === null || n === void 0 ? void 0 : n.call(e, t)) !== null && r !== void 0 ? r : e.issuer;
  if (t.claims.iss !== i) throw Fe('unexpected JWT "iss" (issuer) claim value', Xi, { expected: i, claims: t.claims, claim: "iss" });
  return t;
}
const om = /* @__PURE__ */ new WeakSet(), Ig = /* @__PURE__ */ Symbol(), LE = { aud: "audience", c_hash: "code hash", client_id: "client id", exp: "expiration time", iat: "issued at", iss: "issuer", jti: "jwt id", nonce: "nonce", s_hash: "state hash", sub: "subject", ath: "access token hash", htm: "http method", htu: "http uri", cnf: "confirmation", auth_time: "authentication time" };
function FE(e, t) {
  for (const r of e) if (t.claims[r] === void 0) throw Fe('JWT "'.concat(r, '" (').concat(LE[r], ") claim missing"), at, { claims: t.claims });
  return t;
}
const Uh = /* @__PURE__ */ Symbol(), qh = /* @__PURE__ */ Symbol();
async function jE(e, t, r, n) {
  return typeof n?.expectedNonce == "string" || typeof n?.maxAge == "number" || n != null && n.requireIdToken ? (async function(i, a, o, s, l, d, c) {
    const u = [];
    switch (s) {
      case void 0:
        s = Uh;
        break;
      case Uh:
        break;
      default:
        mr(s, '"expectedNonce" argument'), u.push("nonce");
    }
    switch (l != null || (l = a.default_max_age), l) {
      case void 0:
        l = qh;
        break;
      case qh:
        break;
      default:
        Ma(l, !0, '"maxAge" argument'), u.push("auth_time");
    }
    const h = await ll(i, a, o, u, d, c);
    mr(h.id_token, '"response" body "id_token" property', at, { body: h });
    const f = D2(h);
    if (l !== qh) {
      const p = F0() + L0(a), m = I2(a);
      if (f.auth_time + l < p - m) throw Fe("too much time has elapsed since the last End-User authentication", rc, { claims: f, now: p, tolerance: m, claim: "auth_time" });
    }
    if (s === Uh) {
      if (f.nonce !== void 0) throw Fe('unexpected ID Token "nonce" claim value', Xi, { expected: void 0, claims: f, claim: "nonce" });
    } else if (f.nonce !== s) throw Fe('unexpected ID Token "nonce" claim value', Xi, { expected: s, claims: f, claim: "nonce" });
    return h;
  })(e, t, r, n.expectedNonce, n.maxAge, n[ea], n.recognizedTokenTypes) : (async function(i, a, o, s, l) {
    const d = await ll(i, a, o, void 0, s, l), c = D2(d);
    if (c) {
      if (a.default_max_age !== void 0) {
        Ma(a.default_max_age, !0, '"client.default_max_age"');
        const u = F0() + L0(a), h = I2(a);
        if (c.auth_time + a.default_max_age < u - h) throw Fe("too much time has elapsed since the last End-User authentication", rc, { claims: c, now: u, tolerance: h, claim: "auth_time" });
      }
      if (c.nonce !== void 0) throw Fe('unexpected ID Token "nonce" claim value', Xi, { expected: void 0, claims: c, claim: "nonce" });
    }
    return d;
  })(e, t, r, n?.[ea], n?.recognizedTokenTypes);
}
const zE = "OAUTH_WWW_AUTHENTICATE_CHALLENGE", VE = "OAUTH_RESPONSE_BODY_ERROR", N2 = "OAUTH_UNSUPPORTED_OPERATION", UE = "OAUTH_AUTHORIZATION_RESPONSE_ERROR", j0 = "OAUTH_PARSE_ERROR", at = "OAUTH_INVALID_RESPONSE", S6 = "OAUTH_RESPONSE_IS_NOT_JSON", sm = "OAUTH_RESPONSE_IS_NOT_CONFORM", C6 = "OAUTH_HTTP_REQUEST_FORBIDDEN", T6 = "OAUTH_REQUEST_PROTOCOL_FORBIDDEN", rc = "OAUTH_JWT_TIMESTAMP_CHECK_FAILED", Xi = "OAUTH_JWT_CLAIM_COMPARISON_FAILED", M2 = "OAUTH_JSON_ATTRIBUTE_COMPARISON_FAILED", qE = "OAUTH_MISSING_SERVER_METADATA", BE = "OAUTH_INVALID_SERVER_METADATA";
function Fc(e) {
  if (e.bodyUsed) throw _t('"response" body has been used already', "ERR_INVALID_ARG_VALUE");
}
function Dg(e) {
  const { algorithm: t } = e;
  if (typeof t.modulusLength != "number" || t.modulusLength < 2048) throw new $n("unsupported ".concat(t.name, " modulusLength"), { cause: e });
}
function HE(e) {
  const { algorithm: t } = e;
  switch (t.namedCurve) {
    case "P-256":
      return "SHA-256";
    case "P-384":
      return "SHA-384";
    case "P-521":
      return "SHA-512";
    default:
      throw new $n("unsupported ECDSA namedCurve", { cause: e });
  }
}
async function WE(e) {
  if (e.method !== "POST") throw _t("form_post responses are expected to use the POST method", "ERR_INVALID_ARG_VALUE", { cause: e });
  if (x6(e) !== "application/x-www-form-urlencoded") throw _t("form_post responses are expected to use the application/x-www-form-urlencoded content-type", "ERR_INVALID_ARG_VALUE", { cause: e });
  return (async function(t) {
    if (t.bodyUsed) throw _t("form_post Request instances must contain a readable body", "ERR_INVALID_ARG_VALUE", { cause: t });
    return t.text();
  })(e);
}
function KE(e, t, r, n) {
  if (e === void 0) if (Array.isArray(t)) {
    if (!t.includes(n.alg)) throw Fe('unexpected JWT "alg" header parameter', at, { header: n, expected: t, reason: "authorization server metadata" });
  } else {
    if (r === void 0) throw Fe('missing client or server configuration to verify used JWT "alg" header parameter', void 0, { client: e, issuer: t, fallback: r });
    if (typeof r == "string" ? n.alg !== r : typeof r == "function" ? !r(n.alg) : !r.includes(n.alg)) throw Fe('unexpected JWT "alg" header parameter', at, { header: n, expected: r, reason: "default value" });
  }
  else if (typeof e == "string" ? n.alg !== e : !e.includes(n.alg)) throw Fe('unexpected JWT "alg" header parameter', at, { header: n, expected: e, reason: "client configuration" });
}
function bo(e, t) {
  const { 0: r, length: n } = e.getAll(t);
  if (n > 1) throw Fe('"'.concat(t, '" parameter must be provided only once'), at);
  return r;
}
const QE = /* @__PURE__ */ Symbol(), GE = /* @__PURE__ */ Symbol();
function YE(e, t, r, n) {
  if (oi(e), si(t), r instanceof URL && (r = r.searchParams), !(r instanceof URLSearchParams)) throw _t('"parameters" must be an instance of URLSearchParams, or URL', "ERR_INVALID_ARG_TYPE");
  if (bo(r, "response")) throw Fe('"parameters" contains a JARM response, use validateJwtAuthResponse() instead of validateAuthResponse()', at, { parameters: r });
  const i = bo(r, "iss"), a = bo(r, "state");
  if (!i && e.authorization_response_iss_parameter_supported) throw Fe('response parameter "iss" (issuer) missing', at, { parameters: r });
  if (i && i !== e.issuer) throw Fe('unexpected "iss" (issuer) response parameter value', at, { expected: e.issuer, parameters: r });
  switch (n) {
    case void 0:
    case GE:
      if (a !== void 0) throw Fe('unexpected "state" response parameter encountered', at, { expected: void 0, parameters: r });
      break;
    case QE:
      break;
    default:
      if (mr(n, '"expectedState" argument'), a !== n) throw Fe(a === void 0 ? 'response parameter "state" missing' : 'unexpected "state" response parameter value', at, { expected: n, parameters: r });
  }
  if (bo(r, "error")) throw new k6("authorization response from the server is an error", { cause: r });
  const o = bo(r, "id_token"), s = bo(r, "token");
  if (o !== void 0 || s !== void 0) throw new $n("implicit and hybrid flows are not supported");
  return l = new URLSearchParams(r), om.add(l), l;
  var l;
}
async function F1(e) {
  let t, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : w6;
  try {
    t = await e.json();
  } catch (n) {
    throw r(e), Fe('failed to parse "response" body as JSON', j0, n);
  }
  if (!R0(t)) throw Fe('"response" body must be a top level object', at, { body: t });
  return t;
}
const Bh = /* @__PURE__ */ Symbol(), A6 = /* @__PURE__ */ Symbol(), Ng = new TextEncoder(), nc = new TextDecoder();
function Hh(e) {
  const t = new Uint8Array(e.length);
  for (let r = 0; r < e.length; r++) {
    const n = e.charCodeAt(r);
    if (n > 127) throw new TypeError("non-ASCII string encountered in encode()");
    t[r] = n;
  }
  return t;
}
function O6(e) {
  if (Uint8Array.fromBase64) return Uint8Array.fromBase64(e);
  const t = atob(e), r = new Uint8Array(t.length);
  for (let n = 0; n < t.length; n++) r[n] = t.charCodeAt(n);
  return r;
}
function jd(e) {
  if (Uint8Array.fromBase64) return Uint8Array.fromBase64(typeof e == "string" ? e : nc.decode(e), { alphabet: "base64url" });
  let t = e;
  t instanceof Uint8Array && (t = nc.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return O6(t);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
}
let Mr = class extends Error {
  constructor(t, r) {
    var n;
    super(t, r), me(this, "code", "ERR_JOSE_GENERIC"), this.name = this.constructor.name, (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
};
me(Mr, "code", "ERR_JOSE_GENERIC");
let Bn = class extends Mr {
  constructor(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "unspecified", i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unspecified";
    super(t, { cause: { claim: n, reason: i, payload: r } }), me(this, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED"), me(this, "claim", void 0), me(this, "reason", void 0), me(this, "payload", void 0), this.claim = n, this.reason = i, this.payload = r;
  }
};
me(Bn, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED");
let R2 = class extends Mr {
  constructor(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "unspecified", i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unspecified";
    super(t, { cause: { claim: n, reason: i, payload: r } }), me(this, "code", "ERR_JWT_EXPIRED"), me(this, "claim", void 0), me(this, "reason", void 0), me(this, "payload", void 0), this.claim = n, this.reason = i, this.payload = r;
  }
};
me(R2, "code", "ERR_JWT_EXPIRED");
let P6 = class extends Mr {
  constructor() {
    super(...arguments), me(this, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
  }
};
me(P6, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
let wn = class extends Mr {
  constructor() {
    super(...arguments), me(this, "code", "ERR_JOSE_NOT_SUPPORTED");
  }
};
me(wn, "code", "ERR_JOSE_NOT_SUPPORTED");
me(class extends Mr {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "decryption operation failed", arguments.length > 1 ? arguments[1] : void 0), me(this, "code", "ERR_JWE_DECRYPTION_FAILED");
  }
}, "code", "ERR_JWE_DECRYPTION_FAILED");
me(class extends Mr {
  constructor() {
    super(...arguments), me(this, "code", "ERR_JWE_INVALID");
  }
}, "code", "ERR_JWE_INVALID");
let Sr = class extends Mr {
  constructor() {
    super(...arguments), me(this, "code", "ERR_JWS_INVALID");
  }
};
me(Sr, "code", "ERR_JWS_INVALID");
let L2 = class extends Mr {
  constructor() {
    super(...arguments), me(this, "code", "ERR_JWT_INVALID");
  }
};
me(L2, "code", "ERR_JWT_INVALID");
me(class extends Mr {
  constructor() {
    super(...arguments), me(this, "code", "ERR_JWK_INVALID");
  }
}, "code", "ERR_JWK_INVALID");
let lm = class extends Mr {
  constructor() {
    super(...arguments), me(this, "code", "ERR_JWKS_INVALID");
  }
};
me(lm, "code", "ERR_JWKS_INVALID");
let dm = class extends Mr {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "no applicable key found in the JSON Web Key Set", arguments.length > 1 ? arguments[1] : void 0), me(this, "code", "ERR_JWKS_NO_MATCHING_KEY");
  }
};
me(dm, "code", "ERR_JWKS_NO_MATCHING_KEY");
let I6 = class extends Mr {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "multiple matching keys found in the JSON Web Key Set", arguments.length > 1 ? arguments[1] : void 0), me(this, Symbol.asyncIterator, void 0), me(this, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
  }
};
me(I6, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
let D6 = class extends Mr {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "request timed out", arguments.length > 1 ? arguments[1] : void 0), me(this, "code", "ERR_JWKS_TIMEOUT");
  }
};
me(D6, "code", "ERR_JWKS_TIMEOUT");
let N6 = class extends Mr {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "signature verification failed", arguments.length > 1 ? arguments[1] : void 0), me(this, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
  }
};
me(N6, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
const wi = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "algorithm.name";
  return new TypeError("CryptoKey does not support this operation, its ".concat(t, " must be ").concat(e));
}, hs = (e, t) => e.name === t;
function Wh(e) {
  return parseInt(e.name.slice(4), 10);
}
function JE(e, t, r) {
  switch (t) {
    case "HS256":
    case "HS384":
    case "HS512": {
      if (!hs(e.algorithm, "HMAC")) throw wi("HMAC");
      const n = parseInt(t.slice(2), 10);
      if (Wh(e.algorithm.hash) !== n) throw wi("SHA-".concat(n), "algorithm.hash");
      break;
    }
    case "RS256":
    case "RS384":
    case "RS512": {
      if (!hs(e.algorithm, "RSASSA-PKCS1-v1_5")) throw wi("RSASSA-PKCS1-v1_5");
      const n = parseInt(t.slice(2), 10);
      if (Wh(e.algorithm.hash) !== n) throw wi("SHA-".concat(n), "algorithm.hash");
      break;
    }
    case "PS256":
    case "PS384":
    case "PS512": {
      if (!hs(e.algorithm, "RSA-PSS")) throw wi("RSA-PSS");
      const n = parseInt(t.slice(2), 10);
      if (Wh(e.algorithm.hash) !== n) throw wi("SHA-".concat(n), "algorithm.hash");
      break;
    }
    case "Ed25519":
    case "EdDSA":
      if (!hs(e.algorithm, "Ed25519")) throw wi("Ed25519");
      break;
    case "ML-DSA-44":
    case "ML-DSA-65":
    case "ML-DSA-87":
      if (!hs(e.algorithm, t)) throw wi(t);
      break;
    case "ES256":
    case "ES384":
    case "ES512": {
      if (!hs(e.algorithm, "ECDSA")) throw wi("ECDSA");
      const n = (function(i) {
        switch (i) {
          case "ES256":
            return "P-256";
          case "ES384":
            return "P-384";
          case "ES512":
            return "P-521";
          default:
            throw new Error("unreachable");
        }
      })(t);
      if (e.algorithm.namedCurve !== n) throw wi(n, "algorithm.namedCurve");
      break;
    }
    default:
      throw new TypeError("CryptoKey does not support this operation");
  }
  (function(n, i) {
    if (!n.usages.includes(i)) throw new TypeError("CryptoKey does not support this operation, its usages must include ".concat(i, "."));
  })(e, r);
}
function M6(e, t) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) n[i - 2] = arguments[i];
  if ((n = n.filter(Boolean)).length > 2) {
    const o = n.pop();
    e += "one of type ".concat(n.join(", "), ", or ").concat(o, ".");
  } else n.length === 2 ? e += "one of type ".concat(n[0], " or ").concat(n[1], ".") : e += "of type ".concat(n[0], ".");
  if (t == null) e += " Received ".concat(t);
  else if (typeof t == "function" && t.name) e += " Received function ".concat(t.name);
  else if (typeof t == "object" && t != null) {
    var a;
    (a = t.constructor) !== null && a !== void 0 && a.name && (e += " Received an instance of ".concat(t.constructor.name));
  }
  return e;
}
const Mg = function(e, t) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) n[i - 2] = arguments[i];
  return M6("Key for the ".concat(e, " algorithm must be "), t, ...n);
}, R6 = (e) => {
  if (e?.[Symbol.toStringTag] === "CryptoKey") return !0;
  try {
    return e instanceof CryptoKey;
  } catch {
    return !1;
  }
}, L6 = (e) => e?.[Symbol.toStringTag] === "KeyObject", Rg = (e) => R6(e) || L6(e);
function za(e) {
  if (typeof (t = e) != "object" || t === null || Object.prototype.toString.call(e) !== "[object Object]") return !1;
  var t;
  if (Object.getPrototypeOf(e) === null) return !0;
  let r = e;
  for (; Object.getPrototypeOf(r) !== null; ) r = Object.getPrototypeOf(r);
  return Object.getPrototypeOf(e) === r;
}
const Kh = (e, t) => {
  if (e.byteLength !== t.length) return !1;
  for (let r = 0; r < e.byteLength; r++) if (e[r] !== t[r]) return !1;
  return !0;
}, zd = (e) => {
  const t = e.data[e.pos++];
  if (128 & t) {
    const r = 127 & t;
    let n = 0;
    for (let i = 0; i < r; i++) n = n << 8 | e.data[e.pos++];
    return n;
  }
  return t;
}, Vd = (e, t, r) => {
  if (e.data[e.pos++] !== t) throw new Error(r);
}, Lg = (e, t) => {
  const r = e.data.subarray(e.pos, e.pos + t);
  return e.pos += t, r;
}, ZE = (e) => {
  const t = ((i) => {
    Vd(i, 6, "Expected algorithm OID");
    const a = zd(i);
    return Lg(i, a);
  })(e);
  if (Kh(t, [43, 101, 110])) return "X25519";
  if (!Kh(t, [42, 134, 72, 206, 61, 2, 1])) throw new Error("Unsupported key algorithm");
  Vd(e, 6, "Expected curve OID");
  const r = zd(e), n = Lg(e, r);
  for (const { name: i, oid: a } of [{ name: "P-256", oid: [42, 134, 72, 206, 61, 3, 1, 7] }, { name: "P-384", oid: [43, 129, 4, 0, 34] }, { name: "P-521", oid: [43, 129, 4, 0, 35] }]) if (Kh(n, a)) return i;
  throw new Error("Unsupported named curve");
}, XE = async (e, t, r, n) => {
  var i;
  let a, o;
  const s = () => ["sign"];
  switch (r) {
    case "PS256":
    case "PS384":
    case "PS512":
      a = { name: "RSA-PSS", hash: "SHA-".concat(r.slice(-3)) }, o = s();
      break;
    case "RS256":
    case "RS384":
    case "RS512":
      a = { name: "RSASSA-PKCS1-v1_5", hash: "SHA-".concat(r.slice(-3)) }, o = s();
      break;
    case "RSA-OAEP":
    case "RSA-OAEP-256":
    case "RSA-OAEP-384":
    case "RSA-OAEP-512":
      a = { name: "RSA-OAEP", hash: "SHA-".concat(parseInt(r.slice(-3), 10) || 1) }, o = ["decrypt", "unwrapKey"];
      break;
    case "ES256":
    case "ES384":
    case "ES512":
      a = { name: "ECDSA", namedCurve: { ES256: "P-256", ES384: "P-384", ES512: "P-521" }[r] }, o = s();
      break;
    case "ECDH-ES":
    case "ECDH-ES+A128KW":
    case "ECDH-ES+A192KW":
    case "ECDH-ES+A256KW":
      try {
        const l = n.getNamedCurve(t);
        a = l === "X25519" ? { name: "X25519" } : { name: "ECDH", namedCurve: l };
      } catch {
        throw new wn("Invalid or unsupported key format");
      }
      o = ["deriveBits"];
      break;
    case "Ed25519":
    case "EdDSA":
      a = { name: "Ed25519" }, o = s();
      break;
    case "ML-DSA-44":
    case "ML-DSA-65":
    case "ML-DSA-87":
      a = { name: r }, o = s();
      break;
    default:
      throw new wn('Invalid or unsupported "alg" (Algorithm) value');
  }
  return crypto.subtle.importKey(e, t, a, (i = n?.extractable) !== null && i !== void 0 ? i : !1, o);
}, eS = (e, t, r) => {
  var n;
  const i = ((o, s) => O6(o.replace(s, "")))(e, /(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g);
  let a = r;
  return t != null && (n = t.startsWith) !== null && n !== void 0 && n.call(t, "ECDH-ES") && (a || (a = {}), a.getNamedCurve = (o) => {
    const s = { data: o, pos: 0 };
    return (function(l) {
      Vd(l, 48, "Invalid PKCS#8 structure"), zd(l), Vd(l, 2, "Expected version field");
      const d = zd(l);
      l.pos += d, Vd(l, 48, "Expected algorithm identifier"), zd(l);
    })(s), ZE(s);
  }), XE("pkcs8", i, t, a);
};
async function n0(e) {
  var t, r;
  if (!e.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
  const { algorithm: n, keyUsages: i } = (function(o) {
    let s, l;
    switch (o.kty) {
      case "AKP":
        switch (o.alg) {
          case "ML-DSA-44":
          case "ML-DSA-65":
          case "ML-DSA-87":
            s = { name: o.alg }, l = o.priv ? ["sign"] : ["verify"];
            break;
          default:
            throw new wn('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
        }
        break;
      case "RSA":
        switch (o.alg) {
          case "PS256":
          case "PS384":
          case "PS512":
            s = { name: "RSA-PSS", hash: "SHA-".concat(o.alg.slice(-3)) }, l = o.d ? ["sign"] : ["verify"];
            break;
          case "RS256":
          case "RS384":
          case "RS512":
            s = { name: "RSASSA-PKCS1-v1_5", hash: "SHA-".concat(o.alg.slice(-3)) }, l = o.d ? ["sign"] : ["verify"];
            break;
          case "RSA-OAEP":
          case "RSA-OAEP-256":
          case "RSA-OAEP-384":
          case "RSA-OAEP-512":
            s = { name: "RSA-OAEP", hash: "SHA-".concat(parseInt(o.alg.slice(-3), 10) || 1) }, l = o.d ? ["decrypt", "unwrapKey"] : ["encrypt", "wrapKey"];
            break;
          default:
            throw new wn('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
        }
        break;
      case "EC":
        switch (o.alg) {
          case "ES256":
            s = { name: "ECDSA", namedCurve: "P-256" }, l = o.d ? ["sign"] : ["verify"];
            break;
          case "ES384":
            s = { name: "ECDSA", namedCurve: "P-384" }, l = o.d ? ["sign"] : ["verify"];
            break;
          case "ES512":
            s = { name: "ECDSA", namedCurve: "P-521" }, l = o.d ? ["sign"] : ["verify"];
            break;
          case "ECDH-ES":
          case "ECDH-ES+A128KW":
          case "ECDH-ES+A192KW":
          case "ECDH-ES+A256KW":
            s = { name: "ECDH", namedCurve: o.crv }, l = o.d ? ["deriveBits"] : [];
            break;
          default:
            throw new wn('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
        }
        break;
      case "OKP":
        switch (o.alg) {
          case "Ed25519":
          case "EdDSA":
            s = { name: "Ed25519" }, l = o.d ? ["sign"] : ["verify"];
            break;
          case "ECDH-ES":
          case "ECDH-ES+A128KW":
          case "ECDH-ES+A192KW":
          case "ECDH-ES+A256KW":
            s = { name: o.crv }, l = o.d ? ["deriveBits"] : [];
            break;
          default:
            throw new wn('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
        }
        break;
      default:
        throw new wn('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return { algorithm: s, keyUsages: l };
  })(e), a = Ne({}, e);
  return a.kty !== "AKP" && delete a.alg, delete a.use, crypto.subtle.importKey("jwk", a, n, (t = e.ext) !== null && t !== void 0 ? t : !e.d && !e.priv, (r = e.key_ops) !== null && r !== void 0 ? r : i);
}
const F2 = (e) => za(e) && typeof e.kty == "string";
let Ia;
const Fg = async function(e, t, r) {
  let n = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
  Ia || (Ia = /* @__PURE__ */ new WeakMap());
  let i = Ia.get(e);
  if (i != null && i[r]) return i[r];
  const a = await n0(Ne(Ne({}, t), {}, { alg: r }));
  return n && Object.freeze(e), i ? i[r] = a : Ia.set(e, { [r]: a }), a;
};
async function tS(e, t) {
  if (e instanceof Uint8Array || R6(e)) return e;
  if (L6(e)) {
    if (e.type === "secret") return e.export();
    if ("toCryptoKey" in e && typeof e.toCryptoKey == "function") try {
      return ((n, i) => {
        Ia || (Ia = /* @__PURE__ */ new WeakMap());
        let a = Ia.get(n);
        if (a != null && a[i]) return a[i];
        const o = n.type === "public", s = !!o;
        let l;
        if (n.asymmetricKeyType === "x25519") {
          switch (i) {
            case "ECDH-ES":
            case "ECDH-ES+A128KW":
            case "ECDH-ES+A192KW":
            case "ECDH-ES+A256KW":
              break;
            default:
              throw new TypeError("given KeyObject instance cannot be used for this algorithm");
          }
          l = n.toCryptoKey(n.asymmetricKeyType, s, o ? [] : ["deriveBits"]);
        }
        if (n.asymmetricKeyType === "ed25519") {
          if (i !== "EdDSA" && i !== "Ed25519") throw new TypeError("given KeyObject instance cannot be used for this algorithm");
          l = n.toCryptoKey(n.asymmetricKeyType, s, [o ? "verify" : "sign"]);
        }
        switch (n.asymmetricKeyType) {
          case "ml-dsa-44":
          case "ml-dsa-65":
          case "ml-dsa-87":
            if (i !== n.asymmetricKeyType.toUpperCase()) throw new TypeError("given KeyObject instance cannot be used for this algorithm");
            l = n.toCryptoKey(n.asymmetricKeyType, s, [o ? "verify" : "sign"]);
        }
        if (n.asymmetricKeyType === "rsa") {
          let c;
          switch (i) {
            case "RSA-OAEP":
              c = "SHA-1";
              break;
            case "RS256":
            case "PS256":
            case "RSA-OAEP-256":
              c = "SHA-256";
              break;
            case "RS384":
            case "PS384":
            case "RSA-OAEP-384":
              c = "SHA-384";
              break;
            case "RS512":
            case "PS512":
            case "RSA-OAEP-512":
              c = "SHA-512";
              break;
            default:
              throw new TypeError("given KeyObject instance cannot be used for this algorithm");
          }
          if (i.startsWith("RSA-OAEP")) return n.toCryptoKey({ name: "RSA-OAEP", hash: c }, s, o ? ["encrypt"] : ["decrypt"]);
          l = n.toCryptoKey({ name: i.startsWith("PS") ? "RSA-PSS" : "RSASSA-PKCS1-v1_5", hash: c }, s, [o ? "verify" : "sign"]);
        }
        if (n.asymmetricKeyType === "ec") {
          var d;
          const c = (/* @__PURE__ */ new Map([["prime256v1", "P-256"], ["secp384r1", "P-384"], ["secp521r1", "P-521"]])).get((d = n.asymmetricKeyDetails) === null || d === void 0 ? void 0 : d.namedCurve);
          if (!c) throw new TypeError("given KeyObject instance cannot be used for this algorithm");
          i === "ES256" && c === "P-256" && (l = n.toCryptoKey({ name: "ECDSA", namedCurve: c }, s, [o ? "verify" : "sign"])), i === "ES384" && c === "P-384" && (l = n.toCryptoKey({ name: "ECDSA", namedCurve: c }, s, [o ? "verify" : "sign"])), i === "ES512" && c === "P-521" && (l = n.toCryptoKey({ name: "ECDSA", namedCurve: c }, s, [o ? "verify" : "sign"])), i.startsWith("ECDH-ES") && (l = n.toCryptoKey({ name: "ECDH", namedCurve: c }, s, o ? [] : ["deriveBits"]));
        }
        if (!l) throw new TypeError("given KeyObject instance cannot be used for this algorithm");
        return a ? a[i] = l : Ia.set(n, { [i]: l }), l;
      })(e, t);
    } catch (n) {
      if (n instanceof TypeError) throw n;
    }
    let r = e.export({ format: "jwk" });
    return Fg(e, r, t);
  }
  if (F2(e)) return e.k ? jd(e.k) : Fg(e, e, t, !0);
  throw new Error("unreachable");
}
const fs = (e) => e?.[Symbol.toStringTag], Qh = (e, t, r) => {
  if (t.use !== void 0) {
    let a;
    switch (r) {
      case "sign":
      case "verify":
        a = "sig";
        break;
      case "encrypt":
      case "decrypt":
        a = "enc";
    }
    if (t.use !== a) throw new TypeError('Invalid key for this operation, its "use" must be "'.concat(a, '" when present'));
  }
  if (t.alg !== void 0 && t.alg !== e) throw new TypeError('Invalid key for this operation, its "alg" must be "'.concat(e, '" when present'));
  if (Array.isArray(t.key_ops)) {
    var n, i;
    let a;
    switch (!0) {
      case r === "verify":
      case e === "dir":
      case e.includes("CBC-HS"):
        a = r;
        break;
      case e.startsWith("PBES2"):
        a = "deriveBits";
        break;
      case /^A\d{3}(?:GCM)?(?:KW)?$/.test(e):
        a = !e.includes("GCM") && e.endsWith("KW") ? "unwrapKey" : r;
        break;
      case r === "encrypt":
        a = "wrapKey";
        break;
      case r === "decrypt":
        a = e.startsWith("RSA") ? "unwrapKey" : "deriveBits";
    }
    if (a && ((n = t.key_ops) === null || n === void 0 || (i = n.includes) === null || i === void 0 ? void 0 : i.call(n, a)) === !1) throw new TypeError('Invalid key for this operation, its "key_ops" must include "'.concat(a, '" when present'));
  }
  return !0;
};
function rS(e, t, r) {
  switch (e.substring(0, 2)) {
    case "A1":
    case "A2":
    case "di":
    case "HS":
    case "PB":
      ((n, i, a) => {
        if (!(i instanceof Uint8Array)) {
          if (F2(i)) {
            if (((o) => o.kty === "oct" && typeof o.k == "string")(i) && Qh(n, i, a)) return;
            throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
          }
          if (!Rg(i)) throw new TypeError(Mg(n, i, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array"));
          if (i.type !== "secret") throw new TypeError("".concat(fs(i), ' instances for symmetric algorithms must be of type "secret"'));
        }
      })(e, t, r);
      break;
    default:
      ((n, i, a) => {
        if (F2(i)) switch (a) {
          case "decrypt":
          case "sign":
            if (((o) => o.kty !== "oct" && (o.kty === "AKP" && typeof o.priv == "string" || typeof o.d == "string"))(i) && Qh(n, i, a)) return;
            throw new TypeError("JSON Web Key for this operation must be a private JWK");
          case "encrypt":
          case "verify":
            if (((o) => o.kty !== "oct" && o.d === void 0 && o.priv === void 0)(i) && Qh(n, i, a)) return;
            throw new TypeError("JSON Web Key for this operation must be a public JWK");
        }
        if (!Rg(i)) throw new TypeError(Mg(n, i, "CryptoKey", "KeyObject", "JSON Web Key"));
        if (i.type === "secret") throw new TypeError("".concat(fs(i), ' instances for asymmetric algorithms must not be of type "secret"'));
        if (i.type === "public") switch (a) {
          case "sign":
            throw new TypeError("".concat(fs(i), ' instances for asymmetric algorithm signing must be of type "private"'));
          case "decrypt":
            throw new TypeError("".concat(fs(i), ' instances for asymmetric algorithm decryption must be of type "private"'));
        }
        if (i.type === "private") switch (a) {
          case "verify":
            throw new TypeError("".concat(fs(i), ' instances for asymmetric algorithm verifying must be of type "public"'));
          case "encrypt":
            throw new TypeError("".concat(fs(i), ' instances for asymmetric algorithm encryption must be of type "public"'));
        }
      })(e, t, r);
  }
}
var yu, Gh;
let Ii, jg;
(typeof navigator > "u" || (yu = navigator.userAgent) === null || yu === void 0 || (Gh = yu.startsWith) === null || Gh === void 0 || !Gh.call(yu, "Mozilla/5.0 ")) && (jg = "".concat("openid-client", "/").concat("v6.8.1"), Ii = { "user-agent": jg });
const Dr = (e) => i0.get(e);
let i0, bu;
function F6(e) {
  return e !== void 0 ? Og(e) : (bu || (bu = /* @__PURE__ */ new WeakMap()), (t, r, n, i) => {
    let a;
    return (a = bu.get(r)) || ((function(o, s) {
      if (typeof o != "string") throw Di("".concat(s, " must be a string"), zc);
      if (o.length === 0) throw Di("".concat(s, " must not be empty"), jc);
    })(r.client_secret, '"metadata.client_secret"'), a = Og(r.client_secret), bu.set(r, a)), a(t, r, n, i);
  });
}
const Da = pi, jc = "ERR_INVALID_ARG_VALUE", zc = "ERR_INVALID_ARG_TYPE";
function Di(e, t, r) {
  const n = new TypeError(e, { cause: r });
  return Object.assign(n, { code: t }), n;
}
function nS(e) {
  return (async function(t) {
    return mr(t, "codeVerifier"), jo(await crypto.subtle.digest("SHA-256", Ks(t)));
  })(e);
}
function iS() {
  return $6();
}
let z0 = class extends Error {
  constructor(t, r) {
    var n;
    super(t, r), me(this, "code", void 0), this.name = this.constructor.name, this.code = r?.code, (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
};
function Qr(e, t, r) {
  return new z0(e, { cause: t, code: r });
}
function Yr(e) {
  if (e instanceof TypeError || e instanceof z0 || e instanceof L1 || e instanceof k6 || e instanceof nm) throw e;
  if (e instanceof tm) switch (e.code) {
    case C6:
      throw Qr("only requests to HTTPS are allowed", e, e.code);
    case T6:
      throw Qr("only requests to HTTP or HTTPS are allowed", e, e.code);
    case sm:
      throw Qr("unexpected HTTP response status code", e.cause, e.code);
    case S6:
      throw Qr("unexpected response content-type", e.cause, e.code);
    case j0:
      throw Qr("parsing error occured", e, e.code);
    case at:
      throw Qr("invalid response encountered", e, e.code);
    case Xi:
      throw Qr("unexpected JWT claim value encountered", e, e.code);
    case M2:
      throw Qr("unexpected JSON attribute value encountered", e, e.code);
    case rc:
      throw Qr("JWT timestamp claim value failed validation", e, e.code);
    default:
      throw Qr(e.message, e, e.code);
  }
  if (e instanceof $n) throw Qr("unsupported operation", e, e.code);
  if (e instanceof DOMException) switch (e.name) {
    case "OperationError":
      throw Qr("runtime operation error", e, N2);
    case "NotSupportedError":
      throw Qr("runtime unsupported operation", e, N2);
    case "TimeoutError":
      throw Qr("operation timed out", e, "OAUTH_TIMEOUT");
    case "AbortError":
      throw Qr("operation aborted", e, "OAUTH_ABORT");
  }
  throw new z0("something went wrong", { cause: e });
}
async function aS(e, t, r, n, i) {
  const a = await (async function(l, d) {
    var c, u;
    if (!(l instanceof URL)) throw Di('"server" must be an instance of URL', zc);
    const h = !l.href.includes("/.well-known/"), f = (c = d?.timeout) !== null && c !== void 0 ? c : 30, p = AbortSignal.timeout(1e3 * f), m = await (h ? EE(l, { algorithm: d?.algorithm, [pi]: d?.[Da], [Rn]: d == null || (u = d.execute) === null || u === void 0 ? void 0 : u.includes(Ug), signal: p, headers: new Headers(Ii) }) : (d?.[Da] || fetch)((rm(l, d == null || (y = d.execute) === null || y === void 0 || !y.includes(Ug)), l.href), { headers: Object.fromEntries(new Headers(Ne({ accept: "application/json" }, Ii)).entries()), body: void 0, method: "GET", redirect: "manual", signal: p })).then(((g) => (async function(w, $) {
      const _ = w;
      if (!(_ instanceof URL) && _ !== Bh) throw _t('"expectedIssuerIdentifier" must be an instance of URL', "ERR_INVALID_ARG_TYPE");
      if (!Tl($, Response)) throw _t('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
      if ($.status !== 200) throw Fe('"response" is not a conform Authorization Server Metadata response (unexpected HTTP status code)', sm, $);
      Fc($);
      const x = await F1($);
      if (mr(x.issuer, '"response" body "issuer" property', at, { body: x }), _ !== Bh && new URL(x.issuer).href !== _.href) throw Fe('"response" body "issuer" property does not match the expected value', M2, { expected: _.href, body: x, attribute: "issuer" });
      return x;
    })(Bh, g))).catch(Yr);
    var y;
    return h && new URL(m.issuer).href !== l.href && ((function(g, w, $) {
      return !(g.origin !== "https://login.microsoftonline.com" || $ != null && $.algorithm && $.algorithm !== "oidc" || (w[j6] = !0, 0));
    })(l, m, d) || (function(g, w) {
      return !(!g.hostname.endsWith(".b2clogin.com") || w != null && w.algorithm && w.algorithm !== "oidc");
    })(l, d) || (() => {
      throw new z0("discovered metadata issuer does not match the expected issuer", { code: M2, cause: { expected: l.href, body: m, attribute: "issuer" } });
    })()), m;
  })(e, i), o = new V0(a, t, r, n);
  let s = Dr(o);
  if (i != null && i[Da] && (s.fetch = i[Da]), i != null && i.timeout && (s.timeout = i.timeout), i != null && i.execute) for (const l of i.execute) l(o);
  return o;
}
new TextDecoder();
const j6 = /* @__PURE__ */ Symbol();
let V0 = class {
  constructor(t, r, n, i) {
    var a, o, s, l, d;
    if (typeof r != "string" || !r.length) throw Di('"clientId" must be a non-empty string', zc);
    if (typeof n == "string" && (n = { client_secret: n }), ((a = n) === null || a === void 0 ? void 0 : a.client_id) !== void 0 && r !== n.client_id) throw Di('"clientId" and "metadata.client_id" must be the same', jc);
    const c = Ne(Ne({}, structuredClone(n)), {}, { client_id: r });
    let u;
    c[A2] = (o = (s = n) === null || s === void 0 ? void 0 : s[A2]) !== null && o !== void 0 ? o : 0, c[O2] = (l = (d = n) === null || d === void 0 ? void 0 : d[O2]) !== null && l !== void 0 ? l : 30, u = i || (typeof c.client_secret == "string" && c.client_secret.length ? F6(c.client_secret) : (m, y, g, w) => {
      g.set("client_id", y.client_id);
    });
    let h = Object.freeze(c);
    const f = structuredClone(t);
    j6 in t && (f[A6] = (m) => {
      let { claims: { tid: y } } = m;
      return t.issuer.replace("{tenantid}", y);
    });
    let p = Object.freeze(f);
    i0 || (i0 = /* @__PURE__ */ new WeakMap()), i0.set(this, { __proto__: null, as: p, c: h, auth: u, tlsOnly: !0, jwksCache: {} });
  }
  serverMetadata() {
    const t = structuredClone(Dr(this).as);
    return (function(r) {
      Object.defineProperties(r, /* @__PURE__ */ (function(n) {
        return { supportsPKCE: { __proto__: null, value() {
          var i;
          let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "S256";
          return ((i = n.code_challenge_methods_supported) === null || i === void 0 ? void 0 : i.includes(a)) === !0;
        } } };
      })(r));
    })(t), t;
  }
  clientMetadata() {
    return structuredClone(Dr(this).c);
  }
  get timeout() {
    return Dr(this).timeout;
  }
  set timeout(t) {
    Dr(this).timeout = t;
  }
  get [Da]() {
    return Dr(this).fetch;
  }
  set [Da](t) {
    Dr(this).fetch = t;
  }
};
function Vc(e) {
  Object.defineProperties(e, (function(t) {
    let r;
    if (t.expires_in !== void 0) {
      const n = /* @__PURE__ */ new Date();
      n.setSeconds(n.getSeconds() + t.expires_in), r = n.getTime();
    }
    return { expiresIn: { __proto__: null, value() {
      if (r) {
        const n = Date.now();
        return r > n ? Math.floor((r - n) / 1e3) : 0;
      }
    } }, claims: { __proto__: null, value() {
      try {
        return D2(this);
      } catch {
        return;
      }
    } } };
  })(e));
}
async function zg(e, t, r) {
  var n;
  let i = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
  const a = (n = e.headers.get("retry-after")) === null || n === void 0 ? void 0 : n.trim();
  if (a === void 0) return;
  let o;
  if (/^\d+$/.test(a)) o = parseInt(a, 10);
  else {
    const s = new Date(a);
    if (Number.isFinite(s.getTime())) {
      const l = /* @__PURE__ */ new Date(), d = s.getTime() - l.getTime();
      d > 0 && (o = Math.ceil(d / 1e3));
    }
  }
  if (i && !Number.isFinite(o)) throw new tm("invalid Retry-After header value", { cause: e });
  o > t && await z6(o - t, r);
}
function z6(e, t) {
  return new Promise(((r, n) => {
    const i = (a) => {
      try {
        t.throwIfAborted();
      } catch (s) {
        return void n(s);
      }
      if (a <= 0) return void r();
      const o = Math.min(a, 5);
      setTimeout((() => i(a - o)), 1e3 * o);
    };
    i(e);
  }));
}
async function Vg(e, t) {
  sa(e);
  const { as: r, c: n, auth: i, fetch: a, tlsOnly: o, timeout: s } = Dr(e);
  return (async function(l, d, c, u, h) {
    oi(l), si(d);
    const f = Rc(l, "backchannel_authentication_endpoint", d.use_mtls_endpoint_aliases, h?.[Rn] !== !0), p = new URLSearchParams(u);
    p.set("client_id", d.client_id);
    const m = R1(h?.headers);
    return m.set("accept", "application/json"), am(l, d, c, f, p, m, h);
  })(r, n, i, t, { [pi]: a, [Rn]: !o, headers: new Headers(Ii), signal: is(s) }).then(((l) => (async function(d, c, u) {
    if (oi(d), si(c), !Tl(u, Response)) throw _t('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
    await im(u, 200, "Backchannel Authentication Endpoint"), Fc(u);
    const h = await F1(u);
    mr(h.auth_req_id, '"response" body "auth_req_id" property', at, { body: h });
    let f = typeof h.expires_in != "number" ? parseFloat(h.expires_in) : h.expires_in;
    return Ma(f, !0, '"response" body "expires_in" property', at, { body: h }), h.expires_in = f, h.interval !== void 0 && Ma(h.interval, !1, '"response" body "interval" property', at, { body: h }), h;
  })(r, n, l))).catch(Yr);
}
async function V6(e, t, r, n) {
  var i, a;
  sa(e), r = new URLSearchParams(r);
  let o = (i = t.interval) !== null && i !== void 0 ? i : 5;
  const s = (a = n?.signal) !== null && a !== void 0 ? a : AbortSignal.timeout(1e3 * t.expires_in);
  try {
    await z6(o, s);
  } catch (x) {
    Yr(x);
  }
  const { as: l, c: d, auth: c, fetch: u, tlsOnly: h, nonRepudiation: f, timeout: p, decrypt: m } = Dr(e), y = (x, S) => V6(e, Ne(Ne({}, t), {}, { interval: x }), r, Ne(Ne({}, n), {}, { signal: s, flag: S })), g = await (async function(x, S, T, I, M) {
    oi(x), si(S), mr(I, '"authReqId"');
    const P = new URLSearchParams(M?.additionalParameters);
    return P.set("auth_req_id", I), Lc(x, S, T, "urn:openid:params:grant-type:ciba", P, M);
  })(l, d, c, t.auth_req_id, { [pi]: u, [Rn]: !h, additionalParameters: r, DPoP: n?.DPoP, headers: new Headers(Ii), signal: s.aborted ? s : is(p) }).catch(Yr);
  var w;
  if (g.status === 503 && g.headers.has("retry-after")) return await zg(g, o, s, !0), await ((w = g.body) === null || w === void 0 ? void 0 : w.cancel()), y(o);
  const $ = (async function(x, S, T, I) {
    return ll(x, S, T, void 0, I?.[ea], I?.recognizedTokenTypes);
  })(l, d, g, { [ea]: m });
  let _;
  try {
    _ = await $;
  } catch (x) {
    if (Uc(x, n)) return y(o, Ra);
    if (x instanceof L1) switch (x.error) {
      case "slow_down":
        o += 5;
      case "authorization_pending":
        return await zg(x.response, o, s), y(o);
    }
    Yr(x);
  }
  return _.id_token && await f?.(g), Vc(_), _;
}
function Ug(e) {
  Dr(e).tlsOnly = !1;
}
async function U6(e, t, r, n, i) {
  if (sa(e), !(i?.flag === Ra || t instanceof URL || (function(x, S) {
    try {
      return Object.getPrototypeOf(x)[Symbol.toStringTag] === S;
    } catch {
      return !1;
    }
  })(t, "Request"))) throw Di('"currentUrl" must be an instance of URL, or Request', zc);
  let a, o;
  const { as: s, c: l, auth: d, fetch: c, tlsOnly: u, jarm: h, hybrid: f, nonRepudiation: p, timeout: m, decrypt: y, implicit: g } = Dr(e);
  if (i?.flag === Ra) a = i.authResponse, o = i.redirectUri;
  else {
    if (!(t instanceof URL)) {
      const x = t;
      switch (t = new URL(t.url), x.method) {
        case "GET":
          break;
        case "POST":
          const S = new URLSearchParams(await WE(x));
          if (f) t.hash = S.toString();
          else for (const [T, I] of S.entries()) t.searchParams.append(T, I);
          break;
        default:
          throw Di("unexpected Request HTTP method", jc);
      }
    }
    switch (o = (function(x) {
      return (x = new URL(x)).search = "", x.hash = "", x.href;
    })(t), !0) {
      case !!h:
        a = await h(t, r?.expectedState);
        break;
      case !!f:
        a = await f(t, r?.expectedNonce, r?.expectedState, r?.maxAge);
        break;
      case !!g:
        throw new TypeError("authorizationCodeGrant() cannot be used by response_type=id_token clients");
      default:
        try {
          a = YE(s, l, t.searchParams, r?.expectedState);
        } catch (x) {
          Yr(x);
        }
    }
  }
  const w = await (async function(x, S, T, I, M, P, O) {
    if (oi(x), si(S), !om.has(I)) throw _t('"callbackParameters" must be an instance of URLSearchParams obtained from "validateAuthResponse()", or "validateJwtAuthResponse()', "ERR_INVALID_ARG_VALUE");
    mr(M, '"redirectUri"');
    const D = bo(I, "code");
    if (!D) throw Fe('no authorization code in "callbackParameters"', at);
    const R = new URLSearchParams(O?.additionalParameters);
    return R.set("redirect_uri", M), R.set("code", D), P !== Ig && (mr(P, '"codeVerifier"'), R.set("code_verifier", P)), Lc(x, S, T, "authorization_code", R, O);
  })(s, l, d, a, o, r?.pkceCodeVerifier || Ig, { additionalParameters: n, [pi]: c, [Rn]: !u, DPoP: i?.DPoP, headers: new Headers(Ii), signal: is(m) }).catch(Yr);
  typeof r?.expectedNonce != "string" && typeof r?.maxAge != "number" || (r.idTokenExpected = !0);
  const $ = jE(s, l, w, { expectedNonce: r?.expectedNonce, maxAge: r?.maxAge, requireIdToken: r?.idTokenExpected, [ea]: y });
  let _;
  try {
    _ = await $;
  } catch (x) {
    if (Uc(x, i)) return U6(e, void 0, r, n, Ne(Ne({}, i), {}, { flag: Ra, authResponse: a, redirectUri: o }));
    Yr(x);
  }
  return _.id_token && await p?.(w), Vc(_), _;
}
async function q6(e, t, r, n) {
  sa(e), r = new URLSearchParams(r);
  const { as: i, c: a, auth: o, fetch: s, tlsOnly: l, nonRepudiation: d, timeout: c, decrypt: u } = Dr(e), h = await (async function(m, y, g, w, $) {
    oi(m), si(y), mr(w, '"refreshToken"');
    const _ = new URLSearchParams($?.additionalParameters);
    return _.set("refresh_token", w), Lc(m, y, g, "refresh_token", _, $);
  })(i, a, o, t, { [pi]: s, [Rn]: !l, additionalParameters: r, DPoP: n?.DPoP, headers: new Headers(Ii), signal: is(c) }).catch(Yr), f = (async function(m, y, g, w) {
    return ll(m, y, g, void 0, w?.[ea], w?.recognizedTokenTypes);
  })(i, a, h, { [ea]: u });
  let p;
  try {
    p = await f;
  } catch (m) {
    if (Uc(m, n)) return q6(e, t, r, Ne(Ne({}, n), {}, { flag: Ra }));
    Yr(m);
  }
  return p.id_token && await d?.(h), Vc(p), p;
}
async function B6(e, t, r) {
  sa(e), t = new URLSearchParams(t);
  const { as: n, c: i, auth: a, fetch: o, tlsOnly: s, timeout: l } = Dr(e), d = await (async function(h, f, p, m, y) {
    return oi(h), si(f), Lc(h, f, p, "client_credentials", new URLSearchParams(m), y);
  })(n, i, a, t, { [pi]: o, [Rn]: !s, DPoP: r?.DPoP, headers: new Headers(Ii), signal: is(l) }).catch(Yr), c = (async function(h, f, p, m) {
    return ll(h, f, p, void 0, void 0, void 0);
  })(n, i, d);
  let u;
  try {
    u = await c;
  } catch (h) {
    if (Uc(h, r)) return B6(e, t, Ne(Ne({}, r), {}, { flag: Ra }));
    Yr(h);
  }
  return Vc(u), u;
}
function j2(e, t) {
  sa(e);
  const { as: r, c: n, tlsOnly: i, hybrid: a, jarm: o, implicit: s } = Dr(e), l = Rc(r, "authorization_endpoint", !1, i);
  if ((t = new URLSearchParams(t)).has("client_id") || t.set("client_id", n.client_id), !t.has("request_uri") && !t.has("request")) {
    if (t.has("response_type") || t.set("response_type", a ? "code id_token" : s ? "id_token" : "code"), s && !t.has("nonce")) throw Di("response_type=id_token clients must provide a nonce parameter in their authorization request parameters", jc);
    o && t.set("response_mode", "jwt");
  }
  for (const [d, c] of t.entries()) l.searchParams.append(d, c);
  return l;
}
async function H6(e, t, r) {
  sa(e);
  const n = j2(e, t), { as: i, c: a, auth: o, fetch: s, tlsOnly: l, timeout: d } = Dr(e), c = await (async function(f, p, m, y, g) {
    var w;
    oi(f), si(p);
    const $ = Rc(f, "pushed_authorization_request_endpoint", p.use_mtls_endpoint_aliases, g?.[Rn] !== !0), _ = new URLSearchParams(y);
    _.set("client_id", p.client_id);
    const x = R1(g?.headers);
    x.set("accept", "application/json"), g?.DPoP !== void 0 && (_6(g.DPoP), await g.DPoP.addProof($, x, "POST"));
    const S = await am(f, p, m, $, _, x, g);
    return g == null || (w = g.DPoP) === null || w === void 0 || w.cacheNonce(S, $), S;
  })(i, a, o, n.searchParams, { [pi]: s, [Rn]: !l, DPoP: r?.DPoP, headers: new Headers(Ii), signal: is(d) }).catch(Yr), u = (async function(f, p, m) {
    if (oi(f), si(p), !Tl(m, Response)) throw _t('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
    await im(m, 201, "Pushed Authorization Request Endpoint"), Fc(m);
    const y = await F1(m);
    mr(y.request_uri, '"response" body "request_uri" property', at, { body: y });
    let g = typeof y.expires_in != "number" ? parseFloat(y.expires_in) : y.expires_in;
    return Ma(g, !0, '"response" body "expires_in" property', at, { body: y }), y.expires_in = g, y;
  })(i, a, c);
  let h;
  try {
    h = await u;
  } catch (f) {
    if (Uc(f, r)) return H6(e, t, Ne(Ne({}, r), {}, { flag: Ra }));
    Yr(f);
  }
  return j2(e, { request_uri: h.request_uri });
}
function sa(e) {
  if (!(e instanceof V0)) throw Di('"config" must be an instance of Configuration', zc);
  if (Object.getPrototypeOf(e) !== V0.prototype) throw Di("subclassing Configuration is not allowed", jc);
}
function is(e) {
  return e ? AbortSignal.timeout(1e3 * e) : void 0;
}
function Uc(e, t) {
  return !(t == null || !t.DPoP || t.flag === Ra) && (function(r) {
    if (r instanceof nm) {
      const { 0: n, length: i } = r.cause;
      return i === 1 && n.scheme === "dpop" && n.parameters.error === "use_dpop_nonce";
    }
    return r instanceof L1 && r.error === "use_dpop_nonce";
  })(e);
}
Object.freeze(V0.prototype);
const Ra = /* @__PURE__ */ Symbol();
async function cm(e, t, r, n) {
  sa(e);
  const { as: i, c: a, auth: o, fetch: s, tlsOnly: l, timeout: d, decrypt: c } = Dr(e), u = await (async function(h, f, p, m, y, g) {
    return oi(h), si(f), mr(m, '"grantType"'), Lc(h, f, p, m, new URLSearchParams(y), g);
  })(i, a, o, t, new URLSearchParams(r), { [pi]: s, [Rn]: !l, DPoP: void 0, headers: new Headers(Ii), signal: is(d) }).then(((h) => {
    let f;
    return t === "urn:ietf:params:oauth:grant-type:token-exchange" && (f = { n_a: () => {
    } }), (async function(p, m, y, g) {
      return ll(p, m, y, void 0, g?.[ea], g?.recognizedTokenTypes);
    })(i, a, h, { [ea]: c, recognizedTokenTypes: f });
  })).catch(Yr);
  return Vc(u), u;
}
async function oS(e, t, r) {
  if (t instanceof Uint8Array) {
    if (!e.startsWith("HS")) throw new TypeError((function(n) {
      for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) a[o - 1] = arguments[o];
      return M6("Key must be ", n, ...a);
    })(t, "CryptoKey", "KeyObject", "JSON Web Key"));
    return crypto.subtle.importKey("raw", t, { hash: "SHA-".concat(e.slice(-3)), name: "HMAC" }, !1, [r]);
  }
  return JE(t, e, r), t;
}
async function sS(e, t, r, n) {
  const i = await oS(e, t, "verify");
  (function(o, s) {
    if (o.startsWith("RS") || o.startsWith("PS")) {
      const { modulusLength: l } = s.algorithm;
      if (typeof l != "number" || l < 2048) throw new TypeError("".concat(o, " requires key modulusLength to be 2048 bits or larger"));
    }
  })(e, i);
  const a = (function(o, s) {
    const l = "SHA-".concat(o.slice(-3));
    switch (o) {
      case "HS256":
      case "HS384":
      case "HS512":
        return { hash: l, name: "HMAC" };
      case "PS256":
      case "PS384":
      case "PS512":
        return { hash: l, name: "RSA-PSS", saltLength: parseInt(o.slice(-3), 10) >> 3 };
      case "RS256":
      case "RS384":
      case "RS512":
        return { hash: l, name: "RSASSA-PKCS1-v1_5" };
      case "ES256":
      case "ES384":
      case "ES512":
        return { hash: l, name: "ECDSA", namedCurve: s.namedCurve };
      case "Ed25519":
      case "EdDSA":
        return { name: "Ed25519" };
      case "ML-DSA-44":
      case "ML-DSA-65":
      case "ML-DSA-87":
        return { name: o };
      default:
        throw new wn("alg ".concat(o, " is not supported either by JOSE or your javascript runtime"));
    }
  })(e, i.algorithm);
  try {
    return await crypto.subtle.verify(a, i, r, n);
  } catch {
    return !1;
  }
}
async function lS(e, t, r) {
  if (!za(e)) throw new Sr("Flattened JWS must be an object");
  if (e.protected === void 0 && e.header === void 0) throw new Sr('Flattened JWS must have either of the "protected" or "header" members');
  if (e.protected !== void 0 && typeof e.protected != "string") throw new Sr("JWS Protected Header incorrect type");
  if (e.payload === void 0) throw new Sr("JWS Payload missing");
  if (typeof e.signature != "string") throw new Sr("JWS Signature missing or incorrect type");
  if (e.header !== void 0 && !za(e.header)) throw new Sr("JWS Unprotected Header incorrect type");
  let n = {};
  if (e.protected) try {
    const m = jd(e.protected);
    n = JSON.parse(nc.decode(m));
  } catch {
    throw new Sr("JWS Protected Header is invalid");
  }
  if (!(function() {
    for (var m = arguments.length, y = new Array(m), g = 0; g < m; g++) y[g] = arguments[g];
    const w = y.filter(Boolean);
    if (w.length === 0 || w.length === 1) return !0;
    let $;
    for (const _ of w) {
      const x = Object.keys(_);
      if ($ && $.size !== 0) for (const S of x) {
        if ($.has(S)) return !1;
        $.add(S);
      }
      else $ = new Set(x);
    }
    return !0;
  })(n, e.header)) throw new Sr("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
  const i = Ne(Ne({}, n), e.header), a = (function(m, y, g, w, $) {
    if ($.crit !== void 0 && w?.crit === void 0) throw new m('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!w || w.crit === void 0) return /* @__PURE__ */ new Set();
    if (!Array.isArray(w.crit) || w.crit.length === 0 || w.crit.some(((x) => typeof x != "string" || x.length === 0))) throw new m('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let _;
    _ = g !== void 0 ? new Map([...Object.entries(g), ...y.entries()]) : y;
    for (const x of w.crit) {
      if (!_.has(x)) throw new wn('Extension Header Parameter "'.concat(x, '" is not recognized'));
      if ($[x] === void 0) throw new m('Extension Header Parameter "'.concat(x, '" is missing'));
      if (_.get(x) && w[x] === void 0) throw new m('Extension Header Parameter "'.concat(x, '" MUST be integrity protected'));
    }
    return new Set(w.crit);
  })(Sr, /* @__PURE__ */ new Map([["b64", !0]]), r?.crit, n, i);
  let o = !0;
  if (a.has("b64") && (o = n.b64, typeof o != "boolean")) throw new Sr('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
  const { alg: s } = i;
  if (typeof s != "string" || !s) throw new Sr('JWS "alg" (Algorithm) Header Parameter missing or invalid');
  const l = r && (function(m, y) {
    if (y !== void 0 && (!Array.isArray(y) || y.some(((g) => typeof g != "string")))) throw new TypeError('"'.concat(m, '" option must be an array of strings'));
    if (y) return new Set(y);
  })("algorithms", r.algorithms);
  if (l && !l.has(s)) throw new P6('"alg" (Algorithm) Header Parameter value not allowed');
  if (o) {
    if (typeof e.payload != "string") throw new Sr("JWS Payload must be a string");
  } else if (typeof e.payload != "string" && !(e.payload instanceof Uint8Array)) throw new Sr("JWS Payload must be a string or an Uint8Array instance");
  let d = !1;
  typeof t == "function" && (t = await t(n, e), d = !0), rS(s, t, "verify");
  const c = (function() {
    for (var m = arguments.length, y = new Array(m), g = 0; g < m; g++) y[g] = arguments[g];
    const w = y.reduce(((x, S) => {
      let { length: T } = S;
      return x + T;
    }), 0), $ = new Uint8Array(w);
    let _ = 0;
    for (const x of y) $.set(x, _), _ += x.length;
    return $;
  })(e.protected !== void 0 ? Hh(e.protected) : new Uint8Array(), Hh("."), typeof e.payload == "string" ? o ? Hh(e.payload) : Ng.encode(e.payload) : e.payload);
  let u;
  try {
    u = jd(e.signature);
  } catch {
    throw new Sr("Failed to base64url decode the signature");
  }
  const h = await tS(t, s);
  if (!await sS(s, h, u, c)) throw new N6();
  let f;
  if (o) try {
    f = jd(e.payload);
  } catch {
    throw new Sr("Failed to base64url decode the payload");
  }
  else f = typeof e.payload == "string" ? Ng.encode(e.payload) : e.payload;
  const p = { payload: f };
  return e.protected !== void 0 && (p.protectedHeader = n), e.header !== void 0 && (p.unprotectedHeader = e.header), d ? Ne(Ne({}, p), {}, { key: h }) : p;
}
const dS = (e) => Math.floor(e.getTime() / 1e3), cS = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
function qg(e) {
  const t = cS.exec(e);
  if (!t || t[4] && t[1]) throw new TypeError("Invalid time period format");
  const r = parseFloat(t[2]);
  let n;
  switch (t[3].toLowerCase()) {
    case "sec":
    case "secs":
    case "second":
    case "seconds":
    case "s":
      n = Math.round(r);
      break;
    case "minute":
    case "minutes":
    case "min":
    case "mins":
    case "m":
      n = Math.round(60 * r);
      break;
    case "hour":
    case "hours":
    case "hr":
    case "hrs":
    case "h":
      n = Math.round(3600 * r);
      break;
    case "day":
    case "days":
    case "d":
      n = Math.round(86400 * r);
      break;
    case "week":
    case "weeks":
    case "w":
      n = Math.round(604800 * r);
      break;
    default:
      n = Math.round(31557600 * r);
  }
  return t[1] === "-" || t[4] === "ago" ? -n : n;
}
const Bg = (e) => e.includes("/") ? e.toLowerCase() : "application/".concat(e.toLowerCase()), uS = (e, t) => typeof e == "string" ? t.includes(e) : !!Array.isArray(e) && t.some(Set.prototype.has.bind(new Set(e)));
async function hS(e, t, r) {
  var n;
  const i = await (async function(s, l, d) {
    if (s instanceof Uint8Array && (s = nc.decode(s)), typeof s != "string") throw new Sr("Compact JWS must be a string or Uint8Array");
    const { 0: c, 1: u, 2: h, length: f } = s.split(".");
    if (f !== 3) throw new Sr("Invalid Compact JWS");
    const p = await lS({ payload: u, protected: c, signature: h }, l, d), m = { payload: p.payload, protectedHeader: p.protectedHeader };
    return typeof l == "function" ? Ne(Ne({}, m), {}, { key: p.key }) : m;
  })(e, t, r);
  if ((n = i.protectedHeader.crit) !== null && n !== void 0 && n.includes("b64") && i.protectedHeader.b64 === !1) throw new L2("JWTs MUST NOT use unencoded payload");
  const a = (function(s, l) {
    let d, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    try {
      d = JSON.parse(nc.decode(l));
    } catch {
    }
    if (!za(d)) throw new L2("JWT Claims Set must be a top-level JSON object");
    const { typ: u } = c;
    if (u && (typeof s.typ != "string" || Bg(s.typ) !== Bg(u))) throw new Bn('unexpected "typ" JWT header value', d, "typ", "check_failed");
    const { requiredClaims: h = [], issuer: f, subject: p, audience: m, maxTokenAge: y } = c, g = [...h];
    y !== void 0 && g.push("iat"), m !== void 0 && g.push("aud"), p !== void 0 && g.push("sub"), f !== void 0 && g.push("iss");
    for (const x of new Set(g.reverse())) if (!(x in d)) throw new Bn('missing required "'.concat(x, '" claim'), d, x, "missing");
    if (f && !(Array.isArray(f) ? f : [f]).includes(d.iss)) throw new Bn('unexpected "iss" claim value', d, "iss", "check_failed");
    if (p && d.sub !== p) throw new Bn('unexpected "sub" claim value', d, "sub", "check_failed");
    if (m && !uS(d.aud, typeof m == "string" ? [m] : m)) throw new Bn('unexpected "aud" claim value', d, "aud", "check_failed");
    let w;
    switch (typeof c.clockTolerance) {
      case "string":
        w = qg(c.clockTolerance);
        break;
      case "number":
        w = c.clockTolerance;
        break;
      case "undefined":
        w = 0;
        break;
      default:
        throw new TypeError("Invalid clockTolerance option type");
    }
    const { currentDate: $ } = c, _ = dS($ || /* @__PURE__ */ new Date());
    if ((d.iat !== void 0 || y) && typeof d.iat != "number") throw new Bn('"iat" claim must be a number', d, "iat", "invalid");
    if (d.nbf !== void 0) {
      if (typeof d.nbf != "number") throw new Bn('"nbf" claim must be a number', d, "nbf", "invalid");
      if (d.nbf > _ + w) throw new Bn('"nbf" claim timestamp check failed', d, "nbf", "check_failed");
    }
    if (d.exp !== void 0) {
      if (typeof d.exp != "number") throw new Bn('"exp" claim must be a number', d, "exp", "invalid");
      if (d.exp <= _ - w) throw new R2('"exp" claim timestamp check failed', d, "exp", "check_failed");
    }
    if (y) {
      const x = _ - d.iat;
      if (x - w > (typeof y == "number" ? y : qg(y))) throw new R2('"iat" claim timestamp check failed (too far in the past)', d, "iat", "check_failed");
      if (x < 0 - w) throw new Bn('"iat" claim timestamp check failed (it should be in the past)', d, "iat", "check_failed");
    }
    return d;
  })(i.protectedHeader, i.payload, r), o = { payload: a, protectedHeader: i.protectedHeader };
  return typeof t == "function" ? Ne(Ne({}, o), {}, { key: i.key }) : o;
}
function fS(e) {
  return za(e);
}
var wu, Yh, $u = /* @__PURE__ */ new WeakMap(), Jh = /* @__PURE__ */ new WeakMap();
let pS = class {
  constructor(t) {
    if (yr(this, $u, void 0), yr(this, Jh, /* @__PURE__ */ new WeakMap()), !(function(r) {
      return r && typeof r == "object" && Array.isArray(r.keys) && r.keys.every(fS);
    })(t)) throw new lm("JSON Web Key Set malformed");
    Qt($u, this, structuredClone(t));
  }
  jwks() {
    return he($u, this);
  }
  async getKey(t, r) {
    const { alg: n, kid: i } = Ne(Ne({}, t), r?.header), a = (function(d) {
      switch (typeof d == "string" && d.slice(0, 2)) {
        case "RS":
        case "PS":
          return "RSA";
        case "ES":
          return "EC";
        case "Ed":
          return "OKP";
        case "ML":
          return "AKP";
        default:
          throw new wn('Unsupported "alg" value for a JSON Web Key Set');
      }
    })(n), o = he($u, this).keys.filter(((d) => {
      let c = a === d.kty;
      if (c && typeof i == "string" && (c = i === d.kid), !c || typeof d.alg != "string" && a !== "AKP" || (c = n === d.alg), c && typeof d.use == "string" && (c = d.use === "sig"), c && Array.isArray(d.key_ops) && (c = d.key_ops.includes("verify")), c) switch (n) {
        case "ES256":
          c = d.crv === "P-256";
          break;
        case "ES384":
          c = d.crv === "P-384";
          break;
        case "ES512":
          c = d.crv === "P-521";
          break;
        case "Ed25519":
        case "EdDSA":
          c = d.crv === "Ed25519";
      }
      return c;
    })), { 0: s, length: l } = o;
    if (l === 0) throw new dm();
    if (l !== 1) {
      const d = new I6(), c = he(Jh, this);
      throw d[Symbol.asyncIterator] = $E((function* () {
        for (const u of o) try {
          yield yield wE(Hg(c, u, n));
        } catch {
        }
      })), d;
    }
    return Hg(he(Jh, this), s, n);
  }
};
async function Hg(e, t, r) {
  const n = e.get(t) || e.set(t, {}).get(t);
  if (n[r] === void 0) {
    const i = await (async function(a, o, s) {
      var l;
      if (!za(a)) throw new TypeError("JWK must be an object");
      let d;
      switch (o != null || (o = a.alg), d != null || (d = (l = void 0) !== null && l !== void 0 ? l : a.ext), a.kty) {
        case "oct":
          if (typeof a.k != "string" || !a.k) throw new TypeError('missing "k" (Key Value) Parameter value');
          return jd(a.k);
        case "RSA":
          if ("oth" in a && a.oth !== void 0) throw new wn('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
          return n0(Ne(Ne({}, a), {}, { alg: o, ext: d }));
        case "AKP":
          if (typeof a.alg != "string" || !a.alg) throw new TypeError('missing "alg" (Algorithm) Parameter value');
          if (o !== void 0 && o !== a.alg) throw new TypeError("JWK alg and alg option value mismatch");
          return n0(Ne(Ne({}, a), {}, { ext: d }));
        case "EC":
        case "OKP":
          return n0(Ne(Ne({}, a), {}, { alg: o, ext: d }));
        default:
          throw new wn('Unsupported "kty" (Key Type) Parameter value');
      }
    })(Ne(Ne({}, t), {}, { ext: !0 }), r);
    if (i instanceof Uint8Array || i.type !== "public") throw new lm("JSON Web Key Set members must be public keys");
    n[r] = i;
  }
  return n[r];
}
function Wg(e) {
  const t = new pS(e), r = async (n, i) => t.getKey(n, i);
  return Object.defineProperties(r, { jwks: { value: () => structuredClone(t.jwks()), enumerable: !1, configurable: !1, writable: !1 } }), r;
}
let z2;
(typeof navigator > "u" || (wu = navigator.userAgent) === null || wu === void 0 || (Yh = wu.startsWith) === null || Yh === void 0 || !Yh.call(wu, "Mozilla/5.0 ")) && (z2 = "".concat("jose", "/").concat("v6.1.3"));
const W6 = /* @__PURE__ */ Symbol(), Zh = /* @__PURE__ */ Symbol();
var Xh = /* @__PURE__ */ new WeakMap(), ef = /* @__PURE__ */ new WeakMap(), tf = /* @__PURE__ */ new WeakMap(), ku = /* @__PURE__ */ new WeakMap(), lo = /* @__PURE__ */ new WeakMap(), Ui = /* @__PURE__ */ new WeakMap(), ma = /* @__PURE__ */ new WeakMap(), rf = /* @__PURE__ */ new WeakMap(), co = /* @__PURE__ */ new WeakMap(), uo = /* @__PURE__ */ new WeakMap();
let mS = class {
  constructor(t, r) {
    if (yr(this, Xh, void 0), yr(this, ef, void 0), yr(this, tf, void 0), yr(this, ku, void 0), yr(this, lo, void 0), yr(this, Ui, void 0), yr(this, ma, void 0), yr(this, rf, void 0), yr(this, co, void 0), yr(this, uo, void 0), !(t instanceof URL)) throw new TypeError("url must be an instance of URL");
    var n, i;
    Qt(Xh, this, new URL(t.href)), Qt(ef, this, typeof r?.timeoutDuration == "number" ? r?.timeoutDuration : 5e3), Qt(tf, this, typeof r?.cooldownDuration == "number" ? r?.cooldownDuration : 3e4), Qt(ku, this, typeof r?.cacheMaxAge == "number" ? r?.cacheMaxAge : 6e5), Qt(ma, this, new Headers(r?.headers)), z2 && !he(ma, this).has("User-Agent") && he(ma, this).set("User-Agent", z2), he(ma, this).has("accept") || (he(ma, this).set("accept", "application/json"), he(ma, this).append("accept", "application/jwk-set+json")), Qt(rf, this, r?.[W6]), r?.[Zh] !== void 0 && (Qt(uo, this, r?.[Zh]), n = r?.[Zh], i = he(ku, this), typeof n == "object" && n !== null && "uat" in n && typeof n.uat == "number" && !(Date.now() - n.uat >= i) && "jwks" in n && za(n.jwks) && Array.isArray(n.jwks.keys) && Array.prototype.every.call(n.jwks.keys, za) && (Qt(lo, this, he(uo, this).uat), Qt(co, this, Wg(he(uo, this).jwks))));
  }
  pendingFetch() {
    return !!he(Ui, this);
  }
  coolingDown() {
    return typeof he(lo, this) == "number" && Date.now() < he(lo, this) + he(tf, this);
  }
  fresh() {
    return typeof he(lo, this) == "number" && Date.now() < he(lo, this) + he(ku, this);
  }
  jwks() {
    var t;
    return (t = he(co, this)) === null || t === void 0 ? void 0 : t.jwks();
  }
  async getKey(t, r) {
    he(co, this) && this.fresh() || await this.reload();
    try {
      return await he(co, this).call(this, t, r);
    } catch (n) {
      if (n instanceof dm && this.coolingDown() === !1) return await this.reload(), he(co, this).call(this, t, r);
      throw n;
    }
  }
  async reload() {
    he(Ui, this) && (typeof WebSocketPair < "u" || typeof navigator < "u" && navigator.userAgent === "Cloudflare-Workers" || typeof EdgeRuntime < "u" && EdgeRuntime === "vercel") && Qt(Ui, this, void 0), he(Ui, this) || Qt(Ui, this, (async function(t, r, n) {
      const a = await (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : fetch)(t, { method: "GET", signal: n, redirect: "manual", headers: r }).catch(((o) => {
        throw o.name === "TimeoutError" ? new D6() : o;
      }));
      if (a.status !== 200) throw new Mr("Expected 200 OK from the JSON Web Key Set HTTP response");
      try {
        return await a.json();
      } catch {
        throw new Mr("Failed to parse the JSON Web Key Set HTTP response as JSON");
      }
    })(he(Xh, this).href, he(ma, this), AbortSignal.timeout(he(ef, this)), he(rf, this)).then(((t) => {
      Qt(co, this, Wg(t)), he(uo, this) && (he(uo, this).uat = Date.now(), he(uo, this).jwks = t), Qt(lo, this, Date.now()), Qt(Ui, this, void 0);
    })).catch(((t) => {
      throw Qt(Ui, this, void 0), t;
    }))), await he(Ui, this);
  }
};
const gS = ["mfaToken"], vS = ["mfaToken"];
var ho, _u, fo, _a, Ds, Ot, rd, lr, Kg = class extends Error {
  constructor(t, r) {
    super(r), me(this, "code", void 0), this.name = "NotSupportedError", this.code = t;
  }
}, la = class extends Error {
  constructor(t, r, n) {
    super(r), me(this, "cause", void 0), me(this, "code", void 0), this.code = t, this.cause = n && { error: n.error, error_description: n.error_description, message: n.message };
  }
}, yS = class extends la {
  constructor(t, r) {
    super("token_by_code_error", t, r), this.name = "TokenByCodeError";
  }
}, bS = class extends la {
  constructor(t, r) {
    super("token_by_client_credentials_error", t, r), this.name = "TokenByClientCredentialsError";
  }
}, wS = class extends la {
  constructor(t, r) {
    super("token_by_refresh_token_error", t, r), this.name = "TokenByRefreshTokenError";
  }
}, nf = class extends la {
  constructor(t, r) {
    super("token_for_connection_error", t, r), this.name = "TokenForConnectionErrorCode";
  }
}, ki = class extends la {
  constructor(t, r) {
    super("token_exchange_error", t, r), this.name = "TokenExchangeError";
  }
}, ga = class extends Error {
  constructor(t) {
    super(t), me(this, "code", "verify_logout_token_error"), this.name = "VerifyLogoutTokenError";
  }
}, af = class extends la {
  constructor(t) {
    super("backchannel_authentication_error", "There was an error when trying to use Client-Initiated Backchannel Authentication.", t), me(this, "code", "backchannel_authentication_error"), this.name = "BackchannelAuthenticationError";
  }
}, $S = class extends la {
  constructor(t) {
    super("build_authorization_url_error", "There was an error when trying to build the authorization URL.", t), this.name = "BuildAuthorizationUrlError";
  }
}, kS = class extends la {
  constructor(t) {
    super("build_link_user_url_error", "There was an error when trying to build the Link User URL.", t), this.name = "BuildLinkUserUrlError";
  }
}, _S = class extends la {
  constructor(t) {
    super("build_unlink_user_url_error", "There was an error when trying to build the Unlink User URL.", t), this.name = "BuildUnlinkUserUrlError";
  }
}, xS = class extends Error {
  constructor() {
    super("The client secret or client assertion signing key must be provided."), me(this, "code", "missing_client_auth_error"), this.name = "MissingClientAuthError";
  }
};
function V2(e) {
  return Object.entries(e).filter(((t) => {
    let [, r] = t;
    return r !== void 0;
  })).reduce(((t, r) => Ne(Ne({}, t), {}, { [r[0]]: r[1] })), {});
}
var j1 = class extends Error {
  constructor(t, r, n) {
    super(r), me(this, "cause", void 0), me(this, "code", void 0), this.code = t, this.cause = n && { error: n.error, error_description: n.error_description, message: n.message };
  }
}, K6 = class extends j1 {
  constructor(t, r) {
    super("mfa_list_authenticators_error", t, r), this.name = "MfaListAuthenticatorsError";
  }
}, Q6 = class extends j1 {
  constructor(t, r) {
    super("mfa_enrollment_error", t, r), this.name = "MfaEnrollmentError";
  }
}, ES = class extends j1 {
  constructor(e, t) {
    super("mfa_delete_authenticator_error", e, t), this.name = "MfaDeleteAuthenticatorError";
  }
}, G6 = class extends j1 {
  constructor(t, r) {
    super("mfa_challenge_error", t, r), this.name = "MfaChallengeError";
  }
};
function SS(e) {
  return { id: e.id, authenticatorType: e.authenticator_type, active: e.active, name: e.name, oobChannels: e.oob_channels, type: e.type };
}
var CS = (ho = /* @__PURE__ */ new WeakMap(), _u = /* @__PURE__ */ new WeakMap(), fo = /* @__PURE__ */ new WeakMap(), class {
  constructor(e) {
    var t;
    yr(this, ho, void 0), yr(this, _u, void 0), yr(this, fo, void 0), Qt(ho, this, "https://".concat(e.domain)), Qt(_u, this, e.clientId), Qt(fo, this, (t = e.customFetch) !== null && t !== void 0 ? t : function() {
      return fetch(...arguments);
    });
  }
  async listAuthenticators(e) {
    const t = "".concat(he(ho, this), "/mfa/authenticators"), { mfaToken: r } = e, n = await he(fo, this).call(this, t, { method: "GET", headers: { Authorization: "Bearer ".concat(r), "Content-Type": "application/json" } });
    if (!n.ok) {
      const i = await n.json();
      throw new K6(i.error_description || "Failed to list authenticators", i);
    }
    return (await n.json()).map(SS);
  }
  async enrollAuthenticator(e) {
    const t = "".concat(he(ho, this), "/mfa/associate"), { mfaToken: r } = e, n = Tg(e, gS), i = { authenticator_types: n.authenticatorTypes };
    "oobChannels" in n && (i.oob_channels = n.oobChannels), "phoneNumber" in n && n.phoneNumber && (i.phone_number = n.phoneNumber), "email" in n && n.email && (i.email = n.email);
    const a = await he(fo, this).call(this, t, { method: "POST", headers: { Authorization: "Bearer ".concat(r), "Content-Type": "application/json" }, body: JSON.stringify(i) });
    if (!a.ok) {
      const o = await a.json();
      throw new Q6(o.error_description || "Failed to enroll authenticator", o);
    }
    return (function(o) {
      if (o.authenticator_type === "otp") return { authenticatorType: "otp", secret: o.secret, barcodeUri: o.barcode_uri, recoveryCodes: o.recovery_codes, id: o.id };
      if (o.authenticator_type === "oob") return { authenticatorType: "oob", oobChannel: o.oob_channel, oobCode: o.oob_code, bindingMethod: o.binding_method, id: o.id };
      throw new Error("Unexpected authenticator type: ".concat(o.authenticator_type));
    })(await a.json());
  }
  async deleteAuthenticator(e) {
    const { authenticatorId: t, mfaToken: r } = e, n = "".concat(he(ho, this), "/mfa/authenticators/").concat(encodeURIComponent(t)), i = await he(fo, this).call(this, n, { method: "DELETE", headers: { Authorization: "Bearer ".concat(r), "Content-Type": "application/json" } });
    if (!i.ok) {
      const a = await i.json();
      throw new ES(a.error_description || "Failed to delete authenticator", a);
    }
  }
  async challengeAuthenticator(e) {
    const t = "".concat(he(ho, this), "/mfa/challenge"), { mfaToken: r } = e, n = Tg(e, vS), i = { mfa_token: r, client_id: he(_u, this), challenge_type: n.challengeType };
    n.authenticatorId && (i.authenticator_id = n.authenticatorId);
    const a = await he(fo, this).call(this, t, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(i) });
    if (!a.ok) {
      const o = await a.json();
      throw new G6(o.error_description || "Failed to challenge authenticator", o);
    }
    return (function(o) {
      const s = { challengeType: o.challenge_type };
      return o.oob_code !== void 0 && (s.oobCode = o.oob_code), o.binding_method !== void 0 && (s.bindingMethod = o.binding_method), s;
    })(await a.json());
  }
}), To = class Y6 {
  constructor(t, r, n, i, a, o, s) {
    me(this, "accessToken", void 0), me(this, "idToken", void 0), me(this, "refreshToken", void 0), me(this, "expiresAt", void 0), me(this, "scope", void 0), me(this, "claims", void 0), me(this, "authorizationDetails", void 0), me(this, "tokenType", void 0), me(this, "issuedTokenType", void 0), this.accessToken = t, this.idToken = n, this.refreshToken = i, this.expiresAt = r, this.scope = a, this.claims = o, this.authorizationDetails = s;
  }
  static fromTokenEndpointResponse(t) {
    const r = t.id_token ? t.claims() : void 0, n = new Y6(t.access_token, Math.floor(Date.now() / 1e3) + Number(t.expires_in), t.id_token, t.refresh_token, t.scope, r, t.authorization_details);
    return n.tokenType = t.token_type, n.issuedTokenType = t.issued_token_type, n;
  }
}, U2 = "openid profile email offline_access", TS = Object.freeze(/* @__PURE__ */ new Set(["grant_type", "client_id", "client_secret", "client_assertion", "client_assertion_type", "subject_token", "subject_token_type", "requested_token_type", "actor_token", "actor_token_type", "audience", "aud", "resource", "resources", "resource_indicator", "scope", "connection", "login_hint", "organization", "assertion"]));
function J6(e) {
  if (e == null) throw new ki("subject_token is required");
  if (typeof e != "string") throw new ki("subject_token must be a string");
  if (e.trim().length === 0) throw new ki("subject_token cannot be blank or whitespace");
  if (e !== e.trim()) throw new ki("subject_token must not include leading or trailing whitespace");
  if (/^bearer\s+/i.test(e)) throw new ki("subject_token must not include the 'Bearer ' prefix");
}
function Z6(e, t) {
  if (t) {
    for (const [r, n] of Object.entries(t)) if (!TS.has(r)) if (Array.isArray(n)) {
      if (n.length > 20) throw new ki("Parameter '".concat(r, "' exceeds maximum array size of ").concat(20));
      n.forEach(((i) => {
        e.append(r, i);
      }));
    } else e.append(r, n);
  }
}
var AS = (_a = /* @__PURE__ */ new WeakMap(), Ds = /* @__PURE__ */ new WeakMap(), Ot = /* @__PURE__ */ new WeakMap(), rd = /* @__PURE__ */ new WeakMap(), lr = /* @__PURE__ */ new WeakSet(), class {
  constructor(e) {
    if ((function(t, r) {
      v6(t, r), r.add(t);
    })(this, lr), yr(this, _a, void 0), yr(this, Ds, void 0), yr(this, Ot, void 0), yr(this, rd, void 0), me(this, "mfa", void 0), Qt(Ot, this, e), e.useMtls && !e.customFetch) throw new Kg("mtls_without_custom_fetch_not_supported", "Using mTLS without a custom fetch implementation is not supported");
    this.mfa = new CS({ domain: he(Ot, this).domain, clientId: he(Ot, this).clientId, customFetch: he(Ot, this).customFetch });
  }
  async buildAuthorizationUrl(e) {
    const { serverMetadata: t } = await hr(lr, this, Dn).call(this);
    if (e != null && e.pushedAuthorizationRequests && !t.pushed_authorization_request_endpoint) throw new Kg("par_not_supported_error", "The Auth0 tenant does not have pushed authorization requests enabled. Learn how to enable it here: https://auth0.com/docs/get-started/applications/configure-par");
    try {
      return await hr(lr, this, of).call(this, e);
    } catch (r) {
      throw new $S(r);
    }
  }
  async buildLinkUserUrl(e) {
    try {
      const t = await hr(lr, this, of).call(this, { authorizationParams: Ne(Ne({}, e.authorizationParams), {}, { requested_connection: e.connection, requested_connection_scope: e.connectionScope, scope: "openid link_account offline_access", id_token_hint: e.idToken }) });
      return { linkUserUrl: t.authorizationUrl, codeVerifier: t.codeVerifier };
    } catch (t) {
      throw new kS(t);
    }
  }
  async buildUnlinkUserUrl(e) {
    try {
      const t = await hr(lr, this, of).call(this, { authorizationParams: Ne(Ne({}, e.authorizationParams), {}, { requested_connection: e.connection, scope: "openid unlink_account", id_token_hint: e.idToken }) });
      return { unlinkUserUrl: t.authorizationUrl, codeVerifier: t.codeVerifier };
    } catch (t) {
      throw new _S(t);
    }
  }
  async backchannelAuthentication(e) {
    const { configuration: t, serverMetadata: r } = await hr(lr, this, Dn).call(this), n = V2(Ne(Ne({}, he(Ot, this).authorizationParams), e?.authorizationParams)), i = new URLSearchParams(Ne(Ne({ scope: U2 }, n), {}, { client_id: he(Ot, this).clientId, binding_message: e.bindingMessage, login_hint: JSON.stringify({ format: "iss_sub", iss: r.issuer, sub: e.loginHint.sub }) }));
    e.requestedExpiry && i.append("requested_expiry", e.requestedExpiry.toString()), e.authorizationDetails && i.append("authorization_details", JSON.stringify(e.authorizationDetails));
    try {
      const a = await Vg(t, i), o = await V6(t, a);
      return To.fromTokenEndpointResponse(o);
    } catch (a) {
      throw new af(a);
    }
  }
  async initiateBackchannelAuthentication(e) {
    const { configuration: t, serverMetadata: r } = await hr(lr, this, Dn).call(this), n = V2(Ne(Ne({}, he(Ot, this).authorizationParams), e?.authorizationParams)), i = new URLSearchParams(Ne(Ne({ scope: U2 }, n), {}, { client_id: he(Ot, this).clientId, binding_message: e.bindingMessage, login_hint: JSON.stringify({ format: "iss_sub", iss: r.issuer, sub: e.loginHint.sub }) }));
    e.requestedExpiry && i.append("requested_expiry", e.requestedExpiry.toString()), e.authorizationDetails && i.append("authorization_details", JSON.stringify(e.authorizationDetails));
    try {
      const a = await Vg(t, i);
      return { authReqId: a.auth_req_id, expiresIn: a.expires_in, interval: a.interval };
    } catch (a) {
      throw new af(a);
    }
  }
  async backchannelAuthenticationGrant(e) {
    let { authReqId: t } = e;
    const { configuration: r } = await hr(lr, this, Dn).call(this), n = new URLSearchParams({ auth_req_id: t });
    try {
      const i = await cm(r, "urn:openid:params:grant-type:ciba", n);
      return To.fromTokenEndpointResponse(i);
    } catch (i) {
      throw new af(i);
    }
  }
  async getTokenForConnection(e) {
    var t;
    if (e.refreshToken && e.accessToken) throw new nf("Either a refresh or access token should be specified, but not both.");
    const r = (t = e.accessToken) !== null && t !== void 0 ? t : e.refreshToken;
    if (!r) throw new nf("Either a refresh or access token must be specified.");
    try {
      return await this.exchangeToken({ connection: e.connection, subjectToken: r, subjectTokenType: e.accessToken ? "urn:ietf:params:oauth:token-type:access_token" : "urn:ietf:params:oauth:token-type:refresh_token", loginHint: e.loginHint });
    } catch (n) {
      throw n instanceof ki ? new nf(n.message, n.cause) : n;
    }
  }
  async exchangeToken(e) {
    return "connection" in e ? hr(lr, this, OS).call(this, e) : hr(lr, this, PS).call(this, e);
  }
  async getTokenByCode(e, t) {
    const { configuration: r } = await hr(lr, this, Dn).call(this);
    try {
      const n = await U6(r, e, { pkceCodeVerifier: t.codeVerifier });
      return To.fromTokenEndpointResponse(n);
    } catch (n) {
      throw new yS("There was an error while trying to request a token.", n);
    }
  }
  async getTokenByRefreshToken(e) {
    const { configuration: t } = await hr(lr, this, Dn).call(this);
    try {
      const r = await q6(t, e.refreshToken);
      return To.fromTokenEndpointResponse(r);
    } catch (r) {
      throw new wS("The access token has expired and there was an error while trying to refresh it.", r);
    }
  }
  async getTokenByClientCredentials(e) {
    const { configuration: t } = await hr(lr, this, Dn).call(this);
    try {
      const r = new URLSearchParams({ audience: e.audience });
      e.organization && r.append("organization", e.organization);
      const n = await B6(t, r);
      return To.fromTokenEndpointResponse(n);
    } catch (r) {
      throw new bS("There was an error while trying to request a token.", r);
    }
  }
  async buildLogoutUrl(e) {
    const { configuration: t, serverMetadata: r } = await hr(lr, this, Dn).call(this);
    if (!r.end_session_endpoint) {
      const n = new URL("https://".concat(he(Ot, this).domain, "/v2/logout"));
      return n.searchParams.set("returnTo", e.returnTo), n.searchParams.set("client_id", he(Ot, this).clientId), n;
    }
    return (function(n, i) {
      sa(n);
      const { as: a, c: o, tlsOnly: s } = Dr(n), l = Rc(a, "end_session_endpoint", !1, s);
      (i = new URLSearchParams(i)).has("client_id") || i.set("client_id", o.client_id);
      for (const [d, c] of i.entries()) l.searchParams.append(d, c);
      return l;
    })(t, { post_logout_redirect_uri: e.returnTo });
  }
  async verifyLogoutToken(e) {
    const { serverMetadata: t } = await hr(lr, this, Dn).call(this);
    he(rd, this) || Qt(rd, this, (function(n, i) {
      const a = new mS(n, i), o = async (s, l) => a.getKey(s, l);
      return Object.defineProperties(o, { coolingDown: { get: () => a.coolingDown(), enumerable: !0, configurable: !1 }, fresh: { get: () => a.fresh(), enumerable: !0, configurable: !1 }, reload: { value: () => a.reload(), enumerable: !0, configurable: !1, writable: !1 }, reloading: { get: () => a.pendingFetch(), enumerable: !0, configurable: !1 }, jwks: { value: () => a.jwks(), enumerable: !0, configurable: !1, writable: !1 } }), o;
    })(new URL(t.jwks_uri), { [W6]: he(Ot, this).customFetch }));
    const { payload: r } = await hS(e.logoutToken, he(rd, this), { issuer: t.issuer, audience: he(Ot, this).clientId, algorithms: ["RS256"], requiredClaims: ["iat"] });
    if (!("sid" in r) && !("sub" in r)) throw new ga('either "sid" or "sub" (or both) claims must be present');
    if ("sid" in r && typeof r.sid != "string") throw new ga('"sid" claim must be a string');
    if ("sub" in r && typeof r.sub != "string") throw new ga('"sub" claim must be a string');
    if ("nonce" in r) throw new ga('"nonce" claim is prohibited');
    if (!("events" in r)) throw new ga('"events" claim is missing');
    if (typeof r.events != "object" || r.events === null) throw new ga('"events" claim must be an object');
    if (!("http://schemas.openid.net/event/backchannel-logout" in r.events)) throw new ga('"http://schemas.openid.net/event/backchannel-logout" member is missing in the "events" claim');
    if (typeof r.events["http://schemas.openid.net/event/backchannel-logout"] != "object") throw new ga('"http://schemas.openid.net/event/backchannel-logout" member in the "events" claim must be an object');
    return { sid: r.sid, sub: r.sub };
  }
});
async function Dn() {
  if (he(_a, this) && he(Ds, this)) return { configuration: he(_a, this), serverMetadata: he(Ds, this) };
  const e = await hr(lr, this, IS).call(this);
  return Qt(_a, this, await aS(new URL("https://".concat(he(Ot, this).domain)), he(Ot, this).clientId, { use_mtls_endpoint_aliases: he(Ot, this).useMtls }, e, { [Da]: he(Ot, this).customFetch })), Qt(Ds, this, he(_a, this).serverMetadata()), he(_a, this)[Da] = he(Ot, this).customFetch || fetch, { configuration: he(_a, this), serverMetadata: he(Ds, this) };
}
async function OS(e) {
  var t, r;
  const { configuration: n } = await hr(lr, this, Dn).call(this);
  if ("audience" in e || "resource" in e) throw new ki("audience and resource parameters are not supported for Token Vault exchanges");
  J6(e.subjectToken);
  const i = new URLSearchParams({ connection: e.connection, subject_token: e.subjectToken, subject_token_type: (t = e.subjectTokenType) !== null && t !== void 0 ? t : "urn:ietf:params:oauth:token-type:access_token", requested_token_type: (r = e.requestedTokenType) !== null && r !== void 0 ? r : "http://auth0.com/oauth/token-type/federated-connection-access-token" });
  e.loginHint && i.append("login_hint", e.loginHint), e.scope && i.append("scope", e.scope), Z6(i, e.extra);
  try {
    const a = await cm(n, "urn:auth0:params:oauth:grant-type:token-exchange:federated-connection-access-token", i);
    return To.fromTokenEndpointResponse(a);
  } catch (a) {
    throw new ki("Failed to exchange token for connection '".concat(e.connection, "'."), a);
  }
}
async function PS(e) {
  const { configuration: t } = await hr(lr, this, Dn).call(this);
  J6(e.subjectToken);
  const r = new URLSearchParams({ subject_token_type: e.subjectTokenType, subject_token: e.subjectToken });
  e.audience && r.append("audience", e.audience), e.scope && r.append("scope", e.scope), e.requestedTokenType && r.append("requested_token_type", e.requestedTokenType), e.organization && r.append("organization", e.organization), Z6(r, e.extra);
  try {
    const n = await cm(t, "urn:ietf:params:oauth:grant-type:token-exchange", r);
    return To.fromTokenEndpointResponse(n);
  } catch (n) {
    throw new ki("Failed to exchange token of type '".concat(e.subjectTokenType, "'").concat(e.audience ? " for audience '".concat(e.audience, "'") : "", "."), n);
  }
}
async function IS() {
  if (!he(Ot, this).clientSecret && !he(Ot, this).clientAssertionSigningKey && !he(Ot, this).useMtls) throw new xS();
  if (he(Ot, this).useMtls) return (t, r, n, i) => {
    n.set("client_id", r.client_id);
  };
  let e = he(Ot, this).clientAssertionSigningKey;
  return !e || e instanceof CryptoKey || (e = await (async function(t, r, n) {
    if (typeof t != "string" || t.indexOf("-----BEGIN PRIVATE KEY-----") !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return eS(t, r, n);
  })(e, he(Ot, this).clientAssertionSigningAlg || "RS256")), e ? (function(t, r) {
    return CE(t);
  })(e) : F6(he(Ot, this).clientSecret);
}
async function of(e) {
  const { configuration: t } = await hr(lr, this, Dn).call(this), r = iS(), n = await nS(r), i = V2(Ne(Ne({}, he(Ot, this).authorizationParams), e?.authorizationParams)), a = new URLSearchParams(Ne(Ne({ scope: U2 }, i), {}, { client_id: he(Ot, this).clientId, code_challenge: n, code_challenge_method: "S256" }));
  return { authorizationUrl: e != null && e.pushedAuthorizationRequests ? await H6(t, a) : await j2(t, a), codeVerifier: r };
}
let qc = class q2 extends Gt {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, q2.prototype);
  }
  static fromPayload(t) {
    let { error: r, error_description: n } = t;
    return new q2(r, n);
  }
};
class U0 extends qc {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, U0.prototype);
  }
}
class um extends qc {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, um.prototype);
  }
}
let DS = class X6 extends qc {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, X6.prototype);
  }
}, xu = class e8 extends qc {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, e8.prototype);
  }
}, NS = class t8 extends qc {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, t8.prototype);
  }
}, MS = class {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 6e5;
    this.contexts = /* @__PURE__ */ new Map(), this.ttlMs = t;
  }
  set(t, r) {
    this.cleanup(), this.contexts.set(t, Object.assign(Object.assign({}, r), { createdAt: Date.now() }));
  }
  get(t) {
    const r = this.contexts.get(t);
    if (r) {
      if (!(Date.now() - r.createdAt > this.ttlMs)) return r;
      this.contexts.delete(t);
    }
  }
  remove(t) {
    this.contexts.delete(t);
  }
  cleanup() {
    const t = Date.now();
    for (const [r, n] of this.contexts) t - n.createdAt > this.ttlMs && this.contexts.delete(r);
  }
  get size() {
    return this.contexts.size;
  }
}, RS = class {
  constructor(t, r) {
    this.authJsMfaClient = t, this.auth0Client = r, this.contextManager = new MS();
  }
  setMFAAuthDetails(t, r, n, i) {
    this.contextManager.set(t, { scope: r, audience: n, mfaRequirements: i });
  }
  async getAuthenticators(t) {
    var r, n;
    const i = this.contextManager.get(t);
    if (!(!((r = i?.mfaRequirements) === null || r === void 0) && r.challenge) || i.mfaRequirements.challenge.length === 0) throw new U0("invalid_request", "challengeType is required and must contain at least one challenge type, please check mfa_required error payload");
    const a = i.mfaRequirements.challenge.map(((o) => o.type));
    try {
      return (await this.authJsMfaClient.listAuthenticators({ mfaToken: t })).filter(((o) => !!o.type && a.includes(o.type)));
    } catch (o) {
      throw o instanceof K6 ? new U0((n = o.cause) === null || n === void 0 ? void 0 : n.error, o.message) : o;
    }
  }
  async enroll(t) {
    var r;
    const n = (function(i) {
      const a = gE[i.factorType];
      return Object.assign(Object.assign(Object.assign({ mfaToken: i.mfaToken, authenticatorTypes: a.authenticatorTypes }, a.oobChannels && { oobChannels: a.oobChannels }), "phoneNumber" in i && { phoneNumber: i.phoneNumber }), "email" in i && { email: i.email });
    })(t);
    try {
      return await this.authJsMfaClient.enrollAuthenticator(n);
    } catch (i) {
      throw i instanceof Q6 ? new um((r = i.cause) === null || r === void 0 ? void 0 : r.error, i.message) : i;
    }
  }
  async challenge(t) {
    var r;
    try {
      const n = { challengeType: t.challengeType, mfaToken: t.mfaToken };
      return t.authenticatorId && (n.authenticatorId = t.authenticatorId), await this.authJsMfaClient.challengeAuthenticator(n);
    } catch (n) {
      throw n instanceof G6 ? new DS((r = n.cause) === null || r === void 0 ? void 0 : r.error, n.message) : n;
    }
  }
  async getEnrollmentFactors(t) {
    const r = this.contextManager.get(t);
    if (!r || !r.mfaRequirements) throw new NS("mfa_context_not_found", "MFA context not found for this MFA token. Please retry the original request to get a new MFA token.");
    return r.mfaRequirements.enroll && r.mfaRequirements.enroll.length !== 0 ? r.mfaRequirements.enroll : [];
  }
  async verify(t) {
    const r = this.contextManager.get(t.mfaToken);
    if (!r) throw new xu("mfa_context_not_found", "MFA context not found for this MFA token. Please retry the original request to get a new MFA token.");
    const n = (function(o) {
      return "otp" in o && o.otp ? vE : "oobCode" in o && o.oobCode ? yE : "recoveryCode" in o && o.recoveryCode ? bE : void 0;
    })(t);
    if (!n) throw new xu("invalid_request", "Unable to determine grant type. Provide one of: otp, oobCode, or recoveryCode.");
    const i = r.scope, a = r.audience;
    try {
      const o = await this.auth0Client._requestTokenForMfa({ grant_type: n, mfaToken: t.mfaToken, scope: i, audience: a, otp: t.otp, oob_code: t.oobCode, binding_code: t.bindingCode, recovery_code: t.recoveryCode });
      return this.contextManager.remove(t.mfaToken), o;
    } catch (o) {
      if (o instanceof D0) this.setMFAAuthDetails(o.mfa_token, i, a, o.mfa_requirements);
      else if (o instanceof xu) throw new xu(o.error, o.error_description);
      throw o;
    }
  }
}, LS = class {
  constructor(t) {
    let r, n;
    if (this.userCache = new u6().enclosedCache, this.defaultOptions = { authorizationParams: { scope: "openid profile email" }, useRefreshTokensFallback: !1, useFormData: !0 }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), t), { authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), t.authorizationParams) }), typeof window < "u" && (() => {
      if (!M0()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
      if (M0().subtle === void 0) throw new Error(`
      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.
    `);
    })(), this.lockManager = (Fh || (Fh = Mx()), Fh), t.cache && t.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), t.cache) n = t.cache;
    else {
      if (r = t.cacheLocation || "memory", !_g(r)) throw new Error('Invalid cache location "'.concat(r, '"'));
      n = _g(r)();
    }
    var i;
    this.httpTimeoutMs = t.httpTimeoutInSeconds ? 1e3 * t.httpTimeoutInSeconds : 1e4, this.cookieStorage = t.legacySameSiteCookie === !1 ? ws : oE, this.orgHintCookieName = (i = this.options.clientId, "auth0.".concat(i, ".organization_hint")), this.isAuthenticatedCookieName = ((d) => "auth0.".concat(d, ".is.authenticated"))(this.options.clientId), this.sessionCheckExpiryDays = t.sessionCheckExpiryDays || 1;
    const a = t.useCookiesForTransactions ? this.cookieStorage : sE;
    var o;
    this.scope = (function(d, c) {
      for (var u = arguments.length, h = new Array(u > 2 ? u - 2 : 0), f = 2; f < u; f++) h[f - 2] = arguments[f];
      if (typeof d != "object") return { default: r0(c, d, ...h) };
      let p = { default: r0(c, ...h) };
      return Object.keys(d).forEach(((m) => {
        const y = d[m];
        p[m] = r0(c, y, ...h);
      })), p;
    })(this.options.authorizationParams.scope, "openid", this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new eE(a, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || W7, this.cacheManager = new Xx(n, n.allKeys ? void 0 : new cE(n, this.options.clientId), this.nowProvider), this.dpop = this.options.useDpop ? new fE(this.options.clientId) : void 0, this.domainUrl = (o = this.options.domain, /^https?:\/\//.test(o) ? o : "https://".concat(o)), this.tokenIssuer = ((d, c) => d ? d.startsWith("https://") ? d : "https://".concat(d, "/") : "".concat(c, "/"))(this.options.issuer, this.domainUrl);
    const s = "".concat(this.domainUrl, "/me/"), l = this.createFetcher(Object.assign(Object.assign({}, this.options.useDpop && { dpopNonceId: "__auth0_my_account_api__" }), { getAccessToken: () => this.getTokenSilently({ authorizationParams: { scope: "create:me:connected_accounts", audience: s }, detailedResponse: !0 }) }));
    this.myAccountApi = new mE(l, s), this.authJsClient = new AS({ domain: this.options.domain, clientId: this.options.clientId }), this.mfa = new RS(this.authJsClient.mfa, this), typeof window < "u" && window.Worker && this.options.useRefreshTokens && r === "memory" && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new dE());
  }
  getConfiguration() {
    return Object.freeze({ domain: this.options.domain, clientId: this.options.clientId });
  }
  _url(t) {
    const r = this.options.auth0Client || H7, n = a6(r, !0), i = encodeURIComponent(btoa(JSON.stringify(n)));
    return "".concat(this.domainUrl).concat(t, "&auth0Client=").concat(i);
  }
  _authorizeUrl(t) {
    return this._url("/authorize?".concat(E2(t)));
  }
  async _verifyIdToken(t, r, n) {
    const i = await this.nowProvider();
    return rE({ iss: this.tokenIssuer, aud: this.options.clientId, id_token: t, nonce: r, organization: n, leeway: this.options.leeway, max_age: (a = this.options.authorizationParams.max_age, typeof a != "string" ? a : parseInt(a, 10) || void 0), now: i });
    var a;
  }
  _processOrgHint(t) {
    t ? this.cookieStorage.save(this.orgHintCookieName, t, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }) : this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain });
  }
  async _prepareAuthorizeUrl(t, r, n) {
    var i;
    const a = Mh(Zl()), o = Mh(Zl()), s = Zl(), l = await gg(s), d = yg(l), c = await ((i = this.dpop) === null || i === void 0 ? void 0 : i.calculateThumbprint()), u = ((f, p, m, y, g, w, $, _, x) => Object.assign(Object.assign(Object.assign({ client_id: f.clientId }, f.authorizationParams), m), { scope: gu(p, m.scope, m.audience), response_type: "code", response_mode: _ || "query", state: y, nonce: g, redirect_uri: $ || f.authorizationParams.redirect_uri, code_challenge: w, code_challenge_method: "S256", dpop_jkt: x }))(this.options, this.scope, t, a, o, d, t.redirect_uri || this.options.authorizationParams.redirect_uri || n, r?.response_mode, c), h = this._authorizeUrl(u);
    return { nonce: o, code_verifier: s, scope: u.scope, audience: u.audience || "default", redirect_uri: u.redirect_uri, state: a, url: h };
  }
  async loginWithPopup(t, r) {
    var n;
    if (t = t || {}, !(r = r || {}).popup && (r.popup = ((s) => {
      const l = window.screenX + (window.innerWidth - 400) / 2, d = window.screenY + (window.innerHeight - 600) / 2;
      return window.open(s, "auth0:authorize:popup", "left=".concat(l, ",top=").concat(d, ",width=").concat(400, ",height=").concat(600, ",resizable,scrollbars=yes,status=1"));
    })(""), !r.popup)) throw new Cx();
    const i = await this._prepareAuthorizeUrl(t.authorizationParams || {}, { response_mode: "web_message" }, window.location.origin);
    r.popup.location.href = i.url;
    const a = await ((s) => new Promise(((l, d) => {
      let c;
      const u = setInterval((() => {
        s.popup && s.popup.closed && (clearInterval(u), clearTimeout(h), window.removeEventListener("message", c, !1), d(new Sx(s.popup)));
      }), 1e3), h = setTimeout((() => {
        clearInterval(u), d(new Ex(s.popup)), window.removeEventListener("message", c, !1);
      }), 1e3 * (s.timeoutInSeconds || 60));
      c = function(f) {
        if (f.data && f.data.type === "authorization_response") {
          if (clearTimeout(h), clearInterval(u), window.removeEventListener("message", c, !1), s.closePopup !== !1 && s.popup.close(), f.data.response.error) return d(Gt.fromPayload(f.data.response));
          l(f.data.response);
        }
      }, window.addEventListener("message", c);
    })))(Object.assign(Object.assign({}, r), { timeoutInSeconds: r.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60 }));
    if (i.state !== a.state) throw new Gt("state_mismatch", "Invalid state");
    const o = ((n = t.authorizationParams) === null || n === void 0 ? void 0 : n.organization) || this.options.authorizationParams.organization;
    await this._requestToken({ audience: i.audience, scope: i.scope, code_verifier: i.code_verifier, grant_type: "authorization_code", code: a.code, redirect_uri: i.redirect_uri }, { nonceIn: i.nonce, organization: o });
  }
  async getUser() {
    var t;
    const r = await this._getIdTokenFromCache();
    return (t = r?.decodedToken) === null || t === void 0 ? void 0 : t.user;
  }
  async getIdTokenClaims() {
    var t;
    const r = await this._getIdTokenFromCache();
    return (t = r?.decodedToken) === null || t === void 0 ? void 0 : t.claims;
  }
  async loginWithRedirect() {
    var t;
    const r = xg(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}), { openUrl: n, fragment: i, appState: a } = r, o = Wn(r, ["openUrl", "fragment", "appState"]), s = ((t = o.authorizationParams) === null || t === void 0 ? void 0 : t.organization) || this.options.authorizationParams.organization, l = await this._prepareAuthorizeUrl(o.authorizationParams || {}), { url: d } = l, c = Wn(l, ["url"]);
    this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, c), { appState: a, response_type: Co.Code }), s && { organization: s }));
    const u = i ? "".concat(d, "#").concat(i) : d;
    n ? await n(u) : window.location.assign(u);
  }
  async handleRedirectCallback() {
    const t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location.href).split("?").slice(1);
    if (t.length === 0) throw new Error("There are no query params available for parsing.");
    const r = this.transactionManager.get();
    if (!r) throw new Gt("missing_transaction", "Invalid state");
    this.transactionManager.remove();
    const n = ((i) => {
      i.indexOf("#") > -1 && (i = i.substring(0, i.indexOf("#")));
      const a = new URLSearchParams(i);
      return { state: a.get("state"), code: a.get("code") || void 0, connect_code: a.get("connect_code") || void 0, error: a.get("error") || void 0, error_description: a.get("error_description") || void 0 };
    })(t.join(""));
    return r.response_type === Co.ConnectCode ? this._handleConnectAccountRedirectCallback(n, r) : this._handleLoginRedirectCallback(n, r);
  }
  async _handleLoginRedirectCallback(t, r) {
    const { code: n, state: i, error: a, error_description: o } = t;
    if (a) throw new _x(a, o || a, i, r.appState);
    if (!r.code_verifier || r.state && r.state !== i) throw new Gt("state_mismatch", "Invalid state");
    const s = r.organization, l = r.nonce, d = r.redirect_uri;
    return await this._requestToken(Object.assign({ audience: r.audience, scope: r.scope, code_verifier: r.code_verifier, grant_type: "authorization_code", code: n }, d ? { redirect_uri: d } : {}), { nonceIn: l, organization: s }), { appState: r.appState, response_type: Co.Code };
  }
  async _handleConnectAccountRedirectCallback(t, r) {
    const { connect_code: n, state: i, error: a, error_description: o } = t;
    if (a) throw new xx(a, o || a, r.connection, i, r.appState);
    if (!n) throw new Gt("missing_connect_code", "Missing connect code");
    if (!(r.code_verifier && r.state && r.auth_session && r.redirect_uri && r.state === i)) throw new Gt("state_mismatch", "Invalid state");
    const s = await this.myAccountApi.completeAccount({ auth_session: r.auth_session, connect_code: n, redirect_uri: r.redirect_uri, code_verifier: r.code_verifier });
    return Object.assign(Object.assign({}, s), { appState: r.appState, response_type: Co.ConnectCode });
  }
  async checkSession(t) {
    if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
      if (!this.cookieStorage.get("auth0.is.authenticated")) return;
      this.cookieStorage.save(this.isAuthenticatedCookieName, !0, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove("auth0.is.authenticated");
    }
    try {
      await this.getTokenSilently(t);
    } catch {
    }
  }
  async getTokenSilently() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var r, n;
    const i = Object.assign(Object.assign({ cacheMode: "on" }, t), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), t.authorizationParams), { scope: gu(this.scope, (r = t.authorizationParams) === null || r === void 0 ? void 0 : r.scope, ((n = t.authorizationParams) === null || n === void 0 ? void 0 : n.audience) || this.options.authorizationParams.audience) }) }), a = await ((o, s) => {
      let l = zh[s];
      return l || (l = o().finally((() => {
        delete zh[s], l = null;
      })), zh[s] = l), l;
    })((() => this._getTokenSilently(i)), "".concat(this.options.clientId, "::").concat(i.authorizationParams.audience, "::").concat(i.authorizationParams.scope));
    return t.detailedResponse ? a : a?.access_token;
  }
  async _getTokenSilently(t) {
    const { cacheMode: r } = t, n = Wn(t, ["cacheMode"]);
    if (r !== "off") {
      const s = await this._getEntryFromCache({ scope: n.authorizationParams.scope, audience: n.authorizationParams.audience || "default", clientId: this.options.clientId, cacheMode: r });
      if (s) return s;
    }
    if (r === "cache-only") return;
    const i = (a = this.options.clientId, o = n.authorizationParams.audience || "default", "".concat("auth0.lock.getTokenSilently", ".").concat(a, ".").concat(o));
    var a, o;
    try {
      return await this.lockManager.runWithLock(i, 5e3, (async () => {
        if (r !== "off") {
          const f = await this._getEntryFromCache({ scope: n.authorizationParams.scope, audience: n.authorizationParams.audience || "default", clientId: this.options.clientId });
          if (f) return f;
        }
        const s = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(n) : await this._getTokenFromIFrame(n), { id_token: l, token_type: d, access_token: c, oauthTokenScope: u, expires_in: h } = s;
        return Object.assign(Object.assign({ id_token: l, token_type: d, access_token: c }, u ? { scope: u } : null), { expires_in: h });
      }));
    } catch (s) {
      if (this._isInteractiveError(s) && this.options.interactiveErrorHandler === "popup") return await this._handleInteractiveErrorWithPopup(n);
      throw s;
    }
  }
  _isInteractiveError(t) {
    return t instanceof D0 || t instanceof Gt && this._isIframeMfaError(t);
  }
  _isIframeMfaError(t) {
    return t.error === "login_required" && t.error_description === "Multifactor authentication required";
  }
  async _handleInteractiveErrorWithPopup(t) {
    try {
      await this.loginWithPopup({ authorizationParams: t.authorizationParams });
      const r = await this._getEntryFromCache({ scope: t.authorizationParams.scope, audience: t.authorizationParams.audience || "default", clientId: this.options.clientId });
      if (!r) throw new Gt("interactive_handler_cache_miss", "Token not found in cache after interactive authentication");
      return r;
    } catch (r) {
      throw r;
    }
  }
  async getTokenWithPopup() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var n, i;
    const a = Object.assign(Object.assign({}, t), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), t.authorizationParams), { scope: gu(this.scope, (n = t.authorizationParams) === null || n === void 0 ? void 0 : n.scope, ((i = t.authorizationParams) === null || i === void 0 ? void 0 : i.audience) || this.options.authorizationParams.audience) }) });
    return r = Object.assign(Object.assign({}, kx), r), await this.loginWithPopup(a, r), (await this.cacheManager.get(new Qi({ scope: a.authorizationParams.scope, audience: a.authorizationParams.audience || "default", clientId: this.options.clientId }), void 0, this.options.useMrrt)).access_token;
  }
  async isAuthenticated() {
    return !!await this.getUser();
  }
  _buildLogoutUrl(t) {
    t.clientId !== null ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
    const r = t.logoutParams || {}, { federated: n } = r, i = Wn(r, ["federated"]), a = n ? "&federated" : "";
    return this._url("/v2/logout?".concat(E2(Object.assign({ clientId: t.clientId }, i)))) + a;
  }
  async logout() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var r;
    const n = xg(t), { openUrl: i } = n, a = Wn(n, ["openUrl"]);
    t.clientId === null ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove(this.isAuthenticatedCookieName, { cookieDomain: this.options.cookieDomain }), this.userCache.remove("@@user@@"), await ((r = this.dpop) === null || r === void 0 ? void 0 : r.clear());
    const o = this._buildLogoutUrl(a);
    i ? await i(o) : i !== !1 && window.location.assign(o);
  }
  async _getTokenFromIFrame(t) {
    const r = (n = this.options.clientId, "".concat("auth0.lock.getTokenFromIFrame", ".").concat(n));
    var n;
    try {
      return await this.lockManager.runWithLock(r, 5e3, (async () => {
        const i = Object.assign(Object.assign({}, t.authorizationParams), { prompt: "none" }), a = this.cookieStorage.get(this.orgHintCookieName);
        a && !i.organization && (i.organization = a);
        const { url: o, state: s, nonce: l, code_verifier: d, redirect_uri: c, scope: u, audience: h } = await this._prepareAuthorizeUrl(i, { response_mode: "web_message" }, window.location.origin);
        if (window.crossOriginIsolated) throw new Gt("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
        const f = t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds;
        let p;
        try {
          p = new URL(this.domainUrl).origin;
        } catch {
          p = this.domainUrl;
        }
        const m = await (function(g, w) {
          let $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 60;
          return new Promise(((_, x) => {
            const S = window.document.createElement("iframe");
            S.setAttribute("width", "0"), S.setAttribute("height", "0"), S.style.display = "none";
            const T = () => {
              window.document.body.contains(S) && (window.document.body.removeChild(S), window.removeEventListener("message", I, !1));
            };
            let I;
            const M = setTimeout((() => {
              x(new M1()), T();
            }), 1e3 * $);
            I = function(P) {
              if (P.origin != w || !P.data || P.data.type !== "authorization_response") return;
              const O = P.source;
              O && O.close(), P.data.response.error ? x(Gt.fromPayload(P.data.response)) : _(P.data.response), clearTimeout(M), window.removeEventListener("message", I, !1), setTimeout(T, 2e3);
            }, window.addEventListener("message", I, !1), window.document.body.appendChild(S), S.setAttribute("src", g);
          }));
        })(o, p, f);
        if (s !== m.state) throw new Gt("state_mismatch", "Invalid state");
        const y = await this._requestToken(Object.assign(Object.assign({}, t.authorizationParams), { code_verifier: d, code: m.code, grant_type: "authorization_code", redirect_uri: c, timeout: t.authorizationParams.timeout || this.httpTimeoutMs }), { nonceIn: l, organization: i.organization });
        return Object.assign(Object.assign({}, y), { scope: u, oauthTokenScope: y.scope, audience: h });
      }));
    } catch (i) {
      throw i.error === "login_required" && (i instanceof Gt && this._isIframeMfaError(i) && this.options.interactiveErrorHandler === "popup" || this.logout({ openUrl: !1 })), i;
    }
  }
  async _getTokenUsingRefreshToken(t) {
    var r, n;
    const i = await this.cacheManager.get(new Qi({ scope: t.authorizationParams.scope, audience: t.authorizationParams.audience || "default", clientId: this.options.clientId }), void 0, this.options.useMrrt);
    if (!(i && i.refresh_token || this.worker)) {
      if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(t);
      throw new e6(t.authorizationParams.audience || "default", t.authorizationParams.scope);
    }
    const a = t.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o = typeof t.timeoutInSeconds == "number" ? 1e3 * t.timeoutInSeconds : null, s = ((h, f, p, m) => {
      var y;
      if (h && p && m) {
        if (f.audience !== p) return f.scope;
        const g = m.split(" "), w = ((y = f.scope) === null || y === void 0 ? void 0 : y.split(" ")) || [], $ = w.every(((_) => g.includes(_)));
        return g.length >= w.length && $ ? m : f.scope;
      }
      return f.scope;
    })(this.options.useMrrt, t.authorizationParams, i?.audience, i?.scope);
    try {
      const h = await this._requestToken(Object.assign(Object.assign(Object.assign({}, t.authorizationParams), { grant_type: "refresh_token", refresh_token: i && i.refresh_token, redirect_uri: a }), o && { timeout: o }), { scopesToRequest: s });
      if (h.refresh_token && i?.refresh_token && await this.cacheManager.updateEntry(i.refresh_token, h.refresh_token), this.options.useMrrt && (l = i?.audience, d = i?.scope, c = t.authorizationParams.audience, u = t.authorizationParams.scope, (l !== c || !Eg(u, d)) && !Eg(s, h.scope))) {
        if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(t);
        await this.cacheManager.remove(this.options.clientId, t.authorizationParams.audience, t.authorizationParams.scope);
        const f = ((p, m) => {
          const y = p?.split(" ") || [], g = m?.split(" ") || [];
          return y.filter(((w) => g.indexOf(w) == -1)).join(",");
        })(s, h.scope);
        throw new Tx(t.authorizationParams.audience || "default", f);
      }
      return Object.assign(Object.assign({}, h), { scope: t.authorizationParams.scope, oauthTokenScope: h.scope, audience: t.authorizationParams.audience || "default" });
    } catch (h) {
      if (h.message) {
        if (h.message.includes("user is blocked")) throw await this.logout({ openUrl: !1 }), h;
        if ((h.message.includes("Missing Refresh Token") || h.message.includes("invalid refresh token")) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(t);
      }
      throw h instanceof D0 && this.mfa.setMFAAuthDetails(h.mfa_token, (r = t.authorizationParams) === null || r === void 0 ? void 0 : r.scope, (n = t.authorizationParams) === null || n === void 0 ? void 0 : n.audience, h.mfa_requirements), h;
    }
    var l, d, c, u;
  }
  async _saveEntryInCache(t) {
    const { id_token: r, decodedToken: n } = t, i = Wn(t, ["id_token", "decodedToken"]);
    this.userCache.set("@@user@@", { id_token: r, decodedToken: n }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(i);
  }
  async _getIdTokenFromCache() {
    const t = this.options.authorizationParams.audience || "default", r = this.scope[t], n = await this.cacheManager.getIdToken(new Qi({ clientId: this.options.clientId, audience: t, scope: r })), i = this.userCache.get("@@user@@");
    return n && n.id_token === i?.id_token ? i : (this.userCache.set("@@user@@", n), n);
  }
  async _getEntryFromCache(t) {
    let { scope: r, audience: n, clientId: i, cacheMode: a } = t;
    const o = await this.cacheManager.get(new Qi({ scope: r, audience: n, clientId: i }), 60, this.options.useMrrt, a);
    if (o && o.access_token) {
      const { token_type: s, access_token: l, oauthTokenScope: d, expires_in: c } = o, u = await this._getIdTokenFromCache();
      return u && Object.assign(Object.assign({ id_token: u.id_token, token_type: s || "Bearer", access_token: l }, d ? { scope: d } : null), { expires_in: c });
    }
  }
  async _requestToken(t, r) {
    var n, i;
    const { nonceIn: a, organization: o, scopesToRequest: s } = r || {}, l = await Yx(Object.assign(Object.assign({ baseUrl: this.domainUrl, client_id: this.options.clientId, auth0Client: this.options.auth0Client, useFormData: this.options.useFormData, timeout: this.httpTimeoutMs, useMrrt: this.options.useMrrt, dpop: this.dpop }, t), { scope: s || t.scope }), this.worker), d = await this._verifyIdToken(l.id_token, a, o);
    if (t.grant_type === "authorization_code") {
      const c = await this._getIdTokenFromCache();
      !((i = (n = c?.decodedToken) === null || n === void 0 ? void 0 : n.claims) === null || i === void 0) && i.sub && c.decodedToken.claims.sub !== d.claims.sub && (await this.cacheManager.clear(this.options.clientId), this.userCache.remove("@@user@@"));
    }
    return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, l), { decodedToken: d, scope: t.scope, audience: t.audience || "default" }), l.scope ? { oauthTokenScope: l.scope } : null), { client_id: this.options.clientId })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this._processOrgHint(o || d.claims.org_id), Object.assign(Object.assign({}, l), { decodedToken: d });
  }
  async loginWithCustomTokenExchange(t) {
    return this._requestToken(Object.assign(Object.assign({}, t), { grant_type: "urn:ietf:params:oauth:grant-type:token-exchange", subject_token: t.subject_token, subject_token_type: t.subject_token_type, scope: gu(this.scope, t.scope, t.audience || this.options.authorizationParams.audience), audience: t.audience || this.options.authorizationParams.audience, organization: t.organization || this.options.authorizationParams.organization }));
  }
  async exchangeToken(t) {
    return this.loginWithCustomTokenExchange(t);
  }
  _assertDpop(t) {
    if (!t) throw new Error("`useDpop` option must be enabled before using DPoP.");
  }
  getDpopNonce(t) {
    return this._assertDpop(this.dpop), this.dpop.getNonce(t);
  }
  setDpopNonce(t, r) {
    return this._assertDpop(this.dpop), this.dpop.setNonce(t, r);
  }
  generateDpopProof(t) {
    return this._assertDpop(this.dpop), this.dpop.generateProof(t);
  }
  createFetcher() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return new pE(t, { isDpopEnabled: () => !!this.options.useDpop, getAccessToken: (r) => {
      var n;
      return this.getTokenSilently({ authorizationParams: { scope: (n = r?.scope) === null || n === void 0 ? void 0 : n.join(" "), audience: r?.audience }, detailedResponse: !0 });
    }, getDpopNonce: () => this.getDpopNonce(t.dpopNonceId), setDpopNonce: (r) => this.setDpopNonce(r, t.dpopNonceId), generateDpopProof: (r) => this.generateDpopProof(r) });
  }
  async connectAccountWithRedirect(t) {
    const { openUrl: r, appState: n, connection: i, scopes: a, authorization_params: o, redirectUri: s = this.options.authorizationParams.redirect_uri || window.location.origin } = t;
    if (!i) throw new Error("connection is required");
    const l = Mh(Zl()), d = Zl(), c = await gg(d), u = yg(c), { connect_uri: h, connect_params: f, auth_session: p } = await this.myAccountApi.connectAccount({ connection: i, scopes: a, redirect_uri: s, state: l, code_challenge: u, code_challenge_method: "S256", authorization_params: o });
    this.transactionManager.create({ state: l, code_verifier: d, auth_session: p, redirect_uri: s, appState: n, connection: i, response_type: Co.ConnectCode });
    const m = new URL(h);
    m.searchParams.set("ticket", f.ticket), r ? await r(m.toString()) : window.location.assign(m);
  }
  async _requestTokenForMfa(t, r) {
    const { mfaToken: n } = t, i = Wn(t, ["mfaToken"]);
    return this._requestToken(Object.assign(Object.assign({}, i), { mfa_token: n }), r);
  }
};
var sf = "Invariant Violation", Qg = Object.setPrototypeOf, FS = Qg === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : Qg, r8 = (
  /** @class */
  (function(e) {
    Li(t, e);
    function t(r) {
      r === void 0 && (r = sf);
      var n = e.call(this, typeof r == "number" ? sf + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return n.framesToPop = 1, n.name = sf, FS(n, t.prototype), n;
    }
    return t;
  })(Error)
);
function Ao(e, t) {
  if (!e)
    throw new r8(t);
}
var n8 = ["debug", "log", "warn", "error", "silent"], jS = n8.indexOf("log");
function Eu(e) {
  return function() {
    if (n8.indexOf(e) >= jS) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = Eu("debug"), e.log = Eu("log"), e.warn = Eu("warn"), e.error = Eu("error");
})(Ao || (Ao = {}));
var hm = "3.14.0";
function Gn(e) {
  try {
    return e();
  } catch {
  }
}
const q0 = Gn(function() {
  return globalThis;
}) || Gn(function() {
  return window;
}) || Gn(function() {
  return self;
}) || Gn(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Gn(function() {
  return Gn.constructor("return this")();
});
var Gg = /* @__PURE__ */ new Map();
function B2(e) {
  var t = Gg.get(e) || 1;
  return Gg.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function i8(e, t) {
  t === void 0 && (t = 0);
  var r = B2("stringifyForDisplay");
  return JSON.stringify(e, function(n, i) {
    return i === void 0 ? r : i;
  }, t).split(JSON.stringify(r)).join("<undefined>");
}
function Su(e) {
  return function(t) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    if (typeof t == "number") {
      var i = t;
      t = fm(i), t || (t = pm(i, r), r = []);
    }
    e.apply(void 0, [t].concat(r));
  };
}
var ge = Object.assign(function(t, r) {
  for (var n = [], i = 2; i < arguments.length; i++)
    n[i - 2] = arguments[i];
  t || Ao(t, fm(r, n) || pm(r, n));
}, {
  debug: Su(Ao.debug),
  log: Su(Ao.log),
  warn: Su(Ao.warn),
  error: Su(Ao.error)
});
function Jr(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return new r8(fm(e, t) || pm(e, t));
}
var Yg = /* @__PURE__ */ Symbol.for("ApolloErrorMessageHandler_" + hm);
function a8(e) {
  if (typeof e == "string")
    return e;
  try {
    return i8(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function fm(e, t) {
  if (t === void 0 && (t = []), !!e)
    return q0[Yg] && q0[Yg](e, t.map(a8));
}
function pm(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: hm,
      message: e,
      args: t.map(a8)
    })));
}
function a0(e, t) {
  if (!!!e)
    throw new Error(t);
}
function zS(e) {
  return typeof e == "object" && e !== null;
}
function VS(e, t) {
  if (!!!e)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const US = /\r\n|[\n\r]/g;
function H2(e, t) {
  let r = 0, n = 1;
  for (const i of e.body.matchAll(US)) {
    if (typeof i.index == "number" || VS(!1), i.index >= t)
      break;
    r = i.index + i[0].length, n += 1;
  }
  return {
    line: n,
    column: t + 1 - r
  };
}
function qS(e) {
  return o8(
    e.source,
    H2(e.source, e.start)
  );
}
function o8(e, t) {
  const r = e.locationOffset.column - 1, n = "".padStart(r) + e.body, i = t.line - 1, a = e.locationOffset.line - 1, o = t.line + a, s = t.line === 1 ? r : 0, l = t.column + s, d = `${e.name}:${o}:${l}
`, c = n.split(/\r\n|[\n\r]/g), u = c[i];
  if (u.length > 120) {
    const h = Math.floor(l / 80), f = l % 80, p = [];
    for (let m = 0; m < u.length; m += 80)
      p.push(u.slice(m, m + 80));
    return d + Jg([
      [`${o} |`, p[0]],
      ...p.slice(1, h + 1).map((m) => ["|", m]),
      ["|", "^".padStart(f)],
      ["|", p[h + 1]]
    ]);
  }
  return d + Jg([
    // Lines specified like this: ["prefix", "string"],
    [`${o - 1} |`, c[i - 1]],
    [`${o} |`, u],
    ["|", "^".padStart(l)],
    [`${o + 1} |`, c[i + 1]]
  ]);
}
function Jg(e) {
  const t = e.filter(([n, i]) => i !== void 0), r = Math.max(...t.map(([n]) => n.length));
  return t.map(([n, i]) => n.padStart(r) + (i ? " " + i : "")).join(`
`);
}
function BS(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class mm extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...r) {
    var n, i, a;
    const { nodes: o, source: s, positions: l, path: d, originalError: c, extensions: u } = BS(r);
    super(t), this.name = "GraphQLError", this.path = d ?? void 0, this.originalError = c ?? void 0, this.nodes = Zg(
      Array.isArray(o) ? o : o ? [o] : void 0
    );
    const h = Zg(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((p) => p.loc).filter((p) => p != null)
    );
    this.source = s ?? (h == null || (i = h[0]) === null || i === void 0 ? void 0 : i.source), this.positions = l ?? h?.map((p) => p.start), this.locations = l && s ? l.map((p) => H2(s, p)) : h?.map((p) => H2(p.source, p.start));
    const f = zS(
      c?.extensions
    ) ? c?.extensions : void 0;
    this.extensions = (a = u ?? f) !== null && a !== void 0 ? a : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), c != null && c.stack ? Object.defineProperty(this, "stack", {
      value: c.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, mm) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const r of this.nodes)
        r.loc && (t += `

` + qS(r.loc));
    else if (this.source && this.locations)
      for (const r of this.locations)
        t += `

` + o8(this.source, r);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function Zg(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function wr(e, t, r) {
  return new mm(`Syntax Error: ${r}`, {
    source: e,
    positions: [t]
  });
}
class HS {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, r, n) {
    this.start = t.start, this.end = r.end, this.startToken = t, this.endToken = r, this.source = n;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class s8 {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, r, n, i, a, o) {
    this.kind = t, this.start = r, this.end = n, this.line = i, this.column = a, this.value = o, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const l8 = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "description",
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: [
    "description",
    "variable",
    "type",
    "defaultValue",
    "directives"
  ],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "description",
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"],
  TypeCoordinate: ["name"],
  MemberCoordinate: ["name", "memberName"],
  ArgumentCoordinate: ["name", "fieldName", "argumentName"],
  DirectiveCoordinate: ["name"],
  DirectiveArgumentCoordinate: ["name", "argumentName"]
}, WS = new Set(Object.keys(l8));
function Xg(e) {
  const t = e?.kind;
  return typeof t == "string" && WS.has(t);
}
var Ns;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(Ns || (Ns = {}));
var W2;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(W2 || (W2 = {}));
var ue;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension", e.TYPE_COORDINATE = "TypeCoordinate", e.MEMBER_COORDINATE = "MemberCoordinate", e.ARGUMENT_COORDINATE = "ArgumentCoordinate", e.DIRECTIVE_COORDINATE = "DirectiveCoordinate", e.DIRECTIVE_ARGUMENT_COORDINATE = "DirectiveArgumentCoordinate";
})(ue || (ue = {}));
function K2(e) {
  return e === 9 || e === 32;
}
function ic(e) {
  return e >= 48 && e <= 57;
}
function d8(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function c8(e) {
  return d8(e) || e === 95;
}
function KS(e) {
  return d8(e) || ic(e) || e === 95;
}
function QS(e) {
  var t;
  let r = Number.MAX_SAFE_INTEGER, n = null, i = -1;
  for (let o = 0; o < e.length; ++o) {
    var a;
    const s = e[o], l = GS(s);
    l !== s.length && (n = (a = n) !== null && a !== void 0 ? a : o, i = o, o !== 0 && l < r && (r = l));
  }
  return e.map((o, s) => s === 0 ? o : o.slice(r)).slice(
    (t = n) !== null && t !== void 0 ? t : 0,
    i + 1
  );
}
function GS(e) {
  let t = 0;
  for (; t < e.length && K2(e.charCodeAt(t)); )
    ++t;
  return t;
}
function YS(e, t) {
  const r = e.replace(/"""/g, '\\"""'), n = r.split(/\r\n|[\n\r]/g), i = n.length === 1, a = n.length > 1 && n.slice(1).every((f) => f.length === 0 || K2(f.charCodeAt(0))), o = r.endsWith('\\"""'), s = e.endsWith('"') && !o, l = e.endsWith("\\"), d = s || l, c = (
    // add leading and trailing new lines only if it improves readability
    !i || e.length > 70 || d || a || o
  );
  let u = "";
  const h = i && K2(e.charCodeAt(0));
  return (c && !h || a) && (u += `
`), u += r, (c || d) && (u += `
`), '"""' + u + '"""';
}
var G;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.DOT = ".", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(G || (G = {}));
class JS {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const r = new s8(G.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== G.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const r = XS(this, t.end);
          t.next = r, r.prev = t, t = r;
        }
      while (t.kind === G.COMMENT);
    return t;
  }
}
function ZS(e) {
  return e === G.BANG || e === G.DOLLAR || e === G.AMP || e === G.PAREN_L || e === G.PAREN_R || e === G.DOT || e === G.SPREAD || e === G.COLON || e === G.EQUALS || e === G.AT || e === G.BRACKET_L || e === G.BRACKET_R || e === G.BRACE_L || e === G.PIPE || e === G.BRACE_R;
}
function Al(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function z1(e, t) {
  return u8(e.charCodeAt(t)) && h8(e.charCodeAt(t + 1));
}
function u8(e) {
  return e >= 55296 && e <= 56319;
}
function h8(e) {
  return e >= 56320 && e <= 57343;
}
function Ho(e, t) {
  const r = e.source.body.codePointAt(t);
  if (r === void 0)
    return G.EOF;
  if (r >= 32 && r <= 126) {
    const n = String.fromCodePoint(r);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
}
function cr(e, t, r, n, i) {
  const a = e.line, o = 1 + r - e.lineStart;
  return new s8(t, r, n, a, o, i);
}
function XS(e, t) {
  const r = e.source.body, n = r.length;
  let i = t;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    switch (a) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 65279:
      // <BOM>
      case 9:
      // \t
      case 32:
      // <space>
      case 44:
        ++i;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"
      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;
      case 13:
        r.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;
      // Comment
      case 35:
        return eC(e, i);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
      case 33:
        return cr(e, G.BANG, i, i + 1);
      case 36:
        return cr(e, G.DOLLAR, i, i + 1);
      case 38:
        return cr(e, G.AMP, i, i + 1);
      case 40:
        return cr(e, G.PAREN_L, i, i + 1);
      case 41:
        return cr(e, G.PAREN_R, i, i + 1);
      case 46:
        if (r.charCodeAt(i + 1) === 46 && r.charCodeAt(i + 2) === 46)
          return cr(e, G.SPREAD, i, i + 3);
        break;
      case 58:
        return cr(e, G.COLON, i, i + 1);
      case 61:
        return cr(e, G.EQUALS, i, i + 1);
      case 64:
        return cr(e, G.AT, i, i + 1);
      case 91:
        return cr(e, G.BRACKET_L, i, i + 1);
      case 93:
        return cr(e, G.BRACKET_R, i, i + 1);
      case 123:
        return cr(e, G.BRACE_L, i, i + 1);
      case 124:
        return cr(e, G.PIPE, i, i + 1);
      case 125:
        return cr(e, G.BRACE_R, i, i + 1);
      // StringValue
      case 34:
        return r.charCodeAt(i + 1) === 34 && r.charCodeAt(i + 2) === 34 ? oC(e, i) : rC(e, i);
    }
    if (ic(a) || a === 45)
      return tC(e, i, a);
    if (c8(a))
      return sC(e, i);
    throw wr(
      e.source,
      i,
      a === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Al(a) || z1(r, i) ? `Unexpected character: ${Ho(e, i)}.` : `Invalid character: ${Ho(e, i)}.`
    );
  }
  return cr(e, G.EOF, n, n);
}
function eC(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    if (a === 10 || a === 13)
      break;
    if (Al(a))
      ++i;
    else if (z1(r, i))
      i += 2;
    else
      break;
  }
  return cr(
    e,
    G.COMMENT,
    t,
    i,
    r.slice(t + 1, i)
  );
}
function tC(e, t, r) {
  const n = e.source.body;
  let i = t, a = r, o = !1;
  if (a === 45 && (a = n.charCodeAt(++i)), a === 48) {
    if (a = n.charCodeAt(++i), ic(a))
      throw wr(
        e.source,
        i,
        `Invalid number, unexpected digit after 0: ${Ho(
          e,
          i
        )}.`
      );
  } else
    i = lf(e, i, a), a = n.charCodeAt(i);
  if (a === 46 && (o = !0, a = n.charCodeAt(++i), i = lf(e, i, a), a = n.charCodeAt(i)), (a === 69 || a === 101) && (o = !0, a = n.charCodeAt(++i), (a === 43 || a === 45) && (a = n.charCodeAt(++i)), i = lf(e, i, a), a = n.charCodeAt(i)), a === 46 || c8(a))
    throw wr(
      e.source,
      i,
      `Invalid number, expected digit but got: ${Ho(
        e,
        i
      )}.`
    );
  return cr(
    e,
    o ? G.FLOAT : G.INT,
    t,
    i,
    n.slice(t, i)
  );
}
function lf(e, t, r) {
  if (!ic(r))
    throw wr(
      e.source,
      t,
      `Invalid number, expected digit but got: ${Ho(
        e,
        t
      )}.`
    );
  const n = e.source.body;
  let i = t + 1;
  for (; ic(n.charCodeAt(i)); )
    ++i;
  return i;
}
function rC(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1, a = i, o = "";
  for (; i < n; ) {
    const s = r.charCodeAt(i);
    if (s === 34)
      return o += r.slice(a, i), cr(e, G.STRING, t, i + 1, o);
    if (s === 92) {
      o += r.slice(a, i);
      const l = r.charCodeAt(i + 1) === 117 ? r.charCodeAt(i + 2) === 123 ? nC(e, i) : iC(e, i) : aC(e, i);
      o += l.value, i += l.size, a = i;
      continue;
    }
    if (s === 10 || s === 13)
      break;
    if (Al(s))
      ++i;
    else if (z1(r, i))
      i += 2;
    else
      throw wr(
        e.source,
        i,
        `Invalid character within String: ${Ho(
          e,
          i
        )}.`
      );
  }
  throw wr(e.source, i, "Unterminated string.");
}
function nC(e, t) {
  const r = e.source.body;
  let n = 0, i = 3;
  for (; i < 12; ) {
    const a = r.charCodeAt(t + i++);
    if (a === 125) {
      if (i < 5 || !Al(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: i
      };
    }
    if (n = n << 4 | Td(a), n < 0)
      break;
  }
  throw wr(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(
      t,
      t + i
    )}".`
  );
}
function iC(e, t) {
  const r = e.source.body, n = ev(r, t + 2);
  if (Al(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if (u8(n) && r.charCodeAt(t + 6) === 92 && r.charCodeAt(t + 7) === 117) {
    const i = ev(r, t + 8);
    if (h8(i))
      return {
        value: String.fromCodePoint(n, i),
        size: 12
      };
  }
  throw wr(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(t, t + 6)}".`
  );
}
function ev(e, t) {
  return Td(e.charCodeAt(t)) << 12 | Td(e.charCodeAt(t + 1)) << 8 | Td(e.charCodeAt(t + 2)) << 4 | Td(e.charCodeAt(t + 3));
}
function Td(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function aC(e, t) {
  const r = e.source.body;
  switch (r.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw wr(
    e.source,
    t,
    `Invalid character escape sequence: "${r.slice(
      t,
      t + 2
    )}".`
  );
}
function oC(e, t) {
  const r = e.source.body, n = r.length;
  let i = e.lineStart, a = t + 3, o = a, s = "";
  const l = [];
  for (; a < n; ) {
    const d = r.charCodeAt(a);
    if (d === 34 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34) {
      s += r.slice(o, a), l.push(s);
      const c = cr(
        e,
        G.BLOCK_STRING,
        t,
        a + 3,
        // Return a string of the lines joined with U+000A.
        QS(l).join(`
`)
      );
      return e.line += l.length - 1, e.lineStart = i, c;
    }
    if (d === 92 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34 && r.charCodeAt(a + 3) === 34) {
      s += r.slice(o, a), o = a + 1, a += 4;
      continue;
    }
    if (d === 10 || d === 13) {
      s += r.slice(o, a), l.push(s), d === 13 && r.charCodeAt(a + 1) === 10 ? a += 2 : ++a, s = "", o = a, i = a;
      continue;
    }
    if (Al(d))
      ++a;
    else if (z1(r, a))
      a += 2;
    else
      throw wr(
        e.source,
        a,
        `Invalid character within String: ${Ho(
          e,
          a
        )}.`
      );
  }
  throw wr(e.source, a, "Unterminated string.");
}
function sC(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    if (KS(a))
      ++i;
    else
      break;
  }
  return cr(
    e,
    G.NAME,
    t,
    i,
    r.slice(t, i)
  );
}
const lC = 10, f8 = 2;
function gm(e) {
  return V1(e, []);
}
function V1(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return dC(e, t);
    default:
      return String(e);
  }
}
function dC(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const r = [...t, e];
  if (cC(e)) {
    const n = e.toJSON();
    if (n !== e)
      return typeof n == "string" ? n : V1(n, r);
  } else if (Array.isArray(e))
    return hC(e, r);
  return uC(e, r);
}
function cC(e) {
  return typeof e.toJSON == "function";
}
function uC(e, t) {
  const r = Object.entries(e);
  return r.length === 0 ? "{}" : t.length > f8 ? "[" + fC(e) + "]" : "{ " + r.map(
    ([i, a]) => i + ": " + V1(a, t)
  ).join(", ") + " }";
}
function hC(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > f8)
    return "[Array]";
  const r = Math.min(lC, e.length), n = e.length - r, i = [];
  for (let a = 0; a < r; ++a)
    i.push(V1(e[a], t));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function fC(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
const pC = globalThis.process && // eslint-disable-next-line no-undef
!0, mC = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  pC ? function(t, r) {
    return t instanceof r;
  } : function(t, r) {
    if (t instanceof r)
      return !0;
    if (typeof t == "object" && t !== null) {
      var n;
      const i = r.prototype[Symbol.toStringTag], a = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in t ? t[Symbol.toStringTag] : (n = t.constructor) === null || n === void 0 ? void 0 : n.name
      );
      if (i === a) {
        const o = gm(t);
        throw new Error(`Cannot use ${i} "${o}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class p8 {
  constructor(t, r = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || a0(!1, `Body must be a string. Received: ${gm(t)}.`), this.body = t, this.name = r, this.locationOffset = n, this.locationOffset.line > 0 || a0(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || a0(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function gC(e) {
  return mC(e, p8);
}
function vC(e, t) {
  const r = new yC(e, t), n = r.parseDocument();
  return Object.defineProperty(n, "tokenCount", {
    enumerable: !1,
    value: r.tokenCount
  }), n;
}
let yC = class {
  constructor(t, r = {}) {
    const { lexer: n, ...i } = r;
    if (n)
      this._lexer = n;
    else {
      const a = gC(t) ? t : new p8(t);
      this._lexer = new JS(a);
    }
    this._options = i, this._tokenCounter = 0;
  }
  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const t = this.expectToken(G.NAME);
    return this.node(t, {
      kind: ue.NAME,
      value: t.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: ue.DOCUMENT,
      definitions: this.many(
        G.SOF,
        this.parseDefinition,
        G.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(G.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), r = t ? this._lexer.lookahead() : this._lexer.token;
    if (t && r.kind === G.BRACE_L)
      throw wr(
        this._lexer.source,
        this._lexer.token.start,
        "Unexpected description, descriptions are not supported on shorthand queries."
      );
    if (r.kind === G.NAME) {
      switch (r.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      switch (r.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
      }
      if (t)
        throw wr(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, only GraphQL definitions support descriptions."
        );
      if (r.value === "extend")
        return this.parseTypeSystemExtension();
    }
    throw this.unexpected(r);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(G.BRACE_L))
      return this.node(t, {
        kind: ue.OPERATION_DEFINITION,
        operation: Ns.QUERY,
        description: void 0,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const r = this.parseDescription(), n = this.parseOperationType();
    let i;
    return this.peek(G.NAME) && (i = this.parseName()), this.node(t, {
      kind: ue.OPERATION_DEFINITION,
      operation: n,
      description: r,
      name: i,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const t = this.expectToken(G.NAME);
    switch (t.value) {
      case "query":
        return Ns.QUERY;
      case "mutation":
        return Ns.MUTATION;
      case "subscription":
        return Ns.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      G.PAREN_L,
      this.parseVariableDefinition,
      G.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: ue.VARIABLE_DEFINITION,
      description: this.parseDescription(),
      variable: this.parseVariable(),
      type: (this.expectToken(G.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(G.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(G.DOLLAR), this.node(t, {
      kind: ue.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: ue.SELECTION_SET,
      selections: this.many(
        G.BRACE_L,
        this.parseSelection,
        G.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(G.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const t = this._lexer.token, r = this.parseName();
    let n, i;
    return this.expectOptionalToken(G.COLON) ? (n = r, i = this.parseName()) : i = r, this.node(t, {
      kind: ue.FIELD,
      alias: n,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(G.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(t) {
    const r = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(G.PAREN_L, r, G.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(t = !1) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(G.COLON), this.node(r, {
      kind: ue.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(G.SPREAD);
    const r = this.expectOptionalKeyword("on");
    return !r && this.peek(G.NAME) ? this.node(t, {
      kind: ue.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: ue.INLINE_FRAGMENT,
      typeCondition: r ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: ue.FRAGMENT_DEFINITION,
      description: r,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: ue.FRAGMENT_DEFINITION,
      description: r,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(t) {
    const r = this._lexer.token;
    switch (r.kind) {
      case G.BRACKET_L:
        return this.parseList(t);
      case G.BRACE_L:
        return this.parseObject(t);
      case G.INT:
        return this.advanceLexer(), this.node(r, {
          kind: ue.INT,
          value: r.value
        });
      case G.FLOAT:
        return this.advanceLexer(), this.node(r, {
          kind: ue.FLOAT,
          value: r.value
        });
      case G.STRING:
      case G.BLOCK_STRING:
        return this.parseStringLiteral();
      case G.NAME:
        switch (this.advanceLexer(), r.value) {
          case "true":
            return this.node(r, {
              kind: ue.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(r, {
              kind: ue.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(r, {
              kind: ue.NULL
            });
          default:
            return this.node(r, {
              kind: ue.ENUM,
              value: r.value
            });
        }
      case G.DOLLAR:
        if (t)
          if (this.expectToken(G.DOLLAR), this._lexer.token.kind === G.NAME) {
            const n = this._lexer.token.value;
            throw wr(
              this._lexer.source,
              r.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(r);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: ue.STRING,
      value: t.value,
      block: t.kind === G.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(t) {
    const r = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: ue.LIST,
      values: this.any(G.BRACKET_L, r, G.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(t) {
    const r = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: ue.OBJECT,
      fields: this.any(G.BRACE_L, r, G.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(t) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(G.COLON), this.node(r, {
      kind: ue.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(t) {
    const r = [];
    for (; this.peek(G.AT); )
      r.push(this.parseDirective(t));
    return r;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(t) {
    const r = this._lexer.token;
    return this.expectToken(G.AT), this.node(r, {
      kind: ue.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const t = this._lexer.token;
    let r;
    if (this.expectOptionalToken(G.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(G.BRACKET_R), r = this.node(t, {
        kind: ue.LIST_TYPE,
        type: n
      });
    } else
      r = this.parseNamedType();
    return this.expectOptionalToken(G.BANG) ? this.node(t, {
      kind: ue.NON_NULL_TYPE,
      type: r
    }) : r;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: ue.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(G.STRING) || this.peek(G.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.many(
      G.BRACE_L,
      this.parseOperationTypeDefinition,
      G.BRACE_R
    );
    return this.node(t, {
      kind: ue.SCHEMA_DEFINITION,
      description: r,
      directives: n,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const t = this._lexer.token, r = this.parseOperationType();
    this.expectToken(G.COLON);
    const n = this.parseNamedType();
    return this.node(t, {
      kind: ue.OPERATION_TYPE_DEFINITION,
      operation: r,
      type: n
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: ue.SCALAR_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: ue.OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: a,
      fields: o
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(G.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      G.BRACE_L,
      this.parseFieldDefinition,
      G.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(G.COLON);
    const a = this.parseTypeReference(), o = this.parseConstDirectives();
    return this.node(t, {
      kind: ue.FIELD_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      type: a,
      directives: o
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      G.PAREN_L,
      this.parseInputValueDef,
      G.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName();
    this.expectToken(G.COLON);
    const i = this.parseTypeReference();
    let a;
    this.expectOptionalToken(G.EQUALS) && (a = this.parseConstValueLiteral());
    const o = this.parseConstDirectives();
    return this.node(t, {
      kind: ue.INPUT_VALUE_DEFINITION,
      description: r,
      name: n,
      type: i,
      defaultValue: a,
      directives: o
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: ue.INTERFACE_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: a,
      fields: o
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: ue.UNION_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      types: a
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(G.EQUALS) ? this.delimitedMany(G.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: ue.ENUM_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      values: a
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      G.BRACE_L,
      this.parseEnumValueDefinition,
      G.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: ue.ENUM_VALUE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw wr(
        this._lexer.source,
        this._lexer.token.start,
        `${Cu(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: ue.INPUT_OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      fields: a
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      G.BRACE_L,
      this.parseInputValueDef,
      G.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === G.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const r = this.parseConstDirectives(), n = this.optionalMany(
      G.BRACE_L,
      this.parseOperationTypeDefinition,
      G.BRACE_R
    );
    if (r.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ue.SCHEMA_EXTENSION,
      directives: r,
      operationTypes: n
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const r = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ue.SCALAR_TYPE_EXTENSION,
      name: r,
      directives: n
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ue.OBJECT_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ue.INTERFACE_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ue.UNION_TYPE_EXTENSION,
      name: r,
      directives: n,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ue.ENUM_TYPE_EXTENSION,
      name: r,
      directives: n,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ue.INPUT_OBJECT_TYPE_EXTENSION,
      name: r,
      directives: n,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(G.AT);
    const n = this.parseName(), i = this.parseArgumentDefs(), a = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const o = this.parseDirectiveLocations();
    return this.node(t, {
      kind: ue.DIRECTIVE_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      repeatable: a,
      locations: o
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(G.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const t = this._lexer.token, r = this.parseName();
    if (Object.prototype.hasOwnProperty.call(W2, r.value))
      return r;
    throw this.unexpected(t);
  }
  // Schema Coordinates
  /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   */
  parseSchemaCoordinate() {
    const t = this._lexer.token, r = this.expectOptionalToken(G.AT), n = this.parseName();
    let i;
    !r && this.expectOptionalToken(G.DOT) && (i = this.parseName());
    let a;
    return (r || i) && this.expectOptionalToken(G.PAREN_L) && (a = this.parseName(), this.expectToken(G.COLON), this.expectToken(G.PAREN_R)), r ? a ? this.node(t, {
      kind: ue.DIRECTIVE_ARGUMENT_COORDINATE,
      name: n,
      argumentName: a
    }) : this.node(t, {
      kind: ue.DIRECTIVE_COORDINATE,
      name: n
    }) : i ? a ? this.node(t, {
      kind: ue.ARGUMENT_COORDINATE,
      name: n,
      fieldName: i,
      argumentName: a
    }) : this.node(t, {
      kind: ue.MEMBER_COORDINATE,
      name: n,
      memberName: i
    }) : this.node(t, {
      kind: ue.TYPE_COORDINATE,
      name: n
    });
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(t, r) {
    return this._options.noLocation !== !0 && (r.loc = new HS(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), r;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(t) {
    return this._lexer.token.kind === t;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(t) {
    const r = this._lexer.token;
    if (r.kind === t)
      return this.advanceLexer(), r;
    throw wr(
      this._lexer.source,
      r.start,
      `Expected ${m8(t)}, found ${Cu(r)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(t) {
    const r = this._lexer.token;
    if (r.kind === G.NAME && r.value === t)
      this.advanceLexer();
    else
      throw wr(
        this._lexer.source,
        r.start,
        `Expected "${t}", found ${Cu(r)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(t) {
    const r = this._lexer.token;
    return r.kind === G.NAME && r.value === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(t) {
    const r = t ?? this._lexer.token;
    return wr(
      this._lexer.source,
      r.start,
      `Unexpected ${Cu(r)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(t, r, n) {
    this.expectToken(t);
    const i = [];
    for (; !this.expectOptionalToken(n); )
      i.push(r.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(t, r, n) {
    if (this.expectOptionalToken(t)) {
      const i = [];
      do
        i.push(r.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(t, r, n) {
    this.expectToken(t);
    const i = [];
    do
      i.push(r.call(this));
    while (!this.expectOptionalToken(n));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(t, r) {
    this.expectOptionalToken(t);
    const n = [];
    do
      n.push(r.call(this));
    while (this.expectOptionalToken(t));
    return n;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, r = this._lexer.advance();
    if (r.kind !== G.EOF && (++this._tokenCounter, t !== void 0 && this._tokenCounter > t))
      throw wr(
        this._lexer.source,
        r.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
};
function Cu(e) {
  const t = e.value;
  return m8(e.kind) + (t != null ? ` "${t}"` : "");
}
function m8(e) {
  return ZS(e) ? `"${e}"` : e;
}
function bC(e) {
  return `"${e.replace(wC, $C)}"`;
}
const wC = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $C(e) {
  return kC[e.charCodeAt(0)];
}
const kC = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], U1 = Object.freeze({});
function li(e, t, r = l8) {
  const n = /* @__PURE__ */ new Map();
  for (const g of Object.values(ue))
    n.set(g, _C(t, g));
  let i, a = Array.isArray(e), o = [e], s = -1, l = [], d = e, c, u;
  const h = [], f = [];
  do {
    s++;
    const g = s === o.length, w = g && l.length !== 0;
    if (g) {
      if (c = f.length === 0 ? void 0 : h[h.length - 1], d = u, u = f.pop(), w)
        if (a) {
          d = d.slice();
          let _ = 0;
          for (const [x, S] of l) {
            const T = x - _;
            S === null ? (d.splice(T, 1), _++) : d[T] = S;
          }
        } else {
          d = { ...d };
          for (const [_, x] of l)
            d[_] = x;
        }
      s = i.index, o = i.keys, l = i.edits, a = i.inArray, i = i.prev;
    } else if (u) {
      if (c = a ? s : o[s], d = u[c], d == null)
        continue;
      h.push(c);
    }
    let $;
    if (!Array.isArray(d)) {
      var p, m;
      Xg(d) || a0(!1, `Invalid AST Node: ${gm(d)}.`);
      const _ = g ? (p = n.get(d.kind)) === null || p === void 0 ? void 0 : p.leave : (m = n.get(d.kind)) === null || m === void 0 ? void 0 : m.enter;
      if ($ = _?.call(t, d, c, u, h, f), $ === U1)
        break;
      if ($ === !1) {
        if (!g) {
          h.pop();
          continue;
        }
      } else if ($ !== void 0 && (l.push([c, $]), !g))
        if (Xg($))
          d = $;
        else {
          h.pop();
          continue;
        }
    }
    if ($ === void 0 && w && l.push([c, d]), g)
      h.pop();
    else {
      var y;
      i = {
        inArray: a,
        index: s,
        keys: o,
        edits: l,
        prev: i
      }, a = Array.isArray(d), o = a ? d : (y = r[d.kind]) !== null && y !== void 0 ? y : [], s = -1, l = [], u && f.push(u), u = d;
    }
  } while (i !== void 0);
  return l.length !== 0 ? l[l.length - 1][1] : e;
}
function _C(e, t) {
  const r = e[t];
  return typeof r == "object" ? r : typeof r == "function" ? {
    enter: r,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function xC(e) {
  return li(e, SC);
}
const EC = 80, SC = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => be(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const t = df(e.variableDefinitions) ? Ve(`(
`, be(e.variableDefinitions, `
`), `
)`) : Ve("(", be(e.variableDefinitions, ", "), ")"), r = Ve("", e.description, `
`) + be(
        [
          e.operation,
          be([e.name, t]),
          be(e.directives, " ")
        ],
        " "
      );
      return (r === "query" ? "" : r + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: t, defaultValue: r, directives: n, description: i }) => Ve("", i, `
`) + e + ": " + t + Ve(" = ", r) + Ve(" ", be(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => Un(e)
  },
  Field: {
    leave({ alias: e, name: t, arguments: r, directives: n, selectionSet: i }) {
      const a = Ve("", e, ": ") + t;
      let o = a + Ve("(", be(r, ", "), ")");
      return o.length > EC && (o = a + Ve(`(
`, o0(be(r, `
`)), `
)`)), be([o, be(n, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: t }) => "..." + e + Ve(" ", be(t, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: t, selectionSet: r }) => be(
      [
        "...",
        Ve("on ", e),
        be(t, " "),
        r
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({
      name: e,
      typeCondition: t,
      variableDefinitions: r,
      directives: n,
      selectionSet: i,
      description: a
    }) => Ve("", a, `
`) + // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    `fragment ${e}${Ve("(", be(r, ", "), ")")} on ${t} ${Ve("", be(n, " "), " ")}` + i
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: t }) => t ? YS(e) : bC(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + be(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + be(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: t }) => "@" + e + Ve("(", be(t, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: t, operationTypes: r }) => Ve("", e, `
`) + be(["schema", be(t, " "), Un(r)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: t }) => e + ": " + t
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: t, directives: r }) => Ve("", e, `
`) + be(["scalar", t, be(r, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => Ve("", e, `
`) + be(
      [
        "type",
        t,
        Ve("implements ", be(r, " & ")),
        be(n, " "),
        Un(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: t, arguments: r, type: n, directives: i }) => Ve("", e, `
`) + t + (df(r) ? Ve(`(
`, o0(be(r, `
`)), `
)`) : Ve("(", be(r, ", "), ")")) + ": " + n + Ve(" ", be(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: t, type: r, defaultValue: n, directives: i }) => Ve("", e, `
`) + be(
      [t + ": " + r, Ve("= ", n), be(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => Ve("", e, `
`) + be(
      [
        "interface",
        t,
        Ve("implements ", be(r, " & ")),
        be(n, " "),
        Un(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, types: n }) => Ve("", e, `
`) + be(
      ["union", t, be(r, " "), Ve("= ", be(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, values: n }) => Ve("", e, `
`) + be(["enum", t, be(r, " "), Un(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: t, directives: r }) => Ve("", e, `
`) + be([t, be(r, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, fields: n }) => Ve("", e, `
`) + be(["input", t, be(r, " "), Un(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: t, arguments: r, repeatable: n, locations: i }) => Ve("", e, `
`) + "directive @" + t + (df(r) ? Ve(`(
`, o0(be(r, `
`)), `
)`) : Ve("(", be(r, ", "), ")")) + (n ? " repeatable" : "") + " on " + be(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: t }) => be(
      ["extend schema", be(e, " "), Un(t)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: t }) => be(["extend scalar", e, be(t, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => be(
      [
        "extend type",
        e,
        Ve("implements ", be(t, " & ")),
        be(r, " "),
        Un(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => be(
      [
        "extend interface",
        e,
        Ve("implements ", be(t, " & ")),
        be(r, " "),
        Un(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: t, types: r }) => be(
      [
        "extend union",
        e,
        be(t, " "),
        Ve("= ", be(r, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: t, values: r }) => be(["extend enum", e, be(t, " "), Un(r)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: t, fields: r }) => be(["extend input", e, be(t, " "), Un(r)], " ")
  },
  // Schema Coordinates
  TypeCoordinate: {
    leave: ({ name: e }) => e
  },
  MemberCoordinate: {
    leave: ({ name: e, memberName: t }) => be([e, Ve(".", t)])
  },
  ArgumentCoordinate: {
    leave: ({ name: e, fieldName: t, argumentName: r }) => be([e, Ve(".", t), Ve("(", r, ":)")])
  },
  DirectiveCoordinate: {
    leave: ({ name: e }) => be(["@", e])
  },
  DirectiveArgumentCoordinate: {
    leave: ({ name: e, argumentName: t }) => be(["@", e, Ve("(", t, ":)")])
  }
};
function be(e, t = "") {
  var r;
  return (r = e?.filter((n) => n).join(t)) !== null && r !== void 0 ? r : "";
}
function Un(e) {
  return Ve(`{
`, o0(be(e, `
`)), `
}`);
}
function Ve(e, t, r = "") {
  return t != null && t !== "" ? e + t + r : "";
}
function o0(e) {
  return Ve("  ", e.replace(/\n/g, `
  `));
}
function df(e) {
  var t;
  return (t = e?.some((r) => r.includes(`
`))) !== null && t !== void 0 ? t : !1;
}
function tv(e) {
  return e.kind === ue.FIELD || e.kind === ue.FRAGMENT_SPREAD || e.kind === ue.INLINE_FRAGMENT;
}
function Bc(e, t) {
  var r = e.directives;
  return !r || !r.length ? !0 : AC(r).every(function(n) {
    var i = n.directive, a = n.ifArgument, o = !1;
    return a.value.kind === "Variable" ? (o = t && t[a.value.name.value], ge(o !== void 0, 106, i.name.value)) : o = a.value.value, i.name.value === "skip" ? !o : o;
  });
}
function ac(e, t, r) {
  var n = new Set(e), i = n.size;
  return li(t, {
    Directive: function(a) {
      if (n.delete(a.name.value) && (!r || !n.size))
        return U1;
    }
  }), r ? !n.size : n.size < i;
}
function CC(e) {
  return e && ac(["client", "export"], e, !0);
}
function TC(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function AC(e) {
  var t = [];
  return e && e.length && e.forEach(function(r) {
    if (TC(r)) {
      var n = r.arguments, i = r.name.value;
      ge(n && n.length === 1, 107, i);
      var a = n[0];
      ge(a.name && a.name.value === "if", 108, i);
      var o = a.value;
      ge(o && (o.kind === "Variable" || o.kind === "BooleanValue"), 109, i), t.push({ directive: r, ifArgument: a });
    }
  }), t;
}
function OC(e) {
  var t, r, n = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(a) {
    var o = a.name;
    return o.value === "unmask";
  });
  if (!n)
    return "mask";
  var i = (r = n.arguments) === null || r === void 0 ? void 0 : r.find(function(a) {
    var o = a.name;
    return o.value === "mode";
  });
  return globalThis.__DEV__ !== !1 && i && (i.value.kind === ue.VARIABLE ? globalThis.__DEV__ !== !1 && ge.warn(110) : i.value.kind !== ue.STRING ? globalThis.__DEV__ !== !1 && ge.warn(111) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && ge.warn(112, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const PC = () => /* @__PURE__ */ Object.create(null), { forEach: IC, slice: rv } = Array.prototype, { hasOwnProperty: DC } = Object.prototype;
class da {
  constructor(t = !0, r = PC) {
    this.weakness = t, this.makeData = r;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(t) {
    let r = this;
    return IC.call(t, (n) => r = r.getChildTrie(n)), DC.call(r, "data") ? r.data : r.data = this.makeData(rv.call(t));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(t) {
    let r = this;
    for (let n = 0, i = t.length; r && n < i; ++n) {
      const a = r.mapFor(t[n], !1);
      r = a && a.get(t[n]);
    }
    return r && r.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(t) {
    let r;
    if (t.length) {
      const n = t[0], i = this.mapFor(n, !1), a = i && i.get(n);
      a && (r = a.removeArray(rv.call(t, 1)), !a.data && !a.weak && !(a.strong && a.strong.size) && i.delete(n));
    } else
      r = this.data, delete this.data;
    return r;
  }
  getChildTrie(t) {
    const r = this.mapFor(t, !0);
    let n = r.get(t);
    return n || r.set(t, n = new da(this.weakness, this.makeData)), n;
  }
  mapFor(t, r) {
    return this.weakness && NC(t) ? this.weak || (r ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (r ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function NC(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var MC = Gn(function() {
  return navigator.product;
}) == "ReactNative", as = typeof WeakMap == "function" && !(MC && !global.HermesInternal), vm = typeof WeakSet == "function", g8 = typeof Symbol == "function" && typeof Symbol.for == "function", q1 = g8 && Symbol.asyncIterator;
Gn(function() {
  return window.document.createElement;
});
Gn(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function rr(e) {
  return e !== null && typeof e == "object";
}
function RC(e, t) {
  var r = t, n = [];
  e.definitions.forEach(function(a) {
    if (a.kind === "OperationDefinition")
      throw Jr(
        113,
        a.operation,
        a.name ? " named '".concat(a.name.value, "'") : ""
      );
    a.kind === "FragmentDefinition" && n.push(a);
  }), typeof r > "u" && (ge(n.length === 1, 114, n.length), r = n[0].name.value);
  var i = F(F({}, e), { definitions: Nr([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: r
            }
          }
        ]
      }
    }
  ], e.definitions, !0) });
  return i;
}
function Ol(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(r) {
    t[r.name.value] = r;
  }), t;
}
function B1(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var r = e.name.value;
      if (typeof t == "function")
        return t(r);
      var n = t && t[r];
      return ge(n, 115, r), n || null;
    }
    default:
      return null;
  }
}
function LC(e) {
  var t = !0;
  return li(e, {
    FragmentSpread: function(r) {
      if (t = !!r.directives && r.directives.some(function(n) {
        return n.name.value === "unmask";
      }), !t)
        return U1;
    }
  }), t;
}
function FC() {
}
class Q2 {
  constructor(t = 1 / 0, r = FC) {
    this.max = t, this.dispose = r, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(t, n), n.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (r === this.newest && (this.newest = r.older), r === this.oldest && (this.oldest = r.newer), r.newer && (r.newer.older = r.older), r.older && (r.older.newer = r.newer), this.map.delete(t), this.dispose(r.value, t), !0) : !1;
  }
}
function G2() {
}
const jC = G2, zC = typeof WeakRef < "u" ? WeakRef : function(e) {
  return { deref: () => e };
}, VC = typeof WeakMap < "u" ? WeakMap : Map, UC = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: G2,
    unregister: G2
  };
}, qC = 10024;
class B0 {
  constructor(t = 1 / 0, r = jC) {
    this.max = t, this.dispose = r, this.map = new VC(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const n = this.unfinalizedNodes.values();
      for (let i = 0; i < qC; i++) {
        const a = n.next().value;
        if (!a)
          break;
        this.unfinalizedNodes.delete(a);
        const o = a.key;
        delete a.key, a.keyRef = new zC(o), this.registry.register(o, a, a);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new UC(this.deleteNode.bind(this));
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.scheduleFinalization(n), this.map.set(t, n), this.size++, n.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(t) {
    t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
    const r = t.key || t.keyRef && t.keyRef.deref();
    this.dispose(t.value, r), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), r && this.map.delete(r);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (this.deleteNode(r), !0) : !1;
  }
  scheduleFinalization(t) {
    this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var cf = /* @__PURE__ */ new WeakSet();
function v8(e) {
  e.size <= (e.max || -1) || cf.has(e) || (cf.add(e), setTimeout(function() {
    e.clean(), cf.delete(e);
  }, 100));
}
var y8 = function(e, t) {
  var r = new B0(e, t);
  return r.set = function(n, i) {
    var a = B0.prototype.set.call(this, n, i);
    return v8(this), a;
  }, r;
}, BC = function(e, t) {
  var r = new Q2(e, t);
  return r.set = function(n, i) {
    var a = Q2.prototype.set.call(this, n, i);
    return v8(this), a;
  }, r;
}, HC = /* @__PURE__ */ Symbol.for("apollo.cacheSize"), ta = F({}, q0[HC]), wo = {};
function b8(e, t) {
  wo[e] = t;
}
var WC = globalThis.__DEV__ !== !1 ? YC : void 0, KC = globalThis.__DEV__ !== !1 ? JC : void 0, QC = globalThis.__DEV__ !== !1 ? w8 : void 0;
function GC() {
  var e = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(e).map(function(t) {
    var r = t[0], n = t[1];
    return [
      r,
      ta[r] || n
    ];
  }));
}
function YC() {
  var e, t, r, n, i;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: GC(),
    sizes: F({ print: (e = wo.print) === null || e === void 0 ? void 0 : e.call(wo), parser: (t = wo.parser) === null || t === void 0 ? void 0 : t.call(wo), canonicalStringify: (r = wo.canonicalStringify) === null || r === void 0 ? void 0 : r.call(wo), links: J2(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: k8(this.queryManager.documentTransform)
    } }, (i = (n = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(n))
  };
}
function w8() {
  return {
    cache: {
      fragmentQueryDocuments: xa(this.getFragmentDoc)
    }
  };
}
function JC() {
  var e = this.config.fragments;
  return F(F({}, w8.apply(this)), { addTypenameDocumentTransform: k8(this.addTypenameTransform), inMemoryCache: {
    executeSelectionSet: xa(this.storeReader.executeSelectionSet),
    executeSubSelectedArray: xa(this.storeReader.executeSubSelectedArray),
    maybeBroadcastWatch: xa(this.maybeBroadcastWatch)
  }, fragmentRegistry: {
    findFragmentSpreads: xa(e?.findFragmentSpreads),
    lookup: xa(e?.lookup),
    transform: xa(e?.transform)
  } });
}
function ZC(e) {
  return !!e && "dirtyKey" in e;
}
function xa(e) {
  return ZC(e) ? e.size : void 0;
}
function $8(e) {
  return e != null;
}
function k8(e) {
  return Y2(e).map(function(t) {
    return { cache: t };
  });
}
function Y2(e) {
  return e ? Nr(Nr([
    xa(e?.performWork)
  ], Y2(e?.left), !0), Y2(e?.right), !0).filter($8) : [];
}
function J2(e) {
  var t;
  return e ? Nr(Nr([
    (t = e?.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
  ], J2(e?.left), !0), J2(e?.right), !0).filter($8) : [];
}
var La = Object.assign(function(t) {
  return JSON.stringify(t, XC);
}, {
  reset: function() {
    Ms = new BC(
      ta.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && b8("canonicalStringify", function() {
  return Ms.size;
});
var Ms;
La.reset();
function XC(e, t) {
  if (t && typeof t == "object") {
    var r = Object.getPrototypeOf(t);
    if (r === Object.prototype || r === null) {
      var n = Object.keys(t);
      if (n.every(eT))
        return t;
      var i = JSON.stringify(n), a = Ms.get(i);
      if (!a) {
        n.sort();
        var o = JSON.stringify(n);
        a = Ms.get(o) || n, Ms.set(i, a), Ms.set(o, a);
      }
      var s = Object.create(r);
      return a.forEach(function(l) {
        s[l] = t[l];
      }), s;
    }
  }
  return t;
}
function eT(e, t, r) {
  return t === 0 || r[t - 1] <= e;
}
function Qs(e) {
  return { __ref: String(e) };
}
function kt(e) {
  return !!(e && typeof e == "object" && typeof e.__ref == "string");
}
function tT(e) {
  return rr(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function rT(e) {
  return e.kind === "StringValue";
}
function nT(e) {
  return e.kind === "BooleanValue";
}
function iT(e) {
  return e.kind === "IntValue";
}
function aT(e) {
  return e.kind === "FloatValue";
}
function oT(e) {
  return e.kind === "Variable";
}
function sT(e) {
  return e.kind === "ObjectValue";
}
function lT(e) {
  return e.kind === "ListValue";
}
function dT(e) {
  return e.kind === "EnumValue";
}
function cT(e) {
  return e.kind === "NullValue";
}
function dl(e, t, r, n) {
  if (iT(r) || aT(r))
    e[t.value] = Number(r.value);
  else if (nT(r) || rT(r))
    e[t.value] = r.value;
  else if (sT(r)) {
    var i = {};
    r.fields.map(function(o) {
      return dl(i, o.name, o.value, n);
    }), e[t.value] = i;
  } else if (oT(r)) {
    var a = (n || {})[r.name.value];
    e[t.value] = a;
  } else if (lT(r))
    e[t.value] = r.values.map(function(o) {
      var s = {};
      return dl(s, t, o, n), s[t.value];
    });
  else if (dT(r))
    e[t.value] = r.value;
  else if (cT(r))
    e[t.value] = null;
  else
    throw Jr(124, t.value, r.kind);
}
function uT(e, t) {
  var r = null;
  e.directives && (r = {}, e.directives.forEach(function(i) {
    r[i.name.value] = {}, i.arguments && i.arguments.forEach(function(a) {
      var o = a.name, s = a.value;
      return dl(r[i.name.value], o, s, t);
    });
  }));
  var n = null;
  return e.arguments && e.arguments.length && (n = {}, e.arguments.forEach(function(i) {
    var a = i.name, o = i.value;
    return dl(n, a, o, t);
  })), _8(e.name.value, n, r);
}
var hT = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], nd = La, _8 = Object.assign(function(e, t, r) {
  if (t && r && r.connection && r.connection.key)
    if (r.connection.filter && r.connection.filter.length > 0) {
      var n = r.connection.filter ? r.connection.filter : [];
      n.sort();
      var i = {};
      return n.forEach(function(s) {
        i[s] = t[s];
      }), "".concat(r.connection.key, "(").concat(nd(i), ")");
    } else
      return r.connection.key;
  var a = e;
  if (t) {
    var o = nd(t);
    a += "(".concat(o, ")");
  }
  return r && Object.keys(r).forEach(function(s) {
    hT.indexOf(s) === -1 && (r[s] && Object.keys(r[s]).length ? a += "@".concat(s, "(").concat(nd(r[s]), ")") : a += "@".concat(s));
  }), a;
}, {
  setStringify: function(e) {
    var t = nd;
    return nd = e, t;
  }
});
function H1(e, t) {
  if (e.arguments && e.arguments.length) {
    var r = {};
    return e.arguments.forEach(function(n) {
      var i = n.name, a = n.value;
      return dl(r, i, a, t);
    }), r;
  }
  return null;
}
function ra(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function Z2(e, t, r) {
  for (var n, i = 0, a = t.selections; i < a.length; i++) {
    var o = a[i];
    if (Va(o)) {
      if (o.name.value === "__typename")
        return e[ra(o)];
    } else n ? n.push(o) : n = [o];
  }
  if (typeof e.__typename == "string")
    return e.__typename;
  if (n)
    for (var s = 0, l = n; s < l.length; s++) {
      var o = l[s], d = Z2(e, B1(o, r).selectionSet, r);
      if (typeof d == "string")
        return d;
    }
}
function Va(e) {
  return e.kind === "Field";
}
function fT(e) {
  return e.kind === "InlineFragment";
}
function Pl(e) {
  ge(e && e.kind === "Document", 116);
  var t = e.definitions.filter(function(r) {
    return r.kind !== "FragmentDefinition";
  }).map(function(r) {
    if (r.kind !== "OperationDefinition")
      throw Jr(117, r.kind);
    return r;
  });
  return ge(t.length <= 1, 118, t.length), e;
}
function Wo(e) {
  return Pl(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function Ad(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function Il(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function x8(e) {
  var t = Wo(e);
  return ge(t && t.operation === "query", 119), t;
}
function E8(e) {
  ge(e.kind === "Document", 120), ge(e.definitions.length <= 1, 121);
  var t = e.definitions[0];
  return ge(t.kind === "FragmentDefinition", 122), t;
}
function Hc(e) {
  Pl(e);
  for (var t, r = 0, n = e.definitions; r < n.length; r++) {
    var i = n[r];
    if (i.kind === "OperationDefinition") {
      var a = i.operation;
      if (a === "query" || a === "mutation" || a === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !t && (t = i);
  }
  if (t)
    return t;
  throw Jr(123);
}
function ym(e) {
  var t = /* @__PURE__ */ Object.create(null), r = e && e.variableDefinitions;
  return r && r.length && r.forEach(function(n) {
    n.defaultValue && dl(t, n.variable.name, n.defaultValue);
  }), t;
}
let Or = null;
const nv = {};
let pT = 1;
const mT = () => class {
  constructor() {
    this.id = [
      "slot",
      pT++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let t = Or; t; t = t.parent)
      if (this.id in t.slots) {
        const r = t.slots[this.id];
        if (r === nv)
          break;
        return t !== Or && (Or.slots[this.id] = r), !0;
      }
    return Or && (Or.slots[this.id] = nv), !1;
  }
  getValue() {
    if (this.hasValue())
      return Or.slots[this.id];
  }
  withValue(t, r, n, i) {
    const a = {
      __proto__: null,
      [this.id]: t
    }, o = Or;
    Or = { parent: o, slots: a };
    try {
      return r.apply(i, n);
    } finally {
      Or = o;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(t) {
    const r = Or;
    return function() {
      const n = Or;
      try {
        return Or = r, t.apply(this, arguments);
      } finally {
        Or = n;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(t, r, n) {
    if (Or) {
      const i = Or;
      try {
        return Or = null, t.apply(n, r);
      } finally {
        Or = i;
      }
    } else
      return t.apply(n, r);
  }
};
function iv(e) {
  try {
    return e();
  } catch {
  }
}
const uf = "@wry/context:Slot", gT = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  iv(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  iv(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), av = gT, Dl = av[uf] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[uf] || (function(e) {
  try {
    Object.defineProperty(av, uf, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
})(mT()), { bind: F0e, noContext: j0e } = Dl, W1 = new Dl(), { hasOwnProperty: vT } = Object.prototype, bm = Array.from || function(e) {
  const t = [];
  return e.forEach((r) => t.push(r)), t;
};
function wm(e) {
  const { unsubscribe: t } = e;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
const oc = [], yT = 100;
function cl(e, t) {
  if (!e)
    throw new Error(t || "assertion failure");
}
function S8(e, t) {
  const r = e.length;
  return (
    // Unknown values are not equal to each other.
    r > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    r === t.length && // The underlying value or exception must be the same.
    e[r - 1] === t[r - 1]
  );
}
function C8(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function T8(e) {
  return e.slice(0);
}
class K1 {
  constructor(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++K1.count;
  }
  peek() {
    if (this.value.length === 1 && !Ua(this))
      return ov(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(t) {
    return cl(!this.recomputing, "already recomputing"), ov(this), Ua(this) ? bT(this, t) : C8(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, A8(this), wm(this));
  }
  dispose() {
    this.setDirty(), N8(this), $m(this, (t, r) => {
      t.setDirty(), M8(t, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(t) {
    t.add(this), this.deps || (this.deps = oc.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }
  forgetDeps() {
    this.deps && (bm(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), oc.push(this.deps), this.deps = null);
  }
}
K1.count = 0;
function ov(e) {
  const t = W1.getValue();
  if (t)
    return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), Ua(e) ? P8(t, e) : I8(t, e), t;
}
function bT(e, t) {
  return N8(e), W1.withValue(e, wT, [e, t]), kT(e, t) && $T(e), C8(e.value);
}
function wT(e, t) {
  e.recomputing = !0;
  const { normalizeResult: r } = e;
  let n;
  r && e.value.length === 1 && (n = T8(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, t), r && n && !S8(n, e.value))
      try {
        e.value[0] = r(e.value[0], n[0]);
      } catch {
      }
  } catch (i) {
    e.value[1] = i;
  }
  e.recomputing = !1;
}
function Ua(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function $T(e) {
  e.dirty = !1, !Ua(e) && O8(e);
}
function A8(e) {
  $m(e, P8);
}
function O8(e) {
  $m(e, I8);
}
function $m(e, t) {
  const r = e.parents.size;
  if (r) {
    const n = bm(e.parents);
    for (let i = 0; i < r; ++i)
      t(n[i], e);
  }
}
function P8(e, t) {
  cl(e.childValues.has(t)), cl(Ua(t));
  const r = !Ua(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = oc.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(t))
    return;
  e.dirtyChildren.add(t), r && A8(e);
}
function I8(e, t) {
  cl(e.childValues.has(t)), cl(!Ua(t));
  const r = e.childValues.get(t);
  r.length === 0 ? e.childValues.set(t, T8(t.value)) : S8(r, t.value) || e.setDirty(), D8(e, t), !Ua(e) && O8(e);
}
function D8(e, t) {
  const r = e.dirtyChildren;
  r && (r.delete(t), r.size === 0 && (oc.length < yT && oc.push(r), e.dirtyChildren = null));
}
function N8(e) {
  e.childValues.size > 0 && e.childValues.forEach((t, r) => {
    M8(e, r);
  }), e.forgetDeps(), cl(e.dirtyChildren === null);
}
function M8(e, t) {
  t.parents.delete(e), e.childValues.delete(t), D8(e, t);
}
function kT(e, t) {
  if (typeof e.subscribe == "function")
    try {
      wm(e), e.unsubscribe = e.subscribe.apply(null, t);
    } catch {
      return e.setDirty(), !1;
    }
  return !0;
}
const _T = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function R8(e) {
  const t = /* @__PURE__ */ new Map();
  function r(n) {
    const i = W1.getValue();
    if (i) {
      let a = t.get(n);
      a || t.set(n, a = /* @__PURE__ */ new Set()), i.dependOn(a);
    }
  }
  return r.dirty = function(i, a) {
    const o = t.get(i);
    if (o) {
      const s = a && vT.call(_T, a) ? a : "setDirty";
      bm(o).forEach((l) => l[s]()), t.delete(i), wm(o);
    }
  }, r;
}
let sv;
function xT(...e) {
  return (sv || (sv = new da(typeof WeakMap == "function"))).lookupArray(e);
}
const hf = /* @__PURE__ */ new Set();
function sc(e, { max: t = Math.pow(2, 16), keyArgs: r, makeCacheKey: n = xT, normalizeResult: i, subscribe: a, cache: o = Q2 } = /* @__PURE__ */ Object.create(null)) {
  const s = typeof o == "function" ? new o(t, (h) => h.dispose()) : o, l = function() {
    const h = n.apply(null, r ? r.apply(null, arguments) : arguments);
    if (h === void 0)
      return e.apply(null, arguments);
    let f = s.get(h);
    f || (s.set(h, f = new K1(e)), f.normalizeResult = i, f.subscribe = a, f.forget = () => s.delete(h));
    const p = f.recompute(Array.prototype.slice.call(arguments));
    return s.set(h, f), hf.add(s), W1.hasValue() || (hf.forEach((m) => m.clean()), hf.clear()), p;
  };
  Object.defineProperty(l, "size", {
    get: () => s.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(l.options = {
    max: t,
    keyArgs: r,
    makeCacheKey: n,
    normalizeResult: i,
    subscribe: a,
    cache: s
  });
  function d(h) {
    const f = h && s.get(h);
    f && f.setDirty();
  }
  l.dirtyKey = d, l.dirty = function() {
    d(n.apply(null, arguments));
  };
  function c(h) {
    const f = h && s.get(h);
    if (f)
      return f.peek();
  }
  l.peekKey = c, l.peek = function() {
    return c(n.apply(null, arguments));
  };
  function u(h) {
    return h ? s.delete(h) : !1;
  }
  return l.forgetKey = u, l.forget = function() {
    return u(n.apply(null, arguments));
  }, l.makeCacheKey = n, l.getKey = r ? function() {
    return n.apply(null, r.apply(null, arguments));
  } : n, Object.freeze(l);
}
function ET(e) {
  return e;
}
var L8 = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = /* @__PURE__ */ Object.create(null)), this.resultCache = vm ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, r.getCacheKey && (this.getCacheKey = r.getCacheKey), this.cached = r.cache !== !1, this.resetCache();
    }
    return e.prototype.getCacheKey = function(t) {
      return [t];
    }, e.identity = function() {
      return new e(ET, { cache: !1 });
    }, e.split = function(t, r, n) {
      return n === void 0 && (n = e.identity()), Object.assign(new e(
        function(i) {
          var a = t(i) ? r : n;
          return a.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: r, right: n });
    }, e.prototype.resetCache = function() {
      var t = this;
      if (this.cached) {
        var r = new da(as);
        this.performWork = sc(e.prototype.performWork.bind(this), {
          makeCacheKey: function(n) {
            var i = t.getCacheKey(n);
            if (i)
              return ge(Array.isArray(i), 105), r.lookupArray(i);
          },
          max: ta["documentTransform.cache"],
          cache: B0
        });
      }
    }, e.prototype.performWork = function(t) {
      return Pl(t), this.transform(t);
    }, e.prototype.transformDocument = function(t) {
      if (this.resultCache.has(t))
        return t;
      var r = this.performWork(t);
      return this.resultCache.add(r), r;
    }, e.prototype.concat = function(t) {
      var r = this;
      return Object.assign(new e(
        function(n) {
          return t.transformDocument(r.transformDocument(n));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: t
      });
    }, e;
  })()
), Ud, Mo = Object.assign(function(e) {
  var t = Ud.get(e);
  return t || (t = xC(e), Ud.set(e, t)), t;
}, {
  reset: function() {
    Ud = new y8(
      ta.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
Mo.reset();
globalThis.__DEV__ !== !1 && b8("print", function() {
  return Ud ? Ud.size : 0;
});
var nr = Array.isArray;
function Ni(e) {
  return Array.isArray(e) && e.length > 0;
}
var lv = {
  kind: ue.FIELD,
  name: {
    kind: ue.NAME,
    value: "__typename"
  }
};
function F8(e, t) {
  return !e || e.selectionSet.selections.every(function(r) {
    return r.kind === ue.FRAGMENT_SPREAD && F8(t[r.name.value], t);
  });
}
function ST(e) {
  return F8(Wo(e) || E8(e), Ol(Il(e))) ? null : e;
}
function CT(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    n && (n.name ? t.set(n.name, n) : n.test && r.set(n.test, n));
  }), function(n) {
    var i = t.get(n.name.value);
    return !i && r.size && r.forEach(function(a, o) {
      o(n) && (i = a);
    }), i;
  };
}
function dv(e) {
  var t = /* @__PURE__ */ new Map();
  return function(n) {
    n === void 0 && (n = e);
    var i = t.get(n);
    return i || t.set(n, i = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), i;
  };
}
function j8(e, t) {
  Pl(t);
  for (var r = dv(""), n = dv(""), i = function(g) {
    for (var w = 0, $ = void 0; w < g.length && ($ = g[w]); ++w)
      if (!nr($)) {
        if ($.kind === ue.OPERATION_DEFINITION)
          return r($.name && $.name.value);
        if ($.kind === ue.FRAGMENT_DEFINITION)
          return n($.name.value);
      }
    return globalThis.__DEV__ !== !1 && ge.error(125), null;
  }, a = 0, o = t.definitions.length - 1; o >= 0; --o)
    t.definitions[o].kind === ue.OPERATION_DEFINITION && ++a;
  var s = CT(e), l = function(g) {
    return Ni(g) && g.map(s).some(function(w) {
      return w && w.remove;
    });
  }, d = /* @__PURE__ */ new Map(), c = !1, u = {
    enter: function(g) {
      if (l(g.directives))
        return c = !0, null;
    }
  }, h = li(t, {
    // These two AST node types share the same implementation, defined above.
    Field: u,
    InlineFragment: u,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(g, w, $, _, x) {
        var S = i(x);
        S && S.variables.add(g.name.value);
      }
    },
    FragmentSpread: {
      enter: function(g, w, $, _, x) {
        if (l(g.directives))
          return c = !0, null;
        var S = i(x);
        S && S.fragmentSpreads.add(g.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(g, w, $, _) {
        d.set(JSON.stringify(_), g);
      },
      leave: function(g, w, $, _) {
        var x = d.get(JSON.stringify(_));
        if (g === x)
          return g;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          a > 0 && g.selectionSet.selections.every(function(S) {
            return S.kind === ue.FIELD && S.name.value === "__typename";
          })
        )
          return n(g.name.value).removed = !0, c = !0, null;
      }
    },
    Directive: {
      leave: function(g) {
        if (s(g))
          return c = !0, null;
      }
    }
  });
  if (!c)
    return t;
  var f = function(g) {
    return g.transitiveVars || (g.transitiveVars = new Set(g.variables), g.removed || g.fragmentSpreads.forEach(function(w) {
      f(n(w)).transitiveVars.forEach(function($) {
        g.transitiveVars.add($);
      });
    })), g;
  }, p = /* @__PURE__ */ new Set();
  h.definitions.forEach(function(g) {
    g.kind === ue.OPERATION_DEFINITION ? f(r(g.name && g.name.value)).fragmentSpreads.forEach(function(w) {
      p.add(w);
    }) : g.kind === ue.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    a === 0 && !n(g.name.value).removed && p.add(g.name.value);
  }), p.forEach(function(g) {
    f(n(g)).fragmentSpreads.forEach(function(w) {
      p.add(w);
    });
  });
  var m = function(g) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!p.has(g) || n(g).removed);
  }, y = {
    enter: function(g) {
      if (m(g.name.value))
        return null;
    }
  };
  return ST(li(h, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: y,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: y,
    OperationDefinition: {
      leave: function(g) {
        if (g.variableDefinitions) {
          var w = f(
            // If an operation is anonymous, we use the empty string as its key.
            r(g.name && g.name.value)
          ).transitiveVars;
          if (w.size < g.variableDefinitions.length)
            return F(F({}, g), { variableDefinitions: g.variableDefinitions.filter(function($) {
              return w.has($.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var km = Object.assign(function(e) {
  return li(e, {
    SelectionSet: {
      enter: function(t, r, n) {
        if (!(n && n.kind === ue.OPERATION_DEFINITION)) {
          var i = t.selections;
          if (i) {
            var a = i.some(function(s) {
              return Va(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!a) {
              var o = n;
              if (!(Va(o) && o.directives && o.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return F(F({}, t), { selections: Nr(Nr([], i, !0), [lv], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === lv;
  }
});
function TT(e) {
  var t = Hc(e), r = t.operation;
  if (r === "query")
    return e;
  var n = li(e, {
    OperationDefinition: {
      enter: function(i) {
        return F(F({}, i), { operation: "query" });
      }
    }
  });
  return n;
}
function z8(e) {
  Pl(e);
  var t = j8([
    {
      test: function(r) {
        return r.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return t;
}
function AT(e) {
  return Pl(e), li(e, {
    FragmentSpread: function(t) {
      var r;
      if (!(!((r = t.directives) === null || r === void 0) && r.some(function(n) {
        return n.name.value === "unmask";
      })))
        return F(F({}, t), { directives: Nr(Nr([], t.directives || [], !0), [
          {
            kind: ue.DIRECTIVE,
            name: { kind: ue.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var OT = Object.prototype.hasOwnProperty;
function cv() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Q1(e);
}
function Q1(e) {
  var t = e[0] || {}, r = e.length;
  if (r > 1)
    for (var n = new qa(), i = 1; i < r; ++i)
      t = n.merge(t, e[i]);
  return t;
}
var PT = function(e, t, r) {
  return this.merge(e[r], t[r]);
}, qa = (
  /** @class */
  (function() {
    function e(t) {
      t === void 0 && (t = PT), this.reconciler = t, this.isObject = rr, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(t, r) {
      for (var n = this, i = [], a = 2; a < arguments.length; a++)
        i[a - 2] = arguments[a];
      return rr(r) && rr(t) ? (Object.keys(r).forEach(function(o) {
        if (OT.call(t, o)) {
          var s = t[o];
          if (r[o] !== s) {
            var l = n.reconciler.apply(n, Nr([
              t,
              r,
              o
            ], i, !1));
            l !== s && (t = n.shallowCopyForMerge(t), t[o] = l);
          }
        } else
          t = n.shallowCopyForMerge(t), t[o] = r[o];
      }), t) : r;
    }, e.prototype.shallowCopyForMerge = function(t) {
      return rr(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = F({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
    }, e;
  })()
);
function IT(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = DT(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function DT(e, t) {
  if (e) {
    if (typeof e == "string") return uv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return uv(e, t);
  }
}
function uv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function hv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function _m(e, t, r) {
  return t && hv(e.prototype, t), r && hv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var xm = function() {
  return typeof Symbol == "function";
}, Em = function(e) {
  return xm() && !!Symbol[e];
}, Sm = function(e) {
  return Em(e) ? Symbol[e] : "@@" + e;
};
xm() && !Em("observable") && (Symbol.observable = /* @__PURE__ */ Symbol("observable"));
var NT = Sm("iterator"), X2 = Sm("observable"), V8 = Sm("species");
function H0(e, t) {
  var r = e[t];
  if (r != null) {
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    return r;
  }
}
function id(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[V8], t === null && (t = void 0)), t !== void 0 ? t : Mt;
}
function MT(e) {
  return e instanceof Mt;
}
function ul(e) {
  ul.log ? ul.log(e) : setTimeout(function() {
    throw e;
  });
}
function s0(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      ul(t);
    }
  });
}
function U8(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var r = H0(t, "unsubscribe");
        r && r.call(t);
      }
    } catch (n) {
      ul(n);
    }
}
function ep(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function RT(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var r = 0; r < t.length && (q8(e, t[r].type, t[r].value), e._state !== "closed"); ++r)
      ;
  }
}
function q8(e, t, r) {
  e._state = "running";
  var n = e._observer;
  try {
    var i = H0(n, t);
    switch (t) {
      case "next":
        i && i.call(n, r);
        break;
      case "error":
        if (ep(e), i) i.call(n, r);
        else throw r;
        break;
      case "complete":
        ep(e), i && i.call(n);
        break;
    }
  } catch (a) {
    ul(a);
  }
  e._state === "closed" ? U8(e) : e._state === "running" && (e._state = "ready");
}
function ff(e, t, r) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: r
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: r
      }], s0(function() {
        return RT(e);
      });
      return;
    }
    q8(e, t, r);
  }
}
var LT = /* @__PURE__ */ (function() {
  function e(r, n) {
    this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
    var i = new FT(this);
    try {
      this._cleanup = n.call(void 0, i);
    } catch (a) {
      i.error(a);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (ep(this), U8(this));
  }, _m(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
})(), FT = /* @__PURE__ */ (function() {
  function e(r) {
    this._subscription = r;
  }
  var t = e.prototype;
  return t.next = function(n) {
    ff(this._subscription, "next", n);
  }, t.error = function(n) {
    ff(this._subscription, "error", n);
  }, t.complete = function() {
    ff(this._subscription, "complete");
  }, _m(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
})(), Mt = /* @__PURE__ */ (function() {
  function e(r) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof r != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = r;
  }
  var t = e.prototype;
  return t.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new LT(n, this._subscriber);
  }, t.forEach = function(n) {
    var i = this;
    return new Promise(function(a, o) {
      if (typeof n != "function") {
        o(new TypeError(n + " is not a function"));
        return;
      }
      function s() {
        l.unsubscribe(), a();
      }
      var l = i.subscribe({
        next: function(d) {
          try {
            n(d, s);
          } catch (c) {
            o(c), l.unsubscribe();
          }
        },
        error: o,
        complete: a
      });
    });
  }, t.map = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = id(this);
    return new a(function(o) {
      return i.subscribe({
        next: function(s) {
          try {
            s = n(s);
          } catch (l) {
            return o.error(l);
          }
          o.next(s);
        },
        error: function(s) {
          o.error(s);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.filter = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = id(this);
    return new a(function(o) {
      return i.subscribe({
        next: function(s) {
          try {
            if (!n(s)) return;
          } catch (l) {
            return o.error(l);
          }
          o.next(s);
        },
        error: function(s) {
          o.error(s);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.reduce = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = id(this), o = arguments.length > 1, s = !1, l = arguments[1], d = l;
    return new a(function(c) {
      return i.subscribe({
        next: function(u) {
          var h = !s;
          if (s = !0, !h || o)
            try {
              d = n(d, u);
            } catch (f) {
              return c.error(f);
            }
          else
            d = u;
        },
        error: function(u) {
          c.error(u);
        },
        complete: function() {
          if (!s && !o) return c.error(new TypeError("Cannot reduce an empty sequence"));
          c.next(d), c.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var n = this, i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    var s = id(this);
    return new s(function(l) {
      var d, c = 0;
      function u(h) {
        d = h.subscribe({
          next: function(f) {
            l.next(f);
          },
          error: function(f) {
            l.error(f);
          },
          complete: function() {
            c === a.length ? (d = void 0, l.complete()) : u(s.from(a[c++]));
          }
        });
      }
      return u(n), function() {
        d && (d.unsubscribe(), d = void 0);
      };
    });
  }, t.flatMap = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = id(this);
    return new a(function(o) {
      var s = [], l = i.subscribe({
        next: function(c) {
          if (n)
            try {
              c = n(c);
            } catch (h) {
              return o.error(h);
            }
          var u = a.from(c).subscribe({
            next: function(h) {
              o.next(h);
            },
            error: function(h) {
              o.error(h);
            },
            complete: function() {
              var h = s.indexOf(u);
              h >= 0 && s.splice(h, 1), d();
            }
          });
          s.push(u);
        },
        error: function(c) {
          o.error(c);
        },
        complete: function() {
          d();
        }
      });
      function d() {
        l.closed && s.length === 0 && o.complete();
      }
      return function() {
        s.forEach(function(c) {
          return c.unsubscribe();
        }), l.unsubscribe();
      };
    });
  }, t[X2] = function() {
    return this;
  }, e.from = function(n) {
    var i = typeof this == "function" ? this : e;
    if (n == null) throw new TypeError(n + " is not an object");
    var a = H0(n, X2);
    if (a) {
      var o = a.call(n);
      if (Object(o) !== o) throw new TypeError(o + " is not an object");
      return MT(o) && o.constructor === i ? o : new i(function(s) {
        return o.subscribe(s);
      });
    }
    if (Em("iterator") && (a = H0(n, NT), a))
      return new i(function(s) {
        s0(function() {
          if (!s.closed) {
            for (var l = IT(a.call(n)), d; !(d = l()).done; ) {
              var c = d.value;
              if (s.next(c), s.closed) return;
            }
            s.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new i(function(s) {
        s0(function() {
          if (!s.closed) {
            for (var l = 0; l < n.length; ++l)
              if (s.next(n[l]), s.closed) return;
            s.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, e.of = function() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    var o = typeof this == "function" ? this : e;
    return new o(function(s) {
      s0(function() {
        if (!s.closed) {
          for (var l = 0; l < i.length; ++l)
            if (s.next(i[l]), s.closed) return;
          s.complete();
        }
      });
    });
  }, _m(e, null, [{
    key: V8,
    get: function() {
      return this;
    }
  }]), e;
})();
xm() && Object.defineProperty(Mt, /* @__PURE__ */ Symbol("extensions"), {
  value: {
    symbol: X2,
    hostReportError: ul
  },
  configurable: !0
});
function jT(e) {
  var t, r = e.Symbol;
  if (typeof r == "function")
    if (r.observable)
      t = r.observable;
    else {
      typeof r.for == "function" ? t = r.for("https://github.com/benlesh/symbol-observable") : t = r("https://github.com/benlesh/symbol-observable");
      try {
        r.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var $s;
typeof self < "u" ? $s = self : typeof window < "u" ? $s = window : typeof global < "u" ? $s = global : typeof module < "u" ? $s = module : $s = Function("return this")();
jT($s);
var fv = Mt.prototype, pv = "@@observable";
fv[pv] || (fv[pv] = function() {
  return this;
});
function zT(e) {
  return e.catch(function() {
  }), e;
}
var VT = Object.prototype.toString;
function B8(e) {
  return tp(e);
}
function tp(e, t) {
  switch (VT.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = e.slice(0);
      return t.set(e, r), r.forEach(function(i, a) {
        r[a] = tp(i, t);
      }), r;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var n = Object.create(Object.getPrototypeOf(e));
      return t.set(e, n), Object.keys(e).forEach(function(i) {
        n[i] = tp(e[i], t);
      }), n;
    }
    default:
      return e;
  }
}
function UT(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(r) {
    rr(r) && qT(r) === r && Object.getOwnPropertyNames(r).forEach(function(n) {
      rr(r[n]) && t.add(r[n]);
    });
  }), e;
}
function qT(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function W0(e) {
  return globalThis.__DEV__ !== !1 && UT(e), e;
}
function qd(e, t, r) {
  var n = [];
  e.forEach(function(i) {
    return i[t] && n.push(i);
  }), n.forEach(function(i) {
    return i[t](r);
  });
}
function pf(e, t, r) {
  return new Mt(function(n) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(l) {
        return new Promise(function(d) {
          return d(l());
        });
      }
    };
    function a(l, d) {
      return function(c) {
        if (l) {
          var u = function() {
            return n.closed ? (
              /* will be swallowed */
              0
            ) : l(c);
          };
          i = i.then(u, u).then(function(h) {
            return n.next(h);
          }, function(h) {
            return n.error(h);
          });
        } else
          n[d](c);
      };
    }
    var o = {
      next: a(t, "next"),
      error: a(r, "error"),
      complete: function() {
        i.then(function() {
          return n.complete();
        });
      }
    }, s = e.subscribe(o);
    return function() {
      return s.unsubscribe();
    };
  });
}
function H8(e) {
  function t(r) {
    Object.defineProperty(e, r, { value: Mt });
  }
  return g8 && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function mv(e) {
  return e && typeof e.then == "function";
}
var ks = (
  /** @class */
  (function(e) {
    Li(t, e);
    function t(r) {
      var n = e.call(this, function(i) {
        return n.addObserver(i), function() {
          return n.removeObserver(i);
        };
      }) || this;
      return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, a) {
        n.resolve = i, n.reject = a;
      }), n.handlers = {
        next: function(i) {
          n.sub !== null && (n.latest = ["next", i], n.notify("next", i), qd(n.observers, "next", i));
        },
        error: function(i) {
          var a = n.sub;
          a !== null && (a && setTimeout(function() {
            return a.unsubscribe();
          }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), qd(n.observers, "error", i));
        },
        complete: function() {
          var i = n, a = i.sub, o = i.sources, s = o === void 0 ? [] : o;
          if (a !== null) {
            var l = s.shift();
            l ? mv(l) ? l.then(function(d) {
              return n.sub = d.subscribe(n.handlers);
            }, n.handlers.error) : n.sub = l.subscribe(n.handlers) : (a && setTimeout(function() {
              return a.unsubscribe();
            }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), qd(n.observers, "complete"));
          }
        }
      }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
        n.reject(i), n.sources = [], n.handlers.error(i);
      }, n.promise.catch(function(i) {
      }), typeof r == "function" && (r = [new Mt(r)]), mv(r) ? r.then(function(i) {
        return n.start(i);
      }, n.handlers.error) : n.start(r), n;
    }
    return t.prototype.start = function(r) {
      this.sub === void 0 && (this.sources = Array.from(r), this.handlers.complete());
    }, t.prototype.deliverLastMessage = function(r) {
      if (this.latest) {
        var n = this.latest[0], i = r[n];
        i && i.call(r, this.latest[1]), this.sub === null && n === "next" && r.complete && r.complete();
      }
    }, t.prototype.addObserver = function(r) {
      this.observers.has(r) || (this.deliverLastMessage(r), this.observers.add(r));
    }, t.prototype.removeObserver = function(r) {
      this.observers.delete(r) && this.observers.size < 1 && this.handlers.complete();
    }, t.prototype.notify = function(r, n) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(a) {
        return a(r, n);
      }));
    }, t.prototype.beforeNext = function(r) {
      var n = !1;
      this.nextResultListeners.add(function(i, a) {
        n || (n = !0, r(i, a));
      });
    }, t;
  })(Mt)
);
H8(ks);
function Gs(e) {
  return "incremental" in e;
}
function BT(e) {
  return "hasNext" in e && "data" in e;
}
function HT(e) {
  return Gs(e) || BT(e);
}
function WT(e) {
  return rr(e) && "payload" in e;
}
function W8(e, t) {
  var r = e, n = new qa();
  return Gs(t) && Ni(t.incremental) && t.incremental.forEach(function(i) {
    for (var a = i.data, o = i.path, s = o.length - 1; s >= 0; --s) {
      var l = o[s], d = !isNaN(+l), c = d ? [] : {};
      c[l] = a, a = c;
    }
    r = n.merge(r, a);
  }), r;
}
function l0(e) {
  var t = rp(e);
  return Ni(t);
}
function rp(e) {
  var t = Ni(e.errors) ? e.errors.slice(0) : [];
  return Gs(e) && Ni(e.incremental) && e.incremental.forEach(function(r) {
    r.errors && t.push.apply(t, r.errors);
  }), t;
}
function hl() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(n) {
    n && Object.keys(n).forEach(function(i) {
      var a = n[i];
      a !== void 0 && (r[i] = a);
    });
  }), r;
}
function mf(e, t) {
  return hl(e, t, t.variables && {
    variables: hl(F(F({}, e && e.variables), t.variables))
  });
}
function gf(e) {
  return new Mt(function(t) {
    t.error(e);
  });
}
var K8 = function(e, t, r) {
  var n = new Error(r);
  throw n.name = "ServerError", n.response = e, n.statusCode = e.status, n.result = t, n;
};
function KT(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], r = 0, n = Object.keys(e); r < n.length; r++) {
    var i = n[r];
    if (t.indexOf(i) < 0)
      throw Jr(58, i);
  }
  return e;
}
function QT(e, t) {
  var r = F({}, e), n = function(a) {
    typeof a == "function" ? r = F(F({}, r), a(r)) : r = F(F({}, r), a);
  }, i = function() {
    return F({}, r);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: i
  }), t;
}
function GT(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? Ad(t.query) || void 0 : ""), t;
}
function YT(e, t) {
  var r = F({}, e), n = new Set(Object.keys(e));
  return li(t, {
    Variable: function(i, a, o) {
      o && o.kind !== "VariableDefinition" && n.delete(i.name.value);
    }
  }), n.forEach(function(i) {
    delete r[i];
  }), r;
}
var JT = /* @__PURE__ */ Symbol.for("apollo.deprecations"), ZT = q0, np = new Dl();
function XT(e) {
  return ZT[JT] || (np.getValue() || []).includes(e);
}
function zr(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return np.withValue.apply(np, Nr([Array.isArray(e) ? e : [e]], t, !1));
}
function ar(e, t, r, n) {
  n === void 0 && (n = "Please remove this option."), Oo(t, function() {
    t in e && globalThis.__DEV__ !== !1 && ge.warn(104, r, t, n);
  });
}
function Oo(e, t) {
  XT(e) || t();
}
function gv(e, t) {
  return t ? t(e) : Mt.of();
}
function ad(e) {
  return typeof e == "function" ? new Nl(e) : e;
}
function Tu(e) {
  return e.request.length <= 1;
}
var Nl = (
  /** @class */
  (function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return Mt.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(ad).reduce(function(r, n) {
        return r.concat(n);
      });
    }, e.split = function(t, r, n) {
      var i = ad(r), a = ad(n || new e(gv)), o;
      return Tu(i) && Tu(a) ? o = new e(function(s) {
        return t(s) ? i.request(s) || Mt.of() : a.request(s) || Mt.of();
      }) : o = new e(function(s, l) {
        return t(s) ? i.request(s, l) || Mt.of() : a.request(s, l) || Mt.of();
      }), Object.assign(o, { left: i, right: a });
    }, e.execute = function(t, r) {
      return t.request(QT(r.context, GT(KT(r)))) || Mt.of();
    }, e.concat = function(t, r) {
      var n = ad(t);
      if (Tu(n))
        return globalThis.__DEV__ !== !1 && ge.warn(47, n), n;
      var i = ad(r), a;
      return Tu(i) ? a = new e(function(o) {
        return n.request(o, function(s) {
          return i.request(s) || Mt.of();
        }) || Mt.of();
      }) : a = new e(function(o, s) {
        return n.request(o, function(l) {
          return i.request(l, s) || Mt.of();
        }) || Mt.of();
      }), Object.assign(a, { left: n, right: i });
    }, e.prototype.split = function(t, r, n) {
      return this.concat(e.split(t, r, n || new e(gv)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, r) {
      throw Jr(48);
    }, e.prototype.onError = function(t, r) {
      if (globalThis.__DEV__ !== !1 && Oo("onError", function() {
        globalThis.__DEV__ !== !1 && ge.warn(49);
      }), r && r.error)
        return r.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && ge.warn(50), this.onError = t, this;
    }, e;
  })()
), ip = Nl.execute;
function eA(e) {
  var t, r = e[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return r.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function tA(e) {
  var t = null, r = null, n = !1, i = [], a = [];
  function o(u) {
    if (!r) {
      if (a.length) {
        var h = a.shift();
        if (Array.isArray(h) && h[0])
          return h[0]({ value: u, done: !1 });
      }
      i.push(u);
    }
  }
  function s(u) {
    r = u;
    var h = a.slice();
    h.forEach(function(f) {
      f[1](u);
    }), !t || t();
  }
  function l() {
    n = !0;
    var u = a.slice();
    u.forEach(function(h) {
      h[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, e.removeListener("data", o), e.removeListener("error", s), e.removeListener("end", l), e.removeListener("finish", l), e.removeListener("close", l);
  }, e.on("data", o), e.on("error", s), e.on("end", l), e.on("finish", l), e.on("close", l);
  function d() {
    return new Promise(function(u, h) {
      if (r)
        return h(r);
      if (i.length)
        return u({ value: i.shift(), done: !1 });
      if (n)
        return u({ value: void 0, done: !0 });
      a.push([u, h]);
    });
  }
  var c = {
    next: function() {
      return d();
    }
  };
  return q1 && (c[Symbol.asyncIterator] = function() {
    return this;
  }), c;
}
function rA(e) {
  var t = !1, r = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(n, i) {
        e.then(function(a) {
          n({ value: a, done: !1 });
        }).catch(i);
      }));
    }
  };
  return q1 && (r[Symbol.asyncIterator] = function() {
    return this;
  }), r;
}
function vv(e) {
  var t = {
    next: function() {
      return e.read();
    }
  };
  return q1 && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function nA(e) {
  return !!e.body;
}
function iA(e) {
  return !!e.getReader;
}
function aA(e) {
  return !!(q1 && e[Symbol.asyncIterator]);
}
function oA(e) {
  return !!e.stream;
}
function sA(e) {
  return !!e.arrayBuffer;
}
function lA(e) {
  return !!e.pipe;
}
function dA(e) {
  var t = e;
  if (nA(e) && (t = e.body), aA(t))
    return eA(t);
  if (iA(t))
    return vv(t.getReader());
  if (oA(t))
    return vv(t.stream().getReader());
  if (sA(t))
    return rA(t.arrayBuffer());
  if (lA(t))
    return tA(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var Cm = /* @__PURE__ */ Symbol();
function cA(e) {
  return e.extensions ? Array.isArray(e.extensions[Cm]) : !1;
}
function Q8(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var uA = function(e) {
  var t = Nr(Nr(Nr([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(r) {
    return rr(r) && r.message || "Error message not found.";
  }).join(`
`);
}, $o = (
  /** @class */
  (function(e) {
    Li(t, e);
    function t(r) {
      var n = r.graphQLErrors, i = r.protocolErrors, a = r.clientErrors, o = r.networkError, s = r.errorMessage, l = r.extraInfo, d = e.call(this, s) || this;
      return d.name = "ApolloError", d.graphQLErrors = n || [], d.protocolErrors = i || [], d.clientErrors = a || [], d.networkError = o || null, d.message = s || uA(d), d.extraInfo = l, d.cause = Nr(Nr(Nr([
        o
      ], n || [], !0), i || [], !0), a || [], !0).find(function(c) {
        return !!c;
      }) || null, d.__proto__ = t.prototype, d;
    }
    return t;
  })(Error)
), yv = Object.prototype.hasOwnProperty;
function hA(e, t) {
  return qe(this, void 0, void 0, function() {
    var r, n, i, a, o, s, l, d, c, u, h, f, p, m, y, g, w, $, _, x, S, T, I, M;
    return ka(this, function(P) {
      switch (P.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          r = new TextDecoder("utf-8"), n = (M = e.headers) === null || M === void 0 ? void 0 : M.get("content-type"), i = "boundary=", a = n?.includes(i) ? n?.substring(n?.indexOf(i) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", o = `\r
--`.concat(a), s = "", l = dA(e), d = !0, P.label = 1;
        case 1:
          return d ? [4, l.next()] : [3, 3];
        case 2:
          for (c = P.sent(), u = c.value, h = c.done, f = typeof u == "string" ? u : r.decode(u), p = s.length - o.length + 1, d = !h, s += f, m = s.indexOf(o, p); m > -1; ) {
            if (y = void 0, T = [
              s.slice(0, m),
              s.slice(m + o.length)
            ], y = T[0], s = T[1], g = y.indexOf(`\r
\r
`), w = fA(y.slice(0, g)), $ = w["content-type"], $ && $.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (_ = y.slice(g), _) {
              if (x = G8(e, _), Object.keys(x).length > 1 || "data" in x || "incremental" in x || "errors" in x || "payload" in x)
                if (WT(x)) {
                  if (S = {}, "payload" in x) {
                    if (Object.keys(x).length === 1 && x.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    S = F({}, x.payload);
                  }
                  "errors" in x && (S = F(F({}, S), { extensions: F(F({}, "extensions" in S ? S.extensions : null), (I = {}, I[Cm] = x.errors, I)) })), t(S);
                } else
                  t(x);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(x).length === 1 && "hasNext" in x && !x.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            m = s.indexOf(o);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function fA(e) {
  var t = {};
  return e.split(`
`).forEach(function(r) {
    var n = r.indexOf(":");
    if (n > -1) {
      var i = r.slice(0, n).trim().toLowerCase(), a = r.slice(n + 1).trim();
      t[i] = a;
    }
  }), t;
}
function G8(e, t) {
  if (e.status >= 300) {
    var r = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    K8(e, r(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (i) {
    var n = i;
    throw n.name = "ServerParseError", n.response = e, n.statusCode = e.status, n.bodyText = t, n;
  }
}
function pA(e, t) {
  e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
}
function mA(e) {
  return function(t) {
    return t.text().then(function(r) {
      return G8(t, r);
    }).then(function(r) {
      return !Array.isArray(r) && !yv.call(r, "data") && !yv.call(r, "errors") && K8(t, r, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(n) {
        return n.operationName;
      }) : e.operationName, "'.")), r;
    });
  };
}
var ap = function(e, t) {
  var r;
  try {
    r = JSON.stringify(e);
  } catch (i) {
    var n = Jr(54, t, i.message);
    throw n.parseError = i, n;
  }
  return r;
}, gA = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, vA = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, yA = {
  method: "POST"
}, bA = {
  http: gA,
  headers: vA,
  options: yA
}, wA = function(e, t) {
  return t(e);
};
function $A(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var i = {}, a = {};
  r.forEach(function(u) {
    i = F(F(F({}, i), u.options), { headers: F(F({}, i.headers), u.headers) }), u.credentials && (i.credentials = u.credentials), a = F(F({}, a), u.http);
  }), i.headers && (i.headers = kA(i.headers, a.preserveHeaderCase));
  var o = e.operationName, s = e.extensions, l = e.variables, d = e.query, c = { operationName: o, variables: l };
  return a.includeExtensions && (c.extensions = s), a.includeQuery && (c.query = t(d, Mo)), {
    options: i,
    body: c
  };
}
function kA(e, t) {
  if (!t) {
    var r = {};
    return Object.keys(Object(e)).forEach(function(a) {
      r[a.toLowerCase()] = e[a];
    }), r;
  }
  var n = {};
  Object.keys(Object(e)).forEach(function(a) {
    n[a.toLowerCase()] = {
      originalName: a,
      value: e[a]
    };
  });
  var i = {};
  return Object.keys(n).forEach(function(a) {
    i[n[a].originalName] = n[a].value;
  }), i;
}
var _A = function(e) {
  if (!e && typeof fetch > "u")
    throw Jr(51);
}, xA = function(e, t) {
  var r = e.getContext(), n = r.uri;
  return n || (typeof t == "function" ? t(e) : t || "/graphql");
};
function EA(e, t) {
  var r = [], n = function(u, h) {
    r.push("".concat(u, "=").concat(encodeURIComponent(h)));
  };
  if ("query" in t && n("query", t.query), t.operationName && n("operationName", t.operationName), t.variables) {
    var i = void 0;
    try {
      i = ap(t.variables, "Variables map");
    } catch (u) {
      return { parseError: u };
    }
    n("variables", i);
  }
  if (t.extensions) {
    var a = void 0;
    try {
      a = ap(t.extensions, "Extensions map");
    } catch (u) {
      return { parseError: u };
    }
    n("extensions", a);
  }
  var o = "", s = e, l = e.indexOf("#");
  l !== -1 && (o = e.substr(l), s = e.substr(0, l));
  var d = s.indexOf("?") === -1 ? "?" : "&", c = s + d + r.join("&") + o;
  return { newURI: c };
}
var bv = Gn(function() {
  return fetch;
}), SA = function(e) {
  e === void 0 && (e = {});
  var t = e.uri, r = t === void 0 ? "/graphql" : t, n = e.fetch, i = e.print, a = i === void 0 ? wA : i, o = e.includeExtensions, s = e.preserveHeaderCase, l = e.useGETForQueries, d = e.includeUnusedVariables, c = d === void 0 ? !1 : d, u = ii(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && _A(n || bv);
  var h = {
    http: { includeExtensions: o, preserveHeaderCase: s },
    options: u.fetchOptions,
    credentials: u.credentials,
    headers: u.headers
  };
  return new Nl(function(f) {
    var p = xA(f, r), m = f.getContext(), y = {};
    if (m.clientAwareness) {
      var g = m.clientAwareness, w = g.name, $ = g.version;
      w && (y["apollographql-client-name"] = w), $ && (y["apollographql-client-version"] = $);
    }
    var _ = F(F({}, y), m.headers), x = {
      http: m.http,
      options: m.fetchOptions,
      credentials: m.credentials,
      headers: _
    };
    if (ac(["client"], f.query)) {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && ge.warn(52);
      var S = z8(f.query);
      if (!S)
        return gf(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      f.query = S;
    }
    var T = $A(f, a, bA, h, x), I = T.options, M = T.body;
    M.variables && !c && (M.variables = YT(M.variables, f.query));
    var P;
    !I.signal && typeof AbortController < "u" && (P = new AbortController(), I.signal = P.signal);
    var O = function(H) {
      return H.kind === "OperationDefinition" && H.operation === "mutation";
    }, D = function(H) {
      return H.kind === "OperationDefinition" && H.operation === "subscription";
    }, R = D(Hc(f.query)), L = ac(["defer"], f.query);
    if (l && !f.query.definitions.some(O) && (I.method = "GET"), L || R) {
      I.headers = I.headers || {};
      var Q = "multipart/mixed;";
      R && L && globalThis.__DEV__ !== !1 && ge.warn(53), R ? Q += "boundary=graphql;subscriptionSpec=1.0,application/json" : L && (Q += "deferSpec=20220824,application/json"), I.headers.accept = Q;
    }
    if (I.method === "GET") {
      var ie = EA(p, M), ee = ie.newURI, W = ie.parseError;
      if (W)
        return gf(W);
      p = ee;
    } else
      try {
        I.body = ap(M, "Payload");
      } catch (H) {
        return gf(H);
      }
    return new Mt(function(H) {
      var pe = n || Gn(function() {
        return fetch;
      }) || bv, Te = H.next.bind(H);
      return pe(p, I).then(function(Ce) {
        var de;
        f.setContext({ response: Ce });
        var K = (de = Ce.headers) === null || de === void 0 ? void 0 : de.get("content-type");
        return K !== null && /^multipart\/mixed/i.test(K) ? hA(Ce, Te) : mA(f)(Ce).then(Te);
      }).then(function() {
        P = void 0, H.complete();
      }).catch(function(Ce) {
        P = void 0, pA(Ce, H);
      }), function() {
        P && P.abort();
      };
    });
  });
}, Y8 = (
  /** @class */
  (function(e) {
    Li(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, SA(r).request) || this;
      return n.options = r, n;
    }
    return t;
  })(Nl)
);
const { toString: wv, hasOwnProperty: CA } = Object.prototype, $v = Function.prototype.toString, op = /* @__PURE__ */ new Map();
function Ft(e, t) {
  try {
    return sp(e, t);
  } finally {
    op.clear();
  }
}
function sp(e, t) {
  if (e === t)
    return !0;
  const r = wv.call(e), n = wv.call(t);
  if (r !== n)
    return !1;
  switch (r) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (_v(e, t))
        return !0;
      const i = kv(e), a = kv(t), o = i.length;
      if (o !== a.length)
        return !1;
      for (let s = 0; s < o; ++s)
        if (!CA.call(t, i[s]))
          return !1;
      for (let s = 0; s < o; ++s) {
        const l = i[s];
        if (!sp(e[l], t[l]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (_v(e, t))
        return !0;
      const i = e.entries(), a = r === "[object Map]";
      for (; ; ) {
        const o = i.next();
        if (o.done)
          break;
        const [s, l] = o.value;
        if (!t.has(s) || a && !sp(l, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    // Fall through...
    case "[object DataView]": {
      let i = e.byteLength;
      if (i === t.byteLength)
        for (; i-- && e[i] === t[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = $v.call(e);
      return i !== $v.call(t) ? !1 : !OA(i, AA);
    }
  }
  return !1;
}
function kv(e) {
  return Object.keys(e).filter(TA, e);
}
function TA(e) {
  return this[e] !== void 0;
}
const AA = "{ [native code] }";
function OA(e, t) {
  const r = e.length - t.length;
  return r >= 0 && e.indexOf(t, r) === r;
}
function _v(e, t) {
  let r = op.get(e);
  if (r) {
    if (r.has(t))
      return !0;
  } else
    op.set(e, r = /* @__PURE__ */ new Set());
  return r.add(t), !1;
}
function J8(e, t, r, n) {
  var i = t.data, a = ii(t, ["data"]), o = r.data, s = ii(r, ["data"]);
  return Ft(a, s) && d0(Hc(e).selectionSet, i, o, {
    fragmentMap: Ol(Il(e)),
    variables: n
  });
}
function d0(e, t, r, n) {
  if (t === r)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return e.selections.every(function(a) {
    if (i.has(a) || (i.add(a), !Bc(a, n.variables)) || xv(a))
      return !0;
    if (Va(a)) {
      var o = ra(a), s = t && t[o], l = r && r[o], d = a.selectionSet;
      if (!d)
        return Ft(s, l);
      var c = Array.isArray(s), u = Array.isArray(l);
      if (c !== u)
        return !1;
      if (c && u) {
        var h = s.length;
        if (l.length !== h)
          return !1;
        for (var f = 0; f < h; ++f)
          if (!d0(d, s[f], l[f], n))
            return !1;
        return !0;
      }
      return d0(d, s, l, n);
    } else {
      var p = B1(a, n.fragmentMap);
      if (p)
        return xv(p) ? !0 : d0(
          p.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          r,
          n
        );
    }
  });
}
function xv(e) {
  return !!e.directives && e.directives.some(PA);
}
function PA(e) {
  return e.name.value === "nonreactive";
}
var Z8 = as ? WeakMap : Map, X8 = vm ? WeakSet : Set, Tm = new Dl(), Ev = !1;
function eb() {
  Ev || (Ev = !0, globalThis.__DEV__ !== !1 && ge.warn(64));
}
function tb(e, t, r) {
  return Tm.withValue(!0, function() {
    var n = Od(e, t, r, !1);
    return Object.isFrozen(e) && W0(n), n;
  });
}
function IA(e, t) {
  if (t.has(e))
    return t.get(e);
  var r = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
  return t.set(e, r), r;
}
function Od(e, t, r, n, i) {
  var a, o = r.knownChanged, s = IA(e, r.mutableTargets);
  if (Array.isArray(e)) {
    for (var l = 0, d = Array.from(e.entries()); l < d.length; l++) {
      var c = d[l], u = c[0], h = c[1];
      if (h === null) {
        s[u] = null;
        continue;
      }
      var f = Od(h, t, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(u, "]") : void 0);
      o.has(f) && o.add(s), s[u] = f;
    }
    return o.has(s) ? s : e;
  }
  for (var p = 0, m = t.selections; p < m.length; p++) {
    var y = m[p], g = void 0;
    if (n && o.add(s), y.kind === ue.FIELD) {
      var w = ra(y), $ = y.selectionSet;
      if (g = s[w] || e[w], g === void 0)
        continue;
      if ($ && g !== null) {
        var f = Od(e[w], $, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat(w) : void 0);
        o.has(f) && (g = f);
      }
      globalThis.__DEV__ === !1 && (s[w] = g), globalThis.__DEV__ !== !1 && (n && w !== "__typename" && // either the field is not present in the memo object
      // or it has a `get` descriptor, not a `value` descriptor
      // => it is a warning accessor and we can overwrite it
      // with another accessor
      !(!((a = Object.getOwnPropertyDescriptor(s, w)) === null || a === void 0) && a.value) ? Object.defineProperty(s, w, DA(w, g, i || "", r.operationName, r.operationType)) : (delete s[w], s[w] = g));
    }
    if (y.kind === ue.INLINE_FRAGMENT && (!y.typeCondition || r.cache.fragmentMatches(y, e.__typename)) && (g = Od(e, y.selectionSet, r, n, i)), y.kind === ue.FRAGMENT_SPREAD) {
      var _ = y.name.value, x = r.fragmentMap[_] || (r.fragmentMap[_] = r.cache.lookupFragment(_));
      ge(x, 59, _);
      var S = OC(y);
      S !== "mask" && (g = Od(e, x.selectionSet, r, S === "migrate", i));
    }
    o.has(g) && o.add(s);
  }
  return "__typename" in e && !("__typename" in s) && (s.__typename = e.__typename), Object.keys(s).length !== Object.keys(e).length && o.add(s), o.has(s) ? s : e;
}
function DA(e, t, r, n, i) {
  var a = function() {
    return Tm.getValue() || (globalThis.__DEV__ !== !1 && ge.warn(60, n ? "".concat(i, " '").concat(n, "'") : "anonymous ".concat(i), "".concat(r, ".").concat(e).replace(/^\./, "")), a = function() {
      return t;
    }), t;
  };
  return {
    get: function() {
      return a();
    },
    set: function(o) {
      a = function() {
        return o;
      };
    },
    enumerable: !0,
    configurable: !0
  };
}
function rb(e, t, r, n) {
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && eb(), e;
  var i = t.definitions.filter(function(o) {
    return o.kind === ue.FRAGMENT_DEFINITION;
  });
  typeof n > "u" && (ge(i.length === 1, 61, i.length), n = i[0].name.value);
  var a = i.find(function(o) {
    return o.name.value === n;
  });
  return ge(!!a, 62, n), e == null || Ft(e, {}) ? e : tb(e, a.selectionSet, {
    operationType: "fragment",
    operationName: a.name.value,
    fragmentMap: Ol(Il(t)),
    cache: r,
    mutableTargets: new Z8(),
    knownChanged: new X8()
  });
}
function NA(e, t, r) {
  var n;
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && eb(), e;
  var i = Wo(t);
  return ge(i, 63), e == null ? e : tb(e, i.selectionSet, {
    operationType: i.operation,
    operationName: (n = i.name) === null || n === void 0 ? void 0 : n.value,
    fragmentMap: Ol(Il(t)),
    cache: r,
    mutableTargets: new Z8(),
    knownChanged: new X8()
  });
}
var nb = (
  /** @class */
  (function() {
    function e() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = sc(RC, {
        max: ta["cache.fragmentQueryDocuments"] || 1e3,
        cache: B0
      });
    }
    return e.prototype.lookupFragment = function(t) {
      return null;
    }, e.prototype.batch = function(t) {
      var r = this, n = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0, i;
      return this.performTransaction(function() {
        return i = t.update(r);
      }, n), i;
    }, e.prototype.recordOptimisticTransaction = function(t, r) {
      this.performTransaction(t, r);
    }, e.prototype.transformDocument = function(t) {
      return t;
    }, e.prototype.transformForLink = function(t) {
      return t;
    }, e.prototype.identify = function(t) {
    }, e.prototype.gc = function() {
      return [];
    }, e.prototype.modify = function(t) {
      return !1;
    }, e.prototype.readQuery = function(t, r) {
      var n = this;
      return r === void 0 && (r = !!t.optimistic), globalThis.__DEV__ !== !1 && ar(t, "canonizeResults", "cache.readQuery"), zr("canonizeResults", function() {
        return n.read(F(F({}, t), { rootId: t.id || "ROOT_QUERY", optimistic: r }));
      });
    }, e.prototype.watchFragment = function(t) {
      var r = this, n = t.fragment, i = t.fragmentName, a = t.from, o = t.optimistic, s = o === void 0 ? !0 : o, l = ii(t, ["fragment", "fragmentName", "from", "optimistic"]), d = this.getFragmentDoc(n, i), c = typeof a > "u" || typeof a == "string" ? a : this.identify(a), u = !!t[/* @__PURE__ */ Symbol.for("apollo.dataMasking")];
      if (globalThis.__DEV__ !== !1) {
        var h = i || E8(n).name.value;
        c || globalThis.__DEV__ !== !1 && ge.warn(1, h);
      }
      var f = F(F({}, l), { returnPartialData: !0, id: c, query: d, optimistic: s }), p;
      return new Mt(function(m) {
        return r.watch(F(F({}, f), { immediate: !0, callback: function(y) {
          var g = u ? rb(y.result, n, r, i) : y.result;
          if (
            // Always ensure we deliver the first result
            !(p && J8(
              d,
              { data: p.result },
              { data: g },
              // TODO: Fix the type on WatchFragmentOptions so that TVars
              // extends OperationVariables
              t.variables
            ))
          ) {
            var w = {
              data: g,
              complete: !!y.complete
            };
            y.missing && (w.missing = Q1(y.missing.map(function($) {
              return $.missing;
            }))), p = F(F({}, y), { result: g }), m.next(w);
          }
        } }));
      });
    }, e.prototype.readFragment = function(t, r) {
      var n = this;
      return r === void 0 && (r = !!t.optimistic), globalThis.__DEV__ !== !1 && ar(t, "canonizeResults", "cache.readFragment"), zr("canonizeResults", function() {
        return n.read(F(F({}, t), { query: n.getFragmentDoc(t.fragment, t.fragmentName), rootId: t.id, optimistic: r }));
      });
    }, e.prototype.writeQuery = function(t) {
      var r = t.id, n = t.data, i = ii(t, ["id", "data"]);
      return this.write(Object.assign(i, {
        dataId: r || "ROOT_QUERY",
        result: n
      }));
    }, e.prototype.writeFragment = function(t) {
      var r = t.id, n = t.data, i = t.fragment, a = t.fragmentName, o = ii(t, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(o, {
        query: this.getFragmentDoc(i, a),
        dataId: r,
        result: n
      }));
    }, e.prototype.updateQuery = function(t, r) {
      return globalThis.__DEV__ !== !1 && ar(t, "canonizeResults", "cache.updateQuery"), this.batch({
        update: function(n) {
          var i = zr("canonizeResults", function() {
            return n.readQuery(t);
          }), a = r(i);
          return a == null ? i : (n.writeQuery(F(F({}, t), { data: a })), a);
        }
      });
    }, e.prototype.updateFragment = function(t, r) {
      return globalThis.__DEV__ !== !1 && ar(t, "canonizeResults", "cache.updateFragment"), this.batch({
        update: function(n) {
          var i = zr("canonizeResults", function() {
            return n.readFragment(t);
          }), a = r(i);
          return a == null ? i : (n.writeFragment(F(F({}, t), { data: a })), a);
        }
      });
    }, e;
  })()
);
globalThis.__DEV__ !== !1 && (nb.prototype.getMemoryInternals = QC);
var ib = (
  /** @class */
  (function(e) {
    Li(t, e);
    function t(r, n, i, a) {
      var o, s = e.call(this, r) || this;
      if (s.message = r, s.path = n, s.query = i, s.variables = a, Array.isArray(s.path)) {
        s.missing = s.message;
        for (var l = s.path.length - 1; l >= 0; --l)
          s.missing = (o = {}, o[s.path[l]] = s.missing, o);
      } else
        s.missing = s.path;
      return s.__proto__ = t.prototype, s;
    }
    return t;
  })(Error)
), Cr = Object.prototype.hasOwnProperty;
function od(e) {
  return e == null;
}
function ab(e, t) {
  var r = e.__typename, n = e.id, i = e._id;
  if (typeof r == "string" && (t && (t.keyObject = od(n) ? od(i) ? void 0 : { _id: i } : { id: n }), od(n) && !od(i) && (n = i), !od(n)))
    return "".concat(r, ":").concat(typeof n == "number" || typeof n == "string" ? n : JSON.stringify(n));
}
var ob = {
  dataIdFromObject: ab,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function MA(e) {
  return hl(ob, e);
}
function sb(e) {
  var t = e.canonizeResults;
  return t === void 0 ? ob.canonizeResults : t;
}
function RA(e, t) {
  return kt(t) ? e.get(t.__ref, "__typename") : t && t.__typename;
}
var lb = /^[_a-z][_0-9a-z]*/i;
function Ba(e) {
  var t = e.match(lb);
  return t ? t[0] : e;
}
function lp(e, t, r) {
  return rr(t) ? nr(t) ? t.every(function(n) {
    return lp(e, n, r);
  }) : e.selections.every(function(n) {
    if (Va(n) && Bc(n, r)) {
      var i = ra(n);
      return Cr.call(t, i) && (!n.selectionSet || lp(n.selectionSet, t[i], r));
    }
    return !0;
  }) : !1;
}
function Rs(e) {
  return rr(e) && !kt(e) && !nr(e);
}
function LA() {
  return new qa();
}
function db(e, t) {
  var r = Ol(Il(e));
  return {
    fragmentMap: r,
    lookupFragment: function(n) {
      var i = r[n];
      return !i && t && (i = t.lookup(n)), i || null;
    }
  };
}
var c0 = /* @__PURE__ */ Object.create(null), vf = function() {
  return c0;
}, Sv = /* @__PURE__ */ Object.create(null), lc = (
  /** @class */
  (function() {
    function e(t, r) {
      var n = this;
      this.policies = t, this.group = r, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, a) {
        return W0(kt(i) ? n.get(i.__ref, a) : i && i[a]);
      }, this.canRead = function(i) {
        return kt(i) ? n.has(i.__ref) : typeof i == "object";
      }, this.toReference = function(i, a) {
        if (typeof i == "string")
          return Qs(i);
        if (kt(i))
          return i;
        var o = n.policies.identify(i)[0];
        if (o) {
          var s = Qs(o);
          return a && n.merge(o, i), s;
        }
      };
    }
    return e.prototype.toObject = function() {
      return F({}, this.data);
    }, e.prototype.has = function(t) {
      return this.lookup(t, !0) !== void 0;
    }, e.prototype.get = function(t, r) {
      if (this.group.depend(t, r), Cr.call(this.data, t)) {
        var n = this.data[t];
        if (n && Cr.call(n, r))
          return n[r];
      }
      if (r === "__typename" && Cr.call(this.policies.rootTypenamesById, t))
        return this.policies.rootTypenamesById[t];
      if (this instanceof $a)
        return this.parent.get(t, r);
    }, e.prototype.lookup = function(t, r) {
      if (r && this.group.depend(t, "__exists"), Cr.call(this.data, t))
        return this.data[t];
      if (this instanceof $a)
        return this.parent.lookup(t, r);
      if (this.policies.rootTypenamesById[t])
        return /* @__PURE__ */ Object.create(null);
    }, e.prototype.merge = function(t, r) {
      var n = this, i;
      kt(t) && (t = t.__ref), kt(r) && (r = r.__ref);
      var a = typeof t == "string" ? this.lookup(i = t) : t, o = typeof r == "string" ? this.lookup(i = r) : r;
      if (o) {
        ge(typeof i == "string", 2);
        var s = new qa(jA).merge(a, o);
        if (this.data[i] = s, s !== a && (delete this.refs[i], this.group.caching)) {
          var l = /* @__PURE__ */ Object.create(null);
          a || (l.__exists = 1), Object.keys(o).forEach(function(d) {
            if (!a || a[d] !== s[d]) {
              l[d] = 1;
              var c = Ba(d);
              c !== d && !n.policies.hasKeyArgs(s.__typename, c) && (l[c] = 1), s[d] === void 0 && !(n instanceof $a) && delete s[d];
            }
          }), l.__typename && !(a && a.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[i] === s.__typename && delete l.__typename, Object.keys(l).forEach(function(d) {
            return n.group.dirty(i, d);
          });
        }
      }
    }, e.prototype.modify = function(t, r) {
      var n = this, i = this.lookup(t);
      if (i) {
        var a = /* @__PURE__ */ Object.create(null), o = !1, s = !0, l = {
          DELETE: c0,
          INVALIDATE: Sv,
          isReference: kt,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(d, c) {
            return n.policies.readField(typeof d == "string" ? {
              fieldName: d,
              from: c || Qs(t)
            } : d, { store: n });
          }
        };
        if (Object.keys(i).forEach(function(d) {
          var c = Ba(d), u = i[d];
          if (u !== void 0) {
            var h = typeof r == "function" ? r : r[d] || r[c];
            if (h) {
              var f = h === vf ? c0 : h(W0(u), F(F({}, l), { fieldName: c, storeFieldName: d, storage: n.getStorage(t, d) }));
              if (f === Sv)
                n.group.dirty(t, d);
              else if (f === c0 && (f = void 0), f !== u && (a[d] = f, o = !0, u = f, globalThis.__DEV__ !== !1)) {
                var p = function(x) {
                  if (n.lookup(x.__ref) === void 0)
                    return globalThis.__DEV__ !== !1 && ge.warn(3, x), !0;
                };
                if (kt(f))
                  p(f);
                else if (Array.isArray(f))
                  for (var m = !1, y = void 0, g = 0, w = f; g < w.length; g++) {
                    var $ = w[g];
                    if (kt($)) {
                      if (m = !0, p($))
                        break;
                    } else if (typeof $ == "object" && $) {
                      var _ = n.policies.identify($)[0];
                      _ && (y = $);
                    }
                    if (m && y !== void 0) {
                      globalThis.__DEV__ !== !1 && ge.warn(4, y);
                      break;
                    }
                  }
              }
            }
            u !== void 0 && (s = !1);
          }
        }), o)
          return this.merge(t, a), s && (this instanceof $a ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
      }
      return !1;
    }, e.prototype.delete = function(t, r, n) {
      var i, a = this.lookup(t);
      if (a) {
        var o = this.getFieldValue(a, "__typename"), s = r && n ? this.policies.getStoreFieldName({ typename: o, fieldName: r, args: n }) : r;
        return this.modify(t, s ? (i = {}, i[s] = vf, i) : vf);
      }
      return !1;
    }, e.prototype.evict = function(t, r) {
      var n = !1;
      return t.id && (Cr.call(this.data, t.id) && (n = this.delete(t.id, t.fieldName, t.args)), this instanceof $a && this !== r && (n = this.parent.evict(t, r) || n), (t.fieldName || n) && this.group.dirty(t.id, t.fieldName || "__exists")), n;
    }, e.prototype.clear = function() {
      this.replace(null);
    }, e.prototype.extract = function() {
      var t = this, r = this.toObject(), n = [];
      return this.getRootIdSet().forEach(function(i) {
        Cr.call(t.policies.rootTypenamesById, i) || n.push(i);
      }), n.length && (r.__META = { extraRootIds: n.sort() }), r;
    }, e.prototype.replace = function(t) {
      var r = this;
      if (Object.keys(this.data).forEach(function(a) {
        t && Cr.call(t, a) || r.delete(a);
      }), t) {
        var n = t.__META, i = ii(t, ["__META"]);
        Object.keys(i).forEach(function(a) {
          r.merge(a, i[a]);
        }), n && n.extraRootIds.forEach(this.retain, this);
      }
    }, e.prototype.retain = function(t) {
      return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
    }, e.prototype.release = function(t) {
      if (this.rootIds[t] > 0) {
        var r = --this.rootIds[t];
        return r || delete this.rootIds[t], r;
      }
      return 0;
    }, e.prototype.getRootIdSet = function(t) {
      return t === void 0 && (t = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof $a ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
    }, e.prototype.gc = function() {
      var t = this, r = this.getRootIdSet(), n = this.toObject();
      r.forEach(function(o) {
        Cr.call(n, o) && (Object.keys(t.findChildRefIds(o)).forEach(r.add, r), delete n[o]);
      });
      var i = Object.keys(n);
      if (i.length) {
        for (var a = this; a instanceof $a; )
          a = a.parent;
        i.forEach(function(o) {
          return a.delete(o);
        });
      }
      return i;
    }, e.prototype.findChildRefIds = function(t) {
      if (!Cr.call(this.refs, t)) {
        var r = this.refs[t] = /* @__PURE__ */ Object.create(null), n = this.data[t];
        if (!n)
          return r;
        var i = /* @__PURE__ */ new Set([n]);
        i.forEach(function(a) {
          kt(a) && (r[a.__ref] = !0), rr(a) && Object.keys(a).forEach(function(o) {
            var s = a[o];
            rr(s) && i.add(s);
          });
        });
      }
      return this.refs[t];
    }, e.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, e;
  })()
), cb = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = null), this.caching = t, this.parent = r, this.d = null, this.resetCaching();
    }
    return e.prototype.resetCaching = function() {
      this.d = this.caching ? R8() : null, this.keyMaker = new da(as);
    }, e.prototype.depend = function(t, r) {
      if (this.d) {
        this.d(yf(t, r));
        var n = Ba(r);
        n !== r && this.d(yf(t, n)), this.parent && this.parent.depend(t, r);
      }
    }, e.prototype.dirty = function(t, r) {
      this.d && this.d.dirty(
        yf(t, r),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        r === "__exists" ? "forget" : "setDirty"
      );
    }, e;
  })()
);
function yf(e, t) {
  return t + "#" + e;
}
function Cv(e, t) {
  Bd(e) && e.group.depend(t, "__exists");
}
(function(e) {
  var t = (
    /** @class */
    (function(r) {
      Li(n, r);
      function n(i) {
        var a = i.policies, o = i.resultCaching, s = o === void 0 ? !0 : o, l = i.seed, d = r.call(this, a, new cb(s)) || this;
        return d.stump = new FA(d), d.storageTrie = new da(as), l && d.replace(l), d;
      }
      return n.prototype.addLayer = function(i, a) {
        return this.stump.addLayer(i, a);
      }, n.prototype.removeLayer = function() {
        return this;
      }, n.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, n;
    })(e)
  );
  e.Root = t;
})(lc || (lc = {}));
var $a = (
  /** @class */
  (function(e) {
    Li(t, e);
    function t(r, n, i, a) {
      var o = e.call(this, n.policies, a) || this;
      return o.id = r, o.parent = n, o.replay = i, o.group = a, i(o), o;
    }
    return t.prototype.addLayer = function(r, n) {
      return new t(r, this, n, this.group);
    }, t.prototype.removeLayer = function(r) {
      var n = this, i = this.parent.removeLayer(r);
      return r === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(a) {
        var o = n.data[a], s = i.lookup(a);
        s ? o ? o !== s && Object.keys(o).forEach(function(l) {
          Ft(o[l], s[l]) || n.group.dirty(a, l);
        }) : (n.group.dirty(a, "__exists"), Object.keys(s).forEach(function(l) {
          n.group.dirty(a, l);
        })) : n.delete(a);
      }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
    }, t.prototype.toObject = function() {
      return F(F({}, this.parent.toObject()), this.data);
    }, t.prototype.findChildRefIds = function(r) {
      var n = this.parent.findChildRefIds(r);
      return Cr.call(this.data, r) ? F(F({}, n), e.prototype.findChildRefIds.call(this, r)) : n;
    }, t.prototype.getStorage = function() {
      for (var r = this.parent; r.parent; )
        r = r.parent;
      return r.getStorage.apply(
        r,
        // @ts-expect-error
        arguments
      );
    }, t;
  })(lc)
), FA = (
  /** @class */
  (function(e) {
    Li(t, e);
    function t(r) {
      return e.call(this, "EntityStore.Stump", r, function() {
      }, new cb(r.group.caching, r.group)) || this;
    }
    return t.prototype.removeLayer = function() {
      return this;
    }, t.prototype.merge = function(r, n) {
      return this.parent.merge(r, n);
    }, t;
  })($a)
);
function jA(e, t, r) {
  var n = e[r], i = t[r];
  return Ft(n, i) ? n : i;
}
function Bd(e) {
  return !!(e instanceof lc && e.group.caching);
}
function zA(e) {
  return rr(e) ? nr(e) ? e.slice(0) : F({ __proto__: Object.getPrototypeOf(e) }, e) : e;
}
var Tv = (
  /** @class */
  (function() {
    function e() {
      this.known = new (vm ? WeakSet : Set)(), this.pool = new da(as), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return e.prototype.isKnown = function(t) {
      return rr(t) && this.known.has(t);
    }, e.prototype.pass = function(t) {
      if (rr(t)) {
        var r = zA(t);
        return this.passes.set(r, t), r;
      }
      return t;
    }, e.prototype.admit = function(t) {
      var r = this;
      if (rr(t)) {
        var n = this.passes.get(t);
        if (n)
          return n;
        var i = Object.getPrototypeOf(t);
        switch (i) {
          case Array.prototype: {
            if (this.known.has(t))
              return t;
            var a = t.map(this.admit, this), o = this.pool.lookupArray(a);
            return o.array || (this.known.add(o.array = a), globalThis.__DEV__ !== !1 && Object.freeze(a)), o.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(t))
              return t;
            var s = Object.getPrototypeOf(t), l = [s], d = this.sortedKeys(t);
            l.push(d.json);
            var c = l.length;
            d.sorted.forEach(function(f) {
              l.push(r.admit(t[f]));
            });
            var o = this.pool.lookupArray(l);
            if (!o.object) {
              var u = o.object = Object.create(s);
              this.known.add(u), d.sorted.forEach(function(f, p) {
                u[f] = l[c + p];
              }), globalThis.__DEV__ !== !1 && Object.freeze(u);
            }
            return o.object;
          }
        }
      }
      return t;
    }, e.prototype.sortedKeys = function(t) {
      var r = Object.keys(t), n = this.pool.lookupArray(r);
      if (!n.keys) {
        r.sort();
        var i = JSON.stringify(r);
        (n.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, n.keys = { sorted: r, json: i });
      }
      return n.keys;
    }, e;
  })()
);
function Av(e) {
  return [
    e.selectionSet,
    e.objectOrReference,
    e.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    e.context.canonizeResults
  ];
}
var VA = (
  /** @class */
  (function() {
    function e(t) {
      var r = this;
      this.knownResults = new (as ? WeakMap : Map)(), this.config = hl(t, {
        addTypename: t.addTypename !== !1,
        canonizeResults: sb(t)
      }), this.canon = t.canon || new Tv(), this.executeSelectionSet = sc(function(n) {
        var i, a = n.context.canonizeResults, o = Av(n);
        o[3] = !a;
        var s = (i = r.executeSelectionSet).peek.apply(i, o);
        return s ? a ? F(F({}, s), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: r.canon.admit(s.result)
        }) : s : (Cv(n.context.store, n.enclosingRef.__ref), r.execSelectionSetImpl(n));
      }, {
        max: this.config.resultCacheMaxSize || ta["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: Av,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(n, i, a, o) {
          if (Bd(a.store))
            return a.store.makeCacheKey(n, kt(i) ? i.__ref : i, a.varString, o);
        }
      }), this.executeSubSelectedArray = sc(function(n) {
        return Cv(n.context.store, n.enclosingRef.__ref), r.execSubSelectedArrayImpl(n);
      }, {
        max: this.config.resultCacheMaxSize || ta["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(n) {
          var i = n.field, a = n.array, o = n.context;
          if (Bd(o.store))
            return o.store.makeCacheKey(i, a, o.varString);
        }
      });
    }
    return e.prototype.resetCanon = function() {
      this.canon = new Tv();
    }, e.prototype.diffQueryAgainstStore = function(t) {
      var r = t.store, n = t.query, i = t.rootId, a = i === void 0 ? "ROOT_QUERY" : i, o = t.variables, s = t.returnPartialData, l = s === void 0 ? !0 : s, d = t.canonizeResults, c = d === void 0 ? this.config.canonizeResults : d, u = this.config.cache.policies;
      o = F(F({}, ym(x8(n))), o);
      var h = Qs(a), f = this.executeSelectionSet({
        selectionSet: Hc(n).selectionSet,
        objectOrReference: h,
        enclosingRef: h,
        context: F({ store: r, query: n, policies: u, variables: o, varString: La(o), canonizeResults: c }, db(n, this.config.fragments))
      }), p;
      if (f.missing && (p = [
        new ib(UA(f.missing), f.missing, n, o)
      ], !l))
        throw p[0];
      return {
        result: f.result,
        complete: !p,
        missing: p
      };
    }, e.prototype.isFresh = function(t, r, n, i) {
      if (Bd(i.store) && this.knownResults.get(t) === n) {
        var a = this.executeSelectionSet.peek(
          n,
          r,
          i,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(t)
        );
        if (a && t === a.result)
          return !0;
      }
      return !1;
    }, e.prototype.execSelectionSetImpl = function(t) {
      var r = this, n = t.selectionSet, i = t.objectOrReference, a = t.enclosingRef, o = t.context;
      if (kt(i) && !o.policies.rootTypenamesById[i.__ref] && !o.store.has(i.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(i.__ref, " object")
        };
      var s = o.variables, l = o.policies, d = o.store, c = d.getFieldValue(i, "__typename"), u = [], h, f = new qa();
      this.config.addTypename && typeof c == "string" && !l.rootIdsByTypename[c] && u.push({ __typename: c });
      function p($, _) {
        var x;
        return $.missing && (h = f.merge(h, (x = {}, x[_] = $.missing, x))), $.result;
      }
      var m = new Set(n.selections);
      m.forEach(function($) {
        var _, x;
        if (Bc($, s))
          if (Va($)) {
            var S = l.readField({
              fieldName: $.name.value,
              field: $,
              variables: o.variables,
              from: i
            }, o), T = ra($);
            S === void 0 ? km.added($) || (h = f.merge(h, (_ = {}, _[T] = "Can't find field '".concat($.name.value, "' on ").concat(kt(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), _))) : nr(S) ? S.length > 0 && (S = p(r.executeSubSelectedArray({
              field: $,
              array: S,
              enclosingRef: a,
              context: o
            }), T)) : $.selectionSet ? S != null && (S = p(r.executeSelectionSet({
              selectionSet: $.selectionSet,
              objectOrReference: S,
              enclosingRef: kt(S) ? S : a,
              context: o
            }), T)) : o.canonizeResults && (S = r.canon.pass(S)), S !== void 0 && u.push((x = {}, x[T] = S, x));
          } else {
            var I = B1($, o.lookupFragment);
            if (!I && $.kind === ue.FRAGMENT_SPREAD)
              throw Jr(10, $.name.value);
            I && l.fragmentMatches(I, c) && I.selectionSet.selections.forEach(m.add, m);
          }
      });
      var y = Q1(u), g = { result: y, missing: h }, w = o.canonizeResults ? this.canon.admit(g) : W0(g);
      return w.result && this.knownResults.set(w.result, n), w;
    }, e.prototype.execSubSelectedArrayImpl = function(t) {
      var r = this, n = t.field, i = t.array, a = t.enclosingRef, o = t.context, s, l = new qa();
      function d(c, u) {
        var h;
        return c.missing && (s = l.merge(s, (h = {}, h[u] = c.missing, h))), c.result;
      }
      return n.selectionSet && (i = i.filter(o.store.canRead)), i = i.map(function(c, u) {
        return c === null ? null : nr(c) ? d(r.executeSubSelectedArray({
          field: n,
          array: c,
          enclosingRef: a,
          context: o
        }), u) : n.selectionSet ? d(r.executeSelectionSet({
          selectionSet: n.selectionSet,
          objectOrReference: c,
          enclosingRef: kt(c) ? c : a,
          context: o
        }), u) : (globalThis.__DEV__ !== !1 && qA(o.store, n, c), c);
      }), {
        result: o.canonizeResults ? this.canon.admit(i) : i,
        missing: s
      };
    }, e;
  })()
);
function UA(e) {
  try {
    JSON.stringify(e, function(t, r) {
      if (typeof r == "string")
        throw r;
      return r;
    });
  } catch (t) {
    return t;
  }
}
function qA(e, t, r) {
  if (!t.selectionSet) {
    var n = /* @__PURE__ */ new Set([r]);
    n.forEach(function(i) {
      rr(i) && (ge(
        !kt(i),
        11,
        RA(e, i),
        t.name.value
      ), Object.values(i).forEach(n.add, n));
    });
  }
}
var Am = new Dl(), Ov = /* @__PURE__ */ new WeakMap();
function Hd(e) {
  var t = Ov.get(e);
  return t || Ov.set(e, t = {
    vars: /* @__PURE__ */ new Set(),
    dep: R8()
  }), t;
}
function Pv(e) {
  Hd(e).vars.forEach(function(t) {
    return t.forgetCache(e);
  });
}
function BA(e) {
  Hd(e).vars.forEach(function(t) {
    return t.attachCache(e);
  });
}
function HA(e) {
  var t = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), n = function(a) {
    if (arguments.length > 0) {
      if (e !== a) {
        e = a, t.forEach(function(l) {
          Hd(l).dep.dirty(n), WA(l);
        });
        var o = Array.from(r);
        r.clear(), o.forEach(function(l) {
          return l(e);
        });
      }
    } else {
      var s = Am.getValue();
      s && (i(s), Hd(s).dep(n));
    }
    return e;
  };
  n.onNextChange = function(a) {
    return r.add(a), function() {
      r.delete(a);
    };
  };
  var i = n.attachCache = function(a) {
    return t.add(a), Hd(a).vars.add(n), n;
  };
  return n.forgetCache = function(a) {
    return t.delete(a);
  }, n;
}
function WA(e) {
  e.broadcastWatches && e.broadcastWatches();
}
var Iv = /* @__PURE__ */ Object.create(null);
function Om(e) {
  var t = JSON.stringify(e);
  return Iv[t] || (Iv[t] = /* @__PURE__ */ Object.create(null));
}
function Dv(e) {
  var t = Om(e);
  return t.keyFieldsFn || (t.keyFieldsFn = function(r, n) {
    var i = function(o, s) {
      return n.readField(s, o);
    }, a = n.keyObject = Pm(e, function(o) {
      var s = Ys(
        n.storeObject,
        o,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        i
      );
      return s === void 0 && r !== n.storeObject && Cr.call(r, o[0]) && (s = Ys(r, o, hb)), ge(s !== void 0, 5, o.join("."), r), s;
    });
    return "".concat(n.typename, ":").concat(JSON.stringify(a));
  });
}
function Nv(e) {
  var t = Om(e);
  return t.keyArgsFn || (t.keyArgsFn = function(r, n) {
    var i = n.field, a = n.variables, o = n.fieldName, s = Pm(e, function(d) {
      var c = d[0], u = c.charAt(0);
      if (u === "@") {
        if (i && Ni(i.directives)) {
          var h = c.slice(1), f = i.directives.find(function(g) {
            return g.name.value === h;
          }), p = f && H1(f, a);
          return p && Ys(
            p,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            d.slice(1)
          );
        }
        return;
      }
      if (u === "$") {
        var m = c.slice(1);
        if (a && Cr.call(a, m)) {
          var y = d.slice(0);
          return y[0] = m, Ys(a, y);
        }
        return;
      }
      if (r)
        return Ys(r, d);
    }), l = JSON.stringify(s);
    return (r || l !== "{}") && (o += ":" + l), o;
  });
}
function Pm(e, t) {
  var r = new qa();
  return ub(e).reduce(function(n, i) {
    var a, o = t(i);
    if (o !== void 0) {
      for (var s = i.length - 1; s >= 0; --s)
        o = (a = {}, a[i[s]] = o, a);
      n = r.merge(n, o);
    }
    return n;
  }, /* @__PURE__ */ Object.create(null));
}
function ub(e) {
  var t = Om(e);
  if (!t.paths) {
    var r = t.paths = [], n = [];
    e.forEach(function(i, a) {
      nr(i) ? (ub(i).forEach(function(o) {
        return r.push(n.concat(o));
      }), n.length = 0) : (n.push(i), nr(e[a + 1]) || (r.push(n.slice(0)), n.length = 0));
    });
  }
  return t.paths;
}
function hb(e, t) {
  return e[t];
}
function Ys(e, t, r) {
  return r = r || hb, fb(t.reduce(function n(i, a) {
    return nr(i) ? i.map(function(o) {
      return n(o, a);
    }) : i && r(i, a);
  }, e));
}
function fb(e) {
  return rr(e) ? nr(e) ? e.map(fb) : Pm(Object.keys(e).sort(), function(t) {
    return Ys(e, t);
  }) : e;
}
function dp(e) {
  return e.args !== void 0 ? e.args : e.field ? H1(e.field, e.variables) : null;
}
var KA = function() {
}, Mv = function(e, t) {
  return t.fieldName;
}, Rv = function(e, t, r) {
  var n = r.mergeObjects;
  return n(e, t);
}, Lv = function(e, t) {
  return t;
}, QA = (
  /** @class */
  (function() {
    function e(t) {
      this.config = t, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = F({ dataIdFromObject: ab }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
    }
    return e.prototype.identify = function(t, r) {
      var n, i = this, a = r && (r.typename || ((n = r.storeObject) === null || n === void 0 ? void 0 : n.__typename)) || t.__typename;
      if (a === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      var o = r && r.storeObject || t, s = F(F({}, r), { typename: a, storeObject: o, readField: r && r.readField || function() {
        var u = Im(arguments, o);
        return i.readField(u, {
          store: i.cache.data,
          variables: u.variables
        });
      } }), l, d = a && this.getTypePolicy(a), c = d && d.keyFn || this.config.dataIdFromObject;
      return Tm.withValue(!0, function() {
        for (; c; ) {
          var u = c(F(F({}, t), o), s);
          if (nr(u))
            c = Dv(u);
          else {
            l = u;
            break;
          }
        }
      }), l = l ? String(l) : void 0, s.keyObject ? [l, s.keyObject] : [l];
    }, e.prototype.addTypePolicies = function(t) {
      var r = this;
      Object.keys(t).forEach(function(n) {
        var i = t[n], a = i.queryType, o = i.mutationType, s = i.subscriptionType, l = ii(i, ["queryType", "mutationType", "subscriptionType"]);
        a && r.setRootTypename("Query", n), o && r.setRootTypename("Mutation", n), s && r.setRootTypename("Subscription", n), Cr.call(r.toBeAdded, n) ? r.toBeAdded[n].push(l) : r.toBeAdded[n] = [l];
      });
    }, e.prototype.updateTypePolicy = function(t, r, n) {
      var i = this.getTypePolicy(t), a = r.keyFields, o = r.fields;
      function s(l, d) {
        l.merge = typeof d == "function" ? d : d === !0 ? Rv : d === !1 ? Lv : l.merge;
      }
      s(i, r.merge), i.keyFn = // Pass false to disable normalization for this typename.
      a === !1 ? KA : nr(a) ? Dv(a) : typeof a == "function" ? a : i.keyFn, o && Object.keys(o).forEach(function(l) {
        var d = n[l];
        (!d || d?.typename !== t) && (d = n[l] = { typename: t });
        var c = o[l];
        if (typeof c == "function")
          d.read = c;
        else {
          var u = c.keyArgs, h = c.read, f = c.merge;
          d.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          u === !1 ? Mv : nr(u) ? Nv(u) : typeof u == "function" ? u : d.keyFn, typeof h == "function" && (d.read = h), s(d, f);
        }
        d.read && d.merge && (d.keyFn = d.keyFn || Mv);
      });
    }, e.prototype.setRootTypename = function(t, r) {
      r === void 0 && (r = t);
      var n = "ROOT_" + t.toUpperCase(), i = this.rootTypenamesById[n];
      r !== i && (ge(!i || i === t, 6, t), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[r] = n, this.rootTypenamesById[n] = r);
    }, e.prototype.addPossibleTypes = function(t) {
      var r = this;
      this.usingPossibleTypes = !0, Object.keys(t).forEach(function(n) {
        r.getSupertypeSet(n, !0), t[n].forEach(function(i) {
          r.getSupertypeSet(i, !0).add(n);
          var a = i.match(lb);
          (!a || a[0] !== i) && r.fuzzySubtypes.set(i, new RegExp(i));
        });
      });
    }, e.prototype.getTypePolicy = function(t) {
      var r = this;
      if (!Cr.call(this.typePolicies, t)) {
        var n = this.typePolicies[t] = /* @__PURE__ */ Object.create(null);
        n.fields = /* @__PURE__ */ Object.create(null);
        var i = this.supertypeMap.get(t);
        !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(t, !0), this.fuzzySubtypes.forEach(function(o, s) {
          if (o.test(t)) {
            var l = r.supertypeMap.get(s);
            l && l.forEach(function(d) {
              return i.add(d);
            });
          }
        })), i && i.size && i.forEach(function(o) {
          var s = r.getTypePolicy(o), l = s.fields, d = ii(s, ["fields"]);
          Object.assign(n, d), Object.assign(n.fields, l);
        });
      }
      var a = this.toBeAdded[t];
      return a && a.length && a.splice(0).forEach(function(o) {
        r.updateTypePolicy(t, o, r.typePolicies[t].fields);
      }), this.typePolicies[t];
    }, e.prototype.getFieldPolicy = function(t, r) {
      if (t)
        return this.getTypePolicy(t).fields[r];
    }, e.prototype.getSupertypeSet = function(t, r) {
      var n = this.supertypeMap.get(t);
      return !n && r && this.supertypeMap.set(t, n = /* @__PURE__ */ new Set()), n;
    }, e.prototype.fragmentMatches = function(t, r, n, i) {
      var a = this;
      if (!t.typeCondition)
        return !0;
      if (!r)
        return !1;
      var o = t.typeCondition.name.value;
      if (r === o)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(o))
        for (var s = this.getSupertypeSet(r, !0), l = [s], d = function(p) {
          var m = a.getSupertypeSet(p, !1);
          m && m.size && l.indexOf(m) < 0 && l.push(m);
        }, c = !!(n && this.fuzzySubtypes.size), u = !1, h = 0; h < l.length; ++h) {
          var f = l[h];
          if (f.has(o))
            return s.has(o) || (u && globalThis.__DEV__ !== !1 && ge.warn(7, r, o), s.add(o)), !0;
          f.forEach(d), c && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          h === l.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          lp(t.selectionSet, n, i) && (c = !1, u = !0, this.fuzzySubtypes.forEach(function(p, m) {
            var y = r.match(p);
            y && y[0] === r && d(m);
          }));
        }
      return !1;
    }, e.prototype.hasKeyArgs = function(t, r) {
      var n = this.getFieldPolicy(t, r);
      return !!(n && n.keyFn);
    }, e.prototype.getStoreFieldName = function(t) {
      var r = t.typename, n = t.fieldName, i = this.getFieldPolicy(r, n), a, o = i && i.keyFn;
      if (o && r)
        for (var s = {
          typename: r,
          fieldName: n,
          field: t.field || null,
          variables: t.variables
        }, l = dp(t); o; ) {
          var d = o(l, s);
          if (nr(d))
            o = Nv(d);
          else {
            a = d || n;
            break;
          }
        }
      return a === void 0 && (a = t.field ? uT(t.field, t.variables) : _8(n, dp(t))), a === !1 ? n : n === Ba(a) ? a : n + ":" + a;
    }, e.prototype.readField = function(t, r) {
      var n = t.from;
      if (n) {
        var i = t.field || t.fieldName;
        if (i) {
          if (t.typename === void 0) {
            var a = r.store.getFieldValue(n, "__typename");
            a && (t.typename = a);
          }
          var o = this.getStoreFieldName(t), s = Ba(o), l = r.store.getFieldValue(n, o), d = this.getFieldPolicy(t.typename, s), c = d && d.read;
          if (c) {
            var u = Fv(this, n, t, r, r.store.getStorage(kt(n) ? n.__ref : n, o));
            return Am.withValue(this.cache, c, [
              l,
              u
            ]);
          }
          return l;
        }
      }
    }, e.prototype.getReadFunction = function(t, r) {
      var n = this.getFieldPolicy(t, r);
      return n && n.read;
    }, e.prototype.getMergeFunction = function(t, r, n) {
      var i = this.getFieldPolicy(t, r), a = i && i.merge;
      return !a && n && (i = this.getTypePolicy(n), a = i && i.merge), a;
    }, e.prototype.runMergeFunction = function(t, r, n, i, a) {
      var o = n.field, s = n.typename, l = n.merge;
      return l === Rv ? pb(i.store)(t, r) : l === Lv ? r : (i.overwrite && (t = void 0), l(t, r, Fv(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: s,
          fieldName: o.name.value,
          field: o,
          variables: i.variables
        },
        i,
        a || /* @__PURE__ */ Object.create(null)
      )));
    }, e;
  })()
);
function Fv(e, t, r, n, i) {
  var a = e.getStoreFieldName(r), o = Ba(a), s = r.variables || n.variables, l = n.store, d = l.toReference, c = l.canRead;
  return {
    args: dp(r),
    field: r.field || null,
    fieldName: o,
    storeFieldName: a,
    variables: s,
    isReference: kt,
    toReference: d,
    storage: i,
    cache: e.cache,
    canRead: c,
    readField: function() {
      return e.readField(Im(arguments, t, s), n);
    },
    mergeObjects: pb(n.store)
  };
}
function Im(e, t, r) {
  var n = e[0], i = e[1], a = e.length, o;
  return typeof n == "string" ? o = {
    fieldName: n,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: a > 1 ? i : t
  } : (o = F({}, n), Cr.call(o, "from") || (o.from = t)), globalThis.__DEV__ !== !1 && o.from === void 0 && globalThis.__DEV__ !== !1 && ge.warn(8, i8(Array.from(e))), o.variables === void 0 && (o.variables = r), o;
}
function pb(e) {
  return function(r, n) {
    if (nr(r) || nr(n))
      throw Jr(9);
    if (rr(r) && rr(n)) {
      var i = e.getFieldValue(r, "__typename"), a = e.getFieldValue(n, "__typename"), o = i && a && i !== a;
      if (o)
        return n;
      if (kt(r) && Rs(n))
        return e.merge(r.__ref, n), r;
      if (Rs(r) && kt(n))
        return e.merge(r, n.__ref), n;
      if (Rs(r) && Rs(n))
        return F(F({}, r), n);
    }
    return n;
  };
}
function bf(e, t, r) {
  var n = "".concat(t).concat(r), i = e.flavors.get(n);
  return i || e.flavors.set(n, i = e.clientOnly === t && e.deferred === r ? e : F(F({}, e), { clientOnly: t, deferred: r })), i;
}
var GA = (
  /** @class */
  (function() {
    function e(t, r, n) {
      this.cache = t, this.reader = r, this.fragments = n;
    }
    return e.prototype.writeToStore = function(t, r) {
      var n = this, i = r.query, a = r.result, o = r.dataId, s = r.variables, l = r.overwrite, d = Wo(i), c = LA();
      s = F(F({}, ym(d)), s);
      var u = F(F({ store: t, written: /* @__PURE__ */ Object.create(null), merge: function(f, p) {
        return c.merge(f, p);
      }, variables: s, varString: La(s) }, db(i, this.fragments)), { overwrite: !!l, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), h = this.processSelectionSet({
        result: a || /* @__PURE__ */ Object.create(null),
        dataId: o,
        selectionSet: d.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: u
      });
      if (!kt(h))
        throw Jr(12, a);
      return u.incomingById.forEach(function(f, p) {
        var m = f.storeObject, y = f.mergeTree, g = f.fieldNodeSet, w = Qs(p);
        if (y && y.map.size) {
          var $ = n.applyMerges(y, w, m, u);
          if (kt($))
            return;
          m = $;
        }
        if (globalThis.__DEV__ !== !1 && !u.overwrite) {
          var _ = /* @__PURE__ */ Object.create(null);
          g.forEach(function(T) {
            T.selectionSet && (_[T.name.value] = !0);
          });
          var x = function(T) {
            return _[Ba(T)] === !0;
          }, S = function(T) {
            var I = y && y.map.get(T);
            return !!(I && I.info && I.info.merge);
          };
          Object.keys(m).forEach(function(T) {
            x(T) && !S(T) && YA(w, m, T, u.store);
          });
        }
        t.merge(p, m);
      }), t.retain(h.__ref), h;
    }, e.prototype.processSelectionSet = function(t) {
      var r = this, n = t.dataId, i = t.result, a = t.selectionSet, o = t.context, s = t.mergeTree, l = this.cache.policies, d = /* @__PURE__ */ Object.create(null), c = n && l.rootTypenamesById[n] || Z2(i, a, o.fragmentMap) || n && o.store.get(n, "__typename");
      typeof c == "string" && (d.__typename = c);
      var u = function() {
        var $ = Im(arguments, d, o.variables);
        if (kt($.from)) {
          var _ = o.incomingById.get($.from.__ref);
          if (_) {
            var x = l.readField(F(F({}, $), { from: _.storeObject }), o);
            if (x !== void 0)
              return x;
          }
        }
        return l.readField($, o);
      }, h = /* @__PURE__ */ new Set();
      this.flattenFields(
        a,
        i,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        o,
        c
      ).forEach(function($, _) {
        var x, S = ra(_), T = i[S];
        if (h.add(_), T !== void 0) {
          var I = l.getStoreFieldName({
            typename: c,
            fieldName: _.name.value,
            field: _,
            variables: $.variables
          }), M = jv(s, I), P = r.processFieldValue(
            T,
            _,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            _.selectionSet ? bf($, !1, !1) : $,
            M
          ), O = void 0;
          _.selectionSet && (kt(P) || Rs(P)) && (O = u("__typename", P));
          var D = l.getMergeFunction(c, _.name.value, O);
          D ? M.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: _,
            typename: c,
            merge: D
          } : zv(s, I), d = $.merge(d, (x = {}, x[I] = P, x));
        } else globalThis.__DEV__ !== !1 && !$.clientOnly && !$.deferred && !km.added(_) && // If the field has a read function, it may be a synthetic field or
        // provide a default value, so its absence from the written data should
        // not be cause for alarm.
        !l.getReadFunction(c, _.name.value) && globalThis.__DEV__ !== !1 && ge.error(13, ra(_), i);
      });
      try {
        var f = l.identify(i, {
          typename: c,
          selectionSet: a,
          fragmentMap: o.fragmentMap,
          storeObject: d,
          readField: u
        }), p = f[0], m = f[1];
        n = n || p, m && (d = o.merge(d, m));
      } catch ($) {
        if (!n)
          throw $;
      }
      if (typeof n == "string") {
        var y = Qs(n), g = o.written[n] || (o.written[n] = []);
        if (g.indexOf(a) >= 0 || (g.push(a), this.reader && this.reader.isFresh(i, y, a, o)))
          return y;
        var w = o.incomingById.get(n);
        return w ? (w.storeObject = o.merge(w.storeObject, d), w.mergeTree = cp(w.mergeTree, s), h.forEach(function($) {
          return w.fieldNodeSet.add($);
        })) : o.incomingById.set(n, {
          storeObject: d,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: K0(s) ? void 0 : s,
          fieldNodeSet: h
        }), y;
      }
      return d;
    }, e.prototype.processFieldValue = function(t, r, n, i) {
      var a = this;
      return !r.selectionSet || t === null ? globalThis.__DEV__ !== !1 ? B8(t) : t : nr(t) ? t.map(function(o, s) {
        var l = a.processFieldValue(o, r, n, jv(i, s));
        return zv(i, s), l;
      }) : this.processSelectionSet({
        result: t,
        selectionSet: r.selectionSet,
        context: n,
        mergeTree: i
      });
    }, e.prototype.flattenFields = function(t, r, n, i) {
      i === void 0 && (i = Z2(r, t, n.fragmentMap));
      var a = /* @__PURE__ */ new Map(), o = this.cache.policies, s = new da(!1);
      return (function l(d, c) {
        var u = s.lookup(
          d,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          c.clientOnly,
          c.deferred
        );
        u.visited || (u.visited = !0, d.selections.forEach(function(h) {
          if (Bc(h, n.variables)) {
            var f = c.clientOnly, p = c.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(f && p) && Ni(h.directives) && h.directives.forEach(function(g) {
                var w = g.name.value;
                if (w === "client" && (f = !0), w === "defer") {
                  var $ = H1(g, n.variables);
                  (!$ || $.if !== !1) && (p = !0);
                }
              }), Va(h)
            ) {
              var m = a.get(h);
              m && (f = f && m.clientOnly, p = p && m.deferred), a.set(h, bf(n, f, p));
            } else {
              var y = B1(h, n.lookupFragment);
              if (!y && h.kind === ue.FRAGMENT_SPREAD)
                throw Jr(14, h.name.value);
              y && o.fragmentMatches(y, i, r, n.variables) && l(y.selectionSet, bf(n, f, p));
            }
          }
        }));
      })(t, n), a;
    }, e.prototype.applyMerges = function(t, r, n, i, a) {
      var o, s = this;
      if (t.map.size && !kt(n)) {
        var l = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !nr(n) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (kt(r) || Rs(r)) ? r : void 0
        ), d = n;
        l && !a && (a = [kt(l) ? l.__ref : l]);
        var c, u = function(h, f) {
          return nr(h) ? typeof f == "number" ? h[f] : void 0 : i.store.getFieldValue(h, String(f));
        };
        t.map.forEach(function(h, f) {
          var p = u(l, f), m = u(d, f);
          if (m !== void 0) {
            a && a.push(f);
            var y = s.applyMerges(h, p, m, i, a);
            y !== m && (c = c || /* @__PURE__ */ new Map(), c.set(f, y)), a && ge(a.pop() === f);
          }
        }), c && (n = nr(d) ? d.slice(0) : F({}, d), c.forEach(function(h, f) {
          n[f] = h;
        }));
      }
      return t.info ? this.cache.policies.runMergeFunction(r, n, t.info, i, a && (o = i.store).getStorage.apply(o, a)) : n;
    }, e;
  })()
), mb = [];
function jv(e, t) {
  var r = e.map;
  return r.has(t) || r.set(t, mb.pop() || { map: /* @__PURE__ */ new Map() }), r.get(t);
}
function cp(e, t) {
  if (e === t || !t || K0(t))
    return e;
  if (!e || K0(e))
    return t;
  var r = e.info && t.info ? F(F({}, e.info), t.info) : e.info || t.info, n = e.map.size && t.map.size, i = n ? /* @__PURE__ */ new Map() : e.map.size ? e.map : t.map, a = { info: r, map: i };
  if (n) {
    var o = new Set(t.map.keys());
    e.map.forEach(function(s, l) {
      a.map.set(l, cp(s, t.map.get(l))), o.delete(l);
    }), o.forEach(function(s) {
      a.map.set(s, cp(t.map.get(s), e.map.get(s)));
    });
  }
  return a;
}
function K0(e) {
  return !e || !(e.info || e.map.size);
}
function zv(e, t) {
  var r = e.map, n = r.get(t);
  n && K0(n) && (mb.push(n), r.delete(t));
}
var Vv = /* @__PURE__ */ new Set();
function YA(e, t, r, n) {
  var i = function(u) {
    var h = n.getFieldValue(u, r);
    return typeof h == "object" && h;
  }, a = i(e);
  if (a) {
    var o = i(t);
    if (o && !kt(a) && !Ft(a, o) && !Object.keys(a).every(function(u) {
      return n.getFieldValue(o, u) !== void 0;
    })) {
      var s = n.getFieldValue(e, "__typename") || n.getFieldValue(t, "__typename"), l = Ba(r), d = "".concat(s, ".").concat(l);
      if (!Vv.has(d)) {
        Vv.add(d);
        var c = [];
        !nr(a) && !nr(o) && [a, o].forEach(function(u) {
          var h = n.getFieldValue(u, "__typename");
          typeof h == "string" && !c.includes(h) && c.push(h);
        }), globalThis.__DEV__ !== !1 && ge.warn(15, l, s, c.length ? "either ensure all objects of type " + c.join(" and ") + " have an ID or a custom merge function, or " : "", d, F({}, a), F({}, o));
      }
    }
  }
}
var gb = (
  /** @class */
  (function(e) {
    Li(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this) || this;
      return n.watches = /* @__PURE__ */ new Set(), n.addTypenameTransform = new L8(km), n.assumeImmutableResults = !0, n.makeVar = HA, n.txCount = 0, globalThis.__DEV__ !== !1 && (ar(r, "addTypename", "InMemoryCache", "Please remove the `addTypename` option when initializing `InMemoryCache`."), ar(r, "canonizeResults", "InMemoryCache", "Please remove the `canonizeResults` option when initializing `InMemoryCache`.")), n.config = MA(r), n.addTypename = !!n.config.addTypename, n.policies = new QA({
        cache: n,
        dataIdFromObject: n.config.dataIdFromObject,
        possibleTypes: n.config.possibleTypes,
        typePolicies: n.config.typePolicies
      }), n.init(), n;
    }
    return t.prototype.init = function() {
      var r = this.data = new lc.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = r.stump, this.resetResultCache();
    }, t.prototype.resetResultCache = function(r) {
      var n = this, i = this.storeReader, a = this.config.fragments;
      this.addTypenameTransform.resetCache(), a?.resetCaches(), this.storeWriter = new GA(this, this.storeReader = new VA({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: sb(this.config),
        canon: r ? void 0 : i && i.canon,
        fragments: a
      }), a), this.maybeBroadcastWatch = sc(function(o, s) {
        return n.broadcastWatch(o, s);
      }, {
        max: this.config.resultCacheMaxSize || ta["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(o) {
          var s = o.optimistic ? n.optimisticData : n.data;
          if (Bd(s)) {
            var l = o.optimistic, d = o.id, c = o.variables;
            return s.makeCacheKey(
              o.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              o.callback,
              La({ optimistic: l, id: d, variables: c })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(o) {
        return o.resetCaching();
      });
    }, t.prototype.restore = function(r) {
      return this.init(), r && this.data.replace(r), this;
    }, t.prototype.extract = function(r) {
      return r === void 0 && (r = !1), (r ? this.optimisticData : this.data).extract();
    }, t.prototype.read = function(r) {
      globalThis.__DEV__ !== !1 && ar(r, "canonizeResults", "cache.read");
      var n = r.returnPartialData, i = n === void 0 ? !1 : n;
      try {
        return this.storeReader.diffQueryAgainstStore(F(F({}, r), { store: r.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
      } catch (a) {
        if (a instanceof ib)
          return null;
        throw a;
      }
    }, t.prototype.write = function(r) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, r);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.modify = function(r) {
      if (Cr.call(r, "id") && !r.id)
        return !1;
      var n = r.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, n.modify(r.id || "ROOT_QUERY", r.fields);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.diff = function(r) {
      return globalThis.__DEV__ !== !1 && ar(r, "canonizeResults", "cache.diff"), this.storeReader.diffQueryAgainstStore(F(F({}, r), { store: r.optimistic ? this.optimisticData : this.data, rootId: r.id || "ROOT_QUERY", config: this.config }));
    }, t.prototype.watch = function(r) {
      var n = this;
      return this.watches.size || BA(this), this.watches.add(r), r.immediate && this.maybeBroadcastWatch(r), function() {
        n.watches.delete(r) && !n.watches.size && Pv(n), n.maybeBroadcastWatch.forget(r);
      };
    }, t.prototype.gc = function(r) {
      globalThis.__DEV__ !== !1 && ar(r || {}, "resetResultIdentities", "cache.gc", "First ensure all usages of `canonizeResults` are removed, then remove this option."), La.reset(), Mo.reset();
      var n = this.optimisticData.gc();
      return r && !this.txCount && (r.resetResultCache ? this.resetResultCache(r.resetResultIdentities) : r.resetResultIdentities && this.storeReader.resetCanon()), n;
    }, t.prototype.retain = function(r, n) {
      return (n ? this.optimisticData : this.data).retain(r);
    }, t.prototype.release = function(r, n) {
      return (n ? this.optimisticData : this.data).release(r);
    }, t.prototype.identify = function(r) {
      if (kt(r))
        return r.__ref;
      try {
        return this.policies.identify(r)[0];
      } catch (n) {
        globalThis.__DEV__ !== !1 && ge.warn(n);
      }
    }, t.prototype.evict = function(r) {
      if (!r.id) {
        if (Cr.call(r, "id"))
          return !1;
        r = F(F({}, r), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(r, this.data);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.reset = function(r) {
      var n = this;
      return this.init(), La.reset(), r && r.discardWatches ? (this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch.forget(i);
      }), this.watches.clear(), Pv(this)) : this.broadcastWatches(), Promise.resolve();
    }, t.prototype.removeOptimistic = function(r) {
      var n = this.optimisticData.removeLayer(r);
      n !== this.optimisticData && (this.optimisticData = n, this.broadcastWatches());
    }, t.prototype.batch = function(r) {
      var n = this, i = r.update, a = r.optimistic, o = a === void 0 ? !0 : a, s = r.removeOptimistic, l = r.onWatchUpdated, d, c = function(h) {
        var f = n, p = f.data, m = f.optimisticData;
        ++n.txCount, h && (n.data = n.optimisticData = h);
        try {
          return d = i(n);
        } finally {
          --n.txCount, n.data = p, n.optimisticData = m;
        }
      }, u = /* @__PURE__ */ new Set();
      return l && !this.txCount && this.broadcastWatches(F(F({}, r), { onWatchUpdated: function(h) {
        return u.add(h), !1;
      } })), typeof o == "string" ? this.optimisticData = this.optimisticData.addLayer(o, c) : o === !1 ? c(this.data) : c(), typeof s == "string" && (this.optimisticData = this.optimisticData.removeLayer(s)), l && u.size ? (this.broadcastWatches(F(F({}, r), { onWatchUpdated: function(h, f) {
        var p = l.call(this, h, f);
        return p !== !1 && u.delete(h), p;
      } })), u.size && u.forEach(function(h) {
        return n.maybeBroadcastWatch.dirty(h);
      })) : this.broadcastWatches(r), d;
    }, t.prototype.performTransaction = function(r, n) {
      return this.batch({
        update: r,
        optimistic: n || n !== null
      });
    }, t.prototype.transformDocument = function(r) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(r));
    }, t.prototype.fragmentMatches = function(r, n) {
      return this.policies.fragmentMatches(r, n);
    }, t.prototype.lookupFragment = function(r) {
      var n;
      return ((n = this.config.fragments) === null || n === void 0 ? void 0 : n.lookup(r)) || null;
    }, t.prototype.broadcastWatches = function(r) {
      var n = this;
      this.txCount || this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch(i, r);
      });
    }, t.prototype.addFragmentsToDocument = function(r) {
      var n = this.config.fragments;
      return n ? n.transform(r) : r;
    }, t.prototype.addTypenameToDocument = function(r) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(r) : r;
    }, t.prototype.broadcastWatch = function(r, n) {
      var i = this, a = r.lastDiff, o = zr("canonizeResults", function() {
        return i.diff(r);
      });
      n && (r.optimistic && typeof n.optimistic == "string" && (o.fromOptimisticTransaction = !0), n.onWatchUpdated && n.onWatchUpdated.call(this, r, o, a) === !1) || (!a || !Ft(a.result, o.result)) && r.callback(r.lastDiff = o, a);
    }, t;
  })(nb)
);
globalThis.__DEV__ !== !1 && (gb.prototype.getMemoryInternals = KC);
var wt;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(wt || (wt = {}));
function Ls(e) {
  return e ? e < 7 : !1;
}
var Uv = Object.assign, JA = Object.hasOwnProperty, u0 = (
  /** @class */
  (function(e) {
    Li(t, e);
    function t(r) {
      var n = r.queryManager, i = r.queryInfo, a = r.options, o = this, s = t.inactiveOnCreation.getValue();
      o = e.call(this, function(g) {
        o._getOrCreateQuery();
        try {
          var w = g._subscription._observer;
          w && !w.error && (w.error = ZA);
        } catch {
        }
        var $ = !o.observers.size;
        o.observers.add(g);
        var _ = o.last;
        return _ && _.error ? g.error && g.error(_.error) : _ && _.result && g.next && g.next(o.maskResult(_.result)), $ && o.reobserve().catch(function() {
        }), function() {
          o.observers.delete(g) && !o.observers.size && o.tearDownQuery();
        };
      }) || this, o.observers = /* @__PURE__ */ new Set(), o.subscriptions = /* @__PURE__ */ new Set(), o.dirty = !1, o._getOrCreateQuery = function() {
        return s && (n.queries.set(o.queryId, i), s = !1), o.queryManager.getOrCreateQuery(o.queryId);
      }, o.queryInfo = i, o.queryManager = n, o.waitForOwnResult = wf(a.fetchPolicy), o.isTornDown = !1, o.subscribeToMore = o.subscribeToMore.bind(o), o.maskResult = o.maskResult.bind(o);
      var l = n.defaultOptions.watchQuery, d = l === void 0 ? {} : l, c = d.fetchPolicy, u = c === void 0 ? "cache-first" : c, h = a.fetchPolicy, f = h === void 0 ? u : h, p = a.initialFetchPolicy, m = p === void 0 ? f === "standby" ? u : f : p;
      o.options = F(F({}, a), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: m,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: f
      }), o.queryId = i.queryId || n.generateQueryId();
      var y = Wo(o.query);
      return o.queryName = y && y.name && y.name.value, o;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var r = this;
      return globalThis.__DEV__ !== !1 && Oo("observableQuery.result", function() {
        globalThis.__DEV__ !== !1 && ge.warn(23);
      }), new Promise(function(n, i) {
        var a = {
          next: function(s) {
            n(s), r.observers.delete(a), r.observers.size || r.queryManager.removeQuery(r.queryId), setTimeout(function() {
              o.unsubscribe();
            }, 0);
          },
          error: i
        }, o = r.subscribe(a);
      });
    }, t.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, t.prototype.getCurrentFullResult = function(r) {
      var n = this;
      r === void 0 && (r = !0);
      var i = zr("getLastResult", function() {
        return n.getLastResult(!0);
      }), a = this.queryInfo.networkStatus || i && i.networkStatus || wt.ready, o = F(F({}, i), { loading: Ls(a), networkStatus: a }), s = this.options.fetchPolicy, l = s === void 0 ? "cache-first" : s;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(wf(l) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var d = this.queryInfo.getDiff();
        (d.complete || this.options.returnPartialData) && (o.data = d.result), Ft(o.data, {}) && (o.data = void 0), d.complete ? (delete o.partial, d.complete && o.networkStatus === wt.loading && (l === "cache-first" || l === "cache-only") && (o.networkStatus = wt.ready, o.loading = !1)) : o.partial = !0, o.networkStatus === wt.ready && (o.error || o.errors) && (o.networkStatus = wt.error), globalThis.__DEV__ !== !1 && !d.complete && !this.options.partialRefetch && !o.loading && !o.data && !o.error && vb(d.missing);
      }
      return r && this.updateLastResult(o), o;
    }, t.prototype.getCurrentResult = function(r) {
      return r === void 0 && (r = !0), this.maskResult(this.getCurrentFullResult(r));
    }, t.prototype.isDifferentFromLastResult = function(r, n) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), a = this.queryManager.dataMasking, o = a ? i.nonReactiveQuery : this.query, s = a || i.hasNonreactiveDirective ? !J8(o, this.last.result, r, this.variables) : !Ft(this.last.result, r);
      return s || n && !Ft(this.last.variables, n);
    }, t.prototype.getLast = function(r, n) {
      var i = this.last;
      if (i && i[r] && (!n || Ft(i.variables, this.variables)))
        return i[r];
    }, t.prototype.getLastResult = function(r) {
      return globalThis.__DEV__ !== !1 && Oo("getLastResult", function() {
        globalThis.__DEV__ !== !1 && ge.warn(24);
      }), this.getLast("result", r);
    }, t.prototype.getLastError = function(r) {
      return globalThis.__DEV__ !== !1 && Oo("getLastError", function() {
        globalThis.__DEV__ !== !1 && ge.warn(25);
      }), this.getLast("error", r);
    }, t.prototype.resetLastResults = function() {
      globalThis.__DEV__ !== !1 && Oo("resetLastResults", function() {
        globalThis.__DEV__ !== !1 && ge.warn(26);
      }), delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && ge.warn(27), this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(r) {
      var n, i = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, a = this.options.fetchPolicy;
      if (a === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && r && JA.call(r, "variables")) {
        var o = x8(this.query), s = o.variableDefinitions;
        (!s || !s.some(function(l) {
          return l.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && ge.warn(
          28,
          r,
          ((n = o.name) === null || n === void 0 ? void 0 : n.value) || o
        );
      }
      return r && !Ft(this.options.variables, r) && (i.variables = this.options.variables = F(F({}, this.options.variables), r)), this.queryInfo.resetLastWrite(), this.reobserve(i, wt.refetch);
    }, t.prototype.fetchMore = function(r) {
      var n = this, i = F(F({}, r.query ? r : F(F(F(F({}, this.options), { query: this.options.query }), r), { variables: F(F({}, this.options.variables), r.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var a = this.queryManager.generateQueryId();
      this.lastQuery = r.query ? this.transformDocument(this.options.query) : i.query;
      var o = this.queryInfo, s = o.networkStatus;
      o.networkStatus = wt.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var l = /* @__PURE__ */ new Set(), d = r?.updateQuery, c = this.options.fetchPolicy !== "no-cache";
      return c || ge(d, 29), this.queryManager.fetchQuery(a, i, wt.fetchMore).then(function(u) {
        if (n.queryManager.removeQuery(a), o.networkStatus === wt.fetchMore && (o.networkStatus = s), c)
          n.queryManager.cache.batch({
            update: function(p) {
              var m = r.updateQuery;
              m ? p.updateQuery({
                query: n.query,
                variables: n.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(y) {
                return m(y, {
                  fetchMoreResult: u.data,
                  variables: i.variables
                });
              }) : p.writeQuery({
                query: i.query,
                variables: i.variables,
                data: u.data
              });
            },
            onWatchUpdated: function(p) {
              l.add(p.query);
            }
          });
        else {
          var h = n.getLast("result"), f = d(h.data, {
            fetchMoreResult: u.data,
            variables: i.variables
          });
          n.reportResult(F(F({}, h), { networkStatus: s, loading: Ls(s), data: f }), n.variables);
        }
        return n.maskResult(u);
      }).finally(function() {
        c && !l.has(n.query) && n.reobserveCacheFirst();
      });
    }, t.prototype.subscribeToMore = function(r) {
      var n = this, i = this.queryManager.startGraphQLSubscription({
        query: r.document,
        variables: r.variables,
        context: r.context
      }).subscribe({
        next: function(a) {
          var o = r.updateQuery;
          o && n.updateQuery(function(s, l) {
            return o(s, F({ subscriptionData: a }, l));
          });
        },
        error: function(a) {
          if (r.onError) {
            r.onError(a);
            return;
          }
          globalThis.__DEV__ !== !1 && ge.error(30, a);
        }
      });
      return this.subscriptions.add(i), function() {
        n.subscriptions.delete(i) && i.unsubscribe();
      };
    }, t.prototype.setOptions = function(r) {
      return globalThis.__DEV__ !== !1 && (ar(r, "canonizeResults", "setOptions"), Oo("setOptions", function() {
        globalThis.__DEV__ !== !1 && ge.warn(31);
      })), this.reobserve(r);
    }, t.prototype.silentSetOptions = function(r) {
      var n = hl(this.options, r || {});
      Uv(this.options, n);
    }, t.prototype.setVariables = function(r) {
      var n = this;
      return Ft(this.variables, r) ? this.observers.size ? zr("observableQuery.result", function() {
        return n.result();
      }) : Promise.resolve() : (this.options.variables = r, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: r
      }, wt.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(r) {
      var n = this.queryManager, i = n.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), a = i.result, o = i.complete, s = r(a, {
        variables: this.variables,
        complete: !!o,
        previousData: a
      });
      s && (n.cache.writeQuery({
        query: this.options.query,
        data: s,
        variables: this.variables
      }), n.broadcastQueries());
    }, t.prototype.startPolling = function(r) {
      this.options.pollInterval = r, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(r, n) {
      if (n.nextFetchPolicy) {
        var i = n.fetchPolicy, a = i === void 0 ? "cache-first" : i, o = n.initialFetchPolicy, s = o === void 0 ? a : o;
        a === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(a, {
          reason: r,
          options: n,
          observable: this,
          initialFetchPolicy: s
        }) : r === "variables-changed" ? n.fetchPolicy = s : n.fetchPolicy = n.nextFetchPolicy);
      }
      return n.fetchPolicy;
    }, t.prototype.fetch = function(r, n, i) {
      var a = this._getOrCreateQuery();
      return a.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(a, r, n, i);
    }, t.prototype.updatePolling = function() {
      var r = this;
      if (!this.queryManager.ssrMode) {
        var n = this, i = n.pollingInfo, a = n.options.pollInterval;
        if (!a || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === a)) {
          ge(a, 32);
          var o = i || (this.pollingInfo = {});
          o.interval = a;
          var s = function() {
            var d, c;
            r.pollingInfo && (!Ls(r.queryInfo.networkStatus) && !(!((c = (d = r.options).skipPollAttempt) === null || c === void 0) && c.call(d)) ? r.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: r.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, wt.poll).then(l, l) : l());
          }, l = function() {
            var d = r.pollingInfo;
            d && (clearTimeout(d.timeout), d.timeout = setTimeout(s, d.interval));
          };
          l();
        }
      }
    }, t.prototype.updateLastResult = function(r, n) {
      var i = this;
      n === void 0 && (n = this.variables);
      var a = zr("getLastError", function() {
        return i.getLastError();
      });
      return a && this.last && !Ft(n, this.last.variables) && (a = void 0), this.last = F({ result: this.queryManager.assumeImmutableResults ? r : B8(r), variables: n }, a ? { error: a } : null);
    }, t.prototype.reobserveAsConcast = function(r, n) {
      var i = this;
      this.isTornDown = !1;
      var a = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        n === wt.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        n === wt.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        n === wt.poll
      ), o = this.options.variables, s = this.options.fetchPolicy, l = hl(this.options, r || {}), d = a ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        l
      ) : Uv(this.options, l), c = this.transformDocument(d.query);
      this.lastQuery = c, a || (this.updatePolling(), r && r.variables && !Ft(r.variables, o) && // Don't mess with the fetchPolicy if it's currently "standby".
      d.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (d.fetchPolicy === s || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof d.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", d), n === void 0 && (n = wt.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = wf(d.fetchPolicy));
      var u = function() {
        i.concast === p && (i.waitForOwnResult = !1);
      }, h = d.variables && F({}, d.variables), f = this.fetch(d, n, c), p = f.concast, m = f.fromLink, y = {
        next: function(g) {
          Ft(i.variables, h) && (u(), i.reportResult(g, h));
        },
        error: function(g) {
          Ft(i.variables, h) && (Q8(g) || (g = new $o({ networkError: g })), u(), i.reportError(g, h));
        }
      };
      return !a && (m || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = p, this.observer = y), p.addObserver(y), p;
    }, t.prototype.reobserve = function(r, n) {
      return zT(this.reobserveAsConcast(r, n).promise.then(this.maskResult));
    }, t.prototype.resubscribeAfterError = function() {
      for (var r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var a = this.last;
      zr("resetLastResults", function() {
        return r.resetLastResults();
      });
      var o = this.subscribe.apply(this, n);
      return this.last = a, o;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(r, n) {
      var i = this, a = zr("getLastError", function() {
        return i.getLastError();
      }), o = this.isDifferentFromLastResult(r, n);
      (a || !r.partial || this.options.returnPartialData) && this.updateLastResult(r, n), (a || o) && qd(this.observers, "next", this.maskResult(r));
    }, t.prototype.reportError = function(r, n) {
      var i = this, a = F(F({}, zr("getLastResult", function() {
        return i.getLastResult();
      })), { error: r, errors: r.graphQLErrors, networkStatus: wt.error, loading: !1 });
      this.updateLastResult(a, n), qd(this.observers, "error", this.last.error = r);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(r) {
        return r.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(r) {
      return this.queryManager.transform(r);
    }, t.prototype.maskResult = function(r) {
      return r && "data" in r ? F(F({}, r), { data: this.queryManager.maskOperation({
        document: this.query,
        data: r.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : r;
    }, t.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, t.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, t.prototype.scheduleNotify = function() {
      var r = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return r.notify();
      }, 0)));
    }, t.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !Ls(this.queryInfo.networkStatus))) {
        var r = this.queryInfo.getDiff();
        r.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, t.prototype.reobserveCacheFirst = function() {
      var r = this.options, n = r.fetchPolicy, i = r.nextFetchPolicy;
      return n === "cache-and-network" || n === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(a, o) {
          return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(a, o) : n;
        }
      }) : this.reobserve();
    }, t.inactiveOnCreation = new Dl(), t;
  })(Mt)
);
H8(u0);
function ZA(e) {
  globalThis.__DEV__ !== !1 && ge.error(33, e.message, e.stack);
}
function vb(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && ge.debug(34, e);
}
function wf(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var Fs = new (as ? WeakMap : Map)();
function $f(e, t) {
  var r = e[t];
  typeof r == "function" && (e[t] = function() {
    return Fs.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (Fs.get(e) + 1) % 1e15
    ), r.apply(this, arguments);
  });
}
var kf = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = t.generateQueryId()), this.queryId = r, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
      var n = this.cache = t.cache;
      Fs.has(n) || (Fs.set(n, 0), $f(n, "evict"), $f(n, "modify"), $f(n, "reset"));
    }
    return e.prototype.init = function(t) {
      var r = t.networkStatus || wt.loading;
      return this.variables && this.networkStatus !== wt.loading && !Ft(this.variables, t.variables) && (r = wt.setVariables), Ft(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: t.document,
        variables: t.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: r
      }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
    }, e.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, e.prototype.getDiff = function() {
      var t = this, r = this.getDiffOptions();
      if (this.lastDiff && Ft(r, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var n = this.observableQuery;
      if (n && n.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = zr("canonizeResults", function() {
        return t.cache.diff(r);
      });
      return this.updateLastDiff(i, r), i;
    }, e.prototype.updateLastDiff = function(t, r) {
      this.lastDiff = t ? {
        diff: t,
        options: r || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(t) {
      var r;
      return t === void 0 && (t = this.variables), {
        query: this.document,
        variables: t,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (r = this.observableQuery) === null || r === void 0 ? void 0 : r.options.canonizeResults
      };
    }, e.prototype.setDiff = function(t) {
      var r = this, n, i = this.lastDiff && this.lastDiff.diff;
      t && !t.complete && zr("getLastError", function() {
        var a;
        return (a = r.observableQuery) === null || a === void 0 ? void 0 : a.getLastError();
      }) || (this.updateLastDiff(t), Ft(i && i.result, t && t.result) || (n = this.observableQuery) === null || n === void 0 || n.scheduleNotify());
    }, e.prototype.setObservableQuery = function(t) {
      t !== this.observableQuery && (this.observableQuery = t, t && (t.queryInfo = this));
    }, e.prototype.stop = function() {
      var t;
      if (!this.stopped) {
        this.stopped = !0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), this.cancel();
        var r = this.observableQuery;
        r && r.stopPolling();
      }
    }, e.prototype.cancel = function() {
      var t;
      (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
    }, e.prototype.updateWatch = function(t) {
      var r = this;
      t === void 0 && (t = this.variables);
      var n = this.observableQuery;
      if (!(n && n.options.fetchPolicy === "no-cache")) {
        var i = F(F({}, this.getDiffOptions(t)), { watcher: this, callback: function(a) {
          return r.setDiff(a);
        } });
        (!this.lastWatch || !Ft(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(t, r) {
      var n = this.lastWrite;
      return !(n && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      n.dmCount === Fs.get(this.cache) && Ft(r, n.variables) && Ft(t.data, n.result.data));
    }, e.prototype.markResult = function(t, r, n, i) {
      var a = this, o, s = new qa(), l = Ni(t.errors) ? t.errors.slice(0) : [];
      if ((o = this.observableQuery) === null || o === void 0 || o.resetNotifications(), "incremental" in t && Ni(t.incremental)) {
        var d = W8(this.getDiff().result, t);
        t.data = d;
      } else if ("hasNext" in t && t.hasNext) {
        var c = this.getDiff();
        t.data = s.merge(c.result, t.data);
      }
      this.graphQLErrors = l, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (up(t, n.errorPolicy) ? this.cache.performTransaction(function(u) {
        if (a.shouldWrite(t, n.variables))
          u.writeQuery({
            query: r,
            data: t.data,
            variables: n.variables,
            overwrite: i === 1
          }), a.lastWrite = {
            result: t,
            variables: n.variables,
            dmCount: Fs.get(a.cache)
          };
        else if (a.lastDiff && a.lastDiff.diff.complete) {
          t.data = a.lastDiff.diff.result;
          return;
        }
        var h = a.getDiffOptions(n.variables), f = zr("canonizeResults", function() {
          return u.diff(h);
        });
        !a.stopped && Ft(a.variables, n.variables) && a.updateWatch(n.variables), a.updateLastDiff(f, h), f.complete && (t.data = f.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = wt.ready;
    }, e.prototype.markError = function(t) {
      var r;
      return this.networkStatus = wt.error, this.lastWrite = void 0, (r = this.observableQuery) === null || r === void 0 || r.resetNotifications(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
    }, e;
  })()
);
function up(e, t) {
  t === void 0 && (t = "none");
  var r = t === "ignore" || t === "all", n = !l0(e);
  return !n && r && e.data && (n = !0), n;
}
var XA = Object.prototype.hasOwnProperty, qv = /* @__PURE__ */ Object.create(null), eO = (
  /** @class */
  (function() {
    function e(t) {
      var r = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new y8(
        ta["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new da(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var n = new L8(
        function(a) {
          return r.cache.transformDocument(a);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
      var i = t.documentTransform;
      this.documentTransform = i ? n.concat(i).concat(n) : n, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var t = this;
      this.queries.forEach(function(r, n) {
        t.stopQueryNoBroadcast(n);
      }), this.cancelPendingFetches(Jr(35));
    }, e.prototype.cancelPendingFetches = function(t) {
      this.fetchCancelFns.forEach(function(r) {
        return r(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(t) {
      return qe(this, arguments, void 0, function(r) {
        var n, i, a, o, s, l, d, c = r.mutation, u = r.variables, h = r.optimisticResponse, f = r.updateQueries, p = r.refetchQueries, m = p === void 0 ? [] : p, y = r.awaitRefetchQueries, g = y === void 0 ? !1 : y, w = r.update, $ = r.onQueryUpdated, _ = r.fetchPolicy, x = _ === void 0 ? ((l = this.defaultOptions.mutate) === null || l === void 0 ? void 0 : l.fetchPolicy) || "network-only" : _, S = r.errorPolicy, T = S === void 0 ? ((d = this.defaultOptions.mutate) === null || d === void 0 ? void 0 : d.errorPolicy) || "none" : S, I = r.keepRootFields, M = r.context;
        return ka(this, function(P) {
          switch (P.label) {
            case 0:
              return ge(c, 36), ge(x === "network-only" || x === "no-cache", 37), n = this.generateMutationId(), c = this.cache.transformForLink(this.transform(c)), i = this.getDocumentInfo(c).hasClientExports, u = this.getVariables(c, u), i ? [4, this.localState.addExportedVariables(c, u, M)] : [3, 2];
            case 1:
              u = P.sent(), P.label = 2;
            case 2:
              return a = this.mutationStore && (this.mutationStore[n] = {
                mutation: c,
                variables: u,
                loading: !0,
                error: null
              }), o = h && this.markMutationOptimistic(h, {
                mutationId: n,
                document: c,
                variables: u,
                fetchPolicy: x,
                errorPolicy: T,
                context: M,
                updateQueries: f,
                update: w,
                keepRootFields: I
              }), this.broadcastQueries(), s = this, [2, new Promise(function(O, D) {
                return pf(s.getObservableFromLink(c, F(F({}, M), { optimisticResponse: o ? h : void 0 }), u, {}, !1), function(R) {
                  if (l0(R) && T === "none")
                    throw new $o({
                      graphQLErrors: rp(R)
                    });
                  a && (a.loading = !1, a.error = null);
                  var L = F({}, R);
                  return typeof m == "function" && (m = m(L)), T === "ignore" && l0(L) && delete L.errors, s.markMutationResult({
                    mutationId: n,
                    result: L,
                    document: c,
                    variables: u,
                    fetchPolicy: x,
                    errorPolicy: T,
                    context: M,
                    update: w,
                    updateQueries: f,
                    awaitRefetchQueries: g,
                    refetchQueries: m,
                    removeOptimistic: o ? n : void 0,
                    onQueryUpdated: $,
                    keepRootFields: I
                  });
                }).subscribe({
                  next: function(R) {
                    s.broadcastQueries(), (!("hasNext" in R) || R.hasNext === !1) && O(F(F({}, R), { data: s.maskOperation({
                      document: c,
                      data: R.data,
                      fetchPolicy: x,
                      id: n
                    }) }));
                  },
                  error: function(R) {
                    a && (a.loading = !1, a.error = R), o && s.cache.removeOptimistic(n), s.broadcastQueries(), D(R instanceof $o ? R : new $o({
                      networkError: R
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(t, r) {
      var n = this;
      r === void 0 && (r = this.cache);
      var i = t.result, a = [], o = t.fetchPolicy === "no-cache";
      if (!o && up(i, t.errorPolicy)) {
        if (Gs(i) || a.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), Gs(i) && Ni(i.incremental)) {
          var s = r.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(t.document).asQuery,
            variables: t.variables,
            optimistic: !1,
            returnPartialData: !0
          }), l = void 0;
          s.result && (l = W8(s.result, i)), typeof l < "u" && (i.data = l, a.push({
            result: l,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var d = t.updateQueries;
        d && this.queries.forEach(function(u, h) {
          var f = u.observableQuery, p = f && f.queryName;
          if (!(!p || !XA.call(d, p))) {
            var m = d[p], y = n.queries.get(h), g = y.document, w = y.variables, $ = r.diff({
              query: g,
              variables: w,
              returnPartialData: !0,
              optimistic: !1
            }), _ = $.result, x = $.complete;
            if (x && _) {
              var S = m(_, {
                mutationResult: i,
                queryName: g && Ad(g) || void 0,
                queryVariables: w
              });
              S && a.push({
                result: S,
                dataId: "ROOT_QUERY",
                query: g,
                variables: w
              });
            }
          }
        });
      }
      if (a.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var c = [];
        if (this.refetchQueries({
          updateCache: function(u) {
            o || a.forEach(function(m) {
              return u.write(m);
            });
            var h = t.update, f = !HT(i) || Gs(i) && !i.hasNext;
            if (h) {
              if (!o) {
                var p = u.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: n.getDocumentInfo(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                p.complete && (i = F(F({}, i), { data: p.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              f && h(u, i, {
                context: t.context,
                variables: t.variables
              });
            }
            !o && !t.keepRootFields && f && u.modify({
              id: "ROOT_MUTATION",
              fields: function(m, y) {
                var g = y.fieldName, w = y.DELETE;
                return g === "__typename" ? m : w;
              }
            });
          },
          include: t.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: t.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function(u) {
          return c.push(u);
        }), t.awaitRefetchQueries || t.onQueryUpdated)
          return Promise.all(c).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, e.prototype.markMutationOptimistic = function(t, r) {
      var n = this, i = typeof t == "function" ? t(r.variables, { IGNORE: qv }) : t;
      return i === qv ? !1 : (this.cache.recordOptimisticTransaction(function(a) {
        try {
          n.markMutationResult(F(F({}, r), { result: { data: i } }), a);
        } catch (o) {
          globalThis.__DEV__ !== !1 && ge.error(o);
        }
      }, r.mutationId), !0);
    }, e.prototype.fetchQuery = function(t, r, n) {
      return this.fetchConcastWithInfo(this.getOrCreateQuery(t), r, n).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var t = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(r, n) {
        t[n] = {
          variables: r.variables,
          networkStatus: r.networkStatus,
          networkError: r.networkError,
          graphQLErrors: r.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function(t) {
      var r = this.queries.get(t);
      r && (r.networkError = void 0, r.graphQLErrors = []);
    }, e.prototype.transform = function(t) {
      return this.documentTransform.transformDocument(t);
    }, e.prototype.getDocumentInfo = function(t) {
      var r = this.transformCache;
      if (!r.has(t)) {
        var n = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: CC(t),
          hasForcedResolvers: this.localState.shouldForceResolvers(t),
          hasNonreactiveDirective: ac(["nonreactive"], t),
          nonReactiveQuery: AT(t),
          clientQuery: this.localState.clientQuery(t),
          serverQuery: j8([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], t),
          defaultVars: ym(Wo(t)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: F(F({}, t), { definitions: t.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? F(F({}, i), { operation: "query" }) : i;
          }) })
        };
        r.set(t, n);
      }
      return r.get(t);
    }, e.prototype.getVariables = function(t, r) {
      return F(F({}, this.getDocumentInfo(t).defaultVars), r);
    }, e.prototype.watchQuery = function(t) {
      var r = this.transform(t.query);
      t = F(F({}, t), { variables: this.getVariables(r, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var n = new kf(this), i = new u0({
        queryManager: this,
        queryInfo: n,
        options: t
      });
      return i.lastQuery = r, u0.inactiveOnCreation.getValue() || this.queries.set(i.queryId, n), n.init({
        document: r,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, e.prototype.query = function(t, r) {
      var n = this;
      r === void 0 && (r = this.generateQueryId()), ge(t.query, 38), ge(t.query.kind === "Document", 39), ge(!t.returnPartialData, 40), ge(!t.pollInterval, 41);
      var i = this.transform(t.query);
      return this.fetchQuery(r, F(F({}, t), { query: i })).then(function(a) {
        return a && F(F({}, a), { data: n.maskOperation({
          document: i,
          data: a.data,
          fetchPolicy: t.fetchPolicy,
          id: r
        }) });
      }).finally(function() {
        return n.stopQuery(r);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
      var r = this.queries.get(t);
      r && r.stop();
    }, e.prototype.clearStore = function(t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(Jr(42)), this.queries.forEach(function(r) {
        r.observableQuery ? r.networkStatus = wt.loading : r.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = "active");
      var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set();
      return Array.isArray(t) && t.forEach(function(s) {
        if (typeof s == "string")
          i.set(s, s), a.set(s, !1);
        else if (tT(s)) {
          var l = Mo(r.transform(s));
          i.set(l, Ad(s)), a.set(l, !1);
        } else rr(s) && s.query && o.add(s);
      }), this.queries.forEach(function(s, l) {
        var d = s.observableQuery, c = s.document;
        if (d) {
          if (t === "all") {
            n.set(l, d);
            return;
          }
          var u = d.queryName, h = d.options.fetchPolicy;
          if (h === "standby" || t === "active" && !d.hasObservers())
            return;
          (t === "active" || u && a.has(u) || c && a.has(Mo(c))) && (n.set(l, d), u && a.set(u, !0), c && a.set(Mo(c), !0));
        }
      }), o.size && o.forEach(function(s) {
        var l = B2("legacyOneTimeQuery"), d = r.getOrCreateQuery(l).init({
          document: s.query,
          variables: s.variables
        }), c = new u0({
          queryManager: r,
          queryInfo: d,
          options: F(F({}, s), { fetchPolicy: "network-only" })
        });
        ge(c.queryId === l), d.setObservableQuery(c), n.set(l, c);
      }), globalThis.__DEV__ !== !1 && a.size && a.forEach(function(s, l) {
        if (!s) {
          var d = i.get(l);
          d ? globalThis.__DEV__ !== !1 && ge.warn(43, d) : globalThis.__DEV__ !== !1 && ge.warn(44);
        }
      }), n;
    }, e.prototype.reFetchObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = !1);
      var n = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function(i, a) {
        var o = i.options.fetchPolicy;
        zr("resetLastResults", function() {
          return i.resetLastResults();
        }), (t || o !== "standby" && o !== "cache-only") && n.push(i.refetch()), (r.queries.get(a) || i.queryInfo).setDiff(null);
      }), this.broadcastQueries(), Promise.all(n);
    }, e.prototype.startGraphQLSubscription = function(t) {
      var r = this, n = t.query, i = t.variables, a = t.fetchPolicy, o = t.errorPolicy, s = o === void 0 ? "none" : o, l = t.context, d = l === void 0 ? {} : l, c = t.extensions, u = c === void 0 ? {} : c;
      n = this.transform(n), i = this.getVariables(n, i);
      var h = function(p) {
        return r.getObservableFromLink(n, d, p, u).map(function(m) {
          a !== "no-cache" && (up(m, s) && r.cache.write({
            query: n,
            result: m.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: p
          }), r.broadcastQueries());
          var y = l0(m), g = cA(m);
          if (y || g) {
            var w = {};
            if (y && (w.graphQLErrors = m.errors), g && (w.protocolErrors = m.extensions[Cm]), s === "none" || g)
              throw new $o(w);
          }
          return s === "ignore" && delete m.errors, m;
        });
      };
      if (this.getDocumentInfo(n).hasClientExports) {
        var f = this.localState.addExportedVariables(n, i, d).then(h);
        return new Mt(function(p) {
          var m = null;
          return f.then(function(y) {
            return m = y.subscribe(p);
          }, p.error), function() {
            return m && m.unsubscribe();
          };
        });
      }
      return h(i);
    }, e.prototype.stopQuery = function(t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function(t) {
      var r;
      this.fetchCancelFns.delete(t), this.queries.has(t) && ((r = this.queries.get(t)) === null || r === void 0 || r.stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
        var r;
        return (r = t.observableQuery) === null || r === void 0 ? void 0 : r.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(t, r, n, i, a) {
      var o = this, s;
      a === void 0 && (a = (s = r?.queryDeduplication) !== null && s !== void 0 ? s : this.queryDeduplication);
      var l, d = this.getDocumentInfo(t), c = d.serverQuery, u = d.clientQuery;
      if (c) {
        var h = this, f = h.inFlightLinkObservables, p = h.link, m = {
          query: c,
          variables: n,
          operationName: Ad(c) || void 0,
          context: this.prepareContext(F(F({}, r), { forceFetch: !a })),
          extensions: i
        };
        if (r = m.context, a) {
          var y = Mo(c), g = La(n), w = f.lookup(y, g);
          if (l = w.observable, !l) {
            var $ = new ks([
              ip(p, m)
            ]);
            l = w.observable = $, $.beforeNext(function _(x, S) {
              x === "next" && "hasNext" in S && S.hasNext ? $.beforeNext(_) : f.remove(y, g);
            });
          }
        } else
          l = new ks([
            ip(p, m)
          ]);
      } else
        l = new ks([Mt.of({ data: {} })]), r = this.prepareContext(r);
      return u && (l = pf(l, function(_) {
        return o.localState.runResolvers({
          document: u,
          remoteResult: _,
          context: r,
          variables: n
        });
      })), l;
    }, e.prototype.getResultsFromLink = function(t, r, n) {
      var i = t.lastRequestId = this.generateRequestId(), a = this.cache.transformForLink(n.query);
      return pf(this.getObservableFromLink(a, n.context, n.variables), function(o) {
        var s = rp(o), l = s.length > 0, d = n.errorPolicy;
        if (i >= t.lastRequestId) {
          if (l && d === "none")
            throw t.markError(new $o({
              graphQLErrors: s
            }));
          t.markResult(o, a, n, r), t.markReady();
        }
        var c = {
          data: o.data,
          loading: !1,
          networkStatus: wt.ready
        };
        return l && d === "none" && (c.data = void 0), l && d !== "ignore" && (c.errors = s, c.networkStatus = wt.error), c;
      }, function(o) {
        var s = Q8(o) ? o : new $o({ networkError: o });
        throw i >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchConcastWithInfo = function(t, r, n, i) {
      var a = this;
      n === void 0 && (n = wt.loading), i === void 0 && (i = r.query);
      var o = this.getVariables(i, r.variables), s = this.defaultOptions.watchQuery, l = r.fetchPolicy, d = l === void 0 ? s && s.fetchPolicy || "cache-first" : l, c = r.errorPolicy, u = c === void 0 ? s && s.errorPolicy || "none" : c, h = r.returnPartialData, f = h === void 0 ? !1 : h, p = r.notifyOnNetworkStatusChange, m = p === void 0 ? !1 : p, y = r.context, g = y === void 0 ? {} : y, w = Object.assign({}, r, {
        query: i,
        variables: o,
        fetchPolicy: d,
        errorPolicy: u,
        returnPartialData: f,
        notifyOnNetworkStatusChange: m,
        context: g
      }), $ = function(I) {
        w.variables = I;
        var M = a.fetchQueryByPolicy(t, w, n);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          w.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          M.sources.length > 0 && t.observableQuery && t.observableQuery.applyNextFetchPolicy("after-fetch", r), M
        );
      }, _ = function() {
        return a.fetchCancelFns.delete(t.queryId);
      };
      this.fetchCancelFns.set(t.queryId, function(I) {
        _(), setTimeout(function() {
          return x.cancel(I);
        });
      });
      var x, S;
      if (this.getDocumentInfo(w.query).hasClientExports)
        x = new ks(this.localState.addExportedVariables(w.query, w.variables, w.context).then($).then(function(I) {
          return I.sources;
        })), S = !0;
      else {
        var T = $(w.variables);
        S = T.fromLink, x = new ks(T.sources);
      }
      return x.promise.then(_, _), {
        concast: x,
        fromLink: S
      };
    }, e.prototype.refetchQueries = function(t) {
      var r = this, n = t.updateCache, i = t.include, a = t.optimistic, o = a === void 0 ? !1 : a, s = t.removeOptimistic, l = s === void 0 ? o ? B2("refetchQueries") : void 0 : s, d = t.onQueryUpdated, c = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(h, f) {
        c.set(f, {
          oq: h,
          lastDiff: (r.queries.get(f) || h.queryInfo).getDiff()
        });
      });
      var u = /* @__PURE__ */ new Map();
      return n && this.cache.batch({
        update: n,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: o && l || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: l,
        onWatchUpdated: function(h, f, p) {
          var m = h.watcher instanceof kf && h.watcher.observableQuery;
          if (m) {
            if (d) {
              c.delete(m.queryId);
              var y = d(m, f, p);
              return y === !0 && (y = m.refetch()), y !== !1 && u.set(m, y), y;
            }
            d !== null && c.set(m.queryId, { oq: m, lastDiff: p, diff: f });
          }
        }
      }), c.size && c.forEach(function(h, f) {
        var p = h.oq, m = h.lastDiff, y = h.diff, g;
        d && (y || (y = zr("canonizeResults", function() {
          return r.cache.diff(p.queryInfo.getDiffOptions());
        })), g = d(p, y, m)), (!d || g === !0) && (g = p.refetch()), g !== !1 && u.set(p, g), f.indexOf("legacyOneTimeQuery") >= 0 && r.stopQueryNoBroadcast(f);
      }), l && this.cache.removeOptimistic(l), u;
    }, e.prototype.maskOperation = function(t) {
      var r, n, i, a = t.document, o = t.data;
      if (globalThis.__DEV__ !== !1) {
        var s = t.fetchPolicy, l = t.id, d = (r = Wo(a)) === null || r === void 0 ? void 0 : r.operation, c = ((n = d?.[0]) !== null && n !== void 0 ? n : "o") + l;
        this.dataMasking && s === "no-cache" && !LC(a) && !this.noCacheWarningsByQueryId.has(c) && (this.noCacheWarningsByQueryId.add(c), globalThis.__DEV__ !== !1 && ge.warn(
          45,
          (i = Ad(a)) !== null && i !== void 0 ? i : "Unnamed ".concat(d ?? "operation")
        ));
      }
      return this.dataMasking ? NA(o, a, this.cache) : o;
    }, e.prototype.maskFragment = function(t) {
      var r = t.data, n = t.fragment, i = t.fragmentName;
      return this.dataMasking ? rb(r, n, this.cache, i) : r;
    }, e.prototype.fetchQueryByPolicy = function(t, r, n) {
      var i = this, a = r.query, o = r.variables, s = r.fetchPolicy, l = r.refetchWritePolicy, d = r.errorPolicy, c = r.returnPartialData, u = r.context, h = r.notifyOnNetworkStatusChange, f = t.networkStatus;
      t.init({
        document: a,
        variables: o,
        networkStatus: n
      });
      var p = function() {
        return t.getDiff();
      }, m = function(_, x) {
        x === void 0 && (x = t.networkStatus || wt.loading);
        var S = _.result;
        globalThis.__DEV__ !== !1 && !c && !Ft(S, {}) && vb(_.missing);
        var T = function(I) {
          return Mt.of(F({ data: I, loading: Ls(x), networkStatus: x }, _.complete ? null : { partial: !0 }));
        };
        return S && i.getDocumentInfo(a).hasForcedResolvers ? i.localState.runResolvers({
          document: a,
          remoteResult: { data: S },
          context: u,
          variables: o,
          onlyRunForcedResolvers: !0
        }).then(function(I) {
          return T(I.data || void 0);
        }) : d === "none" && x === wt.refetch && Array.isArray(_.missing) ? T(void 0) : T(S);
      }, y = s === "no-cache" ? 0 : n === wt.refetch && l !== "merge" ? 1 : 2, g = function() {
        return i.getResultsFromLink(t, y, {
          query: a,
          variables: o,
          context: u,
          fetchPolicy: s,
          errorPolicy: d
        });
      }, w = h && typeof f == "number" && f !== n && Ls(n);
      switch (s) {
        default:
        case "cache-first": {
          var $ = p();
          return $.complete ? {
            fromLink: !1,
            sources: [m($, t.markReady())]
          } : c || w ? {
            fromLink: !0,
            sources: [m($), g()]
          } : { fromLink: !0, sources: [g()] };
        }
        case "cache-and-network": {
          var $ = p();
          return $.complete || c || w ? {
            fromLink: !0,
            sources: [m($), g()]
          } : { fromLink: !0, sources: [g()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [m(p(), t.markReady())]
          };
        case "network-only":
          return w ? {
            fromLink: !0,
            sources: [m(p()), g()]
          } : { fromLink: !0, sources: [g()] };
        case "no-cache":
          return w ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [m(t.getDiff()), g()]
          } : { fromLink: !0, sources: [g()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getOrCreateQuery = function(t) {
      return t && !this.queries.has(t) && this.queries.set(t, new kf(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function(t) {
      t === void 0 && (t = {});
      var r = this.localState.prepareContext(t);
      return F(F(F({}, this.defaultContext), r), { clientAwareness: this.clientAwareness });
    }, e;
  })()
), tO = (
  /** @class */
  (function() {
    function e(t) {
      var r = t.cache, n = t.client, i = t.resolvers, a = t.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = r, n && (this.client = n), i && this.addResolvers(i), a && this.setFragmentMatcher(a);
    }
    return e.prototype.addResolvers = function(t) {
      var r = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(n) {
        r.resolvers = cv(r.resolvers, n);
      }) : this.resolvers = cv(this.resolvers, t);
    }, e.prototype.setResolvers = function(t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(t) {
      return qe(this, arguments, void 0, function(r) {
        var n = r.document, i = r.remoteResult, a = r.context, o = r.variables, s = r.onlyRunForcedResolvers, l = s === void 0 ? !1 : s;
        return ka(this, function(d) {
          return n ? [2, this.resolveDocument(n, i.data, a, o, this.fragmentMatcher, l).then(function(c) {
            return F(F({}, i), { data: c.result });
          })] : [2, i];
        });
      });
    }, e.prototype.setFragmentMatcher = function(t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(t) {
      return ac(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function(t) {
      return z8(t);
    }, e.prototype.prepareContext = function(t) {
      var r = this.cache;
      return F(F({}, t), {
        cache: r,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(n) {
          return r.identify(n);
        }
      });
    }, e.prototype.addExportedVariables = function(t) {
      return qe(this, arguments, void 0, function(r, n, i) {
        return n === void 0 && (n = {}), i === void 0 && (i = {}), ka(this, function(a) {
          return r ? [2, this.resolveDocument(r, this.buildRootValueFromCache(r, n) || {}, this.prepareContext(i), n).then(function(o) {
            return F(F({}, n), o.exportedVariables);
          })] : [2, F({}, n)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(t) {
      var r = !1;
      return li(t, {
        Directive: {
          enter: function(n) {
            if (n.name.value === "client" && n.arguments && (r = n.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), r))
              return U1;
          }
        }
      }), r;
    }, e.prototype.buildRootValueFromCache = function(t, r) {
      return this.cache.diff({
        query: TT(t),
        variables: r,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(t, r) {
      return qe(this, arguments, void 0, function(n, i, a, o, s, l) {
        var d, c, u, h, f, p, m, y, g, w, $;
        return a === void 0 && (a = {}), o === void 0 && (o = {}), s === void 0 && (s = function() {
          return !0;
        }), l === void 0 && (l = !1), ka(this, function(_) {
          return d = Hc(n), c = Il(n), u = Ol(c), h = this.collectSelectionsToResolve(d, u), f = d.operation, p = f ? f.charAt(0).toUpperCase() + f.slice(1) : "Query", m = this, y = m.cache, g = m.client, w = {
            fragmentMap: u,
            context: F(F({}, a), { cache: y, client: g }),
            variables: o,
            fragmentMatcher: s,
            defaultOperationType: p,
            exportedVariables: {},
            selectionsToResolve: h,
            onlyRunForcedResolvers: l
          }, $ = !1, [2, this.resolveSelectionSet(d.selectionSet, $, i, w).then(function(x) {
            return {
              result: x,
              exportedVariables: w.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(t, r, n, i) {
      return qe(this, void 0, void 0, function() {
        var a, o, s, l, d, c = this;
        return ka(this, function(u) {
          return a = i.fragmentMap, o = i.context, s = i.variables, l = [n], d = function(h) {
            return qe(c, void 0, void 0, function() {
              var f, p;
              return ka(this, function(m) {
                return !r && !i.selectionsToResolve.has(h) ? [
                  2
                  /*return*/
                ] : Bc(h, s) ? Va(h) ? [2, this.resolveField(h, r, n, i).then(function(y) {
                  var g;
                  typeof y < "u" && l.push((g = {}, g[ra(h)] = y, g));
                })] : (fT(h) ? f = h : (f = a[h.name.value], ge(f, 21, h.name.value)), f && f.typeCondition && (p = f.typeCondition.name.value, i.fragmentMatcher(n, p, o)) ? [2, this.resolveSelectionSet(f.selectionSet, r, n, i).then(function(y) {
                  l.push(y);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(t.selections.map(d)).then(function() {
            return Q1(l);
          })];
        });
      });
    }, e.prototype.resolveField = function(t, r, n, i) {
      return qe(this, void 0, void 0, function() {
        var a, o, s, l, d, c, u, h, f, p = this;
        return ka(this, function(m) {
          return n ? (a = i.variables, o = t.name.value, s = ra(t), l = o !== s, d = n[s] || n[o], c = Promise.resolve(d), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (u = n.__typename || i.defaultOperationType, h = this.resolvers && this.resolvers[u], h && (f = h[l ? o : s], f && (c = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            Am.withValue(this.cache, f, [
              n,
              H1(t, a),
              i.context,
              { field: t, fragmentMap: i.fragmentMap }
            ])
          )))), [2, c.then(function(y) {
            var g, w;
            if (y === void 0 && (y = d), t.directives && t.directives.forEach(function(_) {
              _.name.value === "export" && _.arguments && _.arguments.forEach(function(x) {
                x.name.value === "as" && x.value.kind === "StringValue" && (i.exportedVariables[x.value.value] = y);
              });
            }), !t.selectionSet || y == null)
              return y;
            var $ = (w = (g = t.directives) === null || g === void 0 ? void 0 : g.some(function(_) {
              return _.name.value === "client";
            })) !== null && w !== void 0 ? w : !1;
            if (Array.isArray(y))
              return p.resolveSubSelectedArray(t, r || $, y, i);
            if (t.selectionSet)
              return p.resolveSelectionSet(t.selectionSet, r || $, y, i);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(t, r, n, i) {
      var a = this;
      return Promise.all(n.map(function(o) {
        if (o === null)
          return null;
        if (Array.isArray(o))
          return a.resolveSubSelectedArray(t, r, o, i);
        if (t.selectionSet)
          return a.resolveSelectionSet(t.selectionSet, r, o, i);
      }));
    }, e.prototype.collectSelectionsToResolve = function(t, r) {
      var n = function(o) {
        return !Array.isArray(o);
      }, i = this.selectionsToResolveCache;
      function a(o) {
        if (!i.has(o)) {
          var s = /* @__PURE__ */ new Set();
          i.set(o, s), li(o, {
            Directive: function(l, d, c, u, h) {
              l.name.value === "client" && h.forEach(function(f) {
                n(f) && tv(f) && s.add(f);
              });
            },
            FragmentSpread: function(l, d, c, u, h) {
              var f = r[l.name.value];
              ge(f, 22, l.name.value);
              var p = a(f);
              p.size > 0 && (h.forEach(function(m) {
                n(m) && tv(m) && s.add(m);
              }), s.add(l), p.forEach(function(m) {
                s.add(m);
              }));
            }
          });
        }
        return i.get(o);
      }
      return a(t);
    }, e;
  })()
), Bv = !1, yb = (
  /** @class */
  (function() {
    function e(t) {
      var r = this, n, i, a;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
        throw Jr(16);
      var o = t.uri, s = t.credentials, l = t.headers, d = t.cache, c = t.documentTransform, u = t.ssrMode, h = u === void 0 ? !1 : u, f = t.ssrForceFetchDelay, p = f === void 0 ? 0 : f, m = t.connectToDevTools, y = t.queryDeduplication, g = y === void 0 ? !0 : y, w = t.defaultOptions, $ = t.defaultContext, _ = t.assumeImmutableResults, x = _ === void 0 ? d.assumeImmutableResults : _, S = t.resolvers, T = t.typeDefs, I = t.fragmentMatcher, M = t.clientAwareness, P = t.name, O = t.version, D = t.devtools, R = t.dataMasking;
      globalThis.__DEV__ !== !1 && (ar(t, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead."), ar(t, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead."), ar(t, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead."), ar(t, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead."), ar(t, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead."), ar(t, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead."), ar(t, "typeDefs", "ApolloClient"), t.link || globalThis.__DEV__ !== !1 && ge.warn(17));
      var L = t.link;
      L || (L = o ? new Y8({ uri: o, credentials: s, headers: l }) : Nl.empty()), this.link = L, this.cache = d, this.disableNetworkFetches = h || p > 0, this.queryDeduplication = g, this.defaultOptions = w || /* @__PURE__ */ Object.create(null), this.typeDefs = T, this.devtoolsConfig = F(F({}, D), { enabled: (n = D?.enabled) !== null && n !== void 0 ? n : m }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), p && setTimeout(function() {
        return r.disableNetworkFetches = !1;
      }, p), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = hm, this.localState = new tO({
        cache: d,
        client: this,
        resolvers: S,
        fragmentMatcher: I
      }), this.queryManager = new eO({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: $,
        documentTransform: c,
        queryDeduplication: g,
        ssrMode: h,
        dataMasking: !!R,
        clientAwareness: {
          name: (i = M?.name) !== null && i !== void 0 ? i : P,
          version: (a = M?.version) !== null && a !== void 0 ? a : O
        },
        localState: this.localState,
        assumeImmutableResults: x,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          r.devToolsHookCb && r.devToolsHookCb({
            action: {},
            state: {
              queries: r.queryManager.getQueryStore(),
              mutations: r.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: r.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return Object.defineProperty(e.prototype, "prioritizeCacheValues", {
      /**
       * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
       * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
       * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
       *
       * This can e.g. be used to prioritize the cache during the first render after SSR.
       */
      get: function() {
        return this.disableNetworkFetches;
      },
      set: function(t) {
        this.disableNetworkFetches = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var t = window, r = /* @__PURE__ */ Symbol.for("apollo.devtools");
        (t[r] = t[r] || []).push(this), t.__APOLLO_CLIENT__ = this, !Bv && globalThis.__DEV__ !== !1 && (Bv = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var n = window.navigator, i = n && n.userAgent, a = void 0;
            typeof i == "string" && (i.indexOf("Chrome/") > -1 ? a = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (a = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), a && globalThis.__DEV__ !== !1 && ge.log("Download the Apollo DevTools for a better development experience: %s", a);
          }
        }, 1e4));
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(t) {
      return this.defaultOptions.watchQuery && (t = mf(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = F(F({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (ar(t, "canonizeResults", "client.watchQuery"), ar(t, "partialRefetch", "client.watchQuery")), this.queryManager.watchQuery(t);
    }, e.prototype.query = function(t) {
      return this.defaultOptions.query && (t = mf(this.defaultOptions.query, t)), ge(t.fetchPolicy !== "cache-and-network", 18), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = F(F({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (ar(t, "canonizeResults", "client.query"), ar(t, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed."), t.fetchPolicy === "standby" && globalThis.__DEV__ !== !1 && ge.warn(19)), this.queryManager.query(t);
    }, e.prototype.mutate = function(t) {
      return this.defaultOptions.mutate && (t = mf(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function(t) {
      var r = this, n = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(t).map(function(i) {
        return F(F({}, i), { data: r.queryManager.maskOperation({
          document: t.query,
          data: i.data,
          fetchPolicy: t.fetchPolicy,
          id: n
        }) });
      });
    }, e.prototype.readQuery = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readQuery(t, r);
    }, e.prototype.watchFragment = function(t) {
      var r;
      return this.cache.watchFragment(F(F({}, t), (r = {}, r[/* @__PURE__ */ Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, r)));
    }, e.prototype.readFragment = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readFragment(t, r);
    }, e.prototype.writeQuery = function(t) {
      var r = this.cache.writeQuery(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.writeFragment = function(t) {
      var r = this.cache.writeFragment(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.__actionHookForDevTools = function(t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function(t) {
      return ip(this.link, t);
    }, e.prototype.resetStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(t.resetStoreCallbacks.map(function(r) {
          return r();
        }));
      }).then(function() {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(t.clearStoreCallbacks.map(function(r) {
          return r();
        }));
      });
    }, e.prototype.onResetStore = function(t) {
      var r = this;
      return this.resetStoreCallbacks.push(t), function() {
        r.resetStoreCallbacks = r.resetStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.onClearStore = function(t) {
      var r = this;
      return this.clearStoreCallbacks.push(t), function() {
        r.clearStoreCallbacks = r.clearStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function(t) {
      var r = this.queryManager.refetchQueries(t), n = [], i = [];
      r.forEach(function(o, s) {
        n.push(s), i.push(o);
      });
      var a = Promise.all(i);
      return a.queries = n, a.results = i, a.catch(function(o) {
        globalThis.__DEV__ !== !1 && ge.debug(20, o);
      }), a;
    }, e.prototype.getObservableQueries = function(t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function(t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function(t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function(t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function(t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function(t) {
      this.link = this.queryManager.link = t;
    }, Object.defineProperty(e.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })()
);
globalThis.__DEV__ !== !1 && (yb.prototype.getMemoryInternals = WC);
var h0 = /* @__PURE__ */ new Map(), hp = /* @__PURE__ */ new Map(), bb = !0, Q0 = !1;
function wb(e) {
  return e.replace(/[\s,]+/g, " ").trim();
}
function rO(e) {
  return wb(e.source.body.substring(e.start, e.end));
}
function nO(e) {
  var t = /* @__PURE__ */ new Set(), r = [];
  return e.definitions.forEach(function(n) {
    if (n.kind === "FragmentDefinition") {
      var i = n.name.value, a = rO(n.loc), o = hp.get(i);
      o && !o.has(a) ? bb && console.warn("Warning: fragment with name " + i + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : o || hp.set(i, o = /* @__PURE__ */ new Set()), o.add(a), t.has(a) || (t.add(a), r.push(n));
    } else
      r.push(n);
  }), F(F({}, e), { definitions: r });
}
function iO(e) {
  var t = new Set(e.definitions);
  t.forEach(function(n) {
    n.loc && delete n.loc, Object.keys(n).forEach(function(i) {
      var a = n[i];
      a && typeof a == "object" && t.add(a);
    });
  });
  var r = e.loc;
  return r && (delete r.startToken, delete r.endToken), e;
}
function aO(e) {
  var t = wb(e);
  if (!h0.has(t)) {
    var r = vC(e, {
      experimentalFragmentVariables: Q0,
      allowLegacyFragmentVariables: Q0
    });
    if (!r || r.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    h0.set(t, iO(nO(r)));
  }
  return h0.get(t);
}
function xe(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  typeof e == "string" && (e = [e]);
  var n = e[0];
  return t.forEach(function(i, a) {
    i && i.kind === "Document" ? n += i.loc.source.body : n += i, n += e[a + 1];
  }), aO(n);
}
function oO() {
  h0.clear(), hp.clear();
}
function sO() {
  bb = !1;
}
function lO() {
  Q0 = !0;
}
function dO() {
  Q0 = !1;
}
var sd = {
  gql: xe,
  resetCaches: oO,
  disableFragmentWarnings: sO,
  enableExperimentalFragmentVariables: lO,
  disableExperimentalFragmentVariables: dO
};
(function(e) {
  e.gql = sd.gql, e.resetCaches = sd.resetCaches, e.disableFragmentWarnings = sd.disableFragmentWarnings, e.enableExperimentalFragmentVariables = sd.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = sd.disableExperimentalFragmentVariables;
})(xe || (xe = {}));
xe.default = xe;
function cO(e) {
  return new Nl(function(t, r) {
    var n = ii(t, []);
    return new Mt(function(i) {
      var a, o = !1;
      return Promise.resolve(n).then(function(s) {
        return e(s, t.getContext());
      }).then(t.setContext).then(function() {
        o || (a = r(t).subscribe({
          next: i.next.bind(i),
          error: i.error.bind(i),
          complete: i.complete.bind(i)
        }));
      }).catch(i.error.bind(i)), function() {
        o = !0, a && a.unsubscribe();
      };
    });
  });
}
const uO = /[?&]code=[^&]+/, hO = /[?&]state=[^&]+/, fO = /[?&]error=[^&]+/;
class _f {
  /**
   * @param config - Photon AuthManager configuration options
   * @remarks - Note, that organization is optional for scenarios in which a provider supports more than themselves.
   */
  constructor({ authentication: t, organization: r, audience: n = "https://api.photon.health", connection: i }) {
    this._getAccessToken = (...a) => qe(this, [...a], void 0, function* ({ audience: o } = {
      audience: this.audience
    }, s = !1) {
      const l = {
        authorizationParams: Object.assign({ audience: o || this.audience || void 0 }, this.organization ? { organization: this.organization } : {})
      };
      let d;
      try {
        d = yield this.authentication.getTokenSilently(l);
      } catch (c) {
        c.message.includes("Consent required") && (d = yield this.authentication.getTokenWithPopup(l));
      }
      if (!d) {
        const c = Object.assign(Object.assign({}, l), { appState: {
          returnTo: `${window.location.pathname}${window.location.search}`
        } });
        if (yield this.authentication.loginWithRedirect(c), s)
          throw new Error();
        return yield this._getAccessToken({ audience: o }, !0);
      }
      return d;
    }), this.authentication = t, this.organization = r, this.audience = n, this.connection = i;
  }
  /**
   * Performs a login against the specified Auth0 domain
   * @param config - Login configuration
   * @returns
   */
  login(t) {
    return qe(this, arguments, void 0, function* ({ organizationId: r, invitation: n, connection: i, appState: a }) {
      const o = Object.assign({ authorizationParams: Object.assign(Object.assign(Object.assign(Object.assign({}, this.audience ? { audience: this.audience } : {}), i || this.connection ? { connection: i || this.connection } : {}), r || this.organization ? { organization: r || this.organization } : {}), n ? { invitation: n } : {}) }, a ? { appState: a } : {});
      return this.authentication.loginWithRedirect(o);
    });
  }
  /**
   * Performs a logout against the specified Auth0 domain
   * @param config - Logout configuration
   * @returns
   */
  logout(t) {
    return qe(this, arguments, void 0, function* ({ returnTo: r, federated: n = !1 }) {
      const i = {
        logoutParams: Object.assign(Object.assign({}, r ? { returnTo: r } : {}), n ? { federated: n } : {})
      };
      return this.authentication.logout(i);
    });
  }
  /**
   * Determines if URL has Auth0 parameters
   * @returns boolean
   */
  hasAuthParams(t = window.location.search) {
    return (uO.test(t) || fO.test(t)) && hO.test(t);
  }
  /**
   * Retrieves a valid access token
   * @param config - getAccessToken configuration
   * @returns
   */
  getAccessToken() {
    return qe(this, arguments, void 0, function* ({ audience: t } = {
      audience: this.audience
    }) {
      return yield this._getAccessToken({ audience: t ?? this.audience });
    });
  }
  /**
   * Retrieves a valid access token
   * @param config - getAccessToken configuration
   * @returns
   */
  getAccessTokenWithConsent() {
    return qe(this, arguments, void 0, function* ({ audience: t } = {
      audience: this.audience
    }) {
      const r = {
        authorizationParams: Object.assign({ audience: t || this.audience || void 0 }, this.organization ? { organization: this.organization } : {})
      };
      return this.authentication.getTokenWithPopup(r);
    });
  }
  /**
   * Silently performs a getAccessToken and pre-populates the token and user information caches
   * @returns
   */
  checkSession() {
    return qe(this, void 0, void 0, function* () {
      const t = {
        authorizationParams: Object.assign({ audience: this.audience || void 0 }, this.organization ? { organization: this.organization } : {})
      };
      return this.authentication.checkSession(t);
    });
  }
  /**
   * Handes Auth0 redirect after login
   * @param url - The url which contains the code and state parameters (defaults to window.location.href)
   * @returns
   */
  handleRedirect(t) {
    return qe(this, void 0, void 0, function* () {
      try {
        return this.authentication.handleRedirectCallback(t);
      } catch (r) {
        console.error(r);
      }
    });
  }
  /**
   * Retrieves information about the currently authenticated user
   * @returns
   */
  getUser() {
    return qe(this, void 0, void 0, function* () {
      return this.authentication.getUser();
    });
  }
  /**
   * Determines whether or not a user is currently logged in
   * @returns
   */
  isAuthenticated() {
    return qe(this, void 0, void 0, function* () {
      try {
        return yield this.authentication.checkSession(), yield this.authentication.isAuthenticated();
      } catch {
        return !1;
      }
    });
  }
}
const Au = xe`
  fragment OrganizationFields on Organization {
    id
    name
  }
`, qi = xe`
  fragment PatientFields on Patient {
    id
    externalId
    name {
      full
    }
    dateOfBirth
    sex
    gender
    email
    phone
    address {
      id
      name {
        full
      }
      city
      country
      postalCode
      state
      street1
      street2
    }
  }
`, Hv = xe`
  fragment AllergenFields on Allergen {
    id
    name
    rxcui
  }
`, Ou = xe`
  fragment CatalogFields on Catalog {
    id
    name
  }
`, zo = xe`
  fragment MedicationFields on Medication {
    id
    name
    form
    schedule
    controlled
  }
`, xf = xe`
  fragment SearchMedicationFields on SearchMedication {
    id
    name
  }
`, Wv = xe`
  fragment MedicalEquipmentFields on MedicalEquipment {
    id
    name
  }
`;
xe`
  fragment CatalogTreatmentFields on Catalog {
    treatments {
      id
      name
    }
  }
`;
const Kv = xe`
  fragment DispenseUnitFields on DispenseUnit {
    name
  }
`, pO = xe`
  fragment FillPrescriptionFields on Fill {
    id
    state
    requestedAt
    filledAt
    order {
      id
      createdAt
      state
      fulfillment {
        state
      }
      pharmacy {
        id
        name
        address {
          street1
          street2
          city
          state
          postalCode
        }
      }
    }
  }
`, ld = xe`
  ${pO}
  fragment PrescriptionFields on Prescription {
    id
    externalId
    fills {
      ...FillPrescriptionFields
    }
    prescriber {
      id
      name {
        full
      }
    }
    patient {
      id
      name {
        full
      }
    }
    state
    treatment {
      id
      name
    }
    dispenseAsWritten
    dispenseQuantity
    dispenseUnit
    fillsAllowed
    fillsRemaining
    daysSupply
    instructions
    notes
    effectiveDate
    doNotFillBeforeDate
    expirationDate
    writtenAt
  }
`, mO = xe`
  fragment FillFields on Fill {
    id
    prescription {
      id
    }
    treatment {
      name
    }
    state
    requestedAt
    filledAt
  }
`, dd = xe`
  ${qi}
  ${mO}
  fragment OrderFields on Order {
    id
    externalId
    state
    fills {
      ...FillFields
    }
    patient {
      ...PatientFields
    }
    pharmacy {
      id
      name
      phone
      address {
        city
        country
        postalCode
        state
        street1
        street2
      }
    }
    fulfillment {
      type
      state
      carrier
      trackingNumber
    }
    createdAt
  }
`, Ef = xe`
  fragment WebhookFields on WebhookConfig {
    id
    name
    filters
    url
  }
`, Qv = xe`
  fragment ClientFields on Client {
    id
    name
    secret
    appType
  }
`, Pu = xe`
  fragment PharmacyFields on Pharmacy {
    id
    NPI
    NCPDP
    name
    fulfillmentTypes
    address {
      city
      country
      postalCode
      state
      street1
      street2
    }
  }
`, Sf = xe`
  fragment PrescriptionTemplateFields on PrescriptionTemplate {
    id
    daysSupply
    dispenseAsWritten
    dispenseQuantity
    dispenseUnit
    instructions
    notes
    fillsAllowed
    treatment {
      id
      name
    }
    isPrivate
  }
`;
function Bt(e, t) {
  return qe(this, arguments, void 0, function* (r, n, i = {}, a = "network-only") {
    const o = yield r.query({
      query: n,
      variables: i,
      fetchPolicy: a
    });
    return Object.assign(Object.assign({}, o), { refetch: (s) => r.query({ query: n, variables: Object.assign(i, s) }), fetchMore: ({ after: s, first: l }) => r.query({
      query: n,
      variables: Object.assign(i, { after: s, first: l })
    }) });
  });
}
function ln(e, t) {
  return ({ variables: r, refetchQueries: n, awaitRefetchQueries: i = !1 }) => e.mutate({
    mutation: t,
    refetchQueries: n,
    awaitRefetchQueries: i,
    variables: r
  });
}
const fp = {
  tau: "https://app.boson.health",
  boson: "https://app.boson.health",
  neutron: "https://app.neutron.health",
  photon: "https://app.photon.health"
}, Iu = {
  tau: "https://api.boson.health",
  boson: "https://api.boson.health",
  neutron: "https://api.neutron.health",
  photon: "https://api.photon.health"
}, Gv = {
  tau: "http://clinical-api.tau.health:8080",
  boson: "https://clinical-api.boson.health",
  neutron: "https://clinical-api.neutron.health",
  photon: "https://clinical-api.photon.health"
};
function gO(e) {
  const t = Object.keys(fp).find((r) => e.toLowerCase().includes(r));
  return fp[t || "photon"];
}
class vO {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all catalogs based on currently authenticated organization
   * @param options - Query options
   * @returns
   */
  getCatalogs() {
    return qe(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { CatalogFields: Ou }
    }) {
      t || (t = { CatalogFields: Ou });
      const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      query catalogs {
        catalogs {
          ...${r}
        }
      }
    `;
      return Bt(this.apollo, i);
    });
  }
  /**
   * Retrieves catalog by id
   * @param options - Query options
   * @returns
   */
  getCatalog() {
    return qe(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { CatalogFields: Ou }
    }) {
      r || (r = { CatalogFields: Ou });
      const [n, i] = Object.entries(r)[0], a = xe`
      ${i}
      query catalog($id: ID) {
        catalog(id: $id) {
          ...${n}
        }
      }
    `;
      return Bt(this.apollo, a, { id: t });
    });
  }
  /**
   * Adds a treatment to a catalog
   * @param options - Query options
   * @returns
   */
  addToCatalog({ fragment: t }) {
    t || (t = { MedicationFields: zo });
    const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      mutation addToCatalog(
        $catalogId: ID!
        $treatmentId: ID!
      ) {
        addToCatalog(
          catalogId: $catalogId
          treatmentId: $treatmentId
        ) {
          ...${r}
        }
      }
    `;
    return ln(this.apollo, i);
  }
  /**
   * Removes a treatment from a catalog
   * @param options - Query options
   * @returns
   */
  removeFromCatalog({ fragment: t }) {
    t || (t = { MedicationFields: zo });
    const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      mutation removeFromCatalog(
        $catalogId: ID!
        $treatmentId: ID!
      ) {
        removeFromCatalog(
          catalogId: $catalogId
          treatmentId: $treatmentId
        ) {
          ...${r}
        }
      }
    `;
    return ln(this.apollo, i);
  }
}
class yO {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all medications, optionally filtered by name, type, and code
   * @param options - Query options
   * @returns
   */
  getMedications() {
    return qe(this, arguments, void 0, function* ({ filter: t, after: r, first: n, fragment: i } = {
      fragment: { MedicationFields: zo }
    }) {
      i || (i = { MedicationFields: zo });
      const [a, o] = Object.entries(i)[0], s = xe`
      ${o}
      query medications($filter: MedicationFilter, $after: ID, $first: Int) {
        medications(filter: $filter, after: $after, first: $first) {
          ...${a}
    }
  }
    `;
      return Bt(this.apollo, s, {
        filter: t,
        after: r,
        first: n
      });
    });
  }
}
class bO {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all medical equipment, optionally filtered by name, type, and code
   * @param options - Query options
   * @returns
   */
  getMedicalEquipment() {
    return qe(this, arguments, void 0, function* ({ name: t, after: r, first: n, fragment: i } = {
      fragment: { MedicalEquipmentFields: Wv }
    }) {
      i || (i = { MedicalEquipmentFields: Wv });
      const [a, o] = Object.entries(i)[0], s = xe`
      ${o}
      query medicalEquipment($name: String, $after: ID, $first: Int) {
        medicalEquipment(name: $name, after: $after, first: $first) {
          ...${a}
    }
  }
    `;
      return Bt(this.apollo, s, {
        name: t,
        after: r,
        first: n
      });
    });
  }
}
class wO {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all orders in a paginated fashion, optionally filtered by patientId, patientName
   * @param options - Query options
   * @returns
   */
  getOrders() {
    return qe(this, arguments, void 0, function* ({ patientId: t, patientName: r, after: n, first: i, fragment: a } = {
      first: 25,
      fragment: { OrderFields: dd }
    }) {
      i || (i = 25), a || (a = { OrderFields: dd });
      const [o, s] = Object.entries(a)[0], l = xe`
        ${s}
        query orders(
          $patientId: ID
          $patientName: String
          $after: ID
          $first: Int
      ) {
          orders(
              filter: {
                  patientId: $patientId
                  patientName: $patientName
              }
              after: $after
              first: $first
          ) {
              ...${o}
          }
        }
      `;
      return Bt(this.apollo, l, {
        patientId: t,
        patientName: r,
        after: n,
        first: i
      });
    });
  }
  /**
   * Retrieves order by id
   * @param options - Query options
   * @returns
   */
  getOrder() {
    return qe(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { OrderFields: dd }
    }) {
      r || (r = { OrderFields: dd });
      const [n, i] = Object.entries(r)[0], a = xe`
        ${i}
        query order($id: ID!) {
          order(id: $id) {
            ...${n}
          }
        }
      `;
      return Bt(this.apollo, a, { id: t });
    });
  }
  /**
   * Creates a new order
   * @param options - Query options
   * @returns
   */
  createOrder({ fragment: t }) {
    t || (t = { OrderFields: dd });
    const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      mutation createOrder(
        $externalId: ID
        $patientId: ID!
        $fills: [FillInput!]!
        $addressId: ID
        $address: AddressInput
        $pharmacyId: ID
        $groupId: ID
      ) {
        createOrder(
          externalId: $externalId
          patientId: $patientId
          fills: $fills
          addressId: $addressId
          address: $address
          pharmacyId: $pharmacyId
          groupId: $groupId
        ) {
          ...${r}
        }
      }
    `;
    return ln(this.apollo, i);
  }
}
class $O {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves patient by id
   * @param options - Query options
   * @returns
   */
  getPatient() {
    return qe(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { PatientFields: qi }
    }) {
      r || (r = { PatientFields: qi });
      const [n, i] = Object.entries(r)[0], a = xe`
      ${i}
      query patient($id: ID!) {
        patient(id: $id) {
          ...${n}
        }
      }
    `;
      return Bt(this.apollo, a, { id: t });
    });
  }
  /**
   * Retrieves all patients in a paginated fashion, optionally filtered by name
   * @param options - Query options
   * @returns
   */
  getPatients() {
    return qe(this, arguments, void 0, function* ({ after: t, first: r, name: n, fragment: i } = {
      first: 25,
      fragment: { PatientFields: qi }
    }) {
      i || (i = { PatientFields: qi }), r || (r = 25);
      const [a, o] = Object.entries(i)[0], s = xe`
      ${o}
      query patients($after: ID, $name: String, $first: Int) {
        patients(after: $after, first: $first, filter: { name: $name }) {
          ...${a}
        }
      }
    `;
      return Bt(this.apollo, s, {
        after: t,
        name: n,
        first: r
      });
    });
  }
  /**
   * Creates a new patient
   * @param options - Query options
   * @returns
   */
  createPatient({ fragment: t }) {
    t || (t = { PatientFields: qi });
    const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      mutation createPatient(
        $externalId: ID
        $name: NameInput!
        $dateOfBirth: AWSDate!
        $sex: SexType!
        $gender: String
        $email: AWSEmail
        $phone: AWSPhone!
        $address: AddressInput
        $allergies: [AllergenInput]
        $medicationHistory: [MedHistoryInput]
        $preferredPharmacies: [ID]
      ) {
        createPatient(
          externalId: $externalId
          name: $name
          dateOfBirth: $dateOfBirth
          sex: $sex
          gender: $gender
          address: $address
          email: $email
          phone: $phone
          allergies: $allergies
          medicationHistory: $medicationHistory
          preferredPharmacies: $preferredPharmacies
        ) {
          ...${r}
        }
      }`;
    return ln(this.apollo, i);
  }
  /**
   * Updates an existing patient
   * @param options - Query options
   * @returns
   */
  updatePatient({ fragment: t }) {
    t || (t = { PatientFields: qi });
    const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      mutation updatePatient(
        $id: ID!
        $externalId: ID
        $name: NameInput
        $dateOfBirth: AWSDate
        $sex: SexType
        $gender: String
        $email: AWSEmail
        $phone: AWSPhone
        $allergies: [AllergenInput]
        $medicationHistory: [MedHistoryInput]
        $address: AddressInput
        $preferredPharmacies: [ID]
      ) {
        updatePatient(
          id: $id
          externalId: $externalId
          name: $name
          dateOfBirth: $dateOfBirth
          sex: $sex
          gender: $gender
          email: $email
          phone: $phone
          allergies: $allergies
          medicationHistory: $medicationHistory
          address: $address,
          preferredPharmacies: $preferredPharmacies
        ) {
          ...${r}
        }
      }`;
    return ln(this.apollo, i);
  }
  /**
   * Adds a preferred pharmcy to a patient
   * @param options - Query options
   * @returns
   */
  removePatientPreferredPharmacy({ fragment: t }) {
    t || (t = { PatientFields: qi });
    const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      mutation removePatientPreferredPharmacy(
        $patientId: ID!
        $pharmacyId: ID!
      ) {
        removePatientPreferredPharmacy(
          patientId: $patientId
          pharmacyId: $pharmacyId
        ) {
          ...${r}
        }
      }`;
    return ln(this.apollo, i);
  }
  /**
   * Removes an allergen from a patient
   * @param options - Query options
   * @returns
   */
  removePatientAllergy({ fragment: t }) {
    t || (t = { PatientFields: qi });
    const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      mutation removePatientAllergy(
        $id: ID!
        $allergenId: ID!
      ) {
        updatePatient(
          id: $id
          allergenId: $allergenId
        ) {
          ...${r}
        }
      }`;
    return ln(this.apollo, i);
  }
}
class kO {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all pharmacies, optionally filtered by pharmacy name, in a given latitude/longitude/radius
   * @param options - Query options
   * @returns
   */
  getPharmacies() {
    return qe(this, arguments, void 0, function* ({ name: t, location: r, type: n, after: i, first: a, fragment: o } = {
      first: 100,
      fragment: { PharmacyFields: Pu }
    }) {
      a || (a = 100), o || (o = { PharmacyFields: Pu });
      const [s, l] = Object.entries(o)[0], d = xe`
      ${l}
      query pharmacies($name: String, $location: LatLongSearch, $type: FulfillmentType, $after: Int, $first: Int) {
        pharmacies(name: $name, location: $location, type: $type, after: $after, first: $first) {
          ...${s}
        }
      }
    `;
      return Bt(this.apollo, d, {
        name: t,
        location: r,
        type: n,
        after: i,
        first: a
      });
    });
  }
  /**
   * Retrieves pharmacy by id
   * @param options - Query options
   * @returns
   */
  getPharmacy() {
    return qe(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { PharmacyFields: Pu }
    }) {
      r || (r = { PharmacyFields: Pu });
      const [n, i] = Object.entries(r)[0], a = xe`
          ${i}
          query pharmacy($id: ID!) {
            pharmacy(id: $id) {
              ...${n}
            }
          }
        `;
      return Bt(this.apollo, a, { id: t });
    });
  }
}
class _O {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  getPrescriptions() {
    return qe(this, arguments, void 0, function* ({ patientId: t, patientName: r, prescriberId: n, state: i, after: a, first: o, fragment: s } = {
      first: 25,
      fragment: { PrescriptionFields: ld }
    }) {
      s || (s = { PrescriptionFields: ld }), o || (o = 25);
      const [l, d] = Object.entries(s)[0], c = xe`
      ${d}
      query prescriptions(
        $patientId: ID
        $patientName: String
        $prescriberId: ID
        $state: PrescriptionState
        $after: ID
        $first: Int
      ) {
        prescriptions(
          filter: {
            patientId: $patientId
            patientName: $patientName
            prescriberId: $prescriberId
            state: $state
          }
          after: $after
          first: $first
        ) {
          ...${l}
        }
      }
    `;
      return Bt(this.apollo, c, {
        patientId: t,
        patientName: r,
        prescriberId: n,
        state: i,
        after: a,
        first: o
      });
    });
  }
  getPrescription() {
    return qe(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { PrescriptionFields: ld }
    }) {
      r || (r = { PrescriptionFields: ld });
      const [n, i] = Object.entries(r)[0], a = xe`
      ${i}
      query prescription($id: ID!) {
        prescription(id: $id) {
          ...${n}
        }
      }
    `;
      return Bt(this.apollo, a, {
        id: t
      });
    });
  }
  getDispenseUnits() {
    return qe(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { DispenseUnitFields: Kv }
    }) {
      t || (t = { DispenseUnitFields: Kv });
      const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      query dispenseUnits {
        dispenseUnits {
          ...${r}
        }
      }
    `;
      return Bt(this.apollo, i, {});
    });
  }
  createPrescription({ fragment: t }) {
    t || (t = { PrescriptionFields: ld });
    const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      mutation createPrescription(
        $externalId: ID
        $patientId: ID!
        $treatmentId: ID!
        $dispenseAsWritten: Boolean
        $dispenseQuantity: Float!
        $dispenseUnit: String!
        $fillsAllowed: Int!
        $daysSupply: Int
        $instructions: String!
        $notes: String
        $doNotFillBeforeDate: AWSDate
        $diagnoses: [ID]
      ) {
        createPrescription(
          externalId: $externalId
          patientId: $patientId
          treatmentId: $treatmentId
          dispenseAsWritten: $dispenseAsWritten
          dispenseQuantity: $dispenseQuantity
          dispenseUnit: $dispenseUnit
          fillsAllowed: $fillsAllowed
          daysSupply: $daysSupply
          instructions: $instructions
          notes: $notes
          doNotFillBeforeDate: $doNotFillBeforeDate
          diagnoses: $diagnoses
        ) {
          ...${r}
        }
      }`;
    return ln(this.apollo, i);
  }
}
class xO {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all allergens, optionally filtered by name (fuzzy)
   * @param options - Query options
   * @returns
   */
  getAllergens() {
    return qe(this, arguments, void 0, function* ({ fragment: t, filter: r } = {
      fragment: { AllergenFields: Hv }
    }) {
      t || (t = { AllergenFields: Hv });
      const [n, i] = Object.entries(t)[0], a = xe`
        ${i}
        query allergens($filter: AllergenFilter) {
            allergens(filter: $filter) {
                ...${n}
            }
        }
      `;
      return Bt(this.apollo, a, {
        filter: r
      });
    });
  }
}
class EO {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Creates a new prescription template
   * @param options - Query options
   * @returns
   */
  createPrescriptionTemplate({ fragment: t }) {
    t || (t = { PrescriptionTemplateFields: Sf });
    const [r, n] = Object.entries(t)[0], i = xe`
        ${n}
        mutation createPrescriptionTemplate(
          $catalogId: ID!,
          $treatmentId: ID!,
          $dispenseAsWritten: Boolean,
          $dispenseQuantity: Float,
          $dispenseUnit: String,
          $fillsAllowed: Int,
          $daysSupply: Int,
          $instructions: String,
          $notes: String,
          $name: String,
          $isPrivate: Boolean
        ) {
          createPrescriptionTemplate(
            catalogId: $catalogId
            treatmentId: $treatmentId
            dispenseAsWritten: $dispenseAsWritten
            dispenseQuantity: $dispenseQuantity
            dispenseUnit: $dispenseUnit
            fillsAllowed: $fillsAllowed
            daysSupply: $daysSupply
            instructions: $instructions
            notes: $notes
            name: $name
            isPrivate: $isPrivate
        ) {
            ...${r}
        }
      }
      `;
    return ln(this.apollo, i);
  }
  /**
   * Updates a prescription template
   * @param options - Query options
   * @returns
   */
  updatePrescriptionTemplate({ fragment: t }) {
    t || (t = { PrescriptionTemplateFields: Sf });
    const [r, n] = Object.entries(t)[0], i = xe`
        ${n}
        mutation updatePrescriptionTemplate(
          $catalogId: ID!,
          $templateId: ID!,
          $dispenseAsWritten: Boolean,
          $dispenseQuantity: Float,
          $dispenseUnit: String,
          $fillsAllowed: Int,
          $daysSupply: Int,
          $instructions: String,
          $notes: String,
          $name: String
        ) {
          updatePrescriptionTemplate(
            catalogId: $catalogId
            templateId: $templateId
            dispenseAsWritten: $dispenseAsWritten
            dispenseQuantity: $dispenseQuantity
            dispenseUnit: $dispenseUnit
            fillsAllowed: $fillsAllowed
            daysSupply: $daysSupply
            instructions: $instructions
            notes: $notes
            name: $name
        ) {
            ...${r}
        }
      }
      `;
    return ln(this.apollo, i);
  }
  /**
   * Deletes an existing prescription template
   * @param options - Query options
   * @returns
   */
  deletePrescriptionTemplate({ fragment: t }) {
    t || (t = { PrescriptionTemplateFields: Sf });
    const [r, n] = Object.entries(t)[0], i = xe`
        ${n}
        mutation deletePrescriptionTemplate(
          $catalogId: ID!,
          $templateId: ID!
        ) {
          deletePrescriptionTemplate(
            catalogId: $catalogId
            templateId: $templateId
        ) {
            ...${r}
        }
      }
      `;
    return ln(this.apollo, i);
  }
}
class SO {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all medication concepts, filtered by name
   * @param options - Query options
   * @returns
   */
  getConcepts(t) {
    return qe(this, arguments, void 0, function* ({ name: r, fragment: n }) {
      n || (n = { SearchMedicationFields: xf });
      const [i, a] = Object.entries(n)[0], o = xe`
        ${a}
        query medicationConcepts($name: String!) {
          medicationConcepts(name: $name) {
            ...${i}
      }
    }
      `;
      return Bt(this.apollo, o, {
        name: r
      });
    });
  }
  /**
   * Retrieves all strengths for a SearchMedication CONCEPT
   * @param options - Query options
   * @returns
   */
  getStrengths(t) {
    return qe(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { SearchMedicationFields: xf });
      const [i, a] = Object.entries(n)[0], o = xe`
          ${a}
          query medicationStrengths($id: String!) {
            medicationStrengths(id: $id) {
              ...${i}
        }
      }
        `;
      return Bt(this.apollo, o, {
        id: r
      });
    });
  }
  /**
   * Retrieves all routes for a SearchMedication STRENGTH
   * @param options - Query options
   * @returns
   */
  getRoutes(t) {
    return qe(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { SearchMedicationFields: xf });
      const [i, a] = Object.entries(n)[0], o = xe`
              ${a}
              query medicationRoutes($id: String!) {
                medicationRoutes(id: $id) {
                  ...${i}
            }
          }
            `;
      return Bt(this.apollo, o, {
        id: r
      });
    });
  }
  /**
   * Retrieves all forms for a SearchMedication ROUTE
   * @param options - Query options
   * @returns
   */
  getForms(t) {
    return qe(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { MedicationFields: zo });
      const [i, a] = Object.entries(n)[0], o = xe`
              ${a}
              query medicationForms($id: String!) {
                medicationForms(id: $id) {
                  ...${i}
            }
          }
            `;
      return Bt(this.apollo, o, {
        id: r
      });
    });
  }
  /**
   * Retrieves all products for a SearchMedication FORM/Medication DRUG
   * @param options - Query options
   * @returns
   */
  getProducts(t) {
    return qe(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { MedicationFields: zo });
      const [i, a] = Object.entries(n)[0], o = xe`
                  ${a}
                  query medicationProducts($id: String!) {
                    medicationProducts(id: $id) {
                      ...${i}
                }
              }
                `;
      return Bt(this.apollo, o, {
        id: r
      });
    });
  }
  /**
   * Retrieves all packages for a Medication PRODUCT
   * @param options - Query optiofns
   * @returns
   */
  getPackages(t) {
    return qe(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { MedicationFields: zo });
      const [i, a] = Object.entries(n)[0], o = xe`
                  ${a}
                  query medicationPackages($id: String!) {
                    medicationPackages(id: $id) {
                      ...${i}
                }
              }
                `;
      return Bt(this.apollo, o, {
        id: r
      });
    });
  }
}
class CO {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.catalog = new vO(t), this.medication = new yO(t), this.medicalEquipment = new bO(t), this.searchMedication = new SO(t), this.order = new wO(t), this.patient = new $O(t), this.pharmacy = new kO(t), this.prescription = new _O(t), this.allergens = new xO(t), this.prescriptionTemplate = new EO(t);
  }
}
class TO {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all Auth0 clients based on currently authenticated organization
   * @param options - Query options
   * @returns
   */
  getClients() {
    return qe(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { ClientFields: Qv }
    }) {
      const [r, n] = Object.entries(t)[0], i = xe`
          ${n}
          query clients {
            clients {
              ...${r}
            }
          }
        `;
      return Bt(this.apollo, i);
    });
  }
  /**
   * Rotates client_secret for the authenticated Auth0 organization
   * @param options - Query options
   * @returns
   */
  rotateSecret({ fragment: t }) {
    t || (t = { ClientFields: Qv });
    const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      mutation rotateSecret(
        $id: ID!
      ) {
        rotateSecret(id: $id) {
          ...${r}
        }
      }
    `;
    return ln(this.apollo, i);
  }
}
class AO {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves the organization associated with the authenticated user
   * @param options - Query options
   * @returns
   */
  getOrganization() {
    return qe(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { OrganizationFields: Au }
    }) {
      t || (t = { OrganizationFields: Au });
      const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      query organization {
        organization {
          ...${r}
        }
      }
    `;
      return Bt(this.apollo, i);
    });
  }
  /**
   * Retrieves all organizations associated with the auhenticated user
   * @param options - Query options
   * @returns
   */
  getOrganizations() {
    return qe(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { OrganizationFields: Au }
    }) {
      t || (t = { OrganizationFields: Au });
      const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      query organizations {
        organizations {
          ...${r}
        }
      }
    `;
      return Bt(this.apollo, i);
    });
  }
}
class OO {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves list of webhook associated with currently authenticated organization
   * @param options - Query options
   * @returns
   */
  getWebhooks() {
    return qe(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { WebhookFields: Ef }
    }) {
      t || (t = { WebhookFields: Ef });
      const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      query webhooks {
        webhooks {
          ...${r}
        }
      }
    `;
      return Bt(this.apollo, i);
    });
  }
  /**
   * Creates a new webhook for the authenticated organization
   * @param options - Query options
   * @returns
   */
  createWebhook({ fragment: t }) {
    t || (t = { WebhookFields: Ef });
    const [r, n] = Object.entries(t)[0], i = xe`
      ${n}
      mutation createWebhook(
        $name: String
        $filters: [String]
        $sharedSecret: String
        $url: String!
      ) {
        createWebhookConfig(name: $name, filters: $filters, sharedSecret: $sharedSecret, url: $url) {
          ...${r}
        }
      }`;
    return ln(this.apollo, i);
  }
  /**
   * Deletes a webhook, by id, inside the currently authenticated organization
   * @returns
   */
  deleteWebhook() {
    const t = xe`
      mutation deleteWebhookConfig($id: String!) {
        deleteWebhookConfig(id: $id)
      }
    `;
    return ln(this.apollo, t);
  }
}
class PO {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.client = new TO(t), this.organization = new AO(t), this.webhook = new OO(t);
  }
}
const IO = "1.4.1", Cf = {
  version: IO
};
var pp;
(function(e) {
  e.Drug = "DRUG", e.Package = "PACKAGE", e.Product = "PRODUCT";
})(pp || (pp = {}));
var mp;
(function(e) {
  e.Icd10 = "ICD10";
})(mp || (mp = {}));
var gp;
(function(e) {
  e.Canceled = "CANCELED", e.New = "NEW", e.Scheduled = "SCHEDULED", e.Sent = "SENT";
})(gp || (gp = {}));
var vp;
(function(e) {
  e.MailOrder = "MAIL_ORDER", e.PickUp = "PICK_UP";
})(vp || (vp = {}));
var yp;
(function(e) {
  e.Otc = "OTC", e.Rx = "RX";
})(yp || (yp = {}));
var bp;
(function(e) {
  e.Canceled = "CANCELED", e.Completed = "COMPLETED", e.Error = "ERROR", e.Pending = "PENDING", e.Placed = "PLACED", e.Routing = "ROUTING";
})(bp || (bp = {}));
var wp;
(function(e) {
  e.Pharmacy = "PHARMACY", e.Prescriber = "PRESCRIBER";
})(wp || (wp = {}));
var $p;
(function(e) {
  e.Draft = "DRAFT", e.Active = "ACTIVE", e.Depleted = "DEPLETED", e.Expired = "EXPIRED", e.Canceled = "CANCELED";
})($p || ($p = {}));
var kp;
(function(e) {
  e.I = "I", e.Ii = "II", e.Iii = "III", e.Iv = "IV", e.V = "V";
})(kp || (kp = {}));
var _p;
(function(e) {
  e.Concept = "CONCEPT", e.Form = "FORM", e.Route = "ROUTE", e.Strength = "STRENGTH";
})(_p || (_p = {}));
var xp;
(function(e) {
  e.Female = "FEMALE", e.Male = "MALE", e.Unknown = "UNKNOWN";
})(xp || (xp = {}));
const G0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ConceptType() {
    return pp;
  },
  get DiagnosisType() {
    return mp;
  },
  get FillState() {
    return gp;
  },
  get FulfillmentType() {
    return vp;
  },
  get MedicationType() {
    return yp;
  },
  get OrderState() {
    return bp;
  },
  get OrgType() {
    return wp;
  },
  get PrescriptionState() {
    return $p;
  },
  get ScheduleType() {
    return kp;
  },
  get SearchMedicationType() {
    return _p;
  },
  get SexType() {
    return xp;
  }
}, Symbol.toStringTag, { value: "Module" }));
var Yv;
(function(e) {
  e.Coupon = "coupon", e.Discount = "discount", e.Insurance = "insurance";
})(Yv || (Yv = {}));
var Jv;
(function(e) {
  e.Admin = "admin", e.Group = "group", e.Photon = "photon", e.Provider = "provider";
})(Jv || (Jv = {}));
var Zv;
(function(e) {
  e.Covered = "COVERED", e.CoveredWithRestrictions = "COVERED_WITH_RESTRICTIONS", e.NotCovered = "NOT_COVERED";
})(Zv || (Zv = {}));
var Xv;
(function(e) {
  e.Canceled = "CANCELED", e.New = "NEW", e.Scheduled = "SCHEDULED", e.Sent = "SENT";
})(Xv || (Xv = {}));
var e4;
(function(e) {
  e.MailOrder = "MAIL_ORDER", e.PickUp = "PICK_UP";
})(e4 || (e4 = {}));
var t4;
(function(e) {
  e.Otc = "OTC", e.Rx = "RX";
})(t4 || (t4 = {}));
var r4;
(function(e) {
  e.Canceled = "CANCELED", e.Completed = "COMPLETED", e.Error = "ERROR", e.Pending = "PENDING", e.Placed = "PLACED";
})(r4 || (r4 = {}));
var n4;
(function(e) {
  e.Pharmacy = "PHARMACY", e.Prescriber = "PRESCRIBER";
})(n4 || (n4 = {}));
var i4;
(function(e) {
  e.Major = "MAJOR", e.Minor = "MINOR", e.Moderate = "MODERATE";
})(i4 || (i4 = {}));
var a4;
(function(e) {
  e.Allergen = "ALLERGEN", e.Drug = "DRUG";
})(a4 || (a4 = {}));
var o4;
(function(e) {
  e.Active = "ACTIVE", e.Canceled = "CANCELED", e.Depleted = "DEPLETED", e.Draft = "DRAFT", e.Expired = "EXPIRED";
})(o4 || (o4 = {}));
var s4;
(function(e) {
  e.Exclude = "EXCLUDE", e.Include = "INCLUDE", e.NoAdvice = "NO_ADVICE", e.NoRouting = "NO_ROUTING";
})(s4 || (s4 = {}));
var l4;
(function(e) {
  e.Female = "FEMALE", e.Male = "MALE", e.Unknown = "UNKNOWN";
})(l4 || (l4 = {}));
const DO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SearchTreatments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "filter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "TreatmentFilter" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "treatments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "filter" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] }, NO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SearchTreatmentOptionsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "filter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "TreatmentFilter" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "treatments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "filter" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] }, MO = {
  "\n  query SearchTreatments($filter: TreatmentFilter!) {\n    treatments(filter: $filter) {\n      id\n      name\n    }\n  }\n": DO,
  "\n  query SearchTreatmentOptionsQuery($filter: TreatmentFilter!) {\n    treatments(filter: $filter) {\n      __typename\n      id\n      name\n    }\n  }\n": NO
};
function $b(e) {
  var t;
  return (t = MO[e]) !== null && t !== void 0 ? t : {};
}
const RO = $b(`
  query SearchTreatments($filter: TreatmentFilter!) {
    treatments(filter: $filter) {
      id
      name
    }
  }
`), LO = $b(`
  query SearchTreatmentOptionsQuery($filter: TreatmentFilter!) {
    treatments(filter: $filter) {
      __typename
      id
      name
    }
  }
`);
var Tf;
const FO = (Tf = Cf?.version) !== null && Tf !== void 0 ? Tf : "unknown";
class jO {
  /**
   * Constructs a new PhotonSDK instance
   * @param config - Photon SDK configuration options
   * @remarks - Note, that organization is optional for scenarios in which a provider supports more than themselves.
   */
  constructor({ domain: t, clientId: r, redirectURI: n, organization: i, env: a = "photon", audience: o, connection: s, uri: l, developmentMode: d = !1 }, c) {
    this.audience = o || Iu[a], this.uri = l || `${Iu[a]}/graphql`, this.clinicalUrl = l ? gO(l) : fp[a], this.clinicalApiUri = `${Gv[a]}/graphql`, d && (this.audience = Iu.neutron, this.uri = `${Iu.neutron}/graphql`, this.clinicalApiUri = `${Gv.neutron}/graphql`);
    const u = {
      domain: t || (d ? "auth.neutron.health" : "auth.photon.health"),
      clientId: r,
      cacheLocation: "localstorage",
      useRefreshTokens: !0,
      useRefreshTokensFallback: !0,
      authorizationParams: Object.assign({ redirect_uri: n, audience: this.audience }, s ? { connection: s } : {})
    };
    this.auth0Client = new LS(u), this.organization = i, this.authentication = new _f(Object.assign({ authentication: this.auth0Client, organization: this.organization, audience: this.audience }, s ? { connection: s } : {})), this.apollo = this.constructApolloClient({ elementsVersion: c, isServices: !1 }), this.apolloClinical = this.constructApolloClient({ elementsVersion: c, isServices: !0 }), this.clinical = new CO(this.apollo), this.management = new PO(this.apollo);
  }
  constructApolloClient({ elementsVersion: t, isServices: r } = {
    isServices: !1
  }) {
    return new yb({
      link: cO((i, a) => qe(this, void 0, void 0, function* () {
        var { headers: o } = a, s = ii(a, ["headers"]);
        const l = yield this.authentication.getAccessToken(), d = Object.assign(Object.assign(Object.assign({}, o), { "x-photon-sdk-version": FO }), t ? { "x-photon-elements-version": t } : {});
        return l ? Object.assign(Object.assign({}, s), { headers: r ? Object.assign(Object.assign({}, d), { "x-photon-auth-token": l, "x-photon-auth-token-type": "auth0" }) : Object.assign(Object.assign({}, d), { authorization: l }) }) : Object.assign({ headers: d }, s);
      })).concat(new Y8({
        uri: r ? this.clinicalApiUri : this.uri
      })),
      defaultOptions: {
        query: {
          fetchPolicy: "cache-first",
          errorPolicy: "all"
        },
        mutate: {
          // Because of the way we do lambdas, we have a _slight_ delay between reads and writes
          // This forces a delay of 1s which isn't the greatest, but also isn't the worst
          // https://github.com/apollographql/apollo-feature-requests/issues/207
          onQueryUpdated: VO
        }
      },
      cache: new gb({
        // Addresses and names don't have unique ids. So we just allow for merging these
        typePolicies: {
          Patient: {
            fields: {
              name: {
                merge(i, a, { mergeObjects: o }) {
                  return o(i, a);
                }
              },
              address: {
                merge(i, a, { mergeObjects: o }) {
                  return o(i, a);
                }
              }
            }
          },
          User: {
            fields: {
              name: {
                merge(i, a, { mergeObjects: o }) {
                  return o(i, a);
                }
              },
              address: {
                merge(i, a, { mergeObjects: o }) {
                  return o(i, a);
                }
              }
            }
          }
        }
      })
    });
  }
  /**
   * Sets the organization ID to use
   * @returns PhotonSDK
   */
  setOrganization(t) {
    return this.organization = t, this.authentication = new _f({
      authentication: this.auth0Client,
      organization: t,
      audience: this.audience
    }), this;
  }
  /**
   * Clears the organization ID
   * @returns PhotonSDK
   */
  clearOrganization() {
    return this.organization = void 0, this.authentication = new _f({
      authentication: this.auth0Client,
      organization: void 0,
      audience: this.audience
    }), this.authentication.login({}), this;
  }
}
const zO = (e) => new Promise((t) => setTimeout(t, e)), VO = (e) => qe(void 0, void 0, void 0, function* () {
  yield zO(1e3), e.refetch();
}), UO = [
  "allowfullscreen",
  "async",
  "alpha",
  "autofocus",
  "autoplay",
  "checked",
  "controls",
  "default",
  "disabled",
  "formnovalidate",
  "hidden",
  "indeterminate",
  "inert",
  "ismap",
  "loop",
  "multiple",
  "muted",
  "nomodule",
  "novalidate",
  "open",
  "playsinline",
  "readonly",
  "required",
  "reversed",
  "seamless",
  "selected",
  "adauctionheaders",
  "browsingtopics",
  "credentialless",
  "defaultchecked",
  "defaultmuted",
  "defaultselected",
  "defer",
  "disablepictureinpicture",
  "disableremoteplayback",
  "preservespitch",
  "shadowrootclonable",
  "shadowrootcustomelementregistry",
  "shadowrootdelegatesfocus",
  "shadowrootserializable",
  "sharedstoragewritable"
], qO = /* @__PURE__ */ new Set([
  "className",
  "value",
  "readOnly",
  "noValidate",
  "formNoValidate",
  "isMap",
  "noModule",
  "playsInline",
  "adAuctionHeaders",
  "allowFullscreen",
  "browsingTopics",
  "defaultChecked",
  "defaultMuted",
  "defaultSelected",
  "disablePictureInPicture",
  "disableRemotePlayback",
  "preservesPitch",
  "shadowRootClonable",
  "shadowRootCustomElementRegistry",
  "shadowRootDelegatesFocus",
  "shadowRootSerializable",
  "sharedStorageWritable",
  ...UO
]), BO = /* @__PURE__ */ new Set(["innerHTML", "textContent", "innerText", "children"]), HO = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  className: "class",
  htmlFor: "for"
}), WO = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  class: "className",
  novalidate: {
    $: "noValidate",
    FORM: 1
  },
  formnovalidate: {
    $: "formNoValidate",
    BUTTON: 1,
    INPUT: 1
  },
  ismap: {
    $: "isMap",
    IMG: 1
  },
  nomodule: {
    $: "noModule",
    SCRIPT: 1
  },
  playsinline: {
    $: "playsInline",
    VIDEO: 1
  },
  readonly: {
    $: "readOnly",
    INPUT: 1,
    TEXTAREA: 1
  },
  adauctionheaders: {
    $: "adAuctionHeaders",
    IFRAME: 1
  },
  allowfullscreen: {
    $: "allowFullscreen",
    IFRAME: 1
  },
  browsingtopics: {
    $: "browsingTopics",
    IMG: 1
  },
  defaultchecked: {
    $: "defaultChecked",
    INPUT: 1
  },
  defaultmuted: {
    $: "defaultMuted",
    AUDIO: 1,
    VIDEO: 1
  },
  defaultselected: {
    $: "defaultSelected",
    OPTION: 1
  },
  disablepictureinpicture: {
    $: "disablePictureInPicture",
    VIDEO: 1
  },
  disableremoteplayback: {
    $: "disableRemotePlayback",
    AUDIO: 1,
    VIDEO: 1
  },
  preservespitch: {
    $: "preservesPitch",
    AUDIO: 1,
    VIDEO: 1
  },
  shadowrootclonable: {
    $: "shadowRootClonable",
    TEMPLATE: 1
  },
  shadowrootdelegatesfocus: {
    $: "shadowRootDelegatesFocus",
    TEMPLATE: 1
  },
  shadowrootserializable: {
    $: "shadowRootSerializable",
    TEMPLATE: 1
  },
  sharedstoragewritable: {
    $: "sharedStorageWritable",
    IFRAME: 1,
    IMG: 1
  }
});
function KO(e, t) {
  const r = WO[e];
  return typeof r == "object" ? r[t] ? r.$ : void 0 : r;
}
const QO = /* @__PURE__ */ new Set(["beforeinput", "click", "dblclick", "contextmenu", "focusin", "focusout", "input", "keydown", "keyup", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "pointerdown", "pointermove", "pointerout", "pointerover", "pointerup", "touchend", "touchmove", "touchstart"]), GO = /* @__PURE__ */ new Set([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animate",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "circle",
  "clipPath",
  "color-profile",
  "cursor",
  "defs",
  "desc",
  "ellipse",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "filter",
  "font",
  "font-face",
  "font-face-format",
  "font-face-name",
  "font-face-src",
  "font-face-uri",
  "foreignObject",
  "g",
  "glyph",
  "glyphRef",
  "hkern",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "metadata",
  "missing-glyph",
  "mpath",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "set",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "textPath",
  "tref",
  "tspan",
  "use",
  "view",
  "vkern"
]), YO = {
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace"
}, Pt = (e) => B(() => e());
function JO(e, t, r) {
  let n = r.length, i = t.length, a = n, o = 0, s = 0, l = t[i - 1].nextSibling, d = null;
  for (; o < i || s < a; ) {
    if (t[o] === r[s]) {
      o++, s++;
      continue;
    }
    for (; t[i - 1] === r[a - 1]; )
      i--, a--;
    if (i === o) {
      const c = a < n ? s ? r[s - 1].nextSibling : r[a - s] : l;
      for (; s < a; ) e.insertBefore(r[s++], c);
    } else if (a === s)
      for (; o < i; )
        (!d || !d.has(t[o])) && t[o].remove(), o++;
    else if (t[o] === r[a - 1] && r[s] === t[i - 1]) {
      const c = t[--i].nextSibling;
      e.insertBefore(r[s++], t[o++].nextSibling), e.insertBefore(r[--a], c), t[i] = r[a];
    } else {
      if (!d) {
        d = /* @__PURE__ */ new Map();
        let u = s;
        for (; u < a; ) d.set(r[u], u++);
      }
      const c = d.get(t[o]);
      if (c != null)
        if (s < c && c < a) {
          let u = o, h = 1, f;
          for (; ++u < i && u < a && !((f = d.get(t[u])) == null || f !== c + h); )
            h++;
          if (h > c - s) {
            const p = t[o];
            for (; s < c; ) e.insertBefore(r[s++], p);
          } else e.replaceChild(r[s++], t[o++]);
        } else o++;
      else t[o++].remove();
    }
  }
}
const d4 = "_$DX_DELEGATE";
function k(e, t, r, n) {
  let i;
  const a = () => {
    const s = n ? document.createElementNS("http://www.w3.org/1998/Math/MathML", "template") : document.createElement("template");
    return s.innerHTML = e, r ? s.content.firstChild.firstChild : n ? s.firstChild : s.content.firstChild;
  }, o = t ? () => Le(() => document.importNode(i || (i = a()), !0)) : () => (i || (i = a())).cloneNode(!0);
  return o.cloneNode = o, o;
}
function qr(e, t = window.document) {
  const r = t[d4] || (t[d4] = /* @__PURE__ */ new Set());
  for (let n = 0, i = e.length; n < i; n++) {
    const a = e[n];
    r.has(a) || (r.add(a), t.addEventListener(a, nP));
  }
}
function Xe(e, t, r) {
  r == null ? e.removeAttribute(t) : e.setAttribute(t, r);
}
function ZO(e, t, r, n) {
  n == null ? e.removeAttributeNS(t, r) : e.setAttributeNS(t, r, n);
}
function XO(e, t, r) {
  r ? e.setAttribute(t, "") : e.removeAttribute(t);
}
function rt(e, t) {
  t == null ? e.removeAttribute("class") : e.className = t;
}
function Y0(e, t, r, n) {
  if (n)
    Array.isArray(r) ? (e[`$$${t}`] = r[0], e[`$$${t}Data`] = r[1]) : e[`$$${t}`] = r;
  else if (Array.isArray(r)) {
    const i = r[0];
    e.addEventListener(t, r[0] = (a) => i.call(e, r[1], a));
  } else e.addEventListener(t, r, typeof r != "function" && r);
}
function eP(e, t, r = {}) {
  const n = Object.keys(t || {}), i = Object.keys(r);
  let a, o;
  for (a = 0, o = i.length; a < o; a++) {
    const s = i[a];
    !s || s === "undefined" || t[s] || (c4(e, s, !1), delete r[s]);
  }
  for (a = 0, o = n.length; a < o; a++) {
    const s = n[a], l = !!t[s];
    !s || s === "undefined" || r[s] === l || !l || (c4(e, s, !0), r[s] = l);
  }
  return r;
}
function $i(e, t, r) {
  if (!t) return r ? Xe(e, "style") : t;
  const n = e.style;
  if (typeof t == "string") return n.cssText = t;
  typeof r == "string" && (n.cssText = r = void 0), r || (r = {}), t || (t = {});
  let i, a;
  for (a in r)
    t[a] == null && n.removeProperty(a), delete r[a];
  for (a in t)
    i = t[a], i !== r[a] && (n.setProperty(a, i), r[a] = i);
  return r;
}
function Ln(e, t = {}, r, n) {
  const i = {};
  return n || te(() => i.children = dc(e, t.children, i.children)), te(() => typeof t.ref == "function" && cn(t.ref, e)), te(() => tP(e, t, r, !0, i, !0)), i;
}
function cn(e, t, r) {
  return Le(() => e(t, r));
}
function C(e, t, r, n) {
  if (r !== void 0 && !n && (n = []), typeof t != "function") return dc(e, t, n, r);
  te((i) => dc(e, t(), i, r), n);
}
function tP(e, t, r, n, i = {}, a = !1) {
  t || (t = {});
  for (const o in i)
    if (!(o in t)) {
      if (o === "children") continue;
      i[o] = u4(e, o, null, i[o], r, a, t);
    }
  for (const o in t) {
    if (o === "children")
      continue;
    const s = t[o];
    i[o] = u4(e, o, s, i[o], r, a, t);
  }
}
function rP(e) {
  return e.toLowerCase().replace(/-([a-z])/g, (t, r) => r.toUpperCase());
}
function c4(e, t, r) {
  const n = t.trim().split(/\s+/);
  for (let i = 0, a = n.length; i < a; i++) e.classList.toggle(n[i], r);
}
function u4(e, t, r, n, i, a, o) {
  let s, l, d, c, u;
  if (t === "style") return $i(e, r, n);
  if (t === "classList") return eP(e, r, n);
  if (r === n) return n;
  if (t === "ref")
    a || r(e);
  else if (t.slice(0, 3) === "on:") {
    const h = t.slice(3);
    n && e.removeEventListener(h, n, typeof n != "function" && n), r && e.addEventListener(h, r, typeof r != "function" && r);
  } else if (t.slice(0, 10) === "oncapture:") {
    const h = t.slice(10);
    n && e.removeEventListener(h, n, !0), r && e.addEventListener(h, r, !0);
  } else if (t.slice(0, 2) === "on") {
    const h = t.slice(2).toLowerCase(), f = QO.has(h);
    if (!f && n) {
      const p = Array.isArray(n) ? n[0] : n;
      e.removeEventListener(h, p);
    }
    (f || r) && (Y0(e, h, r, f), f && qr([h]));
  } else if (t.slice(0, 5) === "attr:")
    Xe(e, t.slice(5), r);
  else if (t.slice(0, 5) === "bool:")
    XO(e, t.slice(5), r);
  else if ((u = t.slice(0, 5) === "prop:") || (d = BO.has(t)) || !i && ((c = KO(t, e.tagName)) || (l = qO.has(t))) || (s = e.nodeName.includes("-") || "is" in o))
    u && (t = t.slice(5), l = !0), t === "class" || t === "className" ? rt(e, r) : s && !l && !d ? e[rP(t)] = r : e[c || t] = r;
  else {
    const h = i && t.indexOf(":") > -1 && YO[t.split(":")[0]];
    h ? ZO(e, h, t, r) : Xe(e, HO[t] || t, r);
  }
  return r;
}
function nP(e) {
  let t = e.target;
  const r = `$$${e.type}`, n = e.target, i = e.currentTarget, a = (l) => Object.defineProperty(e, "target", {
    configurable: !0,
    value: l
  }), o = () => {
    const l = t[r];
    if (l && !t.disabled) {
      const d = t[`${r}Data`];
      if (d !== void 0 ? l.call(t, d, e) : l.call(t, e), e.cancelBubble) return;
    }
    return t.host && typeof t.host != "string" && !t.host._$host && t.contains(e.target) && a(t.host), !0;
  }, s = () => {
    for (; o() && (t = t._$host || t.parentNode || t.host); ) ;
  };
  if (Object.defineProperty(e, "currentTarget", {
    configurable: !0,
    get() {
      return t || document;
    }
  }), e.composedPath) {
    const l = e.composedPath();
    a(l[0]);
    for (let d = 0; d < l.length - 2 && (t = l[d], !!o()); d++) {
      if (t._$host) {
        t = t._$host, s();
        break;
      }
      if (t.parentNode === i)
        break;
    }
  } else s();
  a(n);
}
function dc(e, t, r, n, i) {
  for (; typeof r == "function"; ) r = r();
  if (t === r) return r;
  const a = typeof t, o = n !== void 0;
  if (e = o && r[0] && r[0].parentNode || e, a === "string" || a === "number") {
    if (a === "number" && (t = t.toString(), t === r))
      return r;
    if (o) {
      let s = r[0];
      s && s.nodeType === 3 ? s.data !== t && (s.data = t) : s = document.createTextNode(t), r = ps(e, r, n, s);
    } else
      r !== "" && typeof r == "string" ? r = e.firstChild.data = t : r = e.textContent = t;
  } else if (t == null || a === "boolean")
    r = ps(e, r, n);
  else {
    if (a === "function")
      return te(() => {
        let s = t();
        for (; typeof s == "function"; ) s = s();
        r = dc(e, s, r, n);
      }), () => r;
    if (Array.isArray(t)) {
      const s = [], l = r && Array.isArray(r);
      if (Ep(s, t, r, i))
        return te(() => r = dc(e, s, r, n, !0)), () => r;
      if (s.length === 0) {
        if (r = ps(e, r, n), o) return r;
      } else l ? r.length === 0 ? h4(e, s, n) : JO(e, r, s) : (r && ps(e), h4(e, s));
      r = s;
    } else if (t.nodeType) {
      if (Array.isArray(r)) {
        if (o) return r = ps(e, r, n, t);
        ps(e, r, null, t);
      } else r == null || r === "" || !e.firstChild ? e.appendChild(t) : e.replaceChild(t, e.firstChild);
      r = t;
    }
  }
  return r;
}
function Ep(e, t, r, n) {
  let i = !1;
  for (let a = 0, o = t.length; a < o; a++) {
    let s = t[a], l = r && r[e.length], d;
    if (!(s == null || s === !0 || s === !1)) if ((d = typeof s) == "object" && s.nodeType)
      e.push(s);
    else if (Array.isArray(s))
      i = Ep(e, s, l) || i;
    else if (d === "function")
      if (n) {
        for (; typeof s == "function"; ) s = s();
        i = Ep(e, Array.isArray(s) ? s : [s], Array.isArray(l) ? l : [l]) || i;
      } else
        e.push(s), i = !0;
    else {
      const c = String(s);
      l && l.nodeType === 3 && l.data === c ? e.push(l) : e.push(document.createTextNode(c));
    }
  }
  return i;
}
function h4(e, t, r = null) {
  for (let n = 0, i = t.length; n < i; n++) e.insertBefore(t[n], r);
}
function ps(e, t, r, n) {
  if (r === void 0) return e.textContent = "";
  const i = n || document.createTextNode("");
  if (t.length) {
    let a = !1;
    for (let o = t.length - 1; o >= 0; o--) {
      const s = t[o];
      if (i !== s) {
        const l = s.parentNode === e;
        !a && !o ? l ? e.replaceChild(i, s) : e.insertBefore(i, r) : l && s.remove();
      } else a = !0;
    }
  } else e.insertBefore(i, r);
  return [i];
}
const iP = "http://www.w3.org/2000/svg";
function aP(e, t = !1, r = void 0) {
  return t ? document.createElementNS(iP, e) : document.createElement(e, {
    is: r
  });
}
function oP(e, t) {
  const r = B(e);
  return B(() => {
    const n = r();
    switch (typeof n) {
      case "function":
        return Le(() => n(t));
      case "string":
        const i = GO.has(n), a = aP(n, i, Le(() => t.is));
        return Ln(a, t, i), a;
    }
  });
}
function sP(e) {
  const [, t] = qo(e, ["component"]);
  return oP(() => e.component, t);
}
function lP(e, ...t) {
  const r = e.subscribe(...t);
  return r.unsubscribe ? () => r.unsubscribe() : r;
}
function Bi(e) {
  let t;
  return lP(e, (r) => t = r)(), t;
}
class dP extends Error {
  constructor(t, r) {
    super(t), this.name = "FelteSubmitError", this.response = r;
  }
}
function cP(e, t) {
  return Object.keys(e).some((r) => t(e[r]));
}
function G1(e, t) {
  return Object.keys(e || {}).reduce((r, n) => Object.assign(Object.assign({}, r), { [n]: t(e[n]) }), {});
}
function Je(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function on(e) {
  return Object.keys(e || {}).reduce((t, r) => Object.assign(Object.assign({}, t), { [r]: Je(e[r]) ? on(e[r]) : Array.isArray(e[r]) ? [...e[r]] : e[r] }), {});
}
function uP(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function hP(e) {
  return function(t) {
    if (Je(t)) {
      const r = sn(t, e);
      return uP(r, ["key"]);
    }
    return e;
  };
}
function sn(e, t) {
  return G1(e, (r) => Je(r) ? sn(r, t) : Array.isArray(r) ? r.map(hP(t)) : t);
}
function Fa(...e) {
  const t = e.pop(), r = e.shift();
  if (typeof r == "string")
    return r;
  const n = on(r);
  if (e.length === 0)
    return n;
  for (const i of e) {
    if (!i)
      continue;
    if (typeof i == "string")
      return i;
    let a = t(n, i);
    if (typeof a < "u")
      return a;
    const o = Array.from(new Set(Object.keys(n).concat(Object.keys(i))));
    for (const s of o)
      if (a = t(n[s], i[s]), typeof a < "u")
        n[s] = a;
      else if (Je(i[s]) && Je(n[s]))
        n[s] = Fa(n[s], i[s], t);
      else if (Array.isArray(i[s]))
        n[s] = i[s].map((l, d) => {
          if (!Je(l))
            return l;
          const c = Array.isArray(n[s]) ? n[s][d] : n[s];
          return Fa(c, l, t);
        });
      else if (Je(i[s])) {
        const l = sn(on(i[s]), void 0);
        n[s] = Fa(l, i[s], t);
      } else typeof i[s] < "u" && (n[s] = i[s]);
  }
  return n;
}
function fP(e, t) {
  if (!(Je(e) && Je(t))) {
    if (Array.isArray(t)) {
      if (t.some(Je))
        return;
      const r = Array.isArray(e) ? e : [];
      return t.map((n, i) => {
        var a;
        return (a = r[i]) !== null && a !== void 0 ? a : n;
      });
    }
    if (typeof e < "u")
      return e;
  }
}
function f4(...e) {
  return Fa(...e, fP);
}
function kb(...e) {
  return Fa(...e, () => {
  });
}
function Ti(e, t, r) {
  const n = (a) => String.prototype.split.call(t, a).filter(Boolean).reduce((o, s) => o != null ? o[s] : o, e), i = n(/[,[\]]+?/) || n(/[,[\].]+?/);
  return i === void 0 || i === e ? r : i;
}
function Ml(e, t, r) {
  e && (e = on(e)), Je(e) || (e = {});
  const n = Array.isArray(t) ? t : t.match(/[^.[\]]+/g) || [], i = n[n.length - 1];
  if (!i)
    return e;
  let a = e;
  for (let o = 0; o < n.length - 1; o++) {
    const s = n[o];
    if (!a[s] || !Je(a[s]) && !Array.isArray(a[s])) {
      const l = n[o + 1];
      isNaN(Number(l)) ? a[s] = {} : a[s] = [];
    }
    a = a[s];
  }
  return a[i] = r(a[i]), e;
}
function Lt(e, t, r) {
  return Ml(e, t, () => r);
}
function Pd(e, t) {
  if (!e || Object(e) !== e)
    return;
  typeof e < "u" && (e = on(e));
  const r = Array.isArray(t) ? t : t.toString().match(/[^.[\]]+/g) || [], n = r.length === 1 ? e : Ti(e, r.slice(0, -1).join("."));
  return Array.isArray(n) ? n.splice(Number(r[r.length - 1]), 1) : n == null || delete n[r[r.length - 1]], e;
}
function cc(e, t) {
  return cP(e, (r) => Je(r) ? cc(r, t) : Array.isArray(r) ? r.length === 0 || r.every((n) => typeof n == "string") ? t(r) : r.some((n) => Je(n) ? cc(n, t) : t(n)) : t(r));
}
function Js(e) {
  return e?.nodeName === "INPUT";
}
function pP(e) {
  return e?.nodeName === "TEXTAREA";
}
function Zs(e) {
  return e?.nodeName === "SELECT";
}
function Y1(e) {
  return e?.nodeName === "FIELDSET";
}
function kr(e) {
  return Js(e) || pP(e) || Zs(e);
}
function Sp(e) {
  return e.nodeType === Node.ELEMENT_NODE;
}
function Ir(e, t) {
  return kr(e) ? e.name : "";
}
function Af(e) {
  let t = e;
  for (; t && t.nodeName !== "FORM"; ) {
    if (t.hasAttribute("data-felte-ignore"))
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function p4(e, t) {
  return !Je(e) || !t ? e : typeof t == "string" ? Ti(e, t) : t(e);
}
function mP(e, t) {
  if (!(Je(e) || Je(t))) {
    if (e === null || e === "")
      return t;
    if (t === null || t === "" || !t)
      return e;
    if (!(!e || !t)) {
      if (Array.isArray(e)) {
        if (!Array.isArray(t))
          return [...e, t];
        const r = [], n = Math.max(t.length, e.length);
        for (let i = 0; i < n; i++) {
          let a = e[i], o = t[i];
          !Je(a) && !Je(o) ? (Array.isArray(a) || (a = [a]), Array.isArray(o) || (o = [o]), r.push(...a, ...o)) : r.push(_s([a ?? {}, o ?? {}]));
        }
        return r.filter(Boolean);
      }
      return Array.isArray(t) || (t = [t]), [e, ...t].reduce((r, n) => r.concat(n), []).filter(Boolean);
    }
  }
}
function _s(e) {
  return Fa(...e, mP);
}
function gP(e, t) {
  return t ? (Array.isArray(t) ? t : [t]).map((r) => r(e)) : [];
}
function Cp(e, t) {
  return t ? Array.isArray(t) ? t.reduce((r, n) => n(r), e) : t(e) : e;
}
function _b(e = 8) {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let r = "";
  for (let n = 0; n < e; n++)
    r += t.charAt(Math.floor(Math.random() * t.length));
  return r;
}
function Tp(e, t) {
  if (e === t)
    return !0;
  if (Array.isArray(e) && Array.isArray(t))
    return e.length !== t.length ? !1 : e.every((r, n) => Tp(r, t[n]));
  if (Je(e) && Je(t)) {
    const r = Object.keys(e), n = Object.keys(t);
    return r.length !== n.length ? !1 : r.every((i) => Tp(e[i], t[i]));
  }
  return !1;
}
function J0(e, t, { onInit: r, onEnd: n } = {}) {
  let i;
  return (...a) => {
    i || r?.(), i && clearTimeout(i), i = setTimeout(() => {
      e.apply(this, a), i = void 0, n?.();
    }, t);
  };
}
function Ap(e) {
  if (kr(e))
    return [e];
  if (e.childElementCount === 0)
    return [];
  const t = /* @__PURE__ */ new Set();
  for (const r of e.children) {
    if (kr(r) && t.add(r), Y1(r))
      for (const n of r.elements)
        kr(n) && t.add(n);
    r.childElementCount > 0 && Ap(r).forEach((n) => t.add(n));
  }
  return Array.from(t);
}
function xb(e) {
  for (const t of e.elements)
    !kr(t) && !Y1(t) || e.hasAttribute("data-felte-keep-on-remove") && !t.hasAttribute("data-felte-keep-on-remove") && (t.dataset.felteKeepOnRemove = e.dataset.felteKeepOnRemove);
}
function Eb(e) {
  return e.type.match(/^(number|range)$/) ? e.value ? +e.value : null : e.value;
}
function m4(e) {
  var t;
  let r = {}, n = {};
  for (const i of e.elements) {
    if (Y1(i) && xb(i), !kr(i) || !i.name)
      continue;
    const a = Ir(i);
    if (Js(i)) {
      if (i.type === "checkbox") {
        if (typeof Ti(r, a) > "u") {
          if (Array.from(e.querySelectorAll(`[name="${i.name}"]`)).filter((s) => kr(s) ? a === Ir(s) : !1).length === 1) {
            r = Lt(r, a, i.checked), n = Lt(n, a, !1);
            continue;
          }
          r = Lt(r, a, i.checked ? [i.value] : []), n = Lt(n, a, !1);
          continue;
        }
        Array.isArray(Ti(r, a)) && i.checked && (r = Ml(r, a, (s) => [
          ...s,
          i.value
        ]));
        continue;
      }
      if (i.type === "radio") {
        if (Ti(r, a))
          continue;
        r = Lt(r, a, i.checked ? i.value : void 0), n = Lt(n, a, !1);
        continue;
      }
      if (i.type === "file") {
        r = Lt(r, a, i.multiple ? Array.from(i.files || []) : (t = i.files) === null || t === void 0 ? void 0 : t[0]), n = Lt(n, a, !1);
        continue;
      }
    } else if (Zs(i)) {
      if (!i.multiple)
        r = Lt(r, a, i.value);
      else {
        const s = Array.from(i.selectedOptions).map((l) => l.value);
        r = Lt(r, a, s);
      }
      n = Lt(n, a, !1);
      continue;
    }
    const o = Eb(i);
    r = Lt(r, a, o), n = Lt(n, a, !1);
  }
  return { defaultData: r, defaultTouched: n };
}
function f0(e, t) {
  var r;
  if (!kr(e))
    return;
  const n = t;
  if (Js(e)) {
    if (e.type === "checkbox") {
      const i = n;
      if (typeof i > "u" || typeof i == "boolean") {
        e.checked = !!i;
        return;
      }
      Array.isArray(i) && (i.includes(e.value) ? e.checked = !0 : e.checked = !1);
      return;
    }
    if (e.type === "radio") {
      const i = n;
      e.value === i ? e.checked = !0 : e.checked = !1;
      return;
    }
    if (e.type === "file") {
      if (t instanceof FileList)
        e.files = t;
      else if (t instanceof File && typeof DataTransfer < "u") {
        const i = new DataTransfer();
        i.items.add(t), e.files = i.files;
      } else if (typeof DataTransfer < "u" && Array.isArray(t) && t.some((i) => i instanceof File)) {
        const i = new DataTransfer();
        for (const a of t)
          a instanceof File && i.items.add(a);
        e.files = i.files;
      } else (!t || Array.isArray(t) && !t.length) && (e.files = null, e.value = "");
      return;
    }
  } else if (Zs(e)) {
    if (e.multiple) {
      if (Array.isArray(n)) {
        e.value = String((r = n[0]) !== null && r !== void 0 ? r : "");
        const i = n.map((a) => String(a));
        for (const a of e.options)
          i.includes(a.value) ? a.selected = !0 : a.selected = !1;
      }
    } else {
      e.value = String(n ?? "");
      for (const i of e.options)
        i.value === String(n) ? i.selected = !0 : i.selected = !1;
    }
    return;
  }
  e.value = String(n ?? "");
}
function Du(e, t) {
  for (const r of e.elements) {
    if (Y1(r) && xb(r), !kr(r) || !r.name)
      continue;
    const n = Ir(r);
    f0(r, Ti(t, n));
  }
}
const vP = {
  attributes: !0,
  attributeFilter: ["data-felte-validation-message", "aria-invalid"]
};
function yP(e, t) {
  var r, n;
  let i, a, o, s, l, d;
  typeof e == "string" ? (i = e, a = void 0, o = (r = void 0) !== null && r !== void 0 ? r : !1, d = void 0) : (i = e.name, a = e.defaultValue, o = (n = e.touchOnChange) !== null && n !== void 0 ? n : !1, d = e?.onFormReset);
  function c(y, g) {
    if (!l)
      return;
    y !== "focusout" && f0(l, g);
    const w = new Event(y, {
      bubbles: !0,
      composed: !0
    });
    l.dispatchEvent(w);
  }
  function u(y) {
    y.forEach(() => {
      const g = l.getAttribute("aria-invalid");
      g ? s.setAttribute("aria-invalid", g) : s.removeAttribute("aria-invalid");
      const w = l.getAttribute("data-felte-validation-message");
      w ? s.setAttribute("data-felte-validation-message", w) : s.removeAttribute("data-felte-validation-message");
    });
  }
  function h(y) {
    d && (f0(l, a), d(y));
  }
  function f(y) {
    s = y;
    let g, w;
    if (kr(y))
      return l = y, l.name = i, {};
    {
      let $ = !1, _ = !1;
      return setTimeout(() => {
        if (_)
          return;
        const x = s.parentNode;
        if (!x || !Sp(x))
          return;
        const S = x.querySelector(`[name="${i}"]`);
        if (!S || !kr(S)) {
          const T = document.createElement("input");
          T.type = "hidden", T.name = i, x.insertBefore(T, y.nextSibling), l = T, $ = !0;
        } else
          l = S;
        f0(l, a), g = new MutationObserver(u), g.observe(l, vP), w = l.closest("form"), w?.addEventListener("reset", h);
      }), {
        destroy() {
          var x;
          $ && ((x = l.parentNode) === null || x === void 0 || x.removeChild(l)), _ = !0, g?.disconnect(), w?.removeEventListener("reset", h);
        }
      };
    }
  }
  function p(y) {
    c(o ? "change" : "input", y);
  }
  function m() {
    c("focusout");
  }
  return {
    field: f,
    onInput: p,
    onChange: p,
    onBlur: m
  };
}
function Sb(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function Hi(e, t) {
  return G1(e, (r) => Je(r) ? Hi(r, t) : Array.isArray(r) ? r.length === 0 || r.every((n) => typeof n == "string") ? t : r.map((n) => {
    const i = Hi(n, t);
    return Sb(i, ["key"]);
  }) : t);
}
function Ko(e) {
  return e ? G1(e, (t) => Je(t) ? Ko(t) : Array.isArray(t) ? t.length === 0 || t.every((r) => typeof r == "string") ? t : t.map((r) => {
    if (!Je(r))
      return r;
    const n = Ko(r);
    return n.key || (n.key = _b()), n;
  }) : t) : {};
}
function Xs(e) {
  return e ? G1(e, (t) => Je(t) ? Xs(t) : Array.isArray(t) ? t.length === 0 || t.every((r) => typeof r == "string") ? t : t.map((r) => {
    if (!Je(r))
      return r;
    const n = Xs(r);
    return Sb(n, ["key"]);
  }) : t) : {};
}
function bP() {
  class e extends CustomEvent {
    constructor(i) {
      super("feltesuccess", { detail: i });
    }
  }
  class t extends CustomEvent {
    constructor(i) {
      super("felteerror", { detail: i, cancelable: !0 });
    }
    setErrors(i) {
      this.preventDefault(), this.errors = i;
    }
  }
  class r extends Event {
    constructor() {
      super("feltesubmit", { cancelable: !0 });
    }
    handleSubmit(i) {
      this.onSubmit = i;
    }
    handleError(i) {
      this.onError = i;
    }
    handleSuccess(i) {
      this.onSuccess = i;
    }
  }
  return {
    createErrorEvent: (n) => new t(n),
    createSubmitEvent: () => new r(),
    createSuccessEvent: (n) => new e(n)
  };
}
function wP(e) {
  if (e)
    return async function() {
      let t = new FormData(e);
      const r = new URL(e.action), n = e.method.toLowerCase() === "get" ? "get" : r.searchParams.get("_method") || e.method;
      let i = e.enctype;
      e.querySelector('input[type="file"]') && (i = "multipart/form-data"), (n === "get" || i === "application/x-www-form-urlencoded") && (t = new URLSearchParams(t));
      let a;
      n === "get" ? (t.forEach((s, l) => {
        r.searchParams.append(l, s);
      }), a = { method: n, headers: { Accept: "application/json" } }) : a = {
        method: n,
        body: t,
        headers: Object.assign(Object.assign({}, i !== "multipart/form-data" && {
          "Content-Type": i
        }), { Accept: "application/json" })
      };
      const o = await window.fetch(r.toString(), a);
      if (o.ok)
        return o;
      throw new dP("An error occurred while submitting the form", o);
    };
}
function Nu(e, t, r, n) {
  return Ml(e, t, (i) => (typeof i < "u" && !Array.isArray(i) || (i || (i = []), typeof n > "u" ? i.push(r) : i.splice(n, 0, r)), i));
}
function $P(e, t, r, n) {
  return Ml(e, t, (i) => (!i || !Array.isArray(i) || ([i[r], i[n]] = [i[n], i[r]]), i));
}
function kP(e, t, r, n) {
  return Ml(e, t, (i) => (!i || !Array.isArray(i) || i.splice(n, 0, i.splice(r, 1)[0]), i));
}
function g4(e) {
  return typeof e == "function";
}
function va(e) {
  return (t, r) => {
    if (typeof t == "string") {
      const n = t;
      e((i) => {
        const a = g4(r) ? r(Ti(i, n)) : r;
        return Lt(i, n, a);
      });
    } else
      e((n) => g4(t) ? t(n) : t);
  };
}
function _P({ stores: e, config: t, validateErrors: r, validateWarnings: n, _getCurrentExtenders: i }) {
  var a;
  let o, s = Ko((a = t.initialValues) !== null && a !== void 0 ? a : {});
  const { data: l, touched: d, errors: c, warnings: u, isDirty: h, isSubmitting: f, interacted: p } = e, m = va(l.update), y = va(d.update), g = va(c.update), w = va(u.update);
  function $(W) {
    m((H) => {
      const pe = W(H);
      return o && Du(o, pe), pe;
    });
  }
  const _ = (W, H, pe) => {
    va($)(W, H), typeof W == "string" && pe && y(W, !0);
  };
  function x(W, H, pe) {
    const Te = Je(H) ? Hi(H, !1) : !1, Ce = Je(Te) ? sn(Te, []) : [];
    H = Je(H) ? Object.assign(Object.assign({}, H), { key: _b() }) : H, c.update((de) => Nu(de, W, Ce, pe)), u.update((de) => Nu(de, W, Ce, pe)), d.update((de) => Nu(de, W, Te, pe)), l.update((de) => {
      const K = Nu(de, W, H, pe);
      return setTimeout(() => o && Du(o, K)), K;
    });
  }
  function S(W) {
    c.update(W), u.update(W), d.update(W), l.update((H) => {
      const pe = W(H);
      return setTimeout(() => o && Du(o, pe)), pe;
    });
  }
  function T(W) {
    S((H) => Pd(H, W));
  }
  function I(W, H, pe) {
    S((Te) => $P(Te, W, H, pe));
  }
  function M(W, H, pe) {
    S((Te) => kP(Te, W, H, pe));
  }
  function P(W) {
    const H = Ti(s, W), pe = Je(H) ? Hi(H, !1) : !1, Te = Je(pe) ? sn(pe, []) : [];
    l.update((Ce) => {
      const de = Lt(Ce, W, H);
      return o && Du(o, de), de;
    }), d.update((Ce) => Lt(Ce, W, pe)), c.update((Ce) => Lt(Ce, W, Te)), u.update((Ce) => Lt(Ce, W, Te));
  }
  const O = va(f.update), D = va(h.update), R = va(p.update);
  async function L() {
    const W = Bi(l);
    d.set(Hi(W, !0)), p.set(null);
    const H = await r(W);
    return await n(W), H;
  }
  function Q() {
    _(on(s)), y((W) => sn(W, !1)), p.set(null), h.set(!1);
  }
  function ie(W) {
    return async function(H) {
      var pe, Te, Ce, de, K, oe, ae;
      const { createErrorEvent: Me, createSubmitEvent: We, createSuccessEvent: Dt } = bP(), vt = We();
      o?.dispatchEvent(vt);
      const zt = (Te = (pe = vt.onError) !== null && pe !== void 0 ? pe : W?.onError) !== null && Te !== void 0 ? Te : t.onError, Wt = (de = (Ce = vt.onSuccess) !== null && Ce !== void 0 ? Ce : W?.onSuccess) !== null && de !== void 0 ? de : t.onSuccess, $e = (ae = (oe = (K = vt.onSubmit) !== null && K !== void 0 ? K : W?.onSubmit) !== null && oe !== void 0 ? oe : t.onSubmit) !== null && ae !== void 0 ? ae : wP(o);
      if (!$e || (H?.preventDefault(), vt.defaultPrevented))
        return;
      f.set(!0), p.set(null);
      const Z = Xs(Bi(l)), Ie = await r(Z, W?.validate), Re = await n(Z, W?.warn);
      if (Re && u.set(kb(sn(Z, []), Re)), d.set(Hi(Z, !0)), Ie && (d.set(Hi(Ie, !0)), cc(Ie, (it) => Array.isArray(it) ? it.length >= 1 : !!it))) {
        await new Promise((it) => setTimeout(it)), i().forEach((it) => {
          var Kt;
          return (Kt = it.onSubmitError) === null || Kt === void 0 ? void 0 : Kt.call(it, {
            data: Z,
            errors: Ie
          });
        }), f.set(!1);
        return;
      }
      const xt = {
        event: H,
        setFields: _,
        setData: m,
        setTouched: y,
        setErrors: g,
        setWarnings: w,
        unsetField: T,
        addField: x,
        resetField: P,
        reset: Q,
        setInitialValues: ee.setInitialValues,
        moveField: M,
        swapFields: I,
        form: o,
        controls: o && Array.from(o.elements).filter(kr),
        config: Object.assign(Object.assign({}, t), W)
      };
      try {
        const it = await $e(Z, xt);
        o?.dispatchEvent(Dt(Object.assign({ response: it }, xt))), await Wt?.(it, xt);
      } catch (it) {
        const Kt = Me(Object.assign({ error: it }, xt));
        if (o?.dispatchEvent(Kt), !zt && !Kt.defaultPrevented)
          throw it;
        if (!zt && !Kt.errors)
          return;
        const De = Kt.errors || await zt?.(it, xt);
        De && (d.set(Hi(De, !0)), c.set(De), await new Promise((bt) => setTimeout(bt)), i().forEach((bt) => {
          var Et;
          return (Et = bt.onSubmitError) === null || Et === void 0 ? void 0 : Et.call(bt, {
            data: Z,
            errors: Bi(c)
          });
        }));
      } finally {
        f.set(!1);
      }
    };
  }
  const ee = {
    setData: m,
    setFields: _,
    setTouched: y,
    setErrors: g,
    setWarnings: w,
    setIsSubmitting: O,
    setIsDirty: D,
    setInteracted: R,
    validate: L,
    reset: Q,
    unsetField: T,
    resetField: P,
    addField: x,
    swapFields: I,
    moveField: M,
    createSubmitHandler: ie,
    handleSubmit: ie(),
    setInitialValues: (W) => {
      s = Ko(W);
    }
  };
  return {
    public: ee,
    private: {
      _setFormNode(W) {
        o = W;
      },
      _getInitialValues: () => s
    }
  };
}
function xP({ helpers: e, stores: t, config: r, extender: n, createSubmitHandler: i, handleSubmit: a, _setFormNode: o, _getInitialValues: s, _setCurrentExtenders: l, _getCurrentExtenders: d }) {
  const { setFields: c, setTouched: u, reset: h, setInitialValues: f } = e, { addValidator: p, addTransformer: m, validate: y } = e, { data: g, errors: w, warnings: $, touched: _, isSubmitting: x, isDirty: S, interacted: T, isValid: I, isValidating: M } = t;
  function P(O) {
    O.requestSubmit || (O.requestSubmit = a);
    function D($e) {
      return function(Z) {
        return Z({
          form: O,
          stage: $e,
          controls: Array.from(O.elements).filter(kr),
          data: g,
          errors: w,
          warnings: $,
          touched: _,
          isValid: I,
          isValidating: M,
          isSubmitting: x,
          isDirty: S,
          interacted: T,
          config: r,
          addValidator: p,
          addTransformer: m,
          setFields: c,
          validate: y,
          reset: h,
          createSubmitHandler: i,
          handleSubmit: a
        });
      };
    }
    l(n.map(D("MOUNT"))), O.noValidate = !!r.validate;
    const { defaultData: R, defaultTouched: L } = m4(O);
    o(O), f(kb(on(R), s())), c(s()), _.set(L);
    function Q($e) {
      const Z = Ir($e), Ie = Array.from(O.querySelectorAll(`[name="${$e.name}"]`)).filter((Re) => kr(Re) ? Z === Ir(Re) : !1);
      if (Ie.length !== 0)
        return Ie.length === 1 ? g.update((Re) => Lt(Re, Ir($e), $e.checked)) : g.update((Re) => Lt(Re, Ir($e), Ie.filter(Js).filter((xt) => xt.checked).map((xt) => xt.value)));
    }
    function ie($e) {
      const Z = O.querySelectorAll(`[name="${$e.name}"]`), Ie = Array.from(Z).find((Re) => Js(Re) && Re.checked);
      g.update((Re) => Lt(Re, Ir($e), Ie?.value));
    }
    function ee($e) {
      var Z;
      const Ie = Array.from((Z = $e.files) !== null && Z !== void 0 ? Z : []);
      g.update((Re) => Lt(Re, Ir($e), $e.multiple ? Ie : Ie[0]));
    }
    function W($e) {
      if (!$e.multiple)
        g.update((Z) => Lt(Z, Ir($e), $e.value));
      else {
        const Z = Array.from($e.selectedOptions).map((Ie) => Ie.value);
        g.update((Ie) => Lt(Ie, Ir($e), Z));
      }
    }
    function H($e) {
      const Z = $e.target;
      if (!Z || !kr(Z) || Zs(Z) || Af(Z) || ["checkbox", "radio", "file"].includes(Z.type) || !Z.name)
        return;
      S.set(!0);
      const Ie = Eb(Z);
      T.set(Z.name), g.update((Re) => Lt(Re, Ir(Z), Ie));
    }
    function pe($e) {
      const Z = $e.target;
      if (!(!Z || !kr(Z) || Af(Z)) && Z.name)
        if (u(Ir(Z), !0), T.set(Z.name), (Zs(Z) || ["checkbox", "radio", "file", "hidden"].includes(Z.type)) && S.set(!0), Z.type === "hidden" && g.update((Ie) => Lt(Ie, Ir(Z), Z.value)), Zs(Z))
          W(Z);
        else if (Js(Z))
          Z.type === "checkbox" ? Q(Z) : Z.type === "radio" ? ie(Z) : Z.type === "file" && ee(Z);
        else return;
    }
    function Te($e) {
      const Z = $e.target;
      !Z || !kr(Z) || Af(Z) || Z.name && (u(Ir(Z), !0), T.set(Z.name));
    }
    function Ce($e) {
      $e.preventDefault(), h();
    }
    const de = { childList: !0, subtree: !0 };
    function K($e) {
      let Z = Bi(g), Ie = Bi(_), Re = Bi(w), xt = Bi($);
      for (const it of $e.reverse()) {
        if (it.hasAttribute("data-felte-keep-on-remove") && it.dataset.felteKeepOnRemove !== "false")
          continue;
        const Kt = /.*(\[[0-9]+\]|\.[0-9]+)\.[^.]+$/;
        let De = Ir(it);
        const bt = Bi(_);
        if (Kt.test(De)) {
          const Et = De.split(".").slice(0, -1).join("."), pt = Ti(bt, Et);
          Je(pt) && Object.keys(pt).length <= 1 && (De = Et);
        }
        Z = Pd(Z, De), Ie = Pd(Ie, De), Re = Pd(Re, De), xt = Pd(xt, De);
      }
      g.set(Z), _.set(Ie), w.set(Re), $.set(xt);
    }
    const oe = J0(() => {
      d().forEach((Ie) => {
        var Re;
        return (Re = Ie.destroy) === null || Re === void 0 ? void 0 : Re.call(Ie);
      }), l(n.map(D("UPDATE")));
      const { defaultData: $e, defaultTouched: Z } = m4(O);
      g.update((Ie) => f4(Ie, $e)), _.update((Ie) => f4(Ie, Z)), e.setFields(Bi(g));
    }, 0);
    let ae = [];
    const Me = J0(() => {
      d().forEach(($e) => {
        var Z;
        return (Z = $e.destroy) === null || Z === void 0 ? void 0 : Z.call($e);
      }), l(n.map(D("UPDATE"))), K(ae), ae = [];
    }, 0);
    function We($e) {
      Array.from($e.addedNodes).some((Z) => Sp(Z) ? kr(Z) ? !0 : Ap(Z).length > 0 : !1) && oe();
    }
    function Dt($e) {
      for (const Z of $e.removedNodes) {
        if (!Sp(Z))
          continue;
        const Ie = Ap(Z);
        Ie.length !== 0 && (ae.push(...Ie), Me());
      }
    }
    function vt($e) {
      for (const Z of $e)
        Z.type === "childList" && (Z.addedNodes.length > 0 && We(Z), Z.removedNodes.length > 0 && Dt(Z));
    }
    const zt = new MutationObserver(vt);
    zt.observe(O, de), O.addEventListener("input", H), O.addEventListener("change", pe), O.addEventListener("focusout", Te), O.addEventListener("submit", a), O.addEventListener("reset", Ce);
    const Wt = w.subscribe(($e) => {
      for (const Z of O.elements) {
        if (!kr(Z) || !Z.name)
          continue;
        const Ie = Ti($e, Ir(Z)), Re = Array.isArray(Ie) ? Ie.join(`
`) : typeof Ie == "string" ? Ie : void 0;
        Re !== Z.dataset.felteValidationMessage && (Re ? (Z.dataset.felteValidationMessage = Re, Z.setAttribute("aria-invalid", "true")) : (delete Z.dataset.felteValidationMessage, Z.removeAttribute("aria-invalid")));
      }
    });
    return {
      destroy() {
        zt.disconnect(), O.removeEventListener("input", H), O.removeEventListener("change", pe), O.removeEventListener("focusout", Te), O.removeEventListener("submit", a), O.removeEventListener("reset", Ce), Wt(), d().forEach(($e) => {
          var Z;
          return (Z = $e.destroy) === null || Z === void 0 ? void 0 : Z.call($e);
        });
      }
    };
  }
  return { form: P };
}
function EP(e) {
  const t = { aborted: !1, priority: e };
  return {
    signal: t,
    abort() {
      t.aborted = !0;
    }
  };
}
function SP(e, t) {
  if (Je(e))
    return !t || Je(t) && Object.keys(t).length === 0 ? sn(e, null) : void 0;
  if (Array.isArray(e)) {
    if (e.some(Je))
      return;
    const r = Array.isArray(t) ? t : [];
    return e.map((n, i) => {
      const a = r[i];
      return Array.isArray(a) && a.length === 0 ? null : n && a || null;
    });
  }
  return Array.isArray(t) && t.length === 0 ? null : Array.isArray(t) ? e ? t : null : e && t ? [t] : null;
}
function CP(e, t) {
  if (Je(e))
    return !t || Je(t) && Object.keys(t).length === 0 ? sn(e, null) : void 0;
  if (Array.isArray(e)) {
    if (e.some(Je))
      return;
    const r = Array.isArray(t) ? t : [];
    return e.map((n, i) => {
      const a = r[i];
      return Array.isArray(a) && a.length === 0 ? null : a || null;
    });
  }
  return Array.isArray(t) && t.length === 0 ? null : Array.isArray(t) ? t : t ? [t] : null;
}
function TP([e, t]) {
  return Fa(t, e, SP);
}
function AP([e, t]) {
  return Fa(t, e, CP);
}
function OP(e) {
  return function(t, r, n) {
    const i = Array.isArray(t) ? t : [t], a = new Array(i.length), o = e(n), s = o.set, l = o.subscribe;
    let d;
    function c() {
      d = i.map((h, f) => h.subscribe((p) => {
        a[f] = p, s(r(a));
      }));
    }
    function u() {
      d?.forEach((h) => h());
    }
    return o.subscribe = function(h) {
      const f = l(h);
      return () => {
        f();
      };
    }, [o, c, u];
  };
}
function PP(e, t) {
  var r, n, i, a, o, s, l, d, c;
  const u = OP(e), h = t.initialValues = t.initialValues ? Ko(Cp(on(t.initialValues), t.transform)) : {}, f = Hi(Xs(h), !1), p = e(f), m = e(0), [y, g, w] = u([p, m], ([Qe, Vt]) => cc(Qe, (Xt) => !!Xt) && Vt >= 1, !1);
  delete y.set, delete y.update;
  function $(Qe) {
    let Vt;
    return async function(Xt, fn, gi, pn = !1) {
      if (!gi || !Xt)
        return;
      let mn = fn && Object.keys(fn).length > 0 ? fn : sn(Xt, []);
      const Vi = EP(pn);
      if ((!Vt?.signal.priority || pn) && (Vt?.abort(), Vt = Vi), Vt.signal.priority && !pn)
        return;
      m.update((gn) => gn + 1);
      const nn = gP(Xs(Xt), gi);
      return nn.forEach(async (gn) => {
        const ha = await gn;
        Vi.signal.aborted || (mn = _s([mn, ha]), Qe.set(mn));
      }), await Promise.all(nn), Vt = void 0, m.update((gn) => gn - 1), mn;
    };
  }
  let _ = sn(f, []);
  const x = e(h), S = sn(f, []), T = e(S), I = e(on(S)), [M, P, O] = u([
    T,
    I
  ], _s, on(S)), D = sn(f, []), R = e(D), L = e(on(D)), [Q, ie, ee] = u([
    R,
    L
  ], _s, on(D)), [W, H, pe] = u([M, p], TP, on(S)), [Te, Ce, de] = u([Q, p], AP, on(D));
  let K = !1;
  const [oe, ae, Me] = u(M, ([Qe]) => {
    var Vt;
    return K ? !cc(Qe, (Xt) => Array.isArray(Xt) ? Xt.length >= 1 : !!Xt) : (K = !0, !t.validate && !(!((Vt = t.debounced) === null || Vt === void 0) && Vt.validate));
  }, !t.validate && !(!((r = t.debounced) === null || r === void 0) && r.validate));
  delete oe.set, delete oe.update;
  const We = e(!1), Dt = e(!1), vt = e(null), zt = $(T), Wt = $(R), $e = $(I), Z = $(L), Ie = J0($e, (o = (i = (n = t.debounced) === null || n === void 0 ? void 0 : n.validateTimeout) !== null && i !== void 0 ? i : (a = t.debounced) === null || a === void 0 ? void 0 : a.timeout) !== null && o !== void 0 ? o : 300, {
    onInit: () => {
      m.update((Qe) => Qe + 1);
    },
    onEnd: () => {
      m.update((Qe) => Qe - 1);
    }
  }), Re = J0(Z, (c = (l = (s = t.debounced) === null || s === void 0 ? void 0 : s.warnTimeout) !== null && l !== void 0 ? l : (d = t.debounced) === null || d === void 0 ? void 0 : d.timeout) !== null && c !== void 0 ? c : 300);
  async function xt(Qe, Vt) {
    var Xt;
    const fn = zt(Qe, _, Vt ?? t.validate, !0);
    if (Vt)
      return fn;
    const gi = $e(Qe, _, (Xt = t.debounced) === null || Xt === void 0 ? void 0 : Xt.validate, !0);
    return _s(await Promise.all([fn, gi]));
  }
  async function it(Qe, Vt) {
    var Xt;
    const fn = Wt(Qe, _, Vt ?? t.warn, !0);
    if (Vt)
      return fn;
    const gi = Z(Qe, _, (Xt = t.debounced) === null || Xt === void 0 ? void 0 : Xt.warn, !0);
    return _s(await Promise.all([fn, gi]));
  }
  let Kt = S, De = D;
  function bt() {
    const Qe = x.subscribe((pn) => {
      var mn, Vi;
      const nn = Xs(pn);
      zt(nn, _, t.validate), Wt(nn, _, t.warn), Ie(nn, _, (mn = t.debounced) === null || mn === void 0 ? void 0 : mn.validate), Re(nn, _, (Vi = t.debounced) === null || Vi === void 0 ? void 0 : Vi.warn);
    }), Vt = p.subscribe((pn) => {
      _ = sn(pn, []);
    }), Xt = M.subscribe((pn) => {
      Kt = pn;
    }), fn = Q.subscribe((pn) => {
      De = pn;
    });
    P(), ae(), ie(), H(), Ce(), g();
    function gi() {
      Qe(), pe(), O(), ee(), de(), Me(), w(), Vt(), Xt(), fn();
    }
    return gi;
  }
  function Et(Qe) {
    T.set(Qe(Kt)), I.set({});
  }
  function pt(Qe) {
    R.set(Qe(De)), L.set({});
  }
  function At(Qe) {
    Et(() => Qe);
  }
  function rn(Qe) {
    pt(() => Qe);
  }
  return W.set = At, W.update = Et, Te.set = rn, Te.update = pt, {
    data: x,
    errors: W,
    warnings: Te,
    touched: p,
    isValid: oe,
    isSubmitting: We,
    isDirty: Dt,
    isValidating: y,
    interacted: vt,
    validateErrors: xt,
    validateWarnings: it,
    cleanup: t.preventStoreStart ? () => {
    } : bt(),
    start: bt
  };
}
function IP(e, t) {
  var r, n;
  (r = e.extend) !== null && r !== void 0 || (e.extend = []), (n = e.debounced) !== null && n !== void 0 || (e.debounced = {}), e.validate && !Array.isArray(e.validate) && (e.validate = [e.validate]), e.debounced.validate && !Array.isArray(e.debounced.validate) && (e.debounced.validate = [e.debounced.validate]), e.transform && !Array.isArray(e.transform) && (e.transform = [e.transform]), e.warn && !Array.isArray(e.warn) && (e.warn = [e.warn]), e.debounced.warn && !Array.isArray(e.debounced.warn) && (e.debounced.warn = [e.debounced.warn]);
  function i(ie, { debounced: ee, level: W } = {
    debounced: !1,
    level: "error"
  }) {
    var H;
    const pe = W === "error" ? "validate" : "warn";
    (H = e.debounced) !== null && H !== void 0 || (e.debounced = {});
    const Te = ee ? e.debounced : e;
    Te[pe] ? Te[pe] = [
      ...Te[pe],
      ie
    ] : Te[pe] = [ie];
  }
  function a(ie) {
    e.transform ? e.transform = [
      ...e.transform,
      ie
    ] : e.transform = [ie];
  }
  const o = Array.isArray(e.extend) ? e.extend : [e.extend];
  let s = [];
  const l = () => s, d = (ie) => {
    s = ie;
  }, { isSubmitting: c, isValidating: u, data: h, errors: f, warnings: p, touched: m, isValid: y, isDirty: g, cleanup: w, start: $, validateErrors: _, validateWarnings: x, interacted: S } = PP(t.storeFactory, e), T = h.update, I = h.set, M = (ie) => T((ee) => Ko(Cp(ie(ee), e.transform))), P = (ie) => I(Ko(Cp(ie, e.transform)));
  h.update = M, h.set = P;
  const O = _P({
    config: e,
    validateErrors: _,
    validateWarnings: x,
    _getCurrentExtenders: l,
    stores: {
      data: h,
      errors: f,
      warnings: p,
      touched: m,
      isSubmitting: c,
      isDirty: g,
      interacted: S
    }
  }), { createSubmitHandler: D, handleSubmit: R } = O.public;
  s = o.map((ie) => ie({
    stage: "SETUP",
    errors: f,
    warnings: p,
    touched: m,
    data: h,
    isDirty: g,
    isValid: y,
    isValidating: u,
    isSubmitting: c,
    interacted: S,
    config: e,
    addValidator: i,
    addTransformer: a,
    setFields: O.public.setFields,
    reset: O.public.reset,
    validate: O.public.validate,
    handleSubmit: R,
    createSubmitHandler: D
  }));
  const L = Object.assign({
    config: e,
    stores: {
      data: h,
      touched: m,
      errors: f,
      warnings: p,
      isSubmitting: c,
      isValidating: u,
      isValid: y,
      isDirty: g,
      interacted: S
    },
    createSubmitHandler: D,
    handleSubmit: R,
    helpers: Object.assign(Object.assign({}, O.public), {
      addTransformer: a,
      addValidator: i
    }),
    extender: o,
    _getCurrentExtenders: l,
    _setCurrentExtenders: d
  }, O.private), { form: Q } = xP(L);
  return Object.assign({
    data: h,
    errors: f,
    warnings: p,
    touched: m,
    isValid: y,
    isSubmitting: c,
    isValidating: u,
    isDirty: g,
    interacted: S,
    form: Q,
    cleanup: w,
    startStores: $
  }, O.public);
}
function DP(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function NP(e) {
  const t = {}, r = {};
  function n(i) {
    if (!i)
      return e();
    if (!t[i.toString()]) {
      const o = z(p4(Le(e), i));
      r[i.toString()] = o, t[i.toString()] = i;
    }
    const [a] = r[i.toString()];
    return a();
  }
  return le(() => {
    const i = e(), a = Object.keys(t);
    for (const o of a) {
      const s = t[o], l = p4(i, s), [d, c] = r[s.toString()];
      Tp(l, Le(d)) || c(l);
    }
  }), n;
}
function MP(e) {
  return function(t) {
    return Ws((r) => (le(() => t(e())), r));
  };
}
const RP = (e) => {
  const [t, r] = z(e);
  function n(s) {
    r(() => s);
  }
  function i(s) {
    r(s);
  }
  const a = NP(t), o = MP(t);
  return a.subscribe = o, a.set = n, a.update = i, a;
};
function Cb(e) {
  const t = IP(e ?? {}, {
    storeFactory: RP
  }), { form: r, cleanup: n, startStores: i, data: a, errors: o, warnings: s, touched: l } = t, d = DP(t, ["form", "cleanup", "startStores", "data", "errors", "warnings", "touched"]);
  let c = null;
  const u = () => c?.(), [h, f] = z(null);
  le(() => {
    const m = h();
    m && (u(), c = r(m).destroy);
  });
  const p = (m) => (f(m), {
    destroy: u
  });
  return _r(u), _r(n), Object.assign(Object.assign({}, d), { data: a, errors: o, warnings: s, touched: l, form: p });
}
function LP(e, t) {
  const { field: r, onChange: n, onInput: i, onBlur: a } = yP(e);
  function o(s) {
    const { destroy: l } = r(s);
    return _r(() => l?.()), { destroy: l };
  }
  return {
    field: o,
    onChange: n,
    onInput: i,
    onBlur: a
  };
}
function FP(e) {
  function t(r) {
    return r.issues.reduce((n, i) => i.path ? Ml(n, i.path.join("."), (a) => !a || !Array.isArray(a) ? [i.message] : [...a, i.message]) : n, {});
  }
  return async function(r) {
    try {
      await e.parseAsync(r);
    } catch (n) {
      return t(n);
    }
  };
}
function Tb({ schema: e, level: t = "error" }) {
  return function(r) {
    if (r.stage !== "SETUP")
      return {};
    const n = FP(e);
    return r.addValidator(n, { level: t }), {};
  };
}
var mt;
(function(e) {
  e.assertEqual = (i) => {
  };
  function t(i) {
  }
  e.assertIs = t;
  function r(i) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (i) => {
    const a = {};
    for (const o of i)
      a[o] = o;
    return a;
  }, e.getValidEnumValues = (i) => {
    const a = e.objectKeys(i).filter((s) => typeof i[i[s]] != "number"), o = {};
    for (const s of a)
      o[s] = i[s];
    return e.objectValues(o);
  }, e.objectValues = (i) => e.objectKeys(i).map(function(a) {
    return i[a];
  }), e.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const a = [];
    for (const o in i)
      Object.prototype.hasOwnProperty.call(i, o) && a.push(o);
    return a;
  }, e.find = (i, a) => {
    for (const o of i)
      if (a(o))
        return o;
  }, e.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && Number.isFinite(i) && Math.floor(i) === i;
  function n(i, a = " | ") {
    return i.map((o) => typeof o == "string" ? `'${o}'` : o).join(a);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (i, a) => typeof a == "bigint" ? a.toString() : a;
})(mt || (mt = {}));
var v4;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(v4 || (v4 = {}));
const Ee = mt.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Ea = (e) => {
  switch (typeof e) {
    case "undefined":
      return Ee.undefined;
    case "string":
      return Ee.string;
    case "number":
      return Number.isNaN(e) ? Ee.nan : Ee.number;
    case "boolean":
      return Ee.boolean;
    case "function":
      return Ee.function;
    case "bigint":
      return Ee.bigint;
    case "symbol":
      return Ee.symbol;
    case "object":
      return Array.isArray(e) ? Ee.array : e === null ? Ee.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Ee.promise : typeof Map < "u" && e instanceof Map ? Ee.map : typeof Set < "u" && e instanceof Set ? Ee.set : typeof Date < "u" && e instanceof Date ? Ee.date : Ee.object;
    default:
      return Ee.unknown;
  }
}, se = mt.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class na extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const r = t || function(a) {
      return a.message;
    }, n = { _errors: [] }, i = (a) => {
      for (const o of a.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(i);
        else if (o.code === "invalid_return_type")
          i(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          i(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let s = n, l = 0;
          for (; l < o.path.length; ) {
            const d = o.path[l];
            l === o.path.length - 1 ? (s[d] = s[d] || { _errors: [] }, s[d]._errors.push(r(o))) : s[d] = s[d] || { _errors: [] }, s = s[d], l++;
          }
        }
    };
    return i(this), n;
  }
  static assert(t) {
    if (!(t instanceof na))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, mt.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const i of this.issues)
      if (i.path.length > 0) {
        const a = i.path[0];
        r[a] = r[a] || [], r[a].push(t(i));
      } else
        n.push(t(i));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
na.create = (e) => new na(e);
const Op = (e, t) => {
  let r;
  switch (e.code) {
    case se.invalid_type:
      e.received === Ee.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case se.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, mt.jsonStringifyReplacer)}`;
      break;
    case se.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${mt.joinValues(e.keys, ", ")}`;
      break;
    case se.invalid_union:
      r = "Invalid input";
      break;
    case se.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${mt.joinValues(e.options)}`;
      break;
    case se.invalid_enum_value:
      r = `Invalid enum value. Expected ${mt.joinValues(e.options)}, received '${e.received}'`;
      break;
    case se.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case se.invalid_return_type:
      r = "Invalid function return type";
      break;
    case se.invalid_date:
      r = "Invalid date";
      break;
    case se.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : mt.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case se.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "bigint" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case se.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case se.custom:
      r = "Invalid input";
      break;
    case se.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case se.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case se.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, mt.assertNever(e);
  }
  return { message: r };
};
let jP = Op;
function zP() {
  return jP;
}
const VP = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: i } = e, a = [...r, ...i.path || []], o = {
    ...i,
    path: a
  };
  if (i.message !== void 0)
    return {
      ...i,
      path: a,
      message: i.message
    };
  let s = "";
  const l = n.filter((d) => !!d).slice().reverse();
  for (const d of l)
    s = d(o, { data: t, defaultError: s }).message;
  return {
    ...i,
    path: a,
    message: s
  };
};
function ye(e, t) {
  const r = zP(), n = VP({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === Op ? void 0 : Op
      // then global default map
    ].filter((i) => !!i)
  });
  e.common.issues.push(n);
}
class xn {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const i of r) {
      if (i.status === "aborted")
        return He;
      i.status === "dirty" && t.dirty(), n.push(i.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const i of r) {
      const a = await i.key, o = await i.value;
      n.push({
        key: a,
        value: o
      });
    }
    return xn.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const i of r) {
      const { key: a, value: o } = i;
      if (a.status === "aborted" || o.status === "aborted")
        return He;
      a.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), a.value !== "__proto__" && (typeof o.value < "u" || i.alwaysSet) && (n[a.value] = o.value);
    }
    return { status: t.value, value: n };
  }
}
const He = Object.freeze({
  status: "aborted"
}), Pp = (e) => ({ status: "dirty", value: e }), Fn = (e) => ({ status: "valid", value: e }), y4 = (e) => e.status === "aborted", b4 = (e) => e.status === "dirty", fl = (e) => e.status === "valid", Z0 = (e) => typeof Promise < "u" && e instanceof Promise;
var Se;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t?.message;
})(Se || (Se = {}));
class Ha {
  constructor(t, r, n, i) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const w4 = (e, t) => {
  if (fl(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new na(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function Ze(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: i } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: i } : { errorMap: (a, o) => {
    const { message: s } = e;
    return a.code === "invalid_enum_value" ? { message: s ?? o.defaultError } : typeof o.data > "u" ? { message: s ?? n ?? o.defaultError } : a.code !== "invalid_type" ? { message: o.defaultError } : { message: s ?? r ?? o.defaultError };
  }, description: i };
}
class ut {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return Ea(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: Ea(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new xn(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: Ea(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (Z0(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    const n = {
      common: {
        issues: [],
        async: r?.async ?? !1,
        contextualErrorMap: r?.errorMap
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Ea(t)
    }, i = this._parseSync({ data: t, path: n.path, parent: n });
    return w4(n, i);
  }
  "~validate"(t) {
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Ea(t)
    };
    if (!this["~standard"].async)
      try {
        const n = this._parseSync({ data: t, path: [], parent: r });
        return fl(n) ? {
          value: n.value
        } : {
          issues: r.common.issues
        };
      } catch (n) {
        n?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: r }).then((n) => fl(n) ? {
      value: n.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r?.errorMap,
        async: !0
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Ea(t)
    }, i = this._parse({ data: t, path: n.path, parent: n }), a = await (Z0(i) ? i : Promise.resolve(i));
    return w4(n, a);
  }
  refine(t, r) {
    const n = (i) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(i) : r;
    return this._refinement((i, a) => {
      const o = t(i), s = () => a.addIssue({
        code: se.custom,
        ...n(i)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, i) => t(n) ? !0 : (i.addIssue(typeof r == "function" ? r(n, i) : r), !1));
  }
  _refinement(t) {
    return new ml({
      schema: this,
      typeName: Be.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return ja.create(this, this._def);
  }
  nullable() {
    return gl.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Ai.create(this);
  }
  promise() {
    return r1.create(this, this._def);
  }
  or(t) {
    return e1.create([this, t], this._def);
  }
  and(t) {
    return t1.create(this, t, this._def);
  }
  transform(t) {
    return new ml({
      ...Ze(this._def),
      schema: this,
      typeName: Be.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new Dp({
      ...Ze(this._def),
      innerType: this,
      defaultValue: r,
      typeName: Be.ZodDefault
    });
  }
  brand() {
    return new cI({
      typeName: Be.ZodBranded,
      type: this,
      ...Ze(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new Np({
      ...Ze(this._def),
      innerType: this,
      catchValue: r,
      typeName: Be.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return Dm.create(this, t);
  }
  readonly() {
    return Mp.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const UP = /^c[^\s-]{8,}$/i, qP = /^[0-9a-z]+$/, BP = /^[0-9A-HJKMNP-TV-Z]{26}$/i, HP = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, WP = /^[a-z0-9_-]{21}$/i, KP = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, QP = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, GP = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, YP = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Of;
const JP = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, ZP = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, XP = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, eI = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, tI = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, rI = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ab = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", nI = new RegExp(`^${Ab}$`);
function Ob(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const r = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${r}`;
}
function iI(e) {
  return new RegExp(`^${Ob(e)}$`);
}
function aI(e) {
  let t = `${Ab}T${Ob(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function oI(e, t) {
  return !!((t === "v4" || !t) && JP.test(e) || (t === "v6" || !t) && XP.test(e));
}
function sI(e, t) {
  if (!KP.test(e))
    return !1;
  try {
    const [r] = e.split(".");
    if (!r)
      return !1;
    const n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), i = JSON.parse(atob(n));
    return !(typeof i != "object" || i === null || "typ" in i && i?.typ !== "JWT" || !i.alg || t && i.alg !== t);
  } catch {
    return !1;
  }
}
function lI(e, t) {
  return !!((t === "v4" || !t) && ZP.test(e) || (t === "v6" || !t) && eI.test(e));
}
class Na extends ut {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== Ee.string) {
      const i = this._getOrReturnCtx(t);
      return ye(i, {
        code: se.invalid_type,
        expected: Ee.string,
        received: i.parsedType
      }), He;
    }
    const r = new xn();
    let n;
    for (const i of this._def.checks)
      if (i.kind === "min")
        t.data.length < i.value && (n = this._getOrReturnCtx(t, n), ye(n, {
          code: se.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "max")
        t.data.length > i.value && (n = this._getOrReturnCtx(t, n), ye(n, {
          code: se.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "length") {
        const a = t.data.length > i.value, o = t.data.length < i.value;
        (a || o) && (n = this._getOrReturnCtx(t, n), a ? ye(n, {
          code: se.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : o && ye(n, {
          code: se.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), r.dirty());
      } else if (i.kind === "email")
        GP.test(t.data) || (n = this._getOrReturnCtx(t, n), ye(n, {
          validation: "email",
          code: se.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "emoji")
        Of || (Of = new RegExp(YP, "u")), Of.test(t.data) || (n = this._getOrReturnCtx(t, n), ye(n, {
          validation: "emoji",
          code: se.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "uuid")
        HP.test(t.data) || (n = this._getOrReturnCtx(t, n), ye(n, {
          validation: "uuid",
          code: se.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "nanoid")
        WP.test(t.data) || (n = this._getOrReturnCtx(t, n), ye(n, {
          validation: "nanoid",
          code: se.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid")
        UP.test(t.data) || (n = this._getOrReturnCtx(t, n), ye(n, {
          validation: "cuid",
          code: se.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid2")
        qP.test(t.data) || (n = this._getOrReturnCtx(t, n), ye(n, {
          validation: "cuid2",
          code: se.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "ulid")
        BP.test(t.data) || (n = this._getOrReturnCtx(t, n), ye(n, {
          validation: "ulid",
          code: se.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "url")
        try {
          new URL(t.data);
        } catch {
          n = this._getOrReturnCtx(t, n), ye(n, {
            validation: "url",
            code: se.invalid_string,
            message: i.message
          }), r.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(t.data) || (n = this._getOrReturnCtx(t, n), ye(n, {
        validation: "regex",
        code: se.invalid_string,
        message: i.message
      }), r.dirty())) : i.kind === "trim" ? t.data = t.data.trim() : i.kind === "includes" ? t.data.includes(i.value, i.position) || (n = this._getOrReturnCtx(t, n), ye(n, {
        code: se.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), r.dirty()) : i.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : i.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : i.kind === "startsWith" ? t.data.startsWith(i.value) || (n = this._getOrReturnCtx(t, n), ye(n, {
        code: se.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), r.dirty()) : i.kind === "endsWith" ? t.data.endsWith(i.value) || (n = this._getOrReturnCtx(t, n), ye(n, {
        code: se.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), r.dirty()) : i.kind === "datetime" ? aI(i).test(t.data) || (n = this._getOrReturnCtx(t, n), ye(n, {
        code: se.invalid_string,
        validation: "datetime",
        message: i.message
      }), r.dirty()) : i.kind === "date" ? nI.test(t.data) || (n = this._getOrReturnCtx(t, n), ye(n, {
        code: se.invalid_string,
        validation: "date",
        message: i.message
      }), r.dirty()) : i.kind === "time" ? iI(i).test(t.data) || (n = this._getOrReturnCtx(t, n), ye(n, {
        code: se.invalid_string,
        validation: "time",
        message: i.message
      }), r.dirty()) : i.kind === "duration" ? QP.test(t.data) || (n = this._getOrReturnCtx(t, n), ye(n, {
        validation: "duration",
        code: se.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "ip" ? oI(t.data, i.version) || (n = this._getOrReturnCtx(t, n), ye(n, {
        validation: "ip",
        code: se.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "jwt" ? sI(t.data, i.alg) || (n = this._getOrReturnCtx(t, n), ye(n, {
        validation: "jwt",
        code: se.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "cidr" ? lI(t.data, i.version) || (n = this._getOrReturnCtx(t, n), ye(n, {
        validation: "cidr",
        code: se.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "base64" ? tI.test(t.data) || (n = this._getOrReturnCtx(t, n), ye(n, {
        validation: "base64",
        code: se.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "base64url" ? rI.test(t.data) || (n = this._getOrReturnCtx(t, n), ye(n, {
        validation: "base64url",
        code: se.invalid_string,
        message: i.message
      }), r.dirty()) : mt.assertNever(i);
    return { status: r.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((i) => t.test(i), {
      validation: r,
      code: se.invalid_string,
      ...Se.errToObj(n)
    });
  }
  _addCheck(t) {
    return new Na({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...Se.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...Se.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...Se.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...Se.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...Se.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...Se.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...Se.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...Se.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...Se.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...Se.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...Se.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...Se.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...Se.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      offset: t?.offset ?? !1,
      local: t?.local ?? !1,
      ...Se.errToObj(t?.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      ...Se.errToObj(t?.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...Se.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...Se.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r?.position,
      ...Se.errToObj(r?.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...Se.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...Se.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...Se.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...Se.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...Se.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, Se.errToObj(t));
  }
  trim() {
    return new Na({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Na({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Na({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Na.create = (e) => new Na({
  checks: [],
  typeName: Be.ZodString,
  coerce: e?.coerce ?? !1,
  ...Ze(e)
});
function dI(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, i = r > n ? r : n, a = Number.parseInt(e.toFixed(i).replace(".", "")), o = Number.parseInt(t.toFixed(i).replace(".", ""));
  return a % o / 10 ** i;
}
class uc extends ut {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== Ee.number) {
      const i = this._getOrReturnCtx(t);
      return ye(i, {
        code: se.invalid_type,
        expected: Ee.number,
        received: i.parsedType
      }), He;
    }
    let r;
    const n = new xn();
    for (const i of this._def.checks)
      i.kind === "int" ? mt.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), ye(r, {
        code: se.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), n.dirty()) : i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (r = this._getOrReturnCtx(t, r), ye(r, {
        code: se.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), n.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (r = this._getOrReturnCtx(t, r), ye(r, {
        code: se.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), n.dirty()) : i.kind === "multipleOf" ? dI(t.data, i.value) !== 0 && (r = this._getOrReturnCtx(t, r), ye(r, {
        code: se.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), n.dirty()) : i.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), ye(r, {
        code: se.not_finite,
        message: i.message
      }), n.dirty()) : mt.assertNever(i);
    return { status: n.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, Se.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, Se.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, Se.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, Se.toString(r));
  }
  setLimit(t, r, n, i) {
    return new uc({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: Se.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new uc({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: Se.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Se.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Se.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Se.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Se.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Se.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: Se.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Se.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Se.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && mt.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
uc.create = (e) => new uc({
  checks: [],
  typeName: Be.ZodNumber,
  coerce: e?.coerce || !1,
  ...Ze(e)
});
class hc extends ut {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== Ee.bigint)
      return this._getInvalidInput(t);
    let r;
    const n = new xn();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (r = this._getOrReturnCtx(t, r), ye(r, {
        code: se.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), n.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (r = this._getOrReturnCtx(t, r), ye(r, {
        code: se.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), n.dirty()) : i.kind === "multipleOf" ? t.data % i.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), ye(r, {
        code: se.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), n.dirty()) : mt.assertNever(i);
    return { status: n.value, value: t.data };
  }
  _getInvalidInput(t) {
    const r = this._getOrReturnCtx(t);
    return ye(r, {
      code: se.invalid_type,
      expected: Ee.bigint,
      received: r.parsedType
    }), He;
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, Se.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, Se.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, Se.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, Se.toString(r));
  }
  setLimit(t, r, n, i) {
    return new hc({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: Se.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new hc({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Se.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Se.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Se.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Se.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Se.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
hc.create = (e) => new hc({
  checks: [],
  typeName: Be.ZodBigInt,
  coerce: e?.coerce ?? !1,
  ...Ze(e)
});
class $4 extends ut {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== Ee.boolean) {
      const r = this._getOrReturnCtx(t);
      return ye(r, {
        code: se.invalid_type,
        expected: Ee.boolean,
        received: r.parsedType
      }), He;
    }
    return Fn(t.data);
  }
}
$4.create = (e) => new $4({
  typeName: Be.ZodBoolean,
  coerce: e?.coerce || !1,
  ...Ze(e)
});
class X0 extends ut {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== Ee.date) {
      const i = this._getOrReturnCtx(t);
      return ye(i, {
        code: se.invalid_type,
        expected: Ee.date,
        received: i.parsedType
      }), He;
    }
    if (Number.isNaN(t.data.getTime())) {
      const i = this._getOrReturnCtx(t);
      return ye(i, {
        code: se.invalid_date
      }), He;
    }
    const r = new xn();
    let n;
    for (const i of this._def.checks)
      i.kind === "min" ? t.data.getTime() < i.value && (n = this._getOrReturnCtx(t, n), ye(n, {
        code: se.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), r.dirty()) : i.kind === "max" ? t.data.getTime() > i.value && (n = this._getOrReturnCtx(t, n), ye(n, {
        code: se.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), r.dirty()) : mt.assertNever(i);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new X0({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: Se.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: Se.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
X0.create = (e) => new X0({
  checks: [],
  coerce: e?.coerce || !1,
  typeName: Be.ZodDate,
  ...Ze(e)
});
class k4 extends ut {
  _parse(t) {
    if (this._getType(t) !== Ee.symbol) {
      const r = this._getOrReturnCtx(t);
      return ye(r, {
        code: se.invalid_type,
        expected: Ee.symbol,
        received: r.parsedType
      }), He;
    }
    return Fn(t.data);
  }
}
k4.create = (e) => new k4({
  typeName: Be.ZodSymbol,
  ...Ze(e)
});
class _4 extends ut {
  _parse(t) {
    if (this._getType(t) !== Ee.undefined) {
      const r = this._getOrReturnCtx(t);
      return ye(r, {
        code: se.invalid_type,
        expected: Ee.undefined,
        received: r.parsedType
      }), He;
    }
    return Fn(t.data);
  }
}
_4.create = (e) => new _4({
  typeName: Be.ZodUndefined,
  ...Ze(e)
});
class x4 extends ut {
  _parse(t) {
    if (this._getType(t) !== Ee.null) {
      const r = this._getOrReturnCtx(t);
      return ye(r, {
        code: se.invalid_type,
        expected: Ee.null,
        received: r.parsedType
      }), He;
    }
    return Fn(t.data);
  }
}
x4.create = (e) => new x4({
  typeName: Be.ZodNull,
  ...Ze(e)
});
class E4 extends ut {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return Fn(t.data);
  }
}
E4.create = (e) => new E4({
  typeName: Be.ZodAny,
  ...Ze(e)
});
class S4 extends ut {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return Fn(t.data);
  }
}
S4.create = (e) => new S4({
  typeName: Be.ZodUnknown,
  ...Ze(e)
});
class Wa extends ut {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return ye(r, {
      code: se.invalid_type,
      expected: Ee.never,
      received: r.parsedType
    }), He;
  }
}
Wa.create = (e) => new Wa({
  typeName: Be.ZodNever,
  ...Ze(e)
});
class C4 extends ut {
  _parse(t) {
    if (this._getType(t) !== Ee.undefined) {
      const r = this._getOrReturnCtx(t);
      return ye(r, {
        code: se.invalid_type,
        expected: Ee.void,
        received: r.parsedType
      }), He;
    }
    return Fn(t.data);
  }
}
C4.create = (e) => new C4({
  typeName: Be.ZodVoid,
  ...Ze(e)
});
class Ai extends ut {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), i = this._def;
    if (r.parsedType !== Ee.array)
      return ye(r, {
        code: se.invalid_type,
        expected: Ee.array,
        received: r.parsedType
      }), He;
    if (i.exactLength !== null) {
      const o = r.data.length > i.exactLength.value, s = r.data.length < i.exactLength.value;
      (o || s) && (ye(r, {
        code: o ? se.too_big : se.too_small,
        minimum: s ? i.exactLength.value : void 0,
        maximum: o ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), n.dirty());
    }
    if (i.minLength !== null && r.data.length < i.minLength.value && (ye(r, {
      code: se.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), n.dirty()), i.maxLength !== null && r.data.length > i.maxLength.value && (ye(r, {
      code: se.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, s) => i.type._parseAsync(new Ha(r, o, r.path, s)))).then((o) => xn.mergeArray(n, o));
    const a = [...r.data].map((o, s) => i.type._parseSync(new Ha(r, o, r.path, s)));
    return xn.mergeArray(n, a);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new Ai({
      ...this._def,
      minLength: { value: t, message: Se.toString(r) }
    });
  }
  max(t, r) {
    return new Ai({
      ...this._def,
      maxLength: { value: t, message: Se.toString(r) }
    });
  }
  length(t, r) {
    return new Ai({
      ...this._def,
      exactLength: { value: t, message: Se.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Ai.create = (e, t) => new Ai({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Be.ZodArray,
  ...Ze(t)
});
function xs(e) {
  if (e instanceof fr) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = ja.create(xs(n));
    }
    return new fr({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof Ai ? new Ai({
    ...e._def,
    type: xs(e.element)
  }) : e instanceof ja ? ja.create(xs(e.unwrap())) : e instanceof gl ? gl.create(xs(e.unwrap())) : e instanceof Qo ? Qo.create(e.items.map((t) => xs(t))) : e;
}
class fr extends ut {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = mt.objectKeys(t);
    return this._cached = { shape: t, keys: r }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== Ee.object) {
      const l = this._getOrReturnCtx(t);
      return ye(l, {
        code: se.invalid_type,
        expected: Ee.object,
        received: l.parsedType
      }), He;
    }
    const { status: r, ctx: n } = this._processInputParams(t), { shape: i, keys: a } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Wa && this._def.unknownKeys === "strip"))
      for (const l in n.data)
        a.includes(l) || o.push(l);
    const s = [];
    for (const l of a) {
      const d = i[l], c = n.data[l];
      s.push({
        key: { status: "valid", value: l },
        value: d._parse(new Ha(n, c, n.path, l)),
        alwaysSet: l in n.data
      });
    }
    if (this._def.catchall instanceof Wa) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const d of o)
          s.push({
            key: { status: "valid", value: d },
            value: { status: "valid", value: n.data[d] }
          });
      else if (l === "strict")
        o.length > 0 && (ye(n, {
          code: se.unrecognized_keys,
          keys: o
        }), r.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const d of o) {
        const c = n.data[d];
        s.push({
          key: { status: "valid", value: d },
          value: l._parse(
            new Ha(n, c, n.path, d)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: d in n.data
        });
      }
    }
    return n.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const d of s) {
        const c = await d.key, u = await d.value;
        l.push({
          key: c,
          value: u,
          alwaysSet: d.alwaysSet
        });
      }
      return l;
    }).then((l) => xn.mergeObjectSync(r, l)) : xn.mergeObjectSync(r, s);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return Se.errToObj, new fr({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          const i = this._def.errorMap?.(r, n).message ?? n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: Se.errToObj(t).message ?? i
          } : {
            message: i
          };
        }
      } : {}
    });
  }
  strip() {
    return new fr({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new fr({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new fr({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new fr({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: Be.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new fr({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    for (const n of mt.objectKeys(t))
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    return new fr({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    for (const n of mt.objectKeys(this.shape))
      t[n] || (r[n] = this.shape[n]);
    return new fr({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return xs(this);
  }
  partial(t) {
    const r = {};
    for (const n of mt.objectKeys(this.shape)) {
      const i = this.shape[n];
      t && !t[n] ? r[n] = i : r[n] = i.optional();
    }
    return new fr({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    for (const n of mt.objectKeys(this.shape))
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof ja; )
          i = i._def.innerType;
        r[n] = i;
      }
    return new fr({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Pb(mt.objectKeys(this.shape));
  }
}
fr.create = (e, t) => new fr({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Wa.create(),
  typeName: Be.ZodObject,
  ...Ze(t)
});
fr.strictCreate = (e, t) => new fr({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Wa.create(),
  typeName: Be.ZodObject,
  ...Ze(t)
});
fr.lazycreate = (e, t) => new fr({
  shape: e,
  unknownKeys: "strip",
  catchall: Wa.create(),
  typeName: Be.ZodObject,
  ...Ze(t)
});
class e1 extends ut {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function i(a) {
      for (const s of a)
        if (s.result.status === "valid")
          return s.result;
      for (const s of a)
        if (s.result.status === "dirty")
          return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = a.map((s) => new na(s.ctx.common.issues));
      return ye(r, {
        code: se.invalid_union,
        unionErrors: o
      }), He;
    }
    if (r.common.async)
      return Promise.all(n.map(async (a) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(i);
    {
      let a;
      const o = [];
      for (const l of n) {
        const d = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, c = l._parseSync({
          data: r.data,
          path: r.path,
          parent: d
        });
        if (c.status === "valid")
          return c;
        c.status === "dirty" && !a && (a = { result: c, ctx: d }), d.common.issues.length && o.push(d.common.issues);
      }
      if (a)
        return r.common.issues.push(...a.ctx.common.issues), a.result;
      const s = o.map((l) => new na(l));
      return ye(r, {
        code: se.invalid_union,
        unionErrors: s
      }), He;
    }
  }
  get options() {
    return this._def.options;
  }
}
e1.create = (e, t) => new e1({
  options: e,
  typeName: Be.ZodUnion,
  ...Ze(t)
});
function Ip(e, t) {
  const r = Ea(e), n = Ea(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === Ee.object && n === Ee.object) {
    const i = mt.objectKeys(t), a = mt.objectKeys(e).filter((s) => i.indexOf(s) !== -1), o = { ...e, ...t };
    for (const s of a) {
      const l = Ip(e[s], t[s]);
      if (!l.valid)
        return { valid: !1 };
      o[s] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === Ee.array && n === Ee.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const i = [];
    for (let a = 0; a < e.length; a++) {
      const o = e[a], s = t[a], l = Ip(o, s);
      if (!l.valid)
        return { valid: !1 };
      i.push(l.data);
    }
    return { valid: !0, data: i };
  } else return r === Ee.date && n === Ee.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class t1 extends ut {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), i = (a, o) => {
      if (y4(a) || y4(o))
        return He;
      const s = Ip(a.value, o.value);
      return s.valid ? ((b4(a) || b4(o)) && r.dirty(), { status: r.value, value: s.data }) : (ye(n, {
        code: se.invalid_intersection_types
      }), He);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([a, o]) => i(a, o)) : i(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
t1.create = (e, t, r) => new t1({
  left: e,
  right: t,
  typeName: Be.ZodIntersection,
  ...Ze(r)
});
class Qo extends ut {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Ee.array)
      return ye(n, {
        code: se.invalid_type,
        expected: Ee.array,
        received: n.parsedType
      }), He;
    if (n.data.length < this._def.items.length)
      return ye(n, {
        code: se.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), He;
    !this._def.rest && n.data.length > this._def.items.length && (ye(n, {
      code: se.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((a, o) => {
      const s = this._def.items[o] || this._def.rest;
      return s ? s._parse(new Ha(n, a, n.path, o)) : null;
    }).filter((a) => !!a);
    return n.common.async ? Promise.all(i).then((a) => xn.mergeArray(r, a)) : xn.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Qo({
      ...this._def,
      rest: t
    });
  }
}
Qo.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Qo({
    items: e,
    typeName: Be.ZodTuple,
    rest: null,
    ...Ze(t)
  });
};
class T4 extends ut {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Ee.map)
      return ye(n, {
        code: se.invalid_type,
        expected: Ee.map,
        received: n.parsedType
      }), He;
    const i = this._def.keyType, a = this._def.valueType, o = [...n.data.entries()].map(([s, l], d) => ({
      key: i._parse(new Ha(n, s, n.path, [d, "key"])),
      value: a._parse(new Ha(n, l, n.path, [d, "value"]))
    }));
    if (n.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const d = await l.key, c = await l.value;
          if (d.status === "aborted" || c.status === "aborted")
            return He;
          (d.status === "dirty" || c.status === "dirty") && r.dirty(), s.set(d.value, c.value);
        }
        return { status: r.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of o) {
        const d = l.key, c = l.value;
        if (d.status === "aborted" || c.status === "aborted")
          return He;
        (d.status === "dirty" || c.status === "dirty") && r.dirty(), s.set(d.value, c.value);
      }
      return { status: r.value, value: s };
    }
  }
}
T4.create = (e, t, r) => new T4({
  valueType: t,
  keyType: e,
  typeName: Be.ZodMap,
  ...Ze(r)
});
class fc extends ut {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Ee.set)
      return ye(n, {
        code: se.invalid_type,
        expected: Ee.set,
        received: n.parsedType
      }), He;
    const i = this._def;
    i.minSize !== null && n.data.size < i.minSize.value && (ye(n, {
      code: se.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), r.dirty()), i.maxSize !== null && n.data.size > i.maxSize.value && (ye(n, {
      code: se.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), r.dirty());
    const a = this._def.valueType;
    function o(l) {
      const d = /* @__PURE__ */ new Set();
      for (const c of l) {
        if (c.status === "aborted")
          return He;
        c.status === "dirty" && r.dirty(), d.add(c.value);
      }
      return { status: r.value, value: d };
    }
    const s = [...n.data.values()].map((l, d) => a._parse(new Ha(n, l, n.path, d)));
    return n.common.async ? Promise.all(s).then((l) => o(l)) : o(s);
  }
  min(t, r) {
    return new fc({
      ...this._def,
      minSize: { value: t, message: Se.toString(r) }
    });
  }
  max(t, r) {
    return new fc({
      ...this._def,
      maxSize: { value: t, message: Se.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
fc.create = (e, t) => new fc({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: Be.ZodSet,
  ...Ze(t)
});
class A4 extends ut {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
A4.create = (e, t) => new A4({
  getter: e,
  typeName: Be.ZodLazy,
  ...Ze(t)
});
class O4 extends ut {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return ye(r, {
        received: r.data,
        code: se.invalid_literal,
        expected: this._def.value
      }), He;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
O4.create = (e, t) => new O4({
  value: e,
  typeName: Be.ZodLiteral,
  ...Ze(t)
});
function Pb(e, t) {
  return new pl({
    values: e,
    typeName: Be.ZodEnum,
    ...Ze(t)
  });
}
class pl extends ut {
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return ye(r, {
        expected: mt.joinValues(n),
        received: r.parsedType,
        code: se.invalid_type
      }), He;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return ye(r, {
        received: r.data,
        code: se.invalid_enum_value,
        options: n
      }), He;
    }
    return Fn(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return pl.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return pl.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
pl.create = Pb;
class P4 extends ut {
  _parse(t) {
    const r = mt.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== Ee.string && n.parsedType !== Ee.number) {
      const i = mt.objectValues(r);
      return ye(n, {
        expected: mt.joinValues(i),
        received: n.parsedType,
        code: se.invalid_type
      }), He;
    }
    if (this._cache || (this._cache = new Set(mt.getValidEnumValues(this._def.values))), !this._cache.has(t.data)) {
      const i = mt.objectValues(r);
      return ye(n, {
        received: n.data,
        code: se.invalid_enum_value,
        options: i
      }), He;
    }
    return Fn(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
P4.create = (e, t) => new P4({
  values: e,
  typeName: Be.ZodNativeEnum,
  ...Ze(t)
});
class r1 extends ut {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Ee.promise && r.common.async === !1)
      return ye(r, {
        code: se.invalid_type,
        expected: Ee.promise,
        received: r.parsedType
      }), He;
    const n = r.parsedType === Ee.promise ? r.data : Promise.resolve(r.data);
    return Fn(n.then((i) => this._def.type.parseAsync(i, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
r1.create = (e, t) => new r1({
  type: e,
  typeName: Be.ZodPromise,
  ...Ze(t)
});
class ml extends ut {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Be.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), i = this._def.effect || null, a = {
      addIssue: (o) => {
        ye(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), i.type === "preprocess") {
      const o = i.transform(n.data, a);
      if (n.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (r.value === "aborted")
            return He;
          const l = await this._def.schema._parseAsync({
            data: s,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? He : l.status === "dirty" || r.value === "dirty" ? Pp(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return He;
        const s = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? He : s.status === "dirty" || r.value === "dirty" ? Pp(s.value) : s;
      }
    }
    if (i.type === "refinement") {
      const o = (s) => {
        const l = i.refinement(s, a);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? He : (s.status === "dirty" && r.dirty(), o(s.value), { status: r.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => s.status === "aborted" ? He : (s.status === "dirty" && r.dirty(), o(s.value).then(() => ({ status: r.value, value: s.value }))));
    }
    if (i.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!fl(o))
          return He;
        const s = i.transform(o.value, a);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => fl(o) ? Promise.resolve(i.transform(o.value, a)).then((s) => ({
          status: r.value,
          value: s
        })) : He);
    mt.assertNever(i);
  }
}
ml.create = (e, t, r) => new ml({
  schema: e,
  typeName: Be.ZodEffects,
  effect: t,
  ...Ze(r)
});
ml.createWithPreprocess = (e, t, r) => new ml({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: Be.ZodEffects,
  ...Ze(r)
});
class ja extends ut {
  _parse(t) {
    return this._getType(t) === Ee.undefined ? Fn(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ja.create = (e, t) => new ja({
  innerType: e,
  typeName: Be.ZodOptional,
  ...Ze(t)
});
class gl extends ut {
  _parse(t) {
    return this._getType(t) === Ee.null ? Fn(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
gl.create = (e, t) => new gl({
  innerType: e,
  typeName: Be.ZodNullable,
  ...Ze(t)
});
class Dp extends ut {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === Ee.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Dp.create = (e, t) => new Dp({
  innerType: e,
  typeName: Be.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...Ze(t)
});
class Np extends ut {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Z0(i) ? i.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new na(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new na(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Np.create = (e, t) => new Np({
  innerType: e,
  typeName: Be.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...Ze(t)
});
class I4 extends ut {
  _parse(t) {
    if (this._getType(t) !== Ee.nan) {
      const r = this._getOrReturnCtx(t);
      return ye(r, {
        code: se.invalid_type,
        expected: Ee.nan,
        received: r.parsedType
      }), He;
    }
    return { status: "valid", value: t.data };
  }
}
I4.create = (e) => new I4({
  typeName: Be.ZodNaN,
  ...Ze(e)
});
class cI extends ut {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Dm extends ut {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? He : i.status === "dirty" ? (r.dirty(), Pp(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return i.status === "aborted" ? He : i.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new Dm({
      in: t,
      out: r,
      typeName: Be.ZodPipeline
    });
  }
}
class Mp extends ut {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (i) => (fl(i) && (i.value = Object.freeze(i.value)), i);
    return Z0(r) ? r.then((i) => n(i)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Mp.create = (e, t) => new Mp({
  innerType: e,
  typeName: Be.ZodReadonly,
  ...Ze(t)
});
var Be;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(Be || (Be = {}));
const Es = Na.create;
Wa.create;
Ai.create;
const Ib = fr.create;
e1.create;
t1.create;
Qo.create;
pl.create;
r1.create;
ja.create;
gl.create;
var Rp = function(e, t) {
  return Rp = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, Rp(e, t);
};
function Wc(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Rp(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var X = function() {
  return X = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, X.apply(this, arguments);
};
function Lp(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function Sa(e, t, r, n) {
  function i(a) {
    return a instanceof r ? a : new r(function(o) {
      o(a);
    });
  }
  return new (r || (r = Promise))(function(a, o) {
    function s(c) {
      try {
        d(n.next(c));
      } catch (u) {
        o(u);
      }
    }
    function l(c) {
      try {
        d(n.throw(c));
      } catch (u) {
        o(u);
      }
    }
    function d(c) {
      c.done ? a(c.value) : i(c.value).then(s, l);
    }
    d((n = n.apply(e, t || [])).next());
  });
}
function Ca(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = s(0), o.throw = s(1), o.return = s(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(d) {
    return function(c) {
      return l([d, c]);
    };
  }
  function l(d) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, d[0] && (r = 0)), r; ) try {
      if (n = 1, i && (a = d[0] & 2 ? i.return : d[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, d[1])).done) return a;
      switch (i = 0, a && (d = [d[0] & 2, a.value]), d[0]) {
        case 0:
        case 1:
          a = d;
          break;
        case 4:
          return r.label++, { value: d[1], done: !1 };
        case 5:
          r.label++, i = d[1], d = [0];
          continue;
        case 7:
          d = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (d[0] === 6 || d[0] === 2)) {
            r = 0;
            continue;
          }
          if (d[0] === 3 && (!a || d[1] > a[0] && d[1] < a[3])) {
            r.label = d[1];
            break;
          }
          if (d[0] === 6 && r.label < a[1]) {
            r.label = a[1], a = d;
            break;
          }
          if (a && r.label < a[2]) {
            r.label = a[2], r.ops.push(d);
            break;
          }
          a[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      d = t.call(e, r);
    } catch (c) {
      d = [6, c], i = 0;
    } finally {
      n = a = 0;
    }
    if (d[0] & 5) throw d[1];
    return { value: d[0] ? d[1] : void 0, done: !0 };
  }
}
function Ur(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, a; n < i; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function p0(e, t) {
  throw new Error(t);
}
function uI(e) {
  return typeof e == "object" && e !== null;
}
function hI(e, t) {
  throw new Error(
    "Unexpected invariant triggered."
  );
}
const fI = /\r\n|[\n\r]/g;
function Fp(e, t) {
  let r = 0, n = 1;
  for (const i of e.body.matchAll(fI)) {
    if (typeof i.index == "number" || hI(), i.index >= t)
      break;
    r = i.index + i[0].length, n += 1;
  }
  return {
    line: n,
    column: t + 1 - r
  };
}
function pI(e) {
  return Db(
    e.source,
    Fp(e.source, e.start)
  );
}
function Db(e, t) {
  const r = e.locationOffset.column - 1, n = "".padStart(r) + e.body, i = t.line - 1, a = e.locationOffset.line - 1, o = t.line + a, s = t.line === 1 ? r : 0, l = t.column + s, d = `${e.name}:${o}:${l}
`, c = n.split(/\r\n|[\n\r]/g), u = c[i];
  if (u.length > 120) {
    const h = Math.floor(l / 80), f = l % 80, p = [];
    for (let m = 0; m < u.length; m += 80)
      p.push(u.slice(m, m + 80));
    return d + D4([
      [`${o} |`, p[0]],
      ...p.slice(1, h + 1).map((m) => ["|", m]),
      ["|", "^".padStart(f)],
      ["|", p[h + 1]]
    ]);
  }
  return d + D4([
    // Lines specified like this: ["prefix", "string"],
    [`${o - 1} |`, c[i - 1]],
    [`${o} |`, u],
    ["|", "^".padStart(l)],
    [`${o + 1} |`, c[i + 1]]
  ]);
}
function D4(e) {
  const t = e.filter(([n, i]) => i !== void 0), r = Math.max(...t.map(([n]) => n.length));
  return t.map(([n, i]) => n.padStart(r) + (i ? " " + i : "")).join(`
`);
}
function mI(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class Nm extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...r) {
    var n, i, a;
    const { nodes: o, source: s, positions: l, path: d, originalError: c, extensions: u } = mI(r);
    super(t), this.name = "GraphQLError", this.path = d ?? void 0, this.originalError = c ?? void 0, this.nodes = N4(
      Array.isArray(o) ? o : o ? [o] : void 0
    );
    const h = N4(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((p) => p.loc).filter((p) => p != null)
    );
    this.source = s ?? (h == null || (i = h[0]) === null || i === void 0 ? void 0 : i.source), this.positions = l ?? h?.map((p) => p.start), this.locations = l && s ? l.map((p) => Fp(s, p)) : h?.map((p) => Fp(p.source, p.start));
    const f = uI(
      c?.extensions
    ) ? c?.extensions : void 0;
    this.extensions = (a = u ?? f) !== null && a !== void 0 ? a : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), c != null && c.stack ? Object.defineProperty(this, "stack", {
      value: c.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, Nm) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const r of this.nodes)
        r.loc && (t += `

` + pI(r.loc));
    else if (this.source && this.locations)
      for (const r of this.locations)
        t += `

` + Db(this.source, r);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function N4(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function $r(e, t, r) {
  return new Nm(`Syntax Error: ${r}`, {
    source: e,
    positions: [t]
  });
}
class gI {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, r, n) {
    this.start = t.start, this.end = r.end, this.startToken = t, this.endToken = r, this.source = n;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class Nb {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, r, n, i, a, o) {
    this.kind = t, this.start = r, this.end = n, this.line = i, this.column = a, this.value = o, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const Mb = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "description",
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: [
    "description",
    "variable",
    "type",
    "defaultValue",
    "directives"
  ],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "description",
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"],
  TypeCoordinate: ["name"],
  MemberCoordinate: ["name", "memberName"],
  ArgumentCoordinate: ["name", "fieldName", "argumentName"],
  DirectiveCoordinate: ["name"],
  DirectiveArgumentCoordinate: ["name", "argumentName"]
}, vI = new Set(Object.keys(Mb));
function M4(e) {
  const t = e?.kind;
  return typeof t == "string" && vI.has(t);
}
var js;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(js || (js = {}));
var jp;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(jp || (jp = {}));
var fe;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension", e.TYPE_COORDINATE = "TypeCoordinate", e.MEMBER_COORDINATE = "MemberCoordinate", e.ARGUMENT_COORDINATE = "ArgumentCoordinate", e.DIRECTIVE_COORDINATE = "DirectiveCoordinate", e.DIRECTIVE_ARGUMENT_COORDINATE = "DirectiveArgumentCoordinate";
})(fe || (fe = {}));
function zp(e) {
  return e === 9 || e === 32;
}
function pc(e) {
  return e >= 48 && e <= 57;
}
function Rb(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function Lb(e) {
  return Rb(e) || e === 95;
}
function yI(e) {
  return Rb(e) || pc(e) || e === 95;
}
function bI(e) {
  var t;
  let r = Number.MAX_SAFE_INTEGER, n = null, i = -1;
  for (let o = 0; o < e.length; ++o) {
    var a;
    const s = e[o], l = wI(s);
    l !== s.length && (n = (a = n) !== null && a !== void 0 ? a : o, i = o, o !== 0 && l < r && (r = l));
  }
  return e.map((o, s) => s === 0 ? o : o.slice(r)).slice(
    (t = n) !== null && t !== void 0 ? t : 0,
    i + 1
  );
}
function wI(e) {
  let t = 0;
  for (; t < e.length && zp(e.charCodeAt(t)); )
    ++t;
  return t;
}
function $I(e, t) {
  const r = e.replace(/"""/g, '\\"""'), n = r.split(/\r\n|[\n\r]/g), i = n.length === 1, a = n.length > 1 && n.slice(1).every((f) => f.length === 0 || zp(f.charCodeAt(0))), o = r.endsWith('\\"""'), s = e.endsWith('"') && !o, l = e.endsWith("\\"), d = s || l, c = (
    // add leading and trailing new lines only if it improves readability
    !i || e.length > 70 || d || a || o
  );
  let u = "";
  const h = i && zp(e.charCodeAt(0));
  return (c && !h || a) && (u += `
`), u += r, (c || d) && (u += `
`), '"""' + u + '"""';
}
var Y;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.DOT = ".", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(Y || (Y = {}));
class kI {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const r = new Nb(Y.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== Y.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const r = xI(this, t.end);
          t.next = r, r.prev = t, t = r;
        }
      while (t.kind === Y.COMMENT);
    return t;
  }
}
function _I(e) {
  return e === Y.BANG || e === Y.DOLLAR || e === Y.AMP || e === Y.PAREN_L || e === Y.PAREN_R || e === Y.DOT || e === Y.SPREAD || e === Y.COLON || e === Y.EQUALS || e === Y.AT || e === Y.BRACKET_L || e === Y.BRACKET_R || e === Y.BRACE_L || e === Y.PIPE || e === Y.BRACE_R;
}
function Rl(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function J1(e, t) {
  return Fb(e.charCodeAt(t)) && jb(e.charCodeAt(t + 1));
}
function Fb(e) {
  return e >= 55296 && e <= 56319;
}
function jb(e) {
  return e >= 56320 && e <= 57343;
}
function Go(e, t) {
  const r = e.source.body.codePointAt(t);
  if (r === void 0)
    return Y.EOF;
  if (r >= 32 && r <= 126) {
    const n = String.fromCodePoint(r);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
}
function ur(e, t, r, n, i) {
  const a = e.line, o = 1 + r - e.lineStart;
  return new Nb(t, r, n, a, o, i);
}
function xI(e, t) {
  const r = e.source.body, n = r.length;
  let i = t;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    switch (a) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 65279:
      // <BOM>
      case 9:
      // \t
      case 32:
      // <space>
      case 44:
        ++i;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"
      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;
      case 13:
        r.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;
      // Comment
      case 35:
        return EI(e, i);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
      case 33:
        return ur(e, Y.BANG, i, i + 1);
      case 36:
        return ur(e, Y.DOLLAR, i, i + 1);
      case 38:
        return ur(e, Y.AMP, i, i + 1);
      case 40:
        return ur(e, Y.PAREN_L, i, i + 1);
      case 41:
        return ur(e, Y.PAREN_R, i, i + 1);
      case 46:
        if (r.charCodeAt(i + 1) === 46 && r.charCodeAt(i + 2) === 46)
          return ur(e, Y.SPREAD, i, i + 3);
        break;
      case 58:
        return ur(e, Y.COLON, i, i + 1);
      case 61:
        return ur(e, Y.EQUALS, i, i + 1);
      case 64:
        return ur(e, Y.AT, i, i + 1);
      case 91:
        return ur(e, Y.BRACKET_L, i, i + 1);
      case 93:
        return ur(e, Y.BRACKET_R, i, i + 1);
      case 123:
        return ur(e, Y.BRACE_L, i, i + 1);
      case 124:
        return ur(e, Y.PIPE, i, i + 1);
      case 125:
        return ur(e, Y.BRACE_R, i, i + 1);
      // StringValue
      case 34:
        return r.charCodeAt(i + 1) === 34 && r.charCodeAt(i + 2) === 34 ? PI(e, i) : CI(e, i);
    }
    if (pc(a) || a === 45)
      return SI(e, i, a);
    if (Lb(a))
      return II(e, i);
    throw $r(
      e.source,
      i,
      a === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Rl(a) || J1(r, i) ? `Unexpected character: ${Go(e, i)}.` : `Invalid character: ${Go(e, i)}.`
    );
  }
  return ur(e, Y.EOF, n, n);
}
function EI(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    if (a === 10 || a === 13)
      break;
    if (Rl(a))
      ++i;
    else if (J1(r, i))
      i += 2;
    else
      break;
  }
  return ur(
    e,
    Y.COMMENT,
    t,
    i,
    r.slice(t + 1, i)
  );
}
function SI(e, t, r) {
  const n = e.source.body;
  let i = t, a = r, o = !1;
  if (a === 45 && (a = n.charCodeAt(++i)), a === 48) {
    if (a = n.charCodeAt(++i), pc(a))
      throw $r(
        e.source,
        i,
        `Invalid number, unexpected digit after 0: ${Go(
          e,
          i
        )}.`
      );
  } else
    i = Pf(e, i, a), a = n.charCodeAt(i);
  if (a === 46 && (o = !0, a = n.charCodeAt(++i), i = Pf(e, i, a), a = n.charCodeAt(i)), (a === 69 || a === 101) && (o = !0, a = n.charCodeAt(++i), (a === 43 || a === 45) && (a = n.charCodeAt(++i)), i = Pf(e, i, a), a = n.charCodeAt(i)), a === 46 || Lb(a))
    throw $r(
      e.source,
      i,
      `Invalid number, expected digit but got: ${Go(
        e,
        i
      )}.`
    );
  return ur(
    e,
    o ? Y.FLOAT : Y.INT,
    t,
    i,
    n.slice(t, i)
  );
}
function Pf(e, t, r) {
  if (!pc(r))
    throw $r(
      e.source,
      t,
      `Invalid number, expected digit but got: ${Go(
        e,
        t
      )}.`
    );
  const n = e.source.body;
  let i = t + 1;
  for (; pc(n.charCodeAt(i)); )
    ++i;
  return i;
}
function CI(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1, a = i, o = "";
  for (; i < n; ) {
    const s = r.charCodeAt(i);
    if (s === 34)
      return o += r.slice(a, i), ur(e, Y.STRING, t, i + 1, o);
    if (s === 92) {
      o += r.slice(a, i);
      const l = r.charCodeAt(i + 1) === 117 ? r.charCodeAt(i + 2) === 123 ? TI(e, i) : AI(e, i) : OI(e, i);
      o += l.value, i += l.size, a = i;
      continue;
    }
    if (s === 10 || s === 13)
      break;
    if (Rl(s))
      ++i;
    else if (J1(r, i))
      i += 2;
    else
      throw $r(
        e.source,
        i,
        `Invalid character within String: ${Go(
          e,
          i
        )}.`
      );
  }
  throw $r(e.source, i, "Unterminated string.");
}
function TI(e, t) {
  const r = e.source.body;
  let n = 0, i = 3;
  for (; i < 12; ) {
    const a = r.charCodeAt(t + i++);
    if (a === 125) {
      if (i < 5 || !Rl(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: i
      };
    }
    if (n = n << 4 | Id(a), n < 0)
      break;
  }
  throw $r(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(
      t,
      t + i
    )}".`
  );
}
function AI(e, t) {
  const r = e.source.body, n = R4(r, t + 2);
  if (Rl(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if (Fb(n) && r.charCodeAt(t + 6) === 92 && r.charCodeAt(t + 7) === 117) {
    const i = R4(r, t + 8);
    if (jb(i))
      return {
        value: String.fromCodePoint(n, i),
        size: 12
      };
  }
  throw $r(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(t, t + 6)}".`
  );
}
function R4(e, t) {
  return Id(e.charCodeAt(t)) << 12 | Id(e.charCodeAt(t + 1)) << 8 | Id(e.charCodeAt(t + 2)) << 4 | Id(e.charCodeAt(t + 3));
}
function Id(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function OI(e, t) {
  const r = e.source.body;
  switch (r.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw $r(
    e.source,
    t,
    `Invalid character escape sequence: "${r.slice(
      t,
      t + 2
    )}".`
  );
}
function PI(e, t) {
  const r = e.source.body, n = r.length;
  let i = e.lineStart, a = t + 3, o = a, s = "";
  const l = [];
  for (; a < n; ) {
    const d = r.charCodeAt(a);
    if (d === 34 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34) {
      s += r.slice(o, a), l.push(s);
      const c = ur(
        e,
        Y.BLOCK_STRING,
        t,
        a + 3,
        // Return a string of the lines joined with U+000A.
        bI(l).join(`
`)
      );
      return e.line += l.length - 1, e.lineStart = i, c;
    }
    if (d === 92 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34 && r.charCodeAt(a + 3) === 34) {
      s += r.slice(o, a), o = a + 1, a += 4;
      continue;
    }
    if (d === 10 || d === 13) {
      s += r.slice(o, a), l.push(s), d === 13 && r.charCodeAt(a + 1) === 10 ? a += 2 : ++a, s = "", o = a, i = a;
      continue;
    }
    if (Rl(d))
      ++a;
    else if (J1(r, a))
      a += 2;
    else
      throw $r(
        e.source,
        a,
        `Invalid character within String: ${Go(
          e,
          a
        )}.`
      );
  }
  throw $r(e.source, a, "Unterminated string.");
}
function II(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    if (yI(a))
      ++i;
    else
      break;
  }
  return ur(
    e,
    Y.NAME,
    t,
    i,
    r.slice(t, i)
  );
}
const DI = 10, zb = 2;
function Mm(e) {
  return Z1(e, []);
}
function Z1(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return NI(e, t);
    default:
      return String(e);
  }
}
function NI(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const r = [...t, e];
  if (MI(e)) {
    const n = e.toJSON();
    if (n !== e)
      return typeof n == "string" ? n : Z1(n, r);
  } else if (Array.isArray(e))
    return LI(e, r);
  return RI(e, r);
}
function MI(e) {
  return typeof e.toJSON == "function";
}
function RI(e, t) {
  const r = Object.entries(e);
  return r.length === 0 ? "{}" : t.length > zb ? "[" + FI(e) + "]" : "{ " + r.map(
    ([n, i]) => n + ": " + Z1(i, t)
  ).join(", ") + " }";
}
function LI(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > zb)
    return "[Array]";
  const r = Math.min(DI, e.length), n = e.length - r, i = [];
  for (let a = 0; a < r; ++a)
    i.push(Z1(e[a], t));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function FI(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
const jI = globalThis.process && // eslint-disable-next-line no-undef
!0, zI = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  jI ? function(e, t) {
    return e instanceof t;
  } : function(e, t) {
    if (e instanceof t)
      return !0;
    if (typeof e == "object" && e !== null) {
      var r;
      const n = t.prototype[Symbol.toStringTag], i = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in e ? e[Symbol.toStringTag] : (r = e.constructor) === null || r === void 0 ? void 0 : r.name
      );
      if (n === i) {
        const a = Mm(e);
        throw new Error(`Cannot use ${n} "${a}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class Vb {
  constructor(t, r = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || p0(!1, `Body must be a string. Received: ${Mm(t)}.`), this.body = t, this.name = r, this.locationOffset = n, this.locationOffset.line > 0 || p0(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || p0(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function VI(e) {
  return zI(e, Vb);
}
function UI(e, t) {
  const r = new qI(e, t), n = r.parseDocument();
  return Object.defineProperty(n, "tokenCount", {
    enumerable: !1,
    value: r.tokenCount
  }), n;
}
class qI {
  constructor(t, r = {}) {
    const { lexer: n, ...i } = r;
    if (n)
      this._lexer = n;
    else {
      const a = VI(t) ? t : new Vb(t);
      this._lexer = new kI(a);
    }
    this._options = i, this._tokenCounter = 0;
  }
  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const t = this.expectToken(Y.NAME);
    return this.node(t, {
      kind: fe.NAME,
      value: t.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: fe.DOCUMENT,
      definitions: this.many(
        Y.SOF,
        this.parseDefinition,
        Y.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(Y.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), r = t ? this._lexer.lookahead() : this._lexer.token;
    if (t && r.kind === Y.BRACE_L)
      throw $r(
        this._lexer.source,
        this._lexer.token.start,
        "Unexpected description, descriptions are not supported on shorthand queries."
      );
    if (r.kind === Y.NAME) {
      switch (r.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      switch (r.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
      }
      if (t)
        throw $r(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, only GraphQL definitions support descriptions."
        );
      if (r.value === "extend")
        return this.parseTypeSystemExtension();
    }
    throw this.unexpected(r);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(Y.BRACE_L))
      return this.node(t, {
        kind: fe.OPERATION_DEFINITION,
        operation: js.QUERY,
        description: void 0,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const r = this.parseDescription(), n = this.parseOperationType();
    let i;
    return this.peek(Y.NAME) && (i = this.parseName()), this.node(t, {
      kind: fe.OPERATION_DEFINITION,
      operation: n,
      description: r,
      name: i,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const t = this.expectToken(Y.NAME);
    switch (t.value) {
      case "query":
        return js.QUERY;
      case "mutation":
        return js.MUTATION;
      case "subscription":
        return js.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      Y.PAREN_L,
      this.parseVariableDefinition,
      Y.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: fe.VARIABLE_DEFINITION,
      description: this.parseDescription(),
      variable: this.parseVariable(),
      type: (this.expectToken(Y.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(Y.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(Y.DOLLAR), this.node(t, {
      kind: fe.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: fe.SELECTION_SET,
      selections: this.many(
        Y.BRACE_L,
        this.parseSelection,
        Y.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(Y.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const t = this._lexer.token, r = this.parseName();
    let n, i;
    return this.expectOptionalToken(Y.COLON) ? (n = r, i = this.parseName()) : i = r, this.node(t, {
      kind: fe.FIELD,
      alias: n,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(Y.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(t) {
    const r = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(Y.PAREN_L, r, Y.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(t = !1) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(Y.COLON), this.node(r, {
      kind: fe.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(Y.SPREAD);
    const r = this.expectOptionalKeyword("on");
    return !r && this.peek(Y.NAME) ? this.node(t, {
      kind: fe.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: fe.INLINE_FRAGMENT,
      typeCondition: r ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: fe.FRAGMENT_DEFINITION,
      description: r,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: fe.FRAGMENT_DEFINITION,
      description: r,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(t) {
    const r = this._lexer.token;
    switch (r.kind) {
      case Y.BRACKET_L:
        return this.parseList(t);
      case Y.BRACE_L:
        return this.parseObject(t);
      case Y.INT:
        return this.advanceLexer(), this.node(r, {
          kind: fe.INT,
          value: r.value
        });
      case Y.FLOAT:
        return this.advanceLexer(), this.node(r, {
          kind: fe.FLOAT,
          value: r.value
        });
      case Y.STRING:
      case Y.BLOCK_STRING:
        return this.parseStringLiteral();
      case Y.NAME:
        switch (this.advanceLexer(), r.value) {
          case "true":
            return this.node(r, {
              kind: fe.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(r, {
              kind: fe.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(r, {
              kind: fe.NULL
            });
          default:
            return this.node(r, {
              kind: fe.ENUM,
              value: r.value
            });
        }
      case Y.DOLLAR:
        if (t)
          if (this.expectToken(Y.DOLLAR), this._lexer.token.kind === Y.NAME) {
            const n = this._lexer.token.value;
            throw $r(
              this._lexer.source,
              r.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(r);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: fe.STRING,
      value: t.value,
      block: t.kind === Y.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(t) {
    const r = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: fe.LIST,
      values: this.any(Y.BRACKET_L, r, Y.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(t) {
    const r = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: fe.OBJECT,
      fields: this.any(Y.BRACE_L, r, Y.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(t) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(Y.COLON), this.node(r, {
      kind: fe.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(t) {
    const r = [];
    for (; this.peek(Y.AT); )
      r.push(this.parseDirective(t));
    return r;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(t) {
    const r = this._lexer.token;
    return this.expectToken(Y.AT), this.node(r, {
      kind: fe.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const t = this._lexer.token;
    let r;
    if (this.expectOptionalToken(Y.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(Y.BRACKET_R), r = this.node(t, {
        kind: fe.LIST_TYPE,
        type: n
      });
    } else
      r = this.parseNamedType();
    return this.expectOptionalToken(Y.BANG) ? this.node(t, {
      kind: fe.NON_NULL_TYPE,
      type: r
    }) : r;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: fe.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(Y.STRING) || this.peek(Y.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.many(
      Y.BRACE_L,
      this.parseOperationTypeDefinition,
      Y.BRACE_R
    );
    return this.node(t, {
      kind: fe.SCHEMA_DEFINITION,
      description: r,
      directives: n,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const t = this._lexer.token, r = this.parseOperationType();
    this.expectToken(Y.COLON);
    const n = this.parseNamedType();
    return this.node(t, {
      kind: fe.OPERATION_TYPE_DEFINITION,
      operation: r,
      type: n
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: fe.SCALAR_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: fe.OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: a,
      fields: o
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(Y.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      Y.BRACE_L,
      this.parseFieldDefinition,
      Y.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(Y.COLON);
    const a = this.parseTypeReference(), o = this.parseConstDirectives();
    return this.node(t, {
      kind: fe.FIELD_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      type: a,
      directives: o
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      Y.PAREN_L,
      this.parseInputValueDef,
      Y.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName();
    this.expectToken(Y.COLON);
    const i = this.parseTypeReference();
    let a;
    this.expectOptionalToken(Y.EQUALS) && (a = this.parseConstValueLiteral());
    const o = this.parseConstDirectives();
    return this.node(t, {
      kind: fe.INPUT_VALUE_DEFINITION,
      description: r,
      name: n,
      type: i,
      defaultValue: a,
      directives: o
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: fe.INTERFACE_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: a,
      fields: o
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: fe.UNION_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      types: a
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(Y.EQUALS) ? this.delimitedMany(Y.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: fe.ENUM_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      values: a
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      Y.BRACE_L,
      this.parseEnumValueDefinition,
      Y.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: fe.ENUM_VALUE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw $r(
        this._lexer.source,
        this._lexer.token.start,
        `${Mu(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: fe.INPUT_OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      fields: a
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      Y.BRACE_L,
      this.parseInputValueDef,
      Y.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === Y.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const r = this.parseConstDirectives(), n = this.optionalMany(
      Y.BRACE_L,
      this.parseOperationTypeDefinition,
      Y.BRACE_R
    );
    if (r.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: fe.SCHEMA_EXTENSION,
      directives: r,
      operationTypes: n
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const r = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: fe.SCALAR_TYPE_EXTENSION,
      name: r,
      directives: n
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: fe.OBJECT_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: fe.INTERFACE_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: fe.UNION_TYPE_EXTENSION,
      name: r,
      directives: n,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: fe.ENUM_TYPE_EXTENSION,
      name: r,
      directives: n,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: fe.INPUT_OBJECT_TYPE_EXTENSION,
      name: r,
      directives: n,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(Y.AT);
    const n = this.parseName(), i = this.parseArgumentDefs(), a = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const o = this.parseDirectiveLocations();
    return this.node(t, {
      kind: fe.DIRECTIVE_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      repeatable: a,
      locations: o
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(Y.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const t = this._lexer.token, r = this.parseName();
    if (Object.prototype.hasOwnProperty.call(jp, r.value))
      return r;
    throw this.unexpected(t);
  }
  // Schema Coordinates
  /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   */
  parseSchemaCoordinate() {
    const t = this._lexer.token, r = this.expectOptionalToken(Y.AT), n = this.parseName();
    let i;
    !r && this.expectOptionalToken(Y.DOT) && (i = this.parseName());
    let a;
    return (r || i) && this.expectOptionalToken(Y.PAREN_L) && (a = this.parseName(), this.expectToken(Y.COLON), this.expectToken(Y.PAREN_R)), r ? a ? this.node(t, {
      kind: fe.DIRECTIVE_ARGUMENT_COORDINATE,
      name: n,
      argumentName: a
    }) : this.node(t, {
      kind: fe.DIRECTIVE_COORDINATE,
      name: n
    }) : i ? a ? this.node(t, {
      kind: fe.ARGUMENT_COORDINATE,
      name: n,
      fieldName: i,
      argumentName: a
    }) : this.node(t, {
      kind: fe.MEMBER_COORDINATE,
      name: n,
      memberName: i
    }) : this.node(t, {
      kind: fe.TYPE_COORDINATE,
      name: n
    });
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(t, r) {
    return this._options.noLocation !== !0 && (r.loc = new gI(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), r;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(t) {
    return this._lexer.token.kind === t;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(t) {
    const r = this._lexer.token;
    if (r.kind === t)
      return this.advanceLexer(), r;
    throw $r(
      this._lexer.source,
      r.start,
      `Expected ${Ub(t)}, found ${Mu(r)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(t) {
    const r = this._lexer.token;
    if (r.kind === Y.NAME && r.value === t)
      this.advanceLexer();
    else
      throw $r(
        this._lexer.source,
        r.start,
        `Expected "${t}", found ${Mu(r)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(t) {
    const r = this._lexer.token;
    return r.kind === Y.NAME && r.value === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(t) {
    const r = t ?? this._lexer.token;
    return $r(
      this._lexer.source,
      r.start,
      `Unexpected ${Mu(r)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(t, r, n) {
    this.expectToken(t);
    const i = [];
    for (; !this.expectOptionalToken(n); )
      i.push(r.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(t, r, n) {
    if (this.expectOptionalToken(t)) {
      const i = [];
      do
        i.push(r.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(t, r, n) {
    this.expectToken(t);
    const i = [];
    do
      i.push(r.call(this));
    while (!this.expectOptionalToken(n));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(t, r) {
    this.expectOptionalToken(t);
    const n = [];
    do
      n.push(r.call(this));
    while (this.expectOptionalToken(t));
    return n;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, r = this._lexer.advance();
    if (r.kind !== Y.EOF && (++this._tokenCounter, t !== void 0 && this._tokenCounter > t))
      throw $r(
        this._lexer.source,
        r.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
}
function Mu(e) {
  const t = e.value;
  return Ub(e.kind) + (t != null ? ` "${t}"` : "");
}
function Ub(e) {
  return _I(e) ? `"${e}"` : e;
}
function BI(e) {
  return `"${e.replace(HI, WI)}"`;
}
const HI = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function WI(e) {
  return KI[e.charCodeAt(0)];
}
const KI = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], X1 = Object.freeze({});
function di(e, t, r = Mb) {
  const n = /* @__PURE__ */ new Map();
  for (const g of Object.values(fe))
    n.set(g, QI(t, g));
  let i, a = Array.isArray(e), o = [e], s = -1, l = [], d = e, c, u;
  const h = [], f = [];
  do {
    s++;
    const g = s === o.length, w = g && l.length !== 0;
    if (g) {
      if (c = f.length === 0 ? void 0 : h[h.length - 1], d = u, u = f.pop(), w)
        if (a) {
          d = d.slice();
          let _ = 0;
          for (const [x, S] of l) {
            const T = x - _;
            S === null ? (d.splice(T, 1), _++) : d[T] = S;
          }
        } else {
          d = { ...d };
          for (const [_, x] of l)
            d[_] = x;
        }
      s = i.index, o = i.keys, l = i.edits, a = i.inArray, i = i.prev;
    } else if (u) {
      if (c = a ? s : o[s], d = u[c], d == null)
        continue;
      h.push(c);
    }
    let $;
    if (!Array.isArray(d)) {
      var p, m;
      if (M4(d) || p0(!1, `Invalid AST Node: ${Mm(d)}.`), $ = (g ? (p = n.get(d.kind)) === null || p === void 0 ? void 0 : p.leave : (m = n.get(d.kind)) === null || m === void 0 ? void 0 : m.enter)?.call(t, d, c, u, h, f), $ === X1)
        break;
      if ($ === !1) {
        if (!g) {
          h.pop();
          continue;
        }
      } else if ($ !== void 0 && (l.push([c, $]), !g))
        if (M4($))
          d = $;
        else {
          h.pop();
          continue;
        }
    }
    if ($ === void 0 && w && l.push([c, d]), g)
      h.pop();
    else {
      var y;
      i = {
        inArray: a,
        index: s,
        keys: o,
        edits: l,
        prev: i
      }, a = Array.isArray(d), o = a ? d : (y = r[d.kind]) !== null && y !== void 0 ? y : [], s = -1, l = [], u && f.push(u), u = d;
    }
  } while (i !== void 0);
  return l.length !== 0 ? l[l.length - 1][1] : e;
}
function QI(e, t) {
  const r = e[t];
  return typeof r == "object" ? r : typeof r == "function" ? {
    enter: r,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function GI(e) {
  return di(e, JI);
}
const YI = 80, JI = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => we(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const t = If(e.variableDefinitions) ? Ue(`(
`, we(e.variableDefinitions, `
`), `
)`) : Ue("(", we(e.variableDefinitions, ", "), ")"), r = Ue("", e.description, `
`) + we(
        [
          e.operation,
          we([e.name, t]),
          we(e.directives, " ")
        ],
        " "
      );
      return (r === "query" ? "" : r + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: t, defaultValue: r, directives: n, description: i }) => Ue("", i, `
`) + e + ": " + t + Ue(" = ", r) + Ue(" ", we(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => qn(e)
  },
  Field: {
    leave({ alias: e, name: t, arguments: r, directives: n, selectionSet: i }) {
      const a = Ue("", e, ": ") + t;
      let o = a + Ue("(", we(r, ", "), ")");
      return o.length > YI && (o = a + Ue(`(
`, m0(we(r, `
`)), `
)`)), we([o, we(n, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: t }) => "..." + e + Ue(" ", we(t, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: t, selectionSet: r }) => we(
      [
        "...",
        Ue("on ", e),
        we(t, " "),
        r
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({
      name: e,
      typeCondition: t,
      variableDefinitions: r,
      directives: n,
      selectionSet: i,
      description: a
    }) => Ue("", a, `
`) + // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    `fragment ${e}${Ue("(", we(r, ", "), ")")} on ${t} ${Ue("", we(n, " "), " ")}` + i
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: t }) => t ? $I(e) : BI(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + we(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + we(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: t }) => "@" + e + Ue("(", we(t, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: t, operationTypes: r }) => Ue("", e, `
`) + we(["schema", we(t, " "), qn(r)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: t }) => e + ": " + t
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: t, directives: r }) => Ue("", e, `
`) + we(["scalar", t, we(r, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => Ue("", e, `
`) + we(
      [
        "type",
        t,
        Ue("implements ", we(r, " & ")),
        we(n, " "),
        qn(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: t, arguments: r, type: n, directives: i }) => Ue("", e, `
`) + t + (If(r) ? Ue(`(
`, m0(we(r, `
`)), `
)`) : Ue("(", we(r, ", "), ")")) + ": " + n + Ue(" ", we(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: t, type: r, defaultValue: n, directives: i }) => Ue("", e, `
`) + we(
      [t + ": " + r, Ue("= ", n), we(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => Ue("", e, `
`) + we(
      [
        "interface",
        t,
        Ue("implements ", we(r, " & ")),
        we(n, " "),
        qn(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, types: n }) => Ue("", e, `
`) + we(
      ["union", t, we(r, " "), Ue("= ", we(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, values: n }) => Ue("", e, `
`) + we(["enum", t, we(r, " "), qn(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: t, directives: r }) => Ue("", e, `
`) + we([t, we(r, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, fields: n }) => Ue("", e, `
`) + we(["input", t, we(r, " "), qn(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: t, arguments: r, repeatable: n, locations: i }) => Ue("", e, `
`) + "directive @" + t + (If(r) ? Ue(`(
`, m0(we(r, `
`)), `
)`) : Ue("(", we(r, ", "), ")")) + (n ? " repeatable" : "") + " on " + we(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: t }) => we(
      ["extend schema", we(e, " "), qn(t)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: t }) => we(["extend scalar", e, we(t, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => we(
      [
        "extend type",
        e,
        Ue("implements ", we(t, " & ")),
        we(r, " "),
        qn(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => we(
      [
        "extend interface",
        e,
        Ue("implements ", we(t, " & ")),
        we(r, " "),
        qn(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: t, types: r }) => we(
      [
        "extend union",
        e,
        we(t, " "),
        Ue("= ", we(r, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: t, values: r }) => we(["extend enum", e, we(t, " "), qn(r)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: t, fields: r }) => we(["extend input", e, we(t, " "), qn(r)], " ")
  },
  // Schema Coordinates
  TypeCoordinate: {
    leave: ({ name: e }) => e
  },
  MemberCoordinate: {
    leave: ({ name: e, memberName: t }) => we([e, Ue(".", t)])
  },
  ArgumentCoordinate: {
    leave: ({ name: e, fieldName: t, argumentName: r }) => we([e, Ue(".", t), Ue("(", r, ":)")])
  },
  DirectiveCoordinate: {
    leave: ({ name: e }) => we(["@", e])
  },
  DirectiveArgumentCoordinate: {
    leave: ({ name: e, argumentName: t }) => we(["@", e, Ue("(", t, ":)")])
  }
};
function we(e, t = "") {
  var r;
  return (r = e?.filter((n) => n).join(t)) !== null && r !== void 0 ? r : "";
}
function qn(e) {
  return Ue(`{
`, m0(we(e, `
`)), `
}`);
}
function Ue(e, t, r = "") {
  return t != null && t !== "" ? e + t + r : "";
}
function m0(e) {
  return Ue("  ", e.replace(/\n/g, `
  `));
}
function If(e) {
  var t;
  return (t = e?.some((r) => r.includes(`
`))) !== null && t !== void 0 ? t : !1;
}
function L4(e) {
  return e.kind === fe.FIELD || e.kind === fe.FRAGMENT_SPREAD || e.kind === fe.INLINE_FRAGMENT;
}
var g0 = /* @__PURE__ */ new Map(), Vp = /* @__PURE__ */ new Map(), qb = !0, n1 = !1;
function Bb(e) {
  return e.replace(/[\s,]+/g, " ").trim();
}
function ZI(e) {
  return Bb(e.source.body.substring(e.start, e.end));
}
function XI(e) {
  var t = /* @__PURE__ */ new Set(), r = [];
  return e.definitions.forEach(function(n) {
    if (n.kind === "FragmentDefinition") {
      var i = n.name.value, a = ZI(n.loc), o = Vp.get(i);
      o && !o.has(a) ? qb && console.warn("Warning: fragment with name " + i + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : o || Vp.set(i, o = /* @__PURE__ */ new Set()), o.add(a), t.has(a) || (t.add(a), r.push(n));
    } else
      r.push(n);
  }), X(X({}, e), { definitions: r });
}
function eD(e) {
  var t = new Set(e.definitions);
  t.forEach(function(n) {
    n.loc && delete n.loc, Object.keys(n).forEach(function(i) {
      var a = n[i];
      a && typeof a == "object" && t.add(a);
    });
  });
  var r = e.loc;
  return r && (delete r.startToken, delete r.endToken), e;
}
function tD(e) {
  var t = Bb(e);
  if (!g0.has(t)) {
    var r = UI(e, {
      experimentalFragmentVariables: n1,
      allowLegacyFragmentVariables: n1
    });
    if (!r || r.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    g0.set(t, eD(XI(r)));
  }
  return g0.get(t);
}
function je(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  typeof e == "string" && (e = [e]);
  var n = e[0];
  return t.forEach(function(i, a) {
    i && i.kind === "Document" ? n += i.loc.source.body : n += i, n += e[a + 1];
  }), tD(n);
}
function rD() {
  g0.clear(), Vp.clear();
}
function nD() {
  qb = !1;
}
function iD() {
  n1 = !0;
}
function aD() {
  n1 = !1;
}
var cd = {
  gql: je,
  resetCaches: rD,
  disableFragmentWarnings: nD,
  enableExperimentalFragmentVariables: iD,
  disableExperimentalFragmentVariables: aD
};
(function(e) {
  e.gql = cd.gql, e.resetCaches = cd.resetCaches, e.disableFragmentWarnings = cd.disableFragmentWarnings, e.enableExperimentalFragmentVariables = cd.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = cd.disableExperimentalFragmentVariables;
})(je || (je = {}));
je.default = je;
function Hb(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (r = Hb(e[t])) && (n && (n += " "), n += r);
  else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function jt() {
  for (var e, t, r = 0, n = ""; r < arguments.length; ) (e = arguments[r++]) && (t = Hb(e)) && (n && (n += " "), n += t);
  return n;
}
var oD = /* @__PURE__ */ k("<svg>");
const sD = (e) => {
  const [t, r] = qo(e, ["path"]);
  return (() => {
    var n = oD();
    return Ln(n, Ke({
      get viewBox() {
        return t.path.mini ? "0 0 20 20" : "0 0 24 24";
      },
      get fill() {
        return t.path.outline ? "none" : "currentColor";
      },
      get stroke() {
        return t.path.outline ? "currentColor" : "none";
      },
      get "stroke-width"() {
        return t.path.outline ? 1.5 : void 0;
      }
    }, r), !0, !0), C(n, () => t.path.path), n;
  })();
};
var lD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5"></svg>', !1, !0, !1), dD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75"></svg>', !1, !0, !1), cD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5"></svg>', !1, !0, !1), uD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), hD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m6 4.125l2.25 2.25m0 0l2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), fD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), pD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12.75l3 3m0 0l3-3m-3 3v-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), mD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 4.5l-15 15m0 0h11.25m-11.25 0V8.25"></svg>', !1, !0, !1), gD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 7.5h-.75A2.25 2.25 0 004.5 9.75v7.5a2.25 2.25 0 002.25 2.25h7.5a2.25 2.25 0 002.25-2.25v-7.5a2.25 2.25 0 00-2.25-2.25h-.75m-6 3.75l3 3m0 0l3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 012.25 2.25v7.5a2.25 2.25 0 01-2.25 2.25h-7.5a2.25 2.25 0 01-2.25-2.25v-.75"></svg>', !1, !0, !1), vD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15M9 12l3 3m0 0l3-3m-3 3V2.25"></svg>', !1, !0, !1), yD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 4.5l15 15m0 0V8.25m0 11.25H8.25"></svg>', !1, !0, !1), bD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"></svg>', !1, !0, !1), wD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"></svg>', !1, !0, !1), $D = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.25 9l-3 3m0 0l3 3m-3-3h7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), kD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"></svg>', !1, !0, !1), _D = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"></svg>', !1, !0, !1), xD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 17.25L12 21m0 0l-3.75-3.75M12 21V3"></svg>', !1, !0, !1), ED = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"></svg>', !1, !0, !1), SD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"></svg>', !1, !0, !1), CD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 6.75L12 3m0 0l3.75 3.75M12 3v18"></svg>', !1, !0, !1), TD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 00-3.7-3.7 48.678 48.678 0 00-7.324 0 4.006 4.006 0 00-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3l-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 003.7 3.7 48.656 48.656 0 007.324 0 4.006 4.006 0 003.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3l-3 3"></svg>', !1, !0, !1), AD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"></svg>', !1, !0, !1), OD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), PD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"></svg>', !1, !0, !1), ID = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"></svg>', !1, !0, !1), DD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 4.5v15m0 0l6.75-6.75M12 19.5l-6.75-6.75"></svg>', !1, !0, !1), ND = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"></svg>', !1, !0, !1), MD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"></svg>', !1, !0, !1), RD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"></svg>', !1, !0, !1), LD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"></svg>', !1, !0, !1), FD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 6L9 12.75l4.286-4.286a11.948 11.948 0 014.306 6.43l.776 2.898m0 0l3.182-5.511m-3.182 5.51l-5.511-3.181"></svg>', !1, !0, !1), jD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"></svg>', !1, !0, !1), zD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), VD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 19.5l-15-15m0 0v11.25m0-11.25h11.25"></svg>', !1, !0, !1), UD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 7.5h-.75A2.25 2.25 0 004.5 9.75v7.5a2.25 2.25 0 002.25 2.25h7.5a2.25 2.25 0 002.25-2.25v-7.5a2.25 2.25 0 00-2.25-2.25h-.75m0-3l-3-3m0 0l-3 3m3-3v11.25m6-2.25h.75a2.25 2.25 0 012.25 2.25v7.5a2.25 2.25 0 01-2.25 2.25h-7.5a2.25 2.25 0 01-2.25-2.25v-.75"></svg>', !1, !0, !1), qD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15m0-3l-3-3m0 0l-3 3m3-3V15"></svg>', !1, !0, !1), BD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"></svg>', !1, !0, !1), HD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"></svg>', !1, !0, !1), WD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"></svg>', !1, !0, !1), KD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 15l-6 6m0 0l-6-6m6 6V9a6 6 0 0112 0v3"></svg>', !1, !0, !1), QD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"></svg>', !1, !0, !1), GD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 15l6-6m0 0l-6-6m6 6H9a6 6 0 000 12h3"></svg>', !1, !0, !1), YD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 9l6-6m0 0l6 6m-6-6v12a6 6 0 01-12 0v-3"></svg>', !1, !0, !1), JD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 9V4.5M9 9H4.5M9 9L3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5l5.25 5.25"></svg>', !1, !0, !1), ZD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"></svg>', !1, !0, !1), XD = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"></svg>', !1, !0, !1), eN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"></svg>', !1, !0, !1), tN = /* @__PURE__ */ k('<svg><path stroke-linecap=round d="M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25"></svg>', !1, !0, !1), rN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9.75L14.25 12m0 0l2.25 2.25M14.25 12l2.25-2.25M14.25 12L12 14.25m-2.58 4.92l-6.375-6.375a1.125 1.125 0 010-1.59L9.42 4.83c.211-.211.498-.33.796-.33H19.5a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25h-9.284c-.298 0-.585-.119-.796-.33z"></svg>', !1, !0, !1), nN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 16.811c0 .864-.933 1.405-1.683.977l-7.108-4.062a1.125 1.125 0 010-1.953l7.108-4.062A1.125 1.125 0 0121 8.688v8.123zM11.25 16.811c0 .864-.933 1.405-1.683.977l-7.108-4.062a1.125 1.125 0 010-1.953L9.567 7.71a1.125 1.125 0 011.683.977v8.123z"></svg>', !1, !0, !1), iN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"></svg>', !1, !0, !1), aN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 9h16.5m-16.5 6.75h16.5"></svg>', !1, !0, !1), oN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"></svg>', !1, !0, !1), sN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6.75h16.5M3.75 12h16.5M12 17.25h8.25"></svg>', !1, !0, !1), lN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5"></svg>', !1, !0, !1), dN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"></svg>', !1, !0, !1), cN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"></svg>', !1, !0, !1), uN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0l-3.75-3.75M17.25 21L21 17.25"></svg>', !1, !0, !1), hN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12"></svg>', !1, !0, !1), fN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M3.75 18h15A2.25 2.25 0 0021 15.75v-6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 001.5 9.75v6A2.25 2.25 0 003.75 18z"></svg>', !1, !0, !1), pN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5H18V15H4.5v-4.5zM3.75 18h15A2.25 2.25 0 0021 15.75v-6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 001.5 9.75v6A2.25 2.25 0 003.75 18z"></svg>', !1, !0, !1), mN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5h6.75V15H4.5v-4.5zM3.75 18h15A2.25 2.25 0 0021 15.75v-6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 001.5 9.75v6A2.25 2.25 0 003.75 18z"></svg>', !1, !0, !1), gN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5"></svg>', !1, !0, !1), vN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M3.124 7.5A8.969 8.969 0 015.292 3m13.416 0a8.969 8.969 0 012.168 4.5"></svg>', !1, !0, !1), yN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.143 17.082a24.248 24.248 0 003.844.148m-3.844-.148a23.856 23.856 0 01-5.455-1.31 8.964 8.964 0 002.3-5.542m3.155 6.852a3 3 0 005.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 003.536-1.003A8.967 8.967 0 0118 9.75V9A6 6 0 006.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53"></svg>', !1, !0, !1), bN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M10.5 8.25h3l-3 4.5h3"></svg>', !1, !0, !1), wN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"></svg>', !1, !0, !1), $N = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.412 15.655L9.75 21.75l3.745-4.012M9.257 13.5H3.75l2.659-2.849m2.048-2.194L14.25 2.25 12 10.5h8.25l-4.707 5.043M8.457 8.457L3 3m5.457 5.457l7.086 7.086m0 0L21 21"></svg>', !1, !0, !1), kN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"></svg>', !1, !0, !1), _N = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"></svg>', !1, !0, !1), xN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 3l1.664 1.664M21 21l-1.5-1.5m-5.485-1.242L12 17.25 4.5 21V8.742m.164-4.078a2.15 2.15 0 011.743-1.342 48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185V19.5M4.664 4.664L19.5 19.5"></svg>', !1, !0, !1), EN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 3.75V16.5L12 14.25 7.5 16.5V3.75m9 0H18A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h1.5m9 0h-9"></svg>', !1, !0, !1), SN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0z"></svg>', !1, !0, !1), CN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"></svg>', !1, !0, !1), TN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0112 12.75zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 01-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 002.248-2.354M12 12.75a2.25 2.25 0 01-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 00-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 01.4-2.253M12 8.25a2.25 2.25 0 00-2.248 2.146M12 8.25a2.25 2.25 0 012.248 2.146M8.683 5a6.032 6.032 0 01-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0115.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 00-.575-1.752M4.921 6a24.048 24.048 0 00-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 01-5.223 1.082"></svg>', !1, !0, !1), AN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z"></svg>', !1, !0, !1), ON = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), PN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"></svg>', !1, !0, !1), IN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 21v-7.5a.75.75 0 01.75-.75h3a.75.75 0 01.75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349m-16.5 11.65V9.35m0 0a3.001 3.001 0 003.75-.615A2.993 2.993 0 009.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 002.25 1.016c.896 0 1.7-.393 2.25-1.016a3.001 3.001 0 003.75.614m-16.5 0a3.004 3.004 0 01-.621-4.72L4.318 3.44A1.5 1.5 0 015.378 3h13.243a1.5 1.5 0 011.06.44l1.19 1.189a3 3 0 01-.621 4.72m-13.5 8.65h3.75a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75H6.75a.75.75 0 00-.75.75v3.75c0 .415.336.75.75.75z"></svg>', !1, !0, !1), DN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 8.25v-1.5m0 1.5c-1.355 0-2.697.056-4.024.166C6.845 8.51 6 9.473 6 10.608v2.513m6-4.87c1.355 0 2.697.055 4.024.165C17.155 8.51 18 9.473 18 10.608v2.513m-3-4.87v-1.5m-6 1.5v-1.5m12 9.75l-1.5.75a3.354 3.354 0 01-3 0 3.354 3.354 0 00-3 0 3.354 3.354 0 01-3 0 3.354 3.354 0 00-3 0 3.354 3.354 0 01-3 0L3 16.5m15-3.38a48.474 48.474 0 00-6-.37c-2.032 0-4.034.125-6 .37m12 0c.39.049.777.102 1.163.16 1.07.16 1.837 1.094 1.837 2.175v5.17c0 .62-.504 1.124-1.125 1.124H4.125A1.125 1.125 0 013 20.625v-5.17c0-1.08.768-2.014 1.837-2.174A47.78 47.78 0 016 13.12M12.265 3.11a.375.375 0 11-.53 0L12 2.845l.265.265zm-3 0a.375.375 0 11-.53 0L9 2.845l.265.265zm6 0a.375.375 0 11-.53 0L15 2.845l.265.265z"></svg>', !1, !0, !1), NN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z"></svg>', !1, !0, !1), MN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"></svg>', !1, !0, !1), RN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"></svg>', !1, !0, !1), LN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z"></svg>', !1, !0, !1), FN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z"></svg>', !1, !0, !1), jN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"></svg>', !1, !0, !1), zN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"></svg>', !1, !0, !1), VN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 6a7.5 7.5 0 107.5 7.5h-7.5V6z"></svg>', !1, !0, !1), UN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 10.5H21A7.5 7.5 0 0013.5 3v7.5z"></svg>', !1, !0, !1), qN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"></svg>', !1, !0, !1), BN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.068.157 2.148.279 3.238.364.466.037.893.281 1.153.671L12 21l2.652-3.978c.26-.39.687-.634 1.153-.67 1.09-.086 2.17-.208 3.238-.365 1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"></svg>', !1, !0, !1), HN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"></svg>', !1, !0, !1), WN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"></svg>', !1, !0, !1), KN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 011.037-.443 48.282 48.282 0 005.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"></svg>', !1, !0, !1), QN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z"></svg>', !1, !0, !1), GN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 01-.923 1.785A5.969 5.969 0 006 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337z"></svg>', !1, !0, !1), YN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"></svg>', !1, !0, !1), JN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), ZN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 12.75l6 6 9-13.5"></svg>', !1, !0, !1), XN = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 5.25l-7.5 7.5-7.5-7.5m15 6l-7.5 7.5-7.5-7.5"></svg>', !1, !0, !1), eM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5"></svg>', !1, !0, !1), tM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5"></svg>', !1, !0, !1), rM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 12.75l7.5-7.5 7.5 7.5m-15 6l7.5-7.5 7.5 7.5"></svg>', !1, !0, !1), nM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 8.25l-7.5 7.5-7.5-7.5"></svg>', !1, !0, !1), iM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 19.5L8.25 12l7.5-7.5"></svg>', !1, !0, !1), aM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 4.5l7.5 7.5-7.5 7.5"></svg>', !1, !0, !1), oM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></svg>', !1, !0, !1), sM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 15.75l7.5-7.5 7.5 7.5"></svg>', !1, !0, !1), lM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"></svg>', !1, !0, !1), dM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75"></svg>', !1, !0, !1), cM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"></svg>', !1, !0, !1), uM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z"></svg>', !1, !0, !1), hM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184"></svg>', !1, !0, !1), fM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), pM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9.75v6.75m0 0l-3-3m3 3l3-3m-8.25 6a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"></svg>', !1, !0, !1), mM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"></svg>', !1, !0, !1), gM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z"></svg>', !1, !0, !1), vM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 9.75L16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"></svg>', !1, !0, !1), yM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"></svg>', !1, !0, !1), bM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"></svg>', !1, !0, !1), Rm = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></svg>', !1, !0, !1), wM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z"></svg>', !1, !0, !1), $M = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 12a7.5 7.5 0 0015 0m-15 0a7.5 7.5 0 1115 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077l1.41-.513m14.095-5.13l1.41-.513M5.106 17.785l1.15-.964m11.49-9.642l1.149-.964M7.501 19.795l.75-1.3m7.5-12.99l.75-1.3m-6.063 16.658l.26-1.477m2.605-14.772l.26-1.477m0 17.726l-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205L12 12m6.894 5.785l-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864l-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"></svg>', !1, !0, !1), kM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 7.5l3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), _M = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25"></svg>', !1, !0, !1), xM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 002.25-2.25V6.75a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 6.75v10.5a2.25 2.25 0 002.25 2.25zm.75-12h9v9h-9v-9z"></svg>', !1, !0, !1), EM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"></svg>', !1, !0, !1), SM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 7.5l-2.25-1.313M21 7.5v2.25m0-2.25l-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3l2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75l2.25-1.313M12 21.75V19.5m0 2.25l-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"></svg>', !1, !0, !1), CM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"></svg>', !1, !0, !1), TM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 7.5l.415-.207a.75.75 0 011.085.67V10.5m0 0h6m-6 0h-1.5m1.5 0v5.438c0 .354.161.697.473.865a3.751 3.751 0 005.452-2.553c.083-.409-.263-.75-.68-.75h-.745M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), AM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), OM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 7.756a4.5 4.5 0 100 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), PM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.121 7.629A3 3 0 009.017 9.43c-.023.212-.002.425.028.636l.506 3.541a4.5 4.5 0 01-.43 2.65L9 16.5l1.539-.513a2.25 2.25 0 011.422 0l.655.218a2.25 2.25 0 001.718-.122L15 15.75M8.25 12H12m9 0a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), IM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 8.25H9m6 3H9m3 6l-3-3h1.5a3 3 0 100-6M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), DM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 7.5l3 4.5m0 0l3-4.5M12 12v5.25M15 12H9m6 3H9m12-3a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), NM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zM12 2.25V4.5m5.834.166l-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243l-1.59-1.59"></svg>', !1, !0, !1), MM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zm-7.518-.267A8.25 8.25 0 1120.25 10.5M8.288 14.212A5.25 5.25 0 1117.25 10.5"></svg>', !1, !0, !1), RM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"></svg>', !1, !0, !1), LM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 19.5h3m-6.75 2.25h10.5a2.25 2.25 0 002.25-2.25v-15a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 4.5v15a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), FM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m.75 12l3 3m0 0l3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), jM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), zM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), VM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 019 9v.375M10.125 2.25A3.375 3.375 0 0113.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 013.375 3.375M9 15l2.25 2.25L15 12"></svg>', !1, !0, !1), UM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"></svg>', !1, !0, !1), qM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9zm3.75 11.625a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"></svg>', !1, !0, !1), BM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), HM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), WM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), KM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), QM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), GM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"></svg>', !1, !0, !1), YM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"></svg>', !1, !0, !1), JM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.75 9v.906a2.25 2.25 0 01-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 001.183 1.981l6.478 3.488m8.839 2.51l-4.66-2.51m0 0l-1.023-.55a2.25 2.25 0 00-2.134 0l-1.022.55m0 0l-4.661 2.51m16.5 1.615a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V8.844a2.25 2.25 0 011.183-1.98l7.5-4.04a2.25 2.25 0 012.134 0l7.5 4.04a2.25 2.25 0 011.183 1.98V19.5z"></svg>', !1, !0, !1), ZM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"></svg>', !1, !0, !1), XM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"></svg>', !1, !0, !1), eR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"></svg>', !1, !0, !1), tR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 11.25l1.5 1.5.75-.75V8.758l2.276-.61a3 3 0 10-3.675-3.675l-.61 2.277H12l-.75.75 1.5 1.5M15 11.25l-8.47 8.47c-.34.34-.8.53-1.28.53s-.94.19-1.28.53l-.97.97-.75-.75.97-.97c.34-.34.53-.8.53-1.28s.19-.94.53-1.28L12.75 9M15 11.25L12.75 9"></svg>', !1, !0, !1), rR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"></svg>', !1, !0, !1), nR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"></svg>', !1, !0, !1), iR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.182 16.318A4.486 4.486 0 0012.016 15a4.486 4.486 0 00-3.198 1.318M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z"></svg>', !1, !0, !1), aR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.182 15.182a4.5 4.5 0 01-6.364 0M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z"></svg>', !1, !0, !1), oR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0118 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0118 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 016 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5"></svg>', !1, !0, !1), sR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.864 4.243A7.5 7.5 0 0119.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 004.5 10.5a7.464 7.464 0 01-1.15 3.993m1.989 3.559A11.209 11.209 0 008.25 10.5a3.75 3.75 0 117.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 01-3.6 9.75m6.633-4.596a18.666 18.666 0 01-2.485 5.33"></svg>', !1, !0, !1), lR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z"></svg>', !1, !0, !1), dR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 18a3.75 3.75 0 00.495-7.467 5.99 5.99 0 00-1.925 3.546 5.974 5.974 0 01-2.133-1A3.75 3.75 0 0012 18z"></svg>', !1, !0, !1), cR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 3v1.5M3 21v-6m0 0l2.77-.693a9 9 0 016.208.682l.108.054a9 9 0 006.086.71l3.114-.732a48.524 48.524 0 01-.005-10.499l-3.11.732a9 9 0 01-6.085-.711l-.108-.054a9 9 0 00-6.208-.682L3 4.5M3 15V4.5"></svg>', !1, !0, !1), uR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 13.5l3 3m0 0l3-3m-3 3v-6m1.06-4.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"></svg>', !1, !0, !1), hR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 13.5H9m4.06-7.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"></svg>', !1, !0, !1), fR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 00-1.883 2.542l.857 6a2.25 2.25 0 002.227 1.932H19.05a2.25 2.25 0 002.227-1.932l.857-6a2.25 2.25 0 00-1.883-2.542m-16.5 0V6A2.25 2.25 0 016 3.75h3.879a1.5 1.5 0 011.06.44l2.122 2.12a1.5 1.5 0 001.06.44H18A2.25 2.25 0 0120.25 9v.776"></svg>', !1, !0, !1), pR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 10.5v6m3-3H9m4.06-7.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"></svg>', !1, !0, !1), mR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"></svg>', !1, !0, !1), gR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 8.688c0-.864.933-1.405 1.683-.977l7.108 4.062a1.125 1.125 0 010 1.953l-7.108 4.062A1.125 1.125 0 013 16.81V8.688zM12.75 8.688c0-.864.933-1.405 1.683-.977l7.108 4.062a1.125 1.125 0 010 1.953l-7.108 4.062a1.125 1.125 0 01-1.683-.977V8.688z"></svg>', !1, !0, !1), vR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"></svg>', !1, !0, !1), yR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12.75 8.25v7.5m6-7.5h-3V12m0 0v3.75m0-3.75H18M9.75 9.348c-1.03-1.464-2.698-1.464-3.728 0-1.03 1.465-1.03 3.84 0 5.304 1.03 1.464 2.699 1.464 3.728 0V12h-1.5M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"></svg>', !1, !0, !1), bR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 3.75v16.5M2.25 12h19.5M6.375 17.25a4.875 4.875 0 004.875-4.875V12m6.375 5.25a4.875 4.875 0 01-4.875-4.875V12m-9 8.25h16.5a1.5 1.5 0 001.5-1.5V5.25a1.5 1.5 0 00-1.5-1.5H3.75a1.5 1.5 0 00-1.5 1.5v13.5a1.5 1.5 0 001.5 1.5zm12.621-9.44c-1.409 1.41-4.242 1.061-4.242 1.061s-.349-2.833 1.06-4.242a2.25 2.25 0 013.182 3.182zM10.773 7.63c1.409 1.409 1.06 4.242 1.06 4.242S9 12.22 7.592 10.811a2.25 2.25 0 113.182-3.182z"></svg>', !1, !0, !1), wR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), $R = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"></svg>', !1, !0, !1), kR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.115 5.19l.319 1.913A6 6 0 008.11 10.36L9.75 12l-.387.775c-.217.433-.132.956.21 1.298l1.348 1.348c.21.21.329.497.329.795v1.089c0 .426.24.815.622 1.006l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 002.288-4.042 1.087 1.087 0 00-.358-1.099l-1.33-1.108c-.251-.21-.582-.299-.905-.245l-1.17.195a1.125 1.125 0 01-.98-.314l-.295-.295a1.125 1.125 0 010-1.591l.13-.132a1.125 1.125 0 011.3-.21l.603.302a.809.809 0 001.086-1.086L14.25 7.5l1.256-.837a4.5 4.5 0 001.528-1.732l.146-.292M6.115 5.19A9 9 0 1017.18 4.64M6.115 5.19A8.965 8.965 0 0112 3c1.929 0 3.716.607 5.18 1.64"></svg>', !1, !0, !1), _R = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12.75 3.03v.568c0 .334.148.65.405.864l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 01-1.161.886l-.143.048a1.107 1.107 0 00-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 01-1.652.928l-.679-.906a1.125 1.125 0 00-1.906.172L4.5 15.75l-.612.153M12.75 3.031a9 9 0 00-8.862 12.872M12.75 3.031a9 9 0 016.69 14.036m0 0l-.177-.529A2.25 2.25 0 0017.128 15H16.5l-.324-.324a1.453 1.453 0 00-2.328.377l-.036.073a1.586 1.586 0 01-.982.816l-.99.282c-.55.157-.894.702-.8 1.267l.073.438c.08.474.49.821.97.821.846 0 1.598.542 1.865 1.345l.215.643m5.276-3.67a9.012 9.012 0 01-5.276 3.67m0 0a9 9 0 01-10.275-4.835M15.75 9c0 .896-.393 1.7-1.016 2.25"></svg>', !1, !0, !1), xR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.893 13.393l-1.135-1.135a2.252 2.252 0 01-.421-.585l-1.08-2.16a.414.414 0 00-.663-.107.827.827 0 01-.812.21l-1.273-.363a.89.89 0 00-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 01-1.81 1.025 1.055 1.055 0 01-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 01-1.383-2.46l.007-.042a2.25 2.25 0 01.29-.787l.09-.15a2.25 2.25 0 012.37-1.048l1.178.236a1.125 1.125 0 001.302-.795l.208-.73a1.125 1.125 0 00-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 01-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 01-1.458-1.137l1.411-2.353a2.25 2.25 0 00.286-.76m11.928 9.869A9 9 0 008.965 3.525m11.928 9.868A9 9 0 118.965 3.525"></svg>', !1, !0, !1), ER = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.05 4.575a1.575 1.575 0 10-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 013.15 0v1.5m-3.15 0l.075 5.925m3.075.75V4.575m0 0a1.575 1.575 0 013.15 0V15M6.9 7.575a1.575 1.575 0 10-3.15 0v8.175a6.75 6.75 0 006.75 6.75h2.018a5.25 5.25 0 003.712-1.538l1.732-1.732a5.25 5.25 0 001.538-3.712l.003-2.024a.668.668 0 01.198-.471 1.575 1.575 0 10-2.228-2.228 3.818 3.818 0 00-1.12 2.687M6.9 7.575V12m6.27 4.318A4.49 4.49 0 0116.35 15m.002 0h-.002"></svg>', !1, !0, !1), SR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 15h2.25m8.024-9.75c.011.05.028.1.052.148.591 1.2.924 2.55.924 3.977a8.96 8.96 0 01-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398C20.613 14.547 19.833 15 19 15h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 00.303-.54m.023-8.25H16.48a4.5 4.5 0 01-1.423-.23l-3.114-1.04a4.5 4.5 0 00-1.423-.23H6.504c-.618 0-1.217.247-1.605.729A11.95 11.95 0 002.25 12c0 .434.023.863.068 1.285C2.427 14.306 3.346 15 4.372 15h3.126c.618 0 .991.724.725 1.282A7.471 7.471 0 007.5 19.5a2.25 2.25 0 002.25 2.25.75.75 0 00.75-.75v-.633c0-.573.11-1.14.322-1.672.304-.76.93-1.33 1.653-1.715a9.04 9.04 0 002.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384"></svg>', !1, !0, !1), CR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.633 10.5c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75A2.25 2.25 0 0116.5 4.5c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23H5.904M14.25 9h2.25M5.904 18.75c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 01-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 10.203 4.167 9.75 5 9.75h1.053c.472 0 .745.556.5.96a8.958 8.958 0 00-1.302 4.665c0 1.194.232 2.333.654 3.375z"></svg>', !1, !0, !1), TR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5l-3.9 19.5m-2.1-19.5l-3.9 19.5"></svg>', !1, !0, !1), AR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"></svg>', !1, !0, !1), OR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205l3 1m1.5.5l-1.5-.5M6.75 7.364V3h-3v18m3-13.636l10.5-3.819"></svg>', !1, !0, !1), PR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"></svg>', !1, !0, !1), IR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z"></svg>', !1, !0, !1), DR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 3.75H6.912a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859M12 3v8.25m0 0l-3-3m3 3l3-3"></svg>', !1, !0, !1), NR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.875 14.25l1.214 1.942a2.25 2.25 0 001.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 011.872 1.002l.164.246a2.25 2.25 0 001.872 1.002h2.092a2.25 2.25 0 001.872-1.002l.164-.246A2.25 2.25 0 0116.954 9h4.636M2.41 9a2.25 2.25 0 00-.16.832V12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 12V9.832c0-.287-.055-.57-.16-.832M2.41 9a2.25 2.25 0 01.382-.632l3.285-3.832a2.25 2.25 0 011.708-.786h8.43c.657 0 1.281.287 1.709.786l3.284 3.832c.163.19.291.404.382.632M4.5 20.25h15A2.25 2.25 0 0021.75 18v-2.625c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125V18a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), MR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H6.911a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661z"></svg>', !1, !0, !1), RR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></svg>', !1, !0, !1), LR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z"></svg>', !1, !0, !1), FR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802"></svg>', !1, !0, !1), jR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.712 4.33a9.027 9.027 0 011.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 00-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 010 9.424m-4.138-5.976a3.736 3.736 0 00-.88-1.388 3.737 3.737 0 00-1.388-.88m2.268 2.268a3.765 3.765 0 010 2.528m-2.268-4.796a3.765 3.765 0 00-2.528 0m4.796 4.796c-.181.506-.475.982-.88 1.388a3.736 3.736 0 01-1.388.88m2.268-2.268l4.138 3.448m0 0a9.027 9.027 0 01-1.306 1.652c-.51.51-1.064.944-1.652 1.306m0 0l-3.448-4.138m3.448 4.138a9.014 9.014 0 01-9.424 0m5.976-4.138a3.765 3.765 0 01-2.528 0m0 0a3.736 3.736 0 01-1.388-.88 3.737 3.737 0 01-.88-1.388m2.268 2.268L7.288 19.67m0 0a9.024 9.024 0 01-1.652-1.306 9.027 9.027 0 01-1.306-1.652m0 0l4.138-3.448M4.33 16.712a9.014 9.014 0 010-9.424m4.138 5.976a3.765 3.765 0 010-2.528m0 0c.181-.506.475-.982.88-1.388a3.736 3.736 0 011.388-.88m-2.268 2.268L4.33 7.288m6.406 1.18L7.288 4.33m0 0a9.024 9.024 0 00-1.652 1.306A9.025 9.025 0 004.33 7.288"></svg>', !1, !0, !1), zR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"></svg>', !1, !0, !1), VR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"></svg>', !1, !0, !1), UR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), qR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), BR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 10.5V6.75a4.5 4.5 0 119 0v3.75M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), HR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 15.75l-2.489-2.489m0 0a3.375 3.375 0 10-4.773-4.773 3.375 3.375 0 004.774 4.774zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), WR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM13.5 10.5h-6"></svg>', !1, !0, !1), KR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM10.5 7.5v6m3-3h-6"></svg>', !1, !0, !1), QR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"></svg>', !1, !0, !1), GR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"></svg>', !1, !0, !1), YR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"></svg>', !1, !0, !1), JR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z"></svg>', !1, !0, !1), ZR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 01-1.44-4.282m3.102.069a18.03 18.03 0 01-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 018.835 2.535M10.34 6.66a23.847 23.847 0 008.835-2.535m0 0A23.74 23.74 0 0018.795 3m.38 1.125a23.91 23.91 0 011.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 001.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 010 3.46"></svg>', !1, !0, !1), XR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z"></svg>', !1, !0, !1), eL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), tL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M18 12H6"></svg>', !1, !0, !1), rL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 12h-15"></svg>', !1, !0, !1), nL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z"></svg>', !1, !0, !1), iL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 9l10.5-3m0 6.553v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 11-.99-3.467l2.31-.66a2.25 2.25 0 001.632-2.163zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 01-.99-3.467l2.31-.66A2.25 2.25 0 009 15.553z"></svg>', !1, !0, !1), aL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z"></svg>', !1, !0, !1), oL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"></svg>', !1, !0, !1), sL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42"></svg>', !1, !0, !1), lL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"></svg>', !1, !0, !1), dL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13"></svg>', !1, !0, !1), cL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 9v6m-4.5 0V9M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), uL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 5.25v13.5m-7.5-13.5v13.5"></svg>', !1, !0, !1), hL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"></svg>', !1, !0, !1), fL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"></svg>', !1, !0, !1), pL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 9.75v-4.5m0 4.5h4.5m-4.5 0l6-6m-3 18c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z"></svg>', !1, !0, !1), mL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 3.75v4.5m0-4.5h-4.5m4.5 0l-6 6m3 12c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z"></svg>', !1, !0, !1), gL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 3.75L18 6m0 0l2.25 2.25M18 6l2.25-2.25M18 6l-2.25 2.25m1.5 13.5c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z"></svg>', !1, !0, !1), vL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"></svg>', !1, !0, !1), yL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), Wb = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), bL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z"></svg>', !1, !0, !1), wL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 7.5V18M15 7.5V18M3 16.811V8.69c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 010 1.954l-7.108 4.061A1.125 1.125 0 013 16.811z"></svg>', !1, !0, !1), $L = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"></svg>', !1, !0, !1), kL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), _L = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6v12m6-6H6"></svg>', !1, !0, !1), xL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 4.5v15m7.5-7.5h-15"></svg>', !1, !0, !1), EL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.636 5.636a9 9 0 1012.728 0M12 3v9"></svg>', !1, !0, !1), SL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6"></svg>', !1, !0, !1), CL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5m.75-9l3-3 2.148 2.148A12.061 12.061 0 0116.5 7.605"></svg>', !1, !0, !1), TL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z"></svg>', !1, !0, !1), AL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 01-.657.643 48.39 48.39 0 01-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 01-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 00-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 01-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 00.657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 01-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 005.427-.63 48.05 48.05 0 00.582-4.717.532.532 0 00-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 00.658-.663 48.422 48.422 0 00-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 01-.61-.58v0z"></svg>', !1, !0, !1), OL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z"></svg>', !1, !0, !1), PL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 6.75h.75v.75h-.75v-.75zM6.75 16.5h.75v.75h-.75v-.75zM16.5 6.75h.75v.75h-.75v-.75zM13.5 13.5h.75v.75h-.75v-.75zM13.5 19.5h.75v.75h-.75v-.75zM19.5 13.5h.75v.75h-.75v-.75zM19.5 19.5h.75v.75h-.75v-.75zM16.5 16.5h.75v.75h-.75v-.75z"></svg>', !1, !0, !1), IL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"></svg>', !1, !0, !1), DL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z"></svg>', !1, !0, !1), NL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 7.5l16.5-4.125M12 6.75c-2.708 0-5.363.224-7.948.655C2.999 7.58 2.25 8.507 2.25 9.574v9.176A2.25 2.25 0 004.5 21h15a2.25 2.25 0 002.25-2.25V9.574c0-1.067-.75-1.994-1.802-2.169A48.329 48.329 0 0012 6.75zm-1.683 6.443l-.005.005-.006-.005.006-.005.005.005zm-.005 2.127l-.005-.006.005-.005.005.005-.005.005zm-2.116-.006l-.005.006-.006-.006.005-.005.006.005zm-.005-2.116l-.006-.005.006-.005.005.005-.005.005zM9.255 10.5v.008h-.008V10.5h.008zm3.249 1.88l-.007.004-.003-.007.006-.003.004.006zm-1.38 5.126l-.003-.006.006-.004.004.007-.006.003zm.007-6.501l-.003.006-.007-.003.004-.007.006.004zm1.37 5.129l-.007-.004.004-.006.006.003-.004.007zm.504-1.877h-.008v-.007h.008v.007zM9.255 18v.008h-.008V18h.008zm-3.246-1.87l-.007.004L6 16.127l.006-.003.004.006zm1.366-5.119l-.004-.006.006-.004.004.007-.006.003zM7.38 17.5l-.003.006-.007-.003.004-.007.006.004zm-1.376-5.116L6 12.38l.003-.007.007.004-.004.007zm-.5 1.873h-.008v-.007h.008v.007zM17.25 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zm0 4.5a.75.75 0 110-1.5.75.75 0 010 1.5z"></svg>', !1, !0, !1), ML = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 14.25l6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185zM9.75 9h.008v.008H9.75V9zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm4.125 4.5h.008v.008h-.008V13.5zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), RL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 9.75h4.875a2.625 2.625 0 010 5.25H12M8.25 9.75L10.5 7.5M8.25 9.75L10.5 12m9-7.243V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185z"></svg>', !1, !0, !1), LL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 01-1.125-1.125v-3.75zM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-8.25zM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-2.25z"></svg>', !1, !0, !1), FL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 6.878V6a2.25 2.25 0 012.25-2.25h7.5A2.25 2.25 0 0118 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 004.5 9v.878m13.5-3A2.25 2.25 0 0119.5 9v.878m0 0a2.246 2.246 0 00-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0121 12v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6c0-.98.626-1.813 1.5-2.122"></svg>', !1, !0, !1), jL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"></svg>', !1, !0, !1), zL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12.75 19.5v-.75a7.5 7.5 0 00-7.5-7.5H4.5m0-6.75h.75c7.87 0 14.25 6.38 14.25 14.25v.75M6 18.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"></svg>', !1, !0, !1), VL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0012 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52l2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 01-2.031.352 5.988 5.988 0 01-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0l2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 01-2.031.352 5.989 5.989 0 01-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971z"></svg>', !1, !0, !1), UL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.848 8.25l1.536.887M7.848 8.25a3 3 0 11-5.196-3 3 3 0 015.196 3zm1.536.887a2.165 2.165 0 011.083 1.839c.005.351.054.695.14 1.024M9.384 9.137l2.077 1.199M7.848 15.75l1.536-.887m-1.536.887a3 3 0 11-5.196 3 3 3 0 015.196-3zm1.536-.887a2.165 2.165 0 001.083-1.838c.005-.352.054-.695.14-1.025m-1.223 2.863l2.077-1.199m0-3.328a4.323 4.323 0 012.068-1.379l5.325-1.628a4.5 4.5 0 012.48-.044l.803.215-7.794 4.5m-2.882-1.664A4.331 4.331 0 0010.607 12m3.736 0l7.794 4.5-.802.215a4.5 4.5 0 01-2.48-.043l-5.326-1.629a4.324 4.324 0 01-2.068-1.379M14.343 12l-2.882 1.664"></svg>', !1, !0, !1), qL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a4.5 4.5 0 01.9-2.7L5.737 5.1a3.375 3.375 0 012.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 01.9 2.7m0 0a3 3 0 01-3 3m0 3h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008zm-3 6h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), BL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.75 17.25v-.228a4.5 4.5 0 00-.12-1.03l-2.268-9.64a3.375 3.375 0 00-3.285-2.602H7.923a3.375 3.375 0 00-3.285 2.602l-2.268 9.64a4.5 4.5 0 00-.12 1.03v.228m19.5 0a3 3 0 01-3 3H5.25a3 3 0 01-3-3m19.5 0a3 3 0 00-3-3H5.25a3 3 0 00-3 3m16.5 0h.008v.008h-.008v-.008zm-3 0h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), HL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"></svg>', !1, !0, !1), WL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"></svg>', !1, !0, !1), KL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9v3.75m0-10.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.249-8.25-3.286zm0 13.036h.008v.008H12v-.008z"></svg>', !1, !0, !1), QL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), GL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"></svg>', !1, !0, !1), YL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 3l8.735 8.735m0 0a.374.374 0 11.53.53m-.53-.53l.53.53m0 0L21 21M14.652 9.348a3.75 3.75 0 010 5.304m2.121-7.425a6.75 6.75 0 010 9.546m2.121-11.667c3.808 3.807 3.808 9.98 0 13.788m-9.546-4.242a3.733 3.733 0 01-1.06-2.122m-1.061 4.243a6.75 6.75 0 01-1.625-6.929m-.496 9.05c-3.068-3.067-3.664-7.67-1.79-11.334M12 12h.008v.008H12V12z"></svg>', !1, !0, !1), JL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.348 14.651a3.75 3.75 0 010-5.303m5.304 0a3.75 3.75 0 010 5.303m-7.425 2.122a6.75 6.75 0 010-9.546m9.546 0a6.75 6.75 0 010 9.546M5.106 18.894c-3.808-3.808-3.808-9.98 0-13.789m13.788 0c3.808 3.808 3.808 9.981 0 13.79M12 12h.008v.007H12V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), ZL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"></svg>', !1, !0, !1), XL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.114 5.636a9 9 0 010 12.728M16.463 8.288a5.25 5.25 0 010 7.424M6.75 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75z"></svg>', !1, !0, !1), eF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.25 9.75L19.5 12m0 0l2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6l4.72-4.72a.75.75 0 011.28.531V19.94a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.506-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.395C2.806 8.757 3.63 8.25 4.51 8.25H6.75z"></svg>', !1, !0, !1), tF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 8.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v8.25A2.25 2.25 0 006 16.5h2.25m8.25-8.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-7.5A2.25 2.25 0 018.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 00-2.25 2.25v6"></svg>', !1, !0, !1), rF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.429 9.75L2.25 12l4.179 2.25m0-4.5l5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0l4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0l-5.571 3-5.571-3"></svg>', !1, !0, !1), nF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"></svg>', !1, !0, !1), iF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v2.25A2.25 2.25 0 006 10.5zm0 9.75h2.25A2.25 2.25 0 0010.5 18v-2.25a2.25 2.25 0 00-2.25-2.25H6a2.25 2.25 0 00-2.25 2.25V18A2.25 2.25 0 006 20.25zm9.75-9.75H18a2.25 2.25 0 002.25-2.25V6A2.25 2.25 0 0018 3.75h-2.25A2.25 2.25 0 0013.5 6v2.25a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), aF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"></svg>', !1, !0, !1), oF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 9.563C9 9.252 9.252 9 9.563 9h4.874c.311 0 .563.252.563.563v4.874c0 .311-.252.563-.563.563H9.564A.562.562 0 019 14.437V9.564z"></svg>', !1, !0, !1), sF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.25 7.5A2.25 2.25 0 017.5 5.25h9a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-9a2.25 2.25 0 01-2.25-2.25v-9z"></svg>', !1, !0, !1), lF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"></svg>', !1, !0, !1), dF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.098 19.902a3.75 3.75 0 005.304 0l6.401-6.402M6.75 21A3.75 3.75 0 013 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 003.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008z"></svg>', !1, !0, !1), cF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0112 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5"></svg>', !1, !0, !1), uF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z"></svg>', !1, !0, !1), hF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 6h.008v.008H6V6z"></svg>', !1, !0, !1), fF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"></svg>', !1, !0, !1), pF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"></svg>', !1, !0, !1), mF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0"></svg>', !1, !0, !1), gF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"></svg>', !1, !0, !1), vF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 20.25h12m-7.5-3v3m3-3v3m-10.125-3h17.25c.621 0 1.125-.504 1.125-1.125V4.875c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), yF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"></svg>', !1, !0, !1), bF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"></svg>', !1, !0, !1), wF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M22 10.5h-6m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"></svg>', !1, !0, !1), $F = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"></svg>', !1, !0, !1), kF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"></svg>', !1, !0, !1), _F = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"></svg>', !1, !0, !1), xF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.745 3A23.933 23.933 0 003 12c0 3.183.62 6.22 1.745 9M19.5 3c.967 2.78 1.5 5.817 1.5 9s-.533 6.22-1.5 9M8.25 8.885l1.444-.89a.75.75 0 011.105.402l2.402 7.206a.75.75 0 001.104.401l1.445-.889m-8.25.75l.213.09a1.687 1.687 0 002.062-.617l4.45-6.676a1.688 1.688 0 012.062-.618l.213.09"></svg>', !1, !0, !1), EF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M12 18.75H4.5a2.25 2.25 0 01-2.25-2.25V9m12.841 9.091L16.5 19.5m-1.409-1.409c.407-.407.659-.97.659-1.591v-9a2.25 2.25 0 00-2.25-2.25h-9c-.621 0-1.184.252-1.591.659m12.182 12.182L2.909 5.909M1.5 4.5l1.409 1.409"></svg>', !1, !0, !1), SF = /* @__PURE__ */ k('<svg><path stroke-linecap=round d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), CF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), TF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 3.75H6A2.25 2.25 0 003.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0120.25 6v1.5m0 9V18A2.25 2.25 0 0118 20.25h-1.5m-9 0H6A2.25 2.25 0 013.75 18v-1.5M15 12a3 3 0 11-6 0 3 3 0 016 0z"></svg>', !1, !0, !1), AF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 12a2.25 2.25 0 00-2.25-2.25H15a3 3 0 11-6 0H5.25A2.25 2.25 0 003 12m18 0v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 9m18 0V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v3"></svg>', !1, !0, !1), OF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.288 15.038a5.25 5.25 0 017.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 011.06 0z"></svg>', !1, !0, !1), PF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 8.25V18a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 18V8.25m-18 0V6a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6zM7.5 6h.008v.008H7.5V6zm2.25 0h.008v.008H9.75V6z"></svg>', !1, !0, !1), IF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), DF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.75 6.75a4.5 4.5 0 01-4.884 4.484c-1.076-.091-2.264.071-2.95.904l-7.152 8.684a2.548 2.548 0 11-3.586-3.586l8.684-7.152c.833-.686.995-1.874.904-2.95a4.5 4.5 0 016.336-4.486l-3.276 3.276a3.004 3.004 0 002.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852z"></svg>', !1, !0, !1), NF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.867 19.125h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), MF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), RF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 18L18 6M6 6l12 12"></svg>', !1, !0, !1);
const LF = {
  path: () => lD(),
  outline: !0,
  mini: !1
}, FF = {
  path: () => dD(),
  outline: !0,
  mini: !1
}, jF = {
  path: () => cD(),
  outline: !0,
  mini: !1
}, zF = {
  path: () => uD(),
  outline: !0,
  mini: !1
}, VF = {
  path: () => hD(),
  outline: !0,
  mini: !1
}, UF = {
  path: () => fD(),
  outline: !0,
  mini: !1
}, qF = {
  path: () => pD(),
  outline: !0,
  mini: !1
}, BF = {
  path: () => mD(),
  outline: !0,
  mini: !1
}, HF = {
  path: () => gD(),
  outline: !0,
  mini: !1
}, WF = {
  path: () => vD(),
  outline: !0,
  mini: !1
}, KF = {
  path: () => yD(),
  outline: !0,
  mini: !1
}, QF = {
  path: () => bD(),
  outline: !0,
  mini: !1
}, GF = {
  path: () => wD(),
  outline: !0,
  mini: !1
}, YF = {
  path: () => $D(),
  outline: !0,
  mini: !1
}, JF = {
  path: () => kD(),
  outline: !0,
  mini: !1
}, ZF = {
  path: () => _D(),
  outline: !0,
  mini: !1
}, XF = {
  path: () => xD(),
  outline: !0,
  mini: !1
}, ej = {
  path: () => ED(),
  outline: !0,
  mini: !1
}, tj = {
  path: () => SD(),
  outline: !0,
  mini: !1
}, rj = {
  path: () => CD(),
  outline: !0,
  mini: !1
}, nj = {
  path: () => TD(),
  outline: !0,
  mini: !1
}, ij = {
  path: () => AD(),
  outline: !0,
  mini: !1
}, aj = {
  path: () => OD(),
  outline: !0,
  mini: !1
}, oj = {
  path: () => PD(),
  outline: !0,
  mini: !1
}, sj = {
  path: () => ID(),
  outline: !0,
  mini: !1
}, lj = {
  path: () => DD(),
  outline: !0,
  mini: !1
}, dj = {
  path: () => ND(),
  outline: !0,
  mini: !1
}, cj = {
  path: () => MD(),
  outline: !0,
  mini: !1
}, uj = {
  path: () => RD(),
  outline: !0,
  mini: !1
}, hj = {
  path: () => LD(),
  outline: !0,
  mini: !1
}, fj = {
  path: () => FD(),
  outline: !0,
  mini: !1
}, pj = {
  path: () => jD(),
  outline: !0,
  mini: !1
}, mj = {
  path: () => zD(),
  outline: !0,
  mini: !1
}, gj = {
  path: () => VD(),
  outline: !0,
  mini: !1
}, vj = {
  path: () => UD(),
  outline: !0,
  mini: !1
}, yj = {
  path: () => qD(),
  outline: !0,
  mini: !1
}, bj = {
  path: () => BD(),
  outline: !0,
  mini: !1
}, wj = {
  path: () => HD(),
  outline: !0,
  mini: !1
}, $j = {
  path: () => WD(),
  outline: !0,
  mini: !1
}, kj = {
  path: () => KD(),
  outline: !0,
  mini: !1
}, _j = {
  path: () => QD(),
  outline: !0,
  mini: !1
}, xj = {
  path: () => GD(),
  outline: !0,
  mini: !1
}, Ej = {
  path: () => YD(),
  outline: !0,
  mini: !1
}, Sj = {
  path: () => JD(),
  outline: !0,
  mini: !1
}, Cj = {
  path: () => ZD(),
  outline: !0,
  mini: !1
}, Tj = {
  path: () => XD(),
  outline: !0,
  mini: !1
}, Aj = {
  path: () => eN(),
  outline: !0,
  mini: !1
}, Oj = {
  path: () => tN(),
  outline: !0,
  mini: !1
}, Pj = {
  path: () => rN(),
  outline: !0,
  mini: !1
}, Ij = {
  path: () => nN(),
  outline: !0,
  mini: !1
}, Dj = {
  path: () => iN(),
  outline: !0,
  mini: !1
}, Nj = {
  path: () => aN(),
  outline: !0,
  mini: !1
}, Mj = {
  path: () => oN(),
  outline: !0,
  mini: !1
}, Rj = {
  path: () => sN(),
  outline: !0,
  mini: !1
}, Lj = {
  path: () => lN(),
  outline: !0,
  mini: !1
}, Fj = {
  path: () => dN(),
  outline: !0,
  mini: !1
}, jj = {
  path: () => cN(),
  outline: !0,
  mini: !1
}, zj = {
  path: () => uN(),
  outline: !0,
  mini: !1
}, Vj = {
  path: () => hN(),
  outline: !0,
  mini: !1
}, Uj = {
  path: () => fN(),
  outline: !0,
  mini: !1
}, qj = {
  path: () => pN(),
  outline: !0,
  mini: !1
}, Bj = {
  path: () => mN(),
  outline: !0,
  mini: !1
}, Hj = {
  path: () => gN(),
  outline: !0,
  mini: !1
}, Wj = {
  path: () => vN(),
  outline: !0,
  mini: !1
}, Kj = {
  path: () => yN(),
  outline: !0,
  mini: !1
}, Qj = {
  path: () => bN(),
  outline: !0,
  mini: !1
}, Gj = {
  path: () => wN(),
  outline: !0,
  mini: !1
}, Yj = {
  path: () => $N(),
  outline: !0,
  mini: !1
}, Jj = {
  path: () => kN(),
  outline: !0,
  mini: !1
}, Zj = {
  path: () => _N(),
  outline: !0,
  mini: !1
}, Xj = {
  path: () => xN(),
  outline: !0,
  mini: !1
}, ez = {
  path: () => EN(),
  outline: !0,
  mini: !1
}, tz = {
  path: () => SN(),
  outline: !0,
  mini: !1
}, rz = {
  path: () => CN(),
  outline: !0,
  mini: !1
}, nz = {
  path: () => TN(),
  outline: !0,
  mini: !1
}, iz = {
  path: () => AN(),
  outline: !0,
  mini: !1
}, az = {
  path: () => ON(),
  outline: !0,
  mini: !1
}, oz = {
  path: () => PN(),
  outline: !0,
  mini: !1
}, sz = {
  path: () => IN(),
  outline: !0,
  mini: !1
}, lz = {
  path: () => DN(),
  outline: !0,
  mini: !1
}, dz = {
  path: () => NN(),
  outline: !0,
  mini: !1
}, cz = {
  path: () => MN(),
  outline: !0,
  mini: !1
}, uz = {
  path: () => RN(),
  outline: !0,
  mini: !1
}, hz = {
  path: () => [LN(), FN()],
  outline: !0,
  mini: !1
}, fz = {
  path: () => jN(),
  outline: !0,
  mini: !1
}, pz = {
  path: () => zN(),
  outline: !0,
  mini: !1
}, mz = {
  path: () => [VN(), UN()],
  outline: !0,
  mini: !1
}, gz = {
  path: () => qN(),
  outline: !0,
  mini: !1
}, vz = {
  path: () => BN(),
  outline: !0,
  mini: !1
}, yz = {
  path: () => HN(),
  outline: !0,
  mini: !1
}, bz = {
  path: () => WN(),
  outline: !0,
  mini: !1
}, wz = {
  path: () => KN(),
  outline: !0,
  mini: !1
}, $z = {
  path: () => QN(),
  outline: !0,
  mini: !1
}, kz = {
  path: () => GN(),
  outline: !0,
  mini: !1
}, _z = {
  path: () => YN(),
  outline: !0,
  mini: !1
}, xz = {
  path: () => JN(),
  outline: !0,
  mini: !1
}, Ez = {
  path: () => ZN(),
  outline: !0,
  mini: !1
}, Sz = {
  path: () => XN(),
  outline: !0,
  mini: !1
}, Cz = {
  path: () => eM(),
  outline: !0,
  mini: !1
}, Tz = {
  path: () => tM(),
  outline: !0,
  mini: !1
}, Az = {
  path: () => rM(),
  outline: !0,
  mini: !1
}, Oz = {
  path: () => nM(),
  outline: !0,
  mini: !1
}, Pz = {
  path: () => iM(),
  outline: !0,
  mini: !1
}, Iz = {
  path: () => aM(),
  outline: !0,
  mini: !1
}, Dz = {
  path: () => oM(),
  outline: !0,
  mini: !1
}, Nz = {
  path: () => sM(),
  outline: !0,
  mini: !1
}, Mz = {
  path: () => lM(),
  outline: !0,
  mini: !1
}, Rz = {
  path: () => dM(),
  outline: !0,
  mini: !1
}, Lz = {
  path: () => cM(),
  outline: !0,
  mini: !1
}, Fz = {
  path: () => uM(),
  outline: !0,
  mini: !1
}, jz = {
  path: () => hM(),
  outline: !0,
  mini: !1
}, zz = {
  path: () => fM(),
  outline: !0,
  mini: !1
}, Vz = {
  path: () => pM(),
  outline: !0,
  mini: !1
}, Uz = {
  path: () => mM(),
  outline: !0,
  mini: !1
}, qz = {
  path: () => gM(),
  outline: !0,
  mini: !1
}, Bz = {
  path: () => vM(),
  outline: !0,
  mini: !1
}, Hz = {
  path: () => yM(),
  outline: !0,
  mini: !1
}, Wz = {
  path: () => [bM(), Rm()],
  outline: !0,
  mini: !1
}, Kz = {
  path: () => [wM(), Rm()],
  outline: !0,
  mini: !1
}, Qz = {
  path: () => $M(),
  outline: !0,
  mini: !1
}, Gz = {
  path: () => kM(),
  outline: !0,
  mini: !1
}, Yz = {
  path: () => _M(),
  outline: !0,
  mini: !1
}, Jz = {
  path: () => xM(),
  outline: !0,
  mini: !1
}, Zz = {
  path: () => EM(),
  outline: !0,
  mini: !1
}, Xz = {
  path: () => SM(),
  outline: !0,
  mini: !1
}, eV = {
  path: () => CM(),
  outline: !0,
  mini: !1
}, tV = {
  path: () => TM(),
  outline: !0,
  mini: !1
}, rV = {
  path: () => AM(),
  outline: !0,
  mini: !1
}, nV = {
  path: () => OM(),
  outline: !0,
  mini: !1
}, iV = {
  path: () => PM(),
  outline: !0,
  mini: !1
}, aV = {
  path: () => IM(),
  outline: !0,
  mini: !1
}, oV = {
  path: () => DM(),
  outline: !0,
  mini: !1
}, sV = {
  path: () => NM(),
  outline: !0,
  mini: !1
}, lV = {
  path: () => MM(),
  outline: !0,
  mini: !1
}, dV = {
  path: () => RM(),
  outline: !0,
  mini: !1
}, cV = {
  path: () => LM(),
  outline: !0,
  mini: !1
}, uV = {
  path: () => FM(),
  outline: !0,
  mini: !1
}, hV = {
  path: () => jM(),
  outline: !0,
  mini: !1
}, fV = {
  path: () => zM(),
  outline: !0,
  mini: !1
}, pV = {
  path: () => VM(),
  outline: !0,
  mini: !1
}, mV = {
  path: () => UM(),
  outline: !0,
  mini: !1
}, gV = {
  path: () => qM(),
  outline: !0,
  mini: !1
}, vV = {
  path: () => BM(),
  outline: !0,
  mini: !1
}, yV = {
  path: () => HM(),
  outline: !0,
  mini: !1
}, bV = {
  path: () => WM(),
  outline: !0,
  mini: !1
}, wV = {
  path: () => KM(),
  outline: !0,
  mini: !1
}, $V = {
  path: () => QM(),
  outline: !0,
  mini: !1
}, kV = {
  path: () => GM(),
  outline: !0,
  mini: !1
}, _V = {
  path: () => YM(),
  outline: !0,
  mini: !1
}, xV = {
  path: () => JM(),
  outline: !0,
  mini: !1
}, EV = {
  path: () => ZM(),
  outline: !0,
  mini: !1
}, SV = {
  path: () => XM(),
  outline: !0,
  mini: !1
}, CV = {
  path: () => eR(),
  outline: !0,
  mini: !1
}, TV = {
  path: () => tR(),
  outline: !0,
  mini: !1
}, AV = {
  path: () => rR(),
  outline: !0,
  mini: !1
}, OV = {
  path: () => [nR(), Rm()],
  outline: !0,
  mini: !1
}, PV = {
  path: () => iR(),
  outline: !0,
  mini: !1
}, IV = {
  path: () => aR(),
  outline: !0,
  mini: !1
}, DV = {
  path: () => oR(),
  outline: !0,
  mini: !1
}, NV = {
  path: () => sR(),
  outline: !0,
  mini: !1
}, MV = {
  path: () => [lR(), dR()],
  outline: !0,
  mini: !1
}, RV = {
  path: () => cR(),
  outline: !0,
  mini: !1
}, LV = {
  path: () => uR(),
  outline: !0,
  mini: !1
}, FV = {
  path: () => hR(),
  outline: !0,
  mini: !1
}, jV = {
  path: () => fR(),
  outline: !0,
  mini: !1
}, zV = {
  path: () => pR(),
  outline: !0,
  mini: !1
}, VV = {
  path: () => mR(),
  outline: !0,
  mini: !1
}, UV = {
  path: () => gR(),
  outline: !0,
  mini: !1
}, qV = {
  path: () => vR(),
  outline: !0,
  mini: !1
}, BV = {
  path: () => yR(),
  outline: !0,
  mini: !1
}, HV = {
  path: () => bR(),
  outline: !0,
  mini: !1
}, WV = {
  path: () => wR(),
  outline: !0,
  mini: !1
}, KV = {
  path: () => $R(),
  outline: !0,
  mini: !1
}, QV = {
  path: () => kR(),
  outline: !0,
  mini: !1
}, GV = {
  path: () => _R(),
  outline: !0,
  mini: !1
}, YV = {
  path: () => xR(),
  outline: !0,
  mini: !1
}, JV = {
  path: () => ER(),
  outline: !0,
  mini: !1
}, ZV = {
  path: () => SR(),
  outline: !0,
  mini: !1
}, XV = {
  path: () => CR(),
  outline: !0,
  mini: !1
}, eU = {
  path: () => TR(),
  outline: !0,
  mini: !1
}, tU = {
  path: () => AR(),
  outline: !0,
  mini: !1
}, rU = {
  path: () => OR(),
  outline: !0,
  mini: !1
}, nU = {
  path: () => PR(),
  outline: !0,
  mini: !1
}, iU = {
  path: () => IR(),
  outline: !0,
  mini: !1
}, aU = {
  path: () => DR(),
  outline: !0,
  mini: !1
}, oU = {
  path: () => NR(),
  outline: !0,
  mini: !1
}, sU = {
  path: () => MR(),
  outline: !0,
  mini: !1
}, lU = {
  path: () => RR(),
  outline: !0,
  mini: !1
}, dU = {
  path: () => LR(),
  outline: !0,
  mini: !1
}, cU = {
  path: () => FR(),
  outline: !0,
  mini: !1
}, uU = {
  path: () => jR(),
  outline: !0,
  mini: !1
}, hU = {
  path: () => zR(),
  outline: !0,
  mini: !1
}, fU = {
  path: () => VR(),
  outline: !0,
  mini: !1
}, pU = {
  path: () => UR(),
  outline: !0,
  mini: !1
}, mU = {
  path: () => qR(),
  outline: !0,
  mini: !1
}, gU = {
  path: () => BR(),
  outline: !0,
  mini: !1
}, vU = {
  path: () => HR(),
  outline: !0,
  mini: !1
}, yU = {
  path: () => WR(),
  outline: !0,
  mini: !1
}, bU = {
  path: () => KR(),
  outline: !0,
  mini: !1
}, wU = {
  path: () => QR(),
  outline: !0,
  mini: !1
}, $U = {
  path: () => [GR(), YR()],
  outline: !0,
  mini: !1
}, kU = {
  path: () => JR(),
  outline: !0,
  mini: !1
}, _U = {
  path: () => ZR(),
  outline: !0,
  mini: !1
}, xU = {
  path: () => XR(),
  outline: !0,
  mini: !1
}, EU = {
  path: () => eL(),
  outline: !0,
  mini: !1
}, SU = {
  path: () => tL(),
  outline: !0,
  mini: !1
}, CU = {
  path: () => rL(),
  outline: !0,
  mini: !1
}, TU = {
  path: () => nL(),
  outline: !0,
  mini: !1
}, AU = {
  path: () => iL(),
  outline: !0,
  mini: !1
}, OU = {
  path: () => aL(),
  outline: !0,
  mini: !1
}, PU = {
  path: () => oL(),
  outline: !0,
  mini: !1
}, IU = {
  path: () => sL(),
  outline: !0,
  mini: !1
}, DU = {
  path: () => lL(),
  outline: !0,
  mini: !1
}, NU = {
  path: () => dL(),
  outline: !0,
  mini: !1
}, MU = {
  path: () => cL(),
  outline: !0,
  mini: !1
}, RU = {
  path: () => uL(),
  outline: !0,
  mini: !1
}, LU = {
  path: () => hL(),
  outline: !0,
  mini: !1
}, FU = {
  path: () => fL(),
  outline: !0,
  mini: !1
}, jU = {
  path: () => pL(),
  outline: !0,
  mini: !1
}, zU = {
  path: () => mL(),
  outline: !0,
  mini: !1
}, VU = {
  path: () => gL(),
  outline: !0,
  mini: !1
}, UU = {
  path: () => vL(),
  outline: !0,
  mini: !1
}, qU = {
  path: () => yL(),
  outline: !0,
  mini: !1
}, BU = {
  path: () => [Wb(), bL()],
  outline: !0,
  mini: !1
}, HU = {
  path: () => wL(),
  outline: !0,
  mini: !1
}, WU = {
  path: () => $L(),
  outline: !0,
  mini: !1
}, KU = {
  path: () => kL(),
  outline: !0,
  mini: !1
}, QU = {
  path: () => _L(),
  outline: !0,
  mini: !1
}, GU = {
  path: () => xL(),
  outline: !0,
  mini: !1
}, YU = {
  path: () => EL(),
  outline: !0,
  mini: !1
}, JU = {
  path: () => SL(),
  outline: !0,
  mini: !1
}, ZU = {
  path: () => CL(),
  outline: !0,
  mini: !1
}, XU = {
  path: () => TL(),
  outline: !0,
  mini: !1
}, eq = {
  path: () => AL(),
  outline: !0,
  mini: !1
}, tq = {
  path: () => [OL(), PL()],
  outline: !0,
  mini: !1
}, rq = {
  path: () => IL(),
  outline: !0,
  mini: !1
}, nq = {
  path: () => DL(),
  outline: !0,
  mini: !1
}, iq = {
  path: () => NL(),
  outline: !0,
  mini: !1
}, aq = {
  path: () => ML(),
  outline: !0,
  mini: !1
}, oq = {
  path: () => RL(),
  outline: !0,
  mini: !1
}, sq = {
  path: () => LL(),
  outline: !0,
  mini: !1
}, lq = {
  path: () => FL(),
  outline: !0,
  mini: !1
}, dq = {
  path: () => jL(),
  outline: !0,
  mini: !1
}, cq = {
  path: () => zL(),
  outline: !0,
  mini: !1
}, uq = {
  path: () => VL(),
  outline: !0,
  mini: !1
}, hq = {
  path: () => UL(),
  outline: !0,
  mini: !1
}, fq = {
  path: () => qL(),
  outline: !0,
  mini: !1
}, pq = {
  path: () => BL(),
  outline: !0,
  mini: !1
}, mq = {
  path: () => HL(),
  outline: !0,
  mini: !1
}, gq = {
  path: () => WL(),
  outline: !0,
  mini: !1
}, vq = {
  path: () => KL(),
  outline: !0,
  mini: !1
}, yq = {
  path: () => QL(),
  outline: !0,
  mini: !1
}, bq = {
  path: () => GL(),
  outline: !0,
  mini: !1
}, wq = {
  path: () => YL(),
  outline: !0,
  mini: !1
}, $q = {
  path: () => JL(),
  outline: !0,
  mini: !1
}, kq = {
  path: () => ZL(),
  outline: !0,
  mini: !1
}, _q = {
  path: () => XL(),
  outline: !0,
  mini: !1
}, xq = {
  path: () => eF(),
  outline: !0,
  mini: !1
}, Eq = {
  path: () => tF(),
  outline: !0,
  mini: !1
}, Sq = {
  path: () => rF(),
  outline: !0,
  mini: !1
}, Cq = {
  path: () => nF(),
  outline: !0,
  mini: !1
}, Tq = {
  path: () => iF(),
  outline: !0,
  mini: !1
}, Aq = {
  path: () => aF(),
  outline: !0,
  mini: !1
}, Oq = {
  path: () => [Wb(), oF()],
  outline: !0,
  mini: !1
}, Pq = {
  path: () => sF(),
  outline: !0,
  mini: !1
}, Iq = {
  path: () => lF(),
  outline: !0,
  mini: !1
}, Dq = {
  path: () => dF(),
  outline: !0,
  mini: !1
}, Nq = {
  path: () => cF(),
  outline: !0,
  mini: !1
}, Mq = {
  path: () => [uF(), hF()],
  outline: !0,
  mini: !1
}, Rq = {
  path: () => fF(),
  outline: !0,
  mini: !1
}, Lq = {
  path: () => pF(),
  outline: !0,
  mini: !1
}, Fq = {
  path: () => mF(),
  outline: !0,
  mini: !1
}, jq = {
  path: () => gF(),
  outline: !0,
  mini: !1
}, zq = {
  path: () => vF(),
  outline: !0,
  mini: !1
}, Vq = {
  path: () => yF(),
  outline: !0,
  mini: !1
}, Uq = {
  path: () => bF(),
  outline: !0,
  mini: !1
}, qq = {
  path: () => wF(),
  outline: !0,
  mini: !1
}, Bq = {
  path: () => $F(),
  outline: !0,
  mini: !1
}, Hq = {
  path: () => kF(),
  outline: !0,
  mini: !1
}, Wq = {
  path: () => _F(),
  outline: !0,
  mini: !1
}, Kq = {
  path: () => xF(),
  outline: !0,
  mini: !1
}, Qq = {
  path: () => EF(),
  outline: !0,
  mini: !1
}, Gq = {
  path: () => SF(),
  outline: !0,
  mini: !1
}, Yq = {
  path: () => CF(),
  outline: !0,
  mini: !1
}, Jq = {
  path: () => TF(),
  outline: !0,
  mini: !1
}, Zq = {
  path: () => AF(),
  outline: !0,
  mini: !1
}, Xq = {
  path: () => OF(),
  outline: !0,
  mini: !1
}, eB = {
  path: () => PF(),
  outline: !0,
  mini: !1
}, tB = {
  path: () => IF(),
  outline: !0,
  mini: !1
}, rB = {
  path: () => [DF(), NF()],
  outline: !0,
  mini: !1
}, nB = {
  path: () => MF(),
  outline: !0,
  mini: !1
}, iB = {
  path: () => RF(),
  outline: !0,
  mini: !1
}, aB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  academicCap: LF,
  adjustmentsHorizontal: FF,
  adjustmentsVertical: jF,
  archiveBox: UF,
  archiveBoxArrowDown: zF,
  archiveBoxXMark: VF,
  arrowDown: GF,
  arrowDownCircle: qF,
  arrowDownLeft: BF,
  arrowDownOnSquare: WF,
  arrowDownOnSquareStack: HF,
  arrowDownRight: KF,
  arrowDownTray: QF,
  arrowLeft: ZF,
  arrowLeftCircle: YF,
  arrowLeftOnRectangle: JF,
  arrowLongDown: XF,
  arrowLongLeft: ej,
  arrowLongRight: tj,
  arrowLongUp: rj,
  arrowPath: ij,
  arrowPathRoundedSquare: nj,
  arrowRight: sj,
  arrowRightCircle: aj,
  arrowRightOnRectangle: oj,
  arrowSmallDown: lj,
  arrowSmallLeft: dj,
  arrowSmallRight: cj,
  arrowSmallUp: uj,
  arrowTopRightOnSquare: hj,
  arrowTrendingDown: fj,
  arrowTrendingUp: pj,
  arrowUp: $j,
  arrowUpCircle: mj,
  arrowUpLeft: gj,
  arrowUpOnSquare: yj,
  arrowUpOnSquareStack: vj,
  arrowUpRight: bj,
  arrowUpTray: wj,
  arrowUturnDown: kj,
  arrowUturnLeft: _j,
  arrowUturnRight: xj,
  arrowUturnUp: Ej,
  arrowsPointingIn: Sj,
  arrowsPointingOut: Cj,
  arrowsRightLeft: Tj,
  arrowsUpDown: Aj,
  atSymbol: Oj,
  backspace: Pj,
  backward: Ij,
  banknotes: Dj,
  barsArrowDown: zj,
  barsArrowUp: Vj,
  bars_2: Nj,
  bars_3: Fj,
  bars_3BottomLeft: Mj,
  bars_3BottomRight: Rj,
  bars_3CenterLeft: Lj,
  bars_4: jj,
  battery_0: Uj,
  battery_100: qj,
  battery_50: Bj,
  beaker: Hj,
  bell: Gj,
  bellAlert: Wj,
  bellSlash: Kj,
  bellSnooze: Qj,
  bolt: Jj,
  boltSlash: Yj,
  bookOpen: Zj,
  bookmark: tz,
  bookmarkSlash: Xj,
  bookmarkSquare: ez,
  briefcase: rz,
  bugAnt: nz,
  buildingLibrary: iz,
  buildingOffice: oz,
  buildingOffice_2: az,
  buildingStorefront: sz,
  cake: lz,
  calculator: dz,
  calendar: uz,
  calendarDays: cz,
  camera: hz,
  chartBar: pz,
  chartBarSquare: fz,
  chartPie: mz,
  chatBubbleBottomCenter: vz,
  chatBubbleBottomCenterText: gz,
  chatBubbleLeft: wz,
  chatBubbleLeftEllipsis: yz,
  chatBubbleLeftRight: bz,
  chatBubbleOvalLeft: kz,
  chatBubbleOvalLeftEllipsis: $z,
  check: Ez,
  checkBadge: _z,
  checkCircle: xz,
  chevronDoubleDown: Sz,
  chevronDoubleLeft: Cz,
  chevronDoubleRight: Tz,
  chevronDoubleUp: Az,
  chevronDown: Oz,
  chevronLeft: Pz,
  chevronRight: Iz,
  chevronUp: Nz,
  chevronUpDown: Dz,
  circleStack: Mz,
  clipboard: jz,
  clipboardDocument: Fz,
  clipboardDocumentCheck: Rz,
  clipboardDocumentList: Lz,
  clock: zz,
  cloud: qz,
  cloudArrowDown: Vz,
  cloudArrowUp: Uz,
  codeBracket: Hz,
  codeBracketSquare: Bz,
  cog: Qz,
  cog_6Tooth: Wz,
  cog_8Tooth: Kz,
  commandLine: Gz,
  computerDesktop: Yz,
  cpuChip: Jz,
  creditCard: Zz,
  cube: eV,
  cubeTransparent: Xz,
  currencyBangladeshi: tV,
  currencyDollar: rV,
  currencyEuro: nV,
  currencyPound: iV,
  currencyRupee: aV,
  currencyYen: oV,
  cursorArrowRays: sV,
  cursorArrowRipple: lV,
  devicePhoneMobile: dV,
  deviceTablet: cV,
  document: wV,
  documentArrowDown: uV,
  documentArrowUp: hV,
  documentChartBar: fV,
  documentCheck: pV,
  documentDuplicate: mV,
  documentMagnifyingGlass: gV,
  documentMinus: vV,
  documentPlus: yV,
  documentText: bV,
  ellipsisHorizontal: kV,
  ellipsisHorizontalCircle: $V,
  ellipsisVertical: _V,
  envelope: EV,
  envelopeOpen: xV,
  exclamationCircle: SV,
  exclamationTriangle: CV,
  eye: OV,
  eyeDropper: TV,
  eyeSlash: AV,
  faceFrown: PV,
  faceSmile: IV,
  film: DV,
  fingerPrint: NV,
  fire: MV,
  flag: RV,
  folder: VV,
  folderArrowDown: LV,
  folderMinus: FV,
  folderOpen: jV,
  folderPlus: zV,
  forward: UV,
  funnel: qV,
  gif: BV,
  gift: WV,
  giftTop: HV,
  globeAlt: KV,
  globeAmericas: QV,
  globeAsiaAustralia: GV,
  globeEuropeAfrica: YV,
  handRaised: JV,
  handThumbDown: ZV,
  handThumbUp: XV,
  hashtag: eU,
  heart: tU,
  home: nU,
  homeModern: rU,
  identification: iU,
  inbox: sU,
  inboxArrowDown: aU,
  inboxStack: oU,
  informationCircle: lU,
  key: dU,
  language: cU,
  lifebuoy: uU,
  lightBulb: hU,
  link: fU,
  listBullet: pU,
  lockClosed: mU,
  lockOpen: gU,
  magnifyingGlass: wU,
  magnifyingGlassCircle: vU,
  magnifyingGlassMinus: yU,
  magnifyingGlassPlus: bU,
  map: kU,
  mapPin: $U,
  megaphone: _U,
  microphone: xU,
  minus: CU,
  minusCircle: EU,
  minusSmall: SU,
  moon: TU,
  musicalNote: AU,
  newspaper: OU,
  noSymbol: PU,
  paintBrush: IU,
  paperAirplane: DU,
  paperClip: NU,
  pause: RU,
  pauseCircle: MU,
  pencil: FU,
  pencilSquare: LU,
  phone: UU,
  phoneArrowDownLeft: jU,
  phoneArrowUpRight: zU,
  phoneXMark: VU,
  photo: qU,
  play: WU,
  playCircle: BU,
  playPause: HU,
  plus: GU,
  plusCircle: KU,
  plusSmall: QU,
  power: YU,
  presentationChartBar: JU,
  presentationChartLine: ZU,
  printer: XU,
  puzzlePiece: eq,
  qrCode: tq,
  questionMarkCircle: rq,
  queueList: nq,
  radio: iq,
  receiptPercent: aq,
  receiptRefund: oq,
  rectangleGroup: sq,
  rectangleStack: lq,
  rocketLaunch: dq,
  rss: cq,
  scale: uq,
  scissors: hq,
  server: pq,
  serverStack: fq,
  share: mq,
  shieldCheck: gq,
  shieldExclamation: vq,
  shoppingBag: yq,
  shoppingCart: bq,
  signal: $q,
  signalSlash: wq,
  sparkles: kq,
  speakerWave: _q,
  speakerXMark: xq,
  square_2Stack: Eq,
  square_3Stack_3d: Sq,
  squaresPlus: Tq,
  squares_2x2: Cq,
  star: Aq,
  stop: Pq,
  stopCircle: Oq,
  sun: Iq,
  swatch: Dq,
  tableCells: Nq,
  tag: Mq,
  ticket: Rq,
  trash: Lq,
  trophy: Fq,
  truck: jq,
  tv: zq,
  user: Hq,
  userCircle: Vq,
  userGroup: Uq,
  userMinus: qq,
  userPlus: Bq,
  users: Wq,
  variable: Kq,
  videoCamera: Gq,
  videoCameraSlash: Qq,
  viewColumns: Yq,
  viewfinderCircle: Jq,
  wallet: Zq,
  wifi: Xq,
  window: eB,
  wrench: rB,
  wrenchScrewdriver: tB,
  xCircle: nB,
  xMark: iB
}, Symbol.toStringTag, { value: "Module" }));
function et(e) {
  const t = Ke({
    size: "md",
    name: "exclamationMark"
  }, e), r = B(() => jt(e.class, {
    "h-4 w-4": t.size === "sm",
    "h-6 w-6": t.size === "md",
    "h-8 w-8": t.size === "lg",
    "h-10 w-10": t.size === "xl"
  }));
  return v(q, {
    get when() {
      return e.name;
    },
    get children() {
      return v(sD, {
        get path() {
          return aB[t.name];
        },
        get class() {
          return r();
        },
        "aria-hidden": "true"
      });
    }
  });
}
const i1 = /* @__PURE__ */ Symbol("store-raw"), el = /* @__PURE__ */ Symbol("store-node"), Wi = /* @__PURE__ */ Symbol("store-has"), Kb = /* @__PURE__ */ Symbol("store-self");
function Qb(e) {
  let t = e[Tr];
  if (!t && (Object.defineProperty(e, Tr, {
    value: t = new Proxy(e, lB)
  }), !Array.isArray(e))) {
    const r = Object.keys(e), n = Object.getOwnPropertyDescriptors(e);
    for (let i = 0, a = r.length; i < a; i++) {
      const o = r[i];
      n[o].get && Object.defineProperty(e, o, {
        enumerable: n[o].enumerable,
        get: n[o].get.bind(t)
      });
    }
  }
  return t;
}
function Mi(e) {
  let t;
  return e != null && typeof e == "object" && (e[Tr] || !(t = Object.getPrototypeOf(e)) || t === Object.prototype || Array.isArray(e));
}
function Yo(e, t = /* @__PURE__ */ new Set()) {
  let r, n, i, a;
  if (r = e != null && e[i1]) return r;
  if (!Mi(e) || t.has(e)) return e;
  if (Array.isArray(e)) {
    Object.isFrozen(e) ? e = e.slice(0) : t.add(e);
    for (let o = 0, s = e.length; o < s; o++)
      i = e[o], (n = Yo(i, t)) !== i && (e[o] = n);
  } else {
    Object.isFrozen(e) ? e = Object.assign({}, e) : t.add(e);
    const o = Object.keys(e), s = Object.getOwnPropertyDescriptors(e);
    for (let l = 0, d = o.length; l < d; l++)
      a = o[l], !s[a].get && (i = e[a], (n = Yo(i, t)) !== i && (e[a] = n));
  }
  return e;
}
function a1(e, t) {
  let r = e[t];
  return r || Object.defineProperty(e, t, {
    value: r = /* @__PURE__ */ Object.create(null)
  }), r;
}
function mc(e, t, r) {
  if (e[t]) return e[t];
  const [n, i] = z(r, {
    equals: !1,
    internal: !0
  });
  return n.$ = i, e[t] = n;
}
function oB(e, t) {
  const r = Reflect.getOwnPropertyDescriptor(e, t);
  return !r || r.get || !r.configurable || t === Tr || t === el || (delete r.value, delete r.writable, r.get = () => e[Tr][t]), r;
}
function Gb(e) {
  sl() && mc(a1(e, el), Kb)();
}
function sB(e) {
  return Gb(e), Reflect.ownKeys(e);
}
const lB = {
  get(e, t, r) {
    if (t === i1) return e;
    if (t === Tr) return r;
    if (t === Zd)
      return Gb(e), r;
    const n = a1(e, el), i = n[t];
    let a = i ? i() : e[t];
    if (t === el || t === Wi || t === "__proto__") return a;
    if (!i) {
      const o = Object.getOwnPropertyDescriptor(e, t);
      sl() && (typeof a != "function" || e.hasOwnProperty(t)) && !(o && o.get) && (a = mc(n, t, a)());
    }
    return Mi(a) ? Qb(a) : a;
  },
  has(e, t) {
    return t === i1 || t === Tr || t === Zd || t === el || t === Wi || t === "__proto__" ? !0 : (sl() && mc(a1(e, Wi), t)(), t in e);
  },
  set() {
    return !0;
  },
  deleteProperty() {
    return !0;
  },
  ownKeys: sB,
  getOwnPropertyDescriptor: oB
};
function an(e, t, r, n = !1) {
  if (!n && e[t] === r) return;
  const i = e[t], a = e.length;
  r === void 0 ? (delete e[t], e[Wi] && e[Wi][t] && i !== void 0 && e[Wi][t].$()) : (e[t] = r, e[Wi] && e[Wi][t] && i === void 0 && e[Wi][t].$());
  let o = a1(e, el), s;
  if ((s = mc(o, t, i)) && s.$(() => r), Array.isArray(e) && e.length !== a) {
    for (let l = e.length; l < a; l++) (s = o[l]) && s.$();
    (s = mc(o, "length", a)) && s.$(e.length);
  }
  (s = o[Kb]) && s.$();
}
function Yb(e, t) {
  const r = Object.keys(t);
  for (let n = 0; n < r.length; n += 1) {
    const i = r[n];
    an(e, i, t[i]);
  }
}
function dB(e, t) {
  if (typeof t == "function" && (t = t(e)), t = Yo(t), Array.isArray(t)) {
    if (e === t) return;
    let r = 0, n = t.length;
    for (; r < n; r++) {
      const i = t[r];
      e[r] !== i && an(e, r, i);
    }
    an(e, "length", n);
  } else Yb(e, t);
}
function Dd(e, t, r = []) {
  let n, i = e;
  if (t.length > 1) {
    n = t.shift();
    const o = typeof n, s = Array.isArray(e);
    if (Array.isArray(n)) {
      for (let l = 0; l < n.length; l++)
        Dd(e, [n[l]].concat(t), r);
      return;
    } else if (s && o === "function") {
      for (let l = 0; l < e.length; l++)
        n(e[l], l) && Dd(e, [l].concat(t), r);
      return;
    } else if (s && o === "object") {
      const {
        from: l = 0,
        to: d = e.length - 1,
        by: c = 1
      } = n;
      for (let u = l; u <= d; u += c)
        Dd(e, [u].concat(t), r);
      return;
    } else if (t.length > 1) {
      Dd(e[n], t, [n].concat(r));
      return;
    }
    i = e[n], r = [n].concat(r);
  }
  let a = t[0];
  typeof a == "function" && (a = a(i, r), a === i) || n === void 0 && a == null || (a = Yo(a), n === void 0 || Mi(i) && Mi(a) && !Array.isArray(a) ? Yb(i, a) : an(e, n, a));
}
function eo(...[e, t]) {
  const r = Yo(e || {}), n = Array.isArray(r), i = Qb(r);
  function a(...o) {
    A0(() => {
      n && o.length === 1 ? dB(r, o[0]) : Dd(r, o);
    });
  }
  return [i, a];
}
const Up = /* @__PURE__ */ Symbol("store-root");
function Ss(e, t, r, n, i) {
  const a = t[r];
  if (e === a) return;
  const o = Array.isArray(e);
  if (r !== Up && (!Mi(e) || !Mi(a) || o !== Array.isArray(a) || i && e[i] !== a[i])) {
    an(t, r, e);
    return;
  }
  if (o) {
    if (e.length && a.length && (!n || i && e[0] && e[0][i] != null)) {
      let d, c, u, h, f, p, m, y;
      for (u = 0, h = Math.min(a.length, e.length); u < h && (a[u] === e[u] || i && a[u] && e[u] && a[u][i] && a[u][i] === e[u][i]); u++)
        Ss(e[u], a, u, n, i);
      const g = new Array(e.length), w = /* @__PURE__ */ new Map();
      for (h = a.length - 1, f = e.length - 1; h >= u && f >= u && (a[h] === e[f] || i && a[h] && e[f] && a[h][i] && a[h][i] === e[f][i]); h--, f--)
        g[f] = a[h];
      if (u > f || u > h) {
        for (c = u; c <= f; c++) an(a, c, e[c]);
        for (; c < e.length; c++)
          an(a, c, g[c]), Ss(e[c], a, c, n, i);
        a.length > e.length && an(a, "length", e.length);
        return;
      }
      for (m = new Array(f + 1), c = f; c >= u; c--)
        p = e[c], y = i && p ? p[i] : p, d = w.get(y), m[c] = d === void 0 ? -1 : d, w.set(y, c);
      for (d = u; d <= h; d++)
        p = a[d], y = i && p ? p[i] : p, c = w.get(y), c !== void 0 && c !== -1 && (g[c] = a[d], c = m[c], w.set(y, c));
      for (c = u; c < e.length; c++)
        c in g ? (an(a, c, g[c]), Ss(e[c], a, c, n, i)) : an(a, c, e[c]);
    } else
      for (let d = 0, c = e.length; d < c; d++)
        Ss(e[d], a, d, n, i);
    a.length > e.length && an(a, "length", e.length);
    return;
  }
  const s = Object.keys(e);
  for (let d = 0, c = s.length; d < c; d++)
    Ss(e[s[d]], a, s[d], n, i);
  const l = Object.keys(a);
  for (let d = 0, c = l.length; d < c; d++)
    e[l[d]] === void 0 && an(a, l[d], void 0);
}
function cB(e, t = {}) {
  const {
    merge: r,
    key: n = "id"
  } = t, i = Yo(e);
  return (a) => {
    if (!Mi(a) || !Mi(i)) return i;
    const o = Ss(i, {
      [Up]: a
    }, Up, r, n);
    return o === void 0 ? a : o;
  };
}
const o1 = /* @__PURE__ */ new WeakMap(), Jb = {
  get(e, t) {
    if (t === i1) return e;
    const r = e[t];
    let n;
    return Mi(r) ? o1.get(r) || (o1.set(r, n = new Proxy(r, Jb)), n) : r;
  },
  set(e, t, r) {
    return an(e, t, Yo(r)), !0;
  },
  deleteProperty(e, t) {
    return an(e, t, void 0, !0), !0;
  }
};
function Ru(e) {
  return (t) => {
    if (Mi(t)) {
      let r;
      (r = o1.get(t)) || o1.set(t, r = new Proxy(t, Jb)), e(r);
    }
    return t;
  };
}
var uB = /* @__PURE__ */ k('<span aria-hidden=true class="text-red-500 ml-0.5">*'), hB = /* @__PURE__ */ k('<span class="text-xs text-gray-400 ml-2">Optional'), fB = /* @__PURE__ */ k("<label>"), pB = /* @__PURE__ */ k('<div class="text-xs leading-6 text-gray-500">'), mB = /* @__PURE__ */ k("<p>"), gB = /* @__PURE__ */ k('<div><div class="flex justify-between items-center"><div></div></div><div class=h-6>');
const Lm = Rr([{
  id: "",
  error: "",
  loading: !1,
  disabled: !1,
  required: !1
}, {
  setError: () => {
  },
  setLoading: () => {
  },
  setDisabled: () => {
  },
  setRequired: () => {
  }
}]);
function vB(e) {
  const [t, r] = eo({
    id: `input-${Pa()}`,
    error: e.error || "",
    loading: !1,
    disabled: !1,
    required: !1
  }), n = [t, {
    setError(i) {
      r("error", i);
    },
    setLoading(i) {
      r("loading", i);
    },
    setDisabled(i) {
      r("disabled", i);
    },
    setRequired(i) {
      r("required", i);
    }
  }];
  return v(Lm.Provider, {
    value: n,
    get children() {
      return e.children;
    }
  });
}
function Kc() {
  return gr(Lm);
}
function yB(e) {
  const [t, {
    setError: r,
    setLoading: n,
    setDisabled: i,
    setRequired: a
  }] = gr(Lm), o = e.error ? `${t.id}-error` : e.helpText ? `${t.id}-help` : void 0;
  le(() => {
    r(e.error || "");
  }), le(() => {
    n(e.loading || !1);
  }), le(() => {
    i(e.disabled || !1);
  }), le(() => {
    a(e.required || !1);
  });
  const s = B(() => typeof e.label == "string");
  return (() => {
    var l = gB(), d = l.firstChild, c = d.firstChild, u = d.nextSibling;
    return C(c, v(q, {
      get when() {
        return s();
      },
      get children() {
        var h = fB();
        return C(h, () => e.label, null), C(h, v(q, {
          get when() {
            return e.required;
          },
          get children() {
            return uB();
          }
        }), null), C(h, v(q, {
          get when() {
            return e.showOptionalSubtext;
          },
          get children() {
            return hB();
          }
        }), null), te((f) => {
          var p = `block text-sm font-normal leading-6 text-gray-700 pb-1 ${e?.subLabel ? "mb-0" : ""}`, m = t.id;
          return p !== f.e && rt(h, f.e = p), m !== f.t && Xe(h, "for", f.t = m), f;
        }, {
          e: void 0,
          t: void 0
        }), h;
      }
    }), null), C(c, v(q, {
      get when() {
        return !s();
      },
      get children() {
        return e.label;
      }
    }), null), C(c, v(q, {
      get when() {
        return e?.subLabel;
      },
      get children() {
        var h = pB();
        return C(h, () => e.subLabel), h;
      }
    }), null), C(l, () => e.children, u), C(u, v(q, {
      get when() {
        return e.error || e.helpText;
      },
      get children() {
        var h = mB();
        return Xe(h, "id", o), C(h, () => e.error || e.helpText), te(() => rt(h, `text-sm ${e.error ? "text-red-400" : "text-gray-500"}`)), h;
      }
    })), l;
  })();
}
function Ye(e) {
  return v(vB, {
    get error() {
      return e.error;
    },
    get children() {
      return v(yB, Ke(e, {
        get children() {
          return e.children;
        }
      }));
    }
  });
}
var bB = /* @__PURE__ */ k('<div role=status><svg aria-hidden=true viewBox="0 0 100 100"fill=none xmlns=http://www.w3.org/2000/svg><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"fill=currentColor></path><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"fill=currentFill></path></svg><span class=sr-only>Loading...');
function Fi(e) {
  const t = Ke({
    size: "lg",
    color: "blue"
  }, e), r = jt("text-gray-200 animate-spin dark:text-gray-600", {
    "fill-blue-500": t.color === "blue",
    "fill-green-500": t.color === "green",
    "w-4 h-4": t.size === "sm",
    "w-6 h-6": t.size === "md",
    "w-8 h-8": t.size === "lg",
    "w-12 h-12": t.size === "xl"
  });
  return (() => {
    var n = bB(), i = n.firstChild;
    return Xe(i, "class", r), n;
  })();
}
var wB = /* @__PURE__ */ k('<div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">'), $B = /* @__PURE__ */ k('<div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-1">'), kB = /* @__PURE__ */ k('<div class="absolute inset-y-0 right-0 flex items-center pr-3"><button aria-label="Drop Down for more options">'), _B = /* @__PURE__ */ k('<div class="relative rounded-lg shadow-sm"><input autocomplete=off>');
function xB(e) {
  return typeof e == "string" ? e : typeof e == "number" ? e.toString() : Array.isArray(e) ? e.join(", ") : "";
}
function Tt(e) {
  const [t, r] = qo(e, ["error", "copy"]), [n, i] = qo(r, ["onInput"]), [a, o] = z(!1), [s] = Kc(), l = B(() => {
    const c = s.disabled || i.disabled, u = t.error || s.error, h = i.readonly || i.readOnly;
    return jt("block w-full rounded-lg border-0 py-3 px-4 ring-1 ring-inset text-sm sm:text-base sm:leading-6 focus:outline-none", {
      "pl-10": i.type === "email",
      "ring-red-300 placeholder:text-red-300 focus:ring-sky-500/40": !!u && !c,
      "text-gray-900 ring-gray-300 placeholder:text-gray-400 hover:ring-gray-400 focus:ring-sky-500/40": !u && !c,
      "focus:ring-2": !h,
      "cursor-not-allowed bg-gray-50 text-gray-500 ring-gray-200": i.disabled,
      "focus:ring-1 focus:ring-1  focus:outline-0 focus:ring-gray-300 bg-gray-50 text-gray-500 ring-gray-200": h,
      "cursor-pointer": e.pointer
    });
  }), d = (c) => {
    const u = c.currentTarget;
    !isNaN(u.valueAsNumber) && typeof n.onInput == "function" && n.onInput(c);
  };
  return le(() => {
    a() && setTimeout(() => {
      o(!1);
    }, 1e3);
  }), (() => {
    var c = _B(), u = c.firstChild;
    return C(c, v(q, {
      get when() {
        return i.type === "email";
      },
      get children() {
        var h = wB();
        return C(h, v(et, {
          name: "envelope",
          class: "h-5 w-5 text-gray-400",
          size: "sm"
        })), h;
      }
    }), u), Ln(u, Ke({
      get id() {
        return s?.id;
      },
      get "aria-invalid"() {
        return !!(t.error || s.error) || void 0;
      },
      get "aria-describedby"() {
        return t.error || s.error ? `${s.id}-error` : void 0;
      },
      get onInput() {
        return i.type === "number" ? d : n.onInput;
      }
    }, i, {
      get required() {
        return s.required || i.required;
      },
      get class() {
        return l();
      }
    }), !1, !1), C(c, v(q, {
      get when() {
        return s.loading || i.loading;
      },
      get children() {
        var h = $B();
        return C(h, v(Fi, {
          size: "sm"
        })), h;
      }
    }), null), C(c, v(q, {
      get when() {
        return t.copy;
      },
      get children() {
        var h = kB(), f = h.firstChild;
        return f.$$click = () => {
          navigator.clipboard.writeText(xB(i?.value)), o(!0);
        }, C(f, v(q, {
          get when() {
            return a();
          },
          get children() {
            return v(et, {
              name: "check",
              class: "h-5 w-5 text-gray-400",
              size: "sm"
            });
          }
        }), null), C(f, v(q, {
          get when() {
            return !a();
          },
          get children() {
            return v(et, {
              name: "clipboard",
              class: "h-5 w-5 text-gray-400",
              size: "sm"
            });
          }
        }), null), h;
      }
    }), null), c;
  })();
}
qr(["click"]);
const Zb = [
  { id: "AL", name: "Alabama" },
  { id: "AK", name: "Alaska" },
  { id: "AZ", name: "Arizona" },
  { id: "AR", name: "Arkansas" },
  { id: "CA", name: "California" },
  { id: "CO", name: "Colorado" },
  { id: "CT", name: "Connecticut" },
  { id: "DE", name: "Delaware" },
  { id: "DC", name: "District Of Columbia" },
  { id: "FL", name: "Florida" },
  { id: "GA", name: "Georgia" },
  { id: "HI", name: "Hawaii" },
  { id: "ID", name: "Idaho" },
  { id: "IL", name: "Illinois" },
  { id: "IN", name: "Indiana" },
  { id: "IA", name: "Iowa" },
  { id: "KS", name: "Kansas" },
  { id: "KY", name: "Kentucky" },
  { id: "LA", name: "Louisiana" },
  { id: "ME", name: "Maine" },
  { id: "MD", name: "Maryland" },
  { id: "MA", name: "Massachusetts" },
  { id: "MI", name: "Michigan" },
  { id: "MN", name: "Minnesota" },
  { id: "MS", name: "Mississippi" },
  { id: "MO", name: "Missouri" },
  { id: "MT", name: "Montana" },
  { id: "NE", name: "Nebraska" },
  { id: "NV", name: "Nevada" },
  { id: "NH", name: "New Hampshire" },
  { id: "NJ", name: "New Jersey" },
  { id: "NM", name: "New Mexico" },
  { id: "NY", name: "New York" },
  { id: "NC", name: "North Carolina" },
  { id: "ND", name: "North Dakota" },
  { id: "OH", name: "Ohio" },
  { id: "OK", name: "Oklahoma" },
  { id: "OR", name: "Oregon" },
  { id: "PA", name: "Pennsylvania" },
  { id: "PR", name: "Puerto Rico" },
  { id: "RI", name: "Rhode Island" },
  { id: "SC", name: "South Carolina" },
  { id: "SD", name: "South Dakota" },
  { id: "TN", name: "Tennessee" },
  { id: "TX", name: "Texas" },
  { id: "UT", name: "Utah" },
  { id: "VT", name: "Vermont" },
  { id: "VA", name: "Virginia" },
  { id: "WA", name: "Washington" },
  { id: "WV", name: "West Virginia" },
  { id: "WI", name: "Wisconsin" },
  { id: "WY", name: "Wyoming" }
];
function Ei(e, t) {
  let r = {}, n = Object.keys(e);
  for (let i = 0, a = n.length; i < a; i += 1) {
    let o = n[i];
    t.includes(o) || Object.defineProperty(r, o, { get() {
      return e[o];
    }, configurable: !0, enumerable: !0 });
  }
  return r;
}
function Jo(e, t) {
  if (!e) throw t;
}
function qp(e, t) {
  return e === t || e !== e && t !== t;
}
function EB(e) {
  let [t, r] = z(), n, i, a = e.by || qp;
  if ("defaultValue" in e) {
    let [s, l] = z(e.defaultValue);
    n = s, i = (d) => {
      l(() => d), e.onChange && e.onChange(d);
    };
  } else n = B(() => e.value), i = (s) => {
    e.onChange && e.onChange(s);
  };
  let o = B(() => !!e.disabled);
  return { isSelected(s) {
    return qp(s, n());
  }, select(s) {
    Le(o) || (e.toggleable && a(Le(n), s) ? i(void 0) : i(s));
  }, hasSelected() {
    return n() != null;
  }, disabled: o, hasActive() {
    return !!t();
  }, isActive(s) {
    let l = t();
    return l ? a(s, l.value) : !1;
  }, focus(s) {
    Le(o) || r({ value: s });
  }, blur() {
    Le(o) || r(void 0);
  } };
}
function SB(e) {
  let [t, r] = z(), n, i, a = e.by || qp;
  if ("defaultValue" in e) {
    let [s, l] = z(e.defaultValue);
    n = s, i = (d) => {
      l(() => d), e.onChange && e.onChange(d);
    };
  } else n = B(() => e.value), i = (s) => {
    e.onChange && e.onChange(s);
  };
  let o = B(() => !!e.disabled);
  return { isSelected(s) {
    let l = n();
    for (let d = 0, c = l.length; d < c; d += 1) if (a(s, l[d])) return !0;
    return !1;
  }, select(s) {
    if (!Le(o)) {
      let l = [], d = Le(n), c = !1;
      for (let u = 0, h = d.length; u < h; u += 1) {
        let f = d[u], p = a(f, s);
        p && (c = !0), e.toggleable && p || l.push(f);
      }
      c || l.push(s), i(l);
    }
  }, hasSelected: B(() => n().length > 0), disabled: o, hasActive: B(() => !!t()), isActive(s) {
    let l = t();
    return l ? a(s, l.value) : !1;
  }, focus(s) {
    Le(o) || r({ value: s });
  }, blur() {
    Le(o) || r(void 0);
  } };
}
var Xb = Rr();
function ew(e) {
  return v(Xb.Provider, { value: e.state, get children() {
    let t = e.children;
    return typeof t == "function" ? t(e.state) : t;
  } });
}
function Fm() {
  let e = gr(Xb);
  return Jo(e, new Error("Missing <SelectStateProvider>")), e;
}
function eh(e, t) {
  return v(sP, Ke({ get component() {
    return e();
  } }, t));
}
function CB(e) {
  return typeof e == "function";
}
function Qc(e) {
  let [t, r] = z();
  return le(() => {
    let n = t();
    n && "ref" in e && CB(e.ref) && e.ref(n);
  }), [t, r];
}
function Ll(e) {
  return e ? "" : void 0;
}
function Gc(e) {
  return { get disabled() {
    return e();
  }, get "aria-disabled"() {
    return e();
  } };
}
function TB(e) {
  return { get "aria-expanded"() {
    return e();
  } };
}
function AB(e) {
  return { get "aria-selected"() {
    return e();
  } };
}
function Yc(e) {
  return { get "tc-disabled"() {
    return Ll(e());
  } };
}
function jm(e) {
  return { get "tc-expanded"() {
    return Ll(e());
  } };
}
function OB(e) {
  return { get "tc-selected"() {
    return Ll(e());
  } };
}
function PB(e) {
  return { get "tc-active"() {
    return Ll(e());
  } };
}
function zm(e) {
  return { get "tc-has-selected"() {
    return Ll(e());
  } };
}
function Vm(e) {
  return { get "tc-has-active"() {
    return Ll(e());
  } };
}
function IB(e, t, r, n) {
  e.addEventListener(t, r, n), _r(() => {
    e.removeEventListener(t, r, n);
  });
}
var Gr = IB, th = "tc", tw = `[${th}-disabled]`, DB = `[${th}-selected]`;
function Jc(e) {
  return { [`${th}-${e}`]: "" };
}
var NB = /* @__PURE__ */ new Set();
function MB(e) {
  for (let t of NB.keys()) t(e);
}
function F4(e) {
  return !e.matches(tw);
}
function rh(e, t, r, n) {
  let i = t + r;
  if (n) {
    for (r === 1 && i === e.length && (i = 0), r === -1 && i === -1 && (i = e.length - 1); t !== i; ) {
      if (F4(e[i])) return e[i];
      i += r, r === 1 && i >= e.length && (i = 0), r === -1 && i < 0 && (i = e.length - 1);
    }
    return;
  }
  for (; i >= 0 && i < e.length; ) {
    if (F4(e[i])) return e[i];
    i += r;
  }
}
function Fl(e, t) {
  return e && (t ? MB(e) : e.focus()), e;
}
function RB(e, t, r, n) {
  for (let i = 0, a = e.length; i < a; i += 1) if (t === e[i] || e[i].contains(t)) return Fl(rh(e, i, 1, r), n);
}
function LB(e, t, r, n) {
  for (let i = 0, a = e.length; i < a; i += 1) if (e[i].contains(t)) return Fl(rh(e, i, -1, r), n);
}
function FB(e, t) {
  if (e.length) return Fl(rh(e, -1, 1, !1), t);
}
function jB(e, t) {
  if (e.length) return Fl(rh(e, e.length, -1, !1), t);
}
function zB(e, t, r) {
  let n = t.toLowerCase();
  for (let i = 0, a = e.length; i < a; i += 1) {
    let o = e[i].textContent;
    if (o != null && o.toLowerCase().startsWith(n)) return Fl(e[i], r);
  }
}
var rw = `${th}-owner`;
function VB(e, t, r = "") {
  let n = `[${rw}="${t}"]:not(${tw})${r}`;
  return e.querySelectorAll(n);
}
function UB(e) {
  return { [rw]: e };
}
var qB = class {
  constructor(e, t = {}) {
    var r, n;
    this.ownerID = e, this.options = { virtual: (r = t.virtual) != null ? r : !1, base: (n = t.base) != null ? n : "" };
  }
  setRef(e) {
    this.internalRef = e;
  }
  clearRef() {
    this.internalRef = void 0;
  }
  query(e, t = "") {
    return VB(e, this.ownerID, `${this.options.base}${t}`);
  }
  setCurrent(e) {
    this.current = e;
  }
  setChecked(e) {
    this.current = Fl(e, this.options.virtual);
  }
  setNextChecked(e) {
    if (this.internalRef instanceof HTMLElement) {
      Jo(this.current, new Error("missing current ref"));
      let t = RB(this.query(this.internalRef), this.current, e, this.options.virtual);
      t && (this.current = t);
    }
  }
  setPrevChecked(e) {
    if (this.internalRef instanceof HTMLElement) {
      Jo(this.current, new Error("missing current ref"));
      let t = LB(this.query(this.internalRef), this.current, e, this.options.virtual);
      t && (this.current = t);
    }
  }
  setFirstChecked(e = "") {
    if (this.internalRef instanceof HTMLElement) {
      let t = FB(this.query(this.internalRef, e), this.options.virtual);
      t && (this.current = t);
    }
  }
  setLastChecked(e = "") {
    if (this.internalRef instanceof HTMLElement) {
      let t = jB(this.query(this.internalRef, e), this.options.virtual);
      t && (this.current = t);
    }
  }
  setFirstMatch(e) {
    if (this.internalRef instanceof HTMLElement) {
      let t = zB(this.query(this.internalRef), e, this.options.virtual);
      t && (this.current = t);
    }
  }
  getId() {
    return this.ownerID;
  }
};
function BB(e) {
  let t = Fm(), r = B(() => e.disabled || t.disabled());
  return { isSelected: B(() => t.isSelected(e.value)), isActive: B(() => t.isActive(e.value)), select() {
    Le(r) || t.select(e.value);
  }, focus() {
    Le(r) || t.focus(e.value);
  }, blur() {
    !Le(r) && this.isActive() && t.blur();
  }, disabled: r };
}
var HB = Rr();
function WB(e) {
  return v(HB.Provider, { value: e.state, get children() {
    let t = e.children;
    return typeof t == "function" ? t(e.state) : t;
  } });
}
var KB = Jc("button");
function nw(e) {
  let [t, r] = Qc(e);
  return le(() => {
    let n = t();
    n instanceof HTMLElement && n.tagName !== "BUTTON" && Gr(n, "keydown", (i) => {
      switch (i.key) {
        case "Enter":
        case " ": {
          n.click();
          break;
        }
      }
    });
  }), eh(() => e.as || "button", Ke(KB, { get tabindex() {
    return e.disabled ? -1 : 0;
  }, role: "button" }, Yc(() => e.disabled), Gc(() => e.disabled), Ei(e, ["as", "ref"]), { ref: r }));
}
function iw(e, t, r) {
  let n = B(() => e.unmount == null ? !0 : e.unmount);
  return B(() => {
    let i = n();
    if (i === "offscreen") {
      let a = B(() => t()), o = Z5(() => r());
      return B(() => a() && o);
    }
    if (i) {
      let a = B(() => t());
      return B(() => a() && r);
    }
    return r;
  });
}
function QB(e) {
  let t, r;
  if ("defaultOpen" in e) {
    let [i, a] = z(e.defaultOpen);
    t = i, r = (o) => {
      a(o), o && e.onOpen && e.onOpen(), e.onChange && e.onChange(o), !o && e.onClose && e.onClose();
    };
  } else t = B(() => e.isOpen), r = (i) => {
    i && e.onOpen && e.onOpen(), e.onChange && e.onChange(i), !i && e.onClose && e.onClose();
  };
  let n = B(() => !!e.disabled);
  return { isOpen() {
    return t();
  }, setState(i) {
    Le(n) || r(i);
  }, disabled: n, open() {
    Le(n) || r(!0);
  }, close() {
    Le(n) || r(!1);
  }, toggle() {
    Le(n) || r(!Le(t));
  } };
}
var aw = Rr();
function GB(e) {
  return v(aw.Provider, { value: e.state, get children() {
    let t = e.children;
    return typeof t == "function" ? t(e.state) : t;
  } });
}
function nh() {
  let e = gr(aw);
  return Jo(e, new Error("Missing <DisclosureStateProvider>")), e;
}
function ow(e) {
  let t = nh();
  return B(() => {
    let r = e.children;
    return typeof r == "function" && r.length === 1 ? B(() => r(t)) : r;
  });
}
function j4() {
  let e = window.getSelection();
  if (e) {
    let t = e.focusNode;
    if (t) return t.parentElement;
  }
}
function YB(e) {
  if (e) {
    let t = e.getAttribute("tabindex");
    e.setAttribute("tabindex", "-1"), e.focus(), e.blur(), t ? e.setAttribute("tabindex", t) : e.removeAttribute("tabindex");
  }
}
var JB = class {
  constructor() {
    this.returnElement = document.activeElement, this.fsp = j4(), _r(() => {
      this.load();
    });
  }
  load() {
    this.returnElement instanceof HTMLElement ? this.returnElement.focus() : YB(this.fsp);
  }
  save() {
    this.returnElement = document.activeElement, this.fsp = j4();
  }
};
function ZB() {
  return new JB();
}
var sw = Rr();
function Um(e) {
  let t = gr(sw);
  return Jo(t, new Error(`<${e}> must be used inside a <Listbox>`)), t;
}
var XB = Jc("listbox"), eH = Jc("listbox-button"), tH = Jc("listbox-options"), rH = Jc("listbox-option");
function nH(e) {
  return !!e.multiple;
}
function iH(e) {
  return "defaultValue" in e;
}
function z4(e) {
  return "defaultOpen" in e;
}
function aH(e) {
  return iH(e) ? z4(e) ? Ei(e, ["as", "by", "children", "defaultOpen", "defaultValue", "disabled", "horizontal", "multiple", "onClose", "onDisclosureChange", "onOpen", "onSelectChange", "toggleable"]) : Ei(e, ["as", "by", "children", "isOpen", "defaultValue", "disabled", "horizontal", "multiple", "onClose", "onDisclosureChange", "onOpen", "onSelectChange", "toggleable"]) : z4(e) ? Ei(e, ["as", "by", "children", "defaultOpen", "value", "disabled", "horizontal", "multiple", "onClose", "onDisclosureChange", "onOpen", "onSelectChange", "toggleable"]) : Ei(e, ["as", "by", "children", "isOpen", "value", "disabled", "horizontal", "multiple", "onClose", "onDisclosureChange", "onOpen", "onSelectChange", "toggleable"]);
}
function oH(e) {
  return B(() => {
    let t = Pa(), r = Pa(), n = Pa(), i = Pa(), a = QB(Ke(e, { onChange(l) {
      e.onDisclosureChange && e.onDisclosureChange(l);
    } })), o = nH(e) ? SB(Ke(e, { onChange(l) {
      e.onSelectChange && e.onSelectChange(l);
    } })) : EB(Ke(e, { onChange(l) {
      e.onSelectChange && e.onSelectChange(l);
    } })), s = ZB();
    return le(() => {
      a.isOpen() ? s.save() : s.load();
    }), v(sw.Provider, { value: { get multiple() {
      return e.multiple;
    }, ownerID: t, labelID: r, buttonID: n, optionsID: i, get horizontal() {
      return e.horizontal;
    }, buttonHovering: !1, optionsHovering: !1 }, get children() {
      return v(ew, { state: o, get children() {
        return v(GB, { state: a, get children() {
          return eh(() => e.as || "div", Ke(XB, { id: t, "aria-labelledby": r }, Yc(() => o.disabled()), Gc(() => o.disabled()), zm(() => o.hasSelected()), Vm(() => o.hasActive()), jm(() => a.isOpen()), aH(e), { get children() {
            return e.children;
          } }));
        } });
      } });
    } });
  });
}
function sH(e) {
  let t = Um("ListboxButton"), r = nh(), n = Fm(), [i, a] = Qc(e), o = () => r.disabled() || e.disabled;
  return le(() => {
    let s = i();
    s instanceof HTMLElement && (t.anchor = s, Gr(s, "click", () => {
      o() || r.toggle();
    }), Gr(s, "keydown", (l) => {
      if (!o()) switch (l.key) {
        case "ArrowUp":
        case "ArrowDown": {
          l.preventDefault(), r.toggle();
          break;
        }
      }
    }), Gr(s, "mouseenter", () => {
      t.buttonHovering = !0;
    }), Gr(s, "mouseleave", () => {
      t.buttonHovering = !1;
    }));
  }), v(nw, Ke(eH, { id: t.buttonID, "aria-haspopup": "listbox", "aria-controls": t.optionsID, ref: a }, Yc(o), Gc(o), jm(() => r.isOpen()), TB(() => r.isOpen()), zm(() => n.hasSelected()), Vm(() => n.hasActive()), Ei(e, ["children", "ref"]), { get children() {
    return v(ow, { get children() {
      return e.children;
    } });
  } }));
}
var lw = Rr();
function lH(e) {
  let t = gr(lw);
  return Jo(t, new Error(`<${e}> must be used inside a <ListboxOptions>`)), t;
}
function dH(e) {
  return new qB(e);
}
function cH(e) {
  let t = Um("ListboxOptions"), r = lH("ListboxOptions"), n = nh(), i = BB(e), [a, o] = Qc(e);
  return te(() => {
    let s = a();
    s instanceof HTMLElement && (Gr(s, "click", () => {
      i.disabled() || (i.select(), t.multiple || n.close());
    }), Gr(s, "focus", () => {
      i.focus();
    }), Gr(s, "blur", () => {
      i.blur();
    }), Gr(s, "mouseenter", () => {
      i.disabled() || s.focus({ preventScroll: !0 });
    }), Gr(s, "mouseleave", () => {
      i.disabled() || i.blur();
    }));
  }), v(nw, Ke(rH, UB(r.getId()), { get as() {
    return e.as || "li";
  }, role: "option", tabindex: -1, ref: o }, Yc(() => i.disabled()), Gc(() => i.disabled()), OB(() => i.isSelected()), AB(() => i.isSelected()), PB(() => i.isActive()), Ei(e, ["as", "children", "disabled", "value", "ref"]), { get children() {
    return v(WB, { state: i, get children() {
      return e.children;
    } });
  } }));
}
var uH = 250;
function hH(e, t = uH) {
  let r = "", n;
  return _r(() => {
    n && clearTimeout(n);
  }), (i) => {
    r += i, n && clearTimeout(n), n = setTimeout(() => {
      e(r), r = "";
    }, t);
  };
}
function fH(e) {
  let t = Um("ListboxOptions"), r = Fm(), n = nh(), [i, a] = Qc(e), o = dH(t.optionsID), s = hH((l) => {
    o.setFirstMatch(l);
  });
  return Ht(() => {
    le(() => {
      let l = i();
      l instanceof HTMLElement && n.isOpen() && (o.setRef(l), _r(() => {
        o.clearRef();
      }), Le(() => r.hasSelected()) ? o.setFirstChecked(DB) : o.setFirstChecked(), Gr(l, "keydown", (d) => {
        if (!r.disabled()) switch (d.key) {
          case "Escape": {
            n.close();
            break;
          }
          case "ArrowLeft": {
            t.horizontal && (d.preventDefault(), o.setPrevChecked(!0));
            break;
          }
          case "ArrowUp": {
            t.horizontal || (d.preventDefault(), o.setPrevChecked(!0));
            break;
          }
          case "ArrowRight": {
            t.horizontal && (d.preventDefault(), o.setNextChecked(!0));
            break;
          }
          case "ArrowDown": {
            t.horizontal || (d.preventDefault(), o.setNextChecked(!0));
            break;
          }
          case "Home": {
            d.preventDefault(), o.setFirstChecked();
            break;
          }
          case "End": {
            d.preventDefault(), o.setLastChecked();
            break;
          }
          case " ":
          case "Enter": {
            d.preventDefault();
            break;
          }
          default: {
            d.key.length === 1 && s(d.key);
            break;
          }
        }
      }), Gr(l, "focusout", (d) => {
        t.buttonHovering || t.optionsHovering || d.relatedTarget && l.contains(d.relatedTarget) || n.close();
      }), Gr(l, "focusin", (d) => {
        d.target && d.target !== l && o.setCurrent(d.target);
      }), Gr(l, "mouseenter", () => {
        t.optionsHovering = !0;
      }), Gr(l, "mouseleave", () => {
        t.optionsHovering = !1;
      }));
    });
  }), iw(e, () => n.isOpen(), () => v(lw.Provider, { value: o, get children() {
    return eh(() => e.as || "ul", Ke(tH, { id: t.optionsID, role: "listbox", "aria-multiselectable": t.multiple, "aria-labelledby": t.buttonID, ref: a, get "aria-orientation"() {
      return t.horizontal ? "horizontal" : "vertical";
    }, get tabindex() {
      return r.disabled() ? -1 : 0;
    } }, Yc(() => r.disabled()), Gc(() => r.disabled()), jm(() => n.isOpen()), zm(() => r.hasSelected()), Vm(() => r.hasActive()), Ei(e, ["as", "children", "ref"]), { get children() {
      return v(ew, { state: r, get children() {
        return e.children;
      } });
    } }));
  } }));
}
var dw = Rr(), V4 = Rr();
function pH(e) {
  let t = gr(dw);
  return Jo(t, new Error(`<${e}> must be used inside a <Transition>`)), t;
}
function mH() {
  let [e, t] = z(0);
  return { register() {
    t((r) => r + 1);
  }, unregister() {
    t((r) => r - 1);
  }, done() {
    return e() === 0;
  } };
}
function ya(e) {
  return e ? e.split(" ") : [];
}
function po(e, t) {
  let r = t.filter((n) => n);
  r.length && e.classList.add(...r);
}
function mo(e, t) {
  let r = t.filter((n) => n);
  r.length && e.classList.remove(...r);
}
function gH(e) {
  let t = pH("TransitionChild"), r = gr(V4), n = mH(), [i, a] = z(), [o, s] = z(t.show), [l, d] = Qc(e), c = !0;
  function u(h, f) {
    if (f) {
      if (c) {
        let p = ya(e.enter), m = ya(e.enterFrom), y = ya(e.enterTo), g = ya(e.entered), w = () => {
          mo(h, p), mo(h, y), a("entered"), po(h, g), e.afterEnter && e.afterEnter();
        };
        e.beforeEnter && e.beforeEnter(), a("enter-from"), po(h, p), po(h, m), requestAnimationFrame(() => {
          mo(h, m), a("enter-to"), po(h, y), h.addEventListener("transitionend", w, { once: !0 }), h.addEventListener("animationend", w, { once: !0 });
        });
      }
    } else {
      let p = ya(e.leave), m = ya(e.leaveFrom), y = ya(e.leaveTo), g = ya(e.entered);
      e.beforeLeave && e.beforeLeave(), r && r.register(), mo(h, g), a("leave-from"), po(h, p), po(h, m), requestAnimationFrame(() => {
        mo(h, m), a("leave-to"), po(h, y);
      });
      let w = () => {
        mo(h, p), mo(h, y), s(!1), r && r.unregister(), e.afterLeave && e.afterLeave();
      };
      h.addEventListener("transitionend", w, { once: !0 }), h.addEventListener("animationend", w, { once: !0 });
    }
  }
  return le(() => {
    let h = t.show;
    h && s(!0);
    let f = l();
    f instanceof HTMLElement ? h ? u(f, !0) : n.done() && u(f, !1) : c = !0;
  }), v(V4.Provider, { value: n, get children() {
    return iw(e, o, () => eh(() => e.as || "div", Ke(Ei(e, ["as", "enter", "enterFrom", "enterTo", "leave", "leaveFrom", "leaveTo", "unmount", "afterEnter", "afterLeave", "appear", "beforeEnter", "beforeLeave", "entered", "ref"]), { ref: d, get "tc-transition"() {
      return i();
    } })));
  } });
}
function vH(e) {
  return v(dw.Provider, { value: e, get children() {
    return v(gH, Ei(e, ["show"]));
  } });
}
var yH = /* @__PURE__ */ k('<span class="block truncate">'), bH = /* @__PURE__ */ k('<span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">'), wH = /* @__PURE__ */ k("<div><span>"), $H = /* @__PURE__ */ k("<span>");
function kH(e) {
  const [t, r] = z({
    name: e.selectMessage
  }), {
    field: n,
    onInput: i
  } = LP(e.name), [a] = Kc();
  return v(oH, {
    ref: n,
    defaultOpen: !1,
    get value() {
      return t();
    },
    onSelectChange: (o) => {
      r(o ?? {
        name: e.selectMessage
      }), i(o?.value ?? o?.id ?? o?.name ?? "");
    },
    class: "relative shadow-sm rounded-lg",
    get children() {
      return [v(sH, {
        type: "button",
        get class() {
          return `block text-left w-full rounded-lg border-0 py-3 px-4 shadow-sm ring-1 ring-inset text-sm sm:text-base sm:leading-6 focus:outline-none text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-inset focus:ring-blue-600 focus:ring-2
          ${a.error ? "ring-red-300 placeholder:text-red-300 focus:ring-inset focus:ring-red-500" : ""}
          `;
        },
        get children() {
          return [(() => {
            var o = yH();
            return C(o, () => t()?.name ?? ""), o;
          })(), (() => {
            var o = bH();
            return C(o, v(et, {
              name: "chevronDown",
              class: "w-5 h-5 text-gray-400",
              size: "sm"
            })), o;
          })()];
        }
      }), v(ow, {
        children: ({
          isOpen: o
        }) => v(vH, {
          get show() {
            return o();
          },
          enter: "transition ease-in duration-100",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition ease-out duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          get children() {
            return v(fH, {
              unmount: !1,
              get class() {
                return jt("absolute w-full py-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10", e.openUpward ? "bottom-full mb-1" : "mt-1");
              },
              get children() {
                return v(dt, {
                  get each() {
                    return e.list;
                  },
                  children: (s) => v(cH, {
                    class: "focus:outline-none group",
                    value: s,
                    children: ({
                      isActive: l,
                      isSelected: d
                    }) => (() => {
                      var c = wH(), u = c.firstChild;
                      return C(u, () => s.name), C(c, (() => {
                        var h = Pt(() => !!d());
                        return () => h() ? (() => {
                          var f = $H();
                          return C(f, v(et, {
                            name: "checkCircle"
                          })), te(() => rt(f, jt((l(), "text-blue-600"), "group-hover:text-blue-600", "absolute inset-y-0 left-0 flex items-center pl-3"))), f;
                        })() : null;
                      })(), null), te((h) => {
                        var f = jt(l() ? "text-blue-900 bg-blue-100" : "text-gray-900", "group-hover:text-blue-900 group-hover:bg-blue-100", "cursor-default select-none relative py-2 pl-10 pr-4"), p = jt(d() ? "font-medium" : "font-normal", "block truncate");
                        return f !== h.e && rt(c, h.e = f), p !== h.t && rt(u, h.t = p), h;
                      }, {
                        e: void 0,
                        t: void 0
                      }), c;
                    })()
                  })
                });
              }
            });
          }
        })
      })];
    }
  });
}
var U4 = /* @__PURE__ */ k("<div>");
function Sn(e) {
  const t = Ke({
    variant: "white",
    autoPadding: !0
  }, e), r = B(() => jt("border rounded-lg", {
    "divide-y divide-gray-300": t?.addChildrenDivider,
    "border-blue-600 bg-blue-50": t?.selected,
    "border-gray-300": !t?.selected,
    "bg-white": t?.variant === "white",
    "bg-gray-50": t?.variant === "gray",
    "opacity-35": t?.disabled
  }));
  return (() => {
    var n = U4();
    return C(n, v(dt, {
      get each() {
        return Array.isArray(t.children) ? t.children : [t.children];
      },
      children: (i) => (() => {
        var a = U4();
        return C(a, i), te(() => rt(a, jt({
          "px-4 py-3 sm:px-6 sm:py-4": t.autoPadding
        }))), a;
      })()
    })), te(() => rt(n, r())), n;
  })();
}
var _H = /* @__PURE__ */ k("<span>");
function ke(e) {
  const t = Ke({
    size: "md",
    color: "black"
  }, e), r = B(() => (
    // [overflow-wrap:anywhere] is here to prevent long text from overflowing, should be in tailwind soon
    // https://github.com/tailwindlabs/tailwindcss/discussions/2213#discussioncomment-5316024
    jt(e.class, "inline-flex my-px [overflow-wrap:anywhere] leading-snug", {
      "text-xs": t.size === "xs",
      "text-sm": t.size === "sm",
      "text-base": t.size === "md",
      "text-lg": t.size === "lg",
      "text-xl": t.size === "xl",
      "text-black": !e.loading && t.color === "black",
      "text-slate-500": !e.loading && t.color === "gray",
      "text-red-500": !e.loading && t.color === "red",
      "text-transparent box-border rounded-md": e.loading,
      "bg-gray-100": !e.selected && e.loading,
      "bg-blue-100": e.selected && e.loading,
      "font-semibold": e.bold,
      italic: e.italic
    })
  ));
  return (() => {
    var n = _H();
    return C(n, v(q, {
      get when() {
        return !e.loading;
      },
      get children() {
        return e.children;
      }
    }), null), C(n, v(q, {
      get when() {
        return e.loading;
      },
      get children() {
        return e.sampleLoadingText;
      }
    }), null), te((i) => {
      var a = r(), o = e.loading, s = e.loading;
      return a !== i.e && rt(n, i.e = a), o !== i.t && Xe(n, "aria-hidden", i.t = o), s !== i.a && Xe(n, "aria-busy", i.a = s), i;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), n;
  })();
}
var xH = /* @__PURE__ */ k("<button>");
function ct(e) {
  const t = Ke({
    variant: "primary",
    size: "lg"
  }, e), [r, n] = qo(t, ["variant", "size", "color", "children", "iconLeft", "loading"]), i = B(() => {
    const a = r.color || "gray", o = r.variant === "secondary" && r.color ? `rounded bg-white text-${a}-600 shadow-sm ring-1 ring-inset ring-${a}-500 hover:bg-${a}-50` : "";
    return jt("font-semibold flex justify-center inline-flex items-center gap-x-1", {
      "shadow-sm": r.variant !== "naked",
      "rounded-md": ["xl", "lg", "md"].includes(r.size),
      rounded: !["xl", "lg", "md"].includes(r.size),
      "text-xs": r.size === "xs",
      "text-sm": r.size !== "xs",
      "px-3.5 py-2.5": r.size === "xl" && r.variant !== "naked",
      "px-3 py-2": r.size === "lg" && r.variant !== "naked",
      "px-2.5 py-1.5": r.size === "md" && r.variant !== "naked",
      "px-2 py-1": (r.size === "sm" || r.size === "xs") && r.variant !== "naked",
      "text-white bg-blue-500 hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2": r.variant === "primary",
      "rounded bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50": r.variant === "secondary" && !r.color,
      "text-white bg-red-500 hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2": r.variant === "danger",
      "bg-blue-50 text-blue-600 hover:bg-blue-100": r.variant === "tertiary",
      "text-blue-600 hover:text-blue-500 bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-300": r.variant === "naked",
      "opacity-50 cursor-not-allowed": n.disabled || r.loading
    }, o, e?.class);
  });
  return (() => {
    var a = xH();
    return Ln(a, Ke(n, {
      get class() {
        return i();
      },
      get disabled() {
        return n.disabled || r.loading;
      },
      get type() {
        return e?.type;
      }
    }), !1, !0), C(a, v(q, {
      get when() {
        return r?.loading;
      },
      get children() {
        return v(Fi, {
          size: "sm"
        });
      }
    }), null), C(a, v(q, {
      get when() {
        return r?.iconLeft;
      },
      get children() {
        return r?.iconLeft;
      }
    }), null), C(a, () => t.children, null), a;
  })();
}
const cw = Rr();
function EH(e) {
  return v(cw.Provider, {
    get value() {
      return e.client;
    },
    get children() {
      return e.children;
    }
  });
}
function jn() {
  const e = gr(cw);
  if (!e)
    throw new Error("SDKContext must be defined");
  return e;
}
const SH = (e) => typeof e == "function", s1 = (e, t) => SH(e) ? e(t) : e;
var pr;
(function(e) {
  e[e.ADD_TOAST = 0] = "ADD_TOAST", e[e.UPDATE_TOAST = 1] = "UPDATE_TOAST", e[e.UPSERT_TOAST = 2] = "UPSERT_TOAST", e[e.DISMISS_TOAST = 3] = "DISMISS_TOAST", e[e.REMOVE_TOAST = 4] = "REMOVE_TOAST", e[e.START_PAUSE = 5] = "START_PAUSE", e[e.END_PAUSE = 6] = "END_PAUSE";
})(pr || (pr = {}));
const [Vo, ba] = eo({
  toasts: [],
  pausedAt: void 0
}), CH = () => {
  const { pausedAt: e, toasts: t } = Vo;
  if (e)
    return;
  const r = Date.now();
  return t.map((n) => {
    if (n.duration === 1 / 0)
      return;
    const i = (n.duration || 0) + n.pauseDuration - (r - n.createdAt);
    if (i <= 0) {
      n.visible && ci({
        type: pr.DISMISS_TOAST,
        toastId: n.id
      });
      return;
    }
    return setTimeout(() => {
      ci({
        type: pr.DISMISS_TOAST,
        toastId: n.id
      });
    }, i);
  });
}, Wd = /* @__PURE__ */ new Map(), q4 = (e, t) => {
  if (Wd.has(e))
    return;
  const r = setTimeout(() => {
    Wd.delete(e), ci({
      type: pr.REMOVE_TOAST,
      toastId: e
    });
  }, t);
  Wd.set(e, r);
}, TH = (e) => {
  const t = Wd.get(e);
  Wd.delete(e), t && clearTimeout(t);
}, ci = (e) => {
  switch (e.type) {
    case pr.ADD_TOAST:
      ba("toasts", (i) => {
        const a = i;
        return [e.toast, ...a];
      });
      break;
    case pr.DISMISS_TOAST:
      const { toastId: t } = e, r = Vo.toasts;
      if (t) {
        const i = r.find((a) => a.id === t);
        i && q4(t, i.unmountDelay), ba("toasts", (a) => a.id === t, Ru((a) => a.visible = !1));
      } else
        r.forEach((i) => {
          q4(i.id, i.unmountDelay);
        }), ba("toasts", (i) => i.id !== void 0, Ru((i) => i.visible = !1));
      break;
    case pr.REMOVE_TOAST:
      if (!e.toastId) {
        ba("toasts", []);
        break;
      }
      ba("toasts", (i) => i.filter((a) => a.id !== e.toastId));
      break;
    case pr.UPDATE_TOAST:
      e.toast.id && TH(e.toast.id), ba("toasts", (i) => i.id === e.toast.id, (i) => ({
        ...i,
        ...e.toast
      }));
      break;
    case pr.UPSERT_TOAST:
      Vo.toasts.find((i) => i.id === e.toast.id) ? ci({ type: pr.UPDATE_TOAST, toast: e.toast }) : ci({ type: pr.ADD_TOAST, toast: e.toast });
      break;
    case pr.START_PAUSE:
      ba(Ru((i) => {
        i.pausedAt = Date.now(), i.toasts.forEach((a) => {
          a.paused = !0;
        });
      }));
      break;
    case pr.END_PAUSE:
      const n = e.time - (Vo.pausedAt || 0);
      ba(Ru((i) => {
        i.pausedAt = void 0, i.toasts.forEach((a) => {
          a.pauseDuration += n, a.paused = !1;
        });
      }));
      break;
  }
}, AH = {
  blank: 4e3,
  error: 4e3,
  success: 2e3,
  loading: 1 / 0,
  custom: 4e3
}, tl = {
  id: "",
  icon: "",
  unmountDelay: 500,
  duration: 3e3,
  ariaProps: {
    role: "status",
    "aria-live": "polite"
  },
  className: "",
  style: {},
  position: "top-right",
  iconTheme: {}
}, uw = {
  position: "top-right",
  toastOptions: tl,
  gutter: 8,
  containerStyle: {},
  containerClassName: ""
}, Lu = "16px", OH = {
  position: "fixed",
  "z-index": 9999,
  top: Lu,
  bottom: Lu,
  left: Lu,
  right: Lu,
  "pointer-events": "none"
}, PH = /* @__PURE__ */ (() => {
  let e = 0;
  return () => String(++e);
})(), IH = (e) => {
  jH((t) => ({
    containerClassName: e.containerClassName ?? t.containerClassName,
    containerStyle: e.containerStyle ?? t.containerStyle,
    gutter: e.gutter ?? t.gutter,
    position: e.position ?? t.position,
    toastOptions: {
      ...e.toastOptions
    }
  }));
}, DH = (e, t) => {
  const r = e.includes("top") ? { top: 0, "margin-top": `${t}px` } : { bottom: 0, "margin-bottom": `${t}px` }, n = e.includes("center") ? { "justify-content": "center" } : e.includes("right") ? { "justify-content": "flex-end" } : {};
  return {
    left: 0,
    right: 0,
    display: "flex",
    position: "absolute",
    transition: "all 230ms cubic-bezier(.21,1.02,.73,1)",
    ...r,
    ...n
  };
}, NH = (e, t) => {
  const r = e.getBoundingClientRect();
  r.height !== t.height && ci({
    type: pr.UPDATE_TOAST,
    toast: { id: t.id, height: r.height }
  });
}, MH = (e, t) => {
  const { toasts: r } = Vo, n = Cs().gutter || uw.gutter || 8, i = r.filter((s) => (s.position || t) === t && s.height), a = i.findIndex((s) => s.id === e.id), o = i.filter((s, l) => l < a && s.visible).length;
  return i.slice(0, o).reduce((s, l) => s + n + (l.height || 0), 0);
}, RH = (e, t) => (e.position || t).includes("top") ? 1 : -1, LH = {
  display: "flex",
  "align-items": "center",
  color: "#363636",
  background: "white",
  "box-shadow": "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
  "max-width": "350px",
  "pointer-events": "auto",
  padding: "8px 10px",
  "border-radius": "4px",
  "line-height": "1.3",
  "will-change": "transform"
}, FH = {
  display: "flex",
  "align-items": "center",
  flex: "1 1 auto",
  margin: "4px 10px",
  "white-space": "pre-line"
}, Fu = {
  "flex-shrink": 0,
  "min-width": "20px",
  "min-height": "20px",
  display: "flex",
  "align-items": "center",
  "justify-content": "center",
  "text-align": "center"
}, l1 = (e) => ({
  calcMode: "spline",
  keyTimes: "0; 1",
  keySplines: e
}), [Cs, jH] = z(uw), zH = (e, t = "blank", r) => ({
  ...tl,
  ...Cs().toastOptions,
  ...r,
  type: t,
  message: e,
  pauseDuration: 0,
  createdAt: Date.now(),
  visible: !0,
  id: r.id || PH(),
  paused: !1,
  style: {
    ...tl.style,
    ...Cs().toastOptions?.style,
    ...r.style
  },
  duration: r.duration || Cs().toastOptions?.duration || AH[t],
  position: r.position || Cs().toastOptions?.position || Cs().position || tl.position
}), Zc = (e) => (t, r = {}) => Ws(() => {
  const n = Vo.toasts.find((a) => a.id === r.id), i = zH(t, e, { ...n, duration: void 0, ...r });
  return ci({ type: pr.UPSERT_TOAST, toast: i }), i.id;
}), kn = (e, t) => Zc("blank")(e, t);
Le(() => kn);
kn.error = Zc("error");
kn.success = Zc("success");
kn.loading = Zc("loading");
kn.custom = Zc("custom");
kn.dismiss = (e) => {
  ci({
    type: pr.DISMISS_TOAST,
    toastId: e
  });
};
kn.promise = (e, t, r) => {
  const n = kn.loading(t.loading, { ...r });
  return e.then((i) => (kn.success(s1(t.success, i), {
    id: n,
    ...r
  }), i)).catch((i) => {
    kn.error(s1(t.error, i), {
      id: n,
      ...r
    });
  }), e;
};
kn.remove = (e) => {
  ci({
    type: pr.REMOVE_TOAST,
    toastId: e
  });
};
var VH = /* @__PURE__ */ k("<div><style>.sldt-active{z-index:9999;}.sldt-active>*{pointer-events:auto;}");
const UH = (e) => (le(() => {
  IH(e);
}), le(() => {
  const t = CH();
  _r(() => {
    t && t.forEach((r) => r && clearTimeout(r));
  });
}), (() => {
  var t = VH();
  return t.firstChild, C(t, v(dt, {
    get each() {
      return Vo.toasts;
    },
    children: (r) => v(WH, {
      toast: r
    })
  }), null), te((r) => {
    var n = {
      ...OH,
      ...e.containerStyle
    }, i = e.containerClassName;
    return r.e = $i(t, n, r.e), i !== r.t && rt(t, r.t = i), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})());
var ju = /* @__PURE__ */ k("<div>"), qH = /* @__PURE__ */ k("<div><div>");
const BH = (e) => {
  let t;
  return le(() => {
    if (!t) return;
    const r = RH(e.toast, e.position);
    e.toast.visible ? t.animate([{
      transform: `translate3d(0,${r * -200}%,0) scale(.6)`,
      opacity: 0.5
    }, {
      transform: "translate3d(0,0,0) scale(1)",
      opacity: 1
    }], {
      duration: 350,
      fill: "forwards",
      easing: "cubic-bezier(.21,1.02,.73,1)"
    }) : t.animate([{
      transform: "translate3d(0,0,-1px) scale(1)",
      opacity: 1
    }, {
      transform: `translate3d(0,${r * -150}%,-1px) scale(.4)`,
      opacity: 0
    }], {
      duration: 400,
      fill: "forwards",
      easing: "cubic-bezier(.06,.71,.55,1)"
    });
  }), (() => {
    var r = qH(), n = r.firstChild, i = t;
    return typeof i == "function" ? cn(i, r) : t = r, C(r, v(N1, {
      get children() {
        return [v(Mn, {
          get when() {
            return e.toast.icon;
          },
          get children() {
            var a = ju();
            return C(a, () => e.toast.icon), te((o) => $i(a, Fu, o)), a;
          }
        }), v(Mn, {
          get when() {
            return e.toast.type === "loading";
          },
          get children() {
            var a = ju();
            return C(a, v(eW, Ke(() => e.toast.iconTheme))), te((o) => $i(a, Fu, o)), a;
          }
        }), v(Mn, {
          get when() {
            return e.toast.type === "success";
          },
          get children() {
            var a = ju();
            return C(a, v(YH, Ke(() => e.toast.iconTheme))), te((o) => $i(a, Fu, o)), a;
          }
        }), v(Mn, {
          get when() {
            return e.toast.type === "error";
          },
          get children() {
            var a = ju();
            return C(a, v(ZH, Ke(() => e.toast.iconTheme))), te((o) => $i(a, Fu, o)), a;
          }
        })];
      }
    }), n), Ln(n, Ke(() => e.toast.ariaProps), !1, !0), C(n, () => s1(e.toast.message, e.toast)), te((a) => {
      var o = e.toast.className, s = {
        ...LH,
        ...e.toast.style
      }, l = FH;
      return o !== a.e && rt(r, a.e = o), a.t = $i(r, s, a.t), a.a = $i(n, l, a.a), a;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), r;
  })();
};
var HH = /* @__PURE__ */ k("<div>");
const WH = (e) => {
  const t = () => {
    const i = e.toast.position || tl.position, a = MH(e.toast, i);
    return DH(i, a);
  }, r = B(() => t());
  let n;
  return Ht(() => {
    n && NH(n, e.toast);
  }), (() => {
    var i = HH();
    i.addEventListener("mouseleave", () => ci({
      type: pr.END_PAUSE,
      time: Date.now()
    })), i.addEventListener("mouseenter", () => ci({
      type: pr.START_PAUSE,
      time: Date.now()
    }));
    var a = n;
    return typeof a == "function" ? cn(a, i) : n = i, C(i, (() => {
      var o = Pt(() => e.toast.type === "custom");
      return () => o() ? s1(e.toast.message, e.toast) : v(BH, {
        get toast() {
          return e.toast;
        },
        get position() {
          return e.toast.position || tl.position;
        }
      });
    })()), te((o) => {
      var s = r(), l = e.toast.visible ? "sldt-active" : "";
      return o.e = $i(i, s, o.e), l !== o.t && rt(i, o.t = l), o;
    }, {
      e: void 0,
      t: void 0
    }), i;
  })();
};
var KH = /* @__PURE__ */ k('<svg><circle cx=16 cy=16 r=0><animate attributeName=opacity values="0; 1; 1"></animate><animate attributeName=r values="0; 17.5; 16"></svg>', !1, !0, !1), QH = /* @__PURE__ */ k('<svg><circle cx=16 cy=16 r=12 opacity=0><animate attributeName=opacity values="1; 0"></animate><animate attributeName=r values="12; 26"></svg>', !1, !0, !1);
const hw = (e) => {
  const t = {
    dur: "0.35s",
    begin: "100ms",
    fill: "freeze",
    calcMode: "spline",
    keyTimes: "0; 0.6; 1",
    keySplines: "0.25 0.71 0.4 0.88; .59 .22 .87 .63"
  };
  return (() => {
    var r = KH(), n = r.firstChild, i = n.nextSibling;
    return Ln(n, t, !0, !1), Ln(i, t, !0, !1), te(() => Xe(r, "fill", e.fill)), r;
  })();
}, fw = (e) => {
  const t = {
    dur: "1s",
    begin: e.begin || "320ms",
    fill: "freeze",
    ...l1("0.0 0.0 0.2 1")
  };
  return (() => {
    var r = QH(), n = r.firstChild, i = n.nextSibling;
    return Ln(n, t, !0, !1), Ln(i, t, !0, !1), te(() => Xe(r, "fill", e.fill)), r;
  })();
};
var GH = /* @__PURE__ */ k('<svg viewBox="0 0 32 32"width=1.25rem height=1.25rem><path fill=none stroke-width=4 stroke-dasharray=22 stroke-dashoffset=22 stroke-linecap=round stroke-miterlimit=10 d=M9.8,17.2l3.8,3.6c0.1,0.1,0.3,0.1,0.4,0l9.6-9.7><animate attributeName=stroke-dashoffset values=22;0 dur=0.25s begin=250ms fill=freeze>');
const YH = (e) => {
  const t = e.primary || "#34C759";
  return (() => {
    var r = GH(), n = r.firstChild, i = n.firstChild;
    return r.style.setProperty("overflow", "visible"), C(r, v(hw, {
      fill: t
    }), n), C(r, v(fw, {
      fill: t,
      begin: "350ms"
    }), n), Ln(i, Ke(() => l1("0.0, 0.0, 0.58, 1.0")), !0, !1), te(() => Xe(n, "stroke", e.secondary || "#FCFCFC")), r;
  })();
};
var JH = /* @__PURE__ */ k('<svg viewBox="0 0 32 32"width=1.25rem height=1.25rem><path fill=none stroke-width=4 stroke-dasharray=9 stroke-dashoffset=9 stroke-linecap=round d=M16,7l0,9><animate attributeName=stroke-dashoffset values=9;0 dur=0.2s begin=250ms fill=freeze></animate></path><circle cx=16 cy=23 r=2.5 opacity=0><animate attributeName=opacity values=0;1 dur=0.25s begin=350ms fill=freeze>');
const ZH = (e) => {
  const t = e.primary || "#FF3B30";
  return (() => {
    var r = JH(), n = r.firstChild, i = n.firstChild, a = n.nextSibling, o = a.firstChild;
    return r.style.setProperty("overflow", "visible"), C(r, v(hw, {
      fill: t
    }), n), C(r, v(fw, {
      fill: t
    }), n), Ln(i, Ke(() => l1("0.0, 0.0, 0.58, 1.0")), !0, !1), Ln(o, Ke(() => l1("0.0, 0.0, 0.58, 1.0")), !0, !1), te((s) => {
      var l = e.secondary || "#FFFFFF", d = e.secondary || "#FFFFFF";
      return l !== s.e && Xe(n, "stroke", s.e = l), d !== s.t && Xe(a, "fill", s.t = d), s;
    }, {
      e: void 0,
      t: void 0
    }), r;
  })();
};
var XH = /* @__PURE__ */ k('<svg viewBox="0 0 32 32"width=1.25rem height=1.25rem><path fill=none stroke-width=4 stroke-miterlimit=10 d=M16,6c3,0,5.7,1.3,7.5,3.4c1.5,1.8,2.5,4,2.5,6.6c0,5.5-4.5,10-10,10S6,21.6,6,16S10.5,6,16,6z></path><path fill=none stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=M16,6c3,0,5.7,1.3,7.5,3.4c0.6,0.7,1.1,1.4,1.5,2.2><animateTransform attributeName=transform type=rotate from="0 16 16"to="360 16 16"dur=0.75s repeatCount=indefinite>');
const eW = (e) => (() => {
  var t = XH(), r = t.firstChild, n = r.nextSibling;
  return t.style.setProperty("overflow", "visible"), te((i) => {
    var a = e.primary || "#E5E7EB", o = e.secondary || "#4b5563";
    return a !== i.e && Xe(r, "stroke", i.e = a), o !== i.t && Xe(n, "stroke", i.t = o), i;
  }, {
    e: void 0,
    t: void 0
  }), t;
})();
var tW = /* @__PURE__ */ k("<div>"), rW = /* @__PURE__ */ k('<div><div></div><div></div><button type=button class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"><span class=sr-only>Close');
const Yt = (e) => {
  kn.custom((t) => (() => {
    var r = rW(), n = r.firstChild, i = n.nextSibling, a = i.nextSibling;
    return a.firstChild, C(n, v(et, {
      get name() {
        return e.status === "success" ? "checkCircle" : e.status === "error" ? "exclamationCircle" : "informationCircle";
      },
      class: "mr-2"
    })), C(i, v(q, {
      get when() {
        return e?.header;
      },
      get children() {
        return v(ke, {
          bold: !0,
          get children() {
            return e.header;
          }
        });
      }
    }), null), C(i, v(q, {
      get when() {
        return e.body;
      },
      get children() {
        var o = tW();
        return C(o, v(ke, {
          get children() {
            return e.body;
          }
        })), o;
      }
    }), null), a.$$click = () => kn.dismiss(t.id), C(a, v(et, {
      name: "xMark",
      class: "h-6 w-6",
      "aria-hidden": "true"
    }), null), te((o) => {
      var s = `${t.visible ? "animate-enter" : "animate-leave"} flex gap-1 items-start border ${e.status === "success" ? "border-green-400" : e.status === "error" ? "border-red-400" : "border-blue-400"} border-2 rounded-lg p-4 bg-white w-full sm:max-w-md sm:w-auto`, l = e.status === "success" ? "text-green-500" : e.status === "error" ? "text-red-400" : "text-blue-500";
      return s !== o.e && rt(r, o.e = s), l !== o.t && rt(n, o.t = l), o;
    }, {
      e: void 0,
      t: void 0
    }), r;
  })(), {
    position: "top-right",
    unmountDelay: 3e3,
    ariaProps: {
      role: "status",
      "aria-live": "polite"
    }
  });
};
qr(["click"]);
var nW = /* @__PURE__ */ k('<div class="flex-shrink-0 mr-2">'), iW = /* @__PURE__ */ k("<button type=button title=Close>"), aW = /* @__PURE__ */ k('<div><div class="flex w-full">');
function to(e) {
  const [t, r] = z(!0);
  Ht(() => {
    sessionStorage.getItem(`banner-${e.id}`) === "closed" && r(!1);
  });
  const n = () => {
    r(!1), e.id && sessionStorage.setItem(`banner-${e.id}`, "closed");
  }, i = () => jt("flex place-items-start justify-between gap-2 py-3 px-3 sm:px-4 rounded-lg", {
    "border-2 rounded border-solid": e.withBorder,
    "text-blue-600 bg-blue-50": e.status === "info",
    "border-blue-600": e.status === "info" && e.withBorder,
    "text-red-600 bg-red-50": e.status === "error",
    "border-red-600": e.status === "error" && e.withBorder,
    "text-green-600 bg-green-50": e.status === "success",
    "border-green-600": e.status === "success" && e.withBorder,
    "text-yellow-600 bg-yellow-50": e.status === "warning",
    "border-yellow-600": e.status === "warning" && e.withBorder,
    "text-slate-600 bg-slate-50": e.status === "suggestion",
    "border-slate-600": e.status === "suggestion" && e.withBorder
  }), a = () => jt("", {
    "text-blue-600": e.status === "info",
    "text-red-600": e.status === "error",
    "text-green-600": e.status === "success",
    "text-yellow-600": e.status === "warning",
    "text-slate-600": e.status === "suggestion"
  });
  return v(q, {
    get when() {
      return t();
    },
    get children() {
      var o = aW(), s = o.firstChild;
      return C(s, v(q, {
        get when() {
          return !e.withoutIcon;
        },
        get children() {
          var l = nW();
          return C(l, v(et, {
            get name() {
              return e.iconName ? e.iconName : "informationCircle";
            },
            get class() {
              return a();
            }
          })), l;
        }
      }), null), C(s, () => e.children, null), C(o, v(q, {
        get when() {
          return e.closable;
        },
        get children() {
          var l = iW();
          return l.$$click = n, C(l, v(et, {
            name: "xMark",
            size: "sm"
          })), te(() => rt(l, "ml-auto " + a())), l;
        }
      }), null), te(() => rt(o, i())), o;
    }
  });
}
qr(["click"]);
var oW = /* @__PURE__ */ k('<div class="flex items-center justify-between">'), sW = /* @__PURE__ */ k('<div><form id=patient-address class=mt-4><div class="grid grid-cols-1 sm:gap-4 sm:grid-cols-2">');
const lW = Ib({
  street1: Es().min(1, {
    message: "Street 1 is required"
  }),
  street2: Es().optional(),
  city: Es().min(1, {
    message: "City is required"
  }),
  state: Es().min(1, {
    message: "State is required"
  }),
  postalCode: Es().min(5, {
    message: "Postal code must be 5 digits"
  })
}), dW = je`
  mutation UpdateAddress($id: ID!, $address: AddressInput) {
    updatePatient(id: $id, address: $address) {
      id
      address {
        id
        street1
        street2
        city
        state
        postalCode
        country
      }
    }
  }
`;
function pw(e) {
  const [t, r] = z(!1), n = jn(), i = () => e.showRequiredBanner ?? !0, a = async (l) => {
    const {
      data: d
    } = await n.apollo.mutate({
      mutation: dW,
      variables: {
        id: e.patientId,
        address: l
      }
    });
    r(!1), Yt({
      header: "Address Updated",
      body: "The patient address has been updated.",
      status: "success"
    }), e?.setAddress && e.setAddress(d?.updatePatient?.address ?? l);
  }, {
    form: o,
    errors: s
  } = Cb({
    onSubmit: async (l) => {
      r(!0);
      try {
        await a({
          country: "US",
          ...l
        });
      } catch {
        r(!1), Yt({
          header: "Error Updating Patient",
          body: "The patient address has not been updated.",
          status: "info"
        });
      }
    },
    extend: Tb({
      schema: lW
    })
  });
  return v(Sn, {
    addChildrenDivider: !0,
    get children() {
      return [(() => {
        var l = oW();
        return C(l, v(ke, {
          color: "gray",
          children: "Patient Address"
        }), null), C(l, v(ct, {
          type: "submit",
          form: "patient-address",
          get disabled() {
            return t();
          },
          get loading() {
            return t();
          },
          children: "Save address"
        }), null), l;
      })(), (() => {
        var l = sW(), d = l.firstChild, c = d.firstChild;
        return C(l, (() => {
          var u = Pt(() => !!i());
          return () => u() && v(to, {
            status: "info",
            children: "Patient address is required to write a prescription"
          });
        })(), d), cn(o, d), C(d, v(Ye, {
          label: "Address Line 1 *",
          subLabel: "Enter Street Number and Name",
          get error() {
            return s().street1;
          },
          get children() {
            return v(Tt, {
              type: "text",
              name: "street1"
            });
          }
        }), c), C(d, v(Ye, {
          label: "Address Line 2",
          subLabel: "Enter Apt, Unit, or Suite",
          get children() {
            return v(Tt, {
              type: "text",
              name: "street2"
            });
          }
        }), c), C(d, v(Ye, {
          label: "City *",
          get error() {
            return s().city;
          },
          get children() {
            return v(Tt, {
              type: "text",
              name: "city"
            });
          }
        }), c), C(c, v(Ye, {
          label: "State *",
          get error() {
            return s().state;
          },
          get children() {
            return v(kH, {
              list: Zb,
              selectMessage: "Select a State",
              name: "state",
              get openUpward() {
                return e.openStateDropdownUpward;
              }
            });
          }
        }), null), C(c, v(Ye, {
          label: "Zip Code *",
          get error() {
            return s().postalCode;
          },
          get children() {
            return v(Tt, {
              type: "text",
              name: "postalCode"
            });
          }
        }), null), l;
      })()];
    }
  });
}
var cW = /* @__PURE__ */ k('<div><div class=flex><div class=flex-shrink-0></div><div class=ml-3><h3></h3><div><p class="text-sm mb-0">');
const gc = (e) => {
  const t = B(() => {
    switch (e.type) {
      case "success":
        return "checkCircle";
      case "info":
        return "informationCircle";
      case "warning":
        return "exclamationTriangle";
      case "error":
        return "xCircle";
    }
  }), r = B(() => {
    switch (e.type) {
      case "success":
        return "text-green-800";
      case "info":
        return "text-blue-800";
      case "warning":
        return "text-yellow-800";
      case "error":
        return "text-red-800";
    }
  }), n = B(() => {
    switch (e.type) {
      case "success":
        return "bg-green-50";
      case "info":
        return "bg-blue-50";
      case "warning":
        return "bg-yellow-50";
      case "error":
        return "bg-red-50";
    }
  }), i = B(() => {
    switch (e.type) {
      case "success":
        return "border-green-200";
      case "info":
        return "border-blue-200";
      case "warning":
        return "border-yellow-200";
      case "error":
        return "border-red-200";
    }
  });
  return (() => {
    var a = cW(), o = a.firstChild, s = o.firstChild, l = s.nextSibling, d = l.firstChild, c = d.nextSibling, u = c.firstChild;
    return C(s, v(et, {
      get name() {
        return t();
      },
      get class() {
        return r();
      }
    })), C(d, () => e.header), C(u, () => e.message), te((h) => {
      var f = `rounded-md ${n()} border-2 ${i()} p-4`, p = `text-base font-medium mt-0 ${r()}`, m = `mt-2 ${r()}`;
      return f !== h.e && rt(a, h.e = f), p !== h.t && rt(d, h.t = p), m !== h.a && rt(c, h.a = m), h;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), a;
  })();
};
var uW = /* @__PURE__ */ k('<div role=tooltip class="absolute z-50 whitespace-normal rounded bg-gray-900 px-3 py-2 text-sm leading-snug text-gray-50 shadow-lg">'), hW = /* @__PURE__ */ k('<div class="relative inline-flex">');
function fW(e) {
  let t, r;
  const [n, i] = z(!1), [a, o] = z("top"), [s, l] = z(0), d = () => {
    if (!t || !r) return;
    const p = t.getBoundingClientRect(), m = r.getBoundingClientRect(), y = 8;
    p.top - m.height - y < 0 ? o("bottom") : o("top");
    const g = p.left + p.width / 2 - m.width / 2, w = g + m.width;
    g < y ? l(y - g) : w > window.innerWidth - y ? l(window.innerWidth - y - w) : l(0);
  }, c = () => {
    i(!0), requestAnimationFrame(d);
  }, u = () => i(!1), h = () => n() ? u() : c(), f = (p) => {
    n() && t && !t.contains(p.target) && u();
  };
  return Ht(() => {
    document.addEventListener("click", f, !0);
  }), _r(() => {
    document.removeEventListener("click", f, !0);
  }), (() => {
    var p = hW();
    p.$$click = h, p.addEventListener("blur", u), p.$$focusin = c, p.addEventListener("mouseleave", u), p.addEventListener("mouseenter", c);
    var m = t;
    return typeof m == "function" ? cn(m, p) : t = p, C(p, () => e.children, null), C(p, v(q, {
      get when() {
        return n();
      },
      get children() {
        var y = uW(), g = r;
        return typeof g == "function" ? cn(g, y) : r = y, C(y, () => e.text), te((w) => $i(y, {
          width: "360px",
          "max-width": "min(360px, calc(100vw - 16px))",
          left: `calc(50% + ${s()}px)`,
          transform: "translateX(-50%)",
          ...a() === "top" ? {
            bottom: "100%",
            "margin-bottom": "8px"
          } : {
            top: "100%",
            "margin-top": "8px"
          }
        }, w)), y;
      }
    }), null), p;
  })();
}
qr(["focusin", "click"]);
var pW = /* @__PURE__ */ k('<label class="m-0 text-gray-400 text-xs cursor-pointer">Optional'), mW = /* @__PURE__ */ k('<div class="relative flex items-center"><input type=checkbox class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-blue-600 focus:ring-blue-600"><div class="ml-3 text-sm leading-none"><div class="flex items-center gap-1"><label class="m-0 font-medium text-gray-500">');
function Bp(e) {
  const t = Pa(), r = Ke({
    id: `checkbox-${t}`,
    checked: !1
  }, e), n = (i) => {
    const a = i.target;
    r.onChange(a.checked);
  };
  return (() => {
    var i = mW(), a = i.firstChild, o = a.nextSibling, s = o.firstChild, l = s.firstChild;
    return a.addEventListener("change", n), C(l, () => r.mainText), C(s, v(q, {
      get when() {
        return r.tooltip;
      },
      get children() {
        return v(fW, {
          get text() {
            return r.tooltip;
          },
          get children() {
            return v(et, {
              name: "informationCircle",
              size: "sm",
              class: "text-gray-400 cursor-help"
            });
          }
        });
      }
    }), null), C(o, v(q, {
      get when() {
        return r.showOptionalSubtext;
      },
      get children() {
        var d = pW();
        return te(() => Xe(d, "for", r.id)), d;
      }
    }), null), te((d) => {
      var c = r.id, u = `${r.id}-description`, h = r.id, f = r.id;
      return c !== d.e && Xe(a, "id", d.e = c), u !== d.t && Xe(a, "aria-describedby", d.t = u), h !== d.a && Xe(a, "name", d.a = h), f !== d.o && Xe(l, "for", d.o = f), d;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0
    }), te(() => a.checked = r.checked), i;
  })();
}
var gW = /* @__PURE__ */ k("<select>");
function Xc(e) {
  const [t] = Kc(), r = () => {
    const n = t.disabled || e.disabled, i = t.error;
    return jt("block w-full rounded-lg border-0 py-3 px-4 ring-1 ring-inset text-sm sm:text-base sm:leading-6 focus:outline-none bg-white", {
      "ring-red-300 placeholder:text-red-300 focus:ring-2 focus:ring-sky-500/40": !!i && !n,
      "text-gray-900 ring-gray-300 hover:ring-gray-400 focus:ring-2 focus:ring-sky-500/40": !i && !n && !!e.value,
      "text-gray-400 ring-gray-300 hover:ring-gray-400 focus:ring-2 focus:ring-sky-500/40": !i && !n && !e.value,
      "cursor-not-allowed bg-gray-50 text-gray-500 ring-gray-200": !!n
    });
  };
  return (() => {
    var n = gW();
    return Y0(n, "blur", e.onBlur), Y0(n, "change", e.onChange), C(n, () => e.children), te((i) => {
      var a = t.id, o = !!t.error || void 0, s = t.error ? `${t.id}-error` : void 0, l = t.required || e.required, d = t.required || e.required, c = t.disabled || e.disabled, u = r();
      return a !== i.e && Xe(n, "id", i.e = a), o !== i.t && Xe(n, "aria-invalid", i.t = o), s !== i.a && Xe(n, "aria-describedby", i.a = s), l !== i.o && Xe(n, "aria-required", i.o = l), d !== i.i && (n.required = i.i = d), c !== i.n && (n.disabled = i.n = c), u !== i.s && rt(n, i.s = u), i;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0,
      s: void 0
    }), te(() => n.value = e.value ?? ""), n;
  })();
}
const mw = Rr(), Cn = () => {
  const e = gr(mw);
  if (!e)
    throw new Error("usePhoton must be used within PhotonContext");
  return e;
};
var vW = /* @__PURE__ */ k("<option value disabled>"), yW = /* @__PURE__ */ k("<option>");
function bW(e) {
  const t = Cn();
  Ht(() => {
    t && t.clinical.dispenseUnits.state.dispenseUnits.length === 0 && t.clinical.dispenseUnits.getDispenseUnits();
  });
  const r = () => t?.clinical.dispenseUnits.state.isLoading;
  return v(Xc, {
    get value() {
      return e.value;
    },
    get required() {
      return e.required;
    },
    get disabled() {
      return e.disabled || r();
    },
    get onChange() {
      return e.onChange;
    },
    get onBlur() {
      return e.onBlur;
    },
    get children() {
      return [(() => {
        var n = vW();
        return C(n, () => r() ? "Loading..." : "Select a dispense unit"), n;
      })(), v(dt, {
        get each() {
          return t?.clinical.dispenseUnits.state.dispenseUnits;
        },
        children: (n) => (() => {
          var i = yW();
          return C(i, () => n.name), te(() => i.selected = e.value === n.name), te(() => i.value = n.name), i;
        })()
      })];
    }
  });
}
function wW(e) {
  return v(Tt, {
    type: "date",
    get required() {
      return e.required;
    },
    get disabled() {
      return e.disabled;
    },
    get value() {
      return e.value;
    },
    onInput: (t) => {
      e.onDateChange?.(t.currentTarget.value || void 0);
    },
    onPaste: (t) => {
      const r = t.clipboardData?.getData("Text");
      if (!r) return;
      const n = $W(r);
      n && (t.preventDefault(), e.onDateChange?.(n));
    },
    get onBlur() {
      return e.onBlur;
    }
  });
}
function $W(e) {
  const t = e.split(/[/\s-]/);
  if (t.length !== 3) return "";
  const [r, n, i] = t.map((a) => parseInt(a));
  return isNaN(r) || isNaN(n) || isNaN(i) || r < 1 || r > 12 || n < 1 || n > 31 ? "" : `${i}-${r.toString().padStart(2, "0")}-${n.toString().padStart(2, "0")}`;
}
var kW = /* @__PURE__ */ k("<option value disabled>Select state"), _W = /* @__PURE__ */ k("<option>");
function xW(e) {
  return v(Xc, {
    get value() {
      return e.value;
    },
    get required() {
      return e.required;
    },
    get disabled() {
      return e.disabled;
    },
    get onChange() {
      return e.onChange;
    },
    get onBlur() {
      return e.onBlur;
    },
    get children() {
      return [kW(), v(dt, {
        each: Zb,
        children: (t) => (() => {
          var r = _W();
          return C(r, () => t.name), te(() => r.selected = e.value === t.id), te(() => r.value = t.id), r;
        })()
      })];
    }
  });
}
const gw = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:241|349)0\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|91(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79]))))\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:55|6[0-8]|[78]\\d|9[02-9]))\\d{6}", [9]], ["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "(?:[025-7]\\d|44)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[024-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|8)\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[178]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-6]|7[246]|8[2-4]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|[78]"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|3[23]|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "8776\\d{4}|(?:[27]\\d|61)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-8]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["60|809"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:10|[2-9])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|3[13])"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, 0, [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|5[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, "0|180020", 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-5])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|5[01]))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0|180020", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "[2-589]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0|180020", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|8(?:28[235-7]|3))|73179|807(?:1|9[1-3])|(?:1552|6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689])\\d|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["16|[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["18[06]", "18[06]0"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[03]"]]], 0, 0, 0, 0, 0, 0, [["0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0|180020", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[47]"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "8\\d{13}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["20"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["20"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|78|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2679]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{4})(\\d{5})", "$1-$2", ["892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8(?:0[0-7]|9)"], "0$1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, "[5-8]"], MC: ["377", "00", "(?:[3489]|[67]\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[67]"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", [10, 11, 12, 13, 14], [["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "[36-8]\\d{5,8}|4\\d{6,8}|59\\d{6}|9\\d{5,10}|(?:2\\d|5[0-8])\\d{6,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["3[289]|4[246-8]|61|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "[3489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "(?:[15]\\d|800|92)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|[6-8]\\d|90)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[25-7]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[25-7]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|30|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[236-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "(?:[0-57-9]\\d|66)\\d{7}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["\\d"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-579]|61)", "5(?:[0-579]|61[06])", "5(?:[0-579]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:274[27]|(?:472|983)[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-3]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{4,5})", "$1", ["21"]], ["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|5[12]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|5(?:0\\d{3}|2[0-2]))\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function EW(e, t) {
  var r = Array.prototype.slice.call(t);
  return r.push(gw), e.apply(this, r);
}
function B4(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var r = e[0].split("."), n = t[0].split("."), i = 0; i < 3; i++) {
    var a = Number(r[i]), o = Number(n[i]);
    if (a > o) return 1;
    if (o > a) return -1;
    if (!isNaN(a) && isNaN(o)) return 1;
    if (isNaN(a) && !isNaN(o)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var SW = {}.constructor;
function Uo(e) {
  return e != null && e.constructor === SW;
}
function vl(e) {
  "@babel/helpers - typeof";
  return vl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vl(e);
}
function ih(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function CW(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, TW(n.key), n);
  }
}
function ah(e, t, r) {
  return t && CW(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function TW(e) {
  var t = AW(e, "string");
  return vl(t) == "symbol" ? t : t + "";
}
function AW(e, t) {
  if (vl(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (vl(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var OW = "1.2.0", PW = "1.7.35", H4 = " ext. ", IW = /^\d+$/, Ar = /* @__PURE__ */ (function() {
  function e(t) {
    ih(this, e), vw(t), this.metadata = t, yw.call(this, t);
  }
  return ah(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(t) {
        return t !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(t) {
      return this.metadata.countries[t];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(t) {
      return this.getCountryMetadata(t) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(t) {
      if (this.getCountryCodesForCallingCode(t))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[t])
          return !0;
      } else {
        var r = this.countryCallingCodes()[t];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(t) {
      return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(t, r) {
      if (t && IW.test(t) && (r = t, t = null), t && t !== "001") {
        if (!this.hasCountry(t))
          throw new Error("Unknown country: ".concat(t));
        this.numberingPlan = new W4(this.getCountryMetadata(t), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new W4(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(t) {
      var r = this.countryCallingCodes()[t];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(t) {
      var r = this.getCountryCodesForCallingCode(t);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(t) {
      var r = this.getCountryCodeForCallingCode(t);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var n = this.nonGeographic()[t];
        if (n)
          return n;
      } else {
        var i = this.countryCallingCodes()[t];
        if (i && i.length === 1 && i[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(t) {
      return this.numberingPlan.type(t);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]);
})(), W4 = /* @__PURE__ */ (function() {
  function e(t, r) {
    ih(this, e), this.globalMetadataObject = r, this.metadata = t, yw.call(this, r.metadata);
  }
  return ah(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(t) {
      return t[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var t = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(n) {
        return new DW(n, t);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(t) {
      return t[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(t) {
      if (this.hasTypes() && K4(this.types(), t))
        return new MW(K4(this.types(), t), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? H4 : this.metadata[13] || H4;
    }
  }]);
})(), DW = /* @__PURE__ */ (function() {
  function e(t, r) {
    ih(this, e), this._format = t, this.metadata = r;
  }
  return ah(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !NW.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]);
})(), NW = /^\(?\$1\)?$/, MW = /* @__PURE__ */ (function() {
  function e(t, r) {
    ih(this, e), this.type = t, this.metadata = r;
  }
  return ah(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
})();
function K4(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function vw(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Uo(e) || !Uo(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Uo(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + RW(e) + ": " + e, "."));
}
var RW = function(e) {
  return vl(e);
};
function qm(e, t) {
  if (t = new Ar(t), t.hasCountry(e))
    return t.selectNumberingPlan(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function yw(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? B4(t, OW) === -1 ? this.v2 = !0 : B4(t, PW) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function oh(e, t, r) {
  return LW(e, t, void 0, r);
}
function LW(e, t, r, n) {
  t && (n = new Ar(n.metadata), n.selectNumberingPlan(t));
  var i = n.type(r), a = i && i.possibleLengths() || n.possibleLengths();
  if (!a)
    return "IS_POSSIBLE";
  var o = e.length, s = a[0];
  return s === o ? "IS_POSSIBLE" : s > o ? "TOO_SHORT" : a[a.length - 1] < o ? "TOO_LONG" : a.indexOf(o, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function FW(e, t, r) {
  if (t === void 0 && (t = {}), r = new Ar(r), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!r.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      r.selectNumberingPlan(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (r.possibleLengths())
    return bw(e.phone || e.nationalNumber, e.country, r);
  if (e.countryCallingCode && r.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function bw(e, t, r) {
  return oh(e, t, r) === "IS_POSSIBLE";
}
function ia(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function jW(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = zW(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zW(e, t) {
  if (e) {
    if (typeof e == "string") return Q4(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Q4(e, t) : void 0;
  }
}
function Q4(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var VW = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function Bm(e, t, r) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    r = new Ar(r), r.selectNumberingPlan(e.country, e.countryCallingCode);
    var n = t.v2 ? e.nationalNumber : e.phone;
    if (ia(n, r.nationalNumberPattern())) {
      if (Df(n, "FIXED_LINE", r))
        return r.type("MOBILE") && r.type("MOBILE").pattern() === "" || !r.type("MOBILE") || Df(n, "MOBILE", r) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var i = jW(VW), a; !(a = i()).done; ) {
        var o = a.value;
        if (Df(n, o, r))
          return o;
      }
    }
  }
}
function Df(e, t, r) {
  var n = r.type(t);
  return !n || !n.pattern() || n.possibleLengths() && n.possibleLengths().indexOf(e.length) < 0 ? !1 : ia(e, n.pattern());
}
function UW(e, t, r) {
  if (t = t || {}, r = new Ar(r), r.selectNumberingPlan(e.country, e.countryCallingCode), r.hasTypes())
    return Bm(e, t, r.metadata) !== void 0;
  var n = t.v2 ? e.nationalNumber : e.phone;
  return ia(n, r.nationalNumberPattern());
}
function qW(e, t, r) {
  var n = new Ar(r), i = n.getCountryCodesForCallingCode(e);
  return i ? i.filter(function(a) {
    return BW(t, a, r);
  }) : [];
}
function BW(e, t, r) {
  var n = new Ar(r);
  return n.selectNumberingPlan(t), n.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var Hm = 2, HW = 17, WW = 3, Zr = "0-9０-９٠-٩۰-۹", KW = "-‐-―−ー－", QW = "／/", GW = "．.", YW = "  ­​⁠　", JW = "()（）［］\\[\\]", ZW = "~⁓∼～", ai = "".concat(KW).concat(QW).concat(GW).concat(YW).concat(JW).concat(ZW), sh = "+＋", XW = new RegExp("([" + Zr + "])");
function ww(e, t, r, n) {
  if (t) {
    var i = new Ar(n);
    i.selectNumberingPlan(t, r);
    var a = new RegExp(i.IDDPrefix());
    if (e.search(a) === 0) {
      e = e.slice(e.match(a)[0].length);
      var o = e.match(XW);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0"))
        return e;
    }
  }
}
function Hp(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var r = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), n = r.exec(e);
    if (n) {
      var i, a, o = n.length - 1, s = o > 0 && n[o];
      if (t.nationalPrefixTransformRule() && s)
        i = e.replace(r, t.nationalPrefixTransformRule()), o > 1 && (a = n[1]);
      else {
        var l = n[0];
        i = e.slice(l.length), s && (a = n[1]);
      }
      var d;
      if (s) {
        var c = e.indexOf(n[1]), u = e.slice(0, c);
        u === t.numberingPlan.nationalPrefix() && (d = t.numberingPlan.nationalPrefix());
      } else
        d = n[0];
      return {
        nationalNumber: i,
        nationalPrefix: d,
        carrierCode: a
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function eK(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = tK(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tK(e, t) {
  if (e) {
    if (typeof e == "string") return G4(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? G4(e, t) : void 0;
  }
}
function G4(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function $w(e, t) {
  var r = t.countries, n = t.metadata;
  n = new Ar(n);
  for (var i = eK(r), a; !(a = i()).done; ) {
    var o = a.value;
    if (n.selectNumberingPlan(o), n.leadingDigits()) {
      if (e && e.search(n.leadingDigits()) === 0)
        return o;
    } else if (Bm({
      phone: e,
      country: o
    }, void 0, n.metadata))
      return o;
  }
}
function Wm(e, t) {
  var r = t.nationalNumber, n = t.metadata, i = n.getCountryCodesForCallingCode(e);
  if (i)
    return i.length === 1 ? i[0] : $w(r, {
      countries: i,
      metadata: n.metadata
    });
}
function Wp(e, t, r) {
  var n = Hp(e, r), i = n.carrierCode, a = n.nationalNumber;
  if (a !== e) {
    if (!rK(e, a, r))
      return {
        nationalNumber: e
      };
    if (r.numberingPlan.possibleLengths() && (t || (t = Wm(r.numberingPlan.callingCode(), {
      nationalNumber: a,
      metadata: r
    })), !nK(a, t, r)))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: a,
    carrierCode: i
  };
}
function rK(e, t, r) {
  return !(ia(e, r.nationalNumberPattern()) && !ia(t, r.nationalNumberPattern()));
}
function nK(e, t, r) {
  switch (oh(e, t, r)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function kw(e, t, r, n, i) {
  var a = t || r ? qm(t || r, i) : n;
  if (e.indexOf(a) === 0) {
    i = new Ar(i), i.selectNumberingPlan(t || r, a);
    var o = e.slice(a.length), s = Wp(o, t, i), l = s.nationalNumber, d = Wp(e, t, i), c = d.nationalNumber;
    if (!ia(c, i.nationalNumberPattern()) && ia(l, i.nationalNumberPattern()) || oh(c, t, i) === "TOO_LONG")
      return {
        countryCallingCode: a,
        number: o
      };
  }
  return {
    number: e
  };
}
function Km(e, t, r, n, i) {
  if (!e)
    return {};
  var a;
  if (e[0] !== "+") {
    var o = ww(e, t || r, n, i);
    if (o && o !== e)
      a = !0, e = "+" + o;
    else {
      if (t || r || n) {
        var s = kw(e, t, r, n, i), l = s.countryCallingCode, d = s.number;
        if (l)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: l,
            number: d
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  i = new Ar(i);
  for (var c = 2; c - 1 <= WW && c <= e.length; ) {
    var u = e.slice(1, c);
    if (i.hasCallingCode(u))
      return i.selectNumberingPlan(u), {
        countryCallingCodeSource: a ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: u,
        number: e.slice(c)
      };
    c++;
  }
  return {};
}
function _w(e) {
  return e.replace(new RegExp("[".concat(ai, "]+"), "g"), " ").trim();
}
var xw = /(\$\d)/;
function Ew(e, t, r) {
  var n = r.useInternationalFormat, i = r.withNationalPrefix;
  r.carrierCode, r.metadata;
  var a = e.replace(new RegExp(t.pattern()), n ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    i && t.nationalPrefixFormattingRule() ? t.format().replace(xw, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return n ? _w(a) : a;
}
var iK = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function aK(e, t, r) {
  var n = new Ar(r);
  if (n.selectNumberingPlan(e, t), n.defaultIDDPrefix())
    return n.defaultIDDPrefix();
  if (iK.test(n.IDDPrefix()))
    return n.IDDPrefix();
}
var oK = ";ext=", ms = function(e) {
  return "([".concat(Zr, "]{1,").concat(e, "})");
};
function Sw(e) {
  var t = "20", r = "15", n = "9", i = "6", a = "[  \\t,]*", o = "[:\\.．]?[  \\t,-]*", s = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", d = "(?:[xｘ#＃~～]|int|ｉｎｔ)", c = "[- ]+", u = "[  \\t]*", h = "(?:,{2}|;)", f = oK + ms(t), p = a + l + o + ms(t) + s, m = a + d + o + ms(n) + s, y = c + ms(i) + "#", g = u + h + o + ms(r) + s, w = u + "(?:,)+" + o + ms(n) + s;
  return f + "|" + p + "|" + m + "|" + y + "|" + g + "|" + w;
}
var sK = "[" + Zr + "]{" + Hm + "}", lK = "[" + sh + "]{0,1}(?:[" + ai + "]*[" + Zr + "]){3,}[" + ai + Zr + "]*", dK = new RegExp("^[" + sh + "]{0,1}(?:[" + ai + "]*[" + Zr + "]){1,2}$", "i"), cK = lK + // Phone number extensions
"(?:" + Sw() + ")?", uK = new RegExp(
  // Either a short two-digit-only phone number
  "^" + sK + "$|^" + cK + "$",
  "i"
);
function hK(e) {
  return e.length >= Hm && uK.test(e);
}
function fK(e) {
  return dK.test(e);
}
function pK(e) {
  var t = e.number, r = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(r ? ";ext=" + r : "");
}
var Y4 = {
  formatExtension: function(e, t, r) {
    return "".concat(e).concat(r.ext()).concat(t);
  }
};
function mK(e, t, r, n) {
  if (r ? r = yK({}, Y4, r) : r = Y4, n = new Ar(n), e.country && e.country !== "001") {
    if (!n.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    n.selectNumberingPlan(e.country);
  } else if (e.countryCallingCode)
    n.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var i = n.countryCallingCode(), a = r.v2 ? e.nationalNumber : e.phone, o;
  switch (t) {
    case "NATIONAL":
      return a ? (o = d1(a, e.carrierCode, "NATIONAL", n, r), Nf(o, e.ext, n, r.formatExtension)) : "";
    case "INTERNATIONAL":
      return a ? (o = d1(a, null, "INTERNATIONAL", n, r), o = "+".concat(i, " ").concat(o), Nf(o, e.ext, n, r.formatExtension)) : "+".concat(i);
    case "E.164":
      return "+".concat(i).concat(a);
    case "RFC3966":
      return pK({
        number: "+".concat(i).concat(a),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!r.fromCountry)
        return;
      var s = vK(a, e.carrierCode, i, r.fromCountry, n);
      return s ? Nf(s, e.ext, n, r.formatExtension) : void 0;
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function d1(e, t, r, n, i) {
  var a = gK(n.formats(), e);
  return a ? Ew(e, a, {
    useInternationalFormat: r === "INTERNATIONAL",
    withNationalPrefix: !(a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && i && i.nationalPrefix === !1),
    carrierCode: t,
    metadata: n
  }) : e;
}
function gK(e, t) {
  return bK(e, function(r) {
    if (r.leadingDigitsPatterns().length > 0) {
      var n = r.leadingDigitsPatterns()[r.leadingDigitsPatterns().length - 1];
      if (t.search(n) !== 0)
        return !1;
    }
    return ia(t, r.pattern());
  });
}
function Nf(e, t, r, n) {
  return t ? n(e, t, r) : e;
}
function vK(e, t, r, n, i) {
  var a = qm(n, i.metadata);
  if (a === r) {
    var o = d1(e, t, "NATIONAL", i);
    return r === "1" ? r + " " + o : o;
  }
  var s = aK(n, void 0, i.metadata);
  if (s)
    return "".concat(s, " ").concat(r, " ").concat(d1(e, null, "INTERNATIONAL", i));
}
function yK() {
  for (var e = 1, t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  for (; e < r.length; ) {
    if (r[e])
      for (var i in r[e])
        r[0][i] = r[e][i];
    e++;
  }
  return r[0];
}
function bK(e, t) {
  for (var r = 0; r < e.length; ) {
    if (t(e[r]))
      return e[r];
    r++;
  }
}
function vc(e) {
  "@babel/helpers - typeof";
  return vc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vc(e);
}
function J4(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Z4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? J4(Object(r), !0).forEach(function(n) {
      wK(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : J4(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function wK(e, t, r) {
  return (t = Cw(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function $K(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function kK(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Cw(n.key), n);
  }
}
function _K(e, t, r) {
  return t && kK(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Cw(e) {
  var t = xK(e, "string");
  return vc(t) == "symbol" ? t : t + "";
}
function xK(e, t) {
  if (vc(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (vc(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Tw = /* @__PURE__ */ (function() {
  function e(t, r, n) {
    if ($K(this, e), !t)
      throw new TypeError("First argument is required");
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    if (t[0] === "+" && !r)
      throw new TypeError("`metadata` argument not passed");
    if (Uo(r) && Uo(r.countries)) {
      n = r;
      var i = t;
      if (!CK.test(i))
        throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
      var a = Km(i, void 0, void 0, void 0, n), o = a.countryCallingCode, s = a.number;
      if (r = s, t = o, !r)
        throw new Error("Invalid `number` argument passed: too short");
    }
    if (!r)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof r != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    vw(n);
    var l = SK(t, n), d = l.country, c = l.countryCallingCode;
    this.country = d, this.countryCallingCode = c, this.nationalNumber = r, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return n;
    };
  }
  return _K(e, [{
    key: "setExt",
    value: function(t) {
      this.ext = t;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : qW(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return FW(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return UW(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var t = new Ar(this.getMetadata());
      return t.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(t) {
      return this.number === t.number && this.ext === t.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return Bm(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(t, r) {
      return mK(this, t, r ? Z4(Z4({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(t) {
      return this.format("NATIONAL", t);
    }
  }, {
    key: "formatInternational",
    value: function(t) {
      return this.format("INTERNATIONAL", t);
    }
  }, {
    key: "getURI",
    value: function(t) {
      return this.format("RFC3966", t);
    }
  }]);
})(), EK = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function SK(e, t) {
  var r, n, i = new Ar(t);
  return EK(e) ? (r = e, i.selectNumberingPlan(r), n = i.countryCallingCode()) : n = e, {
    country: r,
    countryCallingCode: n
  };
}
var CK = /^\+\d+$/;
function Kp(e) {
  "@babel/helpers - typeof";
  return Kp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Kp(e);
}
function TK(e, t, r) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function AK(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function OK(e, t, r) {
  return t = bc(t), PK(e, Qm() ? Reflect.construct(t, r || [], bc(e).constructor) : t.apply(e, r));
}
function PK(e, t) {
  if (t && (Kp(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return IK(e);
}
function IK(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function DK(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && yc(e, t);
}
function Qp(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Qp = function(r) {
    if (r === null || !MK(r)) return r;
    if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(r)) return t.get(r);
      t.set(r, n);
    }
    function n() {
      return NK(r, arguments, bc(this).constructor);
    }
    return n.prototype = Object.create(r.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), yc(n, r);
  }, Qp(e);
}
function NK(e, t, r) {
  if (Qm()) return Reflect.construct.apply(null, arguments);
  var n = [null];
  n.push.apply(n, t);
  var i = new (e.bind.apply(e, n))();
  return r && yc(i, r.prototype), i;
}
function Qm() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Qm = function() {
    return !!e;
  })();
}
function MK(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function yc(e, t) {
  return yc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, yc(e, t);
}
function bc(e) {
  return bc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, bc(e);
}
var Ta = /* @__PURE__ */ (function(e) {
  function t(r) {
    var n;
    return AK(this, t), n = OK(this, t, [r]), Object.setPrototypeOf(n, t.prototype), n.name = n.constructor.name, n;
  }
  return DK(t, e), TK(t);
})(/* @__PURE__ */ Qp(Error)), X4 = new RegExp("(?:" + Sw() + ")$", "i");
function RK(e) {
  var t = e.search(X4);
  if (t < 0)
    return {};
  for (var r = e.slice(0, t), n = e.match(X4), i = 1; i < n.length; ) {
    if (n[i])
      return {
        number: r,
        ext: n[i]
      };
    i++;
  }
}
function LK(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = FK(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function FK(e, t) {
  if (e) {
    if (typeof e == "string") return ey(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ey(e, t) : void 0;
  }
}
function ey(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var jK = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Aw(e) {
  return jK[e];
}
function c1(e) {
  for (var t = "", r = LK(e.split("")), n; !(n = r()).done; ) {
    var i = n.value, a = Aw(i);
    a && (t += a);
  }
  return t;
}
function zK(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = VK(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function VK(e, t) {
  if (e) {
    if (typeof e == "string") return ty(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ty(e, t) : void 0;
  }
}
function ty(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function ry(e) {
  for (var t = "", r = zK(e.split("")), n; !(n = r()).done; ) {
    var i = n.value;
    t += UK(i, t) || "";
  }
  return t;
}
function UK(e, t, r) {
  return e === "+" ? t ? void 0 : "+" : Aw(e);
}
var Ow = "+", qK = "[\\-\\.\\(\\)]?", ny = "([" + Zr + "]|" + qK + ")", BK = "^\\" + Ow + ny + "*[" + Zr + "]" + ny + "*$", HK = new RegExp(BK, "g"), Gp = Zr, WK = "[" + Gp + "]+((\\-)*[" + Gp + "])*", KK = "a-zA-Z", QK = "[" + KK + "]+((\\-)*[" + Gp + "])*", GK = "^(" + WK + "\\.)*" + QK + "\\.?$", YK = new RegExp(GK, "g"), iy = "tel:", Yp = ";phone-context=", JK = ";isub=";
function ZK(e) {
  var t = e.indexOf(Yp);
  if (t < 0)
    return null;
  var r = t + Yp.length;
  if (r >= e.length)
    return "";
  var n = e.indexOf(";", r);
  return n >= 0 ? e.substring(r, n) : e.substring(r);
}
function XK(e) {
  return e === null ? !0 : e.length === 0 ? !1 : HK.test(e) || YK.test(e);
}
function eQ(e, t) {
  var r = t.extractFormattedPhoneNumber, n = ZK(e);
  if (!XK(n))
    throw new Ta("NOT_A_NUMBER");
  var i;
  if (n === null)
    i = r(e) || "";
  else {
    i = "", n.charAt(0) === Ow && (i += n);
    var a = e.indexOf(iy), o;
    a >= 0 ? o = a + iy.length : o = 0;
    var s = e.indexOf(Yp);
    i += e.substring(o, s);
  }
  var l = i.indexOf(JK);
  if (l > 0 && (i = i.substring(0, l)), i !== "")
    return i;
}
var tQ = 250, rQ = new RegExp("[" + sh + Zr + "]"), nQ = new RegExp("[^" + Zr + "#]+$");
function iQ(e, t, r) {
  if (t = t || {}, r = new Ar(r), t.defaultCountry && !r.hasCountry(t.defaultCountry))
    throw t.v2 ? new Ta("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var n = oQ(e, t.v2, t.extract), i = n.number, a = n.ext, o = n.error;
  if (!i) {
    if (t.v2)
      throw o === "TOO_SHORT" ? new Ta("TOO_SHORT") : new Ta("NOT_A_NUMBER");
    return {};
  }
  var s = lQ(i, t.defaultCountry, t.defaultCallingCode, r), l = s.country, d = s.nationalNumber, c = s.countryCallingCode, u = s.countryCallingCodeSource, h = s.carrierCode;
  if (!r.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new Ta("INVALID_COUNTRY");
    return {};
  }
  if (!d || d.length < Hm) {
    if (t.v2)
      throw new Ta("TOO_SHORT");
    return {};
  }
  if (d.length > HW) {
    if (t.v2)
      throw new Ta("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var f = new Tw(c, d, r.metadata);
    return l && (f.country = l), h && (f.carrierCode = h), a && (f.ext = a), f.__countryCallingCodeSource = u, f;
  }
  var p = (t.extended ? r.hasSelectedNumberingPlan() : l) ? ia(d, r.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: l,
    countryCallingCode: c,
    carrierCode: h,
    valid: p,
    possible: p ? !0 : !!(t.extended === !0 && r.possibleLengths() && bw(d, l, r)),
    phone: d,
    ext: a
  } : p ? sQ(l, d, a) : {};
}
function aQ(e, t, r) {
  if (e) {
    if (e.length > tQ) {
      if (r)
        throw new Ta("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var n = e.search(rQ);
    if (!(n < 0))
      return e.slice(n).replace(nQ, "");
  }
}
function oQ(e, t, r) {
  var n = eQ(e, {
    extractFormattedPhoneNumber: function(a) {
      return aQ(a, r, t);
    }
  });
  if (!n)
    return {};
  if (!hK(n))
    return fK(n) ? {
      error: "TOO_SHORT"
    } : {};
  var i = RK(n);
  return i.ext ? i : {
    number: n
  };
}
function sQ(e, t, r) {
  var n = {
    country: e,
    phone: t
  };
  return r && (n.ext = r), n;
}
function lQ(e, t, r, n) {
  var i = Km(ry(e), void 0, t, r, n.metadata), a = i.countryCallingCodeSource, o = i.countryCallingCode, s = i.number, l;
  if (o)
    n.selectNumberingPlan(o);
  else if (s && (t || r))
    n.selectNumberingPlan(t, r), t && (l = t), o = r || qm(t, n.metadata);
  else return {};
  if (!s)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: o
    };
  var d = Wp(ry(s), l, n), c = d.nationalNumber, u = d.carrierCode, h = Wm(o, {
    nationalNumber: c,
    metadata: n
  });
  return h && (l = h, h === "001" || n.selectNumberingPlan(l)), {
    country: l,
    countryCallingCode: o,
    countryCallingCodeSource: a,
    nationalNumber: c,
    carrierCode: u
  };
}
function wc(e) {
  "@babel/helpers - typeof";
  return wc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wc(e);
}
function ay(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function oy(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ay(Object(r), !0).forEach(function(n) {
      dQ(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ay(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function dQ(e, t, r) {
  return (t = cQ(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function cQ(e) {
  var t = uQ(e, "string");
  return wc(t) == "symbol" ? t : t + "";
}
function uQ(e, t) {
  if (wc(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (wc(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function hQ(e, t, r) {
  return iQ(e, oy(oy({}, t), {}, {
    v2: !0
  }), r);
}
function $c(e) {
  "@babel/helpers - typeof";
  return $c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $c(e);
}
function sy(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function fQ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sy(Object(r), !0).forEach(function(n) {
      pQ(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : sy(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function pQ(e, t, r) {
  return (t = mQ(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function mQ(e) {
  var t = gQ(e, "string");
  return $c(t) == "symbol" ? t : t + "";
}
function gQ(e, t) {
  if ($c(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if ($c(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function vQ(e, t) {
  return $Q(e) || wQ(e, t) || bQ(e, t) || yQ();
}
function yQ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bQ(e, t) {
  if (e) {
    if (typeof e == "string") return ly(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ly(e, t) : void 0;
  }
}
function ly(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function wQ(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], l = !0, d = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); l = !0) ;
    } catch (c) {
      d = !0, i = c;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (d) throw i;
      }
    }
    return s;
  }
}
function $Q(e) {
  if (Array.isArray(e)) return e;
}
function kQ(e) {
  var t = Array.prototype.slice.call(e), r = vQ(t, 4), n = r[0], i = r[1], a = r[2], o = r[3], s, l, d;
  if (typeof n == "string")
    s = n;
  else throw new TypeError("A text for parsing must be a string.");
  if (!i || typeof i == "string")
    o ? (l = a, d = o) : (l = void 0, d = a), i && (l = fQ({
      defaultCountry: i
    }, l));
  else if (Uo(i))
    a ? (l = i, d = a) : d = i;
  else throw new Error("Invalid second argument: ".concat(i));
  return {
    text: s,
    options: l,
    metadata: d
  };
}
function _Q() {
  var e = kQ(arguments), t = e.text, r = e.options, n = e.metadata;
  return hQ(t, r, n);
}
function kc(e) {
  "@babel/helpers - typeof";
  return kc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, kc(e);
}
function xQ(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function EQ(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, CQ(n.key), n);
  }
}
function SQ(e, t, r) {
  return t && EQ(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function CQ(e) {
  var t = TQ(e, "string");
  return kc(t) == "symbol" ? t : t + "";
}
function TQ(e, t) {
  if (kc(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (kc(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var AQ = /* @__PURE__ */ (function() {
  function e(t) {
    var r = t.onCountryChange, n = t.onCallingCodeChange;
    xQ(this, e), this.onCountryChange = r, this.onCallingCodeChange = n;
  }
  return SQ(e, [{
    key: "reset",
    value: function(t) {
      var r = t.country, n = t.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, n);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberIsModified = !1, this.nationalPrefix = void 0, this.carrierCode = void 0, this.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix = void 0;
    }
  }, {
    key: "update",
    value: function(t) {
      for (var r = 0, n = Object.keys(t); r < n.length; r++) {
        var i = n[r];
        this[i] = t[i];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(t, r) {
      this.setCountry(t), this.setCallingCode(r);
    }
  }, {
    key: "setCountry",
    value: function(t) {
      this.country = t, this.onCountryChange(t);
    }
  }, {
    key: "setCallingCode",
    value: function(t) {
      this.callingCode = t, this.onCallingCodeChange(t, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, r) {
      this.international = !0, this.initCountryAndCallingCode(t, r);
    }
  }, {
    key: "appendDigits",
    value: function(t) {
      this.digits += t;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(t) {
      this.nationalSignificantNumber += t;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]);
})();
function OQ(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = PQ(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function PQ(e, t) {
  if (e) {
    if (typeof e == "string") return dy(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? dy(e, t) : void 0;
  }
}
function dy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Hn = "x", Mf = new RegExp(Hn);
function v0(e, t) {
  if (t < 1)
    return "";
  for (var r = ""; t > 1; )
    t & 1 && (r += e), t >>= 1, e += e;
  return r + e;
}
function cy(e, t) {
  return e[t] === ")" && t++, IQ(e.slice(0, t));
}
function IQ(e) {
  for (var t = [], r = 0; r < e.length; )
    e[r] === "(" ? t.push(r) : e[r] === ")" && t.pop(), r++;
  var n = 0, i = "";
  t.push(e.length);
  for (var a = 0, o = t; a < o.length; a++) {
    var s = o[a];
    i += e.slice(n, s), n = s + 1;
  }
  return i;
}
function DQ(e, t, r) {
  for (var n = OQ(r.split("")), i; !(i = n()).done; ) {
    var a = i.value;
    if (e.slice(t + 1).search(Mf) < 0)
      return;
    t = e.search(Mf), e = e.replace(Mf, a);
  }
  return [e, t];
}
function NQ(e, t, r) {
  var n = r.metadata, i = r.shouldTryNationalPrefixFormattingRule, a = r.getSeparatorAfterNationalPrefix, o = new RegExp("^(?:".concat(t.pattern(), ")$"));
  if (o.test(e.nationalSignificantNumber))
    return RQ(e, t, {
      metadata: n,
      shouldTryNationalPrefixFormattingRule: i,
      getSeparatorAfterNationalPrefix: a
    });
}
function MQ(e, t, r) {
  return oh(e, t, r) === "IS_POSSIBLE";
}
function RQ(e, t, r) {
  var n = r.metadata, i = r.shouldTryNationalPrefixFormattingRule, a = r.getSeparatorAfterNationalPrefix;
  if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, i(t)) {
    var o = uy(e, t, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: a,
      metadata: n
    });
    if (o)
      return o;
  }
  return uy(e, t, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: a,
    metadata: n
  });
}
function uy(e, t, r) {
  var n = r.metadata, i = r.useNationalPrefixFormattingRule, a = r.getSeparatorAfterNationalPrefix, o = Ew(e.nationalSignificantNumber, t, {
    carrierCode: e.carrierCode,
    useInternationalFormat: e.international,
    withNationalPrefix: i,
    metadata: n
  });
  if (i || (e.nationalPrefix ? o = e.nationalPrefix + a(t) + o : e.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix && (o = e.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix + " " + o)), LQ(o, e))
    return o;
}
function LQ(e, t) {
  return c1(e) === t.getNationalDigits();
}
function _c(e) {
  "@babel/helpers - typeof";
  return _c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _c(e);
}
function FQ(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function jQ(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, VQ(n.key), n);
  }
}
function zQ(e, t, r) {
  return t && jQ(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function VQ(e) {
  var t = UQ(e, "string");
  return _c(t) == "symbol" ? t : t + "";
}
function UQ(e, t) {
  if (_c(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (_c(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var qQ = /* @__PURE__ */ (function() {
  function e() {
    FQ(this, e);
  }
  return zQ(e, [{
    key: "parse",
    value: function(t) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(t), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var r = this.context[0], n = r.branches, i = r.instructions;
      if (n)
        return {
          op: "|",
          args: n.concat([Rf(i)])
        };
      if (i.length === 0)
        throw new Error("Pattern is required");
      return i.length === 1 ? i[0] : i;
    }
  }, {
    key: "startContext",
    value: function(t) {
      this.context.push(t);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(t) {
      if (!t)
        throw new Error("Pattern is required");
      var r = t.match(WQ);
      if (!r) {
        if (HQ.test(t))
          throw new Error("Illegal characters found in a pattern: ".concat(t));
        this.getContext().instructions = this.getContext().instructions.concat(t.split(""));
        return;
      }
      var n = r[1], i = t.slice(0, r.index), a = t.slice(r.index + n.length);
      switch (n) {
        case "(?:":
          i && this.parsePattern(i), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (i && this.parsePattern(i), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var o = this.getContext(), s = o.branches;
          s.push(Rf(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: s
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (i && this.parsePattern(i), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(Rf(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          i && this.parsePattern(i), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: BQ(i)
          });
          break;
        /* istanbul ignore next */
        default:
          throw new Error("Unknown operator: ".concat(n));
      }
      a && this.parsePattern(a);
    }
  }]);
})();
function BQ(e) {
  for (var t = [], r = 0; r < e.length; ) {
    if (e[r] === "-") {
      if (r === 0 || r === e.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var n = e[r - 1].charCodeAt(0) + 1, i = e[r + 1].charCodeAt(0) - 1, a = n; a <= i; )
        t.push(String.fromCharCode(a)), a++;
    } else
      t.push(e[r]);
    r++;
  }
  return t;
}
var HQ = /[\(\)\[\]\?\:\|]/, WQ = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function Rf(e) {
  return e.length === 1 ? e[0] : e;
}
function hy(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = KQ(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function KQ(e, t) {
  if (e) {
    if (typeof e == "string") return fy(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? fy(e, t) : void 0;
  }
}
function fy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function xc(e) {
  "@babel/helpers - typeof";
  return xc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xc(e);
}
function QQ(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function GQ(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, JQ(n.key), n);
  }
}
function YQ(e, t, r) {
  return t && GQ(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function JQ(e) {
  var t = ZQ(e, "string");
  return xc(t) == "symbol" ? t : t + "";
}
function ZQ(e, t) {
  if (xc(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (xc(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var XQ = /* @__PURE__ */ (function() {
  function e(t) {
    QQ(this, e), this.matchTree = new qQ().parse(t);
  }
  return YQ(e, [{
    key: "match",
    value: function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.allowOverflow;
      if (!t)
        throw new Error("String is required");
      var i = Jp(t.split(""), this.matchTree, !0);
      if (i && i.match && delete i.matchedChars, !(i && i.overflow && !n))
        return i;
    }
  }]);
})();
function Jp(e, t, r) {
  if (typeof t == "string") {
    var n = e.join("");
    return t.indexOf(n) === 0 ? e.length === t.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : n.indexOf(t) === 0 ? r && e.length > t.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, t.length)
    } : void 0;
  }
  if (Array.isArray(t)) {
    for (var i = e.slice(), a = 0; a < t.length; ) {
      var o = t[a], s = Jp(i, o, r && a === t.length - 1);
      if (s) {
        if (s.overflow)
          return s;
        if (s.match) {
          if (i = i.slice(s.matchedChars.length), i.length === 0)
            return a === t.length - 1 ? {
              match: !0,
              matchedChars: e
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (s.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(s, null, 2)));
        }
      } else return;
      a++;
    }
    return r ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - i.length)
    };
  }
  switch (t.op) {
    case "|":
      for (var l, d = hy(t.args), c; !(c = d()).done; ) {
        var u = c.value, h = Jp(e, u, r);
        if (h) {
          if (h.overflow)
            return h;
          if (h.match)
            return {
              match: !0,
              matchedChars: h.matchedChars
            };
          if (h.partialMatch)
            l = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(h, null, 2)));
        }
      }
      return l ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var f = hy(t.args), p; !(p = f()).done; ) {
        var m = p.value;
        if (e[0] === m)
          return e.length === 1 ? {
            match: !0,
            matchedChars: e
          } : r ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [m]
          };
      }
      return;
    /* istanbul ignore next */
    default:
      throw new Error("Unsupported instruction tree: ".concat(t));
  }
}
function Ec(e) {
  "@babel/helpers - typeof";
  return Ec = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ec(e);
}
function py(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = eG(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eG(e, t) {
  if (e) {
    if (typeof e == "string") return my(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? my(e, t) : void 0;
  }
}
function my(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function tG(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function rG(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, iG(n.key), n);
  }
}
function nG(e, t, r) {
  return t && rG(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function iG(e) {
  var t = aG(e, "string");
  return Ec(t) == "symbol" ? t : t + "";
}
function aG(e, t) {
  if (Ec(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ec(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Zp = "9", oG = 15, sG = v0(Zp, oG), lG = /[- ]/, dG = function() {
  return /\[([^\[\]])*\]/g;
}, cG = function() {
  return /\d(?=[^,}][^,}])/g;
}, uG = new RegExp("[" + ai + "]*\\$1[" + ai + "]*(\\$\\d[" + ai + "]*)*$"), gy = 3, hG = /* @__PURE__ */ (function() {
  function e(t) {
    t.state;
    var r = t.metadata;
    tG(this, e), this.metadata = r, this.resetFormat();
  }
  return nG(e, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(t, r) {
      this.resetFormat(), t ? (this.isNANP = t.callingCode() === "1", this.matchingFormats = t.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(t, r) {
      var n = this;
      if (MQ(r.nationalSignificantNumber, r.country, this.metadata))
        for (var i = py(this.matchingFormats), a; !(a = i()).done; ) {
          var o = a.value, s = NQ(r, o, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(l) {
              return n.shouldTryNationalPrefixFormattingRule(l, {
                international: r.international,
                nationalPrefix: r.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(l) {
              return n.getSeparatorAfterNationalPrefix(l);
            }
          });
          if (s)
            return this.resetFormat(), this.chosenFormat = o, this.setNationalNumberTemplate(s.replace(/\d/g, Hn), r), this.populatedNationalNumberTemplate = s, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(Hn), s;
        }
      return this.formatNationalNumberWithNextDigits(t, r);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(t, r) {
      var n = this.chosenFormat, i = this.chooseFormat(r);
      if (i)
        return i === n ? this.formatNextNationalNumberDigits(t) : this.formatNextNationalNumberDigits(r.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(t) {
      var r = this, n = t.nationalSignificantNumber, i = t.nationalPrefix, a = t.international, o = n, s = o.length - gy;
      s < 0 && (s = 0), this.matchingFormats = this.matchingFormats.filter(function(l) {
        return r.formatSuits(l, a, i) && r.formatMatches(l, o, s);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(t, r, n) {
      return !(n && !t.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !t.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !n && t.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(t, r, n) {
      var i = t.leadingDigitsPatterns().length;
      if (i === 0)
        return !0;
      n = Math.min(n, i - 1);
      var a = t.leadingDigitsPatterns()[n];
      if (r.length < gy)
        try {
          return new XQ(a).match(r, {
            allowOverflow: !0
          }) !== void 0;
        } catch (o) {
          return console.error(o), !0;
        }
      return new RegExp("^(".concat(a, ")")).test(r);
    }
  }, {
    key: "getFormatFormat",
    value: function(t, r) {
      return r ? t.internationalFormat() : t.format();
    }
  }, {
    key: "chooseFormat",
    value: function(t) {
      for (var r = this, n = function() {
        var s = o.value;
        return r.chosenFormat === s ? 0 : uG.test(r.getFormatFormat(s, t.international)) ? r.createTemplateForFormat(s, t) ? (r.chosenFormat = s, 0) : (r.matchingFormats = r.matchingFormats.filter(function(l) {
          return l !== s;
        }), 1) : 1;
      }, i, a = py(this.matchingFormats.slice()), o; !(o = a()).done && (i = n(), i !== 0); )
        ;
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(t, r) {
      if (!(t.pattern().indexOf("|") >= 0)) {
        var n = this.getTemplateForFormat(t, r);
        if (n)
          return this.setNationalNumberTemplate(n, r), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(t) {
      return this.isNANP || t && t.nationalPrefixFormattingRule() && lG.test(t.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(t, r) {
      var n = t.IDDPrefix, i = t.missingPlus;
      return n ? r && r.spacing === !1 ? n : n + " " : i ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(t) {
      if (this.template) {
        for (var r = -1, n = 0, i = t.international ? this.getInternationalPrefixBeforeCountryCallingCode(t, {
          spacing: !1
        }) : ""; n < i.length + t.getDigitsWithoutInternationalPrefix().length; )
          r = this.template.indexOf(Hn, r + 1), n++;
        return cy(this.template, r + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(t, r) {
      this.nationalNumberTemplate = t, this.populatedNationalNumberTemplate = t, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, Hn) + v0(Hn, r.callingCode.length) + " " + t : this.template = t;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(t, r) {
      var n = r.nationalSignificantNumber, i = r.international, a = r.nationalPrefix, o = r.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix, s = t.pattern();
      s = s.replace(dG(), "\\d").replace(cG(), "\\d");
      var l = sG.match(s)[0];
      if (!(n.length > l.length)) {
        var d = new RegExp("^" + s + "$"), c = n.replace(/\d/g, Zp);
        d.test(c) && (l = c);
        var u = this.getFormatFormat(t, i), h;
        if (this.shouldTryNationalPrefixFormattingRule(t, {
          international: i,
          nationalPrefix: a
        })) {
          var f = u.replace(xw, t.nationalPrefixFormattingRule());
          if (c1(t.nationalPrefixFormattingRule()) === (a || "") + c1("$1") && (u = f, h = !0, a))
            for (var p = a.length; p > 0; )
              u = u.replace(/\d/, Hn), p--;
        }
        var m = l.replace(new RegExp(s), u).replace(new RegExp(Zp, "g"), Hn);
        return h || (o ? m = v0(Hn, o.length) + " " + m : a && (m = v0(Hn, a.length) + this.getSeparatorAfterNationalPrefix(t) + m)), i && (m = _w(m)), m;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(t) {
      var r = DQ(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, t);
      if (!r) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], cy(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(t, r) {
      var n = r.international, i = r.nationalPrefix;
      if (t.nationalPrefixFormattingRule()) {
        var a = t.usesNationalPrefix();
        if (a && i || !a && !n)
          return !0;
      }
    }
  }]);
})();
function Sc(e) {
  "@babel/helpers - typeof";
  return Sc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Sc(e);
}
function Pw(e, t) {
  return gG(e) || mG(e, t) || pG(e, t) || fG();
}
function fG() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pG(e, t) {
  if (e) {
    if (typeof e == "string") return vy(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? vy(e, t) : void 0;
  }
}
function vy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function mG(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], l = !0, d = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); l = !0) ;
    } catch (c) {
      d = !0, i = c;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (d) throw i;
      }
    }
    return s;
  }
}
function gG(e) {
  if (Array.isArray(e)) return e;
}
function vG(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function yG(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wG(n.key), n);
  }
}
function bG(e, t, r) {
  return t && yG(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function wG(e) {
  var t = $G(e, "string");
  return Sc(t) == "symbol" ? t : t + "";
}
function $G(e, t) {
  if (Sc(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Sc(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var kG = "[" + ai + Zr + "]+", _G = new RegExp("^" + kG + "$", "i"), xG = "(?:[" + sh + "][" + ai + Zr + "]*|[" + ai + Zr + "]+)", EG = new RegExp("[^" + ai + Zr + "]+.*$"), SG = /[^\d\[\]]/, CG = /* @__PURE__ */ (function() {
  function e(t) {
    var r = t.defaultCountry, n = t.defaultCallingCode, i = t.metadata, a = t.onNationalSignificantNumberChange;
    vG(this, e), this.defaultCountry = r, this.defaultCallingCode = n, this.metadata = i, this.onNationalSignificantNumberChange = a;
  }
  return bG(e, [{
    key: "input",
    value: function(t, r) {
      var n = OG(t), i = Pw(n, 2), a = i[0], o = i[1], s = c1(a), l;
      return o && (r.digits || (r.startInternationalNumber(void 0, void 0), s || (l = !0))), s && this.inputDigits(s, r), {
        digits: s,
        justLeadingPlus: l
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(t, r) {
      var n = r.digits, i = n.length < 3 && n.length + t.length >= 3;
      if (r.appendDigits(t), i && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
        if (!this.extractCountryCallingCode(r))
          return;
      } else
        r.appendNationalSignificantNumberDigits(t);
      r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(a) {
        return r.update(a);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(t) {
      var r = t.international, n = t.callingCode;
      return r && !n;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(t) {
      var r = Km("+" + t.getDigitsWithoutInternationalPrefix(), t.country, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), n = r.countryCallingCode, i = r.number;
      if (n)
        return t.setCallingCode(n), t.update({
          nationalSignificantNumber: i
        }), !0;
    }
  }, {
    key: "reset",
    value: function(t) {
      if (t) {
        this.hasSelectedNumberingPlan = !0;
        var r = t._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = r && SG.test(r);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(t, r) {
      if (this.hasSelectedNumberingPlan) {
        var n = Hp(t, this.metadata), i = n.nationalPrefix, a = n.nationalNumber, o = n.carrierCode;
        if (a !== t)
          return this.onExtractedNationalNumber(i, o, a, t, r), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(t, r, n) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(t, n);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var i = Hp(t, this.metadata), a = i.nationalPrefix, o = i.nationalNumber, s = i.carrierCode;
        if (o !== r)
          return this.onExtractedNationalNumber(a, s, o, t, n), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(t, r, n, i, a) {
      var o = !1, s, l = i.lastIndexOf(n);
      if (l < 0 || l !== i.length - n.length)
        o = !0;
      else {
        var d = i.slice(0, l);
        d && d !== t && (s = d);
      }
      a({
        nationalPrefix: t,
        carrierCode: r,
        nationalSignificantNumber: n,
        nationalSignificantNumberIsModified: o,
        prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix: s
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(t) {
      if (this.extractAnotherNationalSignificantNumber(t.getNationalDigits(), t.nationalSignificantNumber, function(r) {
        return t.update(r);
      }))
        return !0;
      if (this.extractIddPrefix(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
      if (this.fixMissingPlus(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(t) {
      var r = t.international, n = t.IDDPrefix, i = t.digits;
      if (t.nationalSignificantNumber, !(r || n)) {
        var a = ww(i, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (a !== void 0 && a !== i)
          return t.update({
            IDDPrefix: i.slice(0, i.length - a.length)
          }), this.startInternationalNumber(t, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(t) {
      if (!t.international) {
        var r = kw(t.digits, t.country, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), n = r.countryCallingCode;
        if (n)
          return t.update({
            missingPlus: !0
          }), this.startInternationalNumber(t, {
            country: t.country,
            callingCode: n
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, r) {
      var n = r.country, i = r.callingCode;
      t.startInternationalNumber(n, i), t.nationalSignificantNumber && (t.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(t) {
      this.extractCountryCallingCode(t) && this.extractNationalSignificantNumber(t.getNationalDigits(), function(r) {
        return t.update(r);
      });
    }
  }]);
})();
function TG(e) {
  var t = e.search(xG);
  if (!(t < 0)) {
    e = e.slice(t);
    var r;
    return e[0] === "+" && (r = !0, e = e.slice(1)), e = e.replace(EG, ""), r && (e = "+" + e), e;
  }
}
function AG(e) {
  var t = TG(e) || "";
  return t[0] === "+" ? [t.slice(1), !0] : [t];
}
function OG(e) {
  var t = AG(e), r = Pw(t, 2), n = r[0], i = r[1];
  return _G.test(n) || (n = ""), [n, i];
}
function Cc(e) {
  "@babel/helpers - typeof";
  return Cc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cc(e);
}
function PG(e, t) {
  return MG(e) || NG(e, t) || DG(e, t) || IG();
}
function IG() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function DG(e, t) {
  if (e) {
    if (typeof e == "string") return yy(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? yy(e, t) : void 0;
  }
}
function yy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function NG(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], l = !0, d = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); l = !0) ;
    } catch (c) {
      d = !0, i = c;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (d) throw i;
      }
    }
    return s;
  }
}
function MG(e) {
  if (Array.isArray(e)) return e;
}
function RG(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function LG(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, jG(n.key), n);
  }
}
function FG(e, t, r) {
  return t && LG(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function jG(e) {
  var t = zG(e, "string");
  return Cc(t) == "symbol" ? t : t + "";
}
function zG(e, t) {
  if (Cc(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Cc(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Iw = /* @__PURE__ */ (function() {
  function e(t, r) {
    RG(this, e), this.metadata = new Ar(r);
    var n = this.getCountryAndCallingCode(t), i = PG(n, 2), a = i[0], o = i[1];
    this.defaultCountry = a, this.defaultCallingCode = o, this.reset();
  }
  return FG(e, [{
    key: "getCountryAndCallingCode",
    value: function(t) {
      var r, n;
      return t && (Uo(t) ? (r = t.defaultCountry, n = t.defaultCallingCode) : r = t), r && !this.metadata.hasCountry(r) && (r = void 0), [r, n];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(t) {
      var r = this.parser.input(t, this.state), n = r.digits, i = r.justLeadingPlus;
      if (i)
        this.formattedOutput = "+";
      else if (n) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var a;
        if (this.metadata.hasSelectedNumberingPlan() && (a = this.formatter.format(n, this.state)), a === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var o = this.state.getNationalDigits();
          o && (a = this.formatter.format(o, this.state));
        }
        this.formattedOutput = a ? this.getFullNumber(a) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var t = this;
      return this.state = new AQ({
        onCountryChange: function(r) {
          t.country = r;
        },
        onCallingCodeChange: function(r, n) {
          t.metadata.selectNumberingPlan(n, r), t.formatter.reset(t.metadata.numberingPlan, t.state), t.parser.reset(t.metadata.numberingPlan);
        }
      }), this.formatter = new hG({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new CG({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          t.determineTheCountryIfNeeded(), t.formatter.reset(t.metadata.numberingPlan, t.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var t = this.state.digits;
      if (t)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var t = this.state.country;
      return t;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(t) {
      var r = this;
      if (this.isInternational()) {
        var n = function(a) {
          return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
            spacing: !!a
          }) + a;
        }, i = this.state.callingCode;
        return n(i ? t ? "".concat(i, " ").concat(t) : i : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return t;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var t = this.state, r = t.nationalSignificantNumber, n = t.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix, i = t.nationalPrefix, a = r, o = n || i;
      return o && (a = o + a), a;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var t = this.state.nationalSignificantNumberIsModified;
      return this.getFullNumber(t ? this.state.getNationalDigits() : this.getNonFormattedNationalNumberWithPrefix());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var t = this.getNonFormattedNumber();
      if (t)
        return t.replace(/[\+\d]/g, Hn);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var t = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(t);
      return r && r.length > 1;
    }
    // Determines the exact country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(Wm(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var t = this.state, r = t.digits, n = t.callingCode, i = t.country, a = t.nationalSignificantNumber;
      if (r) {
        if (this.isInternational())
          return n ? "+" + n + a : "+" + r;
        if (i || n) {
          var o = i ? this.metadata.countryCallingCode() : n;
          return "+" + o + a;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var t = this.state, r = t.nationalSignificantNumber, n = t.carrierCode, i = t.callingCode, a = this._getCountry();
      if (r && !(!a && !i)) {
        if (a && a === this.defaultCountry) {
          var o = new Ar(this.metadata.metadata);
          o.selectNumberingPlan(a);
          var s = o.numberingPlan.callingCode(), l = this.metadata.getCountryCodesForCallingCode(s);
          if (l.length > 1) {
            var d = $w(r, {
              countries: l,
              metadata: this.metadata.metadata
            });
            d && (a = d);
          }
        }
        var c = new Tw(a || i, r, this.metadata.metadata);
        return n && (c.carrierCode = n), c;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var t = this.getNumber();
      return t ? t.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var t = this.getNumber();
      return t ? t.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]);
})();
function Dw() {
  return EW(_Q, arguments);
}
function u1(e) {
  return Iw.call(this, e, gw);
}
u1.prototype = Object.create(Iw.prototype, {});
u1.prototype.constructor = u1;
function VG(e) {
  const [t, r] = z(e.value ? by(e.value) : "");
  return le(() => {
    e.value && r(by(e.value));
  }), v(Tt, {
    type: "tel",
    placeholder: "(   ) ___-____",
    get value() {
      return t();
    },
    onInput: (n) => {
      r(n.currentTarget.value), e.onPhoneChange?.(UG(n.currentTarget.value));
    },
    get onBlur() {
      return e.onBlur;
    },
    get required() {
      return e.required;
    },
    get disabled() {
      return e.disabled;
    }
  });
}
function by(e) {
  try {
    if (e.length > 2)
      return new u1("US").input(Dw(e, "US").formatNational());
  } catch {
  }
  return e;
}
function UG(e) {
  try {
    return Dw(e, "US").format("E.164");
  } catch {
    return e;
  }
}
var qG = /* @__PURE__ */ k("<option value disabled>Select sex"), BG = /* @__PURE__ */ k("<option>");
const Nw = [{
  value: "MALE",
  name: "Male"
}, {
  value: "FEMALE",
  name: "Female"
}, {
  value: "UNKNOWN",
  name: "Unknown"
}];
function HG(e) {
  return v(Xc, {
    get value() {
      return e.value;
    },
    get required() {
      return e.required;
    },
    get disabled() {
      return e.disabled;
    },
    get onChange() {
      return e.onChange;
    },
    get onBlur() {
      return e.onBlur;
    },
    get children() {
      return [qG(), v(dt, {
        each: Nw,
        children: (t) => (() => {
          var r = BG();
          return C(r, () => t.name), te(() => r.selected = e.value === t.value), te(() => r.value = t.value), r;
        })()
      })];
    }
  });
}
var WG = /* @__PURE__ */ k("<option value disabled>Select gender"), KG = /* @__PURE__ */ k("<option>");
const QG = [{
  value: "Male/Man",
  name: "Male/Man"
}, {
  value: "Female/Woman",
  name: "Female/Woman"
}, {
  value: "TransMale/TransMan",
  name: "TransMale/TransMan"
}, {
  value: "TransFemale/TransWoman",
  name: "TransFemale/TransWoman"
}, {
  value: "Genderqueer/Gender nonconforming",
  name: "Genderqueer/Gender nonconforming"
}, {
  value: "Something else",
  name: "Something else"
}, {
  value: "Decline to answer",
  name: "Decline to answer"
}];
function GG(e) {
  return v(Xc, {
    get value() {
      return e.value;
    },
    get required() {
      return e.required;
    },
    get disabled() {
      return e.disabled;
    },
    get onChange() {
      return e.onChange;
    },
    get onBlur() {
      return e.onBlur;
    },
    get children() {
      return [WG(), v(dt, {
        each: QG,
        children: (t) => (() => {
          var r = KG();
          return C(r, () => t.name), te(() => r.selected = e.value === t.value), te(() => r.value = t.value), r;
        })()
      })];
    }
  });
}
const YG = () => {
}, wy = (e, t) => t();
function JG(e, t) {
  const r = Le(e), n = r ? [r] : [], { onEnter: i = wy, onExit: a = wy } = t, [o, s] = z(t.appear ? [] : n), [l] = D_();
  let d, c = !1;
  function u(p, m) {
    if (!p)
      return m && m();
    c = !0, a(p, () => {
      A0(() => {
        c = !1, s((y) => y.filter((g) => g !== p)), m && m();
      });
    });
  }
  function h(p) {
    const m = d;
    if (!m)
      return p && p();
    d = void 0, s((y) => [m, ...y]), i(m, p ?? YG);
  }
  const f = t.mode === "out-in" ? (
    // exit -> enter
    // exit -> enter
    ((p) => c || u(p, h))
  ) : t.mode === "in-out" ? (
    // enter -> exit
    // enter -> exit
    ((p) => h(() => u(p)))
  ) : (
    // exit & enter
    // exit & enter
    ((p) => {
      u(p), h();
    })
  );
  return J5((p) => {
    const m = e();
    return Le(l) ? (l(), p) : (m !== p && (d = m, A0(() => Le(() => f(p)))), m);
  }, t.appear ? void 0 : r), o;
}
const $y = (e) => e instanceof Element;
function Xp(e, t) {
  if (t(e))
    return e;
  if (typeof e == "function" && !e.length)
    return Xp(e(), t);
  if (Array.isArray(e))
    for (const r of e) {
      const n = Xp(r, t);
      if (n)
        return n;
    }
  return null;
}
function ZG(e, t = $y, r = $y) {
  const n = B(e);
  return B(() => Xp(n(), t));
}
function XG(e) {
  return B(() => {
    const t = e.name || "s";
    return {
      enterActive: (e.enterActiveClass || t + "-enter-active").split(" "),
      enter: (e.enterClass || t + "-enter").split(" "),
      enterTo: (e.enterToClass || t + "-enter-to").split(" "),
      exitActive: (e.exitActiveClass || t + "-exit-active").split(" "),
      exit: (e.exitClass || t + "-exit").split(" "),
      exitTo: (e.exitToClass || t + "-exit-to").split(" "),
      move: (e.moveClass || t + "-move").split(" ")
    };
  });
}
function Mw(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
function eY(e, t, r, n) {
  const { onBeforeEnter: i, onEnter: a, onAfterEnter: o } = t;
  i?.(r), r.classList.add(...e.enter), r.classList.add(...e.enterActive), queueMicrotask(() => {
    if (!r.parentNode)
      return n?.();
    a?.(r, () => s());
  }), Mw(() => {
    r.classList.remove(...e.enter), r.classList.add(...e.enterTo), (!a || a.length < 2) && (r.addEventListener("transitionend", s), r.addEventListener("animationend", s));
  });
  function s(l) {
    (!l || l.target === r) && (n?.(), r.removeEventListener("transitionend", s), r.removeEventListener("animationend", s), r.classList.remove(...e.enterActive), r.classList.remove(...e.enterTo), o?.(r));
  }
}
function tY(e, t, r, n) {
  const { onBeforeExit: i, onExit: a, onAfterExit: o } = t;
  if (!r.parentNode)
    return n?.();
  i?.(r), r.classList.add(...e.exit), r.classList.add(...e.exitActive), a?.(r, () => s()), Mw(() => {
    r.classList.remove(...e.exit), r.classList.add(...e.exitTo), (!a || a.length < 2) && (r.addEventListener("transitionend", s), r.addEventListener("animationend", s));
  });
  function s(l) {
    (!l || l.target === r) && (n?.(), r.removeEventListener("transitionend", s), r.removeEventListener("animationend", s), r.classList.remove(...e.exitActive), r.classList.remove(...e.exitTo), o?.(r));
  }
}
const rY = {
  inout: "in-out",
  outin: "out-in"
}, ky = (e) => {
  const t = XG(e);
  return JG(ZG(() => e.children), {
    mode: rY[e.mode],
    appear: e.appear,
    onEnter(r, n) {
      eY(t(), e, r, n);
    },
    onExit(r, n) {
      tY(t(), e, r, n);
    }
  });
}, zu = (e, t) => (r, n) => {
  r.animate(e, t).finished.then(n);
};
var nY = /* @__PURE__ */ k('<div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity">'), iY = /* @__PURE__ */ k('<div class="relative z-100">'), aY = /* @__PURE__ */ k('<div class="absolute right-0 top-0 pr-4 pt-4 sm:pr-6 sm:pt-6 sm:block"><button type=button class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"><span class=sr-only>Close'), oY = /* @__PURE__ */ k('<div class="fixed inset-0 z-20 overflow-y-auto"><div><div>');
const Vu = 100;
function os(e) {
  const t = Ke({
    size: "md",
    open: !1,
    position: "center"
  }, e), r = B(() => jt("relative transform rounded-lg bg-white p-4 text-left shadow-xl transition-all sm:my-8 w-full sm:p-6", {
    "sm:max-w-lg": t.size === "lg",
    "sm:max-w-sm": t.size === "md"
  }));
  return le(() => {
    const n = window?.zE;
    n && (t.open ? n("messenger", "hide") : n("messenger", "show"));
  }), (() => {
    var n = iY();
    return C(n, v(ky, {
      get onEnter() {
        return zu([{
          opacity: 0
        }, {
          opacity: 1
        }], {
          duration: Vu,
          easing: "ease-in"
        });
      },
      get onExit() {
        return zu([{
          opacity: 1
        }, {
          opacity: 0
        }], {
          duration: Vu,
          easing: "ease-out"
        });
      },
      get children() {
        return v(q, {
          get when() {
            return t.open;
          },
          get children() {
            return nY();
          }
        });
      }
    }), null), C(n, v(ky, {
      get onEnter() {
        return zu([{
          opacity: 0,
          transform: "scale(0.95)"
        }, {
          opacity: 1,
          transform: "scale(1)"
        }], {
          duration: Vu,
          easing: "ease-in"
        });
      },
      get onExit() {
        return zu([{
          opacity: 1,
          transform: "scale(1)"
        }, {
          opacity: 0,
          transform: "scale(0.95)"
        }], {
          duration: Vu,
          easing: "ease-out"
        });
      },
      get children() {
        return Pt(() => !!t.open)() && (() => {
          var i = oY(), a = i.firstChild, o = a.firstChild;
          return C(o, v(q, {
            get when() {
              return t?.onClose;
            },
            get children() {
              var s = aY(), l = s.firstChild;
              return l.firstChild, Y0(l, "click", t.onClose, !0), C(l, v(et, {
                name: "xMark",
                class: "h-6 w-6",
                "aria-hidden": "true"
              }), null), s;
            }
          }), null), C(o, () => t.children, null), te((s) => {
            var l = jt("flex min-h-full justify-center p-4 text-center sm:p-0", {
              "items-end": t.position === "bottom",
              "items-center": t.position === "center"
            }), d = r();
            return l !== s.e && rt(a, s.e = l), d !== s.t && rt(o, s.t = d), s;
          }, {
            e: void 0,
            t: void 0
          }), i;
        })();
      }
    }), null), n;
  })();
}
qr(["click"]);
const _y = ["mcg", "mg", "g"], xy = ["mL", "L"], Ey = ["mcg/kg", "mg/kg", "g/kg"], e5 = (e) => 0.453592 * e, t5 = (e) => 2.20462 * e, Rw = (e) => e / 16, Lw = (e) => e / 1e3, Sy = (e) => e5(Rw(e)), Cy = (e) => t5(Lw(e)), Ty = (e) => 1e3 * e, Ay = (e) => 16 * e, sY = {
  lb: {
    lb: (e) => e,
    kg: e5,
    oz: (e) => 16 * e,
    g: (e) => Ty(e5(e))
  },
  kg: {
    lb: t5,
    kg: (e) => e,
    oz: (e) => Ay(t5(e)),
    g: (e) => 1e3 * e
  },
  oz: {
    lb: Rw,
    kg: Sy,
    oz: (e) => e,
    g: (e) => Ty(Sy(e))
  },
  g: {
    lb: Cy,
    kg: Lw,
    oz: (e) => Ay(Cy(e)),
    g: (e) => e
  }
}, lY = (e, t) => sY[t.unit][e](t.value), dY = {
  g: {
    g: (e) => e,
    mcg: (e) => e * 1e3 * 1e3,
    mg: (e) => e * 1e3
  },
  mg: {
    g: (e) => e / 1e3,
    mg: (e) => e,
    mcg: (e) => e * 1e3
  },
  mcg: {
    g: (e) => e / (1e3 * 1e3),
    mg: (e) => e / 1e3,
    mcg: (e) => e
  }
}, cY = (e) => e.split("/")[0], uY = (e, t) => dY[t.unit][cY(e)](t.value), hY = (e) => {
  switch (e) {
    case "g/kg":
    case "mg/kg":
    case "mcg/kg":
      return "kg";
  }
}, fY = (e, t) => e.value * lY(hY(e.unit), t), pY = (e, t, r) => {
  const n = r.unit === "L" ? r.value * 1e3 : r.value;
  return e.value * n / uY(e.unit, t);
};
var mY = /* @__PURE__ */ k("<option>");
function ud(e) {
  return v(Xc, {
    get value() {
      return e.selected;
    },
    onChange: (t) => e.setSelected(t.currentTarget.value),
    get children() {
      return v(dt, {
        get each() {
          return e.options;
        },
        children: (t) => (() => {
          var r = mY();
          return r.value = t, C(r, t), te(() => r.selected = e.selected === t), r;
        })()
      });
    }
  });
}
var gY = /* @__PURE__ */ k('<div class="flex items-center"><h2>Calculate Dose Quantity'), vY = /* @__PURE__ */ k("<p>Enter desired dosage and patient weight to calculate total and dose quantity."), yY = /* @__PURE__ */ k('<div class=my-8><div class="flex items-center"><h3>Selected Medication</h3></div><p>'), bY = /* @__PURE__ */ k('<div class="grid grid-cols-1 sm:grid-cols-2 gap-4"><div class="grid grid-cols-2 gap-4 sm:gap-2"></div><div class="flex gap-4 items-center"><div>per</div><div class=grow>'), wY = /* @__PURE__ */ k('<div class="grid grid-cols-1 sm:grid-cols-2 gap-4"><div class="grid grid-cols-2 gap-4 sm:gap-2">'), Oy = /* @__PURE__ */ k('<div class="flex gap-4 sm:gap-2">'), $Y = /* @__PURE__ */ k('<section class=mt-8><div class="flex items-center"><h3>Dosage Inputs</h3></div><div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">'), kY = /* @__PURE__ */ k('<section class=mt-8><div class="flex items-center"><h3>Frequency</h3></div><div class="grid grid-cols-2 gap-4">'), _Y = /* @__PURE__ */ k('<section class=mt-8><div class="flex items-center"><h3>Dosage</h3></div><div class="grid grid-cols-2 gap-4"></div><hr class="h-px mb-4 bg-gray-200 border-0 dark:bg-gray-700 w-full"><div class="grid grid-cols-2 gap-4">'), xY = /* @__PURE__ */ k('<div class="mt-8 flex gap-4 justify-end">');
const gs = (e) => parseFloat(e.toFixed(1)), Py = ["day", "dose"], Iy = ["lb", "kg"], EY = (e) => {
  switch (e?.toLowerCase()) {
    case "kg":
    case "kgs":
      return "kg";
    case "lb":
    case "lbs":
      return "lb";
    default:
      return;
  }
}, Uu = (e) => isNaN(e) || !isFinite(e) ? 0 : e;
function SY(e) {
  const [t, r] = z(0), [n, i] = z(Ey[1]), [a, o] = z(Py[0]), [s, l] = z(0), [d, c] = z(Iy[0]), [u, h] = z(0), [f, p] = z(_y[1]), [m, y] = z(0), [g, w] = z(xy[0]), [$, _] = z(1), [x, S] = z(1);
  Ht(() => {
    const L = EY(e.weightUnit);
    L ? (e.weight && l(e.weight), e.weightUnit && c(L)) : (l(0), c("lb"));
  });
  const T = B(() => d() ? fY({
    unit: n(),
    value: t()
  }, {
    unit: d(),
    value: s()
  }) : 0), I = B(() => pY({
    unit: n(),
    value: T()
  }, {
    unit: f(),
    value: u()
  }, {
    unit: g(),
    value: m()
  })), M = B(() => Uu(a() === "day" ? T() / x() : T())), P = B(() => Uu(M() * $() * x())), O = B(() => n().split("/")[0]), D = B(() => Uu(a() === "day" ? I() / x() : I())), R = B(() => Uu(D() * $() * x()));
  return v(os, {
    get open() {
      return e.open;
    },
    get onClose() {
      return e.onClose;
    },
    size: "lg",
    get children() {
      return [(() => {
        var L = gY(), Q = L.firstChild;
        return C(L, v(et, {
          name: "calculator",
          class: "mr-2"
        }), Q), L;
      })(), vY(), (() => {
        var L = yY(), Q = L.firstChild, ie = Q.firstChild, ee = Q.nextSibling;
        return C(Q, v(et, {
          name: "pencilSquare",
          class: "mr-2"
        }), ie), C(ee, () => e?.medicationName || "None Selected"), te(() => rt(ee, e?.medicationName ? "" : "@apply text-gray-400")), L;
      })(), (() => {
        var L = $Y(), Q = L.firstChild, ie = Q.firstChild, ee = Q.nextSibling;
        return C(Q, v(et, {
          name: "beaker",
          class: "mr-2"
        }), ie), C(L, v(Ye, {
          label: "Dose",
          get children() {
            var W = bY(), H = W.firstChild, pe = H.nextSibling, Te = pe.firstChild, Ce = Te.nextSibling;
            return C(H, v(Tt, {
              type: "number",
              inputmode: "decimal",
              min: "0",
              get value() {
                return t();
              },
              onInput: (de) => r(de.currentTarget?.valueAsNumber ?? 0),
              onFocusOut: (de) => r(Math.max(de.currentTarget?.valueAsNumber || 0, 0))
            }), null), C(H, v(ud, {
              get selected() {
                return n();
              },
              setSelected: i,
              options: Ey
            }), null), C(Ce, v(ud, {
              get selected() {
                return a();
              },
              setSelected: o,
              options: Py
            })), W;
          }
        }), ee), C(L, v(Ye, {
          label: "Patient Weight",
          get children() {
            var W = wY(), H = W.firstChild;
            return C(H, v(Tt, {
              type: "number",
              inputmode: "decimal",
              min: "0",
              get value() {
                return s();
              },
              onInput: (pe) => l(pe.currentTarget?.valueAsNumber ?? 0),
              onFocusOut: (pe) => l(Math.max(pe.currentTarget?.valueAsNumber || 0, 0))
            }), null), C(H, v(ud, {
              setSelected: c,
              options: Iy,
              get selected() {
                return d();
              }
            }), null), W;
          }
        }), ee), C(ee, v(Ye, {
          label: "Liquid Concentration",
          get children() {
            var W = Oy();
            return C(W, v(Tt, {
              type: "number",
              inputmode: "decimal",
              min: "0",
              get value() {
                return u();
              },
              onInput: (H) => h(H.currentTarget?.valueAsNumber ?? 0),
              onFocusOut: (H) => h(Math.max(H.currentTarget?.valueAsNumber || 0, 0))
            }), null), C(W, v(ud, {
              get selected() {
                return f();
              },
              setSelected: p,
              options: _y
            }), null), W;
          }
        }), null), C(ee, v(Ye, {
          label: "Per Volume",
          get children() {
            var W = Oy();
            return C(W, v(Tt, {
              type: "number",
              inputmode: "decimal",
              min: "0",
              get value() {
                return m();
              },
              onInput: (H) => y(H.currentTarget?.valueAsNumber ?? 0),
              onFocusOut: (H) => y(Math.max(H.currentTarget?.valueAsNumber || 0, 0))
            }), null), C(W, v(ud, {
              get selected() {
                return g();
              },
              setSelected: w,
              options: xy
            }), null), W;
          }
        }), null), L;
      })(), (() => {
        var L = kY(), Q = L.firstChild, ie = Q.firstChild, ee = Q.nextSibling;
        return C(Q, v(et, {
          name: "clock",
          class: "mr-2"
        }), ie), C(ee, v(Ye, {
          label: "Duration in Days",
          get children() {
            return v(Tt, {
              type: "number",
              inputmode: "decimal",
              min: "1",
              get value() {
                return $();
              },
              onInput: (W) => _(W.currentTarget?.valueAsNumber),
              onFocusOut: (W) => _(Math.max(W.currentTarget?.valueAsNumber || 1, 1))
            });
          }
        }), null), C(ee, v(Ye, {
          label: "Doses per Day",
          get children() {
            return v(Tt, {
              type: "number",
              inputmode: "decimal",
              min: "1",
              get value() {
                return x();
              },
              onInput: (W) => S(W.currentTarget?.valueAsNumber),
              onFocusOut: (W) => S(Math.max(W.currentTarget?.valueAsNumber || 1, 1))
            });
          }
        }), null), L;
      })(), (() => {
        var L = _Y(), Q = L.firstChild, ie = Q.firstChild, ee = Q.nextSibling, W = ee.nextSibling, H = W.nextSibling;
        return C(Q, v(et, {
          name: "chartPie",
          class: "mr-2"
        }), ie), C(ee, v(Ye, {
          label: "Single Dose",
          get children() {
            return v(Tt, {
              type: "text",
              get value() {
                return `${gs(M())} ${O()}`;
              },
              readonly: !0,
              copy: !0
            });
          }
        }), null), C(ee, v(Ye, {
          label: "Total Quantity",
          get children() {
            return v(Tt, {
              type: "text",
              get value() {
                return `${gs(P())} ${O()}`;
              },
              readonly: !0,
              copy: !0
            });
          }
        }), null), C(H, v(Ye, {
          label: "Single Liquid Dose",
          get children() {
            return v(Tt, {
              type: "text",
              get value() {
                return `${gs(D())} ${g()}`;
              },
              readonly: !0,
              copy: !0
            });
          }
        }), null), C(H, v(Ye, {
          label: "Total Liquid Quantity",
          get children() {
            return v(Tt, {
              type: "text",
              get value() {
                return `${gs(R())} ${g()}`;
              },
              readonly: !0,
              copy: !0
            });
          }
        }), null), L;
      })(), (() => {
        var L = xY();
        return C(L, v(ct, {
          variant: "secondary",
          get onClick() {
            return e.onClose;
          },
          children: "Cancel"
        }), null), C(L, v(ct, {
          onClick: () => {
            e.setAutocompleteValues({
              days: $(),
              liquidDose: gs(D()),
              totalLiquid: gs(R()),
              unit: g()
            }), e.onClose();
          },
          get disabled() {
            return R() === 0;
          },
          children: "Autofill"
        }), null), L;
      })()];
    }
  });
}
var CY = /* @__PURE__ */ k("<button type=button><span>"), TY = /* @__PURE__ */ k("<div>");
function AY(e) {
  const t = Ke({
    defaultOpen: !1
  }, e), [r, n] = z(t.defaultOpen), i = Pa(), a = () => t.alwaysOpen || (t.isOpen ?? r());
  return [v(q, {
    get when() {
      return !t.alwaysOpen;
    },
    get children() {
      var o = CY(), s = o.firstChild;
      return o.$$click = () => {
        const l = !a();
        t.onOpenChange?.(l), n(l);
      }, Xe(o, "aria-controls", i), C(s, () => a() ? t.openLabel : t.closedLabel), C(o, v(et, {
        get name() {
          return a() ? "chevronUp" : "chevronDown";
        },
        size: "sm"
      }), null), te((l) => {
        var d = jt("flex w-full items-center gap-1 text-left text-xs text-gray-500 hover:text-gray-600", t.buttonClass), c = a() ? "true" : "false";
        return d !== l.e && rt(o, l.e = d), c !== l.t && Xe(o, "aria-expanded", l.t = c), l;
      }, {
        e: void 0,
        t: void 0
      }), o;
    }
  }), (() => {
    var o = TY();
    return Xe(o, "id", i), C(o, () => t.children), te(() => rt(o, jt({
      hidden: !a()
    }, "pt-2", t.class))), o;
  })()];
}
qr(["click"]);
function OY(e, t) {
  const r = (n) => {
    e?.contains(n.target) || t();
  };
  document.body.addEventListener("click", r), _r(() => document.body.removeEventListener("click", r));
}
var PY = /* @__PURE__ */ k("<div class=relative>"), IY = /* @__PURE__ */ k("<ul role=listbox tabindex=-1>"), Fw = /* @__PURE__ */ k("<div>"), DY = /* @__PURE__ */ k('<span class="absolute inset-y-0 right-0 flex items-center pr-4">'), NY = /* @__PURE__ */ k('<li role=option tabindex=-1><span class="block truncate">'), MY = /* @__PURE__ */ k('<button class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"title="Input dropdown">');
const lh = Rr([{
  open: !1,
  selected: {},
  active: "",
  typing: !1
}, {
  setOpen: () => {
  },
  setSelected: () => {
  },
  setActive: () => {
  },
  setTyping: () => {
  }
}]);
function RY() {
  return gr(lh);
}
function ri(e) {
  const [t, r] = eo({
    open: !1,
    selected: {},
    active: "",
    typing: !1
  }), n = [t, {
    setOpen(i) {
      r("open", i);
    },
    setSelected(i) {
      (e.value?.id !== i?.id || e.value?.id === void 0) && e.setSelected(i);
    },
    setActive(i) {
      r("active", i);
    },
    setTyping(i) {
      r("typing", i);
    }
  }];
  return le(() => {
    e.value?.id !== t.selected?.id && r("selected", e.value);
  }), v(lh.Provider, {
    value: n,
    get children() {
      var i = PY();
      return C(i, () => e.children), i;
    }
  });
}
function LY(e) {
  const [t] = gr(lh);
  let r;
  const n = B(() => {
    if (t.open && r?.getBoundingClientRect) {
      const a = r.getBoundingClientRect(), o = window.innerHeight - a.bottom, s = a.top;
      return o > s ? "bottom" : "top";
    }
    return "bottom";
  }), i = B(() => jt("absolute z-10 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm", {
    "bottom-full mb-1": n() === "top",
    "top-full mt-1": n() === "bottom"
  }));
  return (() => {
    var a = Fw(), o = r;
    return typeof o == "function" ? cn(o, a) : r = a, C(a, v(q, {
      get when() {
        return t.open;
      },
      get children() {
        var s = IY();
        return C(s, () => e.children), te(() => rt(s, i())), s;
      }
    })), a;
  })();
}
function FY(e) {
  const [t, {
    setSelected: r,
    setActive: n
  }] = gr(lh), i = B(() => jt("relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 cursor-pointer", {
    "bg-blue-600 text-white": t.active === e.key
  })), a = B(() => jt(t.active === e.key ? "text-white" : "text-blue-600"));
  return (() => {
    var o = NY(), s = o.firstChild;
    return o.addEventListener("mouseenter", () => n(e.key)), o.$$click = () => r(e.value), C(s, () => e.children), C(o, v(q, {
      get when() {
        return t.selected?.id === e.key;
      },
      get children() {
        var l = DY();
        return C(l, v(et, {
          name: "checkCircle",
          get class() {
            return a();
          }
        })), l;
      }
    }), null), te(() => rt(o, i())), o;
  })();
}
function jY(e) {
  const [t, {
    setOpen: r
  }] = RY(), [n] = Kc(), [i, a] = qo(e, ["onInput", "value"]), [o, s] = z("");
  let l;
  return Ht(() => {
    OY(l, () => {
      r(!1);
    });
  }), le(() => {
    t.selected && s(e.displayValue(t.selected)), t.selected === void 0 && s("");
  }), le(() => {
    t.open || s(e.displayValue(t.selected) || "");
  }), [(() => {
    var d = Fw(), c = l;
    return typeof c == "function" ? cn(c, d) : l = d, C(d, v(Tt, Ke(a, {
      get "aria-label"() {
        return e.label;
      },
      get value() {
        return o() || "";
      },
      onClick: () => r(!t.open),
      onInput: (u) => {
        i?.onInput && i?.onInput(u), s(u.currentTarget.value), r(!0);
      },
      type: "text"
    }))), d;
  })(), (() => {
    var d = MY();
    return d.$$click = () => r(!t.open), C(d, v(q, {
      get when() {
        return !n.loading && !e.loading;
      },
      get children() {
        return v(et, {
          name: "chevronUpDown",
          class: "text-gray-400"
        });
      }
    })), d;
  })()];
}
ri.Input = jY;
ri.Options = LY;
ri.Option = FY;
qr(["click"]);
function zY(e) {
  const t = ["00002015204", "00002024304", "00002121404", "00002134004", "00002200204", "00002142304"], r = ["000021423", "000021214", "000022002", "000020152", "000021340", "000020243"], n = ["00002246001", "00002246080", "00002250601", "00002250661", "00002250680", "00002247101", "00002247180", "00002245701", "00002245780", "00002249501", "00002249580", "00002248401", "00002248480"], i = ["000022457", "000022460", "000022484", "000022495", "000022506", "000022471"], a = e.treatment?.codes?.packageNDC?.replaceAll("-", ""), o = e.treatment?.codes?.productNDC?.replaceAll("-", "") || a?.substring(0, a?.length - 2);
  return !a || !o ? {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "no_advice"
  } : t.includes(a) ? {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "include",
    constraint_pharmacies: [{
      id: "phr_01J6APWHGNFJCE74SB031VYPHW",
      name: "LillyDirect Self Pay Pharmacy Solutions"
    }]
  } : r.includes(o) ? {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "no_routing"
  } : n.includes(a) || i.includes(o) ? {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "exclude",
    constraint_pharmacies: [{
      id: "phr_01J6APWHGNFJCE74SB031VYPHW",
      name: "LillyDirect Self Pay Pharmacy Solutions"
    }]
  } : {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "no_advice"
  };
}
function jw(e) {
  return !!(["include", "no_routing"].includes(e.routing_constraint_type) && e.prescriptions.length === 1);
}
function VY(e) {
  const t = /* @__PURE__ */ new Map();
  for (const r of e)
    jw(r) && t.set(r.prescriptions[0].id, r);
  return t;
}
const UY = {
  prescriptions: [],
  routing_constraint_type: "exclude",
  constraint_pharmacies: []
};
function Dy(e) {
  return e.routing_constraint_type === "no_routing" ? {
    prescriptions: e.prescriptions,
    constraint_pharmacies: [],
    routing_constraint_type: "include"
  } : e.routing_constraint_type === "no_advice" ? {
    prescriptions: e.prescriptions,
    constraint_pharmacies: [],
    routing_constraint_type: "exclude"
  } : e;
}
function qY(e, t) {
  e = Dy(e), t = Dy(t);
  const r = (d) => {
    const c = d.constraint_pharmacies?.map((u) => u.id);
    return new Set(c);
  }, n = r(e), i = r(t), a = /* @__PURE__ */ new Map();
  for (const d of e?.constraint_pharmacies || [])
    a.set(d.id, d);
  for (const d of t?.constraint_pharmacies || [])
    a.set(d.id, d);
  const o = (d, c) => {
    const u = [];
    for (const h of Array.from(c))
      d.has(h) && u.push(a.get(h));
    return u;
  }, s = (d, c) => {
    const u = Array.from(d).map((h) => a.get(h));
    for (const h of Array.from(c))
      d.has(h) || u.push(a.get(h));
    return u;
  }, l = (d, c) => {
    const u = [];
    for (const h of Array.from(d))
      c.has(h) || u.push(a.get(h));
    return u;
  };
  return e.routing_constraint_type === "include" && t.routing_constraint_type === "include" ? {
    prescriptions: e.prescriptions.concat(t.prescriptions),
    constraint_pharmacies: o(n, i),
    routing_constraint_type: "include"
  } : e.routing_constraint_type === "include" && t.routing_constraint_type === "exclude" ? {
    prescriptions: e.prescriptions.concat(t.prescriptions),
    constraint_pharmacies: l(n, i),
    routing_constraint_type: "include"
  } : e.routing_constraint_type === "exclude" && t.routing_constraint_type === "include" ? {
    prescriptions: e.prescriptions.concat(t.prescriptions),
    constraint_pharmacies: l(i, n),
    routing_constraint_type: "include"
  } : {
    prescriptions: e.prescriptions.concat(t.prescriptions),
    constraint_pharmacies: s(n, i),
    routing_constraint_type: "exclude"
  };
}
function Ny(e, t = ["include", "exclude", "no_advice", "no_routing"]) {
  return e.reduce((r, n) => t.includes(n.routing_constraint_type) ? qY(r, n) : r, UY);
}
const BY = (e) => e <= 0 ? "error" : "warning", HY = (e, t) => {
  if (!e.constraint_pharmacies || t === 0)
    return "";
  const r = e.constraint_pharmacies.map((n) => n.name);
  return t === 1 ? r[0] : (r[t - 1] = `and ${r[t - 1]}`, t === 2 ? r.join(" ") : r.join(", "));
}, WY = (e, t, r) => r <= 0 ? `${e.treatment.name} cannot be filled at any pharmacies.` : `${e.treatment.name} can only be filled at ${HY(t, r)}.`, KY = (e) => {
  le(() => {
    if (!jw(e.routingConstraint))
      throw new Error("Cannot create a PrescriptionRoutingAlert for the given routing constraint.");
    if (e.routingConstraint.prescriptions[0].id !== e.prescription.id)
      throw new Error(`Prescription ID ${e.prescription.id} and the constraint's prescription ID ${e.routingConstraint.prescriptions[0].id} do not match.`);
  });
  const t = B(() => e.routingConstraint.routing_constraint_type === "no_routing" || !e.routingConstraint.constraint_pharmacies ? 0 : e.routingConstraint.constraint_pharmacies.length);
  return v(to, {
    iconName: "exclamationTriangle",
    get status() {
      return BY(t());
    },
    withBorder: !0,
    get children() {
      return WY(e.prescription, e.routingConstraint, t());
    }
  });
}, QY = () => v(to, {
  iconName: "exclamationTriangle",
  status: "warning",
  withBorder: !0,
  children: "One or more prescriptions in the order cannot be filled at this pharmacy."
}), GY = [
  "treatment",
  "dispenseQuantity",
  "dispenseUnit",
  "daysSupply",
  "refills",
  "instructions",
  "notes",
  "doNotFillBeforeDate",
  "addToTemplates",
  "templateName"
], Lf = [
  "firstName",
  "lastName",
  "dateOfBirth",
  "phone",
  "sex",
  "gender",
  "email",
  "address_street1",
  "address_street2",
  "address_city",
  "address_state",
  "address_zip",
  "preferredPharmacy"
], zw = (e) => e != null && e !== "" && e !== !1, Ff = (e, t) => Object.fromEntries(
  t.map((r) => [r, { completed: zw(e[r]?.value) }])
), My = (e, t) => {
  const r = {
    treatment: e.treatment,
    dispenseQuantity: e.dispenseQuantity,
    dispenseUnit: e.dispenseUnit,
    daysSupply: e.daysSupply,
    refills: e.fillsAllowed != null ? Number(e.fillsAllowed) - 1 : void 0,
    instructions: e.instructions,
    notes: e.notes,
    doNotFillBeforeDate: e.doNotFillBeforeDate,
    addToTemplates: t?.addToTemplates,
    templateName: t?.templateName
  };
  return Object.fromEntries(
    GY.map((n) => [n, { completed: zw(r[n]) }])
  );
}, Ro = (e, t) => {
  const r = new CustomEvent("photon-analytics-track-event", {
    composed: !0,
    bubbles: !0,
    detail: { ...e, timestamp: (/* @__PURE__ */ new Date()).toISOString() }
  });
  t?.dispatchEvent(r);
};
var YY = /* @__PURE__ */ k("<div>");
const Vw = Rr(), JY = (e) => {
  let t;
  const r = {
    dispatchFormValidate: (n, i) => {
      const a = new CustomEvent("photon-form-validate", {
        composed: !0,
        bubbles: !0,
        detail: {
          canSubmit: n,
          form: i
        }
      });
      t.dispatchEvent(a);
    },
    dispatchDraftPrescriptionCreated: (n) => {
      const i = new CustomEvent("photon-draft-prescription-created", {
        composed: !0,
        bubbles: !0,
        detail: {
          draft: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchDraftPrescriptionDeleted: (n) => {
      const i = new CustomEvent("photon-draft-prescription-deleted", {
        composed: !0,
        bubbles: !0,
        detail: {
          prescription: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchPrescriptionsCreated: (n) => {
      const i = new CustomEvent("photon-prescriptions-created", {
        composed: !0,
        bubbles: !0,
        detail: {
          prescriptions: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchPrescriptionsError: (n) => {
      const i = new CustomEvent("photon-prescriptions-error", {
        composed: !0,
        bubbles: !0,
        detail: {
          errors: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchOrderCreated: (n) => {
      const i = new CustomEvent("photon-order-created", {
        composed: !0,
        bubbles: !0,
        detail: {
          order: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchOrderCombined: (n) => {
      const i = new CustomEvent("photon-order-combined", {
        composed: !0,
        bubbles: !0,
        detail: {
          order: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchOrderError: (n) => {
      const i = new CustomEvent("photon-order-error", {
        composed: !0,
        bubbles: !0,
        detail: {
          errors: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchTicketCreatedDuplicate: () => {
      const n = new CustomEvent("photon-ticket-created-duplicate", {
        composed: !0,
        bubbles: !0,
        detail: {}
      });
      t.dispatchEvent(n);
    },
    dispatchClinicalAlertAcknowledge: (n) => {
      const i = new CustomEvent("photon-clinical-alert-acknowledge", {
        composed: !0,
        bubbles: !0,
        detail: {
          alerts: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchClinicalAlertCancel: (n) => {
      const i = new CustomEvent("photon-clinical-alert-cancel", {
        composed: !0,
        bubbles: !0,
        detail: {
          alerts: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchSignatureAttestationAgreed: () => {
      const n = new CustomEvent("photon-signature-attestation-agreed", {
        composed: !0,
        bubbles: !0,
        detail: {}
      });
      t?.dispatchEvent(n);
    },
    dispatchSignatureAttestationCanceled: () => {
      const n = new CustomEvent("photon-signature-attestation-canceled", {
        composed: !0,
        bubbles: !0,
        detail: {}
      });
      t?.dispatchEvent(n);
    },
    dispatchAnalytics: (n) => {
      Ro(n, t);
    }
  };
  return v(Vw.Provider, {
    value: r,
    get children() {
      var n = YY(), i = t;
      return typeof i == "function" ? cn(i, n) : t = n, C(n, () => e.children), n;
    }
  });
}, ca = () => {
  const e = gr(Vw);
  if (!e)
    throw new Error("can't find PrescribeEventDispatchContext");
  return e;
};
var jf = "Invariant Violation", Ry = Object.setPrototypeOf, ZY = Ry === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : Ry, Uw = (
  /** @class */
  (function(e) {
    Wc(t, e);
    function t(r) {
      r === void 0 && (r = jf);
      var n = e.call(this, typeof r == "number" ? jf + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return n.framesToPop = 1, n.name = jf, ZY(n, t.prototype), n;
    }
    return t;
  })(Error)
);
function Po(e, t) {
  if (!e)
    throw new Uw(t);
}
var qw = ["debug", "log", "warn", "error", "silent"], XY = qw.indexOf("log");
function qu(e) {
  return function() {
    if (qw.indexOf(e) >= XY) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = qu("debug"), e.log = qu("log"), e.warn = qu("warn"), e.error = qu("error");
})(Po || (Po = {}));
var Gm = "3.14.0";
function Yn(e) {
  try {
    return e();
  } catch {
  }
}
const h1 = Yn(function() {
  return globalThis;
}) || Yn(function() {
  return window;
}) || Yn(function() {
  return self;
}) || Yn(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Yn(function() {
  return Yn.constructor("return this")();
});
var Ly = /* @__PURE__ */ new Map();
function r5(e) {
  var t = Ly.get(e) || 1;
  return Ly.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function eJ(e, t) {
  var r = r5("stringifyForDisplay");
  return JSON.stringify(e, function(n, i) {
    return i === void 0 ? r : i;
  }, t).split(JSON.stringify(r)).join("<undefined>");
}
function Bu(e) {
  return function(t) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    if (typeof t == "number") {
      var i = t;
      t = Ym(i), t || (t = Jm(i, r), r = []);
    }
    e.apply(void 0, [t].concat(r));
  };
}
var Ae = Object.assign(function(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  e || Po(e, Ym(t, r) || Jm(t, r));
}, {
  debug: Bu(Po.debug),
  log: Bu(Po.log),
  warn: Bu(Po.warn),
  error: Bu(Po.error)
});
function Ri(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return new Uw(Ym(e, t) || Jm(e, t));
}
var Fy = /* @__PURE__ */ Symbol.for("ApolloErrorMessageHandler_" + Gm);
function Bw(e) {
  if (typeof e == "string")
    return e;
  try {
    return eJ(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function Ym(e, t) {
  if (t === void 0 && (t = []), !!e)
    return h1[Fy] && h1[Fy](e, t.map(Bw));
}
function Jm(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: Gm,
      message: e,
      args: t.map(Bw)
    })));
}
function Hw(e, t) {
  var r = e.directives;
  return !r || !r.length ? !0 : nJ(r).every(function(n) {
    var i = n.directive, a = n.ifArgument, o = !1;
    return a.value.kind === "Variable" ? (o = t && t[a.value.name.value], Ae(o !== void 0, 106, i.name.value)) : o = a.value.value, i.name.value === "skip" ? !o : o;
  });
}
function Tc(e, t, r) {
  var n = new Set(e), i = n.size;
  return di(t, {
    Directive: function(a) {
      if (n.delete(a.name.value) && (!r || !n.size))
        return X1;
    }
  }), r ? !n.size : n.size < i;
}
function tJ(e) {
  return e && Tc(["client", "export"], e, !0);
}
function rJ(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function nJ(e) {
  var t = [];
  return e && e.length && e.forEach(function(r) {
    if (rJ(r)) {
      var n = r.arguments, i = r.name.value;
      Ae(n && n.length === 1, 107, i);
      var a = n[0];
      Ae(a.name && a.name.value === "if", 108, i);
      var o = a.value;
      Ae(o && (o.kind === "Variable" || o.kind === "BooleanValue"), 109, i), t.push({ directive: r, ifArgument: a });
    }
  }), t;
}
function iJ(e) {
  var t, r, n = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(a) {
    var o = a.name;
    return o.value === "unmask";
  });
  if (!n)
    return "mask";
  var i = (r = n.arguments) === null || r === void 0 ? void 0 : r.find(function(a) {
    var o = a.name;
    return o.value === "mode";
  });
  return globalThis.__DEV__ !== !1 && i && (i.value.kind === fe.VARIABLE ? globalThis.__DEV__ !== !1 && Ae.warn(110) : i.value.kind !== fe.STRING ? globalThis.__DEV__ !== !1 && Ae.warn(111) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && Ae.warn(112, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const aJ = () => /* @__PURE__ */ Object.create(null), { forEach: oJ, slice: jy } = Array.prototype, { hasOwnProperty: sJ } = Object.prototype;
class eu {
  constructor(t = !0, r = aJ) {
    this.weakness = t, this.makeData = r;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(t) {
    let r = this;
    return oJ.call(t, (n) => r = r.getChildTrie(n)), sJ.call(r, "data") ? r.data : r.data = this.makeData(jy.call(t));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(t) {
    let r = this;
    for (let n = 0, i = t.length; r && n < i; ++n) {
      const a = r.mapFor(t[n], !1);
      r = a && a.get(t[n]);
    }
    return r && r.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(t) {
    let r;
    if (t.length) {
      const n = t[0], i = this.mapFor(n, !1), a = i && i.get(n);
      a && (r = a.removeArray(jy.call(t, 1)), !a.data && !a.weak && !(a.strong && a.strong.size) && i.delete(n));
    } else
      r = this.data, delete this.data;
    return r;
  }
  getChildTrie(t) {
    const r = this.mapFor(t, !0);
    let n = r.get(t);
    return n || r.set(t, n = new eu(this.weakness, this.makeData)), n;
  }
  mapFor(t, r) {
    return this.weakness && lJ(t) ? this.weak || (r ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (r ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function lJ(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var dJ = Yn(function() {
  return navigator.product;
}) == "ReactNative", Zm = typeof WeakMap == "function" && !(dJ && !global.HermesInternal), Ww = typeof WeakSet == "function", Kw = typeof Symbol == "function" && typeof Symbol.for == "function", dh = Kw && Symbol.asyncIterator;
Yn(function() {
  return window.document.createElement;
});
Yn(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function Si(e) {
  return e !== null && typeof e == "object";
}
function tu(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(r) {
    t[r.name.value] = r;
  }), t;
}
function cJ(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var r = e.name.value;
      if (typeof t == "function")
        return t(r);
      var n = t && t[r];
      return Ae(n, 115, r), n || null;
    }
    default:
      return null;
  }
}
function uJ(e) {
  var t = !0;
  return di(e, {
    FragmentSpread: function(r) {
      if (t = !!r.directives && r.directives.some(function(n) {
        return n.name.value === "unmask";
      }), !t)
        return X1;
    }
  }), t;
}
function hJ() {
}
class n5 {
  constructor(t = 1 / 0, r = hJ) {
    this.max = t, this.dispose = r, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(t, n), n.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (r === this.newest && (this.newest = r.older), r === this.oldest && (this.oldest = r.newer), r.newer && (r.newer.older = r.older), r.older && (r.older.newer = r.newer), this.map.delete(t), this.dispose(r.value, t), !0) : !1;
  }
}
function i5() {
}
const fJ = i5, pJ = typeof WeakRef < "u" ? WeakRef : function(e) {
  return { deref: () => e };
}, mJ = typeof WeakMap < "u" ? WeakMap : Map, gJ = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: i5,
    unregister: i5
  };
}, vJ = 10024;
class a5 {
  constructor(t = 1 / 0, r = fJ) {
    this.max = t, this.dispose = r, this.map = new mJ(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const n = this.unfinalizedNodes.values();
      for (let i = 0; i < vJ; i++) {
        const a = n.next().value;
        if (!a)
          break;
        this.unfinalizedNodes.delete(a);
        const o = a.key;
        delete a.key, a.keyRef = new pJ(o), this.registry.register(o, a, a);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new gJ(this.deleteNode.bind(this));
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.scheduleFinalization(n), this.map.set(t, n), this.size++, n.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(t) {
    t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
    const r = t.key || t.keyRef && t.keyRef.deref();
    this.dispose(t.value, r), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), r && this.map.delete(r);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (this.deleteNode(r), !0) : !1;
  }
  scheduleFinalization(t) {
    this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var zf = /* @__PURE__ */ new WeakSet();
function Qw(e) {
  e.size <= (e.max || -1) || zf.has(e) || (zf.add(e), setTimeout(function() {
    e.clean(), zf.delete(e);
  }, 100));
}
var Gw = function(e, t) {
  var r = new a5(e, t);
  return r.set = function(n, i) {
    var a = a5.prototype.set.call(this, n, i);
    return Qw(this), a;
  }, r;
}, yJ = function(e, t) {
  var r = new n5(e, t);
  return r.set = function(n, i) {
    var a = n5.prototype.set.call(this, n, i);
    return Qw(this), a;
  }, r;
}, bJ = /* @__PURE__ */ Symbol.for("apollo.cacheSize"), ru = X({}, h1[bJ]), ko = {};
function Yw(e, t) {
  ko[e] = t;
}
var wJ = globalThis.__DEV__ !== !1 ? kJ : void 0;
function $J() {
  var e = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(e).map(function(t) {
    var r = t[0], n = t[1];
    return [
      r,
      ru[r] || n
    ];
  }));
}
function kJ() {
  var e, t, r, n, i;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: $J(),
    sizes: X({ print: (e = ko.print) === null || e === void 0 ? void 0 : e.call(ko), parser: (t = ko.parser) === null || t === void 0 ? void 0 : t.call(ko), canonicalStringify: (r = ko.canonicalStringify) === null || r === void 0 ? void 0 : r.call(ko), links: s5(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: EJ(this.queryManager.documentTransform)
    } }, (i = (n = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(n))
  };
}
function _J(e) {
  return !!e && "dirtyKey" in e;
}
function xJ(e) {
  return _J(e) ? e.size : void 0;
}
function Jw(e) {
  return e != null;
}
function EJ(e) {
  return o5(e).map(function(t) {
    return { cache: t };
  });
}
function o5(e) {
  return e ? Ur(Ur([
    xJ(e?.performWork)
  ], o5(e?.left), !0), o5(e?.right), !0).filter(Jw) : [];
}
function s5(e) {
  var t;
  return e ? Ur(Ur([
    (t = e?.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
  ], s5(e?.left), !0), s5(e?.right), !0).filter(Jw) : [];
}
var Xm = Object.assign(function(e) {
  return JSON.stringify(e, SJ);
}, {
  reset: function() {
    zs = new yJ(
      ru.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && Yw("canonicalStringify", function() {
  return zs.size;
});
var zs;
Xm.reset();
function SJ(e, t) {
  if (t && typeof t == "object") {
    var r = Object.getPrototypeOf(t);
    if (r === Object.prototype || r === null) {
      var n = Object.keys(t);
      if (n.every(CJ))
        return t;
      var i = JSON.stringify(n), a = zs.get(i);
      if (!a) {
        n.sort();
        var o = JSON.stringify(n);
        a = zs.get(o) || n, zs.set(i, a), zs.set(o, a);
      }
      var s = Object.create(r);
      return a.forEach(function(l) {
        s[l] = t[l];
      }), s;
    }
  }
  return t;
}
function CJ(e, t, r) {
  return t === 0 || r[t - 1] <= e;
}
function TJ(e) {
  return Si(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function AJ(e) {
  return e.kind === "StringValue";
}
function OJ(e) {
  return e.kind === "BooleanValue";
}
function PJ(e) {
  return e.kind === "IntValue";
}
function IJ(e) {
  return e.kind === "FloatValue";
}
function DJ(e) {
  return e.kind === "Variable";
}
function NJ(e) {
  return e.kind === "ObjectValue";
}
function MJ(e) {
  return e.kind === "ListValue";
}
function RJ(e) {
  return e.kind === "EnumValue";
}
function LJ(e) {
  return e.kind === "NullValue";
}
function f1(e, t, r, n) {
  if (PJ(r) || IJ(r))
    e[t.value] = Number(r.value);
  else if (OJ(r) || AJ(r))
    e[t.value] = r.value;
  else if (NJ(r)) {
    var i = {};
    r.fields.map(function(o) {
      return f1(i, o.name, o.value, n);
    }), e[t.value] = i;
  } else if (DJ(r)) {
    var a = (n || {})[r.name.value];
    e[t.value] = a;
  } else if (MJ(r))
    e[t.value] = r.values.map(function(o) {
      var s = {};
      return f1(s, t, o, n), s[t.value];
    });
  else if (RJ(r))
    e[t.value] = r.value;
  else if (LJ(r))
    e[t.value] = null;
  else
    throw Ri(124, t.value, r.kind);
}
var FJ = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], hd = Xm;
Object.assign(function(e, t, r) {
  if (t && r && r.connection && r.connection.key)
    if (r.connection.filter && r.connection.filter.length > 0) {
      var n = r.connection.filter ? r.connection.filter : [];
      n.sort();
      var i = {};
      return n.forEach(function(s) {
        i[s] = t[s];
      }), "".concat(r.connection.key, "(").concat(hd(i), ")");
    } else
      return r.connection.key;
  var a = e;
  if (t) {
    var o = hd(t);
    a += "(".concat(o, ")");
  }
  return r && Object.keys(r).forEach(function(s) {
    FJ.indexOf(s) === -1 && (r[s] && Object.keys(r[s]).length ? a += "@".concat(s, "(").concat(hd(r[s]), ")") : a += "@".concat(s));
  }), a;
}, {
  setStringify: function(e) {
    var t = hd;
    return hd = e, t;
  }
});
function jJ(e, t) {
  if (e.arguments && e.arguments.length) {
    var r = {};
    return e.arguments.forEach(function(n) {
      var i = n.name, a = n.value;
      return f1(r, i, a, t);
    }), r;
  }
  return null;
}
function p1(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function m1(e) {
  return e.kind === "Field";
}
function zJ(e) {
  return e.kind === "InlineFragment";
}
function jl(e) {
  Ae(e && e.kind === "Document", 116);
  var t = e.definitions.filter(function(r) {
    return r.kind !== "FragmentDefinition";
  }).map(function(r) {
    if (r.kind !== "OperationDefinition")
      throw Ri(117, r.kind);
    return r;
  });
  return Ae(t.length <= 1, 118, t.length), e;
}
function yl(e) {
  return jl(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function Nd(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function nu(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function VJ(e) {
  var t = yl(e);
  return Ae(t && t.operation === "query", 119), t;
}
function UJ(e) {
  Ae(e.kind === "Document", 120), Ae(e.definitions.length <= 1, 121);
  var t = e.definitions[0];
  return Ae(t.kind === "FragmentDefinition", 122), t;
}
function ch(e) {
  jl(e);
  for (var t, r = 0, n = e.definitions; r < n.length; r++) {
    var i = n[r];
    if (i.kind === "OperationDefinition") {
      var a = i.operation;
      if (a === "query" || a === "mutation" || a === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !t && (t = i);
  }
  if (t)
    return t;
  throw Ri(123);
}
function qJ(e) {
  var t = /* @__PURE__ */ Object.create(null), r = e && e.variableDefinitions;
  return r && r.length && r.forEach(function(n) {
    n.defaultValue && f1(t, n.variable.name, n.defaultValue);
  }), t;
}
let Pr = null;
const zy = {};
let BJ = 1;
const HJ = () => class {
  constructor() {
    this.id = [
      "slot",
      BJ++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let e = Pr; e; e = e.parent)
      if (this.id in e.slots) {
        const t = e.slots[this.id];
        if (t === zy)
          break;
        return e !== Pr && (Pr.slots[this.id] = t), !0;
      }
    return Pr && (Pr.slots[this.id] = zy), !1;
  }
  getValue() {
    if (this.hasValue())
      return Pr.slots[this.id];
  }
  withValue(e, t, r, n) {
    const i = {
      __proto__: null,
      [this.id]: e
    }, a = Pr;
    Pr = { parent: a, slots: i };
    try {
      return t.apply(n, r);
    } finally {
      Pr = a;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(e) {
    const t = Pr;
    return function() {
      const r = Pr;
      try {
        return Pr = t, e.apply(this, arguments);
      } finally {
        Pr = r;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(e, t, r) {
    if (Pr) {
      const n = Pr;
      try {
        return Pr = null, e.apply(r, t);
      } finally {
        Pr = n;
      }
    } else
      return e.apply(r, t);
  }
};
function Vy(e) {
  try {
    return e();
  } catch {
  }
}
const Vf = "@wry/context:Slot", WJ = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  Vy(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  Vy(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), Uy = WJ, zl = Uy[Vf] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Vf] || (function(e) {
  try {
    Object.defineProperty(Uy, Vf, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
})(HJ()), { bind: z0e, noContext: V0e } = zl, e3 = new zl(), Zw = Array.from || function(e) {
  const t = [];
  return e.forEach((r) => t.push(r)), t;
};
function Xw(e) {
  const { unsubscribe: t } = e;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
const Ac = [], KJ = 100;
function bl(e, t) {
  if (!e)
    throw new Error(t || "assertion failure");
}
function e$(e, t) {
  const r = e.length;
  return (
    // Unknown values are not equal to each other.
    r > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    r === t.length && // The underlying value or exception must be the same.
    e[r - 1] === t[r - 1]
  );
}
function t$(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function r$(e) {
  return e.slice(0);
}
class uh {
  constructor(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++uh.count;
  }
  peek() {
    if (this.value.length === 1 && !Ka(this))
      return qy(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(t) {
    return bl(!this.recomputing, "already recomputing"), qy(this), Ka(this) ? QJ(this, t) : t$(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, n$(this), Xw(this));
  }
  dispose() {
    this.setDirty(), l$(this), t3(this, (t, r) => {
      t.setDirty(), d$(t, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(t) {
    t.add(this), this.deps || (this.deps = Ac.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }
  forgetDeps() {
    this.deps && (Zw(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), Ac.push(this.deps), this.deps = null);
  }
}
uh.count = 0;
function qy(e) {
  const t = e3.getValue();
  if (t)
    return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), Ka(e) ? a$(t, e) : o$(t, e), t;
}
function QJ(e, t) {
  return l$(e), e3.withValue(e, GJ, [e, t]), JJ(e, t) && YJ(e), t$(e.value);
}
function GJ(e, t) {
  e.recomputing = !0;
  const { normalizeResult: r } = e;
  let n;
  r && e.value.length === 1 && (n = r$(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, t), r && n && !e$(n, e.value))
      try {
        e.value[0] = r(e.value[0], n[0]);
      } catch {
      }
  } catch (i) {
    e.value[1] = i;
  }
  e.recomputing = !1;
}
function Ka(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function YJ(e) {
  e.dirty = !1, !Ka(e) && i$(e);
}
function n$(e) {
  t3(e, a$);
}
function i$(e) {
  t3(e, o$);
}
function t3(e, t) {
  const r = e.parents.size;
  if (r) {
    const n = Zw(e.parents);
    for (let i = 0; i < r; ++i)
      t(n[i], e);
  }
}
function a$(e, t) {
  bl(e.childValues.has(t)), bl(Ka(t));
  const r = !Ka(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = Ac.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(t))
    return;
  e.dirtyChildren.add(t), r && n$(e);
}
function o$(e, t) {
  bl(e.childValues.has(t)), bl(!Ka(t));
  const r = e.childValues.get(t);
  r.length === 0 ? e.childValues.set(t, r$(t.value)) : e$(r, t.value) || e.setDirty(), s$(e, t), !Ka(e) && i$(e);
}
function s$(e, t) {
  const r = e.dirtyChildren;
  r && (r.delete(t), r.size === 0 && (Ac.length < KJ && Ac.push(r), e.dirtyChildren = null));
}
function l$(e) {
  e.childValues.size > 0 && e.childValues.forEach((t, r) => {
    d$(e, r);
  }), e.forgetDeps(), bl(e.dirtyChildren === null);
}
function d$(e, t) {
  t.parents.delete(e), e.childValues.delete(t), s$(e, t);
}
function JJ(e, t) {
  if (typeof e.subscribe == "function")
    try {
      Xw(e), e.unsubscribe = e.subscribe.apply(null, t);
    } catch {
      return e.setDirty(), !1;
    }
  return !0;
}
let By;
function ZJ(...e) {
  return (By || (By = new eu(typeof WeakMap == "function"))).lookupArray(e);
}
const Uf = /* @__PURE__ */ new Set();
function XJ(e, { max: t = Math.pow(2, 16), keyArgs: r, makeCacheKey: n = ZJ, normalizeResult: i, subscribe: a, cache: o = n5 } = /* @__PURE__ */ Object.create(null)) {
  const s = typeof o == "function" ? new o(t, (h) => h.dispose()) : o, l = function() {
    const h = n.apply(null, r ? r.apply(null, arguments) : arguments);
    if (h === void 0)
      return e.apply(null, arguments);
    let f = s.get(h);
    f || (s.set(h, f = new uh(e)), f.normalizeResult = i, f.subscribe = a, f.forget = () => s.delete(h));
    const p = f.recompute(Array.prototype.slice.call(arguments));
    return s.set(h, f), Uf.add(s), e3.hasValue() || (Uf.forEach((m) => m.clean()), Uf.clear()), p;
  };
  Object.defineProperty(l, "size", {
    get: () => s.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(l.options = {
    max: t,
    keyArgs: r,
    makeCacheKey: n,
    normalizeResult: i,
    subscribe: a,
    cache: s
  });
  function d(h) {
    const f = h && s.get(h);
    f && f.setDirty();
  }
  l.dirtyKey = d, l.dirty = function() {
    d(n.apply(null, arguments));
  };
  function c(h) {
    const f = h && s.get(h);
    if (f)
      return f.peek();
  }
  l.peekKey = c, l.peek = function() {
    return c(n.apply(null, arguments));
  };
  function u(h) {
    return h ? s.delete(h) : !1;
  }
  return l.forgetKey = u, l.forget = function() {
    return u(n.apply(null, arguments));
  }, l.makeCacheKey = n, l.getKey = r ? function() {
    return n.apply(null, r.apply(null, arguments));
  } : n, Object.freeze(l);
}
function eZ(e) {
  return e;
}
var tZ = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = /* @__PURE__ */ Object.create(null)), this.resultCache = Ww ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, r.getCacheKey && (this.getCacheKey = r.getCacheKey), this.cached = r.cache !== !1, this.resetCache();
    }
    return e.prototype.getCacheKey = function(t) {
      return [t];
    }, e.identity = function() {
      return new e(eZ, { cache: !1 });
    }, e.split = function(t, r, n) {
      return n === void 0 && (n = e.identity()), Object.assign(new e(
        function(i) {
          var a = t(i) ? r : n;
          return a.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: r, right: n });
    }, e.prototype.resetCache = function() {
      var t = this;
      if (this.cached) {
        var r = new eu(Zm);
        this.performWork = XJ(e.prototype.performWork.bind(this), {
          makeCacheKey: function(n) {
            var i = t.getCacheKey(n);
            if (i)
              return Ae(Array.isArray(i), 105), r.lookupArray(i);
          },
          max: ru["documentTransform.cache"],
          cache: a5
        });
      }
    }, e.prototype.performWork = function(t) {
      return jl(t), this.transform(t);
    }, e.prototype.transformDocument = function(t) {
      if (this.resultCache.has(t))
        return t;
      var r = this.performWork(t);
      return this.resultCache.add(r), r;
    }, e.prototype.concat = function(t) {
      var r = this;
      return Object.assign(new e(
        function(n) {
          return t.transformDocument(r.transformDocument(n));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: t
      });
    }, e;
  })()
), Kd, Vs = Object.assign(function(e) {
  var t = Kd.get(e);
  return t || (t = GI(e), Kd.set(e, t)), t;
}, {
  reset: function() {
    Kd = new Gw(
      ru.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
Vs.reset();
globalThis.__DEV__ !== !1 && Yw("print", function() {
  return Kd ? Kd.size : 0;
});
var rZ = Array.isArray;
function Qa(e) {
  return Array.isArray(e) && e.length > 0;
}
var Hy = {
  kind: fe.FIELD,
  name: {
    kind: fe.NAME,
    value: "__typename"
  }
};
function c$(e, t) {
  return !e || e.selectionSet.selections.every(function(r) {
    return r.kind === fe.FRAGMENT_SPREAD && c$(t[r.name.value], t);
  });
}
function nZ(e) {
  return c$(yl(e) || UJ(e), tu(nu(e))) ? null : e;
}
function iZ(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    n && (n.name ? t.set(n.name, n) : n.test && r.set(n.test, n));
  }), function(n) {
    var i = t.get(n.name.value);
    return !i && r.size && r.forEach(function(a, o) {
      o(n) && (i = a);
    }), i;
  };
}
function Wy(e) {
  var t = /* @__PURE__ */ new Map();
  return function(r) {
    r === void 0 && (r = e);
    var n = t.get(r);
    return n || t.set(r, n = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), n;
  };
}
function u$(e, t) {
  jl(t);
  for (var r = Wy(""), n = Wy(""), i = function(g) {
    for (var w = 0, $ = void 0; w < g.length && ($ = g[w]); ++w)
      if (!rZ($)) {
        if ($.kind === fe.OPERATION_DEFINITION)
          return r($.name && $.name.value);
        if ($.kind === fe.FRAGMENT_DEFINITION)
          return n($.name.value);
      }
    return globalThis.__DEV__ !== !1 && Ae.error(125), null;
  }, a = 0, o = t.definitions.length - 1; o >= 0; --o)
    t.definitions[o].kind === fe.OPERATION_DEFINITION && ++a;
  var s = iZ(e), l = function(g) {
    return Qa(g) && g.map(s).some(function(w) {
      return w && w.remove;
    });
  }, d = /* @__PURE__ */ new Map(), c = !1, u = {
    enter: function(g) {
      if (l(g.directives))
        return c = !0, null;
    }
  }, h = di(t, {
    // These two AST node types share the same implementation, defined above.
    Field: u,
    InlineFragment: u,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(g, w, $, _, x) {
        var S = i(x);
        S && S.variables.add(g.name.value);
      }
    },
    FragmentSpread: {
      enter: function(g, w, $, _, x) {
        if (l(g.directives))
          return c = !0, null;
        var S = i(x);
        S && S.fragmentSpreads.add(g.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(g, w, $, _) {
        d.set(JSON.stringify(_), g);
      },
      leave: function(g, w, $, _) {
        var x = d.get(JSON.stringify(_));
        if (g === x)
          return g;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          a > 0 && g.selectionSet.selections.every(function(S) {
            return S.kind === fe.FIELD && S.name.value === "__typename";
          })
        )
          return n(g.name.value).removed = !0, c = !0, null;
      }
    },
    Directive: {
      leave: function(g) {
        if (s(g))
          return c = !0, null;
      }
    }
  });
  if (!c)
    return t;
  var f = function(g) {
    return g.transitiveVars || (g.transitiveVars = new Set(g.variables), g.removed || g.fragmentSpreads.forEach(function(w) {
      f(n(w)).transitiveVars.forEach(function($) {
        g.transitiveVars.add($);
      });
    })), g;
  }, p = /* @__PURE__ */ new Set();
  h.definitions.forEach(function(g) {
    g.kind === fe.OPERATION_DEFINITION ? f(r(g.name && g.name.value)).fragmentSpreads.forEach(function(w) {
      p.add(w);
    }) : g.kind === fe.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    a === 0 && !n(g.name.value).removed && p.add(g.name.value);
  }), p.forEach(function(g) {
    f(n(g)).fragmentSpreads.forEach(function(w) {
      p.add(w);
    });
  });
  var m = function(g) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!p.has(g) || n(g).removed);
  }, y = {
    enter: function(g) {
      if (m(g.name.value))
        return null;
    }
  };
  return nZ(di(h, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: y,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: y,
    OperationDefinition: {
      leave: function(g) {
        if (g.variableDefinitions) {
          var w = f(
            // If an operation is anonymous, we use the empty string as its key.
            r(g.name && g.name.value)
          ).transitiveVars;
          if (w.size < g.variableDefinitions.length)
            return X(X({}, g), { variableDefinitions: g.variableDefinitions.filter(function($) {
              return w.has($.variable.name.value);
            }) });
        }
      }
    }
  }));
}
Object.assign(function(e) {
  return di(e, {
    SelectionSet: {
      enter: function(t, r, n) {
        if (!(n && n.kind === fe.OPERATION_DEFINITION)) {
          var i = t.selections;
          if (i) {
            var a = i.some(function(s) {
              return m1(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!a) {
              var o = n;
              if (!(m1(o) && o.directives && o.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return X(X({}, t), { selections: Ur(Ur([], i, !0), [Hy], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === Hy;
  }
});
function aZ(e) {
  var t = ch(e), r = t.operation;
  if (r === "query")
    return e;
  var n = di(e, {
    OperationDefinition: {
      enter: function(i) {
        return X(X({}, i), { operation: "query" });
      }
    }
  });
  return n;
}
function h$(e) {
  jl(e);
  var t = u$([
    {
      test: function(r) {
        return r.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return t;
}
function oZ(e) {
  return jl(e), di(e, {
    FragmentSpread: function(t) {
      var r;
      if (!(!((r = t.directives) === null || r === void 0) && r.some(function(n) {
        return n.name.value === "unmask";
      })))
        return X(X({}, t), { directives: Ur(Ur([], t.directives || [], !0), [
          {
            kind: fe.DIRECTIVE,
            name: { kind: fe.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var sZ = Object.prototype.hasOwnProperty;
function Ky() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return f$(e);
}
function f$(e) {
  var t = e[0] || {}, r = e.length;
  if (r > 1)
    for (var n = new r3(), i = 1; i < r; ++i)
      t = n.merge(t, e[i]);
  return t;
}
var lZ = function(e, t, r) {
  return this.merge(e[r], t[r]);
}, r3 = (
  /** @class */
  (function() {
    function e(t) {
      t === void 0 && (t = lZ), this.reconciler = t, this.isObject = Si, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(t, r) {
      for (var n = this, i = [], a = 2; a < arguments.length; a++)
        i[a - 2] = arguments[a];
      return Si(r) && Si(t) ? (Object.keys(r).forEach(function(o) {
        if (sZ.call(t, o)) {
          var s = t[o];
          if (r[o] !== s) {
            var l = n.reconciler.apply(n, Ur([
              t,
              r,
              o
            ], i, !1));
            l !== s && (t = n.shallowCopyForMerge(t), t[o] = l);
          }
        } else
          t = n.shallowCopyForMerge(t), t[o] = r[o];
      }), t) : r;
    }, e.prototype.shallowCopyForMerge = function(t) {
      return Si(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = X({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
    }, e;
  })()
);
function dZ(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = cZ(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cZ(e, t) {
  if (e) {
    if (typeof e == "string") return Qy(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Qy(e, t);
  }
}
function Qy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Gy(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function n3(e, t, r) {
  return t && Gy(e.prototype, t), r && Gy(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var i3 = function() {
  return typeof Symbol == "function";
}, a3 = function(e) {
  return i3() && !!Symbol[e];
}, o3 = function(e) {
  return a3(e) ? Symbol[e] : "@@" + e;
};
i3() && !a3("observable") && (Symbol.observable = /* @__PURE__ */ Symbol("observable"));
var uZ = o3("iterator"), l5 = o3("observable"), p$ = o3("species");
function g1(e, t) {
  var r = e[t];
  if (r != null) {
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    return r;
  }
}
function fd(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[p$], t === null && (t = void 0)), t !== void 0 ? t : Ut;
}
function hZ(e) {
  return e instanceof Ut;
}
function wl(e) {
  wl.log ? wl.log(e) : setTimeout(function() {
    throw e;
  });
}
function y0(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      wl(t);
    }
  });
}
function m$(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var r = g1(t, "unsubscribe");
        r && r.call(t);
      }
    } catch (n) {
      wl(n);
    }
}
function d5(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function fZ(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var r = 0; r < t.length && (g$(e, t[r].type, t[r].value), e._state !== "closed"); ++r)
      ;
  }
}
function g$(e, t, r) {
  e._state = "running";
  var n = e._observer;
  try {
    var i = g1(n, t);
    switch (t) {
      case "next":
        i && i.call(n, r);
        break;
      case "error":
        if (d5(e), i) i.call(n, r);
        else throw r;
        break;
      case "complete":
        d5(e), i && i.call(n);
        break;
    }
  } catch (a) {
    wl(a);
  }
  e._state === "closed" ? m$(e) : e._state === "running" && (e._state = "ready");
}
function qf(e, t, r) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: r
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: r
      }], y0(function() {
        return fZ(e);
      });
      return;
    }
    g$(e, t, r);
  }
}
var pZ = /* @__PURE__ */ (function() {
  function e(r, n) {
    this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
    var i = new mZ(this);
    try {
      this._cleanup = n.call(void 0, i);
    } catch (a) {
      i.error(a);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (d5(this), m$(this));
  }, n3(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
})(), mZ = /* @__PURE__ */ (function() {
  function e(r) {
    this._subscription = r;
  }
  var t = e.prototype;
  return t.next = function(r) {
    qf(this._subscription, "next", r);
  }, t.error = function(r) {
    qf(this._subscription, "error", r);
  }, t.complete = function() {
    qf(this._subscription, "complete");
  }, n3(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
})(), Ut = /* @__PURE__ */ (function() {
  function e(r) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof r != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = r;
  }
  var t = e.prototype;
  return t.subscribe = function(r) {
    return (typeof r != "object" || r === null) && (r = {
      next: r,
      error: arguments[1],
      complete: arguments[2]
    }), new pZ(r, this._subscriber);
  }, t.forEach = function(r) {
    var n = this;
    return new Promise(function(i, a) {
      if (typeof r != "function") {
        a(new TypeError(r + " is not a function"));
        return;
      }
      function o() {
        s.unsubscribe(), i();
      }
      var s = n.subscribe({
        next: function(l) {
          try {
            r(l, o);
          } catch (d) {
            a(d), s.unsubscribe();
          }
        },
        error: a,
        complete: i
      });
    });
  }, t.map = function(r) {
    var n = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var i = fd(this);
    return new i(function(a) {
      return n.subscribe({
        next: function(o) {
          try {
            o = r(o);
          } catch (s) {
            return a.error(s);
          }
          a.next(o);
        },
        error: function(o) {
          a.error(o);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, t.filter = function(r) {
    var n = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var i = fd(this);
    return new i(function(a) {
      return n.subscribe({
        next: function(o) {
          try {
            if (!r(o)) return;
          } catch (s) {
            return a.error(s);
          }
          a.next(o);
        },
        error: function(o) {
          a.error(o);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, t.reduce = function(r) {
    var n = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var i = fd(this), a = arguments.length > 1, o = !1, s = arguments[1], l = s;
    return new i(function(d) {
      return n.subscribe({
        next: function(c) {
          var u = !o;
          if (o = !0, !u || a)
            try {
              l = r(l, c);
            } catch (h) {
              return d.error(h);
            }
          else
            l = c;
        },
        error: function(c) {
          d.error(c);
        },
        complete: function() {
          if (!o && !a) return d.error(new TypeError("Cannot reduce an empty sequence"));
          d.next(l), d.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var r = this, n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    var o = fd(this);
    return new o(function(s) {
      var l, d = 0;
      function c(u) {
        l = u.subscribe({
          next: function(h) {
            s.next(h);
          },
          error: function(h) {
            s.error(h);
          },
          complete: function() {
            d === i.length ? (l = void 0, s.complete()) : c(o.from(i[d++]));
          }
        });
      }
      return c(r), function() {
        l && (l.unsubscribe(), l = void 0);
      };
    });
  }, t.flatMap = function(r) {
    var n = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var i = fd(this);
    return new i(function(a) {
      var o = [], s = n.subscribe({
        next: function(d) {
          if (r)
            try {
              d = r(d);
            } catch (u) {
              return a.error(u);
            }
          var c = i.from(d).subscribe({
            next: function(u) {
              a.next(u);
            },
            error: function(u) {
              a.error(u);
            },
            complete: function() {
              var u = o.indexOf(c);
              u >= 0 && o.splice(u, 1), l();
            }
          });
          o.push(c);
        },
        error: function(d) {
          a.error(d);
        },
        complete: function() {
          l();
        }
      });
      function l() {
        s.closed && o.length === 0 && a.complete();
      }
      return function() {
        o.forEach(function(d) {
          return d.unsubscribe();
        }), s.unsubscribe();
      };
    });
  }, t[l5] = function() {
    return this;
  }, e.from = function(r) {
    var n = typeof this == "function" ? this : e;
    if (r == null) throw new TypeError(r + " is not an object");
    var i = g1(r, l5);
    if (i) {
      var a = i.call(r);
      if (Object(a) !== a) throw new TypeError(a + " is not an object");
      return hZ(a) && a.constructor === n ? a : new n(function(o) {
        return a.subscribe(o);
      });
    }
    if (a3("iterator") && (i = g1(r, uZ), i))
      return new n(function(o) {
        y0(function() {
          if (!o.closed) {
            for (var s = dZ(i.call(r)), l; !(l = s()).done; ) {
              var d = l.value;
              if (o.next(d), o.closed) return;
            }
            o.complete();
          }
        });
      });
    if (Array.isArray(r))
      return new n(function(o) {
        y0(function() {
          if (!o.closed) {
            for (var s = 0; s < r.length; ++s)
              if (o.next(r[s]), o.closed) return;
            o.complete();
          }
        });
      });
    throw new TypeError(r + " is not observable");
  }, e.of = function() {
    for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++)
      n[i] = arguments[i];
    var a = typeof this == "function" ? this : e;
    return new a(function(o) {
      y0(function() {
        if (!o.closed) {
          for (var s = 0; s < n.length; ++s)
            if (o.next(n[s]), o.closed) return;
          o.complete();
        }
      });
    });
  }, n3(e, null, [{
    key: p$,
    get: function() {
      return this;
    }
  }]), e;
})();
i3() && Object.defineProperty(Ut, /* @__PURE__ */ Symbol("extensions"), {
  value: {
    symbol: l5,
    hostReportError: wl
  },
  configurable: !0
});
function gZ(e) {
  var t, r = e.Symbol;
  if (typeof r == "function")
    if (r.observable)
      t = r.observable;
    else {
      typeof r.for == "function" ? t = r.for("https://github.com/benlesh/symbol-observable") : t = r("https://github.com/benlesh/symbol-observable");
      try {
        r.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var Ts;
typeof self < "u" ? Ts = self : typeof window < "u" ? Ts = window : typeof global < "u" ? Ts = global : typeof module < "u" ? Ts = module : Ts = Function("return this")();
gZ(Ts);
var Yy = Ut.prototype, Jy = "@@observable";
Yy[Jy] || (Yy[Jy] = function() {
  return this;
});
function vZ(e) {
  return e.catch(function() {
  }), e;
}
var yZ = Object.prototype.toString;
function bZ(e) {
  return c5(e);
}
function c5(e, t) {
  switch (yZ.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = e.slice(0);
      return t.set(e, r), r.forEach(function(i, a) {
        r[a] = c5(i, t);
      }), r;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var n = Object.create(Object.getPrototypeOf(e));
      return t.set(e, n), Object.keys(e).forEach(function(i) {
        n[i] = c5(e[i], t);
      }), n;
    }
    default:
      return e;
  }
}
function wZ(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(r) {
    Si(r) && $Z(r) === r && Object.getOwnPropertyNames(r).forEach(function(n) {
      Si(r[n]) && t.add(r[n]);
    });
  }), e;
}
function $Z(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function kZ(e) {
  return globalThis.__DEV__ !== !1 && wZ(e), e;
}
function Qd(e, t, r) {
  var n = [];
  e.forEach(function(i) {
    return i[t] && n.push(i);
  }), n.forEach(function(i) {
    return i[t](r);
  });
}
function Bf(e, t, r) {
  return new Ut(function(n) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(l) {
        return new Promise(function(d) {
          return d(l());
        });
      }
    };
    function a(l, d) {
      return function(c) {
        if (l) {
          var u = function() {
            return n.closed ? (
              /* will be swallowed */
              0
            ) : l(c);
          };
          i = i.then(u, u).then(function(h) {
            return n.next(h);
          }, function(h) {
            return n.error(h);
          });
        } else
          n[d](c);
      };
    }
    var o = {
      next: a(t, "next"),
      error: a(r, "error"),
      complete: function() {
        i.then(function() {
          return n.complete();
        });
      }
    }, s = e.subscribe(o);
    return function() {
      return s.unsubscribe();
    };
  });
}
function v$(e) {
  function t(r) {
    Object.defineProperty(e, r, { value: Ut });
  }
  return Kw && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function Zy(e) {
  return e && typeof e.then == "function";
}
var As = (
  /** @class */
  (function(e) {
    Wc(t, e);
    function t(r) {
      var n = e.call(this, function(i) {
        return n.addObserver(i), function() {
          return n.removeObserver(i);
        };
      }) || this;
      return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, a) {
        n.resolve = i, n.reject = a;
      }), n.handlers = {
        next: function(i) {
          n.sub !== null && (n.latest = ["next", i], n.notify("next", i), Qd(n.observers, "next", i));
        },
        error: function(i) {
          var a = n.sub;
          a !== null && (a && setTimeout(function() {
            return a.unsubscribe();
          }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), Qd(n.observers, "error", i));
        },
        complete: function() {
          var i = n, a = i.sub, o = i.sources, s = o === void 0 ? [] : o;
          if (a !== null) {
            var l = s.shift();
            l ? Zy(l) ? l.then(function(d) {
              return n.sub = d.subscribe(n.handlers);
            }, n.handlers.error) : n.sub = l.subscribe(n.handlers) : (a && setTimeout(function() {
              return a.unsubscribe();
            }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), Qd(n.observers, "complete"));
          }
        }
      }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
        n.reject(i), n.sources = [], n.handlers.error(i);
      }, n.promise.catch(function(i) {
      }), typeof r == "function" && (r = [new Ut(r)]), Zy(r) ? r.then(function(i) {
        return n.start(i);
      }, n.handlers.error) : n.start(r), n;
    }
    return t.prototype.start = function(r) {
      this.sub === void 0 && (this.sources = Array.from(r), this.handlers.complete());
    }, t.prototype.deliverLastMessage = function(r) {
      if (this.latest) {
        var n = this.latest[0], i = r[n];
        i && i.call(r, this.latest[1]), this.sub === null && n === "next" && r.complete && r.complete();
      }
    }, t.prototype.addObserver = function(r) {
      this.observers.has(r) || (this.deliverLastMessage(r), this.observers.add(r));
    }, t.prototype.removeObserver = function(r) {
      this.observers.delete(r) && this.observers.size < 1 && this.handlers.complete();
    }, t.prototype.notify = function(r, n) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(a) {
        return a(r, n);
      }));
    }, t.prototype.beforeNext = function(r) {
      var n = !1;
      this.nextResultListeners.add(function(i, a) {
        n || (n = !0, r(i, a));
      });
    }, t;
  })(Ut)
);
v$(As);
function rl(e) {
  return "incremental" in e;
}
function _Z(e) {
  return "hasNext" in e && "data" in e;
}
function xZ(e) {
  return rl(e) || _Z(e);
}
function EZ(e) {
  return Si(e) && "payload" in e;
}
function y$(e, t) {
  var r = e, n = new r3();
  return rl(t) && Qa(t.incremental) && t.incremental.forEach(function(i) {
    for (var a = i.data, o = i.path, s = o.length - 1; s >= 0; --s) {
      var l = o[s], d = !isNaN(+l), c = d ? [] : {};
      c[l] = a, a = c;
    }
    r = n.merge(r, a);
  }), r;
}
function b0(e) {
  var t = u5(e);
  return Qa(t);
}
function u5(e) {
  var t = Qa(e.errors) ? e.errors.slice(0) : [];
  return rl(e) && Qa(e.incremental) && e.incremental.forEach(function(r) {
    r.errors && t.push.apply(t, r.errors);
  }), t;
}
function v1() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(n) {
    n && Object.keys(n).forEach(function(i) {
      var a = n[i];
      a !== void 0 && (r[i] = a);
    });
  }), r;
}
function w0(e, t) {
  return v1(e, t, t.variables && {
    variables: v1(X(X({}, e && e.variables), t.variables))
  });
}
function Hf(e) {
  return new Ut(function(t) {
    t.error(e);
  });
}
var b$ = function(e, t, r) {
  var n = new Error(r);
  throw n.name = "ServerError", n.response = e, n.statusCode = e.status, n.result = t, n;
};
function SZ(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], r = 0, n = Object.keys(e); r < n.length; r++) {
    var i = n[r];
    if (t.indexOf(i) < 0)
      throw Ri(58, i);
  }
  return e;
}
function CZ(e, t) {
  var r = X({}, e), n = function(a) {
    typeof a == "function" ? r = X(X({}, r), a(r)) : r = X(X({}, r), a);
  }, i = function() {
    return X({}, r);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: i
  }), t;
}
function TZ(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? Nd(t.query) || void 0 : ""), t;
}
function AZ(e, t) {
  var r = X({}, e), n = new Set(Object.keys(e));
  return di(t, {
    Variable: function(i, a, o) {
      o && o.kind !== "VariableDefinition" && n.delete(i.name.value);
    }
  }), n.forEach(function(i) {
    delete r[i];
  }), r;
}
var OZ = /* @__PURE__ */ Symbol.for("apollo.deprecations"), PZ = h1, h5 = new zl();
function IZ(e) {
  return PZ[OZ] || (h5.getValue() || []).includes(e);
}
function Jn(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return h5.withValue.apply(h5, Ur([Array.isArray(e) ? e : [e]], t, !1));
}
function In(e, t, r, n) {
  n === void 0 && (n = "Please remove this option."), Io(t, function() {
    t in e && globalThis.__DEV__ !== !1 && Ae.warn(104, r, t, n);
  });
}
function Io(e, t) {
  IZ(e) || t();
}
function Xy(e, t) {
  return t ? t(e) : Ut.of();
}
function pd(e) {
  return typeof e == "function" ? new iu(e) : e;
}
function Hu(e) {
  return e.request.length <= 1;
}
var iu = (
  /** @class */
  (function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return Ut.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(pd).reduce(function(r, n) {
        return r.concat(n);
      });
    }, e.split = function(t, r, n) {
      var i = pd(r), a = pd(n || new e(Xy)), o;
      return Hu(i) && Hu(a) ? o = new e(function(s) {
        return t(s) ? i.request(s) || Ut.of() : a.request(s) || Ut.of();
      }) : o = new e(function(s, l) {
        return t(s) ? i.request(s, l) || Ut.of() : a.request(s, l) || Ut.of();
      }), Object.assign(o, { left: i, right: a });
    }, e.execute = function(t, r) {
      return t.request(CZ(r.context, TZ(SZ(r)))) || Ut.of();
    }, e.concat = function(t, r) {
      var n = pd(t);
      if (Hu(n))
        return globalThis.__DEV__ !== !1 && Ae.warn(47, n), n;
      var i = pd(r), a;
      return Hu(i) ? a = new e(function(o) {
        return n.request(o, function(s) {
          return i.request(s) || Ut.of();
        }) || Ut.of();
      }) : a = new e(function(o, s) {
        return n.request(o, function(l) {
          return i.request(l, s) || Ut.of();
        }) || Ut.of();
      }), Object.assign(a, { left: n, right: i });
    }, e.prototype.split = function(t, r, n) {
      return this.concat(e.split(t, r, n || new e(Xy)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, r) {
      throw Ri(48);
    }, e.prototype.onError = function(t, r) {
      if (globalThis.__DEV__ !== !1 && Io("onError", function() {
        globalThis.__DEV__ !== !1 && Ae.warn(49);
      }), r && r.error)
        return r.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Ae.warn(50), this.onError = t, this;
    }, e;
  })()
), f5 = iu.execute;
function DZ(e) {
  var t, r = e[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return r.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function NZ(e) {
  var t = null, r = null, n = !1, i = [], a = [];
  function o(u) {
    if (!r) {
      if (a.length) {
        var h = a.shift();
        if (Array.isArray(h) && h[0])
          return h[0]({ value: u, done: !1 });
      }
      i.push(u);
    }
  }
  function s(u) {
    r = u;
    var h = a.slice();
    h.forEach(function(f) {
      f[1](u);
    }), !t || t();
  }
  function l() {
    n = !0;
    var u = a.slice();
    u.forEach(function(h) {
      h[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, e.removeListener("data", o), e.removeListener("error", s), e.removeListener("end", l), e.removeListener("finish", l), e.removeListener("close", l);
  }, e.on("data", o), e.on("error", s), e.on("end", l), e.on("finish", l), e.on("close", l);
  function d() {
    return new Promise(function(u, h) {
      if (r)
        return h(r);
      if (i.length)
        return u({ value: i.shift(), done: !1 });
      if (n)
        return u({ value: void 0, done: !0 });
      a.push([u, h]);
    });
  }
  var c = {
    next: function() {
      return d();
    }
  };
  return dh && (c[Symbol.asyncIterator] = function() {
    return this;
  }), c;
}
function MZ(e) {
  var t = !1, r = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(n, i) {
        e.then(function(a) {
          n({ value: a, done: !1 });
        }).catch(i);
      }));
    }
  };
  return dh && (r[Symbol.asyncIterator] = function() {
    return this;
  }), r;
}
function e9(e) {
  var t = {
    next: function() {
      return e.read();
    }
  };
  return dh && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function RZ(e) {
  return !!e.body;
}
function LZ(e) {
  return !!e.getReader;
}
function FZ(e) {
  return !!(dh && e[Symbol.asyncIterator]);
}
function jZ(e) {
  return !!e.stream;
}
function zZ(e) {
  return !!e.arrayBuffer;
}
function VZ(e) {
  return !!e.pipe;
}
function UZ(e) {
  var t = e;
  if (RZ(e) && (t = e.body), FZ(t))
    return DZ(t);
  if (LZ(t))
    return e9(t.getReader());
  if (jZ(t))
    return e9(t.stream().getReader());
  if (zZ(t))
    return MZ(t.arrayBuffer());
  if (VZ(t))
    return NZ(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var s3 = /* @__PURE__ */ Symbol();
function qZ(e) {
  return e.extensions ? Array.isArray(e.extensions[s3]) : !1;
}
function w$(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var BZ = function(e) {
  var t = Ur(Ur(Ur([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(r) {
    return Si(r) && r.message || "Error message not found.";
  }).join(`
`);
}, _o = (
  /** @class */
  (function(e) {
    Wc(t, e);
    function t(r) {
      var n = r.graphQLErrors, i = r.protocolErrors, a = r.clientErrors, o = r.networkError, s = r.errorMessage, l = r.extraInfo, d = e.call(this, s) || this;
      return d.name = "ApolloError", d.graphQLErrors = n || [], d.protocolErrors = i || [], d.clientErrors = a || [], d.networkError = o || null, d.message = s || BZ(d), d.extraInfo = l, d.cause = Ur(Ur(Ur([
        o
      ], n || [], !0), i || [], !0), a || [], !0).find(function(c) {
        return !!c;
      }) || null, d.__proto__ = t.prototype, d;
    }
    return t;
  })(Error)
), t9 = Object.prototype.hasOwnProperty;
function HZ(e, t) {
  return Sa(this, void 0, void 0, function() {
    var r, n, i, a, o, s, l, d, c, u, h, f, p, m, y, g, w, $, _, x, S, T, I, M;
    return Ca(this, function(P) {
      switch (P.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          r = new TextDecoder("utf-8"), n = (M = e.headers) === null || M === void 0 ? void 0 : M.get("content-type"), i = "boundary=", a = n?.includes(i) ? n?.substring(n?.indexOf(i) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", o = `\r
--`.concat(a), s = "", l = UZ(e), d = !0, P.label = 1;
        case 1:
          return d ? [4, l.next()] : [3, 3];
        case 2:
          for (c = P.sent(), u = c.value, h = c.done, f = typeof u == "string" ? u : r.decode(u), p = s.length - o.length + 1, d = !h, s += f, m = s.indexOf(o, p); m > -1; ) {
            if (y = void 0, T = [
              s.slice(0, m),
              s.slice(m + o.length)
            ], y = T[0], s = T[1], g = y.indexOf(`\r
\r
`), w = WZ(y.slice(0, g)), $ = w["content-type"], $ && $.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (_ = y.slice(g), _) {
              if (x = $$(e, _), Object.keys(x).length > 1 || "data" in x || "incremental" in x || "errors" in x || "payload" in x)
                if (EZ(x)) {
                  if (S = {}, "payload" in x) {
                    if (Object.keys(x).length === 1 && x.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    S = X({}, x.payload);
                  }
                  "errors" in x && (S = X(X({}, S), { extensions: X(X({}, "extensions" in S ? S.extensions : null), (I = {}, I[s3] = x.errors, I)) })), t(S);
                } else
                  t(x);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(x).length === 1 && "hasNext" in x && !x.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            m = s.indexOf(o);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function WZ(e) {
  var t = {};
  return e.split(`
`).forEach(function(r) {
    var n = r.indexOf(":");
    if (n > -1) {
      var i = r.slice(0, n).trim().toLowerCase(), a = r.slice(n + 1).trim();
      t[i] = a;
    }
  }), t;
}
function $$(e, t) {
  if (e.status >= 300) {
    var r = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    b$(e, r(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (i) {
    var n = i;
    throw n.name = "ServerParseError", n.response = e, n.statusCode = e.status, n.bodyText = t, n;
  }
}
function KZ(e, t) {
  e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
}
function QZ(e) {
  return function(t) {
    return t.text().then(function(r) {
      return $$(t, r);
    }).then(function(r) {
      return !Array.isArray(r) && !t9.call(r, "data") && !t9.call(r, "errors") && b$(t, r, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(n) {
        return n.operationName;
      }) : e.operationName, "'.")), r;
    });
  };
}
var p5 = function(e, t) {
  var r;
  try {
    r = JSON.stringify(e);
  } catch (i) {
    var n = Ri(54, t, i.message);
    throw n.parseError = i, n;
  }
  return r;
}, GZ = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, YZ = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, JZ = {
  method: "POST"
}, ZZ = {
  http: GZ,
  headers: YZ,
  options: JZ
}, XZ = function(e, t) {
  return t(e);
};
function eX(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var i = {}, a = {};
  r.forEach(function(u) {
    i = X(X(X({}, i), u.options), { headers: X(X({}, i.headers), u.headers) }), u.credentials && (i.credentials = u.credentials), a = X(X({}, a), u.http);
  }), i.headers && (i.headers = tX(i.headers, a.preserveHeaderCase));
  var o = e.operationName, s = e.extensions, l = e.variables, d = e.query, c = { operationName: o, variables: l };
  return a.includeExtensions && (c.extensions = s), a.includeQuery && (c.query = t(d, Vs)), {
    options: i,
    body: c
  };
}
function tX(e, t) {
  if (!t) {
    var r = {};
    return Object.keys(Object(e)).forEach(function(a) {
      r[a.toLowerCase()] = e[a];
    }), r;
  }
  var n = {};
  Object.keys(Object(e)).forEach(function(a) {
    n[a.toLowerCase()] = {
      originalName: a,
      value: e[a]
    };
  });
  var i = {};
  return Object.keys(n).forEach(function(a) {
    i[n[a].originalName] = n[a].value;
  }), i;
}
var rX = function(e) {
  if (!e && typeof fetch > "u")
    throw Ri(51);
}, nX = function(e, t) {
  var r = e.getContext(), n = r.uri;
  return n || (typeof t == "function" ? t(e) : t || "/graphql");
};
function iX(e, t) {
  var r = [], n = function(u, h) {
    r.push("".concat(u, "=").concat(encodeURIComponent(h)));
  };
  if ("query" in t && n("query", t.query), t.operationName && n("operationName", t.operationName), t.variables) {
    var i = void 0;
    try {
      i = p5(t.variables, "Variables map");
    } catch (u) {
      return { parseError: u };
    }
    n("variables", i);
  }
  if (t.extensions) {
    var a = void 0;
    try {
      a = p5(t.extensions, "Extensions map");
    } catch (u) {
      return { parseError: u };
    }
    n("extensions", a);
  }
  var o = "", s = e, l = e.indexOf("#");
  l !== -1 && (o = e.substr(l), s = e.substr(0, l));
  var d = s.indexOf("?") === -1 ? "?" : "&", c = s + d + r.join("&") + o;
  return { newURI: c };
}
var r9 = Yn(function() {
  return fetch;
}), aX = function(e) {
  e === void 0 && (e = {});
  var t = e.uri, r = t === void 0 ? "/graphql" : t, n = e.fetch, i = e.print, a = i === void 0 ? XZ : i, o = e.includeExtensions, s = e.preserveHeaderCase, l = e.useGETForQueries, d = e.includeUnusedVariables, c = d === void 0 ? !1 : d, u = Lp(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && rX(n || r9);
  var h = {
    http: { includeExtensions: o, preserveHeaderCase: s },
    options: u.fetchOptions,
    credentials: u.credentials,
    headers: u.headers
  };
  return new iu(function(f) {
    var p = nX(f, r), m = f.getContext(), y = {};
    if (m.clientAwareness) {
      var g = m.clientAwareness, w = g.name, $ = g.version;
      w && (y["apollographql-client-name"] = w), $ && (y["apollographql-client-version"] = $);
    }
    var _ = X(X({}, y), m.headers), x = {
      http: m.http,
      options: m.fetchOptions,
      credentials: m.credentials,
      headers: _
    };
    if (Tc(["client"], f.query)) {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Ae.warn(52);
      var S = h$(f.query);
      if (!S)
        return Hf(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      f.query = S;
    }
    var T = eX(f, a, ZZ, h, x), I = T.options, M = T.body;
    M.variables && !c && (M.variables = AZ(M.variables, f.query));
    var P;
    !I.signal && typeof AbortController < "u" && (P = new AbortController(), I.signal = P.signal);
    var O = function(H) {
      return H.kind === "OperationDefinition" && H.operation === "mutation";
    }, D = function(H) {
      return H.kind === "OperationDefinition" && H.operation === "subscription";
    }, R = D(ch(f.query)), L = Tc(["defer"], f.query);
    if (l && !f.query.definitions.some(O) && (I.method = "GET"), L || R) {
      I.headers = I.headers || {};
      var Q = "multipart/mixed;";
      R && L && globalThis.__DEV__ !== !1 && Ae.warn(53), R ? Q += "boundary=graphql;subscriptionSpec=1.0,application/json" : L && (Q += "deferSpec=20220824,application/json"), I.headers.accept = Q;
    }
    if (I.method === "GET") {
      var ie = iX(p, M), ee = ie.newURI, W = ie.parseError;
      if (W)
        return Hf(W);
      p = ee;
    } else
      try {
        I.body = p5(M, "Payload");
      } catch (H) {
        return Hf(H);
      }
    return new Ut(function(H) {
      var pe = n || Yn(function() {
        return fetch;
      }) || r9, Te = H.next.bind(H);
      return pe(p, I).then(function(Ce) {
        var de;
        f.setContext({ response: Ce });
        var K = (de = Ce.headers) === null || de === void 0 ? void 0 : de.get("content-type");
        return K !== null && /^multipart\/mixed/i.test(K) ? HZ(Ce, Te) : QZ(f)(Ce).then(Te);
      }).then(function() {
        P = void 0, H.complete();
      }).catch(function(Ce) {
        P = void 0, KZ(Ce, H);
      }), function() {
        P && P.abort();
      };
    });
  });
}, oX = (
  /** @class */
  (function(e) {
    Wc(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, aX(r).request) || this;
      return n.options = r, n;
    }
    return t;
  })(iu)
);
const { toString: n9, hasOwnProperty: sX } = Object.prototype, i9 = Function.prototype.toString, m5 = /* @__PURE__ */ new Map();
function er(e, t) {
  try {
    return g5(e, t);
  } finally {
    m5.clear();
  }
}
function g5(e, t) {
  if (e === t)
    return !0;
  const r = n9.call(e), n = n9.call(t);
  if (r !== n)
    return !1;
  switch (r) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (o9(e, t))
        return !0;
      const i = a9(e), a = a9(t), o = i.length;
      if (o !== a.length)
        return !1;
      for (let s = 0; s < o; ++s)
        if (!sX.call(t, i[s]))
          return !1;
      for (let s = 0; s < o; ++s) {
        const l = i[s];
        if (!g5(e[l], t[l]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (o9(e, t))
        return !0;
      const i = e.entries(), a = r === "[object Map]";
      for (; ; ) {
        const o = i.next();
        if (o.done)
          break;
        const [s, l] = o.value;
        if (!t.has(s) || a && !g5(l, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    // Fall through...
    case "[object DataView]": {
      let i = e.byteLength;
      if (i === t.byteLength)
        for (; i-- && e[i] === t[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = i9.call(e);
      return i !== i9.call(t) ? !1 : !cX(i, dX);
    }
  }
  return !1;
}
function a9(e) {
  return Object.keys(e).filter(lX, e);
}
function lX(e) {
  return this[e] !== void 0;
}
const dX = "{ [native code] }";
function cX(e, t) {
  const r = e.length - t.length;
  return r >= 0 && e.indexOf(t, r) === r;
}
function o9(e, t) {
  let r = m5.get(e);
  if (r) {
    if (r.has(t))
      return !0;
  } else
    m5.set(e, r = /* @__PURE__ */ new Set());
  return r.add(t), !1;
}
function uX(e, t, r, n) {
  var i = t.data, a = Lp(t, ["data"]), o = r.data, s = Lp(r, ["data"]);
  return er(a, s) && $0(ch(e).selectionSet, i, o, {
    fragmentMap: tu(nu(e)),
    variables: n
  });
}
function $0(e, t, r, n) {
  if (t === r)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return e.selections.every(function(a) {
    if (i.has(a) || (i.add(a), !Hw(a, n.variables)) || s9(a))
      return !0;
    if (m1(a)) {
      var o = p1(a), s = t && t[o], l = r && r[o], d = a.selectionSet;
      if (!d)
        return er(s, l);
      var c = Array.isArray(s), u = Array.isArray(l);
      if (c !== u)
        return !1;
      if (c && u) {
        var h = s.length;
        if (l.length !== h)
          return !1;
        for (var f = 0; f < h; ++f)
          if (!$0(d, s[f], l[f], n))
            return !1;
        return !0;
      }
      return $0(d, s, l, n);
    } else {
      var p = cJ(a, n.fragmentMap);
      if (p)
        return s9(p) ? !0 : $0(
          p.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          r,
          n
        );
    }
  });
}
function s9(e) {
  return !!e.directives && e.directives.some(hX);
}
function hX(e) {
  return e.name.value === "nonreactive";
}
var k$ = Zm ? WeakMap : Map, _$ = Ww ? WeakSet : Set, x$ = new zl(), l9 = !1;
function E$() {
  l9 || (l9 = !0, globalThis.__DEV__ !== !1 && Ae.warn(64));
}
function S$(e, t, r) {
  return x$.withValue(!0, function() {
    var n = Md(e, t, r, !1);
    return Object.isFrozen(e) && kZ(n), n;
  });
}
function fX(e, t) {
  if (t.has(e))
    return t.get(e);
  var r = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
  return t.set(e, r), r;
}
function Md(e, t, r, n, i) {
  var a, o = r.knownChanged, s = fX(e, r.mutableTargets);
  if (Array.isArray(e)) {
    for (var l = 0, d = Array.from(e.entries()); l < d.length; l++) {
      var c = d[l], u = c[0], h = c[1];
      if (h === null) {
        s[u] = null;
        continue;
      }
      var f = Md(h, t, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(u, "]") : void 0);
      o.has(f) && o.add(s), s[u] = f;
    }
    return o.has(s) ? s : e;
  }
  for (var p = 0, m = t.selections; p < m.length; p++) {
    var y = m[p], g = void 0;
    if (n && o.add(s), y.kind === fe.FIELD) {
      var w = p1(y), $ = y.selectionSet;
      if (g = s[w] || e[w], g === void 0)
        continue;
      if ($ && g !== null) {
        var f = Md(e[w], $, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat(w) : void 0);
        o.has(f) && (g = f);
      }
      globalThis.__DEV__ === !1 && (s[w] = g), globalThis.__DEV__ !== !1 && (n && w !== "__typename" && // either the field is not present in the memo object
      // or it has a `get` descriptor, not a `value` descriptor
      // => it is a warning accessor and we can overwrite it
      // with another accessor
      !(!((a = Object.getOwnPropertyDescriptor(s, w)) === null || a === void 0) && a.value) ? Object.defineProperty(s, w, pX(w, g, i || "", r.operationName, r.operationType)) : (delete s[w], s[w] = g));
    }
    if (y.kind === fe.INLINE_FRAGMENT && (!y.typeCondition || r.cache.fragmentMatches(y, e.__typename)) && (g = Md(e, y.selectionSet, r, n, i)), y.kind === fe.FRAGMENT_SPREAD) {
      var _ = y.name.value, x = r.fragmentMap[_] || (r.fragmentMap[_] = r.cache.lookupFragment(_));
      Ae(x, 59, _);
      var S = iJ(y);
      S !== "mask" && (g = Md(e, x.selectionSet, r, S === "migrate", i));
    }
    o.has(g) && o.add(s);
  }
  return "__typename" in e && !("__typename" in s) && (s.__typename = e.__typename), Object.keys(s).length !== Object.keys(e).length && o.add(s), o.has(s) ? s : e;
}
function pX(e, t, r, n, i) {
  var a = function() {
    return x$.getValue() || (globalThis.__DEV__ !== !1 && Ae.warn(60, n ? "".concat(i, " '").concat(n, "'") : "anonymous ".concat(i), "".concat(r, ".").concat(e).replace(/^\./, "")), a = function() {
      return t;
    }), t;
  };
  return {
    get: function() {
      return a();
    },
    set: function(o) {
      a = function() {
        return o;
      };
    },
    enumerable: !0,
    configurable: !0
  };
}
function mX(e, t, r, n) {
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && E$(), e;
  var i = t.definitions.filter(function(o) {
    return o.kind === fe.FRAGMENT_DEFINITION;
  });
  typeof n > "u" && (Ae(i.length === 1, 61, i.length), n = i[0].name.value);
  var a = i.find(function(o) {
    return o.name.value === n;
  });
  return Ae(!!a, 62, n), e == null || er(e, {}) ? e : S$(e, a.selectionSet, {
    operationType: "fragment",
    operationName: a.name.value,
    fragmentMap: tu(nu(t)),
    cache: r,
    mutableTargets: new k$(),
    knownChanged: new _$()
  });
}
function gX(e, t, r) {
  var n;
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && E$(), e;
  var i = yl(t);
  return Ae(i, 63), e == null ? e : S$(e, i.selectionSet, {
    operationType: i.operation,
    operationName: (n = i.name) === null || n === void 0 ? void 0 : n.value,
    fragmentMap: tu(nu(t)),
    cache: r,
    mutableTargets: new k$(),
    knownChanged: new _$()
  });
}
var vX = new zl(), $t;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})($t || ($t = {}));
function Us(e) {
  return e ? e < 7 : !1;
}
var d9 = Object.assign, yX = Object.hasOwnProperty, k0 = (
  /** @class */
  (function(e) {
    Wc(t, e);
    function t(r) {
      var n = r.queryManager, i = r.queryInfo, a = r.options, o = this, s = t.inactiveOnCreation.getValue();
      o = e.call(this, function(g) {
        o._getOrCreateQuery();
        try {
          var w = g._subscription._observer;
          w && !w.error && (w.error = bX);
        } catch {
        }
        var $ = !o.observers.size;
        o.observers.add(g);
        var _ = o.last;
        return _ && _.error ? g.error && g.error(_.error) : _ && _.result && g.next && g.next(o.maskResult(_.result)), $ && o.reobserve().catch(function() {
        }), function() {
          o.observers.delete(g) && !o.observers.size && o.tearDownQuery();
        };
      }) || this, o.observers = /* @__PURE__ */ new Set(), o.subscriptions = /* @__PURE__ */ new Set(), o.dirty = !1, o._getOrCreateQuery = function() {
        return s && (n.queries.set(o.queryId, i), s = !1), o.queryManager.getOrCreateQuery(o.queryId);
      }, o.queryInfo = i, o.queryManager = n, o.waitForOwnResult = Wf(a.fetchPolicy), o.isTornDown = !1, o.subscribeToMore = o.subscribeToMore.bind(o), o.maskResult = o.maskResult.bind(o);
      var l = n.defaultOptions.watchQuery, d = l === void 0 ? {} : l, c = d.fetchPolicy, u = c === void 0 ? "cache-first" : c, h = a.fetchPolicy, f = h === void 0 ? u : h, p = a.initialFetchPolicy, m = p === void 0 ? f === "standby" ? u : f : p;
      o.options = X(X({}, a), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: m,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: f
      }), o.queryId = i.queryId || n.generateQueryId();
      var y = yl(o.query);
      return o.queryName = y && y.name && y.name.value, o;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var r = this;
      return globalThis.__DEV__ !== !1 && Io("observableQuery.result", function() {
        globalThis.__DEV__ !== !1 && Ae.warn(23);
      }), new Promise(function(n, i) {
        var a = {
          next: function(s) {
            n(s), r.observers.delete(a), r.observers.size || r.queryManager.removeQuery(r.queryId), setTimeout(function() {
              o.unsubscribe();
            }, 0);
          },
          error: i
        }, o = r.subscribe(a);
      });
    }, t.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, t.prototype.getCurrentFullResult = function(r) {
      var n = this;
      r === void 0 && (r = !0);
      var i = Jn("getLastResult", function() {
        return n.getLastResult(!0);
      }), a = this.queryInfo.networkStatus || i && i.networkStatus || $t.ready, o = X(X({}, i), { loading: Us(a), networkStatus: a }), s = this.options.fetchPolicy, l = s === void 0 ? "cache-first" : s;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(Wf(l) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var d = this.queryInfo.getDiff();
        (d.complete || this.options.returnPartialData) && (o.data = d.result), er(o.data, {}) && (o.data = void 0), d.complete ? (delete o.partial, d.complete && o.networkStatus === $t.loading && (l === "cache-first" || l === "cache-only") && (o.networkStatus = $t.ready, o.loading = !1)) : o.partial = !0, o.networkStatus === $t.ready && (o.error || o.errors) && (o.networkStatus = $t.error), globalThis.__DEV__ !== !1 && !d.complete && !this.options.partialRefetch && !o.loading && !o.data && !o.error && C$(d.missing);
      }
      return r && this.updateLastResult(o), o;
    }, t.prototype.getCurrentResult = function(r) {
      return r === void 0 && (r = !0), this.maskResult(this.getCurrentFullResult(r));
    }, t.prototype.isDifferentFromLastResult = function(r, n) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), a = this.queryManager.dataMasking, o = a ? i.nonReactiveQuery : this.query, s = a || i.hasNonreactiveDirective ? !uX(o, this.last.result, r, this.variables) : !er(this.last.result, r);
      return s || n && !er(this.last.variables, n);
    }, t.prototype.getLast = function(r, n) {
      var i = this.last;
      if (i && i[r] && (!n || er(i.variables, this.variables)))
        return i[r];
    }, t.prototype.getLastResult = function(r) {
      return globalThis.__DEV__ !== !1 && Io("getLastResult", function() {
        globalThis.__DEV__ !== !1 && Ae.warn(24);
      }), this.getLast("result", r);
    }, t.prototype.getLastError = function(r) {
      return globalThis.__DEV__ !== !1 && Io("getLastError", function() {
        globalThis.__DEV__ !== !1 && Ae.warn(25);
      }), this.getLast("error", r);
    }, t.prototype.resetLastResults = function() {
      globalThis.__DEV__ !== !1 && Io("resetLastResults", function() {
        globalThis.__DEV__ !== !1 && Ae.warn(26);
      }), delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Ae.warn(27), this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(r) {
      var n, i = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, a = this.options.fetchPolicy;
      if (a === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && r && yX.call(r, "variables")) {
        var o = VJ(this.query), s = o.variableDefinitions;
        (!s || !s.some(function(l) {
          return l.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && Ae.warn(
          28,
          r,
          ((n = o.name) === null || n === void 0 ? void 0 : n.value) || o
        );
      }
      return r && !er(this.options.variables, r) && (i.variables = this.options.variables = X(X({}, this.options.variables), r)), this.queryInfo.resetLastWrite(), this.reobserve(i, $t.refetch);
    }, t.prototype.fetchMore = function(r) {
      var n = this, i = X(X({}, r.query ? r : X(X(X(X({}, this.options), { query: this.options.query }), r), { variables: X(X({}, this.options.variables), r.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var a = this.queryManager.generateQueryId();
      this.lastQuery = r.query ? this.transformDocument(this.options.query) : i.query;
      var o = this.queryInfo, s = o.networkStatus;
      o.networkStatus = $t.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var l = /* @__PURE__ */ new Set(), d = r?.updateQuery, c = this.options.fetchPolicy !== "no-cache";
      return c || Ae(d, 29), this.queryManager.fetchQuery(a, i, $t.fetchMore).then(function(u) {
        if (n.queryManager.removeQuery(a), o.networkStatus === $t.fetchMore && (o.networkStatus = s), c)
          n.queryManager.cache.batch({
            update: function(p) {
              var m = r.updateQuery;
              m ? p.updateQuery({
                query: n.query,
                variables: n.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(y) {
                return m(y, {
                  fetchMoreResult: u.data,
                  variables: i.variables
                });
              }) : p.writeQuery({
                query: i.query,
                variables: i.variables,
                data: u.data
              });
            },
            onWatchUpdated: function(p) {
              l.add(p.query);
            }
          });
        else {
          var h = n.getLast("result"), f = d(h.data, {
            fetchMoreResult: u.data,
            variables: i.variables
          });
          n.reportResult(X(X({}, h), { networkStatus: s, loading: Us(s), data: f }), n.variables);
        }
        return n.maskResult(u);
      }).finally(function() {
        c && !l.has(n.query) && n.reobserveCacheFirst();
      });
    }, t.prototype.subscribeToMore = function(r) {
      var n = this, i = this.queryManager.startGraphQLSubscription({
        query: r.document,
        variables: r.variables,
        context: r.context
      }).subscribe({
        next: function(a) {
          var o = r.updateQuery;
          o && n.updateQuery(function(s, l) {
            return o(s, X({ subscriptionData: a }, l));
          });
        },
        error: function(a) {
          if (r.onError) {
            r.onError(a);
            return;
          }
          globalThis.__DEV__ !== !1 && Ae.error(30, a);
        }
      });
      return this.subscriptions.add(i), function() {
        n.subscriptions.delete(i) && i.unsubscribe();
      };
    }, t.prototype.setOptions = function(r) {
      return globalThis.__DEV__ !== !1 && (In(r, "canonizeResults", "setOptions"), Io("setOptions", function() {
        globalThis.__DEV__ !== !1 && Ae.warn(31);
      })), this.reobserve(r);
    }, t.prototype.silentSetOptions = function(r) {
      var n = v1(this.options, r || {});
      d9(this.options, n);
    }, t.prototype.setVariables = function(r) {
      var n = this;
      return er(this.variables, r) ? this.observers.size ? Jn("observableQuery.result", function() {
        return n.result();
      }) : Promise.resolve() : (this.options.variables = r, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: r
      }, $t.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(r) {
      var n = this.queryManager, i = n.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), a = i.result, o = i.complete, s = r(a, {
        variables: this.variables,
        complete: !!o,
        previousData: a
      });
      s && (n.cache.writeQuery({
        query: this.options.query,
        data: s,
        variables: this.variables
      }), n.broadcastQueries());
    }, t.prototype.startPolling = function(r) {
      this.options.pollInterval = r, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(r, n) {
      if (n.nextFetchPolicy) {
        var i = n.fetchPolicy, a = i === void 0 ? "cache-first" : i, o = n.initialFetchPolicy, s = o === void 0 ? a : o;
        a === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(a, {
          reason: r,
          options: n,
          observable: this,
          initialFetchPolicy: s
        }) : r === "variables-changed" ? n.fetchPolicy = s : n.fetchPolicy = n.nextFetchPolicy);
      }
      return n.fetchPolicy;
    }, t.prototype.fetch = function(r, n, i) {
      var a = this._getOrCreateQuery();
      return a.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(a, r, n, i);
    }, t.prototype.updatePolling = function() {
      var r = this;
      if (!this.queryManager.ssrMode) {
        var n = this, i = n.pollingInfo, a = n.options.pollInterval;
        if (!a || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === a)) {
          Ae(a, 32);
          var o = i || (this.pollingInfo = {});
          o.interval = a;
          var s = function() {
            var d, c;
            r.pollingInfo && (!Us(r.queryInfo.networkStatus) && !(!((c = (d = r.options).skipPollAttempt) === null || c === void 0) && c.call(d)) ? r.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: r.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, $t.poll).then(l, l) : l());
          }, l = function() {
            var d = r.pollingInfo;
            d && (clearTimeout(d.timeout), d.timeout = setTimeout(s, d.interval));
          };
          l();
        }
      }
    }, t.prototype.updateLastResult = function(r, n) {
      var i = this;
      n === void 0 && (n = this.variables);
      var a = Jn("getLastError", function() {
        return i.getLastError();
      });
      return a && this.last && !er(n, this.last.variables) && (a = void 0), this.last = X({ result: this.queryManager.assumeImmutableResults ? r : bZ(r), variables: n }, a ? { error: a } : null);
    }, t.prototype.reobserveAsConcast = function(r, n) {
      var i = this;
      this.isTornDown = !1;
      var a = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        n === $t.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        n === $t.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        n === $t.poll
      ), o = this.options.variables, s = this.options.fetchPolicy, l = v1(this.options, r || {}), d = a ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        l
      ) : d9(this.options, l), c = this.transformDocument(d.query);
      this.lastQuery = c, a || (this.updatePolling(), r && r.variables && !er(r.variables, o) && // Don't mess with the fetchPolicy if it's currently "standby".
      d.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (d.fetchPolicy === s || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof d.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", d), n === void 0 && (n = $t.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = Wf(d.fetchPolicy));
      var u = function() {
        i.concast === p && (i.waitForOwnResult = !1);
      }, h = d.variables && X({}, d.variables), f = this.fetch(d, n, c), p = f.concast, m = f.fromLink, y = {
        next: function(g) {
          er(i.variables, h) && (u(), i.reportResult(g, h));
        },
        error: function(g) {
          er(i.variables, h) && (w$(g) || (g = new _o({ networkError: g })), u(), i.reportError(g, h));
        }
      };
      return !a && (m || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = p, this.observer = y), p.addObserver(y), p;
    }, t.prototype.reobserve = function(r, n) {
      return vZ(this.reobserveAsConcast(r, n).promise.then(this.maskResult));
    }, t.prototype.resubscribeAfterError = function() {
      for (var r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var a = this.last;
      Jn("resetLastResults", function() {
        return r.resetLastResults();
      });
      var o = this.subscribe.apply(this, n);
      return this.last = a, o;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(r, n) {
      var i = this, a = Jn("getLastError", function() {
        return i.getLastError();
      }), o = this.isDifferentFromLastResult(r, n);
      (a || !r.partial || this.options.returnPartialData) && this.updateLastResult(r, n), (a || o) && Qd(this.observers, "next", this.maskResult(r));
    }, t.prototype.reportError = function(r, n) {
      var i = this, a = X(X({}, Jn("getLastResult", function() {
        return i.getLastResult();
      })), { error: r, errors: r.graphQLErrors, networkStatus: $t.error, loading: !1 });
      this.updateLastResult(a, n), Qd(this.observers, "error", this.last.error = r);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(r) {
        return r.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(r) {
      return this.queryManager.transform(r);
    }, t.prototype.maskResult = function(r) {
      return r && "data" in r ? X(X({}, r), { data: this.queryManager.maskOperation({
        document: this.query,
        data: r.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : r;
    }, t.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, t.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, t.prototype.scheduleNotify = function() {
      var r = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return r.notify();
      }, 0)));
    }, t.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !Us(this.queryInfo.networkStatus))) {
        var r = this.queryInfo.getDiff();
        r.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, t.prototype.reobserveCacheFirst = function() {
      var r = this.options, n = r.fetchPolicy, i = r.nextFetchPolicy;
      return n === "cache-and-network" || n === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(a, o) {
          return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(a, o) : n;
        }
      }) : this.reobserve();
    }, t.inactiveOnCreation = new zl(), t;
  })(Ut)
);
v$(k0);
function bX(e) {
  globalThis.__DEV__ !== !1 && Ae.error(33, e.message, e.stack);
}
function C$(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && Ae.debug(34, e);
}
function Wf(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var qs = new (Zm ? WeakMap : Map)();
function Kf(e, t) {
  var r = e[t];
  typeof r == "function" && (e[t] = function() {
    return qs.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (qs.get(e) + 1) % 1e15
    ), r.apply(this, arguments);
  });
}
var Qf = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = t.generateQueryId()), this.queryId = r, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
      var n = this.cache = t.cache;
      qs.has(n) || (qs.set(n, 0), Kf(n, "evict"), Kf(n, "modify"), Kf(n, "reset"));
    }
    return e.prototype.init = function(t) {
      var r = t.networkStatus || $t.loading;
      return this.variables && this.networkStatus !== $t.loading && !er(this.variables, t.variables) && (r = $t.setVariables), er(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: t.document,
        variables: t.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: r
      }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
    }, e.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, e.prototype.getDiff = function() {
      var t = this, r = this.getDiffOptions();
      if (this.lastDiff && er(r, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var n = this.observableQuery;
      if (n && n.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = Jn("canonizeResults", function() {
        return t.cache.diff(r);
      });
      return this.updateLastDiff(i, r), i;
    }, e.prototype.updateLastDiff = function(t, r) {
      this.lastDiff = t ? {
        diff: t,
        options: r || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(t) {
      var r;
      return t === void 0 && (t = this.variables), {
        query: this.document,
        variables: t,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (r = this.observableQuery) === null || r === void 0 ? void 0 : r.options.canonizeResults
      };
    }, e.prototype.setDiff = function(t) {
      var r = this, n, i = this.lastDiff && this.lastDiff.diff;
      t && !t.complete && Jn("getLastError", function() {
        var a;
        return (a = r.observableQuery) === null || a === void 0 ? void 0 : a.getLastError();
      }) || (this.updateLastDiff(t), er(i && i.result, t && t.result) || (n = this.observableQuery) === null || n === void 0 || n.scheduleNotify());
    }, e.prototype.setObservableQuery = function(t) {
      t !== this.observableQuery && (this.observableQuery = t, t && (t.queryInfo = this));
    }, e.prototype.stop = function() {
      var t;
      if (!this.stopped) {
        this.stopped = !0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), this.cancel();
        var r = this.observableQuery;
        r && r.stopPolling();
      }
    }, e.prototype.cancel = function() {
      var t;
      (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
    }, e.prototype.updateWatch = function(t) {
      var r = this;
      t === void 0 && (t = this.variables);
      var n = this.observableQuery;
      if (!(n && n.options.fetchPolicy === "no-cache")) {
        var i = X(X({}, this.getDiffOptions(t)), { watcher: this, callback: function(a) {
          return r.setDiff(a);
        } });
        (!this.lastWatch || !er(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(t, r) {
      var n = this.lastWrite;
      return !(n && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      n.dmCount === qs.get(this.cache) && er(r, n.variables) && er(t.data, n.result.data));
    }, e.prototype.markResult = function(t, r, n, i) {
      var a = this, o, s = new r3(), l = Qa(t.errors) ? t.errors.slice(0) : [];
      if ((o = this.observableQuery) === null || o === void 0 || o.resetNotifications(), "incremental" in t && Qa(t.incremental)) {
        var d = y$(this.getDiff().result, t);
        t.data = d;
      } else if ("hasNext" in t && t.hasNext) {
        var c = this.getDiff();
        t.data = s.merge(c.result, t.data);
      }
      this.graphQLErrors = l, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (v5(t, n.errorPolicy) ? this.cache.performTransaction(function(u) {
        if (a.shouldWrite(t, n.variables))
          u.writeQuery({
            query: r,
            data: t.data,
            variables: n.variables,
            overwrite: i === 1
          }), a.lastWrite = {
            result: t,
            variables: n.variables,
            dmCount: qs.get(a.cache)
          };
        else if (a.lastDiff && a.lastDiff.diff.complete) {
          t.data = a.lastDiff.diff.result;
          return;
        }
        var h = a.getDiffOptions(n.variables), f = Jn("canonizeResults", function() {
          return u.diff(h);
        });
        !a.stopped && er(a.variables, n.variables) && a.updateWatch(n.variables), a.updateLastDiff(f, h), f.complete && (t.data = f.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = $t.ready;
    }, e.prototype.markError = function(t) {
      var r;
      return this.networkStatus = $t.error, this.lastWrite = void 0, (r = this.observableQuery) === null || r === void 0 || r.resetNotifications(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
    }, e;
  })()
);
function v5(e, t) {
  t === void 0 && (t = "none");
  var r = t === "ignore" || t === "all", n = !b0(e);
  return !n && r && e.data && (n = !0), n;
}
var wX = Object.prototype.hasOwnProperty, c9 = /* @__PURE__ */ Object.create(null), $X = (
  /** @class */
  (function() {
    function e(t) {
      var r = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new Gw(
        ru["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new eu(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var n = new tZ(
        function(a) {
          return r.cache.transformDocument(a);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
      var i = t.documentTransform;
      this.documentTransform = i ? n.concat(i).concat(n) : n, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var t = this;
      this.queries.forEach(function(r, n) {
        t.stopQueryNoBroadcast(n);
      }), this.cancelPendingFetches(Ri(35));
    }, e.prototype.cancelPendingFetches = function(t) {
      this.fetchCancelFns.forEach(function(r) {
        return r(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(t) {
      return Sa(this, arguments, void 0, function(r) {
        var n, i, a, o, s, l, d, c = r.mutation, u = r.variables, h = r.optimisticResponse, f = r.updateQueries, p = r.refetchQueries, m = p === void 0 ? [] : p, y = r.awaitRefetchQueries, g = y === void 0 ? !1 : y, w = r.update, $ = r.onQueryUpdated, _ = r.fetchPolicy, x = _ === void 0 ? ((l = this.defaultOptions.mutate) === null || l === void 0 ? void 0 : l.fetchPolicy) || "network-only" : _, S = r.errorPolicy, T = S === void 0 ? ((d = this.defaultOptions.mutate) === null || d === void 0 ? void 0 : d.errorPolicy) || "none" : S, I = r.keepRootFields, M = r.context;
        return Ca(this, function(P) {
          switch (P.label) {
            case 0:
              return Ae(c, 36), Ae(x === "network-only" || x === "no-cache", 37), n = this.generateMutationId(), c = this.cache.transformForLink(this.transform(c)), i = this.getDocumentInfo(c).hasClientExports, u = this.getVariables(c, u), i ? [4, this.localState.addExportedVariables(c, u, M)] : [3, 2];
            case 1:
              u = P.sent(), P.label = 2;
            case 2:
              return a = this.mutationStore && (this.mutationStore[n] = {
                mutation: c,
                variables: u,
                loading: !0,
                error: null
              }), o = h && this.markMutationOptimistic(h, {
                mutationId: n,
                document: c,
                variables: u,
                fetchPolicy: x,
                errorPolicy: T,
                context: M,
                updateQueries: f,
                update: w,
                keepRootFields: I
              }), this.broadcastQueries(), s = this, [2, new Promise(function(O, D) {
                return Bf(s.getObservableFromLink(c, X(X({}, M), { optimisticResponse: o ? h : void 0 }), u, {}, !1), function(R) {
                  if (b0(R) && T === "none")
                    throw new _o({
                      graphQLErrors: u5(R)
                    });
                  a && (a.loading = !1, a.error = null);
                  var L = X({}, R);
                  return typeof m == "function" && (m = m(L)), T === "ignore" && b0(L) && delete L.errors, s.markMutationResult({
                    mutationId: n,
                    result: L,
                    document: c,
                    variables: u,
                    fetchPolicy: x,
                    errorPolicy: T,
                    context: M,
                    update: w,
                    updateQueries: f,
                    awaitRefetchQueries: g,
                    refetchQueries: m,
                    removeOptimistic: o ? n : void 0,
                    onQueryUpdated: $,
                    keepRootFields: I
                  });
                }).subscribe({
                  next: function(R) {
                    s.broadcastQueries(), (!("hasNext" in R) || R.hasNext === !1) && O(X(X({}, R), { data: s.maskOperation({
                      document: c,
                      data: R.data,
                      fetchPolicy: x,
                      id: n
                    }) }));
                  },
                  error: function(R) {
                    a && (a.loading = !1, a.error = R), o && s.cache.removeOptimistic(n), s.broadcastQueries(), D(R instanceof _o ? R : new _o({
                      networkError: R
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(t, r) {
      var n = this;
      r === void 0 && (r = this.cache);
      var i = t.result, a = [], o = t.fetchPolicy === "no-cache";
      if (!o && v5(i, t.errorPolicy)) {
        if (rl(i) || a.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), rl(i) && Qa(i.incremental)) {
          var s = r.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(t.document).asQuery,
            variables: t.variables,
            optimistic: !1,
            returnPartialData: !0
          }), l = void 0;
          s.result && (l = y$(s.result, i)), typeof l < "u" && (i.data = l, a.push({
            result: l,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var d = t.updateQueries;
        d && this.queries.forEach(function(u, h) {
          var f = u.observableQuery, p = f && f.queryName;
          if (!(!p || !wX.call(d, p))) {
            var m = d[p], y = n.queries.get(h), g = y.document, w = y.variables, $ = r.diff({
              query: g,
              variables: w,
              returnPartialData: !0,
              optimistic: !1
            }), _ = $.result, x = $.complete;
            if (x && _) {
              var S = m(_, {
                mutationResult: i,
                queryName: g && Nd(g) || void 0,
                queryVariables: w
              });
              S && a.push({
                result: S,
                dataId: "ROOT_QUERY",
                query: g,
                variables: w
              });
            }
          }
        });
      }
      if (a.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var c = [];
        if (this.refetchQueries({
          updateCache: function(u) {
            o || a.forEach(function(m) {
              return u.write(m);
            });
            var h = t.update, f = !xZ(i) || rl(i) && !i.hasNext;
            if (h) {
              if (!o) {
                var p = u.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: n.getDocumentInfo(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                p.complete && (i = X(X({}, i), { data: p.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              f && h(u, i, {
                context: t.context,
                variables: t.variables
              });
            }
            !o && !t.keepRootFields && f && u.modify({
              id: "ROOT_MUTATION",
              fields: function(m, y) {
                var g = y.fieldName, w = y.DELETE;
                return g === "__typename" ? m : w;
              }
            });
          },
          include: t.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: t.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function(u) {
          return c.push(u);
        }), t.awaitRefetchQueries || t.onQueryUpdated)
          return Promise.all(c).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, e.prototype.markMutationOptimistic = function(t, r) {
      var n = this, i = typeof t == "function" ? t(r.variables, { IGNORE: c9 }) : t;
      return i === c9 ? !1 : (this.cache.recordOptimisticTransaction(function(a) {
        try {
          n.markMutationResult(X(X({}, r), { result: { data: i } }), a);
        } catch (o) {
          globalThis.__DEV__ !== !1 && Ae.error(o);
        }
      }, r.mutationId), !0);
    }, e.prototype.fetchQuery = function(t, r, n) {
      return this.fetchConcastWithInfo(this.getOrCreateQuery(t), r, n).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var t = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(r, n) {
        t[n] = {
          variables: r.variables,
          networkStatus: r.networkStatus,
          networkError: r.networkError,
          graphQLErrors: r.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function(t) {
      var r = this.queries.get(t);
      r && (r.networkError = void 0, r.graphQLErrors = []);
    }, e.prototype.transform = function(t) {
      return this.documentTransform.transformDocument(t);
    }, e.prototype.getDocumentInfo = function(t) {
      var r = this.transformCache;
      if (!r.has(t)) {
        var n = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: tJ(t),
          hasForcedResolvers: this.localState.shouldForceResolvers(t),
          hasNonreactiveDirective: Tc(["nonreactive"], t),
          nonReactiveQuery: oZ(t),
          clientQuery: this.localState.clientQuery(t),
          serverQuery: u$([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], t),
          defaultVars: qJ(yl(t)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: X(X({}, t), { definitions: t.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? X(X({}, i), { operation: "query" }) : i;
          }) })
        };
        r.set(t, n);
      }
      return r.get(t);
    }, e.prototype.getVariables = function(t, r) {
      return X(X({}, this.getDocumentInfo(t).defaultVars), r);
    }, e.prototype.watchQuery = function(t) {
      var r = this.transform(t.query);
      t = X(X({}, t), { variables: this.getVariables(r, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var n = new Qf(this), i = new k0({
        queryManager: this,
        queryInfo: n,
        options: t
      });
      return i.lastQuery = r, k0.inactiveOnCreation.getValue() || this.queries.set(i.queryId, n), n.init({
        document: r,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, e.prototype.query = function(t, r) {
      var n = this;
      r === void 0 && (r = this.generateQueryId()), Ae(t.query, 38), Ae(t.query.kind === "Document", 39), Ae(!t.returnPartialData, 40), Ae(!t.pollInterval, 41);
      var i = this.transform(t.query);
      return this.fetchQuery(r, X(X({}, t), { query: i })).then(function(a) {
        return a && X(X({}, a), { data: n.maskOperation({
          document: i,
          data: a.data,
          fetchPolicy: t.fetchPolicy,
          id: r
        }) });
      }).finally(function() {
        return n.stopQuery(r);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
      var r = this.queries.get(t);
      r && r.stop();
    }, e.prototype.clearStore = function(t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(Ri(42)), this.queries.forEach(function(r) {
        r.observableQuery ? r.networkStatus = $t.loading : r.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = "active");
      var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set();
      return Array.isArray(t) && t.forEach(function(s) {
        if (typeof s == "string")
          i.set(s, s), a.set(s, !1);
        else if (TJ(s)) {
          var l = Vs(r.transform(s));
          i.set(l, Nd(s)), a.set(l, !1);
        } else Si(s) && s.query && o.add(s);
      }), this.queries.forEach(function(s, l) {
        var d = s.observableQuery, c = s.document;
        if (d) {
          if (t === "all") {
            n.set(l, d);
            return;
          }
          var u = d.queryName, h = d.options.fetchPolicy;
          if (h === "standby" || t === "active" && !d.hasObservers())
            return;
          (t === "active" || u && a.has(u) || c && a.has(Vs(c))) && (n.set(l, d), u && a.set(u, !0), c && a.set(Vs(c), !0));
        }
      }), o.size && o.forEach(function(s) {
        var l = r5("legacyOneTimeQuery"), d = r.getOrCreateQuery(l).init({
          document: s.query,
          variables: s.variables
        }), c = new k0({
          queryManager: r,
          queryInfo: d,
          options: X(X({}, s), { fetchPolicy: "network-only" })
        });
        Ae(c.queryId === l), d.setObservableQuery(c), n.set(l, c);
      }), globalThis.__DEV__ !== !1 && a.size && a.forEach(function(s, l) {
        if (!s) {
          var d = i.get(l);
          d ? globalThis.__DEV__ !== !1 && Ae.warn(43, d) : globalThis.__DEV__ !== !1 && Ae.warn(44);
        }
      }), n;
    }, e.prototype.reFetchObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = !1);
      var n = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function(i, a) {
        var o = i.options.fetchPolicy;
        Jn("resetLastResults", function() {
          return i.resetLastResults();
        }), (t || o !== "standby" && o !== "cache-only") && n.push(i.refetch()), (r.queries.get(a) || i.queryInfo).setDiff(null);
      }), this.broadcastQueries(), Promise.all(n);
    }, e.prototype.startGraphQLSubscription = function(t) {
      var r = this, n = t.query, i = t.variables, a = t.fetchPolicy, o = t.errorPolicy, s = o === void 0 ? "none" : o, l = t.context, d = l === void 0 ? {} : l, c = t.extensions, u = c === void 0 ? {} : c;
      n = this.transform(n), i = this.getVariables(n, i);
      var h = function(p) {
        return r.getObservableFromLink(n, d, p, u).map(function(m) {
          a !== "no-cache" && (v5(m, s) && r.cache.write({
            query: n,
            result: m.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: p
          }), r.broadcastQueries());
          var y = b0(m), g = qZ(m);
          if (y || g) {
            var w = {};
            if (y && (w.graphQLErrors = m.errors), g && (w.protocolErrors = m.extensions[s3]), s === "none" || g)
              throw new _o(w);
          }
          return s === "ignore" && delete m.errors, m;
        });
      };
      if (this.getDocumentInfo(n).hasClientExports) {
        var f = this.localState.addExportedVariables(n, i, d).then(h);
        return new Ut(function(p) {
          var m = null;
          return f.then(function(y) {
            return m = y.subscribe(p);
          }, p.error), function() {
            return m && m.unsubscribe();
          };
        });
      }
      return h(i);
    }, e.prototype.stopQuery = function(t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function(t) {
      var r;
      this.fetchCancelFns.delete(t), this.queries.has(t) && ((r = this.queries.get(t)) === null || r === void 0 || r.stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
        var r;
        return (r = t.observableQuery) === null || r === void 0 ? void 0 : r.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(t, r, n, i, a) {
      var o = this, s;
      a === void 0 && (a = (s = r?.queryDeduplication) !== null && s !== void 0 ? s : this.queryDeduplication);
      var l, d = this.getDocumentInfo(t), c = d.serverQuery, u = d.clientQuery;
      if (c) {
        var h = this, f = h.inFlightLinkObservables, p = h.link, m = {
          query: c,
          variables: n,
          operationName: Nd(c) || void 0,
          context: this.prepareContext(X(X({}, r), { forceFetch: !a })),
          extensions: i
        };
        if (r = m.context, a) {
          var y = Vs(c), g = Xm(n), w = f.lookup(y, g);
          if (l = w.observable, !l) {
            var $ = new As([
              f5(p, m)
            ]);
            l = w.observable = $, $.beforeNext(function _(x, S) {
              x === "next" && "hasNext" in S && S.hasNext ? $.beforeNext(_) : f.remove(y, g);
            });
          }
        } else
          l = new As([
            f5(p, m)
          ]);
      } else
        l = new As([Ut.of({ data: {} })]), r = this.prepareContext(r);
      return u && (l = Bf(l, function(_) {
        return o.localState.runResolvers({
          document: u,
          remoteResult: _,
          context: r,
          variables: n
        });
      })), l;
    }, e.prototype.getResultsFromLink = function(t, r, n) {
      var i = t.lastRequestId = this.generateRequestId(), a = this.cache.transformForLink(n.query);
      return Bf(this.getObservableFromLink(a, n.context, n.variables), function(o) {
        var s = u5(o), l = s.length > 0, d = n.errorPolicy;
        if (i >= t.lastRequestId) {
          if (l && d === "none")
            throw t.markError(new _o({
              graphQLErrors: s
            }));
          t.markResult(o, a, n, r), t.markReady();
        }
        var c = {
          data: o.data,
          loading: !1,
          networkStatus: $t.ready
        };
        return l && d === "none" && (c.data = void 0), l && d !== "ignore" && (c.errors = s, c.networkStatus = $t.error), c;
      }, function(o) {
        var s = w$(o) ? o : new _o({ networkError: o });
        throw i >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchConcastWithInfo = function(t, r, n, i) {
      var a = this;
      n === void 0 && (n = $t.loading), i === void 0 && (i = r.query);
      var o = this.getVariables(i, r.variables), s = this.defaultOptions.watchQuery, l = r.fetchPolicy, d = l === void 0 ? s && s.fetchPolicy || "cache-first" : l, c = r.errorPolicy, u = c === void 0 ? s && s.errorPolicy || "none" : c, h = r.returnPartialData, f = h === void 0 ? !1 : h, p = r.notifyOnNetworkStatusChange, m = p === void 0 ? !1 : p, y = r.context, g = y === void 0 ? {} : y, w = Object.assign({}, r, {
        query: i,
        variables: o,
        fetchPolicy: d,
        errorPolicy: u,
        returnPartialData: f,
        notifyOnNetworkStatusChange: m,
        context: g
      }), $ = function(I) {
        w.variables = I;
        var M = a.fetchQueryByPolicy(t, w, n);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          w.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          M.sources.length > 0 && t.observableQuery && t.observableQuery.applyNextFetchPolicy("after-fetch", r), M
        );
      }, _ = function() {
        return a.fetchCancelFns.delete(t.queryId);
      };
      this.fetchCancelFns.set(t.queryId, function(I) {
        _(), setTimeout(function() {
          return x.cancel(I);
        });
      });
      var x, S;
      if (this.getDocumentInfo(w.query).hasClientExports)
        x = new As(this.localState.addExportedVariables(w.query, w.variables, w.context).then($).then(function(I) {
          return I.sources;
        })), S = !0;
      else {
        var T = $(w.variables);
        S = T.fromLink, x = new As(T.sources);
      }
      return x.promise.then(_, _), {
        concast: x,
        fromLink: S
      };
    }, e.prototype.refetchQueries = function(t) {
      var r = this, n = t.updateCache, i = t.include, a = t.optimistic, o = a === void 0 ? !1 : a, s = t.removeOptimistic, l = s === void 0 ? o ? r5("refetchQueries") : void 0 : s, d = t.onQueryUpdated, c = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(h, f) {
        c.set(f, {
          oq: h,
          lastDiff: (r.queries.get(f) || h.queryInfo).getDiff()
        });
      });
      var u = /* @__PURE__ */ new Map();
      return n && this.cache.batch({
        update: n,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: o && l || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: l,
        onWatchUpdated: function(h, f, p) {
          var m = h.watcher instanceof Qf && h.watcher.observableQuery;
          if (m) {
            if (d) {
              c.delete(m.queryId);
              var y = d(m, f, p);
              return y === !0 && (y = m.refetch()), y !== !1 && u.set(m, y), y;
            }
            d !== null && c.set(m.queryId, { oq: m, lastDiff: p, diff: f });
          }
        }
      }), c.size && c.forEach(function(h, f) {
        var p = h.oq, m = h.lastDiff, y = h.diff, g;
        d && (y || (y = Jn("canonizeResults", function() {
          return r.cache.diff(p.queryInfo.getDiffOptions());
        })), g = d(p, y, m)), (!d || g === !0) && (g = p.refetch()), g !== !1 && u.set(p, g), f.indexOf("legacyOneTimeQuery") >= 0 && r.stopQueryNoBroadcast(f);
      }), l && this.cache.removeOptimistic(l), u;
    }, e.prototype.maskOperation = function(t) {
      var r, n, i, a = t.document, o = t.data;
      if (globalThis.__DEV__ !== !1) {
        var s = t.fetchPolicy, l = t.id, d = (r = yl(a)) === null || r === void 0 ? void 0 : r.operation, c = ((n = d?.[0]) !== null && n !== void 0 ? n : "o") + l;
        this.dataMasking && s === "no-cache" && !uJ(a) && !this.noCacheWarningsByQueryId.has(c) && (this.noCacheWarningsByQueryId.add(c), globalThis.__DEV__ !== !1 && Ae.warn(
          45,
          (i = Nd(a)) !== null && i !== void 0 ? i : "Unnamed ".concat(d ?? "operation")
        ));
      }
      return this.dataMasking ? gX(o, a, this.cache) : o;
    }, e.prototype.maskFragment = function(t) {
      var r = t.data, n = t.fragment, i = t.fragmentName;
      return this.dataMasking ? mX(r, n, this.cache, i) : r;
    }, e.prototype.fetchQueryByPolicy = function(t, r, n) {
      var i = this, a = r.query, o = r.variables, s = r.fetchPolicy, l = r.refetchWritePolicy, d = r.errorPolicy, c = r.returnPartialData, u = r.context, h = r.notifyOnNetworkStatusChange, f = t.networkStatus;
      t.init({
        document: a,
        variables: o,
        networkStatus: n
      });
      var p = function() {
        return t.getDiff();
      }, m = function(_, x) {
        x === void 0 && (x = t.networkStatus || $t.loading);
        var S = _.result;
        globalThis.__DEV__ !== !1 && !c && !er(S, {}) && C$(_.missing);
        var T = function(I) {
          return Ut.of(X({ data: I, loading: Us(x), networkStatus: x }, _.complete ? null : { partial: !0 }));
        };
        return S && i.getDocumentInfo(a).hasForcedResolvers ? i.localState.runResolvers({
          document: a,
          remoteResult: { data: S },
          context: u,
          variables: o,
          onlyRunForcedResolvers: !0
        }).then(function(I) {
          return T(I.data || void 0);
        }) : d === "none" && x === $t.refetch && Array.isArray(_.missing) ? T(void 0) : T(S);
      }, y = s === "no-cache" ? 0 : n === $t.refetch && l !== "merge" ? 1 : 2, g = function() {
        return i.getResultsFromLink(t, y, {
          query: a,
          variables: o,
          context: u,
          fetchPolicy: s,
          errorPolicy: d
        });
      }, w = h && typeof f == "number" && f !== n && Us(n);
      switch (s) {
        default:
        case "cache-first": {
          var $ = p();
          return $.complete ? {
            fromLink: !1,
            sources: [m($, t.markReady())]
          } : c || w ? {
            fromLink: !0,
            sources: [m($), g()]
          } : { fromLink: !0, sources: [g()] };
        }
        case "cache-and-network": {
          var $ = p();
          return $.complete || c || w ? {
            fromLink: !0,
            sources: [m($), g()]
          } : { fromLink: !0, sources: [g()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [m(p(), t.markReady())]
          };
        case "network-only":
          return w ? {
            fromLink: !0,
            sources: [m(p()), g()]
          } : { fromLink: !0, sources: [g()] };
        case "no-cache":
          return w ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [m(t.getDiff()), g()]
          } : { fromLink: !0, sources: [g()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getOrCreateQuery = function(t) {
      return t && !this.queries.has(t) && this.queries.set(t, new Qf(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function(t) {
      t === void 0 && (t = {});
      var r = this.localState.prepareContext(t);
      return X(X(X({}, this.defaultContext), r), { clientAwareness: this.clientAwareness });
    }, e;
  })()
), kX = (
  /** @class */
  (function() {
    function e(t) {
      var r = t.cache, n = t.client, i = t.resolvers, a = t.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = r, n && (this.client = n), i && this.addResolvers(i), a && this.setFragmentMatcher(a);
    }
    return e.prototype.addResolvers = function(t) {
      var r = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(n) {
        r.resolvers = Ky(r.resolvers, n);
      }) : this.resolvers = Ky(this.resolvers, t);
    }, e.prototype.setResolvers = function(t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(t) {
      return Sa(this, arguments, void 0, function(r) {
        var n = r.document, i = r.remoteResult, a = r.context, o = r.variables, s = r.onlyRunForcedResolvers, l = s === void 0 ? !1 : s;
        return Ca(this, function(d) {
          return n ? [2, this.resolveDocument(n, i.data, a, o, this.fragmentMatcher, l).then(function(c) {
            return X(X({}, i), { data: c.result });
          })] : [2, i];
        });
      });
    }, e.prototype.setFragmentMatcher = function(t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(t) {
      return Tc(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function(t) {
      return h$(t);
    }, e.prototype.prepareContext = function(t) {
      var r = this.cache;
      return X(X({}, t), {
        cache: r,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(n) {
          return r.identify(n);
        }
      });
    }, e.prototype.addExportedVariables = function(t) {
      return Sa(this, arguments, void 0, function(r, n, i) {
        return n === void 0 && (n = {}), i === void 0 && (i = {}), Ca(this, function(a) {
          return r ? [2, this.resolveDocument(r, this.buildRootValueFromCache(r, n) || {}, this.prepareContext(i), n).then(function(o) {
            return X(X({}, n), o.exportedVariables);
          })] : [2, X({}, n)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(t) {
      var r = !1;
      return di(t, {
        Directive: {
          enter: function(n) {
            if (n.name.value === "client" && n.arguments && (r = n.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), r))
              return X1;
          }
        }
      }), r;
    }, e.prototype.buildRootValueFromCache = function(t, r) {
      return this.cache.diff({
        query: aZ(t),
        variables: r,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(t, r) {
      return Sa(this, arguments, void 0, function(n, i, a, o, s, l) {
        var d, c, u, h, f, p, m, y, g, w, $;
        return a === void 0 && (a = {}), o === void 0 && (o = {}), s === void 0 && (s = function() {
          return !0;
        }), l === void 0 && (l = !1), Ca(this, function(_) {
          return d = ch(n), c = nu(n), u = tu(c), h = this.collectSelectionsToResolve(d, u), f = d.operation, p = f ? f.charAt(0).toUpperCase() + f.slice(1) : "Query", m = this, y = m.cache, g = m.client, w = {
            fragmentMap: u,
            context: X(X({}, a), { cache: y, client: g }),
            variables: o,
            fragmentMatcher: s,
            defaultOperationType: p,
            exportedVariables: {},
            selectionsToResolve: h,
            onlyRunForcedResolvers: l
          }, $ = !1, [2, this.resolveSelectionSet(d.selectionSet, $, i, w).then(function(x) {
            return {
              result: x,
              exportedVariables: w.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(t, r, n, i) {
      return Sa(this, void 0, void 0, function() {
        var a, o, s, l, d, c = this;
        return Ca(this, function(u) {
          return a = i.fragmentMap, o = i.context, s = i.variables, l = [n], d = function(h) {
            return Sa(c, void 0, void 0, function() {
              var f, p;
              return Ca(this, function(m) {
                return !r && !i.selectionsToResolve.has(h) ? [
                  2
                  /*return*/
                ] : Hw(h, s) ? m1(h) ? [2, this.resolveField(h, r, n, i).then(function(y) {
                  var g;
                  typeof y < "u" && l.push((g = {}, g[p1(h)] = y, g));
                })] : (zJ(h) ? f = h : (f = a[h.name.value], Ae(f, 21, h.name.value)), f && f.typeCondition && (p = f.typeCondition.name.value, i.fragmentMatcher(n, p, o)) ? [2, this.resolveSelectionSet(f.selectionSet, r, n, i).then(function(y) {
                  l.push(y);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(t.selections.map(d)).then(function() {
            return f$(l);
          })];
        });
      });
    }, e.prototype.resolveField = function(t, r, n, i) {
      return Sa(this, void 0, void 0, function() {
        var a, o, s, l, d, c, u, h, f, p = this;
        return Ca(this, function(m) {
          return n ? (a = i.variables, o = t.name.value, s = p1(t), l = o !== s, d = n[s] || n[o], c = Promise.resolve(d), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (u = n.__typename || i.defaultOperationType, h = this.resolvers && this.resolvers[u], h && (f = h[l ? o : s], f && (c = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            vX.withValue(this.cache, f, [
              n,
              jJ(t, a),
              i.context,
              { field: t, fragmentMap: i.fragmentMap }
            ])
          )))), [2, c.then(function(y) {
            var g, w;
            if (y === void 0 && (y = d), t.directives && t.directives.forEach(function(_) {
              _.name.value === "export" && _.arguments && _.arguments.forEach(function(x) {
                x.name.value === "as" && x.value.kind === "StringValue" && (i.exportedVariables[x.value.value] = y);
              });
            }), !t.selectionSet || y == null)
              return y;
            var $ = (w = (g = t.directives) === null || g === void 0 ? void 0 : g.some(function(_) {
              return _.name.value === "client";
            })) !== null && w !== void 0 ? w : !1;
            if (Array.isArray(y))
              return p.resolveSubSelectedArray(t, r || $, y, i);
            if (t.selectionSet)
              return p.resolveSelectionSet(t.selectionSet, r || $, y, i);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(t, r, n, i) {
      var a = this;
      return Promise.all(n.map(function(o) {
        if (o === null)
          return null;
        if (Array.isArray(o))
          return a.resolveSubSelectedArray(t, r, o, i);
        if (t.selectionSet)
          return a.resolveSelectionSet(t.selectionSet, r, o, i);
      }));
    }, e.prototype.collectSelectionsToResolve = function(t, r) {
      var n = function(o) {
        return !Array.isArray(o);
      }, i = this.selectionsToResolveCache;
      function a(o) {
        if (!i.has(o)) {
          var s = /* @__PURE__ */ new Set();
          i.set(o, s), di(o, {
            Directive: function(l, d, c, u, h) {
              l.name.value === "client" && h.forEach(function(f) {
                n(f) && L4(f) && s.add(f);
              });
            },
            FragmentSpread: function(l, d, c, u, h) {
              var f = r[l.name.value];
              Ae(f, 22, l.name.value);
              var p = a(f);
              p.size > 0 && (h.forEach(function(m) {
                n(m) && L4(m) && s.add(m);
              }), s.add(l), p.forEach(function(m) {
                s.add(m);
              }));
            }
          });
        }
        return i.get(o);
      }
      return a(t);
    }, e;
  })()
), u9 = !1, _X = (
  /** @class */
  (function() {
    function e(t) {
      var r = this, n, i, a;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
        throw Ri(16);
      var o = t.uri, s = t.credentials, l = t.headers, d = t.cache, c = t.documentTransform, u = t.ssrMode, h = u === void 0 ? !1 : u, f = t.ssrForceFetchDelay, p = f === void 0 ? 0 : f, m = t.connectToDevTools, y = t.queryDeduplication, g = y === void 0 ? !0 : y, w = t.defaultOptions, $ = t.defaultContext, _ = t.assumeImmutableResults, x = _ === void 0 ? d.assumeImmutableResults : _, S = t.resolvers, T = t.typeDefs, I = t.fragmentMatcher, M = t.clientAwareness, P = t.name, O = t.version, D = t.devtools, R = t.dataMasking;
      globalThis.__DEV__ !== !1 && (In(t, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead."), In(t, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead."), In(t, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead."), In(t, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead."), In(t, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead."), In(t, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead."), In(t, "typeDefs", "ApolloClient"), t.link || globalThis.__DEV__ !== !1 && Ae.warn(17));
      var L = t.link;
      L || (L = o ? new oX({ uri: o, credentials: s, headers: l }) : iu.empty()), this.link = L, this.cache = d, this.disableNetworkFetches = h || p > 0, this.queryDeduplication = g, this.defaultOptions = w || /* @__PURE__ */ Object.create(null), this.typeDefs = T, this.devtoolsConfig = X(X({}, D), { enabled: (n = D?.enabled) !== null && n !== void 0 ? n : m }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), p && setTimeout(function() {
        return r.disableNetworkFetches = !1;
      }, p), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = Gm, this.localState = new kX({
        cache: d,
        client: this,
        resolvers: S,
        fragmentMatcher: I
      }), this.queryManager = new $X({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: $,
        documentTransform: c,
        queryDeduplication: g,
        ssrMode: h,
        dataMasking: !!R,
        clientAwareness: {
          name: (i = M?.name) !== null && i !== void 0 ? i : P,
          version: (a = M?.version) !== null && a !== void 0 ? a : O
        },
        localState: this.localState,
        assumeImmutableResults: x,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          r.devToolsHookCb && r.devToolsHookCb({
            action: {},
            state: {
              queries: r.queryManager.getQueryStore(),
              mutations: r.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: r.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return Object.defineProperty(e.prototype, "prioritizeCacheValues", {
      /**
       * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
       * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
       * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
       *
       * This can e.g. be used to prioritize the cache during the first render after SSR.
       */
      get: function() {
        return this.disableNetworkFetches;
      },
      set: function(t) {
        this.disableNetworkFetches = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var t = window, r = /* @__PURE__ */ Symbol.for("apollo.devtools");
        (t[r] = t[r] || []).push(this), t.__APOLLO_CLIENT__ = this, !u9 && globalThis.__DEV__ !== !1 && (u9 = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var n = window.navigator, i = n && n.userAgent, a = void 0;
            typeof i == "string" && (i.indexOf("Chrome/") > -1 ? a = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (a = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), a && globalThis.__DEV__ !== !1 && Ae.log("Download the Apollo DevTools for a better development experience: %s", a);
          }
        }, 1e4));
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(t) {
      return this.defaultOptions.watchQuery && (t = w0(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = X(X({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (In(t, "canonizeResults", "client.watchQuery"), In(t, "partialRefetch", "client.watchQuery")), this.queryManager.watchQuery(t);
    }, e.prototype.query = function(t) {
      return this.defaultOptions.query && (t = w0(this.defaultOptions.query, t)), Ae(t.fetchPolicy !== "cache-and-network", 18), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = X(X({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (In(t, "canonizeResults", "client.query"), In(t, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed."), t.fetchPolicy === "standby" && globalThis.__DEV__ !== !1 && Ae.warn(19)), this.queryManager.query(t);
    }, e.prototype.mutate = function(t) {
      return this.defaultOptions.mutate && (t = w0(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function(t) {
      var r = this, n = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(t).map(function(i) {
        return X(X({}, i), { data: r.queryManager.maskOperation({
          document: t.query,
          data: i.data,
          fetchPolicy: t.fetchPolicy,
          id: n
        }) });
      });
    }, e.prototype.readQuery = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readQuery(t, r);
    }, e.prototype.watchFragment = function(t) {
      var r;
      return this.cache.watchFragment(X(X({}, t), (r = {}, r[/* @__PURE__ */ Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, r)));
    }, e.prototype.readFragment = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readFragment(t, r);
    }, e.prototype.writeQuery = function(t) {
      var r = this.cache.writeQuery(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.writeFragment = function(t) {
      var r = this.cache.writeFragment(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.__actionHookForDevTools = function(t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function(t) {
      return f5(this.link, t);
    }, e.prototype.resetStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(t.resetStoreCallbacks.map(function(r) {
          return r();
        }));
      }).then(function() {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(t.clearStoreCallbacks.map(function(r) {
          return r();
        }));
      });
    }, e.prototype.onResetStore = function(t) {
      var r = this;
      return this.resetStoreCallbacks.push(t), function() {
        r.resetStoreCallbacks = r.resetStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.onClearStore = function(t) {
      var r = this;
      return this.clearStoreCallbacks.push(t), function() {
        r.clearStoreCallbacks = r.clearStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function(t) {
      var r = this.queryManager.refetchQueries(t), n = [], i = [];
      r.forEach(function(o, s) {
        n.push(s), i.push(o);
      });
      var a = Promise.all(i);
      return a.queries = n, a.results = i, a.catch(function(o) {
        globalThis.__DEV__ !== !1 && Ae.debug(20, o);
      }), a;
    }, e.prototype.getObservableQueries = function(t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function(t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function(t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function(t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function(t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function(t) {
      this.link = this.queryManager.link = t;
    }, Object.defineProperty(e.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })()
);
globalThis.__DEV__ !== !1 && (_X.prototype.getMemoryInternals = wJ);
function l3(e) {
  return e ? new Date(e).toLocaleDateString("en-US", { timeZone: "UTC" }) : "";
}
const T$ = "yyyy-MM-dd";
var xX = /* @__PURE__ */ k("<div>");
function Bs(e) {
  const t = Ke({
    size: "md",
    color: "blue"
  }, e), r = B(() => jt(e.class, "inline-flex items-center text-xs font-medium whitespace-nowrap", {
    "px-2 py-1 rounded-xl": t.size === "md",
    "px-1.5 py-0.5 rounded-lg": t.size === "sm",
    "bg-gray-100 text-gray-600 border-gray-300 border-2": t.color === "gray",
    "bg-red-100 text-red-700 border-red-300 border-2": t.color === "red",
    "bg-yellow-100 text-yellow-800 border-yellow-300 border-2": t.color === "yellow",
    "bg-green-100 text-green-700 border-green-300 border-2": t.color === "green",
    "bg-blue-100 text-blue-700 border-blue-300 border-2": t.color === "blue",
    "bg-indigo-100 text-indigo-700 border-indigo-300 border-2": t.color === "indigo",
    "bg-purple-100 text-purple-700 border-purple-300 border-2": t.color === "purple",
    "bg-pink-100 text-pink-700 border-pink-300 border-2": t.color === "pink"
  }));
  return (() => {
    var n = xX();
    return C(n, () => e.children), te(() => rt(n, r())), n;
  })();
}
var EX = /* @__PURE__ */ k('<div class="group relative w-max"><span class="pointer-events-none absolute -bottom-8 left-0 w-max rounded bg-gray-900 px-2 py-1 text-sm font-medium text-gray-50 opacity-0 shadow transition-opacity group-hover:opacity-100">');
function A$(e) {
  return (() => {
    var t = EX(), r = t.firstChild;
    return C(t, () => e.children, r), C(r, () => e.text), t;
  })();
}
var SX = /* @__PURE__ */ k("<div class=mr-1>");
const CX = {
  PLACED: "Placed",
  ROUTING: "Routing",
  PENDING: "Pending",
  CANCELED: "Canceled",
  COMPLETED: "Completed",
  ERROR: "Error"
}, TX = {
  PLACED: "arrowUpRight",
  ROUTING: "arrowUturnRight",
  PENDING: "clock",
  CANCELED: "xCircle",
  COMPLETED: "checkCircle",
  ERROR: "questionMarkCircle"
}, AX = {
  SENT: "Sent",
  RECEIVED: "Received",
  READY: "Ready",
  PICKED_UP: "Picked up",
  FILLING: "Filling",
  SHIPPED: "Shipped",
  DELIVERED: "Delivered"
}, OX = {
  SENT: "Order sent to pharmacy",
  RECEIVED: "Order received by pharmacy",
  READY: "Order ready at pharmacy",
  PICKED_UP: "Order picked up by patient",
  FILLING: "Mail order being filled",
  SHIPPED: "Mail order shipped",
  DELIVERED: "Mail order delivered"
}, PX = {
  PLACED: "Order has been placed",
  ROUTING: "Order waiting on patient pharmacy selection",
  PENDING: "Order is pending",
  CANCELED: "Order has been canceled",
  COMPLETED: "Order has been completed",
  ERROR: "Order has an error"
}, IX = {
  ERROR: "red",
  CANCELED: "red",
  ROUTING: "gray",
  PLACED: "yellow",
  PENDING: "yellow",
  COMPLETED: "green"
}, DX = {
  SENT: "yellow",
  RECEIVED: "yellow",
  FILLING: "yellow",
  SHIPPED: "yellow",
  READY: "green",
  PICKED_UP: "green",
  DELIVERED: "green"
};
function NX(e) {
  const t = B(() => {
    if (e.orderState === "PLACED" && e.fulfillmentState) {
      const r = e.fulfillmentState;
      return {
        status: AX[r],
        statusColor: DX[r],
        statusTip: OX[r]
      };
    } else {
      const r = e.orderState;
      return {
        status: CX[r],
        statusTip: PX[r],
        statusIcon: TX[r],
        statusColor: IX[r]
      };
    }
  });
  return v(q, {
    get when() {
      return t().status;
    },
    get children() {
      return v(A$, {
        get text() {
          return t().statusTip;
        },
        get children() {
          return v(Bs, {
            get color() {
              return t().statusColor;
            },
            get children() {
              return [v(q, {
                get when() {
                  return t().statusIcon;
                },
                get children() {
                  var r = SX();
                  return C(r, v(et, {
                    get name() {
                      return t().statusIcon;
                    },
                    size: "sm"
                  })), r;
                }
              }), Pt(() => t().status)];
            }
          });
        }
      });
    }
  });
}
var MX = /* @__PURE__ */ k('<div class="flex items-center justify-between">'), RX = /* @__PURE__ */ k('<table class="table-fixed divide-y divide-gray-300 break-words"><tbody class="divide-y divide-gray-200">'), LX = /* @__PURE__ */ k('<div class="flex flex-col gap-2"><div class="flex gap-x-4">'), FX = /* @__PURE__ */ k("<div class=mt-4>"), jX = /* @__PURE__ */ k('<tr><td class="align-top whitespace-nowrap pr-4 py-4 text-sm text-gray-500"></td><td class="py-4 text-sm text-gray-500"><div class=flex><div class=pr-4></div><div>');
function zX() {
  const [e, t] = Vl();
  return v(q, {
    get when() {
      return e.orders.length > 0;
    },
    get children() {
      return v(Sn, {
        addChildrenDivider: !0,
        get children() {
          return [(() => {
            var r = MX();
            return C(r, v(ke, {
              color: "gray",
              children: "Recent Orders"
            })), r;
          })(), (() => {
            var r = RX(), n = r.firstChild;
            return C(n, v(dt, {
              get each() {
                return e.orders;
              },
              children: (i) => {
                const a = /* @__PURE__ */ new Set();
                return i?.fills.forEach((o) => {
                  a.add(o.treatment?.name);
                }), (() => {
                  var o = jX(), s = o.firstChild, l = s.nextSibling, d = l.firstChild, c = d.firstChild, u = c.nextSibling;
                  return C(s, v(ke, {
                    color: "gray",
                    size: "sm",
                    get children() {
                      return l3(i.createdAt);
                    }
                  })), C(c, v(NX, {
                    get orderState() {
                      return i.state;
                    }
                  })), C(u, v(dt, {
                    get each() {
                      return [...a];
                    },
                    children: (h, f) => v(ke, {
                      color: "black",
                      size: "sm",
                      get children() {
                        return [h, Pt(() => f() < a.size - 1 ? ",  " : null)];
                      }
                    })
                  })), C(l, v(q, {
                    get when() {
                      return i.state === "ROUTING";
                    },
                    get children() {
                      var h = FX();
                      return C(h, v(to, {
                        status: "info",
                        withoutIcon: !0,
                        get children() {
                          var f = LX(), p = f.firstChild;
                          return C(f, v(ke, {
                            size: "sm",
                            color: "black",
                            children: "This order is pending pharmacy selection by the patient"
                          }), p), C(p, v(ct, {
                            variant: "naked",
                            onClick: () => t.setIsIssueDialogOpen(!0, i),
                            children: "Report Issue"
                          })), f;
                        }
                      })), h;
                    }
                  }), null), o;
                })();
              }
            })), r;
          })()];
        }
      });
    }
  });
}
const dn = (e, t, r) => {
  const n = new CustomEvent("photon-datadog-action", {
    composed: !0,
    bubbles: !0,
    detail: {
      action: e,
      data: { ...t, timestamp: (/* @__PURE__ */ new Date()).toISOString() }
    }
  });
  r?.dispatchEvent(n);
};
function $l({
  dispenseQuantity: e = 0,
  dispenseUnit: t = "",
  fillsAllowed: r = 0,
  instructions: n = ""
}) {
  const i = O$(r);
  return `${e} ${t}, ${i} Refill${i === 1 ? "" : "s"} - ${n}`;
}
function O$(e = 0) {
  return Math.max(e - 1, 0);
}
var VX = /* @__PURE__ */ k('<div class="flex flex-col gap-6"><div><div class="table bg-red-50 text-red-600 p-2 rounded-full mb-4"></div></div><div class="border border-solid border-gray-200 rounded-lg bg-gray-50 py-3 px-4"><br></div><div class="flex flex-col items-stretch gap-4">');
function UX() {
  let e;
  const [t, r] = Vl();
  return le(() => {
    t.isDuplicateDialogOpen && dn("prescribe-duplicate-dialog-open", {
      duplicate: t.duplicateFill,
      order: t.orderWithIssue
    }, e);
  }), v(os, {
    get open() {
      return t.isDuplicateDialogOpen;
    },
    onClose: () => {
      dn("prescribe-duplicate-dialog-exit", {}, e), t?.duplicateDialogCancelCb?.(), r.setIsDuplicateDialogOpen(!1);
    },
    get children() {
      var n = VX(), i = n.firstChild, a = i.firstChild, o = i.nextSibling, s = o.firstChild, l = o.nextSibling, d = e;
      return typeof d == "function" ? cn(d, n) : e = n, C(a, v(et, {
        name: "exclamationCircle"
      })), C(i, v(ke, {
        bold: !0,
        class: "mb-2",
        children: "Looks like a duplicate order"
      }), null), C(i, v(ke, {
        children: "This patient already has the same prescription:"
      }), null), C(o, v(ke, {
        size: "sm",
        get children() {
          return t?.duplicateFill?.treatment?.name;
        }
      }), s), C(o, v(ke, {
        size: "sm",
        color: "gray",
        get children() {
          return $l({
            dispenseQuantity: t?.duplicateFill?.prescription?.dispenseQuantity,
            dispenseUnit: t?.duplicateFill?.prescription?.dispenseUnit,
            fillsAllowed: t?.duplicateFill?.prescription?.fillsAllowed,
            instructions: t?.duplicateFill?.prescription?.instructions
          });
        }
      }), null), C(o, v(ke, {
        size: "sm",
        color: "gray",
        get children() {
          return ["Written by ", Pt(() => t?.duplicateFill?.prescription?.prescriber?.name?.full), " on", " ", Pt(() => new Date(t?.duplicateFill?.prescription?.writtenAt).toLocaleDateString())];
        }
      }), null), C(l, v(ct, {
        size: "xl",
        onClick: () => {
          t?.duplicateDialogCancelCb?.(), r.setIsDuplicateDialogOpen(!1), r.setIsIssueDialogOpen(!0);
        },
        children: "Report Issue"
      }), null), C(l, v(ct, {
        size: "xl",
        variant: "secondary",
        onClick: () => {
          dn("prescribe-duplicate-dialog-add-anyway", {}, e), t?.duplicateDialogContinueCb?.(), r.setIsDuplicateDialogOpen(!1);
        },
        children: "Add Prescriptions Anyway"
      }), null), C(l, v(ct, {
        variant: "naked",
        size: "xl",
        onClick: () => {
          t?.duplicateDialogCancelCb?.(), dn("prescribe-duplicate-dialog-exit", {}, e), r.setIsDuplicateDialogOpen(!1);
        },
        children: "Go Back"
      }), null), n;
    }
  });
}
var qX = /* @__PURE__ */ k("<textarea>");
function y5(e) {
  const t = Pa(), r = Ke({
    resize: !1,
    rows: 4,
    placeholder: ""
  }, e), [n] = Kc(), i = B(() => jt("block w-full touch-pan-y overflow-x-hidden rounded-lg border-0 py-3 px-4 ring-1 ring-inset text-sm sm:text-base sm:leading-6 focus:ring-2 focus:ring-inset focus:outline-none", {
    "resize-y": r.resize,
    "resize-none": !r.resize,
    "ring-red-300 text-gray-900 placeholder:text-red-300 focus:ring-sky-500/40": !!n.error,
    "ring-gray-300 text-gray-900 placeholder:text-gray-400 hover:ring-gray-400 focus:ring-sky-500/40": !n.error && !r.disabled,
    "cursor-not-allowed bg-gray-50 text-gray-500 ring-gray-200": r.disabled
  }));
  return (() => {
    var a = qX();
    return a.addEventListener("blur", (o) => e.onBlur?.(o.currentTarget.value)), a.$$input = (o) => e.onInput?.(o.currentTarget.value), te((o) => {
      var s = n?.id || (e?.name ?? t), l = e?.name ?? t, d = r.rows, c = r.disabled, u = r.placeholder, h = i();
      return s !== o.e && Xe(a, "id", o.e = s), l !== o.t && Xe(a, "name", o.t = l), d !== o.a && Xe(a, "rows", o.a = d), c !== o.o && (a.disabled = o.o = c), u !== o.i && Xe(a, "placeholder", o.i = u), h !== o.n && rt(a, o.n = h), o;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0
    }), te(() => a.value = r.value), a;
  })();
}
qr(["input"]);
function P$(e) {
  const t = /* @__PURE__ */ new Set();
  return e.fills.filter((r) => {
    const n = r.treatment?.name;
    return !n || t.has(n) ? !1 : (t.add(n), !0);
  });
}
const b5 = (e, t) => {
  const r = (typeof t == "function" ? t() : t).client;
  let n = null, i = null;
  const [a, o] = z(!1), [s] = R7(a, async (l) => {
    let d;
    try {
      d = await r.mutate(l);
    } catch (h) {
      throw i && (i(h), i = null), h;
    }
    const { data: c, errors: u } = d;
    if (u)
      throw i && (i(u[0]), i = null), u[0];
    if (c != null)
      return n && (n(c), n = null), c;
    throw new Error("Mutation did not return any data.");
  });
  return [async (l) => {
    const d = {
      mutation: e,
      ...typeof t == "function" ? Le(t) : t
    }, c = w0(l, d);
    return o(c), new Promise((u, h) => {
      n = u, i = h;
    });
  }, s];
};
var BX = /* @__PURE__ */ k('<div class="flex flex-col gap-6"><div></div><div class="border border-solid border-gray-200 rounded-lg bg-gray-50 py-3 px-4 flex flex-col gap-4"><div class="flex flex-col"></div><div class="flex flex-col"><div class="flex flex-col gap-y-4"></div></div></div><form class=mt-4 id=prescribe-flow-duplicate></form><div class="flex flex-col items-stretch gap-4">'), HX = /* @__PURE__ */ k("<div><br>");
const WX = Ib({
  description: Es().min(1, {
    message: "A description is required"
  })
}), KX = je`
  mutation CreateTicket($input: TicketInput!) {
    createTicket(input: $input) {
      id
    }
  }
`, QX = ({
  patient: e,
  order: t,
  prescriptions: r,
  values: n
}) => {
  const i = (o) => `
    Name: ${o.name}
    Info: ${$l({
    dispenseQuantity: o.dispenseQuantity,
    dispenseUnit: o.dispenseUnit,
    fillsAllowed: o.fillsAllowed,
    instructions: o.instructions
  })}
  `, a = r.map(i).join(`

`);
  return `
Order:
  ID: ${t.id}

----
Patient:
  ID: ${e.id}
  Name: ${e.name}

----
Prescriptions:
${a}

----
Description:
  ${n.description}
`;
}, GX = "prescribe-flow-duplicate";
function YX() {
  let e;
  const [t, r] = Vl(), {
    dispatchTicketCreatedDuplicate: n
  } = ca(), i = jn(), [a, o] = b5(KX, {
    client: i.apolloClinical
  });
  le(() => {
    t.isIssueDialogOpen && dn("prescribe-issue-dialog-open", {}, e);
  });
  const s = B(() => t?.orderWithIssue ? P$(t.orderWithIssue) : t?.duplicateFill ? [t.duplicateFill] : []), l = async (u) => {
    dn("prescribe-issue-dialog-submitting", {}, e);
    const h = QX({
      patient: {
        id: t?.patientId,
        name: t?.patientName
      },
      order: {
        id: t?.orderWithIssue?.id
      },
      prescriptions: s().map((f) => ({
        name: f?.treatment?.name,
        dispenseQuantity: f?.prescription?.dispenseQuantity,
        dispenseUnit: f?.prescription?.dispenseUnit,
        fillsAllowed: f?.prescription?.fillsAllowed,
        instructions: f?.prescription?.instructions
      })),
      values: u
    });
    await a({
      variables: {
        input: {
          subject: `Issue with ${t?.duplicateFill?.treatment?.name || t?.orderWithIssue?.id}`,
          comment: {
            body: h
          }
        }
      }
    }), Yt({
      header: "Issue reported",
      body: "The customer support team will respond to you shortly.",
      status: "success"
    }), n(), r.setIsIssueDialogOpen(!1);
  }, {
    form: d,
    errors: c
  } = Cb({
    onSubmit: async (u) => {
      try {
        l({
          ...u
        });
      } catch {
        Yt({
          header: "Error Creating Issue",
          body: "A ticket for this order has not been sent.",
          status: "info"
        });
      }
    },
    extend: Tb({
      schema: WX
    })
  });
  return v(os, {
    get open() {
      return t.isIssueDialogOpen;
    },
    onClose: () => {
      dn("prescribe-issue-dialog-exit", {}, e), r.setIsIssueDialogOpen(!1);
    },
    get children() {
      var u = BX(), h = u.firstChild, f = h.nextSibling, p = f.firstChild, m = p.nextSibling, y = m.firstChild, g = f.nextSibling, w = g.nextSibling, $ = e;
      return typeof $ == "function" ? cn($, u) : e = u, C(h, v(ke, {
        bold: !0,
        class: "mb-2",
        children: "Report issue with existing order"
      }), null), C(h, v(ke, {
        children: "Start an email thread with the Photon team to discuss next steps."
      }), null), C(p, v(ke, {
        size: "xs",
        color: "gray",
        children: "PATIENT"
      }), null), C(p, v(ke, {
        size: "sm",
        get children() {
          return t?.patientName;
        }
      }), null), C(m, v(ke, {
        size: "xs",
        color: "gray",
        children: "PRESCRIPTION"
      }), y), C(y, v(dt, {
        get each() {
          return s();
        },
        children: (_) => (() => {
          var x = HX(), S = x.firstChild;
          return C(x, v(ke, {
            size: "sm",
            get children() {
              return _?.treatment?.name;
            }
          }), S), C(x, v(ke, {
            size: "sm",
            color: "gray",
            get children() {
              return $l({
                dispenseQuantity: _?.prescription?.dispenseQuantity,
                dispenseUnit: _?.prescription?.dispenseUnit,
                fillsAllowed: _?.prescription?.fillsAllowed,
                instructions: _?.prescription?.instructions
              });
            }
          }), null), x;
        })()
      })), cn(d, g), C(g, v(ke, {
        size: "xs",
        class: "mb-2",
        bold: !0,
        children: "Description"
      }), null), C(g, v(y5, {
        placeholder: "Describe issue with this order",
        name: "description"
      }), null), C(g, v(ke, {
        size: "xs",
        color: "red",
        get children() {
          return c().description;
        }
      }), null), C(w, v(ct, {
        size: "xl",
        get disabled() {
          return o.loading;
        },
        get loading() {
          return o.loading;
        },
        type: "submit",
        form: GX,
        children: "Report Issue"
      }), null), C(w, v(ct, {
        variant: "naked",
        size: "xl",
        onClick: () => {
          dn("prescribe-issue-dialog-exit", {}, e), r.setIsIssueDialogOpen(!1);
        },
        children: "Go Back"
      }), null), u;
    }
  });
}
var JX = /* @__PURE__ */ k('<div class="flex flex-col gap-6"><div><div class="table bg-blue-50 text-blue-600 p-2 rounded-full mb-4"></div></div><div class="flex flex-col gap-4"><div class="flex flex-col gap-2"><div class="border border-solid border-gray-200 rounded-lg bg-gray-50 py-3 px-4"></div></div><div class="flex flex-col gap-2"><div class="border border-solid border-gray-200 rounded-lg bg-gray-50 py-3 px-4 flex flex-col gap-4"></div></div></div><div class="flex flex-col items-stretch gap-2">'), h9 = /* @__PURE__ */ k("<div><br>");
const ZX = je`
  mutation RecentOrdersCombineDialogUpdateOrder($orderId: ID!, $fills: [FillInput!]!) {
    updateOrder(id: $orderId, fills: $fills) {
      id
      createdAt
      fills {
        id
        prescription {
          id
          dispenseQuantity
          dispenseUnit
          fillsAllowed
          instructions
          notes
        }
        treatment {
          name
        }
      }
    }
  }
`, XX = je`
  mutation RecentOrdersCombineDialogCreateOrder(
    $patientId: ID!
    $fills: [FillInput!]!
    $addressId: ID
    $address: AddressInput
  ) {
    createOrder(patientId: $patientId, fills: $fills, addressId: $addressId, address: $address) {
      id
    }
  }
`;
function eee() {
  let e;
  const {
    draftPrescriptions: t
  } = Ul(), {
    dispatchOrderCreated: r,
    dispatchOrderCombined: n,
    dispatchAnalytics: i
  } = ca(), a = jn(), [o, s] = Vl(), [l, d] = z(!1), [c, u] = z(!1), [h] = b5(ZX, {
    client: a.apollo
  }), [f] = b5(XX, {
    client: a.apollo
  });
  le(() => {
    o.isCombineDialogOpen && (dn("prescribe-combine-dialog-open", {}, e), i({
      trackEventType: "combine_orders_viewed"
    }));
  });
  const p = B(() => o.orders.find((g) => g.state === "ROUTING")), m = B(() => {
    const g = p();
    return g ? P$(g) : [];
  }), y = async () => {
    const g = p();
    if (!g)
      return;
    u(!0), dn("prescribe-combine-dialog-combining", {}, e);
    const w = t().map(($) => ({
      prescriptionId: $.id
    }));
    try {
      const $ = await h({
        variables: {
          orderId: g.id,
          fills: w
        }
      });
      n($.updateOrder), i({
        trackEventType: "order_created",
        properties: {
          orderId: g.id,
          prescriptionCount: t().length,
          fulfillmentType: null,
          hasPreferredPharmacy: !1,
          setAsPreferred: !1,
          pharmacyId: null,
          isCombinedOrder: !0
        }
      }), u(!1), s.setIsCombineDialogOpen(!1);
      return;
    } catch {
      try {
        if (!o?.addressId && !o?.address || !o?.patientId)
          throw new Error("No address provided");
        const $ = await f({
          variables: {
            patientId: o.patientId,
            fills: w,
            ...o.addressId ? {
              addressId: o.addressId
            } : {
              address: o.address
            }
          }
        });
        r($.createOrder), i({
          trackEventType: "order_created",
          properties: {
            orderId: $.createOrder.id,
            prescriptionCount: t().length,
            fulfillmentType: "SEND_TO_PATIENT",
            hasPreferredPharmacy: !1,
            setAsPreferred: !1,
            pharmacyId: null,
            isCombinedOrder: !1
          }
        }), u(!1);
      } catch {
        Yt({
          header: "Error Creating Order",
          body: "The draft was created but not turned into an active prescription.",
          status: "info"
        }), u(!1);
        return;
      }
    }
  };
  return v(os, {
    get open() {
      return o.isCombineDialogOpen;
    },
    onClose: () => {
      dn("prescribe-combine-dialog-exit", {}, e), s.setIsCombineDialogOpen(!1);
    },
    get children() {
      var g = JX(), w = g.firstChild, $ = w.firstChild, _ = w.nextSibling, x = _.firstChild, S = x.firstChild, T = x.nextSibling, I = T.firstChild, M = _.nextSibling, P = e;
      return typeof P == "function" ? cn(P, g) : e = g, C($, v(et, {
        name: "exclamationCircle"
      })), C(w, v(ke, {
        bold: !0,
        children: "Add prescription to recent order?"
      }), null), C(x, v(ke, {
        children: "This patient currently has prescriptions for:"
      }), S), C(S, v(dt, {
        get each() {
          return m();
        },
        children: (O) => (() => {
          var D = h9(), R = D.firstChild;
          return C(D, v(ke, {
            size: "sm",
            get children() {
              return O?.treatment?.name;
            }
          }), R), C(D, v(ke, {
            size: "sm",
            color: "gray",
            get children() {
              return $l({
                dispenseQuantity: O?.prescription?.dispenseQuantity,
                dispenseUnit: O?.prescription?.dispenseUnit,
                fillsAllowed: O?.prescription?.fillsAllowed,
                instructions: O?.prescription?.instructions
              });
            }
          }), null), D;
        })()
      })), C(T, v(ke, {
        children: "Select YES to combine orders and enable the patient to send it to the same pharmacy:"
      }), I), C(I, () => v(dt, {
        get each() {
          return t();
        },
        children: (O) => (() => {
          var D = h9(), R = D.firstChild;
          return C(D, v(ke, {
            size: "sm",
            get children() {
              return O.treatment.name;
            }
          }), R), C(D, v(ke, {
            size: "sm",
            color: "gray",
            get children() {
              return $l({
                dispenseQuantity: O?.dispenseQuantity ?? 0,
                dispenseUnit: O?.dispenseUnit ?? "",
                fillsAllowed: O?.fillsAllowed ?? 0,
                instructions: O?.instructions ?? ""
              });
            }
          }), null), D;
        })()
      })), C(M, v(ct, {
        size: "xl",
        onClick: y,
        get disabled() {
          return l() || c();
        },
        get loading() {
          return c();
        },
        children: "Yes, combine orders"
      }), null), C(M, v(ct, {
        variant: "secondary",
        size: "xl",
        onClick: () => {
          dn("prescribe-combine-dialog-not-combining", {}, e), o.createOrder?.(), d(!0);
        },
        get disabled() {
          return l() || c();
        },
        get loading() {
          return l();
        },
        get children() {
          return l() ? "Creating order..." : "No, send new order";
        }
      }), null), g;
    }
  });
}
const y1 = (e, t) => {
  const r = (typeof t == "function" ? t() : t).client, n = () => {
    if (typeof t != "function")
      return t.skip && console.warn(
        `you passed options.skip to createQuery, but the options are not an acccessor.
This query will never execute!

Replace your options with a function.`
      ), t;
    const a = typeof t == "function" ? t() : t;
    return a.skip ? !1 : a;
  }, [i] = R7(
    n,
    (a) => {
      const o = r.watchQuery({ query: e, ...a }), [s, l] = eo({});
      let d = !1;
      return new Promise((c, u) => {
        const h = o.subscribe({
          error: u,
          next: ({ data: f, error: p }) => {
            p && u(p), d ? l(cB(f)) : (d = !0, l(f), c(s));
          }
        });
        _r(() => h.unsubscribe());
      });
    }
  );
  return i;
};
var I$ = /* @__PURE__ */ ((e) => (e.Canceled = "CANCELED", e.Completed = "COMPLETED", e.Error = "ERROR", e.Pending = "PENDING", e.Placed = "PLACED", e.Routing = "ROUTING", e))(I$ || {});
const tee = je`
  query GetPatientOrders($patientId: ID!) {
    patient(id: $patientId) {
      id
      name {
        full
      }
      orders(first: 5) {
        id
        createdAt
        state
        fills {
          treatment {
            name
          }
          prescription {
            dispenseQuantity
            dispenseUnit
            fillsAllowed
            instructions
            writtenAt
            prescriber {
              name {
                full
              }
            }
          }
        }
      }
    }
  }
`, D$ = Rr();
function Gi(e) {
  const t = jn(), [r, n] = eo({
    orders: [],
    isLoading: !0,
    isCombineDialogOpen: !1,
    isDuplicateDialogOpen: !1,
    isIssueDialogOpen: !1,
    duplicateDialogContinueCb: () => {
    },
    duplicateDialogCancelCb: () => {
    }
  }), i = B(() => ({
    variables: {
      patientId: e.patientId
    },
    skip: !e.patientId,
    client: t.apollo,
    fetchPolicy: "network-only"
  })), a = y1(tee, i), o = [r, {
    setIsCombineDialogOpen(s, l, d, c) {
      n({
        isCombineDialogOpen: s,
        ...l ? {
          createOrder: l
        } : {
          createOrderCb: void 0
        },
        ...d ? {
          addressId: d
        } : {
          addressId: void 0
        },
        ...c ? {
          address: c
        } : {
          address: void 0
        }
      });
    },
    setIsDuplicateDialogOpen(s, l, d, c) {
      n({
        isDuplicateDialogOpen: s,
        ...d ? {
          duplicateDialogContinueCb: d
        } : {
          duplicateDialogContinueCb: void 0
        },
        ...c ? {
          duplicateDialogCancelCb: c
        } : {
          duplicateDialogCancelCb: void 0
        },
        ...l ? {
          duplicateFill: l.fill
        } : {},
        ...l ? {
          orderWithIssue: l.order
        } : {}
      });
    },
    setIsIssueDialogOpen(s, l) {
      n({
        isIssueDialogOpen: s,
        ...l && {
          orderWithIssue: l
        },
        ...!s && {
          duplicateFill: void 0,
          orderWithIssue: void 0
        }
      });
    },
    checkDuplicateFill(s) {
      const l = r.orders.filter((d) => d.state !== I$.Canceled);
      for (const d of l) {
        const c = d.fills.find((u) => u.treatment.name === s);
        if (c !== void 0)
          return {
            order: d,
            fill: c
          };
      }
    },
    hasRoutingOrder() {
      return r.orders.some((s) => s.state === "ROUTING");
    }
  }];
  return le(() => {
    n({
      isLoading: a.loading
    });
    const s = a()?.patient;
    if (!a.loading && s) {
      const l = s.orders;
      if (l?.length > 0) {
        const d = /* @__PURE__ */ new Date(), c = new Date(d.getTime() - 480 * 60 * 1e3), u = l.filter((h) => new Date(h.createdAt) > c);
        n({
          orders: u,
          patientName: s?.name?.full,
          patientId: s?.id
        });
      }
    }
  }), v(D$.Provider, {
    value: o,
    get children() {
      return e.children;
    }
  });
}
function Vl() {
  const e = gr(D$);
  if (!e)
    throw new Error("useRecentOrders must be used within RecentOrdersContext");
  return e;
}
Gi.Card = zX;
Gi.CombineDialog = eee;
Gi.DuplicateDialog = UX;
Gi.IssueDialog = YX;
const ree = je`
  mutation CreatePrescriptionTemplate(
    $catalogId: ID!
    $name: String
    $treatmentId: ID!
    $dispenseAsWritten: Boolean
    $dispenseQuantity: Float
    $dispenseUnit: String
    $refillsAllowed: Int
    $fillsAllowed: Int
    $daysSupply: Int
    $instructions: String
    $notes: String
    $isPrivate: Boolean
  ) {
    createPrescriptionTemplate(
      catalogId: $catalogId
      name: $name
      treatmentId: $treatmentId
      dispenseAsWritten: $dispenseAsWritten
      dispenseQuantity: $dispenseQuantity
      dispenseUnit: $dispenseUnit
      refillsAllowed: $refillsAllowed
      fillsAllowed: $fillsAllowed
      daysSupply: $daysSupply
      instructions: $instructions
      notes: $notes
      isPrivate: $isPrivate
    ) {
      id
    }
  }
`, nee = je`
  mutation CreatePrescription(
    $externalId: ID
    $patientId: ID!
    $treatmentId: ID!
    $dispenseAsWritten: Boolean
    $dispenseQuantity: Float!
    $dispenseUnit: String!
    $refillsAllowed: Int
    $fillsAllowed: Int
    $daysSupply: Int
    $instructions: String!
    $notes: String
    $doNotFillBeforeDate: AWSDate
    $diagnoses: [ID]
  ) {
    createPrescription(
      externalId: $externalId
      patientId: $patientId
      treatmentId: $treatmentId
      dispenseAsWritten: $dispenseAsWritten
      dispenseQuantity: $dispenseQuantity
      dispenseUnit: $dispenseUnit
      refillsAllowed: $refillsAllowed #todo: remove this?
      fillsAllowed: $fillsAllowed
      daysSupply: $daysSupply
      instructions: $instructions
      notes: $notes
      doNotFillBeforeDate: $doNotFillBeforeDate
      diagnoses: $diagnoses
    ) {
      id
      externalId
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      fillsAllowed
      daysSupply
      instructions
      notes
      effectiveDate
      doNotFillBeforeDate
      diagnoses {
        code
      }
      treatment {
        id
        name
        codes {
          packageNDC
          productNDC
        }
      }
    }
  }
`, iee = je`
  mutation CreatePrescriptions($prescriptions: [PrescriptionInput]!) {
    createPrescriptions(prescriptions: $prescriptions) {
      id
      externalId
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      fillsAllowed
      daysSupply
      instructions
      notes
      doNotFillBeforeDate
      diagnoses {
        code
      }
      treatment {
        id
        name
        codes {
          packageNDC
          productNDC
        }
      }
    }
  }
`, aee = je`
  mutation UpdatePrescriptionStates($input: UpdatePrescriptionStatesInput!) {
    updatePrescriptionStates(input: $input)
  }
`, oee = je`
  mutation GenerateCoverageOptions($pharmacyId: ID!, $prescriptions: [CoverageRxInput!]!) {
    generateCoverageOptions(pharmacyId: $pharmacyId, prescriptions: $prescriptions) {
      id
      prescriptionId
      isAlternative
      status
      statusMessage
      paRequired
      price
      daysSupply
      dispenseQuantity
      dispenseUnit
      treatment {
        id
        name
      }
      pharmacy {
        id
        name
      }
      alerts {
        label
        text
      }
    }
  }
`, see = je`
  query GetPrescription($id: ID!) {
    prescription(id: $id) {
      id
      daysSupply
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      instructions
      notes
      fillsAllowed
      treatment {
        id
        name
      }
    }
  }
`;
je`
  query TemplatesFromCatalogs {
    catalogs {
      templates {
        id
        daysSupply
        dispenseAsWritten
        dispenseQuantity
        dispenseUnit
        instructions
        notes
        fillsAllowed
        treatment {
          id
          name
        }
      }
    }
  }
`;
je`
  query GetPatient($id: ID!) {
    patient(id: $id) {
      id
      preferredPharmacyId
      benefits {
        id
        bin
        groupId
        memberId
        pcn
      }
    }
  }
`;
const d3 = je`
  query GetPatient($id: ID!) {
    patient(id: $id) {
      preferredPharmacies {
        id
        name
        address {
          street1
          city
          state
        }
      }
      address {
        street1
        street2
        city
        state
        postalCode
      }
    }
  }
`, N$ = je`
  query GetPharmacies($location: LatLongSearch!) {
    pharmacies(location: $location) {
      id
      name
      address {
        street1
        city
        state
      }
    }
  }
`, lee = je`
  query GetMailOrderPharmacies(
    $name: String
    $fulfillmentType: FulfillmentType
    $integrated: Boolean
    $limit: Int
    $offset: Int
  ) {
    pharmacies(
      name: $name
      fulfillmentType: $fulfillmentType
      integrated: $integrated
      limit: $limit
      offset: $offset
    ) {
      id
      name
      address {
        street1
        city
        state
      }
    }
  }
`, c3 = Rr(), w5 = (e, t) => ({
  externalId: e.externalId,
  patientId: t,
  treatmentId: e.treatment?.id,
  dispenseAsWritten: e.dispenseAsWritten,
  dispenseQuantity: e.dispenseQuantity,
  dispenseUnit: e.dispenseUnit,
  fillsAllowed: e.fillsAllowed,
  daysSupply: e.daysSupply,
  instructions: e.instructions,
  notes: e.notes,
  doNotFillBeforeDate: e.doNotFillBeforeDate,
  diagnoses: e.diagnoseCodes
});
function dee(e, t) {
  return t.some((r) => r.treatment.id === e);
}
const cee = async ({
  client: e,
  props: t
}) => {
  let r = [];
  if (t.templateIdsPrefill.length > 0) {
    const n = Array.from(new Set(t.templateIdsPrefill)).map((i) => ({
      ...t.templateOverrides?.[i],
      patientId: t.patientId,
      templateId: i
    }));
    r = r.concat(n);
  }
  if (t.prescriptionIdsPrefill.length > 0) {
    const n = await Promise.all(t.prescriptionIdsPrefill.map(async (i) => {
      const {
        data: a
      } = await e.apollo.query({
        query: see,
        variables: {
          id: i
        }
      });
      return w5(a?.prescription, t.patientId);
    }));
    r = r.concat(n);
  }
  return r.length ? (await e.apollo.mutate({
    mutation: iee,
    variables: {
      prescriptions: r
    }
  })).data.createPrescriptions : void 0;
}, uee = (e) => {
  const {
    dispatchDraftPrescriptionCreated: t,
    dispatchAnalytics: r
  } = ca(), [, n] = Vl(), i = jn(), [a, o] = z(!1), [s, l] = z(!1), [d, c] = z([]), u = B(() => d().map((y) => y.id));
  le(async () => {
    if (
      // must have templateIds or prescriptionIds to create prescriptions
      (e.templateIdsPrefill.length > 0 || e.prescriptionIdsPrefill.length > 0) && e.patientId && // must not have created prescriptions yet
      !a()
    ) {
      o(!0), l(!0);
      try {
        const y = await cee({
          client: i,
          props: e
        });
        y && (c((g) => [...g, ...y]), y.forEach((g) => {
          t(g), r({
            trackEventType: "draft_prescription_added",
            properties: {
              draftPrescriptionSource: "prefill",
              fields: My(g)
            }
          });
        }));
      } catch (y) {
        console.error("Error while trying to create prescriptions from prefill IDs", {
          error: y
        }), Yt({
          status: "error",
          body: "There was an issue creating prescriptions from prefill IDs. Please check your configuration."
        });
      } finally {
        l(!1);
      }
    }
  });
  const h = async (y, g = {
    showSuccessToast: !0
  }, w = "form") => {
    if (dee(y.treatment.id, d()))
      throw Yt({
        status: "error",
        body: "You already have this prescription in your order. You can modify the prescription or delete it in Pending Order."
      }), new Error("Prescription already added");
    const $ = n.checkDuplicateFill(y.treatment.name);
    return e.enableCombineAndDuplicate && $ && await new Promise((_, x) => {
      n.setIsDuplicateDialogOpen(!0, $, _, x);
    }), await f(y, g, w);
  }, f = async (y, g = {
    addToTemplates: !1,
    showSuccessToast: !0
  }, w = "form") => {
    let $ = null;
    try {
      const _ = (await i.apollo.mutate({
        mutation: nee,
        variables: w5(y, e.patientId)
      })).data.createPrescription;
      $ = _, c((x) => [...x, _]), t(_), r({
        trackEventType: "draft_prescription_added",
        properties: {
          draftPrescriptionSource: w,
          fields: My(y, {
            addToTemplates: g?.addToTemplates,
            templateName: g?.templateName
          })
        }
      });
    } catch (_) {
      console.error("Mutation error:", _);
      const x = _.message;
      throw Yt({
        status: "error",
        header: "Error Adding Prescription",
        body: x.includes("controlled substance") ? x : "There was an issue adding the prescription. Please try again."
      }), _;
    }
    return g?.addToTemplates && g?.catalogId != null && (await p(y, g.catalogId, g.templateName), g.showSuccessToast && Yt({
      status: "success",
      header: "Personal Template Saved"
    })), g.showSuccessToast && Yt({
      status: "success",
      header: "Prescription Added",
      body: "You can send this order or add another prescription before sending it"
    }), $;
  }, p = async (y, g, w = "") => await i.apollo.mutate({
    mutation: ree,
    variables: {
      ...w5(y, e.patientId),
      catalogId: g,
      isPrivate: !0,
      ...w ? {
        name: w
      } : {}
    }
  }), m = {
    // values
    draftPrescriptions: d,
    prescriptionIds: u,
    isLoadingPrefills: s,
    // actions
    setDraftPrescriptions: c,
    tryCreatePrescription: h,
    tryUpdatePrescriptionStates: async (y, g) => {
      try {
        return (await i.apolloClinical.mutate({
          mutation: aee,
          variables: {
            input: {
              ids: y,
              state: g
            }
          }
        })).data.updatePrescriptionStates;
      } catch (w) {
        throw console.error("Mutation error:", w), Yt({
          status: "error",
          header: "Error Saving Prescription(s)",
          body: w.message
        }), w;
      }
    },
    deletePrescription: (y) => {
      c((g) => g.filter((w) => w.id !== y));
    }
  };
  return v(c3.Provider, {
    value: m,
    get children() {
      return e.children;
    }
  });
}, Ul = () => {
  const e = gr(c3);
  if (!e)
    throw new Error("can't find DraftPrescriptionsContext");
  return e;
}, hee = () => gr(c3), b1 = async (e, t) => {
  if (typeof e != "string" && (!e.latitude || !e.longitude))
    return [];
  const r = await t.geocode({
    ...typeof e == "string" ? { address: e } : { location: { lat: e.latitude, lng: e.longitude } }
  });
  return r?.results?.length ? r.results.map(() => ({
    latitude: r.results[0].geometry.location.lat(),
    longitude: r.results[0].geometry.location.lng(),
    address: r.results[0].formatted_address
  })) : [];
};
let Wu = !1;
function fee({ onLoad: e, onError: t }) {
  if (window?.google?.maps)
    e();
  else if (Wu) {
    const r = setInterval(() => {
      window?.google?.maps && (clearInterval(r), e());
    }, 100);
  } else {
    Wu = !0;
    const r = document.createElement("script");
    r.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAvuwwE6g2Bsmih66nu4dB7-H7U1_7KQ6g&callback=Function.prototype&libraries=places", document.head.appendChild(r), r.onload = () => {
      Wu = !1, e();
    }, r.onerror = (n) => {
      Wu = !1, t && t(n);
    };
  }
}
const M$ = Rr(), pee = (e) => {
  const [t, r] = z({
    geocoder: null,
    autocompleteService: null
  });
  return Ht(() => {
    fee({
      onLoad: () => {
        r({
          geocoder: new google.maps.Geocoder(),
          autocompleteService: new google.maps.places.AutocompleteService()
        });
      },
      onError: (n) => {
        console.error("Error loading Google Maps script:", n);
      }
    });
  }), v(M$.Provider, {
    value: {
      googleMapsServices: t
    },
    get children() {
      return e.children;
    }
  });
}, u3 = () => {
  const e = gr(M$);
  if (!e)
    throw new Error("useGoogleService must be used within the GoogleServiceProvider");
  return e;
}, R$ = Rr(), mee = (e) => {
  const {
    googleMapsServices: t
  } = u3(), {
    draftPrescriptions: r,
    setDraftPrescriptions: n
  } = Ul(), i = jn(), [a, o] = z([]), [s, l] = z(null), [d, c] = z(null), [u, h] = z(null), [f, p] = z(!1), [m, y] = z(), [g, w] = eo(), $ = B(() => r().map((O) => zY(O))), _ = B(() => Ny($())), x = B(() => {
    const O = Ny($(), ["exclude"]);
    return new Set(O.constraint_pharmacies?.map((D) => D.id) || []);
  });
  async function S(O) {
    const {
      data: D
    } = await i.apollo.query({
      query: N$,
      variables: {
        location: {
          latitude: O?.latitude,
          longitude: O?.longitude
        }
      }
    });
    return D?.pharmacies ? D.pharmacies : [];
  }
  async function T(O) {
    const {
      geocoder: D
    } = t();
    if (!D) throw new Error("Geocoder not loaded");
    const R = `${O?.street1}, ${O?.city}, ${O?.state} ${O?.postalCode}`, L = await b1(R, D);
    return await S(L[0]);
  }
  le(() => {
    e.patientId && I(e.patientId).then(({
      pharmacies: O,
      address: D
    }) => {
      O.length > 0 && l(O[0].id), D && h(D);
    });
  }), le(() => {
    e.patientId && e.patientId !== d() ? (n([]), y(void 0), p(!1), o([]), c(e.patientId)) : !e.patientId && d() !== null && (n([]), y(void 0), p(!1), o([]), c(null));
  }), le(() => {
    const O = s(), D = r();
    if (!f() && // after an alternate is chosen, stop fetching coverages for this patient
    e.enableCoverageCheck && D.length > 0)
      if (O)
        M(D, O).then((R) => {
          o(R);
        });
      else {
        const R = u();
        R && T(R).then((L) => {
          let Q = null;
          Q = L.find((ie) => ie.name.toLowerCase().includes("cvs") || ie.name.toLowerCase().includes("walgreens") || ie.name.toLowerCase().includes("walmart") || ie.name.toLowerCase().includes("rite aid"))?.id || L[0]?.id, Q && M(D, Q).then((ie) => {
            o(ie);
          });
        });
      }
  });
  const I = async (O) => {
    try {
      const D = await i.apollo.query({
        query: d3,
        variables: {
          id: O
        }
      });
      return {
        pharmacies: D.data.patient.preferredPharmacies,
        address: D.data.patient.address
      };
    } catch (D) {
      throw Yt({
        status: "error",
        header: "Error Looking Up Patient Pharmacy",
        body: D.message
      }), D;
    }
  }, M = async (O, D) => (await i.apolloClinical.mutate({
    mutation: oee,
    variables: {
      pharmacyId: D,
      prescriptions: O.map((R) => ({
        id: R.id
        // icd10codes: ['gotta get this']
      }))
    }
  })).data.generateCoverageOptions, P = {
    // values
    coverageOptions: a,
    routingConstraints: $,
    combinedRoutingConstraint: _,
    unroutablePharmacyIds: x,
    orderFormData: g,
    selectedCoverageOption: m,
    // actions
    selectOtherCoverageOption: (O) => {
      w("pharmacyId", O.pharmacy.id), y(O), p(!0);
    },
    setOrderFormData: w
  };
  return v(R$.Provider, {
    value: P,
    get children() {
      return e.children;
    }
  });
}, ql = () => {
  const e = gr(R$);
  if (!e)
    throw new Error("usePrescribe must be used within the PrescribeProvider");
  return e;
};
var gee = /* @__PURE__ */ k("<div><span class=font-semibold></span> interaction with "), vee = /* @__PURE__ */ k("<span class=font-semibold>"), yee = /* @__PURE__ */ k('<div class="text-sm text-gray-700">'), bee = /* @__PURE__ */ k("<div>"), wee = /* @__PURE__ */ k('<div class="flex grid-flow-col justify-start"><div class="flex flex-col gap-2"><div class=text-sm> ');
const $ee = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase(), kee = {
  MINOR: "info",
  MODERATE: "warning",
  MAJOR: "error"
}, _ee = (e, t) => t === "ALLERGEN" ? "error" : kee[e] ?? "info", xee = {
  PrescriptionScreeningAlertInvolvedDraftedPrescription: "(Pending Rx)",
  PrescriptionScreeningAlertInvolvedExistingPrescription: "(Existing Rx)",
  PrescriptionScreeningAlertInvolvedAllergen: "(Allergen)"
}, f9 = (e, t) => e.filter((r) => r.id !== t), Eee = (e) => xee[e] ?? "", p9 = () => jt("text-pretty mr-2 text-black text-base", {}), See = (e) => v(q, {
  get when() {
    return e.screeningAlert.type === "DRUG";
  },
  get fallback() {
    return v(ke, {
      bold: !0,
      get class() {
        return p9();
      },
      children: "Allergy found"
    });
  },
  get children() {
    var t = gee(), r = t.firstChild;
    return r.nextSibling, C(r, () => $ee(e.screeningAlert.severity)), C(t, v(dt, {
      get each() {
        return f9(e.screeningAlert.involvedEntities, e.owningId);
      },
      children: (n, i) => [(() => {
        var a = vee();
        return C(a, () => n.name), a;
      })(), " ", Pt(() => Eee(n.__typename)), Pt(() => i() < f9(e.screeningAlert.involvedEntities, e.owningId).length - 1 && " and ")]
    }), null), te(() => rt(t, p9())), t;
  }
}), Cee = (e) => {
  const [t, r] = z(), [n, i] = z(!1), a = () => {
    i(!n());
  };
  return le(() => {
    r(e.screeningAlert.type === "ALLERGEN");
  }), v(to, {
    iconName: "exclamationTriangle",
    get status() {
      return _ee(e.screeningAlert.severity, e.screeningAlert.type);
    },
    withBorder: !0,
    get children() {
      var o = wee(), s = o.firstChild, l = s.firstChild;
      return l.firstChild, C(l, () => See(e), null), C(s, v(q, {
        get when() {
          return n() || t();
        },
        get children() {
          var d = yee();
          return C(d, () => e.screeningAlert.description), d;
        }
      }), null), C(s, v(q, {
        get when() {
          return !t();
        },
        get children() {
          var d = bee();
          return d.$$click = () => {
            a();
          }, C(d, v(ke, {
            bold: !0,
            class: "text-blue-600 cursor-pointer",
            size: "xs",
            get children() {
              return ["See ", Pt(() => n() ? "less" : "more")];
            }
          })), d;
        }
      }), null), o;
    }
  });
};
qr(["click"]);
var Tee = /* @__PURE__ */ k('<div class="grid gap-4">');
const L$ = (e) => v(q, {
  get when() {
    return e.screeningAlerts.length > 0;
  },
  get children() {
    var t = Tee();
    return C(t, v(dt, {
      get each() {
        return e.screeningAlerts;
      },
      children: (r) => v(Cee, {
        screeningAlert: r,
        get owningId() {
          return e.owningId;
        }
      })
    })), t;
  }
});
var Aee = /* @__PURE__ */ k('<div class="flex grid-flow-col justify-start"><div class="flex flex-col gap-2">'), Oee = /* @__PURE__ */ k('<div class="text-sm text-gray-700"> interaction with <!> '), Pee = /* @__PURE__ */ k('<div class="text-sm text-gray-700">');
const Iee = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase(), Dee = {
  PrescriptionScreeningAlertInvolvedDraftedPrescription: "(Pending Rx)",
  PrescriptionScreeningAlertInvolvedExistingPrescription: "(Existing Rx)",
  PrescriptionScreeningAlertInvolvedAllergen: "(Allergen)"
}, Nee = (e) => Dee[e] ?? "", Gf = (e) => e === "PrescriptionScreeningAlertInvolvedAllergen";
function Mee(e) {
  const t = /* @__PURE__ */ new Set();
  return e.filter((r) => t.has(r.id) ? !1 : (t.add(r.id), !0));
}
const Ree = (e) => v(to, {
  withoutIcon: !0,
  withBorder: !0,
  status: "suggestion",
  get children() {
    var t = Aee(), r = t.firstChild;
    return C(r, v(q, {
      get when() {
        return !Gf(e.screeningAlertByEntity.entity.__typename);
      },
      get children() {
        return [v(ke, {
          bold: !0,
          get children() {
            return e.screeningAlertByEntity.entity.name;
          }
        }), v(dt, {
          get each() {
            return e.screeningAlertByEntity.alerts;
          },
          children: (n) => v(dt, {
            get each() {
              return Mee(n.involvedEntities);
            },
            children: (i) => [v(q, {
              get when() {
                return !Gf(i.__typename);
              },
              get children() {
                return v(q, {
                  get when() {
                    return i.id != e.screeningAlertByEntity.entity.id;
                  },
                  get children() {
                    var a = Oee(), o = a.firstChild, s = o.nextSibling;
                    return s.nextSibling, C(a, () => Iee(n.severity), o), C(a, () => i.name, s), C(a, () => Nee(i.__typename), null), a;
                  }
                });
              }
            }), v(q, {
              get when() {
                return Gf(i.__typename);
              },
              get children() {
                return v(dt, {
                  get each() {
                    return e.otherAlertsByEntity.filter((a) => a.entity.id === i.id);
                  },
                  children: (a) => v(dt, {
                    get each() {
                      return a.alerts.filter((o) => o.type === "ALLERGEN");
                    },
                    children: (o) => (() => {
                      var s = Pee();
                      return C(s, () => o.description), s;
                    })()
                  })
                });
              }
            })]
          })
        })];
      }
    })), t;
  }
});
var Lee = /* @__PURE__ */ k('<div class="grid gap-4">');
function m9(e) {
  return Object.values(e.flatMap((t) => t.involvedEntities.map((r) => ({
    entity: r,
    alert: t
  }))).reduce((t, r) => {
    const n = r.entity.id;
    return t[n] || (t[n] = {
      entity: r.entity,
      alerts: []
    }), t[n].alerts.push(r.alert), t;
  }, {}));
}
const Fee = (e) => (() => {
  var t = Lee();
  return C(t, v(dt, {
    get each() {
      return m9(e.screeningAlerts).filter((r) => r.entity.__typename != "PrescriptionScreeningAlertInvolvedAllergen");
    },
    children: (r) => v(Ree, {
      screeningAlertByEntity: r,
      get otherAlertsByEntity() {
        return m9(e.screeningAlerts);
      }
    })
  })), t;
})();
var jee = /* @__PURE__ */ k('<div class="grid gap-6"><div class="flex flex-col gap-6"><div><div class="table bg-blue-50 text-blue-600 p-2 rounded-full mb-4"></div></div></div><div class="flex flex-col items-stretch gap-2">');
function zee(e) {
  const t = e.filter((i) => i.type === "ALLERGEN").length, r = e.filter((i) => i.type === "DRUG").length, n = [];
  return t === 1 ? n.push("a known allergy") : t > 1 && n.push("known allergies"), r === 1 ? n.push("a known interaction") : r > 1 && n.push("known interactions"), n.join(" and ");
}
function Vee(e) {
  const [t, r] = z(!0);
  let n;
  function i() {
    dn("prescribe-clinical-alerting-acknowledge-alerts", e.alerts.reduce((o, s, l) => (o[l] = s.description, o), {}), n), e.onIgnoreWarningAndCreateAnyway();
  }
  function a() {
    dn("prescribe-clinical-alerting-revisit-prescriptions", e.alerts.reduce((o, s, l) => (o[l] = s.description, o), {}), n), e.onRevisitPrescriptions();
  }
  return v(os, {
    get open() {
      return t();
    },
    onClose: () => {
      r(!1), e.onRevisitPrescriptions();
    },
    get children() {
      var o = jee(), s = o.firstChild, l = s.firstChild, d = l.firstChild, c = s.nextSibling, u = n;
      return typeof u == "function" ? cn(u, o) : n = o, C(d, v(et, {
        name: "exclamationCircle"
      })), C(l, v(ke, {
        bold: !0,
        get children() {
          return ["Are you sure you want to send prescriptions with ", Pt(() => zee(e.alerts)), "?"];
        }
      }), null), C(o, v(Fee, {
        get screeningAlerts() {
          return e.alerts;
        }
      }), c), C(c, v(ct, {
        size: "xl",
        onClick: () => {
          r(!1), i();
        },
        children: "Send order"
      }), null), C(c, v(ct, {
        variant: "secondary",
        size: "xl",
        onClick: () => {
          r(!1), a();
        },
        children: "Cancel"
      }), null), o;
    }
  });
}
var Uee = /* @__PURE__ */ k('<div class="flex flex-col md:flex-row justify-between md:items-center gap-4 md:gap-1 w-full"><div class="flex flex-col text-xs"><div class=font-bold></div><div></div></div><div class="text-xs text-left md:text-right whitespace-nowrap"><span>Est. Copay: </span><span class=font-bold>'), qee = /* @__PURE__ */ k("<div>Alerts"), Bee = /* @__PURE__ */ k("<ul>"), Hee = /* @__PURE__ */ k('<div class="flex flex-col gap-4"><div class="flex flex-col"><div class="text-xs text-gray-500"><span>Quantity / Days Supply: </span><span class=font-bold></span></div><div class="text-xs text-gray-500"><span>Pharmacy: </span><span class=font-bold>'), Wee = /* @__PURE__ */ k('<div class="text-xs text-gray-500"><span>Instructions: </span><span>'), Kee = /* @__PURE__ */ k('<div class="text-xs text-gray-500"><span>Refills: </span><span>'), Qee = /* @__PURE__ */ k("<li class=text-xs><span class=text-gray-600>: </span><span class=text-gray-500>");
function F$(e) {
  const t = B(() => e.coverageOption.paRequired ? {
    status: "warning",
    message: "PA Required"
  } : e.coverageOption.status === "COVERED" ? {
    status: "success",
    message: "Covered by Insurance"
  } : e.coverageOption.status === "COVERED_WITH_RESTRICTIONS" ? {
    status: "warning",
    message: "Covered with Restrictions",
    subMessage: e.coverageOption.statusMessage
  } : {
    status: "error",
    message: "Not Covered by Insurance",
    subMessage: e.coverageOption.statusMessage
  }), r = B(() => e.coverageOption.alerts.filter((n) => n.text !== e.coverageOption.statusMessage));
  return (() => {
    var n = Hee(), i = n.firstChild, a = i.firstChild, o = a.firstChild, s = o.nextSibling, l = a.nextSibling, d = l.firstChild, c = d.nextSibling;
    return C(s, () => `${e.coverageOption.dispenseQuantity} ${e.coverageOption.dispenseUnit} / ${e.coverageOption.daysSupply}`), C(i, v(q, {
      get when() {
        return e.prescription;
      },
      children: (u) => [(() => {
        var h = Wee(), f = h.firstChild, p = f.nextSibling;
        return C(p, () => u().instructions), h;
      })(), (() => {
        var h = Kee(), f = h.firstChild, p = f.nextSibling;
        return C(p, () => O$(u().fillsAllowed)), h;
      })()]
    }), l), C(c, () => e.coverageOption.pharmacy.name), C(n, v(to, {
      get status() {
        return t().status;
      },
      withoutIcon: !0,
      get children() {
        var u = Uee(), h = u.firstChild, f = h.firstChild, p = f.nextSibling, m = h.nextSibling, y = m.firstChild, g = y.nextSibling;
        return C(f, () => t().message), C(p, () => t().subMessage), C(g, () => Gee(e.coverageOption.price)), u;
      }
    }), null), C(n, v(q, {
      get when() {
        return r().length > 0;
      },
      get children() {
        return [qee(), (() => {
          var u = Bee();
          return C(u, v(dt, {
            get each() {
              return r();
            },
            children: (h) => (() => {
              var f = Qee(), p = f.firstChild, m = p.firstChild, y = p.nextSibling;
              return C(p, () => h.label, m), C(y, () => h.text), f;
            })()
          })), u;
        })()];
      }
    }), null), n;
  })();
}
function Gee(e) {
  return e ? `$${e.toFixed(0)}` : "N/A";
}
var Yee = /* @__PURE__ */ k("<div>Other Options"), Jee = /* @__PURE__ */ k('<div class="flex flex-col gap-2"><div class="flex flex-col gap-2"><div class="flex flex-col gap-2"><div class=text-sm></div></div></div><div class="flex justify-end mt-2">');
function Zee(e) {
  return [Yee(), v(dt, {
    get each() {
      return e.coverageOptions;
    },
    children: (t) => v(Xee, {
      coverageOption: t,
      get handleSwapToOtherPrescription() {
        return e.handleSwapToOtherPrescription;
      }
    })
  })];
}
function Xee(e) {
  const t = async () => {
    e.handleSwapToOtherPrescription(e.coverageOption);
  };
  return v(Sn, {
    class: "mb-1",
    get children() {
      var r = Jee(), n = r.firstChild, i = n.firstChild, a = i.firstChild, o = n.nextSibling;
      return C(a, () => e.coverageOption.treatment.name), C(i, v(F$, {
        get coverageOption() {
          return e.coverageOption;
        }
      }), null), C(o, v(ct, {
        size: "sm",
        variant: "naked",
        "on:click": t,
        children: "Select This Option"
      })), r;
    }
  });
}
function ete(e, t) {
  return {
    id: e.id,
    doNotFillBeforeDate: e.doNotFillBeforeDate,
    dispenseAsWritten: e.dispenseAsWritten || !1,
    dispenseQuantity: e.dispenseQuantity,
    dispenseUnit: e.dispenseUnit,
    daysSupply: e.daysSupply || 0,
    instructions: e.instructions,
    notes: e.notes || "",
    fillsAllowed: e.fillsAllowed,
    diagnoseCodes: [],
    catalogId: t,
    externalId: e.externalId || void 0,
    treatment: {
      id: e.treatment.id,
      name: e.treatment.name
    }
  };
}
var tte = /* @__PURE__ */ k("<button title=Edit>"), rte = /* @__PURE__ */ k("<button title=Delete>"), nte = /* @__PURE__ */ k('<div class="flex flex-col gap-4"><div class="flex justify-between items-center gap-4"><div class="flex flex-col items-start">'), ite = /* @__PURE__ */ k('<div class="flex items-start gap-3"> ');
function ate(e) {
  const t = B(() => e.screeningAlerts.filter((a) => a.involvedEntities.map((o) => o.id).indexOf(e.draft.treatment.id) >= 0)), r = B(() => e.routingConstraint && KY({
    prescription: e.draft,
    routingConstraint: e.routingConstraint
  })), n = B(() => e.coverageOptions.find((a) => !a.isAlternative)), i = B(() => e.coverageOptions.filter((a) => a.isAlternative));
  return v(j$, {
    get LeftChildren() {
      return [v(ke, {
        get children() {
          return e.draft.treatment.name;
        }
      }), v(q, {
        get when() {
          return n() === void 0;
        },
        get children() {
          return v(ke, {
            color: "gray",
            size: "sm",
            get children() {
              return $l({
                // need to use nullish coalescing here because draft types are eg `Maybe<number> | undefined`
                dispenseQuantity: e.draft?.dispenseQuantity ?? void 0,
                dispenseUnit: e.draft?.dispenseUnit ?? void 0,
                fillsAllowed: e.draft?.fillsAllowed ?? void 0,
                instructions: e.draft?.instructions ?? void 0
              });
            }
          });
        }
      })];
    },
    get RightChildren() {
      return [(() => {
        var a = tte();
        return a.$$click = () => e.handleEdit && e.handleEdit(ete(e.draft)), C(a, v(et, {
          name: "pencilSquare",
          size: "sm",
          class: "text-gray-500 hover:text-amber-500"
        })), a;
      })(), (() => {
        var a = rte();
        return a.$$click = () => e.handleDelete && e.handleDelete(e.draft.id), C(a, v(et, {
          name: "trash",
          size: "sm",
          class: "text-gray-500 hover:text-red-500"
        })), a;
      })()];
    },
    get BottomChildren() {
      return [v(q, {
        get when() {
          return t().length > 0;
        },
        get children() {
          return v(L$, {
            get screeningAlerts() {
              return t();
            },
            get owningId() {
              return e.draft.treatment.id;
            }
          });
        }
      }), v(q, {
        get when() {
          return r();
        },
        get children() {
          return r();
        }
      }), v(q, {
        get when() {
          return n();
        },
        children: (a) => v(F$, {
          get coverageOption() {
            return a();
          },
          get prescription() {
            return e.draft;
          }
        })
      }), v(q, {
        get when() {
          return i().length > 0;
        },
        get children() {
          return v(Zee, {
            get coverageOptions() {
              return i();
            },
            get handleSwapToOtherPrescription() {
              return e.handleSwapToOtherPrescription;
            }
          });
        }
      })];
    }
  });
}
const j$ = (e) => (() => {
  var t = nte(), r = t.firstChild, n = r.firstChild;
  return C(n, () => e.LeftChildren), C(r, v(q, {
    get when() {
      return e?.RightChildren;
    },
    children: (i) => (() => {
      var a = ite();
      return a.firstChild, C(a, i, null), a;
    })()
  }), null), C(t, v(q, {
    get when() {
      return e?.BottomChildren;
    },
    children: (i) => i()
  }), null), t;
})();
qr(["click"]);
var ote = /* @__PURE__ */ k('<div><div aria-hidden=true class="absolute inset-0 flex items-center"><div class="w-full border-t border-gray-300">');
function ste(e) {
  const t = B(() => jt("relative", e.class));
  return (() => {
    var r = ote();
    return te(() => rt(r, t())), r;
  })();
}
var lte = /* @__PURE__ */ k('<div class="flex flex-col gap-4">'), dte = /* @__PURE__ */ k("<div class=space-y-3>");
function cte(e) {
  const {
    isLoadingPrefills: t,
    draftPrescriptions: r,
    prescriptionIds: n
  } = Ul(), {
    coverageOptions: i
  } = ql(), a = B(() => VY(e.routingConstraints));
  return (() => {
    var o = dte();
    return C(o, v(q, {
      get when() {
        return t();
      },
      get children() {
        return v(dt, {
          get each() {
            return n();
          },
          children: () => v(j$, {
            get LeftChildren() {
              return [v(ke, {
                size: "lg",
                sampleLoadingText: "Medication 100mg",
                loading: !0
              }), v(ke, {
                size: "sm",
                sampleLoadingText: "Loading notes about the medication",
                loading: !0
              })];
            }
          })
        });
      }
    }), null), C(o, v(q, {
      get when() {
        return Pt(() => !t())() && n().length === 0;
      },
      get children() {
        return v(to, {
          status: "info",
          get children() {
            return e.enableOrder ? "Add prescription(s) before sending" : "Add prescription(s) before saving";
          }
        });
      }
    }), null), C(o, v(q, {
      get when() {
        return Pt(() => !t())() && r().length > 0;
      },
      get children() {
        var s = lte();
        return C(s, v(dt, {
          get each() {
            return r();
          },
          children: (l, d) => [v(q, {
            get when() {
              return d() > 0;
            },
            get children() {
              return v(ste, {});
            }
          }), v(ate, {
            get screeningAlerts() {
              return e.screeningAlerts;
            },
            get routingConstraint() {
              return a().get(l.id);
            },
            draft: l,
            get coverageOptions() {
              return i().filter((c) => c.prescriptionId === l.id);
            },
            get handleEdit() {
              return e.handleEdit;
            },
            get handleDelete() {
              return e.handleDelete;
            },
            get handleSwapToOtherPrescription() {
              return e.handleSwapToOtherPrescription;
            }
          })]
        })), s;
      }
    }), null), o;
  })();
}
var nl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ute(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var h3 = { exports: {} }, z$ = { exports: {} };
(function(e) {
  (function() {
    var t = this || self;
    function r(b, E) {
      function A() {
      }
      A.prototype = E.prototype, b.Ba = E.prototype, b.prototype = new A(), b.prototype.constructor = b, b.Ha = function(j, U, J) {
        for (var ce = Array(arguments.length - 2), nt = 2; nt < arguments.length; nt++) ce[nt - 2] = arguments[nt];
        return E.prototype[U].apply(j, ce);
      };
    }
    function n(b) {
      var E = [];
      let A = 0;
      for (var j in b) E[A++] = b[j];
      return E;
    }
    function i(b, E) {
      for (this.h = b, this.g = {}, b = 0; b < E.length; b++) {
        var A = E[b];
        this.g[A.g] = A;
      }
    }
    function a(b) {
      return b = n(b.g), b.sort(function(E, A) {
        return E.g - A.g;
      }), b;
    }
    function o(b, E) {
      switch (this.g = b, this.m = !!E.ga, this.h = E.i, this.u = E.type, this.s = !1, this.h) {
        case d:
        case c:
        case u:
        case h:
        case f:
        case l:
        case s:
          this.s = !0;
      }
      this.j = E.defaultValue;
    }
    var s = 1, l = 2, d = 3, c = 4, u = 6, h = 16, f = 18;
    function p() {
      this.h = {}, this.j = this.o().g, this.g = this.m = null;
    }
    p.prototype.has = function(b) {
      return y(this, b.g);
    }, p.prototype.get = function(b, E) {
      return w(this, b.g, E);
    }, p.prototype.set = function(b, E) {
      S(this, b.g, E);
    }, p.prototype.add = function(b, E) {
      T(this, b.g, E);
    };
    function m(b, E) {
      for (var A = a(b.o()), j = 0; j < A.length; j++) {
        var U = A[j], J = U.g;
        if (y(E, J)) {
          b.g && delete b.g[U.g];
          var ce = U.h == 11 || U.h == 10;
          if (U.m) {
            U = _(E, J);
            for (var nt = 0; nt < U.length; nt++) T(b, J, ce ? U[nt].clone() : U[nt]);
          } else U = g(E, J), ce ? (ce = g(b, J)) ? m(ce, U) : S(b, J, U.clone()) : S(b, J, U);
        }
      }
    }
    p.prototype.clone = function() {
      var b = new this.constructor();
      return b != this && (b.h = {}, b.g && (b.g = {}), m(b, this)), b;
    };
    function y(b, E) {
      return b.h[E] != null;
    }
    function g(b, E) {
      var A = b.h[E];
      if (A == null) return null;
      if (b.m) {
        if (!(E in b.g)) {
          var j = b.m, U = b.j[E];
          if (A != null) if (U.m) {
            for (var J = [], ce = 0; ce < A.length; ce++) J[ce] = j.h(U, A[ce]);
            A = J;
          } else A = j.h(U, A);
          return b.g[E] = A;
        }
        return b.g[E];
      }
      return A;
    }
    function w(b, E, A) {
      var j = g(b, E);
      return b.j[E].m ? j[A || 0] : j;
    }
    function $(b, E) {
      if (y(b, E)) b = w(b, E);
      else e: {
        if (b = b.j[E], b.j === void 0) if (E = b.u, E === Boolean) b.j = !1;
        else if (E === Number) b.j = 0;
        else if (E === String) b.j = b.s ? "0" : "";
        else {
          b = new E();
          break e;
        }
        b = b.j;
      }
      return b;
    }
    function _(b, E) {
      return g(b, E) || [];
    }
    function x(b, E) {
      return b.j[E].m ? y(b, E) ? b.h[E].length : 0 : y(b, E) ? 1 : 0;
    }
    function S(b, E, A) {
      b.h[E] = A, b.g && (b.g[E] = A);
    }
    function T(b, E, A) {
      b.h[E] || (b.h[E] = []), b.h[E].push(A), b.g && delete b.g[E];
    }
    function I(b, E) {
      var A = [], j;
      for (j in E) j != 0 && A.push(new o(j, E[j]));
      return new i(b, A);
    }
    function M() {
    }
    M.prototype.g = function(b) {
      throw new b.h(), Error("Unimplemented");
    }, M.prototype.h = function(b, E) {
      if (b.h == 11 || b.h == 10) return E instanceof p ? E : this.g(b.u.prototype.o(), E);
      if (b.h == 14) return typeof E == "string" && P.test(E) && (b = Number(E), 0 < b) ? b : E;
      if (!b.s) return E;
      if (b = b.u, b === String) {
        if (typeof E == "number") return String(E);
      } else if (b === Number && typeof E == "string" && (E === "Infinity" || E === "-Infinity" || E === "NaN" || P.test(E))) return Number(E);
      return E;
    };
    var P = /^-?[0-9]+$/;
    function O() {
    }
    r(O, M), O.prototype.g = function(b, E) {
      return b = new b.h(), b.m = this, b.h = E, b.g = {}, b;
    };
    function D() {
    }
    r(D, O), D.prototype.h = function(b, E) {
      return b.h == 8 ? !!E : M.prototype.h.apply(this, arguments);
    }, D.prototype.g = function(b, E) {
      return D.Ba.g.call(this, b, E);
    };
    function R(b, E) {
      b != null && this.g.apply(this, arguments);
    }
    R.prototype.h = "", R.prototype.set = function(b) {
      this.h = "" + b;
    }, R.prototype.g = function(b, E, A) {
      if (this.h += String(b), E != null) for (let j = 1; j < arguments.length; j++) this.h += arguments[j];
      return this;
    };
    function L(b) {
      b.h = "";
    }
    R.prototype.toString = function() {
      return this.h;
    };
    function Q() {
      p.call(this);
    }
    r(Q, p);
    var ie = null;
    function ee() {
      p.call(this);
    }
    r(ee, p);
    var W = null;
    function H() {
      p.call(this);
    }
    r(H, p);
    var pe = null;
    H.prototype.ia = function() {
      return w(this, 10);
    }, Q.prototype.o = function() {
      var b = ie;
      return b || (ie = b = I(Q, { 0: { name: "NumberFormat", na: "i18n.phonenumbers.NumberFormat" }, 1: { name: "pattern", required: !0, i: 9, type: String }, 2: { name: "format", required: !0, i: 9, type: String }, 3: { name: "leading_digits_pattern", ga: !0, i: 9, type: String }, 4: { name: "national_prefix_formatting_rule", i: 9, type: String }, 6: { name: "national_prefix_optional_when_formatting", i: 8, defaultValue: !1, type: Boolean }, 5: { name: "domestic_carrier_code_formatting_rule", i: 9, type: String } })), b;
    }, Q.o = Q.prototype.o, ee.prototype.o = function() {
      var b = W;
      return b || (W = b = I(ee, { 0: { name: "PhoneNumberDesc", na: "i18n.phonenumbers.PhoneNumberDesc" }, 2: { name: "national_number_pattern", i: 9, type: String }, 9: { name: "possible_length", ga: !0, i: 5, type: Number }, 10: { name: "possible_length_local_only", ga: !0, i: 5, type: Number }, 6: { name: "example_number", i: 9, type: String } })), b;
    }, ee.o = ee.prototype.o, H.prototype.o = function() {
      var b = pe;
      return b || (pe = b = I(H, {
        0: { name: "PhoneMetadata", na: "i18n.phonenumbers.PhoneMetadata" },
        1: { name: "general_desc", i: 11, type: ee },
        2: { name: "fixed_line", i: 11, type: ee },
        3: { name: "mobile", i: 11, type: ee },
        4: { name: "toll_free", i: 11, type: ee },
        5: { name: "premium_rate", i: 11, type: ee },
        6: { name: "shared_cost", i: 11, type: ee },
        7: { name: "personal_number", i: 11, type: ee },
        8: { name: "voip", i: 11, type: ee },
        21: { name: "pager", i: 11, type: ee },
        25: { name: "uan", i: 11, type: ee },
        27: { name: "emergency", i: 11, type: ee },
        28: { name: "voicemail", i: 11, type: ee },
        29: { name: "short_code", i: 11, type: ee },
        30: { name: "standard_rate", i: 11, type: ee },
        31: { name: "carrier_specific", i: 11, type: ee },
        33: { name: "sms_services", i: 11, type: ee },
        24: { name: "no_international_dialling", i: 11, type: ee },
        9: { name: "id", required: !0, i: 9, type: String },
        10: { name: "country_code", i: 5, type: Number },
        11: { name: "international_prefix", i: 9, type: String },
        17: { name: "preferred_international_prefix", i: 9, type: String },
        12: { name: "national_prefix", i: 9, type: String },
        13: { name: "preferred_extn_prefix", i: 9, type: String },
        15: {
          name: "national_prefix_for_parsing",
          i: 9,
          type: String
        },
        16: { name: "national_prefix_transform_rule", i: 9, type: String },
        18: { name: "same_mobile_and_fixed_line_pattern", i: 8, defaultValue: !1, type: Boolean },
        19: { name: "number_format", ga: !0, i: 11, type: Q },
        20: { name: "intl_number_format", ga: !0, i: 11, type: Q },
        22: { name: "main_country_for_code", i: 8, defaultValue: !1, type: Boolean },
        23: { name: "leading_digits", i: 9, type: String }
      })), b;
    }, H.o = H.prototype.o;
    function Te() {
      p.call(this);
    }
    r(Te, p);
    var Ce = null;
    Te.prototype.ia = function() {
      return w(this, 1);
    };
    var de = { Ga: 0, Fa: 1, Ea: 5, Da: 10, Ca: 20 };
    Te.prototype.o = function() {
      var b = Ce;
      return b || (Ce = b = I(Te, { 0: { name: "PhoneNumber", na: "i18n.phonenumbers.PhoneNumber" }, 1: { name: "country_code", required: !0, i: 5, type: Number }, 2: { name: "national_number", required: !0, i: 4, type: Number }, 3: { name: "extension", i: 9, type: String }, 4: { name: "italian_leading_zero", i: 8, type: Boolean }, 8: { name: "number_of_leading_zeros", i: 5, defaultValue: 1, type: Number }, 5: { name: "raw_input", i: 9, type: String }, 6: { name: "country_code_source", i: 14, defaultValue: 0, type: de }, 7: {
        name: "preferred_domestic_carrier_code",
        i: 9,
        type: String
      } })), b;
    }, Te.ctor = Te, Te.ctor.o = Te.prototype.o;
    var K = {
      1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
      7: ["RU", "KZ"],
      20: ["EG"],
      27: ["ZA"],
      30: ["GR"],
      31: ["NL"],
      32: ["BE"],
      33: ["FR"],
      34: ["ES"],
      36: ["HU"],
      39: ["IT", "VA"],
      40: ["RO"],
      41: ["CH"],
      43: ["AT"],
      44: ["GB", "GG", "IM", "JE"],
      45: ["DK"],
      46: ["SE"],
      47: ["NO", "SJ"],
      48: ["PL"],
      49: ["DE"],
      51: ["PE"],
      52: ["MX"],
      53: ["CU"],
      54: ["AR"],
      55: ["BR"],
      56: ["CL"],
      57: ["CO"],
      58: ["VE"],
      60: ["MY"],
      61: ["AU", "CC", "CX"],
      62: ["ID"],
      63: ["PH"],
      64: ["NZ"],
      65: ["SG"],
      66: ["TH"],
      81: ["JP"],
      82: ["KR"],
      84: ["VN"],
      86: ["CN"],
      90: ["TR"],
      91: ["IN"],
      92: ["PK"],
      93: ["AF"],
      94: ["LK"],
      95: ["MM"],
      98: ["IR"],
      211: ["SS"],
      212: ["MA", "EH"],
      213: ["DZ"],
      216: ["TN"],
      218: ["LY"],
      220: ["GM"],
      221: ["SN"],
      222: ["MR"],
      223: ["ML"],
      224: ["GN"],
      225: ["CI"],
      226: ["BF"],
      227: ["NE"],
      228: ["TG"],
      229: ["BJ"],
      230: ["MU"],
      231: ["LR"],
      232: ["SL"],
      233: ["GH"],
      234: ["NG"],
      235: ["TD"],
      236: ["CF"],
      237: ["CM"],
      238: ["CV"],
      239: ["ST"],
      240: ["GQ"],
      241: ["GA"],
      242: ["CG"],
      243: ["CD"],
      244: ["AO"],
      245: ["GW"],
      246: ["IO"],
      247: ["AC"],
      248: ["SC"],
      249: ["SD"],
      250: ["RW"],
      251: ["ET"],
      252: ["SO"],
      253: ["DJ"],
      254: ["KE"],
      255: ["TZ"],
      256: ["UG"],
      257: ["BI"],
      258: ["MZ"],
      260: ["ZM"],
      261: ["MG"],
      262: ["RE", "YT"],
      263: ["ZW"],
      264: ["NA"],
      265: ["MW"],
      266: ["LS"],
      267: ["BW"],
      268: ["SZ"],
      269: ["KM"],
      290: ["SH", "TA"],
      291: ["ER"],
      297: ["AW"],
      298: ["FO"],
      299: ["GL"],
      350: ["GI"],
      351: ["PT"],
      352: ["LU"],
      353: ["IE"],
      354: ["IS"],
      355: ["AL"],
      356: ["MT"],
      357: ["CY"],
      358: ["FI", "AX"],
      359: ["BG"],
      370: ["LT"],
      371: ["LV"],
      372: ["EE"],
      373: ["MD"],
      374: ["AM"],
      375: ["BY"],
      376: ["AD"],
      377: ["MC"],
      378: ["SM"],
      380: ["UA"],
      381: ["RS"],
      382: ["ME"],
      383: ["XK"],
      385: ["HR"],
      386: ["SI"],
      387: ["BA"],
      389: ["MK"],
      420: ["CZ"],
      421: ["SK"],
      423: ["LI"],
      500: ["FK"],
      501: ["BZ"],
      502: ["GT"],
      503: ["SV"],
      504: ["HN"],
      505: ["NI"],
      506: ["CR"],
      507: ["PA"],
      508: ["PM"],
      509: ["HT"],
      590: ["GP", "BL", "MF"],
      591: ["BO"],
      592: ["GY"],
      593: ["EC"],
      594: ["GF"],
      595: ["PY"],
      596: ["MQ"],
      597: ["SR"],
      598: ["UY"],
      599: ["CW", "BQ"],
      670: ["TL"],
      672: ["NF"],
      673: ["BN"],
      674: ["NR"],
      675: ["PG"],
      676: ["TO"],
      677: ["SB"],
      678: ["VU"],
      679: ["FJ"],
      680: ["PW"],
      681: ["WF"],
      682: ["CK"],
      683: ["NU"],
      685: ["WS"],
      686: ["KI"],
      687: ["NC"],
      688: ["TV"],
      689: ["PF"],
      690: ["TK"],
      691: ["FM"],
      692: ["MH"],
      800: ["001"],
      808: ["001"],
      850: ["KP"],
      852: ["HK"],
      853: ["MO"],
      855: ["KH"],
      856: ["LA"],
      870: ["001"],
      878: ["001"],
      880: ["BD"],
      881: ["001"],
      882: ["001"],
      883: ["001"],
      886: ["TW"],
      888: ["001"],
      960: ["MV"],
      961: ["LB"],
      962: ["JO"],
      963: ["SY"],
      964: ["IQ"],
      965: ["KW"],
      966: ["SA"],
      967: ["YE"],
      968: ["OM"],
      970: ["PS"],
      971: ["AE"],
      972: ["IL"],
      973: ["BH"],
      974: ["QA"],
      975: ["BT"],
      976: ["MN"],
      977: ["NP"],
      979: ["001"],
      992: ["TJ"],
      993: ["TM"],
      994: ["AZ"],
      995: ["GE"],
      996: ["KG"],
      998: ["UZ"]
    }, oe = {
      AC: [, [
        ,
        ,
        "(?:[01589]\\d|[46])\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6]
      ], [, , "6[2-467]\\d{3}", , , , "62889", , , [5]], [, , "4\\d{4}", , , , "40123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AC", 247, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:0[1-9]|[1589]\\d)\\d{4}", , , , "542011", , , [6]], , , [, , , , , , , , , [-1]]],
      AD: [
        ,
        [, , "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", , , , , , , [6, 8, 9]],
        [, , "[78]\\d{5}", , , , "712345", , , [6]],
        [, , "690\\d{6}|[356]\\d{5}", , , , "312345", , , [6, 9]],
        [, , "180[02]\\d{4}", , , , "18001234", , , [8]],
        [, , "[19]\\d{5}", , , , "912345", , , [6]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AD",
        376,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "1800\\d{4}", , , , , , , [8]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AE: [
        ,
        [, , "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
        [, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8], [7]],
        [, , "5[024-68]\\d{7}", , , , "501234567", , , [9]],
        [, , "400\\d{6}|800\\d{2,9}", , , , "800123456"],
        [, , "900[02]\\d{5}", , , , "900234567", , , [9]],
        [, , "700[05]\\d{5}", , , , "700012345", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AE",
        971,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], [, "(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "600[25]\\d{5}", , , , "600212345", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AF: [, [, , "[2-7]\\d{8}", , , , , , , [9], [7]], [
        ,
        ,
        "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
        ,
        ,
        ,
        "234567890",
        ,
        ,
        ,
        [7]
      ], [, , "7\\d{8}", , , , "701234567", , , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AF", 93, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AG: [
        ,
        [, , "(?:268|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [
          ,
          ,
          "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",
          ,
          ,
          ,
          "2684601234",
          ,
          ,
          ,
          [7]
        ],
        [, , "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}", , , , "2684641234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , "26848[01]\\d{4}", , , , "2684801234", , , , [7]],
        "AG",
        1,
        "011",
        "1",
        ,
        ,
        "([457]\\d{6})$|1",
        "268$1",
        ,
        ,
        ,
        ,
        [, , "26840[69]\\d{4}", , , , "2684061234", , , , [7]],
        ,
        "268",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AI: [, [, , "(?:264|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "264(?:292|4(?:6[12]|9[78]))\\d{4}", , , , "2644612345", , , , [7]], [, , "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", , , , "2642351234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "AI", 1, "011", "1", , , "([2457]\\d{6})$|1", "264$1", , , , , [, , "264724\\d{4}", , , , "2647241234", , , , [7]], , "264", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AL: [, [, , "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", , , , , , , [6, 7, 8, 9], [5]], [, , "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", , , , "22345678", , , [8], [5, 6, 7]], [, , "6(?:[78][2-9]|9\\d)\\d{6}", , , , "672123456", , , [9]], [, , "800\\d{4}", , , , "8001234", , , [7]], [
        ,
        ,
        "900[1-9]\\d\\d",
        ,
        ,
        ,
        "900123",
        ,
        ,
        [6]
      ], [, , "808[1-9]\\d\\d", , , , "808123", , , [6]], [, , "700[2-9]\\d{4}", , , , "70021234", , , [8]], [, , , , , , , , , [-1]], "AL", 355, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AM: [, [
        ,
        ,
        "(?:[1-489]\\d|55|60|77)\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8],
        [5, 6]
      ], [, , "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}", , , , "10123456", , , , [5, 6]], [, , "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}", , , , "77123456"], [, , "800\\d{5}", , , , "80012345"], [, , "90[016]\\d{5}", , , , "90012345"], [, , "80[1-4]\\d{5}", , , , "80112345"], [, , , , , , , , , [-1]], [, , "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}", , , , "60271234"], "AM", 374, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], [
        ,
        "(\\d{3})(\\d{5})",
        "$1 $2",
        ["2|3[12]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AO: [
        ,
        [, , "[29]\\d{8}", , , , , , , [9]],
        [, , "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}", , , , "222123456"],
        [, , "9[1-59]\\d{7}", , , , "923123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AO",
        244,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AR: [
        ,
        [, , "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", , , , , , , [10, 11], [6, 7, 8]],
        [
          ,
          ,
          "3888[013-9]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
          ,
          ,
          ,
          "1123456789",
          ,
          ,
          [10],
          [6, 7, 8]
        ],
        [
          ,
          ,
          "93(?:7(?:1[15]|81)[46]|8(?:(?:21|4[16]|69|9[12])[46]|88[013-9]))\\d{5}|9(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
          ,
          ,
          ,
          "91123456789",
          ,
          ,
          ,
          [6, 7, 8]
        ],
        [, , "800\\d{7,8}", , , , "8001234567"],
        [, , "60[04579]\\d{7}", , , , "6001234567", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AR",
        54,
        "00",
        "0",
        ,
        ,
        "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
        "9$1",
        ,
        ,
        [[, "(\\d{3})", "$1", ["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]], [, "(\\d{2})(\\d{4})", "$1-$2", ["[1-9]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[1-8]"]], [
          ,
          "(\\d{4})(\\d{2})(\\d{4})",
          "$1 $2-$3",
          [
            "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
            "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ],
          "0$1",
          ,
          1
        ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1], [
          ,
          "(\\d)(\\d{4})(\\d{2})(\\d{4})",
          "$2 15-$3-$4",
          [
            "9(?:2[2-469]|3[3-578])",
            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ],
          "0$1"
        ], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1"]],
        [
          [
            ,
            "(\\d{4})(\\d{2})(\\d{4})",
            "$1 $2-$3",
            [
              "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
              "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
              "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
              "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
            ],
            "0$1",
            ,
            1
          ],
          [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1],
          [, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", [
            "9(?:2[2-469]|3[3-578])",
            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ]],
          [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["91"]],
          [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"],
          [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", ["9"]]
        ],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "810\\d{7}", , , , , , , [10]],
        [, , "810\\d{7}", , , , "8101234567", , , [10]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AS: [, [, , "(?:[58]\\d\\d|684|900)\\d{7}", , , , , , , [10], [7]], [, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234", , , , [7]], [, , "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}", , , , "6847331234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002123456"
      ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AS", 1, "011", "1", , , "([267]\\d{6})$|1", "684$1", , , , , [, , , , , , , , , [-1]], , "684", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AT: [, [
        ,
        ,
        "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
        ,
        ,
        ,
        ,
        ,
        ,
        [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
        [3]
      ], [, , "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}", , , , "1234567890", , , , [3]], [, , "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", , , , "664123456", , , [7, 8, 9, 10, 11, 12, 13]], [
        ,
        ,
        "800\\d{6,10}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [9, 10, 11, 12, 13]
      ], [, , "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", , , , "900123456", , , [9, 10, 11, 12, 13]], [, , "8(?:10|2[018])\\d{6,10}|828\\d{5}", , , , "810123456", , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", , , , "780123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], "AT", 43, "00", "0", , , "0", , , , [
        [, "(\\d{4})", "$1", ["14"]],
        [, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"],
        [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"],
        [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"],
        [, "(\\d{6})", "$1", ["[18]"]],
        [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"],
        [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"],
        [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"],
        [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]
      ], [[, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], [
        ,
        "(\\d{3})(\\d{3,10})",
        "$1 $2",
        ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
        "0$1"
      ], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AU: [
        ,
        [, , "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", , , , , , , [5, 6, 7, 8, 9, 10, 12]],
        [
          ,
          ,
          "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
          ,
          ,
          ,
          "212345678",
          ,
          ,
          [9],
          [8]
        ],
        [, , "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", , , , "412345678", , , [9]],
        [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
        [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]],
        [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]],
        [, , , , , , , , , [-1]],
        [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]],
        "AU",
        61,
        "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
        "0",
        ,
        ,
        "(183[12])|0",
        ,
        "0011",
        ,
        [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["13"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["19"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["180", "1802"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["19"]], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]], [
          ,
          "(\\d{4})(\\d{4})(\\d{4})",
          "$1 $2 $3",
          ["130"]
        ]],
        [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]],
        [, , "163\\d{2,6}", , , , "1631234", , , [5, 6, 7, 8, 9]],
        1,
        ,
        [, , "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}", , , , , , , [6, 7, 8, 10, 12]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AW: [, [
        ,
        ,
        "(?:[25-79]\\d\\d|800)\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7]
      ], [, , "5(?:2\\d|8[1-9])\\d{4}", , , , "5212345"], [, , "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}", , , , "5601234"], [, , "800\\d{4}", , , , "8001234"], [, , "900\\d{4}", , , , "9001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:28\\d|501)\\d{4}", , , , "5011234"], "AW", 297, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AX: [, [
        ,
        ,
        "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7, 8, 9, 10, 11, 12]
      ], [, , "18[1-8]\\d{3,6}", , , , "181234567", , , [6, 7, 8, 9]], [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AX", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , , , [, , , , , , , , , [-1]], , "18", [, , , , , , , , , [-1]], [
        ,
        ,
        "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
        ,
        ,
        ,
        "10112345"
      ], , , [, , , , , , , , , [-1]]],
      AZ: [, [, , "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", , , , , , , [9], [7]], [, , "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}", , , , "123123456", , , , [7]], [, , "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}", , , , "401234567"], [, , "88\\d{7}", , , , "881234567"], [, , "900200\\d{3}", , , , "900200123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AZ", 994, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[1-9]"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["90"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [
        ,
        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[13-9]"],
        "0$1"
      ]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BA: [
        ,
        [, , "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", , , , , , , [8, 9], [6]],
        [, , "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", , , , "30212345", , , [8], [6]],
        [, , "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}", , , , "61123456"],
        [, , "8[08]\\d{6}", , , , "80123456", , , [8]],
        [, , "9[0246]\\d{6}", , , , "90123456", , , [8]],
        [, , "8[12]\\d{6}", , , , "82123456", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "BA",
        387,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})", "$1-$2", ["[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
        [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", , , , "70341234", , , [8]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BB: [, [, , "(?:246|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}", , , , "2464123456", , , , [7]], [, , "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}", , , , "2462501234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002123456"
      ], [, , "(?:246976|900[2-9]\\d\\d)\\d{4}", , , , "9002123456", , , , [7]], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "24631\\d{5}", , , , "2463101234", , , , [7]], "BB", 1, "011", "1", , , "([2-9]\\d{6})$|1", "246$1", , , , , [, , , , , , , , , [-1]], , "246", [, , , , , , , , , [-1]], [
        ,
        ,
        "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
        ,
        ,
        ,
        "2464301234",
        ,
        ,
        ,
        [7]
      ], , , [, , , , , , , , , [-1]]],
      BD: [, [, , "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [
        ,
        ,
        "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:222|[45]\\d)\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
        ,
        ,
        ,
        "27111234"
      ], [, , "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", , , , "1812345678", , , [10]], [, , "80[03]\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", , , , "9604123456", , , [10]], "BD", 880, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], [
        ,
        "(\\d{3})(\\d{3,7})",
        "$1-$2",
        ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
        "0$1"
      ], [, "(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], [, "(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BE: [, [, , "4\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9]], [, , "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", , , , "12345678", , , [8]], [, , "4[5-9]\\d{7}", , , , "470123456", , , [9]], [, , "800[1-9]\\d{4}", , , , "80012345", , , [8]], [, , "(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}", , , , "90012345", , , [8]], [
        ,
        ,
        "7879\\d{4}",
        ,
        ,
        ,
        "78791234",
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BE", 32, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}", , , , "78102345", , , [8]], , , [, , , , , , , , , [-1]]],
      BF: [, [
        ,
        ,
        "[025-7]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8]
      ], [, , "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", , , , "20491234"], [, , "(?:0[1-35-7]|5[0-8]|[67]\\d)\\d{6}", , , , "70123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BF", 226, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BG: [
        ,
        [, , "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", , , , , , , [6, 7, 8, 9, 12], [4, 5]],
        [, , "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", , , , "2123456", , , [6, 7, 8], [4, 5]],
        [, , "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", , , , "43012345", , , [8, 9]],
        [, , "(?:00800\\d\\d|800)\\d{5}", , , , "80012345", , , [8, 12]],
        [, , "90\\d{6}", , , , "90123456", , , [8]],
        [, , "700\\d{5}", , , , "70012345", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "BG",
        359,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{6})", "$1", ["1"]], [, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
          ,
          "(\\d{3})(\\d{4})",
          "$1 $2",
          ["43[1-6]|70[1-9]"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]],
        [[, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
          ,
          "(\\d{3})(\\d{4})",
          "$1 $2",
          ["43[1-6]|70[1-9]"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BH: [, [, , "[136-9]\\d{7}", , , , , , , [8]], [
        ,
        ,
        "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
        ,
        ,
        ,
        "17001234"
      ], [, , "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}", , , , "36001234"], [, , "8[02369]\\d{6}", , , , "80123456"], [, , "(?:87|9[0-8])\\d{6}", , , , "90123456"], [, , "84\\d{6}", , , , "84123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BH", 973, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BI: [, [, , "(?:[267]\\d|31)\\d{6}", , , , , , , [8]], [, , "(?:22|31)\\d{6}", , , , "22201234"], [
        ,
        ,
        "(?:29|[67][125-9])\\d{6}",
        ,
        ,
        ,
        "79561234"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BI", 257, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BJ: [
        ,
        [, , "[24-689]\\d{7}", , , , , , , [8]],
        [, , "2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}", , , , "20211234"],
        [, , "(?:4[0-356]|[56]\\d|9[013-9])\\d{6}", , , , "90011234"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "857[58]\\d{4}", , , , "85751234"],
        "BJ",
        229,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "81\\d{6}", , , , "81123456"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BL: [
        ,
        [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
        [, , "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}", , , , "590271234"],
        [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}", , , , "690001234"],
        [, , "80[0-5]\\d{6}", , , , "800012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"],
        "BL",
        590,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BM: [, [, , "(?:441|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}", , , , "4414123456", , , , [7]], [, , "441(?:[2378]\\d|5[0-39]|92)\\d{5}", , , , "4413701234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "BM", 1, "011", "1", , , "([2-9]\\d{6})$|1", "441$1", , , , , [, , , , , , , , , [-1]], , "441", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BN: [
        ,
        [, , "[2-578]\\d{6}", , , , , , , [7]],
        [, , "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}", , , , "2345678"],
        [, , "(?:22[89]|[78]\\d\\d)\\d{4}", , , , "7123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "5[34]\\d{5}", , , , "5345678"],
        "BN",
        673,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BO: [
        ,
        [, , "(?:[2-467]\\d\\d|8001)\\d{5}", , , , , , , [8, 9], [7]],
        [, , "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", , , , "22123456", , , [8], [7]],
        [, , "[67]\\d{7}", , , , "71234567", , , [8]],
        [, , "8001[07]\\d{4}", , , , "800171234", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "BO",
        591,
        "00(?:1\\d)?",
        "0",
        ,
        ,
        "0(1\\d)?",
        ,
        ,
        ,
        [[, "(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"], , "0$CC $1"], [, "(\\d{8})", "$1", ["[67]"], , "0$CC $1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"], , "0$CC $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "8001[07]\\d{4}", , , , , , , [9]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BQ: [, [, , "(?:[34]1|7\\d)\\d{5}", , , , , , , [7]], [, , "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}", , , , "7151234"], [, , "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", , , , "3181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BQ", 599, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "[347]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BR: [, [, , "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", , , , , , , [8, 9, 10, 11]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", , , , "1123456789", , , [10], [8]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", , , , "11961234567", , , [10, 11], [8, 9]], [
        ,
        ,
        "800\\d{6,7}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [9, 10]
      ], [, , "300\\d{6}|[59]00\\d{6,7}", , , , "300123456", , , [9, 10]], [, , "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", , , , "40041234", , , [8, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0", , , "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", , , [[, "(\\d{3,6})", "$1", ["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], [
        ,
        "(\\d{4})(\\d{4})",
        "$1-$2",
        ["[2-57]", "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]
      ], [, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], [, "(\\d{5})(\\d{4})", "$1-$2", ["9"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], [
        ,
        "(\\d{3})(\\d{2,3})(\\d{4})",
        "$1 $2 $3",
        ["(?:[358]|90)0"],
        "0$1"
      ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "30(?:0\\d{5,7}|3\\d{7})|40(?:0\\d|20)\\d{4}|800\\d{6,7}", , , , , , , [8, 9, 10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BS: [, [, , "(?:242|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
        ,
        ,
        ,
        "2423456789",
        ,
        ,
        ,
        [7]
      ], [, , "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}", , , , "2423591234", , , , [7]], [, , "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , , [7]], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "BS", 1, "011", "1", , , "([3-8]\\d{6})$|1", "242$1", , , , , [, , , , , , , , , [-1]], , "242", [, , , , , , , , , [-1]], [, , "242225\\d{4}", , , , "2422250123"], , , [, , , , , , , , , [-1]]],
      BT: [, [, , "[17]\\d{7}|[2-8]\\d{6}", , , , , , , [7, 8], [6]], [, , "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", , , , "2345678", , , [7], [6]], [, , "(?:1[67]|77)\\d{6}", , , , "17123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BT", 975, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[2-7]"]], [
        ,
        "(\\d)(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[2-68]|7[246]"]
      ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BW: [, [, , "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", , , , , , , [7, 8, 10]], [
        ,
        ,
        "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}",
        ,
        ,
        ,
        "2401234",
        ,
        ,
        [7]
      ], [, , "(?:321|7(?:[1-7]\\d|8[0-4]))\\d{5}", , , , "71123456", , , [8]], [, , "(?:0800|800\\d)\\d{6}", , , , "0800012345", , , [10]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "79(?:1(?:[01]\\d|2[0-7])|2[0-7]\\d)\\d{3}", , , , "79101234", , , [8]], "BW", 267, "00", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["90"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], [
        ,
        "(\\d{3})(\\d{4})(\\d{3})",
        "$1 $2 $3",
        ["8"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BY: [, [, , "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", , , , "152450911", , , [9], [5, 6, 7]], [
        ,
        ,
        "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
        ,
        ,
        ,
        "294911911",
        ,
        ,
        [9]
      ], [, , "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}", , , , "8011234567"], [, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "249\\d{6}", , , , "249123456", , , [9]], "BY", 375, "810", "8", , , "0|80?", , "8~10", , [[, "(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], [
        ,
        "(\\d{4})(\\d{2})(\\d{3})",
        "$1 $2-$3",
        ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
        "8 0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BZ: [, [, , "(?:0800\\d|[2-8])\\d{6}", , , , , , , [7, 11]], [, , "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", , , , "2221234", , , [7]], [
        ,
        ,
        "6[0-35-7]\\d{5}",
        ,
        ,
        ,
        "6221234",
        ,
        ,
        [7]
      ], [, , "0800\\d{7}", , , , "08001234123", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BZ", 501, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CA: [, [, , "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", , , , , , , [7, 10]], [
        ,
        ,
        "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
        ,
        ,
        ,
        "5062345678",
        ,
        ,
        [10],
        [7]
      ], [, , "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", , , , "5062345678", , , [10], [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , [10]], [, , "900[2-9]\\d{6}", , , , "9002123456", , , [10]], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678",
        ,
        ,
        [10]
      ], [, , "600[2-9]\\d{6}", , , , "6002012345", , , [10]], "CA", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "310\\d{4}", , , , "3101234", , , [7]], , , [, , , , , , , , , [-1]]],
      CC: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", , , , "891621234", , , [9], [8]], [
        ,
        ,
        "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
        ,
        ,
        ,
        "412345678",
        ,
        ,
        [9]
      ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CC", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "([59]\\d{7})$|0", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CD: [, [
        ,
        ,
        "[189]\\d{8}|[1-68]\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 9]
      ], [, , "12\\d{7}|[1-6]\\d{6}", , , , "1234567"], [, , "88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}", , , , "991234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CD", 243, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CF: [, [
        ,
        ,
        "(?:[27]\\d{3}|8776)\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8]
      ], [, , "2[12]\\d{6}", , , , "21612345"], [, , "7[024-7]\\d{6}", , , , "70012345"], [, , , , , , , , , [-1]], [, , "8776\\d{4}", , , , "87761234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CF", 236, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CG: [, [, , "222\\d{6}|(?:0\\d|80)\\d{7}", , , , , , , [9]], [, , "222[1-589]\\d{5}", , , , "222123456"], [
        ,
        ,
        "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
        ,
        ,
        ,
        "061234567"
      ], [, , , , , , , , , [-1]], [, , "80[0-2]\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CG", 242, "00", , , , , , , , [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CH: [
        ,
        [, , "8\\d{11}|[2-9]\\d{8}", , , , , , , [9, 12]],
        [, , "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", , , , "212345678", , , [9]],
        [, , "7[35-9]\\d{7}", , , , "781234567", , , [9]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "90[016]\\d{6}", , , , "900123456", , , [9]],
        [, , "84[0248]\\d{6}", , , , "840123456", , , [9]],
        [, , "878\\d{6}", , , , "878123456", , , [9]],
        [, , , , , , , , , [-1]],
        "CH",
        41,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]],
        ,
        [, , "74[0248]\\d{6}", , , , "740123456", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "5[18]\\d{7}", , , , "581234567", , , [9]],
        ,
        ,
        [
          ,
          ,
          "860\\d{9}",
          ,
          ,
          ,
          "860123456789",
          ,
          ,
          [12]
        ]
      ],
      CI: [, [, , "[02]\\d{9}", , , , , , , [10]], [, , "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}", , , , "2123456789"], [, , "0[157]\\d{8}", , , , "0123456789"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CI", 225, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CK: [, [
        ,
        ,
        "[2-578]\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5]
      ], [, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"], [, , "[578]\\d{4}", , , , "71234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CK", 682, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CL: [, [, , "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", , , , , , , [9, 10, 11]], [
        ,
        ,
        "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
        ,
        ,
        ,
        "221234567",
        ,
        ,
        [9]
      ], [, , "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", , , , "221234567", , , [9]], [, , "(?:123|8)00\\d{6}", , , , "800123456", , , [9, 11]], [, , , , , , , , , [-1]], [
        ,
        ,
        "600\\d{7,8}",
        ,
        ,
        ,
        "6001234567",
        ,
        ,
        [10, 11]
      ], [, , , , , , , , , [-1]], [, , "44\\d{7}", , , , "441234567", , , [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", , , , , , , 1, [[, "(\\d{4})", "$1", ["1(?:[03-589]|21)|[29]0|78"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],
        "($1)"
      ], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [[, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["60|8"]
      ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [, , , , , , , , , [-1]], , , [, , "600\\d{7,8}", , , , , , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CM: [, [, , "[26]\\d{8}|88\\d{6,7}", , , , , , , [8, 9]], [, , "2(?:22|33)\\d{6}", , , , "222123456", , , [9]], [, , "(?:24[23]|6[25-9]\\d)\\d{6}", , , , "671234567", , , [9]], [, , "88\\d{6,7}", , , , "88012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CM", 237, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["88"]
      ], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CN: [, [, , "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [
        ,
        ,
        "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
        ,
        ,
        ,
        "1012345678",
        ,
        ,
        [7, 8, 9, 10, 11],
        [5, 6]
      ], [, , "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", , , , "13123456789", , , [11]], [, , "(?:(?:10|21)8|8)00\\d{7}", , , , "8001234567", , , [10, 12]], [, , "16[08]\\d{5}", , , , "16812345", , , [8]], [
        ,
        ,
        "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
        ,
        ,
        ,
        "4001234567",
        ,
        ,
        [7, 8, 9, 10, 11],
        [5, 6]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CN", 86, "00|1(?:[12]\\d|79)\\d\\d00", "0", , , "(1(?:[12]\\d|79)\\d\\d)|0", , "00", , [
        [, "(\\d{5,6})", "$1", ["10|96"]],
        [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1", "$CC $1"],
        [, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]", "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])", "1(?:0(?:[0-8]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])|6)|[3-9]"]],
        [, "(\\d{4})(\\d{4})", "$1 $2", ["16[08]"]],
        [
          ,
          "(\\d{3})(\\d{5,6})",
          "$1 $2",
          [
            "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
            "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
            "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
            "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
          ],
          "0$1",
          "$CC $1"
        ],
        [, "(\\d{4})(\\d{4})", "$1 $2", [
          "[1-9]",
          "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
          "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
          "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
        ]],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
        [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
        [
          ,
          "(\\d{3})(\\d{7,8})",
          "$1 $2",
          ["9"]
        ],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
      ], [
        [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1", "$CC $1"],
        [, "(\\d{3})(\\d{5,6})", "$1 $2", [
          "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
          "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
          "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
          "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
        ], "0$1", "$CC $1"],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
        [
          ,
          "(\\d{2})(\\d{4})(\\d{4})",
          "$1 $2 $3",
          ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],
          "0$1",
          "$CC $1",
          1
        ],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{7,8})", "$1 $2", ["9"]],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
      ], [, , , , , , , , , [-1]], , , [, , "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}", , , , , , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CO: [, [, , "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", , , , , , , [10, 11], [7]], [, , "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60[124-8][2-9]\\d{6}", , , , "6012345678", , , [10], [7]], [
        ,
        ,
        "3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",
        ,
        ,
        ,
        "3211234567",
        ,
        ,
        [10]
      ], [, , "1800\\d{7}", , , , "18001234567", , , [11]], [, , "19(?:0[01]|4[78])\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", , , "0(4(?:[14]4|56)|[579])?", , , , [[, "(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1"]], [
        [, "(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)", "0$CC $1"],
        [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"], , "0$CC $1"],
        [, "(\\d)(\\d{3})(\\d{7})", "$1 $2 $3", ["1"]]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CR: [, [, , "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", , , , , , , [8, 10]], [, , "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", , , , "22123456", , , [8]], [, , "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", , , , "83123456", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "90[059]\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:210[0-6]|4\\d{3}|5100)\\d{4}",
        ,
        ,
        ,
        "40001234",
        ,
        ,
        [8]
      ], "CR", 506, "00", , , , "(19(?:0[0-2468]|1[09]|20|66|77|99))", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CU: [, [, , "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}", , , , , , , [6, 7, 8, 10], [4, 5]], [, , "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}", , , , "71234567", , , , [4, 5]], [
        ,
        ,
        "(?:5\\d|63)\\d{6}",
        ,
        ,
        ,
        "51234567",
        ,
        ,
        [8]
      ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , "807\\d{7}", , , , "8071234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CU", 53, "119", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], [, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CV: [, [, , "(?:[2-59]\\d\\d|800)\\d{4}", , , , , , , [7]], [
        ,
        ,
        "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
        ,
        ,
        ,
        "2211234"
      ], [, , "(?:36|5[1-389]|9\\d)\\d{5}", , , , "9911234"], [, , "800\\d{4}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[3-5]|4[356])\\d{5}", , , , "3401234"], "CV", 238, "0", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CW: [, [, , "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", , , , , , , [7, 8]], [
        ,
        ,
        "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
        ,
        ,
        ,
        "94351234"
      ], [, , "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}", , , , "95181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "60[0-2]\\d{4}", , , , "6001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CW", 599, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], , [, , "955\\d{5}", , , , "95581234", , , [8]], 1, "[69]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CX: [
        ,
        [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]],
        [
          ,
          ,
          "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
          ,
          ,
          ,
          "891641234",
          ,
          ,
          [9],
          [8]
        ],
        [, , "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", , , , "412345678", , , [9]],
        [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
        [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]],
        [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]],
        [, , , , , , , , , [-1]],
        [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]],
        "CX",
        61,
        "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
        "0",
        ,
        ,
        "([59]\\d{7})$|0",
        "8$1",
        "0011",
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      CY: [
        ,
        [, , "(?:[279]\\d|[58]0)\\d{6}", , , , , , , [8]],
        [, , "2[2-6]\\d{6}", , , , "22345678"],
        [, , "9(?:10|[4-79]\\d)\\d{5}", , , , "96123456"],
        [, , "800\\d{5}", , , , "80001234"],
        [, , "90[09]\\d{5}", , , , "90012345"],
        [, , "80[1-9]\\d{5}", , , , "80112345"],
        [, , "700\\d{5}", , , , "70012345"],
        [, , , , , , , , , [-1]],
        "CY",
        357,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "(?:50|77)\\d{6}", , , , "77123456"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      CZ: [, [, , "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]], [, , "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", , , , "212345678", , , [9]], [, , "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}", , , , "601123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]], [, , "8[134]\\d{7}", , , , "811234567", , , [9]], [, , "70[01]\\d{6}", , , , "700123456", , , [9]], [, , "9[17]0\\d{6}", , , , "910123456", , , [9]], "CZ", 420, "00", , , , , , , , [
        [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]],
        [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]
      ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "9(?:5\\d|7[2-4])\\d{6}", , , , "972123456", , , [9]], , , [, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]],
      DE: [, [
        ,
        ,
        "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
        ,
        ,
        ,
        ,
        ,
        ,
        [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        [2, 3]
      ], [
        ,
        ,
        "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
        ,
        ,
        ,
        "30123456",
        ,
        ,
        [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        [2, 3, 4]
      ], [, , "15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}", , , , "15123456789", , , [10, 11]], [, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]], [, , "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", , , , "9001234567", , , [10, 11]], [, , "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", , , , "18012345", , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , "700\\d{8}", , , , "70012345678", , , [11]], [, , , , , , , , , [-1]], "DE", 49, "00", "0", , , "0", , , , [
        [, "(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"],
        [
          ,
          "(\\d{3})(\\d{3,12})",
          "$1 $2",
          ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],
          "0$1"
        ],
        [
          ,
          "(\\d{4})(\\d{2,11})",
          "$1 $2",
          ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
          "0$1"
        ],
        [, "(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
        [, "(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
        [, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
        [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
        [, "(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
        [, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
        [, "(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
        [, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
        [, "(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"],
        [, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
        [, "(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
        [, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"],
        [, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
        [, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]
      ], , [, , "16(?:4\\d{1,10}|[89]\\d{1,11})", , , , "16412345", , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , "18(?:1\\d{5,11}|[2-9]\\d{8})", , , , "18500123456", , , [8, 9, 10, 11, 12, 13, 14]], , , [
        ,
        ,
        "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
        ,
        ,
        ,
        "177991234567",
        ,
        ,
        [12, 13]
      ]],
      DJ: [, [, , "(?:2\\d|77)\\d{6}", , , , , , , [8]], [, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"], [, , "77\\d{6}", , , , "77831001"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DJ", 253, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      DK: [, [, , "[2-9]\\d{7}", , , , , , , [8]], [, , "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}", , , , "32123456"], [
        ,
        ,
        "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",
        ,
        ,
        ,
        "32123456"
      ], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DK", 45, "00", , , , , , , 1, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      DM: [
        ,
        [, , "(?:[58]\\d\\d|767|900)\\d{7}", , , , , , , [10], [7]],
        [, , "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}", , , , "7674201234", , , , [7]],
        [, , "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}", , , , "7672251234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "DM",
        1,
        "011",
        "1",
        ,
        ,
        "([2-7]\\d{6})$|1",
        "767$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "767",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      DO: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}", , , , "8092345678", , , , [7]], [, , "8[024]9[2-9]\\d{6}", , , , "8092345678", , , , [7]], [
        ,
        ,
        "8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}",
        ,
        ,
        ,
        "8002123456"
      ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DO", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "8001|8[024]9", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      DZ: [
        ,
        [, , "(?:[1-4]|[5-79]\\d|80)\\d{7}", , , , , , , [8, 9]],
        [, , "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}", , , , "12345678"],
        [, , "(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", , , , "551234567", , , [9]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]],
        [, , "80[12]1\\d{5}", , , , "801123456", , , [9]],
        [, , , , , , , , , [-1]],
        [, , "98[23]\\d{6}", , , , "983123456", , , [9]],
        "DZ",
        213,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [
          [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"],
          [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"],
          [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]
        ],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      EC: [
        ,
        [, , "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", , , , , , , [8, 9, 10, 11], [7]],
        [, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8], [7]],
        [, , "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", , , , "991234567", , , [9]],
        [, , "1800\\d{7}|1[78]00\\d{6}", , , , "18001234567", , , [10, 11]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "[2-7]890\\d{4}", , , , "28901234", , , [8]],
        "EC",
        593,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]],
        [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-7]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      EE: [
        ,
        [, , "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", , , , , , , [7, 8, 10]],
        [
          ,
          ,
          "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
          ,
          ,
          ,
          "3212345",
          ,
          ,
          [7]
        ],
        [, , "(?:5\\d{5}|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", , , , "51234567", , , [7, 8]],
        [, , "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}", , , , "80012345"],
        [, , "(?:40\\d\\d|900)\\d{4}", , , , "9001234", , , [7, 8]],
        [, , , , , , , , , [-1]],
        [, , "70[0-2]\\d{5}", , , , "70012345", , , [8]],
        [, , , , , , , , , [-1]],
        "EE",
        372,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "800[2-9]\\d{3}", , , , , , , [7]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      EG: [, [
        ,
        ,
        "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10],
        [6, 7]
      ], [, , "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", , , , "234567890", , , [8, 9], [6, 7]], [, , "1[0-25]\\d{8}", , , , "1001234567", , , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "EG", 20, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["[89]"],
        "0$1"
      ], [, "(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      EH: [
        ,
        [, , "[5-8]\\d{8}", , , , , , , [9]],
        [, , "528[89]\\d{5}", , , , "528812345"],
        [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}", , , , "650123456"],
        [, , "80\\d{7}", , , , "801234567"],
        [, , "89\\d{7}", , , , "891234567"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "592(?:4[0-2]|93)\\d{4}", , , , "592401234"],
        "EH",
        212,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "528[89]",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      ER: [, [, , "[178]\\d{6}", , , , , , , [7], [6]], [, , "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}", , , , "8370362", , , , [6]], [, , "(?:17[1-3]|7\\d\\d)\\d{4}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ER", 291, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ES: [, [, , "[5-9]\\d{8}", , , , , , , [9]], [
        ,
        ,
        "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
        ,
        ,
        ,
        "810123456"
      ], [, , "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}", , , , "612345678"], [, , "[89]00\\d{6}", , , , "800123456"], [, , "80[367]\\d{6}", , , , "803123456"], [, , "90[12]\\d{6}", , , , "901123456"], [, , "70\\d{7}", , , , "701234567"], [, , , , , , , , , [-1]], "ES", 34, "00", , , , , , , , [[, "(\\d{4})", "$1", ["905"]], [, "(\\d{6})", "$1", ["[79]9"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], [
        [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]],
        [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "51\\d{7}", , , , "511234567"], , , [, , , , , , , , , [-1]]],
      ET: [, [, , "(?:11|[2-579]\\d)\\d{7}", , , , , , , [9], [7]], [
        ,
        ,
        "11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
        ,
        ,
        ,
        "111112345",
        ,
        ,
        ,
        [7]
      ], [, , "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}", , , , "911234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ET", 251, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FI: [
        ,
        [, , "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
        [
          ,
          ,
          "(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}",
          ,
          ,
          ,
          "131234567",
          ,
          ,
          [5, 6, 7, 8, 9]
        ],
        [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]],
        [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]],
        [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "FI",
        358,
        "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
        "0",
        ,
        ,
        "0",
        ,
        "00",
        ,
        [[, "(\\d{5})", "$1", ["75[12]"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [, "(\\d{6})", "$1", ["11"]], [
          ,
          "(\\d{3})(\\d{3,7})",
          "$1 $2",
          ["[12]00|[368]|70[07-9]"],
          "0$1"
        ], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]],
        [[, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]],
        [, , , , , , , , , [-1]],
        1,
        "1[03-79]|[2-9]",
        [, , "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"],
        [, , "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}", , , , "10112345"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      FJ: [
        ,
        [, , "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", , , , , , , [7, 11]],
        [, , "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", , , , "3212345", , , [7]],
        [, , "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", , , , "7012345", , , [7]],
        [, , "0800\\d{7}", , , , "08001234567", , , [11]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "FJ",
        679,
        "0(?:0|52)",
        ,
        ,
        ,
        ,
        ,
        "00",
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      FK: [, [, , "[2-7]\\d{4}", , , , , , , [5]], [, , "[2-47]\\d{4}", , , , "31234"], [, , "[56]\\d{4}", , , , "51234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FK", 500, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FM: [, [, , "(?:[39]\\d\\d|820)\\d{4}", , , , , , , [7]], [
        ,
        ,
        "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
        ,
        ,
        ,
        "3201234"
      ], [, , "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}", , , , "3501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FM", 691, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FO: [, [, , "[2-9]\\d{5}", , , , , , , [6]], [, , "(?:20|[34]\\d|8[19])\\d{4}", , , , "201234"], [, , "(?:[27][1-9]|5\\d|9[16])\\d{4}", , , , "211234"], [, , "80[257-9]\\d{3}", , , , "802123"], [
        ,
        ,
        "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
        ,
        ,
        ,
        "901123"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6[0-36]|88)\\d{4}", , , , "601234"], "FO", 298, "00", , , , "(10(?:01|[12]0|88))", , , , [[, "(\\d{6})", "$1", ["[2-9]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FR: [, [, , "[1-9]\\d{8}", , , , , , , [9]], [, , "59[1-9]\\d{6}|(?:[1-3]\\d|4[1-9]|5[0-8])\\d{7}", , , , "123456789"], [, , "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}", , , , "612345678"], [, , "80[0-5]\\d{6}", , , , "801234567"], [
        ,
        ,
        "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
        ,
        ,
        ,
        "891123456"
      ], [, , "8(?:1[01]|2[0156]|4[02]|84)\\d{6}", , , , "884012345"], [, , , , , , , , , [-1]], [, , "9\\d{8}", , , , "912345678"], "FR", 33, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["10"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]], [, , "80[6-9]\\d{6}", , , , "806123456"], , , [, , , , , , , , , [-1]]],
      GA: [, [, , "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", , , , , , , [7, 8]], [, , "[01]1\\d{6}", , , , "01441234", , , [8]], [, , "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}", , , , "06031234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GA", 241, "00", , , , "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", , , [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["0"]
      ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GB: [, [, , "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", , , , , , , [7, 9, 10], [4, 5, 6, 8]], [
        ,
        ,
        "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
        ,
        ,
        ,
        "1212345678",
        ,
        ,
        [9, 10],
        [4, 5, 6, 7, 8]
      ], [, , "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", , , , "7400123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [
        ,
        ,
        "56\\d{8}",
        ,
        ,
        ,
        "5612345678",
        ,
        ,
        [10]
      ], "GB", 44, "00", "0", " x", , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", [
        "[25]|7(?:0|6[02-9])",
        "[25]|7(?:0|6(?:[03-9]|2[356]))"
      ], "0$1"], [, "(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456", , , [10]], 1, , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
      GD: [
        ,
        [, , "(?:473|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [
          ,
          ,
          "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
          ,
          ,
          ,
          "4732691234",
          ,
          ,
          ,
          [7]
        ],
        [, , "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}", , , , "4734031234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "GD",
        1,
        "011",
        "1",
        ,
        ,
        "([2-9]\\d{6})$|1",
        "473$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "473",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GE: [, [, , "(?:[3-57]\\d\\d|800)\\d{6}", , , , , , , [9], [6, 7]], [, , "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", , , , "322123456", , , , [6, 7]], [
        ,
        ,
        "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:00(?:0\\d|11|22|33|44|5[05]|77|88|99)|1(?:1(?:00|[124]\\d|3[01])|4\\d\\d)|(?:44|68)\\d\\d|5(?:[0157-9]\\d\\d|200)|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[01]\\d|2[0-4])|58[89]|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:070|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}",
        ,
        ,
        ,
        "555123456"
      ], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70[67]\\d{6}", , , , "706123456"], "GE", 995, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "70[67]\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GF: [, [
        ,
        ,
        "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9]
      ], [, , "594(?:[02-49]\\d|1[0-4]|5[6-9]|6[0-3]|80)\\d{4}", , , , "594101234"], [, , "694(?:[0-249]\\d|3[0-8])\\d{4}", , , , "694201234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}", , , , "976012345"], "GF", 594, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      GG: [, [, , "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", , , , , , , [7, 9, 10], [6]], [, , "1481[25-9]\\d{5}", , , , "1481256789", , , [10], [6]], [, , "7(?:(?:781|839)\\d|911[17])\\d{5}", , , , "7781123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GG", 44, "00", "0", , , "([25-9]\\d{5})$|0", "1481$1", , , , , [
        ,
        ,
        "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
        ,
        ,
        ,
        "7640123456",
        ,
        ,
        [10]
      ], , , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
      GH: [, [, , "(?:[235]\\d{3}|800)\\d{5}", , , , , , , [8, 9], [7]], [, , "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", , , , "302345678", , , [9], [7]], [, , "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", , , , "231234567", , , [9]], [
        ,
        ,
        "800\\d{5}",
        ,
        ,
        ,
        "80012345",
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GH", 233, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[237]|8[0-2]"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [[, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "800\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GI: [, [, , "(?:[25]\\d|60)\\d{6}", , , , , , , [8]], [
        ,
        ,
        "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
        ,
        ,
        ,
        "20012345"
      ], [, , "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}", , , , "57123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GI", 350, "00", , , , , , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GL: [
        ,
        [, , "(?:19|[2-689]\\d|70)\\d{4}", , , , , , , [6]],
        [, , "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}", , , , "321000"],
        [, , "[245]\\d{5}", , , , "221234"],
        [, , "80\\d{4}", , , , "801234"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "3[89]\\d{4}", , , , "381234"],
        "GL",
        299,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GM: [
        ,
        [, , "[2-9]\\d{6}", , , , , , , [7]],
        [, , "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}", , , , "5661234"],
        [, , "(?:[23679]\\d|5[0-489])\\d{5}", , , , "3012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "GM",
        220,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GN: [, [, , "722\\d{6}|(?:3|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", , , , "30241234", , , [8]], [, , "6[0-356]\\d{7}", , , , "601123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "722\\d{6}", , , , "722123456", , , [9]], "GN", 224, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[67]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GP: [, [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]], [, , "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}", , , , "590201234"], [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"], "GP", 590, "00", "0", , , "0", , , , [[
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[569]"],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GQ: [, [, , "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", , , , , , , [9]], [, , "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}", , , , "333091234"], [, , "(?:222|55\\d)\\d{6}", , , , "222123456"], [, , "80\\d[1-9]\\d{5}", , , , "800123456"], [, , "90\\d[1-9]\\d{5}", , , , "900123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GQ", 240, "00", , , , , , , , [[
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[235]"]
      ], [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GR: [, [, , "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", , , , , , , [10, 11, 12]], [
        ,
        ,
        "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
        ,
        ,
        ,
        "2123456789",
        ,
        ,
        [10]
      ], [, , "68[57-9]\\d{7}|(?:69|94)\\d{8}", , , , "6912345678", , , [10]], [, , "800\\d{7,9}", , , , "8001234567"], [, , "90[19]\\d{7}", , , , "9091234567", , , [10]], [, , "8(?:0[16]|12|[27]5|50)\\d{7}", , , , "8011234567", , , [10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , , , , , , , , [-1]], "GR", 30, "00", , , , , , , , [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], [
        ,
        "(\\d{3})(\\d{3,4})(\\d{5})",
        "$1 $2 $3",
        ["8"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "5005000\\d{3}", , , , "5005000123", , , [10]], , , [, , , , , , , , , [-1]]],
      GT: [
        ,
        [, , "(?:1\\d{3}|[2-7])\\d{7}", , , , , , , [8, 11]],
        [, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]],
        [, , "[3-5]\\d{7}", , , , "51234567", , , [8]],
        [, , "18[01]\\d{8}", , , , "18001112222", , , [11]],
        [, , "19\\d{9}", , , , "19001112222", , , [11]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "GT",
        502,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GU: [, [, , "(?:[58]\\d\\d|671|900)\\d{7}", , , , , , , [10], [7]], [, , "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", , , , "6713001234", , , , [7]], [
        ,
        ,
        "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
        ,
        ,
        ,
        "6713001234",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GU", 1, "011", "1", , , "([3-9]\\d{6})$|1", "671$1", , 1, , , [, , , , , , , , , [-1]], , "671", [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      GW: [, [, , "[49]\\d{8}|4\\d{6}", , , , , , , [7, 9]], [, , "443\\d{6}", , , , "443201234", , , [9]], [, , "9(?:5\\d|6[569]|77)\\d{6}", , , , "955012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "40\\d{5}", , , , "4012345", , , [7]], "GW", 245, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["40"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GY: [
        ,
        [, , "9008\\d{3}|(?:[2-467]\\d\\d|510|862)\\d{4}", , , , , , , [7]],
        [, , "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}", , , , "2201234"],
        [, , "(?:510|6\\d\\d|7(?:0\\d|1[0-8]|25|49))\\d{4}", , , , "6091234"],
        [, , "(?:289|862)\\d{4}", , , , "2891234"],
        [, , "9008\\d{3}", , , , "9008123"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "GY",
        592,
        "001",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      HK: [, [
        ,
        ,
        "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7, 8, 9, 11]
      ], [, , "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:[45][0-8]|6[01]|9\\d))|58(?:0[1-9]|1[2-9]))\\d{4}", , , , "21234567", , , [8]], [
        ,
        ,
        "(?:4(?:44[5-9]|6(?:0[0-7]|1[0-6]|4[0-57-9]|6[0-4]|7[0-8]))|573[0-6]|6(?:26[013-8]|66[0-3])|70(?:7[1-5]|8[0-4])|848[015-9]|9(?:29[013-9]|59[0-4]))\\d{4}|(?:4(?:4[01]|6[2358])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
        ,
        ,
        ,
        "51234567",
        ,
        ,
        [8]
      ], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "900(?:[0-24-9]\\d{7}|3\\d{1,4})", , , , "90012345678", , , [5, 6, 7, 8, 11]], [, , , , , , , , , [-1]], [, , "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", , , , "81123456", , , [8]], [, , , , , , , , , [-1]], "HK", 852, "00(?:30|5[09]|[126-9]?)", , , , , , "00", , [[, "(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
        "$1 $2 $3 $4",
        ["9"]
      ]], , [, , "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", , , , "71123456", , , [8]], , , [, , , , , , , , , [-1]], [, , "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", , , , "30161234", , , [8]], , , [, , , , , , , , , [-1]]],
      HN: [, [, , "8\\d{10}|[237-9]\\d{7}", , , , , , , [8, 11]], [
        ,
        ,
        "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
        ,
        ,
        ,
        "22123456",
        ,
        ,
        [8]
      ], [, , "[37-9]\\d{7}", , , , "91234567", , , [8]], [, , "8002\\d{7}", , , , "80021234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "HN", 504, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], [, , , , , , , , , [-1]], , , [, , "8002\\d{7}", , , , , , , [11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      HR: [, [, , "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", , , , , , , [6, 7, 8, 9]], [
        ,
        ,
        "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
        ,
        ,
        ,
        "12345678",
        ,
        ,
        [8, 9],
        [6, 7]
      ], [, , "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|77|9[67])))\\d{4}|98\\d{6}", , , , "921234567", , , [8, 9]], [, , "80[01]\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "6[01459]\\d{6}|6[01]\\d{4,5}", , , , "611234", , , [6, 7, 8]], [, , , , , , , , , [-1]], [, , "7[45]\\d{6}", , , , "74123456", , , [8]], [, , , , , , , , , [-1]], "HR", 385, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], [
        ,
        "(\\d)(\\d{4})(\\d{3})",
        "$1 $2 $3",
        ["1"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "62\\d{6,7}|72\\d{6}", , , , "62123456", , , [8, 9]], , , [, , , , , , , , , [-1]]],
      HT: [
        ,
        [, , "(?:[2-489]\\d|55)\\d{6}", , , , , , , [8]],
        [, , "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", , , , "22453300"],
        [, , "(?:[34]\\d|55)\\d{6}", , , , "34101234"],
        [, , "8\\d{7}", , , , "80012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}", , , , "98901234"],
        "HT",
        509,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      HU: [
        ,
        [, , "[235-7]\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9], [6, 7]],
        [, , "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", , , , "12345678", , , [8], [6, 7]],
        [, , "(?:[257]0|3[01])\\d{7}", , , , "201234567", , , [9]],
        [, , "(?:[48]0\\d|680[29])\\d{5}", , , , "80123456"],
        [, , "9[01]\\d{6}", , , , "90123456", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "21\\d{7}", , , , "211234567", , , [9]],
        "HU",
        36,
        "00",
        "06",
        ,
        ,
        "06",
        ,
        ,
        ,
        [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "(?:[48]0\\d|680[29])\\d{5}"],
        [, , "38\\d{7}", , , , "381234567", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      ID: [, [
        ,
        ,
        "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 8, 9, 10, 11, 12, 13],
        [5, 6]
      ], [
        ,
        ,
        "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
        ,
        ,
        ,
        "218350123",
        ,
        ,
        [7, 8, 9, 10, 11],
        [5, 6]
      ], [, , "8[1-35-9]\\d{7,10}", , , , "812345678", , , [9, 10, 11, 12]], [, , "00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}", , , , "8001234567", , , [8, 9, 10, 11, 12, 13]], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , "804\\d{7}", , , , "8041234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ID", 62, "00[89]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [
        ,
        "(\\d{3})(\\d{5,8})",
        "$1 $2",
        ["[2-79]"],
        "(0$1)"
      ], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["001"]], [, "(\\d{2})(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [
        ,
        "(\\d{2})(\\d{5,9})",
        "$1 $2",
        ["2[124]|[36]1"],
        "(0$1)"
      ], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "001803\\d{6,7}|(?:007803\\d|8071)\\d{6}", , , , , , , [10, 12, 13]], [
        ,
        ,
        "(?:1500|8071\\d{3})\\d{3}",
        ,
        ,
        ,
        "8071123456",
        ,
        ,
        [7, 10]
      ], , , [, , , , , , , , , [-1]]],
      IE: [, [, , "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", , , , , , , [7, 8, 9, 10], [5, 6]], [, , "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}", , , , "2212345", , , , [5, 6]], [, , "8(?:22|[35-9]\\d)\\d{6}", , , , "850123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , "15(?:1[2-8]|[2-8]0|9[089])\\d{6}", , , , "1520123456", , , [10]], [
        ,
        ,
        "18[59]0\\d{6}",
        ,
        ,
        ,
        "1850123456",
        ,
        ,
        [10]
      ], [, , "700\\d{6}", , , , "700123456", , , [9]], [, , "76\\d{7}", , , , "761234567", , , [9]], "IE", 353, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["[78]"],
        "0$1"
      ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], [, "(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "18[59]0\\d{6}", , , , , , , [10]], [, , "818\\d{6}", , , , "818123456", , , [9]], , , [, , "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", , , , "8551234567", , , [10]]],
      IL: [, [, , "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", , , , , , , [7, 8, 9, 10, 11, 12]], [
        ,
        ,
        "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
        ,
        ,
        ,
        "21234567",
        ,
        ,
        [8, 11, 12],
        [7]
      ], [, , "55410\\d{4}|5(?:(?:[02][02-9]|[149][2-9]|[36]\\d|8[3-7])\\d|5(?:01|2[2-9]|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", , , , "502345678", , , [9]], [, , "1(?:255|80[019]\\d{3})\\d{3}", , , , "1800123456", , , [7, 10]], [, , "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", , , , "1919123456", , , [8, 10]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [
        ,
        ,
        "7(?:38(?:0\\d|5[09]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
        ,
        ,
        ,
        "771234567",
        ,
        ,
        [9]
      ], "IL", 972, "0(?:0|1[2-9])", "0", , , "0", , , , [[, "(\\d{4})(\\d{3})", "$1-$2", ["125"]], [, "(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], [, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], [, "(\\d{4})(\\d{6})", "$1-$2", ["159"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], [, "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], , [, , , , , , , , , [-1]], , , [, , "1700\\d{6}", , , , , , , [10]], [
        ,
        ,
        "1599\\d{6}",
        ,
        ,
        ,
        "1599123456",
        ,
        ,
        [10]
      ], , , [, , "151\\d{8,9}", , , , "15112340000", , , [11, 12]]],
      IM: [
        ,
        [, , "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]],
        [, , "1624(?:230|[5-8]\\d\\d)\\d{3}", , , , "1624756789", , , , [6]],
        [, , "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}", , , , "7924123456"],
        [, , "808162\\d{4}", , , , "8081624567"],
        [, , "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}", , , , "9016247890"],
        [, , , , , , , , , [-1]],
        [, , "70\\d{8}", , , , "7012345678"],
        [, , "56\\d{8}", , , , "5612345678"],
        "IM",
        44,
        "00",
        "0",
        ,
        ,
        "([25-8]\\d{5})$|0",
        "1624$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "74576|(?:16|7[56])24",
        [, , , , , , , , , [-1]],
        [, , "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}", , , , "5512345678"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      IN: [, [, , "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [
        ,
        ,
        "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
        ,
        ,
        ,
        "7410410123",
        ,
        ,
        [10],
        [6, 7, 8]
      ], [
        ,
        ,
        "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
        ,
        ,
        ,
        "8123456789",
        ,
        ,
        [10]
      ], [, , "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))", , , , "1800123456"], [, , "186[12]\\d{9}", , , , "1861123456789", , , [13]], [, , "1860\\d{7}", , , , "18603451234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IN", 91, "00", "0", , , "0", , , , [[, "(\\d{7})", "$1", ["575"]], [, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["140"],
        ,
        ,
        1
      ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        [
          "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
        ],
        "0$1",
        ,
        1
      ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
      ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3 $4",
        ["0"]
      ], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], , , 1]], [[, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], , , 1], [
        ,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
        "0$1",
        ,
        1
      ], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        [
          "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
        ],
        "0$1",
        ,
        1
      ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
      ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
        ,
        "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3 $4",
        ["18"],
        ,
        ,
        1
      ]], [, , , , , , , , , [-1]], , , [, , "1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"], [, , "140\\d{7}", , , , "1409305260", , , [10]], , , [, , , , , , , , , [-1]]],
      IO: [, [, , "3\\d{6}", , , , , , , [7]], [, , "37\\d{5}", , , , "3709100"], [, , "38\\d{5}", , , , "3801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IO", 246, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      IQ: [, [
        ,
        ,
        "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10],
        [6, 7]
      ], [, , "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IQ", 964, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      IR: [
        ,
        [, , "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", , , , , , , [4, 5, 6, 7, 10], [8]],
        [, , "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}", , , , "2123456789", , , [6, 7, 10], [4, 5, 8]],
        [, , "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", , , , "9123456789", , , [10]],
        [, , , , , , , , , [-1]],
        [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "IR",
        98,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{4,5})", "$1", ["96"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))", , , , , , , [4, 5, 10]],
        [
          ,
          ,
          "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
          ,
          ,
          ,
          "9601",
          ,
          ,
          [4, 5]
        ],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      IS: [, [, , "(?:38\\d|[4-9])\\d{6}", , , , , , , [7, 9]], [, , "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", , , , "4101234", , , [7]], [, , "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}", , , , "6111234"], [, , "80[0-8]\\d{4}", , , , "8001234", , , [7]], [
        ,
        ,
        "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
        ,
        ,
        ,
        "9001234",
        ,
        ,
        [7]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "49[0-24-79]\\d{4}", , , , "4921234", , , [7]], "IS", 354, "00|1(?:0(?:01|[12]0)|100)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "809\\d{4}", , , , "8091234", , , [7]], , , [, , "(?:689|8(?:7[18]|80)|95[48])\\d{4}", , , , "6891234", , , [7]]],
      IT: [, [, , "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [
        ,
        ,
        "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
        ,
        ,
        ,
        "0212345678",
        ,
        ,
        [6, 7, 8, 9, 10, 11]
      ], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [, , "80(?:0\\d{3}|3)\\d{3}", , , , "800123456", , , [6, 9]], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "IT", 39, "00", , , , , , , , [
        [, "(\\d{4,5})", "$1", ["1(?:0|9[246])", "1(?:0|9(?:2[2-9]|[46]))"]],
        [, "(\\d{6})", "$1", ["1(?:1|92)"]],
        [, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]],
        [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],
        [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]],
        [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]],
        [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]],
        [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]],
        [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]],
        [
          ,
          "(\\d{2})(\\d{4})(\\d{5})",
          "$1 $2 $3",
          ["0[26]"]
        ],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
        [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]
      ], [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [
        ,
        "(\\d{3})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["1(?:44|[679])|[378]"]
      ], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], [, , , , , , , , , [-1]], 1, , [, , "848\\d{6}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
      JE: [, [, , "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]], [, , "1534[0-24-8]\\d{5}", , , , "1534456789", , , , [6]], [
        ,
        ,
        "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}",
        ,
        ,
        ,
        "7797712345"
      ], [, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"], [, , "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"], [, , , , , , , , , [-1]], [, , "701511\\d{4}", , , , "7015115678"], [, , "56\\d{8}", , , , "5612345678"], "JE", 44, "00", "0", , , "([0-24-8]\\d{5})$|0", "1534$1", , , , , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456"], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
        ,
        ,
        ,
        "5512345678"
      ], , , [, , , , , , , , , [-1]]],
      JM: [, [, , "(?:[58]\\d\\d|658|900)\\d{7}", , , , , , , [10], [7]], [, , "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}", , , , "8765230123", , , , [7]], [
        ,
        ,
        "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
        ,
        ,
        ,
        "8762101234",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "JM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "658|876", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      JO: [, [, , "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", , , , , , , [8, 9]], [
        ,
        ,
        "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
        ,
        ,
        ,
        "62001234",
        ,
        ,
        [8]
      ], [, , "7(?:[78][0-25-9]|9\\d)\\d{6}", , , , "790123456", , , [9]], [, , "80\\d{6}", , , , "80012345", , , [8]], [, , "9\\d{7}", , , , "90012345", , , [8]], [, , "85\\d{6}", , , , "85012345", , , [8]], [, , "70\\d{7}", , , , "700123456", , , [9]], [, , , , , , , , , [-1]], "JO", 962, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [
        ,
        ,
        "74(?:66|77)\\d{5}",
        ,
        ,
        ,
        "746612345",
        ,
        ,
        [9]
      ], , , [, , , , , , , , , [-1]], [, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]], , , [, , , , , , , , , [-1]]],
      JP: [, [, , "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", , , , "312345678", , , [9]], [
        ,
        ,
        "[7-9]0[1-9]\\d{7}",
        ,
        ,
        ,
        "9012345678",
        ,
        ,
        [10]
      ], [, , "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}", , , , "120123456"], [, , "990\\d{6}", , , , "990123456", , , [9]], [, , , , , , , , , [-1]], [, , "60\\d{7}", , , , "601234567", , , [9]], [, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]], "JP", 81, "010", "0", , , "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["007", "0077", "00777", "00777[01]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
        ,
        "(\\d{4})(\\d)(\\d{4})",
        "$1-$2-$3",
        ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
        "0$1"
      ], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1-$2-$3",
        ["60"],
        "0$1"
      ], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1-$2-$3",
        [
          "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
        ],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007", "0077"]], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["0"]], [
        ,
        "(\\d{4})(\\d{6})(\\d{6,7})",
        "$1-$2-$3",
        ["0"]
      ]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
        ,
        "(\\d{4})(\\d)(\\d{4})",
        "$1-$2-$3",
        ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1-$2-$3",
        [
          "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
        ],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], [, , "20\\d{8}", , , , "2012345678", , , [10]], , , [, , "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"], [, , "570\\d{6}", , , , "570123456", , , [9]], , , [, , , , , , , , , [-1]]],
      KE: [, [, , "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", , , , , , , [7, 8, 9, 10]], [
        ,
        ,
        "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
        ,
        ,
        ,
        "202012345",
        ,
        ,
        [7, 8, 9]
      ], [, , "(?:1(?:0[0-6]|1[0-5]|2[014]|30)|7\\d\\d)\\d{6}", , , , "712123456", , , [9]], [, , "800[2-8]\\d{5,6}", , , , "800223456", , , [9, 10]], [, , "900[02-9]\\d{5}", , , , "900223456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KE", 254, "000", "0", , , "0", , , , [[, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KG: [, [
        ,
        ,
        "8\\d{9}|[235-9]\\d{8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9, 10],
        [5, 6]
      ], [, , "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", , , , "312123456", , , [9], [5, 6]], [, , "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", , , , "700123456", , , [9]], [, , "800\\d{6,7}", , , , "800123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KG", 996, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KH: [
        ,
        [, , "1\\d{9}|[1-9]\\d{7,8}", , , , , , , [8, 9, 10], [6, 7]],
        [
          ,
          ,
          "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
          ,
          ,
          ,
          "23756789",
          ,
          ,
          [8, 9],
          [6, 7]
        ],
        [, , "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", , , , "91234567", , , [8, 9]],
        [, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]],
        [, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "KH",
        855,
        "00[14-9]",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      KI: [, [, , "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", , , , , , , [5, 8]], [, , "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}", , , , "31234"], [
        ,
        ,
        "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
        ,
        ,
        ,
        "72001234",
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", , , , "30010000", , , [8]], "KI", 686, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KM: [, [, , "[3478]\\d{6}", , , , , , , [7], [4]], [, , "7[4-7]\\d{5}", , , , "7712345", , , , [4]], [, , "[34]\\d{6}", , , , "3212345"], [, , , , , , , , , [-1]], [, , "8\\d{6}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KM", 269, "00", , , , , , , , [[
        ,
        "(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3",
        ["[3478]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KN: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}", , , , "8692361234", , , , [7]], [, , "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}", , , , "8697652917", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "KN", 1, "011", "1", , , "([2-7]\\d{6})$|1", "869$1", , , , , [, , , , , , , , , [-1]], , "869", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KP: [, [, , "85\\d{6}|(?:19\\d|[2-7])\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}", , , , "21234567", , , , [6, 7]], [, , "19[1-3]\\d{7}", , , , "1921234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KP", 850, "00|99", "0", , , "0", , , , [[
        ,
        "(\\d{2})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["8"],
        "0$1"
      ], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KR: [, [, , "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", , , , , , , [5, 6, 8, 9, 10, 11, 12, 13, 14], [3, 4, 7]], [
        ,
        ,
        "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
        ,
        ,
        ,
        "22123456",
        ,
        ,
        [5, 6, 8, 9, 10],
        [3, 4, 7]
      ], [, , "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", , , , "1020000000", , , [9, 10]], [, , "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}", , , , "801234567", , , [9, 11, 12, 13, 14]], [, , "60[2-9]\\d{6}", , , , "602345678", , , [9]], [, , , , , , , , , [-1]], [, , "50\\d{8,9}", , , , "5012345678", , , [10, 11]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "KR", 82, "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "0", , , "0(8(?:[1-46-8]|5\\d\\d))?", , , , [[
        ,
        "(\\d{5})",
        "$1",
        ["1[016-9]1", "1[016-9]11", "1[016-9]114"],
        "0$1"
      ], [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030"]], [
        ,
        "(\\d{2})(\\d{5})(\\d{4})",
        "$1-$2-$3",
        ["5"],
        "0$1",
        "0$CC-$1"
      ], [, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [
        [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"],
        [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]],
        [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"]
      ], [, , "15\\d{7,8}", , , , "1523456789", , , [9, 10]], , , [, , "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})", , , , , , , [11, 12, 13, 14]], [, , "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[168]|88)|8(?:00|33|55|77|99))\\d{4}", , , , "15441234", , , [8]], , , [, , , , , , , , , [-1]]],
      KW: [, [, , "18\\d{5}|(?:[2569]\\d|41)\\d{6}", , , , , , , [7, 8]], [, , "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", , , , "22345678", , , [8]], [
        ,
        ,
        "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|66)|222|3[36]3|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
        ,
        ,
        ,
        "50012345",
        ,
        ,
        [8]
      ], [, , "18\\d{5}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KW", 965, "00", , , , , , , , [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KY: [, [, , "(?:345|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}",
        ,
        ,
        ,
        "3452221234",
        ,
        ,
        ,
        [7]
      ], [, , "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}", , , , "3453231234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "(?:345976|900[2-9]\\d\\d)\\d{4}", , , , "9002345678"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "KY", 1, "011", "1", , , "([2-9]\\d{6})$|1", "345$1", , , , , [, , "345849\\d{4}", , , , "3458491234"], , "345", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KZ: [, [, , "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", , , , , , , [10, 14], [5, 6, 7]], [
        ,
        ,
        "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
        ,
        ,
        ,
        "7123456789",
        ,
        ,
        [10],
        [5, 6, 7]
      ], [, , "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", , , , "7710009998", , , [10]], [, , "8(?:00|108\\d{3})\\d{7}", , , , "8001234567"], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , "751\\d{7}", , , , "7511234567", , , [10]], "KZ", 7, "810", "8", , , "8", , "8~10", , , , [, , , , , , , , , [-1]], , "33|7", [, , "751\\d{7}", , , , , , , [10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LA: [, [, , "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", , , , , , , [8, 9, 10], [6]], [
        ,
        ,
        "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
        ,
        ,
        ,
        "21212862",
        ,
        ,
        [8],
        [6]
      ], [, , "(?:20(?:[2359]\\d|7[6-8]|88)|302\\d)\\d{6}", , , , "2023123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LA", 856, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "30[013-9]\\d{6}", , , , "301234567", , , [9]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      LB: [, [, , "[27-9]\\d{7}|[13-9]\\d{6}", , , , , , , [7, 8]], [, , "7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}", , , , "1123456"], [, , "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}", , , , "71123456"], [, , , , , , , , , [-1]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , "80\\d{6}", , , , "80123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LB", 961, "00", "0", , , "0", , , , [[
        ,
        "(\\d)(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LC: [
        ,
        [, , "(?:[58]\\d\\d|758|900)\\d{7}", , , , , , , [10], [7]],
        [, , "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}", , , , "7584305678", , , , [7]],
        [, , "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}", , , , "7582845678", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "LC",
        1,
        "011",
        "1",
        ,
        ,
        "([2-8]\\d{6})$|1",
        "758$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "758",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      LI: [, [, , "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", , , , , , , [7, 9]], [
        ,
        ,
        "(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
        ,
        ,
        ,
        "2345678",
        ,
        ,
        [7]
      ], [, , "(?:6(?:(?:4[5-9]|5[0-4])\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}", , , , "660234567"], [, , "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}", , , , "8002222"], [, , "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", , , , "9002222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LI", 423, "00", "0", , , "(1001)|0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["69"],
        ,
        "$CC $1"
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "870(?:28|87)\\d\\d", , , , "8702812", , , [7]], , , [, , "697(?:42|56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]],
      LK: [, [, , "[1-9]\\d{8}", , , , , , , [9], [7]], [, , "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}", , , , "112345678", , , , [7]], [, , "7(?:[0-25-8]\\d|4[0-4])\\d{6}", , , , "712345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], "LK", 94, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "1973\\d{5}", , , , "197312345"], , , [, , , , , , , , , [-1]]],
      LR: [, [, , "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", , , , , , , [7, 8, 9]], [, , "2\\d{7}", , , , "21234567", , , [8]], [, , "(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}", , , , "770123456", , , [7, 9]], [, , , , , , , , , [-1]], [
        ,
        ,
        "332(?:02|[34]\\d)\\d{4}",
        ,
        ,
        ,
        "332021234",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LR", 231, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LS: [, [, , "(?:[256]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "2\\d{7}", , , , "22123456"], [, , "[56]\\d{7}", , , , "50123456"], [, , "800[256]\\d{4}", , , , "80021234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], "LS", 266, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LT: [, [, , "(?:[3469]\\d|52|[78]0)\\d{6}", , , , , , , [8]], [, , "(?:3[1478]|4[124-6]|52)\\d{6}", , , , "31234567"], [, , "6\\d{7}", , , , "61234567"], [, , "80[02]\\d{5}", , , , "80012345"], [, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , "70[05]\\d{5}", , , , "70012345"], [, , "[89]01\\d{5}", , , , "80123456"], "LT", 370, "00", "8", , , "[08]", , , , [[
        ,
        "(\\d)(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["52[0-7]"],
        "(8-$1)",
        ,
        1
      ], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", , 1], [, "(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", , 1], [, "(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "70[67]\\d{5}", , , , "70712345"], , , [, , , , , , , , , [-1]]],
      LU: [, [, , "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11]], [
        ,
        ,
        "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
        ,
        ,
        ,
        "27123456"
      ], [, , "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", , , , "628123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90[015]\\d{5}", , , , "90012345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , , , , , , , , [-1]], [, , "20(?:1\\d{5}|[2-689]\\d{1,7})", , , , "20201234", , , [4, 5, 6, 7, 8, 9, 10]], "LU", 352, "00", , , , "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], , "$CC $1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3",
        ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
        ,
        "$CC $1"
      ], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
        "$1 $2 $3 $4",
        ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],
        ,
        "$CC $1"
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LV: [, [, , "(?:[268]\\d|90)\\d{6}", , , , , , , [8]], [, , "6\\d{7}", , , , "63123456"], [, , "23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}", , , , "21234567"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , "81\\d{6}", , , , "81123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LV", 371, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[269]|8[01]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LY: [
        ,
        [, , "[2-9]\\d{8}", , , , , , , [9], [7]],
        [, , "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}", , , , "212345678", , , , [7]],
        [, , "9[1-6]\\d{7}", , , , "912345678"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "LY",
        218,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MA: [, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}", , , , "520123456"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}", , , , "650123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , "592(?:4[0-2]|93)\\d{4}", , , , "592401234"], "MA", 212, "00", "0", , , "0", , , , [[, "(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29[1289]|389)", "529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], [, "(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], [, "(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MC: [, [, , "(?:[3489]|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "(?:870|9[2-47-9]\\d)\\d{5}", , , , "99123456", , , [8]], [, , "4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}", , , , "612345678"], [, , "(?:800|90\\d)\\d{5}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MC", 377, "00", "0", , , "0", , , , [
        [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["87"]],
        [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"],
        [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]],
        [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]
      ], [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "8[07]0\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MD: [
        ,
        [, , "(?:[235-7]\\d|[89]0)\\d{6}", , , , , , , [8]],
        [, , "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"],
        [, , "562\\d{5}|(?:6\\d|7[16-9])\\d{6}", , , , "62112345"],
        [, , "800\\d{5}", , , , "80012345"],
        [, , "90[056]\\d{5}", , , , "90012345"],
        [, , "808\\d{5}", , , , "80812345"],
        [, , , , , , , , , [-1]],
        [, , "3[08]\\d{6}", , , , "30123456"],
        "MD",
        373,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "803\\d{5}", , , , "80312345"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      ME: [, [, , "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", , , , , , , [8, 9], [6]], [
        ,
        ,
        "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",
        ,
        ,
        ,
        "30234567",
        ,
        ,
        [8],
        [6]
      ], [, , "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", , , , "67622901", , , [8]], [, , "80(?:[0-2578]|9\\d)\\d{5}", , , , "80080002"], [, , "9(?:4[1568]|5[178])\\d{5}", , , , "94515151", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "78[1-49]\\d{5}", , , , "78108780", , , [8]], "ME", 382, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "77[1-9]\\d{5}", , , , "77273012", , , [8]], , , [, , , , , , , , , [-1]]],
      MF: [, [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]], [
        ,
        ,
        "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}",
        ,
        ,
        ,
        "590271234"
      ], [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"], "MF", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MG: [, [, , "[23]\\d{8}", , , , , , , [9], [7]], [, , "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}", , , , "202123456", , , , [7]], [, , "3[2-47-9]\\d{7}", , , , "321234567"], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "22\\d{7}", , , , "221234567"], "MG", 261, "00", "0", , , "([24-9]\\d{6})$|0", "20$1", , , [[, "(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MH: [, [, , "329\\d{4}|(?:[256]\\d|45)\\d{5}", , , , , , , [7]], [, , "(?:247|45[78]|528|625)\\d{4}", , , , "2471234"], [, , "(?:(?:23|54)5|329|45[356])\\d{4}", , , , "2351234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "635\\d{4}",
        ,
        ,
        ,
        "6351234"
      ], "MH", 692, "011", "1", , , "1", , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MK: [, [, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]], [, , "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}", , , , "22012345", , , , [6, 7]], [
        ,
        ,
        "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
        ,
        ,
        ,
        "72345678"
      ], [, , "800\\d{5}", , , , "80012345"], [, , "5\\d{7}", , , , "50012345"], [, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MK", 389, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ML: [, [, , "[24-9]\\d{7}", , , , , , , [8]], [
        ,
        ,
        "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",
        ,
        ,
        ,
        "20212345"
      ], [, , "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}", , , , "65012345"], [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ML", 223, "00", , , , , , , , [[, "(\\d{4})", "$1", ["67[057-9]|74[045]", "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [, , , , , , , , , [-1]], , , [, , "80\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MM: [
        ,
        [, , "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", , , , , , , [6, 7, 8, 9, 10], [5]],
        [
          ,
          ,
          "(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:(?:3\\d|8[01459])\\d|4[67]0)))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
          ,
          ,
          ,
          "1234567",
          ,
          ,
          [6, 7, 8, 9],
          [5]
        ],
        [, , "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", , , , "92123456", , , [7, 8, 9, 10]],
        [, , "80080(?:0[1-9]|2\\d)\\d{3}", , , , "8008001234", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "1333\\d{4}|[12]468\\d{4}", , , , "13331234", , , [8]],
        "MM",
        95,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [
          ,
          "(\\d{2})(\\d{2})(\\d{3})",
          "$1 $2 $3",
          ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], [, "(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], [, "(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]],
        ,
        [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MN: [, [, , "[12]\\d{7,9}|[5-9]\\d{7}", , , , , , , [8, 9, 10], [4, 5, 6]], [, , "[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}", , , , "53123456", , , , [4, 5, 6]], [, , "(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}", , , , "88123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}",
        ,
        ,
        ,
        "75123456",
        ,
        ,
        [8]
      ], "MN", 976, "001", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MO: [, [, , "0800\\d{3}|(?:28|[68]\\d)\\d{6}", , , , , , , [7, 8]], [
        ,
        ,
        "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
        ,
        ,
        ,
        "28212345",
        ,
        ,
        [8]
      ], [, , "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", , , , "66123456", , , [8]], [, , "0800\\d{3}", , , , "0800501", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MO", 853, "00", , , , , , , , [[, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MP: [, [, , "[58]\\d{9}|(?:67|90)0\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
        ,
        ,
        ,
        "6702345678",
        ,
        ,
        ,
        [7]
      ], [, , "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "MP", 1, "011", "1", , , "([2-9]\\d{6})$|1", "670$1", , 1, , , [, , , , , , , , , [-1]], , "670", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MQ: [
        ,
        [, , "596\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
        [, , "596(?:[03-7]\\d|10|2[7-9]|8[0-39]|9[04-9])\\d{4}", , , , "596301234"],
        [, , "69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}", , , , "696201234"],
        [, , "80[0-5]\\d{6}", , , , "800012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:397[0-2]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}", , , , "976612345"],
        "MQ",
        596,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MR: [, [, , "(?:[2-4]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "(?:25[08]|35\\d|45[1-7])\\d{5}", , , , "35123456"], [, , "[2-4][0-46-9]\\d{6}", , , , "22123456"], [, , "800\\d{5}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MR", 222, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[2-48]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MS: [, [, , "(?:[58]\\d\\d|664|900)\\d{7}", , , , , , , [10], [7]], [, , "6644(?:1[0-3]|91)\\d{4}", , , , "6644912345", , , , [7]], [, , "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}", , , , "6644923456", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "MS", 1, "011", "1", , , "([34]\\d{6})$|1", "664$1", , , , , [, , , , , , , , , [-1]], , "664", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MT: [, [, , "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}", , , , "21001234"], [, , "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}", , , , "96961234"], [, , "800(?:02|[3467]\\d)\\d{3}", , , , "80071234"], [
        ,
        ,
        "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
        ,
        ,
        ,
        "50037123"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3550\\d{4}", , , , "35501234"], "MT", 356, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], , [, , "7117\\d{4}", , , , "71171234"], , , [, , , , , , , , , [-1]], [, , "501\\d{5}", , , , "50112345"], , , [, , , , , , , , , [-1]]],
      MU: [, [, , "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", , , , , , , [7, 8, 10]], [, , "(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", , , , "54480123", , , [7, 8]], [
        ,
        ,
        "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-2]|3[013]))\\d{5}",
        ,
        ,
        ,
        "52512345",
        ,
        ,
        [8]
      ], [, , "802\\d{7}|80[0-2]\\d{4}", , , , "8001234", , , [7, 10]], [, , "30\\d{5}", , , , "3012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]], "MU", 230, "0(?:0|[24-7]0|3[03])", , , , , , "020", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], [, "(\\d{5})(\\d{5})", "$1 $2", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MV: [, [, , "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", , , , , , , [7, 10]], [
        ,
        ,
        "(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
        ,
        ,
        ,
        "6701234",
        ,
        ,
        [7]
      ], [, , "(?:46[46]|[79]\\d\\d)\\d{4}", , , , "7712345", , , [7]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MV", 960, "0(?:0|19)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "4(?:0[01]|50)\\d{4}", , , , "4001234", , , [7]], , , [, , , , , , , , , [-1]]],
      MW: [, [, , "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", , , , , , , [7, 9]], [
        ,
        ,
        "(?:1[2-9]|2[12]\\d\\d)\\d{5}",
        ,
        ,
        ,
        "1234567"
      ], [, , "111\\d{6}|(?:31|77|[89][89])\\d{7}", , , , "991234567", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MW", 265, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MX: [
        ,
        [
          ,
          ,
          "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [10, 11],
          [7, 8]
        ],
        [, , "657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}", , , , "2001234567", , , [10], [7, 8]],
        [
          ,
          ,
          "657[12]\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",
          ,
          ,
          ,
          "12221234567",
          ,
          ,
          ,
          [7, 8]
        ],
        [, , "8(?:00|88)\\d{7}", , , , "8001234567", , , [10]],
        [, , "900\\d{7}", , , , "9001234567", , , [10]],
        [, , "300\\d{7}", , , , "3001234567", , , [10]],
        [, , "500\\d{7}", , , , "5001234567", , , [10]],
        [, , , , , , , , , [-1]],
        "MX",
        52,
        "0[09]",
        "01",
        ,
        ,
        "0(?:[12]|4[45])|1",
        ,
        "00",
        ,
        [[, "(\\d{5})", "$1", ["53"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], , , 1], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], , , 1], [
          ,
          "(\\d)(\\d{3})(\\d{3})(\\d{4})",
          "$2 $3 $4",
          ["1"],
          ,
          ,
          1
        ]],
        [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], , , 1], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], , , 1], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], , , 1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MY: [, [, , "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", , , , , , , [8, 9, 10], [6, 7]], [
        ,
        ,
        "(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
        ,
        ,
        ,
        "323856789",
        ,
        ,
        [8, 9],
        [6, 7]
      ], [, , "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", , , , "123456789", , , [9, 10]], [, , "1[378]00\\d{6}", , , , "1300123456", , , [10]], [, , "1600\\d{6}", , , , "1600123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
        ,
        ,
        ,
        "1546012345",
        ,
        ,
        [10]
      ], "MY", 60, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      MZ: [, [, , "(?:2|8\\d)\\d{7}", , , , , , , [8, 9]], [, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]], [, , "8[2-79]\\d{7}", , , , "821234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MZ", 258, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NA: [, [
        ,
        ,
        "[68]\\d{7,8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9]
      ], [, , "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}", , , , "61221234"], [, , "(?:60|8[1245])\\d{7}", , , , "811234567", , , [9]], [, , "80\\d{7}", , , , "800123456", , , [9]], [
        ,
        ,
        "8701\\d{5}",
        ,
        ,
        ,
        "870123456",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8(?:3\\d\\d|86)\\d{5}", , , , "88612345"], "NA", 264, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NC: [, [, , "(?:050|[2-57-9]\\d\\d)\\d{3}", , , , , , , [6]], [, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"], [
        ,
        ,
        "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}",
        ,
        ,
        ,
        "751234"
      ], [, , "050\\d{3}", , , , "050012"], [, , "36\\d{4}", , , , "366711"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NC", 687, "00", , , , , , , , [[, "(\\d{3})", "$1", ["5[6-8]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NE: [, [, , "[027-9]\\d{7}", , , , , , , [8]], [
        ,
        ,
        "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
        ,
        ,
        ,
        "20201234"
      ], [, , "(?:23|7[047]|[89]\\d)\\d{6}", , , , "93123456"], [, , "08\\d{6}", , , , "08123456"], [, , "09\\d{6}", , , , "09123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NE", 227, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NF: [, [, , "[13]\\d{5}", , , , , , , [6], [5]], [, , "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}", , , , "106609", , , , [5]], [
        ,
        ,
        "(?:14|3[58])\\d{4}",
        ,
        ,
        ,
        "381234",
        ,
        ,
        ,
        [5]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NF", 672, "00", , , , "([0-258]\\d{4})$", "3$1", , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], [, "(\\d)(\\d{5})", "$1 $2", ["[13]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NG: [, [, , "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", , , , , , , [7, 8, 10, 11, 12, 13, 14], [5, 6]], [
        ,
        ,
        "(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}",
        ,
        ,
        ,
        "18040123",
        ,
        ,
        [7, 8],
        [5, 6]
      ], [, , "(?:702[0-24-9]|819[01])\\d{6}|(?:70[13-689]|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-356]))\\d{7}", , , , "8021234567", , , [10]], [, , "800\\d{7,11}", , , , "80017591759", , , [10, 11, 12, 13, 14]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NG", 234, "009", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["[7-9]"],
        "0$1"
      ], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "700\\d{7,11}", , , , "7001234567", , , [10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]]],
      NI: [, [, , "(?:1800|[25-8]\\d{3})\\d{4}", , , , , , , [8]], [, , "2\\d{7}", , , , "21234567"], [, , "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}", , , , "81234567"], [, , "1800\\d{4}", , , , "18001234"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NI", 505, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NL: [, [, , "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", , , , , , , [5, 6, 7, 8, 9, 10, 11]], [
        ,
        ,
        "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
        ,
        ,
        ,
        "101234567",
        ,
        ,
        [9]
      ], [, , "(?:6[1-58]|970\\d)\\d{7}", , , , "612345678", , , [9, 11]], [, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]], [, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:85|91)\\d{7}", , , , "851234567", , , [9]], "NL", 31, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["1[238]|[34]"]], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["14"]], [, "(\\d{6})", "$1", ["1"]], [, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{5})",
        "$1 $2 $3",
        ["9"],
        "0$1"
      ]], [, , "66\\d{7}", , , , "662345678", , , [9]], , , [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d", , , , , , , [5, 6]], [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", , , , "14020", , , [5, 6, 9]], , , [, , , , , , , , , [-1]]],
      NO: [, [, , "(?:0|[2-9]\\d{3})\\d{4}", , , , , , , [5, 8]], [, , "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", , , , "21234567", , , [8]], [
        ,
        ,
        "(?:4[015-8]|9\\d)\\d{6}",
        ,
        ,
        ,
        "40612345",
        ,
        ,
        [8]
      ], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "NO", 47, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], , [, , , , , , , , , [-1]], 1, "[02-689]|7[0-8]", [, , , , , , , , , [-1]], [, , "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
        ,
        ,
        "81[23]\\d{5}",
        ,
        ,
        ,
        "81212345",
        ,
        ,
        [8]
      ]],
      NP: [, [, , "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", , , , , , , [8, 10, 11], [6, 7]], [, , "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", , , , "14567890", , , [8], [6, 7]], [, , "9(?:6[0-3]|7[024-6]|8[0-24-68])\\d{7}", , , , "9841234567", , , [10]], [, , "1(?:66001|800\\d\\d)\\d{5}", , , , "16600101234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NP", 977, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [
        ,
        "(\\d{2})(\\d{6})",
        "$1-$2",
        ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],
        "0$1"
      ], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]], [, "(\\d{4})(\\d{2})(\\d{5})", "$1-$2-$3", ["1"]]], [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NR: [, [, , "(?:444|(?:55|8\\d)\\d|666)\\d{4}", , , , , , , [7]], [, , "444\\d{4}", , , , "4441234"], [, , "(?:55[3-9]|666|8\\d\\d)\\d{4}", , , , "5551234"], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NR", 674, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NU: [, [, , "(?:[47]|888\\d)\\d{3}", , , , , , , [4, 7]], [, , "[47]\\d{3}", , , , "7012", , , [4]], [, , "888[4-9]\\d{3}", , , , "8884012", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NU", 683, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      NZ: [
        ,
        [, , "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", , , , , , , [5, 6, 7, 8, 9, 10]],
        [, , "24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", , , , "32345678", , , [8], [7]],
        [, , "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", , , , "211234567", , , [8, 9, 10]],
        [, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456", , , [8, 9, 10]],
        [, , "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", , , , "900123456", , , [7, 8, 9, 10]],
        [, , , , , , , , , [-1]],
        [
          ,
          ,
          "70\\d{7}",
          ,
          ,
          ,
          "701234567",
          ,
          ,
          [9]
        ],
        [, , , , , , , , , [-1]],
        "NZ",
        64,
        "0(?:0|161)",
        "0",
        ,
        ,
        "0",
        ,
        "00",
        ,
        [[, "(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}", , , , "83012378"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      OM: [
        ,
        [, , "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", , , , , , , [7, 8, 9]],
        [, , "2[1-6]\\d{6}", , , , "23123456", , , [8]],
        [, , "1505\\d{4}|(?:7(?:[1289]\\d|6[89]|7[0-5])|9(?:0[1-9]|[1-9]\\d))\\d{5}", , , , "92123456", , , [8]],
        [, , "8007\\d{4,5}|(?:500|800[05])\\d{4}", , , , "80071234"],
        [, , "900\\d{5}", , , , "90012345", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "OM",
        968,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["2"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      PA: [, [, , "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", , , , , , , [7, 8, 10, 11]], [
        ,
        ,
        "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
        ,
        ,
        ,
        "2001234",
        ,
        ,
        [7]
      ], [, , "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", , , , "61234567", , , [7, 8]], [, , "800\\d{4,5}|(?:00800|800\\d)\\d{6}", , , , "8001234"], [, , "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", , , , "8601234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PA", 507, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PE: [, [
        ,
        ,
        "(?:[14-8]|9\\d)\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9],
        [6, 7]
      ], [, , "(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", , , , "11234567", , , [8], [6, 7]], [, , "9\\d{8}", , , , "912345678", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "805\\d{5}", , , , "80512345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , "80[24]\\d{5}", , , , "80212345", , , [8]], [, , , , , , , , , [-1]], "PE", 51, "00|19(?:1[124]|77|90)00", "0", " Anexo ", , "0", , "00", , [[
        ,
        "(\\d{3})(\\d{5})",
        "$1 $2",
        ["80"],
        "(0$1)"
      ], [, "(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PF: [
        ,
        [, , "4\\d{5}(?:\\d{2})?|8\\d{7,8}", , , , , , , [6, 8, 9]],
        [, , "4(?:0[4-689]|9[4-68])\\d{5}", , , , "40412345", , , [8]],
        [, , "8[7-9]\\d{6}", , , , "87123456", , , [8]],
        [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "499\\d{5}", , , , "49901234", , , [8]],
        "PF",
        689,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "44\\d{4}", , , , , , , [6]],
        [, , "44\\d{4}", , , , "440123", , , [6]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      PG: [, [, , "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", , , , , , , [7, 8]], [, , "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", , , , "3123456", , , [7]], [, , "(?:7\\d|8[128])\\d{6}", , , , "70123456", , , [8]], [
        ,
        ,
        "180\\d{4}",
        ,
        ,
        ,
        "1801234",
        ,
        ,
        [7]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "2(?:0[0-57]|7[568])\\d{4}", , , , "2751234", , , [7]], "PG", 675, "00|140[1-3]", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], , [, , "27[01]\\d{4}", , , , "2700123", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PH: [, [, , "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", , , , , , , [6, 8, 9, 10, 11, 12, 13], [4, 5, 7]], [
        ,
        ,
        "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
        ,
        ,
        ,
        "232345678",
        ,
        ,
        [6, 8, 9, 10],
        [4, 5, 7]
      ], [, , "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", , , , "9051234567", , , [10]], [, , "1800\\d{7,9}", , , , "180012345678", , , [11, 12, 13]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PH", 63, "00", "0", , , "0", , , , [[, "(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [
        ,
        "(\\d{4})(\\d{4,6})",
        "$1 $2",
        ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
        "(0$1)"
      ], [, "(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PK: [, [
        ,
        ,
        "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10, 11, 12],
        [5, 6, 7]
      ], [, , "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", , , , "2123456789", , , [9, 10], [5, 6, 7, 8]], [, , "3(?:[0-24]\\d|3[0-79]|55|64)\\d{7}", , , , "3012345678", , , [10]], [, , "800\\d{5}(?:\\d{3})?", , , , "80012345", , , [8, 11]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [
        ,
        ,
        "122\\d{6}",
        ,
        ,
        ,
        "122044444",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], "PK", 92, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["1"]], [
        ,
        "(\\d{3})(\\d{6,7})",
        "$1 $2",
        ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [, "(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
        ,
        ,
        ,
        "21111825888",
        ,
        ,
        [11, 12]
      ], , , [, , , , , , , , , [-1]]],
      PL: [, [, , "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [, , "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", , , , "123456789", , , [7, 9]], [, , "21(?:1(?:[145]\\d|3[1-5])|2\\d\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "70[01346-8]\\d{6}", , , , "701234567", , , [9]], [
        ,
        ,
        "801\\d{6}",
        ,
        ,
        ,
        "801234567",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , "39\\d{7}", , , , "391234567", , , [9]], "PL", 48, "00", , , , , , , , [
        [, "(\\d{5})", "$1", ["19"]],
        [, "(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]],
        [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],
        [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]],
        [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],
        [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]],
        [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]
      ], , [, , "64\\d{4,7}", , , , "641234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]], [, , "804\\d{6}", , , , "804123456", , , [9]], , , [, , , , , , , , , [-1]]],
      PM: [
        ,
        [, , "[45]\\d{5}|(?:708|80\\d)\\d{6}", , , , , , , [6, 9]],
        [, , "(?:4[1-35-7]|5[01])\\d{4}", , , , "430123", , , [6]],
        [, , "(?:4[02-4]|5[056]|708[45][0-5])\\d{4}", , , , "551234"],
        [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "PM",
        508,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      PR: [, [, , "(?:[589]\\d\\d|787)\\d{7}", , , , , , , [10], [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [
        ,
        ,
        "900[2-9]\\d{6}",
        ,
        ,
        ,
        "9002345678"
      ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "PR", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "787|939", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PS: [, [, , "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", , , , , , , [8, 9, 10], [7]], [
        ,
        ,
        "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
        ,
        ,
        ,
        "22234567",
        ,
        ,
        [8],
        [7]
      ], [, , "5[69]\\d{7}", , , , "599123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , , , , , , , , [-1]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PS", 970, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PT: [
        ,
        [, , "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", , , , , , , [9]],
        [, , "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}", , , , "212345678"],
        [, , "6(?:[06]92(?:30|9\\d)|[35]92(?:3[03]|9\\d))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}", , , , "912345678"],
        [, , "80[02]\\d{6}", , , , "800123456"],
        [, , "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}", , , , "760123456"],
        [, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"],
        [, , "884[0-4689]\\d{5}", , , , "884123456"],
        [, , "30\\d{7}", , , , "301234567"],
        "PT",
        351,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[
          ,
          "(\\d{2})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          ["2[12]"]
        ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]],
        ,
        [, , "6222\\d{5}", , , , "622212345"],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}", , , , "707123456"],
        ,
        ,
        [, , "600\\d{6}|6[06]9233\\d{3}", , , , "600110000"]
      ],
      PW: [, [, , "(?:[24-8]\\d\\d|345|900)\\d{4}", , , , , , , [7]], [, , "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}", , , , "2771234"], [, , "(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}", , , , "6201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PW", 680, "01[12]", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PY: [, [, , "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [
        ,
        ,
        "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
        ,
        ,
        ,
        "212345678",
        ,
        ,
        [7, 8, 9],
        [5, 6]
      ], [, , "9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}", , , , "961456789", , , [9]], [, , "9800\\d{5,7}", , , , "98000123456", , , [9, 10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8700[0-4]\\d{4}", , , , "870012345", , , [9]], "PY", 595, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], [
        ,
        "(\\d{2})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[2-9]0\\d{4,7}", , , , "201234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]]],
      QA: [, [, , "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", , , , , , , [7, 8, 9, 11]], [
        ,
        ,
        "4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
        ,
        ,
        ,
        "44123456",
        ,
        ,
        [8]
      ], [, , "[35-7]\\d{7}", , , , "33123456", , , [8]], [, , "800\\d{4}|(?:0080[01]|800)\\d{6}", , , , "8001234", , , [7, 9, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "QA", 974, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], , [, , "2[16]\\d{5}", , , , "2123456", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RE: [, [, , "(?:26|[689]\\d)\\d{7}", , , , , , , [9]], [, , "26(?:2\\d\\d|3(?:0\\d|1[0-5]))\\d{4}", , , , "262161234"], [
        ,
        ,
        "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-27]|8[0-8]|9[0-479]))\\d{4}",
        ,
        ,
        ,
        "692123456"
      ], [, , "80\\d{7}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], [, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}", , , , "939901234"], "RE", 262, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RO: [, [, , "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", , , , , , , [6, 9]], [
        ,
        ,
        "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
        ,
        ,
        ,
        "211234567"
      ], [, , "7020\\d{5}|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-29])\\d{6}", , , , "712034567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[0136]\\d{6}", , , , "900123456", , , [9]], [, , "801\\d{6}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RO", 40, "00", "0", " int ", , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], [, "(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[237-9]"],
        "0$1"
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:37\\d|80[578])\\d{6}", , , , "372123456", , , [9]], , , [, , , , , , , , , [-1]]],
      RS: [, [, , "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", , , , , , , [6, 7, 8, 9, 10, 11, 12], [4, 5]], [, , "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", , , , "10234567", , , [7, 8, 9, 10, 11, 12], [4, 5, 6]], [, , "6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]], [, , "800\\d{3,9}", , , , "80012345"], [
        ,
        ,
        "(?:78\\d|90[0169])\\d{3,7}",
        ,
        ,
        ,
        "90012345",
        ,
        ,
        [6, 7, 8, 9, 10]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RS", 381, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], [, "(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7[06]\\d{4,10}", , , , "700123456"], , , [, , , , , , , , , [-1]]],
      RU: [, [, , "8\\d{13}|[347-9]\\d{9}", , , , , , , [10, 14], [7]], [
        ,
        ,
        "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
        ,
        ,
        ,
        "3011234567",
        ,
        ,
        [10],
        [7]
      ], [, , "9\\d{9}", , , , "9123456789", , , [10]], [, , "8(?:0[04]|108\\d{3})\\d{7}", , , , "8001234567"], [, , "80[39]\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , , , , , , , , [-1]], "RU", 7, "810", "8", , , "8", , "8~10", , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[0-79]"]], [
        ,
        "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],
        "8 ($1)",
        ,
        1
      ], [, "(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2-$3-$4",
        ["[349]|8(?:[02-7]|1[1-8])"],
        "8 ($1)",
        ,
        1
      ], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [[, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", , 1], [
        ,
        "(\\d{5})(\\d)(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
        "8 ($1)",
        ,
        1
      ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", , 1], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [, , , , , , , , , [-1]], 1, "3[04-689]|[489]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RW: [, [, , "(?:06|[27]\\d\\d|[89]00)\\d{6}", , , , , , , [8, 9]], [, , "(?:06|2[23568]\\d)\\d{6}", , , , "250123456"], [, , "7[237-9]\\d{7}", , , , "720123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [
        ,
        ,
        "900\\d{6}",
        ,
        ,
        ,
        "900123456",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RW", 250, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SA: [, [, , "92\\d{7}|(?:[15]|8\\d)\\d{8}", , , , , , , [9, 10], [7]], [, , "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", , , , "112345678", , , [9], [7]], [
        ,
        ,
        "579[01]\\d{5}|5(?:[013-689]\\d|7[0-35-8])\\d{6}",
        ,
        ,
        ,
        "512345678",
        ,
        ,
        [9]
      ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "925\\d{6}", , , , "925012345", , , [9]], [, , "920\\d{6}", , , , "920012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SA", 966, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["9"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "811\\d{7}",
        ,
        ,
        ,
        "8110123456",
        ,
        ,
        [10]
      ], , , [, , , , , , , , , [-1]]],
      SB: [
        ,
        [, , "(?:[1-6]|[7-9]\\d\\d)\\d{4}", , , , , , , [5, 7]],
        [, , "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", , , , "40123", , , [5]],
        [, , "48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}", , , , "7421234"],
        [, , "1[38]\\d{3}", , , , "18123", , , [5]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "5[12]\\d{3}", , , , "51123", , , [5]],
        "SB",
        677,
        "0[01]",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SC: [, [, , "800\\d{4}|(?:[249]\\d|64)\\d{5}", , , , , , , [7]], [, , "4[2-46]\\d{5}", , , , "4217123"], [, , "2[125-8]\\d{5}", , , , "2510123"], [, , "800[08]\\d{3}", , , , "8000000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "971\\d{4}|(?:64|95)\\d{5}", , , , "6412345"], "SC", 248, "010|0[0-2]", , , , , , "00", , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SD: [, [, , "[19]\\d{8}", , , , , , , [9]], [
        ,
        ,
        "1(?:5\\d|8[35-7])\\d{6}",
        ,
        ,
        ,
        "153123456"
      ], [, , "(?:1[0-2]|9[0-3569])\\d{7}", , , , "911231234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SD", 249, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SE: [, [, , "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", , , , , , , [6, 7, 8, 9, 10, 12]], [
        ,
        ,
        "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
        ,
        ,
        ,
        "8123456",
        ,
        ,
        [7, 8, 9]
      ], [, , "7[02369]\\d{7}", , , , "701234567", , , [9]], [, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]], [, , "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", , , , "9001234567", , , [7, 8, 9, 10]], [, , "77[0-7]\\d{6}", , , , "771234567", , , [9]], [, , "75[1-8]\\d{6}", , , , "751234567", , , [9]], [, , , , , , , , , [-1]], "SE", 46, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{2})",
        "$1-$2 $3",
        ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
        "0$1"
      ], [, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1"], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1"], [
        ,
        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
        "$1-$2 $3 $4",
        ["8"],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1"]], [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["9(?:00|39|44|9)"]], [, "(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]], [
        ,
        "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["8"]
      ], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1 $2 $3", ["9(?:00|39|44)"]], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["10|7"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]], [, , "74[02-9]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "10[1-8]\\d{6}", , , , "102345678", , , [9]], , , [, , "(?:25[245]|67[3-68])\\d{9}", , , , "254123456789", , , [12]]],
      SG: [, [, , "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", , , , , , , [8, 10, 11]], [
        ,
        ,
        "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
        ,
        ,
        ,
        "61234567",
        ,
        ,
        [8]
      ], [, , "8(?:08[01]|95[0-2])\\d{4}|(?:8(?:0[1-7]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}", , , , "81234567", , , [8]], [, , "(?:18|8)00\\d{7}", , , , "18001234567", , , [10, 11]], [, , "1900\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[12]\\d|666)\\d{5}", , , , "31234567", , , [8]], "SG", 65, "0[0-3]\\d", , , , , , , , [[, "(\\d{4,5})", "$1", ["1[013-9]|77", "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [
        ,
        "(\\d{4})(\\d{4})(\\d{3})",
        "$1 $2 $3",
        ["7"]
      ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [[, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7000\\d{7}", , , , "70001234567", , , [11]], , , [, , , , , , , , , [-1]]],
      SH: [, [, , "(?:[256]\\d|8)\\d{3}", , , , , , , [4, 5]], [, , "2(?:[0-57-9]\\d|6[4-9])\\d\\d", , , , "22158"], [
        ,
        ,
        "[56]\\d{4}",
        ,
        ,
        ,
        "51234",
        ,
        ,
        [5]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "262\\d\\d", , , , "26212", , , [5]], "SH", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], 1, "[256]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SI: [
        ,
        [, , "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", , , , , , , [5, 6, 7, 8]],
        [, , "(?:[1-357][2-8]|4[24-8])\\d{6}", , , , "12345678", , , [8], [7]],
        [, , "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", , , , "31234567", , , [8]],
        [, , "80\\d{4,6}", , , , "80123456", , , [6, 7, 8]],
        [, , "89[1-3]\\d{2,5}|90\\d{4,6}", , , , "90123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", , , , "59012345", , , [8]],
        "SI",
        386,
        "00|10(?:22|66|88|99)",
        "0",
        ,
        ,
        "0",
        ,
        "00",
        ,
        [[, "(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SJ: [, [, , "0\\d{4}|(?:[489]\\d|79)\\d{6}", , , , , , , [5, 8]], [, , "79\\d{6}", , , , "79123456", , , [8]], [, , "(?:4[015-8]|9\\d)\\d{6}", , , , "41234567", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "SJ", 47, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "79", [, , , , , , , , , [-1]], [, , "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
        ,
        ,
        "81[23]\\d{5}",
        ,
        ,
        ,
        "81212345",
        ,
        ,
        [8]
      ]],
      SK: [
        ,
        [, , "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", , , , , , , [6, 7, 9]],
        [, , "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d", , , , "221234567"],
        [, , "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", , , , "912123456", , , [9]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "9(?:00|[78]\\d)\\d{6}", , , , "900123456", , , [9]],
        [, , "8[5-9]\\d{7}", , , , "850123456", , , [9]],
        [, , , , , , , , , [-1]],
        [, , "6(?:02|5[0-4]|9[0-6])\\d{6}", , , , "690123456", , , [9]],
        "SK",
        421,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [, "(\\d{4})(\\d{3})", "$1 $2", ["909", "9090"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]],
        [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", [
          "[3-5][1-8]1",
          "[3-5][1-8]1[67]"
        ], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]],
        [, , "9090\\d{3}", , , , "9090123", , , [7]],
        ,
        ,
        [, , "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}", , , , , , , [7, 9]],
        [, , "96\\d{7}", , , , "961234567", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SL: [, [, , "(?:[237-9]\\d|66)\\d{6}", , , , , , , [8], [6]], [, , "22[2-4][2-9]\\d{4}", , , , "22221234", , , , [6]], [
        ,
        ,
        "(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}",
        ,
        ,
        ,
        "25123456"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SL", 232, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SM: [, [, , "(?:0549|[5-7]\\d)\\d{6}", , , , , , , [8, 10], [6]], [, , "0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10], [6]], [, , "6[16]\\d{6}", , , , "66661212", , , [8]], [, , , , , , , , , [-1]], [, , "7[178]\\d{6}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "5[158]\\d{6}",
        ,
        ,
        ,
        "58001110",
        ,
        ,
        [8]
      ], "SM", 378, "00", , , , "([89]\\d{5})$", "0549$1", , , [[, "(\\d{6})", "$1", ["[89]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SN: [, [, , "(?:[378]\\d|93)\\d{7}", , , , , , , [9]], [, , "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}", , , , "301012345"], [
        ,
        ,
        "7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}",
        ,
        ,
        ,
        "701234567"
      ], [, , "800\\d{6}", , , , "800123456"], [, , "88[4689]\\d{6}", , , , "884123456"], [, , "81[02468]\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}", , , , "933301234"], "SN", 221, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SO: [, [, , "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", , , , , , , [6, 7, 8, 9]], [
        ,
        ,
        "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
        ,
        ,
        ,
        "4012345",
        ,
        ,
        [6, 7]
      ], [, , "(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", , , , "71123456", , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SO", 252, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], [, "(\\d{6})", "$1", ["[134]"]], [, "(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], [
        ,
        "(\\d)(\\d{7})",
        "$1 $2",
        ["(?:2|90)4|[67]"]
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], [, "(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SR: [, [, , "(?:[2-5]|68|[78]\\d)\\d{5}", , , , , , , [6, 7]], [, , "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}", , , , "211234"], [, , "(?:7[124-7]|8[124-9])\\d{5}", , , , "7412345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "56\\d{4}", , , , "561234", , , [6]], "SR", 597, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})",
        "$1-$2-$3",
        ["56"]
      ], [, "(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SS: [, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1[89]\\d{7}", , , , "181234567"], [, , "(?:12|9[1257-9])\\d{7}", , , , "977123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SS", 211, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      ST: [, [, , "(?:22|9\\d)\\d{5}", , , , , , , [7]], [, , "22\\d{5}", , , , "2221234"], [, , "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}", , , , "9812345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ST", 239, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SV: [, [, , "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", , , , , , , [7, 8, 11]], [
        ,
        ,
        "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
        ,
        ,
        ,
        "21234567",
        ,
        ,
        [8]
      ], [, , "[67]\\d{7}", , , , "70123456", , , [8]], [, , "800\\d{4}(?:\\d{4})?", , , , "8001234", , , [7, 11]], [, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SV", 503, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SX: [
        ,
        [, , "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [
          ,
          ,
          "7215(?:4[2-8]|8[239]|9[056])\\d{4}",
          ,
          ,
          ,
          "7215425678",
          ,
          ,
          ,
          [7]
        ],
        [, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "SX",
        1,
        "011",
        "1",
        ,
        ,
        "(5\\d{6})$|1",
        "721$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "721",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SY: [, [, , "[1-39]\\d{8}|[1-5]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}", , , , "112345678", , , , [6, 7]], [, , "9[1-689]\\d{7}", , , , "944567890", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SY", 963, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["9"],
        "0$1",
        ,
        1
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SZ: [, [, , "0800\\d{4}|(?:[237]\\d|900)\\d{6}", , , , , , , [8, 9]], [, , "[23][2-5]\\d{6}", , , , "22171234", , , [8]], [, , "7[6-9]\\d{6}", , , , "76123456", , , [8]], [, , "0800\\d{4}", , , , "08001234", , , [8]], [, , "900\\d{6}", , , , "900012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70\\d{6}", , , , "70012345", , , [8]], "SZ", 268, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["9"]]], , [, , , , , , , , , [-1]], , , [
        ,
        ,
        "0800\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TA: [, [, , "8\\d{3}", , , , , , , [4]], [, , "8\\d{3}", , , , "8999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TA", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TC: [, [, , "(?:[58]\\d\\d|649|900)\\d{7}", , , , , , , [10], [7]], [, , "649(?:266|712|9(?:4\\d|50))\\d{4}", , , , "6497121234", , , , [7]], [, , "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}", , , , "6492311234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002345678"
      ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "649(?:71[01]|966)\\d{4}", , , , "6497101234", , , , [7]], "TC", 1, "011", "1", , , "([2-479]\\d{6})$|1", "649$1", , , , , [, , , , , , , , , [-1]], , "649", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TD: [, [, , "(?:22|[69]\\d|77)\\d{6}", , , , , , , [8]], [, , "22(?:[37-9]0|5[0-5]|6[89])\\d{4}", , , , "22501234"], [, , "(?:6[0235689]|77|9\\d)\\d{6}", , , , "63012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TD", 235, "00|16", , , , , , "00", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TG: [, [, , "[279]\\d{7}", , , , , , , [8]], [, , "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}", , , , "22212345"], [
        ,
        ,
        "(?:7[019]|9[0-36-9])\\d{6}",
        ,
        ,
        ,
        "90112345"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TG", 228, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TH: [, [, , "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", , , , , , , [8, 9, 10, 13]], [, , "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", , , , "21234567", , , [8]], [, , "671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", , , , "812345678", , , [9]], [
        ,
        ,
        "(?:001800\\d|1800)\\d{6}",
        ,
        ,
        ,
        "1800123456",
        ,
        ,
        [10, 13]
      ], [, , "1900\\d{6}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "6[08]\\d{7}", , , , "601234567", , , [9]], "TH", 66, "00[1-9]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TJ: [, [, , "[0-57-9]\\d{8}", , , , , , , [9], [3, 5, 6, 7]], [
        ,
        ,
        "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:4[046]|74|87))\\d{6}",
        ,
        ,
        ,
        "372123456",
        ,
        ,
        ,
        [3, 5, 6, 7]
      ], [, , "(?:41[18]|81[1-9])\\d{6}|(?:0[0-57-9]|1[017]|2[02]|[34]0|5[05]|7[0178]|8[078]|9\\d)\\d{7}", , , , "917123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TJ", 992, "810", , , , , , "8~10", , [[, "(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[04]|[34]7"]], [, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      TK: [, [, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]], [, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"], [, , "7[2-4]\\d{2,5}", , , , "7290"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TK", 690, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TL: [, [, , "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", , , , , , , [7, 8]], [, , "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", , , , "2112345", , , [7]], [, , "7[2-8]\\d{6}", , , , "77212345", , , [8]], [
        ,
        ,
        "80\\d{5}",
        ,
        ,
        ,
        "8012345",
        ,
        ,
        [7]
      ], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , "70\\d{5}", , , , "7012345", , , [7]], [, , , , , , , , , [-1]], "TL", 670, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TM: [
        ,
        [, , "[1-6]\\d{7}", , , , , , , [8]],
        [, , "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}", , , , "12345678"],
        [, , "6\\d{7}", , , , "66123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "TM",
        993,
        "810",
        "8",
        ,
        ,
        "8",
        ,
        "8~10",
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      TN: [, [, , "[2-57-9]\\d{7}", , , , , , , [8]], [, , "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}", , , , "30010123"], [
        ,
        ,
        "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
        ,
        ,
        ,
        "20123456"
      ], [, , "8010\\d{4}", , , , "80101234"], [, , "88\\d{6}", , , , "88123456"], [, , "8[12]10\\d{4}", , , , "81101234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TN", 216, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TO: [, [, , "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", , , , , , , [5, 7]], [, , "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", , , , "20123", , , [5]], [
        ,
        ,
        "(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
        ,
        ,
        ,
        "7715123",
        ,
        ,
        [7]
      ], [, , "0800\\d{3}", , , , "0800222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "55[0-37-9]\\d{4}", , , , "5510123", , , [7]], "TO", 676, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], [, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TR: [, [, , "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", , , , , , , [7, 10, 12, 13]], [
        ,
        ,
        "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
        ,
        ,
        ,
        "2123456789",
        ,
        ,
        [10]
      ], [, , "56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", , , , "5012345678", , , [10]], [, , "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", , , , "8001234567", , , [10, 12, 13]], [, , "(?:8[89]8|900)\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , "592(?:21[12]|461)\\d{4}", , , , "5922121234", , , [10]], [, , "850\\d{7}", , , , "8500123456", , , [10]], "TR", 90, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d)(\\d{3})", "$1 $2 $3", ["444"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"],
        "0$1",
        ,
        1
      ], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1], [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{6,7})",
        "$1 $2 $3",
        ["80"],
        "0$1",
        ,
        1
      ]], [, , "512\\d{7}", , , , "5123456789", , , [10]], , , [, , "(?:444|811\\d{3})\\d{4}", , , , , , , [7, 10]], [, , "444\\d{4}", , , , "4441444", , , [7]], , , [, , , , , , , , , [-1]]],
      TT: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}", , , , "8682211234", , , , [7]], [, , "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}", , , , "8682911234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002345678"
      ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "TT", 1, "011", "1", , , "([2-46-8]\\d{6})$|1", "868$1", , , , , [, , , , , , , , , [-1]], , "868", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "868619\\d{4}", , , , "8686191234", , , , [7]]],
      TV: [, [
        ,
        ,
        "(?:2|7\\d\\d|90)\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7]
      ], [, , "2[02-9]\\d{3}", , , , "20123", , , [5]], [, , "(?:7[01]\\d|90)\\d{4}", , , , "901234", , , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TV", 688, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2"]], [, "(\\d{2})(\\d{4})", "$1 $2", ["90"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TW: [, [, , "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", , , , , , , [7, 8, 9, 10, 11]], [
        ,
        ,
        "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
        ,
        ,
        ,
        "221234567",
        ,
        ,
        [8, 9]
      ], [, , "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", , , , "912345678", , , [9]], [, , "80[0-79]\\d{6}|800\\d{5}", , , , "800123456", , , [8, 9]], [, , "20(?:[013-9]\\d\\d|2)\\d{4}", , , , "203123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "99\\d{7}", , , , "990123456", , , [9]], [, , "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", , , , "7012345678", , , [10, 11]], "TW", 886, "0(?:0[25-79]|19)", "0", "#", , "0", , , , [[, "(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], [
        ,
        "(\\d)(\\d{3,4})(\\d{4})",
        "$1 $2 $3",
        ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],
        "0$1"
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "50[0-46-9]\\d{6}", , , , "500123456", , , [9]], , , [, , , , , , , , , [-1]]],
      TZ: [, [, , "(?:[25-8]\\d|41|90)\\d{7}", , , , , , , [9]], [, , "2[2-8]\\d{7}", , , , "222345678"], [, , "77[2-9]\\d{6}|(?:6[125-9]|7[13-689])\\d{7}", , , , "621234567"], [, , "80[08]\\d{6}", , , , "800123456"], [
        ,
        ,
        "90\\d{7}",
        ,
        ,
        ,
        "900123456"
      ], [, , "8(?:40|6[01])\\d{6}", , , , "840123456"], [, , , , , , , , , [-1]], [, , "41\\d{7}", , , , "412345678"], "TZ", 255, "00[056]", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["5"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UA: [, [, , "[89]\\d{9}|[3-9]\\d{8}", , , , , , , [9, 10], [5, 6, 7]], [
        ,
        ,
        "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
        ,
        ,
        ,
        "311234567",
        ,
        ,
        [9],
        [5, 6, 7]
      ], [, , "(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}", , , , "501234567", , , [9]], [, , "800[1-8]\\d{5,6}", , , , "800123456"], [, , "900[239]\\d{5,6}", , , , "900212345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "89[1-579]\\d{6}", , , , "891234567", , , [9]], "UA", 380, "00", "0", , , "0", , "0~0", , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], [
        ,
        "(\\d{4})(\\d{5})",
        "$1 $2",
        ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UG: [, [, , "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", , , , , , , [9], [5, 6, 7]], [
        ,
        ,
        "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
        ,
        ,
        ,
        "312345678",
        ,
        ,
        ,
        [5, 6, 7]
      ], [, , "726[01]\\d{5}|7(?:[01578]\\d|20|36|4[0-4]|6[0-5]|9[89])\\d{6}", , , , "712345678"], [, , "800[1-3]\\d{5}", , , , "800123456"], [, , "90[1-3]\\d{6}", , , , "901123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UG", 256, "00[057]", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      US: [, [
        ,
        ,
        "[2-9]\\d{9}|3\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [10],
        [7]
      ], [
        ,
        ,
        "5056(?:[0-35-9]\\d|4[46])\\d{4}|(?:4722|505[2-57-9]|983[29])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
        ,
        ,
        ,
        "2015550123",
        ,
        ,
        ,
        [7]
      ], [
        ,
        ,
        "5056(?:[0-35-9]\\d|4[46])\\d{4}|(?:4722|505[2-57-9]|983[29])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
        ,
        ,
        ,
        "2015550123",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "US", 1, "011", "1", , , "1", , , 1, [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [
        ,
        "(\\d{3})(\\d{4})",
        "$1-$2",
        ["[24-9]|3(?:[02-9]|1[1-9])"]
      ], [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], , , 1]], [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-9]"]]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UY: [, [, , "0004\\d{2,9}|4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11, 12, 13]], [, , "(?:1(?:770|9(?:20|87))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", , , , "21231234", , , [8], [7]], [, , "9[1-9]\\d{6}", , , , "94231234", , , [8]], [
        ,
        ,
        "0004\\d{2,9}|(?:4\\d{5}|80[05])\\d{4}|405\\d{4}",
        ,
        ,
        ,
        "8001234"
      ], [, , "90[0-8]\\d{4}", , , , "9001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UY", 598, "0(?:0|1[3-9]\\d)", "0", " int. ", , "0", , "00", , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], [, "(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UZ: [, [, , "200\\d{6}|(?:33|[5-79]\\d|88)\\d{7}", , , , , , , [9]], [
        ,
        ,
        "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}",
        ,
        ,
        ,
        "669050123"
      ], [
        ,
        ,
        "(?:(?:200[01]|(?:33|50|88|9[0-57-9])\\d\\d)\\d|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
        ,
        ,
        ,
        "912345678"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UZ", 998, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VA: [, [, , "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [, , "06698\\d{1,6}", , , , "0669812345", , , [6, 7, 8, 9, 10, 11]], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [
        ,
        ,
        "80(?:0\\d{3}|3)\\d{3}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [6, 9]
      ], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "VA", 39, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "06698", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
      VC: [
        ,
        [, , "(?:[58]\\d\\d|784|900)\\d{7}", , , , , , , [10], [7]],
        [, , "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", , , , "7842661234", , , , [7]],
        [, , "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}", , , , "7844301234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
        [, , "900[2-9]\\d{6}", , , , "9002345678"],
        [, , , , , , , , , [-1]],
        [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ],
        [, , "78451[0-2]\\d{4}", , , , "7845101234", , , , [7]],
        "VC",
        1,
        "011",
        "1",
        ,
        ,
        "([2-7]\\d{6})$|1",
        "784$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "784",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      VE: [
        ,
        [, , "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", , , , , , , [10], [7]],
        [, , "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}", , , , "2121234567", , , , [7]],
        [, , "4(?:1[24-8]|2[46])\\d{7}", , , , "4121234567"],
        [, , "800\\d{7}", , , , "8001234567"],
        [, , "90[01]\\d{7}", , , , "9001234567"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "VE",
        58,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1", "$CC $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "501\\d{7}", , , , "5010123456", , , , [7]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      VG: [, [, , "(?:284|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}", , , , "2842291234", , , , [7]], [, , "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}", , , , "2843001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [
        ,
        ,
        "900[2-9]\\d{6}",
        ,
        ,
        ,
        "9002345678"
      ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VG", 1, "011", "1", , , "([2-578]\\d{6})$|1", "284$1", , , , , [, , , , , , , , , [-1]], , "284", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VI: [, [, , "[58]\\d{9}|(?:34|90)0\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
        ,
        ,
        ,
        "3406421234",
        ,
        ,
        ,
        [7]
      ], [, , "340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "VI", 1, "011", "1", , , "([2-9]\\d{6})$|1", "340$1", , 1, , , [, , , , , , , , , [-1]], , "340", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VN: [, [, , "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", , , , , , , [7, 8, 9, 10]], [, , "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", , , , "2101234567", , , [10]], [, , "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", , , , "912345678", , , [9]], [
        ,
        ,
        "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
        ,
        ,
        ,
        "1800123456",
        ,
        ,
        [8, 9, 10]
      ], [, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "672\\d{6}", , , , "672012345", , , [9]], "VN", 84, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[17]99"], "0$1", , 1], [, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [
        ,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["2[48]"],
        "0$1",
        ,
        1
      ], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [[, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", , 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "[17]99\\d{4}|69\\d{5,6}", , , , , , , [7, 8]], [
        ,
        ,
        "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
        ,
        ,
        ,
        "1992000",
        ,
        ,
        [7, 8]
      ], , , [, , , , , , , , , [-1]]],
      VU: [
        ,
        [, , "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", , , , , , , [5, 7]],
        [, , "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", , , , "22123", , , [5]],
        [, , "(?:[58]\\d|7[013-7])\\d{5}", , , , "5912345", , , [7]],
        [, , "81[18]\\d\\d", , , , "81123", , , [5]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:0[1-9]|1[01])\\d{4}", , , , "9010123", , , [7]],
        "VU",
        678,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "(?:3[03]|900\\d)\\d{3}", , , , "30123"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      WF: [, [, , "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", , , , , , , [6, 9]], [, , "72\\d{4}", , , , "721234", , , [6]], [, , "(?:72|8[23])\\d{4}", , , , "821234", , , [6]], [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WF", 681, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "[48]0\\d{4}", , , , "401234", , , [6]]],
      WS: [, [
        ,
        ,
        "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7, 10]
      ], [, , "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", , , , "22123", , , [5, 6]], [, , "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", , , , "7212345", , , [7, 10]], [, , "800\\d{3}", , , , "800123", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WS", 685, "0", , , , , , , , [[, "(\\d{5})", "$1", ["[2-5]|6[1-9]"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      XK: [, [, , "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", , , , , , , [
        8,
        9
      ]], [, , "(?:2[89]|39)0\\d{6}|[23][89]\\d{6}", , , , "28012345"], [, , "4[3-9]\\d{6}", , , , "43201234", , , [8]], [, , "800\\d{5}", , , , "80001234", , , [8]], [, , "900\\d{5}", , , , "90001234", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "XK", 383, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      YE: [, [
        ,
        ,
        "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 8, 9],
        [6]
      ], [, , "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", , , , "1234567", , , [7, 8], [6]], [, , "7[01378]\\d{7}", , , , "712345678", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YE", 967, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      YT: [, [
        ,
        ,
        "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9]
      ], [, , "269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}", , , , "269601234"], [, , "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}", , , , "639012345"], [, , "80\\d{7}", , , , "801234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:39|47)8[01]|769\\d)\\d{4}", , , , "939801234"], "YT", 262, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ZA: [, [, , "[1-79]\\d{8}|8\\d{4,9}", , , , , , , [5, 6, 7, 8, 9, 10]], [
        ,
        ,
        "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
        ,
        ,
        ,
        "101234567",
        ,
        ,
        [9]
      ], [, , "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", , , , "711234567", , , [5, 6, 7, 8, 9]], [, , "80\\d{7}", , , , "801234567", , , [9]], [, , "(?:86[2-9]|9[0-2]\\d)\\d{6}", , , , "862345678", , , [9]], [, , "860\\d{6}", , , , "860123456", , , [9]], [, , , , , , , , , [-1]], [
        ,
        ,
        "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
        ,
        ,
        ,
        "871234567",
        ,
        ,
        [9]
      ], "ZA", 27, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "861\\d{6,7}", , , , "861123456", , , [9, 10]], , , [, , , , , , , , , [-1]]],
      ZM: [, [, , "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", , , , , , , [9], [6]], [
        ,
        ,
        "21[1-8]\\d{6}",
        ,
        ,
        ,
        "211234567",
        ,
        ,
        ,
        [6]
      ], [, , "(?:7[5-79]|9[5-8])\\d{7}", , , , "955123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "63\\d{7}", , , , "630123456"], "ZM", 260, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[1-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      ZW: [, [, , "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", , , , , , , [5, 6, 7, 8, 9, 10], [3, 4]], [
        ,
        ,
        "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
        ,
        ,
        ,
        "1312345",
        ,
        ,
        ,
        [3, 4]
      ], [, , "7(?:[178]\\d|3[1-9])\\d{6}", , , , "712345678", , , [9]], [, , "80(?:[01]\\d|20|8[0-8])\\d{3}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", , , , "8686123456", , , [10]], "ZW", 263, "00", "0", , , "0", , , , [
        [, "(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"],
        [, "(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"],
        [, "(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"],
        [, "(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"],
        [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
        [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"],
        [, "(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"],
        [
          ,
          "(\\d{2})(\\d{3,5})",
          "$1 $2",
          ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
          "0$1"
        ],
        [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"],
        [, "(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]
      ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      800: [
        ,
        [, , "(?:00|[1-9]\\d)\\d{6}", , , , , , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "(?:00|[1-9]\\d)\\d{6}", , , , "12345678"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "001",
        800,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        1,
        [[, "(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      808: [, [, , "[1-9]\\d{7}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1-9]\\d{7}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 808, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      870: [, [, , "7\\d{11}|[35-7]\\d{8}", , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}", , , , "301234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], "001", 870, , , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      878: [, [, , "10\\d{10}", , , , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "10\\d{10}", , , , "101234567890"], "001", 878, , , , , , , , 1, [[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      881: [, [, , "[0-36-9]\\d{8}", , , , , , , [9]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , "[0-36-9]\\d{8}", , , , "612345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 881, , , , , , , , , [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      882: [, [, , "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", , , , "3421234", , , [7, 8, 9, 10, 12]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}", , , , "390123456789"], "001", 882, , , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["49"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], [, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], [
        ,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["10|23|3(?:[15]|4[57])|4|51"]
      ], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "348[57]\\d{7}", , , , "34851234567", , , [11]]],
      883: [, [, , "(?:[1-4]\\d|51)\\d{6,10}", , , , , , , [8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
        ,
        ,
        ,
        "510012345"
      ], "001", 883, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      888: [, [, , "\\d{11}", , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 888, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "\\d{11}", , , , "12345678901"], , , [, , , , , , , , , [-1]]],
      979: [, [, , "[1359]\\d{8}", , , , , , , [9], [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1359]\\d{8}", , , , "123456789", , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 979, , , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]]
    };
    function ae() {
      this.g = {};
    }
    ae.g = void 0, ae.h = function() {
      return ae.g ? ae.g : ae.g = new ae();
    };
    var Me = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "０": "0", "１": "1", "２": "2", "３": "3", "４": "4", "５": "5", "６": "6", "７": "7", "８": "8", "９": "9", "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4", "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9", "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4", "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9" }, We = {
      0: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      "+": "+",
      "*": "*",
      "#": "#"
    }, Dt = {
      0: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      "０": "0",
      "１": "1",
      "２": "2",
      "３": "3",
      "４": "4",
      "５": "5",
      "６": "6",
      "７": "7",
      "８": "8",
      "９": "9",
      "٠": "0",
      "١": "1",
      "٢": "2",
      "٣": "3",
      "٤": "4",
      "٥": "5",
      "٦": "6",
      "٧": "7",
      "٨": "8",
      "٩": "9",
      "۰": "0",
      "۱": "1",
      "۲": "2",
      "۳": "3",
      "۴": "4",
      "۵": "5",
      "۶": "6",
      "۷": "7",
      "۸": "8",
      "۹": "9",
      A: "2",
      B: "2",
      C: "2",
      D: "3",
      E: "3",
      F: "3",
      G: "4",
      H: "4",
      I: "4",
      J: "5",
      K: "5",
      L: "5",
      M: "6",
      N: "6",
      O: "6",
      P: "7",
      Q: "7",
      R: "7",
      S: "7",
      T: "8",
      U: "8",
      V: "8",
      W: "9",
      X: "9",
      Y: "9",
      Z: "9"
    }, vt = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/, zt = RegExp("[+＋]+"), Wt = RegExp("^[+＋]+"), $e = RegExp("([0-9０-９٠-٩۰-۹])"), Z = RegExp("[+＋0-9０-９٠-٩۰-۹]"), Ie = /[\\\/] *x/, Re = RegExp("[^0-9０-９٠-٩۰-۹A-Za-z#]+$"), xt = /(?:.*?[A-Za-z]){3}.*/, it = RegExp("^\\+([0-9０-９٠-٩۰-۹]|[\\-\\.\\(\\)]?)*[0-9０-９٠-٩۰-۹]([0-9０-９٠-٩۰-۹]|[\\-\\.\\(\\)]?)*$"), Kt = RegExp("^([A-Za-z0-9０-９٠-٩۰-۹]+((\\-)*[A-Za-z0-9０-９٠-٩۰-۹])*\\.)*[A-Za-z]+((\\-)*[A-Za-z0-9０-９٠-٩۰-۹])*\\.?$");
    function De(b) {
      return "([0-9０-９٠-٩۰-۹]{1," + b + "})";
    }
    function bt() {
      return ";ext=" + De("20") + "|[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.．]?[  \\t,-]*" + (De("20") + "#?|[  \\t,]*(?:[xｘ#＃~～]|int|ｉｎｔ)[:\\.．]?[  \\t,-]*") + (De("9") + "#?|[- ]+") + (De("6") + "#|[  \\t]*(?:,{2}|;)[:\\.．]?[  \\t,-]*") + (De("15") + "#?|[  \\t]*(?:,)+[:\\.．]?[  \\t,-]*") + (De("9") + "#?");
    }
    var Et = new RegExp("(?:" + bt() + ")$", "i"), pt = new RegExp("^[0-9０-９٠-٩۰-۹]{2}$|^[+＋]*(?:[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～*]*[0-9０-９٠-٩۰-۹]){3,}[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～*A-Za-z0-9０-９٠-٩۰-۹]*(?:" + bt() + ")?$", "i"), At = /(\$\d)/, rn = /^\(?\$1\)?$/;
    function Qe(b) {
      return 2 > b.length ? !1 : yi(pt, b);
    }
    function Vt(b) {
      return yi(xt, b) ? mn(b, Dt) : mn(b, Me);
    }
    function Xt(b) {
      var E = Vt(b.toString());
      L(b), b.g(E);
    }
    function fn() {
      return Object.keys(oe).filter(function(b) {
        return isNaN(b);
      });
    }
    function gi() {
      return Object.keys(oe).filter(function(b) {
        return !isNaN(b);
      }).map(function(b) {
        return parseInt(b, 10);
      });
    }
    function pn() {
      var b = Object.keys(K);
      return [...gi(), ...b.map(function(E) {
        return parseInt(E, 10);
      })];
    }
    function mn(b, E) {
      for (var A = new R(), j, U = b.length, J = 0; J < U; ++J) j = b.charAt(J), j = E[j.toUpperCase()], j != null && A.g(j);
      return A.toString();
    }
    function Vi(b) {
      return b.length == 0 || rn.test(b);
    }
    function nn(b) {
      return b != null && isNaN(b) && b.toUpperCase() in oe;
    }
    function gn(b, E, A) {
      if (w(E, 2) == 0 && y(E, 5)) {
        var j = $(E, 5);
        if (0 < j.length) return j;
      }
      j = $(E, 1);
      var U = fa(E);
      return A == 0 ? _h(j, 0, U, "") : j in K ? (b = ha(b, j, pa(j)), E = q3(E, b, A), U = V3(U, b, A), _h(j, A, U, E)) : U;
    }
    function ha(b, E, A) {
      return A == "001" ? vi(b, "" + E) : vi(b, A);
    }
    function w_(b, E) {
      var A = Kr;
      if (!nn(E)) return gn(A, b, 1);
      var j = $(b, 1), U = fa(b);
      if (!(j in K)) return U;
      if (j == 1) {
        if (E != null && K[1].includes(E.toUpperCase())) return j + " " + gn(A, b, 2);
      } else if (j == Yl(A, E)) return gn(A, b, 2);
      var J = vi(A, E), ce = $(J, 11);
      return E = "", y(J, 17) ? E = $(J, 17) : yi(vt, ce) && (E = ce), A = ha(A, j, pa(j)), U = V3(U, A, 1), b = q3(b, A, 1), 0 < E.length ? E + " " + j + " " + U + b : _h(j, 1, U, b);
    }
    function fa(b) {
      if (!y(b, 2)) return "";
      var E = "" + w(b, 2);
      return y(b, 4) && w(b, 4) && 0 < $(b, 8) ? Array($(b, 8) + 1).join("0") + E : E;
    }
    function _h(b, E, A, j) {
      switch (E) {
        case 0:
          return "+" + b + A + j;
        case 1:
          return "+" + b + " " + A + j;
        case 3:
          return "tel:+" + b + "-" + A + j;
        default:
          return A + j;
      }
    }
    function V3(b, E, A) {
      e: {
        E = _(E, 20).length == 0 || A == 2 ? _(E, 19) : _(E, 20);
        for (var j, U = E.length, J = 0; J < U; ++J) {
          j = E[J];
          var ce = x(j, 3);
          if ((ce == 0 || b.search(w(j, 3, ce - 1)) == 0) && (ce = new RegExp(w(j, 1)), yi(ce, b))) {
            E = j;
            break e;
          }
        }
        E = null;
      }
      return E == null || (U = E, E = $(U, 2), j = new RegExp(w(U, 1)), $(U, 5), U = $(U, 4), b = A == 2 && U != null && 0 < U.length ? b.replace(j, E.replace(At, U)) : b.replace(j, E), A == 3 && (b = b.replace(RegExp("^[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]+"), ""), b = b.replace(RegExp("[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]+", "g"), "-"))), A = b, A;
    }
    function U3(b, E) {
      var A = Kr;
      if (!nn(b)) return null;
      E = B3(vi(A, b), E);
      try {
        if (y(E, 6)) {
          var j = w(E, 6);
          return Sh(A, j, b);
        }
      } catch {
      }
      return null;
    }
    function q3(b, E, A) {
      return y(b, 3) && w(b, 3).length != 0 ? A == 3 ? ";ext=" + w(b, 3) : y(E, 13) ? w(E, 13) + $(b, 3) : " ext. " + $(b, 3) : "";
    }
    function B3(b, E) {
      switch (E) {
        case 4:
          return w(b, 5);
        case 3:
          return w(b, 4);
        case 1:
          return w(b, 3);
        case 0:
        case 2:
          return w(b, 2);
        case 5:
          return w(b, 6);
        case 6:
          return w(b, 8);
        case 7:
          return w(b, 7);
        case 8:
          return w(b, 21);
        case 9:
          return w(b, 25);
        case 10:
          return w(b, 28);
        default:
          return w(b, 1);
      }
    }
    function xh(b, E) {
      return vn(b, w(E, 1)) ? vn(b, w(E, 5)) ? 4 : vn(b, w(E, 4)) ? 3 : vn(b, w(E, 6)) ? 5 : vn(b, w(E, 8)) ? 6 : vn(b, w(E, 7)) ? 7 : vn(b, w(E, 21)) ? 8 : vn(b, w(E, 25)) ? 9 : vn(b, w(E, 28)) ? 10 : vn(b, w(E, 2)) ? w(E, 18) || vn(b, w(E, 3)) ? 2 : 0 : !w(E, 18) && vn(b, w(E, 3)) ? 1 : -1 : -1;
    }
    function vi(b, E) {
      if (E == null) return null;
      E = E.toUpperCase();
      var A = b.g[E];
      if (A == null) {
        if (A = oe[E], A == null) return null;
        A = new D().g(H.o(), A), b.g[E] = A;
      }
      return A;
    }
    function vn(b, E) {
      var A = b.length;
      return 0 < x(E, 9) && _(E, 9).indexOf(A) == -1 ? !1 : yi($(E, 2), b);
    }
    function H3(b) {
      var E = Kr, A = uu(E, b), j = $(b, 1), U = ha(E, j, A);
      return U == null || A != "001" && j != Yl(E, A) ? U = !1 : (b = fa(b), U = xh(b, U) != -1), U;
    }
    function uu(b, E) {
      if (E == null) return null;
      var A = $(E, 1);
      if (A = K[A], A == null) b = null;
      else if (A.length == 1) b = A[0];
      else e: {
        E = fa(E);
        for (var j, U = A.length, J = 0; J < U; J++) {
          j = A[J];
          var ce = vi(b, j);
          if (y(ce, 23)) {
            if (E.search(w(ce, 23)) == 0) {
              b = j;
              break e;
            }
          } else if (xh(E, ce) != -1) {
            b = j;
            break e;
          }
        }
        b = null;
      }
      return b;
    }
    function pa(b) {
      return b = K[b], b == null ? "ZZ" : b[0];
    }
    function Yl(b, E) {
      if (b = vi(b, E), b == null) throw Error("Invalid region code: " + E);
      return $(b, 10);
    }
    function W3(b) {
      return b = K3(b), b == 0 || b == 4;
    }
    function Eh(b, E, A, j) {
      var U = B3(A, j), J = x(U, 9) == 0 ? _(w(A, 1), 9) : _(U, 9);
      return U = _(U, 10), J[0] == -1 ? 5 : (E = E.length, -1 < U.indexOf(E) ? 4 : (A = J[0], A == E ? 0 : A > E ? 2 : J[J.length - 1] < E ? 3 : -1 < J.indexOf(E, 1) ? 0 : 5));
    }
    function K3(b) {
      var E = Kr, A = fa(b);
      return b = $(b, 1), b in K ? (b = ha(E, b, pa(b)), Eh(E, A, b, -1)) : 1;
    }
    function Q3(b, E) {
      if (b = b.toString(), b.length == 0 || b.charAt(0) == "0") return 0;
      for (var A, j = b.length, U = 1; 3 >= U && U <= j; ++U) if (A = parseInt(b.substring(0, U), 10), A in K) return E.g(b.substring(U)), A;
      return 0;
    }
    function G3(b, E, A, j, U) {
      if (E.length == 0) return 0;
      E = new R(E);
      var J;
      A != null && (J = w(A, 11)), J == null && (J = "NonMatch");
      var ce = E.toString();
      if (ce.length == 0) J = 20;
      else if (Wt.test(ce)) ce = ce.replace(Wt, ""), L(E), E.g(Vt(ce)), J = 1;
      else {
        if (ce = new RegExp(J), Xt(E), J = E.toString(), J.search(ce) == 0) {
          ce = J.match(ce)[0].length;
          var nt = J.substring(ce).match($e);
          nt && nt[1] != null && 0 < nt[1].length && mn(nt[1], Me) == "0" ? J = !1 : (L(E), E.g(J.substring(ce)), J = !0);
        } else J = !1;
        J = J ? 5 : 20;
      }
      if (J != 20) {
        if (2 >= E.h.length) throw Error("Phone number too short after IDD");
        if (b = Q3(
          E,
          j
        ), b != 0) return S(U, 1, b), b;
        throw Error("Invalid country calling code");
      }
      return A != null && (J = $(A, 10), ce = "" + J, nt = E.toString(), nt.lastIndexOf(ce, 0) == 0 && (ce = new R(nt.substring(ce.length)), nt = w(A, 1), nt = new RegExp($(nt, 2)), Y3(ce, A, null), ce = ce.toString(), !yi(nt, E.toString()) && yi(nt, ce) || Eh(b, E.toString(), A, -1) == 3)) ? (j.g(ce), S(U, 1, J), J) : (S(U, 1, 0), 0);
    }
    function Y3(b, E, A) {
      var j = b.toString(), U = j.length, J = w(E, 15);
      if (U != 0 && J != null && J.length != 0) {
        var ce = new RegExp("^(?:" + J + ")");
        if (U = ce.exec(j)) {
          J = new RegExp($(w(E, 1), 2));
          var nt = yi(J, j), vr = U.length - 1;
          E = w(E, 16), E == null || E.length == 0 || U[vr] == null || U[vr].length == 0 ? (!nt || yi(J, j.substring(U[0].length))) && (A != null && 0 < vr && U[vr] != null && A.g(U[1]), b.set(j.substring(U[0].length))) : (j = j.replace(ce, E), (!nt || yi(J, j)) && (A != null && 0 < vr && A.g(U[1]), b.set(j)));
        }
      }
    }
    function Sh(b, E, A) {
      if (E == null) throw Error("The string supplied did not seem to be a phone number");
      if (250 < E.length) throw Error("The string supplied is too long to be a phone number");
      var j = new R(), U = E.indexOf(";phone-context=");
      if (U === -1) U = null;
      else if (U += 15, U >= E.length) U = "";
      else {
        var J = E.indexOf(";", U);
        U = J !== -1 ? E.substring(U, J) : E.substring(U);
      }
      var ce = U;
      if (ce == null ? J = !0 : ce.length === 0 ? J = !1 : (J = it.exec(ce), ce = Kt.exec(ce), J = J !== null || ce !== null), !J || (U != null ? (U.charAt(0) === "+" && j.g(U), U = E.indexOf("tel:"), j.g(E.substring(0 <= U ? U + 4 : 0, E.indexOf(";phone-context=")))) : (U = j.g, E = E ?? "", J = E.search(Z), 0 <= J ? (E = E.substring(J), E = E.replace(Re, ""), J = E.search(Ie), 0 <= J && (E = E.substring(0, J))) : E = "", U.call(j, E)), E = j.toString(), U = E.indexOf(";isub="), 0 < U && (L(j), j.g(E.substring(0, U))), !Qe(j.toString()))) throw Error("The string supplied did not seem to be a phone number");
      if (E = j.toString(), !(nn(A) || E != null && 0 < E.length && Wt.test(E))) throw Error("Invalid country calling code");
      E = new Te();
      e: {
        if (U = j.toString(), J = U.search(Et), 0 <= J && Qe(U.substring(0, J))) {
          ce = U.match(Et);
          for (var nt = ce.length, vr = 1; vr < nt; ++vr) if (ce[vr] != null && 0 < ce[vr].length) {
            L(j), j.g(U.substring(0, J)), U = ce[vr];
            break e;
          }
        }
        U = "";
      }
      0 < U.length && S(E, 3, U), J = vi(b, A), U = new R(), ce = 0, nt = j.toString();
      try {
        ce = G3(b, nt, J, U, E);
      } catch (ds) {
        if (ds.message == "Invalid country calling code" && Wt.test(nt)) {
          if (nt = nt.replace(Wt, ""), ce = G3(b, nt, J, U, E), ce == 0) throw ds;
        } else throw ds;
      }
      if (ce != 0 ? (j = pa(ce), j != A && (J = ha(b, ce, j))) : (Xt(j), U.g(j.toString()), A != null && (ce = $(J, 10), S(E, 1, ce))), 2 > U.h.length || (J != null && (A = new R(U.toString()), Y3(A, J, new R()), b = Eh(b, A.toString(), J, -1), b != 2 && b != 4 && b != 5 && (U = A)), b = U.toString(), A = b.length, 2 > A)) throw Error("The string supplied is too short to be a phone number");
      if (17 < A) throw Error("The string supplied is too long to be a phone number");
      if (1 < b.length && b.charAt(0) == "0") {
        for (S(E, 4, !0), A = 1; A < b.length - 1 && b.charAt(A) == "0"; ) A++;
        A != 1 && S(E, 8, A);
      }
      return S(E, 2, parseInt(b, 10)), E;
    }
    ae.prototype.ja = function(b) {
      var E = vi(this, uu(this, b));
      return E == null ? !0 : (b = fa(b), !vn(b, w(E, 24)));
    };
    function yi(b, E) {
      return !!((b = typeof b == "string" ? E.match("^(?:" + b + ")$") : E.match(b)) && b[0].length == E.length);
    }
    function $_(b) {
      this.ka = RegExp(" "), this.la = "", this.$ = new R(), this.da = "", this.u = new R(), this.ba = new R(), this.v = !0, this.ea = this.ca = this.oa = !1, this.pa = ae.h(), this.aa = 0, this.h = new R(), this.ha = !1, this.s = "", this.g = new R(), this.j = [], this.ma = b, this.wa = this.m = Ch(this, this.ma);
    }
    var J3 = new H();
    S(J3, 11, "NA");
    var k_ = RegExp("^[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*\\$1[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*(\\$\\d[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*)*$"), Z3 = /[- ]/;
    function Ch(b, E) {
      return E = nn(E) ? Yl(b.pa, E) : 0, b = vi(b.pa, pa(E)), b ?? J3;
    }
    function X3(b) {
      for (var E = b.j.length, A = 0; A < E; ++A) {
        var j = b.j[A], U = $(j, 1);
        if (b.da == U) return !1;
        var J = b, ce = j, nt = $(ce, 1);
        L(J.$);
        var vr = J;
        ce = $(ce, 2);
        var ds = "999999999999999".match(nt)[0];
        if (ds.length < vr.g.h.length ? vr = "" : (vr = ds.replace(new RegExp(nt, "g"), ce), vr = vr.replace(RegExp("9", "g"), " ")), 0 < vr.length ? (J.$.g(vr), J = !0) : J = !1, J) return b.da = U, b.ha = Z3.test(w(j, 4)), b.aa = 0, !0;
      }
      return b.v = !1;
    }
    function eg(b, E) {
      for (var A = [], j = E.length - 3, U = b.j.length, J = 0; J < U; ++J) {
        var ce = b.j[J];
        x(ce, 3) == 0 ? A.push(b.j[J]) : (ce = w(ce, 3, Math.min(j, x(ce, 3) - 1)), E.search(ce) == 0 && A.push(b.j[J]));
      }
      b.j = A;
    }
    function __(b, E) {
      b.u.g(E);
      var A = E;
      if ($e.test(A) || b.u.h.length == 1 && zt.test(A) ? (E == "+" ? (A = E, b.ba.g(E)) : (A = Me[E], b.ba.g(A), b.g.g(A)), E = A) : (b.v = !1, b.oa = !0), !b.v) {
        if (!b.oa) {
          if (ag(b)) {
            if (og(b)) return tg(b);
          } else if (0 < b.s.length && (E = b.g.toString(), L(b.g), b.g.g(b.s), b.g.g(E), E = b.h.toString(), A = E.lastIndexOf(b.s), L(b.h), b.h.g(E.substring(0, A))), b.s != ig(b)) return b.h.g(" "), tg(b);
        }
        return b.u.toString();
      }
      switch (b.ba.h.length) {
        case 0:
        case 1:
        case 2:
          return b.u.toString();
        case 3:
          if (ag(b)) b.ea = !0;
          else return b.s = ig(b), Th(b);
        default:
          return b.ea ? (og(b) && (b.ea = !1), b.h.toString() + b.g.toString()) : 0 < b.j.length ? (E = sg(b, E), A = rg(b), 0 < A.length ? A : (eg(b, b.g.toString()), X3(b) ? ng(b) : b.v ? hu(b, E) : b.u.toString())) : Th(b);
      }
    }
    function tg(b) {
      return b.v = !0, b.ea = !1, b.j = [], b.aa = 0, L(b.$), b.da = "", Th(b);
    }
    function rg(b) {
      for (var E = b.g.toString(), A = b.j.length, j = 0; j < A; ++j) {
        var U = b.j[j], J = $(U, 1);
        if (new RegExp("^(?:" + J + ")$").test(E) && (b.ha = Z3.test(w(U, 4)), U = E.replace(new RegExp(J, "g"), w(U, 2)), U = hu(b, U), mn(U, We) == b.ba)) return U;
      }
      return "";
    }
    function hu(b, E) {
      var A = b.h.h.length;
      return b.ha && 0 < A && b.h.toString().charAt(A - 1) != " " ? b.h + " " + E : b.h + E;
    }
    function Th(b) {
      var E = b.g.toString();
      if (3 <= E.length) {
        for (var A = b.ca && b.s.length == 0 && 0 < x(b.m, 20) ? _(b.m, 20) : _(b.m, 19), j = A.length, U = 0; U < j; ++U) {
          var J = A[U];
          0 < b.s.length && Vi($(J, 4)) && !w(J, 6) && !y(J, 5) || (b.s.length != 0 || b.ca || Vi($(J, 4)) || w(J, 6)) && k_.test($(J, 2)) && b.j.push(J);
        }
        return eg(b, E), E = rg(b), 0 < E.length ? E : X3(b) ? ng(b) : b.u.toString();
      }
      return hu(b, E);
    }
    function ng(b) {
      var E = b.g.toString(), A = E.length;
      if (0 < A) {
        for (var j = "", U = 0; U < A; U++) j = sg(b, E.charAt(U));
        return b.v ? hu(b, j) : b.u.toString();
      }
      return b.h.toString();
    }
    function ig(b) {
      var E = b.g.toString(), A = 0;
      if (b.m.ia() != 1) var j = !1;
      else j = b.g.toString(), j = j.charAt(0) == "1" && j.charAt(1) != "0" && j.charAt(1) != "1";
      return j ? (A = 1, b.h.g("1").g(" "), b.ca = !0) : y(b.m, 15) && (j = new RegExp("^(?:" + w(b.m, 15) + ")"), j = E.match(j), j != null && j[0] != null && 0 < j[0].length && (b.ca = !0, A = j[0].length, b.h.g(E.substring(0, A)))), L(b.g), b.g.g(E.substring(A)), E.substring(0, A);
    }
    function ag(b) {
      var E = b.ba.toString(), A = new RegExp("^(?:\\+|" + w(b.m, 11) + ")");
      return A = E.match(A), A != null && A[0] != null && 0 < A[0].length ? (b.ca = !0, A = A[0].length, L(b.g), b.g.g(E.substring(A)), L(b.h), b.h.g(E.substring(0, A)), E.charAt(0) != "+" && b.h.g(" "), !0) : !1;
    }
    function og(b) {
      if (b.g.h.length == 0) return !1;
      var E = new R(), A = Q3(b.g, E);
      return A == 0 ? !1 : (L(b.g), b.g.g(E.toString()), E = pa(A), E == "001" ? b.m = vi(b.pa, "" + A) : E != b.ma && (b.m = Ch(b, E)), b.h.g("" + A).g(" "), b.s = "", !0);
    }
    function sg(b, E) {
      var A = b.$.toString();
      if (0 <= A.substring(b.aa).search(b.ka)) {
        var j = A.search(b.ka);
        return E = A.replace(b.ka, E), L(b.$), b.$.g(E), b.aa = j, E.substring(0, b.aa + 1);
      }
      return b.j.length == 1 && (b.v = !1), b.da = "", b.u.toString();
    }
    var Kr = ae.h();
    function x_(b) {
      var E = Kr, A = uu(E, b);
      switch (E = ha(E, $(b, 1), A), E == null ? b = -1 : (b = fa(b), b = xh(b, E)), b) {
        case 0:
          return "fixed-line";
        case 2:
          return "fixed-line-or-mobile";
        case 1:
          return "mobile";
        case 8:
          return "pager";
        case 7:
          return "personal-number";
        case 4:
          return "premium-rate";
        case 5:
          return "shared-cost";
        case 3:
          return "toll-free";
        case 9:
          return "uan";
        case 6:
          return "voip";
        default:
        case -1:
          return "unknown";
      }
    }
    function E_(b) {
      switch (b) {
        case "fixed-line":
          return 0;
        case "fixed-line-or-mobile":
          return 2;
        case "mobile":
          return 1;
        case "pager":
          return 8;
        case "personal-number":
          return 7;
        case "premium-rate":
          return 4;
        case "shared-cost":
          return 5;
        case "toll-free":
          return 3;
        case "uan":
          return 9;
        case "voip":
          return 6;
        default:
        case "unknown":
          return -1;
      }
    }
    function lg(b) {
      try {
        switch (K3(b)) {
          case 0:
            return "is-possible";
          case 1:
            return "invalid-country-code";
          case 3:
            return "too-long";
          case 2:
            return "too-short";
        }
        if (W3(b)) return "is-possible";
      } catch {
      }
      return "unknown";
    }
    function S_(b, E) {
      if (b.charAt(0) !== "+" && b.slice(0, 2) !== "00") return { parsed: A, fa: j };
      try {
        var A = Sh(Kr, b, E);
      } catch {
      }
      if (A) {
        var j = uu(Kr, A);
        if (j != null && j !== "ZZ") return { parsed: A, fa: j };
      }
      for (E = 1; 4 > E; ++E) {
        if (j = void 0, b.length < E + 1) return { parsed: A, fa: j };
        if (j = pa(b.substring(1, E + 1)), j !== "ZZ") return { fa: j };
      }
      return { parsed: A, fa: void 0 };
    }
    var Ah;
    e: {
      try {
        Ah = /* @__PURE__ */ new WeakMap();
        break e;
      } catch {
      }
      Ah = void 0;
    }
    var fu = Ah;
    function ze(b, E) {
      if (!(this instanceof ze)) return new ze(b, E);
      var A = E?.regionCode;
      if (typeof b == "string") var j = !1;
      else try {
        H3(b), j = !0;
      } catch {
        j = !1;
      }
      let U;
      if (!j && typeof b != "string") throw Error("Invalid phone number, expected a string");
      if (!j && typeof E != "object" && typeof E < "u") throw Error(`Invalid options, expected object, got ${typeof E}. This may be because of not yet upgraded code.`);
      if (!j && A != null && typeof A != "string") throw Error(`Invalid region code, expected a string, got ${typeof A} ${A}`);
      if (j || (b = b.trim(), A && b.charAt(0) === "+" && (A = null), A && b.charAt(0) !== "+" && b.slice(0, 2) !== "00" || ({ fa: A = null, parsed: U } = S_(b, A))), this.g = { number: {}, regionCode: A, valid: !1, possible: !1 }, fu && fu.set(this.g, this), j) this.l = b;
      else {
        if (this.l = null, this.g.number.input = b, !A) {
          this.g.possibility = "invalid-country-code";
          return;
        }
        if (Oh(A) === 0) {
          this.g.possibility = "invalid-country-code";
          return;
        }
        try {
          this.l = U || Sh(Kr, b, A);
        } catch {
          this.g.possibility = lg(b);
          return;
        }
      }
      this.g.number.international = gn(Kr, this.l, 1), this.g.number.national = gn(Kr, this.l, 2), this.g.number.e164 = gn(Kr, this.l, 0), this.g.number.rfc3966 = gn(Kr, this.l, 3), this.g.number.significant = fa(this.l), this.g.canBeInternationallyDialled = Kr.ja(this.l), this.g.valid = H3(this.l), this.g.possible = W3(this.l), this.g.possibility = lg(this.l), !this.g.valid && this.g.possible && (this.g.possibility = "invalid", this.g.possible = !1), this.g.type = x_(this.l), this.g.typeIsMobile = this.sa(), this.g.typeIsFixedLine = this.ra(), this.g.countryCode = nn(A) ? Yl(Kr, A) : 0;
    }
    var Jl = ["PhoneNumber$$module$src$index"], bi = t;
    Jl[0] in bi || typeof bi.execScript > "u" || bi.execScript("var " + Jl[0]);
    for (var oo; Jl.length && (oo = Jl.shift()); ) Jl.length || ze === void 0 ? bi[oo] && bi[oo] !== Object.prototype[oo] ? bi = bi[oo] : bi = bi[oo] = {} : bi[oo] = ze;
    function Oh(b) {
      return nn(b) ? Yl(Kr, b) : 0;
    }
    ze.getCountryCodeForRegionCode = Oh, ze.getRegionCodeForCountryCode = function(b) {
      return pa(b);
    };
    function dg(b) {
      var E = {};
      return b.filter((A) => E.hasOwnProperty(A) ? !1 : (E[A] = 1, !0));
    }
    ze.getSupportedRegionCodes = function() {
      return dg(fn());
    }, ze.getSupportedCallingCodes = function() {
      return dg(pn());
    }, ze.getExample = function(b, E) {
      var A;
      return E ? A = U3(b, E_(E)) : A = U3(b, 0), new ze(A, b).toJSON();
    }, ze.getAsYouType = function(b) {
      return new jr(b);
    }, ze.getNumberFrom = function(b, E) {
      try {
        e: {
          if (fu) {
            var A = fu.get(b);
            if (A) {
              var j = A;
              break e;
            }
          }
          let U;
          j = new ze(b == null || (U = b.number) == null ? void 0 : U.e164, {});
        }
        return { valid: !0, number: w_(j.l, E) };
      } catch (U) {
        return { valid: !1, error: U };
      }
    }, ze.prototype.toJSON = function() {
      return this.g;
    }, ze.prototype.toJSON = ze.prototype.toJSON, ze.prototype.ja = function() {
      return this.g.canBeInternationallyDialled;
    }, ze.prototype.canBeInternationallyDialled = ze.prototype.ja, ze.prototype.ya = function() {
      return this.g.valid;
    }, ze.prototype.isValid = ze.prototype.ya, ze.prototype.xa = function() {
      return this.g.possible;
    }, ze.prototype.isPossible = ze.prototype.xa, ze.prototype.getType = function() {
      return this.g.type;
    }, ze.prototype.getType = ze.prototype.getType, ze.prototype.sa = function() {
      return this.g.type === "mobile" || this.g.type === "fixed-line-or-mobile";
    }, ze.prototype.isMobile = ze.prototype.sa, ze.prototype.ra = function() {
      return this.g.type === "fixed-line" || this.g.type === "fixed-line-or-mobile";
    }, ze.prototype.isFixedLine = ze.prototype.ra, ze.prototype.ta = function(b) {
      return this.g.number[b ?? "e164"];
    }, ze.prototype.getNumber = ze.prototype.ta, ze.prototype.va = function() {
      return this.g.regionCode;
    }, ze.prototype.getRegionCode = ze.prototype.va, ze.prototype.ia = function() {
      return Oh(this.g.regionCode);
    }, ze.prototype.getCountryCode = ze.prototype.ia;
    function jr(b) {
      this.j = b, this.h = new $_(b), this.l = this.g = "";
    }
    jr.prototype.qa = function(b) {
      this.g += b;
      var E = this.h;
      return E.la = __(E, b), this.l = E.la;
    }, jr.prototype.addChar = jr.prototype.qa, jr.prototype.za = function() {
      return this.l;
    }, jr.prototype.number = jr.prototype.za, jr.prototype.Aa = function() {
      return this.g === "" ? this.l : this.reset(this.g.slice(0, this.g.length - 1));
    }, jr.prototype.removeChar = jr.prototype.Aa, jr.prototype.reset = function(b) {
      var E = this.h;
      if (E.la = "", L(E.u), L(E.ba), L(E.$), E.aa = 0, E.da = "", L(E.h), E.s = "", L(E.g), E.v = !0, E.oa = !1, E.ca = !1, E.ea = !1, E.j = [], E.ha = !1, E.m != E.wa && (E.m = Ch(E, E.ma)), this.l = this.g = "", b) {
        E = 0;
        for (var A = b.length; E < A; ++E) this.qa(b.charAt(E));
      }
      return this.l;
    }, jr.prototype.reset = jr.prototype.reset, jr.prototype.ua = function() {
      return new ze(this.l, { regionCode: this.j }).toJSON();
    }, jr.prototype.getPhoneNumber = jr.prototype.ua;
  }).call(
    e.exports || typeof globalThis < "u" && globalThis || typeof nl < "u" && nl || typeof window < "u" && window || typeof self < "u" && self || nl
  );
})(z$);
var hte = z$.exports;
h3.exports;
(function(e) {
  const t = "PhoneNumber$$module$src$index";
  e.exports = hte[t] || (typeof globalThis < "u" && globalThis || typeof nl < "u" && nl || typeof window < "u" && window || typeof self < "u" && self || nl)[t], Object.defineProperty(
    e.exports,
    "__esModule",
    {
      value: !0
    }
  ), e.exports.parsePhoneNumber = (...r) => {
    try {
      const n = e.exports(...r).toJSON();
      return !n.valid && !n.possible && (n.possible = !1, n.possibility || (n.possibility = "invalid")), n;
    } catch (n) {
      return {
        valid: !1,
        possible: !1,
        possibility: "invalid",
        error: n
      };
    }
  }, e.exports.getCountryCodeForRegionCode = e.exports.getCountryCodeForRegionCode, e.exports.getRegionCodeForCountryCode = e.exports.getRegionCodeForCountryCode, e.exports.getSupportedCallingCodes = e.exports.getSupportedCallingCodes, e.exports.getSupportedRegionCodes = e.exports.getSupportedRegionCodes, e.exports.getExample = e.exports.getExample, e.exports.getAsYouType = e.exports.getAsYouType, e.exports.getNumberFrom = e.exports.getNumberFrom;
})(h3);
var fte = h3.exports, V$ = /* @__PURE__ */ ute(fte);
const {
  PhoneNumber: U0e,
  AsYouType: q0e,
  getCountryCodeForRegionCode: B0e,
  getRegionCodeForCountryCode: H0e,
  getSupportedCallingCodes: W0e,
  getSupportedRegionCodes: K0e,
  getExample: Q0e,
  getAsYouType: G0e,
  getNumberFrom: Y0e
} = V$, pte = (...e) => {
  try {
    const t = V$(...e).toJSON();
    return !t.valid && !t.possible && (t.possible = !1, t.possibility || (t.possibility = "invalid")), t;
  } catch (t) {
    return {
      valid: !1,
      possible: !1,
      possibility: "invalid",
      error: t
    };
  }
};
var mte = /* @__PURE__ */ k('<tr><td class="align-top py-1 w-20"></td><td class="align-top py-1">'), gte = /* @__PURE__ */ k('<div class="flex items-center justify-between">'), Yf = /* @__PURE__ */ k("<div>"), vte = /* @__PURE__ */ k('<div class="sm:grid sm:grid-cols-2 sm:gap-2"><table class=table-auto><tbody></tbody></table><table class=table-auto><tbody>'), yte = /* @__PURE__ */ k("<div class=pt-2 data-dd-privacy=mask>"), bte = /* @__PURE__ */ k("<div>N/A");
const wte = je`
  query GetPatient($id: ID!) {
    patient(id: $id) {
      id
      name {
        full
      }
      email
      phone
      sex
      gender
      dateOfBirth
      address {
        id
        street1
        street2
        city
        state
        postalCode
      }
    }
  }
`, go = (e) => (() => {
  var t = mte(), r = t.firstChild, n = r.nextSibling;
  return C(r, v(ke, {
    size: "sm",
    color: "gray",
    get children() {
      return e.label;
    }
  })), C(n, () => e.children), t;
})();
function $te(e) {
  const t = jn(), [r, n] = z(void 0), i = async () => {
    const {
      data: s
    } = await t.apollo.query({
      query: wte,
      variables: {
        id: e.patientId
      }
    });
    s?.patient && n(s?.patient);
  };
  le(() => {
    e.patientId && i();
  });
  const a = B(() => e.address || r()?.address), o = B(() => {
    if (r()?.phone) {
      const s = pte(r()?.phone);
      return s.valid ? s.number.national : r()?.phone;
    }
    return "";
  });
  return v(Sn, {
    addChildrenDivider: !0,
    get children() {
      return [(() => {
        var s = gte();
        return C(s, v(ke, {
          color: "gray",
          children: "Patient Info"
        }), null), C(s, v(q, {
          get when() {
            return e?.editPatient;
          },
          get children() {
            return v(ct, {
              variant: "secondary",
              size: "sm",
              get onClick() {
                return e?.editPatient;
              },
              children: "Edit patient"
            });
          }
        }), null), s;
      })(), (() => {
        var s = yte();
        return C(s, v(ke, {
          size: "lg",
          bold: !0,
          get loading() {
            return !r();
          },
          sampleLoadingText: "Sally Patient",
          get children() {
            return r()?.name.full || "N/A";
          }
        }), null), C(s, v(AY, {
          openLabel: "Show less",
          closedLabel: "Show more",
          class: "sm:block",
          buttonClass: "mt-2 sm:hidden",
          get children() {
            var l = vte(), d = l.firstChild, c = d.firstChild, u = d.nextSibling, h = u.firstChild;
            return C(c, v(go, {
              label: "Email",
              get children() {
                return v(ke, {
                  size: "sm",
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "fake@email.com",
                  get children() {
                    return r()?.email || "N/A";
                  }
                });
              }
            }), null), C(c, v(go, {
              label: "Phone",
              get children() {
                return v(ke, {
                  size: "sm",
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "555-555-5555",
                  get children() {
                    return o() || "N/A";
                  }
                });
              }
            }), null), C(c, v(go, {
              label: "Address",
              get children() {
                return v(q, {
                  get when() {
                    return !r() || a();
                  },
                  get fallback() {
                    return bte();
                  },
                  get children() {
                    return [(() => {
                      var f = Yf();
                      return C(f, v(ke, {
                        size: "sm",
                        get loading() {
                          return !r();
                        },
                        sampleLoadingText: "123 Fake St",
                        get children() {
                          return a()?.street1;
                        }
                      })), f;
                    })(), v(q, {
                      get when() {
                        return !r() || a()?.street2;
                      },
                      get children() {
                        var f = Yf();
                        return C(f, v(ke, {
                          size: "sm",
                          get loading() {
                            return !r();
                          },
                          sampleLoadingText: "Apt 3",
                          get children() {
                            return a()?.street2;
                          }
                        })), f;
                      }
                    }), (() => {
                      var f = Yf();
                      return C(f, v(ke, {
                        size: "sm",
                        get loading() {
                          return !r();
                        },
                        sampleLoadingText: "Brooklyn, NY 11221",
                        get children() {
                          return [Pt(() => a()?.city), ", ", Pt(() => a()?.state), " ", Pt(() => a()?.postalCode)];
                        }
                      })), f;
                    })()];
                  }
                });
              }
            }), null), C(h, v(go, {
              label: "DOB",
              get children() {
                return v(ke, {
                  size: "sm",
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "female",
                  get children() {
                    return l3(r()?.dateOfBirth || "N/A");
                  }
                });
              }
            }), null), C(h, v(go, {
              label: "Weight",
              get children() {
                return v(ke, {
                  size: "sm",
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "150 lbs",
                  get children() {
                    return e?.weight ? `${e.weight} ${e.weightUnit}` : "N/A";
                  }
                });
              }
            }), null), C(h, v(go, {
              label: "Sex",
              get children() {
                return v(ke, {
                  size: "sm",
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "female",
                  get children() {
                    return r()?.sex || "N/A";
                  }
                });
              }
            }), null), C(h, v(go, {
              label: "Gender",
              get children() {
                return v(ke, {
                  size: "sm",
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "female",
                  get children() {
                    return r()?.gender || "N/A";
                  }
                });
              }
            }), null), l;
          }
        }), null), s;
      })()];
    }
  });
}
var kte = /* @__PURE__ */ k('<button class="text-gray-700 hover:text-gray-900 hover:bg-blue-50 rounded-md p-2 disabled:opacity-50 disabled:hover:bg-transparent disabled:hover:text-gray-700 disabled:cursor-not-allowed"type=button>');
const _te = (e) => {
  const t = Ke({
    size: "md"
  }, e), r = (() => {
    var n = kte();
    return n.$$click = () => {
      e.loading || e.onClick();
    }, C(n, v(q, {
      get when() {
        return !e.loading;
      },
      get children() {
        return v(et, {
          get name() {
            return e.iconName;
          },
          get size() {
            return t.iconSize;
          }
        });
      }
    }), null), C(n, v(q, {
      get when() {
        return e.loading;
      },
      get children() {
        return v(Fi, {
          get size() {
            return t.iconSize;
          }
        });
      }
    }), null), te((i) => {
      var a = e.label, o = e.disabled;
      return a !== i.e && Xe(n, "aria-label", i.e = a), o !== i.t && (n.disabled = i.t = o), i;
    }, {
      e: void 0,
      t: void 0
    }), n;
  })();
  return Pt(() => Pt(() => !!e.disabled)() ? r : v(A$, {
    get text() {
      return e.label;
    },
    children: r
  }));
};
qr(["click"]);
var xte = /* @__PURE__ */ k('<div class="px-4 sm:px-6 py-3.5">Actions'), Ete = /* @__PURE__ */ k('<div class="px-4 sm:px-6 py-4 col-span-3 text-center">'), Ste = /* @__PURE__ */ k('<div class="grid w-full text-xs relative"><div><div class="px-4 sm:px-6 py-3.5">Medication</div><div class="px-4 sm:px-6 py-3.5 cursor-pointer flex">Written<div class=ml-1>'), Cte = /* @__PURE__ */ k('<div class="px-4 sm:px-6 py-4 truncate"><div class="flex-col flex-1 min-w-0 whitespace-normal"><div class="text-gray-500 text-ellipsis overflow-hidden">'), Tte = /* @__PURE__ */ k('<div class="px-4 sm:px-6 py-4 self-center">'), Ate = /* @__PURE__ */ k('<div class="px-4 sm:px-6 py-4 m-auto">'), Jf = /* @__PURE__ */ k('<div class="px-4 sm:px-6 py-4 select-none">'), Ote = /* @__PURE__ */ k('<div class="text-ellipsis overflow-hidden">'), Pte = /* @__PURE__ */ k('<a class="text-ellipsis block overflow-hidden text-blue-500 underline"target=_blank>');
function Ite(e) {
  const t = hee(), [r, n] = z(void 0), i = B(() => e.enableRefillButton), a = B(() => jt("grid grid-cols-subgrid border-b text-xs font-semibold text-gray-900 sticky top-0 bg-white z-10", {
    "col-span-3": i(),
    "col-span-2": !i()
  })), o = async (s, l) => {
    if (r() === void 0) {
      if (n(s.id), !t)
        throw new Error("Refill requires <DraftPrescriptionsProvider>");
      try {
        await t.tryCreatePrescription({
          ...s,
          treatment: l,
          diagnoseCodes: s.diagnoses?.map((d) => d.code) || []
        }, void 0, "med_history_refill");
      } finally {
        n(void 0);
      }
    }
  };
  return (() => {
    var s = Ste(), l = s.firstChild, d = l.firstChild, c = d.nextSibling, u = c.firstChild, h = u.nextSibling;
    return c.$$click = () => e.onSortOrderToggle(), C(h, v(q, {
      get when() {
        return e.sortOrder === "desc";
      },
      get children() {
        return v(et, {
          name: "chevronDown",
          size: "sm"
        });
      }
    }), null), C(h, v(q, {
      get when() {
        return e.sortOrder === "asc";
      },
      get children() {
        return v(et, {
          name: "chevronUp",
          size: "sm"
        });
      }
    }), null), C(l, v(q, {
      get when() {
        return e.enableRefillButton;
      },
      get children() {
        return xte();
      }
    }), null), C(s, v(q, {
      get when() {
        return !e.isLoading && e.rowItems;
      },
      get fallback() {
        return [v(Zf, {
          get enableRefill() {
            return e.enableRefillButton;
          }
        }), v(Zf, {
          get enableRefill() {
            return e.enableRefillButton;
          }
        }), v(Zf, {
          get enableRefill() {
            return e.enableRefillButton;
          }
        })];
      },
      get children() {
        return v(dt, {
          get each() {
            return e.rowItems;
          },
          children: (f) => [(() => {
            var p = Cte(), m = p.firstChild, y = m.firstChild;
            return C(m, v(Nte, {
              get treatmentName() {
                return f.treatment.name;
              },
              get prescriptionId() {
                return f.prescription?.id;
              },
              get enableLinks() {
                return e.enableLinks;
              },
              get linkBaseUrl() {
                return e.baseURL;
              }
            }), y), C(y, () => Gre(f.prescription)), p;
          })(), (() => {
            var p = Tte();
            return C(p, () => Dte(f)), p;
          })(), v(q, {
            get when() {
              return e.enableRefillButton;
            },
            get children() {
              var p = Ate();
              return C(p, v(_te, {
                iconName: "documentPlus",
                iconSize: "sm",
                label: "Refill",
                onClick: () => {
                  f.prescription && o(f.prescription, f.treatment);
                },
                get disabled() {
                  return !f.prescription;
                },
                get loading() {
                  return Pt(() => !!f.prescription)() && r() === f.prescription.id;
                }
              })), p;
            }
          })]
        });
      }
    }), null), C(s, v(q, {
      get when() {
        return !e.isLoading && e.rowItems && e.rowItems.length === 0;
      },
      get children() {
        var f = Ete();
        return C(f, v(ke, {
          color: "gray",
          children: "No medication history found."
        })), f;
      }
    }), null), te((f) => {
      var p = `1fr min-content ${i() ? "min-content" : ""}`, m = a();
      return p !== f.e && ((f.e = p) != null ? s.style.setProperty("grid-template-columns", p) : s.style.removeProperty("grid-template-columns")), m !== f.t && rt(l, f.t = m), f;
    }, {
      e: void 0,
      t: void 0
    }), s;
  })();
}
const Zf = (e) => [(() => {
  var t = Jf();
  return C(t, v(ke, {
    get sampleLoadingText() {
      return Qre(10, 25);
    },
    loading: !0
  })), t;
})(), (() => {
  var t = Jf();
  return C(t, v(ke, {
    sampleLoadingText: "aaaaa",
    loading: !0
  })), t;
})(), v(q, {
  get when() {
    return e.enableRefill;
  },
  get children() {
    var t = Jf();
    return C(t, v(ke, {
      sampleLoadingText: "aaa",
      loading: !0
    })), t;
  }
})];
function Dte(e) {
  return e.prescription ? l3(e.prescription?.writtenAt) || "N/A" : "External";
}
const Nte = (e) => {
  const t = B(() => e.enableLinks && !!e.prescriptionId);
  return [v(q, {
    get when() {
      return !t();
    },
    get children() {
      var r = Ote();
      return C(r, () => e.treatmentName), r;
    }
  }), v(q, {
    get when() {
      return t();
    },
    get children() {
      var r = Pte();
      return C(r, () => e.treatmentName), te(() => Xe(r, "href", `${e.linkBaseUrl}${e.prescriptionId}`)), r;
    }
  })];
};
qr(["click"]);
var Mte = /* @__PURE__ */ k('<div class="flex items-center justify-between px-4 py-3 sm:px-6 sm:py-4">'), Rte = /* @__PURE__ */ k('<div class="max-h-80 overflow-y-auto">');
const Ku = je`
  query GetPatient($id: ID!) {
    patient(id: $id) {
      id
      treatmentHistory {
        active
        prescription {
          id
          writtenAt
          instructions
          notes
          fillsAllowed
          dispenseQuantity
          dispenseUnit
          dispenseAsWritten
          daysSupply
        }
        treatment {
          id
          name
        }
      }
    }
  }
`, Lte = je`
  mutation UpdateMedicationHistory($id: ID!, $medicationHistory: [MedHistoryInput!]!) {
    updatePatient(id: $id, medicationHistory: $medicationHistory) {
      id
    }
  }
`;
function U$(e) {
  const t = jn(), [r, n] = z(void 0), [i, a] = z("asc"), o = B(() => `${t?.clinicalUrl}/prescriptions/`), s = B(() => ({
    variables: {
      id: e.patientId
    },
    client: t.apolloClinical,
    skip: !e.patientId,
    fetchPolicy: "network-only",
    refetchQueries: [Ku]
  })), l = y1(Ku, s);
  le(() => {
    const c = l();
    if (l.loading)
      n(void 0);
    else if (c) {
      const u = Fte(c).slice().sort(jte(i()));
      n(u);
    } else
      n([]);
  });
  const d = async (c) => {
    const u = (p) => {
      const m = {
        __typename: "PatientMedication",
        treatment: {
          __typename: "Treatment",
          ...e.newMedication
        },
        active: !1,
        prescription: null
      }, y = p.readQuery({
        query: Ku,
        variables: {
          id: e.patientId
        }
      })?.patient?.treatmentHistory ?? [];
      p.writeQuery({
        query: Ku,
        variables: {
          id: e.patientId
        },
        data: {
          patient: {
            __typename: "Patient",
            id: e.patientId,
            treatmentHistory: [m, ...y]
          }
        }
      });
    }, h = {
      active: !1
    };
    if (c.startsWith("dme_"))
      h.medicalEquipmentId = c;
    else if (c.startsWith("med_"))
      h.medicationId = c;
    else {
      Yt({
        header: `Invalid Treatment Id ${c}`,
        body: "The treatment Id is not valid.",
        status: "error"
      }), console.error(`Invalid Treatment Id ${c}`);
      return;
    }
    await t.apollo.mutate({
      mutation: Lte,
      variables: {
        id: e.patientId,
        medicationHistory: [h]
      },
      update: u
    });
    const f = {
      treatment: e.newMedication,
      prescription: void 0
    };
    n((p) => p ? [f, ...p] : [f]), Yt({
      header: "Medication Added",
      body: "Medication has been added to patients history.",
      status: "success"
    }), e.hideAddMedicationDialog?.();
  };
  return le(() => {
    e?.newMedication?.id && d(e.newMedication.id);
  }), v(Sn, {
    addChildrenDivider: !0,
    autoPadding: !1,
    get children() {
      return [(() => {
        var c = Mte();
        return C(c, v(ke, {
          color: "gray",
          children: "Medication History"
        }), null), C(c, v(q, {
          get when() {
            return e?.openAddMedicationDialog;
          },
          get children() {
            return v(ct, {
              variant: "secondary",
              size: "sm",
              get onClick() {
                return e?.openAddMedicationDialog;
              },
              children: "+ Add"
            });
          }
        }), null), c;
      })(), (() => {
        var c = Rte();
        return C(c, v(Ite, {
          get enableLinks() {
            return e.enableLinks;
          },
          get enableRefillButton() {
            return e.enableRefillButton;
          },
          get baseURL() {
            return o();
          },
          get rowItems() {
            return r();
          },
          get isLoading() {
            return l.loading;
          },
          get sortOrder() {
            return i();
          },
          onSortOrderToggle: () => a((u) => u === "asc" ? "desc" : "asc")
        })), c;
      })()];
    }
  });
}
const Fte = (e) => e?.patient?.treatmentHistory.map((t) => ({
  treatment: t.treatment,
  prescription: t.prescription
})), jte = (e) => (t, r) => {
  const n = t?.prescription?.writtenAt ? new Date(t.prescription.writtenAt).getTime() : -1 / 0, i = r?.prescription?.writtenAt ? new Date(r.prescription.writtenAt).getTime() : -1 / 0;
  return e === "desc" ? n - i : i - n;
};
async function zte(e = {}) {
  return new Promise((t, r) => {
    "geolocation" in navigator ? navigator.geolocation.getCurrentPosition(
      t,
      (n) => {
        r(n);
      },
      e
    ) : r(new Error("Geolocation not supported"));
  });
}
const Vte = async (e, t) => {
  const r = {
    input: e,
    types: ["geocode"],
    componentRestrictions: { country: "us" }
  };
  return (await t.getPlacePredictions(r)).predictions.map((n) => ({
    value: n.place_id,
    label: n.description
  }));
};
var Ute = /* @__PURE__ */ k("<div class=text-left><h3 class=mt-0>Set Location</h3><div class=mt-2><p class=text-sm>Enter the zipcode or address where you'd like to search for a pharmacy."), qte = /* @__PURE__ */ k('<div class="mt-5 sm:mt-6 grid grid-cols-1">'), Bte = /* @__PURE__ */ k('<div class="flex items-center gap-2 py-2"><hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700 w-full"><p>OR</p><hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700 w-full">'), Hte = /* @__PURE__ */ k('<p class="text-sm text-red-500 mt-2 text-center">Could not get current location');
function Wte(e) {
  const [t, r] = z(""), [n, i] = z(!1), [a, o] = z(!1), [s, l] = z([]), {
    googleMapsServices: d
  } = u3(), c = async (f) => {
    const {
      geocoder: p
    } = d();
    if (!p) return;
    o(!1);
    const m = await b1(f, p);
    m.length > 0 && (e.setLocation(m[0]), e.setOpen(!1));
  }, u = async () => {
    const {
      geocoder: f
    } = d();
    if (!f) throw new Error("Geocoder not loaded");
    i(!0), o(!1);
    try {
      const {
        coords: {
          latitude: p,
          longitude: m
        }
      } = await zte({
        timeout: 5e3
      }), y = await b1({
        latitude: p,
        longitude: m
      }, f);
      y.length > 0 && e.setLocation(y[0]), e.setOpen(!1);
    } catch {
      o(!0);
    }
    i(!1);
  }, h = async () => {
    const {
      autocompleteService: f
    } = d();
    if (!f) return;
    const p = await Vte(t(), f);
    l(p);
  };
  return le(() => {
    t() && h();
  }), v(os, {
    get open() {
      return e.open;
    },
    onClose: () => e.setOpen(!1),
    get children() {
      return [Ute(), (() => {
        var f = qte();
        return C(f, v(ct, {
          variant: "tertiary",
          onClick: u,
          get iconLeft() {
            return Pt(() => !!n())() ? v(Fi, {
              size: "sm"
            }) : v(et, {
              name: "mapPin",
              size: "sm"
            });
          },
          get children() {
            return n() ? "Getting Current Location" : "Use my Current Location";
          }
        }), null), C(f, (() => {
          var p = Pt(() => !!a());
          return () => p() && Hte();
        })(), null), f;
      })(), Bte(), v(Ye, {
        label: "Enter an address or zip code",
        get children() {
          return v(ri, {
            setSelected: c,
            get children() {
              return [v(ri.Input, {
                displayValue: (f) => f.label,
                onInput: (f) => r(f.currentTarget.value)
              }), v(q, {
                get when() {
                  return s()?.length > 0;
                },
                get children() {
                  return v(ri.Options, {
                    get children() {
                      return v(dt, {
                        get each() {
                          return s();
                        },
                        children: (f) => v(ri.Option, {
                          get key() {
                            return f.value;
                          },
                          get value() {
                            return f.label;
                          },
                          get children() {
                            return f.label;
                          }
                        })
                      });
                    }
                  });
                }
              })];
            }
          });
        }
      })];
    }
  });
}
const Xf = (e) => e.toLowerCase().split(" ").map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(" ");
function q$(e) {
  if (!e) return "";
  const { city: t, postalCode: r, state: n, street1: i, street2: a } = e;
  return `${Xf(i)}${a ? `, ${Xf(a)}` : ""}, ${Xf(
    t
  )}, ${n} ${r || ""}`;
}
function $5(e) {
  return e.split(" ").map((t) => t.charAt(0).toUpperCase() + t.slice(1).toLowerCase()).join(" ");
}
var Kte = /* @__PURE__ */ k("<div class=p-4>No pharmacy matches that search"), Qte = /* @__PURE__ */ k('<div class="flex gap-x-1">'), Gte = /* @__PURE__ */ k('<div class="flex gap-x-1 items-center"> '), Yte = /* @__PURE__ */ k("<div class=text-xs>");
const Jte = (e) => `${$5(e.address?.street1 || "")}, ${$5(e.address?.city || "")}, ${e.address?.state}`;
function B$(e) {
  return v(Ye, {
    get label() {
      return e.label;
    },
    get helpText() {
      return e.helpText || (e.value?.isPreferred || e.value?.isPrevious) && (() => {
        var t = Qte();
        return C(t, v(q, {
          get when() {
            return e.value?.isPreferred;
          },
          get children() {
            return v(Bs, {
              size: "sm",
              color: "blue",
              children: "Preferred"
            });
          }
        }), null), C(t, v(q, {
          get when() {
            return !e.value?.isPreferred && e.value?.isPrevious;
          },
          get children() {
            return v(Bs, {
              size: "sm",
              color: "green",
              children: "Previous"
            });
          }
        }), null), t;
      })();
    },
    get loading() {
      return e.loading;
    },
    get children() {
      return v(ri, {
        get value() {
          return e.value;
        },
        get setSelected() {
          return e.setValue;
        },
        get children() {
          return [v(ri.Input, {
            onInput: (t) => e.onSearch?.(t.currentTarget.value),
            displayValue: (t) => t?.name ? `${t.name}, ${$5(t.address?.street1 || "")}` : ""
          }), v(ri.Options, {
            get children() {
              return [v(q, {
                get when() {
                  return (e.options?.length || 0) > 0;
                },
                get children() {
                  return v(dt, {
                    get each() {
                      return e.options;
                    },
                    children: (t) => v(ri.Option, {
                      get key() {
                        return t.id;
                      },
                      value: t,
                      get children() {
                        return [(() => {
                          var r = Gte(), n = r.firstChild;
                          return C(r, () => t.name, n), C(r, v(q, {
                            get when() {
                              return t.isPreferred;
                            },
                            get children() {
                              return v(Bs, {
                                size: "sm",
                                color: "blue",
                                children: "Preferred"
                              });
                            }
                          }), null), C(r, v(q, {
                            get when() {
                              return !t.isPreferred && t.isPrevious;
                            },
                            get children() {
                              return v(Bs, {
                                size: "sm",
                                color: "green",
                                children: "Previous"
                              });
                            }
                          }), null), r;
                        })(), (() => {
                          var r = Yte();
                          return C(r, () => Jte(t)), r;
                        })()];
                      }
                    })
                  });
                }
              }), v(q, {
                get when() {
                  return e.options?.length === 0;
                },
                get children() {
                  return Kte();
                }
              })];
            }
          })];
        }
      });
    }
  });
}
var Zte = /* @__PURE__ */ k("<div class=mt-4>"), Xte = /* @__PURE__ */ k("<div>"), ere = /* @__PURE__ */ k('<a href=#! role=button class="text-left truncate text-blue-600 font-semibold text-sm flex items-center">'), tre = /* @__PURE__ */ k('<div class="w-full flex flex-col sm:flex-row sm:items-center mb-2"><label class="whitespace-nowrap mr-1">Showing near:');
const H$ = je`
  query GetLastOrder($id: ID!) {
    orders(filter: { patientId: $id }, first: 1) {
      createdAt
      pharmacy {
        id
        name
        address {
          street1
          street2
          city
          state
          postalCode
        }
      }
    }
  }
`;
function W$(e) {
  const t = jn(), {
    googleMapsServices: r
  } = u3(), [n, i] = z(e.initialValue), [a, o] = z(""), [s, l] = z(null), [d, c] = z(null), [u, h] = z([]), [f, p] = z(!1), [m, y] = z(!1), [g, w] = z(!1), [$, _] = z(null), [x, S] = z("");
  async function T() {
    const {
      data: R
    } = await t.apollo.query({
      query: N$,
      variables: {
        location: {
          latitude: s()?.latitude,
          longitude: s()?.longitude
        }
      }
    });
    R?.pharmacies?.length > 0 && c(R.pharmacies.map((L) => ({
      ...L,
      isPreferred: !1
    }))), p(!1);
  }
  async function I(R) {
    y(!0);
    try {
      const {
        data: L
      } = await t.apollo.query({
        query: d3,
        variables: {
          id: R
        }
      }), {
        data: Q
      } = await t.apollo.query({
        query: H$,
        variables: {
          id: R
        }
      }), ie = L?.patient?.address;
      if (ie) {
        const ee = q$(ie);
        await D(ee);
      }
      L?.patient?.preferredPharmacies?.length > 0 && h(L?.patient?.preferredPharmacies.map((ee) => ({
        ...ee,
        isPreferred: !0
      }))), Q?.orders?.length > 0 && _(Q?.orders?.[0]?.pharmacy?.id);
    } catch (L) {
      console.error("Error fetching preferred and previous pharmacies:", L);
    } finally {
      y(!1);
    }
  }
  const M = B(() => {
    const R = d() || [];
    return u().filter((L) => R.some((Q) => Q.id === L.id));
  }), P = B(() => {
    const R = d() || [], L = M(), Q = $(), ie = [...L, ...R].reduce((ee, W) => {
      if (!ee[W.id]) {
        const H = Q === W.id;
        ee[W.id] = {
          ...W,
          isPrevious: H
        };
      }
      return ee;
    }, {});
    return Object.values(ie);
  });
  le(() => {
    s()?.latitude && s()?.longitude && (c(null), p(!0), T());
  });
  const O = B(() => P() === null || P()?.length === 0 ? [] : a() === "" ? P() : P()?.filter((R) => R.name.toLowerCase().includes(a().toLowerCase())) || []);
  le(() => {
    n()?.id && (o(""), e?.setPharmacy?.(n()));
  });
  async function D(R) {
    const {
      geocoder: L
    } = r();
    if (!L) throw new Error("Geocoder not loaded");
    const Q = await b1(R || "", L);
    Q.length > 0 && l(Q[0]);
  }
  return le(() => {
    e?.patientId && I(e?.patientId);
  }), le(() => {
    const R = e?.address;
    if (R && R !== x()) {
      p(!0);
      const L = setTimeout(() => {
        S(R), D(R);
      }, 500);
      _r(() => clearTimeout(L));
    }
  }), le(() => {
    const R = !n()?.id, L = M()?.length > 0, Q = P()?.[0];
    R && L && Q && i(Q);
  }), (() => {
    var R = Xte();
    return C(R, v(Wte, {
      setLocation: l,
      get open() {
        return g();
      },
      setOpen: w
    }), null), C(R, v(B$, {
      get value() {
        return Pt(() => !!n()?.id)() ? n() : void 0;
      },
      setValue: i,
      get options() {
        return O();
      },
      onSearch: o,
      get loading() {
        return f();
      },
      get label() {
        return (() => {
          var L = tre();
          return L.firstChild, C(L, v(q, {
            get when() {
              return !m();
            },
            get fallback() {
              return v(Fi, {
                size: "sm"
              });
            },
            get children() {
              var Q = ere();
              return Q.$$click = (ie) => {
                ie.preventDefault(), w(!0);
              }, C(Q, v(et, {
                name: "mapPin",
                size: "sm",
                class: "inline-block mr-1"
              }), null), C(Q, () => s()?.address || "Set a location", null), Q;
            }
          }), null), L;
        })();
      }
    }), null), C(R, v(q, {
      get when() {
        return Pt(() => !!(!e?.hidePreferred && !f() && !m() && n()))() && !n()?.isPreferred;
      },
      get children() {
        var L = Zte();
        return C(L, v(Bp, {
          id: "set-preferred-pharmacy",
          mainText: "Set as preferred pharmacy",
          checked: !1,
          onChange: (Q) => e?.setPreferred?.(Q)
        })), L;
      }
    }), null), R;
  })();
}
qr(["click"]);
var Zo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, K$ = {}, f3 = {};
Object.defineProperty(f3, "__esModule", { value: !0 });
var rre = (function() {
  function e() {
    var t = this;
    this.locked = /* @__PURE__ */ new Map(), this.addToLocked = function(r, n) {
      var i = t.locked.get(r);
      i === void 0 ? n === void 0 ? t.locked.set(r, []) : t.locked.set(r, [n]) : n !== void 0 && (i.unshift(n), t.locked.set(r, i));
    }, this.isLocked = function(r) {
      return t.locked.has(r);
    }, this.lock = function(r) {
      return new Promise((function(n, i) {
        t.isLocked(r) ? t.addToLocked(r, n) : (t.addToLocked(r), n());
      }));
    }, this.unlock = function(r) {
      var n = t.locked.get(r);
      if (n !== void 0 && n.length !== 0) {
        var i = n.pop();
        t.locked.set(r, n), i !== void 0 && setTimeout(i, 0);
      } else t.locked.delete(r);
    };
  }
  return e.getInstance = function() {
    return e.instance === void 0 && (e.instance = new e()), e.instance;
  }, e;
})();
f3.default = function() {
  return rre.getInstance();
};
var Zn = Zo && Zo.__awaiter || function(e, t, r, n) {
  return new (r || (r = Promise))((function(i, a) {
    function o(d) {
      try {
        l(n.next(d));
      } catch (c) {
        a(c);
      }
    }
    function s(d) {
      try {
        l(n.throw(d));
      } catch (c) {
        a(c);
      }
    }
    function l(d) {
      d.done ? i(d.value) : new r((function(c) {
        c(d.value);
      })).then(o, s);
    }
    l((n = n.apply(e, t || [])).next());
  }));
}, Xn = Zo && Zo.__generator || function(e, t) {
  var r, n, i, a, o = { label: 0, sent: function() {
    if (1 & i[0]) throw i[1];
    return i[1];
  }, trys: [], ops: [] };
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(l) {
    return function(d) {
      return (function(c) {
        if (r) throw new TypeError("Generator is already executing.");
        for (; o; ) try {
          if (r = 1, n && (i = 2 & c[0] ? n.return : c[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, c[1])).done) return i;
          switch (n = 0, i && (c = [2 & c[0], i.value]), c[0]) {
            case 0:
            case 1:
              i = c;
              break;
            case 4:
              return o.label++, { value: c[1], done: !1 };
            case 5:
              o.label++, n = c[1], c = [0];
              continue;
            case 7:
              c = o.ops.pop(), o.trys.pop();
              continue;
            default:
              if (i = o.trys, !((i = i.length > 0 && i[i.length - 1]) || c[0] !== 6 && c[0] !== 2)) {
                o = 0;
                continue;
              }
              if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
                o.label = c[1];
                break;
              }
              if (c[0] === 6 && o.label < i[1]) {
                o.label = i[1], i = c;
                break;
              }
              if (i && o.label < i[2]) {
                o.label = i[2], o.ops.push(c);
                break;
              }
              i[2] && o.ops.pop(), o.trys.pop();
              continue;
          }
          c = t.call(e, o);
        } catch (u) {
          c = [6, u], n = 0;
        } finally {
          r = i = 0;
        }
        if (5 & c[0]) throw c[1];
        return { value: c[0] ? c[1] : void 0, done: !0 };
      })([l, d]);
    };
  }
}, md = Zo;
Object.defineProperty(K$, "__esModule", { value: !0 });
var vs = f3, Qu = { key: function(e) {
  return Zn(md, void 0, void 0, (function() {
    return Xn(this, (function(t) {
      throw new Error("Unsupported");
    }));
  }));
}, getItem: function(e) {
  return Zn(md, void 0, void 0, (function() {
    return Xn(this, (function(t) {
      throw new Error("Unsupported");
    }));
  }));
}, clear: function() {
  return Zn(md, void 0, void 0, (function() {
    return Xn(this, (function(e) {
      return [2, window.localStorage.clear()];
    }));
  }));
}, removeItem: function(e) {
  return Zn(md, void 0, void 0, (function() {
    return Xn(this, (function(t) {
      throw new Error("Unsupported");
    }));
  }));
}, setItem: function(e, t) {
  return Zn(md, void 0, void 0, (function() {
    return Xn(this, (function(r) {
      throw new Error("Unsupported");
    }));
  }));
}, keySync: function(e) {
  return window.localStorage.key(e);
}, getItemSync: function(e) {
  return window.localStorage.getItem(e);
}, clearSync: function() {
  return window.localStorage.clear();
}, removeItemSync: function(e) {
  return window.localStorage.removeItem(e);
}, setItemSync: function(e, t) {
  return window.localStorage.setItem(e, t);
} };
function e2(e) {
  return new Promise((function(t) {
    return setTimeout(t, e);
  }));
}
function t2(e) {
  for (var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", r = "", n = 0; n < e; n++)
    r += t[Math.floor(Math.random() * t.length)];
  return r;
}
var nre = (function() {
  function e(t) {
    this.acquiredIatSet = /* @__PURE__ */ new Set(), this.storageHandler = void 0, this.id = Date.now().toString() + t2(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, e.waiters === void 0 && (e.waiters = []);
  }
  return e.prototype.acquireLock = function(t, r) {
    return r === void 0 && (r = 5e3), Zn(this, void 0, void 0, (function() {
      var n, i, a, o, s, l, d;
      return Xn(this, (function(c) {
        switch (c.label) {
          case 0:
            n = Date.now() + t2(4), i = Date.now() + r, a = "browser-tabs-lock-key-" + t, o = this.storageHandler === void 0 ? Qu : this.storageHandler, c.label = 1;
          case 1:
            return Date.now() < i ? [4, e2(30)] : [3, 8];
          case 2:
            return c.sent(), o.getItemSync(a) !== null ? [3, 5] : (s = this.id + "-" + t + "-" + n, [4, e2(Math.floor(25 * Math.random()))]);
          case 3:
            return c.sent(), o.setItemSync(a, JSON.stringify({ id: this.id, iat: n, timeoutKey: s, timeAcquired: Date.now(), timeRefreshed: Date.now() })), [4, e2(30)];
          case 4:
            return c.sent(), (l = o.getItemSync(a)) !== null && (d = JSON.parse(l)).id === this.id && d.iat === n ? (this.acquiredIatSet.add(n), this.refreshLockWhileAcquired(a, n), [2, !0]) : [3, 7];
          case 5:
            return e.lockCorrector(this.storageHandler === void 0 ? Qu : this.storageHandler), [4, this.waitForSomethingToChange(i)];
          case 6:
            c.sent(), c.label = 7;
          case 7:
            return n = Date.now() + t2(4), [3, 1];
          case 8:
            return [2, !1];
        }
      }));
    }));
  }, e.prototype.refreshLockWhileAcquired = function(t, r) {
    return Zn(this, void 0, void 0, (function() {
      var n = this;
      return Xn(this, (function(i) {
        return setTimeout((function() {
          return Zn(n, void 0, void 0, (function() {
            var a, o, s;
            return Xn(this, (function(l) {
              switch (l.label) {
                case 0:
                  return [4, vs.default().lock(r)];
                case 1:
                  return l.sent(), this.acquiredIatSet.has(r) ? (a = this.storageHandler === void 0 ? Qu : this.storageHandler, (o = a.getItemSync(t)) === null ? (vs.default().unlock(r), [2]) : ((s = JSON.parse(o)).timeRefreshed = Date.now(), a.setItemSync(t, JSON.stringify(s)), vs.default().unlock(r), this.refreshLockWhileAcquired(t, r), [2])) : (vs.default().unlock(r), [2]);
              }
            }));
          }));
        }), 1e3), [2];
      }));
    }));
  }, e.prototype.waitForSomethingToChange = function(t) {
    return Zn(this, void 0, void 0, (function() {
      return Xn(this, (function(r) {
        switch (r.label) {
          case 0:
            return [4, new Promise((function(n) {
              var i = !1, a = Date.now(), o = !1;
              function s() {
                if (o || (window.removeEventListener("storage", s), e.removeFromWaiting(s), clearTimeout(l), o = !0), !i) {
                  i = !0;
                  var d = 50 - (Date.now() - a);
                  d > 0 ? setTimeout(n, d) : n(null);
                }
              }
              window.addEventListener("storage", s), e.addToWaiting(s);
              var l = setTimeout(s, Math.max(0, t - Date.now()));
            }))];
          case 1:
            return r.sent(), [2];
        }
      }));
    }));
  }, e.addToWaiting = function(t) {
    this.removeFromWaiting(t), e.waiters !== void 0 && e.waiters.push(t);
  }, e.removeFromWaiting = function(t) {
    e.waiters !== void 0 && (e.waiters = e.waiters.filter((function(r) {
      return r !== t;
    })));
  }, e.notifyWaiters = function() {
    e.waiters !== void 0 && e.waiters.slice().forEach((function(t) {
      return t();
    }));
  }, e.prototype.releaseLock = function(t) {
    return Zn(this, void 0, void 0, (function() {
      return Xn(this, (function(r) {
        switch (r.label) {
          case 0:
            return [4, this.releaseLock__private__(t)];
          case 1:
            return [2, r.sent()];
        }
      }));
    }));
  }, e.prototype.releaseLock__private__ = function(t) {
    return Zn(this, void 0, void 0, (function() {
      var r, n, i, a;
      return Xn(this, (function(o) {
        switch (o.label) {
          case 0:
            return r = this.storageHandler === void 0 ? Qu : this.storageHandler, n = "browser-tabs-lock-key-" + t, (i = r.getItemSync(n)) === null ? [2] : (a = JSON.parse(i)).id !== this.id ? [3, 2] : [4, vs.default().lock(a.iat)];
          case 1:
            o.sent(), this.acquiredIatSet.delete(a.iat), r.removeItemSync(n), vs.default().unlock(a.iat), e.notifyWaiters(), o.label = 2;
          case 2:
            return [2];
        }
      }));
    }));
  }, e.lockCorrector = function(t) {
    for (var r = Date.now() - 5e3, n = t, i = [], a = 0; ; ) {
      var o = n.keySync(a);
      if (o === null) break;
      i.push(o), a++;
    }
    for (var s = !1, l = 0; l < i.length; l++) {
      var d = i[l];
      if (d.includes("browser-tabs-lock-key")) {
        var c = n.getItemSync(d);
        if (c !== null) {
          var u = JSON.parse(c);
          (u.timeRefreshed === void 0 && u.timeAcquired < r || u.timeRefreshed !== void 0 && u.timeRefreshed < r) && (n.removeItemSync(d), s = !0);
        }
      }
    }
    s && e.notifyWaiters();
  }, e.waiters = void 0, e;
})();
K$.default = nre;
new TextEncoder();
new TextDecoder();
var g9 = Zo && Zo.__assign || function() {
  return g9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var i in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    return e;
  }, g9.apply(this, arguments);
}, v9;
(function(e) {
  e.Code = "code", e.ConnectCode = "connect_code";
})(v9 || (v9 = {}));
var y9;
(function(e) {
  e.Bearer = "Bearer", e.DPoP = "DPoP";
})(y9 || (y9 = {}));
function tt(e, t, r) {
  return (t = (function(n) {
    var i = (function(a, o) {
      if (typeof a != "object" || !a) return a;
      var s = a[Symbol.toPrimitive];
      if (s !== void 0) {
        var l = s.call(a, o);
        if (typeof l != "object") return l;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (o === "string" ? String : Number)(a);
    })(n, "string");
    return typeof i == "symbol" ? i : i + "";
  })(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var Gu, r2;
typeof navigator > "u" || (Gu = navigator.userAgent) === null || Gu === void 0 || (r2 = Gu.startsWith) === null || r2 === void 0 || r2.call(Gu, "Mozilla/5.0 ");
new TextEncoder();
new TextDecoder();
new TextEncoder();
new TextDecoder();
class en extends Error {
  constructor(t, r) {
    var n;
    super(t, r), tt(this, "code", "ERR_JOSE_GENERIC"), this.name = this.constructor.name, (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
}
tt(en, "code", "ERR_JOSE_GENERIC");
class ire extends en {
  constructor(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "unspecified", i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unspecified";
    super(t, { cause: { claim: n, reason: i, payload: r } }), tt(this, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED"), tt(this, "claim", void 0), tt(this, "reason", void 0), tt(this, "payload", void 0), this.claim = n, this.reason = i, this.payload = r;
  }
}
tt(ire, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED");
class are extends en {
  constructor(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "unspecified", i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unspecified";
    super(t, { cause: { claim: n, reason: i, payload: r } }), tt(this, "code", "ERR_JWT_EXPIRED"), tt(this, "claim", void 0), tt(this, "reason", void 0), tt(this, "payload", void 0), this.claim = n, this.reason = i, this.payload = r;
  }
}
tt(are, "code", "ERR_JWT_EXPIRED");
class ore extends en {
  constructor() {
    super(...arguments), tt(this, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
  }
}
tt(ore, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
class sre extends en {
  constructor() {
    super(...arguments), tt(this, "code", "ERR_JOSE_NOT_SUPPORTED");
  }
}
tt(sre, "code", "ERR_JOSE_NOT_SUPPORTED");
tt(class extends en {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "decryption operation failed", arguments.length > 1 ? arguments[1] : void 0), tt(this, "code", "ERR_JWE_DECRYPTION_FAILED");
  }
}, "code", "ERR_JWE_DECRYPTION_FAILED");
tt(class extends en {
  constructor() {
    super(...arguments), tt(this, "code", "ERR_JWE_INVALID");
  }
}, "code", "ERR_JWE_INVALID");
class lre extends en {
  constructor() {
    super(...arguments), tt(this, "code", "ERR_JWS_INVALID");
  }
}
tt(lre, "code", "ERR_JWS_INVALID");
class dre extends en {
  constructor() {
    super(...arguments), tt(this, "code", "ERR_JWT_INVALID");
  }
}
tt(dre, "code", "ERR_JWT_INVALID");
tt(class extends en {
  constructor() {
    super(...arguments), tt(this, "code", "ERR_JWK_INVALID");
  }
}, "code", "ERR_JWK_INVALID");
class cre extends en {
  constructor() {
    super(...arguments), tt(this, "code", "ERR_JWKS_INVALID");
  }
}
tt(cre, "code", "ERR_JWKS_INVALID");
class ure extends en {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "no applicable key found in the JSON Web Key Set", arguments.length > 1 ? arguments[1] : void 0), tt(this, "code", "ERR_JWKS_NO_MATCHING_KEY");
  }
}
tt(ure, "code", "ERR_JWKS_NO_MATCHING_KEY");
class hre extends en {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "multiple matching keys found in the JSON Web Key Set", arguments.length > 1 ? arguments[1] : void 0), tt(this, Symbol.asyncIterator, void 0), tt(this, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
  }
}
tt(hre, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
class fre extends en {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "request timed out", arguments.length > 1 ? arguments[1] : void 0), tt(this, "code", "ERR_JWKS_TIMEOUT");
  }
}
tt(fre, "code", "ERR_JWKS_TIMEOUT");
class pre extends en {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "signature verification failed", arguments.length > 1 ? arguments[1] : void 0), tt(this, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
  }
}
tt(pre, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
var Yu, n2;
typeof navigator > "u" || (Yu = navigator.userAgent) === null || Yu === void 0 || (n2 = Yu.startsWith) === null || n2 === void 0 || n2.call(Yu, "Mozilla/5.0 ");
new TextDecoder();
var Ju, i2;
typeof navigator > "u" || (Ju = navigator.userAgent) === null || Ju === void 0 || (i2 = Ju.startsWith) === null || i2 === void 0 || i2.call(Ju, "Mozilla/5.0 ");
Object.freeze(/* @__PURE__ */ new Set(["grant_type", "client_id", "client_secret", "client_assertion", "client_assertion_type", "subject_token", "subject_token_type", "requested_token_type", "actor_token", "actor_token_type", "audience", "aud", "resource", "resources", "resource_indicator", "scope", "connection", "login_hint", "organization", "assertion"]));
je`
  fragment OrganizationFields on Organization {
    id
    name
  }
`;
const mre = je`
  fragment PatientFields on Patient {
    id
    externalId
    name {
      full
    }
    dateOfBirth
    sex
    gender
    email
    phone
    address {
      id
      name {
        full
      }
      city
      country
      postalCode
      state
      street1
      street2
    }
  }
`;
je`
  fragment AllergenFields on Allergen {
    id
    name
    rxcui
  }
`;
je`
  fragment CatalogFields on Catalog {
    id
    name
  }
`;
je`
  fragment MedicationFields on Medication {
    id
    name
    form
    schedule
    controlled
  }
`;
je`
  fragment SearchMedicationFields on SearchMedication {
    id
    name
  }
`;
je`
  fragment MedicalEquipmentFields on MedicalEquipment {
    id
    name
  }
`;
je`
  fragment CatalogTreatmentFields on Catalog {
    treatments {
      id
      name
    }
  }
`;
je`
  fragment DispenseUnitFields on DispenseUnit {
    name
  }
`;
const gre = je`
  fragment FillPrescriptionFields on Fill {
    id
    state
    requestedAt
    filledAt
    order {
      id
      createdAt
      state
      fulfillment {
        state
      }
      pharmacy {
        id
        name
        address {
          street1
          street2
          city
          state
          postalCode
        }
      }
    }
  }
`;
je`
  ${gre}
  fragment PrescriptionFields on Prescription {
    id
    externalId
    fills {
      ...FillPrescriptionFields
    }
    prescriber {
      id
      name {
        full
      }
    }
    patient {
      id
      name {
        full
      }
    }
    state
    treatment {
      id
      name
    }
    dispenseAsWritten
    dispenseQuantity
    dispenseUnit
    fillsAllowed
    fillsRemaining
    daysSupply
    instructions
    notes
    effectiveDate
    doNotFillBeforeDate
    expirationDate
    writtenAt
  }
`;
const vre = je`
  fragment FillFields on Fill {
    id
    prescription {
      id
    }
    treatment {
      name
    }
    state
    requestedAt
    filledAt
  }
`;
je`
  ${mre}
  ${vre}
  fragment OrderFields on Order {
    id
    externalId
    state
    fills {
      ...FillFields
    }
    patient {
      ...PatientFields
    }
    pharmacy {
      id
      name
      phone
      address {
        city
        country
        postalCode
        state
        street1
        street2
      }
    }
    fulfillment {
      type
      state
      carrier
      trackingNumber
    }
    createdAt
  }
`;
je`
  fragment WebhookFields on WebhookConfig {
    id
    name
    filters
    url
  }
`;
je`
  fragment ClientFields on Client {
    id
    name
    secret
    appType
  }
`;
je`
  fragment PharmacyFields on Pharmacy {
    id
    NPI
    NCPDP
    name
    fulfillmentTypes
    address {
      city
      country
      postalCode
      state
      street1
      street2
    }
  }
`;
je`
  fragment PrescriptionTemplateFields on PrescriptionTemplate {
    id
    daysSupply
    dispenseAsWritten
    dispenseQuantity
    dispenseUnit
    instructions
    notes
    fillsAllowed
    treatment {
      id
      name
    }
    isPrivate
  }
`;
var k5;
(function(e) {
  e.Drug = "DRUG", e.Package = "PACKAGE", e.Product = "PRODUCT";
})(k5 || (k5 = {}));
var _5;
(function(e) {
  e.Icd10 = "ICD10";
})(_5 || (_5 = {}));
var x5;
(function(e) {
  e.Canceled = "CANCELED", e.New = "NEW", e.Scheduled = "SCHEDULED", e.Sent = "SENT";
})(x5 || (x5 = {}));
var E5;
(function(e) {
  e.MailOrder = "MAIL_ORDER", e.PickUp = "PICK_UP";
})(E5 || (E5 = {}));
var S5;
(function(e) {
  e.Otc = "OTC", e.Rx = "RX";
})(S5 || (S5 = {}));
var C5;
(function(e) {
  e.Canceled = "CANCELED", e.Completed = "COMPLETED", e.Error = "ERROR", e.Pending = "PENDING", e.Placed = "PLACED", e.Routing = "ROUTING";
})(C5 || (C5 = {}));
var T5;
(function(e) {
  e.Pharmacy = "PHARMACY", e.Prescriber = "PRESCRIBER";
})(T5 || (T5 = {}));
var A5;
(function(e) {
  e.Draft = "DRAFT", e.Active = "ACTIVE", e.Depleted = "DEPLETED", e.Expired = "EXPIRED", e.Canceled = "CANCELED";
})(A5 || (A5 = {}));
var O5;
(function(e) {
  e.I = "I", e.Ii = "II", e.Iii = "III", e.Iv = "IV", e.V = "V";
})(O5 || (O5 = {}));
var P5;
(function(e) {
  e.Concept = "CONCEPT", e.Form = "FORM", e.Route = "ROUTE", e.Strength = "STRENGTH";
})(P5 || (P5 = {}));
var I5;
(function(e) {
  e.Female = "FEMALE", e.Male = "MALE", e.Unknown = "UNKNOWN";
})(I5 || (I5 = {}));
const b9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ConceptType() {
    return k5;
  },
  get DiagnosisType() {
    return _5;
  },
  get FillState() {
    return x5;
  },
  get FulfillmentType() {
    return E5;
  },
  get MedicationType() {
    return S5;
  },
  get OrderState() {
    return C5;
  },
  get OrgType() {
    return T5;
  },
  get PrescriptionState() {
    return A5;
  },
  get ScheduleType() {
    return O5;
  },
  get SearchMedicationType() {
    return P5;
  },
  get SexType() {
    return I5;
  }
}, Symbol.toStringTag, { value: "Module" }));
var w9;
(function(e) {
  e.Coupon = "coupon", e.Discount = "discount", e.Insurance = "insurance";
})(w9 || (w9 = {}));
var $9;
(function(e) {
  e.Admin = "admin", e.Group = "group", e.Photon = "photon", e.Provider = "provider";
})($9 || ($9 = {}));
var k9;
(function(e) {
  e.Covered = "COVERED", e.CoveredWithRestrictions = "COVERED_WITH_RESTRICTIONS", e.NotCovered = "NOT_COVERED";
})(k9 || (k9 = {}));
var _9;
(function(e) {
  e.Canceled = "CANCELED", e.New = "NEW", e.Scheduled = "SCHEDULED", e.Sent = "SENT";
})(_9 || (_9 = {}));
var x9;
(function(e) {
  e.MailOrder = "MAIL_ORDER", e.PickUp = "PICK_UP";
})(x9 || (x9 = {}));
var E9;
(function(e) {
  e.Otc = "OTC", e.Rx = "RX";
})(E9 || (E9 = {}));
var S9;
(function(e) {
  e.Canceled = "CANCELED", e.Completed = "COMPLETED", e.Error = "ERROR", e.Pending = "PENDING", e.Placed = "PLACED";
})(S9 || (S9 = {}));
var C9;
(function(e) {
  e.Pharmacy = "PHARMACY", e.Prescriber = "PRESCRIBER";
})(C9 || (C9 = {}));
var T9;
(function(e) {
  e.Major = "MAJOR", e.Minor = "MINOR", e.Moderate = "MODERATE";
})(T9 || (T9 = {}));
var A9;
(function(e) {
  e.Allergen = "ALLERGEN", e.Drug = "DRUG";
})(A9 || (A9 = {}));
var O9;
(function(e) {
  e.Active = "ACTIVE", e.Canceled = "CANCELED", e.Depleted = "DEPLETED", e.Draft = "DRAFT", e.Expired = "EXPIRED";
})(O9 || (O9 = {}));
var P9;
(function(e) {
  e.Exclude = "EXCLUDE", e.Include = "INCLUDE", e.NoAdvice = "NO_ADVICE", e.NoRouting = "NO_ROUTING";
})(P9 || (P9 = {}));
var I9;
(function(e) {
  e.Female = "FEMALE", e.Male = "MALE", e.Unknown = "UNKNOWN";
})(I9 || (I9 = {}));
const yre = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SearchTreatments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "filter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "TreatmentFilter" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "treatments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "filter" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] }, bre = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SearchTreatmentOptionsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "filter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "TreatmentFilter" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "treatments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "filter" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] }, wre = {
  "\n  query SearchTreatments($filter: TreatmentFilter!) {\n    treatments(filter: $filter) {\n      id\n      name\n    }\n  }\n": yre,
  "\n  query SearchTreatmentOptionsQuery($filter: TreatmentFilter!) {\n    treatments(filter: $filter) {\n      __typename\n      id\n      name\n    }\n  }\n": bre
};
function Q$(e) {
  var t;
  return (t = wre[e]) !== null && t !== void 0 ? t : {};
}
Q$(`
  query SearchTreatments($filter: TreatmentFilter!) {
    treatments(filter: $filter) {
      id
      name
    }
  }
`);
Q$(`
  query SearchTreatmentOptionsQuery($filter: TreatmentFilter!) {
    treatments(filter: $filter) {
      __typename
      id
      name
    }
  }
`);
var $re = /* @__PURE__ */ k('<div class="rounded-full bg-slate-100 h-5 w-5 mr-1">'), kre = /* @__PURE__ */ k("<div class=pt-4>"), _re = /* @__PURE__ */ k('<div><div class="flex justify-between items-center"><div><label class=sr-only></label><input type=radio class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600 sr-only">'), xre = /* @__PURE__ */ k("<div>"), Ere = /* @__PURE__ */ k("<fieldset><legend class=sr-only></legend><div class=space-y-3>");
const G$ = Rr([{
  selected: "",
  options: [],
  fieldsetLabel: ""
}, {
  addOption: () => {
  },
  setSelected: () => {
  }
}]);
function Sre(e) {
  const [t, r] = eo({
    selected: e.initSelected,
    options: [],
    fieldsetLabel: e.label
  }), n = [t, {
    addOption(i) {
      r("options", [...t.options, i]);
    },
    setSelected(i, a) {
      a || (r("selected", i), e?.setSelected && e.setSelected(i));
    }
  }];
  return le(() => {
    e.value && r("selected", e.value);
  }), le(() => {
    e.contextRef && e.contextRef(n);
  }), v(G$.Provider, {
    value: n,
    get children() {
      return e.children;
    }
  });
}
function Y$() {
  return gr(G$);
}
function Cre(e) {
  const [t, r] = Y$();
  Ht(() => {
    r.addOption(e.value);
  });
  const n = B(() => t.selected === e.value);
  return (() => {
    var i = xre();
    return i.$$click = () => r.setSelected(e.value, e.disabled), C(i, v(Sn, {
      get selected() {
        return n();
      },
      get disabled() {
        return e.disabled;
      },
      get children() {
        var a = _re(), o = a.firstChild, s = o.firstChild, l = s.firstChild, d = l.nextSibling;
        return C(o, () => e.children, s), C(s, v(q, {
          get when() {
            return n();
          },
          get children() {
            return v(et, {
              name: "checkCircle",
              class: "text-blue-600"
            });
          }
        }), l), C(s, v(q, {
          get when() {
            return !n() && !e.disabled;
          },
          get children() {
            return $re();
          }
        }), l), C(l, () => e.label), C(a, v(q, {
          get when() {
            return e.alert;
          },
          get children() {
            var c = kre();
            return C(c, () => e.alert), c;
          }
        }), null), te((c) => {
          var u = e.value, h = t.fieldsetLabel, f = e.value, p = e.disabled;
          return u !== c.e && Xe(l, "for", c.e = u), h !== c.t && Xe(d, "name", c.t = h), f !== c.a && Xe(d, "id", c.a = f), p !== c.o && (d.disabled = c.o = p), c;
        }, {
          e: void 0,
          t: void 0,
          a: void 0,
          o: void 0
        }), te(() => d.value = e.value), te(() => d.checked = n()), a;
      }
    })), te(() => rt(i, e.disabled ? "" : "cursor-pointer")), i;
  })();
}
function Tre(e) {
  const [, t] = Y$();
  return Ht(() => {
    e.initSelected && t.setSelected(e.initSelected);
  }), (() => {
    var r = Ere(), n = r.firstChild, i = n.nextSibling;
    return C(n, () => e.label), C(i, () => e.children), r;
  })();
}
function Oc(e) {
  return v(Sre, Ke(e, {
    get children() {
      return v(Tre, Ke(e, {
        get children() {
          return e.children;
        }
      }));
    }
  }));
}
Oc.Option = Cre;
qr(["click"]);
var Are = /* @__PURE__ */ k('<div class="border-b border-gray-200"><nav class="-mb-px flex space-x-4 sm:space-x-6 md:space-x-8"aria-label=Tabs>'), Ore = /* @__PURE__ */ k("<div>");
function Pre(e) {
  const t = "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium cursor-pointer", r = "border-blue-500 text-blue-600 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium";
  return (() => {
    var n = Are(), i = n.firstChild;
    return C(i, v(dt, {
      get each() {
        return e.tabs;
      },
      children: (a) => {
        const o = B(() => a === e.activeTab);
        return (() => {
          var s = Ore();
          return s.$$click = () => e.setActiveTab(a), C(s, a), te((l) => {
            var d = o() ? r : t, c = o() ? "page" : void 0;
            return d !== l.e && rt(s, l.e = d), c !== l.t && Xe(s, "aria-current", l.t = c), l;
          }, {
            e: void 0,
            t: void 0
          }), s;
        })();
      }
    })), n;
  })();
}
qr(["click"]);
var Ire = /* @__PURE__ */ k("<span>, "), Dre = /* @__PURE__ */ k('<div class="flex flex-col items-start">');
const Nre = je`
  query GetPharmacy($id: ID!) {
    pharmacy(id: $id) {
      id
      name
      address {
        street1
        city
        state
      }
    }
  }
`;
function Mre(e) {
  const t = jn(), [r, n] = z(null);
  async function i() {
    const {
      data: a
    } = await t.apollo.query({
      query: Nre,
      variables: {
        id: e.pharmacyId
      }
    });
    a?.pharmacy && n(a.pharmacy);
  }
  return Ht(() => {
    i();
  }), (() => {
    var a = Dre();
    return C(a, v(ke, {
      get loading() {
        return !r();
      },
      sampleLoadingText: "Loading Name",
      get children() {
        return r()?.name;
      }
    }), null), C(a, v(ke, {
      get loading() {
        return !r();
      },
      color: "gray",
      size: "sm",
      sampleLoadingText: "Cityville, ST",
      get children() {
        var o = Ire(), s = o.firstChild;
        return C(o, () => r()?.address?.city, s), C(o, () => r()?.address?.state, null), o;
      }
    }), null), a;
  })();
}
var Rre = /* @__PURE__ */ k("<div class=mt-4><div>"), Lre = /* @__PURE__ */ k("<div><div>");
const gd = {
  patientWillSelect: {
    badgeColor: "purple",
    badgeText: "Patient Will Select",
    text: "Patient will select a pharmacy after you send the prescription(s)."
  },
  recentPharmacy: {
    badgeColor: "yellow",
    badgeText: "Recent Pharmacy",
    text: "This patient selected this pharmacy in the last 8 hours. After you send this order, the patient can change the pharmacy."
  },
  preferredPharmacy: {
    badgeColor: "blue",
    badgeText: "Preferred Pharmacy",
    text: "The patient can update their preferred pharmacy selection for 15 minutes. Otherwise, we'll send it to their preferred pharmacy on file."
  },
  coverageOptionPharmacy: {
    badgeColor: "gray",
    badgeText: "Selected Pharmacy",
    text: "The selected option was for this pharmacy."
  }
};
function Fre(e) {
  const t = jn(), {
    orderFormData: r,
    selectedCoverageOption: n
  } = ql(), [i, a] = z(gd.patientWillSelect), [o, s] = z(void 0), l = B(() => ({
    variables: {
      id: e.patientId
    },
    client: t.apollo
  })), d = y1(d3, l), c = y1(H$, l), u = B(() => !c.loading && !d.loading), h = B(() => {
    const f = c()?.orders?.[0];
    if (f) {
      const p = /* @__PURE__ */ new Date(), m = new Date(p.getTime() - 480 * 60 * 1e3);
      if (new Date(f.createdAt) > m)
        return f;
    }
  });
  return le(() => {
    if (u()) {
      const f = d()?.patient?.preferredPharmacies, p = h()?.pharmacy;
      if ((f?.length ?? 0) > 0) {
        if (a(gd.preferredPharmacy), f && f.length > 0) {
          const m = f[0], y = {
            ...m,
            address: {
              country: "",
              postalCode: "",
              ...m.address
            }
          };
          s(y);
        }
      } else p ? (a(gd.recentPharmacy), s(p)) : a(gd.patientWillSelect);
    } else
      s(void 0);
  }), le(() => {
    const f = n();
    f && f.pharmacy.id === r.pharmacyId && (a(gd.coverageOptionPharmacy), t.clinical.pharmacy.getPharmacy({
      id: r.pharmacyId
    }).then((p) => {
      s(p.data.pharmacy);
    }));
  }), v(q, {
    get when() {
      return u();
    },
    get fallback() {
      return v(Fi, {
        size: "sm"
      });
    },
    get children() {
      var f = Rre(), p = f.firstChild;
      return C(p, v(Bs, {
        get color() {
          return i().badgeColor;
        },
        get children() {
          return i().badgeText;
        }
      })), C(f, v(ke, {
        size: "sm",
        class: "py-4",
        get children() {
          return i().text;
        }
      }), null), C(f, v(q, {
        get when() {
          return o();
        },
        children: (m) => v(Sn, {
          variant: "gray",
          get children() {
            var y = Lre(), g = y.firstChild;
            return C(y, v(ke, {
              size: "sm",
              bold: !0,
              get children() {
                return m().name;
              }
            }), g), C(g, v(ke, {
              size: "sm",
              get children() {
                return q$(m().address);
              }
            })), y;
          }
        })
      }), null), f;
    }
  });
}
var jre = /* @__PURE__ */ k("<div class=mb-2><label>Search home delivery options");
function zre(e) {
  const t = jn(), [r, n] = z(!1), [i, a] = z(""), [o, s] = z(), l = B(() => {
    const c = o();
    return c && c.length === 0;
  }), d = B(() => {
    const c = i(), u = c ? new RegExp(c, "i") : null, h = (p) => !u || u.test(p.name), f = (p) => ({
      ...p,
      isPreferred: !1,
      isPrevious: !1
    });
    return o()?.filter(h).map(f);
  });
  return le(() => {
    async function c() {
      n(!0);
      try {
        const {
          data: u
        } = await t.apolloClinical.query({
          query: lee,
          variables: {
            offset: 0,
            limit: 40,
            fulfillmentType: "MAIL_ORDER",
            integrated: !1
          }
        });
        s(u.pharmacies);
      } catch (u) {
        console.error("Failed to load mail order pharmacy options", u);
      } finally {
        n(!1);
      }
    }
    c();
  }), le(() => {
    e.selected || a("");
  }), Pt(() => Pt(() => !!l())() ? null : v(B$, {
    get label() {
      return jre();
    },
    get options() {
      return d();
    },
    onSearch: a,
    get value() {
      return e.selected;
    },
    get setValue() {
      return e.selectPharmacy;
    },
    get loading() {
      return r();
    }
  }));
}
var a2 = /* @__PURE__ */ k("<div>"), Vre = /* @__PURE__ */ k("<div class=space-y-4>"), Ure = /* @__PURE__ */ k("<div><div class=pt-4>"), qre = /* @__PURE__ */ k("<div>Please select a patient."), Bre = /* @__PURE__ */ k("<div class=space-y-2><label>Choose a partner pharmacy");
const D9 = [{
  name: "Send to Patient",
  fulfillmentType: "SEND_TO_PATIENT"
  /* sendToPatient */
}, {
  name: "Local Pickup",
  fulfillmentType: b9.FulfillmentType.PickUp
}, {
  name: "Mail Order",
  fulfillmentType: b9.FulfillmentType.MailOrder
}], N9 = (e) => e === "SEND_TO_PATIENT" ? void 0 : e;
function Hre(e) {
  const {
    orderFormData: t,
    selectedCoverageOption: r,
    unroutablePharmacyIds: n
  } = ql(), {
    dispatchAnalytics: i
  } = ca(), a = B(() => !!e.address?.trim()), [o, s] = z(), [l, d] = z(), [c, u] = z(), [h, f] = z([]), [p, m] = z(
    "Send to Patient"
    /* sendToPatient */
  ), y = B(() => e.mailOrderPharmacyIds?.filter((_) => !n().has(_))), g = B(() => y()?.[0]);
  let w;
  le(() => {
    const _ = l();
    _ && n().has(_) && w[1].setSelected(g() || "");
  }), Ht(() => {
    f([...e.enableSendToPatient ? [
      "Send to Patient"
      /* sendToPatient */
    ] : [], ...e.enableLocalPickup ? [
      "Local Pickup"
      /* localPickup */
    ] : [], ...e.enableDeliveryPharmacies ? [
      "Mail Order"
      /* mailOrder */
    ] : []]);
    const _ = D9.find((x) => x.name === h()[0])?.fulfillmentType;
    e.setFufillmentType(N9(_)), m(h()[0]);
  }), le(() => {
    const _ = r(), x = Le(() => t.pharmacyId);
    _ && x === _.pharmacy.id && m(h()[0]);
  });
  const $ = (_) => {
    m(_), h().includes(_) || f([...h(), _]);
    const x = D9.find((S) => S.name === _)?.fulfillmentType;
    e.setFufillmentType(N9(x)), i({
      trackEventType: "pharmacy_interaction",
      properties: {
        tabSelected: _,
        hasPreferredPharmacy: e.hasPreferredPharmacy ?? !1
      }
    }), _ === "Local Pickup" && o() ? e.setPharmacyId(o()) : _ === "Mail Order" && l() ? e.setPharmacyId(l()) : e.setPharmacyId(r()?.pharmacy.id);
  };
  return (() => {
    var _ = Ure(), x = _.firstChild;
    return C(_, v(Pre, {
      get tabs() {
        return h();
      },
      get activeTab() {
        return p();
      },
      setActiveTab: $
    }), x), C(x, v(q, {
      get when() {
        return h().includes(
          "Send to Patient"
          /* sendToPatient */
        );
      },
      get children() {
        var S = a2();
        return C(S, v(q, {
          get when() {
            return (e?.patientIds?.length || 0) > 0;
          },
          get fallback() {
            return qre();
          },
          get children() {
            return v(Fre, {
              get patientId() {
                return e.patientIds[0];
              }
            });
          }
        })), te(() => rt(S, p() !== "Send to Patient" ? "hidden" : "")), S;
      }
    }), null), C(x, v(q, {
      get when() {
        return h().includes(
          "Local Pickup"
          /* localPickup */
        );
      },
      get children() {
        var S = a2();
        return C(S, v(q, {
          get when() {
            return a();
          },
          get fallback() {
            return v(gc, {
              type: "warning",
              header: "Address required",
              message: "Please add a patient address to select a pharmacy."
            });
          },
          get children() {
            return v(W$, {
              get address() {
                return e?.address || "";
              },
              get patientId() {
                return e?.patientIds?.[0];
              },
              setPharmacy: (T) => {
                s(T.id), p() === "Local Pickup" && e.setPharmacyId(T.id);
              },
              setPreferred: (T) => {
                e?.setPreferredPharmacy?.(T), i({
                  trackEventType: "pharmacy_interaction",
                  properties: {
                    tabSelected: "Local Pickup",
                    hasPreferredPharmacy: e.hasPreferredPharmacy ?? !1,
                    setAsPreferred: T
                  }
                });
              }
            });
          }
        })), te(() => rt(S, p() !== "Local Pickup" ? "hidden" : "")), S;
      }
    }), null), C(x, v(q, {
      get when() {
        return h().includes(
          "Mail Order"
          /* mailOrder */
        );
      },
      get children() {
        var S = a2();
        return C(S, v(q, {
          get when() {
            return a();
          },
          get fallback() {
            return v(gc, {
              type: "warning",
              header: "Address required",
              message: "Please add a patient address to select a pharmacy."
            });
          },
          get children() {
            var T = Vre();
            return C(T, v(zre, {
              get selected() {
                return c();
              },
              selectPharmacy: (I) => {
                u(I), d(I.id), p() === "Mail Order" && e.setPharmacyId(I.id);
              }
            }), null), C(T, (() => {
              var I = Pt(() => (e.mailOrderPharmacyIds?.length ?? 0) > 0);
              return () => I() && (() => {
                var M = Bre();
                return M.firstChild, C(M, v(Oc, {
                  label: "Pharmacies",
                  get value() {
                    return l();
                  },
                  setSelected: (P) => {
                    u(void 0), d(P), p() === "Mail Order" && e.setPharmacyId(P);
                  },
                  contextRef: (P) => w = P,
                  get children() {
                    return v(dt, {
                      get each() {
                        return e?.mailOrderPharmacyIds || [];
                      },
                      children: (P) => v(Oc.Option, {
                        value: P,
                        get disabled() {
                          return n().has(P);
                        },
                        get alert() {
                          return Pt(() => !!n().has(P))() && v(QY, {});
                        },
                        get children() {
                          return v(Mre, {
                            pharmacyId: P
                          });
                        }
                      })
                    });
                  }
                }), null), M;
              })();
            })(), null), T;
          }
        })), te(() => rt(S, p() !== "Mail Order" ? "hidden" : "")), S;
      }
    }), null), _;
  })();
}
const Wre = (e) => v(UH, {
  get containerStyle() {
    return {
      "margin-top": `${e?.buffer || 0}px`
    };
  }
});
function Kre(e) {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let r = "";
  for (let n = 0; n < e; n++)
    r += t.charAt(Math.floor(Math.random() * t.length));
  return r;
}
function Qre(e = 5, t = 10) {
  const r = Math.floor(Math.random() * (t - e + 1)) + e;
  return Kre(r);
}
function Gre(e) {
  let t = "N/A", r = "", n = "N/A", i = "N/A", a = "N/A";
  return e && (t = e.dispenseQuantity.toString(), e.dispenseQuantity > 0 && (r = ` ${e.dispenseUnit}`), e.daysSupply && (n = e.daysSupply.toString()), e.fillsAllowed ? i = (e.fillsAllowed - 1).toString() : i = "0", e.instructions && (a = e.instructions)), `QTY: ${t}${r} | Days Supply: ${n} | Refills: ${i} | Sig: ${a}`;
}
var Yre = /* @__PURE__ */ k('<div class="flex justify-center w-full">'), Jre = /* @__PURE__ */ k('<div class="text-red-700 font-bold flex space-x-2 items-center justify-center"><span>An error occurred. Please refresh and try again'), Zre = /* @__PURE__ */ k("<div class=w-full>"), Xre = /* @__PURE__ */ k('<div class="flex flex-col space-y-5"><div class="bg-[#FFFAEB] flex text-[#DC6803] py-2 font-semibold items-center text-sm">Required before writing prescriptions</div><div class=space-y-3><p class=text-base>By selecting <span class=font-bold>Agree</span>, you approve any prescriptions you create and send via Photon Health, Inc and that you are a practitioner authorized to prescribe and licensed in the relevant state. This signature image will not be used for any other purposes.</p></div><div class="flex justify-end space-x-4">');
const J$ = je`
  query GetCurrentUserSignatureAttestationStatus {
    me {
      signatureAttestationStatus {
        ... on NeedsSignatureAttestation {
          version
          content
        }
        ... on CompletedSignatureAttestation {
          agreedAt
          version
        }
        ... on NotApplicableSignatureAttestation {
          reason
        }
      }
    }
  }
`, ene = je`
  mutation AgreeToSignatureAttestation($version: String!) {
    agreeToSignatureAttestation(version: $version)
  }
`, tne = async (e) => await e.query({
  query: J$,
  fetchPolicy: "cache-first"
}), rne = (e) => async (t) => await e.mutate({
  mutation: ene,
  variables: {
    version: t
  },
  refetchQueries: ["GetCurrentUserSignatureAttestationStatus"],
  awaitRefetchQueries: !0,
  update: (r, {
    data: n
  }) => {
    n?.agreeToSignatureAttestation && r.writeQuery({
      query: J$,
      data: {
        me: {
          signatureAttestationStatus: {
            __typename: "CompletedSignatureAttestation",
            agreedAt: /* @__PURE__ */ new Date(),
            version: t
          }
        }
      }
    });
  }
}), nne = (e) => {
  const {
    dispatchSignatureAttestationAgreed: t,
    dispatchSignatureAttestationCanceled: r,
    dispatchAnalytics: n
  } = ca(), [i, a] = z({
    status: "LOADING"
  }), [o, s] = z(!1), l = async () => {
    const c = await tne(e.client);
    c.error || c.errors ? a({
      status: "ERROR",
      errors: [...c.errors?.map((u) => u.message) ?? [], ...c.error ? [c.error.message] : []]
    }) : c.data?.me?.signatureAttestationStatus ? c.data?.me?.signatureAttestationStatus?.__typename === "CompletedSignatureAttestation" || c.data?.me?.signatureAttestationStatus?.__typename === "NotApplicableSignatureAttestation" ? a({
      status: "COMPLETE"
    }) : a({
      status: "NEEDS ATTESTATION",
      version: c.data.me.signatureAttestationStatus.version
    }) : a({
      status: "ERROR",
      errors: ["Could not get user data. Please refresh and try again"]
    });
  };
  le(() => {
    i().status === "COMPLETE" && t();
  }), le(() => {
    const c = i();
    c.status === "NEEDS ATTESTATION" && n({
      trackEventType: "signature_attestation_shown",
      properties: {
        attestationVersion: c.version
      }
    });
  }), le(() => {
    l();
  });
  const d = async () => {
    if (o())
      return;
    const c = i();
    if (c.status === "NEEDS ATTESTATION") {
      s(!0);
      const u = await rne(e.client)(c.version);
      u.data?.agreeToSignatureAttestation ? (s(!1), a({
        status: "COMPLETE"
      }), n({
        trackEventType: "signature_attestation_agreed",
        properties: {
          attestationVersion: c.version
        }
      })) : (u.error || u.errors) && (s(!1), a({
        status: "ERROR",
        errors: [...u.errors?.map((h) => h.message) ?? [], ...u.error ? [u.error.message] : []]
      }));
    }
  };
  return v(N1, {
    get children() {
      return [v(Mn, {
        get when() {
          return i().status === "LOADING";
        },
        get children() {
          var c = Yre();
          return C(c, v(Fi, {
            color: "green"
          })), c;
        }
      }), v(Mn, {
        get when() {
          return i().status === "COMPLETE";
        },
        get children() {
          return e.children;
        }
      }), v(Mn, {
        get when() {
          return i().status === "ERROR";
        },
        get children() {
          var c = Jre(), u = c.firstChild;
          return C(c, v(et, {
            name: "exclamationCircle"
          }), u), c;
        }
      }), v(Mn, {
        get when() {
          return i().status === "NEEDS ATTESTATION";
        },
        get children() {
          var c = Zre();
          return C(c, v(ine, {
            onAgree: d,
            onCancel: () => {
              n({
                trackEventType: "signature_attestation_canceled"
              }), r();
            },
            get disabled() {
              return o();
            }
          })), c;
        }
      })];
    }
  });
}, ine = (e) => v(Sn, {
  get children() {
    var t = Xre(), r = t.firstChild, n = r.firstChild, i = r.nextSibling, a = i.firstChild, o = i.nextSibling;
    return C(r, v(et, {
      name: "informationCircle",
      class: "mx-2"
    }), n), C(i, v(ke, {
      bold: !0,
      size: "xl",
      children: "Prescriber Signature Attestation"
    }), a), C(i, v(ke, {
      class: "block",
      children: "Photon Health, Inc. attaches your signature image to the digital signature and timestamp associated with an authorized digital prescription; or digital prescription reproduced as a hard copy facsimile."
    }), a), C(i, v(ke, {
      class: "block",
      children: "In order to send prescriptions via the Photon application, you must be personally logged-in at the time of prescribe to approve the prescription to be created."
    }), a), C(o, v(ct, {
      variant: "secondary",
      get onClick() {
        return e.onCancel;
      },
      get disabled() {
        return e.disabled;
      },
      children: "Cancel"
    }), null), C(o, v(ct, {
      variant: "primary",
      get onClick() {
        return e.onAgree;
      },
      get disabled() {
        return e.disabled;
      },
      children: "Agree"
    }), null), t;
  }
});
function D5(e) {
  this.message = e;
}
D5.prototype = new Error(), D5.prototype.name = "InvalidCharacterError";
var M9 = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new D5("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var r, n, i = 0, a = 0, o = ""; n = t.charAt(a++); ~n && (r = i % 4 ? 64 * r + n : n, i++ % 4) ? o += String.fromCharCode(255 & r >> (-2 * i & 6)) : 0) n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);
  return o;
};
function ane(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return (function(r) {
      return decodeURIComponent(M9(r).replace(/(.)/g, (function(n, i) {
        var a = i.charCodeAt(0).toString(16).toUpperCase();
        return a.length < 2 && (a = "0" + a), "%" + a;
      })));
    })(t);
  } catch {
    return M9(t);
  }
}
function w1(e) {
  this.message = e;
}
function one(e, t) {
  if (typeof e != "string") throw new w1("Invalid token specified");
  var r = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(ane(e.split(".")[r]));
  } catch (n) {
    throw new w1("Invalid token specified: " + n.message);
  }
}
w1.prototype = new Error(), w1.prototype.name = "InvalidTokenError";
const sne = (e) => {
  e?.returnTo ? window.location.replace(e?.returnTo) : window.history.pushState(null, window.document.title, window.location.pathname);
}, lne = je`
  fragment CatalogTreatmentsFieldsComponentFragment on Catalog {
    treatments {
      id
      name
    }
    templates {
      id
      daysSupply
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      instructions
      notes
      fillsAllowed
      treatment {
        id
        name
      }
    }
  }
`, dne = {
  CatalogTreatmentsFieldsComponentFragment: lne
};
class cne {
  sdk;
  setStore;
  store;
  authentication;
  getSDK;
  clinical;
  autoLogin;
  constructor(t, r = !1) {
    this.sdk = t, this.autoLogin = r;
    const [n, i] = eo({
      authentication: {
        isAuthenticated: !1,
        isInOrg: !1,
        permissions: [],
        isLoading: !0,
        error: void 0,
        user: void 0
      },
      catalog: {
        isLoading: !1,
        treatments: [],
        templates: []
      },
      catalogs: {
        isLoading: !1,
        catalogs: []
      },
      dispenseUnits: {
        isLoading: !1,
        dispenseUnits: new Array()
      },
      patients: {
        isLoading: !1,
        patients: [],
        finished: !1
      },
      patient: {
        isLoading: !1,
        patient: void 0
      },
      prescription: {
        isLoading: !1,
        errors: [],
        error: void 0,
        data: void 0
      }
    });
    this.setStore = i, this.store = n, this.authentication = {
      state: n.authentication,
      handleRedirect: async (a) => {
        try {
          const o = await this.sdk.authentication.handleRedirect(a);
          sne(o?.appState), await this.authentication.checkSession();
        } catch (o) {
          const s = new URLSearchParams(window.location.search).get("error_description");
          o.message.includes("must be an organization id") ? this.setStore("authentication", {
            ...this.store.authentication,
            error: "The provided organization id is invalid or does not exist"
          }) : s?.includes("is not part of the org") ? this.setStore("authentication", {
            ...this.store.authentication,
            error: "User is not authorized",
            isLoading: !1
          }) : this.setStore("authentication", {
            ...this.store.authentication,
            error: o.message
          });
        }
      },
      checkSession: this.checkSession.bind(this),
      login: this.login.bind(this),
      logout: this.logout.bind(this)
    }, this.getSDK = this._getSDK.bind(this), this.clinical = {
      catalog: {
        state: n.catalog,
        getCatalog: this.getCatalog.bind(this)
      },
      catalogs: {
        state: n.catalogs,
        getCatalogs: this.getCatalogs.bind(this)
      },
      dispenseUnits: {
        state: n.dispenseUnits,
        getDispenseUnits: this.getDispenseUnits.bind(this)
      },
      patients: {
        state: n.patients,
        getPatients: this.getPatients.bind(this)
      },
      patient: {
        state: n.patient,
        getPatient: this.getPatient.bind(this)
      },
      prescription: {
        state: n.prescription,
        createPrescription: this.createPrescription.bind(this)
      }
    };
  }
  _getSDK() {
    return this.sdk;
  }
  async checkSession() {
    try {
      await this.sdk.authentication.checkSession();
      const t = await this.sdk.authentication.isAuthenticated();
      this.setStore("authentication", {
        ...this.store.authentication,
        isAuthenticated: t
      });
      const r = await this.sdk.authentication.getUser(), n = !!this.sdk?.organization && !!r?.org_id;
      let i = [];
      if (this.autoLogin || t)
        try {
          const o = await this.sdk.authentication.getAccessToken();
          i = one(o)?.permissions || [];
        } catch {
          i = [];
        }
      const a = t && n && this.sdk.organization === r.org_id;
      this.setStore("authentication", {
        ...this.store.authentication,
        user: r,
        isLoading: !1,
        isInOrg: a,
        permissions: i || []
      });
    } catch {
      this.setStore("authentication", {
        ...this.store.authentication,
        isLoading: !1
      });
    }
  }
  async login(t = {}) {
    await this.sdk.authentication.login(t), await this.checkSession();
  }
  async logout(t = {}) {
    await this.sdk.authentication.logout(t), this.setStore("authentication", {
      ...this.store.authentication,
      isAuthenticated: !1,
      isInOrg: !1,
      permissions: [],
      user: void 0
    });
  }
  async getPatients(t) {
    t || (t = {}), this.setStore("patients", {
      ...this.store.patients,
      isLoading: !0
    });
    const { data: r } = await this.sdk.clinical.patient.getPatients(t);
    this.setStore("patients", {
      ...this.store.patients,
      isLoading: !1,
      patients: t.clear ? r.patients : this.store.patients.patients.concat(r.patients),
      finished: r.patients.length == 0
    });
  }
  async getPatient(t) {
    this.setStore("patient", {
      ...this.store.patient,
      isLoading: !0
    });
    const { data: r } = await this.sdk.clinical.patient.getPatient(t);
    return this.setStore("patient", {
      ...this.store.patient,
      isLoading: !1,
      patient: r.patient
    }), r.patient;
  }
  async getCatalog(t) {
    this.setStore("catalog", {
      ...this.store.catalog,
      isLoading: !0
    });
    const { data: r } = await this.sdk.clinical.catalog.getCatalog({
      id: t.id,
      fragment: dne
    });
    this.setStore("catalog", {
      ...this.store.catalog,
      isLoading: !1,
      treatments: r.catalog.treatments.map((n) => n) || [],
      templates: r.catalog.templates.map((n) => n) || []
    });
  }
  async getCatalogs() {
    this.setStore("catalogs", {
      ...this.store.catalogs,
      isLoading: !0
    });
    const { data: t } = await this.sdk.clinical.catalog.getCatalogs();
    this.setStore("catalogs", {
      ...this.store.catalogs,
      isLoading: !1,
      catalogs: t.catalogs
    });
  }
  async getDispenseUnits() {
    this.setStore("dispenseUnits", {
      ...this.store.dispenseUnits,
      isLoading: !0
    });
    const { data: t } = await this.sdk.clinical.prescription.getDispenseUnits();
    this.setStore("dispenseUnits", {
      ...this.store.dispenseUnits,
      isLoading: !1,
      dispenseUnits: t.dispenseUnits.map((r, n) => ({
        id: String(n),
        ...r
      }))
    });
  }
  async createPrescription(t) {
    this.setStore("prescription", {
      ...this.store.prescription,
      isLoading: !0
    });
    const r = this.sdk.clinical.prescription.createPrescription({});
    try {
      const { data: n, errors: i } = await r({
        variables: t,
        refetchQueries: [],
        awaitRefetchQueries: !1
      });
      return i && i.length > 0 && this.setStore("prescription", {
        ...this.store.prescription,
        errors: [...i]
      }), n?.createPrescription && this.setStore("prescription", {
        ...this.store.prescription,
        data: n.createPrescription
      }), this.setStore("prescription", {
        ...this.store.prescription,
        isLoading: !1
      }), {
        data: n,
        errors: i
      };
    } catch (n) {
      return this.setStore("prescription", {
        ...this.store.prescription,
        error: n,
        isLoading: !1
      }), {
        data: null,
        errors: []
      };
    }
  }
}
const une = (e, t, r) => {
  const n = r(e, t);
  return _r(() => clearInterval(n));
}, Z$ = "%[a-f0-9]{2}", R9 = new RegExp("(" + Z$ + ")|([^%]+?)", "gi"), L9 = new RegExp("(" + Z$ + ")+", "gi");
function N5(e, t) {
  try {
    return [decodeURIComponent(e.join(""))];
  } catch {
  }
  if (e.length === 1)
    return e;
  t = t || 1;
  const r = e.slice(0, t), n = e.slice(t);
  return Array.prototype.concat.call([], N5(r), N5(n));
}
function hne(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    let t = e.match(R9) || [];
    for (let r = 1; r < t.length; r++)
      e = N5(t, r).join(""), t = e.match(R9) || [];
    return e;
  }
}
function fne(e) {
  const t = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let r = L9.exec(e);
  for (; r; ) {
    try {
      t[r[0]] = decodeURIComponent(r[0]);
    } catch {
      const i = hne(r[0]);
      i !== r[0] && (t[r[0]] = i);
    }
    r = L9.exec(e);
  }
  t["%C2"] = "�";
  const n = Object.keys(t);
  for (const i of n)
    e = e.replace(new RegExp(i, "g"), t[i]);
  return e;
}
function pne(e) {
  if (typeof e != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");
  try {
    return decodeURIComponent(e);
  } catch {
    return fne(e);
  }
}
function mne(e, t) {
  const r = {};
  if (Array.isArray(t))
    for (const n of t) {
      const i = Object.getOwnPropertyDescriptor(e, n);
      i?.enumerable && Object.defineProperty(r, n, i);
    }
  else
    for (const n of Reflect.ownKeys(e)) {
      const i = Object.getOwnPropertyDescriptor(e, n);
      if (i.enumerable) {
        const a = e[n];
        t(n, a, e) && Object.defineProperty(r, n, i);
      }
    }
  return r;
}
function X$(e, t) {
  if (!(typeof e == "string" && typeof t == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (e === "" || t === "")
    return [];
  const r = e.indexOf(t);
  return r === -1 ? [] : [
    e.slice(0, r),
    e.slice(r + t.length)
  ];
}
const gne = (e) => e == null, vne = (e) => encodeURIComponent(e).replaceAll(/[!'()*]/g, (t) => `%${t.charCodeAt(0).toString(16).toUpperCase()}`), M5 = /* @__PURE__ */ Symbol("encodeFragmentIdentifier");
function yne(e) {
  switch (e.arrayFormat) {
    case "index":
      return (t) => (r, n) => {
        const i = r.length;
        return n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
          ...r,
          [dr(t, e), "[", i, "]"].join("")
        ] : [
          ...r,
          [dr(t, e), "[", dr(i, e), "]=", dr(n, e)].join("")
        ];
      };
    case "bracket":
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        [dr(t, e), "[]"].join("")
      ] : [
        ...r,
        [dr(t, e), "[]=", dr(n, e)].join("")
      ];
    case "colon-list-separator":
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        [dr(t, e), ":list="].join("")
      ] : [
        ...r,
        [dr(t, e), ":list=", dr(n, e)].join("")
      ];
    case "comma":
    case "separator":
    case "bracket-separator": {
      const t = e.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (r) => (n, i) => i === void 0 || e.skipNull && i === null || e.skipEmptyString && i === "" ? n : (i = i === null ? "" : i, n.length === 0 ? [[dr(r, e), t, dr(i, e)].join("")] : [[n, dr(i, e)].join(e.arrayFormatSeparator)]);
    }
    default:
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        dr(t, e)
      ] : [
        ...r,
        [dr(t, e), "=", dr(n, e)].join("")
      ];
  }
}
function bne(e) {
  let t;
  switch (e.arrayFormat) {
    case "index":
      return (r, n, i) => {
        if (t = /\[(\d*)]$/.exec(r), r = r.replace(/\[\d*]$/, ""), !t) {
          i[r] = n;
          return;
        }
        i[r] === void 0 && (i[r] = {}), i[r][t[1]] = n;
      };
    case "bracket":
      return (r, n, i) => {
        if (t = /(\[])$/.exec(r), r = r.replace(/\[]$/, ""), !t) {
          i[r] = n;
          return;
        }
        if (i[r] === void 0) {
          i[r] = [n];
          return;
        }
        i[r] = [...i[r], n];
      };
    case "colon-list-separator":
      return (r, n, i) => {
        if (t = /(:list)$/.exec(r), r = r.replace(/:list$/, ""), !t) {
          i[r] = n;
          return;
        }
        if (i[r] === void 0) {
          i[r] = [n];
          return;
        }
        i[r] = [...i[r], n];
      };
    case "comma":
    case "separator":
      return (r, n, i) => {
        const o = typeof n == "string" && n.includes(e.arrayFormatSeparator) ? n.split(e.arrayFormatSeparator).map((s) => Lo(s, e)) : n === null ? n : Lo(n, e);
        i[r] = o;
      };
    case "bracket-separator":
      return (r, n, i) => {
        const a = /(\[])$/.test(r);
        if (r = r.replace(/\[]$/, ""), !a) {
          i[r] = n && Lo(n, e);
          return;
        }
        const o = n === null ? [] : Lo(n, e).split(e.arrayFormatSeparator);
        if (i[r] === void 0) {
          i[r] = o;
          return;
        }
        i[r] = [...i[r], ...o];
      };
    default:
      return (r, n, i) => {
        if (i[r] === void 0) {
          i[r] = n;
          return;
        }
        i[r] = [...[i[r]].flat(), n];
      };
  }
}
function ek(e) {
  if (typeof e != "string" || e.length !== 1)
    throw new TypeError("arrayFormatSeparator must be single character string");
}
function dr(e, t) {
  return t.encode ? t.strict ? vne(e) : encodeURIComponent(e) : e;
}
function Lo(e, t) {
  return t.decode ? pne(e) : e;
}
function tk(e) {
  return Array.isArray(e) ? e.sort() : typeof e == "object" ? tk(Object.keys(e)).sort((t, r) => Number(t) - Number(r)).map((t) => e[t]) : e;
}
function rk(e) {
  const t = e.indexOf("#");
  return t !== -1 && (e = e.slice(0, t)), e;
}
function wne(e) {
  let t = "";
  const r = e.indexOf("#");
  return r !== -1 && (t = e.slice(r)), t;
}
function F9(e, t, r) {
  return r === "string" && typeof e == "string" ? e : typeof r == "function" && typeof e == "string" ? r(e) : r === "boolean" && e === null ? !0 : r === "boolean" && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") ? e.toLowerCase() === "true" : r === "boolean" && e !== null && (e.toLowerCase() === "1" || e.toLowerCase() === "0") ? e.toLowerCase() === "1" : r === "string[]" && t.arrayFormat !== "none" && typeof e == "string" ? [e] : r === "number[]" && t.arrayFormat !== "none" && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? [Number(e)] : r === "number" && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? Number(e) : t.parseBooleans && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") ? e.toLowerCase() === "true" : t.parseNumbers && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? Number(e) : e;
}
function p3(e) {
  e = rk(e);
  const t = e.indexOf("?");
  return t === -1 ? "" : e.slice(t + 1);
}
function m3(e, t) {
  t = {
    decode: !0,
    sort: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: !1,
    parseBooleans: !1,
    types: /* @__PURE__ */ Object.create(null),
    ...t
  }, ek(t.arrayFormatSeparator);
  const r = bne(t), n = /* @__PURE__ */ Object.create(null);
  if (typeof e != "string" || (e = e.trim().replace(/^[?#&]/, ""), !e))
    return n;
  for (const i of e.split("&")) {
    if (i === "")
      continue;
    const a = t.decode ? i.replaceAll("+", " ") : i;
    let [o, s] = X$(a, "=");
    o === void 0 && (o = a), s = s === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(t.arrayFormat) ? s : Lo(s, t), r(Lo(o, t), s, n);
  }
  for (const [i, a] of Object.entries(n))
    if (typeof a == "object" && a !== null && t.types[i] !== "string")
      for (const [o, s] of Object.entries(a)) {
        const l = t.types[i], d = typeof l == "function" ? l : l ? l.replace("[]", "") : void 0;
        a[o] = F9(s, t, d);
      }
    else typeof a == "object" && a !== null && t.types[i] === "string" ? n[i] = Object.values(a).join(t.arrayFormatSeparator) : n[i] = F9(a, t, t.types[i]);
  return t.sort === !1 ? n : (t.sort === !0 ? Object.keys(n).sort() : Object.keys(n).sort(t.sort)).reduce((i, a) => {
    const o = n[a];
    return i[a] = o && typeof o == "object" && !Array.isArray(o) ? tk(o) : o, i;
  }, /* @__PURE__ */ Object.create(null));
}
function nk(e, t) {
  if (!e)
    return "";
  t = {
    encode: !0,
    strict: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...t
  }, ek(t.arrayFormatSeparator);
  const r = (o) => t.skipNull && gne(e[o]) || t.skipEmptyString && e[o] === "", n = yne(t), i = {};
  for (const [o, s] of Object.entries(e))
    r(o) || (i[o] = s);
  const a = Object.keys(i);
  return t.sort !== !1 && a.sort(t.sort), a.map((o) => {
    let s = e[o];
    if (t.replacer && (s = t.replacer(o, s), s === void 0) || s === void 0)
      return "";
    if (s === null)
      return dr(o, t);
    if (Array.isArray(s)) {
      if (s.length === 0 && t.arrayFormat === "bracket-separator")
        return dr(o, t) + "[]";
      let l = s;
      return t.replacer && (l = s.map(
        (d, c) => t.replacer(`${o}[${c}]`, d)
      ).filter((d) => d !== void 0)), l.reduce(n(o), []).join("&");
    }
    return dr(o, t) + "=" + dr(s, t);
  }).filter((o) => o.length > 0).join("&");
}
function ik(e, t) {
  t = {
    decode: !0,
    ...t
  };
  let [r, n] = X$(e, "#");
  return r === void 0 && (r = e), {
    url: r?.split("?")?.[0] ?? "",
    query: m3(p3(e), t),
    ...t && t.parseFragmentIdentifier && n ? { fragmentIdentifier: Lo(n, t) } : {}
  };
}
function ak(e, t) {
  t = {
    encode: !0,
    strict: !0,
    [M5]: !0,
    ...t
  };
  const r = rk(e.url).split("?")[0] || "", n = p3(e.url), i = {
    ...m3(n, { sort: !1, ...t }),
    ...e.query
  };
  let a = nk(i, t);
  a &&= `?${a}`;
  let o = wne(e.url);
  if (typeof e.fragmentIdentifier == "string") {
    const s = new URL(r);
    s.hash = e.fragmentIdentifier, o = t[M5] ? s.hash : `#${e.fragmentIdentifier}`;
  }
  return `${r}${a}${o}`;
}
function ok(e, t, r) {
  r = {
    parseFragmentIdentifier: !0,
    [M5]: !1,
    ...r
  };
  const { url: n, query: i, fragmentIdentifier: a } = ik(e, r);
  return ak({
    url: n,
    query: mne(i, t),
    fragmentIdentifier: a
  }, r);
}
function $ne(e, t, r) {
  const n = Array.isArray(t) ? (i) => !t.includes(i) : (i, a) => !t(i, a);
  return ok(e, n, r);
}
const sk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude: $ne,
  extract: p3,
  parse: m3,
  parseUrl: ik,
  pick: ok,
  stringify: nk,
  stringifyUrl: ak
}, Symbol.toStringTag, { value: "Module" })), kne = (e = window.location.search) => {
  if (!e)
    return !1;
  const t = sk.parse(e);
  return "state" in t && "photon" in t && ("code" in t || "error" in t);
}, _ne = (e) => /^\d{5}(-\d{4})?$/.test(e);
function R5(e, t) {
  return e.every((r) => t.includes(r));
}
const xne = "0.20.4", Ene = {
  version: xne
};
var Sne = /* @__PURE__ */ re("<slot>"), Cne = /* @__PURE__ */ re("<div>");
const Tne = Ene?.version, Ane = (e) => {
  let t;
  const r = e.redirectUri ? e.redirectUri : window.location.origin, n = sk.stringifyUrl({
    url: r,
    query: {
      photon: !0
    }
  }), i = new jO({
    env: e.env,
    domain: e.domain,
    audience: e.audience,
    connection: e.connection,
    uri: e.uri,
    clientId: e.id,
    redirectURI: n,
    organization: e.org,
    developmentMode: e.developmentMode
  }, Tne), a = new cne(i, e.autoLogin);
  e.developmentMode && console.info("[PhotonClient]: Development mode enabled");
  const [o] = z(a), s = async () => {
    await o()?.authentication.handleRedirect(), e.redirectPath && window.location.replace(e.redirectPath);
  }, l = async () => {
    await o()?.authentication.checkSession(), une(async () => {
      await o()?.authentication.checkSession();
    }, 6e4, setInterval);
  };
  return le(() => {
    kne() && o() ? s() : o() && l();
  }), le(() => {
    if (!o()?.authentication.state.isLoading) {
      if (!o()?.authentication.state.isAuthenticated && e.autoLogin) {
        const d = {
          appState: {}
        };
        e.redirectPath && (d.appState.returnTo = e.redirectPath), o()?.authentication.login(d);
      } else if (
        // If `externalUserId` is set, then we check if it matches the logged in user
        // If it doesn't match then logout and then immediately log back in if possible
        e.externalUserId != null && // Note that we check the last piece of the `sub` which is the id from the auth provider
        // We do an exact match on this last section because ids are not guaranteed to not be substrings of the other
        o().authentication.state.user?.sub?.split("|").reverse()[0] !== e.externalUserId
      ) {
        o()?.authentication.logout();
        const d = {
          appState: {}
        };
        e.redirectPath && (d.appState.returnTo = e.redirectPath), o()?.authentication.login(d);
      }
    }
  }), (() => {
    var d = Cne(), c = t;
    return typeof c == "function" ? Rt(c, d) : t = d, N(d, v(mw.Provider, {
      get value() {
        return o();
      },
      get children() {
        return v(pee, {
          get children() {
            return v(EH, {
              client: i,
              get children() {
                var u = Sne();
                return u._$owner = Pe(), u;
              }
            });
          }
        });
      }
    })), d;
  })();
};
Xr("photon-client", {
  domain: {
    attribute: "domain",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  id: {
    attribute: "id",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  redirectUri: {
    attribute: "redirect-uri",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  redirectPath: {
    attribute: "redirect-path",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  org: {
    attribute: "org",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  audience: {
    attribute: "audience",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  connection: {
    attribute: "connection",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  uri: {
    attribute: "uri",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  developmentMode: {
    attribute: "dev-mode",
    value: !1,
    reflect: !0,
    notify: !1,
    parse: !0
  },
  errorMessage: {
    attribute: "error-message",
    value: "Oh snap! There was an error loading. Please contact your site's administrator",
    reflect: !1,
    notify: !1,
    parse: !1
  },
  autoLogin: {
    attribute: "auto-login",
    value: !1,
    reflect: !1,
    notify: !1,
    parse: !0
  },
  env: {
    attribute: "env",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  externalUserId: {
    attribute: "user-id",
    value: void 0,
    reflect: !0,
    notify: !0,
    parse: !1
  }
}, Ane);
const Tn = '*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(21 112 239 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(21 112 239 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }.container{width:100%}@media(min-width:475px){.container{max-width:475px}}@media(min-width:640px){.container{max-width:640px}}@media(min-width:768px){.container{max-width:768px}}@media(min-width:1024px){.container{max-width:1024px}}@media(min-width:1280px){.container{max-width:1280px}}@media(min-width:1536px){.container{max-width:1536px}}.visible{visibility:visible}.invisible{visibility:hidden}.fixed{position:fixed}.relative{position:relative}.sticky{position:sticky}.bottom-0{bottom:0}.left-0{left:0}.top-0{top:0}.z-2000{z-index:2000}.z-30{z-index:30}.z-40{z-index:40}.z-50{z-index:50}.m-0{margin:0}.m-3{margin:.75rem}.my-1{margin-top:.25rem;margin-bottom:.25rem}.\\!mt-8{margin-top:2rem!important}.mb-1{margin-bottom:.25rem}.mb-2{margin-bottom:.5rem}.mb-3{margin-bottom:.75rem}.mb-4{margin-bottom:1rem}.mb-8{margin-bottom:2rem}.ml-1{margin-left:.25rem}.mt-0{margin-top:0}.mt-1{margin-top:.25rem}.mt-2{margin-top:.5rem}.mt-4{margin-top:1rem}.mt-5{margin-top:1.25rem}.mt-6{margin-top:1.5rem}.mt-8{margin-top:2rem}.block{display:block}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.hidden{display:none}.h-10{height:2.5rem}.h-11{height:2.75rem}.h-\\[21px\\]{height:21px}.h-\\[28px\\]{height:28px}.h-fit{height:-moz-fit-content;height:fit-content}.h-full{height:100%}.h-screen{height:100vh}.min-h-screen{min-height:100vh}.w-11{width:2.75rem}.w-\\[44px\\]{width:44px}.w-full{width:100%}.w-screen{width:100vw}.min-w-0{min-width:0px}.min-w-\\[40\\%\\]{min-width:40%}.max-w-sm{max-width:24rem}.flex-1{flex:1 1 0%}.flex-shrink-0{flex-shrink:0}.flex-grow{flex-grow:1}.cursor-not-allowed{cursor:not-allowed}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.items-start{align-items:flex-start}.items-center{align-items:center}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-1{gap:.25rem}.gap-2{gap:.5rem}.gap-3{gap:.75rem}.gap-4{gap:1rem}.gap-8{gap:2rem}.space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.5rem * var(--tw-space-x-reverse));margin-left:calc(.5rem * (1 - var(--tw-space-x-reverse)))}.self-start{align-self:flex-start}.overflow-hidden{overflow:hidden}.overflow-y-auto{overflow-y:auto}.overflow-x-hidden{overflow-x:hidden}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.overflow-ellipsis{text-overflow:ellipsis}.whitespace-normal{white-space:normal}.whitespace-nowrap{white-space:nowrap}.break-words{overflow-wrap:break-word}.rounded{border-radius:.25rem}.rounded-lg{border-radius:.5rem}.border{border-width:1px}.border-2{border-width:2px}.border-none{border-style:none}.border-gray-200{--tw-border-opacity: 1;border-color:rgb(229,231,235,var(--tw-border-opacity))}.border-red-400{--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity))}.bg-\\[\\#F9FAFB\\]{--tw-bg-opacity: 1;background-color:rgb(249,250,251,var(--tw-bg-opacity))}.bg-blue-500{--tw-bg-opacity: 1;background-color:rgb(21,112,239,var(--tw-bg-opacity))}.bg-photon-blue{--tw-bg-opacity: 1;background-color:rgb(49,130,206,var(--tw-bg-opacity))}.bg-red-100{--tw-bg-opacity: 1;background-color:rgb(254,226,226,var(--tw-bg-opacity))}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255,255,255,var(--tw-bg-opacity))}.p-0{padding:0}.p-4{padding:1rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-4{padding-left:1rem;padding-right:1rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-4{padding-top:1rem;padding-bottom:1rem}.pb-2{padding-bottom:.5rem}.pb-4{padding-bottom:1rem}.pb-40{padding-bottom:10rem}.pl-1{padding-left:.25rem}.pl-2{padding-left:.5rem}.pl-5{padding-left:1.25rem}.pl-\\[19\\.75px\\]{padding-left:19.75px}.pr-2{padding-right:.5rem}.pr-5{padding-right:1.25rem}.pt-1{padding-top:.25rem}.pt-14{padding-top:3.5rem}.pt-3{padding-top:.75rem}.text-center{text-align:center}.font-sans{font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji"}.text-3xl{font-size:1.875rem;line-height:2.25rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.text-xs{font-size:.75rem;line-height:1rem}.font-extrabold{font-weight:800}.font-light{font-weight:300}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.italic{font-style:italic}.leading-snug{line-height:1.375}.text-black{--tw-text-opacity: 1;color:rgb(0,0,0,var(--tw-text-opacity))}.text-blue-600{--tw-text-opacity: 1;color:rgb(23,92,211,var(--tw-text-opacity))}.text-gray-400{--tw-text-opacity: 1;color:rgb(156,163,175,var(--tw-text-opacity))}.text-gray-500{--tw-text-opacity: 1;color:rgb(107,114,128,var(--tw-text-opacity))}.text-gray-700{--tw-text-opacity: 1;color:rgb(55,65,81,var(--tw-text-opacity))}.text-red-400{--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}.text-red-500{--tw-text-opacity: 1;color:rgb(239,68,68,var(--tw-text-opacity))}.text-red-700{--tw-text-opacity: 1;color:rgb(185,28,28,var(--tw-text-opacity))}.text-slate-500{--tw-text-opacity: 1;color:rgb(100,116,139,var(--tw-text-opacity))}.text-teal-600{--tw-text-opacity: 1;color:rgb(13,148,136,var(--tw-text-opacity))}.text-white{--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.opacity-50{opacity:.5}.shadow-card{--tw-shadow: 0px 0px 1px rgba(48, 49, 51, .05),0px 2px 4px rgba(48, 49, 51, .1);--tw-shadow-colored: 0px 0px 1px var(--tw-shadow-color), 0px 2px 4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.hover\\:cursor-pointer:hover{cursor:pointer}.hover\\:bg-blue-700:hover{--tw-bg-opacity: 1;background-color:rgb(24,73,169,var(--tw-bg-opacity))}.hover\\:bg-photon-blue-dark:hover{--tw-bg-opacity: 1;background-color:rgb(43,108,176,var(--tw-bg-opacity))}.hover\\:text-gray-600:hover{--tw-text-opacity: 1;color:rgb(75,85,99,var(--tw-text-opacity))}.hover\\:underline:hover{text-decoration-line:underline}.disabled\\:bg-gray-500:disabled{--tw-bg-opacity: 1;background-color:rgb(107,114,128,var(--tw-bg-opacity))}@media(min-width:475px){.xs\\:mx-auto{margin-left:auto;margin-right:auto}.xs\\:\\!w-auto{width:auto!important}.xs\\:w-fit{width:-moz-fit-content;width:fit-content}.xs\\:flex-row{flex-direction:row}.xs\\:flex-row-reverse{flex-direction:row-reverse}.xs\\:justify-start{justify-content:flex-start}.xs\\:text-base{font-size:1rem;line-height:1.5rem}}@media(min-width:640px){.sm\\:inline{display:inline}.sm\\:grid{display:grid}.sm\\:h-12{height:3rem}.sm\\:w-\\[600px\\]{width:600px}.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:gap-4{gap:1rem}.sm\\:px-4{padding-left:1rem;padding-right:1rem}}@media(min-width:768px){.md\\:\\!mt-8{margin-top:2rem!important}.md\\:\\!block{display:block!important}.md\\:flex{display:flex}.md\\:\\!hidden{display:none!important}.md\\:px-4{padding-left:1rem;padding-right:1rem}.md\\:px-8{padding-left:2rem;padding-right:2rem}.md\\:py-3{padding-top:.75rem;padding-bottom:.75rem}.md\\:pb-52{padding-bottom:13rem}.md\\:pt-4{padding-top:1rem}.md\\:text-3xl{font-size:1.875rem;line-height:2.25rem}.md\\:text-xl{font-size:1.25rem;line-height:1.75rem}}';
var One = /* @__PURE__ */ re("<style>"), Pne = /* @__PURE__ */ re('<button class="w-full disabled:bg-gray-500 bg-photon-blue hover:bg-blue-700 text-white h-10 px-4 rounded-lg font-sans hover:bg-photon-blue-dark transition ease-in-out delay-50">');
const Ine = (e) => {
  const t = Cn();
  return le(() => {
    t || console.error("[photon-auth-button] No valid PhotonClient instance was provided. Please ensure you are wrapping the element in a photon-client element");
  }), [(() => {
    var r = One();
    return N(r, Tn), r;
  })(), t ? (() => {
    var r = Pne();
    return r.$$click = async () => {
      const n = {
        appState: {}
      };
      e.redirectPath && (n.appState.returnTo = e.redirectPath), t.authentication.state.isAuthenticated ? await t.authentication.logout() : await t.authentication.login(n);
    }, N(r, () => t.authentication.state.isAuthenticated ? "Log out" : "Log in"), te(() => r.disabled = t.authentication.state.isLoading), r;
  })() : null];
};
Xr("photon-auth-button", {
  redirectPath: {
    attribute: "redirect-path",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  }
}, Ine);
ns(["click"]);
var Dne = /* @__PURE__ */ re("<style>"), Nne = /* @__PURE__ */ re(`<div class="flex flex-col w-screen max-w-sm"><svg viewBox="0 0 305 62.61"xmlns=http://www.w3.org/2000/svg class="h-[28px] pl-[19.75px]"><g fill=#273D52><path d="M0 54.1169H6.81375V35.7722H18.0826C29.5481 35.7722 34.3963 30.3343 34.3963 18.7378V17.4275C34.3963 5.76548 29.417 0.655167 18.0826 0.655167H0V54.1169ZM6.81375 30.1377V6.28961H18.2792C24.7653 6.28961 27.386 8.9758 27.386 16.0516V20.0481C27.386 27.1895 24.7653 30.1377 18.2792 30.1377H6.81375Z"></path><path d="M70.9593 54.1169H77.773V0.655167H70.9593V24.4378H50.8456V0.655167H44.0319V54.1169H50.8456V30.3343H70.9593V54.1169Z"></path><path d="M107.146 54.772C119.528 54.772 125.687 46.5169 125.687 34.9205V19.7861C125.687 8.25511 119.528 0 107.146 0C94.6974 0 88.5388 8.25511 88.5388 19.7861V34.9205C88.5388 46.5169 94.6974 54.772 107.146 54.772ZM95.5491 35.9687V18.8033C95.5491 10.7448 99.4801 5.89651 107.146 5.89651C114.745 5.89651 118.677 10.7448 118.677 18.8033V35.9687C118.677 44.0928 114.745 48.8755 107.146 48.8755C99.4801 48.8755 95.5491 44.0928 95.5491 35.9687Z"></path><path d="M144.295 54.1169H151.109V6.48616H164.54V0.655167H130.864V6.48616H144.295V54.1169Z"></path><path d="M188.299 54.772C200.682 54.772 206.841 46.5169 206.841 34.9205V19.7861C206.841 8.25511 200.682 0 188.299 0C175.851 0 169.693 8.25511 169.693 19.7861V34.9205C169.693 46.5169 175.851 54.772 188.299 54.772ZM176.703 35.9687V18.8033C176.703 10.7448 180.634 5.89651 188.299 5.89651C195.899 5.89651 199.83 10.7448 199.83 18.8033V35.9687C199.83 44.0928 195.899 48.8755 188.299 48.8755C180.634 48.8755 176.703 44.0928 176.703 35.9687Z"></path><path d="M217.6 54.1169H224.021V14.3482L245.576 54.1169H252.608L248.058 45.1084L245.641 40.4239L224.086 0.655167H217.6V54.1169Z"></path></g><g fill=#B35724><circle cx=249.798 cy=5.202 r=5.202></circle></g></svg><h1 class="font-medium text-3xl text-center font-sans mt-6 mb-3">Log in to your account</h1><p class="text-gray-500 font-sans text-center mb-8">Don't have an account? <a href=mailto:support@photon.health class="text-teal-600 hover:underline hover:cursor-pointer font-sans font-light">Contact Support</a></p><photon-auth-button>`, !0, !1, !1);
const Mne = (e) => {
  const t = Cn();
  return le(() => {
    t || console.error("[photon-login] No valid PhotonClient instance was provided. Please ensure you are wrapping the element in a photon-client element");
  }), [(() => {
    var r = Dne();
    return N(r, Tn), r;
  })(), (() => {
    var r = Nne(), n = r.firstChild, i = n.nextSibling, a = i.nextSibling, o = a.nextSibling;
    return o._$owner = Pe(), te(() => o.redirectPath = e.redirectPath), r;
  })()];
};
Xr("photon-login", {
  redirectPath: {
    attribute: "redirect-path",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  }
}, Mne);
const hh = (e, t) => {
  let r;
  const n = () => clearTimeout(r);
  return Pe() && _r(n), Object.assign((...a) => {
    r !== void 0 && n(), r = setTimeout(() => e(...a), t);
  }, { clear: n });
};
const _0 = globalThis, g3 = _0.ShadowRoot && (_0.ShadyCSS === void 0 || _0.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, v3 = /* @__PURE__ */ Symbol(), j9 = /* @__PURE__ */ new WeakMap();
let lk = class {
  constructor(t, r, n) {
    if (this._$cssResult$ = !0, n !== v3) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = r;
  }
  get styleSheet() {
    let t = this.o;
    const r = this.t;
    if (g3 && t === void 0) {
      const n = r !== void 0 && r.length === 1;
      n && (t = j9.get(r)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), n && j9.set(r, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const Rne = (e) => new lk(typeof e == "string" ? e : e + "", void 0, v3), hn = (e, ...t) => {
  const r = e.length === 1 ? e[0] : t.reduce((n, i, a) => n + ((o) => {
    if (o._$cssResult$ === !0) return o.cssText;
    if (typeof o == "number") return o;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + o + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(i) + e[a + 1], e[0]);
  return new lk(r, e, v3);
}, Lne = (e, t) => {
  if (g3) e.adoptedStyleSheets = t.map((r) => r instanceof CSSStyleSheet ? r : r.styleSheet);
  else for (const r of t) {
    const n = document.createElement("style"), i = _0.litNonce;
    i !== void 0 && n.setAttribute("nonce", i), n.textContent = r.cssText, e.appendChild(n);
  }
}, z9 = g3 ? (e) => e : (e) => e instanceof CSSStyleSheet ? ((t) => {
  let r = "";
  for (const n of t.cssRules) r += n.cssText;
  return Rne(r);
})(e) : e;
const { is: Fne, defineProperty: jne, getOwnPropertyDescriptor: zne, getOwnPropertyNames: Vne, getOwnPropertySymbols: Une, getPrototypeOf: qne } = Object, fh = globalThis, V9 = fh.trustedTypes, Bne = V9 ? V9.emptyScript : "", Hne = fh.reactiveElementPolyfillSupport, Gd = (e, t) => e, kl = { toAttribute(e, t) {
  switch (t) {
    case Boolean:
      e = e ? Bne : null;
      break;
    case Object:
    case Array:
      e = e == null ? e : JSON.stringify(e);
  }
  return e;
}, fromAttribute(e, t) {
  let r = e;
  switch (t) {
    case Boolean:
      r = e !== null;
      break;
    case Number:
      r = e === null ? null : Number(e);
      break;
    case Object:
    case Array:
      try {
        r = JSON.parse(e);
      } catch {
        r = null;
      }
  }
  return r;
} }, y3 = (e, t) => !Fne(e, t), U9 = { attribute: !0, type: String, converter: kl, reflect: !1, useDefault: !1, hasChanged: y3 };
Symbol.metadata ??= /* @__PURE__ */ Symbol("metadata"), fh.litPropertyMetadata ??= /* @__PURE__ */ new WeakMap();
let Os = class extends HTMLElement {
  static addInitializer(t) {
    this._$Ei(), (this.l ??= []).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, r = U9) {
    if (r.state && (r.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((r = Object.create(r)).wrapped = !0), this.elementProperties.set(t, r), !r.noAccessor) {
      const n = /* @__PURE__ */ Symbol(), i = this.getPropertyDescriptor(t, n, r);
      i !== void 0 && jne(this.prototype, t, i);
    }
  }
  static getPropertyDescriptor(t, r, n) {
    const { get: i, set: a } = zne(this.prototype, t) ?? { get() {
      return this[r];
    }, set(o) {
      this[r] = o;
    } };
    return { get: i, set(o) {
      const s = i?.call(this);
      a?.call(this, o), this.requestUpdate(t, s, n);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) ?? U9;
  }
  static _$Ei() {
    if (this.hasOwnProperty(Gd("elementProperties"))) return;
    const t = qne(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(Gd("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(Gd("properties"))) {
      const r = this.properties, n = [...Vne(r), ...Une(r)];
      for (const i of n) this.createProperty(i, r[i]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const r = litPropertyMetadata.get(t);
      if (r !== void 0) for (const [n, i] of r) this.elementProperties.set(n, i);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [r, n] of this.elementProperties) {
      const i = this._$Eu(r, n);
      i !== void 0 && this._$Eh.set(i, r);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const r = [];
    if (Array.isArray(t)) {
      const n = new Set(t.flat(1 / 0).reverse());
      for (const i of n) r.unshift(z9(i));
    } else t !== void 0 && r.push(z9(t));
    return r;
  }
  static _$Eu(t, r) {
    const n = r.attribute;
    return n === !1 ? void 0 : typeof n == "string" ? n : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    this._$ES = new Promise((t) => this.enableUpdating = t), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t) => t(this));
  }
  addController(t) {
    (this._$EO ??= /* @__PURE__ */ new Set()).add(t), this.renderRoot !== void 0 && this.isConnected && t.hostConnected?.();
  }
  removeController(t) {
    this._$EO?.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), r = this.constructor.elementProperties;
    for (const n of r.keys()) this.hasOwnProperty(n) && (t.set(n, this[n]), delete this[n]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return Lne(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t) => t.hostConnected?.());
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    this._$EO?.forEach((t) => t.hostDisconnected?.());
  }
  attributeChangedCallback(t, r, n) {
    this._$AK(t, n);
  }
  _$ET(t, r) {
    const n = this.constructor.elementProperties.get(t), i = this.constructor._$Eu(t, n);
    if (i !== void 0 && n.reflect === !0) {
      const a = (n.converter?.toAttribute !== void 0 ? n.converter : kl).toAttribute(r, n.type);
      this._$Em = t, a == null ? this.removeAttribute(i) : this.setAttribute(i, a), this._$Em = null;
    }
  }
  _$AK(t, r) {
    const n = this.constructor, i = n._$Eh.get(t);
    if (i !== void 0 && this._$Em !== i) {
      const a = n.getPropertyOptions(i), o = typeof a.converter == "function" ? { fromAttribute: a.converter } : a.converter?.fromAttribute !== void 0 ? a.converter : kl;
      this._$Em = i;
      const s = o.fromAttribute(r, a.type);
      this[i] = s ?? this._$Ej?.get(i) ?? s, this._$Em = null;
    }
  }
  requestUpdate(t, r, n, i = !1, a) {
    if (t !== void 0) {
      const o = this.constructor;
      if (i === !1 && (a = this[t]), n ??= o.getPropertyOptions(t), !((n.hasChanged ?? y3)(a, r) || n.useDefault && n.reflect && a === this._$Ej?.get(t) && !this.hasAttribute(o._$Eu(t, n)))) return;
      this.C(t, r, n);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$EP());
  }
  C(t, r, { useDefault: n, reflect: i, wrapped: a }, o) {
    n && !(this._$Ej ??= /* @__PURE__ */ new Map()).has(t) && (this._$Ej.set(t, o ?? r ?? this[t]), a !== !0 || o !== void 0) || (this._$AL.has(t) || (this.hasUpdated || n || (r = void 0), this._$AL.set(t, r)), i === !0 && this._$Em !== t && (this._$Eq ??= /* @__PURE__ */ new Set()).add(t));
  }
  async _$EP() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (r) {
      Promise.reject(r);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
        for (const [i, a] of this._$Ep) this[i] = a;
        this._$Ep = void 0;
      }
      const n = this.constructor.elementProperties;
      if (n.size > 0) for (const [i, a] of n) {
        const { wrapped: o } = a, s = this[i];
        o !== !0 || this._$AL.has(i) || s === void 0 || this.C(i, void 0, a, s);
      }
    }
    let t = !1;
    const r = this._$AL;
    try {
      t = this.shouldUpdate(r), t ? (this.willUpdate(r), this._$EO?.forEach((n) => n.hostUpdate?.()), this.update(r)) : this._$EM();
    } catch (n) {
      throw t = !1, this._$EM(), n;
    }
    t && this._$AE(r);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    this._$EO?.forEach((r) => r.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EM() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Eq &&= this._$Eq.forEach((r) => this._$ET(r, this[r])), this._$EM();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
};
Os.elementStyles = [], Os.shadowRootOptions = { mode: "open" }, Os[Gd("elementProperties")] = /* @__PURE__ */ new Map(), Os[Gd("finalized")] = /* @__PURE__ */ new Map(), Hne?.({ ReactiveElement: Os }), (fh.reactiveElementVersions ??= []).push("2.1.2");
const b3 = globalThis, q9 = (e) => e, $1 = b3.trustedTypes, B9 = $1 ? $1.createPolicy("lit-html", { createHTML: (e) => e }) : void 0, dk = "$lit$", Oa = `lit$${Math.random().toFixed(9).slice(2)}$`, ck = "?" + Oa, Wne = `<${ck}>`, Xo = document, Pc = () => Xo.createComment(""), Ic = (e) => e === null || typeof e != "object" && typeof e != "function", w3 = Array.isArray, Kne = (e) => w3(e) || typeof e?.[Symbol.iterator] == "function", o2 = `[ 	
\f\r]`, vd = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, H9 = /-->/g, W9 = />/g, vo = RegExp(`>|${o2}(?:([^\\s"'>=/]+)(${o2}*=${o2}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), K9 = /'/g, Q9 = /"/g, uk = /^(?:script|style|textarea|title)$/i, Qne = (e) => (t, ...r) => ({ _$litType$: e, strings: t, values: r }), Jt = Qne(1), ni = /* @__PURE__ */ Symbol.for("lit-noChange"), tr = /* @__PURE__ */ Symbol.for("lit-nothing"), G9 = /* @__PURE__ */ new WeakMap(), Fo = Xo.createTreeWalker(Xo, 129);
function hk(e, t) {
  if (!w3(e) || !e.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return B9 !== void 0 ? B9.createHTML(t) : t;
}
const Gne = (e, t) => {
  const r = e.length - 1, n = [];
  let i, a = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", o = vd;
  for (let s = 0; s < r; s++) {
    const l = e[s];
    let d, c, u = -1, h = 0;
    for (; h < l.length && (o.lastIndex = h, c = o.exec(l), c !== null); ) h = o.lastIndex, o === vd ? c[1] === "!--" ? o = H9 : c[1] !== void 0 ? o = W9 : c[2] !== void 0 ? (uk.test(c[2]) && (i = RegExp("</" + c[2], "g")), o = vo) : c[3] !== void 0 && (o = vo) : o === vo ? c[0] === ">" ? (o = i ?? vd, u = -1) : c[1] === void 0 ? u = -2 : (u = o.lastIndex - c[2].length, d = c[1], o = c[3] === void 0 ? vo : c[3] === '"' ? Q9 : K9) : o === Q9 || o === K9 ? o = vo : o === H9 || o === W9 ? o = vd : (o = vo, i = void 0);
    const f = o === vo && e[s + 1].startsWith("/>") ? " " : "";
    a += o === vd ? l + Wne : u >= 0 ? (n.push(d), l.slice(0, u) + dk + l.slice(u) + Oa + f) : l + Oa + (u === -2 ? s : f);
  }
  return [hk(e, a + (e[r] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), n];
};
class Dc {
  constructor({ strings: t, _$litType$: r }, n) {
    let i;
    this.parts = [];
    let a = 0, o = 0;
    const s = t.length - 1, l = this.parts, [d, c] = Gne(t, r);
    if (this.el = Dc.createElement(d, n), Fo.currentNode = this.el.content, r === 2 || r === 3) {
      const u = this.el.content.firstChild;
      u.replaceWith(...u.childNodes);
    }
    for (; (i = Fo.nextNode()) !== null && l.length < s; ) {
      if (i.nodeType === 1) {
        if (i.hasAttributes()) for (const u of i.getAttributeNames()) if (u.endsWith(dk)) {
          const h = c[o++], f = i.getAttribute(u).split(Oa), p = /([.?@])?(.*)/.exec(h);
          l.push({ type: 1, index: a, name: p[2], strings: f, ctor: p[1] === "." ? Jne : p[1] === "?" ? Zne : p[1] === "@" ? Xne : ph }), i.removeAttribute(u);
        } else u.startsWith(Oa) && (l.push({ type: 6, index: a }), i.removeAttribute(u));
        if (uk.test(i.tagName)) {
          const u = i.textContent.split(Oa), h = u.length - 1;
          if (h > 0) {
            i.textContent = $1 ? $1.emptyScript : "";
            for (let f = 0; f < h; f++) i.append(u[f], Pc()), Fo.nextNode(), l.push({ type: 2, index: ++a });
            i.append(u[h], Pc());
          }
        }
      } else if (i.nodeType === 8) if (i.data === ck) l.push({ type: 2, index: a });
      else {
        let u = -1;
        for (; (u = i.data.indexOf(Oa, u + 1)) !== -1; ) l.push({ type: 7, index: a }), u += Oa.length - 1;
      }
      a++;
    }
  }
  static createElement(t, r) {
    const n = Xo.createElement("template");
    return n.innerHTML = t, n;
  }
}
function _l(e, t, r = e, n) {
  if (t === ni) return t;
  let i = n !== void 0 ? r._$Co?.[n] : r._$Cl;
  const a = Ic(t) ? void 0 : t._$litDirective$;
  return i?.constructor !== a && (i?._$AO?.(!1), a === void 0 ? i = void 0 : (i = new a(e), i._$AT(e, r, n)), n !== void 0 ? (r._$Co ??= [])[n] = i : r._$Cl = i), i !== void 0 && (t = _l(e, i._$AS(e, t.values), i, n)), t;
}
class Yne {
  constructor(t, r) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = r;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    const { el: { content: r }, parts: n } = this._$AD, i = (t?.creationScope ?? Xo).importNode(r, !0);
    Fo.currentNode = i;
    let a = Fo.nextNode(), o = 0, s = 0, l = n[0];
    for (; l !== void 0; ) {
      if (o === l.index) {
        let d;
        l.type === 2 ? d = new au(a, a.nextSibling, this, t) : l.type === 1 ? d = new l.ctor(a, l.name, l.strings, this, t) : l.type === 6 && (d = new eie(a, this, t)), this._$AV.push(d), l = n[++s];
      }
      o !== l?.index && (a = Fo.nextNode(), o++);
    }
    return Fo.currentNode = Xo, i;
  }
  p(t) {
    let r = 0;
    for (const n of this._$AV) n !== void 0 && (n.strings !== void 0 ? (n._$AI(t, n, r), r += n.strings.length - 2) : n._$AI(t[r])), r++;
  }
}
class au {
  get _$AU() {
    return this._$AM?._$AU ?? this._$Cv;
  }
  constructor(t, r, n, i) {
    this.type = 2, this._$AH = tr, this._$AN = void 0, this._$AA = t, this._$AB = r, this._$AM = n, this.options = i, this._$Cv = i?.isConnected ?? !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const r = this._$AM;
    return r !== void 0 && t?.nodeType === 11 && (t = r.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, r = this) {
    t = _l(this, t, r), Ic(t) ? t === tr || t == null || t === "" ? (this._$AH !== tr && this._$AR(), this._$AH = tr) : t !== this._$AH && t !== ni && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : Kne(t) ? this.k(t) : this._(t);
  }
  O(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  _(t) {
    this._$AH !== tr && Ic(this._$AH) ? this._$AA.nextSibling.data = t : this.T(Xo.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    const { values: r, _$litType$: n } = t, i = typeof n == "number" ? this._$AC(t) : (n.el === void 0 && (n.el = Dc.createElement(hk(n.h, n.h[0]), this.options)), n);
    if (this._$AH?._$AD === i) this._$AH.p(r);
    else {
      const a = new Yne(i, this), o = a.u(this.options);
      a.p(r), this.T(o), this._$AH = a;
    }
  }
  _$AC(t) {
    let r = G9.get(t.strings);
    return r === void 0 && G9.set(t.strings, r = new Dc(t)), r;
  }
  k(t) {
    w3(this._$AH) || (this._$AH = [], this._$AR());
    const r = this._$AH;
    let n, i = 0;
    for (const a of t) i === r.length ? r.push(n = new au(this.O(Pc()), this.O(Pc()), this, this.options)) : n = r[i], n._$AI(a), i++;
    i < r.length && (this._$AR(n && n._$AB.nextSibling, i), r.length = i);
  }
  _$AR(t = this._$AA.nextSibling, r) {
    for (this._$AP?.(!1, !0, r); t !== this._$AB; ) {
      const n = q9(t).nextSibling;
      q9(t).remove(), t = n;
    }
  }
  setConnected(t) {
    this._$AM === void 0 && (this._$Cv = t, this._$AP?.(t));
  }
}
class ph {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, r, n, i, a) {
    this.type = 1, this._$AH = tr, this._$AN = void 0, this.element = t, this.name = r, this._$AM = i, this.options = a, n.length > 2 || n[0] !== "" || n[1] !== "" ? (this._$AH = Array(n.length - 1).fill(new String()), this.strings = n) : this._$AH = tr;
  }
  _$AI(t, r = this, n, i) {
    const a = this.strings;
    let o = !1;
    if (a === void 0) t = _l(this, t, r, 0), o = !Ic(t) || t !== this._$AH && t !== ni, o && (this._$AH = t);
    else {
      const s = t;
      let l, d;
      for (t = a[0], l = 0; l < a.length - 1; l++) d = _l(this, s[n + l], r, l), d === ni && (d = this._$AH[l]), o ||= !Ic(d) || d !== this._$AH[l], d === tr ? t = tr : t !== tr && (t += (d ?? "") + a[l + 1]), this._$AH[l] = d;
    }
    o && !i && this.j(t);
  }
  j(t) {
    t === tr ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
  }
}
class Jne extends ph {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === tr ? void 0 : t;
  }
}
class Zne extends ph {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== tr);
  }
}
class Xne extends ph {
  constructor(t, r, n, i, a) {
    super(t, r, n, i, a), this.type = 5;
  }
  _$AI(t, r = this) {
    if ((t = _l(this, t, r, 0) ?? tr) === ni) return;
    const n = this._$AH, i = t === tr && n !== tr || t.capture !== n.capture || t.once !== n.once || t.passive !== n.passive, a = t !== tr && (n === tr || i);
    i && this.element.removeEventListener(this.name, this, n), a && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    typeof this._$AH == "function" ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
  }
}
class eie {
  constructor(t, r, n) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = r, this.options = n;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    _l(this, t);
  }
}
const tie = b3.litHtmlPolyfillSupport;
tie?.(Dc, au), (b3.litHtmlVersions ??= []).push("3.3.2");
const rie = (e, t, r) => {
  const n = r?.renderBefore ?? t;
  let i = n._$litPart$;
  if (i === void 0) {
    const a = r?.renderBefore ?? null;
    n._$litPart$ = i = new au(t.insertBefore(Pc(), a), a, void 0, r ?? {});
  }
  return i._$AI(e), i;
};
const $3 = globalThis;
let Yd = class extends Os {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    const t = super.createRenderRoot();
    return this.renderOptions.renderBefore ??= t.firstChild, t;
  }
  update(t) {
    const r = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = rie(r, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    super.connectedCallback(), this._$Do?.setConnected(!0);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._$Do?.setConnected(!1);
  }
  render() {
    return ni;
  }
};
Yd._$litElement$ = !0, Yd.finalized = !0, $3.litElementHydrateSupport?.({ LitElement: Yd });
const nie = $3.litElementPolyfillSupport;
nie?.({ LitElement: Yd });
($3.litElementVersions ??= []).push("4.2.2");
var iie = hn`
  :host {
    display: inline-block;
  }

  .dropdown::part(popup) {
    z-index: var(--sl-z-index-dropdown);
  }

  .dropdown[data-current-placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .dropdown[data-current-placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .dropdown[data-current-placement^='left']::part(popup) {
    transform-origin: right;
  }

  .dropdown[data-current-placement^='right']::part(popup) {
    transform-origin: left;
  }

  .dropdown__trigger {
    display: block;
  }

  .dropdown__panel {
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    box-shadow: var(--sl-shadow-large);
    border-radius: var(--sl-border-radius-medium);
    pointer-events: none;
  }

  .dropdown--open .dropdown__panel {
    display: block;
    pointer-events: all;
  }

  /* When users slot a menu, make sure it conforms to the popup's auto-size */
  ::slotted(sl-menu) {
    max-width: var(--auto-size-available-width) !important;
    max-height: var(--auto-size-available-height) !important;
  }
`, fk = Object.defineProperty, aie = Object.defineProperties, oie = Object.getOwnPropertyDescriptor, sie = Object.getOwnPropertyDescriptors, Y9 = Object.getOwnPropertySymbols, lie = Object.prototype.hasOwnProperty, die = Object.prototype.propertyIsEnumerable, s2 = (e, t) => (t = Symbol[e]) ? t : /* @__PURE__ */ Symbol.for("Symbol." + e), k3 = (e) => {
  throw TypeError(e);
}, J9 = (e, t, r) => t in e ? fk(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, ss = (e, t) => {
  for (var r in t || (t = {}))
    lie.call(t, r) && J9(e, r, t[r]);
  if (Y9)
    for (var r of Y9(t))
      die.call(t, r) && J9(e, r, t[r]);
  return e;
}, mh = (e, t) => aie(e, sie(t)), V = (e, t, r, n) => {
  for (var i = n > 1 ? void 0 : n ? oie(t, r) : t, a = e.length - 1, o; a >= 0; a--)
    (o = e[a]) && (i = (n ? o(t, r, i) : o(i)) || i);
  return n && i && fk(t, r, i), i;
}, pk = (e, t, r) => t.has(e) || k3("Cannot " + r), cie = (e, t, r) => (pk(e, t, "read from private field"), t.get(e)), uie = (e, t, r) => t.has(e) ? k3("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), hie = (e, t, r, n) => (pk(e, t, "write to private field"), t.set(e, r), r), fie = function(e, t) {
  this[0] = e, this[1] = t;
}, pie = (e) => {
  var t = e[s2("asyncIterator")], r = !1, n, i = {};
  return t == null ? (t = e[s2("iterator")](), n = (a) => i[a] = (o) => t[a](o)) : (t = t.call(e), n = (a) => i[a] = (o) => {
    if (r) {
      if (r = !1, a === "throw") throw o;
      return o;
    }
    return r = !0, {
      done: !1,
      value: new fie(new Promise((s) => {
        var l = t[a](o);
        l instanceof Object || k3("Object expected"), s(l);
      }), 1)
    };
  }), i[s2("iterator")] = () => i, n("next"), "throw" in t ? n("throw") : i.throw = (a) => {
    throw a;
  }, "return" in t && n("return"), i;
};
function* _3(e = document.activeElement) {
  e != null && (yield e, "shadowRoot" in e && e.shadowRoot && e.shadowRoot.mode !== "closed" && (yield* pie(_3(e.shadowRoot.activeElement))));
}
function mk() {
  return [..._3()].pop();
}
var Z9 = /* @__PURE__ */ new WeakMap();
function gk(e) {
  let t = Z9.get(e);
  return t || (t = window.getComputedStyle(e, null), Z9.set(e, t)), t;
}
function mie(e) {
  if (typeof e.checkVisibility == "function")
    return e.checkVisibility({ checkOpacity: !1, checkVisibilityCSS: !0 });
  const t = gk(e);
  return t.visibility !== "hidden" && t.display !== "none";
}
function gie(e) {
  const t = gk(e), { overflowY: r, overflowX: n } = t;
  return r === "scroll" || n === "scroll" ? !0 : r !== "auto" || n !== "auto" ? !1 : e.scrollHeight > e.clientHeight && r === "auto" || e.scrollWidth > e.clientWidth && n === "auto";
}
function vie(e) {
  const t = e.tagName.toLowerCase(), r = Number(e.getAttribute("tabindex"));
  if (e.hasAttribute("tabindex") && (isNaN(r) || r <= -1) || e.hasAttribute("disabled") || e.closest("[inert]"))
    return !1;
  if (t === "input" && e.getAttribute("type") === "radio") {
    const a = e.getRootNode(), o = `input[type='radio'][name="${e.getAttribute("name")}"]`, s = a.querySelector(`${o}:checked`);
    return s ? s === e : a.querySelector(o) === e;
  }
  return mie(e) ? (t === "audio" || t === "video") && e.hasAttribute("controls") || e.hasAttribute("tabindex") || e.hasAttribute("contenteditable") && e.getAttribute("contenteditable") !== "false" || [
    "button",
    "input",
    "select",
    "textarea",
    "a",
    "audio",
    "video",
    "summary",
    "iframe"
  ].includes(t) ? !0 : gie(e) : !1;
}
function yie(e) {
  var t, r;
  const n = L5(e), i = (t = n[0]) != null ? t : null, a = (r = n[n.length - 1]) != null ? r : null;
  return { start: i, end: a };
}
function bie(e, t) {
  var r;
  return ((r = e.getRootNode({ composed: !0 })) == null ? void 0 : r.host) !== t;
}
function L5(e) {
  const t = /* @__PURE__ */ new WeakMap(), r = [];
  function n(i) {
    if (i instanceof Element) {
      if (i.hasAttribute("inert") || i.closest("[inert]") || t.has(i))
        return;
      t.set(i, !0), !r.includes(i) && vie(i) && r.push(i), i instanceof HTMLSlotElement && bie(i, e) && i.assignedElements({ flatten: !0 }).forEach((a) => {
        n(a);
      }), i.shadowRoot !== null && i.shadowRoot.mode === "open" && n(i.shadowRoot);
    }
    for (const a of i.children)
      n(a);
  }
  return n(e), r.sort((i, a) => {
    const o = Number(i.getAttribute("tabindex")) || 0;
    return (Number(a.getAttribute("tabindex")) || 0) - o;
  });
}
var wie = hn`
  :host {
    --arrow-color: var(--sl-color-neutral-1000);
    --arrow-size: 6px;

    /*
     * These properties are computed to account for the arrow's dimensions after being rotated 45º. The constant
     * 0.7071 is derived from sin(45), which is the diagonal size of the arrow's container after rotating.
     */
    --arrow-size-diagonal: calc(var(--arrow-size) * 0.7071);
    --arrow-padding-offset: calc(var(--arrow-size-diagonal) - var(--arrow-size));

    display: contents;
  }

  .popup {
    position: absolute;
    isolation: isolate;
    max-width: var(--auto-size-available-width, none);
    max-height: var(--auto-size-available-height, none);
  }

  .popup--fixed {
    position: fixed;
  }

  .popup:not(.popup--active) {
    display: none;
  }

  .popup__arrow {
    position: absolute;
    width: calc(var(--arrow-size-diagonal) * 2);
    height: calc(var(--arrow-size-diagonal) * 2);
    rotate: 45deg;
    background: var(--arrow-color);
    z-index: -1;
  }

  /* Hover bridge */
  .popup-hover-bridge:not(.popup-hover-bridge--visible) {
    display: none;
  }

  .popup-hover-bridge {
    position: fixed;
    z-index: calc(var(--sl-z-index-dropdown) - 1);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    clip-path: polygon(
      var(--hover-bridge-top-left-x, 0) var(--hover-bridge-top-left-y, 0),
      var(--hover-bridge-top-right-x, 0) var(--hover-bridge-top-right-y, 0),
      var(--hover-bridge-bottom-right-x, 0) var(--hover-bridge-bottom-right-y, 0),
      var(--hover-bridge-bottom-left-x, 0) var(--hover-bridge-bottom-left-y, 0)
    );
  }
`;
const F5 = /* @__PURE__ */ new Set(), Hs = /* @__PURE__ */ new Map();
let Do, x3 = "ltr", E3 = "en";
const vk = typeof MutationObserver < "u" && typeof document < "u" && typeof document.documentElement < "u";
if (vk) {
  const e = new MutationObserver(bk);
  x3 = document.documentElement.dir || "ltr", E3 = document.documentElement.lang || navigator.language, e.observe(document.documentElement, {
    attributes: !0,
    attributeFilter: ["dir", "lang"]
  });
}
function yk(...e) {
  e.map((t) => {
    const r = t.$code.toLowerCase();
    Hs.has(r) ? Hs.set(r, Object.assign(Object.assign({}, Hs.get(r)), t)) : Hs.set(r, t), Do || (Do = t);
  }), bk();
}
function bk() {
  vk && (x3 = document.documentElement.dir || "ltr", E3 = document.documentElement.lang || navigator.language), [...F5.keys()].map((e) => {
    typeof e.requestUpdate == "function" && e.requestUpdate();
  });
}
let $ie = class {
  constructor(t) {
    this.host = t, this.host.addController(this);
  }
  hostConnected() {
    F5.add(this.host);
  }
  hostDisconnected() {
    F5.delete(this.host);
  }
  dir() {
    return `${this.host.dir || x3}`.toLowerCase();
  }
  lang() {
    return `${this.host.lang || E3}`.toLowerCase();
  }
  getTranslationData(t) {
    var r, n;
    const i = new Intl.Locale(t.replace(/_/g, "-")), a = i?.language.toLowerCase(), o = (n = (r = i?.region) === null || r === void 0 ? void 0 : r.toLowerCase()) !== null && n !== void 0 ? n : "", s = Hs.get(`${a}-${o}`), l = Hs.get(a);
    return { locale: i, language: a, region: o, primary: s, secondary: l };
  }
  exists(t, r) {
    var n;
    const { primary: i, secondary: a } = this.getTranslationData((n = r.lang) !== null && n !== void 0 ? n : this.lang());
    return r = Object.assign({ includeFallback: !1 }, r), !!(i && i[t] || a && a[t] || r.includeFallback && Do && Do[t]);
  }
  term(t, ...r) {
    const { primary: n, secondary: i } = this.getTranslationData(this.lang());
    let a;
    if (n && n[t])
      a = n[t];
    else if (i && i[t])
      a = i[t];
    else if (Do && Do[t])
      a = Do[t];
    else
      return console.error(`No translation found for: ${String(t)}`), String(t);
    return typeof a == "function" ? a(...r) : a;
  }
  date(t, r) {
    return t = new Date(t), new Intl.DateTimeFormat(this.lang(), r).format(t);
  }
  number(t, r) {
    return t = Number(t), isNaN(t) ? "" : new Intl.NumberFormat(this.lang(), r).format(t);
  }
  relativeTime(t, r, n) {
    return new Intl.RelativeTimeFormat(this.lang(), n).format(t, r);
  }
};
var wk = {
  $code: "en",
  $name: "English",
  $dir: "ltr",
  carousel: "Carousel",
  clearEntry: "Clear entry",
  close: "Close",
  copied: "Copied",
  copy: "Copy",
  currentValue: "Current value",
  error: "Error",
  goToSlide: (e, t) => `Go to slide ${e} of ${t}`,
  hidePassword: "Hide password",
  loading: "Loading",
  nextSlide: "Next slide",
  numOptionsSelected: (e) => e === 0 ? "No options selected" : e === 1 ? "1 option selected" : `${e} options selected`,
  previousSlide: "Previous slide",
  progress: "Progress",
  remove: "Remove",
  resize: "Resize",
  scrollToEnd: "Scroll to end",
  scrollToStart: "Scroll to start",
  selectAColorFromTheScreen: "Select a color from the screen",
  showPassword: "Show password",
  slideNum: (e) => `Slide ${e}`,
  toggleColorFormat: "Toggle color format"
};
yk(wk);
var kie = wk, ro = class extends $ie {
};
yk(kie);
var zn = hn`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }
`;
const _ie = { attribute: !0, type: String, converter: kl, reflect: !1, hasChanged: y3 }, xie = (e = _ie, t, r) => {
  const { kind: n, metadata: i } = r;
  let a = globalThis.litPropertyMetadata.get(i);
  if (a === void 0 && globalThis.litPropertyMetadata.set(i, a = /* @__PURE__ */ new Map()), n === "setter" && ((e = Object.create(e)).wrapped = !0), a.set(r.name, e), n === "accessor") {
    const { name: o } = r;
    return { set(s) {
      const l = t.get.call(this);
      t.set.call(this, s), this.requestUpdate(o, l, e, !0, s);
    }, init(s) {
      return s !== void 0 && this.C(o, void 0, e, s), s;
    } };
  }
  if (n === "setter") {
    const { name: o } = r;
    return function(s) {
      const l = this[o];
      t.call(this, s), this.requestUpdate(o, l, e, !0, s);
    };
  }
  throw Error("Unsupported decorator location: " + n);
};
function ne(e) {
  return (t, r) => typeof r == "object" ? xie(e, t, r) : ((n, i, a) => {
    const o = i.hasOwnProperty(a);
    return i.constructor.createProperty(a, n), o ? Object.getOwnPropertyDescriptor(i, a) : void 0;
  })(e, t, r);
}
function ou(e) {
  return ne({ ...e, state: !0, attribute: !1 });
}
const Eie = (e, t, r) => (r.configurable = !0, r.enumerable = !0, Reflect.decorate && typeof t != "object" && Object.defineProperty(e, t, r), r);
function Er(e, t) {
  return (r, n, i) => {
    const a = (o) => o.renderRoot?.querySelector(e) ?? null;
    return Eie(r, n, { get() {
      return a(this);
    } });
  };
}
var x0, Br = class extends Yd {
  constructor() {
    super(), uie(this, x0, !1), this.initialReflectedProperties = /* @__PURE__ */ new Map(), Object.entries(this.constructor.dependencies).forEach(([e, t]) => {
      this.constructor.define(e, t);
    });
  }
  emit(e, t) {
    const r = new CustomEvent(e, ss({
      bubbles: !0,
      cancelable: !1,
      composed: !0,
      detail: {}
    }, t));
    return this.dispatchEvent(r), r;
  }
  /* eslint-enable */
  static define(e, t = this, r = {}) {
    const n = customElements.get(e);
    if (!n) {
      try {
        customElements.define(e, t, r);
      } catch {
        customElements.define(e, class extends t {
        }, r);
      }
      return;
    }
    let i = " (unknown version)", a = i;
    "version" in t && t.version && (i = " v" + t.version), "version" in n && n.version && (a = " v" + n.version), !(i && a && i === a) && console.warn(
      `Attempted to register <${e}>${i}, but <${e}>${a} has already been registered.`
    );
  }
  attributeChangedCallback(e, t, r) {
    cie(this, x0) || (this.constructor.elementProperties.forEach(
      (n, i) => {
        n.reflect && this[i] != null && this.initialReflectedProperties.set(i, this[i]);
      }
    ), hie(this, x0, !0)), super.attributeChangedCallback(e, t, r);
  }
  willUpdate(e) {
    super.willUpdate(e), this.initialReflectedProperties.forEach((t, r) => {
      e.has(r) && this[r] == null && (this[r] = t);
    });
  }
};
x0 = /* @__PURE__ */ new WeakMap();
Br.version = "2.20.1";
Br.dependencies = {};
V([
  ne()
], Br.prototype, "dir", 2);
V([
  ne()
], Br.prototype, "lang", 2);
const Ga = Math.min, yn = Math.max, k1 = Math.round, Zu = Math.floor, Oi = (e) => ({
  x: e,
  y: e
}), Sie = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function j5(e, t, r) {
  return yn(e, Ga(t, r));
}
function Bl(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ya(e) {
  return e.split("-")[0];
}
function Hl(e) {
  return e.split("-")[1];
}
function $k(e) {
  return e === "x" ? "y" : "x";
}
function S3(e) {
  return e === "y" ? "height" : "width";
}
function Yi(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function C3(e) {
  return $k(Yi(e));
}
function Cie(e, t, r) {
  r === void 0 && (r = !1);
  const n = Hl(e), i = C3(e), a = S3(i);
  let o = i === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (o = _1(o)), [o, _1(o)];
}
function Tie(e) {
  const t = _1(e);
  return [z5(e), t, z5(t)];
}
function z5(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const X9 = ["left", "right"], e7 = ["right", "left"], Aie = ["top", "bottom"], Oie = ["bottom", "top"];
function Pie(e, t, r) {
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? e7 : X9 : t ? X9 : e7;
    case "left":
    case "right":
      return t ? Aie : Oie;
    default:
      return [];
  }
}
function Iie(e, t, r, n) {
  const i = Hl(e);
  let a = Pie(Ya(e), r === "start", n);
  return i && (a = a.map((o) => o + "-" + i), t && (a = a.concat(a.map(z5)))), a;
}
function _1(e) {
  const t = Ya(e);
  return Sie[t] + e.slice(t.length);
}
function Die(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function kk(e) {
  return typeof e != "number" ? Die(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function x1(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: i
  } = e;
  return {
    width: n,
    height: i,
    top: r,
    left: t,
    right: t + n,
    bottom: r + i,
    x: t,
    y: r
  };
}
function t7(e, t, r) {
  let {
    reference: n,
    floating: i
  } = e;
  const a = Yi(t), o = C3(t), s = S3(o), l = Ya(t), d = a === "y", c = n.x + n.width / 2 - i.width / 2, u = n.y + n.height / 2 - i.height / 2, h = n[s] / 2 - i[s] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: c,
        y: n.y - i.height
      };
      break;
    case "bottom":
      f = {
        x: c,
        y: n.y + n.height
      };
      break;
    case "right":
      f = {
        x: n.x + n.width,
        y: u
      };
      break;
    case "left":
      f = {
        x: n.x - i.width,
        y: u
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  switch (Hl(t)) {
    case "start":
      f[o] -= h * (r && d ? -1 : 1);
      break;
    case "end":
      f[o] += h * (r && d ? -1 : 1);
      break;
  }
  return f;
}
async function Nie(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: i,
    platform: a,
    rects: o,
    elements: s,
    strategy: l
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: u = "floating",
    altBoundary: h = !1,
    padding: f = 0
  } = Bl(t, e), p = kk(f), y = s[h ? u === "floating" ? "reference" : "floating" : u], g = x1(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(y))) == null || r ? y : y.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: d,
    rootBoundary: c,
    strategy: l
  })), w = u === "floating" ? {
    x: n,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, $ = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), _ = await (a.isElement == null ? void 0 : a.isElement($)) ? await (a.getScale == null ? void 0 : a.getScale($)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = x1(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: w,
    offsetParent: $,
    strategy: l
  }) : w);
  return {
    top: (g.top - x.top + p.top) / _.y,
    bottom: (x.bottom - g.bottom + p.bottom) / _.y,
    left: (g.left - x.left + p.left) / _.x,
    right: (x.right - g.right + p.right) / _.x
  };
}
const Mie = 50, Rie = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: o
  } = r, s = o.detectOverflow ? o : {
    ...o,
    detectOverflow: Nie
  }, l = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let d = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: c,
    y: u
  } = t7(d, n, l), h = n, f = 0;
  const p = {};
  for (let m = 0; m < a.length; m++) {
    const y = a[m];
    if (!y)
      continue;
    const {
      name: g,
      fn: w
    } = y, {
      x: $,
      y: _,
      data: x,
      reset: S
    } = await w({
      x: c,
      y: u,
      initialPlacement: n,
      placement: h,
      strategy: i,
      middlewareData: p,
      rects: d,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = $ ?? c, u = _ ?? u, p[g] = {
      ...p[g],
      ...x
    }, S && f < Mie && (f++, typeof S == "object" && (S.placement && (h = S.placement), S.rects && (d = S.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : S.rects), {
      x: c,
      y: u
    } = t7(d, h, l)), m = -1);
  }
  return {
    x: c,
    y: u,
    placement: h,
    strategy: i,
    middlewareData: p
  };
}, Lie = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: i,
      rects: a,
      platform: o,
      elements: s,
      middlewareData: l
    } = t, {
      element: d,
      padding: c = 0
    } = Bl(e, t) || {};
    if (d == null)
      return {};
    const u = kk(c), h = {
      x: r,
      y: n
    }, f = C3(i), p = S3(f), m = await o.getDimensions(d), y = f === "y", g = y ? "top" : "left", w = y ? "bottom" : "right", $ = y ? "clientHeight" : "clientWidth", _ = a.reference[p] + a.reference[f] - h[f] - a.floating[p], x = h[f] - a.reference[f], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(d));
    let T = S ? S[$] : 0;
    (!T || !await (o.isElement == null ? void 0 : o.isElement(S))) && (T = s.floating[$] || a.floating[p]);
    const I = _ / 2 - x / 2, M = T / 2 - m[p] / 2 - 1, P = Ga(u[g], M), O = Ga(u[w], M), D = P, R = T - m[p] - O, L = T / 2 - m[p] / 2 + I, Q = j5(D, L, R), ie = !l.arrow && Hl(i) != null && L !== Q && a.reference[p] / 2 - (L < D ? P : O) - m[p] / 2 < 0, ee = ie ? L < D ? L - D : L - R : 0;
    return {
      [f]: h[f] + ee,
      data: {
        [f]: Q,
        centerOffset: L - Q - ee,
        ...ie && {
          alignmentOffset: ee
        }
      },
      reset: ie
    };
  }
}), Fie = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: i,
        middlewareData: a,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: d
      } = t, {
        mainAxis: c = !0,
        crossAxis: u = !0,
        fallbackPlacements: h,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: m = !0,
        ...y
      } = Bl(e, t);
      if ((r = a.arrow) != null && r.alignmentOffset)
        return {};
      const g = Ya(i), w = Yi(s), $ = Ya(s) === s, _ = await (l.isRTL == null ? void 0 : l.isRTL(d.floating)), x = h || ($ || !m ? [_1(s)] : Tie(s)), S = p !== "none";
      !h && S && x.push(...Iie(s, m, p, _));
      const T = [s, ...x], I = await l.detectOverflow(t, y), M = [];
      let P = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (c && M.push(I[g]), u) {
        const L = Cie(i, o, _);
        M.push(I[L[0]], I[L[1]]);
      }
      if (P = [...P, {
        placement: i,
        overflows: M
      }], !M.every((L) => L <= 0)) {
        var O, D;
        const L = (((O = a.flip) == null ? void 0 : O.index) || 0) + 1, Q = T[L];
        if (Q && (!(u === "alignment" ? w !== Yi(Q) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        P.every((W) => Yi(W.placement) === w ? W.overflows[0] > 0 : !0)))
          return {
            data: {
              index: L,
              overflows: P
            },
            reset: {
              placement: Q
            }
          };
        let ie = (D = P.filter((ee) => ee.overflows[0] <= 0).sort((ee, W) => ee.overflows[1] - W.overflows[1])[0]) == null ? void 0 : D.placement;
        if (!ie)
          switch (f) {
            case "bestFit": {
              var R;
              const ee = (R = P.filter((W) => {
                if (S) {
                  const H = Yi(W.placement);
                  return H === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  H === "y";
                }
                return !0;
              }).map((W) => [W.placement, W.overflows.filter((H) => H > 0).reduce((H, pe) => H + pe, 0)]).sort((W, H) => W[1] - H[1])[0]) == null ? void 0 : R[0];
              ee && (ie = ee);
              break;
            }
            case "initialPlacement":
              ie = s;
              break;
          }
        if (i !== ie)
          return {
            reset: {
              placement: ie
            }
          };
      }
      return {};
    }
  };
}, jie = /* @__PURE__ */ new Set(["left", "top"]);
async function zie(e, t) {
  const {
    placement: r,
    platform: n,
    elements: i
  } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), o = Ya(r), s = Hl(r), l = Yi(r) === "y", d = jie.has(o) ? -1 : 1, c = a && l ? -1 : 1, u = Bl(t, e);
  let {
    mainAxis: h,
    crossAxis: f,
    alignmentAxis: p
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof p == "number" && (f = s === "end" ? p * -1 : p), l ? {
    x: f * c,
    y: h * d
  } : {
    x: h * d,
    y: f * c
  };
}
const Vie = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: i,
        y: a,
        placement: o,
        middlewareData: s
      } = t, l = await zie(t, e);
      return o === ((r = s.offset) == null ? void 0 : r.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: i + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, Uie = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: i,
        platform: a
      } = t, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: l = {
          fn: (g) => {
            let {
              x: w,
              y: $
            } = g;
            return {
              x: w,
              y: $
            };
          }
        },
        ...d
      } = Bl(e, t), c = {
        x: r,
        y: n
      }, u = await a.detectOverflow(t, d), h = Yi(Ya(i)), f = $k(h);
      let p = c[f], m = c[h];
      if (o) {
        const g = f === "y" ? "top" : "left", w = f === "y" ? "bottom" : "right", $ = p + u[g], _ = p - u[w];
        p = j5($, p, _);
      }
      if (s) {
        const g = h === "y" ? "top" : "left", w = h === "y" ? "bottom" : "right", $ = m + u[g], _ = m - u[w];
        m = j5($, m, _);
      }
      const y = l.fn({
        ...t,
        [f]: p,
        [h]: m
      });
      return {
        ...y,
        data: {
          x: y.x - r,
          y: y.y - n,
          enabled: {
            [f]: o,
            [h]: s
          }
        }
      };
    }
  };
}, qie = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: i,
        rects: a,
        platform: o,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...d
      } = Bl(e, t), c = await o.detectOverflow(t, d), u = Ya(i), h = Hl(i), f = Yi(i) === "y", {
        width: p,
        height: m
      } = a.floating;
      let y, g;
      u === "top" || u === "bottom" ? (y = u, g = h === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (g = u, y = h === "end" ? "top" : "bottom");
      const w = m - c.top - c.bottom, $ = p - c.left - c.right, _ = Ga(m - c[y], w), x = Ga(p - c[g], $), S = !t.middlewareData.shift;
      let T = _, I = x;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (I = $), (n = t.middlewareData.shift) != null && n.enabled.y && (T = w), S && !h) {
        const P = yn(c.left, 0), O = yn(c.right, 0), D = yn(c.top, 0), R = yn(c.bottom, 0);
        f ? I = p - 2 * (P !== 0 || O !== 0 ? P + O : yn(c.left, c.right)) : T = m - 2 * (D !== 0 || R !== 0 ? D + R : yn(c.top, c.bottom));
      }
      await l({
        ...t,
        availableWidth: I,
        availableHeight: T
      });
      const M = await o.getDimensions(s.floating);
      return p !== M.width || m !== M.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function gh() {
  return typeof window < "u";
}
function Wl(e) {
  return _k(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function _n(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ji(e) {
  var t;
  return (t = (_k(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function _k(e) {
  return gh() ? e instanceof Node || e instanceof _n(e).Node : !1;
}
function ui(e) {
  return gh() ? e instanceof Element || e instanceof _n(e).Element : !1;
}
function ua(e) {
  return gh() ? e instanceof HTMLElement || e instanceof _n(e).HTMLElement : !1;
}
function r7(e) {
  return !gh() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof _n(e).ShadowRoot;
}
function su(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: i
  } = hi(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && i !== "inline" && i !== "contents";
}
function Bie(e) {
  return /^(table|td|th)$/.test(Wl(e));
}
function vh(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const Hie = /transform|translate|scale|rotate|perspective|filter/, Wie = /paint|layout|strict|content/, yo = (e) => !!e && e !== "none";
let l2;
function yh(e) {
  const t = ui(e) ? hi(e) : e;
  return yo(t.transform) || yo(t.translate) || yo(t.scale) || yo(t.rotate) || yo(t.perspective) || !T3() && (yo(t.backdropFilter) || yo(t.filter)) || Hie.test(t.willChange || "") || Wie.test(t.contain || "");
}
function Kie(e) {
  let t = Ja(e);
  for (; ua(t) && !xl(t); ) {
    if (yh(t))
      return t;
    if (vh(t))
      return null;
    t = Ja(t);
  }
  return null;
}
function T3() {
  return l2 == null && (l2 = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), l2;
}
function xl(e) {
  return /^(html|body|#document)$/.test(Wl(e));
}
function hi(e) {
  return _n(e).getComputedStyle(e);
}
function bh(e) {
  return ui(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Ja(e) {
  if (Wl(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    r7(e) && e.host || // Fallback.
    ji(e)
  );
  return r7(t) ? t.host : t;
}
function xk(e) {
  const t = Ja(e);
  return xl(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ua(t) && su(t) ? t : xk(t);
}
function Nc(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const i = xk(e), a = i === ((n = e.ownerDocument) == null ? void 0 : n.body), o = _n(i);
  if (a) {
    const s = V5(o);
    return t.concat(o, o.visualViewport || [], su(i) ? i : [], s && r ? Nc(s) : []);
  } else
    return t.concat(i, Nc(i, [], r));
}
function V5(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Ek(e) {
  const t = hi(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const i = ua(e), a = i ? e.offsetWidth : r, o = i ? e.offsetHeight : n, s = k1(r) !== a || k1(n) !== o;
  return s && (r = a, n = o), {
    width: r,
    height: n,
    $: s
  };
}
function A3(e) {
  return ui(e) ? e : e.contextElement;
}
function il(e) {
  const t = A3(e);
  if (!ua(t))
    return Oi(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: i,
    $: a
  } = Ek(t);
  let o = (a ? k1(r.width) : r.width) / n, s = (a ? k1(r.height) : r.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const Qie = /* @__PURE__ */ Oi(0);
function Sk(e) {
  const t = _n(e);
  return !T3() || !t.visualViewport ? Qie : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Gie(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== _n(e) ? !1 : t;
}
function es(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const i = e.getBoundingClientRect(), a = A3(e);
  let o = Oi(1);
  t && (n ? ui(n) && (o = il(n)) : o = il(e));
  const s = Gie(a, r, n) ? Sk(a) : Oi(0);
  let l = (i.left + s.x) / o.x, d = (i.top + s.y) / o.y, c = i.width / o.x, u = i.height / o.y;
  if (a) {
    const h = _n(a), f = n && ui(n) ? _n(n) : n;
    let p = h, m = V5(p);
    for (; m && n && f !== p; ) {
      const y = il(m), g = m.getBoundingClientRect(), w = hi(m), $ = g.left + (m.clientLeft + parseFloat(w.paddingLeft)) * y.x, _ = g.top + (m.clientTop + parseFloat(w.paddingTop)) * y.y;
      l *= y.x, d *= y.y, c *= y.x, u *= y.y, l += $, d += _, p = _n(m), m = V5(p);
    }
  }
  return x1({
    width: c,
    height: u,
    x: l,
    y: d
  });
}
function wh(e, t) {
  const r = bh(e).scrollLeft;
  return t ? t.left + r : es(ji(e)).left + r;
}
function Ck(e, t) {
  const r = e.getBoundingClientRect(), n = r.left + t.scrollLeft - wh(e, r), i = r.top + t.scrollTop;
  return {
    x: n,
    y: i
  };
}
function Yie(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: i
  } = e;
  const a = i === "fixed", o = ji(n), s = t ? vh(t.floating) : !1;
  if (n === o || s && a)
    return r;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = Oi(1);
  const c = Oi(0), u = ua(n);
  if ((u || !u && !a) && ((Wl(n) !== "body" || su(o)) && (l = bh(n)), u)) {
    const f = es(n);
    d = il(n), c.x = f.x + n.clientLeft, c.y = f.y + n.clientTop;
  }
  const h = o && !u && !a ? Ck(o, l) : Oi(0);
  return {
    width: r.width * d.x,
    height: r.height * d.y,
    x: r.x * d.x - l.scrollLeft * d.x + c.x + h.x,
    y: r.y * d.y - l.scrollTop * d.y + c.y + h.y
  };
}
function Jie(e) {
  return Array.from(e.getClientRects());
}
function Zie(e) {
  const t = ji(e), r = bh(e), n = e.ownerDocument.body, i = yn(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), a = yn(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -r.scrollLeft + wh(e);
  const s = -r.scrollTop;
  return hi(n).direction === "rtl" && (o += yn(t.clientWidth, n.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: s
  };
}
const n7 = 25;
function Xie(e, t) {
  const r = _n(e), n = ji(e), i = r.visualViewport;
  let a = n.clientWidth, o = n.clientHeight, s = 0, l = 0;
  if (i) {
    a = i.width, o = i.height;
    const c = T3();
    (!c || c && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  const d = wh(n);
  if (d <= 0) {
    const c = n.ownerDocument, u = c.body, h = getComputedStyle(u), f = c.compatMode === "CSS1Compat" && parseFloat(h.marginLeft) + parseFloat(h.marginRight) || 0, p = Math.abs(n.clientWidth - u.clientWidth - f);
    p <= n7 && (a -= p);
  } else d <= n7 && (a += d);
  return {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function eae(e, t) {
  const r = es(e, !0, t === "fixed"), n = r.top + e.clientTop, i = r.left + e.clientLeft, a = ua(e) ? il(e) : Oi(1), o = e.clientWidth * a.x, s = e.clientHeight * a.y, l = i * a.x, d = n * a.y;
  return {
    width: o,
    height: s,
    x: l,
    y: d
  };
}
function i7(e, t, r) {
  let n;
  if (t === "viewport")
    n = Xie(e, r);
  else if (t === "document")
    n = Zie(ji(e));
  else if (ui(t))
    n = eae(t, r);
  else {
    const i = Sk(e);
    n = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return x1(n);
}
function Tk(e, t) {
  const r = Ja(e);
  return r === t || !ui(r) || xl(r) ? !1 : hi(r).position === "fixed" || Tk(r, t);
}
function tae(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = Nc(e, [], !1).filter((s) => ui(s) && Wl(s) !== "body"), i = null;
  const a = hi(e).position === "fixed";
  let o = a ? Ja(e) : e;
  for (; ui(o) && !xl(o); ) {
    const s = hi(o), l = yh(o);
    !l && s.position === "fixed" && (i = null), (a ? !l && !i : !l && s.position === "static" && !!i && (i.position === "absolute" || i.position === "fixed") || su(o) && !l && Tk(e, o)) ? n = n.filter((c) => c !== o) : i = s, o = Ja(o);
  }
  return t.set(e, n), n;
}
function rae(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: i
  } = e;
  const o = [...r === "clippingAncestors" ? vh(t) ? [] : tae(t, this._c) : [].concat(r), n], s = i7(t, o[0], i);
  let l = s.top, d = s.right, c = s.bottom, u = s.left;
  for (let h = 1; h < o.length; h++) {
    const f = i7(t, o[h], i);
    l = yn(f.top, l), d = Ga(f.right, d), c = Ga(f.bottom, c), u = yn(f.left, u);
  }
  return {
    width: d - u,
    height: c - l,
    x: u,
    y: l
  };
}
function nae(e) {
  const {
    width: t,
    height: r
  } = Ek(e);
  return {
    width: t,
    height: r
  };
}
function iae(e, t, r) {
  const n = ua(t), i = ji(t), a = r === "fixed", o = es(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Oi(0);
  function d() {
    l.x = wh(i);
  }
  if (n || !n && !a)
    if ((Wl(t) !== "body" || su(i)) && (s = bh(t)), n) {
      const f = es(t, !0, a, t);
      l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
    } else i && d();
  a && !n && i && d();
  const c = i && !n && !a ? Ck(i, s) : Oi(0), u = o.left + s.scrollLeft - l.x - c.x, h = o.top + s.scrollTop - l.y - c.y;
  return {
    x: u,
    y: h,
    width: o.width,
    height: o.height
  };
}
function d2(e) {
  return hi(e).position === "static";
}
function a7(e, t) {
  if (!ua(e) || hi(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return ji(e) === r && (r = r.ownerDocument.body), r;
}
function Ak(e, t) {
  const r = _n(e);
  if (vh(e))
    return r;
  if (!ua(e)) {
    let i = Ja(e);
    for (; i && !xl(i); ) {
      if (ui(i) && !d2(i))
        return i;
      i = Ja(i);
    }
    return r;
  }
  let n = a7(e, t);
  for (; n && Bie(n) && d2(n); )
    n = a7(n, t);
  return n && xl(n) && d2(n) && !yh(n) ? r : n || Kie(e) || r;
}
const aae = async function(e) {
  const t = this.getOffsetParent || Ak, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: iae(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function oae(e) {
  return hi(e).direction === "rtl";
}
const E0 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Yie,
  getDocumentElement: ji,
  getClippingRect: rae,
  getOffsetParent: Ak,
  getElementRects: aae,
  getClientRects: Jie,
  getDimensions: nae,
  getScale: il,
  isElement: ui,
  isRTL: oae
};
function Ok(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function sae(e, t) {
  let r = null, n;
  const i = ji(e);
  function a() {
    var s;
    clearTimeout(n), (s = r) == null || s.disconnect(), r = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const d = e.getBoundingClientRect(), {
      left: c,
      top: u,
      width: h,
      height: f
    } = d;
    if (s || t(), !h || !f)
      return;
    const p = Zu(u), m = Zu(i.clientWidth - (c + h)), y = Zu(i.clientHeight - (u + f)), g = Zu(c), $ = {
      rootMargin: -p + "px " + -m + "px " + -y + "px " + -g + "px",
      threshold: yn(0, Ga(1, l)) || 1
    };
    let _ = !0;
    function x(S) {
      const T = S[0].intersectionRatio;
      if (T !== l) {
        if (!_)
          return o();
        T ? o(!1, T) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      T === 1 && !Ok(d, e.getBoundingClientRect()) && o(), _ = !1;
    }
    try {
      r = new IntersectionObserver(x, {
        ...$,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(x, $);
    }
    r.observe(e);
  }
  return o(!0), a;
}
function lae(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, d = A3(e), c = i || a ? [...d ? Nc(d) : [], ...t ? Nc(t) : []] : [];
  c.forEach((g) => {
    i && g.addEventListener("scroll", r, {
      passive: !0
    }), a && g.addEventListener("resize", r);
  });
  const u = d && s ? sae(d, r) : null;
  let h = -1, f = null;
  o && (f = new ResizeObserver((g) => {
    let [w] = g;
    w && w.target === d && f && t && (f.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var $;
      ($ = f) == null || $.observe(t);
    })), r();
  }), d && !l && f.observe(d), t && f.observe(t));
  let p, m = l ? es(e) : null;
  l && y();
  function y() {
    const g = es(e);
    m && !Ok(m, g) && r(), m = g, p = requestAnimationFrame(y);
  }
  return r(), () => {
    var g;
    c.forEach((w) => {
      i && w.removeEventListener("scroll", r), a && w.removeEventListener("resize", r);
    }), u?.(), (g = f) == null || g.disconnect(), f = null, l && cancelAnimationFrame(p);
  };
}
const dae = Vie, cae = Uie, uae = Fie, o7 = qie, hae = Lie, fae = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), i = {
    platform: E0,
    ...r
  }, a = {
    ...i.platform,
    _c: n
  };
  return Rie(e, t, {
    ...i,
    platform: a
  });
};
const Aa = { ATTRIBUTE: 1, CHILD: 2, PROPERTY: 3, BOOLEAN_ATTRIBUTE: 4 }, O3 = (e) => (...t) => ({ _$litDirective$: e, values: t });
let P3 = class {
  constructor(t) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t, r, n) {
    this._$Ct = t, this._$AM = r, this._$Ci = n;
  }
  _$AS(t, r) {
    return this.update(t, r);
  }
  update(t, r) {
    return this.render(...r);
  }
};
const En = O3(class extends P3 {
  constructor(e) {
    if (super(e), e.type !== Aa.ATTRIBUTE || e.name !== "class" || e.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(e) {
    return " " + Object.keys(e).filter((t) => e[t]).join(" ") + " ";
  }
  update(e, [t]) {
    if (this.st === void 0) {
      this.st = /* @__PURE__ */ new Set(), e.strings !== void 0 && (this.nt = new Set(e.strings.join(" ").split(/\s/).filter((n) => n !== "")));
      for (const n in t) t[n] && !this.nt?.has(n) && this.st.add(n);
      return this.render(t);
    }
    const r = e.element.classList;
    for (const n of this.st) n in t || (r.remove(n), this.st.delete(n));
    for (const n in t) {
      const i = !!t[n];
      i === this.st.has(n) || this.nt?.has(n) || (i ? (r.add(n), this.st.add(n)) : (r.remove(n), this.st.delete(n)));
    }
    return ni;
  }
});
function pae(e) {
  return mae(e);
}
function c2(e) {
  return e.assignedSlot ? e.assignedSlot : e.parentNode instanceof ShadowRoot ? e.parentNode.host : e.parentNode;
}
function mae(e) {
  for (let t = e; t; t = c2(t))
    if (t instanceof Element && getComputedStyle(t).display === "none")
      return null;
  for (let t = c2(e); t; t = c2(t)) {
    if (!(t instanceof Element))
      continue;
    const r = getComputedStyle(t);
    if (r.display !== "contents" && (r.position !== "static" || yh(r) || t.tagName === "BODY"))
      return t;
  }
  return null;
}
function gae(e) {
  return e !== null && typeof e == "object" && "getBoundingClientRect" in e && ("contextElement" in e ? e.contextElement instanceof Element : !0);
}
var It = class extends Br {
  constructor() {
    super(...arguments), this.localize = new ro(this), this.active = !1, this.placement = "top", this.strategy = "absolute", this.distance = 0, this.skidding = 0, this.arrow = !1, this.arrowPlacement = "anchor", this.arrowPadding = 10, this.flip = !1, this.flipFallbackPlacements = "", this.flipFallbackStrategy = "best-fit", this.flipPadding = 0, this.shift = !1, this.shiftPadding = 0, this.autoSizePadding = 0, this.hoverBridge = !1, this.updateHoverBridge = () => {
      if (this.hoverBridge && this.anchorEl) {
        const e = this.anchorEl.getBoundingClientRect(), t = this.popup.getBoundingClientRect(), r = this.placement.includes("top") || this.placement.includes("bottom");
        let n = 0, i = 0, a = 0, o = 0, s = 0, l = 0, d = 0, c = 0;
        r ? e.top < t.top ? (n = e.left, i = e.bottom, a = e.right, o = e.bottom, s = t.left, l = t.top, d = t.right, c = t.top) : (n = t.left, i = t.bottom, a = t.right, o = t.bottom, s = e.left, l = e.top, d = e.right, c = e.top) : e.left < t.left ? (n = e.right, i = e.top, a = t.left, o = t.top, s = e.right, l = e.bottom, d = t.left, c = t.bottom) : (n = t.right, i = t.top, a = e.left, o = e.top, s = t.right, l = t.bottom, d = e.left, c = e.bottom), this.style.setProperty("--hover-bridge-top-left-x", `${n}px`), this.style.setProperty("--hover-bridge-top-left-y", `${i}px`), this.style.setProperty("--hover-bridge-top-right-x", `${a}px`), this.style.setProperty("--hover-bridge-top-right-y", `${o}px`), this.style.setProperty("--hover-bridge-bottom-left-x", `${s}px`), this.style.setProperty("--hover-bridge-bottom-left-y", `${l}px`), this.style.setProperty("--hover-bridge-bottom-right-x", `${d}px`), this.style.setProperty("--hover-bridge-bottom-right-y", `${c}px`);
      }
    };
  }
  async connectedCallback() {
    super.connectedCallback(), await this.updateComplete, this.start();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.stop();
  }
  async updated(e) {
    super.updated(e), e.has("active") && (this.active ? this.start() : this.stop()), e.has("anchor") && this.handleAnchorChange(), this.active && (await this.updateComplete, this.reposition());
  }
  async handleAnchorChange() {
    if (await this.stop(), this.anchor && typeof this.anchor == "string") {
      const e = this.getRootNode();
      this.anchorEl = e.getElementById(this.anchor);
    } else this.anchor instanceof Element || gae(this.anchor) ? this.anchorEl = this.anchor : this.anchorEl = this.querySelector('[slot="anchor"]');
    this.anchorEl instanceof HTMLSlotElement && (this.anchorEl = this.anchorEl.assignedElements({ flatten: !0 })[0]), this.anchorEl && this.active && this.start();
  }
  start() {
    !this.anchorEl || !this.active || (this.cleanup = lae(this.anchorEl, this.popup, () => {
      this.reposition();
    }));
  }
  async stop() {
    return new Promise((e) => {
      this.cleanup ? (this.cleanup(), this.cleanup = void 0, this.removeAttribute("data-current-placement"), this.style.removeProperty("--auto-size-available-width"), this.style.removeProperty("--auto-size-available-height"), requestAnimationFrame(() => e())) : e();
    });
  }
  /** Forces the popup to recalculate and reposition itself. */
  reposition() {
    if (!this.active || !this.anchorEl)
      return;
    const e = [
      // The offset middleware goes first
      dae({ mainAxis: this.distance, crossAxis: this.skidding })
    ];
    this.sync ? e.push(
      o7({
        apply: ({ rects: r }) => {
          const n = this.sync === "width" || this.sync === "both", i = this.sync === "height" || this.sync === "both";
          this.popup.style.width = n ? `${r.reference.width}px` : "", this.popup.style.height = i ? `${r.reference.height}px` : "";
        }
      })
    ) : (this.popup.style.width = "", this.popup.style.height = ""), this.flip && e.push(
      uae({
        boundary: this.flipBoundary,
        // @ts-expect-error - We're converting a string attribute to an array here
        fallbackPlacements: this.flipFallbackPlacements,
        fallbackStrategy: this.flipFallbackStrategy === "best-fit" ? "bestFit" : "initialPlacement",
        padding: this.flipPadding
      })
    ), this.shift && e.push(
      cae({
        boundary: this.shiftBoundary,
        padding: this.shiftPadding
      })
    ), this.autoSize ? e.push(
      o7({
        boundary: this.autoSizeBoundary,
        padding: this.autoSizePadding,
        apply: ({ availableWidth: r, availableHeight: n }) => {
          this.autoSize === "vertical" || this.autoSize === "both" ? this.style.setProperty("--auto-size-available-height", `${n}px`) : this.style.removeProperty("--auto-size-available-height"), this.autoSize === "horizontal" || this.autoSize === "both" ? this.style.setProperty("--auto-size-available-width", `${r}px`) : this.style.removeProperty("--auto-size-available-width");
        }
      })
    ) : (this.style.removeProperty("--auto-size-available-width"), this.style.removeProperty("--auto-size-available-height")), this.arrow && e.push(
      hae({
        element: this.arrowEl,
        padding: this.arrowPadding
      })
    );
    const t = this.strategy === "absolute" ? (r) => E0.getOffsetParent(r, pae) : E0.getOffsetParent;
    fae(this.anchorEl, this.popup, {
      placement: this.placement,
      middleware: e,
      strategy: this.strategy,
      platform: mh(ss({}, E0), {
        getOffsetParent: t
      })
    }).then(({ x: r, y: n, middlewareData: i, placement: a }) => {
      const o = this.localize.dir() === "rtl", s = { top: "bottom", right: "left", bottom: "top", left: "right" }[a.split("-")[0]];
      if (this.setAttribute("data-current-placement", a), Object.assign(this.popup.style, {
        left: `${r}px`,
        top: `${n}px`
      }), this.arrow) {
        const l = i.arrow.x, d = i.arrow.y;
        let c = "", u = "", h = "", f = "";
        if (this.arrowPlacement === "start") {
          const p = typeof l == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
          c = typeof d == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "", u = o ? p : "", f = o ? "" : p;
        } else if (this.arrowPlacement === "end") {
          const p = typeof l == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
          u = o ? "" : p, f = o ? p : "", h = typeof d == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
        } else this.arrowPlacement === "center" ? (f = typeof l == "number" ? "calc(50% - var(--arrow-size-diagonal))" : "", c = typeof d == "number" ? "calc(50% - var(--arrow-size-diagonal))" : "") : (f = typeof l == "number" ? `${l}px` : "", c = typeof d == "number" ? `${d}px` : "");
        Object.assign(this.arrowEl.style, {
          top: c,
          right: u,
          bottom: h,
          left: f,
          [s]: "calc(var(--arrow-size-diagonal) * -1)"
        });
      }
    }), requestAnimationFrame(() => this.updateHoverBridge()), this.emit("sl-reposition");
  }
  render() {
    return Jt`
      <slot name="anchor" @slotchange=${this.handleAnchorChange}></slot>

      <span
        part="hover-bridge"
        class=${En({
      "popup-hover-bridge": !0,
      "popup-hover-bridge--visible": this.hoverBridge && this.active
    })}
      ></span>

      <div
        part="popup"
        class=${En({
      popup: !0,
      "popup--active": this.active,
      "popup--fixed": this.strategy === "fixed",
      "popup--has-arrow": this.arrow
    })}
      >
        <slot></slot>
        ${this.arrow ? Jt`<div part="arrow" class="popup__arrow" role="presentation"></div>` : ""}
      </div>
    `;
  }
};
It.styles = [zn, wie];
V([
  Er(".popup")
], It.prototype, "popup", 2);
V([
  Er(".popup__arrow")
], It.prototype, "arrowEl", 2);
V([
  ne()
], It.prototype, "anchor", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], It.prototype, "active", 2);
V([
  ne({ reflect: !0 })
], It.prototype, "placement", 2);
V([
  ne({ reflect: !0 })
], It.prototype, "strategy", 2);
V([
  ne({ type: Number })
], It.prototype, "distance", 2);
V([
  ne({ type: Number })
], It.prototype, "skidding", 2);
V([
  ne({ type: Boolean })
], It.prototype, "arrow", 2);
V([
  ne({ attribute: "arrow-placement" })
], It.prototype, "arrowPlacement", 2);
V([
  ne({ attribute: "arrow-padding", type: Number })
], It.prototype, "arrowPadding", 2);
V([
  ne({ type: Boolean })
], It.prototype, "flip", 2);
V([
  ne({
    attribute: "flip-fallback-placements",
    converter: {
      fromAttribute: (e) => e.split(" ").map((t) => t.trim()).filter((t) => t !== ""),
      toAttribute: (e) => e.join(" ")
    }
  })
], It.prototype, "flipFallbackPlacements", 2);
V([
  ne({ attribute: "flip-fallback-strategy" })
], It.prototype, "flipFallbackStrategy", 2);
V([
  ne({ type: Object })
], It.prototype, "flipBoundary", 2);
V([
  ne({ attribute: "flip-padding", type: Number })
], It.prototype, "flipPadding", 2);
V([
  ne({ type: Boolean })
], It.prototype, "shift", 2);
V([
  ne({ type: Object })
], It.prototype, "shiftBoundary", 2);
V([
  ne({ attribute: "shift-padding", type: Number })
], It.prototype, "shiftPadding", 2);
V([
  ne({ attribute: "auto-size" })
], It.prototype, "autoSize", 2);
V([
  ne()
], It.prototype, "sync", 2);
V([
  ne({ type: Object })
], It.prototype, "autoSizeBoundary", 2);
V([
  ne({ attribute: "auto-size-padding", type: Number })
], It.prototype, "autoSizePadding", 2);
V([
  ne({ attribute: "hover-bridge", type: Boolean })
], It.prototype, "hoverBridge", 2);
var Pk = /* @__PURE__ */ new Map(), vae = /* @__PURE__ */ new WeakMap();
function yae(e) {
  return e ?? { keyframes: [], options: { duration: 0 } };
}
function s7(e, t) {
  return t.toLowerCase() === "rtl" ? {
    keyframes: e.rtlKeyframes || e.keyframes,
    options: e.options
  } : e;
}
function mi(e, t) {
  Pk.set(e, yae(t));
}
function ei(e, t, r) {
  const n = vae.get(e);
  if (n?.[t])
    return s7(n[t], r.dir);
  const i = Pk.get(t);
  return i ? s7(i, r.dir) : {
    keyframes: [],
    options: { duration: 0 }
  };
}
function Za(e, t) {
  return new Promise((r) => {
    function n(i) {
      i.target === e && (e.removeEventListener(t, n), r());
    }
    e.addEventListener(t, n);
  });
}
function ti(e, t, r) {
  return new Promise((n) => {
    if (r?.duration === 1 / 0)
      throw new Error("Promise-based animations must be finite.");
    const i = e.animate(t, mh(ss({}, r), {
      duration: bae() ? 0 : r.duration
    }));
    i.addEventListener("cancel", n, { once: !0 }), i.addEventListener("finish", n, { once: !0 });
  });
}
function l7(e) {
  return e = e.toString().toLowerCase(), e.indexOf("ms") > -1 ? parseFloat(e) : e.indexOf("s") > -1 ? parseFloat(e) * 1e3 : parseFloat(e);
}
function bae() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function Ci(e) {
  return Promise.all(
    e.getAnimations().map((t) => new Promise((r) => {
      t.cancel(), requestAnimationFrame(r);
    }))
  );
}
function Lr(e, t) {
  const r = ss({
    waitUntilFirstUpdate: !1
  }, t);
  return (n, i) => {
    const { update: a } = n, o = Array.isArray(e) ? e : [e];
    n.update = function(s) {
      o.forEach((l) => {
        const d = l;
        if (s.has(d)) {
          const c = s.get(d), u = this[d];
          c !== u && (!r.waitUntilFirstUpdate || this.hasUpdated) && this[i](c, u);
        }
      }), a.call(this, s);
    };
  };
}
const Nt = (e) => e ?? tr;
var Hr = class extends Br {
  constructor() {
    super(...arguments), this.localize = new ro(this), this.open = !1, this.placement = "bottom-start", this.disabled = !1, this.stayOpenOnSelect = !1, this.distance = 0, this.skidding = 0, this.hoist = !1, this.sync = void 0, this.handleKeyDown = (e) => {
      this.open && e.key === "Escape" && (e.stopPropagation(), this.hide(), this.focusOnTrigger());
    }, this.handleDocumentKeyDown = (e) => {
      var t;
      if (e.key === "Escape" && this.open && !this.closeWatcher) {
        e.stopPropagation(), this.focusOnTrigger(), this.hide();
        return;
      }
      if (e.key === "Tab") {
        if (this.open && ((t = document.activeElement) == null ? void 0 : t.tagName.toLowerCase()) === "sl-menu-item") {
          e.preventDefault(), this.hide(), this.focusOnTrigger();
          return;
        }
        const r = (n, i) => {
          if (!n) return null;
          const a = n.closest(i);
          if (a) return a;
          const o = n.getRootNode();
          return o instanceof ShadowRoot ? r(o.host, i) : null;
        };
        setTimeout(() => {
          var n;
          const i = ((n = this.containingElement) == null ? void 0 : n.getRootNode()) instanceof ShadowRoot ? mk() : document.activeElement;
          (!this.containingElement || r(i, this.containingElement.tagName.toLowerCase()) !== this.containingElement) && this.hide();
        });
      }
    }, this.handleDocumentMouseDown = (e) => {
      const t = e.composedPath();
      this.containingElement && !t.includes(this.containingElement) && this.hide();
    }, this.handlePanelSelect = (e) => {
      const t = e.target;
      !this.stayOpenOnSelect && t.tagName.toLowerCase() === "sl-menu" && (this.hide(), this.focusOnTrigger());
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.containingElement || (this.containingElement = this);
  }
  firstUpdated() {
    this.panel.hidden = !this.open, this.open && (this.addOpenListeners(), this.popup.active = !0);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeOpenListeners(), this.hide();
  }
  focusOnTrigger() {
    const e = this.trigger.assignedElements({ flatten: !0 })[0];
    typeof e?.focus == "function" && e.focus();
  }
  getMenu() {
    return this.panel.assignedElements({ flatten: !0 }).find((e) => e.tagName.toLowerCase() === "sl-menu");
  }
  handleTriggerClick() {
    this.open ? this.hide() : (this.show(), this.focusOnTrigger());
  }
  async handleTriggerKeyDown(e) {
    if ([" ", "Enter"].includes(e.key)) {
      e.preventDefault(), this.handleTriggerClick();
      return;
    }
    const t = this.getMenu();
    if (t) {
      const r = t.getAllItems(), n = r[0], i = r[r.length - 1];
      ["ArrowDown", "ArrowUp", "Home", "End"].includes(e.key) && (e.preventDefault(), this.open || (this.show(), await this.updateComplete), r.length > 0 && this.updateComplete.then(() => {
        (e.key === "ArrowDown" || e.key === "Home") && (t.setCurrentItem(n), n.focus()), (e.key === "ArrowUp" || e.key === "End") && (t.setCurrentItem(i), i.focus());
      }));
    }
  }
  handleTriggerKeyUp(e) {
    e.key === " " && e.preventDefault();
  }
  handleTriggerSlotChange() {
    this.updateAccessibleTrigger();
  }
  //
  // Slotted triggers can be arbitrary content, but we need to link them to the dropdown panel with `aria-haspopup` and
  // `aria-expanded`. These must be applied to the "accessible trigger" (the tabbable portion of the trigger element
  // that gets slotted in) so screen readers will understand them. The accessible trigger could be the slotted element,
  // a child of the slotted element, or an element in the slotted element's shadow root.
  //
  // For example, the accessible trigger of an <sl-button> is a <button> located inside its shadow root.
  //
  // To determine this, we assume the first tabbable element in the trigger slot is the "accessible trigger."
  //
  updateAccessibleTrigger() {
    const t = this.trigger.assignedElements({ flatten: !0 }).find((n) => yie(n).start);
    let r;
    if (t) {
      switch (t.tagName.toLowerCase()) {
        // Shoelace buttons have to update the internal button so it's announced correctly by screen readers
        case "sl-button":
        case "sl-icon-button":
          r = t.button;
          break;
        default:
          r = t;
      }
      r.setAttribute("aria-haspopup", "true"), r.setAttribute("aria-expanded", this.open ? "true" : "false");
    }
  }
  /** Shows the dropdown panel. */
  async show() {
    if (!this.open)
      return this.open = !0, Za(this, "sl-after-show");
  }
  /** Hides the dropdown panel */
  async hide() {
    if (this.open)
      return this.open = !1, Za(this, "sl-after-hide");
  }
  /**
   * Instructs the dropdown menu to reposition. Useful when the position or size of the trigger changes when the menu
   * is activated.
   */
  reposition() {
    this.popup.reposition();
  }
  addOpenListeners() {
    var e;
    this.panel.addEventListener("sl-select", this.handlePanelSelect), "CloseWatcher" in window ? ((e = this.closeWatcher) == null || e.destroy(), this.closeWatcher = new CloseWatcher(), this.closeWatcher.onclose = () => {
      this.hide(), this.focusOnTrigger();
    }) : this.panel.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keydown", this.handleDocumentKeyDown), document.addEventListener("mousedown", this.handleDocumentMouseDown);
  }
  removeOpenListeners() {
    var e;
    this.panel && (this.panel.removeEventListener("sl-select", this.handlePanelSelect), this.panel.removeEventListener("keydown", this.handleKeyDown)), document.removeEventListener("keydown", this.handleDocumentKeyDown), document.removeEventListener("mousedown", this.handleDocumentMouseDown), (e = this.closeWatcher) == null || e.destroy();
  }
  async handleOpenChange() {
    if (this.disabled) {
      this.open = !1;
      return;
    }
    if (this.updateAccessibleTrigger(), this.open) {
      this.emit("sl-show"), this.addOpenListeners(), await Ci(this), this.panel.hidden = !1, this.popup.active = !0;
      const { keyframes: e, options: t } = ei(this, "dropdown.show", { dir: this.localize.dir() });
      await ti(this.popup.popup, e, t), this.emit("sl-after-show");
    } else {
      this.emit("sl-hide"), this.removeOpenListeners(), await Ci(this);
      const { keyframes: e, options: t } = ei(this, "dropdown.hide", { dir: this.localize.dir() });
      await ti(this.popup.popup, e, t), this.panel.hidden = !0, this.popup.active = !1, this.emit("sl-after-hide");
    }
  }
  render() {
    return Jt`
      <sl-popup
        part="base"
        exportparts="popup:base__popup"
        id="dropdown"
        placement=${this.placement}
        distance=${this.distance}
        skidding=${this.skidding}
        strategy=${this.hoist ? "fixed" : "absolute"}
        flip
        shift
        auto-size="vertical"
        auto-size-padding="10"
        sync=${Nt(this.sync ? this.sync : void 0)}
        class=${En({
      dropdown: !0,
      "dropdown--open": this.open
    })}
      >
        <slot
          name="trigger"
          slot="anchor"
          part="trigger"
          class="dropdown__trigger"
          @click=${this.handleTriggerClick}
          @keydown=${this.handleTriggerKeyDown}
          @keyup=${this.handleTriggerKeyUp}
          @slotchange=${this.handleTriggerSlotChange}
        ></slot>

        <div aria-hidden=${this.open ? "false" : "true"} aria-labelledby="dropdown">
          <slot part="panel" class="dropdown__panel"></slot>
        </div>
      </sl-popup>
    `;
  }
};
Hr.styles = [zn, iie];
Hr.dependencies = { "sl-popup": It };
V([
  Er(".dropdown")
], Hr.prototype, "popup", 2);
V([
  Er(".dropdown__trigger")
], Hr.prototype, "trigger", 2);
V([
  Er(".dropdown__panel")
], Hr.prototype, "panel", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], Hr.prototype, "open", 2);
V([
  ne({ reflect: !0 })
], Hr.prototype, "placement", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], Hr.prototype, "disabled", 2);
V([
  ne({ attribute: "stay-open-on-select", type: Boolean, reflect: !0 })
], Hr.prototype, "stayOpenOnSelect", 2);
V([
  ne({ attribute: !1 })
], Hr.prototype, "containingElement", 2);
V([
  ne({ type: Number })
], Hr.prototype, "distance", 2);
V([
  ne({ type: Number })
], Hr.prototype, "skidding", 2);
V([
  ne({ type: Boolean })
], Hr.prototype, "hoist", 2);
V([
  ne({ reflect: !0 })
], Hr.prototype, "sync", 2);
V([
  Lr("open", { waitUntilFirstUpdate: !0 })
], Hr.prototype, "handleOpenChange", 1);
mi("dropdown.show", {
  keyframes: [
    { opacity: 0, scale: 0.9 },
    { opacity: 1, scale: 1 }
  ],
  options: { duration: 100, easing: "ease" }
});
mi("dropdown.hide", {
  keyframes: [
    { opacity: 1, scale: 1 },
    { opacity: 0, scale: 0.9 }
  ],
  options: { duration: 100, easing: "ease" }
});
Hr.define("sl-dropdown");
var U5 = "";
function fi(e) {
  U5 = e;
}
function wae(e = "") {
  if (!U5) {
    const t = [...document.getElementsByTagName("script")], r = t.find((n) => n.hasAttribute("data-shoelace"));
    if (r)
      fi(r.getAttribute("data-shoelace"));
    else {
      const n = t.find((a) => /shoelace(\.min)?\.js($|\?)/.test(a.src) || /shoelace-autoloader(\.min)?\.js($|\?)/.test(a.src));
      let i = "";
      n && (i = n.getAttribute("src")), fi(i.split("/").slice(0, -1).join("/"));
    }
  }
  return U5.replace(/\/$/, "") + (e ? `/${e.replace(/^\//, "")}` : "");
}
var $ae = {
  name: "default",
  resolver: (e) => wae(`assets/icons/${e}.svg`)
}, kae = $ae, d7 = {
  caret: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  `,
  check: `
    <svg part="checked-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor">
          <g transform="translate(3.428571, 3.428571)">
            <path d="M0,5.71428571 L3.42857143,9.14285714"></path>
            <path d="M9.14285714,0 L3.42857143,9.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
  "chevron-down": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
  "chevron-left": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
    </svg>
  `,
  "chevron-right": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
  copy: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6ZM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1H2Z"/>
    </svg>
  `,
  eye: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
    </svg>
  `,
  "eye-slash": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
    </svg>
  `,
  eyedropper: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eyedropper" viewBox="0 0 16 16">
      <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708l-2-2zM2 12.707l7-7L10.293 7l-7 7H2v-1.293z"></path>
    </svg>
  `,
  "grip-vertical": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grip-vertical" viewBox="0 0 16 16">
      <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
    </svg>
  `,
  indeterminate: `
    <svg part="indeterminate-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor" stroke-width="2">
          <g transform="translate(2.285714, 6.857143)">
            <path d="M10.2857143,1.14285714 L1.14285714,1.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
  "person-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
    </svg>
  `,
  "play-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-fill" viewBox="0 0 16 16">
      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path>
    </svg>
  `,
  "pause-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"></path>
    </svg>
  `,
  radio: `
    <svg part="checked-icon" class="radio__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g fill="currentColor">
          <circle cx="8" cy="8" r="3.42857143"></circle>
        </g>
      </g>
    </svg>
  `,
  "star-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
    </svg>
  `,
  "x-lg": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  `,
  "x-circle-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>
    </svg>
  `
}, _ae = {
  name: "system",
  resolver: (e) => e in d7 ? `data:image/svg+xml,${encodeURIComponent(d7[e])}` : ""
}, xae = _ae, Eae = [kae, xae], q5 = [];
function Sae(e) {
  q5.push(e);
}
function Cae(e) {
  q5 = q5.filter((t) => t !== e);
}
function c7(e) {
  return Eae.find((t) => t.name === e);
}
var Tae = hn`
  :host {
    display: inline-block;
    width: 1em;
    height: 1em;
    box-sizing: content-box !important;
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;
const Aae = (e, t) => e?._$litType$ !== void 0, Ik = (e) => e.strings === void 0, Oae = {}, Pae = (e, t = Oae) => e._$AH = t;
var yd = /* @__PURE__ */ Symbol(), Xu = /* @__PURE__ */ Symbol(), u2, h2 = /* @__PURE__ */ new Map(), Vn = class extends Br {
  constructor() {
    super(...arguments), this.initialRender = !1, this.svg = null, this.label = "", this.library = "default";
  }
  /** Given a URL, this function returns the resulting SVG element or an appropriate error symbol. */
  async resolveIcon(e, t) {
    var r;
    let n;
    if (t?.spriteSheet)
      return this.svg = Jt`<svg part="svg">
        <use part="use" href="${e}"></use>
      </svg>`, this.svg;
    try {
      if (n = await fetch(e, { mode: "cors" }), !n.ok) return n.status === 410 ? yd : Xu;
    } catch {
      return Xu;
    }
    try {
      const i = document.createElement("div");
      i.innerHTML = await n.text();
      const a = i.firstElementChild;
      if (((r = a?.tagName) == null ? void 0 : r.toLowerCase()) !== "svg") return yd;
      u2 || (u2 = new DOMParser());
      const s = u2.parseFromString(a.outerHTML, "text/html").body.querySelector("svg");
      return s ? (s.part.add("svg"), document.adoptNode(s)) : yd;
    } catch {
      return yd;
    }
  }
  connectedCallback() {
    super.connectedCallback(), Sae(this);
  }
  firstUpdated() {
    this.initialRender = !0, this.setIcon();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), Cae(this);
  }
  getIconSource() {
    const e = c7(this.library);
    return this.name && e ? {
      url: e.resolver(this.name),
      fromLibrary: !0
    } : {
      url: this.src,
      fromLibrary: !1
    };
  }
  handleLabelChange() {
    typeof this.label == "string" && this.label.length > 0 ? (this.setAttribute("role", "img"), this.setAttribute("aria-label", this.label), this.removeAttribute("aria-hidden")) : (this.removeAttribute("role"), this.removeAttribute("aria-label"), this.setAttribute("aria-hidden", "true"));
  }
  async setIcon() {
    var e;
    const { url: t, fromLibrary: r } = this.getIconSource(), n = r ? c7(this.library) : void 0;
    if (!t) {
      this.svg = null;
      return;
    }
    let i = h2.get(t);
    if (i || (i = this.resolveIcon(t, n), h2.set(t, i)), !this.initialRender)
      return;
    const a = await i;
    if (a === Xu && h2.delete(t), t === this.getIconSource().url) {
      if (Aae(a)) {
        if (this.svg = a, n) {
          await this.updateComplete;
          const o = this.shadowRoot.querySelector("[part='svg']");
          typeof n.mutator == "function" && o && n.mutator(o);
        }
        return;
      }
      switch (a) {
        case Xu:
        case yd:
          this.svg = null, this.emit("sl-error");
          break;
        default:
          this.svg = a.cloneNode(!0), (e = n?.mutator) == null || e.call(n, this.svg), this.emit("sl-load");
      }
    }
  }
  render() {
    return this.svg;
  }
};
Vn.styles = [zn, Tae];
V([
  ou()
], Vn.prototype, "svg", 2);
V([
  ne({ reflect: !0 })
], Vn.prototype, "name", 2);
V([
  ne()
], Vn.prototype, "src", 2);
V([
  ne()
], Vn.prototype, "label", 2);
V([
  ne({ reflect: !0 })
], Vn.prototype, "library", 2);
V([
  Lr("label")
], Vn.prototype, "handleLabelChange", 1);
V([
  Lr(["name", "src", "library"])
], Vn.prototype, "setIcon", 1);
Vn.define("sl-icon");
var Iae = hn`
  :host {
    display: block;
  }

  .input {
    flex: 1 1 auto;
    display: inline-flex;
    align-items: stretch;
    justify-content: start;
    position: relative;
    width: 100%;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    letter-spacing: var(--sl-input-letter-spacing);
    vertical-align: middle;
    overflow: hidden;
    cursor: text;
    transition:
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) border,
      var(--sl-transition-fast) box-shadow,
      var(--sl-transition-fast) background-color;
  }

  /* Standard inputs */
  .input--standard {
    background-color: var(--sl-input-background-color);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
  }

  .input--standard:hover:not(.input--disabled) {
    background-color: var(--sl-input-background-color-hover);
    border-color: var(--sl-input-border-color-hover);
  }

  .input--standard.input--focused:not(.input--disabled) {
    background-color: var(--sl-input-background-color-focus);
    border-color: var(--sl-input-border-color-focus);
    box-shadow: 0 0 0 var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
  }

  .input--standard.input--focused:not(.input--disabled) .input__control {
    color: var(--sl-input-color-focus);
  }

  .input--standard.input--disabled {
    background-color: var(--sl-input-background-color-disabled);
    border-color: var(--sl-input-border-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .input--standard.input--disabled .input__control {
    color: var(--sl-input-color-disabled);
  }

  .input--standard.input--disabled .input__control::placeholder {
    color: var(--sl-input-placeholder-color-disabled);
  }

  /* Filled inputs */
  .input--filled {
    border: none;
    background-color: var(--sl-input-filled-background-color);
    color: var(--sl-input-color);
  }

  .input--filled:hover:not(.input--disabled) {
    background-color: var(--sl-input-filled-background-color-hover);
  }

  .input--filled.input--focused:not(.input--disabled) {
    background-color: var(--sl-input-filled-background-color-focus);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .input--filled.input--disabled {
    background-color: var(--sl-input-filled-background-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .input__control {
    flex: 1 1 auto;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    min-width: 0;
    height: 100%;
    color: var(--sl-input-color);
    border: none;
    background: inherit;
    box-shadow: none;
    padding: 0;
    margin: 0;
    cursor: inherit;
    -webkit-appearance: none;
  }

  .input__control::-webkit-search-decoration,
  .input__control::-webkit-search-cancel-button,
  .input__control::-webkit-search-results-button,
  .input__control::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  .input__control:-webkit-autofill,
  .input__control:-webkit-autofill:hover,
  .input__control:-webkit-autofill:focus,
  .input__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-background-color-hover) inset !important;
    -webkit-text-fill-color: var(--sl-color-primary-500);
    caret-color: var(--sl-input-color);
  }

  .input--filled .input__control:-webkit-autofill,
  .input--filled .input__control:-webkit-autofill:hover,
  .input--filled .input__control:-webkit-autofill:focus,
  .input--filled .input__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-filled-background-color) inset !important;
  }

  .input__control::placeholder {
    color: var(--sl-input-placeholder-color);
    user-select: none;
    -webkit-user-select: none;
  }

  .input:hover:not(.input--disabled) .input__control {
    color: var(--sl-input-color-hover);
  }

  .input__control:focus {
    outline: none;
  }

  .input__prefix,
  .input__suffix {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    cursor: default;
  }

  .input__prefix ::slotted(sl-icon),
  .input__suffix ::slotted(sl-icon) {
    color: var(--sl-input-icon-color);
  }

  /*
   * Size modifiers
   */

  .input--small {
    border-radius: var(--sl-input-border-radius-small);
    font-size: var(--sl-input-font-size-small);
    height: var(--sl-input-height-small);
  }

  .input--small .input__control {
    height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-small);
  }

  .input--small .input__clear,
  .input--small .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-small) * 2);
  }

  .input--small .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-small);
  }

  .input--small .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-small);
  }

  .input--medium {
    border-radius: var(--sl-input-border-radius-medium);
    font-size: var(--sl-input-font-size-medium);
    height: var(--sl-input-height-medium);
  }

  .input--medium .input__control {
    height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-medium);
  }

  .input--medium .input__clear,
  .input--medium .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-medium) * 2);
  }

  .input--medium .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-medium);
  }

  .input--medium .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-medium);
  }

  .input--large {
    border-radius: var(--sl-input-border-radius-large);
    font-size: var(--sl-input-font-size-large);
    height: var(--sl-input-height-large);
  }

  .input--large .input__control {
    height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-large);
  }

  .input--large .input__clear,
  .input--large .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-large) * 2);
  }

  .input--large .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-large);
  }

  .input--large .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-large);
  }

  /*
   * Pill modifier
   */

  .input--pill.input--small {
    border-radius: var(--sl-input-height-small);
  }

  .input--pill.input--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .input--pill.input--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Clearable + Password Toggle
   */

  .input__clear,
  .input__password-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: inherit;
    color: var(--sl-input-icon-color);
    border: none;
    background: none;
    padding: 0;
    transition: var(--sl-transition-fast) color;
    cursor: pointer;
  }

  .input__clear:hover,
  .input__password-toggle:hover {
    color: var(--sl-input-icon-color-hover);
  }

  .input__clear:focus,
  .input__password-toggle:focus {
    outline: none;
  }

  /* Don't show the browser's password toggle in Edge */
  ::-ms-reveal {
    display: none;
  }

  /* Hide the built-in number spinner */
  .input--no-spin-buttons input[type='number']::-webkit-outer-spin-button,
  .input--no-spin-buttons input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
  }

  .input--no-spin-buttons input[type='number'] {
    -moz-appearance: textfield;
  }
`, Dk = (e = "value") => (t, r) => {
  const n = t.constructor, i = n.prototype.attributeChangedCallback;
  n.prototype.attributeChangedCallback = function(a, o, s) {
    var l;
    const d = n.getPropertyOptions(e), c = typeof d.attribute == "string" ? d.attribute : e;
    if (a === c) {
      const u = d.converter || kl, f = (typeof u == "function" ? u : (l = u?.fromAttribute) != null ? l : kl.fromAttribute)(s, d.type);
      this[e] !== f && (this[r] = f);
    }
    i.call(this, a, o, s);
  };
}, Nk = hn`
  .form-control .form-control__label {
    display: none;
  }

  .form-control .form-control__help-text {
    display: none;
  }

  /* Label */
  .form-control--has-label .form-control__label {
    display: inline-block;
    color: var(--sl-input-label-color);
    margin-bottom: var(--sl-spacing-3x-small);
  }

  .form-control--has-label.form-control--small .form-control__label {
    font-size: var(--sl-input-label-font-size-small);
  }

  .form-control--has-label.form-control--medium .form-control__label {
    font-size: var(--sl-input-label-font-size-medium);
  }

  .form-control--has-label.form-control--large .form-control__label {
    font-size: var(--sl-input-label-font-size-large);
  }

  :host([required]) .form-control--has-label .form-control__label::after {
    content: var(--sl-input-required-content);
    margin-inline-start: var(--sl-input-required-content-offset);
    color: var(--sl-input-required-content-color);
  }

  /* Help text */
  .form-control--has-help-text .form-control__help-text {
    display: block;
    color: var(--sl-input-help-text-color);
    margin-top: var(--sl-spacing-3x-small);
  }

  .form-control--has-help-text.form-control--small .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-small);
  }

  .form-control--has-help-text.form-control--medium .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-medium);
  }

  .form-control--has-help-text.form-control--large .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-large);
  }

  .form-control--has-help-text.form-control--radio-group .form-control__help-text {
    margin-top: var(--sl-spacing-2x-small);
  }
`, bd = /* @__PURE__ */ new WeakMap(), wd = /* @__PURE__ */ new WeakMap(), $d = /* @__PURE__ */ new WeakMap(), f2 = /* @__PURE__ */ new WeakSet(), e0 = /* @__PURE__ */ new WeakMap(), Mk = class {
  constructor(e, t) {
    this.handleFormData = (r) => {
      const n = this.options.disabled(this.host), i = this.options.name(this.host), a = this.options.value(this.host), o = this.host.tagName.toLowerCase() === "sl-button";
      this.host.isConnected && !n && !o && typeof i == "string" && i.length > 0 && typeof a < "u" && (Array.isArray(a) ? a.forEach((s) => {
        r.formData.append(i, s.toString());
      }) : r.formData.append(i, a.toString()));
    }, this.handleFormSubmit = (r) => {
      var n;
      const i = this.options.disabled(this.host), a = this.options.reportValidity;
      this.form && !this.form.noValidate && ((n = bd.get(this.form)) == null || n.forEach((o) => {
        this.setUserInteracted(o, !0);
      })), this.form && !this.form.noValidate && !i && !a(this.host) && (r.preventDefault(), r.stopImmediatePropagation());
    }, this.handleFormReset = () => {
      this.options.setValue(this.host, this.options.defaultValue(this.host)), this.setUserInteracted(this.host, !1), e0.set(this.host, []);
    }, this.handleInteraction = (r) => {
      const n = e0.get(this.host);
      n.includes(r.type) || n.push(r.type), n.length === this.options.assumeInteractionOn.length && this.setUserInteracted(this.host, !0);
    }, this.checkFormValidity = () => {
      if (this.form && !this.form.noValidate) {
        const r = this.form.querySelectorAll("*");
        for (const n of r)
          if (typeof n.checkValidity == "function" && !n.checkValidity())
            return !1;
      }
      return !0;
    }, this.reportFormValidity = () => {
      if (this.form && !this.form.noValidate) {
        const r = this.form.querySelectorAll("*");
        for (const n of r)
          if (typeof n.reportValidity == "function" && !n.reportValidity())
            return !1;
      }
      return !0;
    }, (this.host = e).addController(this), this.options = ss({
      form: (r) => {
        const n = r.form;
        if (n) {
          const a = r.getRootNode().querySelector(`#${n}`);
          if (a)
            return a;
        }
        return r.closest("form");
      },
      name: (r) => r.name,
      value: (r) => r.value,
      defaultValue: (r) => r.defaultValue,
      disabled: (r) => {
        var n;
        return (n = r.disabled) != null ? n : !1;
      },
      reportValidity: (r) => typeof r.reportValidity == "function" ? r.reportValidity() : !0,
      checkValidity: (r) => typeof r.checkValidity == "function" ? r.checkValidity() : !0,
      setValue: (r, n) => r.value = n,
      assumeInteractionOn: ["sl-input"]
    }, t);
  }
  hostConnected() {
    const e = this.options.form(this.host);
    e && this.attachForm(e), e0.set(this.host, []), this.options.assumeInteractionOn.forEach((t) => {
      this.host.addEventListener(t, this.handleInteraction);
    });
  }
  hostDisconnected() {
    this.detachForm(), e0.delete(this.host), this.options.assumeInteractionOn.forEach((e) => {
      this.host.removeEventListener(e, this.handleInteraction);
    });
  }
  hostUpdated() {
    const e = this.options.form(this.host);
    e || this.detachForm(), e && this.form !== e && (this.detachForm(), this.attachForm(e)), this.host.hasUpdated && this.setValidity(this.host.validity.valid);
  }
  attachForm(e) {
    e ? (this.form = e, bd.has(this.form) ? bd.get(this.form).add(this.host) : bd.set(this.form, /* @__PURE__ */ new Set([this.host])), this.form.addEventListener("formdata", this.handleFormData), this.form.addEventListener("submit", this.handleFormSubmit), this.form.addEventListener("reset", this.handleFormReset), wd.has(this.form) || (wd.set(this.form, this.form.reportValidity), this.form.reportValidity = () => this.reportFormValidity()), $d.has(this.form) || ($d.set(this.form, this.form.checkValidity), this.form.checkValidity = () => this.checkFormValidity())) : this.form = void 0;
  }
  detachForm() {
    if (!this.form) return;
    const e = bd.get(this.form);
    e && (e.delete(this.host), e.size <= 0 && (this.form.removeEventListener("formdata", this.handleFormData), this.form.removeEventListener("submit", this.handleFormSubmit), this.form.removeEventListener("reset", this.handleFormReset), wd.has(this.form) && (this.form.reportValidity = wd.get(this.form), wd.delete(this.form)), $d.has(this.form) && (this.form.checkValidity = $d.get(this.form), $d.delete(this.form)), this.form = void 0));
  }
  setUserInteracted(e, t) {
    t ? f2.add(e) : f2.delete(e), e.requestUpdate();
  }
  doAction(e, t) {
    if (this.form) {
      const r = document.createElement("button");
      r.type = e, r.style.position = "absolute", r.style.width = "0", r.style.height = "0", r.style.clipPath = "inset(50%)", r.style.overflow = "hidden", r.style.whiteSpace = "nowrap", t && (r.name = t.name, r.value = t.value, ["formaction", "formenctype", "formmethod", "formnovalidate", "formtarget"].forEach((n) => {
        t.hasAttribute(n) && r.setAttribute(n, t.getAttribute(n));
      })), this.form.append(r), r.click(), r.remove();
    }
  }
  /** Returns the associated `<form>` element, if one exists. */
  getForm() {
    var e;
    return (e = this.form) != null ? e : null;
  }
  /** Resets the form, restoring all the control to their default value */
  reset(e) {
    this.doAction("reset", e);
  }
  /** Submits the form, triggering validation and form data injection. */
  submit(e) {
    this.doAction("submit", e);
  }
  /**
   * Synchronously sets the form control's validity. Call this when you know the future validity but need to update
   * the host element immediately, i.e. before Lit updates the component in the next update.
   */
  setValidity(e) {
    const t = this.host, r = !!f2.has(t), n = !!t.required;
    t.toggleAttribute("data-required", n), t.toggleAttribute("data-optional", !n), t.toggleAttribute("data-invalid", !e), t.toggleAttribute("data-valid", e), t.toggleAttribute("data-user-invalid", !e && r), t.toggleAttribute("data-user-valid", e && r);
  }
  /**
   * Updates the form control's validity based on the current value of `host.validity.valid`. Call this when anything
   * that affects constraint validation changes so the component receives the correct validity states.
   */
  updateValidity() {
    const e = this.host;
    this.setValidity(e.validity.valid);
  }
  /**
   * Dispatches a non-bubbling, cancelable custom event of type `sl-invalid`.
   * If the `sl-invalid` event will be cancelled then the original `invalid`
   * event (which may have been passed as argument) will also be cancelled.
   * If no original `invalid` event has been passed then the `sl-invalid`
   * event will be cancelled before being dispatched.
   */
  emitInvalidEvent(e) {
    const t = new CustomEvent("sl-invalid", {
      bubbles: !1,
      composed: !1,
      cancelable: !0,
      detail: {}
    });
    e || t.preventDefault(), this.host.dispatchEvent(t) || e?.preventDefault();
  }
}, Rk = Object.freeze({
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: !0,
  valueMissing: !1
});
Object.freeze(mh(ss({}, Rk), {
  valid: !1,
  valueMissing: !0
}));
Object.freeze(mh(ss({}, Rk), {
  valid: !1,
  customError: !0
}));
var lu = class {
  constructor(e, ...t) {
    this.slotNames = [], this.handleSlotChange = (r) => {
      const n = r.target;
      (this.slotNames.includes("[default]") && !n.name || n.name && this.slotNames.includes(n.name)) && this.host.requestUpdate();
    }, (this.host = e).addController(this), this.slotNames = t;
  }
  hasDefaultSlot() {
    return [...this.host.childNodes].some((e) => {
      if (e.nodeType === e.TEXT_NODE && e.textContent.trim() !== "")
        return !0;
      if (e.nodeType === e.ELEMENT_NODE) {
        const t = e;
        if (t.tagName.toLowerCase() === "sl-visually-hidden")
          return !1;
        if (!t.hasAttribute("slot"))
          return !0;
      }
      return !1;
    });
  }
  hasNamedSlot(e) {
    return this.host.querySelector(`:scope > [slot="${e}"]`) !== null;
  }
  test(e) {
    return e === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(e);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener("slotchange", this.handleSlotChange);
  }
};
function Dae(e) {
  if (!e)
    return "";
  const t = e.assignedNodes({ flatten: !0 });
  let r = "";
  return [...t].forEach((n) => {
    n.nodeType === Node.TEXT_NODE && (r += n.textContent);
  }), r;
}
const Lk = O3(class extends P3 {
  constructor(e) {
    if (super(e), e.type !== Aa.PROPERTY && e.type !== Aa.ATTRIBUTE && e.type !== Aa.BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
    if (!Ik(e)) throw Error("`live` bindings can only contain a single expression");
  }
  render(e) {
    return e;
  }
  update(e, [t]) {
    if (t === ni || t === tr) return t;
    const r = e.element, n = e.name;
    if (e.type === Aa.PROPERTY) {
      if (t === r[n]) return ni;
    } else if (e.type === Aa.BOOLEAN_ATTRIBUTE) {
      if (!!t === r.hasAttribute(n)) return ni;
    } else if (e.type === Aa.ATTRIBUTE && r.getAttribute(n) === t + "") return ni;
    return Pae(e), t;
  }
});
var Ge = class extends Br {
  constructor() {
    super(...arguments), this.formControlController = new Mk(this, {
      assumeInteractionOn: ["sl-blur", "sl-input"]
    }), this.hasSlotController = new lu(this, "help-text", "label"), this.localize = new ro(this), this.hasFocus = !1, this.title = "", this.__numberInput = Object.assign(document.createElement("input"), { type: "number" }), this.__dateInput = Object.assign(document.createElement("input"), { type: "date" }), this.type = "text", this.name = "", this.value = "", this.defaultValue = "", this.size = "medium", this.filled = !1, this.pill = !1, this.label = "", this.helpText = "", this.clearable = !1, this.disabled = !1, this.placeholder = "", this.readonly = !1, this.passwordToggle = !1, this.passwordVisible = !1, this.noSpinButtons = !1, this.form = "", this.required = !1, this.spellcheck = !0;
  }
  //
  // NOTE: We use an in-memory input for these getters/setters instead of the one in the template because the properties
  // can be set before the component is rendered.
  //
  /**
   * Gets or sets the current value as a `Date` object. Returns `null` if the value can't be converted. This will use the native `<input type="{{type}}">` implementation and may result in an error.
   */
  get valueAsDate() {
    var e;
    return this.__dateInput.type = this.type, this.__dateInput.value = this.value, ((e = this.input) == null ? void 0 : e.valueAsDate) || this.__dateInput.valueAsDate;
  }
  set valueAsDate(e) {
    this.__dateInput.type = this.type, this.__dateInput.valueAsDate = e, this.value = this.__dateInput.value;
  }
  /** Gets or sets the current value as a number. Returns `NaN` if the value can't be converted. */
  get valueAsNumber() {
    var e;
    return this.__numberInput.value = this.value, ((e = this.input) == null ? void 0 : e.valueAsNumber) || this.__numberInput.valueAsNumber;
  }
  set valueAsNumber(e) {
    this.__numberInput.valueAsNumber = e, this.value = this.__numberInput.value;
  }
  /** Gets the validity state object */
  get validity() {
    return this.input.validity;
  }
  /** Gets the validation message */
  get validationMessage() {
    return this.input.validationMessage;
  }
  firstUpdated() {
    this.formControlController.updateValidity();
  }
  handleBlur() {
    this.hasFocus = !1, this.emit("sl-blur");
  }
  handleChange() {
    this.value = this.input.value, this.emit("sl-change");
  }
  handleClearClick(e) {
    e.preventDefault(), this.value !== "" && (this.value = "", this.emit("sl-clear"), this.emit("sl-input"), this.emit("sl-change")), this.input.focus();
  }
  handleFocus() {
    this.hasFocus = !0, this.emit("sl-focus");
  }
  handleInput() {
    this.value = this.input.value, this.formControlController.updateValidity(), this.emit("sl-input");
  }
  handleInvalid(e) {
    this.formControlController.setValidity(!1), this.formControlController.emitInvalidEvent(e);
  }
  handleKeyDown(e) {
    const t = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
    e.key === "Enter" && !t && setTimeout(() => {
      !e.defaultPrevented && !e.isComposing && this.formControlController.submit();
    });
  }
  handlePasswordToggle() {
    this.passwordVisible = !this.passwordVisible;
  }
  handleDisabledChange() {
    this.formControlController.setValidity(this.disabled);
  }
  handleStepChange() {
    this.input.step = String(this.step), this.formControlController.updateValidity();
  }
  async handleValueChange() {
    await this.updateComplete, this.formControlController.updateValidity();
  }
  /** Sets focus on the input. */
  focus(e) {
    this.input.focus(e);
  }
  /** Removes focus from the input. */
  blur() {
    this.input.blur();
  }
  /** Selects all the text in the input. */
  select() {
    this.input.select();
  }
  /** Sets the start and end positions of the text selection (0-based). */
  setSelectionRange(e, t, r = "none") {
    this.input.setSelectionRange(e, t, r);
  }
  /** Replaces a range of text with a new string. */
  setRangeText(e, t, r, n = "preserve") {
    const i = t ?? this.input.selectionStart, a = r ?? this.input.selectionEnd;
    this.input.setRangeText(e, i, a, n), this.value !== this.input.value && (this.value = this.input.value);
  }
  /** Displays the browser picker for an input element (only works if the browser supports it for the input type). */
  showPicker() {
    "showPicker" in HTMLInputElement.prototype && this.input.showPicker();
  }
  /** Increments the value of a numeric input type by the value of the step attribute. */
  stepUp() {
    this.input.stepUp(), this.value !== this.input.value && (this.value = this.input.value);
  }
  /** Decrements the value of a numeric input type by the value of the step attribute. */
  stepDown() {
    this.input.stepDown(), this.value !== this.input.value && (this.value = this.input.value);
  }
  /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */
  checkValidity() {
    return this.input.checkValidity();
  }
  /** Gets the associated form, if one exists. */
  getForm() {
    return this.formControlController.getForm();
  }
  /** Checks for validity and shows the browser's validation message if the control is invalid. */
  reportValidity() {
    return this.input.reportValidity();
  }
  /** Sets a custom validation message. Pass an empty string to restore validity. */
  setCustomValidity(e) {
    this.input.setCustomValidity(e), this.formControlController.updateValidity();
  }
  render() {
    const e = this.hasSlotController.test("label"), t = this.hasSlotController.test("help-text"), r = this.label ? !0 : !!e, n = this.helpText ? !0 : !!t, a = this.clearable && !this.disabled && !this.readonly && (typeof this.value == "number" || this.value.length > 0);
    return Jt`
      <div
        part="form-control"
        class=${En({
      "form-control": !0,
      "form-control--small": this.size === "small",
      "form-control--medium": this.size === "medium",
      "form-control--large": this.size === "large",
      "form-control--has-label": r,
      "form-control--has-help-text": n
    })}
      >
        <label
          part="form-control-label"
          class="form-control__label"
          for="input"
          aria-hidden=${r ? "false" : "true"}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <div
            part="base"
            class=${En({
      input: !0,
      // Sizes
      "input--small": this.size === "small",
      "input--medium": this.size === "medium",
      "input--large": this.size === "large",
      // States
      "input--pill": this.pill,
      "input--standard": !this.filled,
      "input--filled": this.filled,
      "input--disabled": this.disabled,
      "input--focused": this.hasFocus,
      "input--empty": !this.value,
      "input--no-spin-buttons": this.noSpinButtons
    })}
          >
            <span part="prefix" class="input__prefix">
              <slot name="prefix"></slot>
            </span>

            <input
              part="input"
              id="input"
              class="input__control"
              type=${this.type === "password" && this.passwordVisible ? "text" : this.type}
              title=${this.title}
              name=${Nt(this.name)}
              ?disabled=${this.disabled}
              ?readonly=${this.readonly}
              ?required=${this.required}
              placeholder=${Nt(this.placeholder)}
              minlength=${Nt(this.minlength)}
              maxlength=${Nt(this.maxlength)}
              min=${Nt(this.min)}
              max=${Nt(this.max)}
              step=${Nt(this.step)}
              .value=${Lk(this.value)}
              autocapitalize=${Nt(this.autocapitalize)}
              autocomplete=${Nt(this.autocomplete)}
              autocorrect=${Nt(this.autocorrect)}
              ?autofocus=${this.autofocus}
              spellcheck=${this.spellcheck}
              pattern=${Nt(this.pattern)}
              enterkeyhint=${Nt(this.enterkeyhint)}
              inputmode=${Nt(this.inputmode)}
              aria-describedby="help-text"
              @change=${this.handleChange}
              @input=${this.handleInput}
              @invalid=${this.handleInvalid}
              @keydown=${this.handleKeyDown}
              @focus=${this.handleFocus}
              @blur=${this.handleBlur}
            />

            ${a ? Jt`
                  <button
                    part="clear-button"
                    class="input__clear"
                    type="button"
                    aria-label=${this.localize.term("clearEntry")}
                    @click=${this.handleClearClick}
                    tabindex="-1"
                  >
                    <slot name="clear-icon">
                      <sl-icon name="x-circle-fill" library="system"></sl-icon>
                    </slot>
                  </button>
                ` : ""}
            ${this.passwordToggle && !this.disabled ? Jt`
                  <button
                    part="password-toggle-button"
                    class="input__password-toggle"
                    type="button"
                    aria-label=${this.localize.term(this.passwordVisible ? "hidePassword" : "showPassword")}
                    @click=${this.handlePasswordToggle}
                    tabindex="-1"
                  >
                    ${this.passwordVisible ? Jt`
                          <slot name="show-password-icon">
                            <sl-icon name="eye-slash" library="system"></sl-icon>
                          </slot>
                        ` : Jt`
                          <slot name="hide-password-icon">
                            <sl-icon name="eye" library="system"></sl-icon>
                          </slot>
                        `}
                  </button>
                ` : ""}

            <span part="suffix" class="input__suffix">
              <slot name="suffix"></slot>
            </span>
          </div>
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${n ? "false" : "true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
  }
};
Ge.styles = [zn, Nk, Iae];
Ge.dependencies = { "sl-icon": Vn };
V([
  Er(".input__control")
], Ge.prototype, "input", 2);
V([
  ou()
], Ge.prototype, "hasFocus", 2);
V([
  ne()
], Ge.prototype, "title", 2);
V([
  ne({ reflect: !0 })
], Ge.prototype, "type", 2);
V([
  ne()
], Ge.prototype, "name", 2);
V([
  ne()
], Ge.prototype, "value", 2);
V([
  Dk()
], Ge.prototype, "defaultValue", 2);
V([
  ne({ reflect: !0 })
], Ge.prototype, "size", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], Ge.prototype, "filled", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], Ge.prototype, "pill", 2);
V([
  ne()
], Ge.prototype, "label", 2);
V([
  ne({ attribute: "help-text" })
], Ge.prototype, "helpText", 2);
V([
  ne({ type: Boolean })
], Ge.prototype, "clearable", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], Ge.prototype, "disabled", 2);
V([
  ne()
], Ge.prototype, "placeholder", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], Ge.prototype, "readonly", 2);
V([
  ne({ attribute: "password-toggle", type: Boolean })
], Ge.prototype, "passwordToggle", 2);
V([
  ne({ attribute: "password-visible", type: Boolean })
], Ge.prototype, "passwordVisible", 2);
V([
  ne({ attribute: "no-spin-buttons", type: Boolean })
], Ge.prototype, "noSpinButtons", 2);
V([
  ne({ reflect: !0 })
], Ge.prototype, "form", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], Ge.prototype, "required", 2);
V([
  ne()
], Ge.prototype, "pattern", 2);
V([
  ne({ type: Number })
], Ge.prototype, "minlength", 2);
V([
  ne({ type: Number })
], Ge.prototype, "maxlength", 2);
V([
  ne()
], Ge.prototype, "min", 2);
V([
  ne()
], Ge.prototype, "max", 2);
V([
  ne()
], Ge.prototype, "step", 2);
V([
  ne()
], Ge.prototype, "autocapitalize", 2);
V([
  ne()
], Ge.prototype, "autocorrect", 2);
V([
  ne()
], Ge.prototype, "autocomplete", 2);
V([
  ne({ type: Boolean })
], Ge.prototype, "autofocus", 2);
V([
  ne()
], Ge.prototype, "enterkeyhint", 2);
V([
  ne({
    type: Boolean,
    converter: {
      // Allow "true|false" attribute values but keep the property boolean
      fromAttribute: (e) => !(!e || e === "false"),
      toAttribute: (e) => e ? "true" : "false"
    }
  })
], Ge.prototype, "spellcheck", 2);
V([
  ne()
], Ge.prototype, "inputmode", 2);
V([
  Lr("disabled", { waitUntilFirstUpdate: !0 })
], Ge.prototype, "handleDisabledChange", 1);
V([
  Lr("step", { waitUntilFirstUpdate: !0 })
], Ge.prototype, "handleStepChange", 1);
V([
  Lr("value", { waitUntilFirstUpdate: !0 })
], Ge.prototype, "handleValueChange", 1);
Ge.define("sl-input");
var Nae = hn`
  :host {
    --submenu-offset: -2px;

    display: block;
  }

  :host([inert]) {
    display: none;
  }

  .menu-item {
    position: relative;
    display: flex;
    align-items: stretch;
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    line-height: var(--sl-line-height-normal);
    letter-spacing: var(--sl-letter-spacing-normal);
    color: var(--sl-color-neutral-700);
    padding: var(--sl-spacing-2x-small) var(--sl-spacing-2x-small);
    transition: var(--sl-transition-fast) fill;
    user-select: none;
    -webkit-user-select: none;
    white-space: nowrap;
    cursor: pointer;
  }

  .menu-item.menu-item--disabled {
    outline: none;
    opacity: 0.5;
    cursor: not-allowed;
  }

  .menu-item.menu-item--loading {
    outline: none;
    cursor: wait;
  }

  .menu-item.menu-item--loading *:not(sl-spinner) {
    opacity: 0.5;
  }

  .menu-item--loading sl-spinner {
    --indicator-color: currentColor;
    --track-width: 1px;
    position: absolute;
    font-size: 0.75em;
    top: calc(50% - 0.5em);
    left: 0.65rem;
    opacity: 1;
  }

  .menu-item .menu-item__label {
    flex: 1 1 auto;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .menu-item .menu-item__prefix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .menu-item .menu-item__prefix::slotted(*) {
    margin-inline-end: var(--sl-spacing-x-small);
  }

  .menu-item .menu-item__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .menu-item .menu-item__suffix::slotted(*) {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  /* Safe triangle */
  .menu-item--submenu-expanded::after {
    content: '';
    position: fixed;
    z-index: calc(var(--sl-z-index-dropdown) - 1);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    clip-path: polygon(
      var(--safe-triangle-cursor-x, 0) var(--safe-triangle-cursor-y, 0),
      var(--safe-triangle-submenu-start-x, 0) var(--safe-triangle-submenu-start-y, 0),
      var(--safe-triangle-submenu-end-x, 0) var(--safe-triangle-submenu-end-y, 0)
    );
  }

  :host(:focus-visible) {
    outline: none;
  }

  :host(:hover:not([aria-disabled='true'], :focus-visible)) .menu-item,
  .menu-item--submenu-expanded {
    background-color: var(--sl-color-neutral-100);
    color: var(--sl-color-neutral-1000);
  }

  :host(:focus-visible) .menu-item {
    outline: none;
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
    opacity: 1;
  }

  .menu-item .menu-item__check,
  .menu-item .menu-item__chevron {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5em;
    visibility: hidden;
  }

  .menu-item--checked .menu-item__check,
  .menu-item--has-submenu .menu-item__chevron {
    visibility: visible;
  }

  /* Add elevation and z-index to submenus */
  sl-popup::part(popup) {
    box-shadow: var(--sl-shadow-large);
    z-index: var(--sl-z-index-dropdown);
    margin-left: var(--submenu-offset);
  }

  .menu-item--rtl sl-popup::part(popup) {
    margin-left: calc(-1 * var(--submenu-offset));
  }

  @media (forced-colors: active) {
    :host(:hover:not([aria-disabled='true'])) .menu-item,
    :host(:focus-visible) .menu-item {
      outline: dashed 1px SelectedItem;
      outline-offset: -1px;
    }
  }

  ::slotted(sl-menu) {
    max-width: var(--auto-size-available-width) !important;
    max-height: var(--auto-size-available-height) !important;
  }
`;
const Jd = (e, t) => {
  const r = e._$AN;
  if (r === void 0) return !1;
  for (const n of r) n._$AO?.(t, !1), Jd(n, t);
  return !0;
}, E1 = (e) => {
  let t, r;
  do {
    if ((t = e._$AM) === void 0) break;
    r = t._$AN, r.delete(e), e = t;
  } while (r?.size === 0);
}, Fk = (e) => {
  for (let t; t = e._$AM; e = t) {
    let r = t._$AN;
    if (r === void 0) t._$AN = r = /* @__PURE__ */ new Set();
    else if (r.has(e)) break;
    r.add(e), Lae(t);
  }
};
function Mae(e) {
  this._$AN !== void 0 ? (E1(this), this._$AM = e, Fk(this)) : this._$AM = e;
}
function Rae(e, t = !1, r = 0) {
  const n = this._$AH, i = this._$AN;
  if (i !== void 0 && i.size !== 0) if (t) if (Array.isArray(n)) for (let a = r; a < n.length; a++) Jd(n[a], !1), E1(n[a]);
  else n != null && (Jd(n, !1), E1(n));
  else Jd(this, e);
}
const Lae = (e) => {
  e.type == Aa.CHILD && (e._$AP ??= Rae, e._$AQ ??= Mae);
};
class Fae extends P3 {
  constructor() {
    super(...arguments), this._$AN = void 0;
  }
  _$AT(t, r, n) {
    super._$AT(t, r, n), Fk(this), this.isConnected = t._$AU;
  }
  _$AO(t, r = !0) {
    t !== this.isConnected && (this.isConnected = t, t ? this.reconnected?.() : this.disconnected?.()), r && (Jd(this, t), E1(this));
  }
  setValue(t) {
    if (Ik(this._$Ct)) this._$Ct._$AI(t, this);
    else {
      const r = [...this._$Ct._$AH];
      r[this._$Ci] = t, this._$Ct._$AI(r, this, 0);
    }
  }
  disconnected() {
  }
  reconnected() {
  }
}
const jae = () => new zae();
class zae {
}
const p2 = /* @__PURE__ */ new WeakMap(), Vae = O3(class extends Fae {
  render(e) {
    return tr;
  }
  update(e, [t]) {
    const r = t !== this.G;
    return r && this.G !== void 0 && this.rt(void 0), (r || this.lt !== this.ct) && (this.G = t, this.ht = e.options?.host, this.rt(this.ct = e.element)), tr;
  }
  rt(e) {
    if (this.isConnected || (e = void 0), typeof this.G == "function") {
      const t = this.ht ?? globalThis;
      let r = p2.get(t);
      r === void 0 && (r = /* @__PURE__ */ new WeakMap(), p2.set(t, r)), r.get(this.G) !== void 0 && this.G.call(this.ht, void 0), r.set(this.G, e), e !== void 0 && this.G.call(this.ht, e);
    } else this.G.value = e;
  }
  get lt() {
    return typeof this.G == "function" ? p2.get(this.ht ?? globalThis)?.get(this.G) : this.G?.value;
  }
  disconnected() {
    this.lt === this.ct && this.rt(void 0);
  }
  reconnected() {
    this.rt(this.ct);
  }
});
var Uae = class {
  constructor(e, t) {
    this.popupRef = jae(), this.enableSubmenuTimer = -1, this.isConnected = !1, this.isPopupConnected = !1, this.skidding = 0, this.submenuOpenDelay = 100, this.handleMouseMove = (r) => {
      this.host.style.setProperty("--safe-triangle-cursor-x", `${r.clientX}px`), this.host.style.setProperty("--safe-triangle-cursor-y", `${r.clientY}px`);
    }, this.handleMouseOver = () => {
      this.hasSlotController.test("submenu") && this.enableSubmenu();
    }, this.handleKeyDown = (r) => {
      switch (r.key) {
        case "Escape":
        case "Tab":
          this.disableSubmenu();
          break;
        case "ArrowLeft":
          r.target !== this.host && (r.preventDefault(), r.stopPropagation(), this.host.focus(), this.disableSubmenu());
          break;
        case "ArrowRight":
        case "Enter":
        case " ":
          this.handleSubmenuEntry(r);
          break;
      }
    }, this.handleClick = (r) => {
      var n;
      r.target === this.host ? (r.preventDefault(), r.stopPropagation()) : r.target instanceof Element && (r.target.tagName === "sl-menu-item" || (n = r.target.role) != null && n.startsWith("menuitem")) && this.disableSubmenu();
    }, this.handleFocusOut = (r) => {
      r.relatedTarget && r.relatedTarget instanceof Element && this.host.contains(r.relatedTarget) || this.disableSubmenu();
    }, this.handlePopupMouseover = (r) => {
      r.stopPropagation();
    }, this.handlePopupReposition = () => {
      const r = this.host.renderRoot.querySelector("slot[name='submenu']"), n = r?.assignedElements({ flatten: !0 }).filter((d) => d.localName === "sl-menu")[0], i = getComputedStyle(this.host).direction === "rtl";
      if (!n)
        return;
      const { left: a, top: o, width: s, height: l } = n.getBoundingClientRect();
      this.host.style.setProperty("--safe-triangle-submenu-start-x", `${i ? a + s : a}px`), this.host.style.setProperty("--safe-triangle-submenu-start-y", `${o}px`), this.host.style.setProperty("--safe-triangle-submenu-end-x", `${i ? a + s : a}px`), this.host.style.setProperty("--safe-triangle-submenu-end-y", `${o + l}px`);
    }, (this.host = e).addController(this), this.hasSlotController = t;
  }
  hostConnected() {
    this.hasSlotController.test("submenu") && !this.host.disabled && this.addListeners();
  }
  hostDisconnected() {
    this.removeListeners();
  }
  hostUpdated() {
    this.hasSlotController.test("submenu") && !this.host.disabled ? (this.addListeners(), this.updateSkidding()) : this.removeListeners();
  }
  addListeners() {
    this.isConnected || (this.host.addEventListener("mousemove", this.handleMouseMove), this.host.addEventListener("mouseover", this.handleMouseOver), this.host.addEventListener("keydown", this.handleKeyDown), this.host.addEventListener("click", this.handleClick), this.host.addEventListener("focusout", this.handleFocusOut), this.isConnected = !0), this.isPopupConnected || this.popupRef.value && (this.popupRef.value.addEventListener("mouseover", this.handlePopupMouseover), this.popupRef.value.addEventListener("sl-reposition", this.handlePopupReposition), this.isPopupConnected = !0);
  }
  removeListeners() {
    this.isConnected && (this.host.removeEventListener("mousemove", this.handleMouseMove), this.host.removeEventListener("mouseover", this.handleMouseOver), this.host.removeEventListener("keydown", this.handleKeyDown), this.host.removeEventListener("click", this.handleClick), this.host.removeEventListener("focusout", this.handleFocusOut), this.isConnected = !1), this.isPopupConnected && this.popupRef.value && (this.popupRef.value.removeEventListener("mouseover", this.handlePopupMouseover), this.popupRef.value.removeEventListener("sl-reposition", this.handlePopupReposition), this.isPopupConnected = !1);
  }
  handleSubmenuEntry(e) {
    const t = this.host.renderRoot.querySelector("slot[name='submenu']");
    if (!t) {
      console.error("Cannot activate a submenu if no corresponding menuitem can be found.", this);
      return;
    }
    let r = null;
    for (const n of t.assignedElements())
      if (r = n.querySelectorAll("sl-menu-item, [role^='menuitem']"), r.length !== 0)
        break;
    if (!(!r || r.length === 0)) {
      r[0].setAttribute("tabindex", "0");
      for (let n = 1; n !== r.length; ++n)
        r[n].setAttribute("tabindex", "-1");
      this.popupRef.value && (e.preventDefault(), e.stopPropagation(), this.popupRef.value.active ? r[0] instanceof HTMLElement && r[0].focus() : (this.enableSubmenu(!1), this.host.updateComplete.then(() => {
        r[0] instanceof HTMLElement && r[0].focus();
      }), this.host.requestUpdate()));
    }
  }
  setSubmenuState(e) {
    this.popupRef.value && this.popupRef.value.active !== e && (this.popupRef.value.active = e, this.host.requestUpdate());
  }
  // Shows the submenu. Supports disabling the opening delay, e.g. for keyboard events that want to set the focus to the
  // newly opened menu.
  enableSubmenu(e = !0) {
    e ? (window.clearTimeout(this.enableSubmenuTimer), this.enableSubmenuTimer = window.setTimeout(() => {
      this.setSubmenuState(!0);
    }, this.submenuOpenDelay)) : this.setSubmenuState(!0);
  }
  disableSubmenu() {
    window.clearTimeout(this.enableSubmenuTimer), this.setSubmenuState(!1);
  }
  // Calculate the space the top of a menu takes-up, for aligning the popup menu-item with the activating element.
  updateSkidding() {
    var e;
    if (!((e = this.host.parentElement) != null && e.computedStyleMap))
      return;
    const t = this.host.parentElement.computedStyleMap(), n = ["padding-top", "border-top-width", "margin-top"].reduce((i, a) => {
      var o;
      const s = (o = t.get(a)) != null ? o : new CSSUnitValue(0, "px"), d = (s instanceof CSSUnitValue ? s : new CSSUnitValue(0, "px")).to("px");
      return i - d.value;
    }, 0);
    this.skidding = n;
  }
  isExpanded() {
    return this.popupRef.value ? this.popupRef.value.active : !1;
  }
  renderSubmenu() {
    const e = getComputedStyle(this.host).direction === "rtl";
    return this.isConnected ? Jt`
      <sl-popup
        ${Vae(this.popupRef)}
        placement=${e ? "left-start" : "right-start"}
        anchor="anchor"
        flip
        flip-fallback-strategy="best-fit"
        skidding="${this.skidding}"
        strategy="fixed"
        auto-size="vertical"
        auto-size-padding="10"
      >
        <slot name="submenu"></slot>
      </sl-popup>
    ` : Jt` <slot name="submenu" hidden></slot> `;
  }
}, qae = hn`
  :host {
    --track-width: 2px;
    --track-color: rgb(128 128 128 / 25%);
    --indicator-color: var(--sl-color-primary-600);
    --speed: 2s;

    display: inline-flex;
    width: 1em;
    height: 1em;
    flex: none;
  }

  .spinner {
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
  }

  .spinner__track,
  .spinner__indicator {
    fill: none;
    stroke-width: var(--track-width);
    r: calc(0.5em - var(--track-width) / 2);
    cx: 0.5em;
    cy: 0.5em;
    transform-origin: 50% 50%;
  }

  .spinner__track {
    stroke: var(--track-color);
    transform-origin: 0% 0%;
  }

  .spinner__indicator {
    stroke: var(--indicator-color);
    stroke-linecap: round;
    stroke-dasharray: 150% 75%;
    animation: spin var(--speed) linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
      stroke-dasharray: 0.05em, 3em;
    }

    50% {
      transform: rotate(450deg);
      stroke-dasharray: 1.375em, 1.375em;
    }

    100% {
      transform: rotate(1080deg);
      stroke-dasharray: 0.05em, 3em;
    }
  }
`, I3 = class extends Br {
  constructor() {
    super(...arguments), this.localize = new ro(this);
  }
  render() {
    return Jt`
      <svg part="base" class="spinner" role="progressbar" aria-label=${this.localize.term("loading")}>
        <circle class="spinner__track"></circle>
        <circle class="spinner__indicator"></circle>
      </svg>
    `;
  }
};
I3.styles = [zn, qae];
var An = class extends Br {
  constructor() {
    super(...arguments), this.localize = new ro(this), this.type = "normal", this.checked = !1, this.value = "", this.loading = !1, this.disabled = !1, this.hasSlotController = new lu(this, "submenu"), this.submenuController = new Uae(this, this.hasSlotController), this.handleHostClick = (e) => {
      this.disabled && (e.preventDefault(), e.stopImmediatePropagation());
    }, this.handleMouseOver = (e) => {
      this.focus(), e.stopPropagation();
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("click", this.handleHostClick), this.addEventListener("mouseover", this.handleMouseOver);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("click", this.handleHostClick), this.removeEventListener("mouseover", this.handleMouseOver);
  }
  handleDefaultSlotChange() {
    const e = this.getTextLabel();
    if (typeof this.cachedTextLabel > "u") {
      this.cachedTextLabel = e;
      return;
    }
    e !== this.cachedTextLabel && (this.cachedTextLabel = e, this.emit("slotchange", { bubbles: !0, composed: !1, cancelable: !1 }));
  }
  handleCheckedChange() {
    if (this.checked && this.type !== "checkbox") {
      this.checked = !1, console.error('The checked attribute can only be used on menu items with type="checkbox"', this);
      return;
    }
    this.type === "checkbox" ? this.setAttribute("aria-checked", this.checked ? "true" : "false") : this.removeAttribute("aria-checked");
  }
  handleDisabledChange() {
    this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
  }
  handleTypeChange() {
    this.type === "checkbox" ? (this.setAttribute("role", "menuitemcheckbox"), this.setAttribute("aria-checked", this.checked ? "true" : "false")) : (this.setAttribute("role", "menuitem"), this.removeAttribute("aria-checked"));
  }
  /** Returns a text label based on the contents of the menu item's default slot. */
  getTextLabel() {
    return Dae(this.defaultSlot);
  }
  isSubmenu() {
    return this.hasSlotController.test("submenu");
  }
  render() {
    const e = this.localize.dir() === "rtl", t = this.submenuController.isExpanded();
    return Jt`
      <div
        id="anchor"
        part="base"
        class=${En({
      "menu-item": !0,
      "menu-item--rtl": e,
      "menu-item--checked": this.checked,
      "menu-item--disabled": this.disabled,
      "menu-item--loading": this.loading,
      "menu-item--has-submenu": this.isSubmenu(),
      "menu-item--submenu-expanded": t
    })}
        ?aria-haspopup="${this.isSubmenu()}"
        ?aria-expanded="${!!t}"
      >
        <span part="checked-icon" class="menu-item__check">
          <sl-icon name="check" library="system" aria-hidden="true"></sl-icon>
        </span>

        <slot name="prefix" part="prefix" class="menu-item__prefix"></slot>

        <slot part="label" class="menu-item__label" @slotchange=${this.handleDefaultSlotChange}></slot>

        <slot name="suffix" part="suffix" class="menu-item__suffix"></slot>

        <span part="submenu-icon" class="menu-item__chevron">
          <sl-icon name=${e ? "chevron-left" : "chevron-right"} library="system" aria-hidden="true"></sl-icon>
        </span>

        ${this.submenuController.renderSubmenu()}
        ${this.loading ? Jt` <sl-spinner part="spinner" exportparts="base:spinner__base"></sl-spinner> ` : ""}
      </div>
    `;
  }
};
An.styles = [zn, Nae];
An.dependencies = {
  "sl-icon": Vn,
  "sl-popup": It,
  "sl-spinner": I3
};
V([
  Er("slot:not([name])")
], An.prototype, "defaultSlot", 2);
V([
  Er(".menu-item")
], An.prototype, "menuItem", 2);
V([
  ne()
], An.prototype, "type", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], An.prototype, "checked", 2);
V([
  ne()
], An.prototype, "value", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], An.prototype, "loading", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], An.prototype, "disabled", 2);
V([
  Lr("checked")
], An.prototype, "handleCheckedChange", 1);
V([
  Lr("disabled")
], An.prototype, "handleDisabledChange", 1);
V([
  Lr("type")
], An.prototype, "handleTypeChange", 1);
An.define("sl-menu-item");
var Bae = hn`
  :host {
    display: block;
    position: relative;
    background: var(--sl-panel-background-color);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    border-radius: var(--sl-border-radius-medium);
    padding: var(--sl-spacing-x-small) 0;
    overflow: auto;
    overscroll-behavior: none;
  }

  ::slotted(sl-divider) {
    --spacing: var(--sl-spacing-x-small);
  }
`, D3 = class extends Br {
  connectedCallback() {
    super.connectedCallback(), this.setAttribute("role", "menu");
  }
  handleClick(e) {
    const t = ["menuitem", "menuitemcheckbox"], r = e.composedPath(), n = r.find((s) => {
      var l;
      return t.includes(((l = s?.getAttribute) == null ? void 0 : l.call(s, "role")) || "");
    });
    if (!n || r.find((s) => {
      var l;
      return ((l = s?.getAttribute) == null ? void 0 : l.call(s, "role")) === "menu";
    }) !== this) return;
    const o = n;
    o.type === "checkbox" && (o.checked = !o.checked), this.emit("sl-select", { detail: { item: o } });
  }
  handleKeyDown(e) {
    if (e.key === "Enter" || e.key === " ") {
      const t = this.getCurrentItem();
      e.preventDefault(), e.stopPropagation(), t?.click();
    } else if (["ArrowDown", "ArrowUp", "Home", "End"].includes(e.key)) {
      const t = this.getAllItems(), r = this.getCurrentItem();
      let n = r ? t.indexOf(r) : 0;
      t.length > 0 && (e.preventDefault(), e.stopPropagation(), e.key === "ArrowDown" ? n++ : e.key === "ArrowUp" ? n-- : e.key === "Home" ? n = 0 : e.key === "End" && (n = t.length - 1), n < 0 && (n = t.length - 1), n > t.length - 1 && (n = 0), this.setCurrentItem(t[n]), t[n].focus());
    }
  }
  handleMouseDown(e) {
    const t = e.target;
    this.isMenuItem(t) && this.setCurrentItem(t);
  }
  handleSlotChange() {
    const e = this.getAllItems();
    e.length > 0 && this.setCurrentItem(e[0]);
  }
  isMenuItem(e) {
    var t;
    return e.tagName.toLowerCase() === "sl-menu-item" || ["menuitem", "menuitemcheckbox", "menuitemradio"].includes((t = e.getAttribute("role")) != null ? t : "");
  }
  /** @internal Gets all slotted menu items, ignoring dividers, headers, and other elements. */
  getAllItems() {
    return [...this.defaultSlot.assignedElements({ flatten: !0 })].filter((e) => !(e.inert || !this.isMenuItem(e)));
  }
  /**
   * @internal Gets the current menu item, which is the menu item that has `tabindex="0"` within the roving tab index.
   * The menu item may or may not have focus, but for keyboard interaction purposes it's considered the "active" item.
   */
  getCurrentItem() {
    return this.getAllItems().find((e) => e.getAttribute("tabindex") === "0");
  }
  /**
   * @internal Sets the current menu item to the specified element. This sets `tabindex="0"` on the target element and
   * `tabindex="-1"` to all other items. This method must be called prior to setting focus on a menu item.
   */
  setCurrentItem(e) {
    this.getAllItems().forEach((r) => {
      r.setAttribute("tabindex", r === e ? "0" : "-1");
    });
  }
  render() {
    return Jt`
      <slot
        @slotchange=${this.handleSlotChange}
        @click=${this.handleClick}
        @keydown=${this.handleKeyDown}
        @mousedown=${this.handleMouseDown}
      ></slot>
    `;
  }
};
D3.styles = [zn, Bae];
V([
  Er("slot")
], D3.prototype, "defaultSlot", 2);
D3.define("sl-menu");
I3.define("sl-spinner");
const no = ':host,.sl-theme-dark{color-scheme:dark;--sl-color-gray-50: hsl(240 5.1% 15%);--sl-color-gray-100: hsl(240 5.7% 18.2%);--sl-color-gray-200: hsl(240 4.6% 22%);--sl-color-gray-300: hsl(240 5% 27.6%);--sl-color-gray-400: hsl(240 5% 35.5%);--sl-color-gray-500: hsl(240 3.7% 44%);--sl-color-gray-600: hsl(240 5.3% 58%);--sl-color-gray-700: hsl(240 5.6% 73%);--sl-color-gray-800: hsl(240 7.3% 84%);--sl-color-gray-900: hsl(240 9.1% 91.8%);--sl-color-gray-950: hsl(0 0% 95%);--sl-color-red-50: hsl(0 56% 23.9%);--sl-color-red-100: hsl(.6 60% 33.9%);--sl-color-red-200: hsl(.9 67.2% 37.1%);--sl-color-red-300: hsl(1.1 71.3% 43.7%);--sl-color-red-400: hsl(1 76% 52.5%);--sl-color-red-500: hsl(.7 89.6% 57.2%);--sl-color-red-600: hsl(0 98.6% 67.9%);--sl-color-red-700: hsl(0 100% 72.3%);--sl-color-red-800: hsl(0 100% 85.6%);--sl-color-red-900: hsl(0 100% 90.3%);--sl-color-red-950: hsl(0 100% 95.9%);--sl-color-orange-50: hsl(15 64.2% 23.3%);--sl-color-orange-100: hsl(15.1 70.9% 31.1%);--sl-color-orange-200: hsl(15.3 75.7% 35.5%);--sl-color-orange-300: hsl(17.1 83.5% 42.7%);--sl-color-orange-400: hsl(20.1 88% 50.8%);--sl-color-orange-500: hsl(24.3 100% 50.5%);--sl-color-orange-600: hsl(27.2 100% 57.7%);--sl-color-orange-700: hsl(31.3 100% 68.7%);--sl-color-orange-800: hsl(33.8 100% 79.3%);--sl-color-orange-900: hsl(38.9 100% 87.7%);--sl-color-orange-950: hsl(46.2 100% 95%);--sl-color-amber-50: hsl(21.9 66.3% 21.1%);--sl-color-amber-100: hsl(21.5 73.6% 29.7%);--sl-color-amber-200: hsl(22.3 77.6% 33.3%);--sl-color-amber-300: hsl(25.4 84.2% 39.6%);--sl-color-amber-400: hsl(31.4 87.4% 46.7%);--sl-color-amber-500: hsl(37 96.6% 48.3%);--sl-color-amber-600: hsl(43.3 100% 53.4%);--sl-color-amber-700: hsl(46.5 100% 61.1%);--sl-color-amber-800: hsl(49.3 100% 73%);--sl-color-amber-900: hsl(51.8 100% 85%);--sl-color-amber-950: hsl(60 100% 94.6%);--sl-color-yellow-50: hsl(32.5 60% 18.2%);--sl-color-yellow-100: hsl(28.1 68.6% 29%);--sl-color-yellow-200: hsl(31.3 75.8% 30.8%);--sl-color-yellow-300: hsl(34.7 84.4% 35.3%);--sl-color-yellow-400: hsl(40.1 87.3% 43.3%);--sl-color-yellow-500: hsl(44.7 88% 46%);--sl-color-yellow-600: hsl(47.7 100% 50.9%);--sl-color-yellow-700: hsl(51.3 100% 59.9%);--sl-color-yellow-800: hsl(54.6 100% 73%);--sl-color-yellow-900: hsl(58.9 100% 84.2%);--sl-color-yellow-950: hsl(60 100% 94%);--sl-color-lime-50: hsl(86.5 54.4% 18%);--sl-color-lime-100: hsl(87.6 56.8% 23.3%);--sl-color-lime-200: hsl(85.8 63.2% 24.5%);--sl-color-lime-300: hsl(86.1 72% 29.4%);--sl-color-lime-400: hsl(85.5 76.8% 37.3%);--sl-color-lime-500: hsl(84.3 74.2% 42.1%);--sl-color-lime-600: hsl(82.8 81.5% 52.6%);--sl-color-lime-700: hsl(82 89.9% 64%);--sl-color-lime-800: hsl(80.9 97.9% 76.6%);--sl-color-lime-900: hsl(77.9 100% 85.8%);--sl-color-lime-950: hsl(69.5 100% 93.8%);--sl-color-green-50: hsl(144.3 53.6% 16%);--sl-color-green-100: hsl(143.2 55.4% 23.5%);--sl-color-green-200: hsl(141.5 58.2% 26.3%);--sl-color-green-300: hsl(140.8 64.2% 31.8%);--sl-color-green-400: hsl(140.3 68% 39.2%);--sl-color-green-500: hsl(141.1 64.9% 43%);--sl-color-green-600: hsl(141.6 72.4% 55.2%);--sl-color-green-700: hsl(141.7 82.7% 70.1%);--sl-color-green-800: hsl(141 90.9% 82.1%);--sl-color-green-900: hsl(142 100% 89.1%);--sl-color-green-950: hsl(144 100% 95.5%);--sl-color-emerald-50: hsl(164.3 75% 13.5%);--sl-color-emerald-100: hsl(163.5 72.6% 20.1%);--sl-color-emerald-200: hsl(162.1 73.7% 22.4%);--sl-color-emerald-300: hsl(161.3 77.3% 27.6%);--sl-color-emerald-400: hsl(159.6 77.1% 34.3%);--sl-color-emerald-500: hsl(159.1 73.5% 37.9%);--sl-color-emerald-600: hsl(157.8 66.8% 48.9%);--sl-color-emerald-700: hsl(156.2 76.1% 63.8%);--sl-color-emerald-800: hsl(152.4 84.4% 77.4%);--sl-color-emerald-900: hsl(149.3 100% 87%);--sl-color-emerald-950: hsl(158.6 100% 94.8%);--sl-color-teal-50: hsl(176.5 51.5% 15.4%);--sl-color-teal-100: hsl(175.9 54.7% 22.3%);--sl-color-teal-200: hsl(175.9 60.7% 23.9%);--sl-color-teal-300: hsl(174.5 67.3% 28.8%);--sl-color-teal-400: hsl(174.4 71.9% 34.9%);--sl-color-teal-500: hsl(173.1 71% 38.3%);--sl-color-teal-600: hsl(172.3 68.2% 48.1%);--sl-color-teal-700: hsl(170.5 81.3% 61.5%);--sl-color-teal-800: hsl(168.4 92.1% 75.2%);--sl-color-teal-900: hsl(168.3 100% 86%);--sl-color-teal-950: hsl(180 100% 95.5%);--sl-color-cyan-50: hsl(197.1 53.8% 20.3%);--sl-color-cyan-100: hsl(196.8 57.3% 27.2%);--sl-color-cyan-200: hsl(195.3 62.7% 29.4%);--sl-color-cyan-300: hsl(193.5 71.3% 34.1%);--sl-color-cyan-400: hsl(192.5 76.8% 40.6%);--sl-color-cyan-500: hsl(189.4 78.6% 42.6%);--sl-color-cyan-600: hsl(188.2 89.1% 51.7%);--sl-color-cyan-700: hsl(187 98.6% 66.2%);--sl-color-cyan-800: hsl(184.9 100% 78.3%);--sl-color-cyan-900: hsl(180 100% 86.6%);--sl-color-cyan-950: hsl(180 100% 94.8%);--sl-color-sky-50: hsl(203 63.8% 20.9%);--sl-color-sky-100: hsl(203.4 70.4% 28%);--sl-color-sky-200: hsl(202.7 75.8% 30.8%);--sl-color-sky-300: hsl(203.1 80.4% 36.1%);--sl-color-sky-400: hsl(202.1 80.5% 44.3%);--sl-color-sky-500: hsl(199.7 85.9% 47.7%);--sl-color-sky-600: hsl(198.7 97.9% 57.2%);--sl-color-sky-700: hsl(198.7 100% 70.5%);--sl-color-sky-800: hsl(198.8 100% 82.5%);--sl-color-sky-900: hsl(198.5 100% 89.9%);--sl-color-sky-950: hsl(186 100% 95.5%);--sl-color-blue-50: hsl(227.1 49.5% 22.7%);--sl-color-blue-100: hsl(225.8 58.9% 36.8%);--sl-color-blue-200: hsl(227.7 64.4% 42.9%);--sl-color-blue-300: hsl(226.1 72.7% 51.2%);--sl-color-blue-400: hsl(222.6 86.5% 56.3%);--sl-color-blue-500: hsl(217.8 95.8% 57.4%);--sl-color-blue-600: hsl(213.3 100% 65%);--sl-color-blue-700: hsl(210.9 100% 74.8%);--sl-color-blue-800: hsl(211.5 100% 83.4%);--sl-color-blue-900: hsl(211 100% 88.9%);--sl-color-blue-950: hsl(201.8 100% 95.3%);--sl-color-indigo-50: hsl(243.5 40.8% 27%);--sl-color-indigo-100: hsl(242.9 45.7% 37.6%);--sl-color-indigo-200: hsl(244.7 52.7% 43.1%);--sl-color-indigo-300: hsl(245.3 60.5% 52.4%);--sl-color-indigo-400: hsl(244.1 79.2% 60.4%);--sl-color-indigo-500: hsl(239.6 88.7% 63.8%);--sl-color-indigo-600: hsl(234.5 96.7% 70.9%);--sl-color-indigo-700: hsl(229.4 100% 78.3%);--sl-color-indigo-800: hsl(227.1 100% 85%);--sl-color-indigo-900: hsl(223.8 100% 89.9%);--sl-color-indigo-950: hsl(220 100% 95.1%);--sl-color-violet-50: hsl(265.1 57.3% 25.4%);--sl-color-violet-100: hsl(263.5 63.8% 39.4%);--sl-color-violet-200: hsl(263.4 66.2% 44.1%);--sl-color-violet-300: hsl(263.7 72.8% 52.4%);--sl-color-violet-400: hsl(262.5 87.3% 59.8%);--sl-color-violet-500: hsl(258.3 95.1% 63.2%);--sl-color-violet-600: hsl(255.1 100% 67.2%);--sl-color-violet-700: hsl(253 100% 81.5%);--sl-color-violet-800: hsl(251.7 100% 87.9%);--sl-color-violet-900: hsl(254.1 100% 91.7%);--sl-color-violet-950: hsl(257.1 100% 96.1%);--sl-color-purple-50: hsl(276 54.3% 20.5%);--sl-color-purple-100: hsl(273.6 61.8% 35.4%);--sl-color-purple-200: hsl(272.9 64% 41.4%);--sl-color-purple-300: hsl(271.9 68.1% 49.2%);--sl-color-purple-400: hsl(271.5 85.1% 57.8%);--sl-color-purple-500: hsl(270.7 96.4% 62.1%);--sl-color-purple-600: hsl(270.5 100% 71.9%);--sl-color-purple-700: hsl(270.9 100% 81.3%);--sl-color-purple-800: hsl(272.4 100% 87.7%);--sl-color-purple-900: hsl(276.7 100% 91.5%);--sl-color-purple-950: hsl(300 100% 96.5%);--sl-color-fuchsia-50: hsl(297.1 51.2% 18.6%);--sl-color-fuchsia-100: hsl(296.7 59.5% 31.5%);--sl-color-fuchsia-200: hsl(295.4 65.4% 35.1%);--sl-color-fuchsia-300: hsl(294.6 67.4% 42.2%);--sl-color-fuchsia-400: hsl(293.3 68.7% 51.2%);--sl-color-fuchsia-500: hsl(292.1 88.4% 57.7%);--sl-color-fuchsia-600: hsl(292 98.5% 59.5%);--sl-color-fuchsia-700: hsl(292.4 100% 79.5%);--sl-color-fuchsia-800: hsl(292.9 100% 86.8%);--sl-color-fuchsia-900: hsl(300 100% 91.5%);--sl-color-fuchsia-950: hsl(300 100% 96.3%);--sl-color-pink-50: hsl(336.2 59.6% 20%);--sl-color-pink-100: hsl(336.8 63.9% 34%);--sl-color-pink-200: hsl(336.8 68.7% 37.6%);--sl-color-pink-300: hsl(336.1 71.8% 44.5%);--sl-color-pink-400: hsl(333.9 74.9% 53.1%);--sl-color-pink-500: hsl(330.7 86.3% 57.7%);--sl-color-pink-600: hsl(328.6 91.5% 67.2%);--sl-color-pink-700: hsl(327.4 97.6% 78.7%);--sl-color-pink-800: hsl(325.1 100% 86.6%);--sl-color-pink-900: hsl(322.1 100% 91.3%);--sl-color-pink-950: hsl(315 100% 95.9%);--sl-color-rose-50: hsl(342.3 62.9% 21.5%);--sl-color-rose-100: hsl(342.8 68.9% 34.2%);--sl-color-rose-200: hsl(344.8 72.6% 37.3%);--sl-color-rose-300: hsl(346.9 75.8% 43.7%);--sl-color-rose-400: hsl(348.2 80.1% 52.7%);--sl-color-rose-500: hsl(350.4 94.8% 57.5%);--sl-color-rose-600: hsl(351.2 100% 58.1%);--sl-color-rose-700: hsl(352.3 100% 78.1%);--sl-color-rose-800: hsl(352 100% 86.2%);--sl-color-rose-900: hsl(354.5 100% 90.7%);--sl-color-rose-950: hsl(353.3 100% 95.7%);--sl-color-primary-50: var(--sl-color-sky-50);--sl-color-primary-100: var(--sl-color-sky-100);--sl-color-primary-200: var(--sl-color-sky-200);--sl-color-primary-300: var(--sl-color-sky-300);--sl-color-primary-400: var(--sl-color-sky-400);--sl-color-primary-500: var(--sl-color-sky-500);--sl-color-primary-600: var(--sl-color-sky-600);--sl-color-primary-700: var(--sl-color-sky-700);--sl-color-primary-800: var(--sl-color-sky-800);--sl-color-primary-900: var(--sl-color-sky-900);--sl-color-primary-950: var(--sl-color-sky-950);--sl-color-success-50: var(--sl-color-green-50);--sl-color-success-100: var(--sl-color-green-100);--sl-color-success-200: var(--sl-color-green-200);--sl-color-success-300: var(--sl-color-green-300);--sl-color-success-400: var(--sl-color-green-400);--sl-color-success-500: var(--sl-color-green-500);--sl-color-success-600: var(--sl-color-green-600);--sl-color-success-700: var(--sl-color-green-700);--sl-color-success-800: var(--sl-color-green-800);--sl-color-success-900: var(--sl-color-green-900);--sl-color-success-950: var(--sl-color-green-950);--sl-color-warning-50: var(--sl-color-amber-50);--sl-color-warning-100: var(--sl-color-amber-100);--sl-color-warning-200: var(--sl-color-amber-200);--sl-color-warning-300: var(--sl-color-amber-300);--sl-color-warning-400: var(--sl-color-amber-400);--sl-color-warning-500: var(--sl-color-amber-500);--sl-color-warning-600: var(--sl-color-amber-600);--sl-color-warning-700: var(--sl-color-amber-700);--sl-color-warning-800: var(--sl-color-amber-800);--sl-color-warning-900: var(--sl-color-amber-900);--sl-color-warning-950: var(--sl-color-amber-950);--sl-color-danger-50: var(--sl-color-red-50);--sl-color-danger-100: var(--sl-color-red-100);--sl-color-danger-200: var(--sl-color-red-200);--sl-color-danger-300: var(--sl-color-red-300);--sl-color-danger-400: var(--sl-color-red-400);--sl-color-danger-500: var(--sl-color-red-500);--sl-color-danger-600: var(--sl-color-red-600);--sl-color-danger-700: var(--sl-color-red-700);--sl-color-danger-800: var(--sl-color-red-800);--sl-color-danger-900: var(--sl-color-red-900);--sl-color-danger-950: var(--sl-color-red-950);--sl-color-neutral-50: var(--sl-color-gray-50);--sl-color-neutral-100: var(--sl-color-gray-100);--sl-color-neutral-200: var(--sl-color-gray-200);--sl-color-neutral-300: var(--sl-color-gray-300);--sl-color-neutral-400: var(--sl-color-gray-400);--sl-color-neutral-500: var(--sl-color-gray-500);--sl-color-neutral-600: var(--sl-color-gray-600);--sl-color-neutral-700: var(--sl-color-gray-700);--sl-color-neutral-800: var(--sl-color-gray-800);--sl-color-neutral-900: var(--sl-color-gray-900);--sl-color-neutral-950: var(--sl-color-gray-950);--sl-color-neutral-0: hsl(240, 5.9%, 11%);--sl-color-neutral-1000: hsl(0, 0%, 100%);--sl-border-radius-small: .1875rem;--sl-border-radius-medium: .25rem;--sl-border-radius-large: .5rem;--sl-border-radius-x-large: 1rem;--sl-border-radius-circle: 50%;--sl-border-radius-pill: 9999px;--sl-shadow-x-small: 0 1px 2px rgb(0 0 0 / 18%);--sl-shadow-small: 0 1px 2px rgb(0 0 0 / 24%);--sl-shadow-medium: 0 2px 4px rgb(0 0 0 / 24%);--sl-shadow-large: 0 2px 8px rgb(0 0 0 / 24%);--sl-shadow-x-large: 0 4px 16px rgb(0 0 0 / 24%);--sl-spacing-3x-small: .125rem;--sl-spacing-2x-small: .25rem;--sl-spacing-x-small: .5rem;--sl-spacing-small: .75rem;--sl-spacing-medium: 1rem;--sl-spacing-large: 1.25rem;--sl-spacing-x-large: 1.75rem;--sl-spacing-2x-large: 2.25rem;--sl-spacing-3x-large: 3rem;--sl-spacing-4x-large: 4.5rem;--sl-transition-x-slow: 1s;--sl-transition-slow: .5s;--sl-transition-medium: .25s;--sl-transition-fast: .15s;--sl-transition-x-fast: 50ms;--sl-font-mono: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;--sl-font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";--sl-font-serif: Georgia, "Times New Roman", serif;--sl-font-size-2x-small: .625rem;--sl-font-size-x-small: .75rem;--sl-font-size-small: .875rem;--sl-font-size-medium: 1rem;--sl-font-size-large: 1.25rem;--sl-font-size-x-large: 1.5rem;--sl-font-size-2x-large: 2.25rem;--sl-font-size-3x-large: 3rem;--sl-font-size-4x-large: 4.5rem;--sl-font-weight-light: 300;--sl-font-weight-normal: 400;--sl-font-weight-semibold: 500;--sl-font-weight-bold: 700;--sl-letter-spacing-denser: -.03em;--sl-letter-spacing-dense: -.015em;--sl-letter-spacing-normal: normal;--sl-letter-spacing-loose: .075em;--sl-letter-spacing-looser: .15em;--sl-line-height-denser: 1;--sl-line-height-dense: 1.4;--sl-line-height-normal: 1.8;--sl-line-height-loose: 2.2;--sl-line-height-looser: 2.6;--sl-focus-ring-color: var(--sl-color-primary-700);--sl-focus-ring-style: solid;--sl-focus-ring-width: 3px;--sl-focus-ring: var(--sl-focus-ring-style) var(--sl-focus-ring-width) var(--sl-focus-ring-color);--sl-focus-ring-offset: 1px;--sl-button-font-size-small: var(--sl-font-size-x-small);--sl-button-font-size-medium: var(--sl-font-size-small);--sl-button-font-size-large: var(--sl-font-size-medium);--sl-input-height-small: 1.875rem;--sl-input-height-medium: 2.5rem;--sl-input-height-large: 3.125rem;--sl-input-background-color: var(--sl-color-neutral-0);--sl-input-background-color-hover: var(--sl-input-background-color);--sl-input-background-color-focus: var(--sl-input-background-color);--sl-input-background-color-disabled: var(--sl-color-neutral-100);--sl-input-border-color: var(--sl-color-neutral-400);--sl-input-border-color-hover: var(--sl-color-neutral-500);--sl-input-border-color-focus: var(--sl-color-primary-600);--sl-input-border-color-disabled: var(--sl-color-neutral-400);--sl-input-border-width: 1px;--sl-input-required-content: "*";--sl-input-required-content-offset: -2px;--sl-input-required-content-color: var(--sl-input-label-color);--sl-input-border-radius-small: var(--sl-border-radius-medium);--sl-input-border-radius-medium: var(--sl-border-radius-medium);--sl-input-border-radius-large: var(--sl-border-radius-medium);--sl-input-font-family: var(--sl-font-sans);--sl-input-font-weight: var(--sl-font-weight-normal);--sl-input-font-size-small: var(--sl-font-size-small);--sl-input-font-size-medium: var(--sl-font-size-medium);--sl-input-font-size-large: var(--sl-font-size-large);--sl-input-letter-spacing: var(--sl-letter-spacing-normal);--sl-input-color: var(--sl-color-neutral-700);--sl-input-color-hover: var(--sl-color-neutral-700);--sl-input-color-focus: var(--sl-color-neutral-700);--sl-input-color-disabled: var(--sl-color-neutral-900);--sl-input-icon-color: var(--sl-color-neutral-500);--sl-input-icon-color-hover: var(--sl-color-neutral-600);--sl-input-icon-color-focus: var(--sl-color-neutral-600);--sl-input-placeholder-color: var(--sl-color-neutral-500);--sl-input-placeholder-color-disabled: var(--sl-color-neutral-600);--sl-input-spacing-small: var(--sl-spacing-small);--sl-input-spacing-medium: var(--sl-spacing-medium);--sl-input-spacing-large: var(--sl-spacing-large);--sl-input-focus-ring-color: hsl(198.6 88.7% 48.4% / 40%);--sl-input-focus-ring-offset: 0;--sl-input-filled-background-color: var(--sl-color-neutral-100);--sl-input-filled-background-color-hover: var(--sl-color-neutral-100);--sl-input-filled-background-color-focus: var(--sl-color-neutral-100);--sl-input-filled-background-color-disabled: var(--sl-color-neutral-100);--sl-input-filled-color: var(--sl-color-neutral-800);--sl-input-filled-color-hover: var(--sl-color-neutral-800);--sl-input-filled-color-focus: var(--sl-color-neutral-700);--sl-input-filled-color-disabled: var(--sl-color-neutral-800);--sl-input-label-font-size-small: var(--sl-font-size-small);--sl-input-label-font-size-medium: var(--sl-font-size-medium);--sl-input-label-font-size-large: var(--sl-font-size-large);--sl-input-label-color: inherit;--sl-input-help-text-font-size-small: var(--sl-font-size-x-small);--sl-input-help-text-font-size-medium: var(--sl-font-size-small);--sl-input-help-text-font-size-large: var(--sl-font-size-medium);--sl-input-help-text-color: var(--sl-color-neutral-600);--sl-toggle-size-small: .875rem;--sl-toggle-size-medium: 1.125rem;--sl-toggle-size-large: 1.375rem;--sl-overlay-background-color: hsl(0 0% 0% / 43%);--sl-panel-background-color: var(--sl-color-neutral-50);--sl-panel-border-color: var(--sl-color-neutral-200);--sl-panel-border-width: 1px;--sl-tooltip-border-radius: var(--sl-border-radius-medium);--sl-tooltip-background-color: var(--sl-color-neutral-800);--sl-tooltip-color: var(--sl-color-neutral-0);--sl-tooltip-font-family: var(--sl-font-sans);--sl-tooltip-font-weight: var(--sl-font-weight-normal);--sl-tooltip-font-size: var(--sl-font-size-small);--sl-tooltip-line-height: var(--sl-line-height-dense);--sl-tooltip-padding: var(--sl-spacing-2x-small) var(--sl-spacing-x-small);--sl-tooltip-arrow-size: 6px;--sl-z-index-drawer: 700;--sl-z-index-dialog: 800;--sl-z-index-dropdown: 900;--sl-z-index-toast: 950;--sl-z-index-tooltip: 1000}@supports (scrollbar-gutter: stable){.sl-scroll-lock{scrollbar-gutter:var(--sl-scroll-lock-gutter)!important}.sl-scroll-lock body{overflow:hidden!important}}@supports not (scrollbar-gutter: stable){.sl-scroll-lock body{padding-right:var(--sl-scroll-lock-size)!important;overflow:hidden!important}}.sl-toast-stack{position:fixed;top:0;inset-inline-end:0;z-index:var(--sl-z-index-toast);width:28rem;max-width:100%;max-height:100%;overflow:auto}.sl-toast-stack sl-alert{margin:var(--sl-spacing-medium)}.sl-toast-stack sl-alert::part(base){box-shadow:var(--sl-shadow-large)}', io = ':root,:host,.sl-theme-light{color-scheme:light;--sl-color-gray-50: hsl(0 0% 97.5%);--sl-color-gray-100: hsl(240 4.8% 95.9%);--sl-color-gray-200: hsl(240 5.9% 90%);--sl-color-gray-300: hsl(240 4.9% 83.9%);--sl-color-gray-400: hsl(240 5% 64.9%);--sl-color-gray-500: hsl(240 3.8% 46.1%);--sl-color-gray-600: hsl(240 5.2% 33.9%);--sl-color-gray-700: hsl(240 5.3% 26.1%);--sl-color-gray-800: hsl(240 3.7% 15.9%);--sl-color-gray-900: hsl(240 5.9% 10%);--sl-color-gray-950: hsl(240 7.3% 8%);--sl-color-red-50: hsl(0 85.7% 97.3%);--sl-color-red-100: hsl(0 93.3% 94.1%);--sl-color-red-200: hsl(0 96.3% 89.4%);--sl-color-red-300: hsl(0 93.5% 81.8%);--sl-color-red-400: hsl(0 90.6% 70.8%);--sl-color-red-500: hsl(0 84.2% 60.2%);--sl-color-red-600: hsl(0 72.2% 50.6%);--sl-color-red-700: hsl(0 73.7% 41.8%);--sl-color-red-800: hsl(0 70% 35.3%);--sl-color-red-900: hsl(0 62.8% 30.6%);--sl-color-red-950: hsl(0 60% 19.6%);--sl-color-orange-50: hsl(33.3 100% 96.5%);--sl-color-orange-100: hsl(34.3 100% 91.8%);--sl-color-orange-200: hsl(32.1 97.7% 83.1%);--sl-color-orange-300: hsl(30.7 97.2% 72.4%);--sl-color-orange-400: hsl(27 96% 61%);--sl-color-orange-500: hsl(24.6 95% 53.1%);--sl-color-orange-600: hsl(20.5 90.2% 48.2%);--sl-color-orange-700: hsl(17.5 88.3% 40.4%);--sl-color-orange-800: hsl(15 79.1% 33.7%);--sl-color-orange-900: hsl(15.3 74.6% 27.8%);--sl-color-orange-950: hsl(15.2 69.1% 19%);--sl-color-amber-50: hsl(48 100% 96.1%);--sl-color-amber-100: hsl(48 96.5% 88.8%);--sl-color-amber-200: hsl(48 96.6% 76.7%);--sl-color-amber-300: hsl(45.9 96.7% 64.5%);--sl-color-amber-400: hsl(43.3 96.4% 56.3%);--sl-color-amber-500: hsl(37.7 92.1% 50.2%);--sl-color-amber-600: hsl(32.1 94.6% 43.7%);--sl-color-amber-700: hsl(26 90.5% 37.1%);--sl-color-amber-800: hsl(22.7 82.5% 31.4%);--sl-color-amber-900: hsl(21.7 77.8% 26.5%);--sl-color-amber-950: hsl(22.9 74.1% 16.7%);--sl-color-yellow-50: hsl(54.5 91.7% 95.3%);--sl-color-yellow-100: hsl(54.9 96.7% 88%);--sl-color-yellow-200: hsl(52.8 98.3% 76.9%);--sl-color-yellow-300: hsl(50.4 97.8% 63.5%);--sl-color-yellow-400: hsl(47.9 95.8% 53.1%);--sl-color-yellow-500: hsl(45.4 93.4% 47.5%);--sl-color-yellow-600: hsl(40.6 96.1% 40.4%);--sl-color-yellow-700: hsl(35.5 91.7% 32.9%);--sl-color-yellow-800: hsl(31.8 81% 28.8%);--sl-color-yellow-900: hsl(28.4 72.5% 25.7%);--sl-color-yellow-950: hsl(33.1 69% 13.9%);--sl-color-lime-50: hsl(78.3 92% 95.1%);--sl-color-lime-100: hsl(79.6 89.1% 89.2%);--sl-color-lime-200: hsl(80.9 88.5% 79.6%);--sl-color-lime-300: hsl(82 84.5% 67.1%);--sl-color-lime-400: hsl(82.7 78% 55.5%);--sl-color-lime-500: hsl(83.7 80.5% 44.3%);--sl-color-lime-600: hsl(84.8 85.2% 34.5%);--sl-color-lime-700: hsl(85.9 78.4% 27.3%);--sl-color-lime-800: hsl(86.3 69% 22.7%);--sl-color-lime-900: hsl(87.6 61.2% 20.2%);--sl-color-lime-950: hsl(86.5 60.6% 13.9%);--sl-color-green-50: hsl(138.5 76.5% 96.7%);--sl-color-green-100: hsl(140.6 84.2% 92.5%);--sl-color-green-200: hsl(141 78.9% 85.1%);--sl-color-green-300: hsl(141.7 76.6% 73.1%);--sl-color-green-400: hsl(141.9 69.2% 58%);--sl-color-green-500: hsl(142.1 70.6% 45.3%);--sl-color-green-600: hsl(142.1 76.2% 36.3%);--sl-color-green-700: hsl(142.4 71.8% 29.2%);--sl-color-green-800: hsl(142.8 64.2% 24.1%);--sl-color-green-900: hsl(143.8 61.2% 20.2%);--sl-color-green-950: hsl(144.3 60.7% 12%);--sl-color-emerald-50: hsl(151.8 81% 95.9%);--sl-color-emerald-100: hsl(149.3 80.4% 90%);--sl-color-emerald-200: hsl(152.4 76% 80.4%);--sl-color-emerald-300: hsl(156.2 71.6% 66.9%);--sl-color-emerald-400: hsl(158.1 64.4% 51.6%);--sl-color-emerald-500: hsl(160.1 84.1% 39.4%);--sl-color-emerald-600: hsl(161.4 93.5% 30.4%);--sl-color-emerald-700: hsl(162.9 93.5% 24.3%);--sl-color-emerald-800: hsl(163.1 88.1% 19.8%);--sl-color-emerald-900: hsl(164.2 85.7% 16.5%);--sl-color-emerald-950: hsl(164.3 87.5% 9.4%);--sl-color-teal-50: hsl(166.2 76.5% 96.7%);--sl-color-teal-100: hsl(167.2 85.5% 89.2%);--sl-color-teal-200: hsl(168.4 83.8% 78.2%);--sl-color-teal-300: hsl(170.6 76.9% 64.3%);--sl-color-teal-400: hsl(172.5 66% 50.4%);--sl-color-teal-500: hsl(173.4 80.4% 40%);--sl-color-teal-600: hsl(174.7 83.9% 31.6%);--sl-color-teal-700: hsl(175.3 77.4% 26.1%);--sl-color-teal-800: hsl(176.1 69.4% 21.8%);--sl-color-teal-900: hsl(175.9 60.8% 19%);--sl-color-teal-950: hsl(176.5 58.6% 11.4%);--sl-color-cyan-50: hsl(183.2 100% 96.3%);--sl-color-cyan-100: hsl(185.1 95.9% 90.4%);--sl-color-cyan-200: hsl(186.2 93.5% 81.8%);--sl-color-cyan-300: hsl(187 92.4% 69%);--sl-color-cyan-400: hsl(187.9 85.7% 53.3%);--sl-color-cyan-500: hsl(188.7 94.5% 42.7%);--sl-color-cyan-600: hsl(191.6 91.4% 36.5%);--sl-color-cyan-700: hsl(192.9 82.3% 31%);--sl-color-cyan-800: hsl(194.4 69.6% 27.1%);--sl-color-cyan-900: hsl(196.4 63.6% 23.7%);--sl-color-cyan-950: hsl(196.8 61% 16.1%);--sl-color-sky-50: hsl(204 100% 97.1%);--sl-color-sky-100: hsl(204 93.8% 93.7%);--sl-color-sky-200: hsl(200.6 94.4% 86.1%);--sl-color-sky-300: hsl(199.4 95.5% 73.9%);--sl-color-sky-400: hsl(198.4 93.2% 59.6%);--sl-color-sky-500: hsl(198.6 88.7% 48.4%);--sl-color-sky-600: hsl(200.4 98% 39.4%);--sl-color-sky-700: hsl(201.3 96.3% 32.2%);--sl-color-sky-800: hsl(201 90% 27.5%);--sl-color-sky-900: hsl(202 80.3% 23.9%);--sl-color-sky-950: hsl(202.3 73.8% 16.5%);--sl-color-blue-50: hsl(213.8 100% 96.9%);--sl-color-blue-100: hsl(214.3 94.6% 92.7%);--sl-color-blue-200: hsl(213.3 96.9% 87.3%);--sl-color-blue-300: hsl(211.7 96.4% 78.4%);--sl-color-blue-400: hsl(213.1 93.9% 67.8%);--sl-color-blue-500: hsl(217.2 91.2% 59.8%);--sl-color-blue-600: hsl(221.2 83.2% 53.3%);--sl-color-blue-700: hsl(224.3 76.3% 48%);--sl-color-blue-800: hsl(225.9 70.7% 40.2%);--sl-color-blue-900: hsl(224.4 64.3% 32.9%);--sl-color-blue-950: hsl(226.2 55.3% 18.4%);--sl-color-indigo-50: hsl(225.9 100% 96.7%);--sl-color-indigo-100: hsl(226.5 100% 93.9%);--sl-color-indigo-200: hsl(228 96.5% 88.8%);--sl-color-indigo-300: hsl(229.7 93.5% 81.8%);--sl-color-indigo-400: hsl(234.5 89.5% 73.9%);--sl-color-indigo-500: hsl(238.7 83.5% 66.7%);--sl-color-indigo-600: hsl(243.4 75.4% 58.6%);--sl-color-indigo-700: hsl(244.5 57.9% 50.6%);--sl-color-indigo-800: hsl(243.7 54.5% 41.4%);--sl-color-indigo-900: hsl(242.2 47.4% 34.3%);--sl-color-indigo-950: hsl(243.5 43.6% 22.9%);--sl-color-violet-50: hsl(250 100% 97.6%);--sl-color-violet-100: hsl(251.4 91.3% 95.5%);--sl-color-violet-200: hsl(250.5 95.2% 91.8%);--sl-color-violet-300: hsl(252.5 94.7% 85.1%);--sl-color-violet-400: hsl(255.1 91.7% 76.3%);--sl-color-violet-500: hsl(258.3 89.5% 66.3%);--sl-color-violet-600: hsl(262.1 83.3% 57.8%);--sl-color-violet-700: hsl(263.4 70% 50.4%);--sl-color-violet-800: hsl(263.4 69.3% 42.2%);--sl-color-violet-900: hsl(263.5 67.4% 34.9%);--sl-color-violet-950: hsl(265.1 61.5% 21.4%);--sl-color-purple-50: hsl(270 100% 98%);--sl-color-purple-100: hsl(268.7 100% 95.5%);--sl-color-purple-200: hsl(268.6 100% 91.8%);--sl-color-purple-300: hsl(269.2 97.4% 85.1%);--sl-color-purple-400: hsl(270 95.2% 75.3%);--sl-color-purple-500: hsl(270.7 91% 65.1%);--sl-color-purple-600: hsl(271.5 81.3% 55.9%);--sl-color-purple-700: hsl(272.1 71.7% 47.1%);--sl-color-purple-800: hsl(272.9 67.2% 39.4%);--sl-color-purple-900: hsl(273.6 65.6% 32%);--sl-color-purple-950: hsl(276 59.5% 16.5%);--sl-color-fuchsia-50: hsl(289.1 100% 97.8%);--sl-color-fuchsia-100: hsl(287 100% 95.5%);--sl-color-fuchsia-200: hsl(288.3 95.8% 90.6%);--sl-color-fuchsia-300: hsl(291.1 93.1% 82.9%);--sl-color-fuchsia-400: hsl(292 91.4% 72.5%);--sl-color-fuchsia-500: hsl(292.2 84.1% 60.6%);--sl-color-fuchsia-600: hsl(293.4 69.5% 48.8%);--sl-color-fuchsia-700: hsl(294.7 72.4% 39.8%);--sl-color-fuchsia-800: hsl(295.4 70.2% 32.9%);--sl-color-fuchsia-900: hsl(296.7 63.6% 28%);--sl-color-fuchsia-950: hsl(297.1 56.8% 14.5%);--sl-color-pink-50: hsl(327.3 73.3% 97.1%);--sl-color-pink-100: hsl(325.7 77.8% 94.7%);--sl-color-pink-200: hsl(325.9 84.6% 89.8%);--sl-color-pink-300: hsl(327.4 87.1% 81.8%);--sl-color-pink-400: hsl(328.6 85.5% 70.2%);--sl-color-pink-500: hsl(330.4 81.2% 60.4%);--sl-color-pink-600: hsl(333.3 71.4% 50.6%);--sl-color-pink-700: hsl(335.1 77.6% 42%);--sl-color-pink-800: hsl(335.8 74.4% 35.3%);--sl-color-pink-900: hsl(335.9 69% 30.4%);--sl-color-pink-950: hsl(336.2 65.4% 15.9%);--sl-color-rose-50: hsl(355.7 100% 97.3%);--sl-color-rose-100: hsl(355.6 100% 94.7%);--sl-color-rose-200: hsl(352.7 96.1% 90%);--sl-color-rose-300: hsl(352.6 95.7% 81.8%);--sl-color-rose-400: hsl(351.3 94.5% 71.4%);--sl-color-rose-500: hsl(349.7 89.2% 60.2%);--sl-color-rose-600: hsl(346.8 77.2% 49.8%);--sl-color-rose-700: hsl(345.3 82.7% 40.8%);--sl-color-rose-800: hsl(343.4 79.7% 34.7%);--sl-color-rose-900: hsl(341.5 75.5% 30.4%);--sl-color-rose-950: hsl(341.3 70.1% 17.1%);--sl-color-primary-50: var(--sl-color-sky-50);--sl-color-primary-100: var(--sl-color-sky-100);--sl-color-primary-200: var(--sl-color-sky-200);--sl-color-primary-300: var(--sl-color-sky-300);--sl-color-primary-400: var(--sl-color-sky-400);--sl-color-primary-500: var(--sl-color-sky-500);--sl-color-primary-600: var(--sl-color-sky-600);--sl-color-primary-700: var(--sl-color-sky-700);--sl-color-primary-800: var(--sl-color-sky-800);--sl-color-primary-900: var(--sl-color-sky-900);--sl-color-primary-950: var(--sl-color-sky-950);--sl-color-success-50: var(--sl-color-green-50);--sl-color-success-100: var(--sl-color-green-100);--sl-color-success-200: var(--sl-color-green-200);--sl-color-success-300: var(--sl-color-green-300);--sl-color-success-400: var(--sl-color-green-400);--sl-color-success-500: var(--sl-color-green-500);--sl-color-success-600: var(--sl-color-green-600);--sl-color-success-700: var(--sl-color-green-700);--sl-color-success-800: var(--sl-color-green-800);--sl-color-success-900: var(--sl-color-green-900);--sl-color-success-950: var(--sl-color-green-950);--sl-color-warning-50: var(--sl-color-amber-50);--sl-color-warning-100: var(--sl-color-amber-100);--sl-color-warning-200: var(--sl-color-amber-200);--sl-color-warning-300: var(--sl-color-amber-300);--sl-color-warning-400: var(--sl-color-amber-400);--sl-color-warning-500: var(--sl-color-amber-500);--sl-color-warning-600: var(--sl-color-amber-600);--sl-color-warning-700: var(--sl-color-amber-700);--sl-color-warning-800: var(--sl-color-amber-800);--sl-color-warning-900: var(--sl-color-amber-900);--sl-color-warning-950: var(--sl-color-amber-950);--sl-color-danger-50: var(--sl-color-red-50);--sl-color-danger-100: var(--sl-color-red-100);--sl-color-danger-200: var(--sl-color-red-200);--sl-color-danger-300: var(--sl-color-red-300);--sl-color-danger-400: var(--sl-color-red-400);--sl-color-danger-500: var(--sl-color-red-500);--sl-color-danger-600: var(--sl-color-red-600);--sl-color-danger-700: var(--sl-color-red-700);--sl-color-danger-800: var(--sl-color-red-800);--sl-color-danger-900: var(--sl-color-red-900);--sl-color-danger-950: var(--sl-color-red-950);--sl-color-neutral-50: var(--sl-color-gray-50);--sl-color-neutral-100: var(--sl-color-gray-100);--sl-color-neutral-200: var(--sl-color-gray-200);--sl-color-neutral-300: var(--sl-color-gray-300);--sl-color-neutral-400: var(--sl-color-gray-400);--sl-color-neutral-500: var(--sl-color-gray-500);--sl-color-neutral-600: var(--sl-color-gray-600);--sl-color-neutral-700: var(--sl-color-gray-700);--sl-color-neutral-800: var(--sl-color-gray-800);--sl-color-neutral-900: var(--sl-color-gray-900);--sl-color-neutral-950: var(--sl-color-gray-950);--sl-color-neutral-0: hsl(0, 0%, 100%);--sl-color-neutral-1000: hsl(0, 0%, 0%);--sl-border-radius-small: .1875rem;--sl-border-radius-medium: .25rem;--sl-border-radius-large: .5rem;--sl-border-radius-x-large: 1rem;--sl-border-radius-circle: 50%;--sl-border-radius-pill: 9999px;--sl-shadow-x-small: 0 1px 2px hsl(240 3.8% 46.1% / 6%);--sl-shadow-small: 0 1px 2px hsl(240 3.8% 46.1% / 12%);--sl-shadow-medium: 0 2px 4px hsl(240 3.8% 46.1% / 12%);--sl-shadow-large: 0 2px 8px hsl(240 3.8% 46.1% / 12%);--sl-shadow-x-large: 0 4px 16px hsl(240 3.8% 46.1% / 12%);--sl-spacing-3x-small: .125rem;--sl-spacing-2x-small: .25rem;--sl-spacing-x-small: .5rem;--sl-spacing-small: .75rem;--sl-spacing-medium: 1rem;--sl-spacing-large: 1.25rem;--sl-spacing-x-large: 1.75rem;--sl-spacing-2x-large: 2.25rem;--sl-spacing-3x-large: 3rem;--sl-spacing-4x-large: 4.5rem;--sl-transition-x-slow: 1s;--sl-transition-slow: .5s;--sl-transition-medium: .25s;--sl-transition-fast: .15s;--sl-transition-x-fast: 50ms;--sl-font-mono: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;--sl-font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";--sl-font-serif: Georgia, "Times New Roman", serif;--sl-font-size-2x-small: .625rem;--sl-font-size-x-small: .75rem;--sl-font-size-small: .875rem;--sl-font-size-medium: 1rem;--sl-font-size-large: 1.25rem;--sl-font-size-x-large: 1.5rem;--sl-font-size-2x-large: 2.25rem;--sl-font-size-3x-large: 3rem;--sl-font-size-4x-large: 4.5rem;--sl-font-weight-light: 300;--sl-font-weight-normal: 400;--sl-font-weight-semibold: 500;--sl-font-weight-bold: 700;--sl-letter-spacing-denser: -.03em;--sl-letter-spacing-dense: -.015em;--sl-letter-spacing-normal: normal;--sl-letter-spacing-loose: .075em;--sl-letter-spacing-looser: .15em;--sl-line-height-denser: 1;--sl-line-height-dense: 1.4;--sl-line-height-normal: 1.8;--sl-line-height-loose: 2.2;--sl-line-height-looser: 2.6;--sl-focus-ring-color: var(--sl-color-primary-600);--sl-focus-ring-style: solid;--sl-focus-ring-width: 3px;--sl-focus-ring: var(--sl-focus-ring-style) var(--sl-focus-ring-width) var(--sl-focus-ring-color);--sl-focus-ring-offset: 1px;--sl-button-font-size-small: var(--sl-font-size-x-small);--sl-button-font-size-medium: var(--sl-font-size-small);--sl-button-font-size-large: var(--sl-font-size-medium);--sl-input-height-small: 1.875rem;--sl-input-height-medium: 2.5rem;--sl-input-height-large: 3.125rem;--sl-input-background-color: var(--sl-color-neutral-0);--sl-input-background-color-hover: var(--sl-input-background-color);--sl-input-background-color-focus: var(--sl-input-background-color);--sl-input-background-color-disabled: var(--sl-color-neutral-100);--sl-input-border-color: var(--sl-color-neutral-300);--sl-input-border-color-hover: var(--sl-color-neutral-400);--sl-input-border-color-focus: var(--sl-color-primary-500);--sl-input-border-color-disabled: var(--sl-color-neutral-300);--sl-input-border-width: 1px;--sl-input-required-content: "*";--sl-input-required-content-offset: -2px;--sl-input-required-content-color: var(--sl-input-label-color);--sl-input-border-radius-small: var(--sl-border-radius-medium);--sl-input-border-radius-medium: var(--sl-border-radius-medium);--sl-input-border-radius-large: var(--sl-border-radius-medium);--sl-input-font-family: var(--sl-font-sans);--sl-input-font-weight: var(--sl-font-weight-normal);--sl-input-font-size-small: var(--sl-font-size-small);--sl-input-font-size-medium: var(--sl-font-size-medium);--sl-input-font-size-large: var(--sl-font-size-large);--sl-input-letter-spacing: var(--sl-letter-spacing-normal);--sl-input-color: var(--sl-color-neutral-700);--sl-input-color-hover: var(--sl-color-neutral-700);--sl-input-color-focus: var(--sl-color-neutral-700);--sl-input-color-disabled: var(--sl-color-neutral-900);--sl-input-icon-color: var(--sl-color-neutral-500);--sl-input-icon-color-hover: var(--sl-color-neutral-600);--sl-input-icon-color-focus: var(--sl-color-neutral-600);--sl-input-placeholder-color: var(--sl-color-neutral-500);--sl-input-placeholder-color-disabled: var(--sl-color-neutral-600);--sl-input-spacing-small: var(--sl-spacing-small);--sl-input-spacing-medium: var(--sl-spacing-medium);--sl-input-spacing-large: var(--sl-spacing-large);--sl-input-focus-ring-color: hsl(198.6 88.7% 48.4% / 40%);--sl-input-focus-ring-offset: 0;--sl-input-filled-background-color: var(--sl-color-neutral-100);--sl-input-filled-background-color-hover: var(--sl-color-neutral-100);--sl-input-filled-background-color-focus: var(--sl-color-neutral-100);--sl-input-filled-background-color-disabled: var(--sl-color-neutral-100);--sl-input-filled-color: var(--sl-color-neutral-800);--sl-input-filled-color-hover: var(--sl-color-neutral-800);--sl-input-filled-color-focus: var(--sl-color-neutral-700);--sl-input-filled-color-disabled: var(--sl-color-neutral-800);--sl-input-label-font-size-small: var(--sl-font-size-small);--sl-input-label-font-size-medium: var(--sl-font-size-medium);--sl-input-label-font-size-large: var(--sl-font-size-large);--sl-input-label-color: inherit;--sl-input-help-text-font-size-small: var(--sl-font-size-x-small);--sl-input-help-text-font-size-medium: var(--sl-font-size-small);--sl-input-help-text-font-size-large: var(--sl-font-size-medium);--sl-input-help-text-color: var(--sl-color-neutral-500);--sl-toggle-size-small: .875rem;--sl-toggle-size-medium: 1.125rem;--sl-toggle-size-large: 1.375rem;--sl-overlay-background-color: hsl(240 3.8% 46.1% / 33%);--sl-panel-background-color: var(--sl-color-neutral-0);--sl-panel-border-color: var(--sl-color-neutral-200);--sl-panel-border-width: 1px;--sl-tooltip-border-radius: var(--sl-border-radius-medium);--sl-tooltip-background-color: var(--sl-color-neutral-800);--sl-tooltip-color: var(--sl-color-neutral-0);--sl-tooltip-font-family: var(--sl-font-sans);--sl-tooltip-font-weight: var(--sl-font-weight-normal);--sl-tooltip-font-size: var(--sl-font-size-small);--sl-tooltip-line-height: var(--sl-line-height-dense);--sl-tooltip-padding: var(--sl-spacing-2x-small) var(--sl-spacing-x-small);--sl-tooltip-arrow-size: 6px;--sl-z-index-drawer: 700;--sl-z-index-dialog: 800;--sl-z-index-dropdown: 900;--sl-z-index-toast: 950;--sl-z-index-tooltip: 1000}@supports (scrollbar-gutter: stable){.sl-scroll-lock{scrollbar-gutter:var(--sl-scroll-lock-gutter)!important}.sl-scroll-lock body{overflow:hidden!important}}@supports not (scrollbar-gutter: stable){.sl-scroll-lock body{padding-right:var(--sl-scroll-lock-size)!important;overflow:hidden!important}}.sl-toast-stack{position:fixed;top:0;inset-inline-end:0;z-index:var(--sl-z-index-toast);width:28rem;max-width:100%;max-height:100%;overflow:auto}.sl-toast-stack sl-alert{margin:var(--sl-spacing-medium)}.sl-toast-stack sl-alert::part(base){box-shadow:var(--sl-shadow-large)}', Hae = ".invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.input::part(base){border-radius:var(--photon-border-radius, .5rem)}.input::part(base):hover{cursor:pointer}.input::part(input){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.input{--sl-input-required-content-color: #f87171;--sl-input-label-font-size-medium: .875rem;--sl-input-label-color: #374151}.input::part(form-control-label){padding-bottom:.5rem}.disabled::part(base):hover{cursor:not-allowed}.selected::part(base){--tw-bg-opacity: 1;background-color:rgb(49,130,206,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.default::part(base):hover{--tw-bg-opacity: 1;background-color:rgb(229,231,235,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity))}.default::part(label){width:100%;overflow:hidden}.group-member::part(base){padding-left:1rem;font-weight:500}.group::part(base){background:#d1e9ff;padding-top:.25rem;padding-bottom:.25rem;--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity));font-size:.75rem;font-weight:600}.dropdown::part(panel){border-radius:var(--photon-border-radius, .5rem)}.dropdown-container{border-radius:var(--photon-border-radius, .5rem)}";
function ys(e, t, r) {
  let n = r.initialDeps ?? [], i, a = !0;
  function o() {
    var s, l, d;
    let c;
    r.key && ((s = r.debug) != null && s.call(r)) && (c = Date.now());
    const u = e();
    if (!(u.length !== n.length || u.some((p, m) => n[m] !== p)))
      return i;
    n = u;
    let f;
    if (r.key && ((l = r.debug) != null && l.call(r)) && (f = Date.now()), i = t(...u), r.key && ((d = r.debug) != null && d.call(r))) {
      const p = Math.round((Date.now() - c) * 100) / 100, m = Math.round((Date.now() - f) * 100) / 100, y = m / 16, g = (w, $) => {
        for (w = String(w); w.length < $; )
          w = " " + w;
        return w;
      };
      console.info(
        `%c⏱ ${g(m, 5)} /${g(p, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * y, 120)
        )}deg 100% 31%);`,
        r?.key
      );
    }
    return r?.onChange && !(a && r.skipInitialOnChange) && r.onChange(i), a = !1, i;
  }
  return o.updateDeps = (s) => {
    n = s;
  }, o;
}
function u7(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const Wae = (e, t) => Math.abs(e - t) < 1.01, Kae = (e, t, r) => {
  let n;
  return function(...i) {
    e.clearTimeout(n), n = e.setTimeout(() => t.apply(this, i), r);
  };
}, h7 = (e) => {
  const { offsetWidth: t, offsetHeight: r } = e;
  return { width: t, height: r };
}, Qae = (e) => e, Gae = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), r = Math.min(e.endIndex + e.overscan, e.count - 1), n = [];
  for (let i = t; i <= r; i++)
    n.push(i);
  return n;
}, Yae = (e, t) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const n = e.targetWindow;
  if (!n)
    return;
  const i = (o) => {
    const { width: s, height: l } = o;
    t({ width: Math.round(s), height: Math.round(l) });
  };
  if (i(h7(r)), !n.ResizeObserver)
    return () => {
    };
  const a = new n.ResizeObserver((o) => {
    const s = () => {
      const l = o[0];
      if (l?.borderBoxSize) {
        const d = l.borderBoxSize[0];
        if (d) {
          i({ width: d.inlineSize, height: d.blockSize });
          return;
        }
      }
      i(h7(r));
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(s) : s();
  });
  return a.observe(r, { box: "border-box" }), () => {
    a.unobserve(r);
  };
}, f7 = {
  passive: !0
}, p7 = typeof window > "u" ? !0 : "onscrollend" in window, Jae = (e, t) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const n = e.targetWindow;
  if (!n)
    return;
  let i = 0;
  const a = e.options.useScrollendEvent && p7 ? () => {
  } : Kae(
    n,
    () => {
      t(i, !1);
    },
    e.options.isScrollingResetDelay
  ), o = (c) => () => {
    const { horizontal: u, isRtl: h } = e.options;
    i = u ? r.scrollLeft * (h && -1 || 1) : r.scrollTop, a(), t(i, c);
  }, s = o(!0), l = o(!1);
  r.addEventListener("scroll", s, f7);
  const d = e.options.useScrollendEvent && p7;
  return d && r.addEventListener("scrollend", l, f7), () => {
    r.removeEventListener("scroll", s), d && r.removeEventListener("scrollend", l);
  };
}, Zae = (e, t, r) => {
  if (t?.borderBoxSize) {
    const n = t.borderBoxSize[0];
    if (n)
      return Math.round(
        n[r.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return e[r.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, Xae = (e, {
  adjustments: t = 0,
  behavior: r
}, n) => {
  var i, a;
  const o = e + t;
  (a = (i = n.scrollElement) == null ? void 0 : i.scrollTo) == null || a.call(i, {
    [n.options.horizontal ? "left" : "top"]: o,
    behavior: r
  });
};
class eoe {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollState = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.prevLanes = void 0, this.lanesChangedFlag = !1, this.lanesSettling = !1, this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.now = () => {
      var r, n, i;
      return ((i = (n = (r = this.targetWindow) == null ? void 0 : r.performance) == null ? void 0 : n.now) == null ? void 0 : i.call(n)) ?? Date.now();
    }, this.observer = /* @__PURE__ */ (() => {
      let r = null;
      const n = () => r || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : r = new this.targetWindow.ResizeObserver((i) => {
        i.forEach((a) => {
          const o = () => {
            this._measureElement(a.target, a);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(o) : o();
        });
      }));
      return {
        disconnect: () => {
          var i;
          (i = n()) == null || i.disconnect(), r = null;
        },
        observe: (i) => {
          var a;
          return (a = n()) == null ? void 0 : a.observe(i, { box: "border-box" });
        },
        unobserve: (i) => {
          var a;
          return (a = n()) == null ? void 0 : a.unobserve(i);
        }
      };
    })(), this.range = null, this.setOptions = (r) => {
      Object.entries(r).forEach(([n, i]) => {
        typeof i > "u" && delete r[n];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: Qae,
        rangeExtractor: Gae,
        onChange: () => {
        },
        measureElement: Zae,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...r
      };
    }, this.notify = (r) => {
      var n, i;
      (i = (n = this.options).onChange) == null || i.call(n, this, r);
    }, this.maybeNotify = ys(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (r) => {
        this.notify(r);
      },
      {
        key: !1,
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((r) => r()), this.unsubs = [], this.observer.disconnect(), this.rafId != null && this.targetWindow && (this.targetWindow.cancelAnimationFrame(this.rafId), this.rafId = null), this.scrollState = null, this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var r;
      const n = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== n) {
        if (this.cleanup(), !n) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = n, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((r = this.scrollElement) == null ? void 0 : r.window) ?? null, this.elementsCache.forEach((i) => {
          this.observer.observe(i);
        }), this.unsubs.push(
          this.options.observeElementRect(this, (i) => {
            this.scrollRect = i, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (i, a) => {
            this.scrollAdjustments = 0, this.scrollDirection = a ? this.getScrollOffset() < i ? "forward" : "backward" : null, this.scrollOffset = i, this.isScrolling = a, this.scrollState && this.scheduleScrollReconcile(), this.maybeNotify();
          })
        ), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
      }
    }, this.rafId = null, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (r, n) => {
      const i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
      for (let o = n - 1; o >= 0; o--) {
        const s = r[o];
        if (i.has(s.lane))
          continue;
        const l = a.get(
          s.lane
        );
        if (l == null || s.end > l.end ? a.set(s.lane, s) : s.end < l.end && i.set(s.lane, !0), i.size === this.options.lanes)
          break;
      }
      return a.size === this.options.lanes ? Array.from(a.values()).sort((o, s) => o.end === s.end ? o.index - s.index : o.end - s.end)[0] : void 0;
    }, this.getMeasurementOptions = ys(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled,
        this.options.lanes
      ],
      (r, n, i, a, o, s) => (this.prevLanes !== void 0 && this.prevLanes !== s && (this.lanesChangedFlag = !0), this.prevLanes = s, this.pendingMeasuredCacheIndexes = [], {
        count: r,
        paddingStart: n,
        scrollMargin: i,
        getItemKey: a,
        enabled: o,
        lanes: s
      }),
      {
        key: !1
      }
    ), this.getMeasurements = ys(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: r, paddingStart: n, scrollMargin: i, getItemKey: a, enabled: o, lanes: s }, l) => {
        if (!o)
          return this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), [];
        if (this.laneAssignments.size > r)
          for (const h of this.laneAssignments.keys())
            h >= r && this.laneAssignments.delete(h);
        this.lanesChangedFlag && (this.lanesChangedFlag = !1, this.lanesSettling = !0, this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), this.pendingMeasuredCacheIndexes = []), this.measurementsCache.length === 0 && !this.lanesSettling && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((h) => {
          this.itemSizeCache.set(h.key, h.size);
        }));
        const d = this.lanesSettling ? 0 : this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [], this.lanesSettling && this.measurementsCache.length === r && (this.lanesSettling = !1);
        const c = this.measurementsCache.slice(0, d), u = new Array(s).fill(
          void 0
        );
        for (let h = 0; h < d; h++) {
          const f = c[h];
          f && (u[f.lane] = h);
        }
        for (let h = d; h < r; h++) {
          const f = a(h), p = this.laneAssignments.get(h);
          let m, y;
          if (p !== void 0 && this.options.lanes > 1) {
            m = p;
            const _ = u[m], x = _ !== void 0 ? c[_] : void 0;
            y = x ? x.end + this.options.gap : n + i;
          } else {
            const _ = this.options.lanes === 1 ? c[h - 1] : this.getFurthestMeasurement(c, h);
            y = _ ? _.end + this.options.gap : n + i, m = _ ? _.lane : h % this.options.lanes, this.options.lanes > 1 && this.laneAssignments.set(h, m);
          }
          const g = l.get(f), w = typeof g == "number" ? g : this.options.estimateSize(h), $ = y + w;
          c[h] = {
            index: h,
            start: y,
            size: w,
            end: $,
            key: f,
            lane: m
          }, u[m] = h;
        }
        return this.measurementsCache = c, c;
      },
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.calculateRange = ys(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (r, n, i, a) => this.range = r.length > 0 && n > 0 ? toe({
        measurements: r,
        outerSize: n,
        scrollOffset: i,
        lanes: a
      }) : null,
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = ys(
      () => {
        let r = null, n = null;
        const i = this.calculateRange();
        return i && (r = i.startIndex, n = i.endIndex), this.maybeNotify.updateDeps([this.isScrolling, r, n]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          r,
          n
        ];
      },
      (r, n, i, a, o) => a === null || o === null ? [] : r({
        startIndex: a,
        endIndex: o,
        overscan: n,
        count: i
      }),
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (r) => {
      const n = this.options.indexAttribute, i = r.getAttribute(n);
      return i ? parseInt(i, 10) : (console.warn(
        `Missing attribute name '${n}={index}' on measured element.`
      ), -1);
    }, this.shouldMeasureDuringScroll = (r) => {
      var n;
      if (!this.scrollState || this.scrollState.behavior !== "smooth")
        return !0;
      const i = this.scrollState.index ?? ((n = this.getVirtualItemForOffset(this.scrollState.lastTargetOffset)) == null ? void 0 : n.index);
      if (i !== void 0 && this.range) {
        const a = Math.max(
          this.options.overscan,
          Math.ceil((this.range.endIndex - this.range.startIndex) / 2)
        ), o = Math.max(0, i - a), s = Math.min(
          this.options.count - 1,
          i + a
        );
        return r >= o && r <= s;
      }
      return !0;
    }, this._measureElement = (r, n) => {
      if (!r.isConnected) {
        this.observer.unobserve(r);
        return;
      }
      const i = this.indexFromElement(r), a = this.measurementsCache[i];
      if (!a)
        return;
      const o = a.key, s = this.elementsCache.get(o);
      s !== r && (s && this.observer.unobserve(s), this.observer.observe(r), this.elementsCache.set(o, r)), this.shouldMeasureDuringScroll(i) && this.resizeItem(i, this.options.measureElement(r, n, this));
    }, this.resizeItem = (r, n) => {
      var i;
      const a = this.measurementsCache[r];
      if (!a)
        return;
      const o = this.itemSizeCache.get(a.key) ?? a.size, s = n - o;
      s !== 0 && (((i = this.scrollState) == null ? void 0 : i.behavior) !== "smooth" && (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(a, s, this) : a.start < this.getScrollOffset() + this.scrollAdjustments) && this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += s,
        behavior: void 0
      }), this.pendingMeasuredCacheIndexes.push(a.index), this.itemSizeCache = new Map(this.itemSizeCache.set(a.key, n)), this.notify(!1));
    }, this.measureElement = (r) => {
      if (!r) {
        this.elementsCache.forEach((n, i) => {
          n.isConnected || (this.observer.unobserve(n), this.elementsCache.delete(i));
        });
        return;
      }
      this._measureElement(r, void 0);
    }, this.getVirtualItems = ys(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (r, n) => {
        const i = [];
        for (let a = 0, o = r.length; a < o; a++) {
          const s = r[a], l = n[s];
          i.push(l);
        }
        return i;
      },
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (r) => {
      const n = this.getMeasurements();
      if (n.length !== 0)
        return u7(
          n[jk(
            0,
            n.length - 1,
            (i) => u7(n[i]).start,
            r
          )]
        );
    }, this.getMaxScrollOffset = () => {
      if (!this.scrollElement) return 0;
      if ("scrollHeight" in this.scrollElement)
        return this.options.horizontal ? this.scrollElement.scrollWidth - this.scrollElement.clientWidth : this.scrollElement.scrollHeight - this.scrollElement.clientHeight;
      {
        const r = this.scrollElement.document.documentElement;
        return this.options.horizontal ? r.scrollWidth - this.scrollElement.innerWidth : r.scrollHeight - this.scrollElement.innerHeight;
      }
    }, this.getOffsetForAlignment = (r, n, i = 0) => {
      if (!this.scrollElement) return 0;
      const a = this.getSize(), o = this.getScrollOffset();
      n === "auto" && (n = r >= o + a ? "end" : "start"), n === "center" ? r += (i - a) / 2 : n === "end" && (r -= a);
      const s = this.getMaxScrollOffset();
      return Math.max(Math.min(s, r), 0);
    }, this.getOffsetForIndex = (r, n = "auto") => {
      r = Math.max(0, Math.min(r, this.options.count - 1));
      const i = this.getSize(), a = this.getScrollOffset(), o = this.measurementsCache[r];
      if (!o) return;
      if (n === "auto")
        if (o.end >= a + i - this.options.scrollPaddingEnd)
          n = "end";
        else if (o.start <= a + this.options.scrollPaddingStart)
          n = "start";
        else
          return [a, n];
      if (n === "end" && r === this.options.count - 1)
        return [this.getMaxScrollOffset(), n];
      const s = n === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(s, n, o.size),
        n
      ];
    }, this.scrollToOffset = (r, { align: n = "start", behavior: i = "auto" } = {}) => {
      const a = this.getOffsetForAlignment(r, n), o = this.now();
      this.scrollState = {
        index: null,
        align: n,
        behavior: i,
        startedAt: o,
        lastTargetOffset: a,
        stableFrames: 0
      }, this._scrollToOffset(a, { adjustments: void 0, behavior: i }), this.scheduleScrollReconcile();
    }, this.scrollToIndex = (r, {
      align: n = "auto",
      behavior: i = "auto"
    } = {}) => {
      r = Math.max(0, Math.min(r, this.options.count - 1));
      const a = this.getOffsetForIndex(r, n);
      if (!a)
        return;
      const [o, s] = a, l = this.now();
      this.scrollState = {
        index: r,
        align: s,
        behavior: i,
        startedAt: l,
        lastTargetOffset: o,
        stableFrames: 0
      }, this._scrollToOffset(o, { adjustments: void 0, behavior: i }), this.scheduleScrollReconcile();
    }, this.scrollBy = (r, { behavior: n = "auto" } = {}) => {
      const i = this.getScrollOffset() + r, a = this.now();
      this.scrollState = {
        index: null,
        align: "start",
        behavior: n,
        startedAt: a,
        lastTargetOffset: i,
        stableFrames: 0
      }, this._scrollToOffset(i, { adjustments: void 0, behavior: n }), this.scheduleScrollReconcile();
    }, this.getTotalSize = () => {
      var r;
      const n = this.getMeasurements();
      let i;
      if (n.length === 0)
        i = this.options.paddingStart;
      else if (this.options.lanes === 1)
        i = ((r = n[n.length - 1]) == null ? void 0 : r.end) ?? 0;
      else {
        const a = Array(this.options.lanes).fill(null);
        let o = n.length - 1;
        for (; o >= 0 && a.some((s) => s === null); ) {
          const s = n[o];
          a[s.lane] === null && (a[s.lane] = s.end), o--;
        }
        i = Math.max(...a.filter((s) => s !== null));
      }
      return Math.max(
        i - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (r, {
      adjustments: n,
      behavior: i
    }) => {
      this.options.scrollToFn(r, { behavior: i, adjustments: n }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
  scheduleScrollReconcile() {
    if (!this.targetWindow) {
      this.scrollState = null;
      return;
    }
    this.rafId == null && (this.rafId = this.targetWindow.requestAnimationFrame(() => {
      this.rafId = null, this.reconcileScroll();
    }));
  }
  reconcileScroll() {
    if (!this.scrollState || !this.scrollElement) return;
    if (this.now() - this.scrollState.startedAt > 5e3) {
      this.scrollState = null;
      return;
    }
    const n = this.scrollState.index != null ? this.getOffsetForIndex(this.scrollState.index, this.scrollState.align) : void 0, i = n ? n[0] : this.scrollState.lastTargetOffset, a = 1, o = i !== this.scrollState.lastTargetOffset;
    if (!o && Wae(i, this.getScrollOffset())) {
      if (this.scrollState.stableFrames++, this.scrollState.stableFrames >= a) {
        this.scrollState = null;
        return;
      }
    } else
      this.scrollState.stableFrames = 0, o && (this.scrollState.lastTargetOffset = i, this.scrollState.behavior = "auto", this._scrollToOffset(i, {
        adjustments: void 0,
        behavior: "auto"
      }));
    this.scheduleScrollReconcile();
  }
}
const jk = (e, t, r, n) => {
  for (; e <= t; ) {
    const i = (e + t) / 2 | 0, a = r(i);
    if (a < n)
      e = i + 1;
    else if (a > n)
      t = i - 1;
    else
      return i;
  }
  return e > 0 ? e - 1 : 0;
};
function toe({
  measurements: e,
  outerSize: t,
  scrollOffset: r,
  lanes: n
}) {
  const i = e.length - 1, a = (l) => e[l].start;
  if (e.length <= n)
    return {
      startIndex: 0,
      endIndex: i
    };
  let o = jk(
    0,
    i,
    a,
    r
  ), s = o;
  if (n === 1)
    for (; s < i && e[s].end < r + t; )
      s++;
  else if (n > 1) {
    const l = Array(n).fill(0);
    for (; s < i && l.some((c) => c < r + t); ) {
      const c = e[s];
      l[c.lane] = c.end, s++;
    }
    const d = Array(n).fill(r + t);
    for (; o >= 0 && d.some((c) => c >= r); ) {
      const c = e[o];
      d[c.lane] = c.start, o--;
    }
    o = Math.max(0, o - o % n), s = Math.min(i, s + (n - 1 - s % n));
  }
  return { startIndex: o, endIndex: s };
}
const B5 = /* @__PURE__ */ Symbol("store-raw"), al = /* @__PURE__ */ Symbol("store-node"), Ki = /* @__PURE__ */ Symbol("store-has"), zk = /* @__PURE__ */ Symbol("store-self");
function Vk(e) {
  let t = e[Tr];
  if (!t && (Object.defineProperty(e, Tr, {
    value: t = new Proxy(e, ioe)
  }), !Array.isArray(e))) {
    const r = Object.keys(e), n = Object.getOwnPropertyDescriptors(e);
    for (let i = 0, a = r.length; i < a; i++) {
      const o = r[i];
      n[o].get && Object.defineProperty(e, o, {
        enumerable: n[o].enumerable,
        get: n[o].get.bind(t)
      });
    }
  }
  return t;
}
function Xa(e) {
  let t;
  return e != null && typeof e == "object" && (e[Tr] || !(t = Object.getPrototypeOf(e)) || t === Object.prototype || Array.isArray(e));
}
function El(e, t = /* @__PURE__ */ new Set()) {
  let r, n, i, a;
  if (r = e != null && e[B5]) return r;
  if (!Xa(e) || t.has(e)) return e;
  if (Array.isArray(e)) {
    Object.isFrozen(e) ? e = e.slice(0) : t.add(e);
    for (let o = 0, s = e.length; o < s; o++)
      i = e[o], (n = El(i, t)) !== i && (e[o] = n);
  } else {
    Object.isFrozen(e) ? e = Object.assign({}, e) : t.add(e);
    const o = Object.keys(e), s = Object.getOwnPropertyDescriptors(e);
    for (let l = 0, d = o.length; l < d; l++)
      a = o[l], !s[a].get && (i = e[a], (n = El(i, t)) !== i && (e[a] = n));
  }
  return e;
}
function S1(e, t) {
  let r = e[t];
  return r || Object.defineProperty(e, t, {
    value: r = /* @__PURE__ */ Object.create(null)
  }), r;
}
function Mc(e, t, r) {
  if (e[t]) return e[t];
  const [n, i] = z(r, {
    equals: !1,
    internal: !0
  });
  return n.$ = i, e[t] = n;
}
function roe(e, t) {
  const r = Reflect.getOwnPropertyDescriptor(e, t);
  return !r || r.get || !r.configurable || t === Tr || t === al || (delete r.value, delete r.writable, r.get = () => e[Tr][t]), r;
}
function Uk(e) {
  sl() && Mc(S1(e, al), zk)();
}
function noe(e) {
  return Uk(e), Reflect.ownKeys(e);
}
const ioe = {
  get(e, t, r) {
    if (t === B5) return e;
    if (t === Tr) return r;
    if (t === Zd)
      return Uk(e), r;
    const n = S1(e, al), i = n[t];
    let a = i ? i() : e[t];
    if (t === al || t === Ki || t === "__proto__") return a;
    if (!i) {
      const o = Object.getOwnPropertyDescriptor(e, t);
      sl() && (typeof a != "function" || e.hasOwnProperty(t)) && !(o && o.get) && (a = Mc(n, t, a)());
    }
    return Xa(a) ? Vk(a) : a;
  },
  has(e, t) {
    return t === B5 || t === Tr || t === Zd || t === al || t === Ki || t === "__proto__" ? !0 : (sl() && Mc(S1(e, Ki), t)(), t in e);
  },
  set() {
    return !0;
  },
  deleteProperty() {
    return !0;
  },
  ownKeys: noe,
  getOwnPropertyDescriptor: roe
};
function Nn(e, t, r, n = !1) {
  if (!n && e[t] === r) return;
  const i = e[t], a = e.length;
  r === void 0 ? (delete e[t], e[Ki] && e[Ki][t] && i !== void 0 && e[Ki][t].$()) : (e[t] = r, e[Ki] && e[Ki][t] && i === void 0 && e[Ki][t].$());
  let o = S1(e, al), s;
  if ((s = Mc(o, t, i)) && s.$(() => r), Array.isArray(e) && e.length !== a) {
    for (let l = e.length; l < a; l++) (s = o[l]) && s.$();
    (s = Mc(o, "length", a)) && s.$(e.length);
  }
  (s = o[zk]) && s.$();
}
function qk(e, t) {
  const r = Object.keys(t);
  for (let n = 0; n < r.length; n += 1) {
    const i = r[n];
    Nn(e, i, t[i]);
  }
}
function aoe(e, t) {
  if (typeof t == "function" && (t = t(e)), t = El(t), Array.isArray(t)) {
    if (e === t) return;
    let r = 0, n = t.length;
    for (; r < n; r++) {
      const i = t[r];
      e[r] !== i && Nn(e, r, i);
    }
    Nn(e, "length", n);
  } else qk(e, t);
}
function Rd(e, t, r = []) {
  let n, i = e;
  if (t.length > 1) {
    n = t.shift();
    const o = typeof n, s = Array.isArray(e);
    if (Array.isArray(n)) {
      for (let l = 0; l < n.length; l++)
        Rd(e, [n[l]].concat(t), r);
      return;
    } else if (s && o === "function") {
      for (let l = 0; l < e.length; l++)
        n(e[l], l) && Rd(e, [l].concat(t), r);
      return;
    } else if (s && o === "object") {
      const {
        from: l = 0,
        to: d = e.length - 1,
        by: c = 1
      } = n;
      for (let u = l; u <= d; u += c)
        Rd(e, [u].concat(t), r);
      return;
    } else if (t.length > 1) {
      Rd(e[n], t, [n].concat(r));
      return;
    }
    i = e[n], r = [n].concat(r);
  }
  let a = t[0];
  typeof a == "function" && (a = a(i, r), a === i) || n === void 0 && a == null || (a = El(a), n === void 0 || Xa(i) && Xa(a) && !Array.isArray(a) ? qk(i, a) : Nn(e, n, a));
}
function $h(...[e, t]) {
  const r = El(e || {}), n = Array.isArray(r), i = Vk(r);
  function a(...o) {
    A0(() => {
      n && o.length === 1 ? aoe(r, o[0]) : Rd(r, o);
    });
  }
  return [i, a];
}
const H5 = /* @__PURE__ */ Symbol("store-root");
function Ps(e, t, r, n, i) {
  const a = t[r];
  if (e === a) return;
  const o = Array.isArray(e);
  if (r !== H5 && (!Xa(e) || !Xa(a) || o !== Array.isArray(a) || i && e[i] !== a[i])) {
    Nn(t, r, e);
    return;
  }
  if (o) {
    if (e.length && a.length && (!n || i && e[0] && e[0][i] != null)) {
      let d, c, u, h, f, p, m, y;
      for (u = 0, h = Math.min(a.length, e.length); u < h && (a[u] === e[u] || i && a[u] && e[u] && a[u][i] && a[u][i] === e[u][i]); u++)
        Ps(e[u], a, u, n, i);
      const g = new Array(e.length), w = /* @__PURE__ */ new Map();
      for (h = a.length - 1, f = e.length - 1; h >= u && f >= u && (a[h] === e[f] || i && a[h] && e[f] && a[h][i] && a[h][i] === e[f][i]); h--, f--)
        g[f] = a[h];
      if (u > f || u > h) {
        for (c = u; c <= f; c++) Nn(a, c, e[c]);
        for (; c < e.length; c++)
          Nn(a, c, g[c]), Ps(e[c], a, c, n, i);
        a.length > e.length && Nn(a, "length", e.length);
        return;
      }
      for (m = new Array(f + 1), c = f; c >= u; c--)
        p = e[c], y = i && p ? p[i] : p, d = w.get(y), m[c] = d === void 0 ? -1 : d, w.set(y, c);
      for (d = u; d <= h; d++)
        p = a[d], y = i && p ? p[i] : p, c = w.get(y), c !== void 0 && c !== -1 && (g[c] = a[d], c = m[c], w.set(y, c));
      for (c = u; c < e.length; c++)
        c in g ? (Nn(a, c, g[c]), Ps(e[c], a, c, n, i)) : Nn(a, c, e[c]);
    } else
      for (let d = 0, c = e.length; d < c; d++)
        Ps(e[d], a, d, n, i);
    a.length > e.length && Nn(a, "length", e.length);
    return;
  }
  const s = Object.keys(e);
  for (let d = 0, c = s.length; d < c; d++)
    Ps(e[s[d]], a, s[d], n, i);
  const l = Object.keys(a);
  for (let d = 0, c = l.length; d < c; d++)
    e[l[d]] === void 0 && Nn(a, l[d], void 0);
}
function ooe(e, t = {}) {
  const {
    merge: r,
    key: n = "id"
  } = t, i = El(e);
  return (a) => {
    if (!Xa(a) || !Xa(i)) return i;
    const o = Ps(i, {
      [H5]: a
    }, H5, r, n);
    return o === void 0 ? a : o;
  };
}
function soe(e) {
  const t = Ke(e), r = new eoe(t), [n, i] = $h(r.getVirtualItems()), [a, o] = z(r.getTotalSize()), s = {
    get(d, c) {
      switch (c) {
        case "getVirtualItems":
          return () => n;
        case "getTotalSize":
          return () => a();
        default:
          return Reflect.get(d, c);
      }
    }
  }, l = new Proxy(r, s);
  return l.setOptions(t), Ht(() => {
    const d = l._didMount();
    l._willUpdate(), _r(d);
  }), J5(() => {
    l.setOptions(Ke(t, e, {
      onChange: (d, c) => {
        var u;
        d._willUpdate(), i(ooe(d.getVirtualItems(), {
          key: "index"
        })), o(d.getTotalSize()), (u = e.onChange) == null || u.call(e, d, c);
      }
    })), l.measure();
  }), l;
}
function N3(e) {
  return soe(Ke({
    observeElementRect: Yae,
    observeElementOffset: Jae,
    scrollToFn: Xae
  }, e));
}
var loe = /* @__PURE__ */ re('<div slot=suffix class=flex><sl-icon class="text-gray-400 hover:text-gray-600"name=x-circle-fill>', !0, !1, !1), doe = /* @__PURE__ */ re('<div><style></style><style></style><style></style><style></style><sl-dropdown class="dropdown relative"hoist><sl-input slot=trigger autocomplete=off size=medium class=input><p slot=help-text class="text-red-400 pt-1 font-sans"></p><div slot=suffix class=flex><sl-spinner slot=suffix></sl-spinner></div><div slot=suffix class=flex><sl-icon></sl-icon></div></sl-input><div class="border border-gray-200 dropdown-container overflow-hidden relative"><div class="bg-white overflow-x-hidden overflow-y-auto relative"><div>', !0, !1, !1), coe = /* @__PURE__ */ re('<sl-menu-item><p class="text-center text-gray-400 italic">Loading...', !0, !1, !1), Bk = /* @__PURE__ */ re("<sl-menu-item>", !0, !1, !1), uoe = /* @__PURE__ */ re("<sl-menu-item class=group>", !0, !1, !1), hoe = /* @__PURE__ */ re('<p class="text-center text-gray-400 italic">Loading...'), foe = /* @__PURE__ */ re('<p class="text-center text-gray-400 italic">Nothing more to load'), poe = /* @__PURE__ */ re("<p>");
fi("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const Hk = (e) => {
  let t, r, n, i, a;
  e.actionRef && (e.actionRef.clear = () => {
    d(void 0), u(-1), i.value = "", p(""), w();
  });
  const [o, s] = z(!1), [l, d] = z(void 0), [c, u] = z(-1), [h, f] = z(), p = hh(async (S) => {
    e.onSearchChange && await e.onSearchChange(S);
  }, 250), m = new IntersectionObserver(async (S) => {
    S?.at(-1)?.isIntersecting && e.hasMore && e.fetchMore && await e.fetchMore();
  });
  le(() => {
    e.data.length === 0 && d(void 0);
  }), le(() => {
    h() && m.observe(h());
  });
  const y = (S) => {
    if (S)
      return e.helpText ? e.helpText : e.required ? "Please select data..." : void 0;
  }, g = (S) => {
    const T = new CustomEvent("photon-data-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        data: S
      }
    });
    t?.dispatchEvent(T);
  }, w = () => {
    const S = new CustomEvent("photon-data-unselected", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(S);
  };
  le(() => {
    e.selectedData && d(e.selectedData), e.selectedData === void 0 && d(void 0);
  }), Ht(() => {
    i && i.addEventListener("keydown", (S) => {
      (S.code == "Space" || S.key == " ") && S.stopImmediatePropagation();
    });
  });
  const $ = B(() => {
    const S = l();
    return S ? e.displayAccessor(S, !1) : e.placeholder ?? "Select data...";
  }), _ = B(() => e.groups ? e.groups.map((S) => {
    const T = e.data.map((I, M) => ({
      data: I,
      allItemsIdx: M
    })).filter((I) => S.filter(I.data));
    return T.length > 0 ? [{
      title: S.label
    }, ...T] : [];
  }).flat() : e.data.map((S, T) => ({
    data: S,
    allItemsIdx: T
  }))), x = B(() => N3({
    count: _().length,
    getScrollElement: () => n ?? null,
    estimateSize: () => 36.8,
    overscan: 100
  }));
  return (() => {
    var S = doe(), T = S.firstChild, I = T.nextSibling, M = I.nextSibling, P = M.nextSibling, O = P.nextSibling, D = O.firstChild, R = D.firstChild, L = R.nextSibling, Q = L.firstChild, ie = L.nextSibling, ee = ie.firstChild, W = D.nextSibling, H = W.firstChild, pe = H.firstChild, Te = t;
    typeof Te == "function" ? Rt(Te, S) : t = S, N(T, Tn), N(I, no), N(M, io), N(P, Hae), Oe(O, "sl-show", async () => {
      s(!0), e.onOpen && await e.onOpen();
    }), Oe(O, "sl-hide", async () => {
      l() || (i.value = "", e.onHide && await e.onHide()), s(!1);
    });
    var Ce = r;
    typeof Ce == "function" ? Rt(Ce, O) : r = O, O.style.setProperty("width", "100%"), O._$owner = Pe(), Oe(D, "sl-focus", (ae) => {
      e.onInputFocus ? (e.onInputFocus(), ae.stopImmediatePropagation()) : (r.children[1].style.width = `${i.clientWidth}px`, c() > 0 && x().scrollToIndex(c()));
    }), Oe(D, "click", async (ae) => {
      ae.preventDefault();
    }), Oe(D, "sl-input", (ae) => {
      o() || r.show(), p(ae.target.value);
    });
    var de = i;
    typeof de == "function" ? Rt(de, D) : i = D, D._$owner = Pe(), N(R, () => y(e.invalid ?? !1)), Q._$owner = Pe(), N(D, v(q, {
      get when() {
        return e.clearable;
      },
      get children() {
        var ae = loe(), Me = ae.firstChild;
        return Oe(Me, "click", (We) => {
          We.stopImmediatePropagation(), d(void 0), u(-1), i.value = "", p(""), w(), r.hide();
        }), Me._$owner = Pe(), te(() => ae.classList.toggle("hidden", !!(e.isLoading || l() == null))), ae;
      }
    }), ie), ee._$owner = Pe();
    var K = a;
    typeof K == "function" ? Rt(K, H) : a = H, H.style.setProperty("max-height", "200px"), H.style.setProperty("min-height", "37px"), H.style.setProperty("width", "100%"), H.style.setProperty("display", "flex"), H.style.setProperty("flex-direction", "column"), H.style.setProperty("justify-content", "start");
    var oe = n;
    return typeof oe == "function" ? Rt(oe, pe) : n = pe, pe.style.setProperty("width", "100%"), N(pe, v(dt, {
      get each() {
        return x().getVirtualItems();
      },
      get fallback() {
        return v(moe, {
          get noDataMsg() {
            return e.noDataMsg;
          },
          get isLoading() {
            return e.isLoading;
          }
        });
      },
      children: (ae) => {
        const Me = ae.index > _().length - 1, We = _()[ae.index], Dt = l(), vt = !Me && !!Dt && "id" in Dt && "data" in We && Dt.id === We.data.id;
        return v(N1, {
          get children() {
            return [v(Mn, {
              get when() {
                return "title" in We;
              },
              get children() {
                return v(goe, {
                  item: We
                });
              }
            }), v(Mn, {
              get when() {
                return "data" in We;
              },
              get children() {
                return v(voe, {
                  item: ae,
                  isLoader: Me,
                  isSelected: vt,
                  get index() {
                    return ae.index;
                  },
                  get hasMore() {
                    return e.hasMore;
                  },
                  get showOverflow() {
                    return e.showOverflow;
                  },
                  onClick: () => {
                    Me || (d(We.data), u(We.allItemsIdx), i.value = "", p(""), g(We.data), r.hide());
                  },
                  setLastIndex: f,
                  get children() {
                    return e.displayAccessor(We.data, !0);
                  }
                });
              }
            })];
          }
        });
      }
    })), te((ae) => {
      var Me = e.forceLabelSize && !e.invalid ? -20 : e.invalid ? -18 : 0, We = e.disabled ?? !1, Dt = e.label, vt = $(), zt = e.disabled ?? !1, Wt = !!(e.invalid ?? !1), $e = !!(e.disabled ?? !1), Z = !l() && i.value === "", Ie = e.required, Re = !!e.forceLabelSize, xt = !e.isLoading, it = !!e.isLoading, Kt = o() ? "chevron-up" : "chevron-down", De = `${x().getTotalSize()}px`;
      return Me !== ae.e && (O.distance = ae.e = Me), We !== ae.t && (O.disabled = ae.t = We), Dt !== ae.a && (D.label = ae.a = Dt), vt !== ae.o && (D.placeholder = ae.o = vt), zt !== ae.i && (D.disabled = ae.i = zt), Wt !== ae.n && D.classList.toggle("invalid", ae.n = Wt), $e !== ae.s && D.classList.toggle("disabled", ae.s = $e), Z !== ae.h && D.classList.toggle("placeholder", ae.h = Z), Ie !== ae.r && (D.required = ae.r = Ie), Re !== ae.d && R.classList.toggle("h-[21px]", ae.d = Re), xt !== ae.l && L.classList.toggle("hidden", ae.l = xt), it !== ae.u && ie.classList.toggle("hidden", ae.u = it), Kt !== ae.c && (ee.name = ae.c = Kt), De !== ae.w && ((ae.w = De) != null ? pe.style.setProperty("height", De) : pe.style.removeProperty("height")), ae;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0,
      s: void 0,
      h: void 0,
      r: void 0,
      d: void 0,
      l: void 0,
      u: void 0,
      c: void 0,
      w: void 0
    }), S;
  })();
}, moe = (e) => v(q, {
  get when() {
    return e.isLoading;
  },
  get fallback() {
    return (() => {
      var t = Bk();
      return t._$owner = Pe(), N(t, () => e.noDataMsg ? e.noDataMsg : "No data found"), t;
    })();
  },
  get children() {
    var t = coe();
    return t._$owner = Pe(), t;
  }
}), goe = (e) => (() => {
  var t = uoe();
  return t._$owner = Pe(), N(t, () => e.item.title), t;
})(), voe = (e) => (() => {
  var t = Bk();
  return Rt((r) => {
    e.isLoader && e.index > 0 && e.setLastIndex(r);
  }, t), t.$$click = () => e.onClick(), t.style.setProperty("width", "100%"), t._$owner = Pe(), N(t, (() => {
    var r = gt(() => !!e.isLoader);
    return () => r() ? gt(() => !!e.hasMore)() ? hoe() : foe() : (() => {
      var n = poe();
      return N(n, () => e.children), te((i) => {
        var a = !e.showOverflow, o = !e.showOverflow, s = !e.showOverflow, l = !!e.showOverflow;
        return a !== i.e && n.classList.toggle("overflow-hidden", i.e = a), o !== i.t && n.classList.toggle("overflow-ellipsis", i.t = o), s !== i.a && n.classList.toggle("whitespace-nowrap", i.a = s), l !== i.o && n.classList.toggle("whitespace-normal", i.o = l), i;
      }, {
        e: void 0,
        t: void 0,
        a: void 0,
        o: void 0
      }), n;
    })();
  })()), te((r) => {
    var n = e.isSelected ? "selected default" : "default", i = `${e.item.size}px`;
    return n !== r.e && Zi(t, r.e = n), i !== r.t && ((r.t = i) != null ? t.style.setProperty("min-height", i) : t.style.removeProperty("min-height")), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})();
ns(["click"]);
const m7 = xe`
  fragment PatientOrderFields on Patient {
    id
    externalId
    name {
      full
      first
      middle
      last
      title
    }
    dateOfBirth
    sex
    gender
    email
    phone
    address {
      id
      name {
        full
      }
      city
      country
      postalCode
      state
      street1
      street2
    }
    preferredPharmacies {
      id
      name
      address {
        city
        country
        postalCode
        state
        street1
        street2
      }
      phone
    }
  }
`, yoe = () => {
  const [e, t] = $h({
    patients: {
      data: [],
      errors: [],
      isLoading: !1,
      finished: !1
    },
    selectedPatient: {
      data: void 0,
      errors: [],
      isLoading: !1
    }
  }), r = async (s, l) => {
    t("selectedPatient", {
      ...e.selectedPatient,
      isLoading: !0
    });
    const { data: d, errors: c } = await s.clinical.patient.getPatient({
      id: l,
      fragment: {
        PatientOrderFields: m7
      }
    });
    t("selectedPatient", {
      ...e.selectedPatient,
      isLoading: !1,
      data: d.patient,
      errors: c
    });
  }, n = async (s, l) => {
    l || (l = {}), t("patients", {
      ...e.patients,
      isLoading: !0
    });
    const { data: d, errors: c } = await s.clinical.patient.getPatients({
      first: l.first,
      name: l.name,
      fragment: {
        PatientOrderFields: m7
      }
    });
    return t("patients", {
      ...e.patients,
      isLoading: !1,
      errors: c,
      data: d.patients,
      finished: d.patients.length === 0
    }), (!c || c.length === 0) && d.patients.length > 0 ? () => i(s, {
      ...l,
      after: d.patients?.at(-1).id
    }) : void 0;
  }, i = async (s, l) => {
    t("patients", {
      ...e.patients,
      isLoading: !0
    });
    const { data: d, errors: c } = await s.clinical.patient.getPatients(l);
    return t("patients", {
      ...e.patients,
      isLoading: !1,
      errors: c,
      data: [...e.patients.data, ...d.patients],
      finished: d.patients.length === 0
    }), (!c || c.length === 0) && d.patients.length > 0 ? () => i(s, {
      ...l,
      after: d.patients?.at(-1).id
    }) : void 0;
  };
  return {
    store: e,
    actions: {
      getPatients: n,
      getSelectedPatient: r,
      clearSelectedPatient: async () => {
        t("selectedPatient", {
          ...e.selectedPatient,
          data: void 0
        });
      },
      reset: async () => {
        t("patients", {
          data: [],
          errors: [],
          isLoading: !1,
          finished: !1
        }), t("selectedPatient", {
          data: void 0,
          errors: [],
          isLoading: !1
        });
      }
    }
  };
}, du = yoe();
var boe = /* @__PURE__ */ re("<div>");
const woe = (e) => {
  let t;
  const r = Cn(), {
    store: n,
    actions: i
  } = du;
  let a;
  Ht(() => {
    i.reset();
  });
  const o = (l) => {
    const d = new CustomEvent("photon-patient-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        patient: l
      }
    });
    t?.dispatchEvent(d);
  }, s = B(() => n.selectedPatient.data ? [n.selectedPatient.data, ...n.patients.data.filter((l) => l?.id !== n.selectedPatient.data.id)] : n.patients.data);
  return le(async () => {
    e.selected && !n.selectedPatient.data && Le(async () => {
      await i.getSelectedPatient(r ? r.getSDK() : e.sdk, e.selected);
    });
  }), (() => {
    var l = boe();
    Oe(l, "photon-data-selected", (c) => {
      o(c.detail.data);
    });
    var d = t;
    return typeof d == "function" ? Rt(d, l) : t = l, N(l, v(Hk, {
      get data() {
        return s();
      },
      get label() {
        return e.label;
      },
      get forceLabelSize() {
        return e.forceLabelSize;
      },
      get required() {
        return e.required;
      },
      get disabled() {
        return e.disabled;
      },
      placeholder: "Select patient...",
      get invalid() {
        return e.invalid;
      },
      get isLoading() {
        return n.patients.isLoading || n.selectedPatient.isLoading;
      },
      get hasMore() {
        return n.patients.data.length % 25 === 0 && !n.patients.finished;
      },
      displayAccessor: (c) => c?.name?.full || "",
      onSearchChange: async (c) => a = await i.getPatients(r.getSDK(), {
        name: c
      }),
      onOpen: async () => {
        n.patients.data.length == 0 && (a = await i.getPatients(r.getSDK()));
      },
      onHide: async () => {
        a = await i.getPatients(r.getSDK());
      },
      fetchMore: async () => {
        a && (a = await a());
      },
      noDataMsg: "No patients found",
      get helpText() {
        return e.helpText;
      },
      get selectedData() {
        return n.selectedPatient.data;
      }
    })), l;
  })();
};
Xr("photon-patient-select", {
  label: void 0,
  required: !1,
  invalid: !1,
  helpText: void 0,
  selected: void 0,
  formName: void 0,
  disabled: !1,
  forceLabelSize: !1,
  sdk: void 0
}, woe);
var m2 = /* @__PURE__ */ re("<style>"), $oe = /* @__PURE__ */ re("<slot>"), koe = /* @__PURE__ */ re("<photon-login>", !0, !1, !1), _oe = /* @__PURE__ */ re('<div class="w-full flex justify-center"><sl-spinner>', !0, !1, !1);
fi("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const xoe = (e) => {
  const t = Cn(), [r, n] = z(!1), [i, a] = z(!0);
  return le(() => {
    t || console.error("[photon-auth-wrapper] No valid PhotonClient instance was provided. Please ensure you are wrapping the element in a photon-client element");
  }), le(() => {
    if (t?.authentication.state.isLoading)
      a(!0);
    else {
      if (a(!1), !t?.authentication.state.isAuthenticated && e.autoLogin) {
        const o = {
          appState: {}
        };
        e.redirectPath && (o.appState.returnTo = e.redirectPath), t?.authentication.login(o);
      }
      n(t?.authentication.state.isAuthenticated || !1);
    }
  }), [(() => {
    var o = m2();
    return N(o, Tn), o;
  })(), (() => {
    var o = m2();
    return N(o, no), o;
  })(), (() => {
    var o = m2();
    return N(o, io), o;
  })(), v(q, {
    get when() {
      return t && r();
    },
    get children() {
      var o = $oe();
      return o._$owner = Pe(), o;
    }
  }), v(q, {
    get when() {
      return t && !r() && !i() && !e.autoLogin;
    },
    get children() {
      var o = koe();
      return o._$owner = Pe(), te(() => o.redirectPath = e.redirectPath), o;
    }
  }), v(q, {
    get when() {
      return t && i() && !e.hideLoader;
    },
    get children() {
      var o = _oe(), s = o.firstChild;
      return s.style.setProperty("font-size", "3rem"), s._$owner = Pe(), o;
    }
  })];
};
Xr("photon-auth-wrapper", {
  autoLogin: !1,
  hideLoader: !1,
  redirectPath: {
    attribute: "redirect-path",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  }
}, xoe);
class Eoe extends TypeError {
  constructor(t, r) {
    let n;
    const { message: i, explanation: a, ...o } = t, { path: s } = t, l = s.length === 0 ? i : `At path: ${s.join(".")} -- ${i}`;
    super(a ?? l), a != null && (this.cause = l), Object.assign(this, o), this.name = this.constructor.name, this.failures = () => n ?? (n = [t, ...r()]);
  }
}
function Soe(e) {
  return ol(e) && typeof e[Symbol.iterator] == "function";
}
function ol(e) {
  return typeof e == "object" && e != null;
}
function ts(e) {
  return typeof e == "symbol" ? e.toString() : typeof e == "string" ? JSON.stringify(e) : `${e}`;
}
function Coe(e) {
  const { done: t, value: r } = e.next();
  return t ? void 0 : r;
}
function Toe(e, t, r, n) {
  if (e === !0)
    return;
  e === !1 ? e = {} : typeof e == "string" && (e = { message: e });
  const { path: i, branch: a } = t, { type: o } = r, { refinement: s, message: l = `Expected a value of type \`${o}\`${s ? ` with refinement \`${s}\`` : ""}, but received: \`${ts(n)}\`` } = e;
  return {
    value: n,
    type: o,
    refinement: s,
    key: i[i.length - 1],
    path: i,
    branch: a,
    ...e,
    message: l
  };
}
function* W5(e, t, r, n) {
  Soe(e) || (e = [e]);
  for (const i of e) {
    const a = Toe(i, t, r, n);
    a && (yield a);
  }
}
function* M3(e, t, r = {}) {
  const { path: n = [], branch: i = [e], coerce: a = !1, mask: o = !1 } = r, s = { path: n, branch: i };
  if (a && (e = t.coercer(e, s), o && t.type !== "type" && ol(t.schema) && ol(e) && !Array.isArray(e)))
    for (const d in e)
      t.schema[d] === void 0 && delete e[d];
  let l = "valid";
  for (const d of t.validator(e, s))
    d.explanation = r.message, l = "not_valid", yield [d, void 0];
  for (let [d, c, u] of t.entries(e, s)) {
    const h = M3(c, u, {
      path: d === void 0 ? n : [...n, d],
      branch: d === void 0 ? i : [...i, c],
      coerce: a,
      mask: o,
      message: r.message
    });
    for (const f of h)
      f[0] ? (l = f[0].refinement != null ? "not_refined" : "not_valid", yield [f[0], void 0]) : a && (c = f[1], d === void 0 ? e = c : e instanceof Map ? e.set(d, c) : e instanceof Set ? e.add(c) : ol(e) && (c !== void 0 || d in e) && (e[d] = c));
  }
  if (l !== "not_valid")
    for (const d of t.refiner(e, s))
      d.explanation = r.message, l = "not_refined", yield [d, void 0];
  l === "valid" && (yield [void 0, e]);
}
class Kl {
  constructor(t) {
    const { type: r, schema: n, validator: i, refiner: a, coercer: o = (l) => l, entries: s = function* () {
    } } = t;
    this.type = r, this.schema = n, this.entries = s, this.coercer = o, i ? this.validator = (l, d) => {
      const c = i(l, d);
      return W5(c, d, this, l);
    } : this.validator = () => [], a ? this.refiner = (l, d) => {
      const c = a(l, d);
      return W5(c, d, this, l);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(t, r) {
    return Wk(t, this, r);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(t, r) {
    return Aoe(t, this, r);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(t) {
    return Kk(t, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(t, r) {
    return Ooe(t, this, r);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(t, r = {}) {
    return cu(t, this, r);
  }
}
function Wk(e, t, r) {
  const n = cu(e, t, { message: r });
  if (n[0])
    throw n[0];
}
function Aoe(e, t, r) {
  const n = cu(e, t, { coerce: !0, message: r });
  if (n[0])
    throw n[0];
  return n[1];
}
function Ooe(e, t, r) {
  const n = cu(e, t, { coerce: !0, mask: !0, message: r });
  if (n[0])
    throw n[0];
  return n[1];
}
function Kk(e, t) {
  return !cu(e, t)[0];
}
function cu(e, t, r = {}) {
  const n = M3(e, t, r), i = Coe(n);
  return i[0] ? [new Eoe(i[0], function* () {
    for (const o of n)
      o[0] && (yield o[0]);
  }), void 0] : [void 0, i[1]];
}
function ls(e, t) {
  return new Kl({ type: e, schema: null, validator: t });
}
function kh() {
  return ls("any", () => !0);
}
function Poe(e) {
  const t = {}, r = e.map((n) => ts(n)).join();
  for (const n of e)
    t[n] = n;
  return new Kl({
    type: "enums",
    schema: t,
    validator(n) {
      return e.includes(n) || `Expected one of \`${r}\`, but received: ${ts(n)}`;
    }
  });
}
function g7() {
  return ls("number", (e) => typeof e == "number" && !isNaN(e) || `Expected a number, but received: ${ts(e)}`);
}
function Ioe(e) {
  return new Kl({
    ...e,
    validator: (t, r) => t === void 0 || e.validator(t, r),
    refiner: (t, r) => t === void 0 || e.refiner(t, r)
  });
}
function R3(e, t) {
  return new Kl({
    type: "record",
    schema: null,
    *entries(r) {
      if (ol(r))
        for (const n in r) {
          const i = r[n];
          yield [n, n, e], yield [n, i, t];
        }
    },
    validator(r) {
      return ol(r) || `Expected an object, but received: ${ts(r)}`;
    }
  });
}
function bn() {
  return ls("string", (e) => typeof e == "string" || `Expected a string, but received: ${ts(e)}`);
}
function Doe(e) {
  const t = e.map((r) => r.type).join(" | ");
  return new Kl({
    type: "union",
    schema: null,
    coercer(r) {
      for (const n of e) {
        const [i, a] = n.validate(r, { coerce: !0 });
        if (!i)
          return a;
      }
      return r;
    },
    validator(r, n) {
      const i = [];
      for (const a of e) {
        const [...o] = M3(r, a, n), [s] = o;
        if (s[0])
          for (const [l] of o)
            l && i.push(l);
        else
          return [];
      }
      return [
        `Expected the value to satisfy a union of \`${t}\`, but received: ${ts(r)}`,
        ...i
      ];
    }
  });
}
function v7(e, t, r = {}) {
  const { exclusive: n } = r;
  return Ql(e, "min", (i) => n ? i > t : i >= t || `Expected a ${e.type} greater than ${n ? "" : "or equal to "}${t} but received \`${i}\``);
}
function xo(e, t, r = t) {
  const n = `Expected a ${e.type}`, i = t === r ? `of \`${t}\`` : `between \`${t}\` and \`${r}\``;
  return Ql(e, "size", (a) => {
    if (typeof a == "number" || a instanceof Date)
      return t <= a && a <= r || `${n} ${i} but received \`${a}\``;
    if (a instanceof Map || a instanceof Set) {
      const { size: o } = a;
      return t <= o && o <= r || `${n} with a size ${i} but received one with a size of \`${o}\``;
    } else {
      const { length: o } = a;
      return t <= o && o <= r || `${n} with a length ${i} but received one with a length of \`${o}\``;
    }
  });
}
function Ql(e, t, r) {
  return new Kl({
    ...e,
    *refiner(n, i) {
      yield* e.refiner(n, i);
      const a = r(n, i), o = W5(a, i, e, n);
      for (const s of o)
        yield { ...s, refinement: t };
    }
  });
}
const Qk = (e) => {
  const t = {};
  if (e) {
    const h = {};
    for (const f of Object.keys(e))
      h[f] = {
        value: e[f],
        error: void 0
      };
    e = h;
  }
  const [r, n] = $h(e || {}), i = ({ key: h, value: f }) => {
    n(h, {
      value: f,
      error: void 0
    });
  }, a = (h) => {
    let f = 0;
    for (const p in r)
      h.includes(p) && r[p]?.error && (f += 1);
    return f > 0;
  }, o = (h) => {
    let f = [];
    for (const p in r)
      h.includes(p) && r[p]?.error && (f = [...f, { key: p, error: r[p]?.error ?? "" }]);
    return f;
  }, s = (h) => {
    for (const f of h)
      n(f, void 0);
  };
  return {
    store: r,
    actions: {
      updateFormValue: i,
      clearKeys: s,
      registerValidator: ({ key: h, validator: f }) => {
        if (h in t) {
          t[h] = [...t[h], f];
          return;
        }
        t[h] = [f];
      },
      unRegisterValidator: (h) => {
        delete t[h];
      },
      validate: (h) => {
        Object.entries(r).filter(([f]) => h ? h.includes(f) : !0).forEach(([f, p]) => {
          t[f] && t[f].forEach((m) => {
            try {
              Wk(p?.value, m);
            } catch (y) {
              for (const g of y.failures())
                n(f, {
                  value: p?.value,
                  error: g.message
                });
            }
          });
        });
      },
      hasErrors: a,
      getErrors: o,
      reset: () => {
        const h = Object.keys(r);
        s(h);
        const f = Object.keys(t);
        for (const p of f)
          delete t[p];
      }
    }
  };
};
var Gk = (e) => {
  var t;
  const { activeElement: r } = document;
  r && e.contains(r) && ((t = document.activeElement) == null || t.blur());
}, Noe = hn`
  :host {
    display: inline-block;
    color: var(--sl-color-neutral-600);
  }

  .icon-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-medium);
    font-size: inherit;
    color: inherit;
    padding: var(--sl-spacing-x-small);
    cursor: pointer;
    transition: var(--sl-transition-x-fast) color;
    -webkit-appearance: none;
  }

  .icon-button:hover:not(.icon-button--disabled),
  .icon-button:focus-visible:not(.icon-button--disabled) {
    color: var(--sl-color-primary-600);
  }

  .icon-button:active:not(.icon-button--disabled) {
    color: var(--sl-color-primary-700);
  }

  .icon-button:focus {
    outline: none;
  }

  .icon-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .icon-button__icon {
    pointer-events: none;
  }
`;
const Yk = /* @__PURE__ */ Symbol.for(""), Moe = (e) => {
  if (e?.r === Yk) return e?._$litStatic$;
}, y7 = (e, ...t) => ({ _$litStatic$: t.reduce((r, n, i) => r + ((a) => {
  if (a._$litStatic$ !== void 0) return a._$litStatic$;
  throw Error(`Value passed to 'literal' function must be a 'literal' result: ${a}. Use 'unsafeStatic' to pass non-literal values, but
            take care to ensure page security.`);
})(n) + e[i + 1], e[0]), r: Yk }), b7 = /* @__PURE__ */ new Map(), Roe = (e) => (t, ...r) => {
  const n = r.length;
  let i, a;
  const o = [], s = [];
  let l, d = 0, c = !1;
  for (; d < n; ) {
    for (l = t[d]; d < n && (a = r[d], (i = Moe(a)) !== void 0); ) l += i + t[++d], c = !0;
    d !== n && s.push(a), o.push(l), d++;
  }
  if (d === n && o.push(t[n]), c) {
    const u = o.join("$$lit$$");
    (t = b7.get(u)) === void 0 && (o.raw = o, b7.set(u, t = o)), r = s;
  }
  return e(t, ...r);
}, Loe = Roe(Jt);
var tn = class extends Br {
  constructor() {
    super(...arguments), this.hasFocus = !1, this.label = "", this.disabled = !1;
  }
  handleBlur() {
    this.hasFocus = !1, this.emit("sl-blur");
  }
  handleFocus() {
    this.hasFocus = !0, this.emit("sl-focus");
  }
  handleClick(e) {
    this.disabled && (e.preventDefault(), e.stopPropagation());
  }
  /** Simulates a click on the icon button. */
  click() {
    this.button.click();
  }
  /** Sets focus on the icon button. */
  focus(e) {
    this.button.focus(e);
  }
  /** Removes focus from the icon button. */
  blur() {
    this.button.blur();
  }
  render() {
    const e = !!this.href, t = e ? y7`a` : y7`button`;
    return Loe`
      <${t}
        part="base"
        class=${En({
      "icon-button": !0,
      "icon-button--disabled": !e && this.disabled,
      "icon-button--focused": this.hasFocus
    })}
        ?disabled=${Nt(e ? void 0 : this.disabled)}
        type=${Nt(e ? void 0 : "button")}
        href=${Nt(e ? this.href : void 0)}
        target=${Nt(e ? this.target : void 0)}
        download=${Nt(e ? this.download : void 0)}
        rel=${Nt(e && this.target ? "noreferrer noopener" : void 0)}
        role=${Nt(e ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-label="${this.label}"
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @click=${this.handleClick}
      >
        <sl-icon
          class="icon-button__icon"
          name=${Nt(this.name)}
          library=${Nt(this.library)}
          src=${Nt(this.src)}
          aria-hidden="true"
        ></sl-icon>
      </${t}>
    `;
  }
};
tn.styles = [zn, Noe];
tn.dependencies = { "sl-icon": Vn };
V([
  Er(".icon-button")
], tn.prototype, "button", 2);
V([
  ou()
], tn.prototype, "hasFocus", 2);
V([
  ne()
], tn.prototype, "name", 2);
V([
  ne()
], tn.prototype, "library", 2);
V([
  ne()
], tn.prototype, "src", 2);
V([
  ne()
], tn.prototype, "href", 2);
V([
  ne()
], tn.prototype, "target", 2);
V([
  ne()
], tn.prototype, "download", 2);
V([
  ne()
], tn.prototype, "label", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], tn.prototype, "disabled", 2);
var Foe = hn`
  :host {
    display: contents;

    /* For better DX, we'll reset the margin here so the base part can inherit it */
    margin: 0;
  }

  .alert {
    position: relative;
    display: flex;
    align-items: stretch;
    background-color: var(--sl-panel-background-color);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    border-top-width: calc(var(--sl-panel-border-width) * 3);
    border-radius: var(--sl-border-radius-medium);
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-small);
    font-weight: var(--sl-font-weight-normal);
    line-height: 1.6;
    color: var(--sl-color-neutral-700);
    margin: inherit;
    overflow: hidden;
  }

  .alert:not(.alert--has-icon) .alert__icon,
  .alert:not(.alert--closable) .alert__close-button {
    display: none;
  }

  .alert__icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-large);
    padding-inline-start: var(--sl-spacing-large);
  }

  .alert--has-countdown {
    border-bottom: none;
  }

  .alert--primary {
    border-top-color: var(--sl-color-primary-600);
  }

  .alert--primary .alert__icon {
    color: var(--sl-color-primary-600);
  }

  .alert--success {
    border-top-color: var(--sl-color-success-600);
  }

  .alert--success .alert__icon {
    color: var(--sl-color-success-600);
  }

  .alert--neutral {
    border-top-color: var(--sl-color-neutral-600);
  }

  .alert--neutral .alert__icon {
    color: var(--sl-color-neutral-600);
  }

  .alert--warning {
    border-top-color: var(--sl-color-warning-600);
  }

  .alert--warning .alert__icon {
    color: var(--sl-color-warning-600);
  }

  .alert--danger {
    border-top-color: var(--sl-color-danger-600);
  }

  .alert--danger .alert__icon {
    color: var(--sl-color-danger-600);
  }

  .alert__message {
    flex: 1 1 auto;
    display: block;
    padding: var(--sl-spacing-large);
    overflow: hidden;
  }

  .alert__close-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-medium);
    margin-inline-end: var(--sl-spacing-medium);
    align-self: center;
  }

  .alert__countdown {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: calc(var(--sl-panel-border-width) * 3);
    background-color: var(--sl-panel-border-color);
    display: flex;
  }

  .alert__countdown--ltr {
    justify-content: flex-end;
  }

  .alert__countdown .alert__countdown-elapsed {
    height: 100%;
    width: 0;
  }

  .alert--primary .alert__countdown-elapsed {
    background-color: var(--sl-color-primary-600);
  }

  .alert--success .alert__countdown-elapsed {
    background-color: var(--sl-color-success-600);
  }

  .alert--neutral .alert__countdown-elapsed {
    background-color: var(--sl-color-neutral-600);
  }

  .alert--warning .alert__countdown-elapsed {
    background-color: var(--sl-color-warning-600);
  }

  .alert--danger .alert__countdown-elapsed {
    background-color: var(--sl-color-danger-600);
  }

  .alert__timer {
    display: none;
  }
`, On = class Eo extends Br {
  constructor() {
    super(...arguments), this.hasSlotController = new lu(this, "icon", "suffix"), this.localize = new ro(this), this.open = !1, this.closable = !1, this.variant = "primary", this.duration = 1 / 0, this.remainingTime = this.duration;
  }
  static get toastStack() {
    return this.currentToastStack || (this.currentToastStack = Object.assign(document.createElement("div"), {
      className: "sl-toast-stack"
    })), this.currentToastStack;
  }
  firstUpdated() {
    this.base.hidden = !this.open;
  }
  restartAutoHide() {
    this.handleCountdownChange(), clearTimeout(this.autoHideTimeout), clearInterval(this.remainingTimeInterval), this.open && this.duration < 1 / 0 && (this.autoHideTimeout = window.setTimeout(() => this.hide(), this.duration), this.remainingTime = this.duration, this.remainingTimeInterval = window.setInterval(() => {
      this.remainingTime -= 100;
    }, 100));
  }
  pauseAutoHide() {
    var t;
    (t = this.countdownAnimation) == null || t.pause(), clearTimeout(this.autoHideTimeout), clearInterval(this.remainingTimeInterval);
  }
  resumeAutoHide() {
    var t;
    this.duration < 1 / 0 && (this.autoHideTimeout = window.setTimeout(() => this.hide(), this.remainingTime), this.remainingTimeInterval = window.setInterval(() => {
      this.remainingTime -= 100;
    }, 100), (t = this.countdownAnimation) == null || t.play());
  }
  handleCountdownChange() {
    if (this.open && this.duration < 1 / 0 && this.countdown) {
      const { countdownElement: t } = this, r = "100%", n = "0";
      this.countdownAnimation = t.animate([{ width: r }, { width: n }], {
        duration: this.duration,
        easing: "linear"
      });
    }
  }
  handleCloseClick() {
    this.hide();
  }
  async handleOpenChange() {
    if (this.open) {
      this.emit("sl-show"), this.duration < 1 / 0 && this.restartAutoHide(), await Ci(this.base), this.base.hidden = !1;
      const { keyframes: t, options: r } = ei(this, "alert.show", { dir: this.localize.dir() });
      await ti(this.base, t, r), this.emit("sl-after-show");
    } else {
      Gk(this), this.emit("sl-hide"), clearTimeout(this.autoHideTimeout), clearInterval(this.remainingTimeInterval), await Ci(this.base);
      const { keyframes: t, options: r } = ei(this, "alert.hide", { dir: this.localize.dir() });
      await ti(this.base, t, r), this.base.hidden = !0, this.emit("sl-after-hide");
    }
  }
  handleDurationChange() {
    this.restartAutoHide();
  }
  /** Shows the alert. */
  async show() {
    if (!this.open)
      return this.open = !0, Za(this, "sl-after-show");
  }
  /** Hides the alert */
  async hide() {
    if (this.open)
      return this.open = !1, Za(this, "sl-after-hide");
  }
  /**
   * Displays the alert as a toast notification. This will move the alert out of its position in the DOM and, when
   * dismissed, it will be removed from the DOM completely. By storing a reference to the alert, you can reuse it by
   * calling this method again. The returned promise will resolve after the alert is hidden.
   */
  async toast() {
    return new Promise((t) => {
      this.handleCountdownChange(), Eo.toastStack.parentElement === null && document.body.append(Eo.toastStack), Eo.toastStack.appendChild(this), requestAnimationFrame(() => {
        this.clientWidth, this.show();
      }), this.addEventListener(
        "sl-after-hide",
        () => {
          Eo.toastStack.removeChild(this), t(), Eo.toastStack.querySelector("sl-alert") === null && Eo.toastStack.remove();
        },
        { once: !0 }
      );
    });
  }
  render() {
    return Jt`
      <div
        part="base"
        class=${En({
      alert: !0,
      "alert--open": this.open,
      "alert--closable": this.closable,
      "alert--has-countdown": !!this.countdown,
      "alert--has-icon": this.hasSlotController.test("icon"),
      "alert--primary": this.variant === "primary",
      "alert--success": this.variant === "success",
      "alert--neutral": this.variant === "neutral",
      "alert--warning": this.variant === "warning",
      "alert--danger": this.variant === "danger"
    })}
        role="alert"
        aria-hidden=${this.open ? "false" : "true"}
        @mouseenter=${this.pauseAutoHide}
        @mouseleave=${this.resumeAutoHide}
      >
        <div part="icon" class="alert__icon">
          <slot name="icon"></slot>
        </div>

        <div part="message" class="alert__message" aria-live="polite">
          <slot></slot>
        </div>

        ${this.closable ? Jt`
              <sl-icon-button
                part="close-button"
                exportparts="base:close-button__base"
                class="alert__close-button"
                name="x-lg"
                library="system"
                label=${this.localize.term("close")}
                @click=${this.handleCloseClick}
              ></sl-icon-button>
            ` : ""}

        <div role="timer" class="alert__timer">${this.remainingTime}</div>

        ${this.countdown ? Jt`
              <div
                class=${En({
      alert__countdown: !0,
      "alert__countdown--ltr": this.countdown === "ltr"
    })}
              >
                <div class="alert__countdown-elapsed"></div>
              </div>
            ` : ""}
      </div>
    `;
  }
};
On.styles = [zn, Foe];
On.dependencies = { "sl-icon-button": tn };
V([
  Er('[part~="base"]')
], On.prototype, "base", 2);
V([
  Er(".alert__countdown-elapsed")
], On.prototype, "countdownElement", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], On.prototype, "open", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], On.prototype, "closable", 2);
V([
  ne({ reflect: !0 })
], On.prototype, "variant", 2);
V([
  ne({ type: Number })
], On.prototype, "duration", 2);
V([
  ne({ type: String, reflect: !0 })
], On.prototype, "countdown", 2);
V([
  ou()
], On.prototype, "remainingTime", 2);
V([
  Lr("open", { waitUntilFirstUpdate: !0 })
], On.prototype, "handleOpenChange", 1);
V([
  Lr("duration")
], On.prototype, "handleDurationChange", 1);
var joe = On;
mi("alert.show", {
  keyframes: [
    { opacity: 0, scale: 0.8 },
    { opacity: 1, scale: 1 }
  ],
  options: { duration: 250, easing: "ease" }
});
mi("alert.hide", {
  keyframes: [
    { opacity: 1, scale: 1 },
    { opacity: 0, scale: 0.8 }
  ],
  options: { duration: 250, easing: "ease" }
});
joe.define("sl-alert");
var zoe = /* @__PURE__ */ re('<div class="w-full flex justify-center">');
fi("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
function g2(e) {
  return v(gc, {
    type: "error",
    header: "Unauthorized",
    get message() {
      return e.message;
    }
  });
}
const Jk = (e) => {
  const t = Ke({
    permissions: []
  }, e), r = Cn(), [n, i] = z(r?.authentication.state.isLoading || !1), [a, o] = z(r?.authentication.state.isAuthenticated || !1), [s, l] = z(r?.authentication.state.isInOrg || !1), [d, c] = z(R5(t.permissions, r?.authentication.state.permissions || []));
  le(() => {
    i(r?.authentication.state.isLoading || !1);
  }), le(() => {
    o(r?.authentication.state.isAuthenticated || !1);
  }), le(() => {
    l(r?.authentication.state.isInOrg || !1);
  }), le(() => {
    c(R5(t.permissions, r?.authentication.state.permissions || []));
  });
  const u = B(() => a() && s() && d());
  return v(q, {
    get when() {
      return r && !n();
    },
    get children() {
      return v(q, {
        get when() {
          return u();
        },
        get fallback() {
          return v(q, {
            get when() {
              return !a();
            },
            get fallback() {
              return v(q, {
                get when() {
                  return !s();
                },
                get fallback() {
                  return v(g2, {
                    message: "You are not authorized to prescribe"
                  });
                },
                get children() {
                  return v(g2, {
                    message: "You tried logging in with an account not associated with any organizations. Please check your email for an invite, or ask your administrator for assistance."
                  });
                }
              });
            },
            get children() {
              return v(q, {
                get when() {
                  return r?.autoLogin;
                },
                get fallback() {
                  return v(g2, {
                    message: "You are not signed in"
                  });
                },
                get children() {
                  var h = zoe();
                  return N(h, v(Fi, {
                    color: "green"
                  })), h;
                }
              });
            }
          });
        },
        get children() {
          return t.children;
        }
      });
    }
  });
};
function aa(e) {
  "@babel/helpers - typeof";
  return aa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, aa(e);
}
function un(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function qt(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function xr(e) {
  qt(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || aa(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Voe(e, t) {
  qt(2, arguments);
  var r = xr(e).getTime(), n = un(t);
  return new Date(r + n);
}
var Uoe = {};
function Gl() {
  return Uoe;
}
function Zk(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function w7(e) {
  qt(1, arguments);
  var t = xr(e);
  return t.setHours(0, 0, 0, 0), t;
}
var qoe = 6e4, Xk = 36e5, Boe = 1e3;
function Hoe(e, t) {
  qt(2, arguments);
  var r = w7(e), n = w7(t);
  return r.getTime() === n.getTime();
}
function Woe(e) {
  return qt(1, arguments), e instanceof Date || aa(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Koe(e) {
  if (qt(1, arguments), !Woe(e) && typeof e != "number")
    return !1;
  var t = xr(e);
  return !isNaN(Number(t));
}
function Qoe(e, t) {
  return qt(2, arguments), xr(e).getTime() - xr(t).getTime();
}
var $7 = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, Goe = "trunc";
function Yoe(e) {
  return e ? $7[e] : $7[Goe];
}
function Joe(e, t, r) {
  qt(2, arguments);
  var n = Qoe(e, t) / Xk;
  return Yoe(void 0)(n);
}
function e_(e, t) {
  qt(2, arguments);
  var r = un(t);
  return Voe(e, -r);
}
var Zoe = 864e5;
function Xoe(e) {
  qt(1, arguments);
  var t = xr(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), i = r - n;
  return Math.floor(i / Zoe) + 1;
}
function Sl(e) {
  qt(1, arguments);
  var t = 1, r = xr(e), n = r.getUTCDay(), i = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - i), r.setUTCHours(0, 0, 0, 0), r;
}
function t_(e) {
  qt(1, arguments);
  var t = xr(e), r = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var i = Sl(n), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(r, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var o = Sl(a);
  return t.getTime() >= i.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function ese(e) {
  qt(1, arguments);
  var t = t_(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = Sl(r);
  return n;
}
var tse = 6048e5;
function r_(e) {
  qt(1, arguments);
  var t = xr(e), r = Sl(t).getTime() - ese(t).getTime();
  return Math.round(r / tse) + 1;
}
function rs(e, t) {
  var r, n, i, a, o, s, l, d;
  qt(1, arguments);
  var c = Gl(), u = un((r = (n = (i = (a = t?.weekStartsOn) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : c.weekStartsOn) !== null && n !== void 0 ? n : (l = c.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(u >= 0 && u <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = xr(e), f = h.getUTCDay(), p = (f < u ? 7 : 0) + f - u;
  return h.setUTCDate(h.getUTCDate() - p), h.setUTCHours(0, 0, 0, 0), h;
}
function L3(e, t) {
  var r, n, i, a, o, s, l, d;
  qt(1, arguments);
  var c = xr(e), u = c.getUTCFullYear(), h = Gl(), f = un((r = (n = (i = (a = t?.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : h.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = h.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(f >= 1 && f <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(u + 1, 0, f), p.setUTCHours(0, 0, 0, 0);
  var m = rs(p, t), y = /* @__PURE__ */ new Date(0);
  y.setUTCFullYear(u, 0, f), y.setUTCHours(0, 0, 0, 0);
  var g = rs(y, t);
  return c.getTime() >= m.getTime() ? u + 1 : c.getTime() >= g.getTime() ? u : u - 1;
}
function rse(e, t) {
  var r, n, i, a, o, s, l, d;
  qt(1, arguments);
  var c = Gl(), u = un((r = (n = (i = (a = t?.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : c.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = c.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), h = L3(e, t), f = /* @__PURE__ */ new Date(0);
  f.setUTCFullYear(h, 0, u), f.setUTCHours(0, 0, 0, 0);
  var p = rs(f, t);
  return p;
}
var nse = 6048e5;
function n_(e, t) {
  qt(1, arguments);
  var r = xr(e), n = rs(r, t).getTime() - rse(r, t).getTime();
  return Math.round(n / nse) + 1;
}
function St(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
var wa = {
  // Year
  y: function(t, r) {
    var n = t.getUTCFullYear(), i = n > 0 ? n : 1 - n;
    return St(r === "yy" ? i % 100 : i, r.length);
  },
  // Month
  M: function(t, r) {
    var n = t.getUTCMonth();
    return r === "M" ? String(n + 1) : St(n + 1, 2);
  },
  // Day of the month
  d: function(t, r) {
    return St(t.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(t, r) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, r) {
    return St(t.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(t, r) {
    return St(t.getUTCHours(), r.length);
  },
  // Minute
  m: function(t, r) {
    return St(t.getUTCMinutes(), r.length);
  },
  // Second
  s: function(t, r) {
    return St(t.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(t, r) {
    var n = r.length, i = t.getUTCMilliseconds(), a = Math.floor(i * Math.pow(10, n - 3));
    return St(a, r.length);
  }
}, bs = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ise = {
  // Era
  G: function(t, r, n) {
    var i = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(i, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return n.era(i, {
          width: "narrow"
        });
      default:
        return n.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, r, n) {
    if (r === "yo") {
      var i = t.getUTCFullYear(), a = i > 0 ? i : 1 - i;
      return n.ordinalNumber(a, {
        unit: "year"
      });
    }
    return wa.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, n, i) {
    var a = L3(t, i), o = a > 0 ? a : 1 - a;
    if (r === "YY") {
      var s = o % 100;
      return St(s, 2);
    }
    return r === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : St(o, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    var n = t_(t);
    return St(n, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    var n = t.getUTCFullYear();
    return St(n, r.length);
  },
  // Quarter
  Q: function(t, r, n) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
        return String(i);
      // 01, 02, 03, 04
      case "QQ":
        return St(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(i, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, n) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      // 1, 2, 3, 4
      case "q":
        return String(i);
      // 01, 02, 03, 04
      case "qq":
        return St(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(i, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, n) {
    var i = t.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return wa.M(t, r);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(i + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(i, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, r, n) {
    var i = t.getUTCMonth();
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return String(i + 1);
      // 01, 02, ..., 12
      case "LL":
        return St(i + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(i + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(i, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, r, n, i) {
    var a = n_(t, i);
    return r === "wo" ? n.ordinalNumber(a, {
      unit: "week"
    }) : St(a, r.length);
  },
  // ISO week of year
  I: function(t, r, n) {
    var i = r_(t);
    return r === "Io" ? n.ordinalNumber(i, {
      unit: "week"
    }) : St(i, r.length);
  },
  // Day of the month
  d: function(t, r, n) {
    return r === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : wa.d(t, r);
  },
  // Day of year
  D: function(t, r, n) {
    var i = Xoe(t);
    return r === "Do" ? n.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : St(i, r.length);
  },
  // Day of week
  E: function(t, r, n) {
    var i = t.getUTCDay();
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, n, i) {
    var a = t.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return St(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, n, i) {
    var a = t.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return St(o, r.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, n) {
    var i = t.getUTCDay(), a = i === 0 ? 7 : i;
    switch (r) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return St(a, r.length);
      // 2nd
      case "io":
        return n.ordinalNumber(a, {
          unit: "day"
        });
      // Tue
      case "iii":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, n) {
    var i = t.getUTCHours(), a = i / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, n) {
    var i = t.getUTCHours(), a;
    switch (i === 12 ? a = bs.noon : i === 0 ? a = bs.midnight : a = i / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, n) {
    var i = t.getUTCHours(), a;
    switch (i >= 17 ? a = bs.evening : i >= 12 ? a = bs.afternoon : i >= 4 ? a = bs.morning : a = bs.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, n) {
    if (r === "ho") {
      var i = t.getUTCHours() % 12;
      return i === 0 && (i = 12), n.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return wa.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, n) {
    return r === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : wa.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, n) {
    var i = t.getUTCHours() % 12;
    return r === "Ko" ? n.ordinalNumber(i, {
      unit: "hour"
    }) : St(i, r.length);
  },
  // Hour [1-24]
  k: function(t, r, n) {
    var i = t.getUTCHours();
    return i === 0 && (i = 24), r === "ko" ? n.ordinalNumber(i, {
      unit: "hour"
    }) : St(i, r.length);
  },
  // Minute
  m: function(t, r, n) {
    return r === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : wa.m(t, r);
  },
  // Second
  s: function(t, r, n) {
    return r === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : wa.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return wa.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (r) {
      // Hours and optional minutes
      case "X":
        return _7(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return So(o);
      // Hours and minutes with `:` delimiter
      default:
        return So(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (r) {
      // Hours and optional minutes
      case "x":
        return _7(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return So(o);
      // Hours and minutes with `:` delimiter
      default:
        return So(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (r) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + k7(o, ":");
      default:
        return "GMT" + So(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (r) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + k7(o, ":");
      default:
        return "GMT" + So(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, n, i) {
    var a = i._originalDate || t, o = Math.floor(a.getTime() / 1e3);
    return St(o, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTime();
    return St(o, r.length);
  }
};
function k7(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), i = Math.floor(n / 60), a = n % 60;
  if (a === 0)
    return r + String(i);
  var o = t;
  return r + String(i) + o + St(a, 2);
}
function _7(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + St(Math.abs(e) / 60, 2);
  }
  return So(e, t);
}
function So(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", i = Math.abs(e), a = St(Math.floor(i / 60), 2), o = St(i % 60, 2);
  return n + a + r + o;
}
var x7 = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    default:
      return r.date({
        width: "full"
      });
  }
}, i_ = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    default:
      return r.time({
        width: "full"
      });
  }
}, ase = function(t, r) {
  var n = t.match(/(P+)(p+)?/) || [], i = n[1], a = n[2];
  if (!a)
    return x7(t, r);
  var o;
  switch (i) {
    case "P":
      o = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = r.dateTime({
        width: "long"
      });
      break;
    default:
      o = r.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", x7(i, r)).replace("{{time}}", i_(a, r));
}, K5 = {
  p: i_,
  P: ase
}, ose = ["D", "DD"], sse = ["YY", "YYYY"];
function a_(e) {
  return ose.indexOf(e) !== -1;
}
function o_(e) {
  return sse.indexOf(e) !== -1;
}
function C1(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var lse = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, dse = function(t, r, n) {
  var i, a = lse[t];
  return typeof a == "string" ? i = a : r === 1 ? i = a.one : i = a.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + i : i + " ago" : i;
};
function v2(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
var cse = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, use = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, hse = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, fse = {
  date: v2({
    formats: cse,
    defaultWidth: "full"
  }),
  time: v2({
    formats: use,
    defaultWidth: "full"
  }),
  dateTime: v2({
    formats: hse,
    defaultWidth: "full"
  })
}, pse = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, mse = function(t, r, n, i) {
  return pse[t];
};
function kd(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", i;
    if (n === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, o = r != null && r.width ? String(r.width) : a;
      i = e.formattingValues[o] || e.formattingValues[a];
    } else {
      var s = e.defaultWidth, l = r != null && r.width ? String(r.width) : e.defaultWidth;
      i = e.values[l] || e.values[s];
    }
    var d = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[d];
  };
}
var gse = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, vse = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, yse = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, bse = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, wse = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, $se = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, kse = function(t, r) {
  var n = Number(t), i = n % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, _se = {
  ordinalNumber: kse,
  era: kd({
    values: gse,
    defaultWidth: "wide"
  }),
  quarter: kd({
    values: vse,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: kd({
    values: yse,
    defaultWidth: "wide"
  }),
  day: kd({
    values: bse,
    defaultWidth: "wide"
  }),
  dayPeriod: kd({
    values: wse,
    defaultWidth: "wide",
    formattingValues: $se,
    defaultFormattingWidth: "wide"
  })
};
function _d(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, i = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    var o = a[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? Ese(s, function(u) {
      return u.test(o);
    }) : xse(s, function(u) {
      return u.test(o);
    }), d;
    d = e.valueCallback ? e.valueCallback(l) : l, d = r.valueCallback ? r.valueCallback(d) : d;
    var c = t.slice(o.length);
    return {
      value: d,
      rest: c
    };
  };
}
function xse(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function Ese(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function Sse(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n) return null;
    var i = n[0], a = t.match(e.parsePattern);
    if (!a) return null;
    var o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var s = t.slice(i.length);
    return {
      value: o,
      rest: s
    };
  };
}
var Cse = /^(\d+)(th|st|nd|rd)?/i, Tse = /\d+/i, Ase = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Ose = {
  any: [/^b/i, /^(a|c)/i]
}, Pse = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Ise = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Dse = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Nse = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Mse = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Rse = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Lse = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Fse = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, jse = {
  ordinalNumber: Sse({
    matchPattern: Cse,
    parsePattern: Tse,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: _d({
    matchPatterns: Ase,
    defaultMatchWidth: "wide",
    parsePatterns: Ose,
    defaultParseWidth: "any"
  }),
  quarter: _d({
    matchPatterns: Pse,
    defaultMatchWidth: "wide",
    parsePatterns: Ise,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: _d({
    matchPatterns: Dse,
    defaultMatchWidth: "wide",
    parsePatterns: Nse,
    defaultParseWidth: "any"
  }),
  day: _d({
    matchPatterns: Mse,
    defaultMatchWidth: "wide",
    parsePatterns: Rse,
    defaultParseWidth: "any"
  }),
  dayPeriod: _d({
    matchPatterns: Lse,
    defaultMatchWidth: "any",
    parsePatterns: Fse,
    defaultParseWidth: "any"
  })
}, s_ = {
  code: "en-US",
  formatDistance: dse,
  formatLong: fse,
  formatRelative: mse,
  localize: _se,
  match: jse,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, zse = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Vse = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Use = /^'([^]*?)'?$/, qse = /''/g, Bse = /[a-zA-Z]/;
function Hse(e, t, r) {
  var n, i, a, o, s, l, d, c, u, h, f, p, m, y;
  qt(2, arguments);
  var g = String(t), w = Gl(), $ = (n = (i = void 0) !== null && i !== void 0 ? i : w.locale) !== null && n !== void 0 ? n : s_, _ = un((a = (o = (s = (l = void 0) !== null && l !== void 0 ? l : void 0) !== null && s !== void 0 ? s : w.firstWeekContainsDate) !== null && o !== void 0 ? o : (d = w.locale) === null || d === void 0 || (c = d.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(_ >= 1 && _ <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var x = un((u = (h = (f = (p = void 0) !== null && p !== void 0 ? p : void 0) !== null && f !== void 0 ? f : w.weekStartsOn) !== null && h !== void 0 ? h : (m = w.locale) === null || m === void 0 || (y = m.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && u !== void 0 ? u : 0);
  if (!(x >= 0 && x <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!$.localize)
    throw new RangeError("locale must contain localize property");
  if (!$.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var S = xr(e);
  if (!Koe(S))
    throw new RangeError("Invalid time value");
  var T = Zk(S), I = e_(S, T), M = {
    firstWeekContainsDate: _,
    weekStartsOn: x,
    locale: $,
    _originalDate: S
  }, P = g.match(Vse).map(function(O) {
    var D = O[0];
    if (D === "p" || D === "P") {
      var R = K5[D];
      return R(O, $.formatLong);
    }
    return O;
  }).join("").match(zse).map(function(O) {
    if (O === "''")
      return "'";
    var D = O[0];
    if (D === "'")
      return Wse(O);
    var R = ise[D];
    if (R)
      return o_(O) && C1(O, t, String(e)), a_(O) && C1(O, t, String(e)), R(I, O, $.localize, M);
    if (D.match(Bse))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + D + "`");
    return O;
  }).join("");
  return P;
}
function Wse(e) {
  var t = e.match(Use);
  return t ? t[1].replace(qse, "'") : e;
}
function Kse(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  return e;
}
function E7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Qse(e, t) {
  if (e) {
    if (typeof e == "string") return E7(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? E7(e, t) : void 0;
  }
}
function S7(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = Qse(e)) || t) {
      r && (e = r);
      var n = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[n++]
          };
        },
        e: function(d) {
          throw d;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, o = !0, s = !1;
  return {
    s: function() {
      r = r.call(e);
    },
    n: function() {
      var d = r.next();
      return o = d.done, d;
    },
    e: function(d) {
      s = !0, a = d;
    },
    f: function() {
      try {
        o || r.return == null || r.return();
      } finally {
        if (s) throw a;
      }
    }
  };
}
function _e(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Q5(e, t) {
  return Q5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Q5(e, t);
}
function ht(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Q5(e, t);
}
function T1(e) {
  return T1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, T1(e);
}
function l_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (l_ = function() {
    return !!e;
  })();
}
function Gse(e, t) {
  if (t && (aa(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return _e(e);
}
function ft(e) {
  var t = l_();
  return function() {
    var r, n = T1(e);
    if (t) {
      var i = T1(this).constructor;
      r = Reflect.construct(n, arguments, i);
    } else r = n.apply(this, arguments);
    return Gse(this, r);
  };
}
function ot(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Yse(e, t) {
  if (aa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (aa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function d_(e) {
  var t = Yse(e, "string");
  return aa(t) == "symbol" ? t : t + "";
}
function Jse(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, d_(n.key), n);
  }
}
function st(e, t, r) {
  return t && Jse(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ve(e, t, r) {
  return (t = d_(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var Zse = 10, c_ = /* @__PURE__ */ (function() {
  function e() {
    ot(this, e), ve(this, "priority", void 0), ve(this, "subPriority", 0);
  }
  return st(e, [{
    key: "validate",
    value: function(r, n) {
      return !0;
    }
  }]), e;
})(), Xse = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r(n, i, a, o, s) {
    var l;
    return ot(this, r), l = t.call(this), l.value = n, l.validateValue = i, l.setValue = a, l.priority = o, s && (l.subPriority = s), l;
  }
  return st(r, [{
    key: "validate",
    value: function(i, a) {
      return this.validateValue(i, this.value, a);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return this.setValue(i, a, this.value, o);
    }
  }]), r;
})(c_), ele = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", Zse), ve(_e(n), "subPriority", -1), n;
  }
  return st(r, [{
    key: "set",
    value: function(i, a) {
      if (a.timestampIsSet)
        return i;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), o.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), o;
    }
  }]), r;
})(c_), yt = /* @__PURE__ */ (function() {
  function e() {
    ot(this, e), ve(this, "incompatibleTokens", void 0), ve(this, "priority", void 0), ve(this, "subPriority", void 0);
  }
  return st(e, [{
    key: "run",
    value: function(r, n, i, a) {
      var o = this.parse(r, n, i, a);
      return o ? {
        setter: new Xse(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(r, n, i) {
      return !0;
    }
  }]), e;
})(), tle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 140), ve(_e(n), "incompatibleTokens", ["R", "u", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return o.era(i, {
            width: "abbreviated"
          }) || o.era(i, {
            width: "narrow"
          });
        // A, B
        case "GGGGG":
          return o.era(i, {
            width: "narrow"
          });
        default:
          return o.era(i, {
            width: "wide"
          }) || o.era(i, {
            width: "abbreviated"
          }) || o.era(i, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.era = o, i.setUTCFullYear(o, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(yt), or = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, _i = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function sr(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Zt(e, t) {
  var r = t.match(e);
  return r ? {
    value: parseInt(r[0], 10),
    rest: t.slice(r[0].length)
  } : null;
}
function xi(e, t) {
  var r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var n = r[1] === "+" ? 1 : -1, i = r[2] ? parseInt(r[2], 10) : 0, a = r[3] ? parseInt(r[3], 10) : 0, o = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: n * (i * Xk + a * qoe + o * Boe),
    rest: t.slice(r[0].length)
  };
}
function u_(e) {
  return Zt(or.anyDigitsSigned, e);
}
function ir(e, t) {
  switch (e) {
    case 1:
      return Zt(or.singleDigit, t);
    case 2:
      return Zt(or.twoDigits, t);
    case 3:
      return Zt(or.threeDigits, t);
    case 4:
      return Zt(or.fourDigits, t);
    default:
      return Zt(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function A1(e, t) {
  switch (e) {
    case 1:
      return Zt(or.singleDigitSigned, t);
    case 2:
      return Zt(or.twoDigitsSigned, t);
    case 3:
      return Zt(or.threeDigitsSigned, t);
    case 4:
      return Zt(or.fourDigitsSigned, t);
    default:
      return Zt(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function F3(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    default:
      return 0;
  }
}
function h_(e, t) {
  var r = t > 0, n = r ? t : 1 - t, i;
  if (n <= 50)
    i = e || 100;
  else {
    var a = n + 50, o = Math.floor(a / 100) * 100, s = e >= a % 100;
    i = e + o - (s ? 100 : 0);
  }
  return r ? i : 1 - i;
}
function f_(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var rle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 130), ve(_e(n), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return {
          year: d,
          isTwoDigitYear: a === "yy"
        };
      };
      switch (a) {
        case "y":
          return sr(ir(4, i), s);
        case "yo":
          return sr(o.ordinalNumber(i, {
            unit: "year"
          }), s);
        default:
          return sr(ir(a.length, i), s);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = i.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var l = h_(o.year, s);
        return i.setUTCFullYear(l, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
      }
      var d = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
      return i.setUTCFullYear(d, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(yt), nle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 130), ve(_e(n), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return {
          year: d,
          isTwoDigitYear: a === "YY"
        };
      };
      switch (a) {
        case "Y":
          return sr(ir(4, i), s);
        case "Yo":
          return sr(o.ordinalNumber(i, {
            unit: "year"
          }), s);
        default:
          return sr(ir(a.length, i), s);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      var l = L3(i, s);
      if (o.isTwoDigitYear) {
        var d = h_(o.year, l);
        return i.setUTCFullYear(d, 0, s.firstWeekContainsDate), i.setUTCHours(0, 0, 0, 0), rs(i, s);
      }
      var c = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
      return i.setUTCFullYear(c, 0, s.firstWeekContainsDate), i.setUTCHours(0, 0, 0, 0), rs(i, s);
    }
  }]), r;
})(yt), ile = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 130), ve(_e(n), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a) {
      return A1(a === "R" ? 4 : a.length, i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(o, 0, 4), s.setUTCHours(0, 0, 0, 0), Sl(s);
    }
  }]), r;
})(yt), ale = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 130), ve(_e(n), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a) {
      return A1(a === "u" ? 4 : a.length, i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCFullYear(o, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(yt), ole = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 120), ve(_e(n), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        // 1, 2, 3, 4
        case "Q":
        case "QQ":
          return ir(a.length, i);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return o.ordinalNumber(i, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return o.quarter(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return o.quarter(i, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth((o - 1) * 3, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(yt), sle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 120), ve(_e(n), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        // 1, 2, 3, 4
        case "q":
        case "qq":
          return ir(a.length, i);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return o.ordinalNumber(i, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return o.quarter(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
        default:
          return o.quarter(i, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth((o - 1) * 3, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(yt), lle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), ve(_e(n), "priority", 110), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return d - 1;
      };
      switch (a) {
        // 1, 2, ..., 12
        case "M":
          return sr(Zt(or.month, i), s);
        // 01, 02, ..., 12
        case "MM":
          return sr(ir(2, i), s);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return sr(o.ordinalNumber(i, {
            unit: "month"
          }), s);
        // Jan, Feb, ..., Dec
        case "MMM":
          return o.month(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(i, {
            width: "narrow",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return o.month(i, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return o.month(i, {
            width: "wide",
            context: "formatting"
          }) || o.month(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(o, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(yt), dle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 110), ve(_e(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return d - 1;
      };
      switch (a) {
        // 1, 2, ..., 12
        case "L":
          return sr(Zt(or.month, i), s);
        // 01, 02, ..., 12
        case "LL":
          return sr(ir(2, i), s);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return sr(o.ordinalNumber(i, {
            unit: "month"
          }), s);
        // Jan, Feb, ..., Dec
        case "LLL":
          return o.month(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(i, {
            width: "narrow",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return o.month(i, {
            width: "narrow",
            context: "standalone"
          });
        default:
          return o.month(i, {
            width: "wide",
            context: "standalone"
          }) || o.month(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(o, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(yt);
function cle(e, t, r) {
  qt(2, arguments);
  var n = xr(e), i = un(t), a = n_(n, r) - i;
  return n.setUTCDate(n.getUTCDate() - a * 7), n;
}
var ule = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 100), ve(_e(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "w":
          return Zt(or.week, i);
        case "wo":
          return o.ordinalNumber(i, {
            unit: "week"
          });
        default:
          return ir(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return rs(cle(i, o, s), s);
    }
  }]), r;
})(yt);
function hle(e, t) {
  qt(2, arguments);
  var r = xr(e), n = un(t), i = r_(r) - n;
  return r.setUTCDate(r.getUTCDate() - i * 7), r;
}
var fle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 100), ve(_e(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "I":
          return Zt(or.week, i);
        case "Io":
          return o.ordinalNumber(i, {
            unit: "week"
          });
        default:
          return ir(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return Sl(hle(i, o));
    }
  }]), r;
})(yt), ple = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], mle = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], gle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 90), ve(_e(n), "subPriority", 1), ve(_e(n), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "d":
          return Zt(or.date, i);
        case "do":
          return o.ordinalNumber(i, {
            unit: "date"
          });
        default:
          return ir(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      var o = i.getUTCFullYear(), s = f_(o), l = i.getUTCMonth();
      return s ? a >= 1 && a <= mle[l] : a >= 1 && a <= ple[l];
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCDate(o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(yt), vle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 90), ve(_e(n), "subpriority", 1), ve(_e(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "D":
        case "DD":
          return Zt(or.dayOfYear, i);
        case "Do":
          return o.ordinalNumber(i, {
            unit: "date"
          });
        default:
          return ir(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      var o = i.getUTCFullYear(), s = f_(o);
      return s ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(0, o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(yt);
function j3(e, t, r) {
  var n, i, a, o, s, l, d, c;
  qt(2, arguments);
  var u = Gl(), h = un((n = (i = (a = (o = r?.weekStartsOn) !== null && o !== void 0 ? o : r == null || (s = r.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && i !== void 0 ? i : (d = u.locale) === null || d === void 0 || (c = d.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = xr(e), p = un(t), m = f.getUTCDay(), y = p % 7, g = (y + 7) % 7, w = (g < h ? 7 : 0) + p - m;
  return f.setUTCDate(f.getUTCDate() + w), f;
}
var yle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 90), ve(_e(n), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return i = j3(i, o, s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(yt), ble = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 90), ve(_e(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o, s) {
      var l = function(c) {
        var u = Math.floor((c - 1) / 7) * 7;
        return (c + s.weekStartsOn + 6) % 7 + u;
      };
      switch (a) {
        // 3
        case "e":
        case "ee":
          return sr(ir(a.length, i), l);
        // 3rd
        case "eo":
          return sr(o.ordinalNumber(i, {
            unit: "day"
          }), l);
        // Tue
        case "eee":
          return o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "eeeee":
          return o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return i = j3(i, o, s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(yt), wle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 90), ve(_e(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o, s) {
      var l = function(c) {
        var u = Math.floor((c - 1) / 7) * 7;
        return (c + s.weekStartsOn + 6) % 7 + u;
      };
      switch (a) {
        // 3
        case "c":
        case "cc":
          return sr(ir(a.length, i), l);
        // 3rd
        case "co":
          return sr(o.ordinalNumber(i, {
            unit: "day"
          }), l);
        // Tue
        case "ccc":
          return o.day(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        // T
        case "ccccc":
          return o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        default:
          return o.day(i, {
            width: "wide",
            context: "standalone"
          }) || o.day(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return i = j3(i, o, s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(yt);
function $le(e, t) {
  qt(2, arguments);
  var r = un(t);
  r % 7 === 0 && (r = r - 7);
  var n = 1, i = xr(e), a = i.getUTCDay(), o = r % 7, s = (o + 7) % 7, l = (s < n ? 7 : 0) + r - a;
  return i.setUTCDate(i.getUTCDate() + l), i;
}
var kle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 90), ve(_e(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return d === 0 ? 7 : d;
      };
      switch (a) {
        // 2
        case "i":
        case "ii":
          return ir(a.length, i);
        // 2nd
        case "io":
          return o.ordinalNumber(i, {
            unit: "day"
          });
        // Tue
        case "iii":
          return sr(o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
        // T
        case "iiiii":
          return sr(o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
        // Tu
        case "iiiiii":
          return sr(o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
        default:
          return sr(o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 7;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i = $le(i, o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(yt), _le = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 80), ve(_e(n), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(F3(o), 0, 0, 0), i;
    }
  }]), r;
})(yt), xle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 80), ve(_e(n), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(F3(o), 0, 0, 0), i;
    }
  }]), r;
})(yt), Ele = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 80), ve(_e(n), "incompatibleTokens", ["a", "b", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(F3(o), 0, 0, 0), i;
    }
  }]), r;
})(yt), Sle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 70), ve(_e(n), "incompatibleTokens", ["H", "K", "k", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "h":
          return Zt(or.hour12h, i);
        case "ho":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return ir(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 12;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = i.getUTCHours() >= 12;
      return s && o < 12 ? i.setUTCHours(o + 12, 0, 0, 0) : !s && o === 12 ? i.setUTCHours(0, 0, 0, 0) : i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), r;
})(yt), Cle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 70), ve(_e(n), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "H":
          return Zt(or.hour23h, i);
        case "Ho":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return ir(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 23;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), r;
})(yt), Tle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 70), ve(_e(n), "incompatibleTokens", ["h", "H", "k", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "K":
          return Zt(or.hour11h, i);
        case "Ko":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return ir(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = i.getUTCHours() >= 12;
      return s && o < 12 ? i.setUTCHours(o + 12, 0, 0, 0) : i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), r;
})(yt), Ale = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 70), ve(_e(n), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "k":
          return Zt(or.hour24h, i);
        case "ko":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return ir(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 24;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = o <= 24 ? o % 24 : o;
      return i.setUTCHours(s, 0, 0, 0), i;
    }
  }]), r;
})(yt), Ole = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 60), ve(_e(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "m":
          return Zt(or.minute, i);
        case "mo":
          return o.ordinalNumber(i, {
            unit: "minute"
          });
        default:
          return ir(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMinutes(o, 0, 0), i;
    }
  }]), r;
})(yt), Ple = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 50), ve(_e(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "s":
          return Zt(or.second, i);
        case "so":
          return o.ordinalNumber(i, {
            unit: "second"
          });
        default:
          return ir(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCSeconds(o, 0), i;
    }
  }]), r;
})(yt), Ile = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 30), ve(_e(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a) {
      var o = function(l) {
        return Math.floor(l * Math.pow(10, -a.length + 3));
      };
      return sr(ir(a.length, i), o);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMilliseconds(o), i;
    }
  }]), r;
})(yt), Dle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 10), ve(_e(n), "incompatibleTokens", ["t", "T", "x"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a) {
      switch (a) {
        case "X":
          return xi(_i.basicOptionalMinutes, i);
        case "XX":
          return xi(_i.basic, i);
        case "XXXX":
          return xi(_i.basicOptionalSeconds, i);
        case "XXXXX":
          return xi(_i.extendedOptionalSeconds, i);
        default:
          return xi(_i.extended, i);
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.timestampIsSet ? i : new Date(i.getTime() - o);
    }
  }]), r;
})(yt), Nle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 10), ve(_e(n), "incompatibleTokens", ["t", "T", "X"]), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i, a) {
      switch (a) {
        case "x":
          return xi(_i.basicOptionalMinutes, i);
        case "xx":
          return xi(_i.basic, i);
        case "xxxx":
          return xi(_i.basicOptionalSeconds, i);
        case "xxxxx":
          return xi(_i.extendedOptionalSeconds, i);
        default:
          return xi(_i.extended, i);
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.timestampIsSet ? i : new Date(i.getTime() - o);
    }
  }]), r;
})(yt), Mle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 40), ve(_e(n), "incompatibleTokens", "*"), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i) {
      return u_(i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), r;
})(yt), Rle = /* @__PURE__ */ (function(e) {
  ht(r, e);
  var t = ft(r);
  function r() {
    var n;
    ot(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), ve(_e(n), "priority", 20), ve(_e(n), "incompatibleTokens", "*"), n;
  }
  return st(r, [{
    key: "parse",
    value: function(i) {
      return u_(i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), r;
})(yt), Lle = {
  G: new tle(),
  y: new rle(),
  Y: new nle(),
  R: new ile(),
  u: new ale(),
  Q: new ole(),
  q: new sle(),
  M: new lle(),
  L: new dle(),
  w: new ule(),
  I: new fle(),
  d: new gle(),
  D: new vle(),
  E: new yle(),
  e: new ble(),
  c: new wle(),
  i: new kle(),
  a: new _le(),
  b: new xle(),
  B: new Ele(),
  h: new Sle(),
  H: new Cle(),
  K: new Tle(),
  k: new Ale(),
  m: new Ole(),
  s: new Ple(),
  S: new Ile(),
  X: new Dle(),
  x: new Nle(),
  t: new Mle(),
  T: new Rle()
}, Fle = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, jle = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, zle = /^'([^]*?)'?$/, Vle = /''/g, Ule = /\S/, qle = /[a-zA-Z]/;
function Ble(e, t, r, n) {
  var i, a, o, s, l, d, c, u, h, f, p, m, y, g;
  qt(3, arguments);
  var w = String(e), $ = String(t), _ = Gl(), x = (i = (a = void 0) !== null && a !== void 0 ? a : _.locale) !== null && i !== void 0 ? i : s_;
  if (!x.match)
    throw new RangeError("locale must contain match property");
  var S = un((o = (s = (l = (d = void 0) !== null && d !== void 0 ? d : void 0) !== null && l !== void 0 ? l : _.firstWeekContainsDate) !== null && s !== void 0 ? s : (c = _.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(S >= 1 && S <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var T = un((h = (f = (p = (m = void 0) !== null && m !== void 0 ? m : void 0) !== null && p !== void 0 ? p : _.weekStartsOn) !== null && f !== void 0 ? f : (y = _.locale) === null || y === void 0 || (g = y.options) === null || g === void 0 ? void 0 : g.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(T >= 0 && T <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if ($ === "")
    return w === "" ? xr(r) : /* @__PURE__ */ new Date(NaN);
  var I = {
    firstWeekContainsDate: S,
    weekStartsOn: T,
    locale: x
  }, M = [new ele()], P = $.match(jle).map(function(K) {
    var oe = K[0];
    if (oe in K5) {
      var ae = K5[oe];
      return ae(K, x.formatLong);
    }
    return K;
  }).join("").match(Fle), O = [], D = S7(P), R;
  try {
    var L = function() {
      var oe = R.value;
      !(n != null && n.useAdditionalWeekYearTokens) && o_(oe) && C1(oe, $, e), !(n != null && n.useAdditionalDayOfYearTokens) && a_(oe) && C1(oe, $, e);
      var ae = oe[0], Me = Lle[ae];
      if (Me) {
        var We = Me.incompatibleTokens;
        if (Array.isArray(We)) {
          var Dt = O.find(function(zt) {
            return We.includes(zt.token) || zt.token === ae;
          });
          if (Dt)
            throw new RangeError("The format string mustn't contain `".concat(Dt.fullToken, "` and `").concat(oe, "` at the same time"));
        } else if (Me.incompatibleTokens === "*" && O.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(oe, "` and any other token at the same time"));
        O.push({
          token: ae,
          fullToken: oe
        });
        var vt = Me.run(w, oe, x.match, I);
        if (!vt)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        M.push(vt.setter), w = vt.rest;
      } else {
        if (ae.match(qle))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + ae + "`");
        if (oe === "''" ? oe = "'" : ae === "'" && (oe = Hle(oe)), w.indexOf(oe) === 0)
          w = w.slice(oe.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (D.s(); !(R = D.n()).done; ) {
      var Q = L();
      if (aa(Q) === "object") return Q.v;
    }
  } catch (K) {
    D.e(K);
  } finally {
    D.f();
  }
  if (w.length > 0 && Ule.test(w))
    return /* @__PURE__ */ new Date(NaN);
  var ie = M.map(function(K) {
    return K.priority;
  }).sort(function(K, oe) {
    return oe - K;
  }).filter(function(K, oe, ae) {
    return ae.indexOf(K) === oe;
  }).map(function(K) {
    return M.filter(function(oe) {
      return oe.priority === K;
    }).sort(function(oe, ae) {
      return ae.subPriority - oe.subPriority;
    });
  }).map(function(K) {
    return K[0];
  }), ee = xr(r);
  if (isNaN(ee.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var W = e_(ee, Zk(ee)), H = {}, pe = S7(ie), Te;
  try {
    for (pe.s(); !(Te = pe.n()).done; ) {
      var Ce = Te.value;
      if (!Ce.validate(W, I))
        return /* @__PURE__ */ new Date(NaN);
      var de = Ce.set(W, H, I);
      Array.isArray(de) ? (W = de[0], Kse(H, de[1])) : W = de;
    }
  } catch (K) {
    pe.e(K);
  } finally {
    pe.f();
  }
  return W;
}
function Hle(e) {
  return e.match(zle)[1].replace(Vle, "'");
}
function Wle(e) {
  return qt(1, arguments), Hoe(e, Date.now());
}
const br = (e, t) => ls("message", (r) => Kk(r, e) ? !0 : t), Kle = (e, t, r = !0) => ls("between", function(i) {
  return typeof i == "number" && (r ? i >= e && i <= t : i > e && i < t);
}), Qle = ls("NotFutureDate", (e) => {
  const t = new Date(e);
  return t instanceof Date ? t <= /* @__PURE__ */ new Date() : !1;
}), Gle = (e, t = (r) => Ble(r, T$, /* @__PURE__ */ new Date())) => ls("between", function(n) {
  return Joe(t(n), e) >= 0 || Wle(t(n));
}), Yle = () => Ql(bn(), "zipString", (e) => /^\d{5}(-\d{4})?$/.test(e)), Jle = () => Ql(bn(), "email", (e) => e.length === 0 ? !0 : /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(e)), Zle = () => Ql(kh(), "empty", (e) => e === null || e == null), S0 = (e, t) => {
  e.updateFormValue({
    key: "treatment",
    value: void 0
  }), e.updateFormValue({
    key: "dispenseAsWritten",
    value: !1
  }), e.updateFormValue({
    key: "dispenseQuantity",
    value: void 0
  }), e.updateFormValue({
    key: "dispenseUnit",
    value: void 0
  }), e.updateFormValue({
    key: "daysSupply",
    value: void 0
  }), e.updateFormValue({
    key: "refills",
    value: void 0
  }), e.updateFormValue({
    key: "instructions",
    value: ""
  }), e.updateFormValue({
    key: "notes",
    value: t?.notes ?? ""
  }), e.updateFormValue({
    key: "addToTemplates",
    value: !1
  });
}, p_ = (e, t) => {
  if (e.updateFormValue({
    key: "treatment",
    value: t.treatment
  }), t.dispenseAsWritten && e.updateFormValue({
    key: "dispenseAsWritten",
    value: t.dispenseAsWritten
  }), t.dispenseQuantity && e.updateFormValue({
    key: "dispenseQuantity",
    value: Number(t.dispenseQuantity)
  }), t.dispenseUnit && e.updateFormValue({
    key: "dispenseUnit",
    value: t.dispenseUnit
  }), t.daysSupply && e.updateFormValue({
    key: "daysSupply",
    value: Number(t.daysSupply)
  }), t.fillsAllowed !== void 0 && t.fillsAllowed !== null) {
    const r = Number(t.fillsAllowed);
    e.updateFormValue({
      key: "refills",
      value: r > 0 ? r - 1 : 0
    });
  }
  t.instructions && e.updateFormValue({
    key: "instructions",
    value: t.instructions
  }), t.notes && e.updateFormValue({
    key: "notes",
    value: t.notes
  }), t.doNotFillBeforeDate && e.updateFormValue({
    key: "doNotFillBeforeDate",
    value: t.doNotFillBeforeDate
  });
};
var Xle = /* @__PURE__ */ re('<div class="flex-1 mt-2">'), ede = /* @__PURE__ */ re('<div class="flex flex-col gap-1"><photon-medication-search label="Search for Treatment"></photon-medication-search><div class=mt-2></div><div class="sm:grid sm:grid-cols-2 sm:gap-4 mt-2"><div class="flex items-start gap-1"><div class=flex-1></div></div></div><div class="sm:grid sm:grid-cols-2 sm:gap-4"></div><div class="flex flex-col xs:flex-row mt-4"><div class="flex flex-grow justify-end">', !0, !1, !1);
const C7 = {
  treatment: br(R3(bn(), kh()), "Please select a treatment"),
  dispenseQuantity: br(v7(g7(), 0, {
    exclusive: !0
  }), "Quantity must be positive"),
  dispenseUnit: br(Ql(bn(), "nonEmptyString", (e) => e.trim().length > 0), "Please select a dispensing unit"),
  daysSupply: br(v7(g7(), 0), "Days Supply must be at least 0"),
  refills: br(Kle(0, 11), "Refills must be 0 to 11"),
  instructions: br(xo(bn(), 1, 1 / 0), "Please enter instructions for the patient"),
  doNotFillBeforeDate: br(Ioe(Gle(/* @__PURE__ */ new Date())), "Please choose a date that isn't in the past")
}, tde = (e) => {
  const {
    tryCreatePrescription: t
  } = Ul(), {
    dispatchOrderError: r,
    dispatchAnalytics: n
  } = ca(), [i, a] = z(void 0), [o, s] = z(!1), [l, d] = z(""), [c, u] = z(!1);
  Ht(() => {
    for (const [f, p] of Object.entries(C7))
      e.actions.registerValidator({
        key: f,
        validator: p
      });
    S0(e.actions, e?.prefillNotes ? {
      notes: e.prefillNotes
    } : void 0);
  });
  const h = async () => {
    u(!0);
    const f = Object.keys(C7);
    if (e.actions.validate(f), e.actions.hasErrors(f)) {
      u(!1), Yt({
        status: "error",
        body: "Some items in the form are incomplete, please check for errors"
      });
      return;
    }
    const m = {
      doNotFillBeforeDate: e.store.doNotFillBeforeDate?.value,
      treatment: {
        id: e.store.treatment.value.id,
        name: e.store.treatment.value.name
      },
      dispenseAsWritten: e.store.dispenseAsWritten.value,
      dispenseQuantity: e.store.dispenseQuantity.value,
      dispenseUnit: e.store.dispenseUnit.value,
      daysSupply: e.store.daysSupply.value,
      instructions: e.store.instructions.value,
      notes: e.store.notes.value,
      fillsAllowed: e.store.refills.value + 1,
      // TODO: set this from template-overrides. can we stop using the props.store, with this param as a starting point?
      diagnoseCodes: []
    };
    let y = null;
    try {
      const g = {
        addToTemplates: e.store.addToTemplates?.value ?? !1,
        templateName: e.store.templateName?.value,
        catalogId: e.store.catalogId?.value,
        showSuccessToast: !0
      };
      y = await t(m, g), y && e.onDraftPrescriptionCreated();
    } catch (g) {
      r([g]);
    } finally {
      u(!1);
    }
    y && (e.screenDraftedPrescriptions(), e.actions.clearKeys(["treatment", "dispenseAsWritten", "dispenseQuantity", "dispenseUnit", "daysSupply", "refills", "instructions", "notes", "templateName", "addToTemplates", "doNotFillBeforeDate"]), a(void 0), S0(e.actions, e.prefillNotes ? {
      notes: e.prefillNotes
    } : void 0), d(""));
  };
  return le(() => {
    e.store.treatment?.value && d(e.store.treatment.value.name);
  }), v(Sn, {
    addChildrenDivider: !0,
    get children() {
      return [v(ke, {
        color: "gray",
        children: "Add Prescription"
      }), (() => {
        var f = ede(), p = f.firstChild, m = p.nextSibling, y = m.nextSibling, g = y.firstChild, w = g.firstChild, $ = y.nextSibling, _ = $.nextSibling, x = _.firstChild;
        return Oe(p, "photon-search-text-changed", (S) => d(S.detail.text)), Oe(p, "photon-treatment-unselected", () => {
          S0(e.actions, e?.prefillNotes ? {
            notes: e.prefillNotes
          } : void 0), e.draftedPrescriptionChanged();
        }), Oe(p, "photon-treatment-selected", (S) => {
          S.detail.data.__typename === "PrescriptionTemplate" ? p_(e.actions, {
            ...S.detail.data,
            notes: [S.detail.data?.notes, e.prefillNotes].filter((T) => T).join(`

`)
          }) : e.actions.updateFormValue({
            key: "treatment",
            value: S.detail.data
          }), n({
            trackEventType: "prescription_field_interaction",
            properties: {
              fieldName: "treatment",
              hasValue: !0
            }
          }), S.detail.catalogId && e.actions.updateFormValue({
            key: "catalogId",
            value: S.detail.catalogId
          }), e.draftedPrescriptionChanged();
        }), p._$owner = Pe(), N(f, v(
          L$,
          {
            get screeningAlerts() {
              return e.screeningAlerts.filter((S) => S.involvedEntities.map((T) => T.id).indexOf(e.store.treatment?.value?.id) >= 0);
            },
            get owningId() {
              return e.store.treatment?.value?.id;
            }
          }
        ), m), N(m, v(Bp, {
          mainText: "Dispense as written",
          tooltip: "This prescription will be filled generically unless this box is checked",
          showOptionalSubtext: !0,
          get checked() {
            return e.store.dispenseAsWritten?.value || !1;
          },
          onChange: (S) => {
            e.actions.updateFormValue({
              key: "dispenseAsWritten",
              value: S
            }), n({
              trackEventType: "prescription_field_interaction",
              properties: {
                fieldName: "dispenseAsWritten",
                hasValue: S
              }
            });
          }
        })), w.style.setProperty("width", "100px"), N(w, v(Ye, {
          label: "Quantity",
          required: !0,
          get error() {
            return e.store.dispenseQuantity?.error;
          },
          get children() {
            return v(Tt, {
              type: "number",
              inputMode: "decimal",
              get value() {
                return e.store.dispenseQuantity?.value ?? void 0;
              },
              min: 0,
              onInput: (S) => {
                e.actions.updateFormValue({
                  key: "dispenseQuantity",
                  value: Number(S.currentTarget.value)
                });
              },
              onBlur: (S) => {
                n({
                  trackEventType: "prescription_field_interaction",
                  properties: {
                    fieldName: "dispenseQuantity",
                    hasValue: !!S.currentTarget.value
                  }
                });
              }
            });
          }
        })), N(g, v(Ye, {
          label: " ",
          get children() {
            return v(ct, {
              variant: "secondary",
              class: "w-11 h-11 sm:h-12",
              onClick: () => s(!0),
              get children() {
                return v(et, {
                  name: "calculator",
                  size: "sm"
                });
              }
            });
          }
        }), null), N(y, v(Ye, {
          label: "Dispense Unit",
          required: !0,
          get error() {
            return e.store.dispenseUnit?.error;
          },
          get children() {
            return v(bW, {
              get value() {
                return e.store.dispenseUnit?.value ?? void 0;
              },
              onChange: (S) => {
                e.actions.updateFormValue({
                  key: "dispenseUnit",
                  value: S.currentTarget.value
                });
              },
              onBlur: (S) => {
                n({
                  trackEventType: "prescription_field_interaction",
                  properties: {
                    fieldName: "dispenseUnit",
                    hasValue: !!S.currentTarget.value
                  }
                });
              }
            });
          }
        }), null), N(f, v(SY, {
          get open() {
            return o();
          },
          onClose: () => s(!1),
          get medicationName() {
            return e.store.treatment?.value?.name;
          },
          get weight() {
            return e.weight;
          },
          get weightUnit() {
            return e.weightUnit;
          },
          setAutocompleteValues: ({
            liquidDose: S,
            totalLiquid: T,
            unit: I,
            days: M
          }) => {
            e.actions.updateFormValue({
              key: "daysSupply",
              value: Number(M)
            }), e.actions.updateFormValue({
              key: "dispenseQuantity",
              value: Number(T)
            }), e.actions.updateFormValue({
              key: "instructions",
              value: `${S} ${I} ${e.store.instructions?.value}`
            }), I === "mL" && e.actions.updateFormValue({
              key: "dispenseUnit",
              value: "Milliliter"
            });
          }
        }), $), N($, v(Ye, {
          label: "Days Supply",
          required: !0,
          get error() {
            return e.store.daysSupply?.error;
          },
          get children() {
            return v(Tt, {
              type: "number",
              inputMode: "numeric",
              get value() {
                return e.store.daysSupply?.value ?? void 0;
              },
              min: 0,
              onInput: (S) => {
                e.actions.updateFormValue({
                  key: "daysSupply",
                  value: Number(S.currentTarget.value)
                });
              },
              onBlur: (S) => {
                n({
                  trackEventType: "prescription_field_interaction",
                  properties: {
                    fieldName: "daysSupply",
                    hasValue: !!S.currentTarget.value
                  }
                });
              }
            });
          }
        }), null), N($, v(Ye, {
          label: "Refills",
          required: !0,
          get error() {
            return e.store.refills?.error;
          },
          get children() {
            return v(Tt, {
              type: "number",
              inputMode: "numeric",
              get value() {
                return e.store.refills?.value ?? void 0;
              },
              min: 0,
              max: 11,
              onInput: (S) => {
                e.actions.updateFormValue({
                  key: "refills",
                  value: Number(S.currentTarget.value)
                });
              },
              onBlur: (S) => {
                n({
                  trackEventType: "prescription_field_interaction",
                  properties: {
                    fieldName: "refills",
                    hasValue: !!S.currentTarget.value
                  }
                });
              }
            });
          }
        }), null), N(f, v(Ye, {
          label: "Patient Instructions (SIG)",
          required: !0,
          get error() {
            return e.store.instructions?.error;
          },
          get children() {
            return v(y5, {
              placeholder: "Enter patient instructions",
              get value() {
                return e.store.instructions?.value;
              },
              onInput: (S) => {
                e.actions.updateFormValue({
                  key: "instructions",
                  value: S
                });
              },
              onBlur: (S) => {
                n({
                  trackEventType: "prescription_field_interaction",
                  properties: {
                    fieldName: "instructions",
                    hasValue: !!S
                  }
                });
              }
            });
          }
        }), _), N(f, v(Ye, {
          label: "Pharmacy Note",
          showOptionalSubtext: !0,
          get children() {
            return v(y5, {
              placeholder: "Enter pharmacy note",
              get value() {
                return e.store.notes?.value;
              },
              onInput: (S) => {
                e.actions.updateFormValue({
                  key: "notes",
                  value: S
                });
              },
              onBlur: (S) => {
                n({
                  trackEventType: "prescription_field_interaction",
                  properties: {
                    fieldName: "pharmacy_notes",
                    hasValue: !!S
                  }
                });
              }
            });
          }
        }), _), N(f, v(Ye, {
          label: "Do Not Fill Before",
          showOptionalSubtext: !0,
          get error() {
            return e.store.doNotFillBeforeDate?.error;
          },
          get children() {
            return v(Tt, {
              type: "date",
              get value() {
                return e.store.doNotFillBeforeDate?.value;
              },
              get min() {
                return Hse(/* @__PURE__ */ new Date(), T$);
              },
              onInput: (S) => {
                e.actions.updateFormValue({
                  key: "doNotFillBeforeDate",
                  value: S.currentTarget.value || void 0
                });
              },
              onBlur: (S) => {
                n({
                  trackEventType: "prescription_field_interaction",
                  properties: {
                    fieldName: "doNotFillBeforeDate",
                    hasValue: !!S.currentTarget.value
                  }
                });
              }
            });
          }
        }), _), N(_, v(q, {
          get when() {
            return !e.hideAddToTemplates;
          },
          get children() {
            return v(Bp, {
              mainText: "Add To Personal Templates",
              showOptionalSubtext: !0,
              get checked() {
                return e.store.addToTemplates?.value || !1;
              },
              onChange: (S) => {
                e.actions.updateFormValue({
                  key: "addToTemplates",
                  value: S
                }), n({
                  trackEventType: "prescription_field_interaction",
                  properties: {
                    fieldName: "addToTemplates",
                    hasValue: S
                  }
                });
              }
            });
          }
        }), x), N(_, v(q, {
          get when() {
            return e.store.addToTemplates?.value ?? !1;
          },
          get children() {
            var S = Xle();
            return N(S, v(Ye, {
              label: "Template Name",
              get error() {
                return e.store.templateName?.error;
              },
              get children() {
                return v(Tt, {
                  get value() {
                    return e.store.templateName?.value ?? "";
                  },
                  onInput: (T) => e.actions.updateFormValue({
                    key: "templateName",
                    value: T.currentTarget.value
                  })
                });
              }
            })), S;
          }
        }), x), N(x, v(ct, {
          class: "w-full xs:!w-auto h-fit mt-6",
          size: "lg",
          onClick: () => {
            c() || h();
          },
          get loading() {
            return c();
          },
          variant: "primary",
          color: "blue",
          children: "Add to drafts"
        })), te((S) => {
          var T = e.catalogId, I = e.allowOffCatalogSearch, M = e.store.treatment?.value ?? void 0, P = e.store.treatment?.error ?? !1, O = e.store.treatment?.error, D = i(), R = l(), L = e.disableList;
          return T !== S.e && (p.catalogId = S.e = T), I !== S.t && (p.allowOffCatalogSearch = S.t = I), M !== S.a && (p.selected = S.a = M), P !== S.o && (p.invalid = S.o = P), O !== S.i && (p.helpText = S.i = O), D !== S.n && (p.offCatalogOption = S.n = D), R !== S.s && (p.searchText = S.s = R), L !== S.h && (p.disableList = S.h = L), S;
        }, {
          e: void 0,
          t: void 0,
          a: void 0,
          o: void 0,
          i: void 0,
          n: void 0,
          s: void 0,
          h: void 0
        }), f;
      })()];
    }
  });
};
var rde = hn`
  :host {
    --max-width: 20rem;
    --hide-delay: 0ms;
    --show-delay: 150ms;

    display: contents;
  }

  .tooltip {
    --arrow-size: var(--sl-tooltip-arrow-size);
    --arrow-color: var(--sl-tooltip-background-color);
  }

  .tooltip::part(popup) {
    z-index: var(--sl-z-index-tooltip);
  }

  .tooltip[placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .tooltip[placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .tooltip[placement^='left']::part(popup) {
    transform-origin: right;
  }

  .tooltip[placement^='right']::part(popup) {
    transform-origin: left;
  }

  .tooltip__body {
    display: block;
    width: max-content;
    max-width: var(--max-width);
    border-radius: var(--sl-tooltip-border-radius);
    background-color: var(--sl-tooltip-background-color);
    font-family: var(--sl-tooltip-font-family);
    font-size: var(--sl-tooltip-font-size);
    font-weight: var(--sl-tooltip-font-weight);
    line-height: var(--sl-tooltip-line-height);
    text-align: start;
    white-space: normal;
    color: var(--sl-tooltip-color);
    padding: var(--sl-tooltip-padding);
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
  }
`, Fr = class extends Br {
  constructor() {
    super(), this.localize = new ro(this), this.content = "", this.placement = "top", this.disabled = !1, this.distance = 8, this.open = !1, this.skidding = 0, this.trigger = "hover focus", this.hoist = !1, this.handleBlur = () => {
      this.hasTrigger("focus") && this.hide();
    }, this.handleClick = () => {
      this.hasTrigger("click") && (this.open ? this.hide() : this.show());
    }, this.handleFocus = () => {
      this.hasTrigger("focus") && this.show();
    }, this.handleDocumentKeyDown = (e) => {
      e.key === "Escape" && (e.stopPropagation(), this.hide());
    }, this.handleMouseOver = () => {
      if (this.hasTrigger("hover")) {
        const e = l7(getComputedStyle(this).getPropertyValue("--show-delay"));
        clearTimeout(this.hoverTimeout), this.hoverTimeout = window.setTimeout(() => this.show(), e);
      }
    }, this.handleMouseOut = () => {
      if (this.hasTrigger("hover")) {
        const e = l7(getComputedStyle(this).getPropertyValue("--hide-delay"));
        clearTimeout(this.hoverTimeout), this.hoverTimeout = window.setTimeout(() => this.hide(), e);
      }
    }, this.addEventListener("blur", this.handleBlur, !0), this.addEventListener("focus", this.handleFocus, !0), this.addEventListener("click", this.handleClick), this.addEventListener("mouseover", this.handleMouseOver), this.addEventListener("mouseout", this.handleMouseOut);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this.closeWatcher) == null || e.destroy(), document.removeEventListener("keydown", this.handleDocumentKeyDown);
  }
  firstUpdated() {
    this.body.hidden = !this.open, this.open && (this.popup.active = !0, this.popup.reposition());
  }
  hasTrigger(e) {
    return this.trigger.split(" ").includes(e);
  }
  async handleOpenChange() {
    var e, t;
    if (this.open) {
      if (this.disabled)
        return;
      this.emit("sl-show"), "CloseWatcher" in window ? ((e = this.closeWatcher) == null || e.destroy(), this.closeWatcher = new CloseWatcher(), this.closeWatcher.onclose = () => {
        this.hide();
      }) : document.addEventListener("keydown", this.handleDocumentKeyDown), await Ci(this.body), this.body.hidden = !1, this.popup.active = !0;
      const { keyframes: r, options: n } = ei(this, "tooltip.show", { dir: this.localize.dir() });
      await ti(this.popup.popup, r, n), this.popup.reposition(), this.emit("sl-after-show");
    } else {
      this.emit("sl-hide"), (t = this.closeWatcher) == null || t.destroy(), document.removeEventListener("keydown", this.handleDocumentKeyDown), await Ci(this.body);
      const { keyframes: r, options: n } = ei(this, "tooltip.hide", { dir: this.localize.dir() });
      await ti(this.popup.popup, r, n), this.popup.active = !1, this.body.hidden = !0, this.emit("sl-after-hide");
    }
  }
  async handleOptionsChange() {
    this.hasUpdated && (await this.updateComplete, this.popup.reposition());
  }
  handleDisabledChange() {
    this.disabled && this.open && this.hide();
  }
  /** Shows the tooltip. */
  async show() {
    if (!this.open)
      return this.open = !0, Za(this, "sl-after-show");
  }
  /** Hides the tooltip */
  async hide() {
    if (this.open)
      return this.open = !1, Za(this, "sl-after-hide");
  }
  //
  // NOTE: Tooltip is a bit unique in that we're using aria-live instead of aria-labelledby to trick screen readers into
  // announcing the content. It works really well, but it violates an accessibility rule. We're also adding the
  // aria-describedby attribute to a slot, which is required by <sl-popup> to correctly locate the first assigned
  // element, otherwise positioning is incorrect.
  //
  render() {
    return Jt`
      <sl-popup
        part="base"
        exportparts="
          popup:base__popup,
          arrow:base__arrow
        "
        class=${En({
      tooltip: !0,
      "tooltip--open": this.open
    })}
        placement=${this.placement}
        distance=${this.distance}
        skidding=${this.skidding}
        strategy=${this.hoist ? "fixed" : "absolute"}
        flip
        shift
        arrow
        hover-bridge
      >
        ${""}
        <slot slot="anchor" aria-describedby="tooltip"></slot>

        ${""}
        <div part="body" id="tooltip" class="tooltip__body" role="tooltip" aria-live=${this.open ? "polite" : "off"}>
          <slot name="content">${this.content}</slot>
        </div>
      </sl-popup>
    `;
  }
};
Fr.styles = [zn, rde];
Fr.dependencies = { "sl-popup": It };
V([
  Er("slot:not([name])")
], Fr.prototype, "defaultSlot", 2);
V([
  Er(".tooltip__body")
], Fr.prototype, "body", 2);
V([
  Er("sl-popup")
], Fr.prototype, "popup", 2);
V([
  ne()
], Fr.prototype, "content", 2);
V([
  ne()
], Fr.prototype, "placement", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], Fr.prototype, "disabled", 2);
V([
  ne({ type: Number })
], Fr.prototype, "distance", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], Fr.prototype, "open", 2);
V([
  ne({ type: Number })
], Fr.prototype, "skidding", 2);
V([
  ne()
], Fr.prototype, "trigger", 2);
V([
  ne({ type: Boolean })
], Fr.prototype, "hoist", 2);
V([
  Lr("open", { waitUntilFirstUpdate: !0 })
], Fr.prototype, "handleOpenChange", 1);
V([
  Lr(["content", "distance", "hoist", "placement", "skidding"])
], Fr.prototype, "handleOptionsChange", 1);
V([
  Lr("disabled")
], Fr.prototype, "handleDisabledChange", 1);
mi("tooltip.show", {
  keyframes: [
    { opacity: 0, scale: 0.8 },
    { opacity: 1, scale: 1 }
  ],
  options: { duration: 150, easing: "ease" }
});
mi("tooltip.hide", {
  keyframes: [
    { opacity: 1, scale: 1 },
    { opacity: 0, scale: 0.8 }
  ],
  options: { duration: 150, easing: "ease" }
});
Fr.define("sl-tooltip");
var y2 = /* @__PURE__ */ re("<style>"), nde = /* @__PURE__ */ re("<sl-tooltip><sl-icon name=info-circle>", !0, !1, !1);
fi("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const ide = (e) => {
  const t = Ke({
    placement: "top",
    maxWidth: "200px"
  }, e);
  return [(() => {
    var r = y2();
    return N(r, Tn), r;
  })(), (() => {
    var r = y2();
    return N(r, no), r;
  })(), (() => {
    var r = y2();
    return N(r, io), r;
  })(), (() => {
    var r = nde(), n = r.firstChild;
    return r._$owner = Pe(), n._$owner = Pe(), te((i) => {
      var a = t.tip, o = t.placement, s = t.maxWidth;
      return a !== i.e && (r.content = i.e = a), o !== i.t && (r.placement = i.t = o), s !== i.a && ((i.a = s) != null ? r.style.setProperty("--max-width", s) : r.style.removeProperty("--max-width")), i;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), r;
  })()];
};
var ade = /* @__PURE__ */ re('<div class="flex items-center space-x-2 text-slate-500">'), ode = /* @__PURE__ */ re('<div><photon-dialog label="Overwrite in progress prescription?"confirm-text="Yes, Overwrite"cancel-text="No, Cancel"><p class="font-sans text-lg xs:text-base">You are editing a prescription that has not been added. This will be overwritten if you edit another prescription.</p></photon-dialog><photon-dialog label="Delete pending prescription?"confirm-text="Yes, Delete"cancel-text="No, Cancel"><p class="font-sans text-lg xs:text-base">Deleting this prescription will remove it from your pending prescriptions. This action cannot be undone.', !0, !1, !1);
const sde = (e) => {
  const {
    dispatchDraftPrescriptionDeleted: t,
    dispatchAnalytics: r
  } = ca(), [n, i] = z(!1), [a, o] = z(!1), [s, l] = z(), [d, c] = z(void 0), [u, h] = z(), {
    selectOtherCoverageOption: f
  } = ql(), {
    draftPrescriptions: p,
    prescriptionIds: m,
    deletePrescription: y
  } = Ul(), g = () => {
    const I = d();
    I && I.treatment && (p_(e.actions, I), e.actions.updateFormValue({
      key: "catalogId",
      value: I.catalogId
    }), I.id && y(I.id), e.prescriptionRef?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    }), e.handleDraftPrescriptionsChange());
  }, w = (I, M) => {
    c(I), e.store.treatment.value ? (o(!0), l(M)) : (e.setIsEditing(!0), g(), M?.(), t(), r({
      trackEventType: "draft_prescription_edited"
    }));
  }, $ = (I) => {
    w(lde(I), () => {
      f(I);
    });
  }, _ = () => {
    g(), o(!1), c(void 0), s()?.(), l(void 0), t(), r({
      trackEventType: "draft_prescription_edited"
    });
  }, x = () => {
    o(!1), c(void 0), l(void 0);
  }, S = () => {
    const I = u();
    if (I) {
      const M = p().find((P) => P.id === I);
      y(I), t(M), r({
        trackEventType: "draft_prescription_deleted"
      });
    }
    i(!1), h(void 0), m().length === 0 && e.setIsEditing(!0), e.handleDraftPrescriptionsChange();
  }, T = () => {
    i(!1), h(void 0);
  };
  return (() => {
    var I = ode(), M = I.firstChild, P = M.nextSibling;
    return Oe(M, "photon-dialog-alt", x), Oe(M, "photon-dialog-canceled", x), Oe(M, "photon-dialog-confirmed", _), M._$owner = Pe(), Oe(P, "photon-dialog-alt", T), Oe(P, "photon-dialog-canceled", T), Oe(P, "photon-dialog-confirmed", S), P._$owner = Pe(), N(I, v(Sn, {
      addChildrenDivider: !0,
      get children() {
        return [(() => {
          var O = ade();
          return N(O, v(ke, {
            color: "gray",
            class: "pr-2",
            children: "Draft Prescriptions"
          }), null), N(O, v(ide, {
            maxWidth: "300px",
            tip: "Each prescription will include the prescriber’s digital signature and the date it was written when the order is sent to the pharmacy."
          }), null), O;
        })(), v(cte, {
          handleDelete: (O) => {
            i(!0), h(O);
          },
          handleEdit: (O) => {
            w(O);
          },
          handleSwapToOtherPrescription: $,
          get screeningAlerts() {
            return e.screeningAlerts;
          },
          get routingConstraints() {
            return e.routingConstraints;
          },
          get enableOrder() {
            return e.enableOrder;
          }
        })];
      }
    }), null), te((O) => {
      var D = a(), R = n();
      return D !== O.e && (M.open = O.e = D), R !== O.t && (P.open = O.t = R), O;
    }, {
      e: void 0,
      t: void 0
    }), I;
  })();
};
function lde(e) {
  return {
    // re-using the prescriptionId (via coverageOption.prescriptionId) of the original Prescription
    // so that the edit flow will remove it from the list of prescriptions
    id: e.prescriptionId,
    doNotFillBeforeDate: void 0,
    dispenseAsWritten: !1,
    dispenseQuantity: e.dispenseQuantity,
    dispenseUnit: e.dispenseUnit,
    daysSupply: e.daysSupply,
    instructions: "",
    notes: "",
    fillsAllowed: void 0,
    diagnoseCodes: [],
    externalId: void 0,
    catalogId: void 0,
    treatment: {
      id: e.treatment.id,
      name: e.treatment.name
    }
  };
}
const ao = `*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}input:where([type=text]),input:where(:not([type])),input:where([type=email]),input:where([type=url]),input:where([type=password]),input:where([type=number]),input:where([type=date]),input:where([type=datetime-local]),input:where([type=month]),input:where([type=search]),input:where([type=tel]),input:where([type=time]),input:where([type=week]),select:where([multiple]),textarea,select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;border-color:#6b7280;border-width:1px;border-radius:0;padding:.5rem .75rem;font-size:1rem;line-height:1.5rem;--tw-shadow: 0 0 #0000}input:where([type=text]):focus,input:where(:not([type])):focus,input:where([type=email]):focus,input:where([type=url]):focus,input:where([type=password]):focus,input:where([type=number]):focus,input:where([type=date]):focus,input:where([type=datetime-local]):focus,input:where([type=month]):focus,input:where([type=search]):focus,input:where([type=tel]):focus,input:where([type=time]):focus,input:where([type=week]):focus,select:where([multiple]):focus,textarea:focus,select:focus{outline:2px solid transparent;outline-offset:2px;--tw-ring-inset: var(--tw-empty, );--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: #175CD3;--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow);border-color:#175cd3}input::-moz-placeholder,textarea::-moz-placeholder{color:#6b7280;opacity:1}input::placeholder,textarea::placeholder{color:#6b7280;opacity:1}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-date-and-time-value{min-height:1.5em;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{padding-top:0;padding-bottom:0}select{background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");background-position:right .5rem center;background-repeat:no-repeat;background-size:1.5em 1.5em;padding-right:2.5rem;-webkit-print-color-adjust:exact;print-color-adjust:exact}select:where([multiple]),select:where([size]:not([size="1"])){background-image:initial;background-position:initial;background-repeat:unset;background-size:initial;padding-right:.75rem;-webkit-print-color-adjust:unset;print-color-adjust:unset}input:where([type=checkbox]),input:where([type=radio]){-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;-webkit-print-color-adjust:exact;print-color-adjust:exact;display:inline-block;vertical-align:middle;background-origin:border-box;-webkit-user-select:none;-moz-user-select:none;user-select:none;flex-shrink:0;height:1rem;width:1rem;color:#175cd3;background-color:#fff;border-color:#6b7280;border-width:1px;--tw-shadow: 0 0 #0000}input:where([type=checkbox]){border-radius:0}input:where([type=radio]){border-radius:100%}input:where([type=checkbox]):focus,input:where([type=radio]):focus{outline:2px solid transparent;outline-offset:2px;--tw-ring-inset: var(--tw-empty, );--tw-ring-offset-width: 2px;--tw-ring-offset-color: #fff;--tw-ring-color: #175CD3;--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}input:where([type=checkbox]):checked,input:where([type=radio]):checked{border-color:transparent;background-color:currentColor;background-size:100% 100%;background-position:center;background-repeat:no-repeat}input:where([type=checkbox]):checked{background-image:url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e")}@media(forced-colors:active){input:where([type=checkbox]):checked{-webkit-appearance:auto;-moz-appearance:auto;appearance:auto}}input:where([type=radio]):checked{background-image:url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e")}@media(forced-colors:active){input:where([type=radio]):checked{-webkit-appearance:auto;-moz-appearance:auto;appearance:auto}}input:where([type=checkbox]):checked:hover,input:where([type=checkbox]):checked:focus,input:where([type=radio]):checked:hover,input:where([type=radio]):checked:focus{border-color:transparent;background-color:currentColor}input:where([type=checkbox]):indeterminate{background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16'%3e%3cpath stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4 8h8'/%3e%3c/svg%3e");border-color:transparent;background-color:currentColor;background-size:100% 100%;background-position:center;background-repeat:no-repeat}@media(forced-colors:active){input:where([type=checkbox]):indeterminate{-webkit-appearance:auto;-moz-appearance:auto;appearance:auto}}input:where([type=checkbox]):indeterminate:hover,input:where([type=checkbox]):indeterminate:focus{border-color:transparent;background-color:currentColor}input:where([type=file]){background:unset;border-color:inherit;border-width:0;border-radius:0;padding:0;font-size:unset;line-height:inherit}input:where([type=file]):focus{outline:1px solid ButtonText;outline:1px auto -webkit-focus-ring-color}h1,h2,h3,h4,h5,h6,p,div,li,a,ul,input{font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-weight:400;line-height:1.625}body,html{--tw-text-opacity: 1;color:rgb(17,24,39,var(--tw-text-opacity))}h1,h2,h3,h4,h5,h6,label{font-weight:500;line-height:1.25}h1{font-size:1.875rem;line-height:2.25rem;margin-top:.5rem;margin-bottom:.5rem}h2{font-size:1.5rem;line-height:2rem;margin-top:.5rem;margin-bottom:.5rem}h3{font-size:1.25rem;line-height:1.75rem;margin-top:.25rem;margin-bottom:.25rem}h4{font-size:1.125rem;line-height:1.75rem;margin-top:.25rem;margin-bottom:.25rem}h5{font-size:1rem;line-height:1.5rem;margin-top:.25rem;margin-bottom:.25rem}h6,label{font-size:.875rem;line-height:1.25rem;margin-top:.25rem;margin-bottom:.25rem}p{margin-top:.5rem;margin-bottom:.5rem}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(21 112 239 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(21 112 239 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }.container{width:100%}@media(min-width:640px){.container{max-width:640px}}@media(min-width:768px){.container{max-width:768px}}@media(min-width:1024px){.container{max-width:1024px}}@media(min-width:1280px){.container{max-width:1280px}}@media(min-width:1536px){.container{max-width:1536px}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.pointer-events-none{pointer-events:none}.visible{visibility:visible}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.sticky{position:sticky}.inset-0{inset:0}.inset-y-0{top:0;bottom:0}.-bottom-8{bottom:-2rem}.bottom-full{bottom:100%}.left-0{left:0}.right-0{right:0}.top-0{top:0}.top-full{top:100%}.isolate{isolation:isolate}.z-10{z-index:10}.z-100{z-index:100}.z-20{z-index:20}.z-50{z-index:50}.col-span-2{grid-column:span 2/span 2}.col-span-3{grid-column:span 3/span 3}.m-0{margin:0}.m-auto{margin:auto}.-mx-4{margin-left:-1rem;margin-right:-1rem}.-my-2{margin-top:-.5rem;margin-bottom:-.5rem}.mx-2{margin-left:.5rem;margin-right:.5rem}.mx-auto{margin-left:auto;margin-right:auto}.my-8{margin-top:2rem;margin-bottom:2rem}.my-px{margin-top:1px;margin-bottom:1px}.-mb-px{margin-bottom:-1px}.mb-0{margin-bottom:0}.mb-1{margin-bottom:.25rem}.mb-10{margin-bottom:2.5rem}.mb-2{margin-bottom:.5rem}.mb-4{margin-bottom:1rem}.mb-8{margin-bottom:2rem}.ml-0{margin-left:0}.ml-0\\.5{margin-left:.125rem}.ml-1{margin-left:.25rem}.ml-2{margin-left:.5rem}.ml-3{margin-left:.75rem}.ml-auto{margin-left:auto}.mr-1{margin-right:.25rem}.mr-2{margin-right:.5rem}.mr-4{margin-right:1rem}.mt-0{margin-top:0}.mt-1{margin-top:.25rem}.mt-2{margin-top:.5rem}.mt-3{margin-top:.75rem}.mt-4{margin-top:1rem}.mt-5{margin-top:1.25rem}.mt-8{margin-top:2rem}.box-border{box-sizing:border-box}.block{display:block}.inline-block{display:inline-block}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.flow-root{display:flow-root}.grid{display:grid}.contents{display:contents}.hidden{display:none}.h-10{height:2.5rem}.h-12{height:3rem}.h-4{height:1rem}.h-5{height:1.25rem}.h-6{height:1.5rem}.h-8{height:2rem}.h-px{height:1px}.max-h-60{max-height:15rem}.max-h-80{max-height:20rem}.min-h-full{min-height:100%}.w-10{width:2.5rem}.w-12{width:3rem}.w-20{width:5rem}.w-4{width:1rem}.w-5{width:1.25rem}.w-6{width:1.5rem}.w-8{width:2rem}.w-96{width:24rem}.w-full{width:100%}.w-max{width:-moz-max-content;width:max-content}.min-w-0{min-width:0px}.min-w-full{min-width:100%}.max-w-lg{max-width:32rem}.max-w-md{max-width:28rem}.max-w-sm{max-width:24rem}.flex-1{flex:1 1 0%}.flex-auto{flex:1 1 auto}.flex-shrink-0{flex-shrink:0}.grow{flex-grow:1}.table-auto{table-layout:auto}.table-fixed{table-layout:fixed}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes spin{to{transform:rotate(360deg)}}.animate-spin{animation:spin 1s linear infinite}.cursor-default{cursor:default}.cursor-help{cursor:help}.cursor-not-allowed{cursor:not-allowed}.cursor-pointer{cursor:pointer}.touch-pan-y{--tw-pan-y: pan-y;touch-action:var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom)}.select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}.resize-none{resize:none}.resize-y{resize:vertical}.resize{resize:both}.grid-flow-col{grid-auto-flow:column}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.grid-cols-subgrid{grid-template-columns:subgrid}.flex-col{flex-direction:column}.place-items-start{place-items:start}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.items-stretch{align-items:stretch}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-1{gap:.25rem}.gap-2{gap:.5rem}.gap-3{gap:.75rem}.gap-4{gap:1rem}.gap-6{gap:1.5rem}.gap-8{gap:2rem}.gap-x-1{-moz-column-gap:.25rem;column-gap:.25rem}.gap-x-3{-moz-column-gap:.75rem;column-gap:.75rem}.gap-x-4{-moz-column-gap:1rem;column-gap:1rem}.gap-y-10{row-gap:2.5rem}.gap-y-4{row-gap:1rem}.space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.5rem * var(--tw-space-x-reverse));margin-left:calc(.5rem * (1 - var(--tw-space-x-reverse)))}.space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(1rem * var(--tw-space-x-reverse));margin-left:calc(1rem * (1 - var(--tw-space-x-reverse)))}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.5rem * (1 - var(--tw-space-y-reverse)));margin-bottom:calc(.5rem * var(--tw-space-y-reverse))}.space-y-3>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.75rem * (1 - var(--tw-space-y-reverse)));margin-bottom:calc(.75rem * var(--tw-space-y-reverse))}.space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1rem * (1 - var(--tw-space-y-reverse)));margin-bottom:calc(1rem * var(--tw-space-y-reverse))}.space-y-5>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1.25rem * (1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.25rem * var(--tw-space-y-reverse))}.divide-y>:not([hidden])~:not([hidden]){--tw-divide-y-reverse: 0;border-top-width:calc(1px * (1 - var(--tw-divide-y-reverse)));border-bottom-width:calc(1px * var(--tw-divide-y-reverse))}.divide-gray-200>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(229,231,235,var(--tw-divide-opacity))}.divide-gray-300>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(209,213,219,var(--tw-divide-opacity))}.self-center{align-self:center}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-x-auto{overflow-x:auto}.overflow-y-auto{overflow-y:auto}.overflow-x-hidden{overflow-x:hidden}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-ellipsis{text-overflow:ellipsis}.whitespace-normal{white-space:normal}.whitespace-nowrap{white-space:nowrap}.text-pretty{text-wrap:pretty}.break-words{overflow-wrap:break-word}.rounded{border-radius:.25rem}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:.5rem}.rounded-md{border-radius:.375rem}.rounded-xl{border-radius:.75rem}.rounded-r-md{border-top-right-radius:.375rem;border-bottom-right-radius:.375rem}.border{border-width:1px}.border-0{border-width:0px}.border-2{border-width:2px}.border-b{border-bottom-width:1px}.border-b-2{border-bottom-width:2px}.border-t{border-top-width:1px}.border-solid{border-style:solid}.border-blue-200{--tw-border-opacity: 1;border-color:rgb(132,202,255,var(--tw-border-opacity))}.border-blue-300{--tw-border-opacity: 1;border-color:rgb(83,177,253,var(--tw-border-opacity))}.border-blue-400{--tw-border-opacity: 1;border-color:rgb(46,144,250,var(--tw-border-opacity))}.border-blue-500{--tw-border-opacity: 1;border-color:rgb(21,112,239,var(--tw-border-opacity))}.border-blue-600{--tw-border-opacity: 1;border-color:rgb(23,92,211,var(--tw-border-opacity))}.border-gray-200{--tw-border-opacity: 1;border-color:rgb(229,231,235,var(--tw-border-opacity))}.border-gray-300{--tw-border-opacity: 1;border-color:rgb(209,213,219,var(--tw-border-opacity))}.border-green-200{--tw-border-opacity: 1;border-color:rgb(187,247,208,var(--tw-border-opacity))}.border-green-300{--tw-border-opacity: 1;border-color:rgb(134,239,172,var(--tw-border-opacity))}.border-green-400{--tw-border-opacity: 1;border-color:rgb(74,222,128,var(--tw-border-opacity))}.border-green-600{--tw-border-opacity: 1;border-color:rgb(22,163,74,var(--tw-border-opacity))}.border-indigo-300{--tw-border-opacity: 1;border-color:rgb(165,180,252,var(--tw-border-opacity))}.border-pink-300{--tw-border-opacity: 1;border-color:rgb(249,168,212,var(--tw-border-opacity))}.border-purple-300{--tw-border-opacity: 1;border-color:rgb(216,180,254,var(--tw-border-opacity))}.border-red-200{--tw-border-opacity: 1;border-color:rgb(254,202,202,var(--tw-border-opacity))}.border-red-300{--tw-border-opacity: 1;border-color:rgb(252,165,165,var(--tw-border-opacity))}.border-red-400{--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity))}.border-red-600{--tw-border-opacity: 1;border-color:rgb(220,38,38,var(--tw-border-opacity))}.border-slate-600{--tw-border-opacity: 1;border-color:rgb(71,85,105,var(--tw-border-opacity))}.border-transparent{border-color:transparent}.border-yellow-200{--tw-border-opacity: 1;border-color:rgb(254,240,138,var(--tw-border-opacity))}.border-yellow-300{--tw-border-opacity: 1;border-color:rgb(253,224,71,var(--tw-border-opacity))}.border-yellow-600{--tw-border-opacity: 1;border-color:rgb(202,138,4,var(--tw-border-opacity))}.bg-\\[\\#FFFAEB\\]{--tw-bg-opacity: 1;background-color:rgb(255,250,235,var(--tw-bg-opacity))}.bg-blue-100{--tw-bg-opacity: 1;background-color:rgb(178,221,255,var(--tw-bg-opacity))}.bg-blue-50{--tw-bg-opacity: 1;background-color:rgb(209,233,255,var(--tw-bg-opacity))}.bg-blue-500{--tw-bg-opacity: 1;background-color:rgb(21,112,239,var(--tw-bg-opacity))}.bg-blue-600{--tw-bg-opacity: 1;background-color:rgb(23,92,211,var(--tw-bg-opacity))}.bg-gray-100{--tw-bg-opacity: 1;background-color:rgb(243,244,246,var(--tw-bg-opacity))}.bg-gray-200{--tw-bg-opacity: 1;background-color:rgb(229,231,235,var(--tw-bg-opacity))}.bg-gray-50{--tw-bg-opacity: 1;background-color:rgb(249,250,251,var(--tw-bg-opacity))}.bg-gray-500{--tw-bg-opacity: 1;background-color:rgb(107,114,128,var(--tw-bg-opacity))}.bg-gray-900{--tw-bg-opacity: 1;background-color:rgb(17,24,39,var(--tw-bg-opacity))}.bg-green-100{--tw-bg-opacity: 1;background-color:rgb(220,252,231,var(--tw-bg-opacity))}.bg-green-50{--tw-bg-opacity: 1;background-color:rgb(240,253,244,var(--tw-bg-opacity))}.bg-indigo-100{--tw-bg-opacity: 1;background-color:rgb(224,231,255,var(--tw-bg-opacity))}.bg-pink-100{--tw-bg-opacity: 1;background-color:rgb(252,231,243,var(--tw-bg-opacity))}.bg-purple-100{--tw-bg-opacity: 1;background-color:rgb(243,232,255,var(--tw-bg-opacity))}.bg-red-100{--tw-bg-opacity: 1;background-color:rgb(254,226,226,var(--tw-bg-opacity))}.bg-red-50{--tw-bg-opacity: 1;background-color:rgb(254,242,242,var(--tw-bg-opacity))}.bg-red-500{--tw-bg-opacity: 1;background-color:rgb(239,68,68,var(--tw-bg-opacity))}.bg-slate-100{--tw-bg-opacity: 1;background-color:rgb(241,245,249,var(--tw-bg-opacity))}.bg-slate-50{--tw-bg-opacity: 1;background-color:rgb(248,250,252,var(--tw-bg-opacity))}.bg-transparent{background-color:transparent}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255,255,255,var(--tw-bg-opacity))}.bg-yellow-100{--tw-bg-opacity: 1;background-color:rgb(254,249,195,var(--tw-bg-opacity))}.bg-yellow-50{--tw-bg-opacity: 1;background-color:rgb(254,252,232,var(--tw-bg-opacity))}.bg-opacity-75{--tw-bg-opacity: .75}.fill-blue-500{fill:#1570ef}.fill-green-500{fill:#22c55e}.p-0{padding:0}.p-2{padding:.5rem}.p-4{padding:1rem}.px-1{padding-left:.25rem;padding-right:.25rem}.px-1\\.5{padding-left:.375rem;padding-right:.375rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-2\\.5{padding-left:.625rem;padding-right:.625rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-3\\.5{padding-left:.875rem;padding-right:.875rem}.px-4{padding-left:1rem;padding-right:1rem}.py-0{padding-top:0;padding-bottom:0}.py-0\\.5{padding-top:.125rem;padding-bottom:.125rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.py-1\\.5{padding-top:.375rem;padding-bottom:.375rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-2\\.5{padding-top:.625rem;padding-bottom:.625rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-3\\.5{padding-top:.875rem;padding-bottom:.875rem}.py-4{padding-top:1rem;padding-bottom:1rem}.pb-1{padding-bottom:.25rem}.pl-10{padding-left:2.5rem}.pl-3{padding-left:.75rem}.pr-1{padding-right:.25rem}.pr-2{padding-right:.5rem}.pr-3{padding-right:.75rem}.pr-4{padding-right:1rem}.pr-9{padding-right:2.25rem}.pt-2{padding-top:.5rem}.pt-4{padding-top:1rem}.text-left{text-align:left}.text-center{text-align:center}.text-end{text-align:end}.align-top{vertical-align:top}.align-middle{vertical-align:middle}.font-mono{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}.text-base{font-size:1rem;line-height:1.5rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-sm\\/6{font-size:.875rem;line-height:1.5rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.text-xs{font-size:.75rem;line-height:1rem}.font-bold{font-weight:700}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.capitalize{text-transform:capitalize}.italic{font-style:italic}.leading-6{line-height:1.5rem}.leading-none{line-height:1}.leading-snug{line-height:1.375}.text-\\[\\#DC6803\\]{--tw-text-opacity: 1;color:rgb(220,104,3,var(--tw-text-opacity))}.text-black{--tw-text-opacity: 1;color:rgb(0,0,0,var(--tw-text-opacity))}.text-blue-500{--tw-text-opacity: 1;color:rgb(21,112,239,var(--tw-text-opacity))}.text-blue-600{--tw-text-opacity: 1;color:rgb(23,92,211,var(--tw-text-opacity))}.text-blue-700{--tw-text-opacity: 1;color:rgb(24,73,169,var(--tw-text-opacity))}.text-blue-800{--tw-text-opacity: 1;color:rgb(25,65,133,var(--tw-text-opacity))}.text-blue-900{--tw-text-opacity: 1;color:rgb(16,42,86,var(--tw-text-opacity))}.text-current{color:currentColor}.text-gray-200{--tw-text-opacity: 1;color:rgb(229,231,235,var(--tw-text-opacity))}.text-gray-400{--tw-text-opacity: 1;color:rgb(156,163,175,var(--tw-text-opacity))}.text-gray-50{--tw-text-opacity: 1;color:rgb(249,250,251,var(--tw-text-opacity))}.text-gray-500{--tw-text-opacity: 1;color:rgb(107,114,128,var(--tw-text-opacity))}.text-gray-600{--tw-text-opacity: 1;color:rgb(75,85,99,var(--tw-text-opacity))}.text-gray-700{--tw-text-opacity: 1;color:rgb(55,65,81,var(--tw-text-opacity))}.text-gray-900{--tw-text-opacity: 1;color:rgb(17,24,39,var(--tw-text-opacity))}.text-green-500{--tw-text-opacity: 1;color:rgb(34,197,94,var(--tw-text-opacity))}.text-green-600{--tw-text-opacity: 1;color:rgb(22,163,74,var(--tw-text-opacity))}.text-green-700{--tw-text-opacity: 1;color:rgb(21,128,61,var(--tw-text-opacity))}.text-green-800{--tw-text-opacity: 1;color:rgb(22,101,52,var(--tw-text-opacity))}.text-indigo-700{--tw-text-opacity: 1;color:rgb(67,56,202,var(--tw-text-opacity))}.text-pink-700{--tw-text-opacity: 1;color:rgb(190,24,93,var(--tw-text-opacity))}.text-purple-700{--tw-text-opacity: 1;color:rgb(126,34,206,var(--tw-text-opacity))}.text-red-400{--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}.text-red-500{--tw-text-opacity: 1;color:rgb(239,68,68,var(--tw-text-opacity))}.text-red-600{--tw-text-opacity: 1;color:rgb(220,38,38,var(--tw-text-opacity))}.text-red-700{--tw-text-opacity: 1;color:rgb(185,28,28,var(--tw-text-opacity))}.text-red-800{--tw-text-opacity: 1;color:rgb(153,27,27,var(--tw-text-opacity))}.text-slate-500{--tw-text-opacity: 1;color:rgb(100,116,139,var(--tw-text-opacity))}.text-slate-600{--tw-text-opacity: 1;color:rgb(71,85,105,var(--tw-text-opacity))}.text-transparent{color:transparent}.text-white{--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.text-yellow-600{--tw-text-opacity: 1;color:rgb(202,138,4,var(--tw-text-opacity))}.text-yellow-800{--tw-text-opacity: 1;color:rgb(133,77,14,var(--tw-text-opacity))}.underline{text-decoration-line:underline}.opacity-0{opacity:0}.opacity-100{opacity:1}.opacity-35{opacity:.35}.opacity-50{opacity:.5}.shadow{--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1);--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.shadow-lg{--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.shadow-sm{--tw-shadow: 0 1px 2px 0 rgb(0 0 0 / .05);--tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.shadow-xl{--tw-shadow: 0 20px 25px -5px rgb(0 0 0 / .1), 0 8px 10px -6px rgb(0 0 0 / .1);--tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.ring-1{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 rgba(0, 0, 0, 0))}.ring-2{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 rgba(0, 0, 0, 0))}.ring-inset{--tw-ring-inset: inset}.ring-black{--tw-ring-opacity: 1;--tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity))}.ring-blue-300{--tw-ring-opacity: 1;--tw-ring-color: rgb(83 177 253 / var(--tw-ring-opacity))}.ring-gray-200{--tw-ring-opacity: 1;--tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity))}.ring-gray-300{--tw-ring-opacity: 1;--tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity))}.ring-gray-900\\/5{--tw-ring-color: rgb(17 24 39 / .05)}.ring-red-300{--tw-ring-opacity: 1;--tw-ring-color: rgb(252 165 165 / var(--tw-ring-opacity))}.ring-sky-500\\/40{--tw-ring-color: rgb(14 165 233 / .4)}.ring-opacity-5{--tw-ring-opacity: .05}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-opacity{transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.duration-100{transition-duration:.1s}.ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.theme-photon,[data-theme=photon]{--twc-primaryText: 210 20% 98%;--twc-primary500: 238.70000000000005 83.5% 66.7%;--twc-primary600: 243.39999999999998 75.4% 58.6%;--twc-secondaryText: 220.89999999999998 39.3% 11%;--twc-secondary50: 225.89999999999998 100% 96.7%;--twc-secondary100: 226.5 100% 93.9%}.theme-weekend,[data-theme=weekend]{--twc-primaryText: 210 20% 98%;--twc-primary500: 198.60000000000002 88.7% 48.4%;--twc-primary600: 200.39999999999998 98% 39.4%;--twc-secondaryText: 220.89999999999998 39.3% 11%;--twc-secondary50: 204 100% 97.1%;--twc-secondary100: 204 93.8% 93.7%}.\\[overflow-wrap\\:anywhere\\]{overflow-wrap:anywhere}@keyframes animateEnter{0%{transform:translate3d(0,-20%,0) scale(.8);opacity:.5}to{transform:translateZ(0) scale(1);opacity:1}}@keyframes animateLeave{0%{transform:translateZ(-1px) scale(1);opacity:1}to{transform:translate3d(0,-20%,-1px) scale(.8);opacity:0}}.animate-enter{animation:animateEnter .2s cubic-bezier(.21,1.02,.73,1) forwards}.animate-leave{animation:animateLeave .2s cubic-bezier(.06,.71,.55,1) forwards}.placeholder\\:text-gray-400::-moz-placeholder{--tw-text-opacity: 1;color:rgb(156,163,175,var(--tw-text-opacity))}.placeholder\\:text-gray-400::placeholder{--tw-text-opacity: 1;color:rgb(156,163,175,var(--tw-text-opacity))}.placeholder\\:text-red-300::-moz-placeholder{--tw-text-opacity: 1;color:rgb(252,165,165,var(--tw-text-opacity))}.placeholder\\:text-red-300::placeholder{--tw-text-opacity: 1;color:rgb(252,165,165,var(--tw-text-opacity))}.even\\:bg-gray-50:nth-child(2n){--tw-bg-opacity: 1;background-color:rgb(249,250,251,var(--tw-bg-opacity))}.hover\\:border-gray-300:hover{--tw-border-opacity: 1;border-color:rgb(209,213,219,var(--tw-border-opacity))}.hover\\:bg-blue-100:hover{--tw-bg-opacity: 1;background-color:rgb(178,221,255,var(--tw-bg-opacity))}.hover\\:bg-blue-50:hover{--tw-bg-opacity: 1;background-color:rgb(209,233,255,var(--tw-bg-opacity))}.hover\\:bg-blue-600:hover{--tw-bg-opacity: 1;background-color:rgb(23,92,211,var(--tw-bg-opacity))}.hover\\:bg-gray-50:hover{--tw-bg-opacity: 1;background-color:rgb(249,250,251,var(--tw-bg-opacity))}.hover\\:bg-red-600:hover{--tw-bg-opacity: 1;background-color:rgb(220,38,38,var(--tw-bg-opacity))}.hover\\:text-amber-500:hover{--tw-text-opacity: 1;color:rgb(245,158,11,var(--tw-text-opacity))}.hover\\:text-blue-500:hover{--tw-text-opacity: 1;color:rgb(21,112,239,var(--tw-text-opacity))}.hover\\:text-gray-500:hover{--tw-text-opacity: 1;color:rgb(107,114,128,var(--tw-text-opacity))}.hover\\:text-gray-600:hover{--tw-text-opacity: 1;color:rgb(75,85,99,var(--tw-text-opacity))}.hover\\:text-gray-700:hover{--tw-text-opacity: 1;color:rgb(55,65,81,var(--tw-text-opacity))}.hover\\:text-gray-900:hover{--tw-text-opacity: 1;color:rgb(17,24,39,var(--tw-text-opacity))}.hover\\:text-red-500:hover{--tw-text-opacity: 1;color:rgb(239,68,68,var(--tw-text-opacity))}.hover\\:ring-gray-400:hover{--tw-ring-opacity: 1;--tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity))}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:outline-0:focus{outline-width:0px}.focus\\:ring-1:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 rgba(0, 0, 0, 0))}.focus\\:ring-2:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 rgba(0, 0, 0, 0))}.focus\\:ring-inset:focus{--tw-ring-inset: inset}.focus\\:ring-blue-300:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(83 177 253 / var(--tw-ring-opacity))}.focus\\:ring-blue-500:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(21 112 239 / var(--tw-ring-opacity))}.focus\\:ring-blue-600:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(23 92 211 / var(--tw-ring-opacity))}.focus\\:ring-gray-300:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity))}.focus\\:ring-red-500:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity))}.focus\\:ring-sky-500\\/40:focus{--tw-ring-color: rgb(14 165 233 / .4)}.focus\\:ring-offset-2:focus{--tw-ring-offset-width: 2px}.focus-visible\\:outline:focus-visible{outline-style:solid}.focus-visible\\:outline-2:focus-visible{outline-width:2px}.focus-visible\\:outline-offset-2:focus-visible{outline-offset:2px}.disabled\\:cursor-not-allowed:disabled{cursor:not-allowed}.disabled\\:opacity-50:disabled{opacity:.5}.disabled\\:hover\\:bg-transparent:hover:disabled{background-color:transparent}.disabled\\:hover\\:text-gray-700:hover:disabled{--tw-text-opacity: 1;color:rgb(55,65,81,var(--tw-text-opacity))}.group:hover .group-hover\\:bg-blue-100{--tw-bg-opacity: 1;background-color:rgb(178,221,255,var(--tw-bg-opacity))}.group:hover .group-hover\\:text-blue-600{--tw-text-opacity: 1;color:rgb(23,92,211,var(--tw-text-opacity))}.group:hover .group-hover\\:text-blue-900{--tw-text-opacity: 1;color:rgb(16,42,86,var(--tw-text-opacity))}.group:hover .group-hover\\:opacity-100{opacity:1}@media(min-width:640px){.sm\\:-mx-6{margin-left:-1.5rem;margin-right:-1.5rem}.sm\\:my-8{margin-top:2rem;margin-bottom:2rem}.sm\\:mt-5{margin-top:1.25rem}.sm\\:mt-6{margin-top:1.5rem}.sm\\:block{display:block}.sm\\:grid{display:grid}.sm\\:hidden{display:none}.sm\\:w-auto{width:auto}.sm\\:max-w-lg{max-width:32rem}.sm\\:max-w-md{max-width:28rem}.sm\\:max-w-sm{max-width:24rem}.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.sm\\:flex-row{flex-direction:row}.sm\\:items-center{align-items:center}.sm\\:gap-2{gap:.5rem}.sm\\:gap-4{gap:1rem}.sm\\:space-x-6>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(1.5rem * var(--tw-space-x-reverse));margin-left:calc(1.5rem * (1 - var(--tw-space-x-reverse)))}.sm\\:p-0{padding:0}.sm\\:p-6{padding:1.5rem}.sm\\:px-4{padding-left:1rem;padding-right:1rem}.sm\\:px-6{padding-left:1.5rem;padding-right:1.5rem}.sm\\:py-4{padding-top:1rem;padding-bottom:1rem}.sm\\:pr-6{padding-right:1.5rem}.sm\\:pt-6{padding-top:1.5rem}.sm\\:text-base{font-size:1rem;line-height:1.5rem}.sm\\:text-sm{font-size:.875rem;line-height:1.25rem}.sm\\:leading-6{line-height:1.5rem}}@media(min-width:768px){.md\\:grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.md\\:flex-row{flex-direction:row}.md\\:items-center{align-items:center}.md\\:gap-1{gap:.25rem}.md\\:space-x-8>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(2rem * var(--tw-space-x-reverse));margin-left:calc(2rem * (1 - var(--tw-space-x-reverse)))}.md\\:text-right{text-align:right}}@media(min-width:1024px){.lg\\:-mx-8{margin-left:-2rem;margin-right:-2rem}.lg\\:px-8{padding-left:2rem;padding-right:2rem}}@media(prefers-color-scheme:dark){.dark\\:bg-gray-700{--tw-bg-opacity: 1;background-color:rgb(55,65,81,var(--tw-bg-opacity))}.dark\\:text-gray-600{--tw-text-opacity: 1;color:rgb(75,85,99,var(--tw-text-opacity))}}`;
var dde = /* @__PURE__ */ re('<div class="flex items-center justify-between">'), cde = /* @__PURE__ */ re("<div><style>");
const ude = (e) => e ? !!(e.street1?.trim() && e.city?.trim() && e.state?.trim() && e.postalCode?.trim()) : !1, hde = (e) => {
  const {
    setOrderFormData: t
  } = ql(), r = B(() => e.store.patient?.value ? [e.store.patient?.value?.id] : []), n = B(() => {
    const i = e.store.address?.value ?? e.store.patient?.value?.address;
    return ude(i) ? `${i.street1} ${i.street2 || ""} ${i.city}, ${i.state} ${i.postalCode}` : "";
  });
  return (() => {
    var i = cde(), a = i.firstChild;
    return N(a, ao), N(i, v(Sn, {
      addChildrenDivider: !0,
      get children() {
        return [(() => {
          var o = dde();
          return N(o, v(ke, {
            color: "gray",
            children: "Select Pharmacy"
          })), o;
        })(), v(Hre, {
          get enableSendToPatient() {
            return e.enableSendToPatient;
          },
          get enableDeliveryPharmacies() {
            return e.enableDeliveryPharmacies;
          },
          get enableLocalPickup() {
            return e.enableLocalPickup || !e?.enableSendToPatient && !e?.mailOrderIds;
          },
          get mailOrderPharmacyIds() {
            return gt(() => !!e.mailOrderIds)() ? e.mailOrderIds.split(",") : void 0;
          },
          get patientIds() {
            return r();
          },
          get address() {
            return n();
          },
          get hasPreferredPharmacy() {
            return !!e.store.patient?.value?.preferredPharmacies?.length;
          },
          setFufillmentType: (o) => {
            e.actions.updateFormValue({
              key: "fulfillmentType",
              value: o || ""
            });
          },
          setPreferredPharmacy: (o = !1) => {
            e.actions.updateFormValue({
              key: "updatePreferredPharmacy",
              value: o
            });
          },
          setPharmacyId: (o) => {
            t("pharmacyId", o);
          }
        })];
      }
    }), null), i;
  })();
};
var fde = /* @__PURE__ */ re('<div class="flex items-center justify-between">'), pde = /* @__PURE__ */ re("<photon-patient-select>", !0, !1, !1), mde = /* @__PURE__ */ re("<div><photon-patient-dialog>", !0, !1, !1), gde = /* @__PURE__ */ re("<div><photon-add-medication-history-dialog>", !0, !1, !1), vde = /* @__PURE__ */ re('<div class="flex flex-col gap-8">');
const yde = (e) => e ? !!(e.street1?.trim() && e.city?.trim() && e.state?.trim() && e.postalCode?.trim()) : !1, bde = br(R3(bn(), kh()), "Please select a patient..."), wde = br(R3(bn(), kh()), "Please enter an address for patient..."), $de = (e) => {
  const {
    dispatchAnalytics: t
  } = ca(), [r, n] = z(), [i, a] = z(!1), [o, s] = z(!1), {
    actions: l,
    store: d
  } = du, [c, u] = z(!1);
  Ht(() => {
    e.actions.registerValidator({
      key: "patient",
      validator: bde
    }), e.enableOrder && e.actions.registerValidator({
      key: "address",
      validator: wde
    }), e?.patientId && l.getSelectedPatient(e.client.getSDK(), e.patientId);
  });
  const h = (w, {
    trackInteraction: $ = !0
  } = {}) => {
    e.actions.updateFormValue({
      key: "patient",
      value: w.detail.patient
    }), $ && t({
      trackEventType: "prescription_patient_changed",
      properties: {
        patientId: w.detail.patient.id
      }
    }), e.enableOrder && !e.address && e.actions.updateFormValue({
      key: "address",
      value: w.detail.patient.address
    });
  };
  le(() => {
    d?.selectedPatient?.data && e?.patientId && h({
      detail: {
        patient: d?.selectedPatient?.data
      }
    }, {
      trackInteraction: !1
    });
  });
  const f = B(
    // prefer the passed-in patientId if it exists
    () => e?.patientId || e.store.patient?.value?.id
  ), p = B(() => c() ? "" : f() ?? ""), m = B(() => {
    const w = e.store.address?.value || e.store.patient?.value?.address;
    return yde(w);
  }), y = B(() => !!e.store.patient?.value?.preferredPharmacies?.length), g = B(() => !e.store.patient?.value?.id || !e.enableOrder ? !1 : e.optionalPatientAddress ? y() && !m() : !m());
  return (() => {
    var w = vde();
    return N(w, v(q, {
      get when() {
        return !e?.patientId;
      },
      get children() {
        return v(Sn, {
          addChildrenDivider: !0,
          get children() {
            return [(() => {
              var $ = fde();
              return N($, v(ke, {
                color: "gray",
                get children() {
                  return e?.patientId ? "Patient" : "Select Patient";
                }
              })), $;
            })(), (() => {
              var $ = pde();
              return Oe($, "photon-patient-selected", h), $._$owner = Pe(), te((_) => {
                var x = e.store.patient?.error ?? !1, S = e.store.patient?.error, T = e.store.patient?.value?.id ?? e.patientId, I = e.client.getSDK();
                return x !== _.e && ($.invalid = _.e = x), S !== _.t && ($.helpText = _.t = S), T !== _.a && ($.selected = _.a = T), I !== _.o && ($.sdk = _.o = I), _;
              }, {
                e: void 0,
                t: void 0,
                a: void 0,
                o: void 0
              }), $;
            })()];
          }
        });
      }
    }), null), N(w, v(q, {
      get when() {
        return p() && !e.hidePatientCard;
      },
      get children() {
        var $ = mde(), _ = $.firstChild;
        return N($, v($te, {
          get patientId() {
            return p();
          },
          get weight() {
            return e?.weight;
          },
          get weightUnit() {
            return e?.weightUnit;
          },
          get editPatient() {
            return e?.enableOrder && !g() ? () => a(!0) : void 0;
          },
          get address() {
            return e?.address || e.store.patient?.value?.address;
          }
        }), _), Oe(_, "photon-patient-closed", () => {
          a(!1);
        }), Oe(_, "photon-patient-updated", () => {
          u(!0), l.getSelectedPatient(e.client.getSDK(), e.store.patient.value.id), setTimeout(() => {
            u(!1), a(!1);
          }, 100);
        }), _.hideCreatePrescription = !0, _._$owner = Pe(), te((x) => {
          var S = i(), T = p(), I = e.optionalPatientAddress;
          return S !== x.e && (_.open = x.e = S), T !== x.t && (_.patientId = x.t = T), I !== x.a && (_.optionalPatientAddress = x.a = I), x;
        }, {
          e: void 0,
          t: void 0,
          a: void 0
        }), $;
      }
    }), null), N(w, v(q, {
      get when() {
        return gt(() => !!e.enableMedHistory)() && p();
      },
      get children() {
        var $ = gde(), _ = $.firstChild;
        return N($, v(U$, {
          get patientId() {
            return p();
          },
          get newMedication() {
            return r();
          },
          get enableLinks() {
            return e.enableMedHistoryLinks ?? !1;
          },
          get enableRefillButton() {
            return e.enableMedHistoryRefillButton ?? !1;
          },
          openAddMedicationDialog: () => s(!0),
          hideAddMedicationDialog: () => s(!1)
        }), _), Oe(_, "photon-medication-closed", () => {
          s(!1);
        }), Oe(_, "photon-medication-selected", (x) => {
          n(x.detail.medication), t({
            trackEventType: "add_to_medication_history"
          });
        }), _._$owner = Pe(), te(() => _.open = o()), $;
      }
    }), null), N(w, v(q, {
      get when() {
        return g();
      },
      get children() {
        return v(pw, {
          get patientId() {
            return p();
          },
          setAddress: ($) => {
            e.actions.updateFormValue({
              key: "address",
              value: $
            }), e.actions.updateFormValue({
              key: "patient",
              value: {
                ...e.store.patient.value,
                address: $
              }
            });
          }
        });
      }
    }), null), w;
  })();
};
var kde = /* @__PURE__ */ re("<span>, "), _de = /* @__PURE__ */ re('<div class="flex flex-col items-start">'), xde = /* @__PURE__ */ re('<photon-card><div class="flex flex-col gap-3"><div class="flex flex-row"><p class="font-sans text-l font-medium flex-grow">Selected Pharmacy', !0, !1, !1);
const Ede = (e) => {
  const t = Cn(), [r, n] = z(null), i = async (a) => {
    if (a && t) {
      const {
        data: o
      } = await t.getSDK().clinical.pharmacy.getPharmacy({
        id: a
      });
      n(o.pharmacy);
    }
  };
  return le(() => {
    e.pharmacyId && i(e.pharmacyId);
  }), (() => {
    var a = xde(), o = a.firstChild;
    return o.firstChild, a._$owner = Pe(), N(o, v(q, {
      get when() {
        return r();
      },
      get children() {
        return v(Oc, {
          label: "Pharmacies",
          get initSelected() {
            return e?.pharmacyId || "";
          },
          get children() {
            return v(Oc.Option, {
              get value() {
                return e?.pharmacyId || "";
              },
              get children() {
                var s = _de();
                return N(s, v(ke, {
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "Loading Name",
                  get children() {
                    return r()?.name;
                  }
                }), null), N(s, v(ke, {
                  get loading() {
                    return !r();
                  },
                  color: "gray",
                  size: "sm",
                  sampleLoadingText: "Cityville, ST",
                  get children() {
                    var l = kde(), d = l.firstChild;
                    return N(l, () => r()?.address?.city, d), N(l, () => r()?.address?.state, null), l;
                  }
                }), null), s;
              }
            });
          }
        });
      }
    }), null), a;
  })();
}, Sde = (e, t = "lb") => `Patient weight: ${e} ${t}`;
var m_ = /* @__PURE__ */ ((e) => (e.Draft = "DRAFT", e.Active = "ACTIVE", e.Depleted = "DEPLETED", e.Expired = "EXPIRED", e.Canceled = "CANCELED", e))(m_ || {}), Cde = /* @__PURE__ */ re('<div class="w-full flex justify-center">'), Tde = /* @__PURE__ */ re("<div>"), Ade = /* @__PURE__ */ re('<div class="m-3 gap-4">'), Ode = /* @__PURE__ */ re('<div class="flex flex-row justify-end gap-2">'), Pde = /* @__PURE__ */ re('<div><div><div class="flex flex-col gap-8">'), Ide = /* @__PURE__ */ re("<div>No errors...");
const Dde = (e) => e ? !!(e.street1?.trim() && e.city?.trim() && e.state?.trim() && e.postalCode?.trim()) : !1, g_ = (e) => e === G0.FulfillmentType.PickUp || e === G0.FulfillmentType.MailOrder, Nde = (e, t) => g_(e) && !t, Mde = xe`
  query ScreenDraftedPrescriptionsQuery(
    $draftedPrescriptions: [DraftedPrescriptionInput!]!
    $patientId: ID!
  ) {
    prescriptionScreen(draftedPrescriptions: $draftedPrescriptions, patientId: $patientId) {
      alerts {
        type
        description
        involvedEntities {
          id
          name
          __typename
        }
        severity
      }
    }
  }
`;
function Rde(e) {
  let t, r;
  const {
    draftPrescriptions: n,
    prescriptionIds: i,
    tryUpdatePrescriptionStates: a,
    isLoadingPrefills: o
  } = Ul(), {
    routingConstraints: s,
    combinedRoutingConstraint: l,
    orderFormData: d
  } = ql(), {
    dispatchFormValidate: c,
    dispatchPrescriptionsCreated: u,
    dispatchPrescriptionsError: h,
    dispatchOrderCreated: f,
    dispatchOrderError: p,
    dispatchClinicalAlertAcknowledge: m,
    dispatchClinicalAlertCancel: y,
    dispatchAnalytics: g
  } = ca(), w = B(() => {
    if (e.pharmacyId)
      return e.pharmacyId;
    if (l()?.routing_constraint_type === "include" && l()?.constraint_pharmacies?.length === 1)
      return l().constraint_pharmacies?.[0].id;
  }), $ = Cn(), [_, x] = z(e.initialShowForm), [S, T] = z([]), [I, M] = z(!0), [P, O] = z(!1), [D, R] = z($?.authentication.state.isAuthenticated || !1), [, L] = Vl(), [Q, ie] = z([]), [ee, W] = z(!1), H = B(() => {
    const De = e.formStore?.address?.value ?? e.formStore?.patient?.value?.address;
    return Dde(De);
  }), pe = B(() => !!e.formStore?.patient?.value?.preferredPharmacies?.length), Te = B(() => !e.optionalPatientAddress || !e.enableOrder ? !1 : g_(e.formStore?.fulfillmentType?.value) && !H()), [Ce, de] = z(!1);
  let K = "";
  e.additionalNotes && (K = `${e.additionalNotes}

`), e.weight && (K = `${K}${Sde(e.weight, e?.weightUnit)}`), Ht(() => {
    e.address && e.formActions.updateFormValue({
      key: "address",
      value: e.address
    }), t.addEventListener("photon-ticket-created-duplicate", () => {
      S0(e.formActions, K ? {
        notes: K
      } : void 0);
    });
  }), le(() => {
    !$?.authentication.state.isAuthenticated && !$?.authentication.state.isLoading && !$?.authentication.state.error && $?.autoLogin && $?.authentication.login({
      appState: {
        returnTo: window.location.pathname
      }
    });
  }), le(() => {
    M($?.authentication.state.isLoading || !1);
  }), le(() => {
    R($?.authentication.state.isAuthenticated || !1);
  });
  const oe = B(() => R5(["write:prescription"], $?.authentication.state.permissions || [])), ae = B(() => {
    const De = e.formStore?.address?.value ?? e.formStore?.patient?.value?.address;
    return De && De.street1;
  }), Me = B(() => (e.formStore?.address?.value ?? e.formStore?.patient?.value?.address)?.id), We = B(() => {
    const De = e.formStore?.address?.value ?? e.formStore?.patient?.value?.address ?? {}, {
      __typename: bt,
      name: Et,
      ...pt
    } = De;
    return {
      street2: "",
      country: "US",
      ...pt
    };
  }), Dt = (De) => {
    const bt = /* @__PURE__ */ new Set();
    return De.filter((Et) => {
      const pt = Et.treatment.id;
      return bt.has(pt) ? !1 : (bt.add(pt), !0);
    });
  }, vt = async () => {
    const De = e.formStore.treatment?.value?.id, bt = n().map(Lde);
    De && bt.push({
      treatment: {
        id: De
      }
    });
    const Et = Dt(bt), {
      data: pt
    } = await xt.query({
      query: Mde,
      variables: {
        patientId: e.formStore.patient?.value.id,
        draftedPrescriptions: Et
      }
    });
    ie(pt?.prescriptionScreen?.alerts ?? []);
  };
  le(() => {
    n().length > 0 && vt();
  });
  const zt = () => {
    de(!0);
  }, Wt = () => L.setIsCombineDialogOpen(!0, () => $e(e.enableOrder), Me(), We()), $e = async (De) => {
    if (I())
      return;
    if (T([]), W(!1), !oe())
      return Yt({
        status: "error",
        header: "Unauthorized",
        body: "You do not have permission to prescribe"
      });
    if (e.enableOrder && Nde(e.formStore?.fulfillmentType?.value, H())) {
      M(!1), Yt({
        status: "error",
        header: "Address required",
        body: "Please add a patient address to place a local pickup or mail order."
      }), T([{
        key: "address",
        error: "Please enter an address for patient..."
      }]);
      return;
    }
    const Et = De && (!e.optionalPatientAddress || pe()) ? ["patient", "address"] : ["patient"];
    e.formActions.validate(Et);
    const pt = e.formActions.getErrors(Et);
    pt.length === 0 ? (M(!0), e.formActions.updateFormValue({
      key: "errors",
      value: []
    }), e.enableOrder ? await Ie() : await Z(), u(n())) : T(pt);
  }, Z = async () => {
    try {
      await a(i(), m_.Active), g({
        trackEventType: "draft_prescriptions_activated",
        properties: {
          prescriptionCount: n().length
        }
      });
    } catch (De) {
      h([De]);
    }
    M(!1);
  }, Ie = async () => {
    const De = $.getSDK().clinical.order.createOrder({}), bt = $.getSDK().clinical.patient.removePatientPreferredPharmacy({}), Et = $.getSDK().clinical.patient.updatePatient({});
    try {
      if (e.formStore.updatePreferredPharmacy?.value && d.pharmacyId && e.formStore.fulfillmentType?.value === "PICK_UP") {
        const Qe = e.formStore.patient?.value;
        Qe?.preferredPharmacies && Qe?.preferredPharmacies?.length > 0 && bt({
          variables: {
            patientId: Qe.id,
            pharmacyId: Qe.preferredPharmacies[0].id
          },
          awaitRefetchQueries: !1
        }), Et({
          variables: {
            id: Qe.id,
            preferredPharmacies: [d.pharmacyId]
          },
          awaitRefetchQueries: !1
        });
      }
      let pt = w();
      d.pharmacyId && (pt = d.pharmacyId), pt || (pt = "");
      const {
        data: At,
        errors: rn
      } = await De({
        variables: {
          ...e.externalOrderId ? {
            externalId: e.externalOrderId
          } : {},
          ...e.groupId ? {
            groupId: e.groupId
          } : {},
          patientId: e.formStore.patient?.value.id,
          pharmacyId: pt,
          fulfillmentType: e.formStore.fulfillmentType?.value || "",
          ...Me() ? {
            addressId: Me()
          } : ae() ? {
            address: We()
          } : {},
          fills: i().map((Qe) => ({
            prescriptionId: Qe
          }))
        },
        refetchQueries: [],
        awaitRefetchQueries: !1
      });
      if (M(!1), rn) {
        p(rn);
        return;
      }
      f(At.createOrder), g({
        trackEventType: "order_created",
        properties: {
          orderId: At.createOrder.id,
          prescriptionCount: n().length,
          fulfillmentType: e.formStore.fulfillmentType?.value || "SEND_TO_PATIENT",
          hasPreferredPharmacy: pe(),
          setAsPreferred: e.formStore.updatePreferredPharmacy?.value ?? !1,
          pharmacyId: pt || null,
          isCombinedOrder: !1
        }
      });
    } catch (pt) {
      p([pt]), M(!1), Yt({
        status: "error",
        header: "Error Creating Order",
        body: pt?.message
      });
    }
  }, Re = () => Q().length > 0 && ee() === !1 ? zt() : e.enableCombineAndDuplicate && L.hasRoutingOrder() ? Wt() : $e(e.enableOrder);
  le(() => {
    e.triggerSubmit && Le(() => Re());
  }), le(() => {
    c(!!(n().length > 0 && e.formStore.patient?.value), e.formStore);
  });
  const xt = $.sdk.apolloClinical, it = B(() => !e.patientId || e.patientId === e.formStore.patient?.value?.id || e.patientId === e.formStore.patient?.value?.externalId), Kt = () => {
    P() && O(!1);
  };
  return (() => {
    var De = Pde(), bt = De.firstChild, Et = bt.firstChild, pt = t;
    return typeof pt == "function" ? Rt(pt, De) : t = De, N(De, v(q, {
      get when() {
        return gt(() => !!(Ce() && Q().length > 0))() && !ee();
      },
      get children() {
        return v(Vee, {
          get alerts() {
            return Q();
          },
          get isOpen() {
            return Ce();
          },
          onIgnoreWarningAndCreateAnyway: () => {
            M(!1), W(!0), de(!1), Re(), m(Q()), g({
              trackEventType: "screening_alert_acknowledged",
              properties: {
                screeningAlertCount: Q().length
              }
            });
          },
          onRevisitPrescriptions: () => {
            M(!1), de(!1), y(Q()), g({
              trackEventType: "screening_alert_canceled",
              properties: {
                screeningAlertCount: Q().length
              }
            });
          }
        });
      }
    }), bt), N(De, v(q, {
      get when() {
        return e.enableCombineAndDuplicate;
      },
      get children() {
        return [v(Gi.DuplicateDialog, {}), v(Gi.CombineDialog, {}), v(Gi.IssueDialog, {})];
      }
    }), bt), N(bt, v(Wre, {
      get buffer() {
        return e?.toastBuffer || 0;
      }
    }), Et), N(Et, v(q, {
      get when() {
        return gt(() => !!(!$ || I()))() && !D();
      },
      get children() {
        var At = Cde();
        return N(At, v(Fi, {
          color: "green"
        })), At;
      }
    }), null), N(Et, v(Jk, {
      permissions: ["read:patient"],
      get children() {
        return v(nne, {
          client: xt,
          get children() {
            return [v(q, {
              get when() {
                return !oe();
              },
              get children() {
                return v(gc, {
                  type: "warning",
                  header: "You do not have permission to prescribe",
                  message: "You have access to see the form but you will not be able to submit any prescriptions."
                });
              }
            }), v($de, {
              get actions() {
                return e.formActions;
              },
              get store() {
                return e.formStore;
              },
              get patientId() {
                return e.patientId;
              },
              client: $,
              get enableOrder() {
                return e.enableOrder;
              },
              get address() {
                return e.address;
              },
              get weight() {
                return e.weight;
              },
              get weightUnit() {
                return e.weightUnit;
              },
              get enableMedHistory() {
                return e.enableMedHistory;
              },
              get enableMedHistoryLinks() {
                return e.enableMedHistoryLinks ?? !1;
              },
              get enableMedHistoryRefillButton() {
                return e.enableMedHistoryRefillButton ?? !1;
              },
              get hidePatientCard() {
                return e.hidePatientCard;
              },
              get optionalPatientAddress() {
                return e.optionalPatientAddress;
              }
            }), v(q, {
              get when() {
                return (
                  // if patientId is passed in, we need to ensure it matches the patient id in our store
                  // so we are not referencing stale data
                  gt(() => !!it())() && // if orders are enabled, we need a patient's address (unless address is optional)
                  (e.formStore.patient?.value?.address || // if orders are disabled, we need only a patient id
                  e.formStore.patient?.value?.id && !e.enableOrder || // optionalpatientaddress skips address requirement unless a preferred pharmacy is set
                  e.formStore.patient?.value?.id && e.optionalPatientAddress && !pe())
                );
              },
              get children() {
                return [v(q, {
                  get when() {
                    return e.enableCombineAndDuplicate;
                  },
                  get children() {
                    return v(Gi.Card, {});
                  }
                }), v(q, {
                  get when() {
                    return _() || P();
                  },
                  get children() {
                    var At = Tde(), rn = r;
                    return typeof rn == "function" ? Rt(rn, At) : r = At, N(At, v(tde, {
                      get hideAddToTemplates() {
                        return e.hideTemplates;
                      },
                      get actions() {
                        return e.formActions;
                      },
                      get store() {
                        return e.formStore;
                      },
                      get weight() {
                        return e.weight;
                      },
                      get weightUnit() {
                        return e.weightUnit;
                      },
                      prefillNotes: K,
                      get enableCombineAndDuplicate() {
                        return e.enableCombineAndDuplicate;
                      },
                      screenDraftedPrescriptions: function() {
                        vt();
                      },
                      draftedPrescriptionChanged: function() {
                        vt();
                      },
                      onDraftPrescriptionCreated: Kt,
                      get screeningAlerts() {
                        return Q();
                      },
                      get catalogId() {
                        return e.catalogId;
                      },
                      get allowOffCatalogSearch() {
                        return e.allowOffCatalogSearch;
                      },
                      get enableOrder() {
                        return e.enableOrder;
                      },
                      get disableList() {
                        return e.disableList;
                      }
                    })), At;
                  }
                }), v(sde, {
                  prescriptionRef: r,
                  get actions() {
                    return e.formActions;
                  },
                  get store() {
                    return e.formStore;
                  },
                  setIsEditing: O,
                  handleDraftPrescriptionsChange: function() {
                    vt();
                  },
                  get screeningAlerts() {
                    return Q();
                  },
                  get routingConstraints() {
                    return s();
                  },
                  get enableOrder() {
                    return e.enableOrder;
                  }
                }), v(q, {
                  get when() {
                    return gt(() => !!e.enableOrder)() && !w();
                  },
                  get children() {
                    return v(hde, {
                      get store() {
                        return e.formStore;
                      },
                      get actions() {
                        return e.formActions;
                      },
                      get enableLocalPickup() {
                        return e.enableLocalPickup;
                      },
                      get enableSendToPatient() {
                        return e.enableSendToPatient;
                      },
                      get enableDeliveryPharmacies() {
                        return e.enableDeliveryPharmacies;
                      },
                      get mailOrderIds() {
                        return e.mailOrderIds;
                      }
                    });
                  }
                }), v(q, {
                  get when() {
                    return Te() && e.formStore.patient?.value?.id;
                  },
                  get children() {
                    return v(pw, {
                      get patientId() {
                        return e.formStore.patient?.value?.id;
                      },
                      showRequiredBanner: !1,
                      openStateDropdownUpward: !0,
                      setAddress: (At) => {
                        e.formActions.updateFormValue({
                          key: "address",
                          value: At
                        }), e.formActions.updateFormValue({
                          key: "patient",
                          value: {
                            ...e.formStore.patient.value,
                            address: At
                          }
                        });
                      }
                    });
                  }
                }), v(q, {
                  get when() {
                    return gt(() => !!e.enableOrder)() && w();
                  },
                  get children() {
                    return v(Ede, {
                      get pharmacyId() {
                        return w();
                      }
                    });
                  }
                }), v(q, {
                  get when() {
                    return !e.hideSubmit;
                  },
                  get children() {
                    return [v(q, {
                      get when() {
                        return S().length > 0 && e.enableOrder;
                      },
                      get children() {
                        var At = Ade();
                        return N(At, v(dt, {
                          get each() {
                            return S();
                          },
                          get fallback() {
                            return Ide();
                          },
                          children: ({
                            key: rn,
                            error: Qe
                          }) => v(gc, {
                            type: "warning",
                            header: `Error with ${rn}`,
                            message: Qe
                          })
                        })), At;
                      }
                    }), (() => {
                      var At = Ode();
                      return N(At, v(q, {
                        get when() {
                          return !_();
                        },
                        get children() {
                          return v(ct, {
                            variant: "secondary",
                            onClick: () => x(!0),
                            children: "Add Prescription"
                          });
                        }
                      }), null), N(At, v(ct, {
                        get loading() {
                          return o() || I();
                        },
                        onClick: Re,
                        children: "Send"
                      }), null), At;
                    })()];
                  }
                })];
              }
            })];
          }
        });
      }
    }), null), De;
  })();
}
const Lde = (e) => ({
  dispenseAsWritten: e.dispenseAsWritten || void 0,
  dispenseQuantity: e.dispenseQuantity,
  dispenseUnit: e.dispenseUnit,
  fillsAllowed: e.fillsAllowed,
  daysSupply: e.daysSupply || void 0,
  instructions: e.instructions,
  notes: e.notes || void 0,
  // TODO: is effectiveDate needed to screen prescription?
  effectiveDate: e.effectiveDate,
  treatment: {
    id: e.treatment.id
  }
}), Fde = ".remove-icon-button::part(base):hover,.remove-icon-button::part(base):focus{--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}.edit-icon-button::part(base):hover,.edit-icon-button::part(base):focus{--tw-text-opacity: 1;color:rgb(234,179,8,var(--tw-text-opacity))}.enable-switch{--width: 60px;--height: 32px;--thumb-size: 26px;--sl-color-primary-600: #22c55e}";
tn.define("sl-icon-button");
var jde = hn`
  :host {
    display: inline-block;
  }

  :host([size='small']) {
    --height: var(--sl-toggle-size-small);
    --thumb-size: calc(var(--sl-toggle-size-small) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-small);
  }

  :host([size='medium']) {
    --height: var(--sl-toggle-size-medium);
    --thumb-size: calc(var(--sl-toggle-size-medium) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-medium);
  }

  :host([size='large']) {
    --height: var(--sl-toggle-size-large);
    --thumb-size: calc(var(--sl-toggle-size-large) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-large);
  }

  .switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    font-family: var(--sl-input-font-family);
    font-size: inherit;
    font-weight: var(--sl-input-font-weight);
    color: var(--sl-input-label-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .switch__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--width);
    height: var(--height);
    background-color: var(--sl-color-neutral-400);
    border: solid var(--sl-input-border-width) var(--sl-color-neutral-400);
    border-radius: var(--height);
    transition:
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) background-color;
  }

  .switch__control .switch__thumb {
    width: var(--thumb-size);
    height: var(--thumb-size);
    background-color: var(--sl-color-neutral-0);
    border-radius: 50%;
    border: solid var(--sl-input-border-width) var(--sl-color-neutral-400);
    translate: calc((var(--width) - var(--height)) / -2);
    transition:
      var(--sl-transition-fast) translate ease,
      var(--sl-transition-fast) background-color,
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) box-shadow;
  }

  .switch__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  /* Hover */
  .switch:not(.switch--checked):not(.switch--disabled) .switch__control:hover {
    background-color: var(--sl-color-neutral-400);
    border-color: var(--sl-color-neutral-400);
  }

  .switch:not(.switch--checked):not(.switch--disabled) .switch__control:hover .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-neutral-400);
  }

  /* Focus */
  .switch:not(.switch--checked):not(.switch--disabled) .switch__input:focus-visible ~ .switch__control {
    background-color: var(--sl-color-neutral-400);
    border-color: var(--sl-color-neutral-400);
  }

  .switch:not(.switch--checked):not(.switch--disabled) .switch__input:focus-visible ~ .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Checked */
  .switch--checked .switch__control {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch--checked .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    translate: calc((var(--width) - var(--height)) / 2);
  }

  /* Checked + hover */
  .switch.switch--checked:not(.switch--disabled) .switch__control:hover {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch.switch--checked:not(.switch--disabled) .switch__control:hover .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
  }

  /* Checked + focus */
  .switch.switch--checked:not(.switch--disabled) .switch__input:focus-visible ~ .switch__control {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch.switch--checked:not(.switch--disabled) .switch__input:focus-visible ~ .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Disabled */
  .switch--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .switch__label {
    display: inline-block;
    line-height: var(--height);
    margin-inline-start: 0.5em;
    user-select: none;
    -webkit-user-select: none;
  }

  :host([required]) .switch__label::after {
    content: var(--sl-input-required-content);
    color: var(--sl-input-required-content-color);
    margin-inline-start: var(--sl-input-required-content-offset);
  }

  @media (forced-colors: active) {
    .switch.switch--checked:not(.switch--disabled) .switch__control:hover .switch__thumb,
    .switch--checked .switch__control .switch__thumb {
      background-color: ButtonText;
    }
  }
`, Wr = class extends Br {
  constructor() {
    super(...arguments), this.formControlController = new Mk(this, {
      value: (e) => e.checked ? e.value || "on" : void 0,
      defaultValue: (e) => e.defaultChecked,
      setValue: (e, t) => e.checked = t
    }), this.hasSlotController = new lu(this, "help-text"), this.hasFocus = !1, this.title = "", this.name = "", this.size = "medium", this.disabled = !1, this.checked = !1, this.defaultChecked = !1, this.form = "", this.required = !1, this.helpText = "";
  }
  /** Gets the validity state object */
  get validity() {
    return this.input.validity;
  }
  /** Gets the validation message */
  get validationMessage() {
    return this.input.validationMessage;
  }
  firstUpdated() {
    this.formControlController.updateValidity();
  }
  handleBlur() {
    this.hasFocus = !1, this.emit("sl-blur");
  }
  handleInput() {
    this.emit("sl-input");
  }
  handleInvalid(e) {
    this.formControlController.setValidity(!1), this.formControlController.emitInvalidEvent(e);
  }
  handleClick() {
    this.checked = !this.checked, this.emit("sl-change");
  }
  handleFocus() {
    this.hasFocus = !0, this.emit("sl-focus");
  }
  handleKeyDown(e) {
    e.key === "ArrowLeft" && (e.preventDefault(), this.checked = !1, this.emit("sl-change"), this.emit("sl-input")), e.key === "ArrowRight" && (e.preventDefault(), this.checked = !0, this.emit("sl-change"), this.emit("sl-input"));
  }
  handleCheckedChange() {
    this.input.checked = this.checked, this.formControlController.updateValidity();
  }
  handleDisabledChange() {
    this.formControlController.setValidity(!0);
  }
  /** Simulates a click on the switch. */
  click() {
    this.input.click();
  }
  /** Sets focus on the switch. */
  focus(e) {
    this.input.focus(e);
  }
  /** Removes focus from the switch. */
  blur() {
    this.input.blur();
  }
  /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */
  checkValidity() {
    return this.input.checkValidity();
  }
  /** Gets the associated form, if one exists. */
  getForm() {
    return this.formControlController.getForm();
  }
  /** Checks for validity and shows the browser's validation message if the control is invalid. */
  reportValidity() {
    return this.input.reportValidity();
  }
  /** Sets a custom validation message. Pass an empty string to restore validity. */
  setCustomValidity(e) {
    this.input.setCustomValidity(e), this.formControlController.updateValidity();
  }
  render() {
    const e = this.hasSlotController.test("help-text"), t = this.helpText ? !0 : !!e;
    return Jt`
      <div
        class=${En({
      "form-control": !0,
      "form-control--small": this.size === "small",
      "form-control--medium": this.size === "medium",
      "form-control--large": this.size === "large",
      "form-control--has-help-text": t
    })}
      >
        <label
          part="base"
          class=${En({
      switch: !0,
      "switch--checked": this.checked,
      "switch--disabled": this.disabled,
      "switch--focused": this.hasFocus,
      "switch--small": this.size === "small",
      "switch--medium": this.size === "medium",
      "switch--large": this.size === "large"
    })}
        >
          <input
            class="switch__input"
            type="checkbox"
            title=${this.title}
            name=${this.name}
            value=${Nt(this.value)}
            .checked=${Lk(this.checked)}
            .disabled=${this.disabled}
            .required=${this.required}
            role="switch"
            aria-checked=${this.checked ? "true" : "false"}
            aria-describedby="help-text"
            @click=${this.handleClick}
            @input=${this.handleInput}
            @invalid=${this.handleInvalid}
            @blur=${this.handleBlur}
            @focus=${this.handleFocus}
            @keydown=${this.handleKeyDown}
          />

          <span part="control" class="switch__control">
            <span part="thumb" class="switch__thumb"></span>
          </span>

          <div part="label" class="switch__label">
            <slot></slot>
          </div>
        </label>

        <div
          aria-hidden=${t ? "false" : "true"}
          class="form-control__help-text"
          id="help-text"
          part="form-control-help-text"
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
  }
};
Wr.styles = [zn, Nk, jde];
V([
  Er('input[type="checkbox"]')
], Wr.prototype, "input", 2);
V([
  ou()
], Wr.prototype, "hasFocus", 2);
V([
  ne()
], Wr.prototype, "title", 2);
V([
  ne()
], Wr.prototype, "name", 2);
V([
  ne()
], Wr.prototype, "value", 2);
V([
  ne({ reflect: !0 })
], Wr.prototype, "size", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], Wr.prototype, "disabled", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], Wr.prototype, "checked", 2);
V([
  Dk("checked")
], Wr.prototype, "defaultChecked", 2);
V([
  ne({ reflect: !0 })
], Wr.prototype, "form", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], Wr.prototype, "required", 2);
V([
  ne({ attribute: "help-text" })
], Wr.prototype, "helpText", 2);
V([
  Lr("checked", { waitUntilFirstUpdate: !0 })
], Wr.prototype, "handleCheckedChange", 1);
V([
  Lr("disabled", { waitUntilFirstUpdate: !0 })
], Wr.prototype, "handleDisabledChange", 1);
Wr.define("sl-switch");
var xd = /* @__PURE__ */ re("<style>");
fi("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const zde = (e) => {
  const {
    actions: t
  } = du, {
    store: r,
    actions: n
  } = Qk({
    dispenseAsWritten: !1,
    patient: void 0,
    treatment: void 0,
    pharmacy: void 0,
    errors: [],
    address: void 0
  });
  return _r(() => {
    t.clearSelectedPatient(), n.reset();
  }), v(JY, {
    get children() {
      return v(Gi, {
        get patientId() {
          return r.patient?.value?.id;
        },
        get children() {
          return v(uee, {
            get patientId() {
              return r.patient?.value?.id;
            },
            get templateIdsPrefill() {
              return e.templateIds?.split(",").map((i) => i.trim()) || [];
            },
            get templateOverrides() {
              return e.templateOverrides || {};
            },
            get prescriptionIdsPrefill() {
              return e.prescriptionIds?.split(",").map((i) => i.trim()) || [];
            },
            get enableCombineAndDuplicate() {
              return e.enableCombineAndDuplicate;
            },
            get children() {
              return v(mee, {
                get patientId() {
                  return r.patient?.value?.id;
                },
                get enableCoverageCheck() {
                  return e.enableCoverageCheck;
                },
                get children() {
                  return [(() => {
                    var i = xd();
                    return N(i, Tn), i;
                  })(), (() => {
                    var i = xd();
                    return N(i, no), i;
                  })(), (() => {
                    var i = xd();
                    return N(i, io), i;
                  })(), (() => {
                    var i = xd();
                    return N(i, Fde), i;
                  })(), (() => {
                    var i = xd();
                    return N(i, ao), i;
                  })(), v(Rde, {
                    get patientId() {
                      return e.patientId;
                    },
                    get hideSubmit() {
                      return e.hideSubmit;
                    },
                    get hideTemplates() {
                      return e.hideTemplates;
                    },
                    get hidePatientCard() {
                      return e.hidePatientCard;
                    },
                    get enableOrder() {
                      return e.enableOrder;
                    },
                    get enableLocalPickup() {
                      return e.enableLocalPickup;
                    },
                    get enableSendToPatient() {
                      return e.enableSendToPatient;
                    },
                    get enableDeliveryPharmacies() {
                      return e.enableDeliveryPharmacies;
                    },
                    get enableMedHistory() {
                      return e.enableMedHistory;
                    },
                    get enableMedHistoryLinks() {
                      return e.enableMedHistoryLinks;
                    },
                    get enableMedHistoryRefillButton() {
                      return e.enableMedHistoryRefillButton;
                    },
                    get enableCombineAndDuplicate() {
                      return e.enableCombineAndDuplicate;
                    },
                    get optionalPatientAddress() {
                      return e.optionalPatientAddress;
                    },
                    get mailOrderIds() {
                      return e.mailOrderIds;
                    },
                    get pharmacyId() {
                      return e.pharmacyId;
                    },
                    get address() {
                      return e.address;
                    },
                    get weight() {
                      return e.weight;
                    },
                    get weightUnit() {
                      return e.weightUnit;
                    },
                    get additionalNotes() {
                      return e.additionalNotes;
                    },
                    get triggerSubmit() {
                      return e.triggerSubmit;
                    },
                    get toastBuffer() {
                      return e.toastBuffer;
                    },
                    formStore: r,
                    formActions: n,
                    get externalOrderId() {
                      return e.externalOrderId;
                    },
                    get catalogId() {
                      return e.catalogId;
                    },
                    get allowOffCatalogSearch() {
                      return e.allowOffCatalogSearch;
                    },
                    get disableList() {
                      return e.disableList;
                    },
                    get groupId() {
                      return e.groupId;
                    },
                    get initialShowForm() {
                      return !e.templateIds && !e.prescriptionIds;
                    }
                  })];
                }
              });
            }
          });
        }
      });
    }
  });
};
Xr("photon-prescribe-workflow", {
  patientId: void 0,
  templateIds: void 0,
  templateOverrides: void 0,
  prescriptionIds: void 0,
  hideSubmit: !1,
  hideTemplates: !1,
  hidePatientCard: !1,
  enableOrder: !1,
  enableLocalPickup: !1,
  enableSendToPatient: !1,
  enableDeliveryPharmacies: !0,
  enableCombineAndDuplicate: !1,
  enableMedHistory: !1,
  enableMedHistoryRefillButton: !1,
  enableMedHistoryLinks: !1,
  optionalPatientAddress: !1,
  mailOrderIds: void 0,
  pharmacyId: void 0,
  address: void 0,
  weight: void 0,
  weightUnit: "lbs",
  additionalNotes: void 0,
  triggerSubmit: !1,
  toastBuffer: 0,
  externalOrderId: void 0,
  catalogId: void 0,
  allowOffCatalogSearch: !0,
  enableCoverageCheck: !1,
  disableList: void 0,
  groupId: void 0
}, zde);
var Vde = /* @__PURE__ */ re('<p class="font-sans text-l font-medium mb-2">'), Ude = /* @__PURE__ */ re("<sl-icon-button class=self-start>", !0, !1, !1), qde = /* @__PURE__ */ re("<style>"), Bde = /* @__PURE__ */ re('<div class="rounded-lg bg-white p-4 shadow-card border border-gray-200">'), Hde = /* @__PURE__ */ re('<div class="flex flex-row justify-between">'), Wde = /* @__PURE__ */ re("<slot>");
const Kde = (e) => {
  const [t, r] = z(!0);
  let n = null, i = null;
  return e.title && (n = (() => {
    var a = Vde();
    return N(a, () => e.title), a;
  })()), e.collapsable && (i = (() => {
    var a = Ude();
    return Oe(a, "click", () => {
      r(!t());
    }), a._$owner = Pe(), te(() => a.name = t() ? "chevron-right" : "chevron-down"), a;
  })()), [(() => {
    var a = qde();
    return N(a, Tn), a;
  })(), (() => {
    var a = Bde();
    return N(a, n || i ? (() => {
      var o = Hde();
      return N(o, n, null), N(o, i, null), o;
    })() : null, null), N(a, (() => {
      var o = gt(() => !!(e.collapsable && t()));
      return () => o() ? null : (() => {
        var s = Wde();
        return s._$owner = Pe(), s;
      })();
    })(), null), te((o) => {
      var s = !!e.invalid, l = !!e.invalid;
      return s !== o.e && a.classList.toggle("border-red-400", o.e = s), l !== o.t && a.classList.toggle("border-2", o.t = l), o;
    }, {
      e: void 0,
      t: void 0
    }), a;
  })()];
};
Xr("photon-card", {
  invalid: !1,
  title: null,
  collapsable: !1
}, Kde);
var Ed = [], Qde = class {
  constructor(e) {
    this.tabDirection = "forward", this.handleFocusIn = () => {
      this.isActive() && this.checkFocus();
    }, this.handleKeyDown = (t) => {
      var r;
      if (t.key !== "Tab" || this.isExternalActivated || !this.isActive()) return;
      const n = mk();
      if (this.previousFocus = n, this.previousFocus && this.possiblyHasTabbableChildren(this.previousFocus))
        return;
      t.shiftKey ? this.tabDirection = "backward" : this.tabDirection = "forward";
      const i = L5(this.element);
      let a = i.findIndex((s) => s === n);
      this.previousFocus = this.currentFocus;
      const o = this.tabDirection === "forward" ? 1 : -1;
      for (; ; ) {
        a + o >= i.length ? a = 0 : a + o < 0 ? a = i.length - 1 : a += o, this.previousFocus = this.currentFocus;
        const s = (
          /** @type {HTMLElement} */
          i[a]
        );
        if (this.tabDirection === "backward" && this.previousFocus && this.possiblyHasTabbableChildren(this.previousFocus) || s && this.possiblyHasTabbableChildren(s))
          return;
        t.preventDefault(), this.currentFocus = s, (r = this.currentFocus) == null || r.focus({ preventScroll: !1 });
        const l = [..._3()];
        if (l.includes(this.currentFocus) || !l.includes(this.previousFocus))
          break;
      }
      setTimeout(() => this.checkFocus());
    }, this.handleKeyUp = () => {
      this.tabDirection = "forward";
    }, this.element = e, this.elementsWithTabbableControls = ["iframe"];
  }
  /** Activates focus trapping. */
  activate() {
    Ed.push(this.element), document.addEventListener("focusin", this.handleFocusIn), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keyup", this.handleKeyUp);
  }
  /** Deactivates focus trapping. */
  deactivate() {
    Ed = Ed.filter((e) => e !== this.element), this.currentFocus = null, document.removeEventListener("focusin", this.handleFocusIn), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp);
  }
  /** Determines if this modal element is currently active or not. */
  isActive() {
    return Ed[Ed.length - 1] === this.element;
  }
  /** Activates external modal behavior and temporarily disables focus trapping. */
  activateExternal() {
    this.isExternalActivated = !0;
  }
  /** Deactivates external modal behavior and re-enables focus trapping. */
  deactivateExternal() {
    this.isExternalActivated = !1;
  }
  checkFocus() {
    if (this.isActive() && !this.isExternalActivated) {
      const e = L5(this.element);
      if (!this.element.matches(":focus-within")) {
        const t = e[0], r = e[e.length - 1], n = this.tabDirection === "forward" ? t : r;
        typeof n?.focus == "function" && (this.currentFocus = n, n.focus({ preventScroll: !1 }));
      }
    }
  }
  possiblyHasTabbableChildren(e) {
    return this.elementsWithTabbableControls.includes(e.tagName.toLowerCase()) || e.hasAttribute("controls");
  }
}, G5 = /* @__PURE__ */ new Set();
function Gde() {
  const e = document.documentElement.clientWidth;
  return Math.abs(window.innerWidth - e);
}
function Yde() {
  const e = Number(getComputedStyle(document.body).paddingRight.replace(/px/, ""));
  return isNaN(e) || !e ? 0 : e;
}
function T7(e) {
  if (G5.add(e), !document.documentElement.classList.contains("sl-scroll-lock")) {
    const t = Gde() + Yde();
    let r = getComputedStyle(document.documentElement).scrollbarGutter;
    (!r || r === "auto") && (r = "stable"), t < 2 && (r = ""), document.documentElement.style.setProperty("--sl-scroll-lock-gutter", r), document.documentElement.classList.add("sl-scroll-lock"), document.documentElement.style.setProperty("--sl-scroll-lock-size", `${t}px`);
  }
}
function A7(e) {
  G5.delete(e), G5.size === 0 && (document.documentElement.classList.remove("sl-scroll-lock"), document.documentElement.style.removeProperty("--sl-scroll-lock-size"));
}
var Jde = hn`
  :host {
    --width: 31rem;
    --header-spacing: var(--sl-spacing-large);
    --body-spacing: var(--sl-spacing-large);
    --footer-spacing: var(--sl-spacing-large);

    display: contents;
  }

  .dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: var(--sl-z-index-dialog);
  }

  .dialog__panel {
    display: flex;
    flex-direction: column;
    z-index: 2;
    width: var(--width);
    max-width: calc(100% - var(--sl-spacing-2x-large));
    max-height: calc(100% - var(--sl-spacing-2x-large));
    background-color: var(--sl-panel-background-color);
    border-radius: var(--sl-border-radius-medium);
    box-shadow: var(--sl-shadow-x-large);
  }

  .dialog__panel:focus {
    outline: none;
  }

  /* Ensure there's enough vertical padding for phones that don't update vh when chrome appears (e.g. iPhone) */
  @media screen and (max-width: 420px) {
    .dialog__panel {
      max-height: 80vh;
    }
  }

  .dialog--open .dialog__panel {
    display: flex;
    opacity: 1;
  }

  .dialog__header {
    flex: 0 0 auto;
    display: flex;
  }

  .dialog__title {
    flex: 1 1 auto;
    font: inherit;
    font-size: var(--sl-font-size-large);
    line-height: var(--sl-line-height-dense);
    padding: var(--header-spacing);
    margin: 0;
  }

  .dialog__header-actions {
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    gap: var(--sl-spacing-2x-small);
    padding: 0 var(--header-spacing);
  }

  .dialog__header-actions sl-icon-button,
  .dialog__header-actions ::slotted(sl-icon-button) {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-medium);
  }

  .dialog__body {
    flex: 1 1 auto;
    display: block;
    padding: var(--body-spacing);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .dialog__footer {
    flex: 0 0 auto;
    text-align: right;
    padding: var(--footer-spacing);
  }

  .dialog__footer ::slotted(sl-button:not(:first-of-type)) {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  .dialog:not(.dialog--has-footer) .dialog__footer {
    display: none;
  }

  .dialog__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: var(--sl-overlay-background-color);
  }

  @media (forced-colors: active) {
    .dialog__panel {
      border: solid 1px var(--sl-color-neutral-0);
    }
  }
`, zi = class extends Br {
  constructor() {
    super(...arguments), this.hasSlotController = new lu(this, "footer"), this.localize = new ro(this), this.modal = new Qde(this), this.open = !1, this.label = "", this.noHeader = !1, this.handleDocumentKeyDown = (e) => {
      e.key === "Escape" && this.modal.isActive() && this.open && (e.stopPropagation(), this.requestClose("keyboard"));
    };
  }
  firstUpdated() {
    this.dialog.hidden = !this.open, this.open && (this.addOpenListeners(), this.modal.activate(), T7(this));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.modal.deactivate(), A7(this), this.removeOpenListeners();
  }
  requestClose(e) {
    if (this.emit("sl-request-close", {
      cancelable: !0,
      detail: { source: e }
    }).defaultPrevented) {
      const r = ei(this, "dialog.denyClose", { dir: this.localize.dir() });
      ti(this.panel, r.keyframes, r.options);
      return;
    }
    this.hide();
  }
  addOpenListeners() {
    var e;
    "CloseWatcher" in window ? ((e = this.closeWatcher) == null || e.destroy(), this.closeWatcher = new CloseWatcher(), this.closeWatcher.onclose = () => this.requestClose("keyboard")) : document.addEventListener("keydown", this.handleDocumentKeyDown);
  }
  removeOpenListeners() {
    var e;
    (e = this.closeWatcher) == null || e.destroy(), document.removeEventListener("keydown", this.handleDocumentKeyDown);
  }
  async handleOpenChange() {
    if (this.open) {
      this.emit("sl-show"), this.addOpenListeners(), this.originalTrigger = document.activeElement, this.modal.activate(), T7(this);
      const e = this.querySelector("[autofocus]");
      e && e.removeAttribute("autofocus"), await Promise.all([Ci(this.dialog), Ci(this.overlay)]), this.dialog.hidden = !1, requestAnimationFrame(() => {
        this.emit("sl-initial-focus", { cancelable: !0 }).defaultPrevented || (e ? e.focus({ preventScroll: !0 }) : this.panel.focus({ preventScroll: !0 })), e && e.setAttribute("autofocus", "");
      });
      const t = ei(this, "dialog.show", { dir: this.localize.dir() }), r = ei(this, "dialog.overlay.show", { dir: this.localize.dir() });
      await Promise.all([
        ti(this.panel, t.keyframes, t.options),
        ti(this.overlay, r.keyframes, r.options)
      ]), this.emit("sl-after-show");
    } else {
      Gk(this), this.emit("sl-hide"), this.removeOpenListeners(), this.modal.deactivate(), await Promise.all([Ci(this.dialog), Ci(this.overlay)]);
      const e = ei(this, "dialog.hide", { dir: this.localize.dir() }), t = ei(this, "dialog.overlay.hide", { dir: this.localize.dir() });
      await Promise.all([
        ti(this.overlay, t.keyframes, t.options).then(() => {
          this.overlay.hidden = !0;
        }),
        ti(this.panel, e.keyframes, e.options).then(() => {
          this.panel.hidden = !0;
        })
      ]), this.dialog.hidden = !0, this.overlay.hidden = !1, this.panel.hidden = !1, A7(this);
      const r = this.originalTrigger;
      typeof r?.focus == "function" && setTimeout(() => r.focus()), this.emit("sl-after-hide");
    }
  }
  /** Shows the dialog. */
  async show() {
    if (!this.open)
      return this.open = !0, Za(this, "sl-after-show");
  }
  /** Hides the dialog */
  async hide() {
    if (this.open)
      return this.open = !1, Za(this, "sl-after-hide");
  }
  render() {
    return Jt`
      <div
        part="base"
        class=${En({
      dialog: !0,
      "dialog--open": this.open,
      "dialog--has-footer": this.hasSlotController.test("footer")
    })}
      >
        <div part="overlay" class="dialog__overlay" @click=${() => this.requestClose("overlay")} tabindex="-1"></div>

        <div
          part="panel"
          class="dialog__panel"
          role="dialog"
          aria-modal="true"
          aria-hidden=${this.open ? "false" : "true"}
          aria-label=${Nt(this.noHeader ? this.label : void 0)}
          aria-labelledby=${Nt(this.noHeader ? void 0 : "title")}
          tabindex="-1"
        >
          ${this.noHeader ? "" : Jt`
                <header part="header" class="dialog__header">
                  <h2 part="title" class="dialog__title" id="title">
                    <slot name="label"> ${this.label.length > 0 ? this.label : "\uFEFF"} </slot>
                  </h2>
                  <div part="header-actions" class="dialog__header-actions">
                    <slot name="header-actions"></slot>
                    <sl-icon-button
                      part="close-button"
                      exportparts="base:close-button__base"
                      class="dialog__close"
                      name="x-lg"
                      label=${this.localize.term("close")}
                      library="system"
                      @click="${() => this.requestClose("close-button")}"
                    ></sl-icon-button>
                  </div>
                </header>
              `}
          ${""}
          <div part="body" class="dialog__body" tabindex="-1"><slot></slot></div>

          <footer part="footer" class="dialog__footer">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
    `;
  }
};
zi.styles = [zn, Jde];
zi.dependencies = {
  "sl-icon-button": tn
};
V([
  Er(".dialog")
], zi.prototype, "dialog", 2);
V([
  Er(".dialog__panel")
], zi.prototype, "panel", 2);
V([
  Er(".dialog__overlay")
], zi.prototype, "overlay", 2);
V([
  ne({ type: Boolean, reflect: !0 })
], zi.prototype, "open", 2);
V([
  ne({ reflect: !0 })
], zi.prototype, "label", 2);
V([
  ne({ attribute: "no-header", type: Boolean, reflect: !0 })
], zi.prototype, "noHeader", 2);
V([
  Lr("open", { waitUntilFirstUpdate: !0 })
], zi.prototype, "handleOpenChange", 1);
mi("dialog.show", {
  keyframes: [
    { opacity: 0, scale: 0.8 },
    { opacity: 1, scale: 1 }
  ],
  options: { duration: 250, easing: "ease" }
});
mi("dialog.hide", {
  keyframes: [
    { opacity: 1, scale: 1 },
    { opacity: 0, scale: 0.8 }
  ],
  options: { duration: 250, easing: "ease" }
});
mi("dialog.denyClose", {
  keyframes: [{ scale: 1 }, { scale: 1.02 }, { scale: 1 }],
  options: { duration: 250 }
});
mi("dialog.overlay.show", {
  keyframes: [{ opacity: 0 }, { opacity: 1 }],
  options: { duration: 250 }
});
mi("dialog.overlay.hide", {
  keyframes: [{ opacity: 1 }, { opacity: 0 }],
  options: { duration: 250 }
});
zi.define("sl-dialog");
const Zde = '.dialog::part(overlay){background-color:#0000007a}.dialog::part(body){padding-bottom:.25rem}.dialog::part(footer){padding-top:0}.hideFooter::part(footer){display:none}.showHeader::part(body){padding-top:0}.dialog::part(title){font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-weight:500}';
var Sd = /* @__PURE__ */ re("<style>"), Xde = /* @__PURE__ */ re('<slot name=label><p class="text-xl font-sans font-medium">'), ece = /* @__PURE__ */ re('<sl-dialog class=dialog><div><slot></slot></div><div class="flex flex-col xs:flex-row justify-end gap-2"slot=footer>', !0, !1, !1);
fi("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const tce = (e) => {
  let t;
  const r = (n) => {
    const i = new CustomEvent(n, {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(i);
  };
  return [(() => {
    var n = Sd();
    return N(n, ao), n;
  })(), (() => {
    var n = Sd();
    return N(n, Tn), n;
  })(), (() => {
    var n = Sd();
    return N(n, no), n;
  })(), (() => {
    var n = Sd();
    return N(n, io), n;
  })(), (() => {
    var n = Sd();
    return N(n, Zde), n;
  })(), (() => {
    var n = ece(), i = n.firstChild, a = i.firstChild, o = i.nextSibling;
    Oe(n, "sl-request-close", (l) => {
      l.detail.source === "overlay" && !e.overlayClose || l.detail.source === "keyboard" ? l.preventDefault() : r("photon-dialog-canceled");
    });
    var s = t;
    return typeof s == "function" ? Rt(s, n) : t = n, n._$owner = Pe(), N(n, v(q, {
      get when() {
        return !e.header;
      },
      get children() {
        var l = Xde(), d = l.firstChild;
        return l._$owner = Pe(), N(d, () => e.label), l;
      }
    }), i), a._$owner = Pe(), N(o, v(ct, {
      variant: "secondary",
      get disabled() {
        return e.disableButtons || e.loading;
      },
      onClick: () => {
        r("photon-dialog-alt");
      },
      get children() {
        return e.cancelText;
      }
    }), null), N(o, v(ct, {
      get disabled() {
        return e.disableButtons || e.disableSubmit;
      },
      get loading() {
        return e.loading;
      },
      onClick: () => {
        r("photon-dialog-confirmed");
      },
      get children() {
        return e.confirmText;
      }
    }), null), te((l) => {
      var d = !!e.hideFooter, c = !!e.header, u = `--width: ${e.width};`, h = e.label, f = e.open, p = !e.header, m = `font-sans ${e.header ? "pb-4" : "py-4"}`, y = !!e.hideFooter;
      return d !== l.e && n.classList.toggle("hideFooter", l.e = d), c !== l.t && n.classList.toggle("showHeader", l.t = c), l.a = U7(n, u, l.a), h !== l.o && (n.label = l.o = h), f !== l.i && (n.open = l.i = f), p !== l.n && (n.noHeader = l.n = p), m !== l.s && Zi(i, l.s = m), y !== l.h && o.classList.toggle("hidden", l.h = y), l;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0,
      s: void 0,
      h: void 0
    }), n;
  })()];
};
Xr("photon-dialog", {
  label: void 0,
  header: !0,
  open: !1,
  confirmText: "Yes, Cancel",
  cancelText: "No, Keep Editing",
  disableButtons: !1,
  loading: !1,
  hideFooter: !1,
  disableSubmit: !1,
  width: "500px",
  overlayClose: !1
}, tce);
var rce = /* @__PURE__ */ re('<span class="text-gray-500 text-sm font-normal"> (optional)'), nce = /* @__PURE__ */ re('<p class="font-sans text-lg mt-4 md:!mt-8"role=heading aria-level=3>Address'), ice = /* @__PURE__ */ re('<div class="flex gap-4"><div class="flex-grow min-w-[40%]"></div><div class="flex-grow min-w-[40%]">'), ace = /* @__PURE__ */ re('<div class="w-full flex justify-center">'), oce = /* @__PURE__ */ re('<div><p class="font-sans text-lg flex-grow"role=heading aria-level=2>Patient info</p><div class="flex flex-col"></div><button class="mb-4 mt-8 flex items-center md:!hidden"aria-controls=optional-fields-section><span class="font-sans text-lg"></span></button><div id=optional-fields-section><p class="font-sans text-sm m-0 mt-6">Preferred pharmacy'), sce = /* @__PURE__ */ re('<div class="flex flex-col gap-8">'), lce = /* @__PURE__ */ re('<div class="w-full h-full relative"><style></style><style>');
const dce = (e, t) => {
  const r = e.selectedPatient.data?.address;
  return t.address_zip?.value && _ne(t.address_zip?.value) && t.address_zip?.value != r?.postalCode ? t.address_zip?.value : r ? `${r.street1} ${r.street2 ?? ""} ${r.city}, ${r.state} ${r.postalCode}` : "";
}, cce = (e) => {
  let t;
  const r = Cn(), [n, i] = z(!1), {
    store: a,
    actions: o
  } = du, {
    store: s,
    actions: l
  } = Qk({
    firstName: void 0,
    lastName: void 0,
    dateOfBirth: void 0,
    phone: void 0,
    gender: void 0,
    sex: void 0,
    email: void 0,
    address_street1: void 0,
    address_street2: void 0,
    address_city: void 0,
    address_state: void 0,
    address_zip: void 0,
    preferredPharmacy: void 0
  });
  l.registerValidator({
    key: "firstName",
    validator: br(xo(bn(), 1, 1 / 0), "Please enter a first name.")
  }), l.registerValidator({
    key: "lastName",
    validator: br(xo(bn(), 1, 1 / 0), "Please enter a last name.")
  }), l.registerValidator({
    key: "dateOfBirth",
    validator: br(Qle, "Please enter a valid date of birth.")
  }), l.registerValidator({
    key: "sex",
    validator: br(Poe(Nw.map((p) => p.value)), "Please enter Sex at Birth.")
  }), l.registerValidator({
    key: "phone",
    validator: br(xo(bn(), 12), "Please enter a valid mobile number.")
  }), l.registerValidator({
    key: "email",
    validator: br(Doe([Jle(), Zle()]), "Please enter a valid email.")
  }), l.registerValidator({
    key: "address_street1",
    validator: br(xo(bn(), 1, 1 / 0), "Please enter a valid Street 1.")
  }), l.registerValidator({
    key: "address_city",
    validator: br(xo(bn(), 1, 1 / 0), "Please enter a valid City.")
  }), l.registerValidator({
    key: "address_state",
    validator: br(xo(bn(), 2, 2), "Please enter a valid State.")
  }), l.registerValidator({
    key: "address_zip",
    validator: br(Yle(), "Please enter a valid zip code.")
  }), Ht(() => {
    e.patientId ? o.getSelectedPatient(r.getSDK(), e.patientId) : o.clearSelectedPatient();
  });
  const d = (p) => {
    const m = new CustomEvent("photon-form-updated", {
      composed: !0,
      bubbles: !0,
      detail: {
        form: p,
        actions: l,
        selected: a,
        optionalPatientAddress: e.optionalPatientAddress,
        reset: () => {
          l.reset(), o.reset();
        }
      }
    });
    t?.dispatchEvent(m);
  };
  le(() => {
    a.selectedPatient.data && (l.updateFormValue({
      key: "firstName",
      value: a.selectedPatient.data.name.first
    }), l.updateFormValue({
      key: "lastName",
      value: a.selectedPatient.data.name.last
    }), l.updateFormValue({
      key: "dateOfBirth",
      value: a.selectedPatient.data.dateOfBirth
    }), l.updateFormValue({
      key: "phone",
      value: a.selectedPatient.data.phone
    }), l.updateFormValue({
      key: "gender",
      value: a.selectedPatient.data.gender
    }), l.updateFormValue({
      key: "sex",
      value: a.selectedPatient.data.sex
    }), l.updateFormValue({
      key: "email",
      value: a.selectedPatient.data.email
    }), l.updateFormValue({
      key: "address_street1",
      value: a.selectedPatient.data.address?.street1
    }), l.updateFormValue({
      key: "address_street2",
      value: a.selectedPatient.data.address?.street2
    }), l.updateFormValue({
      key: "address_city",
      value: a.selectedPatient.data.address?.city
    }), l.updateFormValue({
      key: "address_state",
      value: a.selectedPatient.data.address?.state
    }), l.updateFormValue({
      key: "address_zip",
      value: a.selectedPatient.data.address?.postalCode
    }), l.updateFormValue({
      key: "preferredPharmacy",
      value: a.selectedPatient.data.preferredPharmacies?.[0]?.id
    }));
  });
  const c = B(() => !!(s.address_street1?.value || s.address_street2?.value || s.address_city?.value || s.address_state?.value || s.address_zip?.value));
  le(() => {
    d(s);
  }), _r(() => {
    o.clearSelectedPatient(), l.reset();
  });
  const u = B(() => {
    const p = a.selectedPatient.data?.preferredPharmacies?.[0];
    if (!p) return;
    const m = p.address;
    return {
      ...p,
      address: m,
      isPrevious: !0,
      isPreferred: !0
    };
  }), h = (p, m) => {
    Ro({
      trackEventType: "patient_field_interaction",
      properties: {
        fieldName: p,
        hasValue: m
      }
    }, t);
  }, f = () => {
    const p = B(() => !e.optionalPatientAddress || c());
    return [(() => {
      var m = nce();
      return m.firstChild, N(m, v(q, {
        get when() {
          return gt(() => !!e.optionalPatientAddress)() && !c();
        },
        get children() {
          return rce();
        }
      }), null), m;
    })(), v(Ye, {
      label: "Street 1",
      get error() {
        return s.address_street1?.error;
      },
      get required() {
        return p();
      },
      get children() {
        return v(Tt, {
          get value() {
            return s.address_street1?.value ?? a.selectedPatient.data?.address?.street1;
          },
          onInput: (m) => {
            l.updateFormValue({
              key: "address_street1",
              value: m.currentTarget.value
            });
          },
          onBlur: (m) => h("address_street1", !!m.currentTarget.value)
        });
      }
    }), v(Ye, {
      label: "Street 2",
      get error() {
        return s.address_street2?.error;
      },
      get children() {
        return v(Tt, {
          get value() {
            return s.address_street2?.value ?? a.selectedPatient.data?.address?.street2;
          },
          onInput: (m) => {
            l.updateFormValue({
              key: "address_street2",
              value: m.currentTarget.value
            });
          },
          onBlur: (m) => h("address_street2", !!m.currentTarget.value)
        });
      }
    }), v(Ye, {
      label: "City",
      get error() {
        return s.address_city?.error;
      },
      get required() {
        return p();
      },
      get children() {
        return v(Tt, {
          get value() {
            return s.address_city?.value ?? a.selectedPatient.data?.address?.city;
          },
          onInput: (m) => {
            l.updateFormValue({
              key: "address_city",
              value: m.currentTarget.value
            });
          },
          onBlur: (m) => h("address_city", !!m.currentTarget.value)
        });
      }
    }), (() => {
      var m = ice(), y = m.firstChild, g = y.nextSibling;
      return N(y, v(Ye, {
        label: "State",
        get error() {
          return s.address_state?.error;
        },
        get required() {
          return p();
        },
        get children() {
          return v(xW, {
            get value() {
              return s.address_state?.value ?? a.selectedPatient.data?.address?.state;
            },
            onChange: (w) => {
              l.updateFormValue({
                key: "address_state",
                value: w.currentTarget.value
              });
            },
            onBlur: (w) => h("address_state", !!w.currentTarget.value)
          });
        }
      })), N(g, v(Ye, {
        label: "Zip code",
        get error() {
          return s.address_zip?.error;
        },
        get required() {
          return p();
        },
        get children() {
          return v(Tt, {
            get value() {
              return s.address_zip?.value ?? a.selectedPatient.data?.address?.postalCode;
            },
            onInput: (w) => {
              l.updateFormValue({
                key: "address_zip",
                value: w.currentTarget.value
              });
            },
            onBlur: (w) => h("address_zip", !!w.currentTarget.value)
          });
        }
      })), m;
    })()];
  };
  return (() => {
    var p = lce(), m = p.firstChild, y = m.nextSibling, g = t;
    return typeof g == "function" ? Rt(g, p) : t = p, N(m, Tn), N(y, ao), N(p, v(q, {
      get when() {
        return a.selectedPatient.isLoading;
      },
      get children() {
        var w = ace();
        return N(w, v(Fi, {
          color: "green"
        })), w;
      }
    }), null), N(p, v(q, {
      get when() {
        return !a.selectedPatient.isLoading;
      },
      get children() {
        return v(Jk, {
          permissions: ["write:patient"],
          get children() {
            var w = sce();
            return N(w, v(Sn, {
              get children() {
                var $ = oce(), _ = $.firstChild, x = _.nextSibling, S = x.nextSibling, T = S.firstChild, I = S.nextSibling, M = I.firstChild;
                return N(x, v(Ye, {
                  label: "First name",
                  get error() {
                    return s.firstName?.error;
                  },
                  required: !0,
                  get children() {
                    return v(Tt, {
                      get value() {
                        return s.firstName?.value ?? a.selectedPatient.data?.name.first;
                      },
                      onInput: (P) => {
                        l.updateFormValue({
                          key: "firstName",
                          value: P.currentTarget.value
                        });
                      },
                      onBlur: (P) => h("firstName", !!P.currentTarget.value)
                    });
                  }
                }), null), N(x, v(Ye, {
                  label: "Last name",
                  get error() {
                    return s.lastName?.error;
                  },
                  required: !0,
                  get children() {
                    return v(Tt, {
                      get value() {
                        return s.lastName?.value ?? a.selectedPatient.data?.name.last;
                      },
                      onInput: (P) => {
                        l.updateFormValue({
                          key: "lastName",
                          value: P.currentTarget.value
                        });
                      },
                      onBlur: (P) => h("lastName", !!P.currentTarget.value)
                    });
                  }
                }), null), N(x, v(Ye, {
                  label: "Date of birth",
                  get error() {
                    return s.dateOfBirth?.error;
                  },
                  required: !0,
                  get children() {
                    return v(wW, {
                      get value() {
                        return s.dateOfBirth?.value ?? a.selectedPatient.data?.dateOfBirth;
                      },
                      onDateChange: (P) => {
                        l.updateFormValue({
                          key: "dateOfBirth",
                          value: P
                        });
                      },
                      onBlur: (P) => h("dateOfBirth", !!P.currentTarget.value)
                    });
                  }
                }), null), N(x, v(Ye, {
                  label: "Mobile number",
                  get error() {
                    return s.phone?.error;
                  },
                  required: !0,
                  get children() {
                    return v(VG, {
                      get value() {
                        return s.phone?.value ?? a.selectedPatient.data?.phone;
                      },
                      onPhoneChange: (P) => {
                        l.updateFormValue({
                          key: "phone",
                          value: P
                        });
                      },
                      onBlur: (P) => h("phone", !!P.currentTarget.value)
                    });
                  }
                }), null), N(x, v(Ye, {
                  label: "Sex at birth",
                  get error() {
                    return s.sex?.error;
                  },
                  required: !0,
                  get children() {
                    return v(HG, {
                      get value() {
                        return s.sex?.value ?? a.selectedPatient.data?.sex;
                      },
                      onChange: (P) => l.updateFormValue({
                        key: "sex",
                        value: P.currentTarget.value
                      }),
                      onBlur: () => h("sex", !!s.sex?.value)
                    });
                  }
                }), null), N($, v(q, {
                  get when() {
                    return !e.optionalPatientAddress;
                  },
                  get children() {
                    return v(f, {});
                  }
                }), S), S.$$click = () => i((P) => !P), N(T, () => n() ? "Hide optional fields" : "Show optional fields"), N(S, v(et, {
                  get name() {
                    return n() ? "chevronUp" : "chevronDown";
                  },
                  size: "md",
                  class: "inline-block ml-1 mt-1"
                }), null), N(I, v(q, {
                  get when() {
                    return e.optionalPatientAddress;
                  },
                  get children() {
                    return v(f, {});
                  }
                }), M), N(I, v(Ye, {
                  label: "Gender",
                  get error() {
                    return s.gender?.error;
                  },
                  get children() {
                    return v(GG, {
                      get value() {
                        return s.gender?.value ?? a.selectedPatient.data?.gender;
                      },
                      onChange: (P) => l.updateFormValue({
                        key: "gender",
                        value: P.currentTarget.value
                      }),
                      onBlur: () => h("gender", !!s.gender?.value)
                    });
                  }
                }), M), N(I, v(Ye, {
                  label: "Email",
                  get error() {
                    return s.email?.error;
                  },
                  get children() {
                    return v(Tt, {
                      type: "email",
                      get value() {
                        return s.email?.value ?? a.selectedPatient.data?.email;
                      },
                      onInput: (P) => {
                        l.updateFormValue({
                          key: "email",
                          value: P.currentTarget.value
                        });
                      },
                      onBlur: (P) => h("email", !!P.currentTarget.value)
                    });
                  }
                }), M), N(I, v(W$, {
                  get address() {
                    return dce(a, s);
                  },
                  setPharmacy: (P) => {
                    l.updateFormValue({
                      key: "preferredPharmacy",
                      value: P.id
                    });
                  },
                  get patientId() {
                    return e.patientId;
                  },
                  get initialValue() {
                    return u();
                  },
                  hidePreferred: !0
                }), null), te((P) => {
                  var O = n(), D = `mb-4 ${n() ? "block" : "hidden md:!block"}`;
                  return O !== P.e && I0(S, "aria-expanded", P.e = O), D !== P.t && Zi(I, P.t = D), P;
                }, {
                  e: void 0,
                  t: void 0
                }), $;
              }
            })), w;
          }
        });
      }
    }), null), p;
  })();
};
Xr("photon-patient-form", {
  patientId: "",
  optionalPatientAddress: !1
}, cce);
ns(["click"]);
var uce = /* @__PURE__ */ re('<div class="text-black text-xl md:text-3xl">'), hce = /* @__PURE__ */ re("<sl-icon class=flex-shrink-0>", !0, !1, !1), fce = /* @__PURE__ */ re('<footer class="z-40 fixed bottom-0 w-full bg-white shadow-card px-4 py-4 md:px-8"><div class="flex flex-col xs:flex-row-reverse xs:justify-start gap-2 items-center w-full sm:w-[600px] xs:mx-auto sm:px-4">'), pce = /* @__PURE__ */ re('<div class="z-50 fixed top-0 left-0 w-full h-screen overflow-y-auto overflow-x-hidden bg-[#F9FAFB]"><style></style><photon-dialog confirm-text="Yes, Close"cancel-text="Keep Editing"><p class="font-sans text-lg xs:text-base"></p></photon-dialog><header class="z-40 flex items-center px-4 py-2 md:px-8 md:py-3 bg-white fixed w-full shadow-card"><div class="flex items-center"></div><div class="flex-1 flex justify-center items-center min-w-0 px-2"><p class="ml-1 font-sans text-lg md:text-xl font-medium truncate"></p></div><div class="flex items-center w-[44px]"></div></header><div class="z-30 w-full min-h-screen bg-[#F9FAFB] pt-14"><div class="px-4 pb-40 md:pt-4 md:pb-52 md:px-4 w-full h-full sm:w-[600px] xs:mx-auto">', !0, !1, !1);
const v_ = (e) => {
  const t = Ke({
    closeTitle: "Lose unsaved changes?",
    closeBody: "You will not be able to recover unsaved changes.",
    checkShouldWarn: () => !1
  }, e);
  let r;
  const [n, i] = z(!1), a = () => {
    i(!1), t.onClosed();
  }, o = () => i(!1);
  return (() => {
    var s = pce(), l = s.firstChild, d = l.nextSibling, c = d.firstChild, u = d.nextSibling, h = u.firstChild, f = h.nextSibling, p = f.firstChild, m = u.nextSibling, y = m.firstChild, g = r;
    return typeof g == "function" ? Rt(g, s) : r = s, s.style.setProperty("height", "100dvh"), s.style.setProperty("-webkit-overflow-scrolling", "touch"), s.style.setProperty("touch-action", "pan-y"), N(l, Tn), Oe(d, "photon-dialog-alt", o), Oe(d, "photon-dialog-canceled", o), Oe(d, "photon-dialog-confirmed", a), d._$owner = Pe(), N(c, () => t.closeBody), N(h, v(ct, {
      variant: "naked",
      size: "sm",
      onClick: () => {
        t.checkShouldWarn() ? i(!0) : t.onClosed();
      },
      get children() {
        var w = uce();
        return N(w, v(et, {
          name: "xMark"
        })), w;
      }
    })), N(f, v(q, {
      get when() {
        return t.titleIconName;
      },
      get children() {
        var w = hce();
        return w._$owner = Pe(), te(() => w.name = t.titleIconName), w;
      }
    }), p), N(p, () => t.title), N(y, () => t.form), N(s, v(q, {
      get when() {
        return t.footer;
      },
      get children() {
        var w = fce(), $ = w.firstChild;
        return N($, () => t.footer), w;
      }
    }), null), te((w) => {
      var $ = t.closeTitle, _ = n();
      return $ !== w.e && (d.label = w.e = $), _ !== w.t && (d.open = w.t = _), w;
    }, {
      e: void 0,
      t: void 0
    }), s;
  })();
};
var mce = /* @__PURE__ */ re("<div><style>"), gce = /* @__PURE__ */ re('<div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4"role=alert><span class="block sm:inline">'), vce = /* @__PURE__ */ re("<photon-patient-form slot=form>", !0, !1, !1);
const yce = xe`
  fragment PatientFields on Patient {
    id
  }
`, bce = (e) => {
  let t;
  const r = Cn(), [n, i] = z(!1), [a, o] = z(!1), [s, l] = z(void 0), [d, c] = z(void 0), [u, h] = z(void 0), [f, p] = z(void 0), [m, y] = z(!1), [g, w] = z(!1);
  Ht(async () => {
    try {
      const {
        data: T
      } = await r.sdk.clinical.patient.getPatients({
        fragment: {
          PatientFields: yce
        }
      });
      w(T && T.patients.length > 0);
    } catch (T) {
      console.log(T);
    }
  });
  const $ = (T, I = !1) => {
    const M = new CustomEvent("photon-patient-updated", {
      composed: !0,
      bubbles: !0,
      detail: {
        patientId: T,
        didClickCreatePatientAndPrescription: I
      }
    });
    t?.dispatchEvent(M);
  }, _ = (T, I = !1) => {
    const M = new CustomEvent("photon-patient-created", {
      composed: !0,
      bubbles: !0,
      detail: {
        patientId: T,
        createPrescription: I
      }
    });
    t?.dispatchEvent(M);
  }, x = () => {
    const T = new CustomEvent("photon-patient-closed", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(T);
  };
  le(() => {
    e.open && Ro({
      trackEventType: "patient_form_opened",
      properties: {
        isEdit: !!e.patientId
      }
    }, t);
  });
  const S = async (T, I, M, P = !1) => {
    p(void 0), o(P), i(!0);
    const O = ["firstName", "lastName", "dateOfBirth", "phone", "sex", "email"], D = ["address_street1", "address_city", "address_state", "address_zip"], R = !e.optionalPatientAddress || m(), L = R ? [...O, ...D] : O;
    if (I.validate(L), I.hasErrors(L))
      return i(!1), !0;
    T.preferredPharmacy.value && M.selectedPatient.data?.preferredPharmacies && M.selectedPatient.data?.preferredPharmacies.length !== 0 && !M.selectedPatient.data?.preferredPharmacies?.map((ee) => ee?.id).filter((ee) => ee !== null).includes(T.preferredPharmacy.value) && await r.getSDK().clinical.patient.removePatientPreferredPharmacy({})({
      variables: {
        patientId: e.patientId,
        pharmacyId: M.selectedPatient.data?.preferredPharmacies[0].id
      },
      awaitRefetchQueries: !1
    });
    const Q = R, ie = {
      ...e?.patientId ? {
        id: e.patientId
      } : {},
      name: {
        first: T.firstName.value,
        last: T.lastName.value
      },
      gender: T.gender.value,
      email: T.email.value ? T.email.value : void 0,
      phone: T.phone.value,
      dateOfBirth: T.dateOfBirth.value,
      sex: T.sex.value,
      address: Q ? {
        street1: T.address_street1.value,
        street2: T.address_street2.value,
        city: T.address_city.value,
        state: T.address_state.value,
        postalCode: T.address_zip.value,
        country: "US"
      } : void 0,
      preferredPharmacies: T.preferredPharmacy.value ? [T.preferredPharmacy.value] : []
    };
    try {
      if (e?.patientId)
        await r.getSDK().clinical.patient.updatePatient({})({
          variables: ie,
          awaitRefetchQueries: !1
        }), $(e.patientId, P), Ro({
          trackEventType: "patient_updated",
          properties: {
            patientId: e.patientId,
            didClickCreatePatientAndPrescription: P,
            fields: Ff(T, Lf)
          }
        }, t);
      else {
        const H = (await r.getSDK().clinical.patient.createPatient({})({
          variables: ie,
          awaitRefetchQueries: !1
        }))?.data?.createPatient?.id || "";
        _(H, P), Ro({
          trackEventType: "patient_created",
          properties: {
            patientId: H,
            didClickCreatePatientAndPrescription: P,
            fields: Ff(T, Lf)
          }
        }, t);
      }
      i(!1), I.resetStores(), e.open = !1;
    } catch (ee) {
      i(!1), p(ee?.message || "An error occurred while saving the patient.");
    }
  };
  return (() => {
    var T = mce(), I = T.firstChild, M = t;
    return typeof M == "function" ? Rt(M, T) : t = T, N(I, ao), N(T, v(q, {
      get when() {
        return e.open;
      },
      get children() {
        return v(v_, {
          onClosed: () => {
            Ro({
              trackEventType: "patient_form_closed",
              properties: {
                isEdit: !!e.patientId,
                fields: s() ? Ff(s(), Lf) : void 0
              }
            }, t), x(), u().resetStores(), e.open = !1;
          },
          get title() {
            return e?.patientId ? "Edit patient" : "New patient";
          },
          get titleIconName() {
            return e?.patientId ? "pencil-square" : "person-plus";
          },
          get footer() {
            return [v(q, {
              get when() {
                return !e?.hideCreatePrescription;
              },
              get children() {
                return v(ct, {
                  class: "w-full xs:w-fit",
                  size: "lg",
                  get disabled() {
                    return n();
                  },
                  get loading() {
                    return gt(() => !!n())() && a();
                  },
                  onClick: () => S(s(), u(), d(), !0),
                  get children() {
                    return [gt(() => e?.patientId ? "Save" : "Create"), " and start prescription"];
                  }
                });
              }
            }), v(q, {
              get when() {
                return !!g() || !!e?.hideCreatePrescription;
              },
              get children() {
                return v(ct, {
                  class: "w-full xs:w-fit",
                  size: "lg",
                  get variant() {
                    return e?.hideCreatePrescription ? "primary" : "secondary";
                  },
                  get disabled() {
                    return n();
                  },
                  get loading() {
                    return gt(() => !!n())() && !a();
                  },
                  onClick: () => S(s(), u(), d(), !1),
                  get children() {
                    return e?.patientId ? "Save" : "Create";
                  }
                });
              }
            })];
          },
          get form() {
            return [v(q, {
              get when() {
                return f();
              },
              get children() {
                var P = gce(), O = P.firstChild;
                return N(O, f), P;
              }
            }), (() => {
              var P = vce();
              return Oe(P, "photon-form-updated", (O) => {
                l(O.detail.form), h(Object.assign({}, O.detail.actions, {
                  resetStores: O.detail.reset
                })), c(O.detail.selected);
                const D = O.detail.form;
                y(!!(D.address_street1?.value || D.address_street2?.value || D.address_city?.value || D.address_state?.value || D.address_zip?.value));
              }), P._$owner = Pe(), te((O) => {
                var D = e.patientId, R = e.optionalPatientAddress;
                return D !== O.e && (P.patientId = O.e = D), R !== O.t && (P.optionalPatientAddress = O.t = R), O;
              }, {
                e: void 0,
                t: void 0
              }), P;
            })()];
          }
        });
      }
    }), null), T;
  })();
};
Xr("photon-patient-dialog", {
  patientId: "",
  hideCreatePrescription: !1,
  open: !1,
  optionalPatientAddress: !1
}, bce);
var wce = /* @__PURE__ */ re("<photon-patient-dialog>", !0, !1, !1);
const $ce = (e) => (console.warn("photon-update-patient-dialog will be deprecated soon. Please use photon-patient-dialog instead."), (() => {
  var t = wce();
  return t._$owner = Pe(), te((r) => {
    var n = e.patientId, i = e.open;
    return n !== r.e && (t.patientId = r.e = n), i !== r.t && (t.open = r.t = i), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})());
Xr("photon-update-patient-dialog", {
  patientId: "",
  open: !1
}, $ce);
const kce = ".invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.input::part(base){border-radius:var(--photon-border-radius, .5rem)}.input::part(base):hover{cursor:pointer}.disabled::part(base):hover{cursor:not-allowed}.selected::part(base){--tw-bg-opacity: 1;background-color:rgb(49,130,206,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.default::part(base):hover{--tw-bg-opacity: 1;background-color:rgb(229,231,235,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity))}.default::part(label){width:100%;overflow:hidden}.group-member::part(base){padding-left:1rem;font-weight:500}.group{background:#d1e9ff;padding-top:.25rem;padding-bottom:.25rem;--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity));font-size:.75rem;font-weight:500}.treatment-option::part(checked-icon){display:none;width:0px}.full-screen-close-btn::part(base){padding:0}.treatment-search::part(input){padding-right:0}.treatment-search::part(input)::-moz-placeholder{--tw-text-opacity: 1;color:rgb(209,213,219,var(--tw-text-opacity))}.treatment-search::part(input)::placeholder{--tw-text-opacity: 1;color:rgb(209,213,219,var(--tw-text-opacity))}.dropdown::part(panel){box-shadow:none}.dropdown-container{height:100vh;height:100dvh;max-height:100dvh}.dropdown-container-list-items{-webkit-overflow-scrolling:touch;overscroll-behavior:contain;touch-action:pan-y}";
var _ce = /* @__PURE__ */ re('<div slot=suffix class=flex><sl-icon class="text-gray-400 hover:text-gray-600"name=x-circle-fill>', !0, !1, !1), xce = /* @__PURE__ */ re('<div><style></style><style></style><style></style><style></style><div class="dropdown-container fixed top-0 left-0 w-full bg-white overflow-hidden z-2000 flex flex-col"><div class="flex items-center pb-2 pl-5 pr-5 pt-3 flex-shrink-0"><div class="flex items-center"><sl-icon-button name=x label="Close medication search"class=full-screen-close-btn></sl-icon-button></div></div><div class=flex-shrink-0><sl-input slot=trigger clearable autocomplete=off size=medium class="treatment-search input mb-2 px-4"><p slot=help-text class="text-red-400 pt-1 font-sans"></p><div slot=suffix class=flex><sl-spinner slot=suffix></sl-spinner></div></sl-input></div><div class="w-full flex-1 overflow-y-auto .dropdown-container-list-items">', !0, !1, !1), Ece = /* @__PURE__ */ re('<div class="md:flex flex-1 justify-center items-center pl-2"><div class="flex items-center space-x-2"><p class="text-gray-700 text-sm font-sans inline font-medium">'), Sce = /* @__PURE__ */ re('<p class="pl-1 text-red-400">*'), Cce = /* @__PURE__ */ re('<p class="text-gray-400 text-xs pl-2 font-sans">Optional'), Tce = /* @__PURE__ */ re("<div class=px-4><p class=text-gray-400>Loading..."), Ace = /* @__PURE__ */ re("<div class=px-4><p class=text-gray-400>No treatments found"), Oce = /* @__PURE__ */ re('<div class="group uppercase px-4">'), Pce = /* @__PURE__ */ re("<div class=treatment-option>"), Ice = /* @__PURE__ */ re('<p class="text-center text-gray-400 italic px-3">Loading...'), Dce = /* @__PURE__ */ re('<p class="text-center text-gray-400 italic px-3">Nothing more to load'), Nce = /* @__PURE__ */ re('<div class="px-4 py-1">');
fi("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const Mce = (e) => {
  let t, r, n;
  e.actionRef && (e.actionRef.clear = () => {
    n.value = "", i(""), s();
  });
  const i = hh(async (c) => {
    e.onSearchChange && await e.onSearchChange(c);
  }, 500), a = (c) => {
    if (c)
      return e.helpText ? e.helpText : e.required ? "Please select data..." : void 0;
  }, o = (c) => {
    const u = new CustomEvent("photon-data-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        data: c
      }
    });
    t?.dispatchEvent(u);
  }, s = () => {
    const c = new CustomEvent("photon-data-unselected", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(c);
  };
  Ht(() => {
    n && (n.addEventListener("keydown", (c) => {
      (c.code == "Space" || c.key == " ") && c.stopImmediatePropagation();
    }), setTimeout(() => {
      n.focus();
    }, 100));
  }), le(() => {
    if (e.open) {
      const c = window.scrollY;
      document.body.style.position = "fixed", document.body.style.top = `-${c}px`, document.body.style.width = "100%", document.body.style.overflow = "hidden", _r(() => {
        const u = document.body.style.top;
        document.body.style.position = "", document.body.style.top = "", document.body.style.width = "", document.body.style.overflow = "", window.scrollTo(0, parseInt(u || "0") * -1);
      });
    }
  });
  const l = B(() => e.groups ? e.groups.map((c) => {
    const u = e.data.map((h, f) => ({
      data: h,
      allItemsIdx: f
    })).filter((h) => c.filter(h.data));
    return u.length > 0 ? [{
      title: c.label
    }, ...u] : [];
  }).flat() : e.data.map((c, u) => ({
    data: c,
    allItemsIdx: u
  }))), d = B(() => N3({
    count: l().length,
    getScrollElement: () => r ?? null,
    estimateSize: () => 42,
    overscan: 100
  }));
  return (() => {
    var c = xce(), u = c.firstChild, h = u.nextSibling, f = h.nextSibling, p = f.nextSibling, m = p.nextSibling, y = m.firstChild, g = y.firstChild, w = g.firstChild, $ = y.nextSibling, _ = $.firstChild, x = _.firstChild, S = x.nextSibling, T = S.firstChild, I = $.nextSibling, M = t;
    typeof M == "function" ? Rt(M, c) : t = c, N(u, Tn), N(h, no), N(f, io), N(p, kce), m.$$touchstart = (D) => D.stopPropagation(), m.$$touchmove = (D) => D.stopPropagation(), y.style.setProperty("touch-action", "none"), g.style.setProperty("font-size", "26px"), Oe(w, "click", () => {
      e.onClose && e.onClose();
    }), w.style.setProperty("padding", "0px"), w._$owner = Pe(), N(y, (() => {
      var D = gt(() => !!e.label);
      return () => D() ? (() => {
        var R = Ece(), L = R.firstChild, Q = L.firstChild;
        return N(Q, () => e.label), R;
      })() : null;
    })(), null), N(y, (() => {
      var D = gt(() => !!e.required);
      return () => D() ? Sce() : null;
    })(), null), N(y, (() => {
      var D = gt(() => !!e.optional);
      return () => D() ? Cce() : null;
    })(), null), $.$$touchstart = (D) => D.stopPropagation(), $.$$touchmove = (D) => D.stopPropagation(), $.style.setProperty("touch-action", "none"), Oe(_, "sl-clear", () => {
      n.value = "", i(""), s();
    }), Oe(_, "input", (D) => {
      i(D.target.value);
    });
    var P = n;
    typeof P == "function" ? Rt(P, _) : n = _, _.style.setProperty("border-radius", "0px"), _.style.setProperty("border", "0px"), _._$owner = Pe(), N(x, () => a(e.invalid ?? !1)), T._$owner = Pe(), N(_, v(q, {
      get when() {
        return e.clearable;
      },
      get children() {
        var D = _ce(), R = D.firstChild;
        return Oe(R, "click", (L) => {
          L.stopImmediatePropagation(), n.value = "", i(""), s();
        }), R._$owner = Pe(), te(() => D.classList.toggle("hidden", !!(e.isLoading || !e.selectedData))), D;
      }
    }), null);
    var O = r;
    return typeof O == "function" ? Rt(O, I) : r = I, N(I, v(dt, {
      get each() {
        return d().getVirtualItems();
      },
      get fallback() {
        return v(Rce, {
          get isLoading() {
            return e.isLoading;
          }
        });
      },
      children: (D) => {
        const R = D.index > l().length - 1, L = l()[D.index], Q = e.selectedData, ie = !R && !!Q && "id" in Q && "data" in L && Q.id === L.data.id, ee = "title" in L ? Lce : Fce, W = "title" in L ? {
          item: L
        } : {
          item: D,
          isLoader: R,
          isSelected: ie,
          index: D.index,
          hasMore: e.hasMore,
          showOverflow: e.showOverflow,
          onClick: () => {
            R || (n.value = "", i(""), o(L.data));
          }
        };
        return v(dx, Ke({
          component: ee
        }, W, {
          get children() {
            return gt(() => "data" in L)() && e.displayAccessor(L.data, !0);
          }
        }));
      }
    })), te((D) => {
      var R = e.placeholder, L = e.disabled ?? !1, Q = !!(e.invalid ?? !1), ie = !!(e.disabled ?? !1), ee = e.required, W = !!e.forceLabelSize, H = !e.isLoading;
      return R !== D.e && (_.placeholder = D.e = R), L !== D.t && (_.disabled = D.t = L), Q !== D.a && _.classList.toggle("invalid", D.a = Q), ie !== D.o && _.classList.toggle("disabled", D.o = ie), ee !== D.i && (_.required = D.i = ee), W !== D.n && x.classList.toggle("h-[21px]", D.n = W), H !== D.s && S.classList.toggle("hidden", D.s = H), D;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0,
      s: void 0
    }), te(() => _.value = e.searchText), c;
  })();
}, Rce = (e) => v(q, {
  get when() {
    return e.isLoading;
  },
  get fallback() {
    return Ace();
  },
  get children() {
    return Tce();
  }
}), Lce = (e) => (() => {
  var t = Oce();
  return t.style.setProperty("position", "sticky"), t.style.setProperty("top", "0px"), t.style.setProperty("z-index", "10"), N(t, () => e.item.title), t;
})(), Fce = (e) => (() => {
  var t = Pce();
  return t.$$click = () => e.onClick(), N(t, (() => {
    var r = gt(() => !!e.isLoader);
    return () => r() ? gt(() => !!e.hasMore)() ? Ice() : Dce() : (() => {
      var n = Nce();
      return N(n, () => e.children), n;
    })();
  })()), te((r) => {
    var n = !!e.isSelected, i = !!e.isSelected;
    return n !== r.e && t.classList.toggle("bg-blue-500", r.e = n), i !== r.t && t.classList.toggle("text-white", r.t = i), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})();
ns(["touchmove", "touchstart", "click"]);
const jce = ".invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.input::part(base){border-radius:var(--photon-border-radius, .5rem)}.input::part(base):hover{cursor:pointer}.input::part(input){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.disabled::part(base):hover{cursor:not-allowed}.selected::part(base){--tw-bg-opacity: 1;background-color:rgb(49,130,206,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.default::part(base):hover{--tw-bg-opacity: 1;background-color:rgb(229,231,235,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity))}.default::part(label){width:100%;overflow:hidden}.group-member::part(base){padding-left:1rem;font-weight:500}.group::part(base){background:#d1e9ff;padding-top:.25rem;padding-bottom:.25rem;--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity));font-size:.75rem;font-weight:600}.dropdown::part(panel){border-radius:var(--photon-border-radius, .5rem)}.dropdown-container{border-radius:var(--photon-border-radius, .5rem)}.group::part(checked-icon){display:none;width:0px}.group::part(label){padding-left:12px;padding-right:12px}.treatment-option::part(checked-icon){display:none;width:0px}";
var zce = /* @__PURE__ */ re('<div slot=suffix class=flex><sl-icon class="text-gray-400 hover:text-gray-600"name=x-circle-fill>', !0, !1, !1), Vce = /* @__PURE__ */ re('<div><style></style><style></style><style></style><style></style><sl-dropdown class="dropdown relative"hoist><sl-input clearable slot=trigger autocomplete=off size=medium class=input><p slot=help-text class="text-red-400 pt-1 font-sans"></p><div slot=suffix class=flex><sl-spinner slot=suffix></sl-spinner></div><div slot=suffix class=flex><sl-icon></sl-icon></div></sl-input><div class="border border-gray-200 dropdown-container overflow-hidden relative"><div class="bg-white overflow-x-hidden overflow-y-auto relative"><div>', !0, !1, !1), Uce = /* @__PURE__ */ re('<div class="flex items-center pb-2"><p class="text-gray-700 text-sm font-sans">'), qce = /* @__PURE__ */ re('<p class="pl-1 text-red-400">*'), Bce = /* @__PURE__ */ re('<p class="text-gray-400 text-xs pl-2 font-sans">Optional'), Hce = /* @__PURE__ */ re('<sl-menu-item><p class="text-center text-gray-400 italic">Loading...', !0, !1, !1), Wce = /* @__PURE__ */ re("<sl-menu-item>", !0, !1, !1), Kce = /* @__PURE__ */ re('<sl-menu-item class="group uppercase">', !0, !1, !1), Qce = /* @__PURE__ */ re("<sl-menu-item class=treatment-option>", !0, !1, !1), Gce = /* @__PURE__ */ re('<p class="text-center text-gray-400 italic">Loading...'), Yce = /* @__PURE__ */ re('<p class="text-center text-gray-400 italic">Nothing more to load'), Jce = /* @__PURE__ */ re('<p class="break-words px-3">');
fi("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const Zce = (e) => {
  let t, r, n, i, a;
  e.actionRef && (e.actionRef.clear = () => {
    d(void 0), u(-1), i.value = "", p(""), w();
  });
  const [o, s] = z(!1), [l, d] = z(void 0), [c, u] = z(-1), [h, f] = z(), p = hh(async (x) => {
    e.onSearchChange && await e.onSearchChange(x);
  }, 250), m = new IntersectionObserver(async (x) => {
    x?.at(-1)?.isIntersecting && e.hasMore && e.fetchMore && await e.fetchMore();
  });
  le(() => {
    e.data.length === 0 && d(void 0);
  }), le(() => {
    h() && m.observe(h());
  });
  const y = (x) => {
    if (x)
      return e.helpText ? e.helpText : e.required ? "Please select data..." : void 0;
  }, g = (x) => {
    const S = new CustomEvent("photon-data-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        data: x
      }
    });
    t?.dispatchEvent(S);
  }, w = () => {
    const x = new CustomEvent("photon-data-unselected", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(x);
  };
  le(() => {
    e.selectedData && d(e.selectedData), e.selectedData === void 0 && d(void 0);
  }), Ht(() => {
    i && i.addEventListener("keydown", (x) => {
      (x.code == "Space" || x.key == " ") && x.stopImmediatePropagation();
    });
  });
  const $ = B(() => e.groups ? e.groups.map((x) => {
    const S = e.data.map((T, I) => ({
      data: T,
      allItemsIdx: I
    })).filter((T) => x.filter(T.data));
    return S.length > 0 ? [{
      title: x.label
    }, ...S] : [];
  }).flat() : e.data.map((x, S) => ({
    data: x,
    allItemsIdx: S
  }))), _ = B(() => N3({
    count: $().length,
    getScrollElement: () => n ?? null,
    estimateSize: () => 36.8,
    overscan: 100
  }));
  return (() => {
    var x = Vce(), S = x.firstChild, T = S.nextSibling, I = T.nextSibling, M = I.nextSibling, P = M.nextSibling, O = P.firstChild, D = O.firstChild, R = D.nextSibling, L = R.firstChild, Q = R.nextSibling, ie = Q.firstChild, ee = O.nextSibling, W = ee.firstChild, H = W.firstChild, pe = t;
    typeof pe == "function" ? Rt(pe, x) : t = x, N(S, Tn), N(T, no), N(I, io), N(M, jce), N(x, (() => {
      var oe = gt(() => !!e.label);
      return () => oe() ? (() => {
        var ae = Uce(), Me = ae.firstChild;
        return N(Me, () => e.label), N(ae, (() => {
          var We = gt(() => !!e.required);
          return () => We() ? qce() : null;
        })(), null), N(ae, (() => {
          var We = gt(() => !!e.optional);
          return () => We() ? Bce() : null;
        })(), null), ae;
      })() : null;
    })(), P), Oe(P, "sl-show", async () => {
      s(!0), e.onOpen && await e.onOpen();
    }), Oe(P, "sl-hide", async () => {
      l() || (i.value = "", e.onHide && await e.onHide()), s(!1);
    });
    var Te = r;
    typeof Te == "function" ? Rt(Te, P) : r = P, P.style.setProperty("width", "100%"), P._$owner = Pe(), Oe(O, "sl-clear", () => {
      d(void 0), u(-1), i.value = "", p(""), w();
    }), Oe(O, "sl-focus", (oe) => {
      e.onInputFocus ? (e.onInputFocus(), oe.stopImmediatePropagation()) : (r.children[1].style.width = `${i.clientWidth}px`, c() > 0 && _().scrollToIndex(c()));
    }), Oe(O, "sl-input", (oe) => {
      o() || r.show(), p(oe.target.value);
    });
    var Ce = i;
    typeof Ce == "function" ? Rt(Ce, O) : i = O, O._$owner = Pe(), N(D, () => y(e.invalid ?? !1)), L._$owner = Pe(), N(O, v(q, {
      get when() {
        return e.clearable;
      },
      get children() {
        var oe = zce(), ae = oe.firstChild;
        return Oe(ae, "click", (Me) => {
          Me.stopImmediatePropagation(), d(void 0), u(-1), i.value = "", p(""), w(), r.hide();
        }), ae._$owner = Pe(), te(() => oe.classList.toggle("hidden", !!(e.isLoading || l() == null))), oe;
      }
    }), Q), ie._$owner = Pe(), ee.style.setProperty("width", "518px");
    var de = a;
    typeof de == "function" ? Rt(de, W) : a = W, W.style.setProperty("max-height", "500px"), W.style.setProperty("min-height", "37px"), W.style.setProperty("width", "100%"), W.style.setProperty("display", "flex"), W.style.setProperty("flex-direction", "column"), W.style.setProperty("justify-content", "start");
    var K = n;
    return typeof K == "function" ? Rt(K, H) : n = H, H.style.setProperty("width", "100%"), N(H, v(dt, {
      get each() {
        return _().getVirtualItems();
      },
      get fallback() {
        return v(Xce, {
          get noDataMsg() {
            return e.noDataMsg;
          },
          get isLoading() {
            return e.isLoading;
          }
        });
      },
      children: (oe) => {
        const ae = oe.index > $().length - 1, Me = $()[oe.index], We = l(), Dt = !ae && !!We && "id" in We && "data" in Me && We.id === Me.data.id;
        return v(N1, {
          get children() {
            return [v(Mn, {
              get when() {
                return "title" in Me;
              },
              get children() {
                return v(eue, {
                  item: Me
                });
              }
            }), v(Mn, {
              get when() {
                return "data" in Me;
              },
              get children() {
                return v(tue, {
                  item: oe,
                  isLoader: ae,
                  isSelected: Dt,
                  get index() {
                    return oe.index;
                  },
                  get hasMore() {
                    return e.hasMore;
                  },
                  get showOverflow() {
                    return e.showOverflow;
                  },
                  onClick: () => {
                    ae || (d(Me.data), u(Me.allItemsIdx), g(Me.data), r.hide());
                  },
                  setLastIndex: f,
                  get children() {
                    return e.displayAccessor(Me.data, !0);
                  }
                });
              }
            })];
          }
        });
      }
    })), te((oe) => {
      var ae = e.forceLabelSize && !e.invalid ? -20 : e.invalid ? -18 : 0, Me = e.disabled ?? !1, We = e.placeholder ?? void 0, Dt = e.disabled ?? !1, vt = !!(e.invalid ?? !1), zt = !!(e.disabled ?? !1), Wt = !l() && i.value === "", $e = e.required, Z = !!e.forceLabelSize, Ie = !e.isLoading, Re = !!e.isLoading, xt = o() ? "chevron-up" : "chevron-down", it = `${_().getTotalSize()}px`;
      return ae !== oe.e && (P.distance = oe.e = ae), Me !== oe.t && (P.disabled = oe.t = Me), We !== oe.a && (O.placeholder = oe.a = We), Dt !== oe.o && (O.disabled = oe.o = Dt), vt !== oe.i && O.classList.toggle("invalid", oe.i = vt), zt !== oe.n && O.classList.toggle("disabled", oe.n = zt), Wt !== oe.s && O.classList.toggle("placeholder", oe.s = Wt), $e !== oe.h && (O.required = oe.h = $e), Z !== oe.r && D.classList.toggle("h-[21px]", oe.r = Z), Ie !== oe.d && R.classList.toggle("hidden", oe.d = Ie), Re !== oe.l && Q.classList.toggle("hidden", oe.l = Re), xt !== oe.u && (ie.name = oe.u = xt), it !== oe.c && ((oe.c = it) != null ? H.style.setProperty("height", it) : H.style.removeProperty("height")), oe;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0,
      s: void 0,
      h: void 0,
      r: void 0,
      d: void 0,
      l: void 0,
      u: void 0,
      c: void 0
    }), te(() => O.value = e.searchText), x;
  })();
}, Xce = (e) => v(q, {
  get when() {
    return e.isLoading;
  },
  get fallback() {
    return (() => {
      var t = Wce();
      return t._$owner = Pe(), N(t, () => e.noDataMsg ? e.noDataMsg : "No data found"), t;
    })();
  },
  get children() {
    var t = Hce();
    return t._$owner = Pe(), t;
  }
}), eue = (e) => (() => {
  var t = Kce();
  return t._$owner = Pe(), N(t, () => e.item.title), t;
})(), tue = (e) => (() => {
  var t = Qce();
  return Rt((r) => {
    e.isLoader && e.index > 0 && e.setLastIndex(r);
  }, t), t.$$click = () => e.onClick(), t.style.setProperty("width", "100%"), t.style.setProperty("white-space", "normal"), t._$owner = Pe(), N(t, (() => {
    var r = gt(() => !!e.isLoader);
    return () => r() ? gt(() => !!e.hasMore)() ? Gce() : Yce() : (() => {
      var n = Jce();
      return N(n, () => e.children), te((i) => {
        var a = !e.showOverflow, o = !e.showOverflow, s = !e.showOverflow, l = !!e.showOverflow;
        return a !== i.e && n.classList.toggle("overflow-hidden", i.e = a), o !== i.t && n.classList.toggle("overflow-ellipsis", i.t = o), s !== i.a && n.classList.toggle("whitespace-nowrap", i.a = s), l !== i.o && n.classList.toggle("whitespace-normal", i.o = l), i;
      }, {
        e: void 0,
        t: void 0,
        a: void 0,
        o: void 0
      }), n;
    })();
  })()), te((r) => {
    var n = !!e.isSelected, i = `${e.item.size}px`;
    return n !== r.e && t.classList.toggle("selected", r.e = n), i !== r.t && ((r.t = i) != null ? t.style.setProperty("min-height", i) : t.style.removeProperty("min-height")), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})();
ns(["click"]);
const rue = xe`
  fragment CatalogFields on Catalog {
    id
  }
`, nue = { CatalogFields: rue }, iue = xe`
  fragment CatalogTreatmentsFields on Catalog {
    id
    treatments {
      id
      name
    }
    templates {
      id
      name
      daysSupply
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      instructions
      notes
      fillsAllowed
      treatment {
        id
        name
      }
      isPrivate
    }
  }
`, aue = { CatalogTreatmentsFields: iue }, oue = () => {
  const [e, t] = $h({
    catalogs: {
      data: [],
      errors: [],
      isLoading: !1
    },
    catalog: {
      data: void 0,
      errors: [],
      isLoading: !1
    }
  });
  return {
    store: e,
    actions: {
      getCatalogs: async (i) => {
        t("catalogs", {
          ...e.catalogs,
          isLoading: !0
        });
        const { data: a, errors: o } = await i.clinical.catalog.getCatalogs({
          fragment: nue
        });
        t("catalogs", {
          ...e.catalogs,
          isLoading: !1,
          data: a.catalogs,
          errors: o
        });
      },
      getCatalog: async (i, a) => {
        t("catalog", {
          ...e.catalog,
          isLoading: !0
        });
        const { data: o, errors: s } = await i.clinical.catalog.getCatalog({
          id: a,
          fragment: aue
        });
        t("catalog", {
          ...e.catalog,
          isLoading: !1,
          data: o.catalog,
          errors: s
        });
      }
    }
  };
}, y_ = oue();
var sue = /* @__PURE__ */ re("<strong class=font-extrabold>"), lue = /* @__PURE__ */ re("<div><p>"), b_ = /* @__PURE__ */ re('<p class="text-xs text-red-500 mt-1 italic">'), due = /* @__PURE__ */ re("<div><div></div><div> <!>, <!> <!> supply, <!> <!>, "), cue = /* @__PURE__ */ re("<span class=text-blue-600>(<!>): "), uue = /* @__PURE__ */ re("<div>");
function hue(e) {
  return !e || e.length === 0 ? {} : e.reduce((t, r) => {
    if (!r.treatmentIds) return t;
    for (const n of r.treatmentIds)
      t[n] = r.reason;
    return t;
  }, {});
}
function O7(e, t) {
  return e ? e in t ? {
    disabled: !0,
    disableReason: t[e]
  } : {
    disabled: !1
  } : {
    disabled: !1
  };
}
function z3(e, t, r) {
  const n = new CustomEvent(t, {
    composed: !0,
    bubbles: !0,
    detail: r
  });
  e?.dispatchEvent(n);
}
function fue(e, t, r) {
  z3(e, "photon-treatment-selected", {
    data: t,
    catalogId: r
  });
}
function pue(e) {
  z3(e, "photon-treatment-unselected");
}
function Pn(e, t) {
  z3(e, "photon-search-text-changed", {
    text: t
  });
}
const mue = async (e, t) => await e.query({
  query: LO,
  variables: {
    filter: {
      term: t
    }
  },
  fetchPolicy: "no-cache"
});
async function gue(e, t) {
  return (await mue(e, t))?.data?.treatments?.map((n) => ({
    ...n,
    isOffCatalog: !0
  })) ?? [];
}
function vue(e, t, r) {
  const {
    store: n
  } = y_;
  if (!n.catalog.data) return [];
  const i = [...e.offCatalogOption ? [e.offCatalogOption] : [], ...n.catalog.data ? n.catalog.data.templates.map((o) => o) : [], ...n.catalog.data ? n.catalog.data.treatments.map((o) => o) : [], ...r], a = t.toLowerCase().split(/\s+/);
  return a.length === 0 ? i : i.filter((o) => {
    const s = "treatment" in o ? `${o?.name?.toLowerCase() || ""} ${o.treatment.name.toLowerCase()} ` : o.name.toLowerCase();
    return a.every((l) => s.includes(l));
  });
}
const O1 = (e, t) => {
  const i = ((s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))(t).split(" ").filter((s) => s.length > 0), a = new RegExp(`(${i.join("|")})`, "gi");
  return e.split(a).map((s) => i.some((l) => l.toLowerCase() === s?.toLowerCase()) ? (() => {
    var l = sue();
    return N(l, s), l;
  })() : s);
};
function yue(e, t, r, n = !1, i) {
  return t ? (() => {
    var a = lue(), o = a.firstChild;
    return Zi(a, `my-1 ${n ? "opacity-50 cursor-not-allowed" : ""}`), Zi(o, `text-sm whitespace-normal leading-snug ${n ? "text-gray-500" : ""}`), N(o, () => O1(e.name, r)), N(a, n && i && (() => {
      var s = b_();
      return N(s, i), s;
    })(), null), a;
  })() : e.name || "";
}
function bue(e, t, r, n = !1, i) {
  if (t) {
    const a = e.fillsAllowed ? e.fillsAllowed - 1 : 0;
    return (() => {
      var o = due(), s = o.firstChild, l = s.nextSibling, d = l.firstChild, c = d.nextSibling, u = c.nextSibling, h = u.nextSibling, f = h.nextSibling, p = f.nextSibling, m = p.nextSibling, y = m.nextSibling, g = y.nextSibling, w = g.nextSibling;
      return w.nextSibling, Zi(o, `my-1 ${n ? "opacity-50 cursor-not-allowed" : ""}`), Zi(s, `text-sm whitespace-normal font-medium mb-1 ${n ? "text-gray-500" : ""}`), N(s, (() => {
        var $ = gt(() => !!e.name);
        return () => $() ? (() => {
          var _ = cue(), x = _.firstChild, S = x.nextSibling;
          return S.nextSibling, N(_, () => O1(e.name, r), S), _;
        })() : "";
      })(), null), N(s, () => O1(e.treatment.name, r), null), Zi(l, `text-xs truncate ${n ? "text-gray-400" : "text-gray-500"}`), N(l, () => e.dispenseQuantity, d), N(l, () => e.dispenseUnit, c), N(l, () => e.daysSupply, h), N(l, () => e.daysSupply === 1 ? "day" : "days", p), N(l, a, y), N(l, a === 1 ? "refill" : "refills", w), N(l, () => e.instructions, null), N(o, n && i && (() => {
        var $ = b_();
        return N($, i), $;
      })(), null), o;
    })();
  }
  return e.treatment.name;
}
function b2(e) {
  return [{
    label: "Off Catalog",
    filter: (t) => t && typeof t == "object" && e.offCatalogOption && t.id === e.offCatalogOption.id
  }, {
    label: "Personal Templates",
    filter: (t) => t && typeof t == "object" && "treatment" in t && t.isPrivate
  }, {
    label: "Organization Templates",
    filter: (t) => t && typeof t == "object" && "treatment" in t && !t.isPrivate
  }, {
    label: "Organization Catalog",
    filter: (t) => t && typeof t == "object" && "name" in t && !("treatment" in t) && !("isOffCatalog" in t)
  }, {
    label: "All Treatments",
    filter: (t) => t && typeof t == "object" && !("treatment" in t) && "isOffCatalog" in t
  }];
}
const wue = (e) => {
  let t;
  const r = Cn(), {
    store: n,
    actions: i
  } = y_, [a, o] = z([]), [s, l] = z(!1), [d, c] = z(!1), u = B(() => hue(e.disableList));
  Ht(async () => {
    e.catalogId ? await i.getCatalog(r.getSDK(), e.catalogId) : (await i.getCatalogs(r.getSDK()), n.catalogs.data && n.catalogs.data.length > 0 && await i.getCatalog(r.getSDK(), n.catalogs.data[0].id));
  }), le(() => {
    n.catalog.data && h(e.searchText);
  });
  const h = async (m) => {
    l(!0);
    const y = m?.length >= 3 && // 3 min chars for smaller responses
    e.allowOffCatalogSearch ? await gue(r.sdk.apolloClinical, m) : (
      // Set treatment options to empty array if search term is empty
      []
    ), g = vue(e, e.searchText, y);
    o(g), l(!1);
  }, f = (m, y) => {
    const g = "treatment" in m ? m.treatment.id : m.id, {
      disabled: w,
      disableReason: $
    } = O7(g, u());
    return m && "__typename" in m && m.__typename == "PrescriptionTemplate" ? bue(m, y, e.searchText, w, $) : yue(m, y, e.searchText, w, $);
  }, p = window.innerWidth < 768;
  return (() => {
    var m = uue();
    Oe(m, "photon-data-unselected", () => {
      pue(t), Pn(t, "");
    }), Oe(m, "photon-data-selected", (g) => {
      c(!1);
      const w = g.detail.data;
      let $;
      if ("treatment" in w ? $ = w.treatment.id : "id" in w && ($ = w.id), $) {
        const {
          disabled: _
        } = O7($, u());
        if (_)
          return;
      }
      fue(t, w, n.catalog.data?.id || ""), "treatment" in w ? Pn(t, w.treatment.name) : Pn(t, w.name);
    });
    var y = t;
    return typeof y == "function" ? Rt(y, m) : t = m, N(m, v(q, {
      get when() {
        return d();
      },
      get children() {
        return v(Mce, {
          get data() {
            return a();
          },
          get groups() {
            return b2(e);
          },
          get label() {
            return e.label;
          },
          get disabled() {
            return e.disabled;
          },
          get required() {
            return e.required ?? !1;
          },
          placeholder: "Type medication",
          get invalid() {
            return e.invalid ?? !1;
          },
          get isLoading() {
            return n.catalogs.isLoading || n.catalog.isLoading || s();
          },
          hasMore: !1,
          get selectedData() {
            return e.selected ?? e.offCatalogOption;
          },
          displayAccessor: f,
          get searchText() {
            return e.searchText;
          },
          onSearchChange: (g) => {
            Pn(t, g);
          },
          onHide: () => Pn(t, ""),
          get helpText() {
            return e.helpText;
          },
          get open() {
            return d();
          },
          onClose: () => {
            c(!1), Pn(t, "");
          }
        });
      }
    }), null), N(m, v(q, {
      get when() {
        return p && !d();
      },
      get children() {
        return v(Hk, {
          get data() {
            return a();
          },
          get groups() {
            return b2(e);
          },
          get label() {
            return e.label;
          },
          get disabled() {
            return e.disabled;
          },
          get required() {
            return e.required ?? !1;
          },
          placeholder: "Type medication",
          get invalid() {
            return e.invalid ?? !1;
          },
          get isLoading() {
            return n.catalogs.isLoading || n.catalog.isLoading;
          },
          hasMore: !1,
          get selectedData() {
            return e.selected ?? e.offCatalogOption;
          },
          displayAccessor: f,
          onSearchChange: (g) => Pn(t, g),
          onHide: () => Pn(t, ""),
          get helpText() {
            return e.helpText;
          },
          onInputFocus: () => {
            c(!0), e.selected?.name && Pn(t, e.selected.name);
          }
        });
      }
    }), null), N(m, v(q, {
      when: !p,
      get children() {
        return v(Zce, {
          get data() {
            return a();
          },
          get groups() {
            return b2(e);
          },
          get label() {
            return e.label;
          },
          get disabled() {
            return e.disabled;
          },
          get required() {
            return e.required ?? !1;
          },
          placeholder: "Type medication",
          get invalid() {
            return e.invalid ?? !1;
          },
          get isLoading() {
            return n.catalogs.isLoading || n.catalog.isLoading || s();
          },
          hasMore: !1,
          get selectedData() {
            return e.selected ?? e.offCatalogOption;
          },
          displayAccessor: f,
          get searchText() {
            return e.searchText;
          },
          onSearchChange: (g) => {
            Pn(t, g);
          },
          onHide: () => Pn(t, ""),
          get helpText() {
            return e.helpText;
          },
          onInputFocus: () => {
            e.selected?.name && Pn(t, e.selected.name);
          }
        });
      }
    }), null), m;
  })();
};
Xr("photon-medication-search", {
  label: void 0,
  required: !1,
  invalid: !1,
  helpText: void 0,
  catalogId: void 0,
  allowOffCatalogSearch: !0,
  disabled: !1,
  formName: void 0,
  selected: void 0,
  offCatalogOption: void 0,
  searchText: "",
  disableList: void 0
}, wue);
const $ue = ".dropdown::part(panel){width:480px}@media(max-width:768px){.dropdown::part(panel){max-width:100vw;width:100vw}}";
var kue = /* @__PURE__ */ re('<p class="text-lg font-semibold mt-0 mb-4">Add Medication History'), _ue = /* @__PURE__ */ re('<div class="flex items-center pb-2"><p class="text-gray-700 text-sm font-sans">Search for Treatment'), xue = /* @__PURE__ */ re('<sl-dropdown class="w-full p-0 dropdown"><sl-input placeholder="Type medication name"autocomplete=off class="border border-none p-0"size=medium clearable slot=trigger><div slot=suffix class=flex><sl-spinner slot=suffix></sl-spinner></div></sl-input><sl-menu>', !0, !1, !1), Eue = /* @__PURE__ */ re('<div class="mt-5 flex gap-4 justify-end">'), Sue = /* @__PURE__ */ re("<div><style></style><style></style><style></style><style></style><style>"), Cue = /* @__PURE__ */ re("<sl-menu-item disabled>Type at least 3 characters", !0, !1, !1), Tue = /* @__PURE__ */ re("<sl-menu-item>", !0, !1, !1), Aue = /* @__PURE__ */ re("<sl-menu-item disabled>No results found", !0, !1, !1);
fi("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const Oue = (e) => {
  let t;
  const r = Cn(), [n, i] = z(!1), [a, o] = z(!1), [s, l] = z(""), [d, c] = z([]), [u, h] = z(void 0), f = hh(async ($) => {
    if (!$ || $.length < 3) {
      c([]);
      return;
    }
    try {
      i(!0);
      const {
        data: _
      } = await r.sdk.apolloClinical.query({
        query: RO,
        variables: {
          filter: {
            term: $
          }
        },
        fetchPolicy: "no-cache"
      });
      c(_.treatments || []);
    } catch (_) {
      console.error("Search error:", _);
    } finally {
      i(!1);
    }
  }, 300);
  le(() => {
    f(s());
  });
  const p = () => {
    const $ = new CustomEvent("photon-medication-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        medication: u()
      }
    });
    t?.dispatchEvent($);
  }, m = () => {
    const $ = new CustomEvent("photon-medication-closed", {
      composed: !0,
      bubbles: !0
    });
    t?.dispatchEvent($);
  }, y = async () => {
    o(!0), p();
  };
  le(() => {
    e.open || (o(!1), l(""));
  });
  const g = () => {
    m();
  }, w = ($) => {
    h($), l($.name);
  };
  return (() => {
    var $ = Sue(), _ = $.firstChild, x = _.nextSibling, S = x.nextSibling, T = S.nextSibling, I = T.nextSibling, M = t;
    return typeof M == "function" ? Rt(M, $) : t = $, N(_, ao), N(x, Tn), N(S, no), N(T, io), N(I, $ue), N($, v(os, {
      get open() {
        return e.open;
      },
      onClose: g,
      size: "lg",
      position: "center",
      get children() {
        return [kue(), _ue(), (() => {
          var P = xue(), O = P.firstChild, D = O.firstChild, R = D.firstChild, L = O.nextSibling;
          return P._$owner = Pe(), Oe(O, "keydown", (Q) => {
            (Q.code === "Space" || Q.key === " ") && (Q.preventDefault(), Q.stopPropagation(), l(s() + " "));
          }), Oe(O, "sl-input", (Q) => {
            l(Q.target.value);
          }), O._$owner = Pe(), R._$owner = Pe(), L._$owner = Pe(), N(L, (() => {
            var Q = gt(() => s()?.length < 3);
            return () => Q() ? (() => {
              var ie = Cue();
              return ie._$owner = Pe(), ie;
            })() : gt(() => d().length > 0)() ? d().map((ie) => (() => {
              var ee = Tue();
              return ee.$$click = () => w(ie), ee._$owner = Pe(), N(ee, () => O1(ie.name, s())), ee;
            })()) : (() => {
              var ie = Aue();
              return ie._$owner = Pe(), ie;
            })();
          })()), te(() => D.classList.toggle("hidden", !n())), te(() => O.value = s()), P;
        })(), (() => {
          var P = Eue();
          return N(P, v(ct, {
            variant: "secondary",
            onClick: g,
            children: "Cancel"
          }), null), N(P, v(ct, {
            onClick: y,
            get disabled() {
              return !u() || a();
            },
            get loading() {
              return a();
            },
            children: "Select Medication"
          }), null), P;
        })()];
      }
    }), null), $;
  })();
};
Xr("photon-add-medication-history-dialog", {
  open: {
    value: !1,
    reflect: !0,
    notify: !1,
    attribute: "open",
    parse: !0
  }
}, Oue);
ns(["click"]);
var Pue = /* @__PURE__ */ re("<div><style>");
const Iue = (e) => (() => {
  var t = Pue(), r = t.firstChild;
  return N(r, ao), N(t, v(U$, {
    get patientId() {
      return e.patientId;
    },
    enableLinks: !1,
    enableRefillButton: !1
  }), null), t;
})();
Xr("photon-med-history", {
  patientId: ""
}, Iue);
function Y5(e) {
  this.message = e;
}
Y5.prototype = new Error(), Y5.prototype.name = "InvalidCharacterError";
var P7 = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new Y5("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var r, n, i = 0, a = 0, o = ""; n = t.charAt(a++); ~n && (r = i % 4 ? 64 * r + n : n, i++ % 4) ? o += String.fromCharCode(255 & r >> (-2 * i & 6)) : 0) n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);
  return o;
};
function Due(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return (function(r) {
      return decodeURIComponent(P7(r).replace(/(.)/g, (function(n, i) {
        var a = i.charCodeAt(0).toString(16).toUpperCase();
        return a.length < 2 && (a = "0" + a), "%" + a;
      })));
    })(t);
  } catch {
    return P7(t);
  }
}
function P1(e) {
  this.message = e;
}
function Nue(e, t) {
  if (typeof e != "string") throw new P1("Invalid token specified");
  var r = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(Due(e.split(".")[r]));
  } catch (n) {
    throw new P1("Invalid token specified: " + n.message);
  }
}
P1.prototype = new Error(), P1.prototype.name = "InvalidTokenError";
var Mue = /* @__PURE__ */ re(`<div><style></style><photon-dialog label="Lose Unsaved Prescription?"confirm-text="Yes, Continue"cancel-text="Keep Editing"width=500px><p class="font-sans text-lg xs:text-base">You have a prescription "<!>" that hasn't been added. Please add it or continue.</p></photon-dialog><photon-dialog label="Save prescriptions without an order?"confirm-text="Save and create order"cancel-text="Yes, save only"width=500px><p class="font-sans text-lg xs:text-base">You're about to save prescriptions without creating a pharmacy order. You can create an order now, or at a later date.`, !0, !1, !1), Rue = /* @__PURE__ */ re('<div class="w-full h-full bg-[#F9FAFB]"><photon-prescribe-workflow hide-submit=true>', !0, !1, !1);
const I7 = (e) => e().addToTemplates && e().addToTemplates.value != !1 || e().daysSupply?.value || e().dispenseAsWritten && e().dispenseAsWritten?.value != !1 || e().dispenseQuantity?.value || e().dispenseUnit?.value || e().doNotFillBeforeDate?.value || e().instructions?.value || e().notes?.value || e().refills?.value || e().treatment?.value, Lue = (e) => !!e?.id, Fue = (e) => e === G0.FulfillmentType.PickUp || e === G0.FulfillmentType.MailOrder, jue = (e, t) => Fue(e) && !Lue(t), zue = (e) => {
  let t;
  const r = Cn(), [n, i] = z(!1), [a, o] = z(!1), [s, l] = z(), [d, c] = z(!1), [u, h] = z(!1), [f, p] = z(!1), [m, y] = z(!1), {
    actions: g
  } = du, [w, $] = z(!1), [_, x] = z(0);
  Ht(async () => {
    const L = await r.getSDK().authentication.getAccessToken();
    Nue(L).permissions?.includes("write:prescription") && o(!0);
  });
  const S = (L, Q, ie) => {
    const ee = new CustomEvent("photon-prescriptions-created", {
      composed: !0,
      bubbles: !0,
      detail: {
        patientId: ie,
        prescriptionIds: Q,
        createOrder: L
      }
    });
    t?.dispatchEvent(ee);
  }, T = () => {
    Ro({
      trackEventType: "prescription_form_closed",
      properties: {
        hadUnsavedWork: I7(s)
      }
    }, t);
    const L = new CustomEvent("photon-prescriptions-closed", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(L);
  }, I = () => {
    const L = s()?.fulfillmentType?.value, Q = s()?.address?.value ?? s()?.patient?.value?.address;
    if (jue(L, Q))
      return y(!1), Yt({
        status: "error",
        header: "Address required",
        body: "Please add a patient address to place a local pickup or mail order."
      });
    h(!0), y(!0);
  }, M = () => {
    c(!1), I();
  }, P = () => c(!1), O = () => {
    if (!n())
      return Yt({
        status: "info",
        body: "You need to add prescription(s) before sending."
      });
    if (!a())
      return Yt({
        status: "error",
        header: "Unauthorized",
        body: "You do not have permission to prescribe"
      });
    if (s()?.treatment?.value?.name)
      return c(!0);
    I();
  }, D = () => {
    if (!n())
      return Yt({
        status: "info",
        body: "You need to add prescription(s) before sending."
      });
    if (!a())
      return Yt({
        status: "error",
        header: "Unauthorized",
        body: "You do not have permission to prescribe"
      });
    p(!0);
  }, R = B(() => !w() || _() < 1);
  return (() => {
    var L = Mue(), Q = L.firstChild, ie = Q.nextSibling, ee = ie.firstChild, W = ee.firstChild, H = W.nextSibling;
    H.nextSibling;
    var pe = ie.nextSibling, Te = t;
    return typeof Te == "function" ? Rt(Te, L) : t = L, N(Q, ao), Oe(ie, "photon-dialog-alt", P), Oe(ie, "photon-dialog-canceled", P), Oe(ie, "photon-dialog-confirmed", M), ie._$owner = Pe(), N(ee, () => s()?.treatment?.value?.name, H), Oe(pe, "photon-dialog-alt", () => {
      p(!1), y(!0);
    }), Oe(pe, "photon-dialog-canceled", () => {
      p(!1);
    }), Oe(pe, "photon-dialog-confirmed", () => {
      p(!1), I();
    }), pe._$owner = Pe(), N(L, v(v_, {
      closeTitle: "Lose unsaved prescriptions?",
      closeBody: "You will not be able to recover unsaved prescriptions.",
      onClosed: () => {
        T(), g.clearSelectedPatient();
      },
      checkShouldWarn: () => I7(s),
      title: "New prescriptions",
      titleIconName: "prescription",
      get footer() {
        return gt(() => !!R())() ? null : gt(() => !!e.enableOrder)() ? v(ct, {
          class: "w-full xs:w-fit",
          size: "lg",
          get loading() {
            return m();
          },
          onClick: O,
          children: "Send"
        }) : [v(ct, {
          class: "w-full xs:w-fit",
          size: "lg",
          get loading() {
            return gt(() => !!m())() && u();
          },
          onClick: O,
          children: "Save and create order"
        }), v(ct, {
          class: "w-full xs:w-fit",
          size: "lg",
          variant: "secondary",
          get loading() {
            return gt(() => !!m())() && !u();
          },
          onClick: D,
          children: "Save prescriptions"
        })];
      },
      get form() {
        return (() => {
          var Ce = Rue(), de = Ce.firstChild;
          return Oe(de, "photon-clinical-alert-cancel", (K) => {
            K.stopPropagation(), y(!1);
          }), Oe(de, "photon-signature-attestation-canceled", () => {
            T(), g.clearSelectedPatient();
          }), Oe(de, "photon-signature-attestation-agreed", () => {
            $(!0);
          }), Oe(de, "photon-order-combine-error", (K) => {
            K.stopPropagation(), y(!1);
          }), Oe(de, "photon-order-error", (K) => {
            K.stopPropagation(), y(!1);
          }), Oe(de, "photon-prescriptions-created", (K) => {
            K.stopPropagation(), e.enableOrder || S(u(), K.detail.prescriptions.map((oe) => oe.id), s()?.patient?.value?.id);
          }), Oe(de, "photon-draft-prescription-deleted", () => {
            x((K) => Math.max(0, K - 1));
          }), Oe(de, "photon-draft-prescription-created", () => {
            x((K) => K + 1);
          }), Oe(de, "photon-form-validate", (K) => {
            i(K.detail.canSubmit), l(K.detail.form);
          }), de.setTriggerSubmit = y, de._$owner = Pe(), te((K) => {
            var oe = e.hideTemplates, ae = m(), Me = e.patientId, We = e.templateIds, Dt = e.prescriptionIds, vt = e.weight, zt = e.weightUnit, Wt = e.externalOrderId, $e = e.additionalNotes, Z = e.enableMedHistory, Ie = e.enableMedHistoryLinks, Re = e.enableMedHistoryRefillButton, xt = e.enableOrder, it = e.enableLocalPickup, Kt = e.enableSendToPatient, De = e.enableCombineAndDuplicate, bt = e.enableDeliveryPharmacies, Et = e.enableCoverageCheck, pt = e.optionalPatientAddress, At = e.pharmacyId, rn = e.mailOrderIds, Qe = m(), Vt = e?.toastBuffer || 0;
            return oe !== K.e && (de.hideTemplates = K.e = oe), ae !== K.t && (de.loading = K.t = ae), Me !== K.a && (de.patientId = K.a = Me), We !== K.o && (de.templateIds = K.o = We), Dt !== K.i && (de.prescriptionIds = K.i = Dt), vt !== K.n && (de.weight = K.n = vt), zt !== K.s && (de.weightUnit = K.s = zt), Wt !== K.h && (de.externalOrderId = K.h = Wt), $e !== K.r && (de.additionalNotes = K.r = $e), Z !== K.d && (de.enableMedHistory = K.d = Z), Ie !== K.l && (de.enableMedHistoryLinks = K.l = Ie), Re !== K.u && (de.enableMedHistoryRefillButton = K.u = Re), xt !== K.c && (de.enableOrder = K.c = xt), it !== K.w && (de.enableLocalPickup = K.w = it), Kt !== K.m && (de.enableSendToPatient = K.m = Kt), De !== K.f && (de.enableCombineAndDuplicate = K.f = De), bt !== K.y && (de.enableDeliveryPharmacies = K.y = bt), Et !== K.g && (de.enableCoverageCheck = K.g = Et), pt !== K.p && (de.optionalPatientAddress = K.p = pt), At !== K.b && (de.pharmacyId = K.b = At), rn !== K.T && (de.mailOrderIds = K.T = rn), Qe !== K.A && (de.triggerSubmit = K.A = Qe), Vt !== K.O && (de.toastBuffer = K.O = Vt), K;
          }, {
            e: void 0,
            t: void 0,
            a: void 0,
            o: void 0,
            i: void 0,
            n: void 0,
            s: void 0,
            h: void 0,
            r: void 0,
            d: void 0,
            l: void 0,
            u: void 0,
            c: void 0,
            w: void 0,
            m: void 0,
            f: void 0,
            y: void 0,
            g: void 0,
            p: void 0,
            b: void 0,
            T: void 0,
            A: void 0,
            O: void 0
          }), Ce;
        })();
      }
    }), null), te((Ce) => {
      var de = d(), K = f();
      return de !== Ce.e && (ie.open = Ce.e = de), K !== Ce.t && (pe.open = Ce.t = K), Ce;
    }, {
      e: void 0,
      t: void 0
    }), L;
  })();
};
Xr("photon-multirx-form-wrapper", {
  hideTemplates: !1,
  patientId: void 0,
  pharmacyId: void 0,
  templateIds: void 0,
  prescriptionIds: void 0,
  weight: void 0,
  weightUnit: "lbs",
  additionalNotes: void 0,
  enableLocalPickup: !1,
  enableSendToPatient: !1,
  enableDeliveryPharmacies: !0,
  enableMedHistory: !1,
  enableMedHistoryLinks: !1,
  enableMedHistoryRefillButton: !1,
  enableCombineAndDuplicate: !1,
  enableCoverageCheck: !1,
  mailOrderIds: void 0,
  enableOrder: !1,
  toastBuffer: 0,
  externalOrderId: void 0,
  optionalPatientAddress: !1
}, zue);
